export type Brand<T extends string> = { readonly __brand: T };
export type ActualCostId = number & Brand<'ActualCostId'>;
export type ApiOrdersNoticeId = number & Brand<'ApiOrdersNoticeId'>;
export type AssortmentExclusionId = number & Brand<'AssortmentExclusionId'>;
export type AssortmentGroupId = number & Brand<'AssortmentGroupId'>;
export type AssortmentId = number & Brand<'AssortmentId'>;
export type BatchUpdateId = number & Brand<'BatchUpdateId'>;
export type BillOfLadingDatumId = number & Brand<'BillOfLadingDatumId'>;
export type BillOfLadingId = number & Brand<'BillOfLadingId'>;
export type BunkerGradeCalculationId = number & Brand<'BunkerGradeCalculationId'>;
export type BunkerGradeMappingId = number & Brand<'BunkerGradeMappingId'>;
export type BunkerGradeOverrideId = number & Brand<'BunkerGradeOverrideId'>;
export type BunkeringId = number & Brand<'BunkeringId'>;
export type CarbonPriceOverrideId = number & Brand<'CarbonPriceOverrideId'>;
export type CargoCompartmentAllocationId = number & Brand<'CargoCompartmentAllocationId'>;
export type CargoCompartmentId = number & Brand<'CargoCompartmentId'>;
export type CargoEquipmentId = number & Brand<'CargoEquipmentId'>;
export type CargoExclusionId = number & Brand<'CargoExclusionId'>;
export type CargoLengthUnitId = number & Brand<'CargoLengthUnitId'>;
export type CargoMeasurementId = number & Brand<'CargoMeasurementId'>;
export type CargoUnitId = number & Brand<'CargoUnitId'>;
export type CargoWeightUnitId = number & Brand<'CargoWeightUnitId'>;
export type ChannelCostEstimateId = number & Brand<'ChannelCostEstimateId'>;
export type ChannelCostId = number & Brand<'ChannelCostId'>;
export type ChannelId = number & Brand<'ChannelId'>;
export type ChannelIncompatibilityId = number & Brand<'ChannelIncompatibilityId'>;
export type ChatId = number & Brand<'ChatId'>;
export type ClassSocietyAssociationId = number & Brand<'ClassSocietyAssociationId'>;
export type ClassificationSocietyId = number & Brand<'ClassificationSocietyId'>;
export type CoaContractAssortmentId = number & Brand<'CoaContractAssortmentId'>;
export type CoaContractBunkerId = number & Brand<'CoaContractBunkerId'>;
export type CoaContractCommissionId = number & Brand<'CoaContractCommissionId'>;
export type CoaContractDeviationCostId = number & Brand<'CoaContractDeviationCostId'>;
export type CoaContractId = number & Brand<'CoaContractId'>;
export type CoaContractPortCostId = number & Brand<'CoaContractPortCostId'>;
export type CoaContractPortDatumId = number & Brand<'CoaContractPortDatumId'>;
export type CoaContractPortId = number & Brand<'CoaContractPortId'>;
export type CoaContractPriceId = number & Brand<'CoaContractPriceId'>;
export type CoaContractShipId = number & Brand<'CoaContractShipId'>;
export type CommissionId = number & Brand<'CommissionId'>;
export type CommitLogId = number & Brand<'CommitLogId'>;
export type CommitLogScenarioId = number & Brand<'CommitLogScenarioId'>;
export type CostSplitOnScheduledOrderId = number & Brand<'CostSplitOnScheduledOrderId'>;
export type CostSplitOnSingleEventId = number & Brand<'CostSplitOnSingleEventId'>;
export type CountryId = number & Brand<'CountryId'>;
export type DbChangeId = number & Brand<'DbChangeId'>;
export type DemandId = number & Brand<'DemandId'>;
export type EmailToOrderConfigId = number & Brand<'EmailToOrderConfigId'>;
export type EmailToOrderLogId = number & Brand<'EmailToOrderLogId'>;
export type FeatureFeatureNameString = string & Brand<'FeatureFeatureNameString'>;
export type FileId = number & Brand<'FileId'>;
export type GeographicalEntityId = number & Brand<'GeographicalEntityId'>;
export type GeographicalRelationId = number & Brand<'GeographicalRelationId'>;
export type HandledByCoaId = number & Brand<'HandledByCoaId'>;
export type HandledBySpotId = number & Brand<'HandledBySpotId'>;
export type HolidayId = number & Brand<'HolidayId'>;
export type IceClassId = number & Brand<'IceClassId'>;
export type InstructionId = number & Brand<'InstructionId'>;
export type IntegrationLogId = number & Brand<'IntegrationLogId'>;
export type InvoiceId = number & Brand<'InvoiceId'>;
export type InvoiceItemId = number & Brand<'InvoiceItemId'>;
export type InvoiceItemOrderId = number & Brand<'InvoiceItemOrderId'>;
export type LaytimeResponsibilityId = number & Brand<'LaytimeResponsibilityId'>;
export type LocationClusterId = number & Brand<'LocationClusterId'>;
export type LocationId = number & Brand<'LocationId'>;
export type LocationRequirementAssociationId = number & Brand<'LocationRequirementAssociationId'>;
export type LocationWorkingHourId = number & Brand<'LocationWorkingHourId'>;
export type LostContractId = number & Brand<'LostContractId'>;
export type MigrationId = number & Brand<'MigrationId'>;
export type NoGoZoneId = number & Brand<'NoGoZoneId'>;
export type OffHireId = number & Brand<'OffHireId'>;
export type OpenPositionId = number & Brand<'OpenPositionId'>;
export type OrderAttributeAssociationId = number & Brand<'OrderAttributeAssociationId'>;
export type OrderAttributeId = number & Brand<'OrderAttributeId'>;
export type OrderDetailId = number & Brand<'OrderDetailId'>;
export type OrderId = number & Brand<'OrderId'>;
export type OrderPortCallRelationId = number & Brand<'OrderPortCallRelationId'>;
export type OrderPortOverrideOrderId = number & Brand<'OrderPortOverrideOrderId'>;
export type OrderRequirementAssociationId = number & Brand<'OrderRequirementAssociationId'>;
export type OrderVoyageCharterRelationId = number & Brand<'OrderVoyageCharterRelationId'>;
export type OrganizationFeatureId = number & Brand<'OrganizationFeatureId'>;
export type OrganizationId = number & Brand<'OrganizationId'>;
export type PortActivityId = number & Brand<'PortActivityId'>;
export type PortCallExternalTimestampId = number & Brand<'PortCallExternalTimestampId'>;
export type PortCallFileId = number & Brand<'PortCallFileId'>;
export type PortCallId = number & Brand<'PortCallId'>;
export type PortCommodityLdRateIdString = string & Brand<'PortCommodityLdRateIdString'>;
export type PortCostDefaultId = number & Brand<'PortCostDefaultId'>;
export type PortCostEstimatesExternalId = number & Brand<'PortCostEstimatesExternalId'>;
export type PortCostId = number & Brand<'PortCostId'>;
export type PortDatumId = number & Brand<'PortDatumId'>;
export type PortNoticeId = number & Brand<'PortNoticeId'>;
export type PortRegionId = number & Brand<'PortRegionId'>;
export type PromptId = number & Brand<'PromptId'>;
export type QuayId = number & Brand<'QuayId'>;
export type ReceiverOrganizationId = number & Brand<'ReceiverOrganizationId'>;
export type RegionId = number & Brand<'RegionId'>;
export type RequestLogId = number & Brand<'RequestLogId'>;
export type RouteId = number & Brand<'RouteId'>;
export type RouteOverrideId = number & Brand<'RouteOverrideId'>;
export type RoutePointId = number & Brand<'RoutePointId'>;
export type RoutePointUsageId = number & Brand<'RoutePointUsageId'>;
export type ScenarioId = number & Brand<'ScenarioId'>;
export type ScheduledOrderId = number & Brand<'ScheduledOrderId'>;
export type SeenMessageId = number & Brand<'SeenMessageId'>;
export type SenderOrganizationId = number & Brand<'SenderOrganizationId'>;
export type ShipId = number & Brand<'ShipId'>;
export type ShipVoyageNamingRuleRelationId = number & Brand<'ShipVoyageNamingRuleRelationId'>;
export type ShipmentExternalStatusId = number & Brand<'ShipmentExternalStatusId'>;
export type ShipmentExtraFreightId = number & Brand<'ShipmentExtraFreightId'>;
export type ShipmentFreightId = number & Brand<'ShipmentFreightId'>;
export type ShipmentGroupAssociationId = number & Brand<'ShipmentGroupAssociationId'>;
export type ShipmentGroupId = number & Brand<'ShipmentGroupId'>;
export type ShipmentId = number & Brand<'ShipmentId'>;
export type SingleEventId = number & Brand<'SingleEventId'>;
export type SingleEventPortCallRelationId = number & Brand<'SingleEventPortCallRelationId'>;
export type SpecialRequirementId = number & Brand<'SpecialRequirementId'>;
export type SplitOrderId = number & Brand<'SplitOrderId'>;
export type SpotNegotiationId = number & Brand<'SpotNegotiationId'>;
export type StatementOfFactId = number & Brand<'StatementOfFactId'>;
export type SupplyContractId = number & Brand<'SupplyContractId'>;
export type SupplyId = number & Brand<'SupplyId'>;
export type TankDistanceId = number & Brand<'TankDistanceId'>;
export type TcContractId = number & Brand<'TcContractId'>;
export type UserId = number & Brand<'UserId'>;
export type UserRegionId = number & Brand<'UserRegionId'>;
export type UserRightId = number & Brand<'UserRightId'>;
export type UserSettingId = number & Brand<'UserSettingId'>;
export type UserShipId = number & Brand<'UserShipId'>;
export type VesselAttributeAssortmentExclusionId = number & Brand<'VesselAttributeAssortmentExclusionId'>;
export type VesselAttributeId = number & Brand<'VesselAttributeId'>;
export type VesselAttributesAssociationId = number & Brand<'VesselAttributesAssociationId'>;
export type VesselDraftDatapointIdString = string & Brand<'VesselDraftDatapointIdString'>;
export type VesselFulfillsRequirementAssociationId = number & Brand<'VesselFulfillsRequirementAssociationId'>;
export type VesselInfoId = number & Brand<'VesselInfoId'>;
export type VesselPerformanceModelId = number & Brand<'VesselPerformanceModelId'>;
export type VesselReservationId = number & Brand<'VesselReservationId'>;
export type VesselScheduleSharedToOrganizationId = number & Brand<'VesselScheduleSharedToOrganizationId'>;
export type VesselSecretId = number & Brand<'VesselSecretId'>;
export type VesselSpeedConsumptionId = number & Brand<'VesselSpeedConsumptionId'>;
export type VoyageAssociationId = number & Brand<'VoyageAssociationId'>;
export type VoyageAttributeId = number & Brand<'VoyageAttributeId'>;
export type VoyageCharterExtraCostId = number & Brand<'VoyageCharterExtraCostId'>;
export type VoyageCharterExtraFreightId = number & Brand<'VoyageCharterExtraFreightId'>;
export type VoyageCharterId = number & Brand<'VoyageCharterId'>;
export type VoyageCharterOrderFreightId = number & Brand<'VoyageCharterOrderFreightId'>;
export type VoyageCharterPortCostId = number & Brand<'VoyageCharterPortCostId'>;
export type VoyageCharterPortDatumId = number & Brand<'VoyageCharterPortDatumId'>;
export type VoyageCharterToContractId = number & Brand<'VoyageCharterToContractId'>;
export type VoyageCharterUpdateId = number & Brand<'VoyageCharterUpdateId'>;
export type VoyageId = number & Brand<'VoyageId'>;
export type VoyageNamingRuleId = number & Brand<'VoyageNamingRuleId'>;
export type WorldscaleFreightId = number & Brand<'WorldscaleFreightId'>;
export type ZoneId = number & Brand<'ZoneId'>;
export type ZoneLocationId = number & Brand<'ZoneLocationId'>;
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Primary key for actual_cost */
  ActualCostId: { input: ActualCostId; output: ActualCostId; }
  /** Primary key for api_orders_notices */
  ApiOrdersNoticeId: { input: ApiOrdersNoticeId; output: ApiOrdersNoticeId; }
  /** Primary key for assortment_exclusions */
  AssortmentExclusionId: { input: AssortmentExclusionId; output: AssortmentExclusionId; }
  /** Primary key for assortment_groups */
  AssortmentGroupId: { input: AssortmentGroupId; output: AssortmentGroupId; }
  /** Primary key for assortments */
  AssortmentId: { input: AssortmentId; output: AssortmentId; }
  /** Primary key for batch_update */
  BatchUpdateId: { input: BatchUpdateId; output: BatchUpdateId; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: string | number; output: string | number; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string | number; output: string | number; }
  /** Primary key for bill_of_lading_data */
  BillOfLadingDatumId: { input: BillOfLadingDatumId; output: BillOfLadingDatumId; }
  /** Primary key for bill_of_lading */
  BillOfLadingId: { input: BillOfLadingId; output: BillOfLadingId; }
  /** Primary key for bunker_grade_calculations */
  BunkerGradeCalculationId: { input: BunkerGradeCalculationId; output: BunkerGradeCalculationId; }
  /** Primary key for bunker_grade_mappings */
  BunkerGradeMappingId: { input: BunkerGradeMappingId; output: BunkerGradeMappingId; }
  /** Primary key for bunker_grade_override */
  BunkerGradeOverrideId: { input: BunkerGradeOverrideId; output: BunkerGradeOverrideId; }
  /** Primary key for bunkering */
  BunkeringId: { input: BunkeringId; output: BunkeringId; }
  /** Primary key for carbon_price_override */
  CarbonPriceOverrideId: { input: CarbonPriceOverrideId; output: CarbonPriceOverrideId; }
  /** Primary key for cargo_compartment_allocation */
  CargoCompartmentAllocationId: { input: CargoCompartmentAllocationId; output: CargoCompartmentAllocationId; }
  /** Primary key for cargo_compartment */
  CargoCompartmentId: { input: CargoCompartmentId; output: CargoCompartmentId; }
  /** Primary key for cargo_equipments */
  CargoEquipmentId: { input: CargoEquipmentId; output: CargoEquipmentId; }
  /** Primary key for cargo_exclusion */
  CargoExclusionId: { input: CargoExclusionId; output: CargoExclusionId; }
  /** Primary key for cargo_length_units */
  CargoLengthUnitId: { input: CargoLengthUnitId; output: CargoLengthUnitId; }
  /** Primary key for cargo_measurement */
  CargoMeasurementId: { input: CargoMeasurementId; output: CargoMeasurementId; }
  /** Primary key for cargo_units */
  CargoUnitId: { input: CargoUnitId; output: CargoUnitId; }
  /** Primary key for cargo_weight_units */
  CargoWeightUnitId: { input: CargoWeightUnitId; output: CargoWeightUnitId; }
  /** Primary key for channel_cost_estimates */
  ChannelCostEstimateId: { input: ChannelCostEstimateId; output: ChannelCostEstimateId; }
  /** Primary key for channel_cost */
  ChannelCostId: { input: ChannelCostId; output: ChannelCostId; }
  /** Primary key for channel */
  ChannelId: { input: ChannelId; output: ChannelId; }
  /** Primary key for channel_incompatibilities */
  ChannelIncompatibilityId: { input: ChannelIncompatibilityId; output: ChannelIncompatibilityId; }
  /** Primary key for chat */
  ChatId: { input: ChatId; output: ChatId; }
  /** Primary key for class_society_association */
  ClassSocietyAssociationId: { input: ClassSocietyAssociationId; output: ClassSocietyAssociationId; }
  /** Primary key for classification_society */
  ClassificationSocietyId: { input: ClassificationSocietyId; output: ClassificationSocietyId; }
  /** Primary key for coa_contract_assortments */
  CoaContractAssortmentId: { input: CoaContractAssortmentId; output: CoaContractAssortmentId; }
  /** Primary key for coa_contract_bunker */
  CoaContractBunkerId: { input: CoaContractBunkerId; output: CoaContractBunkerId; }
  /** Primary key for coa_contract_commission */
  CoaContractCommissionId: { input: CoaContractCommissionId; output: CoaContractCommissionId; }
  /** Primary key for coa_contract_deviation_costs */
  CoaContractDeviationCostId: { input: CoaContractDeviationCostId; output: CoaContractDeviationCostId; }
  /** Primary key for coa_contracts */
  CoaContractId: { input: CoaContractId; output: CoaContractId; }
  /** Primary key for coa_contract_port_costs */
  CoaContractPortCostId: { input: CoaContractPortCostId; output: CoaContractPortCostId; }
  /** Primary key for coa_contract_port_data */
  CoaContractPortDatumId: { input: CoaContractPortDatumId; output: CoaContractPortDatumId; }
  /** Primary key for coa_contract_ports */
  CoaContractPortId: { input: CoaContractPortId; output: CoaContractPortId; }
  /** Primary key for coa_contract_prices */
  CoaContractPriceId: { input: CoaContractPriceId; output: CoaContractPriceId; }
  /** Primary key for coa_contract_ships */
  CoaContractShipId: { input: CoaContractShipId; output: CoaContractShipId; }
  /** Primary key for commission */
  CommissionId: { input: CommissionId; output: CommissionId; }
  /** Primary key for commit_log */
  CommitLogId: { input: CommitLogId; output: CommitLogId; }
  /** Primary key for commit_log_scenarios */
  CommitLogScenarioId: { input: CommitLogScenarioId; output: CommitLogScenarioId; }
  /** Primary key for cost_split_on_scheduled_order */
  CostSplitOnScheduledOrderId: { input: CostSplitOnScheduledOrderId; output: CostSplitOnScheduledOrderId; }
  /** Primary key for cost_split_on_single_event */
  CostSplitOnSingleEventId: { input: CostSplitOnSingleEventId; output: CostSplitOnSingleEventId; }
  /** Primary key for countries */
  CountryId: { input: CountryId; output: CountryId; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /** The day, does not include a time. */
  Date: { input: string; output: string; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: string; output: string; }
  /** Primary key for db_change */
  DbChangeId: { input: DbChangeId; output: DbChangeId; }
  /** Primary key for demands */
  DemandId: { input: DemandId; output: DemandId; }
  Email: { input: string; output: string; }
  /** Primary key for email_to_order_config */
  EmailToOrderConfigId: { input: EmailToOrderConfigId; output: EmailToOrderConfigId; }
  /** Primary key for email_to_order_logs */
  EmailToOrderLogId: { input: EmailToOrderLogId; output: EmailToOrderLogId; }
  /** Primary key for features */
  FeatureFeatureNameString: { input: FeatureFeatureNameString; output: FeatureFeatureNameString; }
  /** Primary key for files */
  FileId: { input: FileId; output: FileId; }
  /** Primary key for geographical_entity */
  GeographicalEntityId: { input: GeographicalEntityId; output: GeographicalEntityId; }
  /** Primary key for geographical_relation */
  GeographicalRelationId: { input: GeographicalRelationId; output: GeographicalRelationId; }
  /** Primary key for handled_by_coa */
  HandledByCoaId: { input: HandledByCoaId; output: HandledByCoaId; }
  /** Primary key for handled_by_spot */
  HandledBySpotId: { input: HandledBySpotId; output: HandledBySpotId; }
  /** Primary key for holiday */
  HolidayId: { input: HolidayId; output: HolidayId; }
  /** Primary key for ice_class */
  IceClassId: { input: IceClassId; output: IceClassId; }
  /** Primary key for instructions */
  InstructionId: { input: InstructionId; output: InstructionId; }
  /** Primary key for integration_logs */
  IntegrationLogId: { input: IntegrationLogId; output: IntegrationLogId; }
  /** Primary key for invoices */
  InvoiceId: { input: InvoiceId; output: InvoiceId; }
  /** Primary key for invoice_items */
  InvoiceItemId: { input: InvoiceItemId; output: InvoiceItemId; }
  /** Primary key for invoice_item_orders */
  InvoiceItemOrderId: { input: InvoiceItemOrderId; output: InvoiceItemOrderId; }
  /** A JavaScript object encoded in the JSON format as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: string; output: string; }
  /**
   * A JSON Web Token defined by [RFC 7519](https://tools.ietf.org/html/rfc7519)
   * which securely represents claims between two parties.
   */
  JwtToken: { input: string; output: string; }
  /** Primary key for laytime_responsibility */
  LaytimeResponsibilityId: { input: LaytimeResponsibilityId; output: LaytimeResponsibilityId; }
  /** Primary key for location_cluster */
  LocationClusterId: { input: LocationClusterId; output: LocationClusterId; }
  /** Primary key for location */
  LocationId: { input: LocationId; output: LocationId; }
  /** Primary key for location_requirement_association */
  LocationRequirementAssociationId: { input: LocationRequirementAssociationId; output: LocationRequirementAssociationId; }
  /** Primary key for location_working_hours */
  LocationWorkingHourId: { input: LocationWorkingHourId; output: LocationWorkingHourId; }
  /** Primary key for lost_contracts */
  LostContractId: { input: LostContractId; output: LostContractId; }
  /** Primary key for migrations */
  MigrationId: { input: MigrationId; output: MigrationId; }
  /** Primary key for no_go_zone */
  NoGoZoneId: { input: NoGoZoneId; output: NoGoZoneId; }
  /** Primary key for off_hire */
  OffHireId: { input: OffHireId; output: OffHireId; }
  /** Primary key for open_position */
  OpenPositionId: { input: OpenPositionId; output: OpenPositionId; }
  /** Primary key for order_attribute_associations */
  OrderAttributeAssociationId: { input: OrderAttributeAssociationId; output: OrderAttributeAssociationId; }
  /** Primary key for order_attributes */
  OrderAttributeId: { input: OrderAttributeId; output: OrderAttributeId; }
  /** Primary key for order_details */
  OrderDetailId: { input: OrderDetailId; output: OrderDetailId; }
  /** Primary key for orders */
  OrderId: { input: OrderId; output: OrderId; }
  /** Primary key for order_port_call_relation */
  OrderPortCallRelationId: { input: OrderPortCallRelationId; output: OrderPortCallRelationId; }
  /** Primary key for order_port_override */
  OrderPortOverrideOrderId: { input: OrderPortOverrideOrderId; output: OrderPortOverrideOrderId; }
  /** Primary key for order_requirement_association */
  OrderRequirementAssociationId: { input: OrderRequirementAssociationId; output: OrderRequirementAssociationId; }
  /** Primary key for order_voyage_charter_relation */
  OrderVoyageCharterRelationId: { input: OrderVoyageCharterRelationId; output: OrderVoyageCharterRelationId; }
  /** Primary key for organization_features */
  OrganizationFeatureId: { input: OrganizationFeatureId; output: OrganizationFeatureId; }
  /** Primary key for organizations */
  OrganizationId: { input: OrganizationId; output: OrganizationId; }
  /** Primary key for port_activity */
  PortActivityId: { input: PortActivityId; output: PortActivityId; }
  /** Primary key for port_call_external_timestamps */
  PortCallExternalTimestampId: { input: PortCallExternalTimestampId; output: PortCallExternalTimestampId; }
  /** Primary key for port_call_files */
  PortCallFileId: { input: PortCallFileId; output: PortCallFileId; }
  /** Primary key for port_call */
  PortCallId: { input: PortCallId; output: PortCallId; }
  /** Primary key for port_commodity_ld_rates */
  PortCommodityLdRateIdString: { input: PortCommodityLdRateIdString; output: PortCommodityLdRateIdString; }
  /** Primary key for port_cost_default */
  PortCostDefaultId: { input: PortCostDefaultId; output: PortCostDefaultId; }
  /** Primary key for port_cost_estimates_external */
  PortCostEstimatesExternalId: { input: PortCostEstimatesExternalId; output: PortCostEstimatesExternalId; }
  /** Primary key for port_cost */
  PortCostId: { input: PortCostId; output: PortCostId; }
  /** Primary key for port_data */
  PortDatumId: { input: PortDatumId; output: PortDatumId; }
  /** Primary key for port_notice */
  PortNoticeId: { input: PortNoticeId; output: PortNoticeId; }
  /** Primary key for port_regions */
  PortRegionId: { input: PortRegionId; output: PortRegionId; }
  /** Primary key for prompts */
  PromptId: { input: PromptId; output: PromptId; }
  /** Primary key for quays */
  QuayId: { input: QuayId; output: QuayId; }
  /** Primary key for receiver_organizations */
  ReceiverOrganizationId: { input: ReceiverOrganizationId; output: ReceiverOrganizationId; }
  /** Primary key for regions */
  RegionId: { input: RegionId; output: RegionId; }
  /** Primary key for request_logs */
  RequestLogId: { input: RequestLogId; output: RequestLogId; }
  /** Primary key for routes */
  RouteId: { input: RouteId; output: RouteId; }
  /** Primary key for route_override */
  RouteOverrideId: { input: RouteOverrideId; output: RouteOverrideId; }
  /** Primary key for route_point */
  RoutePointId: { input: RoutePointId; output: RoutePointId; }
  /** Primary key for route_point_usage */
  RoutePointUsageId: { input: RoutePointUsageId; output: RoutePointUsageId; }
  /** Primary key for scenarios */
  ScenarioId: { input: ScenarioId; output: ScenarioId; }
  /** Primary key for scheduled_order */
  ScheduledOrderId: { input: ScheduledOrderId; output: ScheduledOrderId; }
  /** Primary key for seen_message */
  SeenMessageId: { input: SeenMessageId; output: SeenMessageId; }
  /** Primary key for sender_organizations */
  SenderOrganizationId: { input: SenderOrganizationId; output: SenderOrganizationId; }
  /** Primary key for ships */
  ShipId: { input: ShipId; output: ShipId; }
  /** Primary key for ship_voyage_naming_rule_relation */
  ShipVoyageNamingRuleRelationId: { input: ShipVoyageNamingRuleRelationId; output: ShipVoyageNamingRuleRelationId; }
  /** Primary key for shipment_external_status */
  ShipmentExternalStatusId: { input: ShipmentExternalStatusId; output: ShipmentExternalStatusId; }
  /** Primary key for shipment_extra_freight */
  ShipmentExtraFreightId: { input: ShipmentExtraFreightId; output: ShipmentExtraFreightId; }
  /** Primary key for shipment_freight */
  ShipmentFreightId: { input: ShipmentFreightId; output: ShipmentFreightId; }
  /** Primary key for shipment_group_association */
  ShipmentGroupAssociationId: { input: ShipmentGroupAssociationId; output: ShipmentGroupAssociationId; }
  /** Primary key for shipment_group */
  ShipmentGroupId: { input: ShipmentGroupId; output: ShipmentGroupId; }
  /** Primary key for shipment */
  ShipmentId: { input: ShipmentId; output: ShipmentId; }
  /** Primary key for single_event */
  SingleEventId: { input: SingleEventId; output: SingleEventId; }
  /** Primary key for single_event_port_call_relation */
  SingleEventPortCallRelationId: { input: SingleEventPortCallRelationId; output: SingleEventPortCallRelationId; }
  /** Primary key for special_requirements */
  SpecialRequirementId: { input: SpecialRequirementId; output: SpecialRequirementId; }
  /** Primary key for split_order */
  SplitOrderId: { input: SplitOrderId; output: SplitOrderId; }
  /** Primary key for spot_negotiation */
  SpotNegotiationId: { input: SpotNegotiationId; output: SpotNegotiationId; }
  /** Primary key for statement_of_facts */
  StatementOfFactId: { input: StatementOfFactId; output: StatementOfFactId; }
  /** Primary key for supply_contracts */
  SupplyContractId: { input: SupplyContractId; output: SupplyContractId; }
  /** Primary key for supply */
  SupplyId: { input: SupplyId; output: SupplyId; }
  /** Primary key for tank_distance */
  TankDistanceId: { input: TankDistanceId; output: TankDistanceId; }
  /** Primary key for tc_contract */
  TcContractId: { input: TcContractId; output: TcContractId; }
  /** The exact time of day, does not include the date. May or may not have a timezone offset. */
  Time: { input: string; output: string; }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: string; output: string; }
  /** Primary key for users */
  UserId: { input: UserId; output: UserId; }
  /** Primary key for user_regions */
  UserRegionId: { input: UserRegionId; output: UserRegionId; }
  /** Primary key for user_rights */
  UserRightId: { input: UserRightId; output: UserRightId; }
  /** Primary key for user_settings */
  UserSettingId: { input: UserSettingId; output: UserSettingId; }
  /** Primary key for user_ships */
  UserShipId: { input: UserShipId; output: UserShipId; }
  /** Primary key for vessel_attribute_assortment_exclusions */
  VesselAttributeAssortmentExclusionId: { input: VesselAttributeAssortmentExclusionId; output: VesselAttributeAssortmentExclusionId; }
  /** Primary key for vessel_attributes */
  VesselAttributeId: { input: VesselAttributeId; output: VesselAttributeId; }
  /** Primary key for vessel_attributes_associations */
  VesselAttributesAssociationId: { input: VesselAttributesAssociationId; output: VesselAttributesAssociationId; }
  /** Primary key for vessel_draft_datapoints */
  VesselDraftDatapointIdString: { input: VesselDraftDatapointIdString; output: VesselDraftDatapointIdString; }
  /** Primary key for vessel_fulfills_requirement_association */
  VesselFulfillsRequirementAssociationId: { input: VesselFulfillsRequirementAssociationId; output: VesselFulfillsRequirementAssociationId; }
  /** Primary key for vessel_info */
  VesselInfoId: { input: VesselInfoId; output: VesselInfoId; }
  /** Primary key for vessel_performance_models */
  VesselPerformanceModelId: { input: VesselPerformanceModelId; output: VesselPerformanceModelId; }
  /** Primary key for vessel_reservation */
  VesselReservationId: { input: VesselReservationId; output: VesselReservationId; }
  /** Primary key for vessel_schedule_shared_to_organization */
  VesselScheduleSharedToOrganizationId: { input: VesselScheduleSharedToOrganizationId; output: VesselScheduleSharedToOrganizationId; }
  /** Primary key for vessel_secrets */
  VesselSecretId: { input: VesselSecretId; output: VesselSecretId; }
  /** Primary key for vessel_speed_consumption */
  VesselSpeedConsumptionId: { input: VesselSpeedConsumptionId; output: VesselSpeedConsumptionId; }
  /** Primary key for voyage_association */
  VoyageAssociationId: { input: VoyageAssociationId; output: VoyageAssociationId; }
  /** Primary key for voyage_attributes */
  VoyageAttributeId: { input: VoyageAttributeId; output: VoyageAttributeId; }
  /** Primary key for voyage_charter_extra_cost */
  VoyageCharterExtraCostId: { input: VoyageCharterExtraCostId; output: VoyageCharterExtraCostId; }
  /** Primary key for voyage_charter_extra_freight */
  VoyageCharterExtraFreightId: { input: VoyageCharterExtraFreightId; output: VoyageCharterExtraFreightId; }
  /** Primary key for voyage_charter */
  VoyageCharterId: { input: VoyageCharterId; output: VoyageCharterId; }
  /** Primary key for voyage_charter_order_freight */
  VoyageCharterOrderFreightId: { input: VoyageCharterOrderFreightId; output: VoyageCharterOrderFreightId; }
  /** Primary key for voyage_charter_port_cost */
  VoyageCharterPortCostId: { input: VoyageCharterPortCostId; output: VoyageCharterPortCostId; }
  /** Primary key for voyage_charter_port_data */
  VoyageCharterPortDatumId: { input: VoyageCharterPortDatumId; output: VoyageCharterPortDatumId; }
  /** Primary key for voyage_charter_to_contract */
  VoyageCharterToContractId: { input: VoyageCharterToContractId; output: VoyageCharterToContractId; }
  /** Primary key for voyage_charter_updates */
  VoyageCharterUpdateId: { input: VoyageCharterUpdateId; output: VoyageCharterUpdateId; }
  /** Primary key for voyage */
  VoyageId: { input: VoyageId; output: VoyageId; }
  /** Primary key for voyage_naming_rule */
  VoyageNamingRuleId: { input: VoyageNamingRuleId; output: VoyageNamingRuleId; }
  /** Primary key for worldscale_freights */
  WorldscaleFreightId: { input: WorldscaleFreightId; output: WorldscaleFreightId; }
  /** Primary key for zones */
  ZoneId: { input: ZoneId; output: ZoneId; }
  /** Primary key for zone_location */
  ZoneLocationId: { input: ZoneLocationId; output: ZoneLocationId; }
};

/** All input for the `acceptVoyageCharterUpdate` mutation. */
export type AcceptVoyageCharterUpdateInput = {
  accept: Scalars['Boolean']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  voyageCharterUpdateId: Scalars['Int']['input'];
};

/** The output of our `acceptVoyageCharterUpdate` mutation. */
export type AcceptVoyageCharterUpdatePayload = {
  __typename?: 'AcceptVoyageCharterUpdatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `LostContract` that is related to this `VoyageCharter`. */
  lostContractByLostContractsId?: Maybe<LostContract>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VoyageCharter`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VoyageCharter`. */
  userByModifiedByUserId?: Maybe<User>;
  voyageCharter?: Maybe<VoyageCharter>;
  /** An edge for our `VoyageCharter`. May be used by Relay 1. */
  voyageCharterEdge?: Maybe<VoyageChartersEdge>;
};


/** The output of our `acceptVoyageCharterUpdate` mutation. */
export type AcceptVoyageCharterUpdatePayloadVoyageCharterEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};

export type ActualCost = Node & {
  __typename?: 'ActualCost';
  cost: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `CostSplitOnScheduledOrder`. */
  costSplitOnScheduledOrdersByActualCostId: CostSplitOnScheduledOrdersConnection;
  /** Reads and enables pagination through a set of `CostSplitOnSingleEvent`. */
  costSplitOnSingleEventsByActualCostId: CostSplitOnSingleEventsConnection;
  currency: Currency;
  id: Scalars['ActualCostId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  type: ActualCostType;
  /** Reads a single `VoyageCharter` that is related to this `ActualCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId?: Maybe<Scalars['VoyageCharterId']['output']>;
};


export type ActualCostCostSplitOnScheduledOrdersByActualCostIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CostSplitOnScheduledOrderCondition>;
  filter?: InputMaybe<CostSplitOnScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CostSplitOnScheduledOrdersOrderBy>>;
};


export type ActualCostCostSplitOnSingleEventsByActualCostIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CostSplitOnSingleEventCondition>;
  filter?: InputMaybe<CostSplitOnSingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CostSplitOnSingleEventsOrderBy>>;
};

/**
 * A condition to be used against `ActualCost` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ActualCostCondition = {
  /** Checks for equality with the object’s `cost` field. */
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ActualCostId']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ActualCostType>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `ActualCost` object types. All fields are combined with a logical ‘and.’ */
export type ActualCostFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActualCostFilter>>;
  /** Filter by the object’s `cost` field. */
  cost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActualCostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActualCostFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<ActualCostTypeFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ActualCost` */
export type ActualCostInput = {
  cost: Scalars['BigFloat']['input'];
  currency: Currency;
  type: ActualCostType;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** Represents an update to a `ActualCost`. Fields that are set will be updated. */
export type ActualCostPatch = {
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  currency?: InputMaybe<Currency>;
  type?: InputMaybe<ActualCostType>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

export enum ActualCostType {
  BAF = 'BAF',
  DEMURRAGE = 'DEMURRAGE',
  FREIGHT = 'FREIGHT'
}

/** A filter to be used against ActualCostType fields. All fields are combined with a logical ‘and.’ */
export type ActualCostTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ActualCostType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ActualCostType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ActualCostType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ActualCostType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ActualCostType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ActualCostType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ActualCostType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ActualCostType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ActualCostType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ActualCostType>>;
};

/** A connection to a list of `ActualCost` values. */
export type ActualCostsConnection = {
  __typename?: 'ActualCostsConnection';
  /** A list of edges which contains the `ActualCost` and cursor to aid in pagination. */
  edges: Array<ActualCostsEdge>;
  /** A list of `ActualCost` objects. */
  nodes: Array<Maybe<ActualCost>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActualCost` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActualCost` edge in the connection. */
export type ActualCostsEdge = {
  __typename?: 'ActualCostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActualCost` at the end of the edge. */
  node?: Maybe<ActualCost>;
};

/** Methods to use when ordering `ActualCost`. */
export enum ActualCostsOrderBy {
  COST_ASC = 'COST_ASC',
  COST_DESC = 'COST_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** All input for the `addJobImosRobSync` mutation. */
export type AddJobImosRobSyncInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runUuid: Scalars['String']['input'];
};

/** The output of our `addJobImosRobSync` mutation. */
export type AddJobImosRobSyncPayload = {
  __typename?: 'AddJobImosRobSyncPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A `AllOrdersAllRelatedOrgsRecord` edge in the connection. */
export type AllOrdersAllRelatedOrgEdge = {
  __typename?: 'AllOrdersAllRelatedOrgEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AllOrdersAllRelatedOrgsRecord` at the end of the edge. */
  node?: Maybe<AllOrdersAllRelatedOrgsRecord>;
};

/** A connection to a list of `AllOrdersAllRelatedOrgsRecord` values. */
export type AllOrdersAllRelatedOrgsConnection = {
  __typename?: 'AllOrdersAllRelatedOrgsConnection';
  /** A list of edges which contains the `AllOrdersAllRelatedOrgsRecord` and cursor to aid in pagination. */
  edges: Array<AllOrdersAllRelatedOrgEdge>;
  /** A list of `AllOrdersAllRelatedOrgsRecord` objects. */
  nodes: Array<Maybe<AllOrdersAllRelatedOrgsRecord>>;
  /** The count of *all* `AllOrdersAllRelatedOrgsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `allOrdersAllRelatedOrgs` query. */
export type AllOrdersAllRelatedOrgsRecord = {
  __typename?: 'AllOrdersAllRelatedOrgsRecord';
  orderId?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `AllOrdersAllRelatedOrgsRecord` object types. All fields are combined with a logical ‘and.’ */
export type AllOrdersAllRelatedOrgsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AllOrdersAllRelatedOrgsRecordFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AllOrdersAllRelatedOrgsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AllOrdersAllRelatedOrgsRecordFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orgId` field. */
  orgId?: InputMaybe<IntFilter>;
};

/** All input for the `allOrgTreeListFromSessOrg` mutation. */
export type AllOrgTreeListFromSessOrgInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `allOrgTreeListFromSessOrg` mutation. */
export type AllOrgTreeListFromSessOrgPayload = {
  __typename?: 'AllOrgTreeListFromSessOrgPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ApiCoaContract = {
  __typename?: 'ApiCoaContract';
  assortmentsJson?: Maybe<Scalars['JSON']['output']>;
  cargoUnit?: Maybe<Scalars['String']['output']>;
  chartererOrgName?: Maybe<Scalars['String']['output']>;
  coaId?: Maybe<Scalars['Int']['output']>;
  contractName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  endDate?: Maybe<Scalars['Datetime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  inactive?: Maybe<Scalars['Boolean']['output']>;
  maxQuantity?: Maybe<Scalars['BigFloat']['output']>;
  minQuantity?: Maybe<Scalars['BigFloat']['output']>;
  paymentDays?: Maybe<Scalars['Int']['output']>;
  paymentTerm?: Maybe<PaymentType>;
  paymentTrigger?: Maybe<PaymentTrigger>;
  portDataJson?: Maybe<Scalars['JSON']['output']>;
  portPairsJson?: Maybe<Scalars['JSON']['output']>;
  shipownerOrgName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Datetime']['output']>;
  vesselsJson?: Maybe<Scalars['JSON']['output']>;
};

/**
 * A condition to be used against `ApiCoaContract` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ApiCoaContractCondition = {
  /** Checks for equality with the object’s `assortmentsJson` field. */
  assortmentsJson?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `cargoUnit` field. */
  cargoUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `chartererOrgName` field. */
  chartererOrgName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `coaId` field. */
  coaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `contractName` field. */
  contractName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `inactive` field. */
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `maxQuantity` field. */
  maxQuantity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minQuantity` field. */
  minQuantity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `paymentDays` field. */
  paymentDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `paymentTerm` field. */
  paymentTerm?: InputMaybe<PaymentType>;
  /** Checks for equality with the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  /** Checks for equality with the object’s `portDataJson` field. */
  portDataJson?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `portPairsJson` field. */
  portPairsJson?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `shipownerOrgName` field. */
  shipownerOrgName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselsJson` field. */
  vesselsJson?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `ApiCoaContract` object types. All fields are combined with a logical ‘and.’ */
export type ApiCoaContractFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApiCoaContractFilter>>;
  /** Filter by the object’s `cargoUnit` field. */
  cargoUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chartererOrgName` field. */
  chartererOrgName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `coaId` field. */
  coaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `contractName` field. */
  contractName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `inactive` field. */
  inactive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `maxQuantity` field. */
  maxQuantity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minQuantity` field. */
  minQuantity?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApiCoaContractFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApiCoaContractFilter>>;
  /** Filter by the object’s `paymentDays` field. */
  paymentDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentTerm` field. */
  paymentTerm?: InputMaybe<PaymentTypeFilter>;
  /** Filter by the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTriggerFilter>;
  /** Filter by the object’s `shipownerOrgName` field. */
  shipownerOrgName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ApiCoaContract` */
export type ApiCoaContractInput = {
  assortmentsJson?: InputMaybe<Scalars['JSON']['input']>;
  cargoUnit?: InputMaybe<Scalars['String']['input']>;
  chartererOrgName?: InputMaybe<Scalars['String']['input']>;
  coaId?: InputMaybe<Scalars['Int']['input']>;
  contractName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  maxQuantity?: InputMaybe<Scalars['BigFloat']['input']>;
  minQuantity?: InputMaybe<Scalars['BigFloat']['input']>;
  paymentDays?: InputMaybe<Scalars['Int']['input']>;
  paymentTerm?: InputMaybe<PaymentType>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  portDataJson?: InputMaybe<Scalars['JSON']['input']>;
  portPairsJson?: InputMaybe<Scalars['JSON']['input']>;
  shipownerOrgName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  vesselsJson?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `ApiCoaContract` values. */
export type ApiCoaContractsConnection = {
  __typename?: 'ApiCoaContractsConnection';
  /** A list of edges which contains the `ApiCoaContract` and cursor to aid in pagination. */
  edges: Array<ApiCoaContractsEdge>;
  /** A list of `ApiCoaContract` objects. */
  nodes: Array<Maybe<ApiCoaContract>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApiCoaContract` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApiCoaContract` edge in the connection. */
export type ApiCoaContractsEdge = {
  __typename?: 'ApiCoaContractsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ApiCoaContract` at the end of the edge. */
  node?: Maybe<ApiCoaContract>;
};

/** Methods to use when ordering `ApiCoaContract`. */
export enum ApiCoaContractsOrderBy {
  ASSORTMENTS_JSON_ASC = 'ASSORTMENTS_JSON_ASC',
  ASSORTMENTS_JSON_DESC = 'ASSORTMENTS_JSON_DESC',
  CARGO_UNIT_ASC = 'CARGO_UNIT_ASC',
  CARGO_UNIT_DESC = 'CARGO_UNIT_DESC',
  CHARTERER_ORG_NAME_ASC = 'CHARTERER_ORG_NAME_ASC',
  CHARTERER_ORG_NAME_DESC = 'CHARTERER_ORG_NAME_DESC',
  COA_ID_ASC = 'COA_ID_ASC',
  COA_ID_DESC = 'COA_ID_DESC',
  CONTRACT_NAME_ASC = 'CONTRACT_NAME_ASC',
  CONTRACT_NAME_DESC = 'CONTRACT_NAME_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  INACTIVE_ASC = 'INACTIVE_ASC',
  INACTIVE_DESC = 'INACTIVE_DESC',
  MAX_QUANTITY_ASC = 'MAX_QUANTITY_ASC',
  MAX_QUANTITY_DESC = 'MAX_QUANTITY_DESC',
  MIN_QUANTITY_ASC = 'MIN_QUANTITY_ASC',
  MIN_QUANTITY_DESC = 'MIN_QUANTITY_DESC',
  NATURAL = 'NATURAL',
  PAYMENT_DAYS_ASC = 'PAYMENT_DAYS_ASC',
  PAYMENT_DAYS_DESC = 'PAYMENT_DAYS_DESC',
  PAYMENT_TERM_ASC = 'PAYMENT_TERM_ASC',
  PAYMENT_TERM_DESC = 'PAYMENT_TERM_DESC',
  PAYMENT_TRIGGER_ASC = 'PAYMENT_TRIGGER_ASC',
  PAYMENT_TRIGGER_DESC = 'PAYMENT_TRIGGER_DESC',
  PORT_DATA_JSON_ASC = 'PORT_DATA_JSON_ASC',
  PORT_DATA_JSON_DESC = 'PORT_DATA_JSON_DESC',
  PORT_PAIRS_JSON_ASC = 'PORT_PAIRS_JSON_ASC',
  PORT_PAIRS_JSON_DESC = 'PORT_PAIRS_JSON_DESC',
  SHIPOWNER_ORG_NAME_ASC = 'SHIPOWNER_ORG_NAME_ASC',
  SHIPOWNER_ORG_NAME_DESC = 'SHIPOWNER_ORG_NAME_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  VESSELS_JSON_ASC = 'VESSELS_JSON_ASC',
  VESSELS_JSON_DESC = 'VESSELS_JSON_DESC'
}

export type ApiCommissionInput = {
  assortment?: InputMaybe<Scalars['String']['input']>;
  bafApplied?: InputMaybe<Scalars['Boolean']['input']>;
  demurrageApplied?: InputMaybe<Scalars['Boolean']['input']>;
  dischargePort?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  extraFreightApplied?: InputMaybe<Scalars['Boolean']['input']>;
  loadPort?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  type: CommissionType;
  value: Scalars['String']['input'];
};

export type ApiLocation = {
  __typename?: 'ApiLocation';
  countryAlpha2?: Maybe<Scalars['String']['output']>;
  countryAlpha3?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryNumeric?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  extraPortDays?: Maybe<Scalars['BigFloat']['output']>;
  latitude?: Maybe<Scalars['BigFloat']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locode?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['BigFloat']['output']>;
  parentLocationName?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ApiLocation` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ApiLocationCondition = {
  /** Checks for equality with the object’s `countryAlpha2` field. */
  countryAlpha2?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `countryAlpha3` field. */
  countryAlpha3?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `countryName` field. */
  countryName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `countryNumeric` field. */
  countryNumeric?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `extraPortDays` field. */
  extraPortDays?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `latitude` field. */
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `locationName` field. */
  locationName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `locode` field. */
  locode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `longitude` field. */
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `parentLocationName` field. */
  parentLocationName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `timezone` field. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ApiLocation` object types. All fields are combined with a logical ‘and.’ */
export type ApiLocationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApiLocationFilter>>;
  /** Filter by the object’s `countryAlpha2` field. */
  countryAlpha2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `countryAlpha3` field. */
  countryAlpha3?: InputMaybe<StringFilter>;
  /** Filter by the object’s `countryName` field. */
  countryName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `countryNumeric` field. */
  countryNumeric?: InputMaybe<IntFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extraPortDays` field. */
  extraPortDays?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `latitude` field. */
  latitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationName` field. */
  locationName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `locode` field. */
  locode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `longitude` field. */
  longitude?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApiLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApiLocationFilter>>;
  /** Filter by the object’s `parentLocationName` field. */
  parentLocationName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `timezone` field. */
  timezone?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ApiLocation` */
export type ApiLocationInput = {
  countryAlpha2?: InputMaybe<Scalars['String']['input']>;
  countryAlpha3?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  countryNumeric?: InputMaybe<Scalars['Int']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  extraPortDays?: InputMaybe<Scalars['BigFloat']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  locode?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  parentLocationName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ApiLocation` values. */
export type ApiLocationsConnection = {
  __typename?: 'ApiLocationsConnection';
  /** A list of edges which contains the `ApiLocation` and cursor to aid in pagination. */
  edges: Array<ApiLocationsEdge>;
  /** A list of `ApiLocation` objects. */
  nodes: Array<Maybe<ApiLocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApiLocation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApiLocation` edge in the connection. */
export type ApiLocationsEdge = {
  __typename?: 'ApiLocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ApiLocation` at the end of the edge. */
  node?: Maybe<ApiLocation>;
};

/** Methods to use when ordering `ApiLocation`. */
export enum ApiLocationsOrderBy {
  COUNTRY_ALPHA2_ASC = 'COUNTRY_ALPHA2_ASC',
  COUNTRY_ALPHA2_DESC = 'COUNTRY_ALPHA2_DESC',
  COUNTRY_ALPHA3_ASC = 'COUNTRY_ALPHA3_ASC',
  COUNTRY_ALPHA3_DESC = 'COUNTRY_ALPHA3_DESC',
  COUNTRY_NAME_ASC = 'COUNTRY_NAME_ASC',
  COUNTRY_NAME_DESC = 'COUNTRY_NAME_DESC',
  COUNTRY_NUMERIC_ASC = 'COUNTRY_NUMERIC_ASC',
  COUNTRY_NUMERIC_DESC = 'COUNTRY_NUMERIC_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  EXTRA_PORT_DAYS_ASC = 'EXTRA_PORT_DAYS_ASC',
  EXTRA_PORT_DAYS_DESC = 'EXTRA_PORT_DAYS_DESC',
  LATITUDE_ASC = 'LATITUDE_ASC',
  LATITUDE_DESC = 'LATITUDE_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  LOCATION_NAME_ASC = 'LOCATION_NAME_ASC',
  LOCATION_NAME_DESC = 'LOCATION_NAME_DESC',
  LOCODE_ASC = 'LOCODE_ASC',
  LOCODE_DESC = 'LOCODE_DESC',
  LONGITUDE_ASC = 'LONGITUDE_ASC',
  LONGITUDE_DESC = 'LONGITUDE_DESC',
  NATURAL = 'NATURAL',
  PARENT_LOCATION_NAME_ASC = 'PARENT_LOCATION_NAME_ASC',
  PARENT_LOCATION_NAME_DESC = 'PARENT_LOCATION_NAME_DESC',
  TIMEZONE_ASC = 'TIMEZONE_ASC',
  TIMEZONE_DESC = 'TIMEZONE_DESC'
}

export type ApiOrder = Node & {
  __typename?: 'ApiOrder';
  assortmentCargoType?: Maybe<CargoType>;
  assortmentGroup?: Maybe<Scalars['String']['output']>;
  assortmentGroupId?: Maybe<Scalars['Int']['output']>;
  assortmentId?: Maybe<Scalars['Int']['output']>;
  assortmentName?: Maybe<Scalars['String']['output']>;
  cargoAmount?: Maybe<Scalars['BigFloat']['output']>;
  cargoCount?: Maybe<Scalars['Int']['output']>;
  cargoDeckOption?: Maybe<CargoDeckOptionType>;
  cargoDepth?: Maybe<Scalars['BigFloat']['output']>;
  cargoEquipmentCount?: Maybe<Scalars['Int']['output']>;
  cargoEquipmentId?: Maybe<Scalars['Int']['output']>;
  cargoEquipmentName?: Maybe<Scalars['String']['output']>;
  cargoHeight?: Maybe<Scalars['BigFloat']['output']>;
  cargoLengthUnit?: Maybe<Scalars['String']['output']>;
  cargoLengthUnitId?: Maybe<Scalars['Int']['output']>;
  cargoPackageType?: Maybe<Scalars['String']['output']>;
  cargoPackingMethod?: Maybe<CargoPackingMethodType>;
  cargoUnit?: Maybe<Scalars['String']['output']>;
  cargoUnitId?: Maybe<Scalars['Int']['output']>;
  cargoWeight?: Maybe<Scalars['BigFloat']['output']>;
  cargoWeightUnit?: Maybe<Scalars['String']['output']>;
  cargoWeightUnitId?: Maybe<Scalars['Int']['output']>;
  cargoWidth?: Maybe<Scalars['BigFloat']['output']>;
  chartererOrgId?: Maybe<Scalars['Int']['output']>;
  chartererOrgName?: Maybe<Scalars['String']['output']>;
  coaId?: Maybe<Scalars['Int']['output']>;
  commissions?: Maybe<Array<Maybe<ApiOrderCommission>>>;
  consigneeName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  currency?: Maybe<Currency>;
  demurrage?: Maybe<Scalars['BigFloat']['output']>;
  dischargePortCountryAlpha2?: Maybe<Scalars['String']['output']>;
  dischargePortId?: Maybe<Scalars['Int']['output']>;
  dischargePortLatitude?: Maybe<Scalars['BigFloat']['output']>;
  dischargePortLocode?: Maybe<Scalars['String']['output']>;
  dischargePortLongitude?: Maybe<Scalars['BigFloat']['output']>;
  dischargePortName?: Maybe<Scalars['String']['output']>;
  dischargingPortcallCostEstimation?: Maybe<Scalars['BigFloat']['output']>;
  dischargingPortcallCostEstimationCurrency?: Maybe<Currency>;
  dischargingRate?: Maybe<Scalars['BigFloat']['output']>;
  dischargingTerms?: Maybe<Scalars['String']['output']>;
  dischargingUnit?: Maybe<Scalars['String']['output']>;
  earliestDischarging?: Maybe<Scalars['String']['output']>;
  earliestLoading?: Maybe<Scalars['String']['output']>;
  externalCoaId?: Maybe<Scalars['String']['output']>;
  externalGroupingId?: Maybe<Scalars['String']['output']>;
  externalOrderId: Scalars['String']['output'];
  externalShipmentId?: Maybe<Scalars['String']['output']>;
  extraFreights?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  fixtureNote?: Maybe<Scalars['String']['output']>;
  freightAmount?: Maybe<Scalars['BigFloat']['output']>;
  freightUnit?: Maybe<PaymentUnit>;
  incoTerms?: Maybe<IncoTermsType>;
  isInquiry?: Maybe<Scalars['Boolean']['output']>;
  isPreliminary?: Maybe<Scalars['Boolean']['output']>;
  latestDischarging?: Maybe<Scalars['String']['output']>;
  latestLoading?: Maybe<Scalars['String']['output']>;
  loadPortCountryAlpha2?: Maybe<Scalars['String']['output']>;
  loadPortId?: Maybe<Scalars['Int']['output']>;
  loadPortLatitude?: Maybe<Scalars['BigFloat']['output']>;
  loadPortLocode?: Maybe<Scalars['String']['output']>;
  loadPortLongitude?: Maybe<Scalars['BigFloat']['output']>;
  loadPortName?: Maybe<Scalars['String']['output']>;
  loadingPortcallCostEstimation?: Maybe<Scalars['BigFloat']['output']>;
  loadingPortcallCostEstimationCurrency?: Maybe<Currency>;
  loadingRate?: Maybe<Scalars['BigFloat']['output']>;
  loadingTerms?: Maybe<Scalars['String']['output']>;
  loadingUnit?: Maybe<Scalars['String']['output']>;
  marginAmount?: Maybe<Scalars['BigFloat']['output']>;
  marginUnit?: Maybe<MarginUnit>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  nominatedVessel?: Maybe<Scalars['String']['output']>;
  onSubjectsUntil?: Maybe<Scalars['Datetime']['output']>;
  orderAttribute?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orderDetailId?: Maybe<Scalars['Int']['output']>;
  orderFreightId?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderNotes?: Maybe<Scalars['String']['output']>;
  orderRemoved?: Maybe<Scalars['Boolean']['output']>;
  sendingOrgId?: Maybe<Scalars['Int']['output']>;
  sendingOrgName?: Maybe<Scalars['String']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  specificGravity?: Maybe<Scalars['BigFloat']['output']>;
  stowageFactorMax?: Maybe<Scalars['BigFloat']['output']>;
  stowageFactorMin?: Maybe<Scalars['BigFloat']['output']>;
  stowageMode?: Maybe<StowageModeType>;
  voyageCharterExternalId?: Maybe<Scalars['String']['output']>;
  voyageCharterId?: Maybe<Scalars['Int']['output']>;
  voyageCharterName?: Maybe<Scalars['String']['output']>;
  voyageCharterRelationId?: Maybe<Scalars['Int']['output']>;
};

export type ApiOrderCommission = {
  __typename?: 'ApiOrderCommission';
  bafApplied?: Maybe<Scalars['Boolean']['output']>;
  demurrageApplied?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  extraFreightApplied?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CommissionType>;
  value?: Maybe<Scalars['BigFloat']['output']>;
};

/** An input for mutations affecting `ApiOrderCommission` */
export type ApiOrderCommissionInput = {
  bafApplied?: InputMaybe<Scalars['Boolean']['input']>;
  demurrageApplied?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  extraFreightApplied?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CommissionType>;
  value?: InputMaybe<Scalars['BigFloat']['input']>;
};

/**
 * A condition to be used against `ApiOrder` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ApiOrderCondition = {
  /** Checks for equality with the object’s `assortmentCargoType` field. */
  assortmentCargoType?: InputMaybe<CargoType>;
  /** Checks for equality with the object’s `assortmentGroup` field. */
  assortmentGroup?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `assortmentName` field. */
  assortmentName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cargoAmount` field. */
  cargoAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoCount` field. */
  cargoCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cargoDeckOption` field. */
  cargoDeckOption?: InputMaybe<CargoDeckOptionType>;
  /** Checks for equality with the object’s `cargoDepth` field. */
  cargoDepth?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoEquipmentCount` field. */
  cargoEquipmentCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cargoEquipmentId` field. */
  cargoEquipmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cargoEquipmentName` field. */
  cargoEquipmentName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cargoHeight` field. */
  cargoHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoLengthUnit` field. */
  cargoLengthUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cargoLengthUnitId` field. */
  cargoLengthUnitId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cargoPackageType` field. */
  cargoPackageType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cargoPackingMethod` field. */
  cargoPackingMethod?: InputMaybe<CargoPackingMethodType>;
  /** Checks for equality with the object’s `cargoUnit` field. */
  cargoUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cargoWeight` field. */
  cargoWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoWeightUnit` field. */
  cargoWeightUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cargoWeightUnitId` field. */
  cargoWeightUnitId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cargoWidth` field. */
  cargoWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chartererOrgName` field. */
  chartererOrgName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `coaId` field. */
  coaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `commissions` field. */
  commissions?: InputMaybe<Array<InputMaybe<ApiOrderCommissionInput>>>;
  /** Checks for equality with the object’s `consigneeName` field. */
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `demurrage` field. */
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargePortCountryAlpha2` field. */
  dischargePortCountryAlpha2?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dischargePortId` field. */
  dischargePortId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dischargePortLatitude` field. */
  dischargePortLatitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargePortLocode` field. */
  dischargePortLocode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dischargePortLongitude` field. */
  dischargePortLongitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargePortName` field. */
  dischargePortName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dischargingPortcallCostEstimation` field. */
  dischargingPortcallCostEstimation?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingPortcallCostEstimationCurrency` field. */
  dischargingPortcallCostEstimationCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingTerms` field. */
  dischargingTerms?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `earliestDischarging` field. */
  earliestDischarging?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `earliestLoading` field. */
  earliestLoading?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalCoaId` field. */
  externalCoaId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalGroupingId` field. */
  externalGroupingId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalOrderId` field. */
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `extraFreights` field. */
  extraFreights?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Checks for equality with the object’s `fixtureNote` field. */
  fixtureNote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `incoTerms` field. */
  incoTerms?: InputMaybe<IncoTermsType>;
  /** Checks for equality with the object’s `isInquiry` field. */
  isInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isPreliminary` field. */
  isPreliminary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `latestDischarging` field. */
  latestDischarging?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `latestLoading` field. */
  latestLoading?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadPortCountryAlpha2` field. */
  loadPortCountryAlpha2?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadPortId` field. */
  loadPortId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `loadPortLatitude` field. */
  loadPortLatitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadPortLocode` field. */
  loadPortLocode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadPortLongitude` field. */
  loadPortLongitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadPortName` field. */
  loadPortName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadingPortcallCostEstimation` field. */
  loadingPortcallCostEstimation?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingPortcallCostEstimationCurrency` field. */
  loadingPortcallCostEstimationCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingTerms` field. */
  loadingTerms?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `marginAmount` field. */
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `marginUnit` field. */
  marginUnit?: InputMaybe<MarginUnit>;
  /** Checks for equality with the object’s `nominatedVessel` field. */
  nominatedVessel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `onSubjectsUntil` field. */
  onSubjectsUntil?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `orderAttribute` field. */
  orderAttribute?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `orderDetailId` field. */
  orderDetailId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderFreightId` field. */
  orderFreightId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderName` field. */
  orderName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderNotes` field. */
  orderNotes?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderRemoved` field. */
  orderRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sendingOrgId` field. */
  sendingOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sendingOrgName` field. */
  sendingOrgName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `specificGravity` field. */
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stowageFactorMax` field. */
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stowageFactorMin` field. */
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stowageMode` field. */
  stowageMode?: InputMaybe<StowageModeType>;
  /** Checks for equality with the object’s `voyageCharterExternalId` field. */
  voyageCharterExternalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voyageCharterName` field. */
  voyageCharterName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `voyageCharterRelationId` field. */
  voyageCharterRelationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ApiOrder` object types. All fields are combined with a logical ‘and.’ */
export type ApiOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApiOrderFilter>>;
  /** Filter by the object’s `assortmentCargoType` field. */
  assortmentCargoType?: InputMaybe<CargoTypeFilter>;
  /** Filter by the object’s `assortmentGroup` field. */
  assortmentGroup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assortmentName` field. */
  assortmentName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cargoAmount` field. */
  cargoAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoCount` field. */
  cargoCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoDeckOption` field. */
  cargoDeckOption?: InputMaybe<CargoDeckOptionTypeFilter>;
  /** Filter by the object’s `cargoDepth` field. */
  cargoDepth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoEquipmentCount` field. */
  cargoEquipmentCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoEquipmentId` field. */
  cargoEquipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoEquipmentName` field. */
  cargoEquipmentName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cargoHeight` field. */
  cargoHeight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoLengthUnit` field. */
  cargoLengthUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cargoLengthUnitId` field. */
  cargoLengthUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoPackageType` field. */
  cargoPackageType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cargoPackingMethod` field. */
  cargoPackingMethod?: InputMaybe<CargoPackingMethodTypeFilter>;
  /** Filter by the object’s `cargoUnit` field. */
  cargoUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoWeight` field. */
  cargoWeight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoWeightUnit` field. */
  cargoWeightUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cargoWeightUnitId` field. */
  cargoWeightUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoWidth` field. */
  cargoWidth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chartererOrgName` field. */
  chartererOrgName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `coaId` field. */
  coaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `consigneeName` field. */
  consigneeName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `demurrage` field. */
  demurrage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargePortCountryAlpha2` field. */
  dischargePortCountryAlpha2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dischargePortId` field. */
  dischargePortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargePortLatitude` field. */
  dischargePortLatitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargePortLocode` field. */
  dischargePortLocode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dischargePortLongitude` field. */
  dischargePortLongitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargePortName` field. */
  dischargePortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dischargingPortcallCostEstimation` field. */
  dischargingPortcallCostEstimation?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingPortcallCostEstimationCurrency` field. */
  dischargingPortcallCostEstimationCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingTerms` field. */
  dischargingTerms?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `earliestDischarging` field. */
  earliestDischarging?: InputMaybe<StringFilter>;
  /** Filter by the object’s `earliestLoading` field. */
  earliestLoading?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalCoaId` field. */
  externalCoaId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalGroupingId` field. */
  externalGroupingId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalOrderId` field. */
  externalOrderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extraFreights` field. */
  extraFreights?: InputMaybe<JsonListFilter>;
  /** Filter by the object’s `fixtureNote` field. */
  fixtureNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `incoTerms` field. */
  incoTerms?: InputMaybe<IncoTermsTypeFilter>;
  /** Filter by the object’s `isInquiry` field. */
  isInquiry?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isPreliminary` field. */
  isPreliminary?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `latestDischarging` field. */
  latestDischarging?: InputMaybe<StringFilter>;
  /** Filter by the object’s `latestLoading` field. */
  latestLoading?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadPortCountryAlpha2` field. */
  loadPortCountryAlpha2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadPortId` field. */
  loadPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadPortLatitude` field. */
  loadPortLatitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadPortLocode` field. */
  loadPortLocode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadPortLongitude` field. */
  loadPortLongitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadPortName` field. */
  loadPortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadingPortcallCostEstimation` field. */
  loadingPortcallCostEstimation?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingPortcallCostEstimationCurrency` field. */
  loadingPortcallCostEstimationCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingTerms` field. */
  loadingTerms?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `marginAmount` field. */
  marginAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `marginUnit` field. */
  marginUnit?: InputMaybe<MarginUnitFilter>;
  /** Filter by the object’s `nominatedVessel` field. */
  nominatedVessel?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApiOrderFilter>;
  /** Filter by the object’s `onSubjectsUntil` field. */
  onSubjectsUntil?: InputMaybe<DatetimeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApiOrderFilter>>;
  /** Filter by the object’s `orderAttribute` field. */
  orderAttribute?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `orderDetailId` field. */
  orderDetailId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orderFreightId` field. */
  orderFreightId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orderName` field. */
  orderName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orderNotes` field. */
  orderNotes?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orderRemoved` field. */
  orderRemoved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sendingOrgId` field. */
  sendingOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sendingOrgName` field. */
  sendingOrgName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `specificGravity` field. */
  specificGravity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stowageFactorMax` field. */
  stowageFactorMax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stowageFactorMin` field. */
  stowageFactorMin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stowageMode` field. */
  stowageMode?: InputMaybe<StowageModeTypeFilter>;
  /** Filter by the object’s `voyageCharterExternalId` field. */
  voyageCharterExternalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageCharterName` field. */
  voyageCharterName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `voyageCharterRelationId` field. */
  voyageCharterRelationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ApiOrder` */
export type ApiOrderInput = {
  assortmentCargoType?: InputMaybe<CargoType>;
  assortmentGroup?: InputMaybe<Scalars['String']['input']>;
  assortmentGroupId?: InputMaybe<Scalars['Int']['input']>;
  assortmentId?: InputMaybe<Scalars['Int']['input']>;
  assortmentName?: InputMaybe<Scalars['String']['input']>;
  cargoAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoCount?: InputMaybe<Scalars['Int']['input']>;
  cargoDeckOption?: InputMaybe<CargoDeckOptionType>;
  cargoDepth?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoEquipmentCount?: InputMaybe<Scalars['Int']['input']>;
  cargoEquipmentId?: InputMaybe<Scalars['Int']['input']>;
  cargoEquipmentName?: InputMaybe<Scalars['String']['input']>;
  cargoHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoLengthUnit?: InputMaybe<Scalars['String']['input']>;
  cargoLengthUnitId?: InputMaybe<Scalars['Int']['input']>;
  cargoPackageType?: InputMaybe<Scalars['String']['input']>;
  cargoPackingMethod?: InputMaybe<CargoPackingMethodType>;
  cargoUnit?: InputMaybe<Scalars['String']['input']>;
  cargoUnitId?: InputMaybe<Scalars['Int']['input']>;
  cargoWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoWeightUnit?: InputMaybe<Scalars['String']['input']>;
  cargoWeightUnitId?: InputMaybe<Scalars['Int']['input']>;
  cargoWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  chartererOrgId?: InputMaybe<Scalars['Int']['input']>;
  chartererOrgName?: InputMaybe<Scalars['String']['input']>;
  coaId?: InputMaybe<Scalars['Int']['input']>;
  commissions?: InputMaybe<Array<InputMaybe<ApiOrderCommissionInput>>>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Currency>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargePortCountryAlpha2?: InputMaybe<Scalars['String']['input']>;
  dischargePortId?: InputMaybe<Scalars['Int']['input']>;
  dischargePortLatitude?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargePortLocode?: InputMaybe<Scalars['String']['input']>;
  dischargePortLongitude?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargePortName?: InputMaybe<Scalars['String']['input']>;
  dischargingPortcallCostEstimation?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingPortcallCostEstimationCurrency?: InputMaybe<Currency>;
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingTerms?: InputMaybe<Scalars['String']['input']>;
  dischargingUnit?: InputMaybe<Scalars['String']['input']>;
  earliestDischarging?: InputMaybe<Scalars['String']['input']>;
  earliestLoading?: InputMaybe<Scalars['String']['input']>;
  externalCoaId?: InputMaybe<Scalars['String']['input']>;
  externalGroupingId?: InputMaybe<Scalars['String']['input']>;
  externalOrderId: Scalars['String']['input'];
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  extraFreights?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  fixtureNote?: InputMaybe<Scalars['String']['input']>;
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightUnit?: InputMaybe<PaymentUnit>;
  incoTerms?: InputMaybe<IncoTermsType>;
  isInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  isPreliminary?: InputMaybe<Scalars['Boolean']['input']>;
  latestDischarging?: InputMaybe<Scalars['String']['input']>;
  latestLoading?: InputMaybe<Scalars['String']['input']>;
  loadPortCountryAlpha2?: InputMaybe<Scalars['String']['input']>;
  loadPortId?: InputMaybe<Scalars['Int']['input']>;
  loadPortLatitude?: InputMaybe<Scalars['BigFloat']['input']>;
  loadPortLocode?: InputMaybe<Scalars['String']['input']>;
  loadPortLongitude?: InputMaybe<Scalars['BigFloat']['input']>;
  loadPortName?: InputMaybe<Scalars['String']['input']>;
  loadingPortcallCostEstimation?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingPortcallCostEstimationCurrency?: InputMaybe<Currency>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingTerms?: InputMaybe<Scalars['String']['input']>;
  loadingUnit?: InputMaybe<Scalars['String']['input']>;
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  marginUnit?: InputMaybe<MarginUnit>;
  nominatedVessel?: InputMaybe<Scalars['String']['input']>;
  onSubjectsUntil?: InputMaybe<Scalars['Datetime']['input']>;
  orderAttribute?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderDetailId?: InputMaybe<Scalars['Int']['input']>;
  orderFreightId?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderName?: InputMaybe<Scalars['String']['input']>;
  orderNotes?: InputMaybe<Scalars['String']['input']>;
  orderRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  sendingOrgId?: InputMaybe<Scalars['Int']['input']>;
  sendingOrgName?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageMode?: InputMaybe<StowageModeType>;
  voyageCharterExternalId?: InputMaybe<Scalars['String']['input']>;
  voyageCharterId?: InputMaybe<Scalars['Int']['input']>;
  voyageCharterName?: InputMaybe<Scalars['String']['input']>;
  voyageCharterRelationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `ApiOrder` values. */
export type ApiOrdersConnection = {
  __typename?: 'ApiOrdersConnection';
  /** A list of edges which contains the `ApiOrder` and cursor to aid in pagination. */
  edges: Array<ApiOrdersEdge>;
  /** A list of `ApiOrder` objects. */
  nodes: Array<Maybe<ApiOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApiOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** All input for the `apiOrdersDateValidation` mutation. */
export type ApiOrdersDateValidationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  earliestDischargingParam?: InputMaybe<Scalars['String']['input']>;
  earliestLoadingParam?: InputMaybe<Scalars['String']['input']>;
  latestDischargingParam?: InputMaybe<Scalars['String']['input']>;
  latestLoadingParam?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `apiOrdersDateValidation` mutation. */
export type ApiOrdersDateValidationPayload = {
  __typename?: 'ApiOrdersDateValidationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<Maybe<ApiOrdersDateValidationRecord>>>;
};

/** The return type of our `apiOrdersDateValidation` mutation. */
export type ApiOrdersDateValidationRecord = {
  __typename?: 'ApiOrdersDateValidationRecord';
  earliestDischargingResult?: Maybe<Scalars['String']['output']>;
  earliestLoadingResult?: Maybe<Scalars['String']['output']>;
  latestDischargingResult?: Maybe<Scalars['String']['output']>;
  latestLoadingResult?: Maybe<Scalars['String']['output']>;
};

/** A `ApiOrder` edge in the connection. */
export type ApiOrdersEdge = {
  __typename?: 'ApiOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ApiOrder` at the end of the edge. */
  node?: Maybe<ApiOrder>;
};

export type ApiOrdersNotice = Node & {
  __typename?: 'ApiOrdersNotice';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ApiOrdersNoticeId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  notices: Scalars['JSON']['output'];
  /** Reads a single `Order` that is related to this `ApiOrdersNotice`. */
  orderByOrderId?: Maybe<Order>;
  orderId?: Maybe<Scalars['OrderId']['output']>;
  /** Reads a single `Organization` that is related to this `ApiOrdersNotice`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ApiOrdersNotice` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ApiOrdersNoticeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ApiOrdersNoticeId']['input']>;
  /** Checks for equality with the object’s `notices` field. */
  notices?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ApiOrdersNotice` object types. All fields are combined with a logical ‘and.’ */
export type ApiOrdersNoticeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApiOrdersNoticeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApiOrdersNoticeFilter>;
  /** Filter by the object’s `notices` field. */
  notices?: InputMaybe<JsonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApiOrdersNoticeFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ApiOrdersNotice` */
export type ApiOrdersNoticeInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  notices?: InputMaybe<Scalars['JSON']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `ApiOrdersNotice`. Fields that are set will be updated. */
export type ApiOrdersNoticePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  notices?: InputMaybe<Scalars['JSON']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `ApiOrdersNotice` values. */
export type ApiOrdersNoticesConnection = {
  __typename?: 'ApiOrdersNoticesConnection';
  /** A list of edges which contains the `ApiOrdersNotice` and cursor to aid in pagination. */
  edges: Array<ApiOrdersNoticesEdge>;
  /** A list of `ApiOrdersNotice` objects. */
  nodes: Array<Maybe<ApiOrdersNotice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApiOrdersNotice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApiOrdersNotice` edge in the connection. */
export type ApiOrdersNoticesEdge = {
  __typename?: 'ApiOrdersNoticesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ApiOrdersNotice` at the end of the edge. */
  node?: Maybe<ApiOrdersNotice>;
};

/** Methods to use when ordering `ApiOrdersNotice`. */
export enum ApiOrdersNoticesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  NOTICES_ASC = 'NOTICES_ASC',
  NOTICES_DESC = 'NOTICES_DESC',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** Methods to use when ordering `ApiOrder`. */
export enum ApiOrdersOrderBy {
  ASSORTMENT_CARGO_TYPE_ASC = 'ASSORTMENT_CARGO_TYPE_ASC',
  ASSORTMENT_CARGO_TYPE_DESC = 'ASSORTMENT_CARGO_TYPE_DESC',
  ASSORTMENT_GROUP_ASC = 'ASSORTMENT_GROUP_ASC',
  ASSORTMENT_GROUP_DESC = 'ASSORTMENT_GROUP_DESC',
  ASSORTMENT_GROUP_ID_ASC = 'ASSORTMENT_GROUP_ID_ASC',
  ASSORTMENT_GROUP_ID_DESC = 'ASSORTMENT_GROUP_ID_DESC',
  ASSORTMENT_ID_ASC = 'ASSORTMENT_ID_ASC',
  ASSORTMENT_ID_DESC = 'ASSORTMENT_ID_DESC',
  ASSORTMENT_NAME_ASC = 'ASSORTMENT_NAME_ASC',
  ASSORTMENT_NAME_DESC = 'ASSORTMENT_NAME_DESC',
  CARGO_AMOUNT_ASC = 'CARGO_AMOUNT_ASC',
  CARGO_AMOUNT_DESC = 'CARGO_AMOUNT_DESC',
  CARGO_COUNT_ASC = 'CARGO_COUNT_ASC',
  CARGO_COUNT_DESC = 'CARGO_COUNT_DESC',
  CARGO_DECK_OPTION_ASC = 'CARGO_DECK_OPTION_ASC',
  CARGO_DECK_OPTION_DESC = 'CARGO_DECK_OPTION_DESC',
  CARGO_DEPTH_ASC = 'CARGO_DEPTH_ASC',
  CARGO_DEPTH_DESC = 'CARGO_DEPTH_DESC',
  CARGO_EQUIPMENT_COUNT_ASC = 'CARGO_EQUIPMENT_COUNT_ASC',
  CARGO_EQUIPMENT_COUNT_DESC = 'CARGO_EQUIPMENT_COUNT_DESC',
  CARGO_EQUIPMENT_ID_ASC = 'CARGO_EQUIPMENT_ID_ASC',
  CARGO_EQUIPMENT_ID_DESC = 'CARGO_EQUIPMENT_ID_DESC',
  CARGO_EQUIPMENT_NAME_ASC = 'CARGO_EQUIPMENT_NAME_ASC',
  CARGO_EQUIPMENT_NAME_DESC = 'CARGO_EQUIPMENT_NAME_DESC',
  CARGO_HEIGHT_ASC = 'CARGO_HEIGHT_ASC',
  CARGO_HEIGHT_DESC = 'CARGO_HEIGHT_DESC',
  CARGO_LENGTH_UNIT_ASC = 'CARGO_LENGTH_UNIT_ASC',
  CARGO_LENGTH_UNIT_DESC = 'CARGO_LENGTH_UNIT_DESC',
  CARGO_LENGTH_UNIT_ID_ASC = 'CARGO_LENGTH_UNIT_ID_ASC',
  CARGO_LENGTH_UNIT_ID_DESC = 'CARGO_LENGTH_UNIT_ID_DESC',
  CARGO_PACKAGE_TYPE_ASC = 'CARGO_PACKAGE_TYPE_ASC',
  CARGO_PACKAGE_TYPE_DESC = 'CARGO_PACKAGE_TYPE_DESC',
  CARGO_PACKING_METHOD_ASC = 'CARGO_PACKING_METHOD_ASC',
  CARGO_PACKING_METHOD_DESC = 'CARGO_PACKING_METHOD_DESC',
  CARGO_UNIT_ASC = 'CARGO_UNIT_ASC',
  CARGO_UNIT_DESC = 'CARGO_UNIT_DESC',
  CARGO_UNIT_ID_ASC = 'CARGO_UNIT_ID_ASC',
  CARGO_UNIT_ID_DESC = 'CARGO_UNIT_ID_DESC',
  CARGO_WEIGHT_ASC = 'CARGO_WEIGHT_ASC',
  CARGO_WEIGHT_DESC = 'CARGO_WEIGHT_DESC',
  CARGO_WEIGHT_UNIT_ASC = 'CARGO_WEIGHT_UNIT_ASC',
  CARGO_WEIGHT_UNIT_DESC = 'CARGO_WEIGHT_UNIT_DESC',
  CARGO_WEIGHT_UNIT_ID_ASC = 'CARGO_WEIGHT_UNIT_ID_ASC',
  CARGO_WEIGHT_UNIT_ID_DESC = 'CARGO_WEIGHT_UNIT_ID_DESC',
  CARGO_WIDTH_ASC = 'CARGO_WIDTH_ASC',
  CARGO_WIDTH_DESC = 'CARGO_WIDTH_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  CHARTERER_ORG_NAME_ASC = 'CHARTERER_ORG_NAME_ASC',
  CHARTERER_ORG_NAME_DESC = 'CHARTERER_ORG_NAME_DESC',
  COA_ID_ASC = 'COA_ID_ASC',
  COA_ID_DESC = 'COA_ID_DESC',
  COMMISSIONS_ASC = 'COMMISSIONS_ASC',
  COMMISSIONS_DESC = 'COMMISSIONS_DESC',
  CONSIGNEE_NAME_ASC = 'CONSIGNEE_NAME_ASC',
  CONSIGNEE_NAME_DESC = 'CONSIGNEE_NAME_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  DEMURRAGE_ASC = 'DEMURRAGE_ASC',
  DEMURRAGE_DESC = 'DEMURRAGE_DESC',
  DISCHARGE_PORT_COUNTRY_ALPHA2_ASC = 'DISCHARGE_PORT_COUNTRY_ALPHA2_ASC',
  DISCHARGE_PORT_COUNTRY_ALPHA2_DESC = 'DISCHARGE_PORT_COUNTRY_ALPHA2_DESC',
  DISCHARGE_PORT_ID_ASC = 'DISCHARGE_PORT_ID_ASC',
  DISCHARGE_PORT_ID_DESC = 'DISCHARGE_PORT_ID_DESC',
  DISCHARGE_PORT_LATITUDE_ASC = 'DISCHARGE_PORT_LATITUDE_ASC',
  DISCHARGE_PORT_LATITUDE_DESC = 'DISCHARGE_PORT_LATITUDE_DESC',
  DISCHARGE_PORT_LOCODE_ASC = 'DISCHARGE_PORT_LOCODE_ASC',
  DISCHARGE_PORT_LOCODE_DESC = 'DISCHARGE_PORT_LOCODE_DESC',
  DISCHARGE_PORT_LONGITUDE_ASC = 'DISCHARGE_PORT_LONGITUDE_ASC',
  DISCHARGE_PORT_LONGITUDE_DESC = 'DISCHARGE_PORT_LONGITUDE_DESC',
  DISCHARGE_PORT_NAME_ASC = 'DISCHARGE_PORT_NAME_ASC',
  DISCHARGE_PORT_NAME_DESC = 'DISCHARGE_PORT_NAME_DESC',
  DISCHARGING_PORTCALL_COST_ESTIMATION_ASC = 'DISCHARGING_PORTCALL_COST_ESTIMATION_ASC',
  DISCHARGING_PORTCALL_COST_ESTIMATION_CURRENCY_ASC = 'DISCHARGING_PORTCALL_COST_ESTIMATION_CURRENCY_ASC',
  DISCHARGING_PORTCALL_COST_ESTIMATION_CURRENCY_DESC = 'DISCHARGING_PORTCALL_COST_ESTIMATION_CURRENCY_DESC',
  DISCHARGING_PORTCALL_COST_ESTIMATION_DESC = 'DISCHARGING_PORTCALL_COST_ESTIMATION_DESC',
  DISCHARGING_RATE_ASC = 'DISCHARGING_RATE_ASC',
  DISCHARGING_RATE_DESC = 'DISCHARGING_RATE_DESC',
  DISCHARGING_TERMS_ASC = 'DISCHARGING_TERMS_ASC',
  DISCHARGING_TERMS_DESC = 'DISCHARGING_TERMS_DESC',
  DISCHARGING_UNIT_ASC = 'DISCHARGING_UNIT_ASC',
  DISCHARGING_UNIT_DESC = 'DISCHARGING_UNIT_DESC',
  EARLIEST_DISCHARGING_ASC = 'EARLIEST_DISCHARGING_ASC',
  EARLIEST_DISCHARGING_DESC = 'EARLIEST_DISCHARGING_DESC',
  EARLIEST_LOADING_ASC = 'EARLIEST_LOADING_ASC',
  EARLIEST_LOADING_DESC = 'EARLIEST_LOADING_DESC',
  EXTERNAL_COA_ID_ASC = 'EXTERNAL_COA_ID_ASC',
  EXTERNAL_COA_ID_DESC = 'EXTERNAL_COA_ID_DESC',
  EXTERNAL_GROUPING_ID_ASC = 'EXTERNAL_GROUPING_ID_ASC',
  EXTERNAL_GROUPING_ID_DESC = 'EXTERNAL_GROUPING_ID_DESC',
  EXTERNAL_ORDER_ID_ASC = 'EXTERNAL_ORDER_ID_ASC',
  EXTERNAL_ORDER_ID_DESC = 'EXTERNAL_ORDER_ID_DESC',
  EXTERNAL_SHIPMENT_ID_ASC = 'EXTERNAL_SHIPMENT_ID_ASC',
  EXTERNAL_SHIPMENT_ID_DESC = 'EXTERNAL_SHIPMENT_ID_DESC',
  EXTRA_FREIGHTS_ASC = 'EXTRA_FREIGHTS_ASC',
  EXTRA_FREIGHTS_DESC = 'EXTRA_FREIGHTS_DESC',
  FIXTURE_NOTE_ASC = 'FIXTURE_NOTE_ASC',
  FIXTURE_NOTE_DESC = 'FIXTURE_NOTE_DESC',
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  INCO_TERMS_ASC = 'INCO_TERMS_ASC',
  INCO_TERMS_DESC = 'INCO_TERMS_DESC',
  IS_INQUIRY_ASC = 'IS_INQUIRY_ASC',
  IS_INQUIRY_DESC = 'IS_INQUIRY_DESC',
  IS_PRELIMINARY_ASC = 'IS_PRELIMINARY_ASC',
  IS_PRELIMINARY_DESC = 'IS_PRELIMINARY_DESC',
  LATEST_DISCHARGING_ASC = 'LATEST_DISCHARGING_ASC',
  LATEST_DISCHARGING_DESC = 'LATEST_DISCHARGING_DESC',
  LATEST_LOADING_ASC = 'LATEST_LOADING_ASC',
  LATEST_LOADING_DESC = 'LATEST_LOADING_DESC',
  LOADING_PORTCALL_COST_ESTIMATION_ASC = 'LOADING_PORTCALL_COST_ESTIMATION_ASC',
  LOADING_PORTCALL_COST_ESTIMATION_CURRENCY_ASC = 'LOADING_PORTCALL_COST_ESTIMATION_CURRENCY_ASC',
  LOADING_PORTCALL_COST_ESTIMATION_CURRENCY_DESC = 'LOADING_PORTCALL_COST_ESTIMATION_CURRENCY_DESC',
  LOADING_PORTCALL_COST_ESTIMATION_DESC = 'LOADING_PORTCALL_COST_ESTIMATION_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  LOADING_TERMS_ASC = 'LOADING_TERMS_ASC',
  LOADING_TERMS_DESC = 'LOADING_TERMS_DESC',
  LOADING_UNIT_ASC = 'LOADING_UNIT_ASC',
  LOADING_UNIT_DESC = 'LOADING_UNIT_DESC',
  LOAD_PORT_COUNTRY_ALPHA2_ASC = 'LOAD_PORT_COUNTRY_ALPHA2_ASC',
  LOAD_PORT_COUNTRY_ALPHA2_DESC = 'LOAD_PORT_COUNTRY_ALPHA2_DESC',
  LOAD_PORT_ID_ASC = 'LOAD_PORT_ID_ASC',
  LOAD_PORT_ID_DESC = 'LOAD_PORT_ID_DESC',
  LOAD_PORT_LATITUDE_ASC = 'LOAD_PORT_LATITUDE_ASC',
  LOAD_PORT_LATITUDE_DESC = 'LOAD_PORT_LATITUDE_DESC',
  LOAD_PORT_LOCODE_ASC = 'LOAD_PORT_LOCODE_ASC',
  LOAD_PORT_LOCODE_DESC = 'LOAD_PORT_LOCODE_DESC',
  LOAD_PORT_LONGITUDE_ASC = 'LOAD_PORT_LONGITUDE_ASC',
  LOAD_PORT_LONGITUDE_DESC = 'LOAD_PORT_LONGITUDE_DESC',
  LOAD_PORT_NAME_ASC = 'LOAD_PORT_NAME_ASC',
  LOAD_PORT_NAME_DESC = 'LOAD_PORT_NAME_DESC',
  MARGIN_AMOUNT_ASC = 'MARGIN_AMOUNT_ASC',
  MARGIN_AMOUNT_DESC = 'MARGIN_AMOUNT_DESC',
  MARGIN_UNIT_ASC = 'MARGIN_UNIT_ASC',
  MARGIN_UNIT_DESC = 'MARGIN_UNIT_DESC',
  NATURAL = 'NATURAL',
  NOMINATED_VESSEL_ASC = 'NOMINATED_VESSEL_ASC',
  NOMINATED_VESSEL_DESC = 'NOMINATED_VESSEL_DESC',
  ON_SUBJECTS_UNTIL_ASC = 'ON_SUBJECTS_UNTIL_ASC',
  ON_SUBJECTS_UNTIL_DESC = 'ON_SUBJECTS_UNTIL_DESC',
  ORDER_ATTRIBUTE_ASC = 'ORDER_ATTRIBUTE_ASC',
  ORDER_ATTRIBUTE_DESC = 'ORDER_ATTRIBUTE_DESC',
  ORDER_DETAIL_ID_ASC = 'ORDER_DETAIL_ID_ASC',
  ORDER_DETAIL_ID_DESC = 'ORDER_DETAIL_ID_DESC',
  ORDER_FREIGHT_ID_ASC = 'ORDER_FREIGHT_ID_ASC',
  ORDER_FREIGHT_ID_DESC = 'ORDER_FREIGHT_ID_DESC',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  ORDER_NAME_ASC = 'ORDER_NAME_ASC',
  ORDER_NAME_DESC = 'ORDER_NAME_DESC',
  ORDER_NOTES_ASC = 'ORDER_NOTES_ASC',
  ORDER_NOTES_DESC = 'ORDER_NOTES_DESC',
  ORDER_REMOVED_ASC = 'ORDER_REMOVED_ASC',
  ORDER_REMOVED_DESC = 'ORDER_REMOVED_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SENDING_ORG_ID_ASC = 'SENDING_ORG_ID_ASC',
  SENDING_ORG_ID_DESC = 'SENDING_ORG_ID_DESC',
  SENDING_ORG_NAME_ASC = 'SENDING_ORG_NAME_ASC',
  SENDING_ORG_NAME_DESC = 'SENDING_ORG_NAME_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  SPECIFIC_GRAVITY_ASC = 'SPECIFIC_GRAVITY_ASC',
  SPECIFIC_GRAVITY_DESC = 'SPECIFIC_GRAVITY_DESC',
  STOWAGE_FACTOR_MAX_ASC = 'STOWAGE_FACTOR_MAX_ASC',
  STOWAGE_FACTOR_MAX_DESC = 'STOWAGE_FACTOR_MAX_DESC',
  STOWAGE_FACTOR_MIN_ASC = 'STOWAGE_FACTOR_MIN_ASC',
  STOWAGE_FACTOR_MIN_DESC = 'STOWAGE_FACTOR_MIN_DESC',
  STOWAGE_MODE_ASC = 'STOWAGE_MODE_ASC',
  STOWAGE_MODE_DESC = 'STOWAGE_MODE_DESC',
  VOYAGE_CHARTER_EXTERNAL_ID_ASC = 'VOYAGE_CHARTER_EXTERNAL_ID_ASC',
  VOYAGE_CHARTER_EXTERNAL_ID_DESC = 'VOYAGE_CHARTER_EXTERNAL_ID_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC',
  VOYAGE_CHARTER_NAME_ASC = 'VOYAGE_CHARTER_NAME_ASC',
  VOYAGE_CHARTER_NAME_DESC = 'VOYAGE_CHARTER_NAME_DESC',
  VOYAGE_CHARTER_RELATION_ID_ASC = 'VOYAGE_CHARTER_RELATION_ID_ASC',
  VOYAGE_CHARTER_RELATION_ID_DESC = 'VOYAGE_CHARTER_RELATION_ID_DESC'
}

/** All input for the `apiPushExtraCost` mutation. */
export type ApiPushExtraCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  extraCostAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  extraCostDescription?: InputMaybe<Scalars['String']['input']>;
  extraCostExternalId?: InputMaybe<Scalars['String']['input']>;
  extraCostExternalName?: InputMaybe<Scalars['String']['input']>;
  extraCostType?: InputMaybe<VoyageCharterCostType>;
  voyageCharterExternalId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `apiPushExtraCost` mutation. */
export type ApiPushExtraCostPayload = {
  __typename?: 'ApiPushExtraCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `apiPushLostContract` mutation. */
export type ApiPushLostContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  freightAmountParam?: InputMaybe<Scalars['BigFloat']['input']>;
  freightCurrencyParam?: InputMaybe<Currency>;
  freightUnitParam?: InputMaybe<PaymentUnit>;
  remarksParam?: InputMaybe<Scalars['String']['input']>;
  voyageCharterIdParam?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `apiPushLostContract` mutation. */
export type ApiPushLostContractPayload = {
  __typename?: 'ApiPushLostContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `apiPushPortCost` mutation. */
export type ApiPushPortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  estimatedPortCostParam?: InputMaybe<Scalars['BigFloat']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  portCostCurrencyParam?: InputMaybe<Currency>;
  portCostParam?: InputMaybe<Scalars['BigFloat']['input']>;
  vesselName?: InputMaybe<Scalars['String']['input']>;
  voyageCharterExternalId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `apiPushPortCost` mutation. */
export type ApiPushPortCostPayload = {
  __typename?: 'ApiPushPortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `apiPushPortcallTime` mutation. */
export type ApiPushPortcallTimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  targetEventType?: InputMaybe<PortcallExternalTimestampEvent>;
  targetExternalOrderId?: InputMaybe<Scalars['String']['input']>;
  targetIsConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  targetIsLoadPortcall?: InputMaybe<Scalars['Boolean']['input']>;
  targetPortCallId?: InputMaybe<Scalars['Int']['input']>;
  targetPriority?: InputMaybe<Scalars['Int']['input']>;
  targetSourceName?: InputMaybe<Scalars['String']['input']>;
  targetTimestampType?: InputMaybe<PortcallExternalTimestampType>;
  targetValue?: InputMaybe<Scalars['Datetime']['input']>;
  targetValueIsLocaltime?: InputMaybe<Scalars['Boolean']['input']>;
  updateThresholdMinutes?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `apiPushPortcallTime` mutation. */
export type ApiPushPortcallTimePayload = {
  __typename?: 'ApiPushPortcallTimePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ApiScheduledOrder = {
  __typename?: 'ApiScheduledOrder';
  assortmentId?: Maybe<Scalars['Int']['output']>;
  assortmentName?: Maybe<Scalars['String']['output']>;
  cancelling?: Maybe<Scalars['Datetime']['output']>;
  cancellingLocalTime?: Maybe<Scalars['String']['output']>;
  cargoAmount?: Maybe<Scalars['BigFloat']['output']>;
  cargoUnit?: Maybe<Scalars['String']['output']>;
  chartererOrgName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  dischargePortCallPlannedArrival?: Maybe<Scalars['Datetime']['output']>;
  dischargePortCallPlannedArrivalDuration?: Maybe<Scalars['BigInt']['output']>;
  dischargePortCallPlannedBerthing?: Maybe<Scalars['Datetime']['output']>;
  dischargePortCallPlannedBerthingDuration?: Maybe<Scalars['BigInt']['output']>;
  dischargePortCallPlannedDeparture?: Maybe<Scalars['Datetime']['output']>;
  dischargePortCallPlannedDepartureDuration?: Maybe<Scalars['BigInt']['output']>;
  dischargePortLocationId?: Maybe<Scalars['Int']['output']>;
  dischargePortName?: Maybe<Scalars['String']['output']>;
  dischargingEnd?: Maybe<Scalars['Datetime']['output']>;
  dischargingRate?: Maybe<Scalars['BigFloat']['output']>;
  dischargingStart?: Maybe<Scalars['Datetime']['output']>;
  dischargingUnit?: Maybe<Scalars['String']['output']>;
  externalCoaId?: Maybe<Scalars['String']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  externalShipmentId?: Maybe<Scalars['String']['output']>;
  freightAmount?: Maybe<Scalars['BigFloat']['output']>;
  freightCurrency?: Maybe<Currency>;
  freightUnit?: Maybe<PaymentUnit>;
  imo?: Maybe<Scalars['BigFloat']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  layday?: Maybe<Scalars['Datetime']['output']>;
  laydayLocalTime?: Maybe<Scalars['String']['output']>;
  loadPortCallPlannedArrival?: Maybe<Scalars['Datetime']['output']>;
  loadPortCallPlannedArrivalDuration?: Maybe<Scalars['BigInt']['output']>;
  loadPortCallPlannedBerthing?: Maybe<Scalars['Datetime']['output']>;
  loadPortCallPlannedBerthingDuration?: Maybe<Scalars['BigInt']['output']>;
  loadPortCallPlannedDeparture?: Maybe<Scalars['Datetime']['output']>;
  loadPortCallPlannedDepartureDuration?: Maybe<Scalars['BigInt']['output']>;
  loadPortLocationId?: Maybe<Scalars['Int']['output']>;
  loadPortName?: Maybe<Scalars['String']['output']>;
  loadingEnd?: Maybe<Scalars['Datetime']['output']>;
  loadingRate?: Maybe<Scalars['BigFloat']['output']>;
  loadingStart?: Maybe<Scalars['Datetime']['output']>;
  loadingUnit?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orderRemoved?: Maybe<Scalars['Boolean']['output']>;
  shipId?: Maybe<Scalars['Int']['output']>;
  shipName?: Maybe<Scalars['String']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  shipmentName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  vesselId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `ApiScheduledOrder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ApiScheduledOrderCondition = {
  /** Checks for equality with the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `assortmentName` field. */
  assortmentName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cancelling` field. */
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `cancellingLocalTime` field. */
  cancellingLocalTime?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cargoAmount` field. */
  cargoAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoUnit` field. */
  cargoUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `chartererOrgName` field. */
  chartererOrgName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargePortCallPlannedArrival` field. */
  dischargePortCallPlannedArrival?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargePortCallPlannedArrivalDuration` field. */
  dischargePortCallPlannedArrivalDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargePortCallPlannedBerthing` field. */
  dischargePortCallPlannedBerthing?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargePortCallPlannedBerthingDuration` field. */
  dischargePortCallPlannedBerthingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargePortCallPlannedDeparture` field. */
  dischargePortCallPlannedDeparture?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargePortCallPlannedDepartureDuration` field. */
  dischargePortCallPlannedDepartureDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargePortLocationId` field. */
  dischargePortLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dischargePortName` field. */
  dischargePortName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalCoaId` field. */
  externalCoaId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalOrderId` field. */
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightCurrency` field. */
  freightCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `imo` field. */
  imo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `isPublished` field. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `layday` field. */
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `laydayLocalTime` field. */
  laydayLocalTime?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadPortCallPlannedArrival` field. */
  loadPortCallPlannedArrival?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadPortCallPlannedArrivalDuration` field. */
  loadPortCallPlannedArrivalDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadPortCallPlannedBerthing` field. */
  loadPortCallPlannedBerthing?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadPortCallPlannedBerthingDuration` field. */
  loadPortCallPlannedBerthingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadPortCallPlannedDeparture` field. */
  loadPortCallPlannedDeparture?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadPortCallPlannedDepartureDuration` field. */
  loadPortCallPlannedDepartureDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadPortLocationId` field. */
  loadPortLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `loadPortName` field. */
  loadPortName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderRemoved` field. */
  orderRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipName` field. */
  shipName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipmentName` field. */
  shipmentName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ApiScheduledOrder` object types. All fields are combined with a logical ‘and.’ */
export type ApiScheduledOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApiScheduledOrderFilter>>;
  /** Filter by the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assortmentName` field. */
  assortmentName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cancelling` field. */
  cancelling?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `cancellingLocalTime` field. */
  cancellingLocalTime?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cargoAmount` field. */
  cargoAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoUnit` field. */
  cargoUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chartererOrgName` field. */
  chartererOrgName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargePortCallPlannedArrival` field. */
  dischargePortCallPlannedArrival?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargePortCallPlannedArrivalDuration` field. */
  dischargePortCallPlannedArrivalDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargePortCallPlannedBerthing` field. */
  dischargePortCallPlannedBerthing?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargePortCallPlannedBerthingDuration` field. */
  dischargePortCallPlannedBerthingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargePortCallPlannedDeparture` field. */
  dischargePortCallPlannedDeparture?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargePortCallPlannedDepartureDuration` field. */
  dischargePortCallPlannedDepartureDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargePortLocationId` field. */
  dischargePortLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargePortName` field. */
  dischargePortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalCoaId` field. */
  externalCoaId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalOrderId` field. */
  externalOrderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightCurrency` field. */
  freightCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `imo` field. */
  imo?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `isPublished` field. */
  isPublished?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<StringFilter>;
  /** Filter by the object’s `layday` field. */
  layday?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `laydayLocalTime` field. */
  laydayLocalTime?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadPortCallPlannedArrival` field. */
  loadPortCallPlannedArrival?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadPortCallPlannedArrivalDuration` field. */
  loadPortCallPlannedArrivalDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadPortCallPlannedBerthing` field. */
  loadPortCallPlannedBerthing?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadPortCallPlannedBerthingDuration` field. */
  loadPortCallPlannedBerthingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadPortCallPlannedDeparture` field. */
  loadPortCallPlannedDeparture?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadPortCallPlannedDepartureDuration` field. */
  loadPortCallPlannedDepartureDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadPortLocationId` field. */
  loadPortLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadPortName` field. */
  loadPortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApiScheduledOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApiScheduledOrderFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orderRemoved` field. */
  orderRemoved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipName` field. */
  shipName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipmentName` field. */
  shipmentName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `ApiScheduledOrder` values. */
export type ApiScheduledOrdersConnection = {
  __typename?: 'ApiScheduledOrdersConnection';
  /** A list of edges which contains the `ApiScheduledOrder` and cursor to aid in pagination. */
  edges: Array<ApiScheduledOrdersEdge>;
  /** A list of `ApiScheduledOrder` objects. */
  nodes: Array<Maybe<ApiScheduledOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApiScheduledOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApiScheduledOrder` edge in the connection. */
export type ApiScheduledOrdersEdge = {
  __typename?: 'ApiScheduledOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ApiScheduledOrder` at the end of the edge. */
  node?: Maybe<ApiScheduledOrder>;
};

/** Methods to use when ordering `ApiScheduledOrder`. */
export enum ApiScheduledOrdersOrderBy {
  ASSORTMENT_ID_ASC = 'ASSORTMENT_ID_ASC',
  ASSORTMENT_ID_DESC = 'ASSORTMENT_ID_DESC',
  ASSORTMENT_NAME_ASC = 'ASSORTMENT_NAME_ASC',
  ASSORTMENT_NAME_DESC = 'ASSORTMENT_NAME_DESC',
  CANCELLING_ASC = 'CANCELLING_ASC',
  CANCELLING_DESC = 'CANCELLING_DESC',
  CANCELLING_LOCAL_TIME_ASC = 'CANCELLING_LOCAL_TIME_ASC',
  CANCELLING_LOCAL_TIME_DESC = 'CANCELLING_LOCAL_TIME_DESC',
  CARGO_AMOUNT_ASC = 'CARGO_AMOUNT_ASC',
  CARGO_AMOUNT_DESC = 'CARGO_AMOUNT_DESC',
  CARGO_UNIT_ASC = 'CARGO_UNIT_ASC',
  CARGO_UNIT_DESC = 'CARGO_UNIT_DESC',
  CHARTERER_ORG_NAME_ASC = 'CHARTERER_ORG_NAME_ASC',
  CHARTERER_ORG_NAME_DESC = 'CHARTERER_ORG_NAME_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DISCHARGE_PORT_CALL_PLANNED_ARRIVAL_ASC = 'DISCHARGE_PORT_CALL_PLANNED_ARRIVAL_ASC',
  DISCHARGE_PORT_CALL_PLANNED_ARRIVAL_DESC = 'DISCHARGE_PORT_CALL_PLANNED_ARRIVAL_DESC',
  DISCHARGE_PORT_CALL_PLANNED_ARRIVAL_DURATION_ASC = 'DISCHARGE_PORT_CALL_PLANNED_ARRIVAL_DURATION_ASC',
  DISCHARGE_PORT_CALL_PLANNED_ARRIVAL_DURATION_DESC = 'DISCHARGE_PORT_CALL_PLANNED_ARRIVAL_DURATION_DESC',
  DISCHARGE_PORT_CALL_PLANNED_BERTHING_ASC = 'DISCHARGE_PORT_CALL_PLANNED_BERTHING_ASC',
  DISCHARGE_PORT_CALL_PLANNED_BERTHING_DESC = 'DISCHARGE_PORT_CALL_PLANNED_BERTHING_DESC',
  DISCHARGE_PORT_CALL_PLANNED_BERTHING_DURATION_ASC = 'DISCHARGE_PORT_CALL_PLANNED_BERTHING_DURATION_ASC',
  DISCHARGE_PORT_CALL_PLANNED_BERTHING_DURATION_DESC = 'DISCHARGE_PORT_CALL_PLANNED_BERTHING_DURATION_DESC',
  DISCHARGE_PORT_CALL_PLANNED_DEPARTURE_ASC = 'DISCHARGE_PORT_CALL_PLANNED_DEPARTURE_ASC',
  DISCHARGE_PORT_CALL_PLANNED_DEPARTURE_DESC = 'DISCHARGE_PORT_CALL_PLANNED_DEPARTURE_DESC',
  DISCHARGE_PORT_CALL_PLANNED_DEPARTURE_DURATION_ASC = 'DISCHARGE_PORT_CALL_PLANNED_DEPARTURE_DURATION_ASC',
  DISCHARGE_PORT_CALL_PLANNED_DEPARTURE_DURATION_DESC = 'DISCHARGE_PORT_CALL_PLANNED_DEPARTURE_DURATION_DESC',
  DISCHARGE_PORT_LOCATION_ID_ASC = 'DISCHARGE_PORT_LOCATION_ID_ASC',
  DISCHARGE_PORT_LOCATION_ID_DESC = 'DISCHARGE_PORT_LOCATION_ID_DESC',
  DISCHARGE_PORT_NAME_ASC = 'DISCHARGE_PORT_NAME_ASC',
  DISCHARGE_PORT_NAME_DESC = 'DISCHARGE_PORT_NAME_DESC',
  DISCHARGING_END_ASC = 'DISCHARGING_END_ASC',
  DISCHARGING_END_DESC = 'DISCHARGING_END_DESC',
  DISCHARGING_RATE_ASC = 'DISCHARGING_RATE_ASC',
  DISCHARGING_RATE_DESC = 'DISCHARGING_RATE_DESC',
  DISCHARGING_START_ASC = 'DISCHARGING_START_ASC',
  DISCHARGING_START_DESC = 'DISCHARGING_START_DESC',
  DISCHARGING_UNIT_ASC = 'DISCHARGING_UNIT_ASC',
  DISCHARGING_UNIT_DESC = 'DISCHARGING_UNIT_DESC',
  EXTERNAL_COA_ID_ASC = 'EXTERNAL_COA_ID_ASC',
  EXTERNAL_COA_ID_DESC = 'EXTERNAL_COA_ID_DESC',
  EXTERNAL_ORDER_ID_ASC = 'EXTERNAL_ORDER_ID_ASC',
  EXTERNAL_ORDER_ID_DESC = 'EXTERNAL_ORDER_ID_DESC',
  EXTERNAL_SHIPMENT_ID_ASC = 'EXTERNAL_SHIPMENT_ID_ASC',
  EXTERNAL_SHIPMENT_ID_DESC = 'EXTERNAL_SHIPMENT_ID_DESC',
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_CURRENCY_ASC = 'FREIGHT_CURRENCY_ASC',
  FREIGHT_CURRENCY_DESC = 'FREIGHT_CURRENCY_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  IMO_ASC = 'IMO_ASC',
  IMO_DESC = 'IMO_DESC',
  IS_PUBLISHED_ASC = 'IS_PUBLISHED_ASC',
  IS_PUBLISHED_DESC = 'IS_PUBLISHED_DESC',
  KIND_ASC = 'KIND_ASC',
  KIND_DESC = 'KIND_DESC',
  LAYDAY_ASC = 'LAYDAY_ASC',
  LAYDAY_DESC = 'LAYDAY_DESC',
  LAYDAY_LOCAL_TIME_ASC = 'LAYDAY_LOCAL_TIME_ASC',
  LAYDAY_LOCAL_TIME_DESC = 'LAYDAY_LOCAL_TIME_DESC',
  LOADING_END_ASC = 'LOADING_END_ASC',
  LOADING_END_DESC = 'LOADING_END_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  LOADING_START_ASC = 'LOADING_START_ASC',
  LOADING_START_DESC = 'LOADING_START_DESC',
  LOADING_UNIT_ASC = 'LOADING_UNIT_ASC',
  LOADING_UNIT_DESC = 'LOADING_UNIT_DESC',
  LOAD_PORT_CALL_PLANNED_ARRIVAL_ASC = 'LOAD_PORT_CALL_PLANNED_ARRIVAL_ASC',
  LOAD_PORT_CALL_PLANNED_ARRIVAL_DESC = 'LOAD_PORT_CALL_PLANNED_ARRIVAL_DESC',
  LOAD_PORT_CALL_PLANNED_ARRIVAL_DURATION_ASC = 'LOAD_PORT_CALL_PLANNED_ARRIVAL_DURATION_ASC',
  LOAD_PORT_CALL_PLANNED_ARRIVAL_DURATION_DESC = 'LOAD_PORT_CALL_PLANNED_ARRIVAL_DURATION_DESC',
  LOAD_PORT_CALL_PLANNED_BERTHING_ASC = 'LOAD_PORT_CALL_PLANNED_BERTHING_ASC',
  LOAD_PORT_CALL_PLANNED_BERTHING_DESC = 'LOAD_PORT_CALL_PLANNED_BERTHING_DESC',
  LOAD_PORT_CALL_PLANNED_BERTHING_DURATION_ASC = 'LOAD_PORT_CALL_PLANNED_BERTHING_DURATION_ASC',
  LOAD_PORT_CALL_PLANNED_BERTHING_DURATION_DESC = 'LOAD_PORT_CALL_PLANNED_BERTHING_DURATION_DESC',
  LOAD_PORT_CALL_PLANNED_DEPARTURE_ASC = 'LOAD_PORT_CALL_PLANNED_DEPARTURE_ASC',
  LOAD_PORT_CALL_PLANNED_DEPARTURE_DESC = 'LOAD_PORT_CALL_PLANNED_DEPARTURE_DESC',
  LOAD_PORT_CALL_PLANNED_DEPARTURE_DURATION_ASC = 'LOAD_PORT_CALL_PLANNED_DEPARTURE_DURATION_ASC',
  LOAD_PORT_CALL_PLANNED_DEPARTURE_DURATION_DESC = 'LOAD_PORT_CALL_PLANNED_DEPARTURE_DURATION_DESC',
  LOAD_PORT_LOCATION_ID_ASC = 'LOAD_PORT_LOCATION_ID_ASC',
  LOAD_PORT_LOCATION_ID_DESC = 'LOAD_PORT_LOCATION_ID_DESC',
  LOAD_PORT_NAME_ASC = 'LOAD_PORT_NAME_ASC',
  LOAD_PORT_NAME_DESC = 'LOAD_PORT_NAME_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  ORDER_REMOVED_ASC = 'ORDER_REMOVED_ASC',
  ORDER_REMOVED_DESC = 'ORDER_REMOVED_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  SHIPMENT_NAME_ASC = 'SHIPMENT_NAME_ASC',
  SHIPMENT_NAME_DESC = 'SHIPMENT_NAME_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC',
  SHIP_NAME_ASC = 'SHIP_NAME_ASC',
  SHIP_NAME_DESC = 'SHIP_NAME_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type ApiShip = {
  __typename?: 'ApiShip';
  area?: Maybe<VesselArea>;
  attributeName?: Maybe<Scalars['String']['output']>;
  consumption?: Maybe<Scalars['BigFloat']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  gradeName?: Maybe<Scalars['String']['output']>;
  imo?: Maybe<Scalars['BigFloat']['output']>;
  inactive?: Maybe<Scalars['Boolean']['output']>;
  massCapacity?: Maybe<Scalars['BigFloat']['output']>;
  shipId?: Maybe<Scalars['Int']['output']>;
  shipName?: Maybe<Scalars['String']['output']>;
  speed?: Maybe<Scalars['BigFloat']['output']>;
  tag?: Maybe<VesselSpeedTag>;
  type?: Maybe<VesselSpeedType>;
  volumeCapacity?: Maybe<Scalars['BigFloat']['output']>;
  weightCapacity?: Maybe<Scalars['Int']['output']>;
  weightCapacityType?: Maybe<WeightCapacityType>;
};

/** A condition to be used against `ApiShip` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ApiShipCondition = {
  /** Checks for equality with the object’s `area` field. */
  area?: InputMaybe<VesselArea>;
  /** Checks for equality with the object’s `attributeName` field. */
  attributeName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `consumption` field. */
  consumption?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `gradeName` field. */
  gradeName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `imo` field. */
  imo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `inactive` field. */
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `massCapacity` field. */
  massCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipName` field. */
  shipName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `speed` field. */
  speed?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `tag` field. */
  tag?: InputMaybe<VesselSpeedTag>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<VesselSpeedType>;
  /** Checks for equality with the object’s `volumeCapacity` field. */
  volumeCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `weightCapacity` field. */
  weightCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `weightCapacityType` field. */
  weightCapacityType?: InputMaybe<WeightCapacityType>;
};

/** A filter to be used against `ApiShip` object types. All fields are combined with a logical ‘and.’ */
export type ApiShipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApiShipFilter>>;
  /** Filter by the object’s `area` field. */
  area?: InputMaybe<VesselAreaFilter>;
  /** Filter by the object’s `attributeName` field. */
  attributeName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `consumption` field. */
  consumption?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gradeName` field. */
  gradeName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `imo` field. */
  imo?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `inactive` field. */
  inactive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `massCapacity` field. */
  massCapacity?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApiShipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApiShipFilter>>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipName` field. */
  shipName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `speed` field. */
  speed?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `tag` field. */
  tag?: InputMaybe<VesselSpeedTagFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<VesselSpeedTypeFilter>;
  /** Filter by the object’s `volumeCapacity` field. */
  volumeCapacity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `weightCapacity` field. */
  weightCapacity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `weightCapacityType` field. */
  weightCapacityType?: InputMaybe<WeightCapacityTypeFilter>;
};

/** An input for mutations affecting `ApiShip` */
export type ApiShipInput = {
  area?: InputMaybe<VesselArea>;
  attributeName?: InputMaybe<Scalars['String']['input']>;
  consumption?: InputMaybe<Scalars['BigFloat']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  gradeName?: InputMaybe<Scalars['String']['input']>;
  imo?: InputMaybe<Scalars['BigFloat']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  massCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  shipId?: InputMaybe<Scalars['Int']['input']>;
  shipName?: InputMaybe<Scalars['String']['input']>;
  speed?: InputMaybe<Scalars['BigFloat']['input']>;
  tag?: InputMaybe<VesselSpeedTag>;
  type?: InputMaybe<VesselSpeedType>;
  volumeCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  weightCapacity?: InputMaybe<Scalars['Int']['input']>;
  weightCapacityType?: InputMaybe<WeightCapacityType>;
};

export type ApiShipmentStatus = {
  __typename?: 'ApiShipmentStatus';
  externalShipmentId?: Maybe<Scalars['String']['output']>;
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  shipmentStatusId?: Maybe<Scalars['Int']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ShipmentStatus>;
};

/**
 * A condition to be used against `ApiShipmentStatus` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ApiShipmentStatusCondition = {
  /** Checks for equality with the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isAccepted` field. */
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipmentStatusId` field. */
  shipmentStatusId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ShipmentStatus>;
};

/** A filter to be used against `ApiShipmentStatus` object types. All fields are combined with a logical ‘and.’ */
export type ApiShipmentStatusFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApiShipmentStatusFilter>>;
  /** Filter by the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isAccepted` field. */
  isAccepted?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApiShipmentStatusFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApiShipmentStatusFilter>>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipmentStatusId` field. */
  shipmentStatusId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ShipmentStatusFilter>;
};

/** An input for mutations affecting `ApiShipmentStatus` */
export type ApiShipmentStatusInput = {
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  shipmentStatusId?: InputMaybe<Scalars['Int']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ShipmentStatus>;
};

/** A connection to a list of `ApiShipmentStatus` values. */
export type ApiShipmentStatusesConnection = {
  __typename?: 'ApiShipmentStatusesConnection';
  /** A list of edges which contains the `ApiShipmentStatus` and cursor to aid in pagination. */
  edges: Array<ApiShipmentStatusesEdge>;
  /** A list of `ApiShipmentStatus` objects. */
  nodes: Array<Maybe<ApiShipmentStatus>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApiShipmentStatus` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApiShipmentStatus` edge in the connection. */
export type ApiShipmentStatusesEdge = {
  __typename?: 'ApiShipmentStatusesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ApiShipmentStatus` at the end of the edge. */
  node?: Maybe<ApiShipmentStatus>;
};

/** Methods to use when ordering `ApiShipmentStatus`. */
export enum ApiShipmentStatusesOrderBy {
  EXTERNAL_SHIPMENT_ID_ASC = 'EXTERNAL_SHIPMENT_ID_ASC',
  EXTERNAL_SHIPMENT_ID_DESC = 'EXTERNAL_SHIPMENT_ID_DESC',
  IS_ACCEPTED_ASC = 'IS_ACCEPTED_ASC',
  IS_ACCEPTED_DESC = 'IS_ACCEPTED_DESC',
  NATURAL = 'NATURAL',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  SHIPMENT_STATUS_ID_ASC = 'SHIPMENT_STATUS_ID_ASC',
  SHIPMENT_STATUS_ID_DESC = 'SHIPMENT_STATUS_ID_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC'
}

/** A connection to a list of `ApiShip` values. */
export type ApiShipsConnection = {
  __typename?: 'ApiShipsConnection';
  /** A list of edges which contains the `ApiShip` and cursor to aid in pagination. */
  edges: Array<ApiShipsEdge>;
  /** A list of `ApiShip` objects. */
  nodes: Array<Maybe<ApiShip>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApiShip` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ApiShip` edge in the connection. */
export type ApiShipsEdge = {
  __typename?: 'ApiShipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ApiShip` at the end of the edge. */
  node?: Maybe<ApiShip>;
};

/** Methods to use when ordering `ApiShip`. */
export enum ApiShipsOrderBy {
  AREA_ASC = 'AREA_ASC',
  AREA_DESC = 'AREA_DESC',
  ATTRIBUTE_NAME_ASC = 'ATTRIBUTE_NAME_ASC',
  ATTRIBUTE_NAME_DESC = 'ATTRIBUTE_NAME_DESC',
  CONSUMPTION_ASC = 'CONSUMPTION_ASC',
  CONSUMPTION_DESC = 'CONSUMPTION_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  GRADE_NAME_ASC = 'GRADE_NAME_ASC',
  GRADE_NAME_DESC = 'GRADE_NAME_DESC',
  IMO_ASC = 'IMO_ASC',
  IMO_DESC = 'IMO_DESC',
  INACTIVE_ASC = 'INACTIVE_ASC',
  INACTIVE_DESC = 'INACTIVE_DESC',
  MASS_CAPACITY_ASC = 'MASS_CAPACITY_ASC',
  MASS_CAPACITY_DESC = 'MASS_CAPACITY_DESC',
  NATURAL = 'NATURAL',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC',
  SHIP_NAME_ASC = 'SHIP_NAME_ASC',
  SHIP_NAME_DESC = 'SHIP_NAME_DESC',
  SPEED_ASC = 'SPEED_ASC',
  SPEED_DESC = 'SPEED_DESC',
  TAG_ASC = 'TAG_ASC',
  TAG_DESC = 'TAG_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  VOLUME_CAPACITY_ASC = 'VOLUME_CAPACITY_ASC',
  VOLUME_CAPACITY_DESC = 'VOLUME_CAPACITY_DESC',
  WEIGHT_CAPACITY_ASC = 'WEIGHT_CAPACITY_ASC',
  WEIGHT_CAPACITY_DESC = 'WEIGHT_CAPACITY_DESC',
  WEIGHT_CAPACITY_TYPE_ASC = 'WEIGHT_CAPACITY_TYPE_ASC',
  WEIGHT_CAPACITY_TYPE_DESC = 'WEIGHT_CAPACITY_TYPE_DESC'
}

export type Assortment = Node & {
  __typename?: 'Assortment';
  /** Reads and enables pagination through a set of `AssortmentExclusion`. */
  assortmentExclusionsByNextAssortment: AssortmentExclusionsConnection;
  /** Reads and enables pagination through a set of `AssortmentExclusion`. */
  assortmentExclusionsByPreviousAssortment: AssortmentExclusionsConnection;
  assortmentGroup?: Maybe<Scalars['AssortmentGroupId']['output']>;
  /** Reads a single `AssortmentGroup` that is related to this `Assortment`. */
  assortmentGroupByAssortmentGroup?: Maybe<AssortmentGroup>;
  /** Reads and enables pagination through a set of `CargoExclusion`. */
  cargoExclusionsByAssortment: CargoExclusionsConnection;
  cargoType?: Maybe<CargoType>;
  /** Reads a single `CargoUnit` that is related to this `Assortment`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /** Default cargo unit */
  cargoUnitId?: Maybe<Scalars['CargoUnitId']['output']>;
  chartererOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `CoaContractAssortment`. */
  coaContractAssortmentsByAssortmentId: CoaContractAssortmentsConnection;
  /** Reads and enables pagination through a set of `Commission`. */
  commissionsByAssortmentId: CommissionsConnection;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsByAssortment: DemandsConnection;
  /** Default discharging rate */
  dischargingRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Default discharging unit */
  dischargingUnit?: Maybe<LoadingUnit>;
  /** Link assortment information to external integration id */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Fill factor of the commodity */
  fillFactor?: Maybe<Scalars['BigFloat']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['AssortmentId']['output'];
  imoClass?: Maybe<ImoClass>;
  /** Default loading rate */
  loadingRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Default loading unit */
  loadingUnit?: Maybe<LoadingUnit>;
  marginAmount?: Maybe<Scalars['BigFloat']['output']>;
  marginUnit?: Maybe<MarginUnit>;
  name: Scalars['String']['output'];
  nameSynonyms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Order`. */
  ordersByAssortmentId: OrdersConnection;
  /** Reads and enables pagination through a set of `OrdersHistory`. */
  ordersHistoriesByAssortmentId: OrdersHistoriesConnection;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `PortCommodityLdRate`. */
  portCommodityLdRatesByAssortmentId: PortCommodityLdRatesConnection;
  requiresHeating?: Maybe<Scalars['Boolean']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  specificGravity?: Maybe<Scalars['BigFloat']['output']>;
  stowageFactorMax?: Maybe<Scalars['BigFloat']['output']>;
  stowageFactorMin?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesByAssortment: SuppliesConnection;
  /** Reads a single `User` that is related to this `Assortment`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
  /** Reads and enables pagination through a set of `VesselAttributeAssortmentExclusion`. */
  vesselAttributeAssortmentExclusionsByAssortmentId: VesselAttributeAssortmentExclusionsConnection;
};


export type AssortmentAssortmentExclusionsByNextAssortmentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentExclusionCondition>;
  filter?: InputMaybe<AssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};


export type AssortmentAssortmentExclusionsByPreviousAssortmentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentExclusionCondition>;
  filter?: InputMaybe<AssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};


export type AssortmentCargoExclusionsByAssortmentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoExclusionCondition>;
  filter?: InputMaybe<CargoExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoExclusionsOrderBy>>;
};


export type AssortmentCoaContractAssortmentsByAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractAssortmentCondition>;
  filter?: InputMaybe<CoaContractAssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractAssortmentsOrderBy>>;
};


export type AssortmentCommissionsByAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommissionCondition>;
  filter?: InputMaybe<CommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};


export type AssortmentDemandsByAssortmentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type AssortmentOrdersByAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type AssortmentOrdersHistoriesByAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrdersHistoryCondition>;
  filter?: InputMaybe<OrdersHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersHistoriesOrderBy>>;
};


export type AssortmentPortCommodityLdRatesByAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCommodityLdRateCondition>;
  filter?: InputMaybe<PortCommodityLdRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};


export type AssortmentSuppliesByAssortmentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};


export type AssortmentVesselAttributeAssortmentExclusionsByAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributeAssortmentExclusionCondition>;
  filter?: InputMaybe<VesselAttributeAssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributeAssortmentExclusionsOrderBy>>;
};

/**
 * A condition to be used against `Assortment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AssortmentCondition = {
  /** Checks for equality with the object’s `assortmentGroup` field. */
  assortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `cargoType` field. */
  cargoType?: InputMaybe<CargoType>;
  /** Checks for equality with the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fillFactor` field. */
  fillFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `imoClass` field. */
  imoClass?: InputMaybe<ImoClass>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `marginAmount` field. */
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `marginUnit` field. */
  marginUnit?: InputMaybe<MarginUnit>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nameSynonyms` field. */
  nameSynonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `requiresHeating` field. */
  requiresHeating?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `specificGravity` field. */
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stowageFactorMax` field. */
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stowageFactorMin` field. */
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

export type AssortmentExclusion = Node & {
  __typename?: 'AssortmentExclusion';
  /** Reads a single `Assortment` that is related to this `AssortmentExclusion`. */
  assortmentByNextAssortment?: Maybe<Assortment>;
  /** Reads a single `Assortment` that is related to this `AssortmentExclusion`. */
  assortmentByPreviousAssortment?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `AssortmentExclusion`. */
  assortmentGroupByNextAssortmentGroup?: Maybe<AssortmentGroup>;
  /** Reads a single `AssortmentGroup` that is related to this `AssortmentExclusion`. */
  assortmentGroupByPreviousAssortmentGroup?: Maybe<AssortmentGroup>;
  cleaningPossible?: Maybe<Scalars['Boolean']['output']>;
  distance?: Maybe<Scalars['BigFloat']['output']>;
  holdCleaningCost?: Maybe<Scalars['BigFloat']['output']>;
  holdCleaningTimeHours?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['AssortmentExclusionId']['output'];
  nextAssortment?: Maybe<Scalars['AssortmentId']['output']>;
  nextAssortmentGroup?: Maybe<Scalars['AssortmentGroupId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  previousAssortment?: Maybe<Scalars['AssortmentId']['output']>;
  previousAssortmentGroup?: Maybe<Scalars['AssortmentGroupId']['output']>;
  /** Reads and enables pagination through a set of `SingleEvent`. */
  singleEventsByCleaningAssortmentExclusionId: SingleEventsConnection;
  tanks?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `VesselAttribute` that is related to this `AssortmentExclusion`. */
  vesselAttributeByVesselCostClassId?: Maybe<VesselAttribute>;
  vesselCostClassId?: Maybe<Scalars['VesselAttributeId']['output']>;
  voyages?: Maybe<Scalars['Int']['output']>;
};


export type AssortmentExclusionSingleEventsByCleaningAssortmentExclusionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventCondition>;
  filter?: InputMaybe<SingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};

/**
 * A condition to be used against `AssortmentExclusion` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AssortmentExclusionCondition = {
  /** Checks for equality with the object’s `cleaningPossible` field. */
  cleaningPossible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `distance` field. */
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `holdCleaningCost` field. */
  holdCleaningCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `holdCleaningTimeHours` field. */
  holdCleaningTimeHours?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['AssortmentExclusionId']['input']>;
  /** Checks for equality with the object’s `nextAssortment` field. */
  nextAssortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `nextAssortmentGroup` field. */
  nextAssortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `previousAssortment` field. */
  previousAssortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `previousAssortmentGroup` field. */
  previousAssortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `tanks` field. */
  tanks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `vesselCostClassId` field. */
  vesselCostClassId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  /** Checks for equality with the object’s `voyages` field. */
  voyages?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `AssortmentExclusion` object types. All fields are combined with a logical ‘and.’ */
export type AssortmentExclusionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AssortmentExclusionFilter>>;
  /** Filter by the object’s `cleaningPossible` field. */
  cleaningPossible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `distance` field. */
  distance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `holdCleaningCost` field. */
  holdCleaningCost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `holdCleaningTimeHours` field. */
  holdCleaningTimeHours?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nextAssortment` field. */
  nextAssortment?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nextAssortmentGroup` field. */
  nextAssortmentGroup?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AssortmentExclusionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AssortmentExclusionFilter>>;
  /** Filter by the object’s `previousAssortment` field. */
  previousAssortment?: InputMaybe<IntFilter>;
  /** Filter by the object’s `previousAssortmentGroup` field. */
  previousAssortmentGroup?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tanks` field. */
  tanks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselCostClassId` field. */
  vesselCostClassId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyages` field. */
  voyages?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `AssortmentExclusion` */
export type AssortmentExclusionInput = {
  cleaningPossible?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  holdCleaningCost?: InputMaybe<Scalars['BigFloat']['input']>;
  holdCleaningTimeHours?: InputMaybe<Scalars['BigFloat']['input']>;
  nextAssortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  nextAssortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  previousAssortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  previousAssortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  tanks?: InputMaybe<Scalars['Int']['input']>;
  vesselCostClassId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  voyages?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `AssortmentExclusion`. Fields that are set will be updated. */
export type AssortmentExclusionPatch = {
  cleaningPossible?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  holdCleaningCost?: InputMaybe<Scalars['BigFloat']['input']>;
  holdCleaningTimeHours?: InputMaybe<Scalars['BigFloat']['input']>;
  nextAssortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  nextAssortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  previousAssortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  previousAssortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  tanks?: InputMaybe<Scalars['Int']['input']>;
  vesselCostClassId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  voyages?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AssortmentExclusion` values. */
export type AssortmentExclusionsConnection = {
  __typename?: 'AssortmentExclusionsConnection';
  /** A list of edges which contains the `AssortmentExclusion` and cursor to aid in pagination. */
  edges: Array<AssortmentExclusionsEdge>;
  /** A list of `AssortmentExclusion` objects. */
  nodes: Array<Maybe<AssortmentExclusion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AssortmentExclusion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AssortmentExclusion` edge in the connection. */
export type AssortmentExclusionsEdge = {
  __typename?: 'AssortmentExclusionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AssortmentExclusion` at the end of the edge. */
  node?: Maybe<AssortmentExclusion>;
};

/** Methods to use when ordering `AssortmentExclusion`. */
export enum AssortmentExclusionsOrderBy {
  CLEANING_POSSIBLE_ASC = 'CLEANING_POSSIBLE_ASC',
  CLEANING_POSSIBLE_DESC = 'CLEANING_POSSIBLE_DESC',
  DISTANCE_ASC = 'DISTANCE_ASC',
  DISTANCE_DESC = 'DISTANCE_DESC',
  HOLD_CLEANING_COST_ASC = 'HOLD_CLEANING_COST_ASC',
  HOLD_CLEANING_COST_DESC = 'HOLD_CLEANING_COST_DESC',
  HOLD_CLEANING_TIME_HOURS_ASC = 'HOLD_CLEANING_TIME_HOURS_ASC',
  HOLD_CLEANING_TIME_HOURS_DESC = 'HOLD_CLEANING_TIME_HOURS_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  NEXT_ASSORTMENT_ASC = 'NEXT_ASSORTMENT_ASC',
  NEXT_ASSORTMENT_DESC = 'NEXT_ASSORTMENT_DESC',
  NEXT_ASSORTMENT_GROUP_ASC = 'NEXT_ASSORTMENT_GROUP_ASC',
  NEXT_ASSORTMENT_GROUP_DESC = 'NEXT_ASSORTMENT_GROUP_DESC',
  PREVIOUS_ASSORTMENT_ASC = 'PREVIOUS_ASSORTMENT_ASC',
  PREVIOUS_ASSORTMENT_DESC = 'PREVIOUS_ASSORTMENT_DESC',
  PREVIOUS_ASSORTMENT_GROUP_ASC = 'PREVIOUS_ASSORTMENT_GROUP_ASC',
  PREVIOUS_ASSORTMENT_GROUP_DESC = 'PREVIOUS_ASSORTMENT_GROUP_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TANKS_ASC = 'TANKS_ASC',
  TANKS_DESC = 'TANKS_DESC',
  VESSEL_COST_CLASS_ID_ASC = 'VESSEL_COST_CLASS_ID_ASC',
  VESSEL_COST_CLASS_ID_DESC = 'VESSEL_COST_CLASS_ID_DESC',
  VOYAGES_ASC = 'VOYAGES_ASC',
  VOYAGES_DESC = 'VOYAGES_DESC'
}

/** A filter to be used against `Assortment` object types. All fields are combined with a logical ‘and.’ */
export type AssortmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AssortmentFilter>>;
  /** Filter by the object’s `assortmentGroup` field. */
  assortmentGroup?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoType` field. */
  cargoType?: InputMaybe<CargoTypeFilter>;
  /** Filter by the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fillFactor` field. */
  fillFactor?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `groupName` field. */
  groupName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imoClass` field. */
  imoClass?: InputMaybe<ImoClassFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `marginAmount` field. */
  marginAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `marginUnit` field. */
  marginUnit?: InputMaybe<MarginUnitFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameSynonyms` field. */
  nameSynonyms?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AssortmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AssortmentFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `requiresHeating` field. */
  requiresHeating?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `specificGravity` field. */
  specificGravity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stowageFactorMax` field. */
  stowageFactorMax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stowageFactorMin` field. */
  stowageFactorMin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

export type AssortmentGroup = Node & {
  __typename?: 'AssortmentGroup';
  /** Reads and enables pagination through a set of `AssortmentExclusion`. */
  assortmentExclusionsByNextAssortmentGroup: AssortmentExclusionsConnection;
  /** Reads and enables pagination through a set of `AssortmentExclusion`. */
  assortmentExclusionsByPreviousAssortmentGroup: AssortmentExclusionsConnection;
  /** Reads and enables pagination through a set of `Assortment`. */
  assortmentsByAssortmentGroup: AssortmentsConnection;
  /** Reads and enables pagination through a set of `CargoExclusion`. */
  cargoExclusionsByAssortmentGroup: CargoExclusionsConnection;
  /** Reads and enables pagination through a set of `ChannelCostEstimate`. */
  channelCostEstimatesByAssortmentGroupId: ChannelCostEstimatesConnection;
  chartererOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `CoaContractAssortment`. */
  coaContractAssortmentsByAssortmentGroupId: CoaContractAssortmentsConnection;
  /** External ID for fetching data from external APIs */
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['AssortmentGroupId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `AssortmentGroup`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads and enables pagination through a set of `PortCommodityLdRate`. */
  portCommodityLdRatesByAssortmentGroupId: PortCommodityLdRatesConnection;
  requiresHeating?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `User` that is related to this `AssortmentGroup`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
  /** Reads and enables pagination through a set of `VesselAttributeAssortmentExclusion`. */
  vesselAttributeAssortmentExclusionsByAssortmentGroupId: VesselAttributeAssortmentExclusionsConnection;
};


export type AssortmentGroupAssortmentExclusionsByNextAssortmentGroupArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentExclusionCondition>;
  filter?: InputMaybe<AssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};


export type AssortmentGroupAssortmentExclusionsByPreviousAssortmentGroupArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentExclusionCondition>;
  filter?: InputMaybe<AssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};


export type AssortmentGroupAssortmentsByAssortmentGroupArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentCondition>;
  filter?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};


export type AssortmentGroupCargoExclusionsByAssortmentGroupArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoExclusionCondition>;
  filter?: InputMaybe<CargoExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoExclusionsOrderBy>>;
};


export type AssortmentGroupChannelCostEstimatesByAssortmentGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostEstimateCondition>;
  filter?: InputMaybe<ChannelCostEstimateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
};


export type AssortmentGroupCoaContractAssortmentsByAssortmentGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractAssortmentCondition>;
  filter?: InputMaybe<CoaContractAssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractAssortmentsOrderBy>>;
};


export type AssortmentGroupPortCommodityLdRatesByAssortmentGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCommodityLdRateCondition>;
  filter?: InputMaybe<PortCommodityLdRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};


export type AssortmentGroupVesselAttributeAssortmentExclusionsByAssortmentGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributeAssortmentExclusionCondition>;
  filter?: InputMaybe<VesselAttributeAssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributeAssortmentExclusionsOrderBy>>;
};

/**
 * A condition to be used against `AssortmentGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AssortmentGroupCondition = {
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `requiresHeating` field. */
  requiresHeating?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `AssortmentGroup` object types. All fields are combined with a logical ‘and.’ */
export type AssortmentGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AssortmentGroupFilter>>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AssortmentGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AssortmentGroupFilter>>;
  /** Filter by the object’s `requiresHeating` field. */
  requiresHeating?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `AssortmentGroup` */
export type AssortmentGroupInput = {
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** External ID for fetching data from external APIs */
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requiresHeating?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `AssortmentGroup`. Fields that are set will be updated. */
export type AssortmentGroupPatch = {
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** External ID for fetching data from external APIs */
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresHeating?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `AssortmentGroup` values. */
export type AssortmentGroupsConnection = {
  __typename?: 'AssortmentGroupsConnection';
  /** A list of edges which contains the `AssortmentGroup` and cursor to aid in pagination. */
  edges: Array<AssortmentGroupsEdge>;
  /** A list of `AssortmentGroup` objects. */
  nodes: Array<Maybe<AssortmentGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AssortmentGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AssortmentGroup` edge in the connection. */
export type AssortmentGroupsEdge = {
  __typename?: 'AssortmentGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AssortmentGroup` at the end of the edge. */
  node?: Maybe<AssortmentGroup>;
};

/** Methods to use when ordering `AssortmentGroup`. */
export enum AssortmentGroupsOrderBy {
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REQUIRES_HEATING_ASC = 'REQUIRES_HEATING_ASC',
  REQUIRES_HEATING_DESC = 'REQUIRES_HEATING_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** An input for mutations affecting `Assortment` */
export type AssortmentInput = {
  assortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  cargoType?: InputMaybe<CargoType>;
  /** Default cargo unit */
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Default discharging rate */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Default discharging unit */
  dischargingUnit?: InputMaybe<LoadingUnit>;
  /** Link assortment information to external integration id */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Fill factor of the commodity */
  fillFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  imoClass?: InputMaybe<ImoClass>;
  /** Default loading rate */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Default loading unit */
  loadingUnit?: InputMaybe<LoadingUnit>;
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  marginUnit?: InputMaybe<MarginUnit>;
  name: Scalars['String']['input'];
  nameSynonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId: Scalars['OrganizationId']['input'];
  requiresHeating?: InputMaybe<Scalars['Boolean']['input']>;
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `Assortment`. Fields that are set will be updated. */
export type AssortmentPatch = {
  assortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  cargoType?: InputMaybe<CargoType>;
  /** Default cargo unit */
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Default discharging rate */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Default discharging unit */
  dischargingUnit?: InputMaybe<LoadingUnit>;
  /** Link assortment information to external integration id */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Fill factor of the commodity */
  fillFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  imoClass?: InputMaybe<ImoClass>;
  /** Default loading rate */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Default loading unit */
  loadingUnit?: InputMaybe<LoadingUnit>;
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  marginUnit?: InputMaybe<MarginUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameSynonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  requiresHeating?: InputMaybe<Scalars['Boolean']['input']>;
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `Assortment` values. */
export type AssortmentsConnection = {
  __typename?: 'AssortmentsConnection';
  /** A list of edges which contains the `Assortment` and cursor to aid in pagination. */
  edges: Array<AssortmentsEdge>;
  /** A list of `Assortment` objects. */
  nodes: Array<Maybe<Assortment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Assortment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Assortment` edge in the connection. */
export type AssortmentsEdge = {
  __typename?: 'AssortmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Assortment` at the end of the edge. */
  node?: Maybe<Assortment>;
};

/** Methods to use when ordering `Assortment`. */
export enum AssortmentsOrderBy {
  ASSORTMENT_GROUP_ASC = 'ASSORTMENT_GROUP_ASC',
  ASSORTMENT_GROUP_DESC = 'ASSORTMENT_GROUP_DESC',
  CARGO_TYPE_ASC = 'CARGO_TYPE_ASC',
  CARGO_TYPE_DESC = 'CARGO_TYPE_DESC',
  CARGO_UNIT_ID_ASC = 'CARGO_UNIT_ID_ASC',
  CARGO_UNIT_ID_DESC = 'CARGO_UNIT_ID_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  DISCHARGING_RATE_ASC = 'DISCHARGING_RATE_ASC',
  DISCHARGING_RATE_DESC = 'DISCHARGING_RATE_DESC',
  DISCHARGING_UNIT_ASC = 'DISCHARGING_UNIT_ASC',
  DISCHARGING_UNIT_DESC = 'DISCHARGING_UNIT_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  FILL_FACTOR_ASC = 'FILL_FACTOR_ASC',
  FILL_FACTOR_DESC = 'FILL_FACTOR_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IMO_CLASS_ASC = 'IMO_CLASS_ASC',
  IMO_CLASS_DESC = 'IMO_CLASS_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  LOADING_UNIT_ASC = 'LOADING_UNIT_ASC',
  LOADING_UNIT_DESC = 'LOADING_UNIT_DESC',
  MARGIN_AMOUNT_ASC = 'MARGIN_AMOUNT_ASC',
  MARGIN_AMOUNT_DESC = 'MARGIN_AMOUNT_DESC',
  MARGIN_UNIT_ASC = 'MARGIN_UNIT_ASC',
  MARGIN_UNIT_DESC = 'MARGIN_UNIT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NAME_SYNONYMS_ASC = 'NAME_SYNONYMS_ASC',
  NAME_SYNONYMS_DESC = 'NAME_SYNONYMS_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REQUIRES_HEATING_ASC = 'REQUIRES_HEATING_ASC',
  REQUIRES_HEATING_DESC = 'REQUIRES_HEATING_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SPECIFIC_GRAVITY_ASC = 'SPECIFIC_GRAVITY_ASC',
  SPECIFIC_GRAVITY_DESC = 'SPECIFIC_GRAVITY_DESC',
  STOWAGE_FACTOR_MAX_ASC = 'STOWAGE_FACTOR_MAX_ASC',
  STOWAGE_FACTOR_MAX_DESC = 'STOWAGE_FACTOR_MAX_DESC',
  STOWAGE_FACTOR_MIN_ASC = 'STOWAGE_FACTOR_MIN_ASC',
  STOWAGE_FACTOR_MIN_DESC = 'STOWAGE_FACTOR_MIN_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type AssortmentsSubscriptionPayload = {
  __typename?: 'AssortmentsSubscriptionPayload';
  assortment?: Maybe<Assortment>;
  event?: Maybe<Scalars['String']['output']>;
};

/** All input for the `authenticate` mutation. */
export type AuthenticateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** The output of our `authenticate` mutation. */
export type AuthenticatePayload = {
  __typename?: 'AuthenticatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export enum BafTypes {
  /** Actual bunkers used */
  ACTUAL_BUNKERS_USED = 'ACTUAL_BUNKERS_USED',
  /** Agreed bunker amount */
  AGREED_BUNKER_AMOUNT = 'AGREED_BUNKER_AMOUNT',
  /** Stepped */
  STEPPED = 'STEPPED'
}

/** A filter to be used against BafTypes fields. All fields are combined with a logical ‘and.’ */
export type BafTypesFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BafTypes>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BafTypes>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BafTypes>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BafTypes>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BafTypes>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BafTypes>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BafTypes>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BafTypes>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BafTypes>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BafTypes>>;
};

export type BalticConfig = {
  __typename?: 'BalticConfig';
  bookedCargoEndpoint: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  companyEndpoint: Scalars['String']['output'];
  hasBalticFeature: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  integrationUserId: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  organizationId: Scalars['Int']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  projectsEndpoint?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  sessionId: Scalars['Int']['output'];
  shipEndpoint: Scalars['String']['output'];
  tokenUrl: Scalars['String']['output'];
};

export type BalticConfigPayload = {
  __typename?: 'BalticConfigPayload';
  balticConfig?: Maybe<BalticConfig>;
};

export type BalticOrdersSyncResult = {
  __typename?: 'BalticOrdersSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type BalticScenarioSyncResult = {
  __typename?: 'BalticScenarioSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type BalticSyncInput = {
  resources?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BalticUpdateData = {
  __typename?: 'BalticUpdateData';
  syncOrders: BalticOrdersSyncResult;
  syncScenario: BalticScenarioSyncResult;
  syncVessel: BalticVesselsSyncResult;
};

export type BalticVesselsSyncResult = {
  __typename?: 'BalticVesselsSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type BatchTunePerformanceModelsInput = {
  vesselIds: Array<Scalars['Int']['input']>;
};

export type BatchTunePerformanceModelsResult = {
  __typename?: 'BatchTunePerformanceModelsResult';
  errorCount: Scalars['Int']['output'];
  results: Array<UpdateVesselPerformanceModelResult>;
  successCount: Scalars['Int']['output'];
  totalProcessed: Scalars['Int']['output'];
};

export type BatchUpdate = Node & {
  __typename?: 'BatchUpdate';
  createdAt: Scalars['Datetime']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['BatchUpdateId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `BatchUpdate`. */
  organizationByRootOrg?: Maybe<Organization>;
  rootOrg: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `BatchUpdate` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BatchUpdateCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BatchUpdateId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `BatchUpdate` object types. All fields are combined with a logical ‘and.’ */
export type BatchUpdateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BatchUpdateFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BatchUpdateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BatchUpdateFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `BatchUpdate` */
export type BatchUpdateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  data: Scalars['JSON']['input'];
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Represents an update to a `BatchUpdate`. Fields that are set will be updated. */
export type BatchUpdatePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

export type BatchUpdateSubscriptionPayload = {
  __typename?: 'BatchUpdateSubscriptionPayload';
  batchUpdate?: Maybe<BatchUpdate>;
  event?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `BatchUpdate` values. */
export type BatchUpdatesConnection = {
  __typename?: 'BatchUpdatesConnection';
  /** A list of edges which contains the `BatchUpdate` and cursor to aid in pagination. */
  edges: Array<BatchUpdatesEdge>;
  /** A list of `BatchUpdate` objects. */
  nodes: Array<Maybe<BatchUpdate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BatchUpdate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BatchUpdate` edge in the connection. */
export type BatchUpdatesEdge = {
  __typename?: 'BatchUpdatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BatchUpdate` at the end of the edge. */
  node?: Maybe<BatchUpdate>;
};

/** Methods to use when ordering `BatchUpdate`. */
export enum BatchUpdatesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DATA_ASC = 'DATA_ASC',
  DATA_DESC = 'DATA_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type BeaufortDistribution = {
  __typename?: 'BeaufortDistribution';
  HFO?: Maybe<Scalars['Float']['output']>;
  LNG?: Maybe<Scalars['Float']['output']>;
  LSFO?: Maybe<Scalars['Float']['output']>;
  MGO?: Maybe<Scalars['Float']['output']>;
};

export type BerthPrediction = {
  __typename?: 'BerthPrediction';
  InputUsedByTheModel?: Maybe<BerthPredictionMapping>;
  PredictedBerthTime?: Maybe<Scalars['Float']['output']>;
  ReceivedInputRow?: Maybe<BerthPredictionInputs>;
};

export type BerthPredictionInput = {
  berthName?: InputMaybe<Scalars['String']['input']>;
  cargo?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  portName?: InputMaybe<Scalars['String']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  vesselImo?: InputMaybe<Scalars['Int']['input']>;
  vesselName?: InputMaybe<Scalars['String']['input']>;
};

export type BerthPredictionInputs = {
  __typename?: 'BerthPredictionInputs';
  Cargo?: Maybe<Scalars['String']['output']>;
  Operation?: Maybe<Scalars['String']['output']>;
  PortName?: Maybe<Scalars['String']['output']>;
  Scheduled_Quantity?: Maybe<Scalars['Int']['output']>;
  TerminalName?: Maybe<Scalars['String']['output']>;
  VesselName?: Maybe<Scalars['String']['output']>;
  imoNumber?: Maybe<Scalars['String']['output']>;
};

export type BerthPredictionMapping = {
  __typename?: 'BerthPredictionMapping';
  Cargo?: Maybe<Scalars['String']['output']>;
  CargoOPL?: Maybe<Scalars['String']['output']>;
  Operation?: Maybe<Scalars['String']['output']>;
  PortName?: Maybe<Scalars['String']['output']>;
  Scheduled_Quantity?: Maybe<Scalars['Int']['output']>;
  TerminalName?: Maybe<Scalars['String']['output']>;
  VesselName?: Maybe<Scalars['String']['output']>;
  dwt?: Maybe<Scalars['Float']['output']>;
  imoNumber?: Maybe<Scalars['String']['output']>;
  vesselType?: Maybe<Scalars['String']['output']>;
};

export type BerthPredictions = {
  __typename?: 'BerthPredictions';
  predictions?: Maybe<Array<Maybe<BerthPrediction>>>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BillOfLading = Node & {
  __typename?: 'BillOfLading';
  /** Reads and enables pagination through a set of `BillOfLadingDatum`. */
  billOfLadingDataByBillOfLadingId: BillOfLadingDataConnection;
  blNumber?: Maybe<Scalars['String']['output']>;
  date: Scalars['Datetime']['output'];
  id: Scalars['BillOfLadingId']['output'];
  mastersName?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `BillOfLading`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `BillOfLading`. */
  portCallByPortCallId?: Maybe<PortCall>;
  portCallId: Scalars['PortCallId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `User` that is related to this `BillOfLading`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  /** Reads a single `VoyageCharter` that is related to this `BillOfLading`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId?: Maybe<Scalars['VoyageCharterId']['output']>;
};


export type BillOfLadingBillOfLadingDataByBillOfLadingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillOfLadingDatumCondition>;
  filter?: InputMaybe<BillOfLadingDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOfLadingDataOrderBy>>;
};

/**
 * A condition to be used against `BillOfLading` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BillOfLadingCondition = {
  /** Checks for equality with the object’s `blNumber` field. */
  blNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BillOfLadingId']['input']>;
  /** Checks for equality with the object’s `mastersName` field. */
  mastersName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `BillOfLadingDatum` values. */
export type BillOfLadingDataConnection = {
  __typename?: 'BillOfLadingDataConnection';
  /** A list of edges which contains the `BillOfLadingDatum` and cursor to aid in pagination. */
  edges: Array<BillOfLadingDataEdge>;
  /** A list of `BillOfLadingDatum` objects. */
  nodes: Array<Maybe<BillOfLadingDatum>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BillOfLadingDatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BillOfLadingDatum` edge in the connection. */
export type BillOfLadingDataEdge = {
  __typename?: 'BillOfLadingDataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BillOfLadingDatum` at the end of the edge. */
  node?: Maybe<BillOfLadingDatum>;
};

/** Methods to use when ordering `BillOfLadingDatum`. */
export enum BillOfLadingDataOrderBy {
  BATCH_NUMBER_ASC = 'BATCH_NUMBER_ASC',
  BATCH_NUMBER_DESC = 'BATCH_NUMBER_DESC',
  BILL_OF_LADING_ID_ASC = 'BILL_OF_LADING_ID_ASC',
  BILL_OF_LADING_ID_DESC = 'BILL_OF_LADING_ID_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VOLUME_ASC = 'VOLUME_ASC',
  VOLUME_DESC = 'VOLUME_DESC',
  VOLUME_ON_DECK_ASC = 'VOLUME_ON_DECK_ASC',
  VOLUME_ON_DECK_DESC = 'VOLUME_ON_DECK_DESC',
  VOLUME_UNIT_ASC = 'VOLUME_UNIT_ASC',
  VOLUME_UNIT_DESC = 'VOLUME_UNIT_DESC',
  WEIGHT_ASC = 'WEIGHT_ASC',
  WEIGHT_DESC = 'WEIGHT_DESC',
  WEIGHT_ON_DECK_ASC = 'WEIGHT_ON_DECK_ASC',
  WEIGHT_ON_DECK_DESC = 'WEIGHT_ON_DECK_DESC',
  WEIGHT_UNIT_ASC = 'WEIGHT_UNIT_ASC',
  WEIGHT_UNIT_DESC = 'WEIGHT_UNIT_DESC'
}

export type BillOfLadingDatum = Node & {
  __typename?: 'BillOfLadingDatum';
  batchNumber?: Maybe<Scalars['String']['output']>;
  /** Reads a single `BillOfLading` that is related to this `BillOfLadingDatum`. */
  billOfLadingByBillOfLadingId?: Maybe<BillOfLading>;
  billOfLadingId: Scalars['BillOfLadingId']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['BillOfLadingDatumId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `BillOfLadingDatum`. */
  orderByOrderId?: Maybe<Order>;
  orderId?: Maybe<Scalars['OrderId']['output']>;
  volume?: Maybe<Scalars['BigFloat']['output']>;
  volumeOnDeck?: Maybe<Scalars['BigFloat']['output']>;
  volumeUnit?: Maybe<VolumeUnits>;
  weight?: Maybe<Scalars['BigFloat']['output']>;
  weightOnDeck?: Maybe<Scalars['BigFloat']['output']>;
  weightUnit?: Maybe<WeightUnits>;
};

/**
 * A condition to be used against `BillOfLadingDatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BillOfLadingDatumCondition = {
  /** Checks for equality with the object’s `batchNumber` field. */
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `billOfLadingId` field. */
  billOfLadingId?: InputMaybe<Scalars['BillOfLadingId']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BillOfLadingDatumId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `volume` field. */
  volume?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `volumeOnDeck` field. */
  volumeOnDeck?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `volumeUnit` field. */
  volumeUnit?: InputMaybe<VolumeUnits>;
  /** Checks for equality with the object’s `weight` field. */
  weight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `weightOnDeck` field. */
  weightOnDeck?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `weightUnit` field. */
  weightUnit?: InputMaybe<WeightUnits>;
};

/** A filter to be used against `BillOfLadingDatum` object types. All fields are combined with a logical ‘and.’ */
export type BillOfLadingDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BillOfLadingDatumFilter>>;
  /** Filter by the object’s `batchNumber` field. */
  batchNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billOfLadingId` field. */
  billOfLadingId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BillOfLadingDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BillOfLadingDatumFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `volume` field. */
  volume?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `volumeOnDeck` field. */
  volumeOnDeck?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `volumeUnit` field. */
  volumeUnit?: InputMaybe<VolumeUnitsFilter>;
  /** Filter by the object’s `weight` field. */
  weight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `weightOnDeck` field. */
  weightOnDeck?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `weightUnit` field. */
  weightUnit?: InputMaybe<WeightUnitsFilter>;
};

/** An input for mutations affecting `BillOfLadingDatum` */
export type BillOfLadingDatumInput = {
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  billOfLadingId: Scalars['BillOfLadingId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  volume?: InputMaybe<Scalars['BigFloat']['input']>;
  volumeOnDeck?: InputMaybe<Scalars['BigFloat']['input']>;
  volumeUnit?: InputMaybe<VolumeUnits>;
  weight?: InputMaybe<Scalars['BigFloat']['input']>;
  weightOnDeck?: InputMaybe<Scalars['BigFloat']['input']>;
  weightUnit?: InputMaybe<WeightUnits>;
};

/** Represents an update to a `BillOfLadingDatum`. Fields that are set will be updated. */
export type BillOfLadingDatumPatch = {
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  billOfLadingId?: InputMaybe<Scalars['BillOfLadingId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  volume?: InputMaybe<Scalars['BigFloat']['input']>;
  volumeOnDeck?: InputMaybe<Scalars['BigFloat']['input']>;
  volumeUnit?: InputMaybe<VolumeUnits>;
  weight?: InputMaybe<Scalars['BigFloat']['input']>;
  weightOnDeck?: InputMaybe<Scalars['BigFloat']['input']>;
  weightUnit?: InputMaybe<WeightUnits>;
};

/** A filter to be used against `BillOfLading` object types. All fields are combined with a logical ‘and.’ */
export type BillOfLadingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BillOfLadingFilter>>;
  /** Filter by the object’s `blNumber` field. */
  blNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `mastersName` field. */
  mastersName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BillOfLadingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BillOfLadingFilter>>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `BillOfLading` */
export type BillOfLadingInput = {
  blNumber?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Datetime']['input'];
  mastersName?: InputMaybe<Scalars['String']['input']>;
  portCallId: Scalars['PortCallId']['input'];
  userId: Scalars['UserId']['input'];
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** Represents an update to a `BillOfLading`. Fields that are set will be updated. */
export type BillOfLadingPatch = {
  blNumber?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Datetime']['input']>;
  mastersName?: InputMaybe<Scalars['String']['input']>;
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `BillOfLading` values. */
export type BillOfLadingsConnection = {
  __typename?: 'BillOfLadingsConnection';
  /** A list of edges which contains the `BillOfLading` and cursor to aid in pagination. */
  edges: Array<BillOfLadingsEdge>;
  /** A list of `BillOfLading` objects. */
  nodes: Array<Maybe<BillOfLading>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BillOfLading` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BillOfLading` edge in the connection. */
export type BillOfLadingsEdge = {
  __typename?: 'BillOfLadingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BillOfLading` at the end of the edge. */
  node?: Maybe<BillOfLading>;
};

/** Methods to use when ordering `BillOfLading`. */
export enum BillOfLadingsOrderBy {
  BL_NUMBER_ASC = 'BL_NUMBER_ASC',
  BL_NUMBER_DESC = 'BL_NUMBER_DESC',
  DATE_ASC = 'DATE_ASC',
  DATE_DESC = 'DATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MASTERS_NAME_ASC = 'MASTERS_NAME_ASC',
  MASTERS_NAME_DESC = 'MASTERS_NAME_DESC',
  NATURAL = 'NATURAL',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BunkerEx = {
  __typename?: 'BunkerEx';
  message?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<Maybe<BunkerExSpotPrice>>>;
};

export type BunkerExFuelGrade = {
  __typename?: 'BunkerExFuelGrade';
  id: Scalars['String']['output'];
};

export type BunkerExLatestPrice = {
  __typename?: 'BunkerExLatestPrice';
  price: Scalars['Float']['output'];
  publishedDate: Scalars['String']['output'];
};

export type BunkerExPort = {
  __typename?: 'BunkerExPort';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BunkerExSpotPrice = {
  __typename?: 'BunkerExSpotPrice';
  fuelGrade: BunkerExFuelGrade;
  latestPrices: Array<BunkerExLatestPrice>;
  port: BunkerExPort;
};

export enum BunkerGrade {
  IFO180 = 'IFO180',
  IFO380 = 'IFO380',
  LS180 = 'LS180',
  LS380 = 'LS380',
  LSMGO = 'LSMGO',
  MDO = 'MDO',
  MGO = 'MGO',
  ULSFO = 'ULSFO'
}

export type BunkerGradeCalculation = Node & {
  __typename?: 'BunkerGradeCalculation';
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeCalculation`. */
  bunkerGradeOverrideByFromGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeCalculation`. */
  bunkerGradeOverrideByToGradeId?: Maybe<BunkerGradeOverride>;
  createdAt: Scalars['Datetime']['output'];
  fromGradeId: Scalars['BunkerGradeOverrideId']['output'];
  id: Scalars['BunkerGradeCalculationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `BunkerGradeCalculation`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  toGradeId: Scalars['BunkerGradeOverrideId']['output'];
};

/**
 * A condition to be used against `BunkerGradeCalculation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BunkerGradeCalculationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fromGradeId` field. */
  fromGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BunkerGradeCalculationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `toGradeId` field. */
  toGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
};

/** A filter to be used against `BunkerGradeCalculation` object types. All fields are combined with a logical ‘and.’ */
export type BunkerGradeCalculationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BunkerGradeCalculationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fromGradeId` field. */
  fromGradeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BunkerGradeCalculationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BunkerGradeCalculationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toGradeId` field. */
  toGradeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `BunkerGradeCalculation` */
export type BunkerGradeCalculationInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  fromGradeId: Scalars['BunkerGradeOverrideId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  toGradeId: Scalars['BunkerGradeOverrideId']['input'];
};

/** Represents an update to a `BunkerGradeCalculation`. Fields that are set will be updated. */
export type BunkerGradeCalculationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  fromGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  toGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
};

/** A connection to a list of `BunkerGradeCalculation` values. */
export type BunkerGradeCalculationsConnection = {
  __typename?: 'BunkerGradeCalculationsConnection';
  /** A list of edges which contains the `BunkerGradeCalculation` and cursor to aid in pagination. */
  edges: Array<BunkerGradeCalculationsEdge>;
  /** A list of `BunkerGradeCalculation` objects. */
  nodes: Array<Maybe<BunkerGradeCalculation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BunkerGradeCalculation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BunkerGradeCalculation` edge in the connection. */
export type BunkerGradeCalculationsEdge = {
  __typename?: 'BunkerGradeCalculationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BunkerGradeCalculation` at the end of the edge. */
  node?: Maybe<BunkerGradeCalculation>;
};

/** Methods to use when ordering `BunkerGradeCalculation`. */
export enum BunkerGradeCalculationsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FROM_GRADE_ID_ASC = 'FROM_GRADE_ID_ASC',
  FROM_GRADE_ID_DESC = 'FROM_GRADE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TO_GRADE_ID_ASC = 'TO_GRADE_ID_ASC',
  TO_GRADE_ID_DESC = 'TO_GRADE_ID_DESC'
}

/** A filter to be used against BunkerGrade fields. All fields are combined with a logical ‘and.’ */
export type BunkerGradeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BunkerGrade>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BunkerGrade>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BunkerGrade>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BunkerGrade>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BunkerGrade>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BunkerGrade>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BunkerGrade>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BunkerGrade>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BunkerGrade>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BunkerGrade>>;
};

export type BunkerGradeMapping = Node & {
  __typename?: 'BunkerGradeMapping';
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeMapping`. */
  bunkerGradeOverrideByFromGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeMapping`. */
  bunkerGradeOverrideByToGradeId?: Maybe<BunkerGradeOverride>;
  createdAt: Scalars['Datetime']['output'];
  fromGradeId: Scalars['BunkerGradeOverrideId']['output'];
  id: Scalars['BunkerGradeMappingId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `BunkerGradeMapping`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  toGradeId: Scalars['BunkerGradeOverrideId']['output'];
};

/**
 * A condition to be used against `BunkerGradeMapping` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BunkerGradeMappingCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `fromGradeId` field. */
  fromGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BunkerGradeMappingId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `toGradeId` field. */
  toGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
};

/** A filter to be used against `BunkerGradeMapping` object types. All fields are combined with a logical ‘and.’ */
export type BunkerGradeMappingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BunkerGradeMappingFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fromGradeId` field. */
  fromGradeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BunkerGradeMappingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BunkerGradeMappingFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toGradeId` field. */
  toGradeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `BunkerGradeMapping` */
export type BunkerGradeMappingInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  fromGradeId: Scalars['BunkerGradeOverrideId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  toGradeId: Scalars['BunkerGradeOverrideId']['input'];
};

/** Represents an update to a `BunkerGradeMapping`. Fields that are set will be updated. */
export type BunkerGradeMappingPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  fromGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  toGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
};

/** A connection to a list of `BunkerGradeMapping` values. */
export type BunkerGradeMappingsConnection = {
  __typename?: 'BunkerGradeMappingsConnection';
  /** A list of edges which contains the `BunkerGradeMapping` and cursor to aid in pagination. */
  edges: Array<BunkerGradeMappingsEdge>;
  /** A list of `BunkerGradeMapping` objects. */
  nodes: Array<Maybe<BunkerGradeMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BunkerGradeMapping` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BunkerGradeMapping` edge in the connection. */
export type BunkerGradeMappingsEdge = {
  __typename?: 'BunkerGradeMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BunkerGradeMapping` at the end of the edge. */
  node?: Maybe<BunkerGradeMapping>;
};

/** Methods to use when ordering `BunkerGradeMapping`. */
export enum BunkerGradeMappingsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FROM_GRADE_ID_ASC = 'FROM_GRADE_ID_ASC',
  FROM_GRADE_ID_DESC = 'FROM_GRADE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TO_GRADE_ID_ASC = 'TO_GRADE_ID_ASC',
  TO_GRADE_ID_DESC = 'TO_GRADE_ID_DESC'
}

export type BunkerGradeOverride = Node & {
  __typename?: 'BunkerGradeOverride';
  blendComponent1Id?: Maybe<Scalars['BunkerGradeOverrideId']['output']>;
  blendComponent2Id?: Maybe<Scalars['BunkerGradeOverrideId']['output']>;
  blendPercentage1?: Maybe<Scalars['BigFloat']['output']>;
  blendPercentage2?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `BunkerGradeCalculation`. */
  bunkerGradeCalculationsByFromGradeId: BunkerGradeCalculationsConnection;
  /** Reads and enables pagination through a set of `BunkerGradeCalculation`. */
  bunkerGradeCalculationsByToGradeId: BunkerGradeCalculationsConnection;
  /** Reads and enables pagination through a set of `BunkerGradeMapping`. */
  bunkerGradeMappingsByFromGradeId: BunkerGradeMappingsConnection;
  /** Reads and enables pagination through a set of `BunkerGradeMapping`. */
  bunkerGradeMappingsByToGradeId: BunkerGradeMappingsConnection;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeOverride`. */
  bunkerGradeOverrideByBlendComponent1Id?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeOverride`. */
  bunkerGradeOverrideByBlendComponent2Id?: Maybe<BunkerGradeOverride>;
  /** Reads and enables pagination through a set of `BunkerGradeOverride`. */
  bunkerGradeOverridesByBlendComponent1Id: BunkerGradeOverridesConnection;
  /** Reads and enables pagination through a set of `BunkerGradeOverride`. */
  bunkerGradeOverridesByBlendComponent2Id: BunkerGradeOverridesConnection;
  carbonFactor?: Maybe<Scalars['BigFloat']['output']>;
  /** Methane emission factor */
  ch4Factor?: Maybe<Scalars['BigFloat']['output']>;
  createdAt: Scalars['Datetime']['output'];
  currency: Currency;
  gradeName: Scalars['String']['output'];
  id: Scalars['BunkerGradeOverrideId']['output'];
  isBlend: Scalars['Boolean']['output'];
  /** Lower Calorific Value - energy content of the fuel */
  lcv?: Maybe<Scalars['BigFloat']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** Nitrous oxide emission factor */
  n2OFactor?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrganizationAreaBunkerGradeMapping`. */
  organizationAreaBunkerGradeMappingsByBunkerGradeId: OrganizationAreaBunkerGradeMappingsConnection;
  /** Reads a single `Organization` that is related to this `BunkerGradeOverride`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `BunkerGradeOverride`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  price?: Maybe<Scalars['BigFloat']['output']>;
  priceAdjustment?: Maybe<Scalars['BigFloat']['output']>;
  referenceGrade?: Maybe<Scalars['String']['output']>;
  referencePort?: Maybe<Scalars['String']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `Ship`. */
  shipsByDefaultBunkerGradeId: ShipsConnection;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `BunkerGradeOverride`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads and enables pagination through a set of `VesselSpeedConsumption`. */
  vesselSpeedConsumptionsByBunkerGradeId: VesselSpeedConsumptionsConnection;
  /** Well-to-Tank factor for emissions calculation */
  wttFactor?: Maybe<Scalars['BigFloat']['output']>;
};


export type BunkerGradeOverrideBunkerGradeCalculationsByFromGradeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeCalculationCondition>;
  filter?: InputMaybe<BunkerGradeCalculationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeCalculationsOrderBy>>;
};


export type BunkerGradeOverrideBunkerGradeCalculationsByToGradeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeCalculationCondition>;
  filter?: InputMaybe<BunkerGradeCalculationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeCalculationsOrderBy>>;
};


export type BunkerGradeOverrideBunkerGradeMappingsByFromGradeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeMappingCondition>;
  filter?: InputMaybe<BunkerGradeMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeMappingsOrderBy>>;
};


export type BunkerGradeOverrideBunkerGradeMappingsByToGradeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeMappingCondition>;
  filter?: InputMaybe<BunkerGradeMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeMappingsOrderBy>>;
};


export type BunkerGradeOverrideBunkerGradeOverridesByBlendComponent1IdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeOverrideCondition>;
  filter?: InputMaybe<BunkerGradeOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};


export type BunkerGradeOverrideBunkerGradeOverridesByBlendComponent2IdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeOverrideCondition>;
  filter?: InputMaybe<BunkerGradeOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};


export type BunkerGradeOverrideOrganizationAreaBunkerGradeMappingsByBunkerGradeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationAreaBunkerGradeMappingCondition>;
  filter?: InputMaybe<OrganizationAreaBunkerGradeMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationAreaBunkerGradeMappingsOrderBy>>;
};


export type BunkerGradeOverrideShipsByDefaultBunkerGradeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipCondition>;
  filter?: InputMaybe<ShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};


export type BunkerGradeOverrideVesselSpeedConsumptionsByBunkerGradeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSpeedConsumptionCondition>;
  filter?: InputMaybe<VesselSpeedConsumptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSpeedConsumptionsOrderBy>>;
};

/**
 * A condition to be used against `BunkerGradeOverride` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BunkerGradeOverrideCondition = {
  /** Checks for equality with the object’s `blendComponent1Id` field. */
  blendComponent1Id?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  /** Checks for equality with the object’s `blendComponent2Id` field. */
  blendComponent2Id?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  /** Checks for equality with the object’s `blendPercentage1` field. */
  blendPercentage1?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `blendPercentage2` field. */
  blendPercentage2?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `carbonFactor` field. */
  carbonFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ch4Factor` field. */
  ch4Factor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `gradeName` field. */
  gradeName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  /** Checks for equality with the object’s `isBlend` field. */
  isBlend?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lcv` field. */
  lcv?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `n2OFactor` field. */
  n2OFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `priceAdjustment` field. */
  priceAdjustment?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `referenceGrade` field. */
  referenceGrade?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `referencePort` field. */
  referencePort?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `wttFactor` field. */
  wttFactor?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `BunkerGradeOverride` object types. All fields are combined with a logical ‘and.’ */
export type BunkerGradeOverrideFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BunkerGradeOverrideFilter>>;
  /** Filter by the object’s `blendComponent1Id` field. */
  blendComponent1Id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blendComponent2Id` field. */
  blendComponent2Id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blendPercentage1` field. */
  blendPercentage1?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `blendPercentage2` field. */
  blendPercentage2?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `carbonFactor` field. */
  carbonFactor?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ch4Factor` field. */
  ch4Factor?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `gradeName` field. */
  gradeName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isBlend` field. */
  isBlend?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lcv` field. */
  lcv?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `n2OFactor` field. */
  n2OFactor?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BunkerGradeOverrideFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BunkerGradeOverrideFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `priceAdjustment` field. */
  priceAdjustment?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `referenceGrade` field. */
  referenceGrade?: InputMaybe<StringFilter>;
  /** Filter by the object’s `referencePort` field. */
  referencePort?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `wttFactor` field. */
  wttFactor?: InputMaybe<BigFloatFilter>;
};

/** A connection to a list of `BunkerGradeOverrideHistory` values. */
export type BunkerGradeOverrideHistoriesConnection = {
  __typename?: 'BunkerGradeOverrideHistoriesConnection';
  /** A list of edges which contains the `BunkerGradeOverrideHistory` and cursor to aid in pagination. */
  edges: Array<BunkerGradeOverrideHistoriesEdge>;
  /** A list of `BunkerGradeOverrideHistory` objects. */
  nodes: Array<Maybe<BunkerGradeOverrideHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BunkerGradeOverrideHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BunkerGradeOverrideHistory` edge in the connection. */
export type BunkerGradeOverrideHistoriesEdge = {
  __typename?: 'BunkerGradeOverrideHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BunkerGradeOverrideHistory` at the end of the edge. */
  node?: Maybe<BunkerGradeOverrideHistory>;
};

/** Methods to use when ordering `BunkerGradeOverrideHistory`. */
export enum BunkerGradeOverrideHistoriesOrderBy {
  BLEND_COMPONENT_1_ID_ASC = 'BLEND_COMPONENT_1_ID_ASC',
  BLEND_COMPONENT_1_ID_DESC = 'BLEND_COMPONENT_1_ID_DESC',
  BLEND_COMPONENT_2_ID_ASC = 'BLEND_COMPONENT_2_ID_ASC',
  BLEND_COMPONENT_2_ID_DESC = 'BLEND_COMPONENT_2_ID_DESC',
  BLEND_PERCENTAGE_1_ASC = 'BLEND_PERCENTAGE_1_ASC',
  BLEND_PERCENTAGE_1_DESC = 'BLEND_PERCENTAGE_1_DESC',
  BLEND_PERCENTAGE_2_ASC = 'BLEND_PERCENTAGE_2_ASC',
  BLEND_PERCENTAGE_2_DESC = 'BLEND_PERCENTAGE_2_DESC',
  CARBON_FACTOR_ASC = 'CARBON_FACTOR_ASC',
  CARBON_FACTOR_DESC = 'CARBON_FACTOR_DESC',
  CH4_FACTOR_ASC = 'CH4_FACTOR_ASC',
  CH4_FACTOR_DESC = 'CH4_FACTOR_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  GRADE_NAME_ASC = 'GRADE_NAME_ASC',
  GRADE_NAME_DESC = 'GRADE_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_BLEND_ASC = 'IS_BLEND_ASC',
  IS_BLEND_DESC = 'IS_BLEND_DESC',
  LCV_ASC = 'LCV_ASC',
  LCV_DESC = 'LCV_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  N2O_FACTOR_ASC = 'N2O_FACTOR_ASC',
  N2O_FACTOR_DESC = 'N2O_FACTOR_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRICE_ADJUSTMENT_ASC = 'PRICE_ADJUSTMENT_ASC',
  PRICE_ADJUSTMENT_DESC = 'PRICE_ADJUSTMENT_DESC',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  REFERENCE_GRADE_ASC = 'REFERENCE_GRADE_ASC',
  REFERENCE_GRADE_DESC = 'REFERENCE_GRADE_DESC',
  REFERENCE_PORT_ASC = 'REFERENCE_PORT_ASC',
  REFERENCE_PORT_DESC = 'REFERENCE_PORT_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  WTT_FACTOR_ASC = 'WTT_FACTOR_ASC',
  WTT_FACTOR_DESC = 'WTT_FACTOR_DESC'
}

/** History log for this table */
export type BunkerGradeOverrideHistory = {
  __typename?: 'BunkerGradeOverrideHistory';
  blendComponent1Id?: Maybe<Scalars['Int']['output']>;
  blendComponent2Id?: Maybe<Scalars['Int']['output']>;
  blendPercentage1?: Maybe<Scalars['BigFloat']['output']>;
  blendPercentage2?: Maybe<Scalars['BigFloat']['output']>;
  carbonFactor?: Maybe<Scalars['BigFloat']['output']>;
  ch4Factor?: Maybe<Scalars['BigFloat']['output']>;
  createdAt: Scalars['Datetime']['output'];
  currency: Currency;
  gradeName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isBlend?: Maybe<Scalars['Boolean']['output']>;
  lcv?: Maybe<Scalars['BigFloat']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  n2OFactor?: Maybe<Scalars['BigFloat']['output']>;
  organizationId: Scalars['Int']['output'];
  price?: Maybe<Scalars['BigFloat']['output']>;
  priceAdjustment?: Maybe<Scalars['BigFloat']['output']>;
  referenceGrade?: Maybe<Scalars['String']['output']>;
  referencePort?: Maybe<Scalars['String']['output']>;
  rootOrg: Scalars['Int']['output'];
  sysPeriod: DatetimeRange;
  wttFactor?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BunkerGradeOverrideHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BunkerGradeOverrideHistoryCondition = {
  /** Checks for equality with the object’s `blendComponent1Id` field. */
  blendComponent1Id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `blendComponent2Id` field. */
  blendComponent2Id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `blendPercentage1` field. */
  blendPercentage1?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `blendPercentage2` field. */
  blendPercentage2?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `carbonFactor` field. */
  carbonFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ch4Factor` field. */
  ch4Factor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `gradeName` field. */
  gradeName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isBlend` field. */
  isBlend?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lcv` field. */
  lcv?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `n2OFactor` field. */
  n2OFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `priceAdjustment` field. */
  priceAdjustment?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `referenceGrade` field. */
  referenceGrade?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `referencePort` field. */
  referencePort?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `wttFactor` field. */
  wttFactor?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `BunkerGradeOverrideHistory` object types. All fields are combined with a logical ‘and.’ */
export type BunkerGradeOverrideHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BunkerGradeOverrideHistoryFilter>>;
  /** Filter by the object’s `blendComponent1Id` field. */
  blendComponent1Id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blendComponent2Id` field. */
  blendComponent2Id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blendPercentage1` field. */
  blendPercentage1?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `blendPercentage2` field. */
  blendPercentage2?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `carbonFactor` field. */
  carbonFactor?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ch4Factor` field. */
  ch4Factor?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `gradeName` field. */
  gradeName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isBlend` field. */
  isBlend?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lcv` field. */
  lcv?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `n2OFactor` field. */
  n2OFactor?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BunkerGradeOverrideHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BunkerGradeOverrideHistoryFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `priceAdjustment` field. */
  priceAdjustment?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `referenceGrade` field. */
  referenceGrade?: InputMaybe<StringFilter>;
  /** Filter by the object’s `referencePort` field. */
  referencePort?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `wttFactor` field. */
  wttFactor?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `BunkerGradeOverride` */
export type BunkerGradeOverrideInput = {
  blendComponent1Id?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  blendComponent2Id?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  blendPercentage1?: InputMaybe<Scalars['BigFloat']['input']>;
  blendPercentage2?: InputMaybe<Scalars['BigFloat']['input']>;
  carbonFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Methane emission factor */
  ch4Factor?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency: Currency;
  gradeName: Scalars['String']['input'];
  isBlend?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lower Calorific Value - energy content of the fuel */
  lcv?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Nitrous oxide emission factor */
  n2OFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  priceAdjustment?: InputMaybe<Scalars['BigFloat']['input']>;
  referenceGrade?: InputMaybe<Scalars['String']['input']>;
  referencePort?: InputMaybe<Scalars['String']['input']>;
  /** Well-to-Tank factor for emissions calculation */
  wttFactor?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Represents an update to a `BunkerGradeOverride`. Fields that are set will be updated. */
export type BunkerGradeOverridePatch = {
  blendComponent1Id?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  blendComponent2Id?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  blendPercentage1?: InputMaybe<Scalars['BigFloat']['input']>;
  blendPercentage2?: InputMaybe<Scalars['BigFloat']['input']>;
  carbonFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Methane emission factor */
  ch4Factor?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Currency>;
  gradeName?: InputMaybe<Scalars['String']['input']>;
  isBlend?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lower Calorific Value - energy content of the fuel */
  lcv?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Nitrous oxide emission factor */
  n2OFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  priceAdjustment?: InputMaybe<Scalars['BigFloat']['input']>;
  referenceGrade?: InputMaybe<Scalars['String']['input']>;
  referencePort?: InputMaybe<Scalars['String']['input']>;
  /** Well-to-Tank factor for emissions calculation */
  wttFactor?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `BunkerGradeOverride` values. */
export type BunkerGradeOverridesConnection = {
  __typename?: 'BunkerGradeOverridesConnection';
  /** A list of edges which contains the `BunkerGradeOverride` and cursor to aid in pagination. */
  edges: Array<BunkerGradeOverridesEdge>;
  /** A list of `BunkerGradeOverride` objects. */
  nodes: Array<Maybe<BunkerGradeOverride>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BunkerGradeOverride` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BunkerGradeOverride` edge in the connection. */
export type BunkerGradeOverridesEdge = {
  __typename?: 'BunkerGradeOverridesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BunkerGradeOverride` at the end of the edge. */
  node?: Maybe<BunkerGradeOverride>;
};

/** Methods to use when ordering `BunkerGradeOverride`. */
export enum BunkerGradeOverridesOrderBy {
  BLEND_COMPONENT_1_ID_ASC = 'BLEND_COMPONENT_1_ID_ASC',
  BLEND_COMPONENT_1_ID_DESC = 'BLEND_COMPONENT_1_ID_DESC',
  BLEND_COMPONENT_2_ID_ASC = 'BLEND_COMPONENT_2_ID_ASC',
  BLEND_COMPONENT_2_ID_DESC = 'BLEND_COMPONENT_2_ID_DESC',
  BLEND_PERCENTAGE_1_ASC = 'BLEND_PERCENTAGE_1_ASC',
  BLEND_PERCENTAGE_1_DESC = 'BLEND_PERCENTAGE_1_DESC',
  BLEND_PERCENTAGE_2_ASC = 'BLEND_PERCENTAGE_2_ASC',
  BLEND_PERCENTAGE_2_DESC = 'BLEND_PERCENTAGE_2_DESC',
  CARBON_FACTOR_ASC = 'CARBON_FACTOR_ASC',
  CARBON_FACTOR_DESC = 'CARBON_FACTOR_DESC',
  CH4_FACTOR_ASC = 'CH4_FACTOR_ASC',
  CH4_FACTOR_DESC = 'CH4_FACTOR_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  GRADE_NAME_ASC = 'GRADE_NAME_ASC',
  GRADE_NAME_DESC = 'GRADE_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_BLEND_ASC = 'IS_BLEND_ASC',
  IS_BLEND_DESC = 'IS_BLEND_DESC',
  LCV_ASC = 'LCV_ASC',
  LCV_DESC = 'LCV_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  N2O_FACTOR_ASC = 'N2O_FACTOR_ASC',
  N2O_FACTOR_DESC = 'N2O_FACTOR_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRICE_ADJUSTMENT_ASC = 'PRICE_ADJUSTMENT_ASC',
  PRICE_ADJUSTMENT_DESC = 'PRICE_ADJUSTMENT_DESC',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REFERENCE_GRADE_ASC = 'REFERENCE_GRADE_ASC',
  REFERENCE_GRADE_DESC = 'REFERENCE_GRADE_DESC',
  REFERENCE_PORT_ASC = 'REFERENCE_PORT_ASC',
  REFERENCE_PORT_DESC = 'REFERENCE_PORT_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  WTT_FACTOR_ASC = 'WTT_FACTOR_ASC',
  WTT_FACTOR_DESC = 'WTT_FACTOR_DESC'
}

export type Bunkering = Node & {
  __typename?: 'Bunkering';
  duration?: Maybe<Scalars['BigFloat']['output']>;
  end: Scalars['Datetime']['output'];
  id: Scalars['BunkeringId']['output'];
  /** Reads a single `Location` that is related to this `Bunkering`. */
  locationByLocationId?: Maybe<Location>;
  locationId?: Maybe<Scalars['LocationId']['output']>;
  locked: Scalars['Boolean']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Bunkering`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  planningOrganisationId: Scalars['OrganizationId']['output'];
  shared: Scalars['Boolean']['output'];
  /** Reads a single `Ship` that is related to this `Bunkering`. */
  shipByVesselId?: Maybe<Ship>;
  start: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `Bunkering`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};

/**
 * A condition to be used against `Bunkering` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BunkeringCondition = {
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BunkeringId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `locked` field. */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meta` field. */
  meta?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `Bunkering` object types. All fields are combined with a logical ‘and.’ */
export type BunkeringFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BunkeringFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locked` field. */
  locked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meta` field. */
  meta?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BunkeringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BunkeringFilter>>;
  /** Filter by the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Bunkering` */
export type BunkeringInput = {
  duration?: InputMaybe<Scalars['BigFloat']['input']>;
  end: Scalars['Datetime']['input'];
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  locked: Scalars['Boolean']['input'];
  meta?: InputMaybe<Scalars['String']['input']>;
  planningOrganisationId: Scalars['OrganizationId']['input'];
  shared: Scalars['Boolean']['input'];
  start: Scalars['Datetime']['input'];
  userId: Scalars['UserId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `Bunkering`. Fields that are set will be updated. */
export type BunkeringPatch = {
  duration?: InputMaybe<Scalars['BigFloat']['input']>;
  end?: InputMaybe<Scalars['Datetime']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  planningOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `Bunkering` values. */
export type BunkeringsConnection = {
  __typename?: 'BunkeringsConnection';
  /** A list of edges which contains the `Bunkering` and cursor to aid in pagination. */
  edges: Array<BunkeringsEdge>;
  /** A list of `Bunkering` objects. */
  nodes: Array<Maybe<Bunkering>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Bunkering` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Bunkering` edge in the connection. */
export type BunkeringsEdge = {
  __typename?: 'BunkeringsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Bunkering` at the end of the edge. */
  node?: Maybe<Bunkering>;
};

/** Methods to use when ordering `Bunkering`. */
export enum BunkeringsOrderBy {
  DURATION_ASC = 'DURATION_ASC',
  DURATION_DESC = 'DURATION_DESC',
  END_ASC = 'END_ASC',
  END_DESC = 'END_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  LOCKED_ASC = 'LOCKED_ASC',
  LOCKED_DESC = 'LOCKED_DESC',
  META_ASC = 'META_ASC',
  META_DESC = 'META_DESC',
  NATURAL = 'NATURAL',
  PLANNING_ORGANISATION_ID_ASC = 'PLANNING_ORGANISATION_ID_ASC',
  PLANNING_ORGANISATION_ID_DESC = 'PLANNING_ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  START_ASC = 'START_ASC',
  START_DESC = 'START_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type CachedRoute = {
  __typename?: 'CachedRoute';
  avoidsChannels?: Maybe<Scalars['Boolean']['output']>;
  draft?: Maybe<Scalars['BigFloat']['output']>;
  exact?: Maybe<Scalars['JSON']['output']>;
  from: Scalars['Int']['output'];
  noGoZones?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  to: Scalars['Int']['output'];
};

export type CachedRoutesByPortPairsInputs = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  from: Scalars['Int']['input'];
  noGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to: Scalars['Int']['input'];
};

/** A connection to a list of `Int` values. */
export type CalculateRootOrgConnection = {
  __typename?: 'CalculateRootOrgConnection';
  /** A list of edges which contains the `Int` and cursor to aid in pagination. */
  edges: Array<CalculateRootOrgEdge>;
  /** A list of `Int` objects. */
  nodes: Array<Maybe<Scalars['Int']['output']>>;
  /** The count of *all* `Int` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Int` edge in the connection. */
export type CalculateRootOrgEdge = {
  __typename?: 'CalculateRootOrgEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Int` at the end of the edge. */
  node?: Maybe<Scalars['Int']['output']>;
};

export type CalculateVoyageInputs = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  constraints?: InputMaybe<VoyageCalculationConstraints>;
  dailyCosts?: InputMaybe<Scalars['Float']['input']>;
  draft: Scalars['Float']['input'];
  fixedCosts?: InputMaybe<Scalars['Float']['input']>;
  from: Scalars['Int']['input'];
  fuels?: InputMaybe<FuelInput>;
  imoNumber: Scalars['Int']['input'];
  maxCalculationIntervalDistance?: InputMaybe<Scalars['Float']['input']>;
  netFreight?: InputMaybe<Scalars['Float']['input']>;
  noGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  operationMethod: OperationMethod;
  performanceModelId?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type CalculatedLeg = {
  __typename?: 'CalculatedLeg';
  calculationPoints: Array<CalculationPoint>;
  cost: ResultResponseDouble;
  distance: Scalars['Float']['output'];
  endLatitude: Scalars['Float']['output'];
  endLongitude: Scalars['Float']['output'];
  endTime: Scalars['String']['output'];
  engineLoad: ResultResponseDouble;
  fuelConsumption: ResultResponseDouble;
  fuelType: FuelType;
  isInsideEca: Scalars['Boolean']['output'];
  legType: LegType;
  propellerRpm: ResultResponseDouble;
  propulsionPower: ResultResponseDouble;
  speedOverGround: Scalars['Float']['output'];
  startLatitude: Scalars['Float']['output'];
  startLongitude: Scalars['Float']['output'];
  startTime: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type CalculationPoint = {
  __typename?: 'CalculationPoint';
  engineLoad?: Maybe<ResultResponseDouble>;
  fuelMassFlow?: Maybe<ResultResponseDouble>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  propellerRpm?: Maybe<ResultResponseDouble>;
  propulsionPower?: Maybe<ResultResponseDouble>;
  seaCurrentDirection?: Maybe<Scalars['Float']['output']>;
  seaCurrentSpeed?: Maybe<Scalars['Float']['output']>;
  speedOverGround?: Maybe<ResultResponseDouble>;
  swellDirection?: Maybe<Scalars['Float']['output']>;
  swellSignificantHeight?: Maybe<Scalars['Float']['output']>;
  swellZeroCrossingPeriod?: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['String']['output'];
  waterDepth: Scalars['Float']['output'];
  windDirection?: Maybe<Scalars['Float']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
  windWavesDirection?: Maybe<Scalars['Float']['output']>;
  windWavesSignificantHeight?: Maybe<Scalars['Float']['output']>;
  windWavesZeroCrossingPeriod?: Maybe<Scalars['Float']['output']>;
};

/** All input for the `canAccessBunkerGradeOverride` mutation. */
export type CanAccessBunkerGradeOverrideInput = {
  bunkerGradeOverrideId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `canAccessBunkerGradeOverride` mutation. */
export type CanAccessBunkerGradeOverridePayload = {
  __typename?: 'CanAccessBunkerGradeOverridePayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `canAccessCommitLog` mutation. */
export type CanAccessCommitLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commitLogId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `canAccessCommitLog` mutation. */
export type CanAccessCommitLogPayload = {
  __typename?: 'CanAccessCommitLogPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `canAccessScenario` mutation. */
export type CanAccessScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  scenarioId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `canAccessScenario` mutation. */
export type CanAccessScenarioPayload = {
  __typename?: 'CanAccessScenarioPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type CarbonPrice = {
  __typename?: 'CarbonPrice';
  isOverride?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Float']['output'];
  updatedAt: Scalars['BigInt']['output'];
};

export type CarbonPriceOverride = Node & {
  __typename?: 'CarbonPriceOverride';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['CarbonPriceOverrideId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CarbonPriceOverride`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  price: Scalars['BigFloat']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `CarbonPriceOverride` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CarbonPriceOverrideCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CarbonPriceOverrideId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `CarbonPriceOverride` object types. All fields are combined with a logical ‘and.’ */
export type CarbonPriceOverrideFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CarbonPriceOverrideFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CarbonPriceOverrideFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CarbonPriceOverrideFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `CarbonPriceOverride` */
export type CarbonPriceOverrideInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  price: Scalars['BigFloat']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `CarbonPriceOverride`. Fields that are set will be updated. */
export type CarbonPriceOverridePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `CarbonPriceOverride` values. */
export type CarbonPriceOverridesConnection = {
  __typename?: 'CarbonPriceOverridesConnection';
  /** A list of edges which contains the `CarbonPriceOverride` and cursor to aid in pagination. */
  edges: Array<CarbonPriceOverridesEdge>;
  /** A list of `CarbonPriceOverride` objects. */
  nodes: Array<Maybe<CarbonPriceOverride>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CarbonPriceOverride` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CarbonPriceOverride` edge in the connection. */
export type CarbonPriceOverridesEdge = {
  __typename?: 'CarbonPriceOverridesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CarbonPriceOverride` at the end of the edge. */
  node?: Maybe<CarbonPriceOverride>;
};

/** Methods to use when ordering `CarbonPriceOverride`. */
export enum CarbonPriceOverridesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type CargoCompartment = Node & {
  __typename?: 'CargoCompartment';
  adminUserId?: Maybe<Scalars['UserId']['output']>;
  /** Reads and enables pagination through a set of `CargoCompartmentAllocation`. */
  cargoCompartmentAllocationsByCompartmentId: CargoCompartmentAllocationsConnection;
  cleaningCost?: Maybe<Scalars['BigFloat']['output']>;
  height?: Maybe<Scalars['BigFloat']['output']>;
  hold?: Maybe<Scalars['Int']['output']>;
  id: Scalars['CargoCompartmentId']['output'];
  length?: Maybe<Scalars['BigFloat']['output']>;
  maxVolume: Scalars['BigFloat']['output'];
  minVolume?: Maybe<Scalars['BigFloat']['output']>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Organization` that is related to this `CargoCompartment`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CargoCompartment`. */
  organizationByRootOrg?: Maybe<Organization>;
  positionHeight?: Maybe<Scalars['BigFloat']['output']>;
  positionLength?: Maybe<Scalars['BigFloat']['output']>;
  positionWidth?: Maybe<Scalars['BigFloat']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `CargoCompartment`. */
  shipByShipId?: Maybe<Ship>;
  shipId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads and enables pagination through a set of `TankDistance`. */
  tankDistancesByTankA: TankDistancesConnection;
  /** Reads and enables pagination through a set of `TankDistance`. */
  tankDistancesByTankB: TankDistancesConnection;
  type?: Maybe<HoldType>;
  /** Reads a single `User` that is related to this `CargoCompartment`. */
  userByAdminUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['VesselInfoId']['output']>;
  /** Reads a single `VesselInfo` that is related to this `CargoCompartment`. */
  vesselInfoByVesselId?: Maybe<VesselInfo>;
  volumeUnit?: Maybe<VolumeUnits>;
  width?: Maybe<Scalars['BigFloat']['output']>;
};


export type CargoCompartmentCargoCompartmentAllocationsByCompartmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentAllocationCondition>;
  filter?: InputMaybe<CargoCompartmentAllocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};


export type CargoCompartmentTankDistancesByTankAArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TankDistanceCondition>;
  filter?: InputMaybe<TankDistanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TankDistancesOrderBy>>;
};


export type CargoCompartmentTankDistancesByTankBArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TankDistanceCondition>;
  filter?: InputMaybe<TankDistanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TankDistancesOrderBy>>;
};

export type CargoCompartmentAllocation = Node & {
  __typename?: 'CargoCompartmentAllocation';
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `CargoCompartment` that is related to this `CargoCompartmentAllocation`. */
  cargoCompartmentByCompartmentId?: Maybe<CargoCompartment>;
  clientId: Scalars['UUID']['output'];
  compartmentId: Scalars['CargoCompartmentId']['output'];
  id: Scalars['CargoCompartmentAllocationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `CargoCompartmentAllocation`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Organization` that is related to this `CargoCompartmentAllocation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `ScheduledOrder` that is related to this `CargoCompartmentAllocation`. */
  scheduledOrderByScheduledOrderClientId?: Maybe<ScheduledOrder>;
  /** Reads a single `ScheduledOrder` that is related to this `CargoCompartmentAllocation`. */
  scheduledOrderByScheduledOrderId?: Maybe<ScheduledOrder>;
  scheduledOrderClientId: Scalars['UUID']['output'];
  scheduledOrderId: Scalars['ScheduledOrderId']['output'];
};

/**
 * A condition to be used against `CargoCompartmentAllocation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CargoCompartmentAllocationCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `compartmentId` field. */
  compartmentId?: InputMaybe<Scalars['CargoCompartmentId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CargoCompartmentAllocationId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `scheduledOrderClientId` field. */
  scheduledOrderClientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `scheduledOrderId` field. */
  scheduledOrderId?: InputMaybe<Scalars['ScheduledOrderId']['input']>;
};

/** A filter to be used against `CargoCompartmentAllocation` object types. All fields are combined with a logical ‘and.’ */
export type CargoCompartmentAllocationFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoCompartmentAllocationFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `compartmentId` field. */
  compartmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoCompartmentAllocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoCompartmentAllocationFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `scheduledOrderClientId` field. */
  scheduledOrderClientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scheduledOrderId` field. */
  scheduledOrderId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CargoCompartmentAllocation` */
export type CargoCompartmentAllocationInput = {
  amount: Scalars['BigFloat']['input'];
  clientId: Scalars['UUID']['input'];
  compartmentId: Scalars['CargoCompartmentId']['input'];
  orderId: Scalars['OrderId']['input'];
  scheduledOrderClientId: Scalars['UUID']['input'];
  scheduledOrderId: Scalars['ScheduledOrderId']['input'];
};

/** Represents an update to a `CargoCompartmentAllocation`. Fields that are set will be updated. */
export type CargoCompartmentAllocationPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  compartmentId?: InputMaybe<Scalars['CargoCompartmentId']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  scheduledOrderClientId?: InputMaybe<Scalars['UUID']['input']>;
  scheduledOrderId?: InputMaybe<Scalars['ScheduledOrderId']['input']>;
};

/** A connection to a list of `CargoCompartmentAllocation` values. */
export type CargoCompartmentAllocationsConnection = {
  __typename?: 'CargoCompartmentAllocationsConnection';
  /** A list of edges which contains the `CargoCompartmentAllocation` and cursor to aid in pagination. */
  edges: Array<CargoCompartmentAllocationsEdge>;
  /** A list of `CargoCompartmentAllocation` objects. */
  nodes: Array<Maybe<CargoCompartmentAllocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoCompartmentAllocation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CargoCompartmentAllocation` edge in the connection. */
export type CargoCompartmentAllocationsEdge = {
  __typename?: 'CargoCompartmentAllocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoCompartmentAllocation` at the end of the edge. */
  node?: Maybe<CargoCompartmentAllocation>;
};

/** Methods to use when ordering `CargoCompartmentAllocation`. */
export enum CargoCompartmentAllocationsOrderBy {
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  COMPARTMENT_ID_ASC = 'COMPARTMENT_ID_ASC',
  COMPARTMENT_ID_DESC = 'COMPARTMENT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SCHEDULED_ORDER_CLIENT_ID_ASC = 'SCHEDULED_ORDER_CLIENT_ID_ASC',
  SCHEDULED_ORDER_CLIENT_ID_DESC = 'SCHEDULED_ORDER_CLIENT_ID_DESC',
  SCHEDULED_ORDER_ID_ASC = 'SCHEDULED_ORDER_ID_ASC',
  SCHEDULED_ORDER_ID_DESC = 'SCHEDULED_ORDER_ID_DESC'
}

/**
 * A condition to be used against `CargoCompartment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CargoCompartmentCondition = {
  /** Checks for equality with the object’s `adminUserId` field. */
  adminUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `cleaningCost` field. */
  cleaningCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `height` field. */
  height?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `hold` field. */
  hold?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CargoCompartmentId']['input']>;
  /** Checks for equality with the object’s `length` field. */
  length?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxVolume` field. */
  maxVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minVolume` field. */
  minVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `positionHeight` field. */
  positionHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `positionLength` field. */
  positionLength?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `positionWidth` field. */
  positionWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<HoldType>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  /** Checks for equality with the object’s `volumeUnit` field. */
  volumeUnit?: InputMaybe<VolumeUnits>;
  /** Checks for equality with the object’s `width` field. */
  width?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `CargoCompartment` object types. All fields are combined with a logical ‘and.’ */
export type CargoCompartmentFilter = {
  /** Filter by the object’s `adminUserId` field. */
  adminUserId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoCompartmentFilter>>;
  /** Filter by the object’s `cleaningCost` field. */
  cleaningCost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `height` field. */
  height?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `hold` field. */
  hold?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `length` field. */
  length?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxVolume` field. */
  maxVolume?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minVolume` field. */
  minVolume?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoCompartmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoCompartmentFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `positionHeight` field. */
  positionHeight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `positionLength` field. */
  positionLength?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `positionWidth` field. */
  positionWidth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<HoldTypeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `volumeUnit` field. */
  volumeUnit?: InputMaybe<VolumeUnitsFilter>;
  /** Filter by the object’s `width` field. */
  width?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `CargoCompartment` */
export type CargoCompartmentInput = {
  adminUserId?: InputMaybe<Scalars['UserId']['input']>;
  cleaningCost?: InputMaybe<Scalars['BigFloat']['input']>;
  height?: InputMaybe<Scalars['BigFloat']['input']>;
  hold?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['BigFloat']['input']>;
  maxVolume: Scalars['BigFloat']['input'];
  minVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  name: Scalars['String']['input'];
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  positionHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  positionLength?: InputMaybe<Scalars['BigFloat']['input']>;
  positionWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  type?: InputMaybe<HoldType>;
  vesselId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  volumeUnit?: InputMaybe<VolumeUnits>;
  width?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Represents an update to a `CargoCompartment`. Fields that are set will be updated. */
export type CargoCompartmentPatch = {
  adminUserId?: InputMaybe<Scalars['UserId']['input']>;
  cleaningCost?: InputMaybe<Scalars['BigFloat']['input']>;
  height?: InputMaybe<Scalars['BigFloat']['input']>;
  hold?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['BigFloat']['input']>;
  maxVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  minVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  positionHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  positionLength?: InputMaybe<Scalars['BigFloat']['input']>;
  positionWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  type?: InputMaybe<HoldType>;
  vesselId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  volumeUnit?: InputMaybe<VolumeUnits>;
  width?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `CargoCompartment` values. */
export type CargoCompartmentsConnection = {
  __typename?: 'CargoCompartmentsConnection';
  /** A list of edges which contains the `CargoCompartment` and cursor to aid in pagination. */
  edges: Array<CargoCompartmentsEdge>;
  /** A list of `CargoCompartment` objects. */
  nodes: Array<Maybe<CargoCompartment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoCompartment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CargoCompartment` edge in the connection. */
export type CargoCompartmentsEdge = {
  __typename?: 'CargoCompartmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoCompartment` at the end of the edge. */
  node?: Maybe<CargoCompartment>;
};

/** Methods to use when ordering `CargoCompartment`. */
export enum CargoCompartmentsOrderBy {
  ADMIN_USER_ID_ASC = 'ADMIN_USER_ID_ASC',
  ADMIN_USER_ID_DESC = 'ADMIN_USER_ID_DESC',
  CLEANING_COST_ASC = 'CLEANING_COST_ASC',
  CLEANING_COST_DESC = 'CLEANING_COST_DESC',
  HEIGHT_ASC = 'HEIGHT_ASC',
  HEIGHT_DESC = 'HEIGHT_DESC',
  HOLD_ASC = 'HOLD_ASC',
  HOLD_DESC = 'HOLD_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LENGTH_ASC = 'LENGTH_ASC',
  LENGTH_DESC = 'LENGTH_DESC',
  MAX_VOLUME_ASC = 'MAX_VOLUME_ASC',
  MAX_VOLUME_DESC = 'MAX_VOLUME_DESC',
  MIN_VOLUME_ASC = 'MIN_VOLUME_ASC',
  MIN_VOLUME_DESC = 'MIN_VOLUME_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  POSITION_HEIGHT_ASC = 'POSITION_HEIGHT_ASC',
  POSITION_HEIGHT_DESC = 'POSITION_HEIGHT_DESC',
  POSITION_LENGTH_ASC = 'POSITION_LENGTH_ASC',
  POSITION_LENGTH_DESC = 'POSITION_LENGTH_DESC',
  POSITION_WIDTH_ASC = 'POSITION_WIDTH_ASC',
  POSITION_WIDTH_DESC = 'POSITION_WIDTH_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC',
  VOLUME_UNIT_ASC = 'VOLUME_UNIT_ASC',
  VOLUME_UNIT_DESC = 'VOLUME_UNIT_DESC',
  WIDTH_ASC = 'WIDTH_ASC',
  WIDTH_DESC = 'WIDTH_DESC'
}

export enum CargoDeckOptionType {
  DECK = 'DECK',
  DECK_OR_HOLDS = 'DECK_OR_HOLDS',
  FULLDECK = 'FULLDECK',
  HOLDS = 'HOLDS',
  ONETHIRDDECK = 'ONETHIRDDECK',
  UNDERDECK = 'UNDERDECK'
}

/** A filter to be used against CargoDeckOptionType fields. All fields are combined with a logical ‘and.’ */
export type CargoDeckOptionTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CargoDeckOptionType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CargoDeckOptionType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CargoDeckOptionType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CargoDeckOptionType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CargoDeckOptionType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CargoDeckOptionType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CargoDeckOptionType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CargoDeckOptionType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CargoDeckOptionType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CargoDeckOptionType>>;
};

export type CargoEquipment = Node & {
  __typename?: 'CargoEquipment';
  id: Scalars['CargoEquipmentId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsByCargoEquipmentId: OrderDetailsConnection;
};


export type CargoEquipmentOrderDetailsByCargoEquipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};

/**
 * A condition to be used against `CargoEquipment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CargoEquipmentCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CargoEquipmentId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CargoEquipment` object types. All fields are combined with a logical ‘and.’ */
export type CargoEquipmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoEquipmentFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoEquipmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoEquipmentFilter>>;
};

/** An input for mutations affecting `CargoEquipment` */
export type CargoEquipmentInput = {
  name: Scalars['String']['input'];
};

/** Represents an update to a `CargoEquipment`. Fields that are set will be updated. */
export type CargoEquipmentPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CargoEquipment` values. */
export type CargoEquipmentsConnection = {
  __typename?: 'CargoEquipmentsConnection';
  /** A list of edges which contains the `CargoEquipment` and cursor to aid in pagination. */
  edges: Array<CargoEquipmentsEdge>;
  /** A list of `CargoEquipment` objects. */
  nodes: Array<Maybe<CargoEquipment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoEquipment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CargoEquipment` edge in the connection. */
export type CargoEquipmentsEdge = {
  __typename?: 'CargoEquipmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoEquipment` at the end of the edge. */
  node?: Maybe<CargoEquipment>;
};

/** Methods to use when ordering `CargoEquipment`. */
export enum CargoEquipmentsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type CargoExclusion = Node & {
  __typename?: 'CargoExclusion';
  assortment?: Maybe<Scalars['AssortmentId']['output']>;
  /** Reads a single `Assortment` that is related to this `CargoExclusion`. */
  assortmentByAssortment?: Maybe<Assortment>;
  assortmentGroup?: Maybe<Scalars['AssortmentGroupId']['output']>;
  /** Reads a single `AssortmentGroup` that is related to this `CargoExclusion`. */
  assortmentGroupByAssortmentGroup?: Maybe<AssortmentGroup>;
  distance?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['CargoExclusionId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `CargoExclusion`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  tanks?: Maybe<Scalars['Int']['output']>;
  voyages?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `CargoExclusion` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CargoExclusionCondition = {
  /** Checks for equality with the object’s `assortment` field. */
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `assortmentGroup` field. */
  assortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `distance` field. */
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CargoExclusionId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `tanks` field. */
  tanks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voyages` field. */
  voyages?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `CargoExclusion` object types. All fields are combined with a logical ‘and.’ */
export type CargoExclusionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoExclusionFilter>>;
  /** Filter by the object’s `assortment` field. */
  assortment?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assortmentGroup` field. */
  assortmentGroup?: InputMaybe<IntFilter>;
  /** Filter by the object’s `distance` field. */
  distance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoExclusionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoExclusionFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tanks` field. */
  tanks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyages` field. */
  voyages?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CargoExclusion` */
export type CargoExclusionInput = {
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  assortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  orderId: Scalars['OrderId']['input'];
  tanks?: InputMaybe<Scalars['Int']['input']>;
  voyages?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `CargoExclusion`. Fields that are set will be updated. */
export type CargoExclusionPatch = {
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  assortmentGroup?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  tanks?: InputMaybe<Scalars['Int']['input']>;
  voyages?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CargoExclusion` values. */
export type CargoExclusionsConnection = {
  __typename?: 'CargoExclusionsConnection';
  /** A list of edges which contains the `CargoExclusion` and cursor to aid in pagination. */
  edges: Array<CargoExclusionsEdge>;
  /** A list of `CargoExclusion` objects. */
  nodes: Array<Maybe<CargoExclusion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoExclusion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CargoExclusion` edge in the connection. */
export type CargoExclusionsEdge = {
  __typename?: 'CargoExclusionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoExclusion` at the end of the edge. */
  node?: Maybe<CargoExclusion>;
};

/** Methods to use when ordering `CargoExclusion`. */
export enum CargoExclusionsOrderBy {
  ASSORTMENT_ASC = 'ASSORTMENT_ASC',
  ASSORTMENT_DESC = 'ASSORTMENT_DESC',
  ASSORTMENT_GROUP_ASC = 'ASSORTMENT_GROUP_ASC',
  ASSORTMENT_GROUP_DESC = 'ASSORTMENT_GROUP_DESC',
  DISTANCE_ASC = 'DISTANCE_ASC',
  DISTANCE_DESC = 'DISTANCE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TANKS_ASC = 'TANKS_ASC',
  TANKS_DESC = 'TANKS_DESC',
  VOYAGES_ASC = 'VOYAGES_ASC',
  VOYAGES_DESC = 'VOYAGES_DESC'
}

export type CargoLengthUnit = Node & {
  __typename?: 'CargoLengthUnit';
  id: Scalars['CargoLengthUnitId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsByCargoLengthUnitId: OrderDetailsConnection;
};


export type CargoLengthUnitOrderDetailsByCargoLengthUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};

/**
 * A condition to be used against `CargoLengthUnit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CargoLengthUnitCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CargoLengthUnitId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CargoLengthUnit` object types. All fields are combined with a logical ‘and.’ */
export type CargoLengthUnitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoLengthUnitFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoLengthUnitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoLengthUnitFilter>>;
};

/** An input for mutations affecting `CargoLengthUnit` */
export type CargoLengthUnitInput = {
  name: Scalars['String']['input'];
};

/** Represents an update to a `CargoLengthUnit`. Fields that are set will be updated. */
export type CargoLengthUnitPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CargoLengthUnit` values. */
export type CargoLengthUnitsConnection = {
  __typename?: 'CargoLengthUnitsConnection';
  /** A list of edges which contains the `CargoLengthUnit` and cursor to aid in pagination. */
  edges: Array<CargoLengthUnitsEdge>;
  /** A list of `CargoLengthUnit` objects. */
  nodes: Array<Maybe<CargoLengthUnit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoLengthUnit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CargoLengthUnit` edge in the connection. */
export type CargoLengthUnitsEdge = {
  __typename?: 'CargoLengthUnitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoLengthUnit` at the end of the edge. */
  node?: Maybe<CargoLengthUnit>;
};

/** Methods to use when ordering `CargoLengthUnit`. */
export enum CargoLengthUnitsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type CargoMeasurement = Node & {
  __typename?: 'CargoMeasurement';
  id: Scalars['CargoMeasurementId']['output'];
  /** Reads a single `Location` that is related to this `CargoMeasurement`. */
  locationByLocationId?: Maybe<Location>;
  locationId?: Maybe<Scalars['LocationId']['output']>;
  measuredVolume?: Maybe<Scalars['BigFloat']['output']>;
  measuredWeight?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `CargoMeasurement`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  rejectedVolume?: Maybe<Scalars['BigFloat']['output']>;
  rejectedWeight?: Maybe<Scalars['BigFloat']['output']>;
  time: Scalars['Datetime']['output'];
  /** Reads a single `User` that is related to this `CargoMeasurement`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  volumeUnit?: Maybe<VolumeUnits>;
  weightUnit?: Maybe<WeightUnits>;
};

/**
 * A condition to be used against `CargoMeasurement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CargoMeasurementCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CargoMeasurementId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `measuredVolume` field. */
  measuredVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `measuredWeight` field. */
  measuredWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `rejectedVolume` field. */
  rejectedVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rejectedWeight` field. */
  rejectedWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `time` field. */
  time?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `volumeUnit` field. */
  volumeUnit?: InputMaybe<VolumeUnits>;
  /** Checks for equality with the object’s `weightUnit` field. */
  weightUnit?: InputMaybe<WeightUnits>;
};

/** A filter to be used against `CargoMeasurement` object types. All fields are combined with a logical ‘and.’ */
export type CargoMeasurementFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoMeasurementFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `measuredVolume` field. */
  measuredVolume?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `measuredWeight` field. */
  measuredWeight?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoMeasurementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoMeasurementFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rejectedVolume` field. */
  rejectedVolume?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rejectedWeight` field. */
  rejectedWeight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `time` field. */
  time?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `volumeUnit` field. */
  volumeUnit?: InputMaybe<VolumeUnitsFilter>;
  /** Filter by the object’s `weightUnit` field. */
  weightUnit?: InputMaybe<WeightUnitsFilter>;
};

/** An input for mutations affecting `CargoMeasurement` */
export type CargoMeasurementInput = {
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  measuredVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  measuredWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  orderId: Scalars['OrderId']['input'];
  rejectedVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  rejectedWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  time: Scalars['Datetime']['input'];
  userId: Scalars['UserId']['input'];
  volumeUnit?: InputMaybe<VolumeUnits>;
  weightUnit?: InputMaybe<WeightUnits>;
};

/** Represents an update to a `CargoMeasurement`. Fields that are set will be updated. */
export type CargoMeasurementPatch = {
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  measuredVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  measuredWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  rejectedVolume?: InputMaybe<Scalars['BigFloat']['input']>;
  rejectedWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  time?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  volumeUnit?: InputMaybe<VolumeUnits>;
  weightUnit?: InputMaybe<WeightUnits>;
};

/** A connection to a list of `CargoMeasurement` values. */
export type CargoMeasurementsConnection = {
  __typename?: 'CargoMeasurementsConnection';
  /** A list of edges which contains the `CargoMeasurement` and cursor to aid in pagination. */
  edges: Array<CargoMeasurementsEdge>;
  /** A list of `CargoMeasurement` objects. */
  nodes: Array<Maybe<CargoMeasurement>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoMeasurement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CargoMeasurement` edge in the connection. */
export type CargoMeasurementsEdge = {
  __typename?: 'CargoMeasurementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoMeasurement` at the end of the edge. */
  node?: Maybe<CargoMeasurement>;
};

/** Methods to use when ordering `CargoMeasurement`. */
export enum CargoMeasurementsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  MEASURED_VOLUME_ASC = 'MEASURED_VOLUME_ASC',
  MEASURED_VOLUME_DESC = 'MEASURED_VOLUME_DESC',
  MEASURED_WEIGHT_ASC = 'MEASURED_WEIGHT_ASC',
  MEASURED_WEIGHT_DESC = 'MEASURED_WEIGHT_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REJECTED_VOLUME_ASC = 'REJECTED_VOLUME_ASC',
  REJECTED_VOLUME_DESC = 'REJECTED_VOLUME_DESC',
  REJECTED_WEIGHT_ASC = 'REJECTED_WEIGHT_ASC',
  REJECTED_WEIGHT_DESC = 'REJECTED_WEIGHT_DESC',
  TIME_ASC = 'TIME_ASC',
  TIME_DESC = 'TIME_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VOLUME_UNIT_ASC = 'VOLUME_UNIT_ASC',
  VOLUME_UNIT_DESC = 'VOLUME_UNIT_DESC',
  WEIGHT_UNIT_ASC = 'WEIGHT_UNIT_ASC',
  WEIGHT_UNIT_DESC = 'WEIGHT_UNIT_DESC'
}

export enum CargoPackingMethodType {
  LENGTHPACKAGE = 'LENGTHPACKAGE',
  TRUCKPACKAGE = 'TRUCKPACKAGE'
}

/** A filter to be used against CargoPackingMethodType fields. All fields are combined with a logical ‘and.’ */
export type CargoPackingMethodTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CargoPackingMethodType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CargoPackingMethodType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CargoPackingMethodType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CargoPackingMethodType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CargoPackingMethodType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CargoPackingMethodType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CargoPackingMethodType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CargoPackingMethodType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CargoPackingMethodType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CargoPackingMethodType>>;
};

export enum CargoType {
  GAS = 'GAS',
  LIQUID = 'LIQUID',
  SOLID = 'SOLID'
}

/** A filter to be used against CargoType fields. All fields are combined with a logical ‘and.’ */
export type CargoTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CargoType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CargoType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CargoType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CargoType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CargoType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CargoType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CargoType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CargoType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CargoType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CargoType>>;
};

export type CargoUnit = Node & {
  __typename?: 'CargoUnit';
  /** Reads and enables pagination through a set of `Assortment`. */
  assortmentsByCargoUnitId: AssortmentsConnection;
  /** Reads and enables pagination through a set of `CargoUnitsConversion`. */
  cargoUnitsConversionsByCargoUnitId: CargoUnitsConversionsConnection;
  /** Reads and enables pagination through a set of `CoaContract`. */
  coaContractsByAmountUnitId: CoaContractsConnection;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsByAmountUnitId: DemandsConnection;
  id: Scalars['CargoUnitId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Order`. */
  ordersByCargoUnitId: OrdersConnection;
  /** Reads and enables pagination through a set of `OrdersHistory`. */
  ordersHistoriesByCargoUnitId: OrdersHistoriesConnection;
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesByAmountUnitId: SuppliesConnection;
};


export type CargoUnitAssortmentsByCargoUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentCondition>;
  filter?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};


export type CargoUnitCargoUnitsConversionsByCargoUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoUnitsConversionCondition>;
  filter?: InputMaybe<CargoUnitsConversionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoUnitsConversionsOrderBy>>;
};


export type CargoUnitCoaContractsByAmountUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCondition>;
  filter?: InputMaybe<CoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};


export type CargoUnitDemandsByAmountUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type CargoUnitOrdersByCargoUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type CargoUnitOrdersHistoriesByCargoUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrdersHistoryCondition>;
  filter?: InputMaybe<OrdersHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersHistoriesOrderBy>>;
};


export type CargoUnitSuppliesByAmountUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};

/**
 * A condition to be used against `CargoUnit` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CargoUnitCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum CargoUnitEnum {
  frt = 'frt',
  ft3 = 'ft3',
  lt = 'lt',
  m3 = 'm3',
  mts = 'mts',
  pcs = 'pcs',
  set = 'set',
  st = 'st'
}

/** A filter to be used against `CargoUnit` object types. All fields are combined with a logical ‘and.’ */
export type CargoUnitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoUnitFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoUnitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoUnitFilter>>;
};

/** An input for mutations affecting `CargoUnit` */
export type CargoUnitInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `CargoUnit`. Fields that are set will be updated. */
export type CargoUnitPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CargoUnit` values. */
export type CargoUnitsConnection = {
  __typename?: 'CargoUnitsConnection';
  /** A list of edges which contains the `CargoUnit` and cursor to aid in pagination. */
  edges: Array<CargoUnitsEdge>;
  /** A list of `CargoUnit` objects. */
  nodes: Array<Maybe<CargoUnit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoUnit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Map cargo units from external integrations (i.e. tons can be identifid by t, to, ton) */
export type CargoUnitsConversion = {
  __typename?: 'CargoUnitsConversion';
  /** Reads a single `CargoUnit` that is related to this `CargoUnitsConversion`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /** Target unit id idenfiter from cargo_units table */
  cargoUnitId?: Maybe<Scalars['CargoUnitId']['output']>;
  /** Extended unit name for a given unit defined in cargo_units table */
  extraUnitName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `CargoUnitsConversion` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CargoUnitsConversionCondition = {
  /** Checks for equality with the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Checks for equality with the object’s `extraUnitName` field. */
  extraUnitName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CargoUnitsConversion` object types. All fields are combined with a logical ‘and.’ */
export type CargoUnitsConversionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoUnitsConversionFilter>>;
  /** Filter by the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `extraUnitName` field. */
  extraUnitName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoUnitsConversionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoUnitsConversionFilter>>;
};

/** An input for mutations affecting `CargoUnitsConversion` */
export type CargoUnitsConversionInput = {
  /** Target unit id idenfiter from cargo_units table */
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Extended unit name for a given unit defined in cargo_units table */
  extraUnitName?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `CargoUnitsConversion`. Fields that are set will be updated. */
export type CargoUnitsConversionPatch = {
  /** Target unit id idenfiter from cargo_units table */
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Extended unit name for a given unit defined in cargo_units table */
  extraUnitName?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CargoUnitsConversion` values. */
export type CargoUnitsConversionsConnection = {
  __typename?: 'CargoUnitsConversionsConnection';
  /** A list of edges which contains the `CargoUnitsConversion` and cursor to aid in pagination. */
  edges: Array<CargoUnitsConversionsEdge>;
  /** A list of `CargoUnitsConversion` objects. */
  nodes: Array<Maybe<CargoUnitsConversion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoUnitsConversion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CargoUnitsConversion` edge in the connection. */
export type CargoUnitsConversionsEdge = {
  __typename?: 'CargoUnitsConversionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoUnitsConversion` at the end of the edge. */
  node?: Maybe<CargoUnitsConversion>;
};

/** Methods to use when ordering `CargoUnitsConversion`. */
export enum CargoUnitsConversionsOrderBy {
  CARGO_UNIT_ID_ASC = 'CARGO_UNIT_ID_ASC',
  CARGO_UNIT_ID_DESC = 'CARGO_UNIT_ID_DESC',
  EXTRA_UNIT_NAME_ASC = 'EXTRA_UNIT_NAME_ASC',
  EXTRA_UNIT_NAME_DESC = 'EXTRA_UNIT_NAME_DESC',
  NATURAL = 'NATURAL'
}

/** A `CargoUnit` edge in the connection. */
export type CargoUnitsEdge = {
  __typename?: 'CargoUnitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoUnit` at the end of the edge. */
  node?: Maybe<CargoUnit>;
};

/** Methods to use when ordering `CargoUnit`. */
export enum CargoUnitsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type CargoWeightUnit = Node & {
  __typename?: 'CargoWeightUnit';
  id: Scalars['CargoWeightUnitId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsByCargoWeightUnitId: OrderDetailsConnection;
};


export type CargoWeightUnitOrderDetailsByCargoWeightUnitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};

/**
 * A condition to be used against `CargoWeightUnit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CargoWeightUnitCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CargoWeightUnitId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CargoWeightUnit` object types. All fields are combined with a logical ‘and.’ */
export type CargoWeightUnitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CargoWeightUnitFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CargoWeightUnitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CargoWeightUnitFilter>>;
};

/** An input for mutations affecting `CargoWeightUnit` */
export type CargoWeightUnitInput = {
  name: Scalars['String']['input'];
};

/** Represents an update to a `CargoWeightUnit`. Fields that are set will be updated. */
export type CargoWeightUnitPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CargoWeightUnit` values. */
export type CargoWeightUnitsConnection = {
  __typename?: 'CargoWeightUnitsConnection';
  /** A list of edges which contains the `CargoWeightUnit` and cursor to aid in pagination. */
  edges: Array<CargoWeightUnitsEdge>;
  /** A list of `CargoWeightUnit` objects. */
  nodes: Array<Maybe<CargoWeightUnit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CargoWeightUnit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CargoWeightUnit` edge in the connection. */
export type CargoWeightUnitsEdge = {
  __typename?: 'CargoWeightUnitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CargoWeightUnit` at the end of the edge. */
  node?: Maybe<CargoWeightUnit>;
};

/** Methods to use when ordering `CargoWeightUnit`. */
export enum CargoWeightUnitsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** All input for the `changePassword` mutation. */
export type ChangePasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newpassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** The output of our `changePassword` mutation. */
export type ChangePasswordPayload = {
  __typename?: 'ChangePasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Channel = Node & {
  __typename?: 'Channel';
  airdraft?: Maybe<Scalars['BigFloat']['output']>;
  beam?: Maybe<Scalars['BigFloat']['output']>;
  breadth?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `ChannelCost`. */
  channelCostsByChannelId: ChannelCostsConnection;
  draft?: Maybe<Scalars['BigFloat']['output']>;
  geoId?: Maybe<Scalars['GeographicalEntityId']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `Channel`. */
  geographicalEntityByGeoId?: Maybe<GeographicalEntity>;
  id: Scalars['ChannelId']['output'];
  loa?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type ChannelChannelCostsByChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostCondition>;
  filter?: InputMaybe<ChannelCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostsOrderBy>>;
};

/** A condition to be used against `Channel` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ChannelCondition = {
  /** Checks for equality with the object’s `airdraft` field. */
  airdraft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `beam` field. */
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `breadth` field. */
  breadth?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `geoId` field. */
  geoId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ChannelId']['input']>;
  /** Checks for equality with the object’s `loa` field. */
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Unused. See channel_cost_estimates instead. */
export type ChannelCost = Node & {
  __typename?: 'ChannelCost';
  /** Reads a single `Channel` that is related to this `ChannelCost`. */
  channelByChannelId?: Maybe<Channel>;
  channelId: Scalars['ChannelId']['output'];
  cost?: Maybe<Scalars['BigFloat']['output']>;
  currency?: Maybe<Currency>;
  id: Scalars['ChannelCostId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Organization` that is related to this `ChannelCost`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Ship` that is related to this `ChannelCost`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `ChannelCost`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};

export enum ChannelCostCargoCondition {
  BALLAST = 'BALLAST',
  LADEN = 'LADEN'
}

/** A filter to be used against ChannelCostCargoCondition fields. All fields are combined with a logical ‘and.’ */
export type ChannelCostCargoConditionFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChannelCostCargoCondition>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChannelCostCargoCondition>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChannelCostCargoCondition>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChannelCostCargoCondition>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChannelCostCargoCondition>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChannelCostCargoCondition>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChannelCostCargoCondition>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChannelCostCargoCondition>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChannelCostCargoCondition>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChannelCostCargoCondition>>;
};

/**
 * A condition to be used against `ChannelCost` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ChannelCostCondition = {
  /** Checks for equality with the object’s `channelId` field. */
  channelId?: InputMaybe<Scalars['ChannelId']['input']>;
  /** Checks for equality with the object’s `cost` field. */
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ChannelCostId']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type ChannelCostEstimate = Node & {
  __typename?: 'ChannelCostEstimate';
  /** Reads a single `AssortmentGroup` that is related to this `ChannelCostEstimate`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  assortmentGroupId?: Maybe<Scalars['AssortmentGroupId']['output']>;
  cargoCondition?: Maybe<ChannelCostCargoCondition>;
  channelCost: Scalars['BigFloat']['output'];
  channelCostCurrency: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Hours. Additional duration added to computed sea duration when using this channel. */
  durationOverhead?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ChannelCostEstimateId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `ChannelCostEstimate`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `PortCall`. */
  portCallsByChannelCostDefaultId: PortCallsConnection;
  /** Reads a single `Ship` that is related to this `ChannelCostEstimate`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `ChannelCostEstimate`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  vesselTypeId?: Maybe<Scalars['VesselAttributeId']['output']>;
};


export type ChannelCostEstimatePortCallsByChannelCostDefaultIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallCondition>;
  filter?: InputMaybe<PortCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};

/**
 * A condition to be used against `ChannelCostEstimate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ChannelCostEstimateCondition = {
  /** Checks for equality with the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `cargoCondition` field. */
  cargoCondition?: InputMaybe<ChannelCostCargoCondition>;
  /** Checks for equality with the object’s `channelCost` field. */
  channelCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `channelCostCurrency` field. */
  channelCostCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `channelName` field. */
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `durationOverhead` field. */
  durationOverhead?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ChannelCostEstimateId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `vesselTypeId` field. */
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A filter to be used against `ChannelCostEstimate` object types. All fields are combined with a logical ‘and.’ */
export type ChannelCostEstimateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChannelCostEstimateFilter>>;
  /** Filter by the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoCondition` field. */
  cargoCondition?: InputMaybe<ChannelCostCargoConditionFilter>;
  /** Filter by the object’s `channelCost` field. */
  channelCost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `channelCostCurrency` field. */
  channelCostCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `channelName` field. */
  channelName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `durationOverhead` field. */
  durationOverhead?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChannelCostEstimateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChannelCostEstimateFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselTypeId` field. */
  vesselTypeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ChannelCostEstimate` */
export type ChannelCostEstimateInput = {
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  cargoCondition?: InputMaybe<ChannelCostCargoCondition>;
  channelCost: Scalars['BigFloat']['input'];
  channelCostCurrency: Scalars['String']['input'];
  channelName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Hours. Additional duration added to computed sea duration when using this channel. */
  durationOverhead?: InputMaybe<Scalars['BigInt']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** Represents an update to a `ChannelCostEstimate`. Fields that are set will be updated. */
export type ChannelCostEstimatePatch = {
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  cargoCondition?: InputMaybe<ChannelCostCargoCondition>;
  channelCost?: InputMaybe<Scalars['BigFloat']['input']>;
  channelCostCurrency?: InputMaybe<Scalars['String']['input']>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Hours. Additional duration added to computed sea duration when using this channel. */
  durationOverhead?: InputMaybe<Scalars['BigInt']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A connection to a list of `ChannelCostEstimate` values. */
export type ChannelCostEstimatesConnection = {
  __typename?: 'ChannelCostEstimatesConnection';
  /** A list of edges which contains the `ChannelCostEstimate` and cursor to aid in pagination. */
  edges: Array<ChannelCostEstimatesEdge>;
  /** A list of `ChannelCostEstimate` objects. */
  nodes: Array<Maybe<ChannelCostEstimate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChannelCostEstimate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ChannelCostEstimate` edge in the connection. */
export type ChannelCostEstimatesEdge = {
  __typename?: 'ChannelCostEstimatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ChannelCostEstimate` at the end of the edge. */
  node?: Maybe<ChannelCostEstimate>;
};

/** Methods to use when ordering `ChannelCostEstimate`. */
export enum ChannelCostEstimatesOrderBy {
  ASSORTMENT_GROUP_ID_ASC = 'ASSORTMENT_GROUP_ID_ASC',
  ASSORTMENT_GROUP_ID_DESC = 'ASSORTMENT_GROUP_ID_DESC',
  CARGO_CONDITION_ASC = 'CARGO_CONDITION_ASC',
  CARGO_CONDITION_DESC = 'CARGO_CONDITION_DESC',
  CHANNEL_COST_ASC = 'CHANNEL_COST_ASC',
  CHANNEL_COST_CURRENCY_ASC = 'CHANNEL_COST_CURRENCY_ASC',
  CHANNEL_COST_CURRENCY_DESC = 'CHANNEL_COST_CURRENCY_DESC',
  CHANNEL_COST_DESC = 'CHANNEL_COST_DESC',
  CHANNEL_NAME_ASC = 'CHANNEL_NAME_ASC',
  CHANNEL_NAME_DESC = 'CHANNEL_NAME_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DURATION_OVERHEAD_ASC = 'DURATION_OVERHEAD_ASC',
  DURATION_OVERHEAD_DESC = 'DURATION_OVERHEAD_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC',
  VESSEL_TYPE_ID_ASC = 'VESSEL_TYPE_ID_ASC',
  VESSEL_TYPE_ID_DESC = 'VESSEL_TYPE_ID_DESC'
}

/** A filter to be used against `ChannelCost` object types. All fields are combined with a logical ‘and.’ */
export type ChannelCostFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChannelCostFilter>>;
  /** Filter by the object’s `channelId` field. */
  channelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cost` field. */
  cost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChannelCostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChannelCostFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ChannelCost` */
export type ChannelCostInput = {
  channelId: Scalars['ChannelId']['input'];
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  currency?: InputMaybe<Currency>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  userId: Scalars['UserId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `ChannelCost`. Fields that are set will be updated. */
export type ChannelCostPatch = {
  channelId?: InputMaybe<Scalars['ChannelId']['input']>;
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  currency?: InputMaybe<Currency>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `ChannelCost` values. */
export type ChannelCostsConnection = {
  __typename?: 'ChannelCostsConnection';
  /** A list of edges which contains the `ChannelCost` and cursor to aid in pagination. */
  edges: Array<ChannelCostsEdge>;
  /** A list of `ChannelCost` objects. */
  nodes: Array<Maybe<ChannelCost>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChannelCost` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ChannelCost` edge in the connection. */
export type ChannelCostsEdge = {
  __typename?: 'ChannelCostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ChannelCost` at the end of the edge. */
  node?: Maybe<ChannelCost>;
};

/** Methods to use when ordering `ChannelCost`. */
export enum ChannelCostsOrderBy {
  CHANNEL_ID_ASC = 'CHANNEL_ID_ASC',
  CHANNEL_ID_DESC = 'CHANNEL_ID_DESC',
  COST_ASC = 'COST_ASC',
  COST_DESC = 'COST_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** A filter to be used against `Channel` object types. All fields are combined with a logical ‘and.’ */
export type ChannelFilter = {
  /** Filter by the object’s `airdraft` field. */
  airdraft?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChannelFilter>>;
  /** Filter by the object’s `beam` field. */
  beam?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `breadth` field. */
  breadth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `geoId` field. */
  geoId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loa` field. */
  loa?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChannelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChannelFilter>>;
};

/** A connection to a list of `ChannelIncompatibility` values. */
export type ChannelIncompatibilitiesConnection = {
  __typename?: 'ChannelIncompatibilitiesConnection';
  /** A list of edges which contains the `ChannelIncompatibility` and cursor to aid in pagination. */
  edges: Array<ChannelIncompatibilitiesEdge>;
  /** A list of `ChannelIncompatibility` objects. */
  nodes: Array<Maybe<ChannelIncompatibility>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChannelIncompatibility` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ChannelIncompatibility` edge in the connection. */
export type ChannelIncompatibilitiesEdge = {
  __typename?: 'ChannelIncompatibilitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ChannelIncompatibility` at the end of the edge. */
  node?: Maybe<ChannelIncompatibility>;
};

/** Methods to use when ordering `ChannelIncompatibility`. */
export enum ChannelIncompatibilitiesOrderBy {
  CHANNEL_NAME_ASC = 'CHANNEL_NAME_ASC',
  CHANNEL_NAME_DESC = 'CHANNEL_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  VESSEL_ATTRIBUTE_ID_ASC = 'VESSEL_ATTRIBUTE_ID_ASC',
  VESSEL_ATTRIBUTE_ID_DESC = 'VESSEL_ATTRIBUTE_ID_DESC'
}

export type ChannelIncompatibility = Node & {
  __typename?: 'ChannelIncompatibility';
  /** Name of the channel that is incompatible with the vessel attribute */
  channelName: Scalars['String']['output'];
  id: Scalars['ChannelIncompatibilityId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organizationId: Scalars['Int']['output'];
  rootOrg: Scalars['Int']['output'];
  /** Reads a single `VesselAttribute` that is related to this `ChannelIncompatibility`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  /** Reference to vessel attribute that is incompatible with the channel */
  vesselAttributeId: Scalars['VesselAttributeId']['output'];
};

/**
 * A condition to be used against `ChannelIncompatibility` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ChannelIncompatibilityCondition = {
  /** Checks for equality with the object’s `channelName` field. */
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ChannelIncompatibilityId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `vesselAttributeId` field. */
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A filter to be used against `ChannelIncompatibility` object types. All fields are combined with a logical ‘and.’ */
export type ChannelIncompatibilityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChannelIncompatibilityFilter>>;
  /** Filter by the object’s `channelName` field. */
  channelName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChannelIncompatibilityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChannelIncompatibilityFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselAttributeId` field. */
  vesselAttributeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ChannelIncompatibility` */
export type ChannelIncompatibilityInput = {
  /** Name of the channel that is incompatible with the vessel attribute */
  channelName: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to vessel attribute that is incompatible with the channel */
  vesselAttributeId: Scalars['VesselAttributeId']['input'];
};

/** Represents an update to a `ChannelIncompatibility`. Fields that are set will be updated. */
export type ChannelIncompatibilityPatch = {
  /** Name of the channel that is incompatible with the vessel attribute */
  channelName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to vessel attribute that is incompatible with the channel */
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** An input for mutations affecting `Channel` */
export type ChannelInput = {
  airdraft?: InputMaybe<Scalars['BigFloat']['input']>;
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  breadth?: InputMaybe<Scalars['BigFloat']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  geoId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Represents an update to a `Channel`. Fields that are set will be updated. */
export type ChannelPatch = {
  airdraft?: InputMaybe<Scalars['BigFloat']['input']>;
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  breadth?: InputMaybe<Scalars['BigFloat']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  geoId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `Channel` values. */
export type ChannelsConnection = {
  __typename?: 'ChannelsConnection';
  /** A list of edges which contains the `Channel` and cursor to aid in pagination. */
  edges: Array<ChannelsEdge>;
  /** A list of `Channel` objects. */
  nodes: Array<Maybe<Channel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Channel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Channel` edge in the connection. */
export type ChannelsEdge = {
  __typename?: 'ChannelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Channel` at the end of the edge. */
  node?: Maybe<Channel>;
};

/** Methods to use when ordering `Channel`. */
export enum ChannelsOrderBy {
  AIRDRAFT_ASC = 'AIRDRAFT_ASC',
  AIRDRAFT_DESC = 'AIRDRAFT_DESC',
  BEAM_ASC = 'BEAM_ASC',
  BEAM_DESC = 'BEAM_DESC',
  BREADTH_ASC = 'BREADTH_ASC',
  BREADTH_DESC = 'BREADTH_DESC',
  DRAFT_ASC = 'DRAFT_ASC',
  DRAFT_DESC = 'DRAFT_DESC',
  GEO_ID_ASC = 'GEO_ID_ASC',
  GEO_ID_DESC = 'GEO_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOA_ASC = 'LOA_ASC',
  LOA_DESC = 'LOA_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type Chat = Node & {
  __typename?: 'Chat';
  fromOrganizationId: Scalars['OrganizationId']['output'];
  fromUserId: Scalars['UserId']['output'];
  id: Scalars['ChatId']['output'];
  insertedAt?: Maybe<Scalars['Datetime']['output']>;
  message: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `Chat`. */
  orderByOrderId?: Maybe<Order>;
  orderId?: Maybe<Scalars['OrderId']['output']>;
  /** Reads a single `Organization` that is related to this `Chat`. */
  organizationByFromOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Chat`. */
  organizationByToOrganizationId?: Maybe<Organization>;
  /** Reads and enables pagination through a set of `SeenMessage`. */
  seenMessagesByChatId: SeenMessagesConnection;
  sent?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Shipment` that is related to this `Chat`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['ShipmentId']['output']>;
  toOrganizationId: Scalars['OrganizationId']['output'];
  toUserId?: Maybe<Scalars['UserId']['output']>;
  /** Reads a single `User` that is related to this `Chat`. */
  userByFromUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Chat`. */
  userByToUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `Chat`. */
  voyageByVoyageId?: Maybe<Voyage>;
  voyageId?: Maybe<Scalars['VoyageId']['output']>;
};


export type ChatSeenMessagesByChatIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SeenMessageCondition>;
  filter?: InputMaybe<SeenMessageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SeenMessagesOrderBy>>;
};

/** A condition to be used against `Chat` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ChatCondition = {
  /** Checks for equality with the object’s `fromOrganizationId` field. */
  fromOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `fromUserId` field. */
  fromUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ChatId']['input']>;
  /** Checks for equality with the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `sent` field. */
  sent?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Checks for equality with the object’s `toOrganizationId` field. */
  toOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `toUserId` field. */
  toUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `voyageId` field. */
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** A filter to be used against `Chat` object types. All fields are combined with a logical ‘and.’ */
export type ChatFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChatFilter>>;
  /** Filter by the object’s `fromOrganizationId` field. */
  fromOrganizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fromUserId` field. */
  fromUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChatFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sent` field. */
  sent?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toOrganizationId` field. */
  toOrganizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toUserId` field. */
  toUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageId` field. */
  voyageId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Chat` */
export type ChatInput = {
  fromOrganizationId: Scalars['OrganizationId']['input'];
  fromUserId: Scalars['UserId']['input'];
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  message: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  sent?: InputMaybe<Scalars['Datetime']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  toOrganizationId: Scalars['OrganizationId']['input'];
  toUserId?: InputMaybe<Scalars['UserId']['input']>;
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** Represents an update to a `Chat`. Fields that are set will be updated. */
export type ChatPatch = {
  fromOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  fromUserId?: InputMaybe<Scalars['UserId']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  sent?: InputMaybe<Scalars['Datetime']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  toOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  toUserId?: InputMaybe<Scalars['UserId']['input']>;
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** A connection to a list of `Chat` values. */
export type ChatsConnection = {
  __typename?: 'ChatsConnection';
  /** A list of edges which contains the `Chat` and cursor to aid in pagination. */
  edges: Array<ChatsEdge>;
  /** A list of `Chat` objects. */
  nodes: Array<Maybe<Chat>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Chat` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Chat` edge in the connection. */
export type ChatsEdge = {
  __typename?: 'ChatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Chat` at the end of the edge. */
  node?: Maybe<Chat>;
};

/** Methods to use when ordering `Chat`. */
export enum ChatsOrderBy {
  FROM_ORGANIZATION_ID_ASC = 'FROM_ORGANIZATION_ID_ASC',
  FROM_ORGANIZATION_ID_DESC = 'FROM_ORGANIZATION_ID_DESC',
  FROM_USER_ID_ASC = 'FROM_USER_ID_ASC',
  FROM_USER_ID_DESC = 'FROM_USER_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INSERTED_AT_ASC = 'INSERTED_AT_ASC',
  INSERTED_AT_DESC = 'INSERTED_AT_DESC',
  MESSAGE_ASC = 'MESSAGE_ASC',
  MESSAGE_DESC = 'MESSAGE_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SENT_ASC = 'SENT_ASC',
  SENT_DESC = 'SENT_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  TO_ORGANIZATION_ID_ASC = 'TO_ORGANIZATION_ID_ASC',
  TO_ORGANIZATION_ID_DESC = 'TO_ORGANIZATION_ID_DESC',
  TO_USER_ID_ASC = 'TO_USER_ID_ASC',
  TO_USER_ID_DESC = 'TO_USER_ID_DESC',
  VOYAGE_ID_ASC = 'VOYAGE_ID_ASC',
  VOYAGE_ID_DESC = 'VOYAGE_ID_DESC'
}

export type ClassSocietyAssociation = Node & {
  __typename?: 'ClassSocietyAssociation';
  /** Reads a single `ClassificationSociety` that is related to this `ClassSocietyAssociation`. */
  classificationSocietyBySocietyId?: Maybe<ClassificationSociety>;
  /** Reads a single `IceClass` that is related to this `ClassSocietyAssociation`. */
  iceClassByIceClassId?: Maybe<IceClass>;
  iceClassId?: Maybe<Scalars['IceClassId']['output']>;
  id: Scalars['ClassSocietyAssociationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  societyId?: Maybe<Scalars['ClassificationSocietyId']['output']>;
  /** Reads and enables pagination through a set of `VesselInfo`. */
  vesselInfosByClassSocietyAssociationId: VesselInfosConnection;
};


export type ClassSocietyAssociationVesselInfosByClassSocietyAssociationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselInfoCondition>;
  filter?: InputMaybe<VesselInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
};

/**
 * A condition to be used against `ClassSocietyAssociation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ClassSocietyAssociationCondition = {
  /** Checks for equality with the object’s `iceClassId` field. */
  iceClassId?: InputMaybe<Scalars['IceClassId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ClassSocietyAssociationId']['input']>;
  /** Checks for equality with the object’s `societyId` field. */
  societyId?: InputMaybe<Scalars['ClassificationSocietyId']['input']>;
};

/** A filter to be used against `ClassSocietyAssociation` object types. All fields are combined with a logical ‘and.’ */
export type ClassSocietyAssociationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClassSocietyAssociationFilter>>;
  /** Filter by the object’s `iceClassId` field. */
  iceClassId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClassSocietyAssociationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClassSocietyAssociationFilter>>;
  /** Filter by the object’s `societyId` field. */
  societyId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ClassSocietyAssociation` */
export type ClassSocietyAssociationInput = {
  iceClassId?: InputMaybe<Scalars['IceClassId']['input']>;
  societyId?: InputMaybe<Scalars['ClassificationSocietyId']['input']>;
};

/** Represents an update to a `ClassSocietyAssociation`. Fields that are set will be updated. */
export type ClassSocietyAssociationPatch = {
  iceClassId?: InputMaybe<Scalars['IceClassId']['input']>;
  societyId?: InputMaybe<Scalars['ClassificationSocietyId']['input']>;
};

/** A connection to a list of `ClassSocietyAssociation` values. */
export type ClassSocietyAssociationsConnection = {
  __typename?: 'ClassSocietyAssociationsConnection';
  /** A list of edges which contains the `ClassSocietyAssociation` and cursor to aid in pagination. */
  edges: Array<ClassSocietyAssociationsEdge>;
  /** A list of `ClassSocietyAssociation` objects. */
  nodes: Array<Maybe<ClassSocietyAssociation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClassSocietyAssociation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ClassSocietyAssociation` edge in the connection. */
export type ClassSocietyAssociationsEdge = {
  __typename?: 'ClassSocietyAssociationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ClassSocietyAssociation` at the end of the edge. */
  node?: Maybe<ClassSocietyAssociation>;
};

/** Methods to use when ordering `ClassSocietyAssociation`. */
export enum ClassSocietyAssociationsOrderBy {
  ICE_CLASS_ID_ASC = 'ICE_CLASS_ID_ASC',
  ICE_CLASS_ID_DESC = 'ICE_CLASS_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SOCIETY_ID_ASC = 'SOCIETY_ID_ASC',
  SOCIETY_ID_DESC = 'SOCIETY_ID_DESC'
}

/** A connection to a list of `ClassificationSociety` values. */
export type ClassificationSocietiesConnection = {
  __typename?: 'ClassificationSocietiesConnection';
  /** A list of edges which contains the `ClassificationSociety` and cursor to aid in pagination. */
  edges: Array<ClassificationSocietiesEdge>;
  /** A list of `ClassificationSociety` objects. */
  nodes: Array<Maybe<ClassificationSociety>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClassificationSociety` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ClassificationSociety` edge in the connection. */
export type ClassificationSocietiesEdge = {
  __typename?: 'ClassificationSocietiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ClassificationSociety` at the end of the edge. */
  node?: Maybe<ClassificationSociety>;
};

/** Methods to use when ordering `ClassificationSociety`. */
export enum ClassificationSocietiesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type ClassificationSociety = Node & {
  __typename?: 'ClassificationSociety';
  /** Reads and enables pagination through a set of `ClassSocietyAssociation`. */
  classSocietyAssociationsBySocietyId: ClassSocietyAssociationsConnection;
  id: Scalars['ClassificationSocietyId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type ClassificationSocietyClassSocietyAssociationsBySocietyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassSocietyAssociationCondition>;
  filter?: InputMaybe<ClassSocietyAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassSocietyAssociationsOrderBy>>;
};

/**
 * A condition to be used against `ClassificationSociety` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ClassificationSocietyCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ClassificationSocietyId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ClassificationSociety` object types. All fields are combined with a logical ‘and.’ */
export type ClassificationSocietyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClassificationSocietyFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClassificationSocietyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClassificationSocietyFilter>>;
};

/** An input for mutations affecting `ClassificationSociety` */
export type ClassificationSocietyInput = {
  name: Scalars['String']['input'];
};

/** Represents an update to a `ClassificationSociety`. Fields that are set will be updated. */
export type ClassificationSocietyPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClusterRoute = {
  __typename?: 'ClusterRoute';
  avoidsChannels?: Maybe<Scalars['Boolean']['output']>;
  draft?: Maybe<Scalars['BigFloat']['output']>;
  exact?: Maybe<Scalars['JSON']['output']>;
  fromClusterId: Scalars['Int']['output'];
  noGoZones?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  toClusterId: Scalars['Int']['output'];
};

export type CoaContract = Node & {
  __typename?: 'CoaContract';
  amountUnitId?: Maybe<Scalars['CargoUnitId']['output']>;
  /** Reads a single `CargoUnit` that is related to this `CoaContract`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  chartererId: Scalars['UserId']['output'];
  chartererOrgId: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `CoaContractAssortment`. */
  coaContractAssortmentsByCoaContractId: CoaContractAssortmentsConnection;
  /** Reads and enables pagination through a set of `CoaContractBunker`. */
  coaContractBunkersByCoaContractId: CoaContractBunkersConnection;
  /** Reads and enables pagination through a set of `CoaContractCommission`. */
  coaContractCommissionsByCoaContractId: CoaContractCommissionsConnection;
  /** Reads and enables pagination through a set of `CoaContractDeviationCost`. */
  coaContractDeviationCostsByCoaContractId: CoaContractDeviationCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractPortCost`. */
  coaContractPortCostsByCoaContractId: CoaContractPortCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractPortDatum`. */
  coaContractPortDataByCoaContractId: CoaContractPortDataConnection;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  coaContractPortsByCoaContractId: CoaContractPortsConnection;
  /** Reads and enables pagination through a set of `CoaContractPrice`. */
  coaContractPricesByCoaContractId: CoaContractPricesConnection;
  /** Reads and enables pagination through a set of `CoaContractShip`. */
  coaContractShipsByCoaContractId: CoaContractShipsConnection;
  currency?: Maybe<Currency>;
  despatch?: Maybe<Scalars['BigFloat']['output']>;
  despatchSharing?: Maybe<DespatchSharing>;
  endDate: Scalars['Datetime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `HandledByCoa`. */
  handledByCoasByCoaId: HandledByCoasConnection;
  id: Scalars['CoaContractId']['output'];
  inactive: Scalars['Boolean']['output'];
  insertedAt?: Maybe<Scalars['Datetime']['output']>;
  maxAmount?: Maybe<Scalars['BigFloat']['output']>;
  minAmount?: Maybe<Scalars['BigFloat']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Order`. */
  ordersByCoaId: OrdersConnection;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  paymentDays?: Maybe<Scalars['Int']['output']>;
  paymentTrigger?: Maybe<PaymentTrigger>;
  paymentType?: Maybe<PaymentType>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  shipownerOrgId: Scalars['OrganizationId']['output'];
  startDate: Scalars['Datetime']['output'];
  useHighestFreightRate: Scalars['Boolean']['output'];
  /** Reads a single `User` that is related to this `CoaContract`. */
  userByChartererId?: Maybe<User>;
  /** Reads a single `User` that is related to this `CoaContract`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
  /** Reads and enables pagination through a set of `VoyageCharterToContract`. */
  voyageCharterToContractsByCoaId: VoyageCharterToContractsConnection;
};


export type CoaContractCoaContractAssortmentsByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractAssortmentCondition>;
  filter?: InputMaybe<CoaContractAssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractAssortmentsOrderBy>>;
};


export type CoaContractCoaContractBunkersByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractBunkerCondition>;
  filter?: InputMaybe<CoaContractBunkerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractBunkersOrderBy>>;
};


export type CoaContractCoaContractCommissionsByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCommissionCondition>;
  filter?: InputMaybe<CoaContractCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractCommissionsOrderBy>>;
};


export type CoaContractCoaContractDeviationCostsByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractDeviationCostCondition>;
  filter?: InputMaybe<CoaContractDeviationCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};


export type CoaContractCoaContractPortCostsByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCostCondition>;
  filter?: InputMaybe<CoaContractPortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortCostsOrderBy>>;
};


export type CoaContractCoaContractPortDataByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortDatumCondition>;
  filter?: InputMaybe<CoaContractPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortDataOrderBy>>;
};


export type CoaContractCoaContractPortsByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


export type CoaContractCoaContractPricesByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPriceCondition>;
  filter?: InputMaybe<CoaContractPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};


export type CoaContractCoaContractShipsByCoaContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractShipCondition>;
  filter?: InputMaybe<CoaContractShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractShipsOrderBy>>;
};


export type CoaContractHandledByCoasByCoaIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaCondition>;
  filter?: InputMaybe<HandledByCoaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};


export type CoaContractOrdersByCoaIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type CoaContractVoyageCharterToContractsByCoaIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterToContractCondition>;
  filter?: InputMaybe<VoyageCharterToContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};

export type CoaContractAssortment = Node & {
  __typename?: 'CoaContractAssortment';
  /** Reads a single `Assortment` that is related to this `CoaContractAssortment`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `CoaContractAssortment`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  assortmentGroupId?: Maybe<Scalars['AssortmentGroupId']['output']>;
  assortmentId?: Maybe<Scalars['AssortmentId']['output']>;
  /** Reads and enables pagination through a set of `CoaContractBunker`. */
  coaContractBunkersByCoaAssortmentId: CoaContractBunkersConnection;
  /** Reads a single `CoaContract` that is related to this `CoaContractAssortment`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads and enables pagination through a set of `CoaContractCommission`. */
  coaContractCommissionsByCoaAssortmentId: CoaContractCommissionsConnection;
  coaContractId: Scalars['CoaContractId']['output'];
  /** Reads and enables pagination through a set of `CoaContractPrice`. */
  coaContractPricesByCoaAssortmentId: CoaContractPricesConnection;
  id: Scalars['CoaContractAssortmentId']['output'];
  maxAmount?: Maybe<Scalars['BigFloat']['output']>;
  minAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CoaContractAssortment`. */
  organizationByRootOrg?: Maybe<Organization>;
  paymentUnit: PaymentUnit;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
};


export type CoaContractAssortmentCoaContractBunkersByCoaAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractBunkerCondition>;
  filter?: InputMaybe<CoaContractBunkerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractBunkersOrderBy>>;
};


export type CoaContractAssortmentCoaContractCommissionsByCoaAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCommissionCondition>;
  filter?: InputMaybe<CoaContractCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractCommissionsOrderBy>>;
};


export type CoaContractAssortmentCoaContractPricesByCoaAssortmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPriceCondition>;
  filter?: InputMaybe<CoaContractPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};

/**
 * A condition to be used against `CoaContractAssortment` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CoaContractAssortmentCondition = {
  /** Checks for equality with the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  /** Checks for equality with the object’s `maxAmount` field. */
  maxAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minAmount` field. */
  minAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `paymentUnit` field. */
  paymentUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `CoaContractAssortment` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractAssortmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractAssortmentFilter>>;
  /** Filter by the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxAmount` field. */
  maxAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minAmount` field. */
  minAmount?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractAssortmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractAssortmentFilter>>;
  /** Filter by the object’s `paymentUnit` field. */
  paymentUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CoaContractAssortment` */
export type CoaContractAssortmentInput = {
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  coaContractId: Scalars['CoaContractId']['input'];
  maxAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  paymentUnit: PaymentUnit;
};

/** Represents an update to a `CoaContractAssortment`. Fields that are set will be updated. */
export type CoaContractAssortmentPatch = {
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  maxAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  paymentUnit?: InputMaybe<PaymentUnit>;
};

/** A connection to a list of `CoaContractAssortment` values. */
export type CoaContractAssortmentsConnection = {
  __typename?: 'CoaContractAssortmentsConnection';
  /** A list of edges which contains the `CoaContractAssortment` and cursor to aid in pagination. */
  edges: Array<CoaContractAssortmentsEdge>;
  /** A list of `CoaContractAssortment` objects. */
  nodes: Array<Maybe<CoaContractAssortment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractAssortment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractAssortment` edge in the connection. */
export type CoaContractAssortmentsEdge = {
  __typename?: 'CoaContractAssortmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractAssortment` at the end of the edge. */
  node?: Maybe<CoaContractAssortment>;
};

/** Methods to use when ordering `CoaContractAssortment`. */
export enum CoaContractAssortmentsOrderBy {
  ASSORTMENT_GROUP_ID_ASC = 'ASSORTMENT_GROUP_ID_ASC',
  ASSORTMENT_GROUP_ID_DESC = 'ASSORTMENT_GROUP_ID_DESC',
  ASSORTMENT_ID_ASC = 'ASSORTMENT_ID_ASC',
  ASSORTMENT_ID_DESC = 'ASSORTMENT_ID_DESC',
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MAX_AMOUNT_ASC = 'MAX_AMOUNT_ASC',
  MAX_AMOUNT_DESC = 'MAX_AMOUNT_DESC',
  MIN_AMOUNT_ASC = 'MIN_AMOUNT_ASC',
  MIN_AMOUNT_DESC = 'MIN_AMOUNT_DESC',
  NATURAL = 'NATURAL',
  PAYMENT_UNIT_ASC = 'PAYMENT_UNIT_ASC',
  PAYMENT_UNIT_DESC = 'PAYMENT_UNIT_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type CoaContractBunker = Node & {
  __typename?: 'CoaContractBunker';
  bafBunkerAmount?: Maybe<Scalars['BigFloat']['output']>;
  bafStartFromBase?: Maybe<Scalars['Boolean']['output']>;
  bafStepEffect?: Maybe<Scalars['BigFloat']['output']>;
  bafStepSize?: Maybe<Scalars['BigFloat']['output']>;
  bafType?: Maybe<BafTypes>;
  bafUseStepEffectAsValue?: Maybe<Scalars['Boolean']['output']>;
  basePriceMax?: Maybe<Scalars['BigFloat']['output']>;
  bunkerGrade: BunkerGrade;
  coaAssortmentId?: Maybe<Scalars['CoaContractAssortmentId']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractBunker`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractBunker`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  coaContractId: Scalars['CoaContractId']['output'];
  /** Reads a single `CoaContractPort` that is related to this `CoaContractBunker`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  coaRouteId?: Maybe<Scalars['CoaContractPortId']['output']>;
  id: Scalars['CoaContractBunkerId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  price: Scalars['BigFloat']['output'];
  priceRange?: Maybe<Scalars['BigFloat']['output']>;
  riskSharing?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CoaContractBunker` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CoaContractBunkerCondition = {
  /** Checks for equality with the object’s `bafBunkerAmount` field. */
  bafBunkerAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bafStartFromBase` field. */
  bafStartFromBase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `bafStepEffect` field. */
  bafStepEffect?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bafStepSize` field. */
  bafStepSize?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bafType` field. */
  bafType?: InputMaybe<BafTypes>;
  /** Checks for equality with the object’s `bafUseStepEffectAsValue` field. */
  bafUseStepEffectAsValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `basePriceMax` field. */
  basePriceMax?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bunkerGrade` field. */
  bunkerGrade?: InputMaybe<BunkerGrade>;
  /** Checks for equality with the object’s `coaAssortmentId` field. */
  coaAssortmentId?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `coaRouteId` field. */
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractBunkerId']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `priceRange` field. */
  priceRange?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `riskSharing` field. */
  riskSharing?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `CoaContractBunker` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractBunkerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractBunkerFilter>>;
  /** Filter by the object’s `bafBunkerAmount` field. */
  bafBunkerAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `bafStartFromBase` field. */
  bafStartFromBase?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `bafStepEffect` field. */
  bafStepEffect?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `bafStepSize` field. */
  bafStepSize?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `bafType` field. */
  bafType?: InputMaybe<BafTypesFilter>;
  /** Filter by the object’s `bafUseStepEffectAsValue` field. */
  bafUseStepEffectAsValue?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `basePriceMax` field. */
  basePriceMax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `bunkerGrade` field. */
  bunkerGrade?: InputMaybe<BunkerGradeFilter>;
  /** Filter by the object’s `coaAssortmentId` field. */
  coaAssortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `coaRouteId` field. */
  coaRouteId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractBunkerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractBunkerFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `priceRange` field. */
  priceRange?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `riskSharing` field. */
  riskSharing?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `CoaContractBunker` */
export type CoaContractBunkerInput = {
  bafBunkerAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  bafStartFromBase?: InputMaybe<Scalars['Boolean']['input']>;
  bafStepEffect?: InputMaybe<Scalars['BigFloat']['input']>;
  bafStepSize?: InputMaybe<Scalars['BigFloat']['input']>;
  bafType?: InputMaybe<BafTypes>;
  bafUseStepEffectAsValue?: InputMaybe<Scalars['Boolean']['input']>;
  basePriceMax?: InputMaybe<Scalars['BigFloat']['input']>;
  bunkerGrade: BunkerGrade;
  coaAssortmentId?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  coaContractId: Scalars['CoaContractId']['input'];
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  price: Scalars['BigFloat']['input'];
  priceRange?: InputMaybe<Scalars['BigFloat']['input']>;
  riskSharing?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Represents an update to a `CoaContractBunker`. Fields that are set will be updated. */
export type CoaContractBunkerPatch = {
  bafBunkerAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  bafStartFromBase?: InputMaybe<Scalars['Boolean']['input']>;
  bafStepEffect?: InputMaybe<Scalars['BigFloat']['input']>;
  bafStepSize?: InputMaybe<Scalars['BigFloat']['input']>;
  bafType?: InputMaybe<BafTypes>;
  bafUseStepEffectAsValue?: InputMaybe<Scalars['Boolean']['input']>;
  basePriceMax?: InputMaybe<Scalars['BigFloat']['input']>;
  bunkerGrade?: InputMaybe<BunkerGrade>;
  coaAssortmentId?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  priceRange?: InputMaybe<Scalars['BigFloat']['input']>;
  riskSharing?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `CoaContractBunker` values. */
export type CoaContractBunkersConnection = {
  __typename?: 'CoaContractBunkersConnection';
  /** A list of edges which contains the `CoaContractBunker` and cursor to aid in pagination. */
  edges: Array<CoaContractBunkersEdge>;
  /** A list of `CoaContractBunker` objects. */
  nodes: Array<Maybe<CoaContractBunker>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractBunker` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractBunker` edge in the connection. */
export type CoaContractBunkersEdge = {
  __typename?: 'CoaContractBunkersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractBunker` at the end of the edge. */
  node?: Maybe<CoaContractBunker>;
};

/** Methods to use when ordering `CoaContractBunker`. */
export enum CoaContractBunkersOrderBy {
  BAF_BUNKER_AMOUNT_ASC = 'BAF_BUNKER_AMOUNT_ASC',
  BAF_BUNKER_AMOUNT_DESC = 'BAF_BUNKER_AMOUNT_DESC',
  BAF_START_FROM_BASE_ASC = 'BAF_START_FROM_BASE_ASC',
  BAF_START_FROM_BASE_DESC = 'BAF_START_FROM_BASE_DESC',
  BAF_STEP_EFFECT_ASC = 'BAF_STEP_EFFECT_ASC',
  BAF_STEP_EFFECT_DESC = 'BAF_STEP_EFFECT_DESC',
  BAF_STEP_SIZE_ASC = 'BAF_STEP_SIZE_ASC',
  BAF_STEP_SIZE_DESC = 'BAF_STEP_SIZE_DESC',
  BAF_TYPE_ASC = 'BAF_TYPE_ASC',
  BAF_TYPE_DESC = 'BAF_TYPE_DESC',
  BAF_USE_STEP_EFFECT_AS_VALUE_ASC = 'BAF_USE_STEP_EFFECT_AS_VALUE_ASC',
  BAF_USE_STEP_EFFECT_AS_VALUE_DESC = 'BAF_USE_STEP_EFFECT_AS_VALUE_DESC',
  BASE_PRICE_MAX_ASC = 'BASE_PRICE_MAX_ASC',
  BASE_PRICE_MAX_DESC = 'BASE_PRICE_MAX_DESC',
  BUNKER_GRADE_ASC = 'BUNKER_GRADE_ASC',
  BUNKER_GRADE_DESC = 'BUNKER_GRADE_DESC',
  COA_ASSORTMENT_ID_ASC = 'COA_ASSORTMENT_ID_ASC',
  COA_ASSORTMENT_ID_DESC = 'COA_ASSORTMENT_ID_DESC',
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  COA_ROUTE_ID_ASC = 'COA_ROUTE_ID_ASC',
  COA_ROUTE_ID_DESC = 'COA_ROUTE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  PRICE_RANGE_ASC = 'PRICE_RANGE_ASC',
  PRICE_RANGE_DESC = 'PRICE_RANGE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RISK_SHARING_ASC = 'RISK_SHARING_ASC',
  RISK_SHARING_DESC = 'RISK_SHARING_DESC'
}

export type CoaContractCommission = Node & {
  __typename?: 'CoaContractCommission';
  coaAssortmentId?: Maybe<Scalars['CoaContractAssortmentId']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractCommission`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractCommission`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  coaContractId: Scalars['CoaContractId']['output'];
  /** Reads a single `CoaContractPort` that is related to this `CoaContractCommission`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  coaRouteId?: Maybe<Scalars['CoaContractPortId']['output']>;
  /** Reads a single `Commission` that is related to this `CoaContractCommission`. */
  commissionByCommissionId?: Maybe<Commission>;
  commissionId: Scalars['CommissionId']['output'];
  id: Scalars['CoaContractCommissionId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/**
 * A condition to be used against `CoaContractCommission` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CoaContractCommissionCondition = {
  /** Checks for equality with the object’s `coaAssortmentId` field. */
  coaAssortmentId?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `coaRouteId` field. */
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  /** Checks for equality with the object’s `commissionId` field. */
  commissionId?: InputMaybe<Scalars['CommissionId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractCommissionId']['input']>;
};

/** A filter to be used against `CoaContractCommission` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractCommissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractCommissionFilter>>;
  /** Filter by the object’s `coaAssortmentId` field. */
  coaAssortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `coaRouteId` field. */
  coaRouteId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `commissionId` field. */
  commissionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractCommissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractCommissionFilter>>;
};

/** An input for mutations affecting `CoaContractCommission` */
export type CoaContractCommissionInput = {
  coaAssortmentId?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  coaContractId: Scalars['CoaContractId']['input'];
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  commissionId: Scalars['CommissionId']['input'];
};

/** Represents an update to a `CoaContractCommission`. Fields that are set will be updated. */
export type CoaContractCommissionPatch = {
  coaAssortmentId?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  commissionId?: InputMaybe<Scalars['CommissionId']['input']>;
};

/** A connection to a list of `CoaContractCommission` values. */
export type CoaContractCommissionsConnection = {
  __typename?: 'CoaContractCommissionsConnection';
  /** A list of edges which contains the `CoaContractCommission` and cursor to aid in pagination. */
  edges: Array<CoaContractCommissionsEdge>;
  /** A list of `CoaContractCommission` objects. */
  nodes: Array<Maybe<CoaContractCommission>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractCommission` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractCommission` edge in the connection. */
export type CoaContractCommissionsEdge = {
  __typename?: 'CoaContractCommissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractCommission` at the end of the edge. */
  node?: Maybe<CoaContractCommission>;
};

/** Methods to use when ordering `CoaContractCommission`. */
export enum CoaContractCommissionsOrderBy {
  COA_ASSORTMENT_ID_ASC = 'COA_ASSORTMENT_ID_ASC',
  COA_ASSORTMENT_ID_DESC = 'COA_ASSORTMENT_ID_DESC',
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  COA_ROUTE_ID_ASC = 'COA_ROUTE_ID_ASC',
  COA_ROUTE_ID_DESC = 'COA_ROUTE_ID_DESC',
  COMMISSION_ID_ASC = 'COMMISSION_ID_ASC',
  COMMISSION_ID_DESC = 'COMMISSION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/**
 * A condition to be used against `CoaContract` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CoaContractCondition = {
  /** Checks for equality with the object’s `amountUnitId` field. */
  amountUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Checks for equality with the object’s `chartererId` field. */
  chartererId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `despatch` field. */
  despatch?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `despatchSharing` field. */
  despatchSharing?: InputMaybe<DespatchSharing>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `inactive` field. */
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `maxAmount` field. */
  maxAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minAmount` field. */
  minAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `paymentDays` field. */
  paymentDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  /** Checks for equality with the object’s `paymentType` field. */
  paymentType?: InputMaybe<PaymentType>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shipownerOrgId` field. */
  shipownerOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `useHighestFreightRate` field. */
  useHighestFreightRate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

export type CoaContractDeviationCost = Node & {
  __typename?: 'CoaContractDeviationCost';
  /** Reads a single `CoaContract` that is related to this `CoaContractDeviationCost`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  coaContractId: Scalars['CoaContractId']['output'];
  fromLocationId?: Maybe<Scalars['LocationId']['output']>;
  fromZoneId?: Maybe<Scalars['ZoneId']['output']>;
  id: Scalars['CoaContractDeviationCostId']['output'];
  /** Reads a single `Location` that is related to this `CoaContractDeviationCost`. */
  locationByFromLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `CoaContractDeviationCost`. */
  locationByToLocationId?: Maybe<Location>;
  lumpSumAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  toLocationId?: Maybe<Scalars['LocationId']['output']>;
  toZoneId?: Maybe<Scalars['ZoneId']['output']>;
  /** Reads a single `Zone` that is related to this `CoaContractDeviationCost`. */
  zoneByFromZoneId?: Maybe<Zone>;
  /** Reads a single `Zone` that is related to this `CoaContractDeviationCost`. */
  zoneByToZoneId?: Maybe<Zone>;
};

/**
 * A condition to be used against `CoaContractDeviationCost` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CoaContractDeviationCostCondition = {
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `fromLocationId` field. */
  fromLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `fromZoneId` field. */
  fromZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractDeviationCostId']['input']>;
  /** Checks for equality with the object’s `lumpSumAmount` field. */
  lumpSumAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `toLocationId` field. */
  toLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `toZoneId` field. */
  toZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A filter to be used against `CoaContractDeviationCost` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractDeviationCostFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractDeviationCostFilter>>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fromLocationId` field. */
  fromLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fromZoneId` field. */
  fromZoneId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lumpSumAmount` field. */
  lumpSumAmount?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractDeviationCostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractDeviationCostFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toLocationId` field. */
  toLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toZoneId` field. */
  toZoneId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CoaContractDeviationCost` */
export type CoaContractDeviationCostInput = {
  coaContractId: Scalars['CoaContractId']['input'];
  fromLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  fromZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
  lumpSumAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  toLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  toZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** Represents an update to a `CoaContractDeviationCost`. Fields that are set will be updated. */
export type CoaContractDeviationCostPatch = {
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  fromLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  fromZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
  lumpSumAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  toLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  toZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A connection to a list of `CoaContractDeviationCost` values. */
export type CoaContractDeviationCostsConnection = {
  __typename?: 'CoaContractDeviationCostsConnection';
  /** A list of edges which contains the `CoaContractDeviationCost` and cursor to aid in pagination. */
  edges: Array<CoaContractDeviationCostsEdge>;
  /** A list of `CoaContractDeviationCost` objects. */
  nodes: Array<Maybe<CoaContractDeviationCost>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractDeviationCost` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractDeviationCost` edge in the connection. */
export type CoaContractDeviationCostsEdge = {
  __typename?: 'CoaContractDeviationCostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractDeviationCost` at the end of the edge. */
  node?: Maybe<CoaContractDeviationCost>;
};

/** Methods to use when ordering `CoaContractDeviationCost`. */
export enum CoaContractDeviationCostsOrderBy {
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  FROM_LOCATION_ID_ASC = 'FROM_LOCATION_ID_ASC',
  FROM_LOCATION_ID_DESC = 'FROM_LOCATION_ID_DESC',
  FROM_ZONE_ID_ASC = 'FROM_ZONE_ID_ASC',
  FROM_ZONE_ID_DESC = 'FROM_ZONE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LUMP_SUM_AMOUNT_ASC = 'LUMP_SUM_AMOUNT_ASC',
  LUMP_SUM_AMOUNT_DESC = 'LUMP_SUM_AMOUNT_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  TO_LOCATION_ID_ASC = 'TO_LOCATION_ID_ASC',
  TO_LOCATION_ID_DESC = 'TO_LOCATION_ID_DESC',
  TO_ZONE_ID_ASC = 'TO_ZONE_ID_ASC',
  TO_ZONE_ID_DESC = 'TO_ZONE_ID_DESC'
}

/** A filter to be used against `CoaContract` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractFilter = {
  /** Filter by the object’s `amountUnitId` field. */
  amountUnitId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractFilter>>;
  /** Filter by the object’s `chartererId` field. */
  chartererId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `despatch` field. */
  despatch?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `despatchSharing` field. */
  despatchSharing?: InputMaybe<DespatchSharingFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `inactive` field. */
  inactive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `maxAmount` field. */
  maxAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minAmount` field. */
  minAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentDays` field. */
  paymentDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTriggerFilter>;
  /** Filter by the object’s `paymentType` field. */
  paymentType?: InputMaybe<PaymentTypeFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipownerOrgId` field. */
  shipownerOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `useHighestFreightRate` field. */
  useHighestFreightRate?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CoaContract` */
export type CoaContractInput = {
  amountUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  chartererId?: InputMaybe<Scalars['UserId']['input']>;
  chartererOrgId: Scalars['OrganizationId']['input'];
  currency?: InputMaybe<Currency>;
  despatch?: InputMaybe<Scalars['BigFloat']['input']>;
  despatchSharing?: InputMaybe<DespatchSharing>;
  endDate: Scalars['Datetime']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  maxAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  paymentDays?: InputMaybe<Scalars['Int']['input']>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  paymentType?: InputMaybe<PaymentType>;
  shipownerOrgId: Scalars['OrganizationId']['input'];
  startDate: Scalars['Datetime']['input'];
  useHighestFreightRate?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `CoaContract`. Fields that are set will be updated. */
export type CoaContractPatch = {
  amountUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  chartererId?: InputMaybe<Scalars['UserId']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  currency?: InputMaybe<Currency>;
  despatch?: InputMaybe<Scalars['BigFloat']['input']>;
  despatchSharing?: InputMaybe<DespatchSharing>;
  endDate?: InputMaybe<Scalars['Datetime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  maxAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  minAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  paymentDays?: InputMaybe<Scalars['Int']['input']>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  paymentType?: InputMaybe<PaymentType>;
  shipownerOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  startDate?: InputMaybe<Scalars['Datetime']['input']>;
  useHighestFreightRate?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

export type CoaContractPort = Node & {
  __typename?: 'CoaContractPort';
  chartererId: Scalars['UserId']['output'];
  chartererOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `CoaContractBunker`. */
  coaContractBunkersByCoaRouteId: CoaContractBunkersConnection;
  /** Reads a single `CoaContract` that is related to this `CoaContractPort`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads and enables pagination through a set of `CoaContractCommission`. */
  coaContractCommissionsByCoaRouteId: CoaContractCommissionsConnection;
  coaContractId: Scalars['CoaContractId']['output'];
  /** Reads and enables pagination through a set of `CoaContractPrice`. */
  coaContractPricesByRouteId: CoaContractPricesConnection;
  destinationId?: Maybe<Scalars['LocationId']['output']>;
  destinationZoneId?: Maybe<Scalars['ZoneId']['output']>;
  id: Scalars['CoaContractPortId']['output'];
  /** Reads a single `Location` that is related to this `CoaContractPort`. */
  locationByDestinationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `CoaContractPort`. */
  locationByOriginId?: Maybe<Location>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrderVoyageCharterRelation`. */
  orderVoyageCharterRelationsByCoaRouteId: OrderVoyageCharterRelationsConnection;
  /** Reads a single `Organization` that is related to this `CoaContractPort`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContractPort`. */
  organizationByRootOrg?: Maybe<Organization>;
  originId?: Maybe<Scalars['LocationId']['output']>;
  originZoneId?: Maybe<Scalars['ZoneId']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `User` that is related to this `CoaContractPort`. */
  userByChartererId?: Maybe<User>;
  /** Reads a single `Zone` that is related to this `CoaContractPort`. */
  zoneByDestinationZoneId?: Maybe<Zone>;
  /** Reads a single `Zone` that is related to this `CoaContractPort`. */
  zoneByOriginZoneId?: Maybe<Zone>;
};


export type CoaContractPortCoaContractBunkersByCoaRouteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractBunkerCondition>;
  filter?: InputMaybe<CoaContractBunkerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractBunkersOrderBy>>;
};


export type CoaContractPortCoaContractCommissionsByCoaRouteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCommissionCondition>;
  filter?: InputMaybe<CoaContractCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractCommissionsOrderBy>>;
};


export type CoaContractPortCoaContractPricesByRouteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPriceCondition>;
  filter?: InputMaybe<CoaContractPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};


export type CoaContractPortOrderVoyageCharterRelationsByCoaRouteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderVoyageCharterRelationCondition>;
  filter?: InputMaybe<OrderVoyageCharterRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};

/**
 * A condition to be used against `CoaContractPort` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CoaContractPortCondition = {
  /** Checks for equality with the object’s `chartererId` field. */
  chartererId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `destinationId` field. */
  destinationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `destinationZoneId` field. */
  destinationZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  /** Checks for equality with the object’s `originId` field. */
  originId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `originZoneId` field. */
  originZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

export type CoaContractPortCost = Node & {
  __typename?: 'CoaContractPortCost';
  /** Reads a single `CoaContract` that is related to this `CoaContractPortCost`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  coaContractId: Scalars['CoaContractId']['output'];
  cost: Scalars['BigFloat']['output'];
  id: Scalars['CoaContractPortCostId']['output'];
  /** Reads a single `Location` that is related to this `CoaContractPortCost`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  /** Reads a single `Ship` that is related to this `CoaContractPortCost`. */
  shipByShipId?: Maybe<Ship>;
  shipId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads a single `VesselAttribute` that is related to this `CoaContractPortCost`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
  vesselTypeId?: Maybe<Scalars['VesselAttributeId']['output']>;
};

/**
 * A condition to be used against `CoaContractPortCost` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CoaContractPortCostCondition = {
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `cost` field. */
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractPortCostId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `vesselTypeId` field. */
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A filter to be used against `CoaContractPortCost` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractPortCostFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractPortCostFilter>>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cost` field. */
  cost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractPortCostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractPortCostFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselTypeId` field. */
  vesselTypeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CoaContractPortCost` */
export type CoaContractPortCostInput = {
  coaContractId: Scalars['CoaContractId']['input'];
  cost: Scalars['BigFloat']['input'];
  locationId: Scalars['LocationId']['input'];
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** Represents an update to a `CoaContractPortCost`. Fields that are set will be updated. */
export type CoaContractPortCostPatch = {
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A connection to a list of `CoaContractPortCost` values. */
export type CoaContractPortCostsConnection = {
  __typename?: 'CoaContractPortCostsConnection';
  /** A list of edges which contains the `CoaContractPortCost` and cursor to aid in pagination. */
  edges: Array<CoaContractPortCostsEdge>;
  /** A list of `CoaContractPortCost` objects. */
  nodes: Array<Maybe<CoaContractPortCost>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractPortCost` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractPortCost` edge in the connection. */
export type CoaContractPortCostsEdge = {
  __typename?: 'CoaContractPortCostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractPortCost` at the end of the edge. */
  node?: Maybe<CoaContractPortCost>;
};

/** Methods to use when ordering `CoaContractPortCost`. */
export enum CoaContractPortCostsOrderBy {
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  COST_ASC = 'COST_ASC',
  COST_DESC = 'COST_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC',
  VESSEL_TYPE_ID_ASC = 'VESSEL_TYPE_ID_ASC',
  VESSEL_TYPE_ID_DESC = 'VESSEL_TYPE_ID_DESC'
}

/** A connection to a list of `CoaContractPortDatum` values. */
export type CoaContractPortDataConnection = {
  __typename?: 'CoaContractPortDataConnection';
  /** A list of edges which contains the `CoaContractPortDatum` and cursor to aid in pagination. */
  edges: Array<CoaContractPortDataEdge>;
  /** A list of `CoaContractPortDatum` objects. */
  nodes: Array<Maybe<CoaContractPortDatum>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractPortDatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractPortDatum` edge in the connection. */
export type CoaContractPortDataEdge = {
  __typename?: 'CoaContractPortDataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractPortDatum` at the end of the edge. */
  node?: Maybe<CoaContractPortDatum>;
};

/** Methods to use when ordering `CoaContractPortDatum`. */
export enum CoaContractPortDataOrderBy {
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PORT_DATA_ID_ASC = 'PORT_DATA_ID_ASC',
  PORT_DATA_ID_DESC = 'PORT_DATA_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type CoaContractPortDatum = Node & {
  __typename?: 'CoaContractPortDatum';
  /** Reads a single `CoaContract` that is related to this `CoaContractPortDatum`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  coaContractId: Scalars['CoaContractId']['output'];
  id: Scalars['CoaContractPortDatumId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CoaContractPortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  portDataId: Scalars['PortDatumId']['output'];
  /** Reads a single `PortDatum` that is related to this `CoaContractPortDatum`. */
  portDatumByPortDataId?: Maybe<PortDatum>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `CoaContractPortDatum` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CoaContractPortDatumCondition = {
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractPortDatumId']['input']>;
  /** Checks for equality with the object’s `portDataId` field. */
  portDataId?: InputMaybe<Scalars['PortDatumId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `CoaContractPortDatum` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractPortDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractPortDatumFilter>>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractPortDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractPortDatumFilter>>;
  /** Filter by the object’s `portDataId` field. */
  portDataId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CoaContractPortDatum` */
export type CoaContractPortDatumInput = {
  coaContractId: Scalars['CoaContractId']['input'];
  portDataId: Scalars['PortDatumId']['input'];
};

/** Represents an update to a `CoaContractPortDatum`. Fields that are set will be updated. */
export type CoaContractPortDatumPatch = {
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  portDataId?: InputMaybe<Scalars['PortDatumId']['input']>;
};

/** A filter to be used against `CoaContractPort` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractPortFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractPortFilter>>;
  /** Filter by the object’s `chartererId` field. */
  chartererId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `destinationId` field. */
  destinationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `destinationZoneId` field. */
  destinationZoneId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractPortFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractPortFilter>>;
  /** Filter by the object’s `originId` field. */
  originId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `originZoneId` field. */
  originZoneId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CoaContractPort` */
export type CoaContractPortInput = {
  chartererId?: InputMaybe<Scalars['UserId']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  coaContractId: Scalars['CoaContractId']['input'];
  destinationId?: InputMaybe<Scalars['LocationId']['input']>;
  destinationZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
  originId?: InputMaybe<Scalars['LocationId']['input']>;
  originZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** Represents an update to a `CoaContractPort`. Fields that are set will be updated. */
export type CoaContractPortPatch = {
  chartererId?: InputMaybe<Scalars['UserId']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  destinationId?: InputMaybe<Scalars['LocationId']['input']>;
  destinationZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
  originId?: InputMaybe<Scalars['LocationId']['input']>;
  originZoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A connection to a list of `CoaContractPort` values. */
export type CoaContractPortsConnection = {
  __typename?: 'CoaContractPortsConnection';
  /** A list of edges which contains the `CoaContractPort` and cursor to aid in pagination. */
  edges: Array<CoaContractPortsEdge>;
  /** A list of `CoaContractPort` objects. */
  nodes: Array<Maybe<CoaContractPort>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractPort` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractPort` edge in the connection. */
export type CoaContractPortsEdge = {
  __typename?: 'CoaContractPortsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractPort` at the end of the edge. */
  node?: Maybe<CoaContractPort>;
};

/** Methods to use when ordering `CoaContractPort`. */
export enum CoaContractPortsOrderBy {
  CHARTERER_ID_ASC = 'CHARTERER_ID_ASC',
  CHARTERER_ID_DESC = 'CHARTERER_ID_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  DESTINATION_ID_ASC = 'DESTINATION_ID_ASC',
  DESTINATION_ID_DESC = 'DESTINATION_ID_DESC',
  DESTINATION_ZONE_ID_ASC = 'DESTINATION_ZONE_ID_ASC',
  DESTINATION_ZONE_ID_DESC = 'DESTINATION_ZONE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORIGIN_ID_ASC = 'ORIGIN_ID_ASC',
  ORIGIN_ID_DESC = 'ORIGIN_ID_DESC',
  ORIGIN_ZONE_ID_ASC = 'ORIGIN_ZONE_ID_ASC',
  ORIGIN_ZONE_ID_DESC = 'ORIGIN_ZONE_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type CoaContractPrice = Node & {
  __typename?: 'CoaContractPrice';
  coaAssortmentId: Scalars['CoaContractAssortmentId']['output'];
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractPrice`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPrice`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  coaContractId: Scalars['CoaContractId']['output'];
  /** Reads a single `CoaContractPort` that is related to this `CoaContractPrice`. */
  coaContractPortByRouteId?: Maybe<CoaContractPort>;
  id: Scalars['CoaContractPriceId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CoaContractPrice`. */
  organizationByRootOrg?: Maybe<Organization>;
  paymentTrigger?: Maybe<PaymentTrigger>;
  paymentType?: Maybe<PaymentType>;
  price: Scalars['BigFloat']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  routeId?: Maybe<Scalars['CoaContractPortId']['output']>;
  /** Reads a single `Ship` that is related to this `CoaContractPrice`. */
  shipByShipId?: Maybe<Ship>;
  shipId?: Maybe<Scalars['ShipId']['output']>;
};

/**
 * A condition to be used against `CoaContractPrice` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CoaContractPriceCondition = {
  /** Checks for equality with the object’s `coaAssortmentId` field. */
  coaAssortmentId?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractPriceId']['input']>;
  /** Checks for equality with the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  /** Checks for equality with the object’s `paymentType` field. */
  paymentType?: InputMaybe<PaymentType>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `routeId` field. */
  routeId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `CoaContractPrice` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractPriceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractPriceFilter>>;
  /** Filter by the object’s `coaAssortmentId` field. */
  coaAssortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractPriceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractPriceFilter>>;
  /** Filter by the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTriggerFilter>;
  /** Filter by the object’s `paymentType` field. */
  paymentType?: InputMaybe<PaymentTypeFilter>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `routeId` field. */
  routeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CoaContractPrice` */
export type CoaContractPriceInput = {
  coaAssortmentId: Scalars['CoaContractAssortmentId']['input'];
  coaContractId: Scalars['CoaContractId']['input'];
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  paymentType?: InputMaybe<PaymentType>;
  price: Scalars['BigFloat']['input'];
  routeId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `CoaContractPrice`. Fields that are set will be updated. */
export type CoaContractPricePatch = {
  coaAssortmentId?: InputMaybe<Scalars['CoaContractAssortmentId']['input']>;
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  paymentType?: InputMaybe<PaymentType>;
  price?: InputMaybe<Scalars['BigFloat']['input']>;
  routeId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `CoaContractPrice` values. */
export type CoaContractPricesConnection = {
  __typename?: 'CoaContractPricesConnection';
  /** A list of edges which contains the `CoaContractPrice` and cursor to aid in pagination. */
  edges: Array<CoaContractPricesEdge>;
  /** A list of `CoaContractPrice` objects. */
  nodes: Array<Maybe<CoaContractPrice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractPrice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractPrice` edge in the connection. */
export type CoaContractPricesEdge = {
  __typename?: 'CoaContractPricesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractPrice` at the end of the edge. */
  node?: Maybe<CoaContractPrice>;
};

/** Methods to use when ordering `CoaContractPrice`. */
export enum CoaContractPricesOrderBy {
  COA_ASSORTMENT_ID_ASC = 'COA_ASSORTMENT_ID_ASC',
  COA_ASSORTMENT_ID_DESC = 'COA_ASSORTMENT_ID_DESC',
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PAYMENT_TRIGGER_ASC = 'PAYMENT_TRIGGER_ASC',
  PAYMENT_TRIGGER_DESC = 'PAYMENT_TRIGGER_DESC',
  PAYMENT_TYPE_ASC = 'PAYMENT_TYPE_ASC',
  PAYMENT_TYPE_DESC = 'PAYMENT_TYPE_DESC',
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  ROUTE_ID_ASC = 'ROUTE_ID_ASC',
  ROUTE_ID_DESC = 'ROUTE_ID_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC'
}

export type CoaContractShip = Node & {
  __typename?: 'CoaContractShip';
  /** Reads a single `CoaContract` that is related to this `CoaContractShip`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  coaContractId: Scalars['CoaContractId']['output'];
  demurrage?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['CoaContractShipId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CoaContractShip`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `CoaContractShip`. */
  shipByShipId?: Maybe<Ship>;
  shipId: Scalars['ShipId']['output'];
};

/**
 * A condition to be used against `CoaContractShip` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CoaContractShipCondition = {
  /** Checks for equality with the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `demurrage` field. */
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CoaContractShipId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `CoaContractShip` object types. All fields are combined with a logical ‘and.’ */
export type CoaContractShipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CoaContractShipFilter>>;
  /** Filter by the object’s `coaContractId` field. */
  coaContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `demurrage` field. */
  demurrage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CoaContractShipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CoaContractShipFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CoaContractShip` */
export type CoaContractShipInput = {
  coaContractId: Scalars['CoaContractId']['input'];
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  shipId: Scalars['ShipId']['input'];
};

/** Represents an update to a `CoaContractShip`. Fields that are set will be updated. */
export type CoaContractShipPatch = {
  coaContractId?: InputMaybe<Scalars['CoaContractId']['input']>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `CoaContractShip` values. */
export type CoaContractShipsConnection = {
  __typename?: 'CoaContractShipsConnection';
  /** A list of edges which contains the `CoaContractShip` and cursor to aid in pagination. */
  edges: Array<CoaContractShipsEdge>;
  /** A list of `CoaContractShip` objects. */
  nodes: Array<Maybe<CoaContractShip>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContractShip` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContractShip` edge in the connection. */
export type CoaContractShipsEdge = {
  __typename?: 'CoaContractShipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContractShip` at the end of the edge. */
  node?: Maybe<CoaContractShip>;
};

/** Methods to use when ordering `CoaContractShip`. */
export enum CoaContractShipsOrderBy {
  COA_CONTRACT_ID_ASC = 'COA_CONTRACT_ID_ASC',
  COA_CONTRACT_ID_DESC = 'COA_CONTRACT_ID_DESC',
  DEMURRAGE_ASC = 'DEMURRAGE_ASC',
  DEMURRAGE_DESC = 'DEMURRAGE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC'
}

/** A connection to a list of `CoaContract` values. */
export type CoaContractsConnection = {
  __typename?: 'CoaContractsConnection';
  /** A list of edges which contains the `CoaContract` and cursor to aid in pagination. */
  edges: Array<CoaContractsEdge>;
  /** A list of `CoaContract` objects. */
  nodes: Array<Maybe<CoaContract>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CoaContract` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CoaContract` edge in the connection. */
export type CoaContractsEdge = {
  __typename?: 'CoaContractsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CoaContract` at the end of the edge. */
  node?: Maybe<CoaContract>;
};

/** All input for the `coaContractsForCurrentPortAgent` mutation. */
export type CoaContractsForCurrentPortAgentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `coaContractsForCurrentPortAgent` mutation. */
export type CoaContractsForCurrentPortAgentPayload = {
  __typename?: 'CoaContractsForCurrentPortAgentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `coaContractsForCurrentSendersReceivers` mutation. */
export type CoaContractsForCurrentSendersReceiversInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `coaContractsForCurrentSendersReceivers` mutation. */
export type CoaContractsForCurrentSendersReceiversPayload = {
  __typename?: 'CoaContractsForCurrentSendersReceiversPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** Methods to use when ordering `CoaContract`. */
export enum CoaContractsOrderBy {
  AMOUNT_UNIT_ID_ASC = 'AMOUNT_UNIT_ID_ASC',
  AMOUNT_UNIT_ID_DESC = 'AMOUNT_UNIT_ID_DESC',
  CHARTERER_ID_ASC = 'CHARTERER_ID_ASC',
  CHARTERER_ID_DESC = 'CHARTERER_ID_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  DESPATCH_ASC = 'DESPATCH_ASC',
  DESPATCH_DESC = 'DESPATCH_DESC',
  DESPATCH_SHARING_ASC = 'DESPATCH_SHARING_ASC',
  DESPATCH_SHARING_DESC = 'DESPATCH_SHARING_DESC',
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INACTIVE_ASC = 'INACTIVE_ASC',
  INACTIVE_DESC = 'INACTIVE_DESC',
  INSERTED_AT_ASC = 'INSERTED_AT_ASC',
  INSERTED_AT_DESC = 'INSERTED_AT_DESC',
  MAX_AMOUNT_ASC = 'MAX_AMOUNT_ASC',
  MAX_AMOUNT_DESC = 'MAX_AMOUNT_DESC',
  MIN_AMOUNT_ASC = 'MIN_AMOUNT_ASC',
  MIN_AMOUNT_DESC = 'MIN_AMOUNT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PAYMENT_DAYS_ASC = 'PAYMENT_DAYS_ASC',
  PAYMENT_DAYS_DESC = 'PAYMENT_DAYS_DESC',
  PAYMENT_TRIGGER_ASC = 'PAYMENT_TRIGGER_ASC',
  PAYMENT_TRIGGER_DESC = 'PAYMENT_TRIGGER_DESC',
  PAYMENT_TYPE_ASC = 'PAYMENT_TYPE_ASC',
  PAYMENT_TYPE_DESC = 'PAYMENT_TYPE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIPOWNER_ORG_ID_ASC = 'SHIPOWNER_ORG_ID_ASC',
  SHIPOWNER_ORG_ID_DESC = 'SHIPOWNER_ORG_ID_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  USE_HIGHEST_FREIGHT_RATE_ASC = 'USE_HIGHEST_FREIGHT_RATE_ASC',
  USE_HIGHEST_FREIGHT_RATE_DESC = 'USE_HIGHEST_FREIGHT_RATE_DESC'
}

export type Commission = Node & {
  __typename?: 'Commission';
  /** Reads a single `Assortment` that is related to this `Commission`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  assortmentId?: Maybe<Scalars['AssortmentId']['output']>;
  bafApplied?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `CoaContractCommission`. */
  coaContractCommissionsByCommissionId: CoaContractCommissionsConnection;
  demurrageApplied?: Maybe<Scalars['Boolean']['output']>;
  dischargePortId?: Maybe<Scalars['LocationId']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  extraFreightApplied?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['CommissionId']['output'];
  loadPortId?: Maybe<Scalars['LocationId']['output']>;
  /** Reads a single `Location` that is related to this `Commission`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Commission`. */
  locationByLoadPortId?: Maybe<Location>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Commission`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  type: CommissionType;
  value: Scalars['BigFloat']['output'];
  /** Reads a single `VoyageCharter` that is related to this `Commission`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId?: Maybe<Scalars['VoyageCharterId']['output']>;
};


export type CommissionCoaContractCommissionsByCommissionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCommissionCondition>;
  filter?: InputMaybe<CoaContractCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractCommissionsOrderBy>>;
};

/**
 * A condition to be used against `Commission` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CommissionCondition = {
  /** Checks for equality with the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `bafApplied` field. */
  bafApplied?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `demurrageApplied` field. */
  demurrageApplied?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargePortId` field. */
  dischargePortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `extraFreightApplied` field. */
  extraFreightApplied?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CommissionId']['input']>;
  /** Checks for equality with the object’s `loadPortId` field. */
  loadPortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<CommissionType>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `Commission` object types. All fields are combined with a logical ‘and.’ */
export type CommissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CommissionFilter>>;
  /** Filter by the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `bafApplied` field. */
  bafApplied?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `demurrageApplied` field. */
  demurrageApplied?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargePortId` field. */
  dischargePortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extraFreightApplied` field. */
  extraFreightApplied?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadPortId` field. */
  loadPortId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CommissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CommissionFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<CommissionTypeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Commission` */
export type CommissionInput = {
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  bafApplied?: InputMaybe<Scalars['Boolean']['input']>;
  demurrageApplied?: InputMaybe<Scalars['Boolean']['input']>;
  dischargePortId?: InputMaybe<Scalars['LocationId']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  extraFreightApplied?: InputMaybe<Scalars['Boolean']['input']>;
  loadPortId?: InputMaybe<Scalars['LocationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  type: CommissionType;
  value: Scalars['BigFloat']['input'];
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** Represents an update to a `Commission`. Fields that are set will be updated. */
export type CommissionPatch = {
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  bafApplied?: InputMaybe<Scalars['Boolean']['input']>;
  demurrageApplied?: InputMaybe<Scalars['Boolean']['input']>;
  dischargePortId?: InputMaybe<Scalars['LocationId']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  extraFreightApplied?: InputMaybe<Scalars['Boolean']['input']>;
  loadPortId?: InputMaybe<Scalars['LocationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  type?: InputMaybe<CommissionType>;
  value?: InputMaybe<Scalars['BigFloat']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

export enum CommissionType {
  LUMPSUM = 'LUMPSUM',
  PERCENTAGE = 'PERCENTAGE',
  RATE = 'RATE'
}

/** A filter to be used against CommissionType fields. All fields are combined with a logical ‘and.’ */
export type CommissionTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CommissionType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CommissionType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CommissionType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CommissionType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CommissionType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CommissionType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CommissionType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CommissionType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CommissionType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CommissionType>>;
};

/** A connection to a list of `Commission` values. */
export type CommissionsConnection = {
  __typename?: 'CommissionsConnection';
  /** A list of edges which contains the `Commission` and cursor to aid in pagination. */
  edges: Array<CommissionsEdge>;
  /** A list of `Commission` objects. */
  nodes: Array<Maybe<Commission>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Commission` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Commission` edge in the connection. */
export type CommissionsEdge = {
  __typename?: 'CommissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Commission` at the end of the edge. */
  node?: Maybe<Commission>;
};

/** Methods to use when ordering `Commission`. */
export enum CommissionsOrderBy {
  ASSORTMENT_ID_ASC = 'ASSORTMENT_ID_ASC',
  ASSORTMENT_ID_DESC = 'ASSORTMENT_ID_DESC',
  BAF_APPLIED_ASC = 'BAF_APPLIED_ASC',
  BAF_APPLIED_DESC = 'BAF_APPLIED_DESC',
  DEMURRAGE_APPLIED_ASC = 'DEMURRAGE_APPLIED_ASC',
  DEMURRAGE_APPLIED_DESC = 'DEMURRAGE_APPLIED_DESC',
  DISCHARGE_PORT_ID_ASC = 'DISCHARGE_PORT_ID_ASC',
  DISCHARGE_PORT_ID_DESC = 'DISCHARGE_PORT_ID_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  EXTRA_FREIGHT_APPLIED_ASC = 'EXTRA_FREIGHT_APPLIED_ASC',
  EXTRA_FREIGHT_APPLIED_DESC = 'EXTRA_FREIGHT_APPLIED_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOAD_PORT_ID_ASC = 'LOAD_PORT_ID_ASC',
  LOAD_PORT_ID_DESC = 'LOAD_PORT_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

export type CommitCargoCompartmentAllocationInput = {
  amount: Scalars['BigFloat']['input'];
  clientId: Scalars['UUID']['input'];
  compartmentId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
  scheduledOrderClientId: Scalars['UUID']['input'];
  scheduledOrderId: CreatedOrExisting;
};

export type CommitCargoExclusionInput = {
  assortment?: InputMaybe<Scalars['Int']['input']>;
  assortmentGroup?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  orderId: CreatedOrExisting;
  tanks?: InputMaybe<Scalars['Int']['input']>;
  voyages?: InputMaybe<Scalars['Int']['input']>;
};

export type CommitCommissionInput = {
  assortmentId?: InputMaybe<Scalars['Int']['input']>;
  bafApplied?: InputMaybe<Scalars['Boolean']['input']>;
  demurrageApplied?: InputMaybe<Scalars['Boolean']['input']>;
  dischargePortId?: InputMaybe<Scalars['Int']['input']>;
  extraFreightApplied?: InputMaybe<Scalars['Boolean']['input']>;
  loadPortId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  type: CommissionType;
  value: Scalars['BigFloat']['input'];
  voyageCharterId: CreatedOrExisting;
};

export type CommitInput = {
  createCargoCompartmentAllocations?: InputMaybe<Array<CommitCargoCompartmentAllocationInput>>;
  createHandledByCoas?: InputMaybe<Array<HandledByCoaInput>>;
  createHandledBySpots?: InputMaybe<Array<HandledBySpotInput>>;
  createOffHires?: InputMaybe<Array<OffHireInput>>;
  createOrderPortCallRelations?: InputMaybe<Array<CommitOrderPortCallRelationInput>>;
  createOrderVoyageCharterRelations?: InputMaybe<Array<CommitOrderVoyageCharterRelationInput>>;
  createPortCalls?: InputMaybe<Array<PortCallInput>>;
  createPortNotices?: InputMaybe<Array<CommitPortNoticeInput>>;
  createScheduledOrders?: InputMaybe<Array<ScheduledOrderInput>>;
  createShipmentExtraFreights?: InputMaybe<Array<CommitShipmentExtraFreightInput>>;
  createShipmentFreights?: InputMaybe<Array<CommitShipmentFreightInput>>;
  createShipments?: InputMaybe<Array<ShipmentInput>>;
  createSingleEventPortCallRelations?: InputMaybe<Array<CommitSingleEventPortCallRelationInput>>;
  createSingleEvents?: InputMaybe<Array<SingleEventInput>>;
  createVoyageCharterOrderFreights?: InputMaybe<Array<CommitVoyageCharterOrderFreightInput>>;
  createVoyageCharterPortData?: InputMaybe<Array<CommitVoyageCharterPortDatumInput>>;
  createVoyageCharterToContracts?: InputMaybe<Array<CommitVoyageCharterToContractInput>>;
  createVoyageCharters?: InputMaybe<Array<VoyageCharterInput>>;
  deleteBillOfLadingData?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteCargoCompartmentAllocations?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteCargoMeasurements?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteHandledByCoas?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteHandledBySpots?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteOffHires?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteOrderPortCallRelations?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteOrderVoyageCharterRelations?: InputMaybe<Array<Scalars['Int']['input']>>;
  deletePortCalls?: InputMaybe<Array<Scalars['Int']['input']>>;
  deletePortNotices?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteScheduledOrders?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteShipmentExtraFreights?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteShipmentFreights?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteSingleEventPortCallRelations?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteSingleEvents?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteVoyageCharterOrderFreights?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteVoyageCharterPortData?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteVoyageCharterToContracts?: InputMaybe<Array<Scalars['Int']['input']>>;
  deleteVoyageCharters?: InputMaybe<Array<Scalars['Int']['input']>>;
  isMerge?: InputMaybe<Scalars['Boolean']['input']>;
  masterScenarioCommitLogClientId?: InputMaybe<Scalars['UUID']['input']>;
  previousCommitAt?: InputMaybe<Scalars['Datetime']['input']>;
  scenarioCID?: InputMaybe<Scalars['UUID']['input']>;
  scenarioScenarioCommitLogClientId?: InputMaybe<Scalars['UUID']['input']>;
  suppressEmail?: InputMaybe<Scalars['Boolean']['input']>;
  updateCargoCompartmentAllocations?: InputMaybe<Array<UpdateCargoCompartmentAllocationByIdInput>>;
  updateHandledByCoas?: InputMaybe<Array<UpdateHandledByCoaByIdInput>>;
  updateHandledBySpots?: InputMaybe<Array<UpdateHandledBySpotByIdInput>>;
  updateOffHires?: InputMaybe<Array<UpdateOffHireByIdInput>>;
  updateOrders?: InputMaybe<Array<CommitUpdateOrderByIdInput>>;
  updatePortCalls?: InputMaybe<Array<UpdatePortCallByIdInput>>;
  updateScheduledOrders?: InputMaybe<Array<UpdateScheduledOrderByIdInput>>;
  updateShipmentExtraFreights?: InputMaybe<Array<UpdateShipmentExtraFreightByIdInput>>;
  updateShipmentFreights?: InputMaybe<Array<UpdateShipmentFreightByIdInput>>;
  updateShipments?: InputMaybe<Array<UpdateShipmentByIdInput>>;
  updateSingleEvents?: InputMaybe<Array<UpdateSingleEventByIdInput>>;
  updateVoyageCharterOrderFreights?: InputMaybe<Array<UpdateVoyageCharterOrderFreightByIdInput>>;
  updateVoyageCharterPortData?: InputMaybe<Array<UpdateVoyageCharterPortDatumByIdInput>>;
  updateVoyageCharterToContracts?: InputMaybe<Array<UpdateVoyageCharterToContractByIdInput>>;
  updateVoyageCharters?: InputMaybe<Array<UpdateVoyageCharterByIdInput>>;
};

export type CommitLog = Node & {
  __typename?: 'CommitLog';
  /** Reads a single `CommitLogScenario` that is related to this `CommitLog`. */
  commitLogScenarioByMasterClientId?: Maybe<CommitLogScenario>;
  /** Reads a single `CommitLogScenario` that is related to this `CommitLog`. */
  commitLogScenarioByScenarioClientId?: Maybe<CommitLogScenario>;
  committedAt: Scalars['Datetime']['output'];
  committedBy?: Maybe<Scalars['UserId']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['CommitLogId']['output'];
  input: Scalars['JSON']['output'];
  /** TRUE = merge, FALSE = replace */
  isMerge: Scalars['Boolean']['output'];
  masterClientId?: Maybe<Scalars['UUID']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CommitLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CommitLog`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
  /** Root organization from the current session */
  rootOrg?: Maybe<Scalars['OrganizationId']['output']>;
  scenarioCid?: Maybe<Scalars['UUID']['output']>;
  scenarioClientId?: Maybe<Scalars['UUID']['output']>;
  success: Scalars['Boolean']['output'];
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `CommitLog`. */
  userByCommittedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `CommitLog`. */
  userByModifiedByUserId?: Maybe<User>;
};

/**
 * A condition to be used against `CommitLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CommitLogCondition = {
  /** Checks for equality with the object’s `committedAt` field. */
  committedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `committedBy` field. */
  committedBy?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `errors` field. */
  errors?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CommitLogId']['input']>;
  /** Checks for equality with the object’s `input` field. */
  input?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `isMerge` field. */
  isMerge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `masterClientId` field. */
  masterClientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `payload` field. */
  payload?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `scenarioCid` field. */
  scenarioCid?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `scenarioClientId` field. */
  scenarioClientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `success` field. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `CommitLog` object types. All fields are combined with a logical ‘and.’ */
export type CommitLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CommitLogFilter>>;
  /** Filter by the object’s `committedAt` field. */
  committedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `committedBy` field. */
  committedBy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isMerge` field. */
  isMerge?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `masterClientId` field. */
  masterClientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CommitLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CommitLogFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `scenarioCid` field. */
  scenarioCid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scenarioClientId` field. */
  scenarioClientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `success` field. */
  success?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** A connection to a list of `CommitLogHistory` values. */
export type CommitLogHistoriesConnection = {
  __typename?: 'CommitLogHistoriesConnection';
  /** A list of edges which contains the `CommitLogHistory` and cursor to aid in pagination. */
  edges: Array<CommitLogHistoriesEdge>;
  /** A list of `CommitLogHistory` objects. */
  nodes: Array<Maybe<CommitLogHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CommitLogHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CommitLogHistory` edge in the connection. */
export type CommitLogHistoriesEdge = {
  __typename?: 'CommitLogHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CommitLogHistory` at the end of the edge. */
  node?: Maybe<CommitLogHistory>;
};

/** Methods to use when ordering `CommitLogHistory`. */
export enum CommitLogHistoriesOrderBy {
  COMMITTED_AT_ASC = 'COMMITTED_AT_ASC',
  COMMITTED_AT_DESC = 'COMMITTED_AT_DESC',
  COMMITTED_BY_ASC = 'COMMITTED_BY_ASC',
  COMMITTED_BY_DESC = 'COMMITTED_BY_DESC',
  ERRORS_ASC = 'ERRORS_ASC',
  ERRORS_DESC = 'ERRORS_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INPUT_ASC = 'INPUT_ASC',
  INPUT_DESC = 'INPUT_DESC',
  IS_MERGE_ASC = 'IS_MERGE_ASC',
  IS_MERGE_DESC = 'IS_MERGE_DESC',
  MASTER_CLIENT_ID_ASC = 'MASTER_CLIENT_ID_ASC',
  MASTER_CLIENT_ID_DESC = 'MASTER_CLIENT_ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PAYLOAD_ASC = 'PAYLOAD_ASC',
  PAYLOAD_DESC = 'PAYLOAD_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SCENARIO_CID_ASC = 'SCENARIO_CID_ASC',
  SCENARIO_CID_DESC = 'SCENARIO_CID_DESC',
  SCENARIO_CLIENT_ID_ASC = 'SCENARIO_CLIENT_ID_ASC',
  SCENARIO_CLIENT_ID_DESC = 'SCENARIO_CLIENT_ID_DESC',
  SUCCESS_ASC = 'SUCCESS_ASC',
  SUCCESS_DESC = 'SUCCESS_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC'
}

/** History log for this table */
export type CommitLogHistory = {
  __typename?: 'CommitLogHistory';
  committedAt: Scalars['Datetime']['output'];
  committedBy?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  input: Scalars['JSON']['output'];
  isMerge: Scalars['Boolean']['output'];
  masterClientId?: Maybe<Scalars['UUID']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['Int']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  scenarioCid?: Maybe<Scalars['UUID']['output']>;
  scenarioClientId?: Maybe<Scalars['UUID']['output']>;
  success: Scalars['Boolean']['output'];
  sysPeriod: DatetimeRange;
};

/**
 * A condition to be used against `CommitLogHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CommitLogHistoryCondition = {
  /** Checks for equality with the object’s `committedAt` field. */
  committedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `committedBy` field. */
  committedBy?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `errors` field. */
  errors?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `input` field. */
  input?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `isMerge` field. */
  isMerge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `masterClientId` field. */
  masterClientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `payload` field. */
  payload?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `scenarioCid` field. */
  scenarioCid?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `scenarioClientId` field. */
  scenarioClientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `success` field. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `CommitLogHistory` object types. All fields are combined with a logical ‘and.’ */
export type CommitLogHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CommitLogHistoryFilter>>;
  /** Filter by the object’s `committedAt` field. */
  committedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `committedBy` field. */
  committedBy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isMerge` field. */
  isMerge?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `masterClientId` field. */
  masterClientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CommitLogHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CommitLogHistoryFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `scenarioCid` field. */
  scenarioCid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `scenarioClientId` field. */
  scenarioClientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `success` field. */
  success?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

export type CommitLogScenario = Node & {
  __typename?: 'CommitLogScenario';
  clientId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `CommitLog`. */
  commitLogsByMasterClientId: CommitLogsConnection;
  /** Reads and enables pagination through a set of `CommitLog`. */
  commitLogsByScenarioClientId: CommitLogsConnection;
  dataSchemaVersion: Scalars['Int']['output'];
  id: Scalars['CommitLogScenarioId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `CommitLogScenario`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  scenarioData?: Maybe<Scalars['JSON']['output']>;
};


export type CommitLogScenarioCommitLogsByMasterClientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogCondition>;
  filter?: InputMaybe<CommitLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogsOrderBy>>;
};


export type CommitLogScenarioCommitLogsByScenarioClientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogCondition>;
  filter?: InputMaybe<CommitLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogsOrderBy>>;
};

/**
 * A condition to be used against `CommitLogScenario` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CommitLogScenarioCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `dataSchemaVersion` field. */
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CommitLogScenarioId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `scenarioData` field. */
  scenarioData?: InputMaybe<Scalars['JSON']['input']>;
};

/** A filter to be used against `CommitLogScenario` object types. All fields are combined with a logical ‘and.’ */
export type CommitLogScenarioFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CommitLogScenarioFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dataSchemaVersion` field. */
  dataSchemaVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CommitLogScenarioFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CommitLogScenarioFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CommitLogScenario` */
export type CommitLogScenarioInput = {
  clientId: Scalars['UUID']['input'];
  dataSchemaVersion: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  scenarioData?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `CommitLogScenario`. Fields that are set will be updated. */
export type CommitLogScenarioPatch = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  scenarioData?: InputMaybe<Scalars['JSON']['input']>;
};

export type CommitLogScenarioSubscriptionPayload = {
  __typename?: 'CommitLogScenarioSubscriptionPayload';
  commitLogScenario?: Maybe<CommitLogScenario>;
  event?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `CommitLogScenario` values. */
export type CommitLogScenariosConnection = {
  __typename?: 'CommitLogScenariosConnection';
  /** A list of edges which contains the `CommitLogScenario` and cursor to aid in pagination. */
  edges: Array<CommitLogScenariosEdge>;
  /** A list of `CommitLogScenario` objects. */
  nodes: Array<Maybe<CommitLogScenario>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CommitLogScenario` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CommitLogScenario` edge in the connection. */
export type CommitLogScenariosEdge = {
  __typename?: 'CommitLogScenariosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CommitLogScenario` at the end of the edge. */
  node?: Maybe<CommitLogScenario>;
};

/** Methods to use when ordering `CommitLogScenario`. */
export enum CommitLogScenariosOrderBy {
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  DATA_SCHEMA_VERSION_ASC = 'DATA_SCHEMA_VERSION_ASC',
  DATA_SCHEMA_VERSION_DESC = 'DATA_SCHEMA_VERSION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SCENARIO_DATA_ASC = 'SCENARIO_DATA_ASC',
  SCENARIO_DATA_DESC = 'SCENARIO_DATA_DESC'
}

export type CommitLogSubscriptionPayload = {
  __typename?: 'CommitLogSubscriptionPayload';
  commitLog?: Maybe<CommitLog>;
  event?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `CommitLog` values. */
export type CommitLogsConnection = {
  __typename?: 'CommitLogsConnection';
  /** A list of edges which contains the `CommitLog` and cursor to aid in pagination. */
  edges: Array<CommitLogsEdge>;
  /** A list of `CommitLog` objects. */
  nodes: Array<Maybe<CommitLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CommitLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CommitLog` edge in the connection. */
export type CommitLogsEdge = {
  __typename?: 'CommitLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CommitLog` at the end of the edge. */
  node?: Maybe<CommitLog>;
};

/** Methods to use when ordering `CommitLog`. */
export enum CommitLogsOrderBy {
  COMMITTED_AT_ASC = 'COMMITTED_AT_ASC',
  COMMITTED_AT_DESC = 'COMMITTED_AT_DESC',
  COMMITTED_BY_ASC = 'COMMITTED_BY_ASC',
  COMMITTED_BY_DESC = 'COMMITTED_BY_DESC',
  ERRORS_ASC = 'ERRORS_ASC',
  ERRORS_DESC = 'ERRORS_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INPUT_ASC = 'INPUT_ASC',
  INPUT_DESC = 'INPUT_DESC',
  IS_MERGE_ASC = 'IS_MERGE_ASC',
  IS_MERGE_DESC = 'IS_MERGE_DESC',
  MASTER_CLIENT_ID_ASC = 'MASTER_CLIENT_ID_ASC',
  MASTER_CLIENT_ID_DESC = 'MASTER_CLIENT_ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PAYLOAD_ASC = 'PAYLOAD_ASC',
  PAYLOAD_DESC = 'PAYLOAD_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SCENARIO_CID_ASC = 'SCENARIO_CID_ASC',
  SCENARIO_CID_DESC = 'SCENARIO_CID_DESC',
  SCENARIO_CLIENT_ID_ASC = 'SCENARIO_CLIENT_ID_ASC',
  SCENARIO_CLIENT_ID_DESC = 'SCENARIO_CLIENT_ID_DESC',
  SUCCESS_ASC = 'SUCCESS_ASC',
  SUCCESS_DESC = 'SUCCESS_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC'
}

export type CommitOrderAttributeAssociationInput = {
  orderAttributeId: Scalars['Int']['input'];
  orderId: CreatedOrExisting;
};

export type CommitOrderDetailInput = {
  cargoCount?: InputMaybe<Scalars['Int']['input']>;
  cargoDeckOption?: InputMaybe<CargoDeckOptionType>;
  cargoDepth?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoEquipmentCount?: InputMaybe<Scalars['Int']['input']>;
  cargoEquipmentId?: InputMaybe<Scalars['Int']['input']>;
  cargoHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoLengthUnitId?: InputMaybe<Scalars['Int']['input']>;
  cargoMaxUnitWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoPackageType?: InputMaybe<Scalars['String']['input']>;
  cargoPackingMethod?: InputMaybe<CargoPackingMethodType>;
  cargoWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoWeightUnitId?: InputMaybe<Scalars['Int']['input']>;
  cargoWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  closingDate?: InputMaybe<Scalars['Datetime']['input']>;
  commission?: InputMaybe<Scalars['BigFloat']['input']>;
  consignee?: InputMaybe<Scalars['String']['input']>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargePortAgentId?: InputMaybe<Scalars['Int']['input']>;
  externalRemarks?: InputMaybe<Scalars['String']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  fixtureNote?: InputMaybe<Scalars['String']['input']>;
  imoClass?: InputMaybe<ImoClass>;
  incoTerms?: InputMaybe<IncoTermsType>;
  linerTerms?: InputMaybe<Scalars['String']['input']>;
  loadPortAgentOrgId?: InputMaybe<Scalars['Int']['input']>;
  orderId: CreatedOrExisting;
  orderName?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<PaymentType>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  peymentTime?: InputMaybe<Scalars['Int']['input']>;
  receiverOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  senderOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  supplyContractId?: InputMaybe<Scalars['Int']['input']>;
};

export type CommitOrderPatch = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assortmentId?: InputMaybe<Scalars['Int']['input']>;
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  cargoAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoUnitId?: InputMaybe<Scalars['Int']['input']>;
  chartererOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  completed?: InputMaybe<Scalars['Datetime']['input']>;
  deliveredBefore?: InputMaybe<Scalars['Datetime']['input']>;
  dischargePortId?: InputMaybe<Scalars['Int']['input']>;
  dischargingDays?: InputMaybe<ShincShexInput>;
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingUnit?: InputMaybe<LoadingUnit>;
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightCurrency?: InputMaybe<Currency>;
  freightUnit?: InputMaybe<PaymentUnit>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  loadPortId?: InputMaybe<Scalars['Int']['input']>;
  loadingDays?: InputMaybe<ShincShexInput>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingUnit?: InputMaybe<LoadingUnit>;
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  marginUnit?: InputMaybe<MarginUnit>;
  nominatedVessel?: InputMaybe<Scalars['String']['input']>;
  numberOfPackages?: InputMaybe<Scalars['Int']['input']>;
  ownerOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  rta?: InputMaybe<Scalars['Datetime']['input']>;
  shipmentId?: InputMaybe<CreatedOrExisting>;
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  started?: InputMaybe<Scalars['Datetime']['input']>;
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  withoutGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommitOrderPortCallRelationInput = {
  isLoadPort: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
  portCallId: CreatedOrExisting;
};

export type CommitOrderRequirementAssociationInput = {
  orderId: CreatedOrExisting;
  specialRequirementId: Scalars['Int']['input'];
};

export type CommitOrderVoyageCharterRelationInput = {
  coaRouteId?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
  voyageCharterId: CreatedOrExisting;
};

export type CommitPayload = {
  __typename?: 'CommitPayload';
  committedAt: Scalars['Datetime']['output'];
  createdCargoCompartmentAllocations: Array<Ident>;
  createdHandledByCoas: Array<Ident>;
  createdHandledBySpots: Array<Ident>;
  createdOffHires: Array<Ident>;
  createdOrderPortCallRelations: Array<Ident>;
  createdOrderVoyageCharterRelations: Array<Ident>;
  createdPortCalls: Array<Ident>;
  createdPortNotices: Array<Ident>;
  createdScheduledOrders: Array<Ident>;
  createdShipmentExtraFreights: Array<IdentWithShipmentId>;
  createdShipmentFreights: Array<IdentWithShipmentId>;
  createdShipments: Array<Ident>;
  createdSingleEventPortCallRelations: Array<Ident>;
  createdSingleEvents: Array<Ident>;
  createdVoyageCharterOrderFreights: Array<Ident>;
  createdVoyageCharterPortData: Array<Ident>;
  createdVoyageCharterToContracts: Array<Ident>;
  createdVoyageCharters: Array<Ident>;
  deletedBillOfLadingData: Array<Ident>;
  deletedCargoCompartmentAllocations: Array<Ident>;
  deletedCargoMeasurements: Array<Ident>;
  deletedHandledByCoas: Array<Ident>;
  deletedHandledBySpots: Array<Ident>;
  deletedOffHires: Array<Ident>;
  deletedOrderPortCallRelations: Array<Ident>;
  deletedOrderVoyageCharterRelations: Array<Ident>;
  deletedPortCalls: Array<Ident>;
  deletedPortNotices: Array<Ident>;
  deletedScheduledOrders: Array<Ident>;
  deletedShipmentExtraFreights: Array<Ident>;
  deletedShipmentFreights: Array<Ident>;
  deletedSingleEventPortCallRelations: Array<Ident>;
  deletedSingleEvents: Array<Ident>;
  deletedVoyageCharterOrderFreights: Array<Ident>;
  deletedVoyageCharterPortData: Array<Ident>;
  deletedVoyageCharterToContracts: Array<Ident>;
  deletedVoyageCharters: Array<Ident>;
  success: Scalars['Boolean']['output'];
  updatedCargoCompartmentAllocations: Array<Ident>;
  updatedHandledByCoas: Array<Ident>;
  updatedHandledBySpots: Array<Ident>;
  updatedOffHires: Array<Ident>;
  updatedOrders: Array<Ident>;
  updatedPortCalls: Array<Ident>;
  updatedScheduledOrders: Array<Ident>;
  updatedShipmentExtraFreights: Array<Ident>;
  updatedShipmentFreights: Array<Ident>;
  updatedShipments: Array<Ident>;
  updatedSingleEvents: Array<Ident>;
  updatedVoyageCharterOrderFreights: Array<Ident>;
  updatedVoyageCharterPortData: Array<Ident>;
  updatedVoyageCharterToContracts: Array<Ident>;
  updatedVoyageCharters: Array<Ident>;
};

export type CommitPortNoticeInput = {
  ataBerth?: InputMaybe<Scalars['Datetime']['input']>;
  ataPbp?: InputMaybe<Scalars['Datetime']['input']>;
  berthingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  eta?: InputMaybe<Scalars['Datetime']['input']>;
  etaNextPort?: InputMaybe<Scalars['Datetime']['input']>;
  etcBunkers?: InputMaybe<Scalars['Datetime']['input']>;
  etcTerminal?: InputMaybe<Scalars['Datetime']['input']>;
  etdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  loadingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  norTendered?: InputMaybe<Scalars['Datetime']['input']>;
  portCallId: CreatedOrExisting;
  rtaBerth?: InputMaybe<Scalars['Datetime']['input']>;
  rtaPbp?: InputMaybe<Scalars['Datetime']['input']>;
  rtdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['Int']['input'];
};

export type CommitShipmentExtraFreightInput = {
  clientId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  freightAmount: Scalars['BigFloat']['input'];
  freightUnit: PaymentUnit;
  name?: InputMaybe<Scalars['String']['input']>;
  shipmentId: CreatedOrExisting;
};

export type CommitShipmentFreightInput = {
  clientId: Scalars['UUID']['input'];
  freightAmount: Scalars['BigFloat']['input'];
  freightUnit: PaymentUnit;
  shipmentId: CreatedOrExisting;
};

export type CommitSingleEventPortCallRelationInput = {
  portCallId: CreatedOrExisting;
  singleEventId: CreatedOrExisting;
};

export type CommitSubscriptionPayload = {
  __typename?: 'CommitSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
};

export type CommitUpdateOrderByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  orderPatch: CommitOrderPatch;
};

export type CommitVcOrderVoyageCharterRelationInput = {
  coaRouteId?: InputMaybe<Scalars['Int']['input']>;
  orderId: CreatedOrExisting;
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
  voyageCharterId: CreatedOrExisting;
};

export type CommitVcVoyageCharterPortDatumInput = {
  portDataId: CreatedOrExisting;
  voyageCharterId: CreatedOrExisting;
};

export type CommitVoyageCharterExtraCostInput = {
  amount: Scalars['BigFloat']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  type?: InputMaybe<VoyageCharterCostType>;
  voyageCharterId: CreatedOrExisting;
};

export type CommitVoyageCharterExtraFreightInput = {
  amount: Scalars['BigFloat']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['Datetime']['input']>;
  externalUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  ignoreInPnl?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  type?: InputMaybe<FreightType>;
  voyageCharterId: CreatedOrExisting;
};

export type CommitVoyageCharterOrderFreightInput = {
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightUnit?: InputMaybe<PaymentUnit>;
  orderVoyageCharterRelationId: CreatedOrExisting;
};

export type CommitVoyageCharterPortDatumInput = {
  portDataId: Scalars['Int']['input'];
  voyageCharterId: CreatedOrExisting;
};

export type CommitVoyageCharterToContractInput = {
  coaId?: InputMaybe<Scalars['Int']['input']>;
  spotNegotiationId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
  voyageCharterId: CreatedOrExisting;
};

export type CommodityGroupMappingResult = {
  __typename?: 'CommodityGroupMappingResult';
  status?: Maybe<Scalars['String']['output']>;
};

export type CostSplitOnScheduledOrder = Node & {
  __typename?: 'CostSplitOnScheduledOrder';
  /** Reads a single `ActualCost` that is related to this `CostSplitOnScheduledOrder`. */
  actualCostByActualCostId?: Maybe<ActualCost>;
  actualCostId: Scalars['ActualCostId']['output'];
  amount: Scalars['BigFloat']['output'];
  id: Scalars['CostSplitOnScheduledOrderId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `ScheduledOrder` that is related to this `CostSplitOnScheduledOrder`. */
  scheduledOrderByScheduledOrderId?: Maybe<ScheduledOrder>;
  scheduledOrderId: Scalars['ScheduledOrderId']['output'];
};

/**
 * A condition to be used against `CostSplitOnScheduledOrder` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CostSplitOnScheduledOrderCondition = {
  /** Checks for equality with the object’s `actualCostId` field. */
  actualCostId?: InputMaybe<Scalars['ActualCostId']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CostSplitOnScheduledOrderId']['input']>;
  /** Checks for equality with the object’s `scheduledOrderId` field. */
  scheduledOrderId?: InputMaybe<Scalars['ScheduledOrderId']['input']>;
};

/** A filter to be used against `CostSplitOnScheduledOrder` object types. All fields are combined with a logical ‘and.’ */
export type CostSplitOnScheduledOrderFilter = {
  /** Filter by the object’s `actualCostId` field. */
  actualCostId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CostSplitOnScheduledOrderFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CostSplitOnScheduledOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CostSplitOnScheduledOrderFilter>>;
  /** Filter by the object’s `scheduledOrderId` field. */
  scheduledOrderId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CostSplitOnScheduledOrder` */
export type CostSplitOnScheduledOrderInput = {
  actualCostId: Scalars['ActualCostId']['input'];
  amount: Scalars['BigFloat']['input'];
  scheduledOrderId: Scalars['ScheduledOrderId']['input'];
};

/** Represents an update to a `CostSplitOnScheduledOrder`. Fields that are set will be updated. */
export type CostSplitOnScheduledOrderPatch = {
  actualCostId?: InputMaybe<Scalars['ActualCostId']['input']>;
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  scheduledOrderId?: InputMaybe<Scalars['ScheduledOrderId']['input']>;
};

/** A connection to a list of `CostSplitOnScheduledOrder` values. */
export type CostSplitOnScheduledOrdersConnection = {
  __typename?: 'CostSplitOnScheduledOrdersConnection';
  /** A list of edges which contains the `CostSplitOnScheduledOrder` and cursor to aid in pagination. */
  edges: Array<CostSplitOnScheduledOrdersEdge>;
  /** A list of `CostSplitOnScheduledOrder` objects. */
  nodes: Array<Maybe<CostSplitOnScheduledOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CostSplitOnScheduledOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CostSplitOnScheduledOrder` edge in the connection. */
export type CostSplitOnScheduledOrdersEdge = {
  __typename?: 'CostSplitOnScheduledOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CostSplitOnScheduledOrder` at the end of the edge. */
  node?: Maybe<CostSplitOnScheduledOrder>;
};

/** Methods to use when ordering `CostSplitOnScheduledOrder`. */
export enum CostSplitOnScheduledOrdersOrderBy {
  ACTUAL_COST_ID_ASC = 'ACTUAL_COST_ID_ASC',
  ACTUAL_COST_ID_DESC = 'ACTUAL_COST_ID_DESC',
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SCHEDULED_ORDER_ID_ASC = 'SCHEDULED_ORDER_ID_ASC',
  SCHEDULED_ORDER_ID_DESC = 'SCHEDULED_ORDER_ID_DESC'
}

export type CostSplitOnSingleEvent = Node & {
  __typename?: 'CostSplitOnSingleEvent';
  /** Reads a single `ActualCost` that is related to this `CostSplitOnSingleEvent`. */
  actualCostByActualCostId?: Maybe<ActualCost>;
  actualCostId: Scalars['ActualCostId']['output'];
  amount: Scalars['BigFloat']['output'];
  id: Scalars['CostSplitOnSingleEventId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `SingleEvent` that is related to this `CostSplitOnSingleEvent`. */
  singleEventBySingleEventId?: Maybe<SingleEvent>;
  singleEventId: Scalars['SingleEventId']['output'];
};

/**
 * A condition to be used against `CostSplitOnSingleEvent` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CostSplitOnSingleEventCondition = {
  /** Checks for equality with the object’s `actualCostId` field. */
  actualCostId?: InputMaybe<Scalars['ActualCostId']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CostSplitOnSingleEventId']['input']>;
  /** Checks for equality with the object’s `singleEventId` field. */
  singleEventId?: InputMaybe<Scalars['SingleEventId']['input']>;
};

/** A filter to be used against `CostSplitOnSingleEvent` object types. All fields are combined with a logical ‘and.’ */
export type CostSplitOnSingleEventFilter = {
  /** Filter by the object’s `actualCostId` field. */
  actualCostId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CostSplitOnSingleEventFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CostSplitOnSingleEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CostSplitOnSingleEventFilter>>;
  /** Filter by the object’s `singleEventId` field. */
  singleEventId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CostSplitOnSingleEvent` */
export type CostSplitOnSingleEventInput = {
  actualCostId: Scalars['ActualCostId']['input'];
  amount: Scalars['BigFloat']['input'];
  singleEventId: Scalars['SingleEventId']['input'];
};

/** Represents an update to a `CostSplitOnSingleEvent`. Fields that are set will be updated. */
export type CostSplitOnSingleEventPatch = {
  actualCostId?: InputMaybe<Scalars['ActualCostId']['input']>;
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  singleEventId?: InputMaybe<Scalars['SingleEventId']['input']>;
};

/** A connection to a list of `CostSplitOnSingleEvent` values. */
export type CostSplitOnSingleEventsConnection = {
  __typename?: 'CostSplitOnSingleEventsConnection';
  /** A list of edges which contains the `CostSplitOnSingleEvent` and cursor to aid in pagination. */
  edges: Array<CostSplitOnSingleEventsEdge>;
  /** A list of `CostSplitOnSingleEvent` objects. */
  nodes: Array<Maybe<CostSplitOnSingleEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CostSplitOnSingleEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CostSplitOnSingleEvent` edge in the connection. */
export type CostSplitOnSingleEventsEdge = {
  __typename?: 'CostSplitOnSingleEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CostSplitOnSingleEvent` at the end of the edge. */
  node?: Maybe<CostSplitOnSingleEvent>;
};

/** Methods to use when ordering `CostSplitOnSingleEvent`. */
export enum CostSplitOnSingleEventsOrderBy {
  ACTUAL_COST_ID_ASC = 'ACTUAL_COST_ID_ASC',
  ACTUAL_COST_ID_DESC = 'ACTUAL_COST_ID_DESC',
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SINGLE_EVENT_ID_ASC = 'SINGLE_EVENT_ID_ASC',
  SINGLE_EVENT_ID_DESC = 'SINGLE_EVENT_ID_DESC'
}

export enum CostType {
  BAF = 'BAF',
  DEADFREIGHT = 'DEADFREIGHT',
  DEMURRAGE = 'DEMURRAGE',
  FREIGHT = 'FREIGHT',
  OTHER = 'OTHER',
  SHIFTING = 'SHIFTING'
}

/** A filter to be used against CostType fields. All fields are combined with a logical ‘and.’ */
export type CostTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CostType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CostType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CostType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CostType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CostType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CostType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CostType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CostType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CostType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CostType>>;
};

/** A connection to a list of `Country` values. */
export type CountriesConnection = {
  __typename?: 'CountriesConnection';
  /** A list of edges which contains the `Country` and cursor to aid in pagination. */
  edges: Array<CountriesEdge>;
  /** A list of `Country` objects. */
  nodes: Array<Maybe<Country>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Country` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Country` edge in the connection. */
export type CountriesEdge = {
  __typename?: 'CountriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Country` at the end of the edge. */
  node?: Maybe<Country>;
};

/** Methods to use when ordering `Country`. */
export enum CountriesOrderBy {
  ALPHA2_ASC = 'ALPHA2_ASC',
  ALPHA2_DESC = 'ALPHA2_DESC',
  ALPHA3_ASC = 'ALPHA3_ASC',
  ALPHA3_DESC = 'ALPHA3_DESC',
  ENGLISH_ASC = 'ENGLISH_ASC',
  ENGLISH_DESC = 'ENGLISH_DESC',
  FRENCH_ASC = 'FRENCH_ASC',
  FRENCH_DESC = 'FRENCH_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  NUMERIC_ASC = 'NUMERIC_ASC',
  NUMERIC_DESC = 'NUMERIC_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type Country = Node & {
  __typename?: 'Country';
  alpha2?: Maybe<Scalars['String']['output']>;
  alpha3?: Maybe<Scalars['String']['output']>;
  english?: Maybe<Scalars['String']['output']>;
  french?: Maybe<Scalars['String']['output']>;
  id: Scalars['CountryId']['output'];
  /** Reads and enables pagination through a set of `Location`. */
  locationsByCountryId: LocationsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  numeric?: Maybe<Scalars['Int']['output']>;
};


export type CountryLocationsByCountryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** A condition to be used against `Country` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CountryCondition = {
  /** Checks for equality with the object’s `alpha2` field. */
  alpha2?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `alpha3` field. */
  alpha3?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `english` field. */
  english?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `french` field. */
  french?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['CountryId']['input']>;
  /** Checks for equality with the object’s `numeric` field. */
  numeric?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Country` object types. All fields are combined with a logical ‘and.’ */
export type CountryFilter = {
  /** Filter by the object’s `alpha2` field. */
  alpha2?: InputMaybe<StringFilter>;
  /** Filter by the object’s `alpha3` field. */
  alpha3?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CountryFilter>>;
  /** Filter by the object’s `english` field. */
  english?: InputMaybe<StringFilter>;
  /** Filter by the object’s `french` field. */
  french?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CountryFilter>;
  /** Filter by the object’s `numeric` field. */
  numeric?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CountryFilter>>;
};

/** An input for mutations affecting `Country` */
export type CountryInput = {
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  english?: InputMaybe<Scalars['String']['input']>;
  french?: InputMaybe<Scalars['String']['input']>;
  numeric?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `Country`. Fields that are set will be updated. */
export type CountryPatch = {
  alpha2?: InputMaybe<Scalars['String']['input']>;
  alpha3?: InputMaybe<Scalars['String']['input']>;
  english?: InputMaybe<Scalars['String']['input']>;
  french?: InputMaybe<Scalars['String']['input']>;
  numeric?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the create `ActualCost` mutation. */
export type CreateActualCostInput = {
  /** The `ActualCost` to be created by this mutation. */
  actualCost: ActualCostInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ActualCost` mutation. */
export type CreateActualCostPayload = {
  __typename?: 'CreateActualCostPayload';
  /** The `ActualCost` that was created by this mutation. */
  actualCost?: Maybe<ActualCost>;
  /** An edge for our `ActualCost`. May be used by Relay 1. */
  actualCostEdge?: Maybe<ActualCostsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `ActualCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our create `ActualCost` mutation. */
export type CreateActualCostPayloadActualCostEdgeArgs = {
  orderBy?: InputMaybe<Array<ActualCostsOrderBy>>;
};

/** All input for the create `ApiCoaContract` mutation. */
export type CreateApiCoaContractInput = {
  /** The `ApiCoaContract` to be created by this mutation. */
  apiCoaContract: ApiCoaContractInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ApiCoaContract` mutation. */
export type CreateApiCoaContractPayload = {
  __typename?: 'CreateApiCoaContractPayload';
  /** The `ApiCoaContract` that was created by this mutation. */
  apiCoaContract?: Maybe<ApiCoaContract>;
  /** An edge for our `ApiCoaContract`. May be used by Relay 1. */
  apiCoaContractEdge?: Maybe<ApiCoaContractsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ApiCoaContract` mutation. */
export type CreateApiCoaContractPayloadApiCoaContractEdgeArgs = {
  orderBy?: InputMaybe<Array<ApiCoaContractsOrderBy>>;
};

/** All input for the create `ApiLocation` mutation. */
export type CreateApiLocationInput = {
  /** The `ApiLocation` to be created by this mutation. */
  apiLocation: ApiLocationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ApiLocation` mutation. */
export type CreateApiLocationPayload = {
  __typename?: 'CreateApiLocationPayload';
  /** The `ApiLocation` that was created by this mutation. */
  apiLocation?: Maybe<ApiLocation>;
  /** An edge for our `ApiLocation`. May be used by Relay 1. */
  apiLocationEdge?: Maybe<ApiLocationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ApiLocation` mutation. */
export type CreateApiLocationPayloadApiLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ApiLocationsOrderBy>>;
};

/** All input for the create `ApiOrders` mutation. */
export type CreateApiOrdersInput = {
  /** The `ApiOrders` to be created by this mutation. */
  apiOrders: Array<ApiOrderInput>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the create `ApiOrdersNotice` mutation. */
export type CreateApiOrdersNoticeInput = {
  /** The `ApiOrdersNotice` to be created by this mutation. */
  apiOrdersNotice: ApiOrdersNoticeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ApiOrdersNotice` mutation. */
export type CreateApiOrdersNoticePayload = {
  __typename?: 'CreateApiOrdersNoticePayload';
  /** The `ApiOrdersNotice` that was created by this mutation. */
  apiOrdersNotice?: Maybe<ApiOrdersNotice>;
  /** An edge for our `ApiOrdersNotice`. May be used by Relay 1. */
  apiOrdersNoticeEdge?: Maybe<ApiOrdersNoticesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `ApiOrdersNotice`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `ApiOrdersNotice`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ApiOrdersNotice` mutation. */
export type CreateApiOrdersNoticePayloadApiOrdersNoticeEdgeArgs = {
  orderBy?: InputMaybe<Array<ApiOrdersNoticesOrderBy>>;
};

/** The output of our create `ApiOrder` mutation. */
export type CreateApiOrdersPayload = {
  __typename?: 'CreateApiOrdersPayload';
  /** The `ApiOrder` that was created by this mutation. */
  apiOrders: Array<Maybe<ApiOrder>>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `ApiShip` mutation. */
export type CreateApiShipInput = {
  /** The `ApiShip` to be created by this mutation. */
  apiShip: ApiShipInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ApiShip` mutation. */
export type CreateApiShipPayload = {
  __typename?: 'CreateApiShipPayload';
  /** The `ApiShip` that was created by this mutation. */
  apiShip?: Maybe<ApiShip>;
  /** An edge for our `ApiShip`. May be used by Relay 1. */
  apiShipEdge?: Maybe<ApiShipsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ApiShip` mutation. */
export type CreateApiShipPayloadApiShipEdgeArgs = {
  orderBy?: InputMaybe<Array<ApiShipsOrderBy>>;
};

/** All input for the create `ApiShipmentStatus` mutation. */
export type CreateApiShipmentStatusInput = {
  /** The `ApiShipmentStatus` to be created by this mutation. */
  apiShipmentStatus: ApiShipmentStatusInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ApiShipmentStatus` mutation. */
export type CreateApiShipmentStatusPayload = {
  __typename?: 'CreateApiShipmentStatusPayload';
  /** The `ApiShipmentStatus` that was created by this mutation. */
  apiShipmentStatus?: Maybe<ApiShipmentStatus>;
  /** An edge for our `ApiShipmentStatus`. May be used by Relay 1. */
  apiShipmentStatusEdge?: Maybe<ApiShipmentStatusesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ApiShipmentStatus` mutation. */
export type CreateApiShipmentStatusPayloadApiShipmentStatusEdgeArgs = {
  orderBy?: InputMaybe<Array<ApiShipmentStatusesOrderBy>>;
};

/** All input for the create `AssortmentExclusion` mutation. */
export type CreateAssortmentExclusionInput = {
  /** The `AssortmentExclusion` to be created by this mutation. */
  assortmentExclusion: AssortmentExclusionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AssortmentExclusion` mutation. */
export type CreateAssortmentExclusionPayload = {
  __typename?: 'CreateAssortmentExclusionPayload';
  /** Reads a single `Assortment` that is related to this `AssortmentExclusion`. */
  assortmentByNextAssortment?: Maybe<Assortment>;
  /** Reads a single `Assortment` that is related to this `AssortmentExclusion`. */
  assortmentByPreviousAssortment?: Maybe<Assortment>;
  /** The `AssortmentExclusion` that was created by this mutation. */
  assortmentExclusion?: Maybe<AssortmentExclusion>;
  /** An edge for our `AssortmentExclusion`. May be used by Relay 1. */
  assortmentExclusionEdge?: Maybe<AssortmentExclusionsEdge>;
  /** Reads a single `AssortmentGroup` that is related to this `AssortmentExclusion`. */
  assortmentGroupByNextAssortmentGroup?: Maybe<AssortmentGroup>;
  /** Reads a single `AssortmentGroup` that is related to this `AssortmentExclusion`. */
  assortmentGroupByPreviousAssortmentGroup?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VesselAttribute` that is related to this `AssortmentExclusion`. */
  vesselAttributeByVesselCostClassId?: Maybe<VesselAttribute>;
};


/** The output of our create `AssortmentExclusion` mutation. */
export type CreateAssortmentExclusionPayloadAssortmentExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};

/** All input for the create `AssortmentGroup` mutation. */
export type CreateAssortmentGroupInput = {
  /** The `AssortmentGroup` to be created by this mutation. */
  assortmentGroup: AssortmentGroupInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AssortmentGroup` mutation. */
export type CreateAssortmentGroupPayload = {
  __typename?: 'CreateAssortmentGroupPayload';
  /** The `AssortmentGroup` that was created by this mutation. */
  assortmentGroup?: Maybe<AssortmentGroup>;
  /** An edge for our `AssortmentGroup`. May be used by Relay 1. */
  assortmentGroupEdge?: Maybe<AssortmentGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `AssortmentGroup`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `AssortmentGroup`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `AssortmentGroup` mutation. */
export type CreateAssortmentGroupPayloadAssortmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentGroupsOrderBy>>;
};

/** All input for the create `Assortment` mutation. */
export type CreateAssortmentInput = {
  /** The `Assortment` to be created by this mutation. */
  assortment: AssortmentInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Assortment` mutation. */
export type CreateAssortmentPayload = {
  __typename?: 'CreateAssortmentPayload';
  /** The `Assortment` that was created by this mutation. */
  assortment?: Maybe<Assortment>;
  /** An edge for our `Assortment`. May be used by Relay 1. */
  assortmentEdge?: Maybe<AssortmentsEdge>;
  /** Reads a single `AssortmentGroup` that is related to this `Assortment`. */
  assortmentGroupByAssortmentGroup?: Maybe<AssortmentGroup>;
  /** Reads a single `CargoUnit` that is related to this `Assortment`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Assortment`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Assortment` mutation. */
export type CreateAssortmentPayloadAssortmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};

/** All input for the create `BatchUpdate` mutation. */
export type CreateBatchUpdateInput = {
  /** The `BatchUpdate` to be created by this mutation. */
  batchUpdate: BatchUpdateInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BatchUpdate` mutation. */
export type CreateBatchUpdatePayload = {
  __typename?: 'CreateBatchUpdatePayload';
  /** The `BatchUpdate` that was created by this mutation. */
  batchUpdate?: Maybe<BatchUpdate>;
  /** An edge for our `BatchUpdate`. May be used by Relay 1. */
  batchUpdateEdge?: Maybe<BatchUpdatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BatchUpdate`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BatchUpdate` mutation. */
export type CreateBatchUpdatePayloadBatchUpdateEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchUpdatesOrderBy>>;
};

/** All input for the create `BillOfLadingDatum` mutation. */
export type CreateBillOfLadingDatumInput = {
  /** The `BillOfLadingDatum` to be created by this mutation. */
  billOfLadingDatum: BillOfLadingDatumInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BillOfLadingDatum` mutation. */
export type CreateBillOfLadingDatumPayload = {
  __typename?: 'CreateBillOfLadingDatumPayload';
  /** Reads a single `BillOfLading` that is related to this `BillOfLadingDatum`. */
  billOfLadingByBillOfLadingId?: Maybe<BillOfLading>;
  /** The `BillOfLadingDatum` that was created by this mutation. */
  billOfLadingDatum?: Maybe<BillOfLadingDatum>;
  /** An edge for our `BillOfLadingDatum`. May be used by Relay 1. */
  billOfLadingDatumEdge?: Maybe<BillOfLadingDataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `BillOfLadingDatum`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BillOfLadingDatum` mutation. */
export type CreateBillOfLadingDatumPayloadBillOfLadingDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<BillOfLadingDataOrderBy>>;
};

/** All input for the create `BillOfLading` mutation. */
export type CreateBillOfLadingInput = {
  /** The `BillOfLading` to be created by this mutation. */
  billOfLading: BillOfLadingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BillOfLading` mutation. */
export type CreateBillOfLadingPayload = {
  __typename?: 'CreateBillOfLadingPayload';
  /** The `BillOfLading` that was created by this mutation. */
  billOfLading?: Maybe<BillOfLading>;
  /** An edge for our `BillOfLading`. May be used by Relay 1. */
  billOfLadingEdge?: Maybe<BillOfLadingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BillOfLading`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `BillOfLading`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `BillOfLading`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `BillOfLading`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our create `BillOfLading` mutation. */
export type CreateBillOfLadingPayloadBillOfLadingEdgeArgs = {
  orderBy?: InputMaybe<Array<BillOfLadingsOrderBy>>;
};

/** All input for the create `BunkerGradeCalculation` mutation. */
export type CreateBunkerGradeCalculationInput = {
  /** The `BunkerGradeCalculation` to be created by this mutation. */
  bunkerGradeCalculation: BunkerGradeCalculationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BunkerGradeCalculation` mutation. */
export type CreateBunkerGradeCalculationPayload = {
  __typename?: 'CreateBunkerGradeCalculationPayload';
  /** The `BunkerGradeCalculation` that was created by this mutation. */
  bunkerGradeCalculation?: Maybe<BunkerGradeCalculation>;
  /** An edge for our `BunkerGradeCalculation`. May be used by Relay 1. */
  bunkerGradeCalculationEdge?: Maybe<BunkerGradeCalculationsEdge>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeCalculation`. */
  bunkerGradeOverrideByFromGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeCalculation`. */
  bunkerGradeOverrideByToGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeCalculation`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BunkerGradeCalculation` mutation. */
export type CreateBunkerGradeCalculationPayloadBunkerGradeCalculationEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeCalculationsOrderBy>>;
};

/** All input for the create `BunkerGradeMapping` mutation. */
export type CreateBunkerGradeMappingInput = {
  /** The `BunkerGradeMapping` to be created by this mutation. */
  bunkerGradeMapping: BunkerGradeMappingInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BunkerGradeMapping` mutation. */
export type CreateBunkerGradeMappingPayload = {
  __typename?: 'CreateBunkerGradeMappingPayload';
  /** The `BunkerGradeMapping` that was created by this mutation. */
  bunkerGradeMapping?: Maybe<BunkerGradeMapping>;
  /** An edge for our `BunkerGradeMapping`. May be used by Relay 1. */
  bunkerGradeMappingEdge?: Maybe<BunkerGradeMappingsEdge>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeMapping`. */
  bunkerGradeOverrideByFromGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeMapping`. */
  bunkerGradeOverrideByToGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeMapping`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BunkerGradeMapping` mutation. */
export type CreateBunkerGradeMappingPayloadBunkerGradeMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeMappingsOrderBy>>;
};

/** All input for the create `BunkerGradeOverride` mutation. */
export type CreateBunkerGradeOverrideInput = {
  /** The `BunkerGradeOverride` to be created by this mutation. */
  bunkerGradeOverride: BunkerGradeOverrideInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BunkerGradeOverride` mutation. */
export type CreateBunkerGradeOverridePayload = {
  __typename?: 'CreateBunkerGradeOverridePayload';
  /** The `BunkerGradeOverride` that was created by this mutation. */
  bunkerGradeOverride?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeOverride`. */
  bunkerGradeOverrideByBlendComponent1Id?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeOverride`. */
  bunkerGradeOverrideByBlendComponent2Id?: Maybe<BunkerGradeOverride>;
  /** An edge for our `BunkerGradeOverride`. May be used by Relay 1. */
  bunkerGradeOverrideEdge?: Maybe<BunkerGradeOverridesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeOverride`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `BunkerGradeOverride`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `BunkerGradeOverride`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our create `BunkerGradeOverride` mutation. */
export type CreateBunkerGradeOverridePayloadBunkerGradeOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};

/** All input for the create `Bunkering` mutation. */
export type CreateBunkeringInput = {
  /** The `Bunkering` to be created by this mutation. */
  bunkering: BunkeringInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Bunkering` mutation. */
export type CreateBunkeringPayload = {
  __typename?: 'CreateBunkeringPayload';
  /** The `Bunkering` that was created by this mutation. */
  bunkering?: Maybe<Bunkering>;
  /** An edge for our `Bunkering`. May be used by Relay 1. */
  bunkeringEdge?: Maybe<BunkeringsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `Bunkering`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Bunkering`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `Bunkering`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `Bunkering`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Bunkering` mutation. */
export type CreateBunkeringPayloadBunkeringEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkeringsOrderBy>>;
};

/** All input for the create `CarbonPriceOverride` mutation. */
export type CreateCarbonPriceOverrideInput = {
  /** The `CarbonPriceOverride` to be created by this mutation. */
  carbonPriceOverride: CarbonPriceOverrideInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CarbonPriceOverride` mutation. */
export type CreateCarbonPriceOverridePayload = {
  __typename?: 'CreateCarbonPriceOverridePayload';
  /** The `CarbonPriceOverride` that was created by this mutation. */
  carbonPriceOverride?: Maybe<CarbonPriceOverride>;
  /** An edge for our `CarbonPriceOverride`. May be used by Relay 1. */
  carbonPriceOverrideEdge?: Maybe<CarbonPriceOverridesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `CarbonPriceOverride`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CarbonPriceOverride` mutation. */
export type CreateCarbonPriceOverridePayloadCarbonPriceOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<CarbonPriceOverridesOrderBy>>;
};

/** All input for the create `CargoCompartmentAllocation` mutation. */
export type CreateCargoCompartmentAllocationInput = {
  /** The `CargoCompartmentAllocation` to be created by this mutation. */
  cargoCompartmentAllocation: CargoCompartmentAllocationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoCompartmentAllocation` mutation. */
export type CreateCargoCompartmentAllocationPayload = {
  __typename?: 'CreateCargoCompartmentAllocationPayload';
  /** The `CargoCompartmentAllocation` that was created by this mutation. */
  cargoCompartmentAllocation?: Maybe<CargoCompartmentAllocation>;
  /** An edge for our `CargoCompartmentAllocation`. May be used by Relay 1. */
  cargoCompartmentAllocationEdge?: Maybe<CargoCompartmentAllocationsEdge>;
  /** Reads a single `CargoCompartment` that is related to this `CargoCompartmentAllocation`. */
  cargoCompartmentByCompartmentId?: Maybe<CargoCompartment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `CargoCompartmentAllocation`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `CargoCompartmentAllocation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledOrder` that is related to this `CargoCompartmentAllocation`. */
  scheduledOrderByScheduledOrderClientId?: Maybe<ScheduledOrder>;
  /** Reads a single `ScheduledOrder` that is related to this `CargoCompartmentAllocation`. */
  scheduledOrderByScheduledOrderId?: Maybe<ScheduledOrder>;
};


/** The output of our create `CargoCompartmentAllocation` mutation. */
export type CreateCargoCompartmentAllocationPayloadCargoCompartmentAllocationEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};

/** All input for the create `CargoCompartment` mutation. */
export type CreateCargoCompartmentInput = {
  /** The `CargoCompartment` to be created by this mutation. */
  cargoCompartment: CargoCompartmentInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoCompartment` mutation. */
export type CreateCargoCompartmentPayload = {
  __typename?: 'CreateCargoCompartmentPayload';
  /** The `CargoCompartment` that was created by this mutation. */
  cargoCompartment?: Maybe<CargoCompartment>;
  /** An edge for our `CargoCompartment`. May be used by Relay 1. */
  cargoCompartmentEdge?: Maybe<CargoCompartmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `CargoCompartment`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CargoCompartment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CargoCompartment`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `CargoCompartment`. */
  userByAdminUserId?: Maybe<User>;
  /** Reads a single `VesselInfo` that is related to this `CargoCompartment`. */
  vesselInfoByVesselId?: Maybe<VesselInfo>;
};


/** The output of our create `CargoCompartment` mutation. */
export type CreateCargoCompartmentPayloadCargoCompartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};

/** All input for the create `CargoEquipment` mutation. */
export type CreateCargoEquipmentInput = {
  /** The `CargoEquipment` to be created by this mutation. */
  cargoEquipment: CargoEquipmentInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoEquipment` mutation. */
export type CreateCargoEquipmentPayload = {
  __typename?: 'CreateCargoEquipmentPayload';
  /** The `CargoEquipment` that was created by this mutation. */
  cargoEquipment?: Maybe<CargoEquipment>;
  /** An edge for our `CargoEquipment`. May be used by Relay 1. */
  cargoEquipmentEdge?: Maybe<CargoEquipmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CargoEquipment` mutation. */
export type CreateCargoEquipmentPayloadCargoEquipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoEquipmentsOrderBy>>;
};

/** All input for the create `CargoExclusion` mutation. */
export type CreateCargoExclusionInput = {
  /** The `CargoExclusion` to be created by this mutation. */
  cargoExclusion: CargoExclusionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoExclusion` mutation. */
export type CreateCargoExclusionPayload = {
  __typename?: 'CreateCargoExclusionPayload';
  /** Reads a single `Assortment` that is related to this `CargoExclusion`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `CargoExclusion`. */
  assortmentGroupByAssortmentGroup?: Maybe<AssortmentGroup>;
  /** The `CargoExclusion` that was created by this mutation. */
  cargoExclusion?: Maybe<CargoExclusion>;
  /** An edge for our `CargoExclusion`. May be used by Relay 1. */
  cargoExclusionEdge?: Maybe<CargoExclusionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `CargoExclusion`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CargoExclusion` mutation. */
export type CreateCargoExclusionPayloadCargoExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoExclusionsOrderBy>>;
};

/** All input for the create `CargoLengthUnit` mutation. */
export type CreateCargoLengthUnitInput = {
  /** The `CargoLengthUnit` to be created by this mutation. */
  cargoLengthUnit: CargoLengthUnitInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoLengthUnit` mutation. */
export type CreateCargoLengthUnitPayload = {
  __typename?: 'CreateCargoLengthUnitPayload';
  /** The `CargoLengthUnit` that was created by this mutation. */
  cargoLengthUnit?: Maybe<CargoLengthUnit>;
  /** An edge for our `CargoLengthUnit`. May be used by Relay 1. */
  cargoLengthUnitEdge?: Maybe<CargoLengthUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CargoLengthUnit` mutation. */
export type CreateCargoLengthUnitPayloadCargoLengthUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoLengthUnitsOrderBy>>;
};

/** All input for the create `CargoMeasurement` mutation. */
export type CreateCargoMeasurementInput = {
  /** The `CargoMeasurement` to be created by this mutation. */
  cargoMeasurement: CargoMeasurementInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoMeasurement` mutation. */
export type CreateCargoMeasurementPayload = {
  __typename?: 'CreateCargoMeasurementPayload';
  /** The `CargoMeasurement` that was created by this mutation. */
  cargoMeasurement?: Maybe<CargoMeasurement>;
  /** An edge for our `CargoMeasurement`. May be used by Relay 1. */
  cargoMeasurementEdge?: Maybe<CargoMeasurementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `CargoMeasurement`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Order` that is related to this `CargoMeasurement`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CargoMeasurement`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `CargoMeasurement` mutation. */
export type CreateCargoMeasurementPayloadCargoMeasurementEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoMeasurementsOrderBy>>;
};

/** All input for the create `CargoUnit` mutation. */
export type CreateCargoUnitInput = {
  /** The `CargoUnit` to be created by this mutation. */
  cargoUnit: CargoUnitInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoUnit` mutation. */
export type CreateCargoUnitPayload = {
  __typename?: 'CreateCargoUnitPayload';
  /** The `CargoUnit` that was created by this mutation. */
  cargoUnit?: Maybe<CargoUnit>;
  /** An edge for our `CargoUnit`. May be used by Relay 1. */
  cargoUnitEdge?: Maybe<CargoUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CargoUnit` mutation. */
export type CreateCargoUnitPayloadCargoUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoUnitsOrderBy>>;
};

/** All input for the create `CargoUnitsConversion` mutation. */
export type CreateCargoUnitsConversionInput = {
  /** The `CargoUnitsConversion` to be created by this mutation. */
  cargoUnitsConversion: CargoUnitsConversionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoUnitsConversion` mutation. */
export type CreateCargoUnitsConversionPayload = {
  __typename?: 'CreateCargoUnitsConversionPayload';
  /** Reads a single `CargoUnit` that is related to this `CargoUnitsConversion`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /** The `CargoUnitsConversion` that was created by this mutation. */
  cargoUnitsConversion?: Maybe<CargoUnitsConversion>;
  /** An edge for our `CargoUnitsConversion`. May be used by Relay 1. */
  cargoUnitsConversionEdge?: Maybe<CargoUnitsConversionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CargoUnitsConversion` mutation. */
export type CreateCargoUnitsConversionPayloadCargoUnitsConversionEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoUnitsConversionsOrderBy>>;
};

/** All input for the create `CargoWeightUnit` mutation. */
export type CreateCargoWeightUnitInput = {
  /** The `CargoWeightUnit` to be created by this mutation. */
  cargoWeightUnit: CargoWeightUnitInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CargoWeightUnit` mutation. */
export type CreateCargoWeightUnitPayload = {
  __typename?: 'CreateCargoWeightUnitPayload';
  /** The `CargoWeightUnit` that was created by this mutation. */
  cargoWeightUnit?: Maybe<CargoWeightUnit>;
  /** An edge for our `CargoWeightUnit`. May be used by Relay 1. */
  cargoWeightUnitEdge?: Maybe<CargoWeightUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CargoWeightUnit` mutation. */
export type CreateCargoWeightUnitPayloadCargoWeightUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoWeightUnitsOrderBy>>;
};

/** All input for the create `ChannelCostEstimate` mutation. */
export type CreateChannelCostEstimateInput = {
  /** The `ChannelCostEstimate` to be created by this mutation. */
  channelCostEstimate: ChannelCostEstimateInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ChannelCostEstimate` mutation. */
export type CreateChannelCostEstimatePayload = {
  __typename?: 'CreateChannelCostEstimatePayload';
  /** Reads a single `AssortmentGroup` that is related to this `ChannelCostEstimate`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /** The `ChannelCostEstimate` that was created by this mutation. */
  channelCostEstimate?: Maybe<ChannelCostEstimate>;
  /** An edge for our `ChannelCostEstimate`. May be used by Relay 1. */
  channelCostEstimateEdge?: Maybe<ChannelCostEstimatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `ChannelCostEstimate`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ChannelCostEstimate`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `ChannelCostEstimate`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our create `ChannelCostEstimate` mutation. */
export type CreateChannelCostEstimatePayloadChannelCostEstimateEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
};

/** All input for the create `ChannelCost` mutation. */
export type CreateChannelCostInput = {
  /** The `ChannelCost` to be created by this mutation. */
  channelCost: ChannelCostInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ChannelCost` mutation. */
export type CreateChannelCostPayload = {
  __typename?: 'CreateChannelCostPayload';
  /** Reads a single `Channel` that is related to this `ChannelCost`. */
  channelByChannelId?: Maybe<Channel>;
  /** The `ChannelCost` that was created by this mutation. */
  channelCost?: Maybe<ChannelCost>;
  /** An edge for our `ChannelCost`. May be used by Relay 1. */
  channelCostEdge?: Maybe<ChannelCostsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `ChannelCost`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ChannelCost`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `ChannelCost`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `ChannelCost` mutation. */
export type CreateChannelCostPayloadChannelCostEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelCostsOrderBy>>;
};

/** All input for the create `ChannelIncompatibility` mutation. */
export type CreateChannelIncompatibilityInput = {
  /** The `ChannelIncompatibility` to be created by this mutation. */
  channelIncompatibility: ChannelIncompatibilityInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ChannelIncompatibility` mutation. */
export type CreateChannelIncompatibilityPayload = {
  __typename?: 'CreateChannelIncompatibilityPayload';
  /** The `ChannelIncompatibility` that was created by this mutation. */
  channelIncompatibility?: Maybe<ChannelIncompatibility>;
  /** An edge for our `ChannelIncompatibility`. May be used by Relay 1. */
  channelIncompatibilityEdge?: Maybe<ChannelIncompatibilitiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VesselAttribute` that is related to this `ChannelIncompatibility`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
};


/** The output of our create `ChannelIncompatibility` mutation. */
export type CreateChannelIncompatibilityPayloadChannelIncompatibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelIncompatibilitiesOrderBy>>;
};

/** All input for the create `Channel` mutation. */
export type CreateChannelInput = {
  /** The `Channel` to be created by this mutation. */
  channel: ChannelInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Channel` mutation. */
export type CreateChannelPayload = {
  __typename?: 'CreateChannelPayload';
  /** The `Channel` that was created by this mutation. */
  channel?: Maybe<Channel>;
  /** An edge for our `Channel`. May be used by Relay 1. */
  channelEdge?: Maybe<ChannelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `Channel`. */
  geographicalEntityByGeoId?: Maybe<GeographicalEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Channel` mutation. */
export type CreateChannelPayloadChannelEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelsOrderBy>>;
};

/** All input for the create `Chat` mutation. */
export type CreateChatInput = {
  /** The `Chat` to be created by this mutation. */
  chat: ChatInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `Chat` mutation. */
export type CreateChatPayload = {
  __typename?: 'CreateChatPayload';
  /** The `Chat` that was created by this mutation. */
  chat?: Maybe<Chat>;
  /** An edge for our `Chat`. May be used by Relay 1. */
  chatEdge?: Maybe<ChatsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `Chat`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `Chat`. */
  organizationByFromOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Chat`. */
  organizationByToOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `Chat`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `Chat`. */
  userByFromUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Chat`. */
  userByToUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `Chat`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our create `Chat` mutation. */
export type CreateChatPayloadChatEdgeArgs = {
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};

/** All input for the create `ClassSocietyAssociation` mutation. */
export type CreateClassSocietyAssociationInput = {
  /** The `ClassSocietyAssociation` to be created by this mutation. */
  classSocietyAssociation: ClassSocietyAssociationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ClassSocietyAssociation` mutation. */
export type CreateClassSocietyAssociationPayload = {
  __typename?: 'CreateClassSocietyAssociationPayload';
  /** The `ClassSocietyAssociation` that was created by this mutation. */
  classSocietyAssociation?: Maybe<ClassSocietyAssociation>;
  /** An edge for our `ClassSocietyAssociation`. May be used by Relay 1. */
  classSocietyAssociationEdge?: Maybe<ClassSocietyAssociationsEdge>;
  /** Reads a single `ClassificationSociety` that is related to this `ClassSocietyAssociation`. */
  classificationSocietyBySocietyId?: Maybe<ClassificationSociety>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `IceClass` that is related to this `ClassSocietyAssociation`. */
  iceClassByIceClassId?: Maybe<IceClass>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ClassSocietyAssociation` mutation. */
export type CreateClassSocietyAssociationPayloadClassSocietyAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassSocietyAssociationsOrderBy>>;
};

/** All input for the create `ClassificationSociety` mutation. */
export type CreateClassificationSocietyInput = {
  /** The `ClassificationSociety` to be created by this mutation. */
  classificationSociety: ClassificationSocietyInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ClassificationSociety` mutation. */
export type CreateClassificationSocietyPayload = {
  __typename?: 'CreateClassificationSocietyPayload';
  /** The `ClassificationSociety` that was created by this mutation. */
  classificationSociety?: Maybe<ClassificationSociety>;
  /** An edge for our `ClassificationSociety`. May be used by Relay 1. */
  classificationSocietyEdge?: Maybe<ClassificationSocietiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ClassificationSociety` mutation. */
export type CreateClassificationSocietyPayloadClassificationSocietyEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationSocietiesOrderBy>>;
};

/** All input for the create `CoaContractAssortment` mutation. */
export type CreateCoaContractAssortmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractAssortment` to be created by this mutation. */
  coaContractAssortment: CoaContractAssortmentInput;
};

/** The output of our create `CoaContractAssortment` mutation. */
export type CreateCoaContractAssortmentPayload = {
  __typename?: 'CreateCoaContractAssortmentPayload';
  /** Reads a single `Assortment` that is related to this `CoaContractAssortment`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `CoaContractAssortment`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoaContractAssortment` that was created by this mutation. */
  coaContractAssortment?: Maybe<CoaContractAssortment>;
  /** An edge for our `CoaContractAssortment`. May be used by Relay 1. */
  coaContractAssortmentEdge?: Maybe<CoaContractAssortmentsEdge>;
  /** Reads a single `CoaContract` that is related to this `CoaContractAssortment`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads a single `Organization` that is related to this `CoaContractAssortment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CoaContractAssortment` mutation. */
export type CreateCoaContractAssortmentPayloadCoaContractAssortmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractAssortmentsOrderBy>>;
};

/** All input for the create `CoaContractBunker` mutation. */
export type CreateCoaContractBunkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractBunker` to be created by this mutation. */
  coaContractBunker: CoaContractBunkerInput;
};

/** The output of our create `CoaContractBunker` mutation. */
export type CreateCoaContractBunkerPayload = {
  __typename?: 'CreateCoaContractBunkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractBunker`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** The `CoaContractBunker` that was created by this mutation. */
  coaContractBunker?: Maybe<CoaContractBunker>;
  /** An edge for our `CoaContractBunker`. May be used by Relay 1. */
  coaContractBunkerEdge?: Maybe<CoaContractBunkersEdge>;
  /** Reads a single `CoaContract` that is related to this `CoaContractBunker`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractBunker`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CoaContractBunker` mutation. */
export type CreateCoaContractBunkerPayloadCoaContractBunkerEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractBunkersOrderBy>>;
};

/** All input for the create `CoaContractCommission` mutation. */
export type CreateCoaContractCommissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractCommission` to be created by this mutation. */
  coaContractCommission: CoaContractCommissionInput;
};

/** The output of our create `CoaContractCommission` mutation. */
export type CreateCoaContractCommissionPayload = {
  __typename?: 'CreateCoaContractCommissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractCommission`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractCommission`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractCommission` that was created by this mutation. */
  coaContractCommission?: Maybe<CoaContractCommission>;
  /** An edge for our `CoaContractCommission`. May be used by Relay 1. */
  coaContractCommissionEdge?: Maybe<CoaContractCommissionsEdge>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractCommission`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  /** Reads a single `Commission` that is related to this `CoaContractCommission`. */
  commissionByCommissionId?: Maybe<Commission>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CoaContractCommission` mutation. */
export type CreateCoaContractCommissionPayloadCoaContractCommissionEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractCommissionsOrderBy>>;
};

/** All input for the create `CoaContractDeviationCost` mutation. */
export type CreateCoaContractDeviationCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractDeviationCost` to be created by this mutation. */
  coaContractDeviationCost: CoaContractDeviationCostInput;
};

/** The output of our create `CoaContractDeviationCost` mutation. */
export type CreateCoaContractDeviationCostPayload = {
  __typename?: 'CreateCoaContractDeviationCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractDeviationCost`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractDeviationCost` that was created by this mutation. */
  coaContractDeviationCost?: Maybe<CoaContractDeviationCost>;
  /** An edge for our `CoaContractDeviationCost`. May be used by Relay 1. */
  coaContractDeviationCostEdge?: Maybe<CoaContractDeviationCostsEdge>;
  /** Reads a single `Location` that is related to this `CoaContractDeviationCost`. */
  locationByFromLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `CoaContractDeviationCost`. */
  locationByToLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `CoaContractDeviationCost`. */
  zoneByFromZoneId?: Maybe<Zone>;
  /** Reads a single `Zone` that is related to this `CoaContractDeviationCost`. */
  zoneByToZoneId?: Maybe<Zone>;
};


/** The output of our create `CoaContractDeviationCost` mutation. */
export type CreateCoaContractDeviationCostPayloadCoaContractDeviationCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};

/** All input for the create `CoaContract` mutation. */
export type CreateCoaContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContract` to be created by this mutation. */
  coaContract: CoaContractInput;
};

/** The output of our create `CoaContract` mutation. */
export type CreateCoaContractPayload = {
  __typename?: 'CreateCoaContractPayload';
  /** Reads a single `CargoUnit` that is related to this `CoaContract`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoaContract` that was created by this mutation. */
  coaContract?: Maybe<CoaContract>;
  /** An edge for our `CoaContract`. May be used by Relay 1. */
  coaContractEdge?: Maybe<CoaContractsEdge>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CoaContract`. */
  userByChartererId?: Maybe<User>;
  /** Reads a single `User` that is related to this `CoaContract`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `CoaContract` mutation. */
export type CreateCoaContractPayloadCoaContractEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};

/** All input for the create `CoaContractPortCost` mutation. */
export type CreateCoaContractPortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractPortCost` to be created by this mutation. */
  coaContractPortCost: CoaContractPortCostInput;
};

/** The output of our create `CoaContractPortCost` mutation. */
export type CreateCoaContractPortCostPayload = {
  __typename?: 'CreateCoaContractPortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPortCost`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPortCost` that was created by this mutation. */
  coaContractPortCost?: Maybe<CoaContractPortCost>;
  /** An edge for our `CoaContractPortCost`. May be used by Relay 1. */
  coaContractPortCostEdge?: Maybe<CoaContractPortCostsEdge>;
  /** Reads a single `Location` that is related to this `CoaContractPortCost`. */
  locationByLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractPortCost`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `CoaContractPortCost`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our create `CoaContractPortCost` mutation. */
export type CreateCoaContractPortCostPayloadCoaContractPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortCostsOrderBy>>;
};

/** All input for the create `CoaContractPortDatum` mutation. */
export type CreateCoaContractPortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractPortDatum` to be created by this mutation. */
  coaContractPortDatum: CoaContractPortDatumInput;
};

/** The output of our create `CoaContractPortDatum` mutation. */
export type CreateCoaContractPortDatumPayload = {
  __typename?: 'CreateCoaContractPortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPortDatum`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPortDatum` that was created by this mutation. */
  coaContractPortDatum?: Maybe<CoaContractPortDatum>;
  /** An edge for our `CoaContractPortDatum`. May be used by Relay 1. */
  coaContractPortDatumEdge?: Maybe<CoaContractPortDataEdge>;
  /** Reads a single `Organization` that is related to this `CoaContractPortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortDatum` that is related to this `CoaContractPortDatum`. */
  portDatumByPortDataId?: Maybe<PortDatum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CoaContractPortDatum` mutation. */
export type CreateCoaContractPortDatumPayloadCoaContractPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortDataOrderBy>>;
};

/** All input for the create `CoaContractPort` mutation. */
export type CreateCoaContractPortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractPort` to be created by this mutation. */
  coaContractPort: CoaContractPortInput;
};

/** The output of our create `CoaContractPort` mutation. */
export type CreateCoaContractPortPayload = {
  __typename?: 'CreateCoaContractPortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPort`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPort` that was created by this mutation. */
  coaContractPort?: Maybe<CoaContractPort>;
  /** An edge for our `CoaContractPort`. May be used by Relay 1. */
  coaContractPortEdge?: Maybe<CoaContractPortsEdge>;
  /** Reads a single `Location` that is related to this `CoaContractPort`. */
  locationByDestinationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `CoaContractPort`. */
  locationByOriginId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `CoaContractPort`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContractPort`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CoaContractPort`. */
  userByChartererId?: Maybe<User>;
  /** Reads a single `Zone` that is related to this `CoaContractPort`. */
  zoneByDestinationZoneId?: Maybe<Zone>;
  /** Reads a single `Zone` that is related to this `CoaContractPort`. */
  zoneByOriginZoneId?: Maybe<Zone>;
};


/** The output of our create `CoaContractPort` mutation. */
export type CreateCoaContractPortPayloadCoaContractPortEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};

/** All input for the create `CoaContractPrice` mutation. */
export type CreateCoaContractPriceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractPrice` to be created by this mutation. */
  coaContractPrice: CoaContractPriceInput;
};

/** The output of our create `CoaContractPrice` mutation. */
export type CreateCoaContractPricePayload = {
  __typename?: 'CreateCoaContractPricePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractPrice`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPrice`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractPrice`. */
  coaContractPortByRouteId?: Maybe<CoaContractPort>;
  /** The `CoaContractPrice` that was created by this mutation. */
  coaContractPrice?: Maybe<CoaContractPrice>;
  /** An edge for our `CoaContractPrice`. May be used by Relay 1. */
  coaContractPriceEdge?: Maybe<CoaContractPricesEdge>;
  /** Reads a single `Organization` that is related to this `CoaContractPrice`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractPrice`. */
  shipByShipId?: Maybe<Ship>;
};


/** The output of our create `CoaContractPrice` mutation. */
export type CreateCoaContractPricePayloadCoaContractPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};

/** All input for the create `CoaContractShip` mutation. */
export type CreateCoaContractShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CoaContractShip` to be created by this mutation. */
  coaContractShip: CoaContractShipInput;
};

/** The output of our create `CoaContractShip` mutation. */
export type CreateCoaContractShipPayload = {
  __typename?: 'CreateCoaContractShipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractShip`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractShip` that was created by this mutation. */
  coaContractShip?: Maybe<CoaContractShip>;
  /** An edge for our `CoaContractShip`. May be used by Relay 1. */
  coaContractShipEdge?: Maybe<CoaContractShipsEdge>;
  /** Reads a single `Organization` that is related to this `CoaContractShip`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractShip`. */
  shipByShipId?: Maybe<Ship>;
};


/** The output of our create `CoaContractShip` mutation. */
export type CreateCoaContractShipPayloadCoaContractShipEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractShipsOrderBy>>;
};

/** All input for the create `Commission` mutation. */
export type CreateCommissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Commission` to be created by this mutation. */
  commission: CommissionInput;
};

/** The output of our create `Commission` mutation. */
export type CreateCommissionPayload = {
  __typename?: 'CreateCommissionPayload';
  /** Reads a single `Assortment` that is related to this `Commission`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Commission` that was created by this mutation. */
  commission?: Maybe<Commission>;
  /** An edge for our `Commission`. May be used by Relay 1. */
  commissionEdge?: Maybe<CommissionsEdge>;
  /** Reads a single `Location` that is related to this `Commission`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Commission`. */
  locationByLoadPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Commission`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `Commission`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our create `Commission` mutation. */
export type CreateCommissionPayloadCommissionEdgeArgs = {
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};

/** All input for the create `CommitLogScenario` mutation. */
export type CreateCommitLogScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CommitLogScenario` to be created by this mutation. */
  commitLogScenario: CommitLogScenarioInput;
};

/** The output of our create `CommitLogScenario` mutation. */
export type CreateCommitLogScenarioPayload = {
  __typename?: 'CreateCommitLogScenarioPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CommitLogScenario` that was created by this mutation. */
  commitLogScenario?: Maybe<CommitLogScenario>;
  /** An edge for our `CommitLogScenario`. May be used by Relay 1. */
  commitLogScenarioEdge?: Maybe<CommitLogScenariosEdge>;
  /** Reads a single `Organization` that is related to this `CommitLogScenario`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CommitLogScenario` mutation. */
export type CreateCommitLogScenarioPayloadCommitLogScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<CommitLogScenariosOrderBy>>;
};

/** All input for the create `CostSplitOnScheduledOrder` mutation. */
export type CreateCostSplitOnScheduledOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CostSplitOnScheduledOrder` to be created by this mutation. */
  costSplitOnScheduledOrder: CostSplitOnScheduledOrderInput;
};

/** The output of our create `CostSplitOnScheduledOrder` mutation. */
export type CreateCostSplitOnScheduledOrderPayload = {
  __typename?: 'CreateCostSplitOnScheduledOrderPayload';
  /** Reads a single `ActualCost` that is related to this `CostSplitOnScheduledOrder`. */
  actualCostByActualCostId?: Maybe<ActualCost>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CostSplitOnScheduledOrder` that was created by this mutation. */
  costSplitOnScheduledOrder?: Maybe<CostSplitOnScheduledOrder>;
  /** An edge for our `CostSplitOnScheduledOrder`. May be used by Relay 1. */
  costSplitOnScheduledOrderEdge?: Maybe<CostSplitOnScheduledOrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledOrder` that is related to this `CostSplitOnScheduledOrder`. */
  scheduledOrderByScheduledOrderId?: Maybe<ScheduledOrder>;
};


/** The output of our create `CostSplitOnScheduledOrder` mutation. */
export type CreateCostSplitOnScheduledOrderPayloadCostSplitOnScheduledOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<CostSplitOnScheduledOrdersOrderBy>>;
};

/** All input for the create `CostSplitOnSingleEvent` mutation. */
export type CreateCostSplitOnSingleEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CostSplitOnSingleEvent` to be created by this mutation. */
  costSplitOnSingleEvent: CostSplitOnSingleEventInput;
};

/** The output of our create `CostSplitOnSingleEvent` mutation. */
export type CreateCostSplitOnSingleEventPayload = {
  __typename?: 'CreateCostSplitOnSingleEventPayload';
  /** Reads a single `ActualCost` that is related to this `CostSplitOnSingleEvent`. */
  actualCostByActualCostId?: Maybe<ActualCost>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CostSplitOnSingleEvent` that was created by this mutation. */
  costSplitOnSingleEvent?: Maybe<CostSplitOnSingleEvent>;
  /** An edge for our `CostSplitOnSingleEvent`. May be used by Relay 1. */
  costSplitOnSingleEventEdge?: Maybe<CostSplitOnSingleEventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SingleEvent` that is related to this `CostSplitOnSingleEvent`. */
  singleEventBySingleEventId?: Maybe<SingleEvent>;
};


/** The output of our create `CostSplitOnSingleEvent` mutation. */
export type CreateCostSplitOnSingleEventPayloadCostSplitOnSingleEventEdgeArgs = {
  orderBy?: InputMaybe<Array<CostSplitOnSingleEventsOrderBy>>;
};

/** All input for the create `Country` mutation. */
export type CreateCountryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Country` to be created by this mutation. */
  country: CountryInput;
};

/** The output of our create `Country` mutation. */
export type CreateCountryPayload = {
  __typename?: 'CreateCountryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Country` that was created by this mutation. */
  country?: Maybe<Country>;
  /** An edge for our `Country`. May be used by Relay 1. */
  countryEdge?: Maybe<CountriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Country` mutation. */
export type CreateCountryPayloadCountryEdgeArgs = {
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};

/** All input for the create `CurrentOrganization` mutation. */
export type CreateCurrentOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CurrentOrganization` to be created by this mutation. */
  currentOrganization: CurrentOrganizationInput;
};

/** The output of our create `CurrentOrganization` mutation. */
export type CreateCurrentOrganizationPayload = {
  __typename?: 'CreateCurrentOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CurrentOrganization` that was created by this mutation. */
  currentOrganization?: Maybe<CurrentOrganization>;
  /** An edge for our `CurrentOrganization`. May be used by Relay 1. */
  currentOrganizationEdge?: Maybe<CurrentOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CurrentOrganization` mutation. */
export type CreateCurrentOrganizationPayloadCurrentOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<CurrentOrganizationsOrderBy>>;
};

/** All input for the create `DbChange` mutation. */
export type CreateDbChangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `DbChange` to be created by this mutation. */
  dbChange: DbChangeInput;
};

/** The output of our create `DbChange` mutation. */
export type CreateDbChangePayload = {
  __typename?: 'CreateDbChangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DbChange` that was created by this mutation. */
  dbChange?: Maybe<DbChange>;
  /** An edge for our `DbChange`. May be used by Relay 1. */
  dbChangeEdge?: Maybe<DbChangesEdge>;
  /** Reads a single `Organization` that is related to this `DbChange`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DbChange`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `DbChange` mutation. */
export type CreateDbChangePayloadDbChangeEdgeArgs = {
  orderBy?: InputMaybe<Array<DbChangesOrderBy>>;
};

/** All input for the create `Demand` mutation. */
export type CreateDemandInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Demand` to be created by this mutation. */
  demand: DemandInput;
};

/** The output of our create `Demand` mutation. */
export type CreateDemandPayload = {
  __typename?: 'CreateDemandPayload';
  /** Reads a single `Assortment` that is related to this `Demand`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Demand`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Demand` that was created by this mutation. */
  demand?: Maybe<Demand>;
  /** An edge for our `Demand`. May be used by Relay 1. */
  demandEdge?: Maybe<DemandsEdge>;
  /** Reads a single `Location` that is related to this `Demand`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByDestinationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationBySendingOrganizationId?: Maybe<Organization>;
  /** Reads a single `Quay` that is related to this `Demand`. */
  quayByQuayId?: Maybe<Quay>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Demand`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Demand` mutation. */
export type CreateDemandPayloadDemandEdgeArgs = {
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};

/** All input for the create `EmailToOrderConfig` mutation. */
export type CreateEmailToOrderConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EmailToOrderConfig` to be created by this mutation. */
  emailToOrderConfig: EmailToOrderConfigInput;
};

/** The output of our create `EmailToOrderConfig` mutation. */
export type CreateEmailToOrderConfigPayload = {
  __typename?: 'CreateEmailToOrderConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailToOrderConfig` that was created by this mutation. */
  emailToOrderConfig?: Maybe<EmailToOrderConfig>;
  /** An edge for our `EmailToOrderConfig`. May be used by Relay 1. */
  emailToOrderConfigEdge?: Maybe<EmailToOrderConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailToOrderConfig`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `EmailToOrderConfig` mutation. */
export type CreateEmailToOrderConfigPayloadEmailToOrderConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailToOrderConfigsOrderBy>>;
};

/** All input for the create `EmailToOrderLog` mutation. */
export type CreateEmailToOrderLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EmailToOrderLog` to be created by this mutation. */
  emailToOrderLog: EmailToOrderLogInput;
};

/** The output of our create `EmailToOrderLog` mutation. */
export type CreateEmailToOrderLogPayload = {
  __typename?: 'CreateEmailToOrderLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EmailToOrderConfig` that is related to this `EmailToOrderLog`. */
  emailToOrderConfigByConfigId?: Maybe<EmailToOrderConfig>;
  /** The `EmailToOrderLog` that was created by this mutation. */
  emailToOrderLog?: Maybe<EmailToOrderLog>;
  /** An edge for our `EmailToOrderLog`. May be used by Relay 1. */
  emailToOrderLogEdge?: Maybe<EmailToOrderLogsEdge>;
  /** Reads a single `Organization` that is related to this `EmailToOrderLog`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EmailToOrderLog` mutation. */
export type CreateEmailToOrderLogPayloadEmailToOrderLogEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailToOrderLogsOrderBy>>;
};

/** All input for the create `Feature` mutation. */
export type CreateFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Feature` to be created by this mutation. */
  feature: FeatureInput;
};

/** The output of our create `Feature` mutation. */
export type CreateFeaturePayload = {
  __typename?: 'CreateFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Feature` that was created by this mutation. */
  feature?: Maybe<Feature>;
  /** An edge for our `Feature`. May be used by Relay 1. */
  featureEdge?: Maybe<FeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Feature` mutation. */
export type CreateFeaturePayloadFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};

/** All input for the create `File` mutation. */
export type CreateFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `File` to be created by this mutation. */
  file: FileInput;
};

/** The output of our create `File` mutation. */
export type CreateFilePayload = {
  __typename?: 'CreateFilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `File` that was created by this mutation. */
  file?: Maybe<File>;
  /** An edge for our `File`. May be used by Relay 1. */
  fileEdge?: Maybe<FilesEdge>;
  /** Reads a single `Location` that is related to this `File`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Order` that is related to this `File`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `File`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `Shipment` that is related to this `File`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `File`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `File`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our create `File` mutation. */
export type CreateFilePayloadFileEdgeArgs = {
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** All input for the create `GeographicalEntity` mutation. */
export type CreateGeographicalEntityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `GeographicalEntity` to be created by this mutation. */
  geographicalEntity: GeographicalEntityInput;
};

/** The output of our create `GeographicalEntity` mutation. */
export type CreateGeographicalEntityPayload = {
  __typename?: 'CreateGeographicalEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `GeographicalEntity` that was created by this mutation. */
  geographicalEntity?: Maybe<GeographicalEntity>;
  /** An edge for our `GeographicalEntity`. May be used by Relay 1. */
  geographicalEntityEdge?: Maybe<GeographicalEntitiesEdge>;
  /** Reads a single `Organization` that is related to this `GeographicalEntity`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `GeographicalEntity`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `GeographicalEntity` mutation. */
export type CreateGeographicalEntityPayloadGeographicalEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<GeographicalEntitiesOrderBy>>;
};

/** All input for the create `GeographicalRelation` mutation. */
export type CreateGeographicalRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `GeographicalRelation` to be created by this mutation. */
  geographicalRelation: GeographicalRelationInput;
};

/** The output of our create `GeographicalRelation` mutation. */
export type CreateGeographicalRelationPayload = {
  __typename?: 'CreateGeographicalRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `GeographicalRelation`. */
  geographicalEntityByEntityId?: Maybe<GeographicalEntity>;
  /** The `GeographicalRelation` that was created by this mutation. */
  geographicalRelation?: Maybe<GeographicalRelation>;
  /** An edge for our `GeographicalRelation`. May be used by Relay 1. */
  geographicalRelationEdge?: Maybe<GeographicalRelationsEdge>;
  /** Reads a single `Location` that is related to this `GeographicalRelation`. */
  locationByLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `GeographicalRelation`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `GeographicalRelation` mutation. */
export type CreateGeographicalRelationPayloadGeographicalRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<GeographicalRelationsOrderBy>>;
};

/** All input for the create `HandledByCoa` mutation. */
export type CreateHandledByCoaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `HandledByCoa` to be created by this mutation. */
  handledByCoa: HandledByCoaInput;
};

/** The output of our create `HandledByCoa` mutation. */
export type CreateHandledByCoaPayload = {
  __typename?: 'CreateHandledByCoaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `HandledByCoa`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  /** The `HandledByCoa` that was created by this mutation. */
  handledByCoa?: Maybe<HandledByCoa>;
  /** An edge for our `HandledByCoa`. May be used by Relay 1. */
  handledByCoaEdge?: Maybe<HandledByCoasEdge>;
  /** Reads a single `Order` that is related to this `HandledByCoa`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `HandledByCoa`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `HandledByCoa`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `HandledByCoa`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledByCoa`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our create `HandledByCoa` mutation. */
export type CreateHandledByCoaPayloadHandledByCoaEdgeArgs = {
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};

/** All input for the create `HandledBySpot` mutation. */
export type CreateHandledBySpotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `HandledBySpot` to be created by this mutation. */
  handledBySpot: HandledBySpotInput;
};

/** The output of our create `HandledBySpot` mutation. */
export type CreateHandledBySpotPayload = {
  __typename?: 'CreateHandledBySpotPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `HandledBySpot` that was created by this mutation. */
  handledBySpot?: Maybe<HandledBySpot>;
  /** An edge for our `HandledBySpot`. May be used by Relay 1. */
  handledBySpotEdge?: Maybe<HandledBySpotsEdge>;
  /** Reads a single `Order` that is related to this `HandledBySpot`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `HandledBySpot`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `HandledBySpot`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `HandledBySpot`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `HandledBySpot`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledBySpot`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our create `HandledBySpot` mutation. */
export type CreateHandledBySpotPayloadHandledBySpotEdgeArgs = {
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};

/** All input for the create `Holiday` mutation. */
export type CreateHolidayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Holiday` to be created by this mutation. */
  holiday: HolidayInput;
};

/** The output of our create `Holiday` mutation. */
export type CreateHolidayPayload = {
  __typename?: 'CreateHolidayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `Holiday`. */
  geographicalEntityByGeoId?: Maybe<GeographicalEntity>;
  /** The `Holiday` that was created by this mutation. */
  holiday?: Maybe<Holiday>;
  /** An edge for our `Holiday`. May be used by Relay 1. */
  holidayEdge?: Maybe<HolidaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Holiday` mutation. */
export type CreateHolidayPayloadHolidayEdgeArgs = {
  orderBy?: InputMaybe<Array<HolidaysOrderBy>>;
};

/** All input for the create `IceClass` mutation. */
export type CreateIceClassInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IceClass` to be created by this mutation. */
  iceClass: IceClassInput;
};

/** The output of our create `IceClass` mutation. */
export type CreateIceClassPayload = {
  __typename?: 'CreateIceClassPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IceClass` that was created by this mutation. */
  iceClass?: Maybe<IceClass>;
  /** An edge for our `IceClass`. May be used by Relay 1. */
  iceClassEdge?: Maybe<IceClassesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IceClass` mutation. */
export type CreateIceClassPayloadIceClassEdgeArgs = {
  orderBy?: InputMaybe<Array<IceClassesOrderBy>>;
};

/** All input for the create `Instruction` mutation. */
export type CreateInstructionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Instruction` to be created by this mutation. */
  instruction: InstructionInput;
};

/** The output of our create `Instruction` mutation. */
export type CreateInstructionPayload = {
  __typename?: 'CreateInstructionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Instruction` that was created by this mutation. */
  instruction?: Maybe<Instruction>;
  /** An edge for our `Instruction`. May be used by Relay 1. */
  instructionEdge?: Maybe<InstructionsEdge>;
  /** Reads a single `Order` that is related to this `Instruction`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `Instruction`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Instruction`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Instruction` mutation. */
export type CreateInstructionPayloadInstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<InstructionsOrderBy>>;
};

/** All input for the create `IntegrationLog` mutation. */
export type CreateIntegrationLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IntegrationLog` to be created by this mutation. */
  integrationLog: IntegrationLogInput;
};

/** The output of our create `IntegrationLog` mutation. */
export type CreateIntegrationLogPayload = {
  __typename?: 'CreateIntegrationLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IntegrationLog` that was created by this mutation. */
  integrationLog?: Maybe<IntegrationLog>;
  /** An edge for our `IntegrationLog`. May be used by Relay 1. */
  integrationLogEdge?: Maybe<IntegrationLogsEdge>;
  /** Reads a single `Organization` that is related to this `IntegrationLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IntegrationLog` mutation. */
export type CreateIntegrationLogPayloadIntegrationLogEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrationLogsOrderBy>>;
};

/** All input for the create `Invoice` mutation. */
export type CreateInvoiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Invoice` to be created by this mutation. */
  invoice: InvoiceInput;
};

/** All input for the create `InvoiceItem` mutation. */
export type CreateInvoiceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `InvoiceItem` to be created by this mutation. */
  invoiceItem: InvoiceItemInput;
};

/** All input for the create `InvoiceItemOrder` mutation. */
export type CreateInvoiceItemOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `InvoiceItemOrder` to be created by this mutation. */
  invoiceItemOrder: InvoiceItemOrderInput;
};

/** The output of our create `InvoiceItemOrder` mutation. */
export type CreateInvoiceItemOrderPayload = {
  __typename?: 'CreateInvoiceItemOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `InvoiceItem` that is related to this `InvoiceItemOrder`. */
  invoiceItemByInvoiceItemId?: Maybe<InvoiceItem>;
  /** The `InvoiceItemOrder` that was created by this mutation. */
  invoiceItemOrder?: Maybe<InvoiceItemOrder>;
  /** An edge for our `InvoiceItemOrder`. May be used by Relay 1. */
  invoiceItemOrderEdge?: Maybe<InvoiceItemOrdersEdge>;
  /** Reads a single `Order` that is related to this `InvoiceItemOrder`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `InvoiceItemOrder` mutation. */
export type CreateInvoiceItemOrderPayloadInvoiceItemOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoiceItemOrdersOrderBy>>;
};

/** The output of our create `InvoiceItem` mutation. */
export type CreateInvoiceItemPayload = {
  __typename?: 'CreateInvoiceItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Invoice` that is related to this `InvoiceItem`. */
  invoiceByInvoiceId?: Maybe<Invoice>;
  /** The `InvoiceItem` that was created by this mutation. */
  invoiceItem?: Maybe<InvoiceItem>;
  /** An edge for our `InvoiceItem`. May be used by Relay 1. */
  invoiceItemEdge?: Maybe<InvoiceItemsEdge>;
  /** Reads a single `Organization` that is related to this `InvoiceItem`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `InvoiceItem`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `InvoiceItem` mutation. */
export type CreateInvoiceItemPayloadInvoiceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoiceItemsOrderBy>>;
};

/** The output of our create `Invoice` mutation. */
export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Invoice` that was created by this mutation. */
  invoice?: Maybe<Invoice>;
  /** An edge for our `Invoice`. May be used by Relay 1. */
  invoiceEdge?: Maybe<InvoicesEdge>;
  /** Reads a single `Organization` that is related to this `Invoice`. */
  organizationByPayingOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `Invoice`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our create `Invoice` mutation. */
export type CreateInvoicePayloadInvoiceEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
};

/** All input for the create `LaytimeResponsibility` mutation. */
export type CreateLaytimeResponsibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LaytimeResponsibility` to be created by this mutation. */
  laytimeResponsibility: LaytimeResponsibilityInput;
};

/** The output of our create `LaytimeResponsibility` mutation. */
export type CreateLaytimeResponsibilityPayload = {
  __typename?: 'CreateLaytimeResponsibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LaytimeResponsibility` that was created by this mutation. */
  laytimeResponsibility?: Maybe<LaytimeResponsibility>;
  /** An edge for our `LaytimeResponsibility`. May be used by Relay 1. */
  laytimeResponsibilityEdge?: Maybe<LaytimeResponsibilitiesEdge>;
  /** Reads a single `Organization` that is related to this `LaytimeResponsibility`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `PortActivity` that is related to this `LaytimeResponsibility`. */
  portActivityByPortActivityId?: Maybe<PortActivity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `LaytimeResponsibility`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our create `LaytimeResponsibility` mutation. */
export type CreateLaytimeResponsibilityPayloadLaytimeResponsibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<LaytimeResponsibilitiesOrderBy>>;
};

/** All input for the create `LocationCluster` mutation. */
export type CreateLocationClusterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LocationCluster` to be created by this mutation. */
  locationCluster: LocationClusterInput;
};

/** The output of our create `LocationCluster` mutation. */
export type CreateLocationClusterPayload = {
  __typename?: 'CreateLocationClusterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LocationCluster` that was created by this mutation. */
  locationCluster?: Maybe<LocationCluster>;
  /** An edge for our `LocationCluster`. May be used by Relay 1. */
  locationClusterEdge?: Maybe<LocationClustersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LocationCluster` mutation. */
export type CreateLocationClusterPayloadLocationClusterEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationClustersOrderBy>>;
};

/** All input for the create `Location` mutation. */
export type CreateLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Location` to be created by this mutation. */
  location: LocationInput;
};

/** The output of our create `Location` mutation. */
export type CreateLocationPayload = {
  __typename?: 'CreateLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Country` that is related to this `Location`. */
  countryByCountryId?: Maybe<Country>;
  /** The `Location` that was created by this mutation. */
  location?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Location`. */
  locationByParentLocationId?: Maybe<Location>;
  /** Reads a single `LocationCluster` that is related to this `Location`. */
  locationClusterByClusterId?: Maybe<LocationCluster>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge?: Maybe<LocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Location`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Location` mutation. */
export type CreateLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** All input for the create `LocationRequirementAssociation` mutation. */
export type CreateLocationRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LocationRequirementAssociation` to be created by this mutation. */
  locationRequirementAssociation: LocationRequirementAssociationInput;
};

/** The output of our create `LocationRequirementAssociation` mutation. */
export type CreateLocationRequirementAssociationPayload = {
  __typename?: 'CreateLocationRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `LocationRequirementAssociation`. */
  locationByLocationId?: Maybe<Location>;
  /** The `LocationRequirementAssociation` that was created by this mutation. */
  locationRequirementAssociation?: Maybe<LocationRequirementAssociation>;
  /** An edge for our `LocationRequirementAssociation`. May be used by Relay 1. */
  locationRequirementAssociationEdge?: Maybe<LocationRequirementAssociationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpecialRequirement` that is related to this `LocationRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  /** Reads a single `Zone` that is related to this `LocationRequirementAssociation`. */
  zoneByZoneId?: Maybe<Zone>;
};


/** The output of our create `LocationRequirementAssociation` mutation. */
export type CreateLocationRequirementAssociationPayloadLocationRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
};

/** All input for the create `LocationWorkingHour` mutation. */
export type CreateLocationWorkingHourInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LocationWorkingHour` to be created by this mutation. */
  locationWorkingHour: LocationWorkingHourInput;
};

/** The output of our create `LocationWorkingHour` mutation. */
export type CreateLocationWorkingHourPayload = {
  __typename?: 'CreateLocationWorkingHourPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `LocationWorkingHour`. */
  locationByLocationId?: Maybe<Location>;
  /** The `LocationWorkingHour` that was created by this mutation. */
  locationWorkingHour?: Maybe<LocationWorkingHour>;
  /** An edge for our `LocationWorkingHour`. May be used by Relay 1. */
  locationWorkingHourEdge?: Maybe<LocationWorkingHoursEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LocationWorkingHour`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `LocationWorkingHour` mutation. */
export type CreateLocationWorkingHourPayloadLocationWorkingHourEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationWorkingHoursOrderBy>>;
};

/** All input for the create `LostContract` mutation. */
export type CreateLostContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `LostContract` to be created by this mutation. */
  lostContract: LostContractInput;
};

/** The output of our create `LostContract` mutation. */
export type CreateLostContractPayload = {
  __typename?: 'CreateLostContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LostContract` that was created by this mutation. */
  lostContract?: Maybe<LostContract>;
  /** An edge for our `LostContract`. May be used by Relay 1. */
  lostContractEdge?: Maybe<LostContractsEdge>;
  /** Reads a single `Organization` that is related to this `LostContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `LostContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `LostContract` mutation. */
export type CreateLostContractPayloadLostContractEdgeArgs = {
  orderBy?: InputMaybe<Array<LostContractsOrderBy>>;
};

/** All input for the create `Migration` mutation. */
export type CreateMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Migration` to be created by this mutation. */
  migration: MigrationInput;
};

/** The output of our create `Migration` mutation. */
export type CreateMigrationPayload = {
  __typename?: 'CreateMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Migration` that was created by this mutation. */
  migration?: Maybe<Migration>;
  /** An edge for our `Migration`. May be used by Relay 1. */
  migrationEdge?: Maybe<MigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Migration` mutation. */
export type CreateMigrationPayloadMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<MigrationsOrderBy>>;
};

/** All input for the create `NoGoZone` mutation. */
export type CreateNoGoZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `NoGoZone` to be created by this mutation. */
  noGoZone: NoGoZoneInput;
};

/** The output of our create `NoGoZone` mutation. */
export type CreateNoGoZonePayload = {
  __typename?: 'CreateNoGoZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `NoGoZone` that was created by this mutation. */
  noGoZone?: Maybe<NoGoZone>;
  /** An edge for our `NoGoZone`. May be used by Relay 1. */
  noGoZoneEdge?: Maybe<NoGoZonesEdge>;
  /** Reads a single `Organization` that is related to this `NoGoZone`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `NoGoZone` mutation. */
export type CreateNoGoZonePayloadNoGoZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<NoGoZonesOrderBy>>;
};

/** All input for the create `NotificationReceiver` mutation. */
export type CreateNotificationReceiverInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `NotificationReceiver` to be created by this mutation. */
  notificationReceiver: NotificationReceiverInput;
};

/** The output of our create `NotificationReceiver` mutation. */
export type CreateNotificationReceiverPayload = {
  __typename?: 'CreateNotificationReceiverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `NotificationReceiver`. */
  locationByLocationId?: Maybe<Location>;
  /** The `NotificationReceiver` that was created by this mutation. */
  notificationReceiver?: Maybe<NotificationReceiver>;
  /** An edge for our `NotificationReceiver`. May be used by Relay 1. */
  notificationReceiverEdge?: Maybe<NotificationReceiversEdge>;
  /** Reads a single `Order` that is related to this `NotificationReceiver`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `NotificationReceiver`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `NotificationReceiver`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `NotificationReceiver`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our create `NotificationReceiver` mutation. */
export type CreateNotificationReceiverPayloadNotificationReceiverEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};

/** All input for the create `OffHire` mutation. */
export type CreateOffHireInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OffHire` to be created by this mutation. */
  offHire: OffHireInput;
};

/** The output of our create `OffHire` mutation. */
export type CreateOffHirePayload = {
  __typename?: 'CreateOffHirePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `OffHire`. */
  locationByLocationAId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OffHire`. */
  locationByLocationBId?: Maybe<Location>;
  /** The `OffHire` that was created by this mutation. */
  offHire?: Maybe<OffHire>;
  /** An edge for our `OffHire`. May be used by Relay 1. */
  offHireEdge?: Maybe<OffHiresEdge>;
  /** Reads a single `Organization` that is related to this `OffHire`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OffHire`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `OffHire`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `OffHire`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `OffHire`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `OffHire` mutation. */
export type CreateOffHirePayloadOffHireEdgeArgs = {
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};

/** All input for the create `OpenPosition` mutation. */
export type CreateOpenPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OpenPosition` to be created by this mutation. */
  openPosition: OpenPositionInput;
};

/** The output of our create `OpenPosition` mutation. */
export type CreateOpenPositionPayload = {
  __typename?: 'CreateOpenPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `OpenPosition`. */
  locationByDirectionId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OpenPosition`. */
  locationByStartPortId?: Maybe<Location>;
  /** The `OpenPosition` that was created by this mutation. */
  openPosition?: Maybe<OpenPosition>;
  /** An edge for our `OpenPosition`. May be used by Relay 1. */
  openPositionEdge?: Maybe<OpenPositionsEdge>;
  /** Reads a single `Organization` that is related to this `OpenPosition`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `OpenPosition`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `OpenPosition`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `OpenPosition`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our create `OpenPosition` mutation. */
export type CreateOpenPositionPayloadOpenPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};

/** All input for the create `OrderAttributeAssociation` mutation. */
export type CreateOrderAttributeAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrderAttributeAssociation` to be created by this mutation. */
  orderAttributeAssociation: OrderAttributeAssociationInput;
};

/** The output of our create `OrderAttributeAssociation` mutation. */
export type CreateOrderAttributeAssociationPayload = {
  __typename?: 'CreateOrderAttributeAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OrderAttributeAssociation` that was created by this mutation. */
  orderAttributeAssociation?: Maybe<OrderAttributeAssociation>;
  /** An edge for our `OrderAttributeAssociation`. May be used by Relay 1. */
  orderAttributeAssociationEdge?: Maybe<OrderAttributeAssociationsEdge>;
  /** Reads a single `OrderAttribute` that is related to this `OrderAttributeAssociation`. */
  orderAttributeByOrderAttributeId?: Maybe<OrderAttribute>;
  /** Reads a single `Order` that is related to this `OrderAttributeAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `OrderAttributeAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderAttributeAssociation` mutation. */
export type CreateOrderAttributeAssociationPayloadOrderAttributeAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderAttributeAssociationsOrderBy>>;
};

/** All input for the create `OrderAttribute` mutation. */
export type CreateOrderAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrderAttribute` to be created by this mutation. */
  orderAttribute: OrderAttributeInput;
};

/** The output of our create `OrderAttribute` mutation. */
export type CreateOrderAttributePayload = {
  __typename?: 'CreateOrderAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OrderAttribute` that was created by this mutation. */
  orderAttribute?: Maybe<OrderAttribute>;
  /** An edge for our `OrderAttribute`. May be used by Relay 1. */
  orderAttributeEdge?: Maybe<OrderAttributesEdge>;
  /** Reads a single `Organization` that is related to this `OrderAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderAttribute` mutation. */
export type CreateOrderAttributePayloadOrderAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderAttributesOrderBy>>;
};

/** All input for the create `OrderDetail` mutation. */
export type CreateOrderDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrderDetail` to be created by this mutation. */
  orderDetail: OrderDetailInput;
};

/** The output of our create `OrderDetail` mutation. */
export type CreateOrderDetailPayload = {
  __typename?: 'CreateOrderDetailPayload';
  /** Reads a single `CargoEquipment` that is related to this `OrderDetail`. */
  cargoEquipmentByCargoEquipmentId?: Maybe<CargoEquipment>;
  /** Reads a single `CargoLengthUnit` that is related to this `OrderDetail`. */
  cargoLengthUnitByCargoLengthUnitId?: Maybe<CargoLengthUnit>;
  /** Reads a single `CargoWeightUnit` that is related to this `OrderDetail`. */
  cargoWeightUnitByCargoWeightUnitId?: Maybe<CargoWeightUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `OrderDetail`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderDetail` that was created by this mutation. */
  orderDetail?: Maybe<OrderDetail>;
  /** An edge for our `OrderDetail`. May be used by Relay 1. */
  orderDetailEdge?: Maybe<OrderDetailsEdge>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByDischargePortAgentId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByLoadPortAgentOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByReceiverOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationBySenderOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SupplyContract` that is related to this `OrderDetail`. */
  supplyContractBySupplyContractId?: Maybe<SupplyContract>;
};


/** The output of our create `OrderDetail` mutation. */
export type CreateOrderDetailPayloadOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};

/** All input for the create `Order` mutation. */
export type CreateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Order` to be created by this mutation. */
  order: OrderInput;
};

/** The output of our create `Order` mutation. */
export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  /** Reads a single `Assortment` that is related to this `Order`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Order`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `Order`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  /** Reads a single `Location` that is related to this `Order`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Order`. */
  locationByLoadPortId?: Maybe<Location>;
  /** The `Order` that was created by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByChartererOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `Order`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `Order`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Order`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselAttribute` that is related to this `Order`. */
  vesselAttributeByMinVesselClassRequirement?: Maybe<VesselAttribute>;
};


/** The output of our create `Order` mutation. */
export type CreateOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the create `OrderPortCallRelation` mutation. */
export type CreateOrderPortCallRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrderPortCallRelation` to be created by this mutation. */
  orderPortCallRelation: OrderPortCallRelationInput;
};

/** The output of our create `OrderPortCallRelation` mutation. */
export type CreateOrderPortCallRelationPayload = {
  __typename?: 'CreateOrderPortCallRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `OrderPortCallRelation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderPortCallRelation` that was created by this mutation. */
  orderPortCallRelation?: Maybe<OrderPortCallRelation>;
  /** An edge for our `OrderPortCallRelation`. May be used by Relay 1. */
  orderPortCallRelationEdge?: Maybe<OrderPortCallRelationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderPortCallRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `OrderPortCallRelation`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `OrderPortCallRelation`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our create `OrderPortCallRelation` mutation. */
export type CreateOrderPortCallRelationPayloadOrderPortCallRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderPortCallRelationsOrderBy>>;
};

/** All input for the create `OrderPortOverride` mutation. */
export type CreateOrderPortOverrideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrderPortOverride` to be created by this mutation. */
  orderPortOverride: OrderPortOverrideInput;
};

/** The output of our create `OrderPortOverride` mutation. */
export type CreateOrderPortOverridePayload = {
  __typename?: 'CreateOrderPortOverridePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `OrderPortOverride`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderPortOverride` that was created by this mutation. */
  orderPortOverride?: Maybe<OrderPortOverride>;
  /** An edge for our `OrderPortOverride`. May be used by Relay 1. */
  orderPortOverrideEdge?: Maybe<OrderPortOverridesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrderPortOverride` mutation. */
export type CreateOrderPortOverridePayloadOrderPortOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderPortOverridesOrderBy>>;
};

/** All input for the create `OrderRequirementAssociation` mutation. */
export type CreateOrderRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrderRequirementAssociation` to be created by this mutation. */
  orderRequirementAssociation: OrderRequirementAssociationInput;
};

/** The output of our create `OrderRequirementAssociation` mutation. */
export type CreateOrderRequirementAssociationPayload = {
  __typename?: 'CreateOrderRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `OrderRequirementAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderRequirementAssociation` that was created by this mutation. */
  orderRequirementAssociation?: Maybe<OrderRequirementAssociation>;
  /** An edge for our `OrderRequirementAssociation`. May be used by Relay 1. */
  orderRequirementAssociationEdge?: Maybe<OrderRequirementAssociationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderRequirementAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpecialRequirement` that is related to this `OrderRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
};


/** The output of our create `OrderRequirementAssociation` mutation. */
export type CreateOrderRequirementAssociationPayloadOrderRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderRequirementAssociationsOrderBy>>;
};

/** All input for the create `OrderVoyageCharterRelation` mutation. */
export type CreateOrderVoyageCharterRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrderVoyageCharterRelation` to be created by this mutation. */
  orderVoyageCharterRelation: OrderVoyageCharterRelationInput;
};

/** The output of our create `OrderVoyageCharterRelation` mutation. */
export type CreateOrderVoyageCharterRelationPayload = {
  __typename?: 'CreateOrderVoyageCharterRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractPort` that is related to this `OrderVoyageCharterRelation`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  /** Reads a single `Order` that is related to this `OrderVoyageCharterRelation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderVoyageCharterRelation` that was created by this mutation. */
  orderVoyageCharterRelation?: Maybe<OrderVoyageCharterRelation>;
  /** An edge for our `OrderVoyageCharterRelation`. May be used by Relay 1. */
  orderVoyageCharterRelationEdge?: Maybe<OrderVoyageCharterRelationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderVoyageCharterRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `OrderVoyageCharterRelation`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `OrderVoyageCharterRelation`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our create `OrderVoyageCharterRelation` mutation. */
export type CreateOrderVoyageCharterRelationPayloadOrderVoyageCharterRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};

/** All input for the create `OrganizationAreaBunkerGradeMapping` mutation. */
export type CreateOrganizationAreaBunkerGradeMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrganizationAreaBunkerGradeMapping` to be created by this mutation. */
  organizationAreaBunkerGradeMapping: OrganizationAreaBunkerGradeMappingInput;
};

/** The output of our create `OrganizationAreaBunkerGradeMapping` mutation. */
export type CreateOrganizationAreaBunkerGradeMappingPayload = {
  __typename?: 'CreateOrganizationAreaBunkerGradeMappingPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `OrganizationAreaBunkerGradeMapping`. */
  bunkerGradeOverrideByBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OrganizationAreaBunkerGradeMapping` that was created by this mutation. */
  organizationAreaBunkerGradeMapping?: Maybe<OrganizationAreaBunkerGradeMapping>;
  /** An edge for our `OrganizationAreaBunkerGradeMapping`. May be used by Relay 1. */
  organizationAreaBunkerGradeMappingEdge?: Maybe<OrganizationAreaBunkerGradeMappingsEdge>;
  /** Reads a single `Organization` that is related to this `OrganizationAreaBunkerGradeMapping`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrganizationAreaBunkerGradeMapping` mutation. */
export type CreateOrganizationAreaBunkerGradeMappingPayloadOrganizationAreaBunkerGradeMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationAreaBunkerGradeMappingsOrderBy>>;
};

/** All input for the create `OrganizationFeature` mutation. */
export type CreateOrganizationFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OrganizationFeature` to be created by this mutation. */
  organizationFeature: OrganizationFeatureInput;
};

/** The output of our create `OrganizationFeature` mutation. */
export type CreateOrganizationFeaturePayload = {
  __typename?: 'CreateOrganizationFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Feature` that is related to this `OrganizationFeature`. */
  featureByFeatureName?: Maybe<Feature>;
  /** Reads a single `Organization` that is related to this `OrganizationFeature`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `OrganizationFeature` that was created by this mutation. */
  organizationFeature?: Maybe<OrganizationFeature>;
  /** An edge for our `OrganizationFeature`. May be used by Relay 1. */
  organizationFeatureEdge?: Maybe<OrganizationFeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `OrganizationFeature` mutation. */
export type CreateOrganizationFeaturePayloadOrganizationFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationFeaturesOrderBy>>;
};

/** All input for the create `Organization` mutation. */
export type CreateOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Organization` to be created by this mutation. */
  organization: OrganizationInput;
};

/** The output of our create `Organization` mutation. */
export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Organization` that was created by this mutation. */
  organization?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Organization`. */
  organizationByParentOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Organization`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Organization` mutation. */
export type CreateOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};

/** All input for the create `PortActivity` mutation. */
export type CreatePortActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortActivity` to be created by this mutation. */
  portActivity: PortActivityInput;
};

/** The output of our create `PortActivity` mutation. */
export type CreatePortActivityPayload = {
  __typename?: 'CreatePortActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `PortActivity`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `PortActivity`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** The `PortActivity` that was created by this mutation. */
  portActivity?: Maybe<PortActivity>;
  /** An edge for our `PortActivity`. May be used by Relay 1. */
  portActivityEdge?: Maybe<PortActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `StatementOfFact` that is related to this `PortActivity`. */
  statementOfFactByStatementOfFactsId?: Maybe<StatementOfFact>;
  /** Reads a single `User` that is related to this `PortActivity`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `PortActivity` mutation. */
export type CreatePortActivityPayloadPortActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<PortActivitiesOrderBy>>;
};

/** All input for the create `PortCallExternalTimestamp` mutation. */
export type CreatePortCallExternalTimestampInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortCallExternalTimestamp` to be created by this mutation. */
  portCallExternalTimestamp: PortCallExternalTimestampInput;
};

/** The output of our create `PortCallExternalTimestamp` mutation. */
export type CreatePortCallExternalTimestampPayload = {
  __typename?: 'CreatePortCallExternalTimestampPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PortCallExternalTimestamp`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortCallExternalTimestamp`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortCallExternalTimestamp` that was created by this mutation. */
  portCallExternalTimestamp?: Maybe<PortCallExternalTimestamp>;
  /** An edge for our `PortCallExternalTimestamp`. May be used by Relay 1. */
  portCallExternalTimestampEdge?: Maybe<PortCallExternalTimestampsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PortCallExternalTimestamp` mutation. */
export type CreatePortCallExternalTimestampPayloadPortCallExternalTimestampEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallExternalTimestampsOrderBy>>;
};

/** All input for the create `PortCallFile` mutation. */
export type CreatePortCallFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortCallFile` to be created by this mutation. */
  portCallFile: PortCallFileInput;
};

/** The output of our create `PortCallFile` mutation. */
export type CreatePortCallFilePayload = {
  __typename?: 'CreatePortCallFilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `File` that is related to this `PortCallFile`. */
  fileByFileId?: Maybe<File>;
  /** Reads a single `Organization` that is related to this `PortCallFile`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortCallFile`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortCallFile` that was created by this mutation. */
  portCallFile?: Maybe<PortCallFile>;
  /** An edge for our `PortCallFile`. May be used by Relay 1. */
  portCallFileEdge?: Maybe<PortCallFilesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PortCallFile` mutation. */
export type CreatePortCallFilePayloadPortCallFileEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallFilesOrderBy>>;
};

/** All input for the create `PortCall` mutation. */
export type CreatePortCallInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortCall` to be created by this mutation. */
  portCall: PortCallInput;
};

/** The output of our create `PortCall` mutation. */
export type CreatePortCallPayload = {
  __typename?: 'CreatePortCallPayload';
  /** Reads a single `ChannelCostEstimate` that is related to this `PortCall`. */
  channelCostEstimateByChannelCostDefaultId?: Maybe<ChannelCostEstimate>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortCall`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `PortCall`. */
  locationByPreviousLocationId?: Maybe<Location>;
  /** The `PortCall` that was created by this mutation. */
  portCall?: Maybe<PortCall>;
  /** An edge for our `PortCall`. May be used by Relay 1. */
  portCallEdge?: Maybe<PortCallsEdge>;
  /** Reads a single `PortCostDefault` that is related to this `PortCall`. */
  portCostDefaultByPortCostDefaultId?: Maybe<PortCostDefault>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCall`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `PortCall`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our create `PortCall` mutation. */
export type CreatePortCallPayloadPortCallEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};

/** All input for the create `PortCommodityLdRate` mutation. */
export type CreatePortCommodityLdRateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortCommodityLdRate` to be created by this mutation. */
  portCommodityLdRate: PortCommodityLdRateInput;
};

/** The output of our create `PortCommodityLdRate` mutation. */
export type CreatePortCommodityLdRatePayload = {
  __typename?: 'CreatePortCommodityLdRatePayload';
  /** Reads a single `Assortment` that is related to this `PortCommodityLdRate`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `PortCommodityLdRate`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortCommodityLdRate`. */
  locationByPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCommodityLdRate`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCommodityLdRate` that was created by this mutation. */
  portCommodityLdRate?: Maybe<PortCommodityLdRate>;
  /** An edge for our `PortCommodityLdRate`. May be used by Relay 1. */
  portCommodityLdRateEdge?: Maybe<PortCommodityLdRatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `PortCommodityLdRate`. */
  zoneByZoneId?: Maybe<Zone>;
};


/** The output of our create `PortCommodityLdRate` mutation. */
export type CreatePortCommodityLdRatePayloadPortCommodityLdRateEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};

/** All input for the create `PortCostDefault` mutation. */
export type CreatePortCostDefaultInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortCostDefault` to be created by this mutation. */
  portCostDefault: PortCostDefaultInput;
};

/** The output of our create `PortCostDefault` mutation. */
export type CreatePortCostDefaultPayload = {
  __typename?: 'CreatePortCostDefaultPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortCostDefault`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCostDefault`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCostDefault` that was created by this mutation. */
  portCostDefault?: Maybe<PortCostDefault>;
  /** An edge for our `PortCostDefault`. May be used by Relay 1. */
  portCostDefaultEdge?: Maybe<PortCostDefaultsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCostDefault`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `PortCostDefault`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our create `PortCostDefault` mutation. */
export type CreatePortCostDefaultPayloadPortCostDefaultEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostDefaultsOrderBy>>;
};

/** All input for the create `PortCostEstimatesExternal` mutation. */
export type CreatePortCostEstimatesExternalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortCostEstimatesExternal` to be created by this mutation. */
  portCostEstimatesExternal: PortCostEstimatesExternalInput;
};

/** The output of our create `PortCostEstimatesExternal` mutation. */
export type CreatePortCostEstimatesExternalPayload = {
  __typename?: 'CreatePortCostEstimatesExternalPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PortCostEstimatesExternal`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCostEstimatesExternal` that was created by this mutation. */
  portCostEstimatesExternal?: Maybe<PortCostEstimatesExternal>;
  /** An edge for our `PortCostEstimatesExternal`. May be used by Relay 1. */
  portCostEstimatesExternalEdge?: Maybe<PortCostEstimatesExternalsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PortCostEstimatesExternal` mutation. */
export type CreatePortCostEstimatesExternalPayloadPortCostEstimatesExternalEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostEstimatesExternalsOrderBy>>;
};

/** All input for the create `PortCost` mutation. */
export type CreatePortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortCost` to be created by this mutation. */
  portCost: PortCostInput;
};

/** The output of our create `PortCost` mutation. */
export type CreatePortCostPayload = {
  __typename?: 'CreatePortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortCost`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCost`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** The `PortCost` that was created by this mutation. */
  portCost?: Maybe<PortCost>;
  /** An edge for our `PortCost`. May be used by Relay 1. */
  portCostEdge?: Maybe<PortCostsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCost`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `PortCost`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `PortCost` mutation. */
export type CreatePortCostPayloadPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostsOrderBy>>;
};

/** All input for the create `PortDatum` mutation. */
export type CreatePortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortDatum` to be created by this mutation. */
  portDatum: PortDatumInput;
};

/** The output of our create `PortDatum` mutation. */
export type CreatePortDatumPayload = {
  __typename?: 'CreatePortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortDatum`. */
  locationByPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortDatum`. */
  organizationByPortAgentOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `PortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** The `PortDatum` that was created by this mutation. */
  portDatum?: Maybe<PortDatum>;
  /** An edge for our `PortDatum`. May be used by Relay 1. */
  portDatumEdge?: Maybe<PortDataEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `PortDatum` mutation. */
export type CreatePortDatumPayloadPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<PortDataOrderBy>>;
};

/** All input for the create `PortNotice` mutation. */
export type CreatePortNoticeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortNotice` to be created by this mutation. */
  portNotice: PortNoticeInput;
};

/** The output of our create `PortNotice` mutation. */
export type CreatePortNoticePayload = {
  __typename?: 'CreatePortNoticePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PortNotice`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortNotice`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortNotice` that was created by this mutation. */
  portNotice?: Maybe<PortNotice>;
  /** An edge for our `PortNotice`. May be used by Relay 1. */
  portNoticeEdge?: Maybe<PortNoticesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PortNotice`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `PortNotice`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `PortNotice` mutation. */
export type CreatePortNoticePayloadPortNoticeEdgeArgs = {
  orderBy?: InputMaybe<Array<PortNoticesOrderBy>>;
};

/** All input for the create `PortRegion` mutation. */
export type CreatePortRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `PortRegion` to be created by this mutation. */
  portRegion: PortRegionInput;
};

/** The output of our create `PortRegion` mutation. */
export type CreatePortRegionPayload = {
  __typename?: 'CreatePortRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `PortRegion`. */
  geographicalEntityByGeographicalEntityId?: Maybe<GeographicalEntity>;
  /** Reads a single `Location` that is related to this `PortRegion`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortRegion`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortRegion` that was created by this mutation. */
  portRegion?: Maybe<PortRegion>;
  /** An edge for our `PortRegion`. May be used by Relay 1. */
  portRegionEdge?: Maybe<PortRegionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `PortRegion`. */
  regionByRegionId?: Maybe<Region>;
};


/** The output of our create `PortRegion` mutation. */
export type CreatePortRegionPayloadPortRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<PortRegionsOrderBy>>;
};

/** All input for the create `Prompt` mutation. */
export type CreatePromptInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Prompt` to be created by this mutation. */
  prompt: PromptInput;
};

/** The output of our create `Prompt` mutation. */
export type CreatePromptPayload = {
  __typename?: 'CreatePromptPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Prompt`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `Prompt` that was created by this mutation. */
  prompt?: Maybe<Prompt>;
  /** An edge for our `Prompt`. May be used by Relay 1. */
  promptEdge?: Maybe<PromptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Prompt`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Prompt`. */
  userByModifiedBy?: Maybe<User>;
};


/** The output of our create `Prompt` mutation. */
export type CreatePromptPayloadPromptEdgeArgs = {
  orderBy?: InputMaybe<Array<PromptsOrderBy>>;
};

/** All input for the create `Quay` mutation. */
export type CreateQuayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Quay` to be created by this mutation. */
  quay: QuayInput;
};

/** The output of our create `Quay` mutation. */
export type CreateQuayPayload = {
  __typename?: 'CreateQuayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `Quay`. */
  locationByLocationId?: Maybe<Location>;
  /** The `Quay` that was created by this mutation. */
  quay?: Maybe<Quay>;
  /** An edge for our `Quay`. May be used by Relay 1. */
  quayEdge?: Maybe<QuaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Quay`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Quay` mutation. */
export type CreateQuayPayloadQuayEdgeArgs = {
  orderBy?: InputMaybe<Array<QuaysOrderBy>>;
};

/** All input for the create `ReceiverOrganization` mutation. */
export type CreateReceiverOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ReceiverOrganization` to be created by this mutation. */
  receiverOrganization: ReceiverOrganizationInput;
};

/** The output of our create `ReceiverOrganization` mutation. */
export type CreateReceiverOrganizationPayload = {
  __typename?: 'CreateReceiverOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `ReceiverOrganization`. */
  organizationByAdminOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `ReceiverOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ReceiverOrganization` that was created by this mutation. */
  receiverOrganization?: Maybe<ReceiverOrganization>;
  /** An edge for our `ReceiverOrganization`. May be used by Relay 1. */
  receiverOrganizationEdge?: Maybe<ReceiverOrganizationsEdge>;
};


/** The output of our create `ReceiverOrganization` mutation. */
export type CreateReceiverOrganizationPayloadReceiverOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<ReceiverOrganizationsOrderBy>>;
};

/** All input for the create `Region` mutation. */
export type CreateRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Region` to be created by this mutation. */
  region: RegionInput;
};

/** The output of our create `Region` mutation. */
export type CreateRegionPayload = {
  __typename?: 'CreateRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Region`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Region` that was created by this mutation. */
  region?: Maybe<Region>;
  /** Reads a single `Region` that is related to this `Region`. */
  regionByParentRegion?: Maybe<Region>;
  /** An edge for our `Region`. May be used by Relay 1. */
  regionEdge?: Maybe<RegionsEdge>;
  /** Reads a single `User` that is related to this `Region`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Region` mutation. */
export type CreateRegionPayloadRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<RegionsOrderBy>>;
};

/** All input for the create `RequestLog` mutation. */
export type CreateRequestLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RequestLog` to be created by this mutation. */
  requestLog: RequestLogInput;
};

/** The output of our create `RequestLog` mutation. */
export type CreateRequestLogPayload = {
  __typename?: 'CreateRequestLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `RequestLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RequestLog` that was created by this mutation. */
  requestLog?: Maybe<RequestLog>;
  /** An edge for our `RequestLog`. May be used by Relay 1. */
  requestLogEdge?: Maybe<RequestLogsEdge>;
};


/** The output of our create `RequestLog` mutation. */
export type CreateRequestLogPayloadRequestLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RequestLogsOrderBy>>;
};

/** All input for the `createRoleIfNotExists` mutation. */
export type CreateRoleIfNotExistsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  rolename?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `createRoleIfNotExists` mutation. */
export type CreateRoleIfNotExistsPayload = {
  __typename?: 'CreateRoleIfNotExistsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `Route` mutation. */
export type CreateRouteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Route` to be created by this mutation. */
  route: RouteInput;
};

/** All input for the create `RouteOverride` mutation. */
export type CreateRouteOverrideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RouteOverride` to be created by this mutation. */
  routeOverride: RouteOverrideInput;
};

/** The output of our create `RouteOverride` mutation. */
export type CreateRouteOverridePayload = {
  __typename?: 'CreateRouteOverridePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `RouteOverride`. */
  locationByFromId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `RouteOverride`. */
  locationByToId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `RouteOverride`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RouteOverride` that was created by this mutation. */
  routeOverride?: Maybe<RouteOverride>;
  /** An edge for our `RouteOverride`. May be used by Relay 1. */
  routeOverrideEdge?: Maybe<RouteOverridesEdge>;
  /** Reads a single `Ship` that is related to this `RouteOverride`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `RouteOverride`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `RouteOverride` mutation. */
export type CreateRouteOverridePayloadRouteOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};

/** The output of our create `Route` mutation. */
export type CreateRoutePayload = {
  __typename?: 'CreateRoutePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `LocationCluster` that is related to this `Route`. */
  locationClusterByFromClusterId?: Maybe<LocationCluster>;
  /** Reads a single `LocationCluster` that is related to this `Route`. */
  locationClusterByToClusterId?: Maybe<LocationCluster>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Route` that was created by this mutation. */
  route?: Maybe<Route>;
  /** An edge for our `Route`. May be used by Relay 1. */
  routeEdge?: Maybe<RoutesEdge>;
};


/** The output of our create `Route` mutation. */
export type CreateRoutePayloadRouteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};

/** All input for the create `RoutePoint` mutation. */
export type CreateRoutePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RoutePoint` to be created by this mutation. */
  routePoint: RoutePointInput;
};

/** The output of our create `RoutePoint` mutation. */
export type CreateRoutePointPayload = {
  __typename?: 'CreateRoutePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoutePoint` that was created by this mutation. */
  routePoint?: Maybe<RoutePoint>;
  /** An edge for our `RoutePoint`. May be used by Relay 1. */
  routePointEdge?: Maybe<RoutePointsEdge>;
};


/** The output of our create `RoutePoint` mutation. */
export type CreateRoutePointPayloadRoutePointEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePointsOrderBy>>;
};

/** All input for the create `RoutePointUsage` mutation. */
export type CreateRoutePointUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RoutePointUsage` to be created by this mutation. */
  routePointUsage: RoutePointUsageInput;
};

/** The output of our create `RoutePointUsage` mutation. */
export type CreateRoutePointUsagePayload = {
  __typename?: 'CreateRoutePointUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Route` that is related to this `RoutePointUsage`. */
  routeByRouteId?: Maybe<Route>;
  /** Reads a single `RoutePoint` that is related to this `RoutePointUsage`. */
  routePointByRoutePointId?: Maybe<RoutePoint>;
  /** The `RoutePointUsage` that was created by this mutation. */
  routePointUsage?: Maybe<RoutePointUsage>;
  /** An edge for our `RoutePointUsage`. May be used by Relay 1. */
  routePointUsageEdge?: Maybe<RoutePointUsagesEdge>;
};


/** The output of our create `RoutePointUsage` mutation. */
export type CreateRoutePointUsagePayloadRoutePointUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePointUsagesOrderBy>>;
};

/** All input for the create `Scenario` mutation. */
export type CreateScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Scenario` to be created by this mutation. */
  scenario: ScenarioInput;
};

/** The output of our create `Scenario` mutation. */
export type CreateScenarioPayload = {
  __typename?: 'CreateScenarioPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Scenario`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Scenario`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Scenario` that was created by this mutation. */
  scenario?: Maybe<Scenario>;
  /** An edge for our `Scenario`. May be used by Relay 1. */
  scenarioEdge?: Maybe<ScenariosEdge>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our create `Scenario` mutation. */
export type CreateScenarioPayloadScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};

/** All input for the create `ScheduledOrder` mutation. */
export type CreateScheduledOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ScheduledOrder` to be created by this mutation. */
  scheduledOrder: ScheduledOrderInput;
};

/** The output of our create `ScheduledOrder` mutation. */
export type CreateScheduledOrderPayload = {
  __typename?: 'CreateScheduledOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `ScheduledOrder`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `ScheduledOrder`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `ScheduledOrder`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScheduledOrder` that was created by this mutation. */
  scheduledOrder?: Maybe<ScheduledOrder>;
  /** An edge for our `ScheduledOrder`. May be used by Relay 1. */
  scheduledOrderEdge?: Maybe<ScheduledOrdersEdge>;
  /** Reads a single `Ship` that is related to this `ScheduledOrder`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `ScheduledOrder` mutation. */
export type CreateScheduledOrderPayloadScheduledOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};

/** All input for the create `SeenMessage` mutation. */
export type CreateSeenMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SeenMessage` to be created by this mutation. */
  seenMessage: SeenMessageInput;
};

/** The output of our create `SeenMessage` mutation. */
export type CreateSeenMessagePayload = {
  __typename?: 'CreateSeenMessagePayload';
  /** Reads a single `Chat` that is related to this `SeenMessage`. */
  chatByChatId?: Maybe<Chat>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SeenMessage` that was created by this mutation. */
  seenMessage?: Maybe<SeenMessage>;
  /** An edge for our `SeenMessage`. May be used by Relay 1. */
  seenMessageEdge?: Maybe<SeenMessagesEdge>;
  /** Reads a single `User` that is related to this `SeenMessage`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `SeenMessage` mutation. */
export type CreateSeenMessagePayloadSeenMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<SeenMessagesOrderBy>>;
};

/** All input for the create `SenderOrganization` mutation. */
export type CreateSenderOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SenderOrganization` to be created by this mutation. */
  senderOrganization: SenderOrganizationInput;
};

/** The output of our create `SenderOrganization` mutation. */
export type CreateSenderOrganizationPayload = {
  __typename?: 'CreateSenderOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SenderOrganization`. */
  organizationByAdminOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SenderOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SenderOrganization` that was created by this mutation. */
  senderOrganization?: Maybe<SenderOrganization>;
  /** An edge for our `SenderOrganization`. May be used by Relay 1. */
  senderOrganizationEdge?: Maybe<SenderOrganizationsEdge>;
};


/** The output of our create `SenderOrganization` mutation. */
export type CreateSenderOrganizationPayloadSenderOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<SenderOrganizationsOrderBy>>;
};

/** All input for the create `Ship` mutation. */
export type CreateShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Ship` to be created by this mutation. */
  ship: ShipInput;
};

/** The output of our create `Ship` mutation. */
export type CreateShipPayload = {
  __typename?: 'CreateShipPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `Ship`. */
  bunkerGradeOverrideByDefaultBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Ship`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Ship`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Ship` that was created by this mutation. */
  ship?: Maybe<Ship>;
  /** An edge for our `Ship`. May be used by Relay 1. */
  shipEdge?: Maybe<ShipsEdge>;
  /** Reads a single `User` that is related to this `Ship`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselAttribute` that is related to this `Ship`. */
  vesselAttributeByPrimaryAttributeId?: Maybe<VesselAttribute>;
  /** Reads a single `VesselInfo` that is related to this `Ship`. */
  vesselInfoByVesselInfoId?: Maybe<VesselInfo>;
};


/** The output of our create `Ship` mutation. */
export type CreateShipPayloadShipEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};

/** All input for the create `ShipVoyageNamingRuleRelation` mutation. */
export type CreateShipVoyageNamingRuleRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ShipVoyageNamingRuleRelation` to be created by this mutation. */
  shipVoyageNamingRuleRelation: ShipVoyageNamingRuleRelationInput;
};

/** The output of our create `ShipVoyageNamingRuleRelation` mutation. */
export type CreateShipVoyageNamingRuleRelationPayload = {
  __typename?: 'CreateShipVoyageNamingRuleRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ShipVoyageNamingRuleRelation`. */
  shipByShipId?: Maybe<Ship>;
  /** The `ShipVoyageNamingRuleRelation` that was created by this mutation. */
  shipVoyageNamingRuleRelation?: Maybe<ShipVoyageNamingRuleRelation>;
  /** An edge for our `ShipVoyageNamingRuleRelation`. May be used by Relay 1. */
  shipVoyageNamingRuleRelationEdge?: Maybe<ShipVoyageNamingRuleRelationsEdge>;
  /** Reads a single `VoyageNamingRule` that is related to this `ShipVoyageNamingRuleRelation`. */
  voyageNamingRuleByRuleId?: Maybe<VoyageNamingRule>;
};


/** The output of our create `ShipVoyageNamingRuleRelation` mutation. */
export type CreateShipVoyageNamingRuleRelationPayloadShipVoyageNamingRuleRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipVoyageNamingRuleRelationsOrderBy>>;
};

/** All input for the create `ShipmentExternalStatus` mutation. */
export type CreateShipmentExternalStatusInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ShipmentExternalStatus` to be created by this mutation. */
  shipmentExternalStatus: ShipmentExternalStatusInput;
};

/** The output of our create `ShipmentExternalStatus` mutation. */
export type CreateShipmentExternalStatusPayload = {
  __typename?: 'CreateShipmentExternalStatusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentExternalStatus`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentExternalStatus` that was created by this mutation. */
  shipmentExternalStatus?: Maybe<ShipmentExternalStatus>;
  /** An edge for our `ShipmentExternalStatus`. May be used by Relay 1. */
  shipmentExternalStatusEdge?: Maybe<ShipmentExternalStatusesEdge>;
};


/** The output of our create `ShipmentExternalStatus` mutation. */
export type CreateShipmentExternalStatusPayloadShipmentExternalStatusEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentExternalStatusesOrderBy>>;
};

/** All input for the create `ShipmentExtraFreight` mutation. */
export type CreateShipmentExtraFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ShipmentExtraFreight` to be created by this mutation. */
  shipmentExtraFreight: ShipmentExtraFreightInput;
};

/** The output of our create `ShipmentExtraFreight` mutation. */
export type CreateShipmentExtraFreightPayload = {
  __typename?: 'CreateShipmentExtraFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentExtraFreight`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentExtraFreight` that was created by this mutation. */
  shipmentExtraFreight?: Maybe<ShipmentExtraFreight>;
  /** An edge for our `ShipmentExtraFreight`. May be used by Relay 1. */
  shipmentExtraFreightEdge?: Maybe<ShipmentExtraFreightsEdge>;
};


/** The output of our create `ShipmentExtraFreight` mutation. */
export type CreateShipmentExtraFreightPayloadShipmentExtraFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentExtraFreightsOrderBy>>;
};

/** All input for the create `ShipmentFreight` mutation. */
export type CreateShipmentFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ShipmentFreight` to be created by this mutation. */
  shipmentFreight: ShipmentFreightInput;
};

/** The output of our create `ShipmentFreight` mutation. */
export type CreateShipmentFreightPayload = {
  __typename?: 'CreateShipmentFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentFreight`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentFreight` that was created by this mutation. */
  shipmentFreight?: Maybe<ShipmentFreight>;
  /** An edge for our `ShipmentFreight`. May be used by Relay 1. */
  shipmentFreightEdge?: Maybe<ShipmentFreightsEdge>;
};


/** The output of our create `ShipmentFreight` mutation. */
export type CreateShipmentFreightPayloadShipmentFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentFreightsOrderBy>>;
};

/** All input for the create `ShipmentGroupAssociation` mutation. */
export type CreateShipmentGroupAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ShipmentGroupAssociation` to be created by this mutation. */
  shipmentGroupAssociation: ShipmentGroupAssociationInput;
};

/** The output of our create `ShipmentGroupAssociation` mutation. */
export type CreateShipmentGroupAssociationPayload = {
  __typename?: 'CreateShipmentGroupAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentGroupAssociation`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentGroupAssociation` that was created by this mutation. */
  shipmentGroupAssociation?: Maybe<ShipmentGroupAssociation>;
  /** An edge for our `ShipmentGroupAssociation`. May be used by Relay 1. */
  shipmentGroupAssociationEdge?: Maybe<ShipmentGroupAssociationsEdge>;
  /** Reads a single `ShipmentGroup` that is related to this `ShipmentGroupAssociation`. */
  shipmentGroupByShipmentGroupId?: Maybe<ShipmentGroup>;
};


/** The output of our create `ShipmentGroupAssociation` mutation. */
export type CreateShipmentGroupAssociationPayloadShipmentGroupAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentGroupAssociationsOrderBy>>;
};

/** All input for the create `ShipmentGroup` mutation. */
export type CreateShipmentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ShipmentGroup` to be created by this mutation. */
  shipmentGroup: ShipmentGroupInput;
};

/** The output of our create `ShipmentGroup` mutation. */
export type CreateShipmentGroupPayload = {
  __typename?: 'CreateShipmentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `ShipmentGroup`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShipmentGroup` that was created by this mutation. */
  shipmentGroup?: Maybe<ShipmentGroup>;
  /** An edge for our `ShipmentGroup`. May be used by Relay 1. */
  shipmentGroupEdge?: Maybe<ShipmentGroupsEdge>;
};


/** The output of our create `ShipmentGroup` mutation. */
export type CreateShipmentGroupPayloadShipmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentGroupsOrderBy>>;
};

/** All input for the create `Shipment` mutation. */
export type CreateShipmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Shipment` to be created by this mutation. */
  shipment: ShipmentInput;
};

/** The output of our create `Shipment` mutation. */
export type CreateShipmentPayload = {
  __typename?: 'CreateShipmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByChartererOrganisation?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByOwnerOrganisation?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shipment` that was created by this mutation. */
  shipment?: Maybe<Shipment>;
  /** An edge for our `Shipment`. May be used by Relay 1. */
  shipmentEdge?: Maybe<ShipmentsEdge>;
  /** Reads a single `User` that is related to this `Shipment`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Shipment`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageAttribute` that is related to this `Shipment`. */
  voyageAttributeByVoyageAttributeId?: Maybe<VoyageAttribute>;
};


/** The output of our create `Shipment` mutation. */
export type CreateShipmentPayloadShipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};

/** All input for the create `SingleEvent` mutation. */
export type CreateSingleEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SingleEvent` to be created by this mutation. */
  singleEvent: SingleEventInput;
};

/** The output of our create `SingleEvent` mutation. */
export type CreateSingleEventPayload = {
  __typename?: 'CreateSingleEventPayload';
  /** Reads a single `AssortmentExclusion` that is related to this `SingleEvent`. */
  assortmentExclusionByCleaningAssortmentExclusionId?: Maybe<AssortmentExclusion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `SingleEvent`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `SingleEvent`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SingleEvent`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `SingleEvent`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `SingleEvent` that was created by this mutation. */
  singleEvent?: Maybe<SingleEvent>;
  /** An edge for our `SingleEvent`. May be used by Relay 1. */
  singleEventEdge?: Maybe<SingleEventsEdge>;
  /** Reads a single `User` that is related to this `SingleEvent`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `SingleEvent`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `SingleEvent` mutation. */
export type CreateSingleEventPayloadSingleEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};

/** All input for the create `SingleEventPortCallRelation` mutation. */
export type CreateSingleEventPortCallRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SingleEventPortCallRelation` to be created by this mutation. */
  singleEventPortCallRelation: SingleEventPortCallRelationInput;
};

/** The output of our create `SingleEventPortCallRelation` mutation. */
export type CreateSingleEventPortCallRelationPayload = {
  __typename?: 'CreateSingleEventPortCallRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SingleEventPortCallRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `SingleEventPortCallRelation`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SingleEvent` that is related to this `SingleEventPortCallRelation`. */
  singleEventBySingleEventId?: Maybe<SingleEvent>;
  /** The `SingleEventPortCallRelation` that was created by this mutation. */
  singleEventPortCallRelation?: Maybe<SingleEventPortCallRelation>;
  /** An edge for our `SingleEventPortCallRelation`. May be used by Relay 1. */
  singleEventPortCallRelationEdge?: Maybe<SingleEventPortCallRelationsEdge>;
};


/** The output of our create `SingleEventPortCallRelation` mutation. */
export type CreateSingleEventPortCallRelationPayloadSingleEventPortCallRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<SingleEventPortCallRelationsOrderBy>>;
};

/** All input for the create `SpecialRequirement` mutation. */
export type CreateSpecialRequirementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SpecialRequirement` to be created by this mutation. */
  specialRequirement: SpecialRequirementInput;
};

/** The output of our create `SpecialRequirement` mutation. */
export type CreateSpecialRequirementPayload = {
  __typename?: 'CreateSpecialRequirementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SpecialRequirement`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpecialRequirement` that was created by this mutation. */
  specialRequirement?: Maybe<SpecialRequirement>;
  /** An edge for our `SpecialRequirement`. May be used by Relay 1. */
  specialRequirementEdge?: Maybe<SpecialRequirementsEdge>;
};


/** The output of our create `SpecialRequirement` mutation. */
export type CreateSpecialRequirementPayloadSpecialRequirementEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialRequirementsOrderBy>>;
};

/** All input for the create `SplitOrder` mutation. */
export type CreateSplitOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SplitOrder` to be created by this mutation. */
  splitOrder: SplitOrderInput;
};

/** The output of our create `SplitOrder` mutation. */
export type CreateSplitOrderPayload = {
  __typename?: 'CreateSplitOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `SplitOrder`. */
  orderByFromOrderId?: Maybe<Order>;
  /** Reads a single `Order` that is related to this `SplitOrder`. */
  orderByToOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SplitOrder` that was created by this mutation. */
  splitOrder?: Maybe<SplitOrder>;
  /** An edge for our `SplitOrder`. May be used by Relay 1. */
  splitOrderEdge?: Maybe<SplitOrdersEdge>;
};


/** The output of our create `SplitOrder` mutation. */
export type CreateSplitOrderPayloadSplitOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<SplitOrdersOrderBy>>;
};

/** All input for the create `SpotNegotiation` mutation. */
export type CreateSpotNegotiationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SpotNegotiation` to be created by this mutation. */
  spotNegotiation: SpotNegotiationInput;
};

/** The output of our create `SpotNegotiation` mutation. */
export type CreateSpotNegotiationPayload = {
  __typename?: 'CreateSpotNegotiationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SpotNegotiation`. */
  organizationByChartererOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SpotNegotiation`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpotNegotiation` that was created by this mutation. */
  spotNegotiation?: Maybe<SpotNegotiation>;
  /** An edge for our `SpotNegotiation`. May be used by Relay 1. */
  spotNegotiationEdge?: Maybe<SpotNegotiationsEdge>;
  /** Reads a single `User` that is related to this `SpotNegotiation`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselInfo` that is related to this `SpotNegotiation`. */
  vesselInfoByVesselId?: Maybe<VesselInfo>;
  /** Reads a single `VoyageCharter` that is related to this `SpotNegotiation`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our create `SpotNegotiation` mutation. */
export type CreateSpotNegotiationPayloadSpotNegotiationEdgeArgs = {
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};

/** All input for the create `StatementOfFact` mutation. */
export type CreateStatementOfFactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `StatementOfFact` to be created by this mutation. */
  statementOfFact: StatementOfFactInput;
};

/** The output of our create `StatementOfFact` mutation. */
export type CreateStatementOfFactPayload = {
  __typename?: 'CreateStatementOfFactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `StatementOfFact`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `StatementOfFact`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StatementOfFact` that was created by this mutation. */
  statementOfFact?: Maybe<StatementOfFact>;
  /** An edge for our `StatementOfFact`. May be used by Relay 1. */
  statementOfFactEdge?: Maybe<StatementOfFactsEdge>;
  /** Reads a single `User` that is related to this `StatementOfFact`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `StatementOfFact`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `StatementOfFact` mutation. */
export type CreateStatementOfFactPayloadStatementOfFactEdgeArgs = {
  orderBy?: InputMaybe<Array<StatementOfFactsOrderBy>>;
};

/** All input for the create `SupplyContract` mutation. */
export type CreateSupplyContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `SupplyContract` to be created by this mutation. */
  supplyContract: SupplyContractInput;
};

/** The output of our create `SupplyContract` mutation. */
export type CreateSupplyContractPayload = {
  __typename?: 'CreateSupplyContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SupplyContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SupplyContract`. */
  organizationBySenderOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SupplyContract` that was created by this mutation. */
  supplyContract?: Maybe<SupplyContract>;
  /** An edge for our `SupplyContract`. May be used by Relay 1. */
  supplyContractEdge?: Maybe<SupplyContractsEdge>;
};


/** The output of our create `SupplyContract` mutation. */
export type CreateSupplyContractPayloadSupplyContractEdgeArgs = {
  orderBy?: InputMaybe<Array<SupplyContractsOrderBy>>;
};

/** All input for the create `Supply` mutation. */
export type CreateSupplyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Supply` to be created by this mutation. */
  supply: SupplyInput;
};

/** The output of our create `Supply` mutation. */
export type CreateSupplyPayload = {
  __typename?: 'CreateSupplyPayload';
  /** Reads a single `Assortment` that is related to this `Supply`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Supply`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `Supply`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Supply`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Supply`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Quay` that is related to this `Supply`. */
  quayByQuay?: Maybe<Quay>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `Supply`. */
  regionByRegion?: Maybe<Region>;
  /** The `Supply` that was created by this mutation. */
  supply?: Maybe<Supply>;
  /** Reads a single `SupplyContract` that is related to this `Supply`. */
  supplyContractBySupplyContract?: Maybe<SupplyContract>;
  /** An edge for our `Supply`. May be used by Relay 1. */
  supplyEdge?: Maybe<SuppliesEdge>;
  /** Reads a single `User` that is related to this `Supply`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Supply` mutation. */
export type CreateSupplyPayloadSupplyEdgeArgs = {
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};

/** All input for the create `TankDistance` mutation. */
export type CreateTankDistanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TankDistance` to be created by this mutation. */
  tankDistance: TankDistanceInput;
};

/** The output of our create `TankDistance` mutation. */
export type CreateTankDistancePayload = {
  __typename?: 'CreateTankDistancePayload';
  /** Reads a single `CargoCompartment` that is related to this `TankDistance`. */
  cargoCompartmentByTankA?: Maybe<CargoCompartment>;
  /** Reads a single `CargoCompartment` that is related to this `TankDistance`. */
  cargoCompartmentByTankB?: Maybe<CargoCompartment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TankDistance` that was created by this mutation. */
  tankDistance?: Maybe<TankDistance>;
  /** An edge for our `TankDistance`. May be used by Relay 1. */
  tankDistanceEdge?: Maybe<TankDistancesEdge>;
};


/** The output of our create `TankDistance` mutation. */
export type CreateTankDistancePayloadTankDistanceEdgeArgs = {
  orderBy?: InputMaybe<Array<TankDistancesOrderBy>>;
};

/** All input for the create `TcContract` mutation. */
export type CreateTcContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TcContract` to be created by this mutation. */
  tcContract: TcContractInput;
};

/** The output of our create `TcContract` mutation. */
export type CreateTcContractPayload = {
  __typename?: 'CreateTcContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `TcContract`. */
  locationByDeliveryPortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `TcContract`. */
  locationByRedeliveryPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `TcContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `TcContract`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `TcContract` that was created by this mutation. */
  tcContract?: Maybe<TcContract>;
  /** An edge for our `TcContract`. May be used by Relay 1. */
  tcContractEdge?: Maybe<TcContractsEdge>;
};


/** The output of our create `TcContract` mutation. */
export type CreateTcContractPayloadTcContractEdgeArgs = {
  orderBy?: InputMaybe<Array<TcContractsOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UserRegion` mutation. */
export type CreateUserRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserRegion` to be created by this mutation. */
  userRegion: UserRegionInput;
};

/** The output of our create `UserRegion` mutation. */
export type CreateUserRegionPayload = {
  __typename?: 'CreateUserRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `UserRegion`. */
  regionByRegionId?: Maybe<Region>;
  /** Reads a single `User` that is related to this `UserRegion`. */
  userByUserId?: Maybe<User>;
  /** The `UserRegion` that was created by this mutation. */
  userRegion?: Maybe<UserRegion>;
  /** An edge for our `UserRegion`. May be used by Relay 1. */
  userRegionEdge?: Maybe<UserRegionsEdge>;
};


/** The output of our create `UserRegion` mutation. */
export type CreateUserRegionPayloadUserRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRegionsOrderBy>>;
};

/** All input for the create `UserRight` mutation. */
export type CreateUserRightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserRight` to be created by this mutation. */
  userRight: UserRightInput;
};

/** The output of our create `UserRight` mutation. */
export type CreateUserRightPayload = {
  __typename?: 'CreateUserRightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `UserRight`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRight`. */
  userByUserId?: Maybe<User>;
  /** The `UserRight` that was created by this mutation. */
  userRight?: Maybe<UserRight>;
  /** An edge for our `UserRight`. May be used by Relay 1. */
  userRightEdge?: Maybe<UserRightsEdge>;
};


/** The output of our create `UserRight` mutation. */
export type CreateUserRightPayloadUserRightEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRightsOrderBy>>;
};

/** All input for the create `UserSetting` mutation. */
export type CreateUserSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserSetting` to be created by this mutation. */
  userSetting: UserSettingInput;
};

/** The output of our create `UserSetting` mutation. */
export type CreateUserSettingPayload = {
  __typename?: 'CreateUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  userByUserId?: Maybe<User>;
  /** The `UserSetting` that was created by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our create `UserSetting` mutation. */
export type CreateUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the create `UserShip` mutation. */
export type CreateUserShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserShip` to be created by this mutation. */
  userShip: UserShipInput;
};

/** The output of our create `UserShip` mutation. */
export type CreateUserShipPayload = {
  __typename?: 'CreateUserShipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `UserShip`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `UserShip`. */
  userByUserId?: Maybe<User>;
  /** The `UserShip` that was created by this mutation. */
  userShip?: Maybe<UserShip>;
  /** An edge for our `UserShip`. May be used by Relay 1. */
  userShipEdge?: Maybe<UserShipsEdge>;
};


/** The output of our create `UserShip` mutation. */
export type CreateUserShipPayloadUserShipEdgeArgs = {
  orderBy?: InputMaybe<Array<UserShipsOrderBy>>;
};

/** All input for the create `VesselAttributeAssortmentExclusion` mutation. */
export type CreateVesselAttributeAssortmentExclusionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselAttributeAssortmentExclusion` to be created by this mutation. */
  vesselAttributeAssortmentExclusion: VesselAttributeAssortmentExclusionInput;
};

/** The output of our create `VesselAttributeAssortmentExclusion` mutation. */
export type CreateVesselAttributeAssortmentExclusionPayload = {
  __typename?: 'CreateVesselAttributeAssortmentExclusionPayload';
  /** Reads a single `Assortment` that is related to this `VesselAttributeAssortmentExclusion`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `VesselAttributeAssortmentExclusion`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VesselAttributeAssortmentExclusion` that was created by this mutation. */
  vesselAttributeAssortmentExclusion?: Maybe<VesselAttributeAssortmentExclusion>;
  /** An edge for our `VesselAttributeAssortmentExclusion`. May be used by Relay 1. */
  vesselAttributeAssortmentExclusionEdge?: Maybe<VesselAttributeAssortmentExclusionsEdge>;
  /** Reads a single `VesselAttribute` that is related to this `VesselAttributeAssortmentExclusion`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
};


/** The output of our create `VesselAttributeAssortmentExclusion` mutation. */
export type CreateVesselAttributeAssortmentExclusionPayloadVesselAttributeAssortmentExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributeAssortmentExclusionsOrderBy>>;
};

/** All input for the create `VesselAttribute` mutation. */
export type CreateVesselAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselAttribute` to be created by this mutation. */
  vesselAttribute: VesselAttributeInput;
};

/** The output of our create `VesselAttribute` mutation. */
export type CreateVesselAttributePayload = {
  __typename?: 'CreateVesselAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselAttribute`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VesselAttribute` that was created by this mutation. */
  vesselAttribute?: Maybe<VesselAttribute>;
  /** An edge for our `VesselAttribute`. May be used by Relay 1. */
  vesselAttributeEdge?: Maybe<VesselAttributesEdge>;
};


/** The output of our create `VesselAttribute` mutation. */
export type CreateVesselAttributePayloadVesselAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributesOrderBy>>;
};

/** All input for the create `VesselAttributesAssociation` mutation. */
export type CreateVesselAttributesAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselAttributesAssociation` to be created by this mutation. */
  vesselAttributesAssociation: VesselAttributesAssociationInput;
};

/** The output of our create `VesselAttributesAssociation` mutation. */
export type CreateVesselAttributesAssociationPayload = {
  __typename?: 'CreateVesselAttributesAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselAttributesAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselAttributesAssociation`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `VesselAttributesAssociation`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  /** The `VesselAttributesAssociation` that was created by this mutation. */
  vesselAttributesAssociation?: Maybe<VesselAttributesAssociation>;
  /** An edge for our `VesselAttributesAssociation`. May be used by Relay 1. */
  vesselAttributesAssociationEdge?: Maybe<VesselAttributesAssociationsEdge>;
};


/** The output of our create `VesselAttributesAssociation` mutation. */
export type CreateVesselAttributesAssociationPayloadVesselAttributesAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributesAssociationsOrderBy>>;
};

/** All input for the create `VesselDraftDatapoint` mutation. */
export type CreateVesselDraftDatapointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselDraftDatapoint` to be created by this mutation. */
  vesselDraftDatapoint: VesselDraftDatapointInput;
};

/** The output of our create `VesselDraftDatapoint` mutation. */
export type CreateVesselDraftDatapointPayload = {
  __typename?: 'CreateVesselDraftDatapointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselDraftDatapoint`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselDraftDatapoint`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselDraftDatapoint` that was created by this mutation. */
  vesselDraftDatapoint?: Maybe<VesselDraftDatapoint>;
  /** An edge for our `VesselDraftDatapoint`. May be used by Relay 1. */
  vesselDraftDatapointEdge?: Maybe<VesselDraftDatapointsEdge>;
};


/** The output of our create `VesselDraftDatapoint` mutation. */
export type CreateVesselDraftDatapointPayloadVesselDraftDatapointEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselDraftDatapointsOrderBy>>;
};

/** All input for the create `VesselFulfillsRequirementAssociation` mutation. */
export type CreateVesselFulfillsRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselFulfillsRequirementAssociation` to be created by this mutation. */
  vesselFulfillsRequirementAssociation: VesselFulfillsRequirementAssociationInput;
};

/** The output of our create `VesselFulfillsRequirementAssociation` mutation. */
export type CreateVesselFulfillsRequirementAssociationPayload = {
  __typename?: 'CreateVesselFulfillsRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselFulfillsRequirementAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselFulfillsRequirementAssociation`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `SpecialRequirement` that is related to this `VesselFulfillsRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  /** Reads a single `VesselAttribute` that is related to this `VesselFulfillsRequirementAssociation`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  /** The `VesselFulfillsRequirementAssociation` that was created by this mutation. */
  vesselFulfillsRequirementAssociation?: Maybe<VesselFulfillsRequirementAssociation>;
  /** An edge for our `VesselFulfillsRequirementAssociation`. May be used by Relay 1. */
  vesselFulfillsRequirementAssociationEdge?: Maybe<VesselFulfillsRequirementAssociationsEdge>;
};


/** The output of our create `VesselFulfillsRequirementAssociation` mutation. */
export type CreateVesselFulfillsRequirementAssociationPayloadVesselFulfillsRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
};

/** All input for the create `VesselInfo` mutation. */
export type CreateVesselInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselInfo` to be created by this mutation. */
  vesselInfo: VesselInfoInput;
};

/** The output of our create `VesselInfo` mutation. */
export type CreateVesselInfoPayload = {
  __typename?: 'CreateVesselInfoPayload';
  /** Reads a single `ClassSocietyAssociation` that is related to this `VesselInfo`. */
  classSocietyAssociationByClassSocietyAssociationId?: Maybe<ClassSocietyAssociation>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselInfo`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselInfo`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VesselInfo`. */
  userByAdminUserId?: Maybe<User>;
  /** The `VesselInfo` that was created by this mutation. */
  vesselInfo?: Maybe<VesselInfo>;
  /** An edge for our `VesselInfo`. May be used by Relay 1. */
  vesselInfoEdge?: Maybe<VesselInfosEdge>;
};


/** The output of our create `VesselInfo` mutation. */
export type CreateVesselInfoPayloadVesselInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
};

/** All input for the create `VesselPerformanceModel` mutation. */
export type CreateVesselPerformanceModelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselPerformanceModel` to be created by this mutation. */
  vesselPerformanceModel: VesselPerformanceModelInput;
};

/** The output of our create `VesselPerformanceModel` mutation. */
export type CreateVesselPerformanceModelPayload = {
  __typename?: 'CreateVesselPerformanceModelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselPerformanceModel`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselPerformanceModel`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselPerformanceModel` that was created by this mutation. */
  vesselPerformanceModel?: Maybe<VesselPerformanceModel>;
  /** An edge for our `VesselPerformanceModel`. May be used by Relay 1. */
  vesselPerformanceModelEdge?: Maybe<VesselPerformanceModelsEdge>;
};


/** The output of our create `VesselPerformanceModel` mutation. */
export type CreateVesselPerformanceModelPayloadVesselPerformanceModelEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselPerformanceModelsOrderBy>>;
};

/** All input for the create `VesselReservation` mutation. */
export type CreateVesselReservationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselReservation` to be created by this mutation. */
  vesselReservation: VesselReservationInput;
};

/** The output of our create `VesselReservation` mutation. */
export type CreateVesselReservationPayload = {
  __typename?: 'CreateVesselReservationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `VesselReservation`. */
  locationByEndPortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `VesselReservation`. */
  locationByStartPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `VesselReservation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `VesselReservation`. */
  regionByEndRegionId?: Maybe<Region>;
  /** Reads a single `Region` that is related to this `VesselReservation`. */
  regionByStartRegionId?: Maybe<Region>;
  /** Reads a single `Ship` that is related to this `VesselReservation`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VesselReservation`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VesselReservation`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VesselReservation` that was created by this mutation. */
  vesselReservation?: Maybe<VesselReservation>;
  /** An edge for our `VesselReservation`. May be used by Relay 1. */
  vesselReservationEdge?: Maybe<VesselReservationsEdge>;
};


/** The output of our create `VesselReservation` mutation. */
export type CreateVesselReservationPayloadVesselReservationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};

/** All input for the create `VesselScheduleSharedToOrganization` mutation. */
export type CreateVesselScheduleSharedToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselScheduleSharedToOrganization` to be created by this mutation. */
  vesselScheduleSharedToOrganization: VesselScheduleSharedToOrganizationInput;
};

/** The output of our create `VesselScheduleSharedToOrganization` mutation. */
export type CreateVesselScheduleSharedToOrganizationPayload = {
  __typename?: 'CreateVesselScheduleSharedToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselScheduleSharedToOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselScheduleSharedToOrganization`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselScheduleSharedToOrganization`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `VesselScheduleSharedToOrganization` that was created by this mutation. */
  vesselScheduleSharedToOrganization?: Maybe<VesselScheduleSharedToOrganization>;
  /** An edge for our `VesselScheduleSharedToOrganization`. May be used by Relay 1. */
  vesselScheduleSharedToOrganizationEdge?: Maybe<VesselScheduleSharedToOrganizationsEdge>;
};


/** The output of our create `VesselScheduleSharedToOrganization` mutation. */
export type CreateVesselScheduleSharedToOrganizationPayloadVesselScheduleSharedToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselScheduleSharedToOrganizationsOrderBy>>;
};

/** All input for the create `VesselSecret` mutation. */
export type CreateVesselSecretInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselSecret` to be created by this mutation. */
  vesselSecret: VesselSecretInput;
};

/** The output of our create `VesselSecret` mutation. */
export type CreateVesselSecretPayload = {
  __typename?: 'CreateVesselSecretPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselSecret`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselSecret`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VesselSecret`. */
  userByAdminUserId?: Maybe<User>;
  /** The `VesselSecret` that was created by this mutation. */
  vesselSecret?: Maybe<VesselSecret>;
  /** An edge for our `VesselSecret`. May be used by Relay 1. */
  vesselSecretEdge?: Maybe<VesselSecretsEdge>;
};


/** The output of our create `VesselSecret` mutation. */
export type CreateVesselSecretPayloadVesselSecretEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselSecretsOrderBy>>;
};

/** All input for the create `VesselSpeedConsumption` mutation. */
export type CreateVesselSpeedConsumptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VesselSpeedConsumption` to be created by this mutation. */
  vesselSpeedConsumption: VesselSpeedConsumptionInput;
};

/** The output of our create `VesselSpeedConsumption` mutation. */
export type CreateVesselSpeedConsumptionPayload = {
  __typename?: 'CreateVesselSpeedConsumptionPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `VesselSpeedConsumption`. */
  bunkerGradeOverrideByBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselSpeedConsumption`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselSpeedConsumption`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselSpeedConsumption`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselSpeedConsumption` that was created by this mutation. */
  vesselSpeedConsumption?: Maybe<VesselSpeedConsumption>;
  /** An edge for our `VesselSpeedConsumption`. May be used by Relay 1. */
  vesselSpeedConsumptionEdge?: Maybe<VesselSpeedConsumptionsEdge>;
};


/** The output of our create `VesselSpeedConsumption` mutation. */
export type CreateVesselSpeedConsumptionPayloadVesselSpeedConsumptionEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselSpeedConsumptionsOrderBy>>;
};

/** All input for the create `VoyageAssociation` mutation. */
export type CreateVoyageAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageAssociation` to be created by this mutation. */
  voyageAssociation: VoyageAssociationInput;
};

/** The output of our create `VoyageAssociation` mutation. */
export type CreateVoyageAssociationPayload = {
  __typename?: 'CreateVoyageAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `VoyageAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageAssociation` that was created by this mutation. */
  voyageAssociation?: Maybe<VoyageAssociation>;
  /** An edge for our `VoyageAssociation`. May be used by Relay 1. */
  voyageAssociationEdge?: Maybe<VoyageAssociationsEdge>;
  /** Reads a single `Voyage` that is related to this `VoyageAssociation`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our create `VoyageAssociation` mutation. */
export type CreateVoyageAssociationPayloadVoyageAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageAssociationsOrderBy>>;
};

/** All input for the create `VoyageAttribute` mutation. */
export type CreateVoyageAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageAttribute` to be created by this mutation. */
  voyageAttribute: VoyageAttributeInput;
};

/** The output of our create `VoyageAttribute` mutation. */
export type CreateVoyageAttributePayload = {
  __typename?: 'CreateVoyageAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageAttribute`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageAttribute` that was created by this mutation. */
  voyageAttribute?: Maybe<VoyageAttribute>;
  /** An edge for our `VoyageAttribute`. May be used by Relay 1. */
  voyageAttributeEdge?: Maybe<VoyageAttributesEdge>;
};


/** The output of our create `VoyageAttribute` mutation. */
export type CreateVoyageAttributePayloadVoyageAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageAttributesOrderBy>>;
};

/** All input for the create `VoyageCharterExtraCost` mutation. */
export type CreateVoyageCharterExtraCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageCharterExtraCost` to be created by this mutation. */
  voyageCharterExtraCost: VoyageCharterExtraCostInput;
};

/** The output of our create `VoyageCharterExtraCost` mutation. */
export type CreateVoyageCharterExtraCostPayload = {
  __typename?: 'CreateVoyageCharterExtraCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterExtraCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterExtraCost` that was created by this mutation. */
  voyageCharterExtraCost?: Maybe<VoyageCharterExtraCost>;
  /** An edge for our `VoyageCharterExtraCost`. May be used by Relay 1. */
  voyageCharterExtraCostEdge?: Maybe<VoyageCharterExtraCostsEdge>;
};


/** The output of our create `VoyageCharterExtraCost` mutation. */
export type CreateVoyageCharterExtraCostPayloadVoyageCharterExtraCostEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterExtraCostsOrderBy>>;
};

/** All input for the create `VoyageCharterExtraFreight` mutation. */
export type CreateVoyageCharterExtraFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageCharterExtraFreight` to be created by this mutation. */
  voyageCharterExtraFreight: VoyageCharterExtraFreightInput;
};

/** The output of our create `VoyageCharterExtraFreight` mutation. */
export type CreateVoyageCharterExtraFreightPayload = {
  __typename?: 'CreateVoyageCharterExtraFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterExtraFreight`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterExtraFreight` that was created by this mutation. */
  voyageCharterExtraFreight?: Maybe<VoyageCharterExtraFreight>;
  /** An edge for our `VoyageCharterExtraFreight`. May be used by Relay 1. */
  voyageCharterExtraFreightEdge?: Maybe<VoyageCharterExtraFreightsEdge>;
};


/** The output of our create `VoyageCharterExtraFreight` mutation. */
export type CreateVoyageCharterExtraFreightPayloadVoyageCharterExtraFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterExtraFreightsOrderBy>>;
};

/** All input for the create `VoyageCharter` mutation. */
export type CreateVoyageCharterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageCharter` to be created by this mutation. */
  voyageCharter: VoyageCharterInput;
};

/** All input for the create `VoyageCharterOrderFreight` mutation. */
export type CreateVoyageCharterOrderFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageCharterOrderFreight` to be created by this mutation. */
  voyageCharterOrderFreight: VoyageCharterOrderFreightInput;
};

/** The output of our create `VoyageCharterOrderFreight` mutation. */
export type CreateVoyageCharterOrderFreightPayload = {
  __typename?: 'CreateVoyageCharterOrderFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `OrderVoyageCharterRelation` that is related to this `VoyageCharterOrderFreight`. */
  orderVoyageCharterRelationByOrderVoyageCharterRelationId?: Maybe<OrderVoyageCharterRelation>;
  /** Reads a single `Organization` that is related to this `VoyageCharterOrderFreight`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VoyageCharterOrderFreight`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VoyageCharterOrderFreight` that was created by this mutation. */
  voyageCharterOrderFreight?: Maybe<VoyageCharterOrderFreight>;
  /** An edge for our `VoyageCharterOrderFreight`. May be used by Relay 1. */
  voyageCharterOrderFreightEdge?: Maybe<VoyageCharterOrderFreightsEdge>;
};


/** The output of our create `VoyageCharterOrderFreight` mutation. */
export type CreateVoyageCharterOrderFreightPayloadVoyageCharterOrderFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterOrderFreightsOrderBy>>;
};

/** The output of our create `VoyageCharter` mutation. */
export type CreateVoyageCharterPayload = {
  __typename?: 'CreateVoyageCharterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `LostContract` that is related to this `VoyageCharter`. */
  lostContractByLostContractsId?: Maybe<LostContract>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VoyageCharter`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VoyageCharter`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VoyageCharter` that was created by this mutation. */
  voyageCharter?: Maybe<VoyageCharter>;
  /** An edge for our `VoyageCharter`. May be used by Relay 1. */
  voyageCharterEdge?: Maybe<VoyageChartersEdge>;
};


/** The output of our create `VoyageCharter` mutation. */
export type CreateVoyageCharterPayloadVoyageCharterEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};

/** All input for the create `VoyageCharterPortCost` mutation. */
export type CreateVoyageCharterPortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageCharterPortCost` to be created by this mutation. */
  voyageCharterPortCost: VoyageCharterPortCostInput;
};

/** The output of our create `VoyageCharterPortCost` mutation. */
export type CreateVoyageCharterPortCostPayload = {
  __typename?: 'CreateVoyageCharterPortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PortCost` that is related to this `VoyageCharterPortCost`. */
  portCostByPortCostId?: Maybe<PortCost>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterPortCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterPortCost` that was created by this mutation. */
  voyageCharterPortCost?: Maybe<VoyageCharterPortCost>;
  /** An edge for our `VoyageCharterPortCost`. May be used by Relay 1. */
  voyageCharterPortCostEdge?: Maybe<VoyageCharterPortCostsEdge>;
};


/** The output of our create `VoyageCharterPortCost` mutation. */
export type CreateVoyageCharterPortCostPayloadVoyageCharterPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterPortCostsOrderBy>>;
};

/** All input for the create `VoyageCharterPortDatum` mutation. */
export type CreateVoyageCharterPortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageCharterPortDatum` to be created by this mutation. */
  voyageCharterPortDatum: VoyageCharterPortDatumInput;
};

/** The output of our create `VoyageCharterPortDatum` mutation. */
export type CreateVoyageCharterPortDatumPayload = {
  __typename?: 'CreateVoyageCharterPortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageCharterPortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortDatum` that is related to this `VoyageCharterPortDatum`. */
  portDatumByPortDataId?: Maybe<PortDatum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VoyageCharterPortDatum`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterPortDatum`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterPortDatum` that was created by this mutation. */
  voyageCharterPortDatum?: Maybe<VoyageCharterPortDatum>;
  /** An edge for our `VoyageCharterPortDatum`. May be used by Relay 1. */
  voyageCharterPortDatumEdge?: Maybe<VoyageCharterPortDataEdge>;
};


/** The output of our create `VoyageCharterPortDatum` mutation. */
export type CreateVoyageCharterPortDatumPayloadVoyageCharterPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterPortDataOrderBy>>;
};

/** All input for the create `VoyageCharterToContract` mutation. */
export type CreateVoyageCharterToContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageCharterToContract` to be created by this mutation. */
  voyageCharterToContract: VoyageCharterToContractInput;
};

/** The output of our create `VoyageCharterToContract` mutation. */
export type CreateVoyageCharterToContractPayload = {
  __typename?: 'CreateVoyageCharterToContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `VoyageCharterToContract`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  /** Reads a single `Organization` that is related to this `VoyageCharterToContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpotNegotiation` that is related to this `VoyageCharterToContract`. */
  spotNegotiationBySpotNegotiationId?: Maybe<SpotNegotiation>;
  /** Reads a single `User` that is related to this `VoyageCharterToContract`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VoyageCharterToContract`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterToContract`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterToContract` that was created by this mutation. */
  voyageCharterToContract?: Maybe<VoyageCharterToContract>;
  /** An edge for our `VoyageCharterToContract`. May be used by Relay 1. */
  voyageCharterToContractEdge?: Maybe<VoyageCharterToContractsEdge>;
};


/** The output of our create `VoyageCharterToContract` mutation. */
export type CreateVoyageCharterToContractPayloadVoyageCharterToContractEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};

/** All input for the create `VoyageCharterUpdate` mutation. */
export type CreateVoyageCharterUpdateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageCharterUpdate` to be created by this mutation. */
  voyageCharterUpdate: VoyageCharterUpdateInput;
};

/** The output of our create `VoyageCharterUpdate` mutation. */
export type CreateVoyageCharterUpdatePayload = {
  __typename?: 'CreateVoyageCharterUpdatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageCharterUpdate`. */
  organizationByCreatedByOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VoyageCharterUpdate`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VoyageCharterUpdate`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VoyageCharterUpdate`. */
  userByRejectedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterUpdate`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterUpdate` that was created by this mutation. */
  voyageCharterUpdate?: Maybe<VoyageCharterUpdate>;
  /** An edge for our `VoyageCharterUpdate`. May be used by Relay 1. */
  voyageCharterUpdateEdge?: Maybe<VoyageCharterUpdatesEdge>;
};


/** The output of our create `VoyageCharterUpdate` mutation. */
export type CreateVoyageCharterUpdatePayloadVoyageCharterUpdateEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};

/** All input for the create `Voyage` mutation. */
export type CreateVoyageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Voyage` to be created by this mutation. */
  voyage: VoyageInput;
};

/** All input for the create `VoyageNamingRule` mutation. */
export type CreateVoyageNamingRuleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VoyageNamingRule` to be created by this mutation. */
  voyageNamingRule: VoyageNamingRuleInput;
};

/** The output of our create `VoyageNamingRule` mutation. */
export type CreateVoyageNamingRulePayload = {
  __typename?: 'CreateVoyageNamingRulePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageNamingRule`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageNamingRule` that was created by this mutation. */
  voyageNamingRule?: Maybe<VoyageNamingRule>;
  /** An edge for our `VoyageNamingRule`. May be used by Relay 1. */
  voyageNamingRuleEdge?: Maybe<VoyageNamingRulesEdge>;
};


/** The output of our create `VoyageNamingRule` mutation. */
export type CreateVoyageNamingRulePayloadVoyageNamingRuleEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageNamingRulesOrderBy>>;
};

/** The output of our create `Voyage` mutation. */
export type CreateVoyagePayload = {
  __typename?: 'CreateVoyagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Voyage`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `Voyage`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `Voyage` that was created by this mutation. */
  voyage?: Maybe<Voyage>;
  /** An edge for our `Voyage`. May be used by Relay 1. */
  voyageEdge?: Maybe<VoyagesEdge>;
};


/** The output of our create `Voyage` mutation. */
export type CreateVoyagePayloadVoyageEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyagesOrderBy>>;
};

/** All input for the create `VwHandledBySpotShipOwnerPg` mutation. */
export type CreateVwHandledBySpotShipOwnerPgInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VwHandledBySpotShipOwnerPg` to be created by this mutation. */
  vwHandledBySpotShipOwnerPg: VwHandledBySpotShipOwnerPgInput;
};

/** The output of our create `VwHandledBySpotShipOwnerPg` mutation. */
export type CreateVwHandledBySpotShipOwnerPgPayload = {
  __typename?: 'CreateVwHandledBySpotShipOwnerPgPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VwHandledBySpotShipOwnerPg` that was created by this mutation. */
  vwHandledBySpotShipOwnerPg?: Maybe<VwHandledBySpotShipOwnerPg>;
  /** An edge for our `VwHandledBySpotShipOwnerPg`. May be used by Relay 1. */
  vwHandledBySpotShipOwnerPgEdge?: Maybe<VwHandledBySpotShipOwnerPgsEdge>;
};


/** The output of our create `VwHandledBySpotShipOwnerPg` mutation. */
export type CreateVwHandledBySpotShipOwnerPgPayloadVwHandledBySpotShipOwnerPgEdgeArgs = {
  orderBy?: InputMaybe<Array<VwHandledBySpotShipOwnerPgsOrderBy>>;
};

/** All input for the create `VwVoyageCharterShipownerNonfinancial` mutation. */
export type CreateVwVoyageCharterShipownerNonfinancialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `VwVoyageCharterShipownerNonfinancial` to be created by this mutation. */
  vwVoyageCharterShipownerNonfinancial: VwVoyageCharterShipownerNonfinancialInput;
};

/** The output of our create `VwVoyageCharterShipownerNonfinancial` mutation. */
export type CreateVwVoyageCharterShipownerNonfinancialPayload = {
  __typename?: 'CreateVwVoyageCharterShipownerNonfinancialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VwVoyageCharterShipownerNonfinancial` that was created by this mutation. */
  vwVoyageCharterShipownerNonfinancial?: Maybe<VwVoyageCharterShipownerNonfinancial>;
  /** An edge for our `VwVoyageCharterShipownerNonfinancial`. May be used by Relay 1. */
  vwVoyageCharterShipownerNonfinancialEdge?: Maybe<VwVoyageCharterShipownerNonfinancialsEdge>;
};


/** The output of our create `VwVoyageCharterShipownerNonfinancial` mutation. */
export type CreateVwVoyageCharterShipownerNonfinancialPayloadVwVoyageCharterShipownerNonfinancialEdgeArgs = {
  orderBy?: InputMaybe<Array<VwVoyageCharterShipownerNonfinancialsOrderBy>>;
};

/** All input for the create `WorldscaleFreight` mutation. */
export type CreateWorldscaleFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `WorldscaleFreight` to be created by this mutation. */
  worldscaleFreight: WorldscaleFreightInput;
};

/** The output of our create `WorldscaleFreight` mutation. */
export type CreateWorldscaleFreightPayload = {
  __typename?: 'CreateWorldscaleFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `WorldscaleFreight`. */
  locationByFromLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `WorldscaleFreight`. */
  locationByToLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `WorldscaleFreight`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WorldscaleFreight` that was created by this mutation. */
  worldscaleFreight?: Maybe<WorldscaleFreight>;
  /** An edge for our `WorldscaleFreight`. May be used by Relay 1. */
  worldscaleFreightEdge?: Maybe<WorldscaleFreightsEdge>;
};


/** The output of our create `WorldscaleFreight` mutation. */
export type CreateWorldscaleFreightPayloadWorldscaleFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<WorldscaleFreightsOrderBy>>;
};

/** All input for the create `Zone` mutation. */
export type CreateZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Zone` to be created by this mutation. */
  zone: ZoneInput;
};

/** All input for the create `ZoneLocation` mutation. */
export type CreateZoneLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ZoneLocation` to be created by this mutation. */
  zoneLocation: ZoneLocationInput;
};

/** The output of our create `ZoneLocation` mutation. */
export type CreateZoneLocationPayload = {
  __typename?: 'CreateZoneLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `ZoneLocation`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `ZoneLocation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneLocation`. */
  zoneByZoneId?: Maybe<Zone>;
  /** The `ZoneLocation` that was created by this mutation. */
  zoneLocation?: Maybe<ZoneLocation>;
  /** An edge for our `ZoneLocation`. May be used by Relay 1. */
  zoneLocationEdge?: Maybe<ZoneLocationsEdge>;
};


/** The output of our create `ZoneLocation` mutation. */
export type CreateZoneLocationPayloadZoneLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneLocationsOrderBy>>;
};

/** The output of our create `Zone` mutation. */
export type CreateZonePayload = {
  __typename?: 'CreateZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Zone`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Zone` that was created by this mutation. */
  zone?: Maybe<Zone>;
  /** An edge for our `Zone`. May be used by Relay 1. */
  zoneEdge?: Maybe<ZonesEdge>;
};


/** The output of our create `Zone` mutation. */
export type CreateZonePayloadZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

export type CreatedOrExisting = {
  created?: InputMaybe<Scalars['Int']['input']>;
  existing?: InputMaybe<Scalars['Int']['input']>;
};

export enum Currency {
  AUD = 'AUD',
  BRL = 'BRL',
  BZD = 'BZD',
  CAD = 'CAD',
  CLP = 'CLP',
  CNY = 'CNY',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  INR = 'INR',
  ISK = 'ISK',
  JPY = 'JPY',
  KRW = 'KRW',
  MAD = 'MAD',
  MXN = 'MXN',
  MYR = 'MYR',
  NAD = 'NAD',
  NOK = 'NOK',
  NZD = 'NZD',
  PLN = 'PLN',
  RUB = 'RUB',
  SEK = 'SEK',
  SGD = 'SGD',
  TND = 'TND',
  TWD = 'TWD',
  USD = 'USD',
  XOF = 'XOF',
  ZAR = 'ZAR'
}

export type CurrencyApi = {
  __typename?: 'CurrencyAPI';
  baseCurrency?: Maybe<Currency>;
  message?: Maybe<Scalars['String']['output']>;
  rates?: Maybe<Array<Maybe<CurrencyApiRate>>>;
};

export type CurrencyApiRate = {
  __typename?: 'CurrencyApiRate';
  code: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** A filter to be used against Currency fields. All fields are combined with a logical ‘and.’ */
export type CurrencyFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Currency>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Currency>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Currency>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Currency>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Currency>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Currency>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Currency>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Currency>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Currency>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Currency>>;
};

/** All input for the `currentOrgId` mutation. */
export type CurrentOrgIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `currentOrgId` mutation. */
export type CurrentOrgIdPayload = {
  __typename?: 'CurrentOrgIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type CurrentOrganization = {
  __typename?: 'CurrentOrganization';
  organizationId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `CurrentOrganization` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CurrentOrganizationCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `CurrentOrganization` object types. All fields are combined with a logical ‘and.’ */
export type CurrentOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CurrentOrganizationFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<CurrentOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CurrentOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CurrentOrganization` */
export type CurrentOrganizationInput = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `CurrentOrganization` values. */
export type CurrentOrganizationsConnection = {
  __typename?: 'CurrentOrganizationsConnection';
  /** A list of edges which contains the `CurrentOrganization` and cursor to aid in pagination. */
  edges: Array<CurrentOrganizationsEdge>;
  /** A list of `CurrentOrganization` objects. */
  nodes: Array<Maybe<CurrentOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CurrentOrganization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CurrentOrganization` edge in the connection. */
export type CurrentOrganizationsEdge = {
  __typename?: 'CurrentOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CurrentOrganization` at the end of the edge. */
  node?: Maybe<CurrentOrganization>;
};

/** Methods to use when ordering `CurrentOrganization`. */
export enum CurrentOrganizationsOrderBy {
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC'
}

/** All input for the `currentUserCanAdminOrg` mutation. */
export type CurrentUserCanAdminOrgInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `currentUserCanAdminOrg` mutation. */
export type CurrentUserCanAdminOrgPayload = {
  __typename?: 'CurrentUserCanAdminOrgPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `currentUserId` mutation. */
export type CurrentUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `currentUserId` mutation. */
export type CurrentUserIdPayload = {
  __typename?: 'CurrentUserIdPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** A range of `Date`. */
export type DateRange = {
  __typename?: 'DateRange';
  /** The ending bound of our range. */
  end?: Maybe<DateRangeBound>;
  /** The starting bound of our range. */
  start?: Maybe<DateRangeBound>;
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DateRangeBound = {
  __typename?: 'DateRangeBound';
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean']['output'];
  /** The value at one end of our range. */
  value: Scalars['Date']['output'];
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DateRangeBoundInput = {
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean']['input'];
  /** The value at one end of our range. */
  value: Scalars['Date']['input'];
};

/** A filter to be used against DateRange fields. All fields are combined with a logical ‘and.’ */
export type DateRangeFilter = {
  /** Adjacent to the specified range. */
  adjacentTo?: InputMaybe<DateRangeInput>;
  /** Contained by the specified range. */
  containedBy?: InputMaybe<DateRangeInput>;
  /** Contains the specified range. */
  contains?: InputMaybe<DateRangeInput>;
  /** Contains the specified value. */
  containsElement?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DateRangeInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DateRangeInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DateRangeInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DateRangeInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DateRangeInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DateRangeInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DateRangeInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DateRangeInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DateRangeInput>;
  /** Does not extend left of the specified range. */
  notExtendsLeftOf?: InputMaybe<DateRangeInput>;
  /** Does not extend right of the specified range. */
  notExtendsRightOf?: InputMaybe<DateRangeInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DateRangeInput>>;
  /** Overlaps the specified range. */
  overlaps?: InputMaybe<DateRangeInput>;
  /** Strictly left of the specified range. */
  strictlyLeftOf?: InputMaybe<DateRangeInput>;
  /** Strictly right of the specified range. */
  strictlyRightOf?: InputMaybe<DateRangeInput>;
};

/** A range of `Date`. */
export type DateRangeInput = {
  /** The ending bound of our range. */
  end?: InputMaybe<DateRangeBoundInput>;
  /** The starting bound of our range. */
  start?: InputMaybe<DateRangeBoundInput>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** A range of `Datetime`. */
export type DatetimeRange = {
  __typename?: 'DatetimeRange';
  /** The ending bound of our range. */
  end?: Maybe<DatetimeRangeBound>;
  /** The starting bound of our range. */
  start?: Maybe<DatetimeRangeBound>;
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DatetimeRangeBound = {
  __typename?: 'DatetimeRangeBound';
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean']['output'];
  /** The value at one end of our range. */
  value: Scalars['Datetime']['output'];
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DatetimeRangeBoundInput = {
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean']['input'];
  /** The value at one end of our range. */
  value: Scalars['Datetime']['input'];
};

/** A filter to be used against DatetimeRange fields. All fields are combined with a logical ‘and.’ */
export type DatetimeRangeFilter = {
  /** Adjacent to the specified range. */
  adjacentTo?: InputMaybe<DatetimeRangeInput>;
  /** Contained by the specified range. */
  containedBy?: InputMaybe<DatetimeRangeInput>;
  /** Contains the specified range. */
  contains?: InputMaybe<DatetimeRangeInput>;
  /** Contains the specified value. */
  containsElement?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DatetimeRangeInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DatetimeRangeInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DatetimeRangeInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DatetimeRangeInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DatetimeRangeInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DatetimeRangeInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Does not extend left of the specified range. */
  notExtendsLeftOf?: InputMaybe<DatetimeRangeInput>;
  /** Does not extend right of the specified range. */
  notExtendsRightOf?: InputMaybe<DatetimeRangeInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DatetimeRangeInput>>;
  /** Overlaps the specified range. */
  overlaps?: InputMaybe<DatetimeRangeInput>;
  /** Strictly left of the specified range. */
  strictlyLeftOf?: InputMaybe<DatetimeRangeInput>;
  /** Strictly right of the specified range. */
  strictlyRightOf?: InputMaybe<DatetimeRangeInput>;
};

/** A range of `Datetime`. */
export type DatetimeRangeInput = {
  /** The ending bound of our range. */
  end?: InputMaybe<DatetimeRangeBoundInput>;
  /** The starting bound of our range. */
  start?: InputMaybe<DatetimeRangeBoundInput>;
};

export type DbChange = Node & {
  __typename?: 'DbChange';
  createdAt: Scalars['Datetime']['output'];
  deletedBillOfLadingData?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deletedCargoCompartmentAllocation?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deletedCargoExclusion?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deletedCargoMeasurement?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deletedNotificationReceivers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deletedOrderPortCallRelation?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deletedOrderVoyageCharterRelation?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id: Scalars['DbChangeId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `DbChange`. */
  organizationByRootOrg?: Maybe<Organization>;
  rootOrg: Scalars['OrganizationId']['output'];
  softDeletedOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Reads a single `User` that is related to this `DbChange`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
};

/**
 * A condition to be used against `DbChange` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DbChangeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deletedBillOfLadingData` field. */
  deletedBillOfLadingData?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `deletedCargoCompartmentAllocation` field. */
  deletedCargoCompartmentAllocation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `deletedCargoExclusion` field. */
  deletedCargoExclusion?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `deletedCargoMeasurement` field. */
  deletedCargoMeasurement?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `deletedNotificationReceivers` field. */
  deletedNotificationReceivers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `deletedOrderPortCallRelation` field. */
  deletedOrderPortCallRelation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `deletedOrderVoyageCharterRelation` field. */
  deletedOrderVoyageCharterRelation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['DbChangeId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `softDeletedOrders` field. */
  softDeletedOrders?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `DbChange` object types. All fields are combined with a logical ‘and.’ */
export type DbChangeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DbChangeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deletedBillOfLadingData` field. */
  deletedBillOfLadingData?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `deletedCargoCompartmentAllocation` field. */
  deletedCargoCompartmentAllocation?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `deletedCargoExclusion` field. */
  deletedCargoExclusion?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `deletedCargoMeasurement` field. */
  deletedCargoMeasurement?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `deletedNotificationReceivers` field. */
  deletedNotificationReceivers?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `deletedOrderPortCallRelation` field. */
  deletedOrderPortCallRelation?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `deletedOrderVoyageCharterRelation` field. */
  deletedOrderVoyageCharterRelation?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DbChangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DbChangeFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softDeletedOrders` field. */
  softDeletedOrders?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `DbChange` */
export type DbChangeInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedBillOfLadingData?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedCargoCompartmentAllocation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedCargoExclusion?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedCargoMeasurement?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedNotificationReceivers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedOrderPortCallRelation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedOrderVoyageCharterRelation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  softDeletedOrders?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `DbChange`. Fields that are set will be updated. */
export type DbChangePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedBillOfLadingData?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedCargoCompartmentAllocation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedCargoExclusion?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedCargoMeasurement?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedNotificationReceivers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedOrderPortCallRelation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deletedOrderVoyageCharterRelation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  softDeletedOrders?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

export type DbChangeSubscriptionPayload = {
  __typename?: 'DbChangeSubscriptionPayload';
  dbChange?: Maybe<DbChange>;
  event?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `DbChange` values. */
export type DbChangesConnection = {
  __typename?: 'DbChangesConnection';
  /** A list of edges which contains the `DbChange` and cursor to aid in pagination. */
  edges: Array<DbChangesEdge>;
  /** A list of `DbChange` objects. */
  nodes: Array<Maybe<DbChange>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DbChange` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DbChange` edge in the connection. */
export type DbChangesEdge = {
  __typename?: 'DbChangesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DbChange` at the end of the edge. */
  node?: Maybe<DbChange>;
};

/** Methods to use when ordering `DbChange`. */
export enum DbChangesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELETED_BILL_OF_LADING_DATA_ASC = 'DELETED_BILL_OF_LADING_DATA_ASC',
  DELETED_BILL_OF_LADING_DATA_DESC = 'DELETED_BILL_OF_LADING_DATA_DESC',
  DELETED_CARGO_COMPARTMENT_ALLOCATION_ASC = 'DELETED_CARGO_COMPARTMENT_ALLOCATION_ASC',
  DELETED_CARGO_COMPARTMENT_ALLOCATION_DESC = 'DELETED_CARGO_COMPARTMENT_ALLOCATION_DESC',
  DELETED_CARGO_EXCLUSION_ASC = 'DELETED_CARGO_EXCLUSION_ASC',
  DELETED_CARGO_EXCLUSION_DESC = 'DELETED_CARGO_EXCLUSION_DESC',
  DELETED_CARGO_MEASUREMENT_ASC = 'DELETED_CARGO_MEASUREMENT_ASC',
  DELETED_CARGO_MEASUREMENT_DESC = 'DELETED_CARGO_MEASUREMENT_DESC',
  DELETED_NOTIFICATION_RECEIVERS_ASC = 'DELETED_NOTIFICATION_RECEIVERS_ASC',
  DELETED_NOTIFICATION_RECEIVERS_DESC = 'DELETED_NOTIFICATION_RECEIVERS_DESC',
  DELETED_ORDER_PORT_CALL_RELATION_ASC = 'DELETED_ORDER_PORT_CALL_RELATION_ASC',
  DELETED_ORDER_PORT_CALL_RELATION_DESC = 'DELETED_ORDER_PORT_CALL_RELATION_DESC',
  DELETED_ORDER_VOYAGE_CHARTER_RELATION_ASC = 'DELETED_ORDER_VOYAGE_CHARTER_RELATION_ASC',
  DELETED_ORDER_VOYAGE_CHARTER_RELATION_DESC = 'DELETED_ORDER_VOYAGE_CHARTER_RELATION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SOFT_DELETED_ORDERS_ASC = 'SOFT_DELETED_ORDERS_ASC',
  SOFT_DELETED_ORDERS_DESC = 'SOFT_DELETED_ORDERS_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** All input for the `deleteActualCostById` mutation. */
export type DeleteActualCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ActualCostId']['input'];
};

/** All input for the `deleteActualCost` mutation. */
export type DeleteActualCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActualCost` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ActualCost` mutation. */
export type DeleteActualCostPayload = {
  __typename?: 'DeleteActualCostPayload';
  /** The `ActualCost` that was deleted by this mutation. */
  actualCost?: Maybe<ActualCost>;
  /** An edge for our `ActualCost`. May be used by Relay 1. */
  actualCostEdge?: Maybe<ActualCostsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedActualCostId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `ActualCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our delete `ActualCost` mutation. */
export type DeleteActualCostPayloadActualCostEdgeArgs = {
  orderBy?: InputMaybe<Array<ActualCostsOrderBy>>;
};

/** All input for the `deleteApiOrderByExternalOrderId` mutation. */
export type DeleteApiOrderByExternalOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalOrderId: Scalars['String']['input'];
};

/** All input for the `deleteApiOrder` mutation. */
export type DeleteApiOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ApiOrder` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ApiOrder` mutation. */
export type DeleteApiOrderPayload = {
  __typename?: 'DeleteApiOrderPayload';
  /** The `ApiOrder` that was deleted by this mutation. */
  apiOrder?: Maybe<ApiOrder>;
  /** An edge for our `ApiOrder`. May be used by Relay 1. */
  apiOrderEdge?: Maybe<ApiOrdersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedApiOrderId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ApiOrder` mutation. */
export type DeleteApiOrderPayloadApiOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ApiOrdersOrderBy>>;
};

/** All input for the `deleteApiOrdersNoticeById` mutation. */
export type DeleteApiOrdersNoticeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ApiOrdersNoticeId']['input'];
};

/** All input for the `deleteApiOrdersNotice` mutation. */
export type DeleteApiOrdersNoticeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ApiOrdersNotice` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ApiOrdersNotice` mutation. */
export type DeleteApiOrdersNoticePayload = {
  __typename?: 'DeleteApiOrdersNoticePayload';
  /** The `ApiOrdersNotice` that was deleted by this mutation. */
  apiOrdersNotice?: Maybe<ApiOrdersNotice>;
  /** An edge for our `ApiOrdersNotice`. May be used by Relay 1. */
  apiOrdersNoticeEdge?: Maybe<ApiOrdersNoticesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedApiOrdersNoticeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `ApiOrdersNotice`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `ApiOrdersNotice`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ApiOrdersNotice` mutation. */
export type DeleteApiOrdersNoticePayloadApiOrdersNoticeEdgeArgs = {
  orderBy?: InputMaybe<Array<ApiOrdersNoticesOrderBy>>;
};

/** All input for the `deleteAssortmentById` mutation. */
export type DeleteAssortmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['AssortmentId']['input'];
};

/** All input for the `deleteAssortmentExclusionById` mutation. */
export type DeleteAssortmentExclusionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['AssortmentExclusionId']['input'];
};

/** All input for the `deleteAssortmentExclusion` mutation. */
export type DeleteAssortmentExclusionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AssortmentExclusion` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `AssortmentExclusion` mutation. */
export type DeleteAssortmentExclusionPayload = {
  __typename?: 'DeleteAssortmentExclusionPayload';
  /** Reads a single `Assortment` that is related to this `AssortmentExclusion`. */
  assortmentByNextAssortment?: Maybe<Assortment>;
  /** Reads a single `Assortment` that is related to this `AssortmentExclusion`. */
  assortmentByPreviousAssortment?: Maybe<Assortment>;
  /** The `AssortmentExclusion` that was deleted by this mutation. */
  assortmentExclusion?: Maybe<AssortmentExclusion>;
  /** An edge for our `AssortmentExclusion`. May be used by Relay 1. */
  assortmentExclusionEdge?: Maybe<AssortmentExclusionsEdge>;
  /** Reads a single `AssortmentGroup` that is related to this `AssortmentExclusion`. */
  assortmentGroupByNextAssortmentGroup?: Maybe<AssortmentGroup>;
  /** Reads a single `AssortmentGroup` that is related to this `AssortmentExclusion`. */
  assortmentGroupByPreviousAssortmentGroup?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAssortmentExclusionId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VesselAttribute` that is related to this `AssortmentExclusion`. */
  vesselAttributeByVesselCostClassId?: Maybe<VesselAttribute>;
};


/** The output of our delete `AssortmentExclusion` mutation. */
export type DeleteAssortmentExclusionPayloadAssortmentExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};

/** All input for the `deleteAssortmentGroupById` mutation. */
export type DeleteAssortmentGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['AssortmentGroupId']['input'];
};

/** All input for the `deleteAssortmentGroup` mutation. */
export type DeleteAssortmentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AssortmentGroup` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `AssortmentGroup` mutation. */
export type DeleteAssortmentGroupPayload = {
  __typename?: 'DeleteAssortmentGroupPayload';
  /** The `AssortmentGroup` that was deleted by this mutation. */
  assortmentGroup?: Maybe<AssortmentGroup>;
  /** An edge for our `AssortmentGroup`. May be used by Relay 1. */
  assortmentGroupEdge?: Maybe<AssortmentGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAssortmentGroupId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `AssortmentGroup`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `AssortmentGroup`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `AssortmentGroup` mutation. */
export type DeleteAssortmentGroupPayloadAssortmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentGroupsOrderBy>>;
};

/** All input for the `deleteAssortment` mutation. */
export type DeleteAssortmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Assortment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Assortment` mutation. */
export type DeleteAssortmentPayload = {
  __typename?: 'DeleteAssortmentPayload';
  /** The `Assortment` that was deleted by this mutation. */
  assortment?: Maybe<Assortment>;
  /** An edge for our `Assortment`. May be used by Relay 1. */
  assortmentEdge?: Maybe<AssortmentsEdge>;
  /** Reads a single `AssortmentGroup` that is related to this `Assortment`. */
  assortmentGroupByAssortmentGroup?: Maybe<AssortmentGroup>;
  /** Reads a single `CargoUnit` that is related to this `Assortment`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedAssortmentId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Assortment`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Assortment` mutation. */
export type DeleteAssortmentPayloadAssortmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};

/** All input for the `deleteBatchUpdateById` mutation. */
export type DeleteBatchUpdateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BatchUpdateId']['input'];
};

/** All input for the `deleteBatchUpdate` mutation. */
export type DeleteBatchUpdateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BatchUpdate` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `BatchUpdate` mutation. */
export type DeleteBatchUpdatePayload = {
  __typename?: 'DeleteBatchUpdatePayload';
  /** The `BatchUpdate` that was deleted by this mutation. */
  batchUpdate?: Maybe<BatchUpdate>;
  /** An edge for our `BatchUpdate`. May be used by Relay 1. */
  batchUpdateEdge?: Maybe<BatchUpdatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBatchUpdateId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `BatchUpdate`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BatchUpdate` mutation. */
export type DeleteBatchUpdatePayloadBatchUpdateEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchUpdatesOrderBy>>;
};

/** All input for the `deleteBillOfLadingById` mutation. */
export type DeleteBillOfLadingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BillOfLadingId']['input'];
};

/** All input for the `deleteBillOfLadingDatumById` mutation. */
export type DeleteBillOfLadingDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BillOfLadingDatumId']['input'];
};

/** All input for the `deleteBillOfLadingDatum` mutation. */
export type DeleteBillOfLadingDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BillOfLadingDatum` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `BillOfLadingDatum` mutation. */
export type DeleteBillOfLadingDatumPayload = {
  __typename?: 'DeleteBillOfLadingDatumPayload';
  /** Reads a single `BillOfLading` that is related to this `BillOfLadingDatum`. */
  billOfLadingByBillOfLadingId?: Maybe<BillOfLading>;
  /** The `BillOfLadingDatum` that was deleted by this mutation. */
  billOfLadingDatum?: Maybe<BillOfLadingDatum>;
  /** An edge for our `BillOfLadingDatum`. May be used by Relay 1. */
  billOfLadingDatumEdge?: Maybe<BillOfLadingDataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBillOfLadingDatumId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `BillOfLadingDatum`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BillOfLadingDatum` mutation. */
export type DeleteBillOfLadingDatumPayloadBillOfLadingDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<BillOfLadingDataOrderBy>>;
};

/** All input for the `deleteBillOfLading` mutation. */
export type DeleteBillOfLadingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BillOfLading` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `BillOfLading` mutation. */
export type DeleteBillOfLadingPayload = {
  __typename?: 'DeleteBillOfLadingPayload';
  /** The `BillOfLading` that was deleted by this mutation. */
  billOfLading?: Maybe<BillOfLading>;
  /** An edge for our `BillOfLading`. May be used by Relay 1. */
  billOfLadingEdge?: Maybe<BillOfLadingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBillOfLadingId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `BillOfLading`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `BillOfLading`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `BillOfLading`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `BillOfLading`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our delete `BillOfLading` mutation. */
export type DeleteBillOfLadingPayloadBillOfLadingEdgeArgs = {
  orderBy?: InputMaybe<Array<BillOfLadingsOrderBy>>;
};

/** All input for the `deleteBunkerGradeCalculationById` mutation. */
export type DeleteBunkerGradeCalculationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BunkerGradeCalculationId']['input'];
};

/** All input for the `deleteBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeId` mutation. */
export type DeleteBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromGradeId: Scalars['BunkerGradeOverrideId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  toGradeId: Scalars['BunkerGradeOverrideId']['input'];
};

/** All input for the `deleteBunkerGradeCalculation` mutation. */
export type DeleteBunkerGradeCalculationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BunkerGradeCalculation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `BunkerGradeCalculation` mutation. */
export type DeleteBunkerGradeCalculationPayload = {
  __typename?: 'DeleteBunkerGradeCalculationPayload';
  /** The `BunkerGradeCalculation` that was deleted by this mutation. */
  bunkerGradeCalculation?: Maybe<BunkerGradeCalculation>;
  /** An edge for our `BunkerGradeCalculation`. May be used by Relay 1. */
  bunkerGradeCalculationEdge?: Maybe<BunkerGradeCalculationsEdge>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeCalculation`. */
  bunkerGradeOverrideByFromGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeCalculation`. */
  bunkerGradeOverrideByToGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBunkerGradeCalculationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeCalculation`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BunkerGradeCalculation` mutation. */
export type DeleteBunkerGradeCalculationPayloadBunkerGradeCalculationEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeCalculationsOrderBy>>;
};

/** All input for the `deleteBunkerGradeMappingById` mutation. */
export type DeleteBunkerGradeMappingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BunkerGradeMappingId']['input'];
};

/** All input for the `deleteBunkerGradeMappingByOrganizationIdAndFromGradeId` mutation. */
export type DeleteBunkerGradeMappingByOrganizationIdAndFromGradeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromGradeId: Scalars['BunkerGradeOverrideId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteBunkerGradeMapping` mutation. */
export type DeleteBunkerGradeMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BunkerGradeMapping` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `BunkerGradeMapping` mutation. */
export type DeleteBunkerGradeMappingPayload = {
  __typename?: 'DeleteBunkerGradeMappingPayload';
  /** The `BunkerGradeMapping` that was deleted by this mutation. */
  bunkerGradeMapping?: Maybe<BunkerGradeMapping>;
  /** An edge for our `BunkerGradeMapping`. May be used by Relay 1. */
  bunkerGradeMappingEdge?: Maybe<BunkerGradeMappingsEdge>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeMapping`. */
  bunkerGradeOverrideByFromGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeMapping`. */
  bunkerGradeOverrideByToGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBunkerGradeMappingId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeMapping`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BunkerGradeMapping` mutation. */
export type DeleteBunkerGradeMappingPayloadBunkerGradeMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeMappingsOrderBy>>;
};

/** All input for the `deleteBunkerGradeOverrideByGradeNameAndOrganizationId` mutation. */
export type DeleteBunkerGradeOverrideByGradeNameAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gradeName: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteBunkerGradeOverrideById` mutation. */
export type DeleteBunkerGradeOverrideByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BunkerGradeOverrideId']['input'];
};

/** All input for the `deleteBunkerGradeOverride` mutation. */
export type DeleteBunkerGradeOverrideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BunkerGradeOverride` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `BunkerGradeOverride` mutation. */
export type DeleteBunkerGradeOverridePayload = {
  __typename?: 'DeleteBunkerGradeOverridePayload';
  /** The `BunkerGradeOverride` that was deleted by this mutation. */
  bunkerGradeOverride?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeOverride`. */
  bunkerGradeOverrideByBlendComponent1Id?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeOverride`. */
  bunkerGradeOverrideByBlendComponent2Id?: Maybe<BunkerGradeOverride>;
  /** An edge for our `BunkerGradeOverride`. May be used by Relay 1. */
  bunkerGradeOverrideEdge?: Maybe<BunkerGradeOverridesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBunkerGradeOverrideId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeOverride`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `BunkerGradeOverride`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `BunkerGradeOverride`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our delete `BunkerGradeOverride` mutation. */
export type DeleteBunkerGradeOverridePayloadBunkerGradeOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};

/** All input for the `deleteBunkeringById` mutation. */
export type DeleteBunkeringByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BunkeringId']['input'];
};

/** All input for the `deleteBunkering` mutation. */
export type DeleteBunkeringInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Bunkering` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Bunkering` mutation. */
export type DeleteBunkeringPayload = {
  __typename?: 'DeleteBunkeringPayload';
  /** The `Bunkering` that was deleted by this mutation. */
  bunkering?: Maybe<Bunkering>;
  /** An edge for our `Bunkering`. May be used by Relay 1. */
  bunkeringEdge?: Maybe<BunkeringsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBunkeringId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `Bunkering`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Bunkering`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `Bunkering`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `Bunkering`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Bunkering` mutation. */
export type DeleteBunkeringPayloadBunkeringEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkeringsOrderBy>>;
};

/** All input for the `deleteCarbonPriceOverrideById` mutation. */
export type DeleteCarbonPriceOverrideByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CarbonPriceOverrideId']['input'];
};

/** All input for the `deleteCarbonPriceOverride` mutation. */
export type DeleteCarbonPriceOverrideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CarbonPriceOverride` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CarbonPriceOverride` mutation. */
export type DeleteCarbonPriceOverridePayload = {
  __typename?: 'DeleteCarbonPriceOverridePayload';
  /** The `CarbonPriceOverride` that was deleted by this mutation. */
  carbonPriceOverride?: Maybe<CarbonPriceOverride>;
  /** An edge for our `CarbonPriceOverride`. May be used by Relay 1. */
  carbonPriceOverrideEdge?: Maybe<CarbonPriceOverridesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCarbonPriceOverrideId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `CarbonPriceOverride`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CarbonPriceOverride` mutation. */
export type DeleteCarbonPriceOverridePayloadCarbonPriceOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<CarbonPriceOverridesOrderBy>>;
};

/** All input for the `deleteCargoCompartmentAllocationById` mutation. */
export type DeleteCargoCompartmentAllocationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoCompartmentAllocationId']['input'];
};

/** All input for the `deleteCargoCompartmentAllocation` mutation. */
export type DeleteCargoCompartmentAllocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoCompartmentAllocation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CargoCompartmentAllocation` mutation. */
export type DeleteCargoCompartmentAllocationPayload = {
  __typename?: 'DeleteCargoCompartmentAllocationPayload';
  /** The `CargoCompartmentAllocation` that was deleted by this mutation. */
  cargoCompartmentAllocation?: Maybe<CargoCompartmentAllocation>;
  /** An edge for our `CargoCompartmentAllocation`. May be used by Relay 1. */
  cargoCompartmentAllocationEdge?: Maybe<CargoCompartmentAllocationsEdge>;
  /** Reads a single `CargoCompartment` that is related to this `CargoCompartmentAllocation`. */
  cargoCompartmentByCompartmentId?: Maybe<CargoCompartment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoCompartmentAllocationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `CargoCompartmentAllocation`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `CargoCompartmentAllocation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledOrder` that is related to this `CargoCompartmentAllocation`. */
  scheduledOrderByScheduledOrderClientId?: Maybe<ScheduledOrder>;
  /** Reads a single `ScheduledOrder` that is related to this `CargoCompartmentAllocation`. */
  scheduledOrderByScheduledOrderId?: Maybe<ScheduledOrder>;
};


/** The output of our delete `CargoCompartmentAllocation` mutation. */
export type DeleteCargoCompartmentAllocationPayloadCargoCompartmentAllocationEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};

/** All input for the `deleteCargoCompartmentById` mutation. */
export type DeleteCargoCompartmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoCompartmentId']['input'];
};

/** All input for the `deleteCargoCompartment` mutation. */
export type DeleteCargoCompartmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoCompartment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CargoCompartment` mutation. */
export type DeleteCargoCompartmentPayload = {
  __typename?: 'DeleteCargoCompartmentPayload';
  /** The `CargoCompartment` that was deleted by this mutation. */
  cargoCompartment?: Maybe<CargoCompartment>;
  /** An edge for our `CargoCompartment`. May be used by Relay 1. */
  cargoCompartmentEdge?: Maybe<CargoCompartmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoCompartmentId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `CargoCompartment`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CargoCompartment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CargoCompartment`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `CargoCompartment`. */
  userByAdminUserId?: Maybe<User>;
  /** Reads a single `VesselInfo` that is related to this `CargoCompartment`. */
  vesselInfoByVesselId?: Maybe<VesselInfo>;
};


/** The output of our delete `CargoCompartment` mutation. */
export type DeleteCargoCompartmentPayloadCargoCompartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};

/** All input for the `deleteCargoEquipmentById` mutation. */
export type DeleteCargoEquipmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoEquipmentId']['input'];
};

/** All input for the `deleteCargoEquipment` mutation. */
export type DeleteCargoEquipmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoEquipment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CargoEquipment` mutation. */
export type DeleteCargoEquipmentPayload = {
  __typename?: 'DeleteCargoEquipmentPayload';
  /** The `CargoEquipment` that was deleted by this mutation. */
  cargoEquipment?: Maybe<CargoEquipment>;
  /** An edge for our `CargoEquipment`. May be used by Relay 1. */
  cargoEquipmentEdge?: Maybe<CargoEquipmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoEquipmentId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CargoEquipment` mutation. */
export type DeleteCargoEquipmentPayloadCargoEquipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoEquipmentsOrderBy>>;
};

/** All input for the `deleteCargoExclusionById` mutation. */
export type DeleteCargoExclusionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoExclusionId']['input'];
};

/** All input for the `deleteCargoExclusion` mutation. */
export type DeleteCargoExclusionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoExclusion` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CargoExclusion` mutation. */
export type DeleteCargoExclusionPayload = {
  __typename?: 'DeleteCargoExclusionPayload';
  /** Reads a single `Assortment` that is related to this `CargoExclusion`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `CargoExclusion`. */
  assortmentGroupByAssortmentGroup?: Maybe<AssortmentGroup>;
  /** The `CargoExclusion` that was deleted by this mutation. */
  cargoExclusion?: Maybe<CargoExclusion>;
  /** An edge for our `CargoExclusion`. May be used by Relay 1. */
  cargoExclusionEdge?: Maybe<CargoExclusionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoExclusionId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `CargoExclusion`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CargoExclusion` mutation. */
export type DeleteCargoExclusionPayloadCargoExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoExclusionsOrderBy>>;
};

/** All input for the `deleteCargoLengthUnitById` mutation. */
export type DeleteCargoLengthUnitByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoLengthUnitId']['input'];
};

/** All input for the `deleteCargoLengthUnit` mutation. */
export type DeleteCargoLengthUnitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoLengthUnit` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CargoLengthUnit` mutation. */
export type DeleteCargoLengthUnitPayload = {
  __typename?: 'DeleteCargoLengthUnitPayload';
  /** The `CargoLengthUnit` that was deleted by this mutation. */
  cargoLengthUnit?: Maybe<CargoLengthUnit>;
  /** An edge for our `CargoLengthUnit`. May be used by Relay 1. */
  cargoLengthUnitEdge?: Maybe<CargoLengthUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoLengthUnitId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CargoLengthUnit` mutation. */
export type DeleteCargoLengthUnitPayloadCargoLengthUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoLengthUnitsOrderBy>>;
};

/** All input for the `deleteCargoMeasurementById` mutation. */
export type DeleteCargoMeasurementByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoMeasurementId']['input'];
};

/** All input for the `deleteCargoMeasurement` mutation. */
export type DeleteCargoMeasurementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoMeasurement` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CargoMeasurement` mutation. */
export type DeleteCargoMeasurementPayload = {
  __typename?: 'DeleteCargoMeasurementPayload';
  /** The `CargoMeasurement` that was deleted by this mutation. */
  cargoMeasurement?: Maybe<CargoMeasurement>;
  /** An edge for our `CargoMeasurement`. May be used by Relay 1. */
  cargoMeasurementEdge?: Maybe<CargoMeasurementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoMeasurementId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `CargoMeasurement`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Order` that is related to this `CargoMeasurement`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CargoMeasurement`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `CargoMeasurement` mutation. */
export type DeleteCargoMeasurementPayloadCargoMeasurementEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoMeasurementsOrderBy>>;
};

/** All input for the `deleteCargoUnitById` mutation. */
export type DeleteCargoUnitByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoUnitId']['input'];
};

/** All input for the `deleteCargoUnit` mutation. */
export type DeleteCargoUnitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoUnit` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CargoUnit` mutation. */
export type DeleteCargoUnitPayload = {
  __typename?: 'DeleteCargoUnitPayload';
  /** The `CargoUnit` that was deleted by this mutation. */
  cargoUnit?: Maybe<CargoUnit>;
  /** An edge for our `CargoUnit`. May be used by Relay 1. */
  cargoUnitEdge?: Maybe<CargoUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoUnitId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CargoUnit` mutation. */
export type DeleteCargoUnitPayloadCargoUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoUnitsOrderBy>>;
};

/** All input for the `deleteCargoUnitsConversionByExtraUnitName` mutation. */
export type DeleteCargoUnitsConversionByExtraUnitNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Extended unit name for a given unit defined in cargo_units table */
  extraUnitName: Scalars['String']['input'];
};

/** The output of our delete `CargoUnitsConversion` mutation. */
export type DeleteCargoUnitsConversionPayload = {
  __typename?: 'DeleteCargoUnitsConversionPayload';
  /** Reads a single `CargoUnit` that is related to this `CargoUnitsConversion`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /** The `CargoUnitsConversion` that was deleted by this mutation. */
  cargoUnitsConversion?: Maybe<CargoUnitsConversion>;
  /** An edge for our `CargoUnitsConversion`. May be used by Relay 1. */
  cargoUnitsConversionEdge?: Maybe<CargoUnitsConversionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoUnitsConversionId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CargoUnitsConversion` mutation. */
export type DeleteCargoUnitsConversionPayloadCargoUnitsConversionEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoUnitsConversionsOrderBy>>;
};

/** All input for the `deleteCargoWeightUnitById` mutation. */
export type DeleteCargoWeightUnitByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoWeightUnitId']['input'];
};

/** All input for the `deleteCargoWeightUnit` mutation. */
export type DeleteCargoWeightUnitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoWeightUnit` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CargoWeightUnit` mutation. */
export type DeleteCargoWeightUnitPayload = {
  __typename?: 'DeleteCargoWeightUnitPayload';
  /** The `CargoWeightUnit` that was deleted by this mutation. */
  cargoWeightUnit?: Maybe<CargoWeightUnit>;
  /** An edge for our `CargoWeightUnit`. May be used by Relay 1. */
  cargoWeightUnitEdge?: Maybe<CargoWeightUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCargoWeightUnitId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CargoWeightUnit` mutation. */
export type DeleteCargoWeightUnitPayloadCargoWeightUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoWeightUnitsOrderBy>>;
};

/** All input for the `deleteChannelById` mutation. */
export type DeleteChannelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChannelId']['input'];
};

/** All input for the `deleteChannelCostById` mutation. */
export type DeleteChannelCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChannelCostId']['input'];
};

/** All input for the `deleteChannelCostEstimateById` mutation. */
export type DeleteChannelCostEstimateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChannelCostEstimateId']['input'];
};

/** All input for the `deleteChannelCostEstimate` mutation. */
export type DeleteChannelCostEstimateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ChannelCostEstimate` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ChannelCostEstimate` mutation. */
export type DeleteChannelCostEstimatePayload = {
  __typename?: 'DeleteChannelCostEstimatePayload';
  /** Reads a single `AssortmentGroup` that is related to this `ChannelCostEstimate`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /** The `ChannelCostEstimate` that was deleted by this mutation. */
  channelCostEstimate?: Maybe<ChannelCostEstimate>;
  /** An edge for our `ChannelCostEstimate`. May be used by Relay 1. */
  channelCostEstimateEdge?: Maybe<ChannelCostEstimatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedChannelCostEstimateId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `ChannelCostEstimate`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ChannelCostEstimate`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `ChannelCostEstimate`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our delete `ChannelCostEstimate` mutation. */
export type DeleteChannelCostEstimatePayloadChannelCostEstimateEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
};

/** All input for the `deleteChannelCost` mutation. */
export type DeleteChannelCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ChannelCost` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ChannelCost` mutation. */
export type DeleteChannelCostPayload = {
  __typename?: 'DeleteChannelCostPayload';
  /** Reads a single `Channel` that is related to this `ChannelCost`. */
  channelByChannelId?: Maybe<Channel>;
  /** The `ChannelCost` that was deleted by this mutation. */
  channelCost?: Maybe<ChannelCost>;
  /** An edge for our `ChannelCost`. May be used by Relay 1. */
  channelCostEdge?: Maybe<ChannelCostsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedChannelCostId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `ChannelCost`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ChannelCost`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `ChannelCost`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `ChannelCost` mutation. */
export type DeleteChannelCostPayloadChannelCostEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelCostsOrderBy>>;
};

/** All input for the `deleteChannelIncompatibilityById` mutation. */
export type DeleteChannelIncompatibilityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChannelIncompatibilityId']['input'];
};

/** All input for the `deleteChannelIncompatibilityByVesselAttributeIdAndChannelName` mutation. */
export type DeleteChannelIncompatibilityByVesselAttributeIdAndChannelNameInput = {
  /** Name of the channel that is incompatible with the vessel attribute */
  channelName: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reference to vessel attribute that is incompatible with the channel */
  vesselAttributeId: Scalars['VesselAttributeId']['input'];
};

/** All input for the `deleteChannelIncompatibility` mutation. */
export type DeleteChannelIncompatibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ChannelIncompatibility` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ChannelIncompatibility` mutation. */
export type DeleteChannelIncompatibilityPayload = {
  __typename?: 'DeleteChannelIncompatibilityPayload';
  /** The `ChannelIncompatibility` that was deleted by this mutation. */
  channelIncompatibility?: Maybe<ChannelIncompatibility>;
  /** An edge for our `ChannelIncompatibility`. May be used by Relay 1. */
  channelIncompatibilityEdge?: Maybe<ChannelIncompatibilitiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedChannelIncompatibilityId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VesselAttribute` that is related to this `ChannelIncompatibility`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
};


/** The output of our delete `ChannelIncompatibility` mutation. */
export type DeleteChannelIncompatibilityPayloadChannelIncompatibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelIncompatibilitiesOrderBy>>;
};

/** All input for the `deleteChannel` mutation. */
export type DeleteChannelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Channel` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Channel` mutation. */
export type DeleteChannelPayload = {
  __typename?: 'DeleteChannelPayload';
  /** The `Channel` that was deleted by this mutation. */
  channel?: Maybe<Channel>;
  /** An edge for our `Channel`. May be used by Relay 1. */
  channelEdge?: Maybe<ChannelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedChannelId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `Channel`. */
  geographicalEntityByGeoId?: Maybe<GeographicalEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Channel` mutation. */
export type DeleteChannelPayloadChannelEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelsOrderBy>>;
};

/** All input for the `deleteChatById` mutation. */
export type DeleteChatByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChatId']['input'];
};

/** All input for the `deleteChat` mutation. */
export type DeleteChatInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Chat` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Chat` mutation. */
export type DeleteChatPayload = {
  __typename?: 'DeleteChatPayload';
  /** The `Chat` that was deleted by this mutation. */
  chat?: Maybe<Chat>;
  /** An edge for our `Chat`. May be used by Relay 1. */
  chatEdge?: Maybe<ChatsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedChatId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `Chat`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `Chat`. */
  organizationByFromOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Chat`. */
  organizationByToOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `Chat`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `Chat`. */
  userByFromUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Chat`. */
  userByToUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `Chat`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our delete `Chat` mutation. */
export type DeleteChatPayloadChatEdgeArgs = {
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};

/** All input for the `deleteClassSocietyAssociationById` mutation. */
export type DeleteClassSocietyAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ClassSocietyAssociationId']['input'];
};

/** All input for the `deleteClassSocietyAssociation` mutation. */
export type DeleteClassSocietyAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ClassSocietyAssociation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ClassSocietyAssociation` mutation. */
export type DeleteClassSocietyAssociationPayload = {
  __typename?: 'DeleteClassSocietyAssociationPayload';
  /** The `ClassSocietyAssociation` that was deleted by this mutation. */
  classSocietyAssociation?: Maybe<ClassSocietyAssociation>;
  /** An edge for our `ClassSocietyAssociation`. May be used by Relay 1. */
  classSocietyAssociationEdge?: Maybe<ClassSocietyAssociationsEdge>;
  /** Reads a single `ClassificationSociety` that is related to this `ClassSocietyAssociation`. */
  classificationSocietyBySocietyId?: Maybe<ClassificationSociety>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedClassSocietyAssociationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `IceClass` that is related to this `ClassSocietyAssociation`. */
  iceClassByIceClassId?: Maybe<IceClass>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ClassSocietyAssociation` mutation. */
export type DeleteClassSocietyAssociationPayloadClassSocietyAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassSocietyAssociationsOrderBy>>;
};

/** All input for the `deleteClassificationSocietyById` mutation. */
export type DeleteClassificationSocietyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ClassificationSocietyId']['input'];
};

/** All input for the `deleteClassificationSociety` mutation. */
export type DeleteClassificationSocietyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ClassificationSociety` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ClassificationSociety` mutation. */
export type DeleteClassificationSocietyPayload = {
  __typename?: 'DeleteClassificationSocietyPayload';
  /** The `ClassificationSociety` that was deleted by this mutation. */
  classificationSociety?: Maybe<ClassificationSociety>;
  /** An edge for our `ClassificationSociety`. May be used by Relay 1. */
  classificationSocietyEdge?: Maybe<ClassificationSocietiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedClassificationSocietyId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ClassificationSociety` mutation. */
export type DeleteClassificationSocietyPayloadClassificationSocietyEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationSocietiesOrderBy>>;
};

/** All input for the `deleteCoaContractAssortmentById` mutation. */
export type DeleteCoaContractAssortmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractAssortmentId']['input'];
};

/** All input for the `deleteCoaContractAssortment` mutation. */
export type DeleteCoaContractAssortmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractAssortment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractAssortment` mutation. */
export type DeleteCoaContractAssortmentPayload = {
  __typename?: 'DeleteCoaContractAssortmentPayload';
  /** Reads a single `Assortment` that is related to this `CoaContractAssortment`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `CoaContractAssortment`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoaContractAssortment` that was deleted by this mutation. */
  coaContractAssortment?: Maybe<CoaContractAssortment>;
  /** An edge for our `CoaContractAssortment`. May be used by Relay 1. */
  coaContractAssortmentEdge?: Maybe<CoaContractAssortmentsEdge>;
  /** Reads a single `CoaContract` that is related to this `CoaContractAssortment`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  deletedCoaContractAssortmentId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `CoaContractAssortment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CoaContractAssortment` mutation. */
export type DeleteCoaContractAssortmentPayloadCoaContractAssortmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractAssortmentsOrderBy>>;
};

/** All input for the `deleteCoaContractBunkerById` mutation. */
export type DeleteCoaContractBunkerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractBunkerId']['input'];
};

/** All input for the `deleteCoaContractBunker` mutation. */
export type DeleteCoaContractBunkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractBunker` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractBunker` mutation. */
export type DeleteCoaContractBunkerPayload = {
  __typename?: 'DeleteCoaContractBunkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractBunker`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** The `CoaContractBunker` that was deleted by this mutation. */
  coaContractBunker?: Maybe<CoaContractBunker>;
  /** An edge for our `CoaContractBunker`. May be used by Relay 1. */
  coaContractBunkerEdge?: Maybe<CoaContractBunkersEdge>;
  /** Reads a single `CoaContract` that is related to this `CoaContractBunker`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractBunker`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  deletedCoaContractBunkerId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CoaContractBunker` mutation. */
export type DeleteCoaContractBunkerPayloadCoaContractBunkerEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractBunkersOrderBy>>;
};

/** All input for the `deleteCoaContractById` mutation. */
export type DeleteCoaContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractId']['input'];
};

/** All input for the `deleteCoaContractCommissionById` mutation. */
export type DeleteCoaContractCommissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractCommissionId']['input'];
};

/** All input for the `deleteCoaContractCommission` mutation. */
export type DeleteCoaContractCommissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractCommission` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractCommission` mutation. */
export type DeleteCoaContractCommissionPayload = {
  __typename?: 'DeleteCoaContractCommissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractCommission`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractCommission`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractCommission` that was deleted by this mutation. */
  coaContractCommission?: Maybe<CoaContractCommission>;
  /** An edge for our `CoaContractCommission`. May be used by Relay 1. */
  coaContractCommissionEdge?: Maybe<CoaContractCommissionsEdge>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractCommission`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  /** Reads a single `Commission` that is related to this `CoaContractCommission`. */
  commissionByCommissionId?: Maybe<Commission>;
  deletedCoaContractCommissionId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CoaContractCommission` mutation. */
export type DeleteCoaContractCommissionPayloadCoaContractCommissionEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractCommissionsOrderBy>>;
};

/** All input for the `deleteCoaContractDeviationCostById` mutation. */
export type DeleteCoaContractDeviationCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractDeviationCostId']['input'];
};

/** All input for the `deleteCoaContractDeviationCost` mutation. */
export type DeleteCoaContractDeviationCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractDeviationCost` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractDeviationCost` mutation. */
export type DeleteCoaContractDeviationCostPayload = {
  __typename?: 'DeleteCoaContractDeviationCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractDeviationCost`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractDeviationCost` that was deleted by this mutation. */
  coaContractDeviationCost?: Maybe<CoaContractDeviationCost>;
  /** An edge for our `CoaContractDeviationCost`. May be used by Relay 1. */
  coaContractDeviationCostEdge?: Maybe<CoaContractDeviationCostsEdge>;
  deletedCoaContractDeviationCostId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `CoaContractDeviationCost`. */
  locationByFromLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `CoaContractDeviationCost`. */
  locationByToLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `CoaContractDeviationCost`. */
  zoneByFromZoneId?: Maybe<Zone>;
  /** Reads a single `Zone` that is related to this `CoaContractDeviationCost`. */
  zoneByToZoneId?: Maybe<Zone>;
};


/** The output of our delete `CoaContractDeviationCost` mutation. */
export type DeleteCoaContractDeviationCostPayloadCoaContractDeviationCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};

/** All input for the `deleteCoaContract` mutation. */
export type DeleteCoaContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContract` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContract` mutation. */
export type DeleteCoaContractPayload = {
  __typename?: 'DeleteCoaContractPayload';
  /** Reads a single `CargoUnit` that is related to this `CoaContract`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoaContract` that was deleted by this mutation. */
  coaContract?: Maybe<CoaContract>;
  /** An edge for our `CoaContract`. May be used by Relay 1. */
  coaContractEdge?: Maybe<CoaContractsEdge>;
  deletedCoaContractId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CoaContract`. */
  userByChartererId?: Maybe<User>;
  /** Reads a single `User` that is related to this `CoaContract`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `CoaContract` mutation. */
export type DeleteCoaContractPayloadCoaContractEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};

/** All input for the `deleteCoaContractPortByCoaContractIdAndOriginIdAndDestinationId` mutation. */
export type DeleteCoaContractPortByCoaContractIdAndOriginIdAndDestinationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coaContractId: Scalars['CoaContractId']['input'];
  destinationId: Scalars['LocationId']['input'];
  originId: Scalars['LocationId']['input'];
};

/** All input for the `deleteCoaContractPortById` mutation. */
export type DeleteCoaContractPortByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractPortId']['input'];
};

/** All input for the `deleteCoaContractPortCostById` mutation. */
export type DeleteCoaContractPortCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractPortCostId']['input'];
};

/** All input for the `deleteCoaContractPortCostByLocationIdAndShipId` mutation. */
export type DeleteCoaContractPortCostByLocationIdAndShipIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['LocationId']['input'];
  shipId: Scalars['ShipId']['input'];
};

/** All input for the `deleteCoaContractPortCostByLocationIdAndVesselTypeId` mutation. */
export type DeleteCoaContractPortCostByLocationIdAndVesselTypeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['LocationId']['input'];
  vesselTypeId: Scalars['VesselAttributeId']['input'];
};

/** All input for the `deleteCoaContractPortCost` mutation. */
export type DeleteCoaContractPortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractPortCost` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractPortCost` mutation. */
export type DeleteCoaContractPortCostPayload = {
  __typename?: 'DeleteCoaContractPortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPortCost`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPortCost` that was deleted by this mutation. */
  coaContractPortCost?: Maybe<CoaContractPortCost>;
  /** An edge for our `CoaContractPortCost`. May be used by Relay 1. */
  coaContractPortCostEdge?: Maybe<CoaContractPortCostsEdge>;
  deletedCoaContractPortCostId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `CoaContractPortCost`. */
  locationByLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractPortCost`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `CoaContractPortCost`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our delete `CoaContractPortCost` mutation. */
export type DeleteCoaContractPortCostPayloadCoaContractPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortCostsOrderBy>>;
};

/** All input for the `deleteCoaContractPortDatumById` mutation. */
export type DeleteCoaContractPortDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractPortDatumId']['input'];
};

/** All input for the `deleteCoaContractPortDatum` mutation. */
export type DeleteCoaContractPortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractPortDatum` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractPortDatum` mutation. */
export type DeleteCoaContractPortDatumPayload = {
  __typename?: 'DeleteCoaContractPortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPortDatum`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPortDatum` that was deleted by this mutation. */
  coaContractPortDatum?: Maybe<CoaContractPortDatum>;
  /** An edge for our `CoaContractPortDatum`. May be used by Relay 1. */
  coaContractPortDatumEdge?: Maybe<CoaContractPortDataEdge>;
  deletedCoaContractPortDatumId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `CoaContractPortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortDatum` that is related to this `CoaContractPortDatum`. */
  portDatumByPortDataId?: Maybe<PortDatum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CoaContractPortDatum` mutation. */
export type DeleteCoaContractPortDatumPayloadCoaContractPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortDataOrderBy>>;
};

/** All input for the `deleteCoaContractPort` mutation. */
export type DeleteCoaContractPortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractPort` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractPort` mutation. */
export type DeleteCoaContractPortPayload = {
  __typename?: 'DeleteCoaContractPortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPort`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPort` that was deleted by this mutation. */
  coaContractPort?: Maybe<CoaContractPort>;
  /** An edge for our `CoaContractPort`. May be used by Relay 1. */
  coaContractPortEdge?: Maybe<CoaContractPortsEdge>;
  deletedCoaContractPortId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `CoaContractPort`. */
  locationByDestinationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `CoaContractPort`. */
  locationByOriginId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `CoaContractPort`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContractPort`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CoaContractPort`. */
  userByChartererId?: Maybe<User>;
  /** Reads a single `Zone` that is related to this `CoaContractPort`. */
  zoneByDestinationZoneId?: Maybe<Zone>;
  /** Reads a single `Zone` that is related to this `CoaContractPort`. */
  zoneByOriginZoneId?: Maybe<Zone>;
};


/** The output of our delete `CoaContractPort` mutation. */
export type DeleteCoaContractPortPayloadCoaContractPortEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};

/** All input for the `deleteCoaContractPriceById` mutation. */
export type DeleteCoaContractPriceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractPriceId']['input'];
};

/** All input for the `deleteCoaContractPrice` mutation. */
export type DeleteCoaContractPriceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractPrice` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractPrice` mutation. */
export type DeleteCoaContractPricePayload = {
  __typename?: 'DeleteCoaContractPricePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractPrice`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPrice`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractPrice`. */
  coaContractPortByRouteId?: Maybe<CoaContractPort>;
  /** The `CoaContractPrice` that was deleted by this mutation. */
  coaContractPrice?: Maybe<CoaContractPrice>;
  /** An edge for our `CoaContractPrice`. May be used by Relay 1. */
  coaContractPriceEdge?: Maybe<CoaContractPricesEdge>;
  deletedCoaContractPriceId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `CoaContractPrice`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractPrice`. */
  shipByShipId?: Maybe<Ship>;
};


/** The output of our delete `CoaContractPrice` mutation. */
export type DeleteCoaContractPricePayloadCoaContractPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};

/** All input for the `deleteCoaContractShipByCoaContractIdAndShipId` mutation. */
export type DeleteCoaContractShipByCoaContractIdAndShipIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coaContractId: Scalars['CoaContractId']['input'];
  shipId: Scalars['ShipId']['input'];
};

/** All input for the `deleteCoaContractShipById` mutation. */
export type DeleteCoaContractShipByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CoaContractShipId']['input'];
};

/** All input for the `deleteCoaContractShip` mutation. */
export type DeleteCoaContractShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CoaContractShip` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CoaContractShip` mutation. */
export type DeleteCoaContractShipPayload = {
  __typename?: 'DeleteCoaContractShipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractShip`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractShip` that was deleted by this mutation. */
  coaContractShip?: Maybe<CoaContractShip>;
  /** An edge for our `CoaContractShip`. May be used by Relay 1. */
  coaContractShipEdge?: Maybe<CoaContractShipsEdge>;
  deletedCoaContractShipId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `CoaContractShip`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractShip`. */
  shipByShipId?: Maybe<Ship>;
};


/** The output of our delete `CoaContractShip` mutation. */
export type DeleteCoaContractShipPayloadCoaContractShipEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractShipsOrderBy>>;
};

/** All input for the `deleteCommissionByExternalIdAndVoyageCharterId` mutation. */
export type DeleteCommissionByExternalIdAndVoyageCharterIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** All input for the `deleteCommissionById` mutation. */
export type DeleteCommissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CommissionId']['input'];
};

/** All input for the `deleteCommission` mutation. */
export type DeleteCommissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Commission` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Commission` mutation. */
export type DeleteCommissionPayload = {
  __typename?: 'DeleteCommissionPayload';
  /** Reads a single `Assortment` that is related to this `Commission`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Commission` that was deleted by this mutation. */
  commission?: Maybe<Commission>;
  /** An edge for our `Commission`. May be used by Relay 1. */
  commissionEdge?: Maybe<CommissionsEdge>;
  deletedCommissionId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `Commission`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Commission`. */
  locationByLoadPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Commission`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `Commission`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our delete `Commission` mutation. */
export type DeleteCommissionPayloadCommissionEdgeArgs = {
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};

/** All input for the `deleteCommitLogScenarioById` mutation. */
export type DeleteCommitLogScenarioByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CommitLogScenarioId']['input'];
};

/** All input for the `deleteCommitLogScenario` mutation. */
export type DeleteCommitLogScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CommitLogScenario` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CommitLogScenario` mutation. */
export type DeleteCommitLogScenarioPayload = {
  __typename?: 'DeleteCommitLogScenarioPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CommitLogScenario` that was deleted by this mutation. */
  commitLogScenario?: Maybe<CommitLogScenario>;
  /** An edge for our `CommitLogScenario`. May be used by Relay 1. */
  commitLogScenarioEdge?: Maybe<CommitLogScenariosEdge>;
  deletedCommitLogScenarioId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `CommitLogScenario`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CommitLogScenario` mutation. */
export type DeleteCommitLogScenarioPayloadCommitLogScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<CommitLogScenariosOrderBy>>;
};

/** All input for the `deleteCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderId` mutation. */
export type DeleteCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderIdInput = {
  actualCostId: Scalars['ActualCostId']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  scheduledOrderId: Scalars['ScheduledOrderId']['input'];
};

/** All input for the `deleteCostSplitOnScheduledOrderById` mutation. */
export type DeleteCostSplitOnScheduledOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CostSplitOnScheduledOrderId']['input'];
};

/** All input for the `deleteCostSplitOnScheduledOrder` mutation. */
export type DeleteCostSplitOnScheduledOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CostSplitOnScheduledOrder` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CostSplitOnScheduledOrder` mutation. */
export type DeleteCostSplitOnScheduledOrderPayload = {
  __typename?: 'DeleteCostSplitOnScheduledOrderPayload';
  /** Reads a single `ActualCost` that is related to this `CostSplitOnScheduledOrder`. */
  actualCostByActualCostId?: Maybe<ActualCost>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CostSplitOnScheduledOrder` that was deleted by this mutation. */
  costSplitOnScheduledOrder?: Maybe<CostSplitOnScheduledOrder>;
  /** An edge for our `CostSplitOnScheduledOrder`. May be used by Relay 1. */
  costSplitOnScheduledOrderEdge?: Maybe<CostSplitOnScheduledOrdersEdge>;
  deletedCostSplitOnScheduledOrderId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledOrder` that is related to this `CostSplitOnScheduledOrder`. */
  scheduledOrderByScheduledOrderId?: Maybe<ScheduledOrder>;
};


/** The output of our delete `CostSplitOnScheduledOrder` mutation. */
export type DeleteCostSplitOnScheduledOrderPayloadCostSplitOnScheduledOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<CostSplitOnScheduledOrdersOrderBy>>;
};

/** All input for the `deleteCostSplitOnSingleEventByActualCostIdAndSingleEventId` mutation. */
export type DeleteCostSplitOnSingleEventByActualCostIdAndSingleEventIdInput = {
  actualCostId: Scalars['ActualCostId']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  singleEventId: Scalars['SingleEventId']['input'];
};

/** All input for the `deleteCostSplitOnSingleEventById` mutation. */
export type DeleteCostSplitOnSingleEventByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CostSplitOnSingleEventId']['input'];
};

/** All input for the `deleteCostSplitOnSingleEvent` mutation. */
export type DeleteCostSplitOnSingleEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CostSplitOnSingleEvent` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `CostSplitOnSingleEvent` mutation. */
export type DeleteCostSplitOnSingleEventPayload = {
  __typename?: 'DeleteCostSplitOnSingleEventPayload';
  /** Reads a single `ActualCost` that is related to this `CostSplitOnSingleEvent`. */
  actualCostByActualCostId?: Maybe<ActualCost>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CostSplitOnSingleEvent` that was deleted by this mutation. */
  costSplitOnSingleEvent?: Maybe<CostSplitOnSingleEvent>;
  /** An edge for our `CostSplitOnSingleEvent`. May be used by Relay 1. */
  costSplitOnSingleEventEdge?: Maybe<CostSplitOnSingleEventsEdge>;
  deletedCostSplitOnSingleEventId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SingleEvent` that is related to this `CostSplitOnSingleEvent`. */
  singleEventBySingleEventId?: Maybe<SingleEvent>;
};


/** The output of our delete `CostSplitOnSingleEvent` mutation. */
export type DeleteCostSplitOnSingleEventPayloadCostSplitOnSingleEventEdgeArgs = {
  orderBy?: InputMaybe<Array<CostSplitOnSingleEventsOrderBy>>;
};

/** All input for the `deleteCountryById` mutation. */
export type DeleteCountryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CountryId']['input'];
};

/** All input for the `deleteCountryByNumeric` mutation. */
export type DeleteCountryByNumericInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  numeric: Scalars['Int']['input'];
};

/** All input for the `deleteCountry` mutation. */
export type DeleteCountryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Country` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Country` mutation. */
export type DeleteCountryPayload = {
  __typename?: 'DeleteCountryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Country` that was deleted by this mutation. */
  country?: Maybe<Country>;
  /** An edge for our `Country`. May be used by Relay 1. */
  countryEdge?: Maybe<CountriesEdge>;
  deletedCountryId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Country` mutation. */
export type DeleteCountryPayloadCountryEdgeArgs = {
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};

/** All input for the `deleteDbChangeById` mutation. */
export type DeleteDbChangeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['DbChangeId']['input'];
};

/** All input for the `deleteDbChange` mutation. */
export type DeleteDbChangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `DbChange` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `DbChange` mutation. */
export type DeleteDbChangePayload = {
  __typename?: 'DeleteDbChangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DbChange` that was deleted by this mutation. */
  dbChange?: Maybe<DbChange>;
  /** An edge for our `DbChange`. May be used by Relay 1. */
  dbChangeEdge?: Maybe<DbChangesEdge>;
  deletedDbChangeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `DbChange`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DbChange`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `DbChange` mutation. */
export type DeleteDbChangePayloadDbChangeEdgeArgs = {
  orderBy?: InputMaybe<Array<DbChangesOrderBy>>;
};

/** All input for the `deleteDemandById` mutation. */
export type DeleteDemandByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['DemandId']['input'];
};

/** All input for the `deleteDemand` mutation. */
export type DeleteDemandInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Demand` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Demand` mutation. */
export type DeleteDemandPayload = {
  __typename?: 'DeleteDemandPayload';
  /** Reads a single `Assortment` that is related to this `Demand`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Demand`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedDemandId?: Maybe<Scalars['ID']['output']>;
  /** The `Demand` that was deleted by this mutation. */
  demand?: Maybe<Demand>;
  /** An edge for our `Demand`. May be used by Relay 1. */
  demandEdge?: Maybe<DemandsEdge>;
  /** Reads a single `Location` that is related to this `Demand`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByDestinationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationBySendingOrganizationId?: Maybe<Organization>;
  /** Reads a single `Quay` that is related to this `Demand`. */
  quayByQuayId?: Maybe<Quay>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Demand`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Demand` mutation. */
export type DeleteDemandPayloadDemandEdgeArgs = {
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};

/** All input for the `deleteEmailToOrderConfigById` mutation. */
export type DeleteEmailToOrderConfigByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['EmailToOrderConfigId']['input'];
};

/** All input for the `deleteEmailToOrderConfig` mutation. */
export type DeleteEmailToOrderConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EmailToOrderConfig` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `EmailToOrderConfig` mutation. */
export type DeleteEmailToOrderConfigPayload = {
  __typename?: 'DeleteEmailToOrderConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedEmailToOrderConfigId?: Maybe<Scalars['ID']['output']>;
  /** The `EmailToOrderConfig` that was deleted by this mutation. */
  emailToOrderConfig?: Maybe<EmailToOrderConfig>;
  /** An edge for our `EmailToOrderConfig`. May be used by Relay 1. */
  emailToOrderConfigEdge?: Maybe<EmailToOrderConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailToOrderConfig`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `EmailToOrderConfig` mutation. */
export type DeleteEmailToOrderConfigPayloadEmailToOrderConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailToOrderConfigsOrderBy>>;
};

/** All input for the `deleteEmailToOrderLogById` mutation. */
export type DeleteEmailToOrderLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['EmailToOrderLogId']['input'];
};

/** All input for the `deleteEmailToOrderLog` mutation. */
export type DeleteEmailToOrderLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EmailToOrderLog` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `EmailToOrderLog` mutation. */
export type DeleteEmailToOrderLogPayload = {
  __typename?: 'DeleteEmailToOrderLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedEmailToOrderLogId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `EmailToOrderConfig` that is related to this `EmailToOrderLog`. */
  emailToOrderConfigByConfigId?: Maybe<EmailToOrderConfig>;
  /** The `EmailToOrderLog` that was deleted by this mutation. */
  emailToOrderLog?: Maybe<EmailToOrderLog>;
  /** An edge for our `EmailToOrderLog`. May be used by Relay 1. */
  emailToOrderLogEdge?: Maybe<EmailToOrderLogsEdge>;
  /** Reads a single `Organization` that is related to this `EmailToOrderLog`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EmailToOrderLog` mutation. */
export type DeleteEmailToOrderLogPayloadEmailToOrderLogEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailToOrderLogsOrderBy>>;
};

/** All input for the `deleteFeatureByFeatureName` mutation. */
export type DeleteFeatureByFeatureNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureName: Scalars['FeatureFeatureNameString']['input'];
};

/** All input for the `deleteFeature` mutation. */
export type DeleteFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Feature` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Feature` mutation. */
export type DeleteFeaturePayload = {
  __typename?: 'DeleteFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFeatureId?: Maybe<Scalars['ID']['output']>;
  /** The `Feature` that was deleted by this mutation. */
  feature?: Maybe<Feature>;
  /** An edge for our `Feature`. May be used by Relay 1. */
  featureEdge?: Maybe<FeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Feature` mutation. */
export type DeleteFeaturePayloadFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};

/** All input for the `deleteFileById` mutation. */
export type DeleteFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['FileId']['input'];
};

/** All input for the `deleteFile` mutation. */
export type DeleteFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `File` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `File` mutation. */
export type DeleteFilePayload = {
  __typename?: 'DeleteFilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedFileId?: Maybe<Scalars['ID']['output']>;
  /** The `File` that was deleted by this mutation. */
  file?: Maybe<File>;
  /** An edge for our `File`. May be used by Relay 1. */
  fileEdge?: Maybe<FilesEdge>;
  /** Reads a single `Location` that is related to this `File`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Order` that is related to this `File`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `File`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `Shipment` that is related to this `File`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `File`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `File`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our delete `File` mutation. */
export type DeleteFilePayloadFileEdgeArgs = {
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** All input for the `deleteGeographicalEntityById` mutation. */
export type DeleteGeographicalEntityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['GeographicalEntityId']['input'];
};

/** All input for the `deleteGeographicalEntity` mutation. */
export type DeleteGeographicalEntityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `GeographicalEntity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `GeographicalEntity` mutation. */
export type DeleteGeographicalEntityPayload = {
  __typename?: 'DeleteGeographicalEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedGeographicalEntityId?: Maybe<Scalars['ID']['output']>;
  /** The `GeographicalEntity` that was deleted by this mutation. */
  geographicalEntity?: Maybe<GeographicalEntity>;
  /** An edge for our `GeographicalEntity`. May be used by Relay 1. */
  geographicalEntityEdge?: Maybe<GeographicalEntitiesEdge>;
  /** Reads a single `Organization` that is related to this `GeographicalEntity`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `GeographicalEntity`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `GeographicalEntity` mutation. */
export type DeleteGeographicalEntityPayloadGeographicalEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<GeographicalEntitiesOrderBy>>;
};

/** All input for the `deleteGeographicalRelationById` mutation. */
export type DeleteGeographicalRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['GeographicalRelationId']['input'];
};

/** All input for the `deleteGeographicalRelation` mutation. */
export type DeleteGeographicalRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `GeographicalRelation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `GeographicalRelation` mutation. */
export type DeleteGeographicalRelationPayload = {
  __typename?: 'DeleteGeographicalRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedGeographicalRelationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `GeographicalRelation`. */
  geographicalEntityByEntityId?: Maybe<GeographicalEntity>;
  /** The `GeographicalRelation` that was deleted by this mutation. */
  geographicalRelation?: Maybe<GeographicalRelation>;
  /** An edge for our `GeographicalRelation`. May be used by Relay 1. */
  geographicalRelationEdge?: Maybe<GeographicalRelationsEdge>;
  /** Reads a single `Location` that is related to this `GeographicalRelation`. */
  locationByLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `GeographicalRelation`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `GeographicalRelation` mutation. */
export type DeleteGeographicalRelationPayloadGeographicalRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<GeographicalRelationsOrderBy>>;
};

/** All input for the `deleteHandledByCoaById` mutation. */
export type DeleteHandledByCoaByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['HandledByCoaId']['input'];
};

/** All input for the `deleteHandledByCoaByOrderId` mutation. */
export type DeleteHandledByCoaByOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
};

/** All input for the `deleteHandledByCoa` mutation. */
export type DeleteHandledByCoaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `HandledByCoa` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `HandledByCoa` mutation. */
export type DeleteHandledByCoaPayload = {
  __typename?: 'DeleteHandledByCoaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `HandledByCoa`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  deletedHandledByCoaId?: Maybe<Scalars['ID']['output']>;
  /** The `HandledByCoa` that was deleted by this mutation. */
  handledByCoa?: Maybe<HandledByCoa>;
  /** An edge for our `HandledByCoa`. May be used by Relay 1. */
  handledByCoaEdge?: Maybe<HandledByCoasEdge>;
  /** Reads a single `Order` that is related to this `HandledByCoa`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `HandledByCoa`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `HandledByCoa`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `HandledByCoa`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledByCoa`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our delete `HandledByCoa` mutation. */
export type DeleteHandledByCoaPayloadHandledByCoaEdgeArgs = {
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};

/** All input for the `deleteHandledBySpotById` mutation. */
export type DeleteHandledBySpotByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['HandledBySpotId']['input'];
};

/** All input for the `deleteHandledBySpotByOrderId` mutation. */
export type DeleteHandledBySpotByOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
};

/** All input for the `deleteHandledBySpot` mutation. */
export type DeleteHandledBySpotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `HandledBySpot` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `HandledBySpot` mutation. */
export type DeleteHandledBySpotPayload = {
  __typename?: 'DeleteHandledBySpotPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedHandledBySpotId?: Maybe<Scalars['ID']['output']>;
  /** The `HandledBySpot` that was deleted by this mutation. */
  handledBySpot?: Maybe<HandledBySpot>;
  /** An edge for our `HandledBySpot`. May be used by Relay 1. */
  handledBySpotEdge?: Maybe<HandledBySpotsEdge>;
  /** Reads a single `Order` that is related to this `HandledBySpot`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `HandledBySpot`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `HandledBySpot`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `HandledBySpot`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `HandledBySpot`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledBySpot`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our delete `HandledBySpot` mutation. */
export type DeleteHandledBySpotPayloadHandledBySpotEdgeArgs = {
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};

/** All input for the `deleteHolidayById` mutation. */
export type DeleteHolidayByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['HolidayId']['input'];
};

/** All input for the `deleteHoliday` mutation. */
export type DeleteHolidayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Holiday` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Holiday` mutation. */
export type DeleteHolidayPayload = {
  __typename?: 'DeleteHolidayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedHolidayId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `Holiday`. */
  geographicalEntityByGeoId?: Maybe<GeographicalEntity>;
  /** The `Holiday` that was deleted by this mutation. */
  holiday?: Maybe<Holiday>;
  /** An edge for our `Holiday`. May be used by Relay 1. */
  holidayEdge?: Maybe<HolidaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Holiday` mutation. */
export type DeleteHolidayPayloadHolidayEdgeArgs = {
  orderBy?: InputMaybe<Array<HolidaysOrderBy>>;
};

/** All input for the `deleteIceClassById` mutation. */
export type DeleteIceClassByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['IceClassId']['input'];
};

/** All input for the `deleteIceClass` mutation. */
export type DeleteIceClassInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `IceClass` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `IceClass` mutation. */
export type DeleteIceClassPayload = {
  __typename?: 'DeleteIceClassPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedIceClassId?: Maybe<Scalars['ID']['output']>;
  /** The `IceClass` that was deleted by this mutation. */
  iceClass?: Maybe<IceClass>;
  /** An edge for our `IceClass`. May be used by Relay 1. */
  iceClassEdge?: Maybe<IceClassesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IceClass` mutation. */
export type DeleteIceClassPayloadIceClassEdgeArgs = {
  orderBy?: InputMaybe<Array<IceClassesOrderBy>>;
};

/** All input for the `deleteInstructionById` mutation. */
export type DeleteInstructionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InstructionId']['input'];
};

/** All input for the `deleteInstruction` mutation. */
export type DeleteInstructionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Instruction` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Instruction` mutation. */
export type DeleteInstructionPayload = {
  __typename?: 'DeleteInstructionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedInstructionId?: Maybe<Scalars['ID']['output']>;
  /** The `Instruction` that was deleted by this mutation. */
  instruction?: Maybe<Instruction>;
  /** An edge for our `Instruction`. May be used by Relay 1. */
  instructionEdge?: Maybe<InstructionsEdge>;
  /** Reads a single `Order` that is related to this `Instruction`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `Instruction`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Instruction`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Instruction` mutation. */
export type DeleteInstructionPayloadInstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<InstructionsOrderBy>>;
};

/** All input for the `deleteIntegrationLogById` mutation. */
export type DeleteIntegrationLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['IntegrationLogId']['input'];
};

/** All input for the `deleteIntegrationLog` mutation. */
export type DeleteIntegrationLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `IntegrationLog` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `IntegrationLog` mutation. */
export type DeleteIntegrationLogPayload = {
  __typename?: 'DeleteIntegrationLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedIntegrationLogId?: Maybe<Scalars['ID']['output']>;
  /** The `IntegrationLog` that was deleted by this mutation. */
  integrationLog?: Maybe<IntegrationLog>;
  /** An edge for our `IntegrationLog`. May be used by Relay 1. */
  integrationLogEdge?: Maybe<IntegrationLogsEdge>;
  /** Reads a single `Organization` that is related to this `IntegrationLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IntegrationLog` mutation. */
export type DeleteIntegrationLogPayloadIntegrationLogEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrationLogsOrderBy>>;
};

/** All input for the `deleteInvoiceById` mutation. */
export type DeleteInvoiceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceId']['input'];
};

/** All input for the `deleteInvoice` mutation. */
export type DeleteInvoiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Invoice` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteInvoiceItemById` mutation. */
export type DeleteInvoiceItemByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceItemId']['input'];
};

/** All input for the `deleteInvoiceItem` mutation. */
export type DeleteInvoiceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `InvoiceItem` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteInvoiceItemOrderById` mutation. */
export type DeleteInvoiceItemOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceItemOrderId']['input'];
};

/** All input for the `deleteInvoiceItemOrder` mutation. */
export type DeleteInvoiceItemOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `InvoiceItemOrder` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `InvoiceItemOrder` mutation. */
export type DeleteInvoiceItemOrderPayload = {
  __typename?: 'DeleteInvoiceItemOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedInvoiceItemOrderId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `InvoiceItem` that is related to this `InvoiceItemOrder`. */
  invoiceItemByInvoiceItemId?: Maybe<InvoiceItem>;
  /** The `InvoiceItemOrder` that was deleted by this mutation. */
  invoiceItemOrder?: Maybe<InvoiceItemOrder>;
  /** An edge for our `InvoiceItemOrder`. May be used by Relay 1. */
  invoiceItemOrderEdge?: Maybe<InvoiceItemOrdersEdge>;
  /** Reads a single `Order` that is related to this `InvoiceItemOrder`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `InvoiceItemOrder` mutation. */
export type DeleteInvoiceItemOrderPayloadInvoiceItemOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoiceItemOrdersOrderBy>>;
};

/** The output of our delete `InvoiceItem` mutation. */
export type DeleteInvoiceItemPayload = {
  __typename?: 'DeleteInvoiceItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedInvoiceItemId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Invoice` that is related to this `InvoiceItem`. */
  invoiceByInvoiceId?: Maybe<Invoice>;
  /** The `InvoiceItem` that was deleted by this mutation. */
  invoiceItem?: Maybe<InvoiceItem>;
  /** An edge for our `InvoiceItem`. May be used by Relay 1. */
  invoiceItemEdge?: Maybe<InvoiceItemsEdge>;
  /** Reads a single `Organization` that is related to this `InvoiceItem`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `InvoiceItem`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `InvoiceItem` mutation. */
export type DeleteInvoiceItemPayloadInvoiceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoiceItemsOrderBy>>;
};

/** The output of our delete `Invoice` mutation. */
export type DeleteInvoicePayload = {
  __typename?: 'DeleteInvoicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedInvoiceId?: Maybe<Scalars['ID']['output']>;
  /** The `Invoice` that was deleted by this mutation. */
  invoice?: Maybe<Invoice>;
  /** An edge for our `Invoice`. May be used by Relay 1. */
  invoiceEdge?: Maybe<InvoicesEdge>;
  /** Reads a single `Organization` that is related to this `Invoice`. */
  organizationByPayingOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `Invoice`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our delete `Invoice` mutation. */
export type DeleteInvoicePayloadInvoiceEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
};

/** All input for the `deleteLaytimeResponsibilityById` mutation. */
export type DeleteLaytimeResponsibilityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LaytimeResponsibilityId']['input'];
};

/** All input for the `deleteLaytimeResponsibility` mutation. */
export type DeleteLaytimeResponsibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LaytimeResponsibility` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `LaytimeResponsibility` mutation. */
export type DeleteLaytimeResponsibilityPayload = {
  __typename?: 'DeleteLaytimeResponsibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLaytimeResponsibilityId?: Maybe<Scalars['ID']['output']>;
  /** The `LaytimeResponsibility` that was deleted by this mutation. */
  laytimeResponsibility?: Maybe<LaytimeResponsibility>;
  /** An edge for our `LaytimeResponsibility`. May be used by Relay 1. */
  laytimeResponsibilityEdge?: Maybe<LaytimeResponsibilitiesEdge>;
  /** Reads a single `Organization` that is related to this `LaytimeResponsibility`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `PortActivity` that is related to this `LaytimeResponsibility`. */
  portActivityByPortActivityId?: Maybe<PortActivity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `LaytimeResponsibility`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our delete `LaytimeResponsibility` mutation. */
export type DeleteLaytimeResponsibilityPayloadLaytimeResponsibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<LaytimeResponsibilitiesOrderBy>>;
};

/** All input for the `deleteLocationById` mutation. */
export type DeleteLocationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LocationId']['input'];
};

/** All input for the `deleteLocationClusterById` mutation. */
export type DeleteLocationClusterByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LocationClusterId']['input'];
};

/** All input for the `deleteLocationCluster` mutation. */
export type DeleteLocationClusterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LocationCluster` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `LocationCluster` mutation. */
export type DeleteLocationClusterPayload = {
  __typename?: 'DeleteLocationClusterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLocationClusterId?: Maybe<Scalars['ID']['output']>;
  /** The `LocationCluster` that was deleted by this mutation. */
  locationCluster?: Maybe<LocationCluster>;
  /** An edge for our `LocationCluster`. May be used by Relay 1. */
  locationClusterEdge?: Maybe<LocationClustersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LocationCluster` mutation. */
export type DeleteLocationClusterPayloadLocationClusterEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationClustersOrderBy>>;
};

/** All input for the `deleteLocation` mutation. */
export type DeleteLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Location` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Location` mutation. */
export type DeleteLocationPayload = {
  __typename?: 'DeleteLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Country` that is related to this `Location`. */
  countryByCountryId?: Maybe<Country>;
  deletedLocationId?: Maybe<Scalars['ID']['output']>;
  /** The `Location` that was deleted by this mutation. */
  location?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Location`. */
  locationByParentLocationId?: Maybe<Location>;
  /** Reads a single `LocationCluster` that is related to this `Location`. */
  locationClusterByClusterId?: Maybe<LocationCluster>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge?: Maybe<LocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Location`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Location` mutation. */
export type DeleteLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** All input for the `deleteLocationRequirementAssociationById` mutation. */
export type DeleteLocationRequirementAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LocationRequirementAssociationId']['input'];
};

/** All input for the `deleteLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneId` mutation. */
export type DeleteLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['LocationId']['input'];
  specialRequirementId: Scalars['SpecialRequirementId']['input'];
  zoneId: Scalars['ZoneId']['input'];
};

/** All input for the `deleteLocationRequirementAssociation` mutation. */
export type DeleteLocationRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LocationRequirementAssociation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `LocationRequirementAssociation` mutation. */
export type DeleteLocationRequirementAssociationPayload = {
  __typename?: 'DeleteLocationRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLocationRequirementAssociationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `LocationRequirementAssociation`. */
  locationByLocationId?: Maybe<Location>;
  /** The `LocationRequirementAssociation` that was deleted by this mutation. */
  locationRequirementAssociation?: Maybe<LocationRequirementAssociation>;
  /** An edge for our `LocationRequirementAssociation`. May be used by Relay 1. */
  locationRequirementAssociationEdge?: Maybe<LocationRequirementAssociationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpecialRequirement` that is related to this `LocationRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  /** Reads a single `Zone` that is related to this `LocationRequirementAssociation`. */
  zoneByZoneId?: Maybe<Zone>;
};


/** The output of our delete `LocationRequirementAssociation` mutation. */
export type DeleteLocationRequirementAssociationPayloadLocationRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
};

/** All input for the `deleteLocationWorkingHourById` mutation. */
export type DeleteLocationWorkingHourByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LocationWorkingHourId']['input'];
};

/** All input for the `deleteLocationWorkingHour` mutation. */
export type DeleteLocationWorkingHourInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LocationWorkingHour` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `LocationWorkingHour` mutation. */
export type DeleteLocationWorkingHourPayload = {
  __typename?: 'DeleteLocationWorkingHourPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLocationWorkingHourId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `LocationWorkingHour`. */
  locationByLocationId?: Maybe<Location>;
  /** The `LocationWorkingHour` that was deleted by this mutation. */
  locationWorkingHour?: Maybe<LocationWorkingHour>;
  /** An edge for our `LocationWorkingHour`. May be used by Relay 1. */
  locationWorkingHourEdge?: Maybe<LocationWorkingHoursEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LocationWorkingHour`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `LocationWorkingHour` mutation. */
export type DeleteLocationWorkingHourPayloadLocationWorkingHourEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationWorkingHoursOrderBy>>;
};

/** All input for the `deleteLostContractById` mutation. */
export type DeleteLostContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LostContractId']['input'];
};

/** All input for the `deleteLostContract` mutation. */
export type DeleteLostContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `LostContract` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `LostContract` mutation. */
export type DeleteLostContractPayload = {
  __typename?: 'DeleteLostContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedLostContractId?: Maybe<Scalars['ID']['output']>;
  /** The `LostContract` that was deleted by this mutation. */
  lostContract?: Maybe<LostContract>;
  /** An edge for our `LostContract`. May be used by Relay 1. */
  lostContractEdge?: Maybe<LostContractsEdge>;
  /** Reads a single `Organization` that is related to this `LostContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `LostContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `LostContract` mutation. */
export type DeleteLostContractPayloadLostContractEdgeArgs = {
  orderBy?: InputMaybe<Array<LostContractsOrderBy>>;
};

/** All input for the `deleteMigrationById` mutation. */
export type DeleteMigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['MigrationId']['input'];
};

/** All input for the `deleteMigration` mutation. */
export type DeleteMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Migration` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Migration` mutation. */
export type DeleteMigrationPayload = {
  __typename?: 'DeleteMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedMigrationId?: Maybe<Scalars['ID']['output']>;
  /** The `Migration` that was deleted by this mutation. */
  migration?: Maybe<Migration>;
  /** An edge for our `Migration`. May be used by Relay 1. */
  migrationEdge?: Maybe<MigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Migration` mutation. */
export type DeleteMigrationPayloadMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<MigrationsOrderBy>>;
};

/** All input for the `deleteNoGoZoneById` mutation. */
export type DeleteNoGoZoneByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['NoGoZoneId']['input'];
};

/** All input for the `deleteNoGoZone` mutation. */
export type DeleteNoGoZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `NoGoZone` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `NoGoZone` mutation. */
export type DeleteNoGoZonePayload = {
  __typename?: 'DeleteNoGoZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedNoGoZoneId?: Maybe<Scalars['ID']['output']>;
  /** The `NoGoZone` that was deleted by this mutation. */
  noGoZone?: Maybe<NoGoZone>;
  /** An edge for our `NoGoZone`. May be used by Relay 1. */
  noGoZoneEdge?: Maybe<NoGoZonesEdge>;
  /** Reads a single `Organization` that is related to this `NoGoZone`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `NoGoZone` mutation. */
export type DeleteNoGoZonePayloadNoGoZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<NoGoZonesOrderBy>>;
};

/** All input for the `deleteNotificationReceiverById` mutation. */
export type DeleteNotificationReceiverByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `NotificationReceiver` mutation. */
export type DeleteNotificationReceiverPayload = {
  __typename?: 'DeleteNotificationReceiverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedNotificationReceiverId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `NotificationReceiver`. */
  locationByLocationId?: Maybe<Location>;
  /** The `NotificationReceiver` that was deleted by this mutation. */
  notificationReceiver?: Maybe<NotificationReceiver>;
  /** An edge for our `NotificationReceiver`. May be used by Relay 1. */
  notificationReceiverEdge?: Maybe<NotificationReceiversEdge>;
  /** Reads a single `Order` that is related to this `NotificationReceiver`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `NotificationReceiver`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `NotificationReceiver`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `NotificationReceiver`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our delete `NotificationReceiver` mutation. */
export type DeleteNotificationReceiverPayloadNotificationReceiverEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};

/** All input for the `deleteOffHireById` mutation. */
export type DeleteOffHireByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OffHireId']['input'];
};

/** All input for the `deleteOffHire` mutation. */
export type DeleteOffHireInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OffHire` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OffHire` mutation. */
export type DeleteOffHirePayload = {
  __typename?: 'DeleteOffHirePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOffHireId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `OffHire`. */
  locationByLocationAId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OffHire`. */
  locationByLocationBId?: Maybe<Location>;
  /** The `OffHire` that was deleted by this mutation. */
  offHire?: Maybe<OffHire>;
  /** An edge for our `OffHire`. May be used by Relay 1. */
  offHireEdge?: Maybe<OffHiresEdge>;
  /** Reads a single `Organization` that is related to this `OffHire`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OffHire`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `OffHire`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `OffHire`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `OffHire`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `OffHire` mutation. */
export type DeleteOffHirePayloadOffHireEdgeArgs = {
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};

/** All input for the `deleteOpenPositionById` mutation. */
export type DeleteOpenPositionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OpenPositionId']['input'];
};

/** All input for the `deleteOpenPosition` mutation. */
export type DeleteOpenPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OpenPosition` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OpenPosition` mutation. */
export type DeleteOpenPositionPayload = {
  __typename?: 'DeleteOpenPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOpenPositionId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `OpenPosition`. */
  locationByDirectionId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OpenPosition`. */
  locationByStartPortId?: Maybe<Location>;
  /** The `OpenPosition` that was deleted by this mutation. */
  openPosition?: Maybe<OpenPosition>;
  /** An edge for our `OpenPosition`. May be used by Relay 1. */
  openPositionEdge?: Maybe<OpenPositionsEdge>;
  /** Reads a single `Organization` that is related to this `OpenPosition`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `OpenPosition`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `OpenPosition`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `OpenPosition`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our delete `OpenPosition` mutation. */
export type DeleteOpenPositionPayloadOpenPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};

/** All input for the `deleteOrderAttributeAssociationById` mutation. */
export type DeleteOrderAttributeAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderAttributeAssociationId']['input'];
};

/** All input for the `deleteOrderAttributeAssociation` mutation. */
export type DeleteOrderAttributeAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderAttributeAssociation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrderAttributeAssociation` mutation. */
export type DeleteOrderAttributeAssociationPayload = {
  __typename?: 'DeleteOrderAttributeAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrderAttributeAssociationId?: Maybe<Scalars['ID']['output']>;
  /** The `OrderAttributeAssociation` that was deleted by this mutation. */
  orderAttributeAssociation?: Maybe<OrderAttributeAssociation>;
  /** An edge for our `OrderAttributeAssociation`. May be used by Relay 1. */
  orderAttributeAssociationEdge?: Maybe<OrderAttributeAssociationsEdge>;
  /** Reads a single `OrderAttribute` that is related to this `OrderAttributeAssociation`. */
  orderAttributeByOrderAttributeId?: Maybe<OrderAttribute>;
  /** Reads a single `Order` that is related to this `OrderAttributeAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `OrderAttributeAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderAttributeAssociation` mutation. */
export type DeleteOrderAttributeAssociationPayloadOrderAttributeAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderAttributeAssociationsOrderBy>>;
};

/** All input for the `deleteOrderAttributeById` mutation. */
export type DeleteOrderAttributeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderAttributeId']['input'];
};

/** All input for the `deleteOrderAttribute` mutation. */
export type DeleteOrderAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderAttribute` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrderAttribute` mutation. */
export type DeleteOrderAttributePayload = {
  __typename?: 'DeleteOrderAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrderAttributeId?: Maybe<Scalars['ID']['output']>;
  /** The `OrderAttribute` that was deleted by this mutation. */
  orderAttribute?: Maybe<OrderAttribute>;
  /** An edge for our `OrderAttribute`. May be used by Relay 1. */
  orderAttributeEdge?: Maybe<OrderAttributesEdge>;
  /** Reads a single `Organization` that is related to this `OrderAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderAttribute` mutation. */
export type DeleteOrderAttributePayloadOrderAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderAttributesOrderBy>>;
};

/** All input for the `deleteOrderById` mutation. */
export type DeleteOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderId']['input'];
};

/** All input for the `deleteOrderDetailById` mutation. */
export type DeleteOrderDetailByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderDetailId']['input'];
};

/** All input for the `deleteOrderDetail` mutation. */
export type DeleteOrderDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderDetail` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrderDetail` mutation. */
export type DeleteOrderDetailPayload = {
  __typename?: 'DeleteOrderDetailPayload';
  /** Reads a single `CargoEquipment` that is related to this `OrderDetail`. */
  cargoEquipmentByCargoEquipmentId?: Maybe<CargoEquipment>;
  /** Reads a single `CargoLengthUnit` that is related to this `OrderDetail`. */
  cargoLengthUnitByCargoLengthUnitId?: Maybe<CargoLengthUnit>;
  /** Reads a single `CargoWeightUnit` that is related to this `OrderDetail`. */
  cargoWeightUnitByCargoWeightUnitId?: Maybe<CargoWeightUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrderDetailId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `OrderDetail`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderDetail` that was deleted by this mutation. */
  orderDetail?: Maybe<OrderDetail>;
  /** An edge for our `OrderDetail`. May be used by Relay 1. */
  orderDetailEdge?: Maybe<OrderDetailsEdge>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByDischargePortAgentId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByLoadPortAgentOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByReceiverOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationBySenderOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SupplyContract` that is related to this `OrderDetail`. */
  supplyContractBySupplyContractId?: Maybe<SupplyContract>;
};


/** The output of our delete `OrderDetail` mutation. */
export type DeleteOrderDetailPayloadOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};

/** All input for the `deleteOrder` mutation. */
export type DeleteOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Order` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Order` mutation. */
export type DeleteOrderPayload = {
  __typename?: 'DeleteOrderPayload';
  /** Reads a single `Assortment` that is related to this `Order`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Order`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `Order`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  deletedOrderId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `Order`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Order`. */
  locationByLoadPortId?: Maybe<Location>;
  /** The `Order` that was deleted by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByChartererOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `Order`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `Order`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Order`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselAttribute` that is related to this `Order`. */
  vesselAttributeByMinVesselClassRequirement?: Maybe<VesselAttribute>;
};


/** The output of our delete `Order` mutation. */
export type DeleteOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the `deleteOrderPortCallRelationById` mutation. */
export type DeleteOrderPortCallRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderPortCallRelationId']['input'];
};

/** All input for the `deleteOrderPortCallRelationByOrderIdAndIsLoadPort` mutation. */
export type DeleteOrderPortCallRelationByOrderIdAndIsLoadPortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isLoadPort: Scalars['Boolean']['input'];
  orderId: Scalars['OrderId']['input'];
};

/** All input for the `deleteOrderPortCallRelation` mutation. */
export type DeleteOrderPortCallRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderPortCallRelation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrderPortCallRelation` mutation. */
export type DeleteOrderPortCallRelationPayload = {
  __typename?: 'DeleteOrderPortCallRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrderPortCallRelationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `OrderPortCallRelation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderPortCallRelation` that was deleted by this mutation. */
  orderPortCallRelation?: Maybe<OrderPortCallRelation>;
  /** An edge for our `OrderPortCallRelation`. May be used by Relay 1. */
  orderPortCallRelationEdge?: Maybe<OrderPortCallRelationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderPortCallRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `OrderPortCallRelation`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `OrderPortCallRelation`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our delete `OrderPortCallRelation` mutation. */
export type DeleteOrderPortCallRelationPayloadOrderPortCallRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderPortCallRelationsOrderBy>>;
};

/** All input for the `deleteOrderPortOverrideByOrderId` mutation. */
export type DeleteOrderPortOverrideByOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
};

/** All input for the `deleteOrderPortOverride` mutation. */
export type DeleteOrderPortOverrideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderPortOverride` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrderPortOverride` mutation. */
export type DeleteOrderPortOverridePayload = {
  __typename?: 'DeleteOrderPortOverridePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrderPortOverrideId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `OrderPortOverride`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderPortOverride` that was deleted by this mutation. */
  orderPortOverride?: Maybe<OrderPortOverride>;
  /** An edge for our `OrderPortOverride`. May be used by Relay 1. */
  orderPortOverrideEdge?: Maybe<OrderPortOverridesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrderPortOverride` mutation. */
export type DeleteOrderPortOverridePayloadOrderPortOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderPortOverridesOrderBy>>;
};

/** All input for the `deleteOrderRequirementAssociationById` mutation. */
export type DeleteOrderRequirementAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderRequirementAssociationId']['input'];
};

/** All input for the `deleteOrderRequirementAssociationBySpecialRequirementIdAndOrderId` mutation. */
export type DeleteOrderRequirementAssociationBySpecialRequirementIdAndOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
  specialRequirementId: Scalars['SpecialRequirementId']['input'];
};

/** All input for the `deleteOrderRequirementAssociation` mutation. */
export type DeleteOrderRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderRequirementAssociation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrderRequirementAssociation` mutation. */
export type DeleteOrderRequirementAssociationPayload = {
  __typename?: 'DeleteOrderRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrderRequirementAssociationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `OrderRequirementAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderRequirementAssociation` that was deleted by this mutation. */
  orderRequirementAssociation?: Maybe<OrderRequirementAssociation>;
  /** An edge for our `OrderRequirementAssociation`. May be used by Relay 1. */
  orderRequirementAssociationEdge?: Maybe<OrderRequirementAssociationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderRequirementAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpecialRequirement` that is related to this `OrderRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
};


/** The output of our delete `OrderRequirementAssociation` mutation. */
export type DeleteOrderRequirementAssociationPayloadOrderRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderRequirementAssociationsOrderBy>>;
};

/** All input for the `deleteOrderVoyageCharterRelationById` mutation. */
export type DeleteOrderVoyageCharterRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderVoyageCharterRelationId']['input'];
};

/** All input for the `deleteOrderVoyageCharterRelationByOrderIdAndOutgoing` mutation. */
export type DeleteOrderVoyageCharterRelationByOrderIdAndOutgoingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
  outgoing: Scalars['Boolean']['input'];
};

/** All input for the `deleteOrderVoyageCharterRelation` mutation. */
export type DeleteOrderVoyageCharterRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderVoyageCharterRelation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrderVoyageCharterRelation` mutation. */
export type DeleteOrderVoyageCharterRelationPayload = {
  __typename?: 'DeleteOrderVoyageCharterRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractPort` that is related to this `OrderVoyageCharterRelation`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  deletedOrderVoyageCharterRelationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `OrderVoyageCharterRelation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderVoyageCharterRelation` that was deleted by this mutation. */
  orderVoyageCharterRelation?: Maybe<OrderVoyageCharterRelation>;
  /** An edge for our `OrderVoyageCharterRelation`. May be used by Relay 1. */
  orderVoyageCharterRelationEdge?: Maybe<OrderVoyageCharterRelationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderVoyageCharterRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `OrderVoyageCharterRelation`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `OrderVoyageCharterRelation`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our delete `OrderVoyageCharterRelation` mutation. */
export type DeleteOrderVoyageCharterRelationPayloadOrderVoyageCharterRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};

/** All input for the `deleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea` mutation. */
export type DeleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  vesselArea: VesselArea;
};

/** All input for the `deleteOrganizationAreaBunkerGradeMapping` mutation. */
export type DeleteOrganizationAreaBunkerGradeMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrganizationAreaBunkerGradeMapping` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrganizationAreaBunkerGradeMapping` mutation. */
export type DeleteOrganizationAreaBunkerGradeMappingPayload = {
  __typename?: 'DeleteOrganizationAreaBunkerGradeMappingPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `OrganizationAreaBunkerGradeMapping`. */
  bunkerGradeOverrideByBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrganizationAreaBunkerGradeMappingId?: Maybe<Scalars['ID']['output']>;
  /** The `OrganizationAreaBunkerGradeMapping` that was deleted by this mutation. */
  organizationAreaBunkerGradeMapping?: Maybe<OrganizationAreaBunkerGradeMapping>;
  /** An edge for our `OrganizationAreaBunkerGradeMapping`. May be used by Relay 1. */
  organizationAreaBunkerGradeMappingEdge?: Maybe<OrganizationAreaBunkerGradeMappingsEdge>;
  /** Reads a single `Organization` that is related to this `OrganizationAreaBunkerGradeMapping`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrganizationAreaBunkerGradeMapping` mutation. */
export type DeleteOrganizationAreaBunkerGradeMappingPayloadOrganizationAreaBunkerGradeMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationAreaBunkerGradeMappingsOrderBy>>;
};

/** All input for the `deleteOrganizationById` mutation. */
export type DeleteOrganizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteOrganizationFeatureById` mutation. */
export type DeleteOrganizationFeatureByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrganizationFeatureId']['input'];
};

/** All input for the `deleteOrganizationFeature` mutation. */
export type DeleteOrganizationFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrganizationFeature` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `OrganizationFeature` mutation. */
export type DeleteOrganizationFeaturePayload = {
  __typename?: 'DeleteOrganizationFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrganizationFeatureId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Feature` that is related to this `OrganizationFeature`. */
  featureByFeatureName?: Maybe<Feature>;
  /** Reads a single `Organization` that is related to this `OrganizationFeature`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `OrganizationFeature` that was deleted by this mutation. */
  organizationFeature?: Maybe<OrganizationFeature>;
  /** An edge for our `OrganizationFeature`. May be used by Relay 1. */
  organizationFeatureEdge?: Maybe<OrganizationFeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `OrganizationFeature` mutation. */
export type DeleteOrganizationFeaturePayloadOrganizationFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationFeaturesOrderBy>>;
};

/** All input for the `deleteOrganization` mutation. */
export type DeleteOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Organization` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Organization` mutation. */
export type DeleteOrganizationPayload = {
  __typename?: 'DeleteOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** The `Organization` that was deleted by this mutation. */
  organization?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Organization`. */
  organizationByParentOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Organization`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Organization` mutation. */
export type DeleteOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};

/** All input for the `deletePortActivityById` mutation. */
export type DeletePortActivityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortActivityId']['input'];
};

/** All input for the `deletePortActivity` mutation. */
export type DeletePortActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortActivity` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortActivity` mutation. */
export type DeletePortActivityPayload = {
  __typename?: 'DeletePortActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortActivityId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `PortActivity`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `PortActivity`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** The `PortActivity` that was deleted by this mutation. */
  portActivity?: Maybe<PortActivity>;
  /** An edge for our `PortActivity`. May be used by Relay 1. */
  portActivityEdge?: Maybe<PortActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `StatementOfFact` that is related to this `PortActivity`. */
  statementOfFactByStatementOfFactsId?: Maybe<StatementOfFact>;
  /** Reads a single `User` that is related to this `PortActivity`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `PortActivity` mutation. */
export type DeletePortActivityPayloadPortActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<PortActivitiesOrderBy>>;
};

/** All input for the `deletePortCallById` mutation. */
export type DeletePortCallByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCallId']['input'];
};

/** All input for the `deletePortCallExternalTimestampById` mutation. */
export type DeletePortCallExternalTimestampByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCallExternalTimestampId']['input'];
};

/** All input for the `deletePortCallExternalTimestamp` mutation. */
export type DeletePortCallExternalTimestampInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCallExternalTimestamp` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortCallExternalTimestamp` mutation. */
export type DeletePortCallExternalTimestampPayload = {
  __typename?: 'DeletePortCallExternalTimestampPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortCallExternalTimestampId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `PortCallExternalTimestamp`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortCallExternalTimestamp`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortCallExternalTimestamp` that was deleted by this mutation. */
  portCallExternalTimestamp?: Maybe<PortCallExternalTimestamp>;
  /** An edge for our `PortCallExternalTimestamp`. May be used by Relay 1. */
  portCallExternalTimestampEdge?: Maybe<PortCallExternalTimestampsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PortCallExternalTimestamp` mutation. */
export type DeletePortCallExternalTimestampPayloadPortCallExternalTimestampEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallExternalTimestampsOrderBy>>;
};

/** All input for the `deletePortCallFileByFileId` mutation. */
export type DeletePortCallFileByFileIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['FileId']['input'];
};

/** All input for the `deletePortCallFileById` mutation. */
export type DeletePortCallFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCallFileId']['input'];
};

/** All input for the `deletePortCallFile` mutation. */
export type DeletePortCallFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCallFile` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortCallFile` mutation. */
export type DeletePortCallFilePayload = {
  __typename?: 'DeletePortCallFilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortCallFileId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `File` that is related to this `PortCallFile`. */
  fileByFileId?: Maybe<File>;
  /** Reads a single `Organization` that is related to this `PortCallFile`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortCallFile`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortCallFile` that was deleted by this mutation. */
  portCallFile?: Maybe<PortCallFile>;
  /** An edge for our `PortCallFile`. May be used by Relay 1. */
  portCallFileEdge?: Maybe<PortCallFilesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PortCallFile` mutation. */
export type DeletePortCallFilePayloadPortCallFileEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallFilesOrderBy>>;
};

/** All input for the `deletePortCall` mutation. */
export type DeletePortCallInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCall` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortCall` mutation. */
export type DeletePortCallPayload = {
  __typename?: 'DeletePortCallPayload';
  /** Reads a single `ChannelCostEstimate` that is related to this `PortCall`. */
  channelCostEstimateByChannelCostDefaultId?: Maybe<ChannelCostEstimate>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortCallId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `PortCall`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `PortCall`. */
  locationByPreviousLocationId?: Maybe<Location>;
  /** The `PortCall` that was deleted by this mutation. */
  portCall?: Maybe<PortCall>;
  /** An edge for our `PortCall`. May be used by Relay 1. */
  portCallEdge?: Maybe<PortCallsEdge>;
  /** Reads a single `PortCostDefault` that is related to this `PortCall`. */
  portCostDefaultByPortCostDefaultId?: Maybe<PortCostDefault>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCall`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `PortCall`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our delete `PortCall` mutation. */
export type DeletePortCallPayloadPortCallEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};

/** All input for the `deletePortCommodityLdRateById` mutation. */
export type DeletePortCommodityLdRateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCommodityLdRateIdString']['input'];
};

/** All input for the `deletePortCommodityLdRate` mutation. */
export type DeletePortCommodityLdRateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCommodityLdRate` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortCommodityLdRate` mutation. */
export type DeletePortCommodityLdRatePayload = {
  __typename?: 'DeletePortCommodityLdRatePayload';
  /** Reads a single `Assortment` that is related to this `PortCommodityLdRate`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `PortCommodityLdRate`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortCommodityLdRateId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `PortCommodityLdRate`. */
  locationByPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCommodityLdRate`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCommodityLdRate` that was deleted by this mutation. */
  portCommodityLdRate?: Maybe<PortCommodityLdRate>;
  /** An edge for our `PortCommodityLdRate`. May be used by Relay 1. */
  portCommodityLdRateEdge?: Maybe<PortCommodityLdRatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `PortCommodityLdRate`. */
  zoneByZoneId?: Maybe<Zone>;
};


/** The output of our delete `PortCommodityLdRate` mutation. */
export type DeletePortCommodityLdRatePayloadPortCommodityLdRateEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};

/** All input for the `deletePortCostById` mutation. */
export type DeletePortCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCostId']['input'];
};

/** All input for the `deletePortCostDefaultById` mutation. */
export type DeletePortCostDefaultByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCostDefaultId']['input'];
};

/** All input for the `deletePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrency` mutation. */
export type DeletePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrencyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
  locationId: Scalars['LocationId']['input'];
  vesselId: Scalars['ShipId']['input'];
  vesselTypeId: Scalars['VesselAttributeId']['input'];
};

/** All input for the `deletePortCostDefault` mutation. */
export type DeletePortCostDefaultInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCostDefault` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortCostDefault` mutation. */
export type DeletePortCostDefaultPayload = {
  __typename?: 'DeletePortCostDefaultPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortCostDefaultId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `PortCostDefault`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCostDefault`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCostDefault` that was deleted by this mutation. */
  portCostDefault?: Maybe<PortCostDefault>;
  /** An edge for our `PortCostDefault`. May be used by Relay 1. */
  portCostDefaultEdge?: Maybe<PortCostDefaultsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCostDefault`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `PortCostDefault`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our delete `PortCostDefault` mutation. */
export type DeletePortCostDefaultPayloadPortCostDefaultEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostDefaultsOrderBy>>;
};

/** All input for the `deletePortCostEstimatesExternalById` mutation. */
export type DeletePortCostEstimatesExternalByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCostEstimatesExternalId']['input'];
};

/** All input for the `deletePortCostEstimatesExternal` mutation. */
export type DeletePortCostEstimatesExternalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCostEstimatesExternal` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortCostEstimatesExternal` mutation. */
export type DeletePortCostEstimatesExternalPayload = {
  __typename?: 'DeletePortCostEstimatesExternalPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortCostEstimatesExternalId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `PortCostEstimatesExternal`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCostEstimatesExternal` that was deleted by this mutation. */
  portCostEstimatesExternal?: Maybe<PortCostEstimatesExternal>;
  /** An edge for our `PortCostEstimatesExternal`. May be used by Relay 1. */
  portCostEstimatesExternalEdge?: Maybe<PortCostEstimatesExternalsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PortCostEstimatesExternal` mutation. */
export type DeletePortCostEstimatesExternalPayloadPortCostEstimatesExternalEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostEstimatesExternalsOrderBy>>;
};

/** All input for the `deletePortCost` mutation. */
export type DeletePortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCost` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortCost` mutation. */
export type DeletePortCostPayload = {
  __typename?: 'DeletePortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortCostId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `PortCost`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCost`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** The `PortCost` that was deleted by this mutation. */
  portCost?: Maybe<PortCost>;
  /** An edge for our `PortCost`. May be used by Relay 1. */
  portCostEdge?: Maybe<PortCostsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCost`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `PortCost`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `PortCost` mutation. */
export type DeletePortCostPayloadPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostsOrderBy>>;
};

/** All input for the `deletePortDatumById` mutation. */
export type DeletePortDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortDatumId']['input'];
};

/** All input for the `deletePortDatum` mutation. */
export type DeletePortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortDatum` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortDatum` mutation. */
export type DeletePortDatumPayload = {
  __typename?: 'DeletePortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortDatumId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `PortDatum`. */
  locationByPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortDatum`. */
  organizationByPortAgentOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `PortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** The `PortDatum` that was deleted by this mutation. */
  portDatum?: Maybe<PortDatum>;
  /** An edge for our `PortDatum`. May be used by Relay 1. */
  portDatumEdge?: Maybe<PortDataEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `PortDatum` mutation. */
export type DeletePortDatumPayloadPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<PortDataOrderBy>>;
};

/** All input for the `deletePortNoticeById` mutation. */
export type DeletePortNoticeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortNoticeId']['input'];
};

/** All input for the `deletePortNotice` mutation. */
export type DeletePortNoticeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortNotice` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortNotice` mutation. */
export type DeletePortNoticePayload = {
  __typename?: 'DeletePortNoticePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortNoticeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `PortNotice`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortNotice`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortNotice` that was deleted by this mutation. */
  portNotice?: Maybe<PortNotice>;
  /** An edge for our `PortNotice`. May be used by Relay 1. */
  portNoticeEdge?: Maybe<PortNoticesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PortNotice`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `PortNotice`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `PortNotice` mutation. */
export type DeletePortNoticePayloadPortNoticeEdgeArgs = {
  orderBy?: InputMaybe<Array<PortNoticesOrderBy>>;
};

/** All input for the `deletePortRegionById` mutation. */
export type DeletePortRegionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortRegionId']['input'];
};

/** All input for the `deletePortRegionByLocationIdAndRegionIdAndOrganizationId` mutation. */
export type DeletePortRegionByLocationIdAndRegionIdAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['LocationId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  regionId: Scalars['RegionId']['input'];
};

/** All input for the `deletePortRegion` mutation. */
export type DeletePortRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortRegion` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `PortRegion` mutation. */
export type DeletePortRegionPayload = {
  __typename?: 'DeletePortRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPortRegionId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `PortRegion`. */
  geographicalEntityByGeographicalEntityId?: Maybe<GeographicalEntity>;
  /** Reads a single `Location` that is related to this `PortRegion`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortRegion`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortRegion` that was deleted by this mutation. */
  portRegion?: Maybe<PortRegion>;
  /** An edge for our `PortRegion`. May be used by Relay 1. */
  portRegionEdge?: Maybe<PortRegionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `PortRegion`. */
  regionByRegionId?: Maybe<Region>;
};


/** The output of our delete `PortRegion` mutation. */
export type DeletePortRegionPayloadPortRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<PortRegionsOrderBy>>;
};

/** All input for the `deletePromptById` mutation. */
export type DeletePromptByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PromptId']['input'];
};

/** All input for the `deletePrompt` mutation. */
export type DeletePromptInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Prompt` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Prompt` mutation. */
export type DeletePromptPayload = {
  __typename?: 'DeletePromptPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedPromptId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Prompt`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `Prompt` that was deleted by this mutation. */
  prompt?: Maybe<Prompt>;
  /** An edge for our `Prompt`. May be used by Relay 1. */
  promptEdge?: Maybe<PromptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Prompt`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Prompt`. */
  userByModifiedBy?: Maybe<User>;
};


/** The output of our delete `Prompt` mutation. */
export type DeletePromptPayloadPromptEdgeArgs = {
  orderBy?: InputMaybe<Array<PromptsOrderBy>>;
};

/** All input for the `deleteQuayById` mutation. */
export type DeleteQuayByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['QuayId']['input'];
};

/** All input for the `deleteQuay` mutation. */
export type DeleteQuayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Quay` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Quay` mutation. */
export type DeleteQuayPayload = {
  __typename?: 'DeleteQuayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedQuayId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `Quay`. */
  locationByLocationId?: Maybe<Location>;
  /** The `Quay` that was deleted by this mutation. */
  quay?: Maybe<Quay>;
  /** An edge for our `Quay`. May be used by Relay 1. */
  quayEdge?: Maybe<QuaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Quay`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Quay` mutation. */
export type DeleteQuayPayloadQuayEdgeArgs = {
  orderBy?: InputMaybe<Array<QuaysOrderBy>>;
};

/** All input for the `deleteReceiverOrganizationByAdminOrganizationIdAndOrganizationId` mutation. */
export type DeleteReceiverOrganizationByAdminOrganizationIdAndOrganizationIdInput = {
  adminOrganizationId: Scalars['OrganizationId']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteReceiverOrganizationById` mutation. */
export type DeleteReceiverOrganizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ReceiverOrganizationId']['input'];
};

/** All input for the `deleteReceiverOrganization` mutation. */
export type DeleteReceiverOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ReceiverOrganization` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ReceiverOrganization` mutation. */
export type DeleteReceiverOrganizationPayload = {
  __typename?: 'DeleteReceiverOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedReceiverOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `ReceiverOrganization`. */
  organizationByAdminOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `ReceiverOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ReceiverOrganization` that was deleted by this mutation. */
  receiverOrganization?: Maybe<ReceiverOrganization>;
  /** An edge for our `ReceiverOrganization`. May be used by Relay 1. */
  receiverOrganizationEdge?: Maybe<ReceiverOrganizationsEdge>;
};


/** The output of our delete `ReceiverOrganization` mutation. */
export type DeleteReceiverOrganizationPayloadReceiverOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<ReceiverOrganizationsOrderBy>>;
};

/** All input for the `deleteRegionById` mutation. */
export type DeleteRegionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RegionId']['input'];
};

/** All input for the `deleteRegion` mutation. */
export type DeleteRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Region` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Region` mutation. */
export type DeleteRegionPayload = {
  __typename?: 'DeleteRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRegionId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Region`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Region` that was deleted by this mutation. */
  region?: Maybe<Region>;
  /** Reads a single `Region` that is related to this `Region`. */
  regionByParentRegion?: Maybe<Region>;
  /** An edge for our `Region`. May be used by Relay 1. */
  regionEdge?: Maybe<RegionsEdge>;
  /** Reads a single `User` that is related to this `Region`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Region` mutation. */
export type DeleteRegionPayloadRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<RegionsOrderBy>>;
};

/** All input for the `deleteRequestLogById` mutation. */
export type DeleteRequestLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RequestLogId']['input'];
};

/** All input for the `deleteRequestLog` mutation. */
export type DeleteRequestLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RequestLog` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `RequestLog` mutation. */
export type DeleteRequestLogPayload = {
  __typename?: 'DeleteRequestLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRequestLogId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `RequestLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RequestLog` that was deleted by this mutation. */
  requestLog?: Maybe<RequestLog>;
  /** An edge for our `RequestLog`. May be used by Relay 1. */
  requestLogEdge?: Maybe<RequestLogsEdge>;
};


/** The output of our delete `RequestLog` mutation. */
export type DeleteRequestLogPayloadRequestLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RequestLogsOrderBy>>;
};

/** All input for the `deleteRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZones` mutation. */
export type DeleteRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZonesInput = {
  avoidsChannels: Scalars['Boolean']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draft: Scalars['BigFloat']['input'];
  fromLat: Scalars['BigFloat']['input'];
  fromLong: Scalars['BigFloat']['input'];
  toLat: Scalars['BigFloat']['input'];
  toLong: Scalars['BigFloat']['input'];
  usedNoGoZones: Array<InputMaybe<Scalars['Int']['input']>>;
};

/** All input for the `deleteRouteById` mutation. */
export type DeleteRouteByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RouteId']['input'];
};

/** All input for the `deleteRoute` mutation. */
export type DeleteRouteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Route` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteRouteOverrideById` mutation. */
export type DeleteRouteOverrideByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RouteOverrideId']['input'];
};

/** All input for the `deleteRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannels` mutation. */
export type DeleteRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannelsInput = {
  avoidsChannels: Scalars['Boolean']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromId: Scalars['LocationId']['input'];
  organisationId: Scalars['OrganizationId']['input'];
  toId: Scalars['LocationId']['input'];
};

/** All input for the `deleteRouteOverride` mutation. */
export type DeleteRouteOverrideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RouteOverride` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `RouteOverride` mutation. */
export type DeleteRouteOverridePayload = {
  __typename?: 'DeleteRouteOverridePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRouteOverrideId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `RouteOverride`. */
  locationByFromId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `RouteOverride`. */
  locationByToId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `RouteOverride`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RouteOverride` that was deleted by this mutation. */
  routeOverride?: Maybe<RouteOverride>;
  /** An edge for our `RouteOverride`. May be used by Relay 1. */
  routeOverrideEdge?: Maybe<RouteOverridesEdge>;
  /** Reads a single `Ship` that is related to this `RouteOverride`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `RouteOverride`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `RouteOverride` mutation. */
export type DeleteRouteOverridePayloadRouteOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};

/** The output of our delete `Route` mutation. */
export type DeleteRoutePayload = {
  __typename?: 'DeleteRoutePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRouteId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `LocationCluster` that is related to this `Route`. */
  locationClusterByFromClusterId?: Maybe<LocationCluster>;
  /** Reads a single `LocationCluster` that is related to this `Route`. */
  locationClusterByToClusterId?: Maybe<LocationCluster>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Route` that was deleted by this mutation. */
  route?: Maybe<Route>;
  /** An edge for our `Route`. May be used by Relay 1. */
  routeEdge?: Maybe<RoutesEdge>;
};


/** The output of our delete `Route` mutation. */
export type DeleteRoutePayloadRouteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};

/** All input for the `deleteRoutePointById` mutation. */
export type DeleteRoutePointByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RoutePointId']['input'];
};

/** All input for the `deleteRoutePoint` mutation. */
export type DeleteRoutePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RoutePoint` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `RoutePoint` mutation. */
export type DeleteRoutePointPayload = {
  __typename?: 'DeleteRoutePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRoutePointId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoutePoint` that was deleted by this mutation. */
  routePoint?: Maybe<RoutePoint>;
  /** An edge for our `RoutePoint`. May be used by Relay 1. */
  routePointEdge?: Maybe<RoutePointsEdge>;
};


/** The output of our delete `RoutePoint` mutation. */
export type DeleteRoutePointPayloadRoutePointEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePointsOrderBy>>;
};

/** All input for the `deleteRoutePointUsageById` mutation. */
export type DeleteRoutePointUsageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RoutePointUsageId']['input'];
};

/** All input for the `deleteRoutePointUsage` mutation. */
export type DeleteRoutePointUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RoutePointUsage` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `RoutePointUsage` mutation. */
export type DeleteRoutePointUsagePayload = {
  __typename?: 'DeleteRoutePointUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRoutePointUsageId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Route` that is related to this `RoutePointUsage`. */
  routeByRouteId?: Maybe<Route>;
  /** Reads a single `RoutePoint` that is related to this `RoutePointUsage`. */
  routePointByRoutePointId?: Maybe<RoutePoint>;
  /** The `RoutePointUsage` that was deleted by this mutation. */
  routePointUsage?: Maybe<RoutePointUsage>;
  /** An edge for our `RoutePointUsage`. May be used by Relay 1. */
  routePointUsageEdge?: Maybe<RoutePointUsagesEdge>;
};


/** The output of our delete `RoutePointUsage` mutation. */
export type DeleteRoutePointUsagePayloadRoutePointUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePointUsagesOrderBy>>;
};

/** All input for the `deleteScenarioById` mutation. */
export type DeleteScenarioByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ScenarioId']['input'];
};

/** All input for the `deleteScenario` mutation. */
export type DeleteScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Scenario` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Scenario` mutation. */
export type DeleteScenarioPayload = {
  __typename?: 'DeleteScenarioPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedScenarioId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Scenario`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Scenario`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Scenario` that was deleted by this mutation. */
  scenario?: Maybe<Scenario>;
  /** An edge for our `Scenario`. May be used by Relay 1. */
  scenarioEdge?: Maybe<ScenariosEdge>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our delete `Scenario` mutation. */
export type DeleteScenarioPayloadScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};

/** All input for the `deleteScheduledOrderById` mutation. */
export type DeleteScheduledOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ScheduledOrderId']['input'];
};

/** All input for the `deleteScheduledOrder` mutation. */
export type DeleteScheduledOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ScheduledOrder` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ScheduledOrder` mutation. */
export type DeleteScheduledOrderPayload = {
  __typename?: 'DeleteScheduledOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedScheduledOrderId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `ScheduledOrder`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `ScheduledOrder`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `ScheduledOrder`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScheduledOrder` that was deleted by this mutation. */
  scheduledOrder?: Maybe<ScheduledOrder>;
  /** An edge for our `ScheduledOrder`. May be used by Relay 1. */
  scheduledOrderEdge?: Maybe<ScheduledOrdersEdge>;
  /** Reads a single `Ship` that is related to this `ScheduledOrder`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `ScheduledOrder` mutation. */
export type DeleteScheduledOrderPayloadScheduledOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};

/** All input for the `deleteSeenMessageById` mutation. */
export type DeleteSeenMessageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SeenMessageId']['input'];
};

/** All input for the `deleteSeenMessage` mutation. */
export type DeleteSeenMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SeenMessage` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SeenMessage` mutation. */
export type DeleteSeenMessagePayload = {
  __typename?: 'DeleteSeenMessagePayload';
  /** Reads a single `Chat` that is related to this `SeenMessage`. */
  chatByChatId?: Maybe<Chat>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSeenMessageId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SeenMessage` that was deleted by this mutation. */
  seenMessage?: Maybe<SeenMessage>;
  /** An edge for our `SeenMessage`. May be used by Relay 1. */
  seenMessageEdge?: Maybe<SeenMessagesEdge>;
  /** Reads a single `User` that is related to this `SeenMessage`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `SeenMessage` mutation. */
export type DeleteSeenMessagePayloadSeenMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<SeenMessagesOrderBy>>;
};

/** All input for the `deleteSenderOrganizationByAdminOrganizationIdAndOrganizationId` mutation. */
export type DeleteSenderOrganizationByAdminOrganizationIdAndOrganizationIdInput = {
  adminOrganizationId: Scalars['OrganizationId']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteSenderOrganizationById` mutation. */
export type DeleteSenderOrganizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SenderOrganizationId']['input'];
};

/** All input for the `deleteSenderOrganization` mutation. */
export type DeleteSenderOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SenderOrganization` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SenderOrganization` mutation. */
export type DeleteSenderOrganizationPayload = {
  __typename?: 'DeleteSenderOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSenderOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `SenderOrganization`. */
  organizationByAdminOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SenderOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SenderOrganization` that was deleted by this mutation. */
  senderOrganization?: Maybe<SenderOrganization>;
  /** An edge for our `SenderOrganization`. May be used by Relay 1. */
  senderOrganizationEdge?: Maybe<SenderOrganizationsEdge>;
};


/** The output of our delete `SenderOrganization` mutation. */
export type DeleteSenderOrganizationPayloadSenderOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<SenderOrganizationsOrderBy>>;
};

/** All input for the `deleteShipById` mutation. */
export type DeleteShipByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipId']['input'];
};

/** All input for the `deleteShip` mutation. */
export type DeleteShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Ship` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Ship` mutation. */
export type DeleteShipPayload = {
  __typename?: 'DeleteShipPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `Ship`. */
  bunkerGradeOverrideByDefaultBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Ship`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Ship`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Ship` that was deleted by this mutation. */
  ship?: Maybe<Ship>;
  /** An edge for our `Ship`. May be used by Relay 1. */
  shipEdge?: Maybe<ShipsEdge>;
  /** Reads a single `User` that is related to this `Ship`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselAttribute` that is related to this `Ship`. */
  vesselAttributeByPrimaryAttributeId?: Maybe<VesselAttribute>;
  /** Reads a single `VesselInfo` that is related to this `Ship`. */
  vesselInfoByVesselInfoId?: Maybe<VesselInfo>;
};


/** The output of our delete `Ship` mutation. */
export type DeleteShipPayloadShipEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};

/** All input for the `deleteShipVoyageNamingRuleRelationById` mutation. */
export type DeleteShipVoyageNamingRuleRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipVoyageNamingRuleRelationId']['input'];
};

/** All input for the `deleteShipVoyageNamingRuleRelation` mutation. */
export type DeleteShipVoyageNamingRuleRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipVoyageNamingRuleRelation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ShipVoyageNamingRuleRelation` mutation. */
export type DeleteShipVoyageNamingRuleRelationPayload = {
  __typename?: 'DeleteShipVoyageNamingRuleRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipVoyageNamingRuleRelationId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ShipVoyageNamingRuleRelation`. */
  shipByShipId?: Maybe<Ship>;
  /** The `ShipVoyageNamingRuleRelation` that was deleted by this mutation. */
  shipVoyageNamingRuleRelation?: Maybe<ShipVoyageNamingRuleRelation>;
  /** An edge for our `ShipVoyageNamingRuleRelation`. May be used by Relay 1. */
  shipVoyageNamingRuleRelationEdge?: Maybe<ShipVoyageNamingRuleRelationsEdge>;
  /** Reads a single `VoyageNamingRule` that is related to this `ShipVoyageNamingRuleRelation`. */
  voyageNamingRuleByRuleId?: Maybe<VoyageNamingRule>;
};


/** The output of our delete `ShipVoyageNamingRuleRelation` mutation. */
export type DeleteShipVoyageNamingRuleRelationPayloadShipVoyageNamingRuleRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipVoyageNamingRuleRelationsOrderBy>>;
};

/** All input for the `deleteShipmentById` mutation. */
export type DeleteShipmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentId']['input'];
};

/** All input for the `deleteShipmentExternalStatusById` mutation. */
export type DeleteShipmentExternalStatusByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentExternalStatusId']['input'];
};

/** All input for the `deleteShipmentExternalStatus` mutation. */
export type DeleteShipmentExternalStatusInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentExternalStatus` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ShipmentExternalStatus` mutation. */
export type DeleteShipmentExternalStatusPayload = {
  __typename?: 'DeleteShipmentExternalStatusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipmentExternalStatusId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentExternalStatus`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentExternalStatus` that was deleted by this mutation. */
  shipmentExternalStatus?: Maybe<ShipmentExternalStatus>;
  /** An edge for our `ShipmentExternalStatus`. May be used by Relay 1. */
  shipmentExternalStatusEdge?: Maybe<ShipmentExternalStatusesEdge>;
};


/** The output of our delete `ShipmentExternalStatus` mutation. */
export type DeleteShipmentExternalStatusPayloadShipmentExternalStatusEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentExternalStatusesOrderBy>>;
};

/** All input for the `deleteShipmentExtraFreightById` mutation. */
export type DeleteShipmentExtraFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentExtraFreightId']['input'];
};

/** All input for the `deleteShipmentExtraFreight` mutation. */
export type DeleteShipmentExtraFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentExtraFreight` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ShipmentExtraFreight` mutation. */
export type DeleteShipmentExtraFreightPayload = {
  __typename?: 'DeleteShipmentExtraFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipmentExtraFreightId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentExtraFreight`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentExtraFreight` that was deleted by this mutation. */
  shipmentExtraFreight?: Maybe<ShipmentExtraFreight>;
  /** An edge for our `ShipmentExtraFreight`. May be used by Relay 1. */
  shipmentExtraFreightEdge?: Maybe<ShipmentExtraFreightsEdge>;
};


/** The output of our delete `ShipmentExtraFreight` mutation. */
export type DeleteShipmentExtraFreightPayloadShipmentExtraFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentExtraFreightsOrderBy>>;
};

/** All input for the `deleteShipmentFreightById` mutation. */
export type DeleteShipmentFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentFreightId']['input'];
};

/** All input for the `deleteShipmentFreightByShipmentId` mutation. */
export type DeleteShipmentFreightByShipmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shipmentId: Scalars['ShipmentId']['input'];
};

/** All input for the `deleteShipmentFreight` mutation. */
export type DeleteShipmentFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentFreight` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ShipmentFreight` mutation. */
export type DeleteShipmentFreightPayload = {
  __typename?: 'DeleteShipmentFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipmentFreightId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentFreight`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentFreight` that was deleted by this mutation. */
  shipmentFreight?: Maybe<ShipmentFreight>;
  /** An edge for our `ShipmentFreight`. May be used by Relay 1. */
  shipmentFreightEdge?: Maybe<ShipmentFreightsEdge>;
};


/** The output of our delete `ShipmentFreight` mutation. */
export type DeleteShipmentFreightPayloadShipmentFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentFreightsOrderBy>>;
};

/** All input for the `deleteShipmentGroupAssociationById` mutation. */
export type DeleteShipmentGroupAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentGroupAssociationId']['input'];
};

/** All input for the `deleteShipmentGroupAssociation` mutation. */
export type DeleteShipmentGroupAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentGroupAssociation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ShipmentGroupAssociation` mutation. */
export type DeleteShipmentGroupAssociationPayload = {
  __typename?: 'DeleteShipmentGroupAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipmentGroupAssociationId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentGroupAssociation`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentGroupAssociation` that was deleted by this mutation. */
  shipmentGroupAssociation?: Maybe<ShipmentGroupAssociation>;
  /** An edge for our `ShipmentGroupAssociation`. May be used by Relay 1. */
  shipmentGroupAssociationEdge?: Maybe<ShipmentGroupAssociationsEdge>;
  /** Reads a single `ShipmentGroup` that is related to this `ShipmentGroupAssociation`. */
  shipmentGroupByShipmentGroupId?: Maybe<ShipmentGroup>;
};


/** The output of our delete `ShipmentGroupAssociation` mutation. */
export type DeleteShipmentGroupAssociationPayloadShipmentGroupAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentGroupAssociationsOrderBy>>;
};

/** All input for the `deleteShipmentGroupById` mutation. */
export type DeleteShipmentGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentGroupId']['input'];
};

/** All input for the `deleteShipmentGroup` mutation. */
export type DeleteShipmentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentGroup` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ShipmentGroup` mutation. */
export type DeleteShipmentGroupPayload = {
  __typename?: 'DeleteShipmentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipmentGroupId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `ShipmentGroup`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShipmentGroup` that was deleted by this mutation. */
  shipmentGroup?: Maybe<ShipmentGroup>;
  /** An edge for our `ShipmentGroup`. May be used by Relay 1. */
  shipmentGroupEdge?: Maybe<ShipmentGroupsEdge>;
};


/** The output of our delete `ShipmentGroup` mutation. */
export type DeleteShipmentGroupPayloadShipmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentGroupsOrderBy>>;
};

/** All input for the `deleteShipment` mutation. */
export type DeleteShipmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Shipment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Shipment` mutation. */
export type DeleteShipmentPayload = {
  __typename?: 'DeleteShipmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedShipmentId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByChartererOrganisation?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByOwnerOrganisation?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shipment` that was deleted by this mutation. */
  shipment?: Maybe<Shipment>;
  /** An edge for our `Shipment`. May be used by Relay 1. */
  shipmentEdge?: Maybe<ShipmentsEdge>;
  /** Reads a single `User` that is related to this `Shipment`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Shipment`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageAttribute` that is related to this `Shipment`. */
  voyageAttributeByVoyageAttributeId?: Maybe<VoyageAttribute>;
};


/** The output of our delete `Shipment` mutation. */
export type DeleteShipmentPayloadShipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};

/** All input for the `deleteSingleEventById` mutation. */
export type DeleteSingleEventByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SingleEventId']['input'];
};

/** All input for the `deleteSingleEvent` mutation. */
export type DeleteSingleEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SingleEvent` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SingleEvent` mutation. */
export type DeleteSingleEventPayload = {
  __typename?: 'DeleteSingleEventPayload';
  /** Reads a single `AssortmentExclusion` that is related to this `SingleEvent`. */
  assortmentExclusionByCleaningAssortmentExclusionId?: Maybe<AssortmentExclusion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSingleEventId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `SingleEvent`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `SingleEvent`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SingleEvent`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `SingleEvent`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `SingleEvent` that was deleted by this mutation. */
  singleEvent?: Maybe<SingleEvent>;
  /** An edge for our `SingleEvent`. May be used by Relay 1. */
  singleEventEdge?: Maybe<SingleEventsEdge>;
  /** Reads a single `User` that is related to this `SingleEvent`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `SingleEvent`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `SingleEvent` mutation. */
export type DeleteSingleEventPayloadSingleEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};

/** All input for the `deleteSingleEventPortCallRelationById` mutation. */
export type DeleteSingleEventPortCallRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SingleEventPortCallRelationId']['input'];
};

/** All input for the `deleteSingleEventPortCallRelation` mutation. */
export type DeleteSingleEventPortCallRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SingleEventPortCallRelation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SingleEventPortCallRelation` mutation. */
export type DeleteSingleEventPortCallRelationPayload = {
  __typename?: 'DeleteSingleEventPortCallRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSingleEventPortCallRelationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `SingleEventPortCallRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `SingleEventPortCallRelation`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SingleEvent` that is related to this `SingleEventPortCallRelation`. */
  singleEventBySingleEventId?: Maybe<SingleEvent>;
  /** The `SingleEventPortCallRelation` that was deleted by this mutation. */
  singleEventPortCallRelation?: Maybe<SingleEventPortCallRelation>;
  /** An edge for our `SingleEventPortCallRelation`. May be used by Relay 1. */
  singleEventPortCallRelationEdge?: Maybe<SingleEventPortCallRelationsEdge>;
};


/** The output of our delete `SingleEventPortCallRelation` mutation. */
export type DeleteSingleEventPortCallRelationPayloadSingleEventPortCallRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<SingleEventPortCallRelationsOrderBy>>;
};

/** All input for the `deleteSpecialRequirementById` mutation. */
export type DeleteSpecialRequirementByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SpecialRequirementId']['input'];
};

/** All input for the `deleteSpecialRequirement` mutation. */
export type DeleteSpecialRequirementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SpecialRequirement` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SpecialRequirement` mutation. */
export type DeleteSpecialRequirementPayload = {
  __typename?: 'DeleteSpecialRequirementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSpecialRequirementId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `SpecialRequirement`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpecialRequirement` that was deleted by this mutation. */
  specialRequirement?: Maybe<SpecialRequirement>;
  /** An edge for our `SpecialRequirement`. May be used by Relay 1. */
  specialRequirementEdge?: Maybe<SpecialRequirementsEdge>;
};


/** The output of our delete `SpecialRequirement` mutation. */
export type DeleteSpecialRequirementPayloadSpecialRequirementEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialRequirementsOrderBy>>;
};

/** All input for the `deleteSplitOrderById` mutation. */
export type DeleteSplitOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SplitOrderId']['input'];
};

/** All input for the `deleteSplitOrder` mutation. */
export type DeleteSplitOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SplitOrder` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SplitOrder` mutation. */
export type DeleteSplitOrderPayload = {
  __typename?: 'DeleteSplitOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSplitOrderId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `SplitOrder`. */
  orderByFromOrderId?: Maybe<Order>;
  /** Reads a single `Order` that is related to this `SplitOrder`. */
  orderByToOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SplitOrder` that was deleted by this mutation. */
  splitOrder?: Maybe<SplitOrder>;
  /** An edge for our `SplitOrder`. May be used by Relay 1. */
  splitOrderEdge?: Maybe<SplitOrdersEdge>;
};


/** The output of our delete `SplitOrder` mutation. */
export type DeleteSplitOrderPayloadSplitOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<SplitOrdersOrderBy>>;
};

/** All input for the `deleteSpotNegotiationById` mutation. */
export type DeleteSpotNegotiationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SpotNegotiationId']['input'];
};

/** All input for the `deleteSpotNegotiation` mutation. */
export type DeleteSpotNegotiationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SpotNegotiation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SpotNegotiation` mutation. */
export type DeleteSpotNegotiationPayload = {
  __typename?: 'DeleteSpotNegotiationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSpotNegotiationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `SpotNegotiation`. */
  organizationByChartererOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SpotNegotiation`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpotNegotiation` that was deleted by this mutation. */
  spotNegotiation?: Maybe<SpotNegotiation>;
  /** An edge for our `SpotNegotiation`. May be used by Relay 1. */
  spotNegotiationEdge?: Maybe<SpotNegotiationsEdge>;
  /** Reads a single `User` that is related to this `SpotNegotiation`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselInfo` that is related to this `SpotNegotiation`. */
  vesselInfoByVesselId?: Maybe<VesselInfo>;
  /** Reads a single `VoyageCharter` that is related to this `SpotNegotiation`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our delete `SpotNegotiation` mutation. */
export type DeleteSpotNegotiationPayloadSpotNegotiationEdgeArgs = {
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};

/** All input for the `deleteStatementOfFactById` mutation. */
export type DeleteStatementOfFactByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['StatementOfFactId']['input'];
};

/** All input for the `deleteStatementOfFact` mutation. */
export type DeleteStatementOfFactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `StatementOfFact` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `StatementOfFact` mutation. */
export type DeleteStatementOfFactPayload = {
  __typename?: 'DeleteStatementOfFactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedStatementOfFactId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `StatementOfFact`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `StatementOfFact`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StatementOfFact` that was deleted by this mutation. */
  statementOfFact?: Maybe<StatementOfFact>;
  /** An edge for our `StatementOfFact`. May be used by Relay 1. */
  statementOfFactEdge?: Maybe<StatementOfFactsEdge>;
  /** Reads a single `User` that is related to this `StatementOfFact`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `StatementOfFact`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `StatementOfFact` mutation. */
export type DeleteStatementOfFactPayloadStatementOfFactEdgeArgs = {
  orderBy?: InputMaybe<Array<StatementOfFactsOrderBy>>;
};

/** All input for the `deleteSupplyById` mutation. */
export type DeleteSupplyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SupplyId']['input'];
};

/** All input for the `deleteSupplyContractById` mutation. */
export type DeleteSupplyContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SupplyContractId']['input'];
};

/** All input for the `deleteSupplyContract` mutation. */
export type DeleteSupplyContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SupplyContract` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `SupplyContract` mutation. */
export type DeleteSupplyContractPayload = {
  __typename?: 'DeleteSupplyContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSupplyContractId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `SupplyContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SupplyContract`. */
  organizationBySenderOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SupplyContract` that was deleted by this mutation. */
  supplyContract?: Maybe<SupplyContract>;
  /** An edge for our `SupplyContract`. May be used by Relay 1. */
  supplyContractEdge?: Maybe<SupplyContractsEdge>;
};


/** The output of our delete `SupplyContract` mutation. */
export type DeleteSupplyContractPayloadSupplyContractEdgeArgs = {
  orderBy?: InputMaybe<Array<SupplyContractsOrderBy>>;
};

/** All input for the `deleteSupply` mutation. */
export type DeleteSupplyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Supply` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `Supply` mutation. */
export type DeleteSupplyPayload = {
  __typename?: 'DeleteSupplyPayload';
  /** Reads a single `Assortment` that is related to this `Supply`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Supply`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedSupplyId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `Supply`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Supply`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Supply`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Quay` that is related to this `Supply`. */
  quayByQuay?: Maybe<Quay>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `Supply`. */
  regionByRegion?: Maybe<Region>;
  /** The `Supply` that was deleted by this mutation. */
  supply?: Maybe<Supply>;
  /** Reads a single `SupplyContract` that is related to this `Supply`. */
  supplyContractBySupplyContract?: Maybe<SupplyContract>;
  /** An edge for our `Supply`. May be used by Relay 1. */
  supplyEdge?: Maybe<SuppliesEdge>;
  /** Reads a single `User` that is related to this `Supply`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Supply` mutation. */
export type DeleteSupplyPayloadSupplyEdgeArgs = {
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};

/** All input for the `deleteTankDistanceById` mutation. */
export type DeleteTankDistanceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['TankDistanceId']['input'];
};

/** All input for the `deleteTankDistance` mutation. */
export type DeleteTankDistanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TankDistance` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `TankDistance` mutation. */
export type DeleteTankDistancePayload = {
  __typename?: 'DeleteTankDistancePayload';
  /** Reads a single `CargoCompartment` that is related to this `TankDistance`. */
  cargoCompartmentByTankA?: Maybe<CargoCompartment>;
  /** Reads a single `CargoCompartment` that is related to this `TankDistance`. */
  cargoCompartmentByTankB?: Maybe<CargoCompartment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTankDistanceId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TankDistance` that was deleted by this mutation. */
  tankDistance?: Maybe<TankDistance>;
  /** An edge for our `TankDistance`. May be used by Relay 1. */
  tankDistanceEdge?: Maybe<TankDistancesEdge>;
};


/** The output of our delete `TankDistance` mutation. */
export type DeleteTankDistancePayloadTankDistanceEdgeArgs = {
  orderBy?: InputMaybe<Array<TankDistancesOrderBy>>;
};

/** All input for the `deleteTcContractById` mutation. */
export type DeleteTcContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['TcContractId']['input'];
};

/** All input for the `deleteTcContractByRootOrgAndExternalId` mutation. */
export type DeleteTcContractByRootOrgAndExternalIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  rootOrg: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteTcContract` mutation. */
export type DeleteTcContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TcContract` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `TcContract` mutation. */
export type DeleteTcContractPayload = {
  __typename?: 'DeleteTcContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTcContractId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `TcContract`. */
  locationByDeliveryPortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `TcContract`. */
  locationByRedeliveryPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `TcContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `TcContract`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `TcContract` that was deleted by this mutation. */
  tcContract?: Maybe<TcContract>;
  /** An edge for our `TcContract`. May be used by Relay 1. */
  tcContractEdge?: Maybe<TcContractsEdge>;
};


/** The output of our delete `TcContract` mutation. */
export type DeleteTcContractPayloadTcContractEdgeArgs = {
  orderBy?: InputMaybe<Array<TcContractsOrderBy>>;
};

/** All input for the `deleteUserById` mutation. */
export type DeleteUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserId']['input'];
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUserRegionById` mutation. */
export type DeleteUserRegionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserRegionId']['input'];
};

/** All input for the `deleteUserRegion` mutation. */
export type DeleteUserRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserRegion` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `UserRegion` mutation. */
export type DeleteUserRegionPayload = {
  __typename?: 'DeleteUserRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserRegionId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `UserRegion`. */
  regionByRegionId?: Maybe<Region>;
  /** Reads a single `User` that is related to this `UserRegion`. */
  userByUserId?: Maybe<User>;
  /** The `UserRegion` that was deleted by this mutation. */
  userRegion?: Maybe<UserRegion>;
  /** An edge for our `UserRegion`. May be used by Relay 1. */
  userRegionEdge?: Maybe<UserRegionsEdge>;
};


/** The output of our delete `UserRegion` mutation. */
export type DeleteUserRegionPayloadUserRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRegionsOrderBy>>;
};

/** All input for the `deleteUserRightById` mutation. */
export type DeleteUserRightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserRightId']['input'];
};

/** All input for the `deleteUserRightByUserIdAndOrganizationId` mutation. */
export type DeleteUserRightByUserIdAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  userId: Scalars['UserId']['input'];
};

/** All input for the `deleteUserRight` mutation. */
export type DeleteUserRightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserRight` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `UserRight` mutation. */
export type DeleteUserRightPayload = {
  __typename?: 'DeleteUserRightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserRightId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `UserRight`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRight`. */
  userByUserId?: Maybe<User>;
  /** The `UserRight` that was deleted by this mutation. */
  userRight?: Maybe<UserRight>;
  /** An edge for our `UserRight`. May be used by Relay 1. */
  userRightEdge?: Maybe<UserRightsEdge>;
};


/** The output of our delete `UserRight` mutation. */
export type DeleteUserRightPayloadUserRightEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRightsOrderBy>>;
};

/** All input for the `deleteUserSettingById` mutation. */
export type DeleteUserSettingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserSettingId']['input'];
};

/** All input for the `deleteUserSetting` mutation. */
export type DeleteUserSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserSetting` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `UserSetting` mutation. */
export type DeleteUserSettingPayload = {
  __typename?: 'DeleteUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserSettingId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  userByUserId?: Maybe<User>;
  /** The `UserSetting` that was deleted by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our delete `UserSetting` mutation. */
export type DeleteUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the `deleteUserShipById` mutation. */
export type DeleteUserShipByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserShipId']['input'];
};

/** All input for the `deleteUserShip` mutation. */
export type DeleteUserShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserShip` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `UserShip` mutation. */
export type DeleteUserShipPayload = {
  __typename?: 'DeleteUserShipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedUserShipId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `UserShip`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `UserShip`. */
  userByUserId?: Maybe<User>;
  /** The `UserShip` that was deleted by this mutation. */
  userShip?: Maybe<UserShip>;
  /** An edge for our `UserShip`. May be used by Relay 1. */
  userShipEdge?: Maybe<UserShipsEdge>;
};


/** The output of our delete `UserShip` mutation. */
export type DeleteUserShipPayloadUserShipEdgeArgs = {
  orderBy?: InputMaybe<Array<UserShipsOrderBy>>;
};

/** All input for the `deleteVesselAttributeAssortmentExclusionById` mutation. */
export type DeleteVesselAttributeAssortmentExclusionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselAttributeAssortmentExclusionId']['input'];
};

/** All input for the `deleteVesselAttributeAssortmentExclusion` mutation. */
export type DeleteVesselAttributeAssortmentExclusionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselAttributeAssortmentExclusion` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselAttributeAssortmentExclusion` mutation. */
export type DeleteVesselAttributeAssortmentExclusionPayload = {
  __typename?: 'DeleteVesselAttributeAssortmentExclusionPayload';
  /** Reads a single `Assortment` that is related to this `VesselAttributeAssortmentExclusion`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `VesselAttributeAssortmentExclusion`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselAttributeAssortmentExclusionId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VesselAttributeAssortmentExclusion` that was deleted by this mutation. */
  vesselAttributeAssortmentExclusion?: Maybe<VesselAttributeAssortmentExclusion>;
  /** An edge for our `VesselAttributeAssortmentExclusion`. May be used by Relay 1. */
  vesselAttributeAssortmentExclusionEdge?: Maybe<VesselAttributeAssortmentExclusionsEdge>;
  /** Reads a single `VesselAttribute` that is related to this `VesselAttributeAssortmentExclusion`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
};


/** The output of our delete `VesselAttributeAssortmentExclusion` mutation. */
export type DeleteVesselAttributeAssortmentExclusionPayloadVesselAttributeAssortmentExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributeAssortmentExclusionsOrderBy>>;
};

/** All input for the `deleteVesselAttributeById` mutation. */
export type DeleteVesselAttributeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselAttributeId']['input'];
};

/** All input for the `deleteVesselAttributeByOrganizationIdAndName` mutation. */
export type DeleteVesselAttributeByOrganizationIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteVesselAttribute` mutation. */
export type DeleteVesselAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselAttribute` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselAttribute` mutation. */
export type DeleteVesselAttributePayload = {
  __typename?: 'DeleteVesselAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselAttributeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselAttribute`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VesselAttribute` that was deleted by this mutation. */
  vesselAttribute?: Maybe<VesselAttribute>;
  /** An edge for our `VesselAttribute`. May be used by Relay 1. */
  vesselAttributeEdge?: Maybe<VesselAttributesEdge>;
};


/** The output of our delete `VesselAttribute` mutation. */
export type DeleteVesselAttributePayloadVesselAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributesOrderBy>>;
};

/** All input for the `deleteVesselAttributesAssociationById` mutation. */
export type DeleteVesselAttributesAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselAttributesAssociationId']['input'];
};

/** All input for the `deleteVesselAttributesAssociation` mutation. */
export type DeleteVesselAttributesAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselAttributesAssociation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselAttributesAssociation` mutation. */
export type DeleteVesselAttributesAssociationPayload = {
  __typename?: 'DeleteVesselAttributesAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselAttributesAssociationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselAttributesAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselAttributesAssociation`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `VesselAttributesAssociation`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  /** The `VesselAttributesAssociation` that was deleted by this mutation. */
  vesselAttributesAssociation?: Maybe<VesselAttributesAssociation>;
  /** An edge for our `VesselAttributesAssociation`. May be used by Relay 1. */
  vesselAttributesAssociationEdge?: Maybe<VesselAttributesAssociationsEdge>;
};


/** The output of our delete `VesselAttributesAssociation` mutation. */
export type DeleteVesselAttributesAssociationPayloadVesselAttributesAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributesAssociationsOrderBy>>;
};

/** All input for the `deleteVesselDraftDatapointById` mutation. */
export type DeleteVesselDraftDatapointByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselDraftDatapointIdString']['input'];
};

/** All input for the `deleteVesselDraftDatapoint` mutation. */
export type DeleteVesselDraftDatapointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselDraftDatapoint` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselDraftDatapoint` mutation. */
export type DeleteVesselDraftDatapointPayload = {
  __typename?: 'DeleteVesselDraftDatapointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselDraftDatapointId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselDraftDatapoint`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselDraftDatapoint`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselDraftDatapoint` that was deleted by this mutation. */
  vesselDraftDatapoint?: Maybe<VesselDraftDatapoint>;
  /** An edge for our `VesselDraftDatapoint`. May be used by Relay 1. */
  vesselDraftDatapointEdge?: Maybe<VesselDraftDatapointsEdge>;
};


/** The output of our delete `VesselDraftDatapoint` mutation. */
export type DeleteVesselDraftDatapointPayloadVesselDraftDatapointEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselDraftDatapointsOrderBy>>;
};

/** All input for the `deleteVesselFulfillsRequirementAssociationById` mutation. */
export type DeleteVesselFulfillsRequirementAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselFulfillsRequirementAssociationId']['input'];
};

/** All input for the `deleteVesselFulfillsRequirementAssociation` mutation. */
export type DeleteVesselFulfillsRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselFulfillsRequirementAssociation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselFulfillsRequirementAssociation` mutation. */
export type DeleteVesselFulfillsRequirementAssociationPayload = {
  __typename?: 'DeleteVesselFulfillsRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselFulfillsRequirementAssociationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselFulfillsRequirementAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselFulfillsRequirementAssociation`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `SpecialRequirement` that is related to this `VesselFulfillsRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  /** Reads a single `VesselAttribute` that is related to this `VesselFulfillsRequirementAssociation`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  /** The `VesselFulfillsRequirementAssociation` that was deleted by this mutation. */
  vesselFulfillsRequirementAssociation?: Maybe<VesselFulfillsRequirementAssociation>;
  /** An edge for our `VesselFulfillsRequirementAssociation`. May be used by Relay 1. */
  vesselFulfillsRequirementAssociationEdge?: Maybe<VesselFulfillsRequirementAssociationsEdge>;
};


/** The output of our delete `VesselFulfillsRequirementAssociation` mutation. */
export type DeleteVesselFulfillsRequirementAssociationPayloadVesselFulfillsRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
};

/** All input for the `deleteVesselInfoById` mutation. */
export type DeleteVesselInfoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselInfoId']['input'];
};

/** All input for the `deleteVesselInfoByImo` mutation. */
export type DeleteVesselInfoByImoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  imo: Scalars['Int']['input'];
};

/** All input for the `deleteVesselInfo` mutation. */
export type DeleteVesselInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselInfo` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselInfo` mutation. */
export type DeleteVesselInfoPayload = {
  __typename?: 'DeleteVesselInfoPayload';
  /** Reads a single `ClassSocietyAssociation` that is related to this `VesselInfo`. */
  classSocietyAssociationByClassSocietyAssociationId?: Maybe<ClassSocietyAssociation>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselInfoId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselInfo`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselInfo`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VesselInfo`. */
  userByAdminUserId?: Maybe<User>;
  /** The `VesselInfo` that was deleted by this mutation. */
  vesselInfo?: Maybe<VesselInfo>;
  /** An edge for our `VesselInfo`. May be used by Relay 1. */
  vesselInfoEdge?: Maybe<VesselInfosEdge>;
};


/** The output of our delete `VesselInfo` mutation. */
export type DeleteVesselInfoPayloadVesselInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
};

/** All input for the `deleteVesselPerformanceModelById` mutation. */
export type DeleteVesselPerformanceModelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselPerformanceModelId']['input'];
};

/** All input for the `deleteVesselPerformanceModelByRootOrgAndShipId` mutation. */
export type DeleteVesselPerformanceModelByRootOrgAndShipIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Root organization that owns this performance model. Performance models are shared across all sub-organizations. */
  rootOrg: Scalars['OrganizationId']['input'];
  /** Reference to the vessel in the ships table */
  shipId: Scalars['ShipId']['input'];
};

/** All input for the `deleteVesselPerformanceModel` mutation. */
export type DeleteVesselPerformanceModelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselPerformanceModel` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselPerformanceModel` mutation. */
export type DeleteVesselPerformanceModelPayload = {
  __typename?: 'DeleteVesselPerformanceModelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselPerformanceModelId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselPerformanceModel`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselPerformanceModel`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselPerformanceModel` that was deleted by this mutation. */
  vesselPerformanceModel?: Maybe<VesselPerformanceModel>;
  /** An edge for our `VesselPerformanceModel`. May be used by Relay 1. */
  vesselPerformanceModelEdge?: Maybe<VesselPerformanceModelsEdge>;
};


/** The output of our delete `VesselPerformanceModel` mutation. */
export type DeleteVesselPerformanceModelPayloadVesselPerformanceModelEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselPerformanceModelsOrderBy>>;
};

/** All input for the `deleteVesselReservationById` mutation. */
export type DeleteVesselReservationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselReservationId']['input'];
};

/** All input for the `deleteVesselReservation` mutation. */
export type DeleteVesselReservationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselReservation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselReservation` mutation. */
export type DeleteVesselReservationPayload = {
  __typename?: 'DeleteVesselReservationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselReservationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `VesselReservation`. */
  locationByEndPortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `VesselReservation`. */
  locationByStartPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `VesselReservation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `VesselReservation`. */
  regionByEndRegionId?: Maybe<Region>;
  /** Reads a single `Region` that is related to this `VesselReservation`. */
  regionByStartRegionId?: Maybe<Region>;
  /** Reads a single `Ship` that is related to this `VesselReservation`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VesselReservation`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VesselReservation`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VesselReservation` that was deleted by this mutation. */
  vesselReservation?: Maybe<VesselReservation>;
  /** An edge for our `VesselReservation`. May be used by Relay 1. */
  vesselReservationEdge?: Maybe<VesselReservationsEdge>;
};


/** The output of our delete `VesselReservation` mutation. */
export type DeleteVesselReservationPayloadVesselReservationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};

/** All input for the `deleteVesselScheduleSharedToOrganizationById` mutation. */
export type DeleteVesselScheduleSharedToOrganizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselScheduleSharedToOrganizationId']['input'];
};

/** All input for the `deleteVesselScheduleSharedToOrganizationByVesselIdAndOrganizationId` mutation. */
export type DeleteVesselScheduleSharedToOrganizationByVesselIdAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  vesselId: Scalars['ShipId']['input'];
};

/** All input for the `deleteVesselScheduleSharedToOrganization` mutation. */
export type DeleteVesselScheduleSharedToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselScheduleSharedToOrganization` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselScheduleSharedToOrganization` mutation. */
export type DeleteVesselScheduleSharedToOrganizationPayload = {
  __typename?: 'DeleteVesselScheduleSharedToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselScheduleSharedToOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselScheduleSharedToOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselScheduleSharedToOrganization`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselScheduleSharedToOrganization`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `VesselScheduleSharedToOrganization` that was deleted by this mutation. */
  vesselScheduleSharedToOrganization?: Maybe<VesselScheduleSharedToOrganization>;
  /** An edge for our `VesselScheduleSharedToOrganization`. May be used by Relay 1. */
  vesselScheduleSharedToOrganizationEdge?: Maybe<VesselScheduleSharedToOrganizationsEdge>;
};


/** The output of our delete `VesselScheduleSharedToOrganization` mutation. */
export type DeleteVesselScheduleSharedToOrganizationPayloadVesselScheduleSharedToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselScheduleSharedToOrganizationsOrderBy>>;
};

/** All input for the `deleteVesselSecretById` mutation. */
export type DeleteVesselSecretByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselSecretId']['input'];
};

/** All input for the `deleteVesselSecret` mutation. */
export type DeleteVesselSecretInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselSecret` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselSecret` mutation. */
export type DeleteVesselSecretPayload = {
  __typename?: 'DeleteVesselSecretPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselSecretId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselSecret`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselSecret`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VesselSecret`. */
  userByAdminUserId?: Maybe<User>;
  /** The `VesselSecret` that was deleted by this mutation. */
  vesselSecret?: Maybe<VesselSecret>;
  /** An edge for our `VesselSecret`. May be used by Relay 1. */
  vesselSecretEdge?: Maybe<VesselSecretsEdge>;
};


/** The output of our delete `VesselSecret` mutation. */
export type DeleteVesselSecretPayloadVesselSecretEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselSecretsOrderBy>>;
};

/** All input for the `deleteVesselSpeedConsumptionById` mutation. */
export type DeleteVesselSpeedConsumptionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselSpeedConsumptionId']['input'];
};

/** All input for the `deleteVesselSpeedConsumption` mutation. */
export type DeleteVesselSpeedConsumptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselSpeedConsumption` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VesselSpeedConsumption` mutation. */
export type DeleteVesselSpeedConsumptionPayload = {
  __typename?: 'DeleteVesselSpeedConsumptionPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `VesselSpeedConsumption`. */
  bunkerGradeOverrideByBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVesselSpeedConsumptionId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VesselSpeedConsumption`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselSpeedConsumption`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselSpeedConsumption`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselSpeedConsumption` that was deleted by this mutation. */
  vesselSpeedConsumption?: Maybe<VesselSpeedConsumption>;
  /** An edge for our `VesselSpeedConsumption`. May be used by Relay 1. */
  vesselSpeedConsumptionEdge?: Maybe<VesselSpeedConsumptionsEdge>;
};


/** The output of our delete `VesselSpeedConsumption` mutation. */
export type DeleteVesselSpeedConsumptionPayloadVesselSpeedConsumptionEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselSpeedConsumptionsOrderBy>>;
};

/** All input for the `deleteVoyageAssociationById` mutation. */
export type DeleteVoyageAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageAssociationId']['input'];
};

/** All input for the `deleteVoyageAssociation` mutation. */
export type DeleteVoyageAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageAssociation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageAssociation` mutation. */
export type DeleteVoyageAssociationPayload = {
  __typename?: 'DeleteVoyageAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageAssociationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Order` that is related to this `VoyageAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageAssociation` that was deleted by this mutation. */
  voyageAssociation?: Maybe<VoyageAssociation>;
  /** An edge for our `VoyageAssociation`. May be used by Relay 1. */
  voyageAssociationEdge?: Maybe<VoyageAssociationsEdge>;
  /** Reads a single `Voyage` that is related to this `VoyageAssociation`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our delete `VoyageAssociation` mutation. */
export type DeleteVoyageAssociationPayloadVoyageAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageAssociationsOrderBy>>;
};

/** All input for the `deleteVoyageAttributeById` mutation. */
export type DeleteVoyageAttributeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageAttributeId']['input'];
};

/** All input for the `deleteVoyageAttributeByOrganizationIdAndNameAndColor` mutation. */
export type DeleteVoyageAttributeByOrganizationIdAndNameAndColorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteVoyageAttribute` mutation. */
export type DeleteVoyageAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageAttribute` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageAttribute` mutation. */
export type DeleteVoyageAttributePayload = {
  __typename?: 'DeleteVoyageAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageAttributeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageAttribute`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageAttribute` that was deleted by this mutation. */
  voyageAttribute?: Maybe<VoyageAttribute>;
  /** An edge for our `VoyageAttribute`. May be used by Relay 1. */
  voyageAttributeEdge?: Maybe<VoyageAttributesEdge>;
};


/** The output of our delete `VoyageAttribute` mutation. */
export type DeleteVoyageAttributePayloadVoyageAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageAttributesOrderBy>>;
};

/** All input for the `deleteVoyageById` mutation. */
export type DeleteVoyageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageId']['input'];
};

/** All input for the `deleteVoyageCharterById` mutation. */
export type DeleteVoyageCharterByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterId']['input'];
};

/** All input for the `deleteVoyageCharterByRootOrgAndExternalId` mutation. */
export type DeleteVoyageCharterByRootOrgAndExternalIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteVoyageCharterByRootOrgAndName` mutation. */
export type DeleteVoyageCharterByRootOrgAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['input'];
};

/** All input for the `deleteVoyageCharterExtraCostById` mutation. */
export type DeleteVoyageCharterExtraCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterExtraCostId']['input'];
};

/** All input for the `deleteVoyageCharterExtraCost` mutation. */
export type DeleteVoyageCharterExtraCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterExtraCost` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageCharterExtraCost` mutation. */
export type DeleteVoyageCharterExtraCostPayload = {
  __typename?: 'DeleteVoyageCharterExtraCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageCharterExtraCostId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterExtraCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterExtraCost` that was deleted by this mutation. */
  voyageCharterExtraCost?: Maybe<VoyageCharterExtraCost>;
  /** An edge for our `VoyageCharterExtraCost`. May be used by Relay 1. */
  voyageCharterExtraCostEdge?: Maybe<VoyageCharterExtraCostsEdge>;
};


/** The output of our delete `VoyageCharterExtraCost` mutation. */
export type DeleteVoyageCharterExtraCostPayloadVoyageCharterExtraCostEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterExtraCostsOrderBy>>;
};

/** All input for the `deleteVoyageCharterExtraFreightById` mutation. */
export type DeleteVoyageCharterExtraFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterExtraFreightId']['input'];
};

/** All input for the `deleteVoyageCharterExtraFreight` mutation. */
export type DeleteVoyageCharterExtraFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterExtraFreight` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageCharterExtraFreight` mutation. */
export type DeleteVoyageCharterExtraFreightPayload = {
  __typename?: 'DeleteVoyageCharterExtraFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageCharterExtraFreightId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterExtraFreight`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterExtraFreight` that was deleted by this mutation. */
  voyageCharterExtraFreight?: Maybe<VoyageCharterExtraFreight>;
  /** An edge for our `VoyageCharterExtraFreight`. May be used by Relay 1. */
  voyageCharterExtraFreightEdge?: Maybe<VoyageCharterExtraFreightsEdge>;
};


/** The output of our delete `VoyageCharterExtraFreight` mutation. */
export type DeleteVoyageCharterExtraFreightPayloadVoyageCharterExtraFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterExtraFreightsOrderBy>>;
};

/** All input for the `deleteVoyageCharter` mutation. */
export type DeleteVoyageCharterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharter` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteVoyageCharterOrderFreightById` mutation. */
export type DeleteVoyageCharterOrderFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterOrderFreightId']['input'];
};

/** All input for the `deleteVoyageCharterOrderFreight` mutation. */
export type DeleteVoyageCharterOrderFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterOrderFreight` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageCharterOrderFreight` mutation. */
export type DeleteVoyageCharterOrderFreightPayload = {
  __typename?: 'DeleteVoyageCharterOrderFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageCharterOrderFreightId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `OrderVoyageCharterRelation` that is related to this `VoyageCharterOrderFreight`. */
  orderVoyageCharterRelationByOrderVoyageCharterRelationId?: Maybe<OrderVoyageCharterRelation>;
  /** Reads a single `Organization` that is related to this `VoyageCharterOrderFreight`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VoyageCharterOrderFreight`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VoyageCharterOrderFreight` that was deleted by this mutation. */
  voyageCharterOrderFreight?: Maybe<VoyageCharterOrderFreight>;
  /** An edge for our `VoyageCharterOrderFreight`. May be used by Relay 1. */
  voyageCharterOrderFreightEdge?: Maybe<VoyageCharterOrderFreightsEdge>;
};


/** The output of our delete `VoyageCharterOrderFreight` mutation. */
export type DeleteVoyageCharterOrderFreightPayloadVoyageCharterOrderFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterOrderFreightsOrderBy>>;
};

/** The output of our delete `VoyageCharter` mutation. */
export type DeleteVoyageCharterPayload = {
  __typename?: 'DeleteVoyageCharterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageCharterId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `LostContract` that is related to this `VoyageCharter`. */
  lostContractByLostContractsId?: Maybe<LostContract>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VoyageCharter`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VoyageCharter`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VoyageCharter` that was deleted by this mutation. */
  voyageCharter?: Maybe<VoyageCharter>;
  /** An edge for our `VoyageCharter`. May be used by Relay 1. */
  voyageCharterEdge?: Maybe<VoyageChartersEdge>;
};


/** The output of our delete `VoyageCharter` mutation. */
export type DeleteVoyageCharterPayloadVoyageCharterEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};

/** All input for the `deleteVoyageCharterPortCostById` mutation. */
export type DeleteVoyageCharterPortCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterPortCostId']['input'];
};

/** All input for the `deleteVoyageCharterPortCost` mutation. */
export type DeleteVoyageCharterPortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterPortCost` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageCharterPortCost` mutation. */
export type DeleteVoyageCharterPortCostPayload = {
  __typename?: 'DeleteVoyageCharterPortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageCharterPortCostId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `PortCost` that is related to this `VoyageCharterPortCost`. */
  portCostByPortCostId?: Maybe<PortCost>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterPortCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterPortCost` that was deleted by this mutation. */
  voyageCharterPortCost?: Maybe<VoyageCharterPortCost>;
  /** An edge for our `VoyageCharterPortCost`. May be used by Relay 1. */
  voyageCharterPortCostEdge?: Maybe<VoyageCharterPortCostsEdge>;
};


/** The output of our delete `VoyageCharterPortCost` mutation. */
export type DeleteVoyageCharterPortCostPayloadVoyageCharterPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterPortCostsOrderBy>>;
};

/** All input for the `deleteVoyageCharterPortDatumById` mutation. */
export type DeleteVoyageCharterPortDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterPortDatumId']['input'];
};

/** All input for the `deleteVoyageCharterPortDatum` mutation. */
export type DeleteVoyageCharterPortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterPortDatum` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageCharterPortDatum` mutation. */
export type DeleteVoyageCharterPortDatumPayload = {
  __typename?: 'DeleteVoyageCharterPortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageCharterPortDatumId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageCharterPortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortDatum` that is related to this `VoyageCharterPortDatum`. */
  portDatumByPortDataId?: Maybe<PortDatum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VoyageCharterPortDatum`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterPortDatum`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterPortDatum` that was deleted by this mutation. */
  voyageCharterPortDatum?: Maybe<VoyageCharterPortDatum>;
  /** An edge for our `VoyageCharterPortDatum`. May be used by Relay 1. */
  voyageCharterPortDatumEdge?: Maybe<VoyageCharterPortDataEdge>;
};


/** The output of our delete `VoyageCharterPortDatum` mutation. */
export type DeleteVoyageCharterPortDatumPayloadVoyageCharterPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterPortDataOrderBy>>;
};

/** All input for the `deleteVoyageCharterToContractById` mutation. */
export type DeleteVoyageCharterToContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterToContractId']['input'];
};

/** All input for the `deleteVoyageCharterToContract` mutation. */
export type DeleteVoyageCharterToContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterToContract` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageCharterToContract` mutation. */
export type DeleteVoyageCharterToContractPayload = {
  __typename?: 'DeleteVoyageCharterToContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `VoyageCharterToContract`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  deletedVoyageCharterToContractId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageCharterToContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpotNegotiation` that is related to this `VoyageCharterToContract`. */
  spotNegotiationBySpotNegotiationId?: Maybe<SpotNegotiation>;
  /** Reads a single `User` that is related to this `VoyageCharterToContract`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VoyageCharterToContract`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterToContract`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterToContract` that was deleted by this mutation. */
  voyageCharterToContract?: Maybe<VoyageCharterToContract>;
  /** An edge for our `VoyageCharterToContract`. May be used by Relay 1. */
  voyageCharterToContractEdge?: Maybe<VoyageCharterToContractsEdge>;
};


/** The output of our delete `VoyageCharterToContract` mutation. */
export type DeleteVoyageCharterToContractPayloadVoyageCharterToContractEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};

/** All input for the `deleteVoyageCharterUpdateById` mutation. */
export type DeleteVoyageCharterUpdateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterUpdateId']['input'];
};

/** All input for the `deleteVoyageCharterUpdate` mutation. */
export type DeleteVoyageCharterUpdateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterUpdate` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageCharterUpdate` mutation. */
export type DeleteVoyageCharterUpdatePayload = {
  __typename?: 'DeleteVoyageCharterUpdatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageCharterUpdateId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageCharterUpdate`. */
  organizationByCreatedByOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VoyageCharterUpdate`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VoyageCharterUpdate`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VoyageCharterUpdate`. */
  userByRejectedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterUpdate`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterUpdate` that was deleted by this mutation. */
  voyageCharterUpdate?: Maybe<VoyageCharterUpdate>;
  /** An edge for our `VoyageCharterUpdate`. May be used by Relay 1. */
  voyageCharterUpdateEdge?: Maybe<VoyageCharterUpdatesEdge>;
};


/** The output of our delete `VoyageCharterUpdate` mutation. */
export type DeleteVoyageCharterUpdatePayloadVoyageCharterUpdateEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};

/** All input for the `deleteVoyage` mutation. */
export type DeleteVoyageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Voyage` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteVoyageNamingRuleById` mutation. */
export type DeleteVoyageNamingRuleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageNamingRuleId']['input'];
};

/** All input for the `deleteVoyageNamingRule` mutation. */
export type DeleteVoyageNamingRuleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageNamingRule` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `VoyageNamingRule` mutation. */
export type DeleteVoyageNamingRulePayload = {
  __typename?: 'DeleteVoyageNamingRulePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageNamingRuleId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageNamingRule`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageNamingRule` that was deleted by this mutation. */
  voyageNamingRule?: Maybe<VoyageNamingRule>;
  /** An edge for our `VoyageNamingRule`. May be used by Relay 1. */
  voyageNamingRuleEdge?: Maybe<VoyageNamingRulesEdge>;
};


/** The output of our delete `VoyageNamingRule` mutation. */
export type DeleteVoyageNamingRulePayloadVoyageNamingRuleEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageNamingRulesOrderBy>>;
};

/** The output of our delete `Voyage` mutation. */
export type DeleteVoyagePayload = {
  __typename?: 'DeleteVoyagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedVoyageId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Voyage`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `Voyage`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `Voyage` that was deleted by this mutation. */
  voyage?: Maybe<Voyage>;
  /** An edge for our `Voyage`. May be used by Relay 1. */
  voyageEdge?: Maybe<VoyagesEdge>;
};


/** The output of our delete `Voyage` mutation. */
export type DeleteVoyagePayloadVoyageEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyagesOrderBy>>;
};

/** All input for the `deleteWorldscaleFreightById` mutation. */
export type DeleteWorldscaleFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['WorldscaleFreightId']['input'];
};

/** All input for the `deleteWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYear` mutation. */
export type DeleteWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYearInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromLocationId: Scalars['LocationId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  route: Scalars['String']['input'];
  toLocationId: Scalars['LocationId']['input'];
  year: Scalars['Int']['input'];
};

/** All input for the `deleteWorldscaleFreight` mutation. */
export type DeleteWorldscaleFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorldscaleFreight` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `WorldscaleFreight` mutation. */
export type DeleteWorldscaleFreightPayload = {
  __typename?: 'DeleteWorldscaleFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWorldscaleFreightId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `WorldscaleFreight`. */
  locationByFromLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `WorldscaleFreight`. */
  locationByToLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `WorldscaleFreight`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WorldscaleFreight` that was deleted by this mutation. */
  worldscaleFreight?: Maybe<WorldscaleFreight>;
  /** An edge for our `WorldscaleFreight`. May be used by Relay 1. */
  worldscaleFreightEdge?: Maybe<WorldscaleFreightsEdge>;
};


/** The output of our delete `WorldscaleFreight` mutation. */
export type DeleteWorldscaleFreightPayloadWorldscaleFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<WorldscaleFreightsOrderBy>>;
};

/** All input for the `deleteZoneById` mutation. */
export type DeleteZoneByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ZoneId']['input'];
};

/** All input for the `deleteZone` mutation. */
export type DeleteZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Zone` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteZoneLocationById` mutation. */
export type DeleteZoneLocationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ZoneLocationId']['input'];
};

/** All input for the `deleteZoneLocationByZoneIdAndLocationId` mutation. */
export type DeleteZoneLocationByZoneIdAndLocationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['LocationId']['input'];
  zoneId: Scalars['ZoneId']['input'];
};

/** All input for the `deleteZoneLocation` mutation. */
export type DeleteZoneLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ZoneLocation` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our delete `ZoneLocation` mutation. */
export type DeleteZoneLocationPayload = {
  __typename?: 'DeleteZoneLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedZoneLocationId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Location` that is related to this `ZoneLocation`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `ZoneLocation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneLocation`. */
  zoneByZoneId?: Maybe<Zone>;
  /** The `ZoneLocation` that was deleted by this mutation. */
  zoneLocation?: Maybe<ZoneLocation>;
  /** An edge for our `ZoneLocation`. May be used by Relay 1. */
  zoneLocationEdge?: Maybe<ZoneLocationsEdge>;
};


/** The output of our delete `ZoneLocation` mutation. */
export type DeleteZoneLocationPayloadZoneLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneLocationsOrderBy>>;
};

/** The output of our delete `Zone` mutation. */
export type DeleteZonePayload = {
  __typename?: 'DeleteZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedZoneId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organization` that is related to this `Zone`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Zone` that was deleted by this mutation. */
  zone?: Maybe<Zone>;
  /** An edge for our `Zone`. May be used by Relay 1. */
  zoneEdge?: Maybe<ZonesEdge>;
};


/** The output of our delete `Zone` mutation. */
export type DeleteZonePayloadZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

export type Demand = Node & {
  __typename?: 'Demand';
  amount: Scalars['BigFloat']['output'];
  amountUnitId: Scalars['CargoUnitId']['output'];
  assortment?: Maybe<Scalars['AssortmentId']['output']>;
  /** Reads a single `Assortment` that is related to this `Demand`. */
  assortmentByAssortment?: Maybe<Assortment>;
  canSplit?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `CargoUnit` that is related to this `Demand`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  chartererOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  destinationId?: Maybe<Scalars['OrganizationId']['output']>;
  id: Scalars['DemandId']['output'];
  /** Reads a single `Location` that is related to this `Demand`. */
  locationByLocationId?: Maybe<Location>;
  locationId?: Maybe<Scalars['LocationId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByDestinationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationBySendingOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Quay` that is related to this `Demand`. */
  quayByQuayId?: Maybe<Quay>;
  quayId?: Maybe<Scalars['QuayId']['output']>;
  sendingOrganizationId?: Maybe<Scalars['OrganizationId']['output']>;
  timePeriod?: Maybe<DateRange>;
  /** Reads a single `User` that is related to this `Demand`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};

/** A condition to be used against `Demand` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DemandCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUnitId` field. */
  amountUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Checks for equality with the object’s `assortment` field. */
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `canSplit` field. */
  canSplit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `destinationId` field. */
  destinationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['DemandId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `quayId` field. */
  quayId?: InputMaybe<Scalars['QuayId']['input']>;
  /** Checks for equality with the object’s `sendingOrganizationId` field. */
  sendingOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `timePeriod` field. */
  timePeriod?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `Demand` object types. All fields are combined with a logical ‘and.’ */
export type DemandFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUnitId` field. */
  amountUnitId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DemandFilter>>;
  /** Filter by the object’s `assortment` field. */
  assortment?: InputMaybe<IntFilter>;
  /** Filter by the object’s `canSplit` field. */
  canSplit?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `destinationId` field. */
  destinationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DemandFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DemandFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `quayId` field. */
  quayId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sendingOrganizationId` field. */
  sendingOrganizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `timePeriod` field. */
  timePeriod?: InputMaybe<DateRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Demand` */
export type DemandInput = {
  amount: Scalars['BigFloat']['input'];
  amountUnitId: Scalars['CargoUnitId']['input'];
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  canSplit?: InputMaybe<Scalars['Boolean']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  destinationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  quayId?: InputMaybe<Scalars['QuayId']['input']>;
  sendingOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  timePeriod?: InputMaybe<DateRangeInput>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `Demand`. Fields that are set will be updated. */
export type DemandPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  amountUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  canSplit?: InputMaybe<Scalars['Boolean']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  destinationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  quayId?: InputMaybe<Scalars['QuayId']['input']>;
  sendingOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  timePeriod?: InputMaybe<DateRangeInput>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `Demand` values. */
export type DemandsConnection = {
  __typename?: 'DemandsConnection';
  /** A list of edges which contains the `Demand` and cursor to aid in pagination. */
  edges: Array<DemandsEdge>;
  /** A list of `Demand` objects. */
  nodes: Array<Maybe<Demand>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Demand` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Demand` edge in the connection. */
export type DemandsEdge = {
  __typename?: 'DemandsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Demand` at the end of the edge. */
  node?: Maybe<Demand>;
};

/** Methods to use when ordering `Demand`. */
export enum DemandsOrderBy {
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  AMOUNT_UNIT_ID_ASC = 'AMOUNT_UNIT_ID_ASC',
  AMOUNT_UNIT_ID_DESC = 'AMOUNT_UNIT_ID_DESC',
  ASSORTMENT_ASC = 'ASSORTMENT_ASC',
  ASSORTMENT_DESC = 'ASSORTMENT_DESC',
  CAN_SPLIT_ASC = 'CAN_SPLIT_ASC',
  CAN_SPLIT_DESC = 'CAN_SPLIT_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  DELETED_ASC = 'DELETED_ASC',
  DELETED_DESC = 'DELETED_DESC',
  DESTINATION_ID_ASC = 'DESTINATION_ID_ASC',
  DESTINATION_ID_DESC = 'DESTINATION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  QUAY_ID_ASC = 'QUAY_ID_ASC',
  QUAY_ID_DESC = 'QUAY_ID_DESC',
  SENDING_ORGANIZATION_ID_ASC = 'SENDING_ORGANIZATION_ID_ASC',
  SENDING_ORGANIZATION_ID_DESC = 'SENDING_ORGANIZATION_ID_DESC',
  TIME_PERIOD_ASC = 'TIME_PERIOD_ASC',
  TIME_PERIOD_DESC = 'TIME_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export enum DespatchSharing {
  FULL = 'FULL',
  HALF = 'HALF',
  NONE = 'NONE'
}

/** A filter to be used against DespatchSharing fields. All fields are combined with a logical ‘and.’ */
export type DespatchSharingFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DespatchSharing>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DespatchSharing>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DespatchSharing>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DespatchSharing>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DespatchSharing>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DespatchSharing>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DespatchSharing>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DespatchSharing>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DespatchSharing>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DespatchSharing>>;
};

export enum DocumentType {
  BOL = 'BOL',
  CARGO_CLAIM = 'CARGO_CLAIM',
  CARGO_HOLD_INSPECTION_REPORT = 'CARGO_HOLD_INSPECTION_REPORT',
  CARGO_MANIFEST = 'CARGO_MANIFEST',
  CARGO_PLAN = 'CARGO_PLAN',
  DAMAGE = 'DAMAGE',
  DANGEROUS_CARGO_DECLARATION = 'DANGEROUS_CARGO_DECLARATION',
  FYTOSANITARY_CERTIFICATE = 'FYTOSANITARY_CERTIFICATE',
  MATES_RECIPT = 'MATES_RECIPT',
  MEASUREMENT_REPORT = 'MEASUREMENT_REPORT',
  NOTICE_OF_READINESS = 'NOTICE_OF_READINESS',
  OTHER = 'OTHER',
  SOF = 'SOF',
  SURVEY_REPORT = 'SURVEY_REPORT',
  T2L_CUSTOMS_APPROVAL = 'T2L_CUSTOMS_APPROVAL'
}

/** A filter to be used against DocumentType fields. All fields are combined with a logical ‘and.’ */
export type DocumentTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DocumentType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DocumentType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DocumentType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DocumentType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DocumentType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DocumentType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DocumentType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DocumentType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DocumentType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DocumentType>>;
};

/** A filter to be used against Email fields. All fields are combined with a logical ‘and.’ */
export type EmailFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Email']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['Email']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Email']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Email']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Email']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['Email']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Email']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Email']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['Email']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Email']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['Email']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Email']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['Email']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['Email']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['Email']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['Email']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['Email']['input']>;
};

export type EmailToOrderConfig = Node & {
  __typename?: 'EmailToOrderConfig';
  chatgptBaseurl?: Maybe<Scalars['String']['output']>;
  chatgptRequest?: Maybe<Scalars['String']['output']>;
  chatgptToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  emailFrom?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `EmailToOrderLog`. */
  emailToOrderLogsByConfigId: EmailToOrderLogsConnection;
  id: Scalars['EmailToOrderConfigId']['output'];
  isEnabled: Scalars['Boolean']['output'];
  langtecPassword?: Maybe<Scalars['String']['output']>;
  langtecUrl?: Maybe<Scalars['String']['output']>;
  langtecUsername?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `EmailToOrderConfig`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
};


export type EmailToOrderConfigEmailToOrderLogsByConfigIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailToOrderLogCondition>;
  filter?: InputMaybe<EmailToOrderLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailToOrderLogsOrderBy>>;
};

/**
 * A condition to be used against `EmailToOrderConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EmailToOrderConfigCondition = {
  /** Checks for equality with the object’s `chatgptBaseurl` field. */
  chatgptBaseurl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `chatgptRequest` field. */
  chatgptRequest?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `chatgptToken` field. */
  chatgptToken?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `emailFrom` field. */
  emailFrom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['EmailToOrderConfigId']['input']>;
  /** Checks for equality with the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `langtecPassword` field. */
  langtecPassword?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `langtecUrl` field. */
  langtecUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `langtecUsername` field. */
  langtecUsername?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `EmailToOrderConfig` object types. All fields are combined with a logical ‘and.’ */
export type EmailToOrderConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmailToOrderConfigFilter>>;
  /** Filter by the object’s `chatgptBaseurl` field. */
  chatgptBaseurl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chatgptRequest` field. */
  chatgptRequest?: InputMaybe<StringFilter>;
  /** Filter by the object’s `chatgptToken` field. */
  chatgptToken?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `emailFrom` field. */
  emailFrom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `langtecPassword` field. */
  langtecPassword?: InputMaybe<StringFilter>;
  /** Filter by the object’s `langtecUrl` field. */
  langtecUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `langtecUsername` field. */
  langtecUsername?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmailToOrderConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmailToOrderConfigFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `EmailToOrderConfig` */
export type EmailToOrderConfigInput = {
  chatgptBaseurl?: InputMaybe<Scalars['String']['input']>;
  chatgptRequest?: InputMaybe<Scalars['String']['input']>;
  chatgptToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailFrom?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  langtecPassword?: InputMaybe<Scalars['String']['input']>;
  langtecUrl?: InputMaybe<Scalars['String']['input']>;
  langtecUsername?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['UserId']['input'];
};

/** Represents an update to a `EmailToOrderConfig`. Fields that are set will be updated. */
export type EmailToOrderConfigPatch = {
  chatgptBaseurl?: InputMaybe<Scalars['String']['input']>;
  chatgptRequest?: InputMaybe<Scalars['String']['input']>;
  chatgptToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailFrom?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  langtecPassword?: InputMaybe<Scalars['String']['input']>;
  langtecUrl?: InputMaybe<Scalars['String']['input']>;
  langtecUsername?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `EmailToOrderConfig` values. */
export type EmailToOrderConfigsConnection = {
  __typename?: 'EmailToOrderConfigsConnection';
  /** A list of edges which contains the `EmailToOrderConfig` and cursor to aid in pagination. */
  edges: Array<EmailToOrderConfigsEdge>;
  /** A list of `EmailToOrderConfig` objects. */
  nodes: Array<Maybe<EmailToOrderConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailToOrderConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EmailToOrderConfig` edge in the connection. */
export type EmailToOrderConfigsEdge = {
  __typename?: 'EmailToOrderConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmailToOrderConfig` at the end of the edge. */
  node?: Maybe<EmailToOrderConfig>;
};

/** Methods to use when ordering `EmailToOrderConfig`. */
export enum EmailToOrderConfigsOrderBy {
  CHATGPT_BASEURL_ASC = 'CHATGPT_BASEURL_ASC',
  CHATGPT_BASEURL_DESC = 'CHATGPT_BASEURL_DESC',
  CHATGPT_REQUEST_ASC = 'CHATGPT_REQUEST_ASC',
  CHATGPT_REQUEST_DESC = 'CHATGPT_REQUEST_DESC',
  CHATGPT_TOKEN_ASC = 'CHATGPT_TOKEN_ASC',
  CHATGPT_TOKEN_DESC = 'CHATGPT_TOKEN_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EMAIL_FROM_ASC = 'EMAIL_FROM_ASC',
  EMAIL_FROM_DESC = 'EMAIL_FROM_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ENABLED_ASC = 'IS_ENABLED_ASC',
  IS_ENABLED_DESC = 'IS_ENABLED_DESC',
  LANGTEC_PASSWORD_ASC = 'LANGTEC_PASSWORD_ASC',
  LANGTEC_PASSWORD_DESC = 'LANGTEC_PASSWORD_DESC',
  LANGTEC_URL_ASC = 'LANGTEC_URL_ASC',
  LANGTEC_URL_DESC = 'LANGTEC_URL_DESC',
  LANGTEC_USERNAME_ASC = 'LANGTEC_USERNAME_ASC',
  LANGTEC_USERNAME_DESC = 'LANGTEC_USERNAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type EmailToOrderLog = Node & {
  __typename?: 'EmailToOrderLog';
  awsMessageId: Scalars['String']['output'];
  configId: Scalars['EmailToOrderConfigId']['output'];
  createdAt: Scalars['Datetime']['output'];
  emailMessageId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EmailToOrderConfig` that is related to this `EmailToOrderLog`. */
  emailToOrderConfigByConfigId?: Maybe<EmailToOrderConfig>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['EmailToOrderLogId']['output'];
  mailHtml: Scalars['String']['output'];
  mailSubject: Scalars['String']['output'];
  mailText: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  orderExternalIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Reads a single `Organization` that is related to this `EmailToOrderLog`. */
  organizationByRootOrg?: Maybe<Organization>;
  parsed?: Maybe<Scalars['JSON']['output']>;
  rootOrg: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `EmailToOrderLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EmailToOrderLogCondition = {
  /** Checks for equality with the object’s `awsMessageId` field. */
  awsMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `configId` field. */
  configId?: InputMaybe<Scalars['EmailToOrderConfigId']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `emailMessageId` field. */
  emailMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `error` field. */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['EmailToOrderLogId']['input']>;
  /** Checks for equality with the object’s `mailHtml` field. */
  mailHtml?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mailSubject` field. */
  mailSubject?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `mailText` field. */
  mailText?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderExternalIds` field. */
  orderExternalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `parsed` field. */
  parsed?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `EmailToOrderLog` object types. All fields are combined with a logical ‘and.’ */
export type EmailToOrderLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmailToOrderLogFilter>>;
  /** Filter by the object’s `awsMessageId` field. */
  awsMessageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `configId` field. */
  configId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `emailMessageId` field. */
  emailMessageId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `error` field. */
  error?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `mailHtml` field. */
  mailHtml?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mailSubject` field. */
  mailSubject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mailText` field. */
  mailText?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmailToOrderLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmailToOrderLogFilter>>;
  /** Filter by the object’s `orderExternalIds` field. */
  orderExternalIds?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `parsed` field. */
  parsed?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `EmailToOrderLog` */
export type EmailToOrderLogInput = {
  awsMessageId: Scalars['String']['input'];
  configId: Scalars['EmailToOrderConfigId']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailMessageId?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  mailHtml: Scalars['String']['input'];
  mailSubject: Scalars['String']['input'];
  mailText: Scalars['String']['input'];
  orderExternalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parsed?: InputMaybe<Scalars['JSON']['input']>;
  rootOrg: Scalars['OrganizationId']['input'];
};

/** Represents an update to a `EmailToOrderLog`. Fields that are set will be updated. */
export type EmailToOrderLogPatch = {
  awsMessageId?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['EmailToOrderConfigId']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  emailMessageId?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  mailHtml?: InputMaybe<Scalars['String']['input']>;
  mailSubject?: InputMaybe<Scalars['String']['input']>;
  mailText?: InputMaybe<Scalars['String']['input']>;
  orderExternalIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parsed?: InputMaybe<Scalars['JSON']['input']>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `EmailToOrderLog` values. */
export type EmailToOrderLogsConnection = {
  __typename?: 'EmailToOrderLogsConnection';
  /** A list of edges which contains the `EmailToOrderLog` and cursor to aid in pagination. */
  edges: Array<EmailToOrderLogsEdge>;
  /** A list of `EmailToOrderLog` objects. */
  nodes: Array<Maybe<EmailToOrderLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailToOrderLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EmailToOrderLog` edge in the connection. */
export type EmailToOrderLogsEdge = {
  __typename?: 'EmailToOrderLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmailToOrderLog` at the end of the edge. */
  node?: Maybe<EmailToOrderLog>;
};

/** Methods to use when ordering `EmailToOrderLog`. */
export enum EmailToOrderLogsOrderBy {
  AWS_MESSAGE_ID_ASC = 'AWS_MESSAGE_ID_ASC',
  AWS_MESSAGE_ID_DESC = 'AWS_MESSAGE_ID_DESC',
  CONFIG_ID_ASC = 'CONFIG_ID_ASC',
  CONFIG_ID_DESC = 'CONFIG_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  EMAIL_MESSAGE_ID_ASC = 'EMAIL_MESSAGE_ID_ASC',
  EMAIL_MESSAGE_ID_DESC = 'EMAIL_MESSAGE_ID_DESC',
  ERROR_ASC = 'ERROR_ASC',
  ERROR_DESC = 'ERROR_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MAIL_HTML_ASC = 'MAIL_HTML_ASC',
  MAIL_HTML_DESC = 'MAIL_HTML_DESC',
  MAIL_SUBJECT_ASC = 'MAIL_SUBJECT_ASC',
  MAIL_SUBJECT_DESC = 'MAIL_SUBJECT_DESC',
  MAIL_TEXT_ASC = 'MAIL_TEXT_ASC',
  MAIL_TEXT_DESC = 'MAIL_TEXT_DESC',
  NATURAL = 'NATURAL',
  ORDER_EXTERNAL_IDS_ASC = 'ORDER_EXTERNAL_IDS_ASC',
  ORDER_EXTERNAL_IDS_DESC = 'ORDER_EXTERNAL_IDS_DESC',
  PARSED_ASC = 'PARSED_ASC',
  PARSED_DESC = 'PARSED_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type Emissions = {
  __typename?: 'Emissions';
  HFO?: Maybe<ResultResponseDouble>;
  LNG?: Maybe<ResultResponseDouble>;
  LSFO?: Maybe<ResultResponseDouble>;
  MGO?: Maybe<ResultResponseDouble>;
};

export enum EventType {
  BUNKERING = 'BUNKERING',
  CANAL_TRANSIT = 'CANAL_TRANSIT',
  CLEANING = 'CLEANING',
  CONGESTION = 'CONGESTION',
  DRIFTING = 'DRIFTING',
  MANEUVERING = 'MANEUVERING',
  OTHER = 'OTHER',
  PASSING = 'PASSING',
  REPAIR = 'REPAIR',
  WAITING = 'WAITING'
}

/** A filter to be used against EventType fields. All fields are combined with a logical ‘and.’ */
export type EventTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EventType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EventType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EventType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EventType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EventType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<EventType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EventType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EventType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EventType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EventType>>;
};

export type ExternalPortCostPredictionsInput = {
  /** '1' if ETA is a working day, '0' if not */
  bizday: Scalars['String']['input'];
  /** Amount of cargo loaded/discharged */
  cargo: Scalars['String']['input'];
  /** Vessel deadweight tonnage (DWT) */
  dwt: Scalars['String']['input'];
  /** ETA month '1'-'12' */
  month: Scalars['String']['input'];
  /** Performed cargo operation: '0' for discharge, '1' for loading */
  port_func: Scalars['String']['input'];
  port_name: Scalars['String']['input'];
  vessel_name: Scalars['String']['input'];
  /** ETA year */
  year: Scalars['String']['input'];
};

export type ExternalPortCostPredictionsPredictedResult = {
  __typename?: 'ExternalPortCostPredictionsPredictedResult';
  fairway_dues: Scalars['Float']['output'];
  harbor_dues: Scalars['Float']['output'];
  mooring_dues: Scalars['Float']['output'];
  pilotage_dues: Scalars['Float']['output'];
  tonnage_dues: Scalars['Float']['output'];
  total_dues: Scalars['Float']['output'];
  towage_dues: Scalars['Float']['output'];
};

export type ExternalPortCostPredictionsResult = {
  __typename?: 'ExternalPortCostPredictionsResult';
  predicted?: Maybe<ExternalPortCostPredictionsPredictedResult>;
};

export type ExtraFreightInput = {
  amount: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FreightType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type Feature = Node & {
  __typename?: 'Feature';
  featureName: Scalars['FeatureFeatureNameString']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrganizationFeature`. */
  organizationFeaturesByFeatureName: OrganizationFeaturesConnection;
};


export type FeatureOrganizationFeaturesByFeatureNameArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationFeatureCondition>;
  filter?: InputMaybe<OrganizationFeatureFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationFeaturesOrderBy>>;
};

/** A condition to be used against `Feature` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FeatureCondition = {
  /** Checks for equality with the object’s `featureName` field. */
  featureName?: InputMaybe<Scalars['FeatureFeatureNameString']['input']>;
};

/** A filter to be used against `Feature` object types. All fields are combined with a logical ‘and.’ */
export type FeatureFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeatureFilter>>;
  /** Filter by the object’s `featureName` field. */
  featureName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeatureFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeatureFilter>>;
};

/** An input for mutations affecting `Feature` */
export type FeatureInput = {
  featureName: Scalars['FeatureFeatureNameString']['input'];
};

/** Represents an update to a `Feature`. Fields that are set will be updated. */
export type FeaturePatch = {
  featureName?: InputMaybe<Scalars['FeatureFeatureNameString']['input']>;
};

/** A connection to a list of `Feature` values. */
export type FeaturesConnection = {
  __typename?: 'FeaturesConnection';
  /** A list of edges which contains the `Feature` and cursor to aid in pagination. */
  edges: Array<FeaturesEdge>;
  /** A list of `Feature` objects. */
  nodes: Array<Maybe<Feature>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Feature` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Feature` edge in the connection. */
export type FeaturesEdge = {
  __typename?: 'FeaturesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Feature` at the end of the edge. */
  node?: Maybe<Feature>;
};

/** Methods to use when ordering `Feature`. */
export enum FeaturesOrderBy {
  FEATURE_NAME_ASC = 'FEATURE_NAME_ASC',
  FEATURE_NAME_DESC = 'FEATURE_NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type File = Node & {
  __typename?: 'File';
  id: Scalars['FileId']['output'];
  /** Reads a single `Location` that is related to this `File`. */
  locationByLocationId?: Maybe<Location>;
  locationId?: Maybe<Scalars['LocationId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `File`. */
  orderByOrderId?: Maybe<Order>;
  orderId?: Maybe<Scalars['OrderId']['output']>;
  /** Reads a single `PortCallFile` that is related to this `File`. */
  portCallFileByFileId?: Maybe<PortCallFile>;
  /**
   * Reads and enables pagination through a set of `PortCallFile`.
   * @deprecated Please use portCallFileByFileId instead
   */
  portCallFilesByFileId: PortCallFilesConnection;
  /** Reads a single `Ship` that is related to this `File`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `Shipment` that is related to this `File`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['ShipmentId']['output']>;
  type: DocumentType;
  uploaded?: Maybe<Scalars['Datetime']['output']>;
  uri: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `File`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads a single `Voyage` that is related to this `File`. */
  voyageByVoyageId?: Maybe<Voyage>;
  voyageId?: Maybe<Scalars['VoyageId']['output']>;
};


export type FilePortCallFilesByFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallFileCondition>;
  filter?: InputMaybe<PortCallFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallFilesOrderBy>>;
};

/** A condition to be used against `File` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FileCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['FileId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<DocumentType>;
  /** Checks for equality with the object’s `uploaded` field. */
  uploaded?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `uri` field. */
  uri?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `voyageId` field. */
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** A filter to be used against `File` object types. All fields are combined with a logical ‘and.’ */
export type FileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<DocumentTypeFilter>;
  /** Filter by the object’s `uploaded` field. */
  uploaded?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `uri` field. */
  uri?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageId` field. */
  voyageId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `File` */
export type FileInput = {
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  type: DocumentType;
  uploaded?: InputMaybe<Scalars['Datetime']['input']>;
  uri: Scalars['String']['input'];
  userId: Scalars['UserId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** Represents an update to a `File`. Fields that are set will be updated. */
export type FilePatch = {
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  type?: InputMaybe<DocumentType>;
  uploaded?: InputMaybe<Scalars['Datetime']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** A connection to a list of `File` values. */
export type FilesConnection = {
  __typename?: 'FilesConnection';
  /** A list of edges which contains the `File` and cursor to aid in pagination. */
  edges: Array<FilesEdge>;
  /** A list of `File` objects. */
  nodes: Array<Maybe<File>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `File` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `File` edge in the connection. */
export type FilesEdge = {
  __typename?: 'FilesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `File` at the end of the edge. */
  node?: Maybe<File>;
};

/** Methods to use when ordering `File`. */
export enum FilesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  NOTE_ASC = 'NOTE_ASC',
  NOTE_DESC = 'NOTE_DESC',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UPLOADED_ASC = 'UPLOADED_ASC',
  UPLOADED_DESC = 'UPLOADED_DESC',
  URI_ASC = 'URI_ASC',
  URI_DESC = 'URI_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC',
  VOYAGE_ID_ASC = 'VOYAGE_ID_ASC',
  VOYAGE_ID_DESC = 'VOYAGE_ID_DESC'
}

/** All input for the `findOrCreateLocationCluster` mutation. */
export type FindOrCreateLocationClusterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['BigFloat']['input']>;
  lng?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** The output of our `findOrCreateLocationCluster` mutation. */
export type FindOrCreateLocationClusterPayload = {
  __typename?: 'FindOrCreateLocationClusterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** All input for the `formatTimestampWithOffset` mutation. */
export type FormatTimestampWithOffsetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inputTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  targetTimezone?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `formatTimestampWithOffset` mutation. */
export type FormatTimestampWithOffsetPayload = {
  __typename?: 'FormatTimestampWithOffsetPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']['output']>;
};

export enum FreightType {
  LUMPSUM = 'LUMPSUM',
  PERCENTAGE = 'PERCENTAGE',
  RATE = 'RATE'
}

/** A filter to be used against FreightType fields. All fields are combined with a logical ‘and.’ */
export type FreightTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FreightType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FreightType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FreightType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FreightType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FreightType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FreightType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FreightType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FreightType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FreightType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FreightType>>;
};

export type FuelConsumptionBreakdown = {
  __typename?: 'FuelConsumptionBreakdown';
  errors: Array<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
  value?: Maybe<FuelSummaries>;
};

export type FuelInput = {
  availableFuels: Array<FuelTypeInput>;
  insideEca: Scalars['String']['input'];
  outsideEca: Scalars['String']['input'];
};

export type FuelSummaries = {
  __typename?: 'FuelSummaries';
  HFO?: Maybe<FuelSummary>;
  LNG?: Maybe<FuelSummary>;
  LSFO?: Maybe<FuelSummary>;
  MGO?: Maybe<FuelSummary>;
};

export type FuelSummary = {
  __typename?: 'FuelSummary';
  consumption: Scalars['Float']['output'];
  cost: Scalars['Float']['output'];
};

export type FuelType = {
  __typename?: 'FuelType';
  /**  Unknow if this is correct, swagger has no info  */
  description?: Maybe<Scalars['String']['output']>;
};

export type FuelTypeInput = {
  lowerHeatValue?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  type: Scalars['String']['input'];
};

/** All input for the `generateInitialsForAllUsers` mutation. */
export type GenerateInitialsForAllUsersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `generateInitialsForAllUsers` mutation. */
export type GenerateInitialsForAllUsersPayload = {
  __typename?: 'GenerateInitialsForAllUsersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export enum GenericLoadUnitType {
  ADMT_DAY = 'ADMT_DAY',
  ADMT_HOUR = 'ADMT_HOUR',
  BDMT_DAY = 'BDMT_DAY',
  BDMT_HOUR = 'BDMT_HOUR',
  CUBIC_FEET_PER_DAY = 'CUBIC_FEET_PER_DAY',
  CUBIC_FEET_PER_HOUR = 'CUBIC_FEET_PER_HOUR',
  CUBIC_METERS_PER_DAY = 'CUBIC_METERS_PER_DAY',
  CUBIC_METERS_PER_HOUR = 'CUBIC_METERS_PER_HOUR',
  DAYS_FOR_WHOLE_PARCEL = 'DAYS_FOR_WHOLE_PARCEL',
  HOURS_FOR_WHOLE_PARCEL = 'HOURS_FOR_WHOLE_PARCEL',
  METRIC_TONNES_PER_DAY = 'METRIC_TONNES_PER_DAY',
  METRIC_TONNES_PER_HOUR = 'METRIC_TONNES_PER_HOUR',
  SCBMOB_DAY = 'SCBMOB_DAY',
  SCBMOB_HOUR = 'SCBMOB_HOUR',
  SCBMUB_DAY = 'SCBMUB_DAY',
  SCBMUB_HOUR = 'SCBMUB_HOUR'
}

export enum GenericMarginUnitEnumType {
  MINMAX = 'MINMAX',
  PERCENTAGE = 'PERCENTAGE',
  TONNES = 'TONNES'
}

export type GenericOrderInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assortment_group?: InputMaybe<Scalars['String']['input']>;
  assortment_margin_amount?: InputMaybe<Scalars['String']['input']>;
  assortment_margin_unit?: InputMaybe<MarginUnit>;
  assortment_name?: InputMaybe<Scalars['String']['input']>;
  assortment_specific_gravity?: InputMaybe<Scalars['String']['input']>;
  assortment_stowage_factor_max?: InputMaybe<Scalars['String']['input']>;
  assortment_stowage_factor_min?: InputMaybe<Scalars['String']['input']>;
  cargo_amount: Scalars['String']['input'];
  cargo_unit: Scalars['String']['input'];
  charterer_org_name?: InputMaybe<Scalars['String']['input']>;
  coa_id?: InputMaybe<Scalars['Int']['input']>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  demurrage?: InputMaybe<Scalars['String']['input']>;
  discharge_port_name?: InputMaybe<Scalars['String']['input']>;
  discharging_rate?: InputMaybe<Scalars['String']['input']>;
  discharging_unit?: InputMaybe<LoadingUnit>;
  earliest_discharging?: InputMaybe<Scalars['Date']['input']>;
  earliest_loading?: InputMaybe<Scalars['Date']['input']>;
  external_order_id?: InputMaybe<Scalars['String']['input']>;
  fixture_note?: InputMaybe<Scalars['String']['input']>;
  freight_amount?: InputMaybe<Scalars['String']['input']>;
  freight_unit?: InputMaybe<Scalars['String']['input']>;
  isLostContract?: InputMaybe<Scalars['Boolean']['input']>;
  is_inquiry?: InputMaybe<Scalars['Boolean']['input']>;
  is_preliminary?: InputMaybe<Scalars['Boolean']['input']>;
  latest_discharging?: InputMaybe<Scalars['Date']['input']>;
  latest_loading?: InputMaybe<Scalars['Date']['input']>;
  load_port_name?: InputMaybe<Scalars['String']['input']>;
  loading_rate?: InputMaybe<Scalars['String']['input']>;
  loading_unit?: InputMaybe<LoadingUnit>;
  margin_amount?: InputMaybe<Scalars['String']['input']>;
  margin_unit?: InputMaybe<MarginUnit>;
  nominated_vessel?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['Int']['input']>;
  order_name?: InputMaybe<Scalars['String']['input']>;
  order_notes?: InputMaybe<Scalars['String']['input']>;
  order_removed?: InputMaybe<Scalars['Boolean']['input']>;
  otherIncome?: InputMaybe<Scalars['Float']['input']>;
  shipowner_org_name?: InputMaybe<Scalars['String']['input']>;
  specific_gravity?: InputMaybe<Scalars['String']['input']>;
  stowage_factor_max?: InputMaybe<Scalars['String']['input']>;
  stowage_factor_min?: InputMaybe<Scalars['String']['input']>;
  voyage_charter_external_id?: InputMaybe<Scalars['String']['input']>;
  voyage_charter_name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `GeographicalEntity` values. */
export type GeographicalEntitiesConnection = {
  __typename?: 'GeographicalEntitiesConnection';
  /** A list of edges which contains the `GeographicalEntity` and cursor to aid in pagination. */
  edges: Array<GeographicalEntitiesEdge>;
  /** A list of `GeographicalEntity` objects. */
  nodes: Array<Maybe<GeographicalEntity>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GeographicalEntity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GeographicalEntity` edge in the connection. */
export type GeographicalEntitiesEdge = {
  __typename?: 'GeographicalEntitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GeographicalEntity` at the end of the edge. */
  node?: Maybe<GeographicalEntity>;
};

/** Methods to use when ordering `GeographicalEntity`. */
export enum GeographicalEntitiesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHAPE_ASC = 'SHAPE_ASC',
  SHAPE_DESC = 'SHAPE_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type GeographicalEntity = Node & {
  __typename?: 'GeographicalEntity';
  /** Reads and enables pagination through a set of `Channel`. */
  channelsByGeoId: ChannelsConnection;
  /** Reads and enables pagination through a set of `GeographicalRelation`. */
  geographicalRelationsByEntityId: GeographicalRelationsConnection;
  /** Reads and enables pagination through a set of `Holiday`. */
  holidaysByGeoId: HolidaysConnection;
  id: Scalars['GeographicalEntityId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Organization` that is related to this `GeographicalEntity`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads and enables pagination through a set of `PortRegion`. */
  portRegionsByGeographicalEntityId: PortRegionsConnection;
  shape?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `User` that is related to this `GeographicalEntity`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};


export type GeographicalEntityChannelsByGeoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCondition>;
  filter?: InputMaybe<ChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelsOrderBy>>;
};


export type GeographicalEntityGeographicalRelationsByEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GeographicalRelationCondition>;
  filter?: InputMaybe<GeographicalRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeographicalRelationsOrderBy>>;
};


export type GeographicalEntityHolidaysByGeoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HolidayCondition>;
  filter?: InputMaybe<HolidayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HolidaysOrderBy>>;
};


export type GeographicalEntityPortRegionsByGeographicalEntityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortRegionCondition>;
  filter?: InputMaybe<PortRegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortRegionsOrderBy>>;
};

/**
 * A condition to be used against `GeographicalEntity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GeographicalEntityCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shape` field. */
  shape?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `GeographicalEntity` object types. All fields are combined with a logical ‘and.’ */
export type GeographicalEntityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GeographicalEntityFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GeographicalEntityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GeographicalEntityFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `GeographicalEntity` */
export type GeographicalEntityInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shape?: InputMaybe<Scalars['JSON']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `GeographicalEntity`. Fields that are set will be updated. */
export type GeographicalEntityPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shape?: InputMaybe<Scalars['JSON']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

export type GeographicalRelation = Node & {
  __typename?: 'GeographicalRelation';
  entityId?: Maybe<Scalars['GeographicalEntityId']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `GeographicalRelation`. */
  geographicalEntityByEntityId?: Maybe<GeographicalEntity>;
  id: Scalars['GeographicalRelationId']['output'];
  /** Reads a single `Location` that is related to this `GeographicalRelation`. */
  locationByLocationId?: Maybe<Location>;
  locationId?: Maybe<Scalars['LocationId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `GeographicalRelation`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};

/**
 * A condition to be used against `GeographicalRelation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GeographicalRelationCondition = {
  /** Checks for equality with the object’s `entityId` field. */
  entityId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['GeographicalRelationId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `GeographicalRelation` object types. All fields are combined with a logical ‘and.’ */
export type GeographicalRelationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GeographicalRelationFilter>>;
  /** Filter by the object’s `entityId` field. */
  entityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GeographicalRelationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GeographicalRelationFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `GeographicalRelation` */
export type GeographicalRelationInput = {
  entityId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `GeographicalRelation`. Fields that are set will be updated. */
export type GeographicalRelationPatch = {
  entityId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `GeographicalRelation` values. */
export type GeographicalRelationsConnection = {
  __typename?: 'GeographicalRelationsConnection';
  /** A list of edges which contains the `GeographicalRelation` and cursor to aid in pagination. */
  edges: Array<GeographicalRelationsEdge>;
  /** A list of `GeographicalRelation` objects. */
  nodes: Array<Maybe<GeographicalRelation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GeographicalRelation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `GeographicalRelation` edge in the connection. */
export type GeographicalRelationsEdge = {
  __typename?: 'GeographicalRelationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `GeographicalRelation` at the end of the edge. */
  node?: Maybe<GeographicalRelation>;
};

/** Methods to use when ordering `GeographicalRelation`. */
export enum GeographicalRelationsOrderBy {
  ENTITY_ID_ASC = 'ENTITY_ID_ASC',
  ENTITY_ID_DESC = 'ENTITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** A `Int` edge in the connection. */
export type GetChildOrgEdge = {
  __typename?: 'GetChildOrgEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Int` at the end of the edge. */
  node?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of `Int` values. */
export type GetChildOrgsConnection = {
  __typename?: 'GetChildOrgsConnection';
  /** A list of edges which contains the `Int` and cursor to aid in pagination. */
  edges: Array<GetChildOrgEdge>;
  /** A list of `Int` objects. */
  nodes: Array<Maybe<Scalars['Int']['output']>>;
  /** The count of *all* `Int` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type GetMarcuraPortCostInput = {
  assortmentId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
};

/** A connection to a list of `Int` values. */
export type GetOrgHierarchyConnection = {
  __typename?: 'GetOrgHierarchyConnection';
  /** A list of edges which contains the `Int` and cursor to aid in pagination. */
  edges: Array<GetOrgHierarchyEdge>;
  /** A list of `Int` objects. */
  nodes: Array<Maybe<Scalars['Int']['output']>>;
  /** The count of *all* `Int` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Int` edge in the connection. */
export type GetOrgHierarchyEdge = {
  __typename?: 'GetOrgHierarchyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Int` at the end of the edge. */
  node?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of `Int` values. */
export type GetOrgTreeConnection = {
  __typename?: 'GetOrgTreeConnection';
  /** A list of edges which contains the `Int` and cursor to aid in pagination. */
  edges: Array<GetOrgTreeEdge>;
  /** A list of `Int` objects. */
  nodes: Array<Maybe<Scalars['Int']['output']>>;
  /** The count of *all* `Int` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Int` edge in the connection. */
export type GetOrgTreeEdge = {
  __typename?: 'GetOrgTreeEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Int` at the end of the edge. */
  node?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of `Int` values. */
export type GetRootOrgConnection = {
  __typename?: 'GetRootOrgConnection';
  /** A list of edges which contains the `Int` and cursor to aid in pagination. */
  edges: Array<GetRootOrgEdge>;
  /** A list of `Int` objects. */
  nodes: Array<Maybe<Scalars['Int']['output']>>;
  /** The count of *all* `Int` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Int` edge in the connection. */
export type GetRootOrgEdge = {
  __typename?: 'GetRootOrgEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Int` at the end of the edge. */
  node?: Maybe<Scalars['Int']['output']>;
};

export type GetVesonBunkerResult = {
  __typename?: 'GetVesonBunkerResult';
  defaultBunkerOfVessels?: Maybe<Array<VesonDefaultBunkerOfVessel>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  remainingBunkerOfVoyages?: Maybe<Array<VesonRemainingBunkerOfVoyage>>;
};

export type GetVesonPnlResult = {
  __typename?: 'GetVesonPnlResult';
  voyagePnl: Array<VesonVoyagePnl>;
};

export type GoogleAuthenticateInput = {
  idToken: Scalars['String']['input'];
};

export type GoogleAuthenticatePayload = {
  __typename?: 'GoogleAuthenticatePayload';
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
};

export type HandledByCoa = Node & {
  __typename?: 'HandledByCoa';
  archived: Scalars['Boolean']['output'];
  clientId: Scalars['UUID']['output'];
  /** Reads a single `CoaContract` that is related to this `HandledByCoa`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  coaId: Scalars['CoaContractId']['output'];
  createdByUserId?: Maybe<Scalars['UserId']['output']>;
  dischargingConcurrent: Scalars['Boolean']['output'];
  dischargingDuration: Scalars['BigInt']['output'];
  dischargingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingEnd: Scalars['Datetime']['output'];
  dischargingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingStart: Scalars['Datetime']['output'];
  dischargingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `HandledByCoaHistory`. */
  handledByCoaHistoriesById: HandledByCoaHistoriesConnection;
  id: Scalars['HandledByCoaId']['output'];
  loadingConcurrent: Scalars['Boolean']['output'];
  loadingDuration: Scalars['BigInt']['output'];
  loadingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingEnd: Scalars['Datetime']['output'];
  loadingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingStart: Scalars['Datetime']['output'];
  loadingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `HandledByCoa`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Organization` that is related to this `HandledByCoa`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  shared: Scalars['Boolean']['output'];
  /** Reads a single `Ship` that is related to this `HandledByCoa`. */
  shipByVesselId?: Maybe<Ship>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `HandledByCoa`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledByCoa`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};


export type HandledByCoaHandledByCoaHistoriesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaHistoryCondition>;
  filter?: InputMaybe<HandledByCoaHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoaHistoriesOrderBy>>;
};

/**
 * A condition to be used against `HandledByCoa` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type HandledByCoaCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `coaId` field. */
  coaId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['HandledByCoaId']['input']>;
  /** Checks for equality with the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `HandledByCoa` object types. All fields are combined with a logical ‘and.’ */
export type HandledByCoaFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HandledByCoaFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `coaId` field. */
  coaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HandledByCoaFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HandledByCoaFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `HandledByCoaHistory` values. */
export type HandledByCoaHistoriesConnection = {
  __typename?: 'HandledByCoaHistoriesConnection';
  /** A list of edges which contains the `HandledByCoaHistory` and cursor to aid in pagination. */
  edges: Array<HandledByCoaHistoriesEdge>;
  /** A list of `HandledByCoaHistory` objects. */
  nodes: Array<Maybe<HandledByCoaHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HandledByCoaHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `HandledByCoaHistory` edge in the connection. */
export type HandledByCoaHistoriesEdge = {
  __typename?: 'HandledByCoaHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `HandledByCoaHistory` at the end of the edge. */
  node?: Maybe<HandledByCoaHistory>;
};

/** Methods to use when ordering `HandledByCoaHistory`. */
export enum HandledByCoaHistoriesOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  COA_ID_ASC = 'COA_ID_ASC',
  COA_ID_DESC = 'COA_ID_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DISCHARGING_CONCURRENT_ASC = 'DISCHARGING_CONCURRENT_ASC',
  DISCHARGING_CONCURRENT_DESC = 'DISCHARGING_CONCURRENT_DESC',
  DISCHARGING_DURATION_ASC = 'DISCHARGING_DURATION_ASC',
  DISCHARGING_DURATION_DESC = 'DISCHARGING_DURATION_DESC',
  DISCHARGING_DURATION_OVERRIDE_ASC = 'DISCHARGING_DURATION_OVERRIDE_ASC',
  DISCHARGING_DURATION_OVERRIDE_DESC = 'DISCHARGING_DURATION_OVERRIDE_DESC',
  DISCHARGING_END_ASC = 'DISCHARGING_END_ASC',
  DISCHARGING_END_DESC = 'DISCHARGING_END_DESC',
  DISCHARGING_SEA_DURATION_OVERRIDE_ASC = 'DISCHARGING_SEA_DURATION_OVERRIDE_ASC',
  DISCHARGING_SEA_DURATION_OVERRIDE_DESC = 'DISCHARGING_SEA_DURATION_OVERRIDE_DESC',
  DISCHARGING_START_ASC = 'DISCHARGING_START_ASC',
  DISCHARGING_START_DESC = 'DISCHARGING_START_DESC',
  DISCHARGING_START_OVERRIDE_ASC = 'DISCHARGING_START_OVERRIDE_ASC',
  DISCHARGING_START_OVERRIDE_DESC = 'DISCHARGING_START_OVERRIDE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_CONCURRENT_ASC = 'LOADING_CONCURRENT_ASC',
  LOADING_CONCURRENT_DESC = 'LOADING_CONCURRENT_DESC',
  LOADING_DURATION_ASC = 'LOADING_DURATION_ASC',
  LOADING_DURATION_DESC = 'LOADING_DURATION_DESC',
  LOADING_DURATION_OVERRIDE_ASC = 'LOADING_DURATION_OVERRIDE_ASC',
  LOADING_DURATION_OVERRIDE_DESC = 'LOADING_DURATION_OVERRIDE_DESC',
  LOADING_END_ASC = 'LOADING_END_ASC',
  LOADING_END_DESC = 'LOADING_END_DESC',
  LOADING_SEA_DURATION_OVERRIDE_ASC = 'LOADING_SEA_DURATION_OVERRIDE_ASC',
  LOADING_SEA_DURATION_OVERRIDE_DESC = 'LOADING_SEA_DURATION_OVERRIDE_DESC',
  LOADING_START_ASC = 'LOADING_START_ASC',
  LOADING_START_DESC = 'LOADING_START_DESC',
  LOADING_START_OVERRIDE_ASC = 'LOADING_START_OVERRIDE_ASC',
  LOADING_START_OVERRIDE_DESC = 'LOADING_START_OVERRIDE_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for handled_by_coa table */
export type HandledByCoaHistory = {
  __typename?: 'HandledByCoaHistory';
  archived: Scalars['Boolean']['output'];
  clientId: Scalars['UUID']['output'];
  coaId: Scalars['Int']['output'];
  createdByUserId?: Maybe<Scalars['UserId']['output']>;
  dischargingConcurrent: Scalars['Boolean']['output'];
  dischargingDuration: Scalars['BigInt']['output'];
  dischargingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingEnd: Scalars['Datetime']['output'];
  dischargingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingStart: Scalars['Datetime']['output'];
  dischargingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `HandledByCoa` that is related to this `HandledByCoaHistory`. */
  handledByCoaById?: Maybe<HandledByCoa>;
  id: Scalars['HandledByCoaId']['output'];
  loadingConcurrent: Scalars['Boolean']['output'];
  loadingDuration: Scalars['BigInt']['output'];
  loadingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingEnd: Scalars['Datetime']['output'];
  loadingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingStart: Scalars['Datetime']['output'];
  loadingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  orderId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  shared: Scalars['Boolean']['output'];
  /** Reads a single `Ship` that is related to this `HandledByCoaHistory`. */
  shipByVesselId?: Maybe<Ship>;
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `HandledByCoaHistory`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledByCoaHistory`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};

/**
 * A condition to be used against `HandledByCoaHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type HandledByCoaHistoryCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `coaId` field. */
  coaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['HandledByCoaId']['input']>;
  /** Checks for equality with the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `HandledByCoaHistory` object types. All fields are combined with a logical ‘and.’ */
export type HandledByCoaHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HandledByCoaHistoryFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `coaId` field. */
  coaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HandledByCoaHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HandledByCoaHistoryFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `HandledByCoa` */
export type HandledByCoaInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  coaId: Scalars['CoaContractId']['input'];
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  dischargingDuration: Scalars['BigInt']['input'];
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingEnd: Scalars['Datetime']['input'];
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingStart: Scalars['Datetime']['input'];
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDuration: Scalars['BigInt']['input'];
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingEnd: Scalars['Datetime']['input'];
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingStart: Scalars['Datetime']['input'];
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `HandledByCoa`. Fields that are set will be updated. */
export type HandledByCoaPatch = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  coaId?: InputMaybe<Scalars['CoaContractId']['input']>;
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `HandledByCoa` values. */
export type HandledByCoasConnection = {
  __typename?: 'HandledByCoasConnection';
  /** A list of edges which contains the `HandledByCoa` and cursor to aid in pagination. */
  edges: Array<HandledByCoasEdge>;
  /** A list of `HandledByCoa` objects. */
  nodes: Array<Maybe<HandledByCoa>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HandledByCoa` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `HandledByCoa` edge in the connection. */
export type HandledByCoasEdge = {
  __typename?: 'HandledByCoasEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `HandledByCoa` at the end of the edge. */
  node?: Maybe<HandledByCoa>;
};

/** Methods to use when ordering `HandledByCoa`. */
export enum HandledByCoasOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  COA_ID_ASC = 'COA_ID_ASC',
  COA_ID_DESC = 'COA_ID_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DISCHARGING_CONCURRENT_ASC = 'DISCHARGING_CONCURRENT_ASC',
  DISCHARGING_CONCURRENT_DESC = 'DISCHARGING_CONCURRENT_DESC',
  DISCHARGING_DURATION_ASC = 'DISCHARGING_DURATION_ASC',
  DISCHARGING_DURATION_DESC = 'DISCHARGING_DURATION_DESC',
  DISCHARGING_DURATION_OVERRIDE_ASC = 'DISCHARGING_DURATION_OVERRIDE_ASC',
  DISCHARGING_DURATION_OVERRIDE_DESC = 'DISCHARGING_DURATION_OVERRIDE_DESC',
  DISCHARGING_END_ASC = 'DISCHARGING_END_ASC',
  DISCHARGING_END_DESC = 'DISCHARGING_END_DESC',
  DISCHARGING_SEA_DURATION_OVERRIDE_ASC = 'DISCHARGING_SEA_DURATION_OVERRIDE_ASC',
  DISCHARGING_SEA_DURATION_OVERRIDE_DESC = 'DISCHARGING_SEA_DURATION_OVERRIDE_DESC',
  DISCHARGING_START_ASC = 'DISCHARGING_START_ASC',
  DISCHARGING_START_DESC = 'DISCHARGING_START_DESC',
  DISCHARGING_START_OVERRIDE_ASC = 'DISCHARGING_START_OVERRIDE_ASC',
  DISCHARGING_START_OVERRIDE_DESC = 'DISCHARGING_START_OVERRIDE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_CONCURRENT_ASC = 'LOADING_CONCURRENT_ASC',
  LOADING_CONCURRENT_DESC = 'LOADING_CONCURRENT_DESC',
  LOADING_DURATION_ASC = 'LOADING_DURATION_ASC',
  LOADING_DURATION_DESC = 'LOADING_DURATION_DESC',
  LOADING_DURATION_OVERRIDE_ASC = 'LOADING_DURATION_OVERRIDE_ASC',
  LOADING_DURATION_OVERRIDE_DESC = 'LOADING_DURATION_OVERRIDE_DESC',
  LOADING_END_ASC = 'LOADING_END_ASC',
  LOADING_END_DESC = 'LOADING_END_DESC',
  LOADING_SEA_DURATION_OVERRIDE_ASC = 'LOADING_SEA_DURATION_OVERRIDE_ASC',
  LOADING_SEA_DURATION_OVERRIDE_DESC = 'LOADING_SEA_DURATION_OVERRIDE_DESC',
  LOADING_START_ASC = 'LOADING_START_ASC',
  LOADING_START_DESC = 'LOADING_START_DESC',
  LOADING_START_OVERRIDE_ASC = 'LOADING_START_OVERRIDE_ASC',
  LOADING_START_OVERRIDE_DESC = 'LOADING_START_OVERRIDE_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type HandledBySpot = Node & {
  __typename?: 'HandledBySpot';
  archived: Scalars['Boolean']['output'];
  clientId: Scalars['UUID']['output'];
  createdByUserId?: Maybe<Scalars['UserId']['output']>;
  dischargingConcurrent: Scalars['Boolean']['output'];
  dischargingDuration: Scalars['BigInt']['output'];
  dischargingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingEnd: Scalars['Datetime']['output'];
  dischargingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingStart: Scalars['Datetime']['output'];
  dischargingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `HandledBySpotHistory`. */
  handledBySpotHistoriesById: HandledBySpotHistoriesConnection;
  id: Scalars['HandledBySpotId']['output'];
  loadingConcurrent: Scalars['Boolean']['output'];
  loadingDuration: Scalars['BigInt']['output'];
  loadingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingEnd: Scalars['Datetime']['output'];
  loadingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingStart: Scalars['Datetime']['output'];
  loadingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `HandledBySpot`. */
  orderByOrderId?: Maybe<Order>;
  orderId?: Maybe<Scalars['OrderId']['output']>;
  /** Reads a single `Organization` that is related to this `HandledBySpot`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `HandledBySpot`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Shipowner org that might be assigned (by Charterer org) or not (null) */
  ownerOrganisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  shared: Scalars['Boolean']['output'];
  /** Reads a single `Ship` that is related to this `HandledBySpot`. */
  shipByVesselId?: Maybe<Ship>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `HandledBySpot`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledBySpot`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};


export type HandledBySpotHandledBySpotHistoriesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotHistoryCondition>;
  filter?: InputMaybe<HandledBySpotHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotHistoriesOrderBy>>;
};

/**
 * A condition to be used against `HandledBySpot` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type HandledBySpotCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['HandledBySpotId']['input']>;
  /** Checks for equality with the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `HandledBySpot` object types. All fields are combined with a logical ‘and.’ */
export type HandledBySpotFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HandledBySpotFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HandledBySpotFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HandledBySpotFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `HandledBySpotHistory` values. */
export type HandledBySpotHistoriesConnection = {
  __typename?: 'HandledBySpotHistoriesConnection';
  /** A list of edges which contains the `HandledBySpotHistory` and cursor to aid in pagination. */
  edges: Array<HandledBySpotHistoriesEdge>;
  /** A list of `HandledBySpotHistory` objects. */
  nodes: Array<Maybe<HandledBySpotHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HandledBySpotHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `HandledBySpotHistory` edge in the connection. */
export type HandledBySpotHistoriesEdge = {
  __typename?: 'HandledBySpotHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `HandledBySpotHistory` at the end of the edge. */
  node?: Maybe<HandledBySpotHistory>;
};

/** Methods to use when ordering `HandledBySpotHistory`. */
export enum HandledBySpotHistoriesOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DISCHARGING_CONCURRENT_ASC = 'DISCHARGING_CONCURRENT_ASC',
  DISCHARGING_CONCURRENT_DESC = 'DISCHARGING_CONCURRENT_DESC',
  DISCHARGING_DURATION_ASC = 'DISCHARGING_DURATION_ASC',
  DISCHARGING_DURATION_DESC = 'DISCHARGING_DURATION_DESC',
  DISCHARGING_DURATION_OVERRIDE_ASC = 'DISCHARGING_DURATION_OVERRIDE_ASC',
  DISCHARGING_DURATION_OVERRIDE_DESC = 'DISCHARGING_DURATION_OVERRIDE_DESC',
  DISCHARGING_END_ASC = 'DISCHARGING_END_ASC',
  DISCHARGING_END_DESC = 'DISCHARGING_END_DESC',
  DISCHARGING_SEA_DURATION_OVERRIDE_ASC = 'DISCHARGING_SEA_DURATION_OVERRIDE_ASC',
  DISCHARGING_SEA_DURATION_OVERRIDE_DESC = 'DISCHARGING_SEA_DURATION_OVERRIDE_DESC',
  DISCHARGING_START_ASC = 'DISCHARGING_START_ASC',
  DISCHARGING_START_DESC = 'DISCHARGING_START_DESC',
  DISCHARGING_START_OVERRIDE_ASC = 'DISCHARGING_START_OVERRIDE_ASC',
  DISCHARGING_START_OVERRIDE_DESC = 'DISCHARGING_START_OVERRIDE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_CONCURRENT_ASC = 'LOADING_CONCURRENT_ASC',
  LOADING_CONCURRENT_DESC = 'LOADING_CONCURRENT_DESC',
  LOADING_DURATION_ASC = 'LOADING_DURATION_ASC',
  LOADING_DURATION_DESC = 'LOADING_DURATION_DESC',
  LOADING_DURATION_OVERRIDE_ASC = 'LOADING_DURATION_OVERRIDE_ASC',
  LOADING_DURATION_OVERRIDE_DESC = 'LOADING_DURATION_OVERRIDE_DESC',
  LOADING_END_ASC = 'LOADING_END_ASC',
  LOADING_END_DESC = 'LOADING_END_DESC',
  LOADING_SEA_DURATION_OVERRIDE_ASC = 'LOADING_SEA_DURATION_OVERRIDE_ASC',
  LOADING_SEA_DURATION_OVERRIDE_DESC = 'LOADING_SEA_DURATION_OVERRIDE_DESC',
  LOADING_START_ASC = 'LOADING_START_ASC',
  LOADING_START_DESC = 'LOADING_START_DESC',
  LOADING_START_OVERRIDE_ASC = 'LOADING_START_OVERRIDE_ASC',
  LOADING_START_OVERRIDE_DESC = 'LOADING_START_OVERRIDE_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  OWNER_ORGANISATION_ID_ASC = 'OWNER_ORGANISATION_ID_ASC',
  OWNER_ORGANISATION_ID_DESC = 'OWNER_ORGANISATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for handled_by_spot table */
export type HandledBySpotHistory = {
  __typename?: 'HandledBySpotHistory';
  archived: Scalars['Boolean']['output'];
  clientId: Scalars['UUID']['output'];
  createdByUserId?: Maybe<Scalars['UserId']['output']>;
  dischargingConcurrent: Scalars['Boolean']['output'];
  dischargingDuration: Scalars['BigInt']['output'];
  dischargingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingEnd: Scalars['Datetime']['output'];
  dischargingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingStart: Scalars['Datetime']['output'];
  dischargingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `HandledBySpot` that is related to this `HandledBySpotHistory`. */
  handledBySpotById?: Maybe<HandledBySpot>;
  id: Scalars['HandledBySpotId']['output'];
  loadingConcurrent: Scalars['Boolean']['output'];
  loadingDuration: Scalars['BigInt']['output'];
  loadingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingEnd: Scalars['Datetime']['output'];
  loadingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingStart: Scalars['Datetime']['output'];
  loadingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  ownerOrganisationId?: Maybe<Scalars['Int']['output']>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  shared: Scalars['Boolean']['output'];
  /** Reads a single `Ship` that is related to this `HandledBySpotHistory`. */
  shipByVesselId?: Maybe<Ship>;
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `HandledBySpotHistory`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledBySpotHistory`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};

/**
 * A condition to be used against `HandledBySpotHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type HandledBySpotHistoryCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['HandledBySpotId']['input']>;
  /** Checks for equality with the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `HandledBySpotHistory` object types. All fields are combined with a logical ‘and.’ */
export type HandledBySpotHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HandledBySpotHistoryFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HandledBySpotHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HandledBySpotHistoryFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `HandledBySpot` */
export type HandledBySpotInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  dischargingDuration: Scalars['BigInt']['input'];
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingEnd: Scalars['Datetime']['input'];
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingStart: Scalars['Datetime']['input'];
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDuration: Scalars['BigInt']['input'];
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingEnd: Scalars['Datetime']['input'];
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingStart: Scalars['Datetime']['input'];
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Shipowner org that might be assigned (by Charterer org) or not (null) */
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `HandledBySpot`. Fields that are set will be updated. */
export type HandledBySpotPatch = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Shipowner org that might be assigned (by Charterer org) or not (null) */
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `HandledBySpot` values. */
export type HandledBySpotsConnection = {
  __typename?: 'HandledBySpotsConnection';
  /** A list of edges which contains the `HandledBySpot` and cursor to aid in pagination. */
  edges: Array<HandledBySpotsEdge>;
  /** A list of `HandledBySpot` objects. */
  nodes: Array<Maybe<HandledBySpot>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HandledBySpot` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `HandledBySpot` edge in the connection. */
export type HandledBySpotsEdge = {
  __typename?: 'HandledBySpotsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `HandledBySpot` at the end of the edge. */
  node?: Maybe<HandledBySpot>;
};

/** Methods to use when ordering `HandledBySpot`. */
export enum HandledBySpotsOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DISCHARGING_CONCURRENT_ASC = 'DISCHARGING_CONCURRENT_ASC',
  DISCHARGING_CONCURRENT_DESC = 'DISCHARGING_CONCURRENT_DESC',
  DISCHARGING_DURATION_ASC = 'DISCHARGING_DURATION_ASC',
  DISCHARGING_DURATION_DESC = 'DISCHARGING_DURATION_DESC',
  DISCHARGING_DURATION_OVERRIDE_ASC = 'DISCHARGING_DURATION_OVERRIDE_ASC',
  DISCHARGING_DURATION_OVERRIDE_DESC = 'DISCHARGING_DURATION_OVERRIDE_DESC',
  DISCHARGING_END_ASC = 'DISCHARGING_END_ASC',
  DISCHARGING_END_DESC = 'DISCHARGING_END_DESC',
  DISCHARGING_SEA_DURATION_OVERRIDE_ASC = 'DISCHARGING_SEA_DURATION_OVERRIDE_ASC',
  DISCHARGING_SEA_DURATION_OVERRIDE_DESC = 'DISCHARGING_SEA_DURATION_OVERRIDE_DESC',
  DISCHARGING_START_ASC = 'DISCHARGING_START_ASC',
  DISCHARGING_START_DESC = 'DISCHARGING_START_DESC',
  DISCHARGING_START_OVERRIDE_ASC = 'DISCHARGING_START_OVERRIDE_ASC',
  DISCHARGING_START_OVERRIDE_DESC = 'DISCHARGING_START_OVERRIDE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_CONCURRENT_ASC = 'LOADING_CONCURRENT_ASC',
  LOADING_CONCURRENT_DESC = 'LOADING_CONCURRENT_DESC',
  LOADING_DURATION_ASC = 'LOADING_DURATION_ASC',
  LOADING_DURATION_DESC = 'LOADING_DURATION_DESC',
  LOADING_DURATION_OVERRIDE_ASC = 'LOADING_DURATION_OVERRIDE_ASC',
  LOADING_DURATION_OVERRIDE_DESC = 'LOADING_DURATION_OVERRIDE_DESC',
  LOADING_END_ASC = 'LOADING_END_ASC',
  LOADING_END_DESC = 'LOADING_END_DESC',
  LOADING_SEA_DURATION_OVERRIDE_ASC = 'LOADING_SEA_DURATION_OVERRIDE_ASC',
  LOADING_SEA_DURATION_OVERRIDE_DESC = 'LOADING_SEA_DURATION_OVERRIDE_DESC',
  LOADING_START_ASC = 'LOADING_START_ASC',
  LOADING_START_DESC = 'LOADING_START_DESC',
  LOADING_START_OVERRIDE_ASC = 'LOADING_START_OVERRIDE_ASC',
  LOADING_START_OVERRIDE_DESC = 'LOADING_START_OVERRIDE_DESC',
  METADATA_ASC = 'METADATA_ASC',
  METADATA_DESC = 'METADATA_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  OWNER_ORGANISATION_ID_ASC = 'OWNER_ORGANISATION_ID_ASC',
  OWNER_ORGANISATION_ID_DESC = 'OWNER_ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export enum HoldType {
  DECK = 'DECK',
  GAS = 'GAS',
  HOLD = 'HOLD',
  LIQUID = 'LIQUID'
}

/** A filter to be used against HoldType fields. All fields are combined with a logical ‘and.’ */
export type HoldTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<HoldType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<HoldType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<HoldType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<HoldType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<HoldType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<HoldType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<HoldType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<HoldType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<HoldType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<HoldType>>;
};

export type Holiday = Node & {
  __typename?: 'Holiday';
  date: Scalars['Date']['output'];
  geoId: Scalars['GeographicalEntityId']['output'];
  /** Reads a single `GeographicalEntity` that is related to this `Holiday`. */
  geographicalEntityByGeoId?: Maybe<GeographicalEntity>;
  id: Scalars['HolidayId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** A condition to be used against `Holiday` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type HolidayCondition = {
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `geoId` field. */
  geoId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['HolidayId']['input']>;
};

/** A filter to be used against `Holiday` object types. All fields are combined with a logical ‘and.’ */
export type HolidayFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HolidayFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `geoId` field. */
  geoId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HolidayFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HolidayFilter>>;
};

/** An input for mutations affecting `Holiday` */
export type HolidayInput = {
  date: Scalars['Date']['input'];
  geoId: Scalars['GeographicalEntityId']['input'];
};

/** Represents an update to a `Holiday`. Fields that are set will be updated. */
export type HolidayPatch = {
  date?: InputMaybe<Scalars['Date']['input']>;
  geoId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
};

/** A connection to a list of `Holiday` values. */
export type HolidaysConnection = {
  __typename?: 'HolidaysConnection';
  /** A list of edges which contains the `Holiday` and cursor to aid in pagination. */
  edges: Array<HolidaysEdge>;
  /** A list of `Holiday` objects. */
  nodes: Array<Maybe<Holiday>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Holiday` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Holiday` edge in the connection. */
export type HolidaysEdge = {
  __typename?: 'HolidaysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Holiday` at the end of the edge. */
  node?: Maybe<Holiday>;
};

/** Methods to use when ordering `Holiday`. */
export enum HolidaysOrderBy {
  DATE_ASC = 'DATE_ASC',
  DATE_DESC = 'DATE_DESC',
  GEO_ID_ASC = 'GEO_ID_ASC',
  GEO_ID_DESC = 'GEO_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type IceClass = Node & {
  __typename?: 'IceClass';
  /** Reads and enables pagination through a set of `ClassSocietyAssociation`. */
  classSocietyAssociationsByIceClassId: ClassSocietyAssociationsConnection;
  id: Scalars['IceClassId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type IceClassClassSocietyAssociationsByIceClassIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassSocietyAssociationCondition>;
  filter?: InputMaybe<ClassSocietyAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassSocietyAssociationsOrderBy>>;
};

/**
 * A condition to be used against `IceClass` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type IceClassCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['IceClassId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `IceClass` object types. All fields are combined with a logical ‘and.’ */
export type IceClassFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IceClassFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IceClassFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IceClassFilter>>;
};

/** An input for mutations affecting `IceClass` */
export type IceClassInput = {
  name: Scalars['String']['input'];
};

/** Represents an update to a `IceClass`. Fields that are set will be updated. */
export type IceClassPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `IceClass` values. */
export type IceClassesConnection = {
  __typename?: 'IceClassesConnection';
  /** A list of edges which contains the `IceClass` and cursor to aid in pagination. */
  edges: Array<IceClassesEdge>;
  /** A list of `IceClass` objects. */
  nodes: Array<Maybe<IceClass>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IceClass` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IceClass` edge in the connection. */
export type IceClassesEdge = {
  __typename?: 'IceClassesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IceClass` at the end of the edge. */
  node?: Maybe<IceClass>;
};

/** Methods to use when ordering `IceClass`. */
export enum IceClassesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type IdRemappingInput = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type Ident = {
  __typename?: 'Ident';
  id: Scalars['Int']['output'];
};

export type IdentWithShipmentId = {
  __typename?: 'IdentWithShipmentId';
  id: Scalars['Int']['output'];
  shipment_id: Scalars['Int']['output'];
};

export enum ImoClass {
  CLASS_1_EXPLOSIVES = 'CLASS_1_EXPLOSIVES',
  CLASS_3_FLAMMABLE_LIQUIDS = 'CLASS_3_FLAMMABLE_LIQUIDS',
  CLASS_4_FLAMMABLE_SOLIDS_OR_SUBSTANCES = 'CLASS_4_FLAMMABLE_SOLIDS_OR_SUBSTANCES',
  CLASS_5_OXIDIZING_SUBSTANCES_AND_ORGANIC_PEROXIDES = 'CLASS_5_OXIDIZING_SUBSTANCES_AND_ORGANIC_PEROXIDES',
  CLASS_6_TOXIC_AND_INFECTIOUS_SUBSTANCES = 'CLASS_6_TOXIC_AND_INFECTIOUS_SUBSTANCES',
  CLASS_7_RADIOACTIVE_SUBSTANCES = 'CLASS_7_RADIOACTIVE_SUBSTANCES',
  CLASS_8_CORROSIVES = 'CLASS_8_CORROSIVES',
  CLASS_9_MISCELLANEOUS_DANGEROUS_SUBSTANCES_AND_ARTICLES = 'CLASS_9_MISCELLANEOUS_DANGEROUS_SUBSTANCES_AND_ARTICLES',
  MHB_MATERIALS_HAZARDOUS_ONLY_IN_BULK = 'MHB_MATERIALS_HAZARDOUS_ONLY_IN_BULK',
  NON_HAZARDOUS = 'NON_HAZARDOUS',
  _1_1_OBJECTS_WITH_MASS_EXPLOSION_HAZARD = '_1_1_OBJECTS_WITH_MASS_EXPLOSION_HAZARD',
  _1_2_OBJECTS_WITH_PROJECTION_HAZARD_BUT_NO_MASS_EXPLOSION = '_1_2_OBJECTS_WITH_PROJECTION_HAZARD_BUT_NO_MASS_EXPLOSION',
  _1_3_OBJECTS_WITH_FIRE_HAZARD_AND_A_MINOR_BLAST_HAZARD = '_1_3_OBJECTS_WITH_FIRE_HAZARD_AND_A_MINOR_BLAST_HAZARD',
  _1_4_EXPLOSIVES_THAT_DO_NOT_PRESENT_A_SIGNIFICANT_HAZARD = '_1_4_EXPLOSIVES_THAT_DO_NOT_PRESENT_A_SIGNIFICANT_HAZARD',
  _1_5_INSENSITIVE_SUBSTANCES_WITH_MASS_EXPLOSION_HAZARD = '_1_5_INSENSITIVE_SUBSTANCES_WITH_MASS_EXPLOSION_HAZARD',
  _1_6_EXTREMELY_INSENSITIVE_ARTICLES_NO_MASS_EXPLOSION_HAZARD = '_1_6_EXTREMELY_INSENSITIVE_ARTICLES_NO_MASS_EXPLOSION_HAZARD',
  _2_1_FLAMMABLE_GASES = '_2_1_FLAMMABLE_GASES',
  _2_2_NON_FLAMMABLE_GASES = '_2_2_NON_FLAMMABLE_GASES',
  _2_3_TOXIC_GASES = '_2_3_TOXIC_GASES',
  _4_1_FLAMMABLE_SOLIDS = '_4_1_FLAMMABLE_SOLIDS',
  _4_2_SUBSTANCES_LIABLE_TO_SPONTANEOUS_COMBUSTION = '_4_2_SUBSTANCES_LIABLE_TO_SPONTANEOUS_COMBUSTION',
  _4_3_SUBSTANCES_THAT_EMIT_FLAMMABLE_GASES = '_4_3_SUBSTANCES_THAT_EMIT_FLAMMABLE_GASES',
  _5_1_OXIDIZING_SUBSTANCES = '_5_1_OXIDIZING_SUBSTANCES',
  _5_2_ORGANIC_PEROXIDES = '_5_2_ORGANIC_PEROXIDES',
  _6_1_TOXIC_SUBSTANCES = '_6_1_TOXIC_SUBSTANCES',
  _6_2_INFECTIOUS_SUBSTANCES = '_6_2_INFECTIOUS_SUBSTANCES'
}

/** A filter to be used against ImoClass fields. All fields are combined with a logical ‘and.’ */
export type ImoClassFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ImoClass>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ImoClass>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ImoClass>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ImoClass>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ImoClass>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ImoClass>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ImoClass>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ImoClass>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ImoClass>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ImoClass>>;
};

export type ImportOrderResultData = {
  __typename?: 'ImportOrderResultData';
  insertedOrderIds: Array<Scalars['OrderId']['output']>;
  updatedOrderIds: Array<Scalars['OrderId']['output']>;
};

/** All input for the `inactivateShips` mutation. */
export type InactivateShipsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shipIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** The output of our `inactivateShips` mutation. */
export type InactivateShipsPayload = {
  __typename?: 'InactivateShipsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  ships?: Maybe<Array<Maybe<Ship>>>;
};

export enum IncludedExcludedUnlessUsed {
  EX = 'EX',
  INC = 'INC',
  UU = 'UU'
}

/** A filter to be used against IncludedExcludedUnlessUsed fields. All fields are combined with a logical ‘and.’ */
export type IncludedExcludedUnlessUsedFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IncludedExcludedUnlessUsed>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IncludedExcludedUnlessUsed>>;
};

export enum IncoTermsType {
  CFR = 'CFR',
  CIF = 'CIF',
  CIP = 'CIP',
  CPT = 'CPT',
  DAP = 'DAP',
  DAT = 'DAT',
  DDP = 'DDP',
  EXW = 'EXW',
  FAS = 'FAS',
  FCA = 'FCA',
  FOB = 'FOB'
}

/** A filter to be used against IncoTermsType fields. All fields are combined with a logical ‘and.’ */
export type IncoTermsTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IncoTermsType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IncoTermsType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IncoTermsType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IncoTermsType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IncoTermsType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IncoTermsType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IncoTermsType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IncoTermsType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IncoTermsType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IncoTermsType>>;
};

export type Instruction = Node & {
  __typename?: 'Instruction';
  id: Scalars['InstructionId']['output'];
  insertedAt?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `Instruction`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Organization` that is related to this `Instruction`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  text: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `Instruction`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};

/**
 * A condition to be used against `Instruction` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type InstructionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['InstructionId']['input']>;
  /** Checks for equality with the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `Instruction` object types. All fields are combined with a logical ‘and.’ */
export type InstructionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InstructionFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InstructionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InstructionFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Instruction` */
export type InstructionInput = {
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  orderId: Scalars['OrderId']['input'];
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  text: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `Instruction`. Fields that are set will be updated. */
export type InstructionPatch = {
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `Instruction` values. */
export type InstructionsConnection = {
  __typename?: 'InstructionsConnection';
  /** A list of edges which contains the `Instruction` and cursor to aid in pagination. */
  edges: Array<InstructionsEdge>;
  /** A list of `Instruction` objects. */
  nodes: Array<Maybe<Instruction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Instruction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Instruction` edge in the connection. */
export type InstructionsEdge = {
  __typename?: 'InstructionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Instruction` at the end of the edge. */
  node?: Maybe<Instruction>;
};

/** Methods to use when ordering `Instruction`. */
export enum InstructionsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INSERTED_AT_ASC = 'INSERTED_AT_ASC',
  INSERTED_AT_DESC = 'INSERTED_AT_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TEXT_ASC = 'TEXT_ASC',
  TEXT_DESC = 'TEXT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against Int List fields. All fields are combined with a logical ‘and.’ */
export type IntListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type IntegrationLog = Node & {
  __typename?: 'IntegrationLog';
  cargoId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['IntegrationLogId']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `IntegrationLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  runtimeUuid?: Maybe<Scalars['UUID']['output']>;
  severity: IntegrationLogsSeverityType;
};

/**
 * A condition to be used against `IntegrationLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IntegrationLogCondition = {
  /** Checks for equality with the object’s `cargoId` field. */
  cargoId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['IntegrationLogId']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `runtimeUuid` field. */
  runtimeUuid?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `severity` field. */
  severity?: InputMaybe<IntegrationLogsSeverityType>;
};

/** A filter to be used against `IntegrationLog` object types. All fields are combined with a logical ‘and.’ */
export type IntegrationLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IntegrationLogFilter>>;
  /** Filter by the object’s `cargoId` field. */
  cargoId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IntegrationLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IntegrationLogFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `runtimeUuid` field. */
  runtimeUuid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `severity` field. */
  severity?: InputMaybe<IntegrationLogsSeverityTypeFilter>;
};

/** An input for mutations affecting `IntegrationLog` */
export type IntegrationLogInput = {
  cargoId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  runtimeUuid?: InputMaybe<Scalars['UUID']['input']>;
  severity: IntegrationLogsSeverityType;
};

/** Represents an update to a `IntegrationLog`. Fields that are set will be updated. */
export type IntegrationLogPatch = {
  cargoId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  runtimeUuid?: InputMaybe<Scalars['UUID']['input']>;
  severity?: InputMaybe<IntegrationLogsSeverityType>;
};

/** A connection to a list of `IntegrationLog` values. */
export type IntegrationLogsConnection = {
  __typename?: 'IntegrationLogsConnection';
  /** A list of edges which contains the `IntegrationLog` and cursor to aid in pagination. */
  edges: Array<IntegrationLogsEdge>;
  /** A list of `IntegrationLog` objects. */
  nodes: Array<Maybe<IntegrationLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IntegrationLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IntegrationLog` edge in the connection. */
export type IntegrationLogsEdge = {
  __typename?: 'IntegrationLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IntegrationLog` at the end of the edge. */
  node?: Maybe<IntegrationLog>;
};

/** Methods to use when ordering `IntegrationLog`. */
export enum IntegrationLogsOrderBy {
  CARGO_ID_ASC = 'CARGO_ID_ASC',
  CARGO_ID_DESC = 'CARGO_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MESSAGE_ASC = 'MESSAGE_ASC',
  MESSAGE_DESC = 'MESSAGE_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RUNTIME_UUID_ASC = 'RUNTIME_UUID_ASC',
  RUNTIME_UUID_DESC = 'RUNTIME_UUID_DESC',
  SEVERITY_ASC = 'SEVERITY_ASC',
  SEVERITY_DESC = 'SEVERITY_DESC'
}

export enum IntegrationLogsSeverityType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  NOTICE = 'NOTICE',
  WARN = 'WARN'
}

/** A filter to be used against IntegrationLogsSeverityType fields. All fields are combined with a logical ‘and.’ */
export type IntegrationLogsSeverityTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntegrationLogsSeverityType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntegrationLogsSeverityType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntegrationLogsSeverityType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntegrationLogsSeverityType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntegrationLogsSeverityType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntegrationLogsSeverityType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntegrationLogsSeverityType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntegrationLogsSeverityType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntegrationLogsSeverityType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntegrationLogsSeverityType>>;
};

export enum IntegrationSourceType {
  BSC = 'BSC',
  OAS = 'OAS',
  VESON = 'VESON'
}

/** A filter to be used against IntegrationSourceType fields. All fields are combined with a logical ‘and.’ */
export type IntegrationSourceTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntegrationSourceType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntegrationSourceType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntegrationSourceType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntegrationSourceType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntegrationSourceType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntegrationSourceType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntegrationSourceType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntegrationSourceType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntegrationSourceType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntegrationSourceType>>;
};

export type Invoice = Node & {
  __typename?: 'Invoice';
  currency?: Maybe<Currency>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['InvoiceId']['output'];
  /** Reads and enables pagination through a set of `InvoiceItem`. */
  invoiceItemsByInvoiceId: InvoiceItemsConnection;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Invoice`. */
  organizationByPayingOrganizationId?: Maybe<Organization>;
  payingOrganizationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `VoyageCharter` that is related to this `Invoice`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId?: Maybe<Scalars['VoyageCharterId']['output']>;
};


export type InvoiceInvoiceItemsByInvoiceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceItemCondition>;
  filter?: InputMaybe<InvoiceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoiceItemsOrderBy>>;
};

/** A condition to be used against `Invoice` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type InvoiceCondition = {
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `dueDate` field. */
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['InvoiceId']['input']>;
  /** Checks for equality with the object’s `invoiceNumber` field. */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `payingOrganizationId` field. */
  payingOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `Invoice` object types. All fields are combined with a logical ‘and.’ */
export type InvoiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InvoiceFilter>>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `dueDate` field. */
  dueDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `invoiceNumber` field. */
  invoiceNumber?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InvoiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InvoiceFilter>>;
  /** Filter by the object’s `payingOrganizationId` field. */
  payingOrganizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Invoice` */
export type InvoiceInput = {
  currency?: InputMaybe<Currency>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  payingOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

export type InvoiceItem = Node & {
  __typename?: 'InvoiceItem';
  amount?: Maybe<Scalars['BigFloat']['output']>;
  costType?: Maybe<CostType>;
  id: Scalars['InvoiceItemId']['output'];
  /** Reads a single `Invoice` that is related to this `InvoiceItem`. */
  invoiceByInvoiceId?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['InvoiceId']['output']>;
  /** Reads and enables pagination through a set of `InvoiceItemOrder`. */
  invoiceItemOrdersByInvoiceItemId: InvoiceItemOrdersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `InvoiceItem`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `InvoiceItem`. */
  portCallByPortCallId?: Maybe<PortCall>;
  portCallId?: Maybe<Scalars['PortCallId']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
};


export type InvoiceItemInvoiceItemOrdersByInvoiceItemIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceItemOrderCondition>;
  filter?: InputMaybe<InvoiceItemOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoiceItemOrdersOrderBy>>;
};

/**
 * A condition to be used against `InvoiceItem` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type InvoiceItemCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `costType` field. */
  costType?: InputMaybe<CostType>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['InvoiceItemId']['input']>;
  /** Checks for equality with the object’s `invoiceId` field. */
  invoiceId?: InputMaybe<Scalars['InvoiceId']['input']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `InvoiceItem` object types. All fields are combined with a logical ‘and.’ */
export type InvoiceItemFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InvoiceItemFilter>>;
  /** Filter by the object’s `costType` field. */
  costType?: InputMaybe<CostTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `invoiceId` field. */
  invoiceId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InvoiceItemFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InvoiceItemFilter>>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `InvoiceItem` */
export type InvoiceItemInput = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  costType?: InputMaybe<CostType>;
  invoiceId?: InputMaybe<Scalars['InvoiceId']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
};

export type InvoiceItemOrder = Node & {
  __typename?: 'InvoiceItemOrder';
  id: Scalars['InvoiceItemOrderId']['output'];
  /** Reads a single `InvoiceItem` that is related to this `InvoiceItemOrder`. */
  invoiceItemByInvoiceItemId?: Maybe<InvoiceItem>;
  invoiceItemId?: Maybe<Scalars['InvoiceItemId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `InvoiceItemOrder`. */
  orderByOrderId?: Maybe<Order>;
  orderId?: Maybe<Scalars['OrderId']['output']>;
};

/**
 * A condition to be used against `InvoiceItemOrder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InvoiceItemOrderCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['InvoiceItemOrderId']['input']>;
  /** Checks for equality with the object’s `invoiceItemId` field. */
  invoiceItemId?: InputMaybe<Scalars['InvoiceItemId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
};

/** A filter to be used against `InvoiceItemOrder` object types. All fields are combined with a logical ‘and.’ */
export type InvoiceItemOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InvoiceItemOrderFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `invoiceItemId` field. */
  invoiceItemId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InvoiceItemOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InvoiceItemOrderFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `InvoiceItemOrder` */
export type InvoiceItemOrderInput = {
  invoiceItemId?: InputMaybe<Scalars['InvoiceItemId']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
};

/** Represents an update to a `InvoiceItemOrder`. Fields that are set will be updated. */
export type InvoiceItemOrderPatch = {
  invoiceItemId?: InputMaybe<Scalars['InvoiceItemId']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
};

/** A connection to a list of `InvoiceItemOrder` values. */
export type InvoiceItemOrdersConnection = {
  __typename?: 'InvoiceItemOrdersConnection';
  /** A list of edges which contains the `InvoiceItemOrder` and cursor to aid in pagination. */
  edges: Array<InvoiceItemOrdersEdge>;
  /** A list of `InvoiceItemOrder` objects. */
  nodes: Array<Maybe<InvoiceItemOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InvoiceItemOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `InvoiceItemOrder` edge in the connection. */
export type InvoiceItemOrdersEdge = {
  __typename?: 'InvoiceItemOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `InvoiceItemOrder` at the end of the edge. */
  node?: Maybe<InvoiceItemOrder>;
};

/** Methods to use when ordering `InvoiceItemOrder`. */
export enum InvoiceItemOrdersOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INVOICE_ITEM_ID_ASC = 'INVOICE_ITEM_ID_ASC',
  INVOICE_ITEM_ID_DESC = 'INVOICE_ITEM_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** Represents an update to a `InvoiceItem`. Fields that are set will be updated. */
export type InvoiceItemPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  costType?: InputMaybe<CostType>;
  invoiceId?: InputMaybe<Scalars['InvoiceId']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
};

/** A connection to a list of `InvoiceItem` values. */
export type InvoiceItemsConnection = {
  __typename?: 'InvoiceItemsConnection';
  /** A list of edges which contains the `InvoiceItem` and cursor to aid in pagination. */
  edges: Array<InvoiceItemsEdge>;
  /** A list of `InvoiceItem` objects. */
  nodes: Array<Maybe<InvoiceItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InvoiceItem` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `InvoiceItem` edge in the connection. */
export type InvoiceItemsEdge = {
  __typename?: 'InvoiceItemsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `InvoiceItem` at the end of the edge. */
  node?: Maybe<InvoiceItem>;
};

/** Methods to use when ordering `InvoiceItem`. */
export enum InvoiceItemsOrderBy {
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  COST_TYPE_ASC = 'COST_TYPE_ASC',
  COST_TYPE_DESC = 'COST_TYPE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INVOICE_ID_ASC = 'INVOICE_ID_ASC',
  INVOICE_ID_DESC = 'INVOICE_ID_DESC',
  NATURAL = 'NATURAL',
  NOTE_ASC = 'NOTE_ASC',
  NOTE_DESC = 'NOTE_DESC',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

/** Represents an update to a `Invoice`. Fields that are set will be updated. */
export type InvoicePatch = {
  currency?: InputMaybe<Currency>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  payingOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `Invoice` values. */
export type InvoicesConnection = {
  __typename?: 'InvoicesConnection';
  /** A list of edges which contains the `Invoice` and cursor to aid in pagination. */
  edges: Array<InvoicesEdge>;
  /** A list of `Invoice` objects. */
  nodes: Array<Maybe<Invoice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Invoice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Invoice` edge in the connection. */
export type InvoicesEdge = {
  __typename?: 'InvoicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Invoice` at the end of the edge. */
  node?: Maybe<Invoice>;
};

/** Methods to use when ordering `Invoice`. */
export enum InvoicesOrderBy {
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  DUE_DATE_ASC = 'DUE_DATE_ASC',
  DUE_DATE_DESC = 'DUE_DATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INVOICE_NUMBER_ASC = 'INVOICE_NUMBER_ASC',
  INVOICE_NUMBER_DESC = 'INVOICE_NUMBER_DESC',
  NATURAL = 'NATURAL',
  PAYING_ORGANIZATION_ID_ASC = 'PAYING_ORGANIZATION_ID_ASC',
  PAYING_ORGANIZATION_ID_DESC = 'PAYING_ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

/** A filter to be used against JSON List fields. All fields are combined with a logical ‘and.’ */
export type JsonListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

export type LlmParsedOrder = {
  __typename?: 'LLMParsedOrder';
  assortmentName: Scalars['String']['output'];
  cargoAmount: Scalars['Float']['output'];
  cargoDeckOption?: Maybe<CargoDeckOptionType>;
  cargoUnit: CargoUnitEnum;
  charterParty?: Maybe<Scalars['String']['output']>;
  chartererOrgName?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['Float']['output']>;
  dischargePortName?: Maybe<Scalars['String']['output']>;
  dischargingRate?: Maybe<Scalars['Float']['output']>;
  dischargingUnit?: Maybe<LoadingUnit>;
  earliestDischarging?: Maybe<Scalars['String']['output']>;
  earliestLoading?: Maybe<Scalars['String']['output']>;
  externalGroupingId?: Maybe<Scalars['String']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  isInquiry?: Maybe<Scalars['Boolean']['output']>;
  isPreliminary?: Maybe<Scalars['Boolean']['output']>;
  latestLoading?: Maybe<Scalars['String']['output']>;
  laytimeTerms?: Maybe<Scalars['String']['output']>;
  loadPortName: Scalars['String']['output'];
  loadingRate?: Maybe<Scalars['Float']['output']>;
  loadingUnit?: Maybe<LoadingUnit>;
  marginAmount?: Maybe<Scalars['Float']['output']>;
  marginUnit?: Maybe<MarginUnit>;
  nominatedVessel?: Maybe<Scalars['String']['output']>;
  onSubjectsUntil?: Maybe<Scalars['Datetime']['output']>;
  orderName: Scalars['String']['output'];
  orderNotes?: Maybe<Scalars['String']['output']>;
  specificGravity?: Maybe<Scalars['Float']['output']>;
  stowageFactorMax?: Maybe<Scalars['Float']['output']>;
  stowageFactorMin?: Maybe<Scalars['Float']['output']>;
};

export type LlmParserResult = {
  __typename?: 'LLMParserResult';
  orders: Array<LlmParsedOrder>;
};

export type LatestPortCostByPortAndPrimaryAttribute = {
  __typename?: 'LatestPortCostByPortAndPrimaryAttribute';
  organizationId?: Maybe<Scalars['Int']['output']>;
  portCost?: Maybe<Scalars['BigFloat']['output']>;
  portCostCurrency?: Maybe<Scalars['String']['output']>;
  portName?: Maybe<Scalars['String']['output']>;
  portType?: Maybe<Scalars['String']['output']>;
  primaryAttributeId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `LatestPortCostByPortAndPrimaryAttribute` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type LatestPortCostByPortAndPrimaryAttributeCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portCost` field. */
  portCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portName` field. */
  portName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portType` field. */
  portType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `LatestPortCostByPortAndPrimaryAttribute` object types. All fields are combined with a logical ‘and.’ */
export type LatestPortCostByPortAndPrimaryAttributeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LatestPortCostByPortAndPrimaryAttributeFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<LatestPortCostByPortAndPrimaryAttributeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LatestPortCostByPortAndPrimaryAttributeFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCost` field. */
  portCost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portName` field. */
  portName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portType` field. */
  portType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `LatestPortCostByPortAndPrimaryAttribute` values. */
export type LatestPortCostByPortAndPrimaryAttributesConnection = {
  __typename?: 'LatestPortCostByPortAndPrimaryAttributesConnection';
  /** A list of edges which contains the `LatestPortCostByPortAndPrimaryAttribute` and cursor to aid in pagination. */
  edges: Array<LatestPortCostByPortAndPrimaryAttributesEdge>;
  /** A list of `LatestPortCostByPortAndPrimaryAttribute` objects. */
  nodes: Array<Maybe<LatestPortCostByPortAndPrimaryAttribute>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LatestPortCostByPortAndPrimaryAttribute` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LatestPortCostByPortAndPrimaryAttribute` edge in the connection. */
export type LatestPortCostByPortAndPrimaryAttributesEdge = {
  __typename?: 'LatestPortCostByPortAndPrimaryAttributesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LatestPortCostByPortAndPrimaryAttribute` at the end of the edge. */
  node?: Maybe<LatestPortCostByPortAndPrimaryAttribute>;
};

/** Methods to use when ordering `LatestPortCostByPortAndPrimaryAttribute`. */
export enum LatestPortCostByPortAndPrimaryAttributesOrderBy {
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_COST_ASC = 'PORT_COST_ASC',
  PORT_COST_CURRENCY_ASC = 'PORT_COST_CURRENCY_ASC',
  PORT_COST_CURRENCY_DESC = 'PORT_COST_CURRENCY_DESC',
  PORT_COST_DESC = 'PORT_COST_DESC',
  PORT_NAME_ASC = 'PORT_NAME_ASC',
  PORT_NAME_DESC = 'PORT_NAME_DESC',
  PORT_TYPE_ASC = 'PORT_TYPE_ASC',
  PORT_TYPE_DESC = 'PORT_TYPE_DESC',
  PRIMARY_ATTRIBUTE_ID_ASC = 'PRIMARY_ATTRIBUTE_ID_ASC',
  PRIMARY_ATTRIBUTE_ID_DESC = 'PRIMARY_ATTRIBUTE_ID_DESC'
}

export type Latlng = {
  __typename?: 'Latlng';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** An input for mutations affecting `Latlng` */
export type LatlngInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export enum LaytimeCountingTrigger {
  ARRIVAL_AT_PILOT_BOARDING_STATION = 'ARRIVAL_AT_PILOT_BOARDING_STATION',
  BERTHING = 'BERTHING',
  NOR_TENDERED = 'NOR_TENDERED'
}

/** A filter to be used against LaytimeCountingTrigger fields. All fields are combined with a logical ‘and.’ */
export type LaytimeCountingTriggerFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LaytimeCountingTrigger>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LaytimeCountingTrigger>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LaytimeCountingTrigger>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LaytimeCountingTrigger>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LaytimeCountingTrigger>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LaytimeCountingTrigger>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LaytimeCountingTrigger>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LaytimeCountingTrigger>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LaytimeCountingTrigger>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LaytimeCountingTrigger>>;
};

/** A connection to a list of `LaytimeResponsibility` values. */
export type LaytimeResponsibilitiesConnection = {
  __typename?: 'LaytimeResponsibilitiesConnection';
  /** A list of edges which contains the `LaytimeResponsibility` and cursor to aid in pagination. */
  edges: Array<LaytimeResponsibilitiesEdge>;
  /** A list of `LaytimeResponsibility` objects. */
  nodes: Array<Maybe<LaytimeResponsibility>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LaytimeResponsibility` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LaytimeResponsibility` edge in the connection. */
export type LaytimeResponsibilitiesEdge = {
  __typename?: 'LaytimeResponsibilitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LaytimeResponsibility` at the end of the edge. */
  node?: Maybe<LaytimeResponsibility>;
};

/** Methods to use when ordering `LaytimeResponsibility`. */
export enum LaytimeResponsibilitiesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_ACTIVITY_ID_ASC = 'PORT_ACTIVITY_ID_ASC',
  PORT_ACTIVITY_ID_DESC = 'PORT_ACTIVITY_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHARE_ASC = 'SHARE_ASC',
  SHARE_DESC = 'SHARE_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

export type LaytimeResponsibility = Node & {
  __typename?: 'LaytimeResponsibility';
  id: Scalars['LaytimeResponsibilityId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `LaytimeResponsibility`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Reads a single `PortActivity` that is related to this `LaytimeResponsibility`. */
  portActivityByPortActivityId?: Maybe<PortActivity>;
  portActivityId: Scalars['PortActivityId']['output'];
  share: Scalars['BigFloat']['output'];
  /** Reads a single `VoyageCharter` that is related to this `LaytimeResponsibility`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId?: Maybe<Scalars['VoyageCharterId']['output']>;
};

/**
 * A condition to be used against `LaytimeResponsibility` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LaytimeResponsibilityCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['LaytimeResponsibilityId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `portActivityId` field. */
  portActivityId?: InputMaybe<Scalars['PortActivityId']['input']>;
  /** Checks for equality with the object’s `share` field. */
  share?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `LaytimeResponsibility` object types. All fields are combined with a logical ‘and.’ */
export type LaytimeResponsibilityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LaytimeResponsibilityFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LaytimeResponsibilityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LaytimeResponsibilityFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portActivityId` field. */
  portActivityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `share` field. */
  share?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `LaytimeResponsibility` */
export type LaytimeResponsibilityInput = {
  organizationId: Scalars['OrganizationId']['input'];
  portActivityId: Scalars['PortActivityId']['input'];
  share: Scalars['BigFloat']['input'];
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** Represents an update to a `LaytimeResponsibility`. Fields that are set will be updated. */
export type LaytimeResponsibilityPatch = {
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portActivityId?: InputMaybe<Scalars['PortActivityId']['input']>;
  share?: InputMaybe<Scalars['BigFloat']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

export type LegType = {
  __typename?: 'LegType';
  description?: Maybe<Scalars['String']['output']>;
};

export type ListenPayload = {
  __typename?: 'ListenPayload';
  /** Our root query field type. Allows us to run any query from our subscription payload. */
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']['output']>;
};

export enum LoadingUnit {
  /** admt/d */
  ADMT_DAY = 'ADMT_DAY',
  /** admt/h */
  ADMT_HOUR = 'ADMT_HOUR',
  /** bdmt/d */
  BDMT_DAY = 'BDMT_DAY',
  /** bdmt/h */
  BDMT_HOUR = 'BDMT_HOUR',
  /** ft³/d */
  CUBIC_FEET_PER_DAY = 'CUBIC_FEET_PER_DAY',
  /** ft³/h */
  CUBIC_FEET_PER_HOUR = 'CUBIC_FEET_PER_HOUR',
  /** m³/d */
  CUBIC_METERS_PER_DAY = 'CUBIC_METERS_PER_DAY',
  /** m³/h */
  CUBIC_METERS_PER_HOUR = 'CUBIC_METERS_PER_HOUR',
  /** days */
  LOADING_IN_DAYS_FOR_THE_WHOLE_PARCEL = 'LOADING_IN_DAYS_FOR_THE_WHOLE_PARCEL',
  /** h */
  LOADING_IN_HOURS_FOR_THE_WHOLE_PARCEL = 'LOADING_IN_HOURS_FOR_THE_WHOLE_PARCEL',
  /** t/d */
  METRIC_TONNES_PER_DAY = 'METRIC_TONNES_PER_DAY',
  /** t/h */
  METRIC_TONNES_PER_HOUR = 'METRIC_TONNES_PER_HOUR',
  /** scbmob/d */
  SCBMOB_DAY = 'SCBMOB_DAY',
  /** scbmob/h */
  SCBMOB_HOUR = 'SCBMOB_HOUR',
  /** scbmub/d */
  SCBMUB_DAY = 'SCBMUB_DAY',
  /** scbmub/h */
  SCBMUB_HOUR = 'SCBMUB_HOUR'
}

/** A filter to be used against LoadingUnit fields. All fields are combined with a logical ‘and.’ */
export type LoadingUnitFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LoadingUnit>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LoadingUnit>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LoadingUnit>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LoadingUnit>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LoadingUnit>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LoadingUnit>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LoadingUnit>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LoadingUnit>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LoadingUnit>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LoadingUnit>>;
};

export type Location = Node & {
  __typename?: 'Location';
  airDraft?: Maybe<Scalars['BigFloat']['output']>;
  beam?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `Bunkering`. */
  bunkeringsByLocationId: BunkeringsConnection;
  /** Reads and enables pagination through a set of `CargoMeasurement`. */
  cargoMeasurementsByLocationId: CargoMeasurementsConnection;
  clusterId?: Maybe<Scalars['LocationClusterId']['output']>;
  /** Reads and enables pagination through a set of `CoaContractDeviationCost`. */
  coaContractDeviationCostsByFromLocationId: CoaContractDeviationCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractDeviationCost`. */
  coaContractDeviationCostsByToLocationId: CoaContractDeviationCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractPortCost`. */
  coaContractPortCostsByLocationId: CoaContractPortCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  coaContractPortsByDestinationId: CoaContractPortsConnection;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  coaContractPortsByOriginId: CoaContractPortsConnection;
  /** Reads and enables pagination through a set of `Commission`. */
  commissionsByDischargePortId: CommissionsConnection;
  /** Reads and enables pagination through a set of `Commission`. */
  commissionsByLoadPortId: CommissionsConnection;
  country?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Country` that is related to this `Location`. */
  countryByCountryId?: Maybe<Country>;
  countryId?: Maybe<Scalars['CountryId']['output']>;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsByLocationId: DemandsConnection;
  draft?: Maybe<Scalars['BigFloat']['output']>;
  extIdArray?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  externalId?: Maybe<Scalars['String']['output']>;
  extraPortDays?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `File`. */
  filesByLocationId: FilesConnection;
  geog?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `GeographicalRelation`. */
  geographicalRelationsByLocationId: GeographicalRelationsConnection;
  id: Scalars['LocationId']['output'];
  latitude?: Maybe<Scalars['BigFloat']['output']>;
  lengthOverall?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `Location` that is related to this `Location`. */
  locationByParentLocationId?: Maybe<Location>;
  /** Reads a single `LocationCluster` that is related to this `Location`. */
  locationClusterByClusterId?: Maybe<LocationCluster>;
  /** Reads and enables pagination through a set of `LocationRequirementAssociation`. */
  locationRequirementAssociationsByLocationId: LocationRequirementAssociationsConnection;
  /** Reads and enables pagination through a set of `LocationWorkingHour`. */
  locationWorkingHoursByLocationId: LocationWorkingHoursConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByParentLocationId: LocationsConnection;
  locode?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum Deadweight Tonnage */
  maxDwt?: Maybe<Scalars['BigFloat']['output']>;
  name: Scalars['String']['output'];
  nameSynonyms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `NotificationReceiver`. */
  notificationReceiversByLocationId: NotificationReceiversConnection;
  /** Reads and enables pagination through a set of `OffHire`. */
  offHiresByLocationAId: OffHiresConnection;
  /** Reads and enables pagination through a set of `OffHire`. */
  offHiresByLocationBId: OffHiresConnection;
  /** Reads and enables pagination through a set of `OpenPosition`. */
  openPositionsByDirectionId: OpenPositionsConnection;
  /** Reads and enables pagination through a set of `OpenPosition`. */
  openPositionsByStartPortId: OpenPositionsConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByDischargePortId: OrdersConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByLoadPortId: OrdersConnection;
  /** Reads and enables pagination through a set of `OrdersHistory`. */
  ordersHistoriesByDischargePortId: OrdersHistoriesConnection;
  /** Reads and enables pagination through a set of `OrdersHistory`. */
  ordersHistoriesByLoadPortId: OrdersHistoriesConnection;
  organisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organizationByRootOrg?: Maybe<Organization>;
  parentLocationId?: Maybe<Scalars['LocationId']['output']>;
  /** Reads and enables pagination through a set of `PortCall`. */
  portCallsByLocationId: PortCallsConnection;
  /** Reads and enables pagination through a set of `PortCall`. */
  portCallsByPreviousLocationId: PortCallsConnection;
  /** Reads and enables pagination through a set of `PortCommodityLdRate`. */
  portCommodityLdRatesByPortId: PortCommodityLdRatesConnection;
  /** Reads and enables pagination through a set of `PortCostDefault`. */
  portCostDefaultsByLocationId: PortCostDefaultsConnection;
  /** Reads and enables pagination through a set of `PortCost`. */
  portCostsByLocationId: PortCostsConnection;
  /** Reads and enables pagination through a set of `PortDatum`. */
  portDataByPortId: PortDataConnection;
  /** Reads and enables pagination through a set of `PortRegion`. */
  portRegionsByLocationId: PortRegionsConnection;
  /** Reads and enables pagination through a set of `Quay`. */
  quaysByLocationId: QuaysConnection;
  /** Root organization from the current session */
  rootOrg?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `RouteOverride`. */
  routeOverridesByFromId: RouteOverridesConnection;
  /** Reads and enables pagination through a set of `RouteOverride`. */
  routeOverridesByToId: RouteOverridesConnection;
  /** Reads and enables pagination through a set of `SingleEvent`. */
  singleEventsByLocationId: SingleEventsConnection;
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesByLocationId: SuppliesConnection;
  /** Reads and enables pagination through a set of `TcContract`. */
  tcContractsByDeliveryPortId: TcContractsConnection;
  /** Reads and enables pagination through a set of `TcContract`. */
  tcContractsByRedeliveryPortId: TcContractsConnection;
  /** Offset in hours from UTC */
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<LocationType>;
  /** Reads a single `User` that is related to this `Location`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  vesselReservationsByEndPortId: VesselReservationsConnection;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  vesselReservationsByStartPortId: VesselReservationsConnection;
  /** Mo, Tu, We, Th, Fr, Sa, Su, Ho */
  workingHours?: Maybe<Array<Maybe<Workhour>>>;
  /** Reads and enables pagination through a set of `WorldscaleFreight`. */
  worldscaleFreightsByFromLocationId: WorldscaleFreightsConnection;
  /** Reads and enables pagination through a set of `WorldscaleFreight`. */
  worldscaleFreightsByToLocationId: WorldscaleFreightsConnection;
  /** Reads and enables pagination through a set of `ZoneLocation`. */
  zoneLocationsByLocationId: ZoneLocationsConnection;
};


export type LocationBunkeringsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkeringCondition>;
  filter?: InputMaybe<BunkeringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkeringsOrderBy>>;
};


export type LocationCargoMeasurementsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoMeasurementCondition>;
  filter?: InputMaybe<CargoMeasurementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoMeasurementsOrderBy>>;
};


export type LocationCoaContractDeviationCostsByFromLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractDeviationCostCondition>;
  filter?: InputMaybe<CoaContractDeviationCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};


export type LocationCoaContractDeviationCostsByToLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractDeviationCostCondition>;
  filter?: InputMaybe<CoaContractDeviationCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};


export type LocationCoaContractPortCostsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCostCondition>;
  filter?: InputMaybe<CoaContractPortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortCostsOrderBy>>;
};


export type LocationCoaContractPortsByDestinationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


export type LocationCoaContractPortsByOriginIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


export type LocationCommissionsByDischargePortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommissionCondition>;
  filter?: InputMaybe<CommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};


export type LocationCommissionsByLoadPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommissionCondition>;
  filter?: InputMaybe<CommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};


export type LocationDemandsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type LocationFilesByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type LocationGeographicalRelationsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GeographicalRelationCondition>;
  filter?: InputMaybe<GeographicalRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeographicalRelationsOrderBy>>;
};


export type LocationLocationRequirementAssociationsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationRequirementAssociationCondition>;
  filter?: InputMaybe<LocationRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
};


export type LocationLocationWorkingHoursByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationWorkingHourCondition>;
  filter?: InputMaybe<LocationWorkingHourFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationWorkingHoursOrderBy>>;
};


export type LocationLocationsByParentLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type LocationNotificationReceiversByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationReceiverCondition>;
  filter?: InputMaybe<NotificationReceiverFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};


export type LocationOffHiresByLocationAIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireCondition>;
  filter?: InputMaybe<OffHireFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};


export type LocationOffHiresByLocationBIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireCondition>;
  filter?: InputMaybe<OffHireFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};


export type LocationOpenPositionsByDirectionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionCondition>;
  filter?: InputMaybe<OpenPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};


export type LocationOpenPositionsByStartPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionCondition>;
  filter?: InputMaybe<OpenPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};


export type LocationOrdersByDischargePortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type LocationOrdersByLoadPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type LocationOrdersHistoriesByDischargePortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrdersHistoryCondition>;
  filter?: InputMaybe<OrdersHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersHistoriesOrderBy>>;
};


export type LocationOrdersHistoriesByLoadPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrdersHistoryCondition>;
  filter?: InputMaybe<OrdersHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersHistoriesOrderBy>>;
};


export type LocationPortCallsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallCondition>;
  filter?: InputMaybe<PortCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};


export type LocationPortCallsByPreviousLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallCondition>;
  filter?: InputMaybe<PortCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};


export type LocationPortCommodityLdRatesByPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCommodityLdRateCondition>;
  filter?: InputMaybe<PortCommodityLdRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};


export type LocationPortCostDefaultsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostDefaultCondition>;
  filter?: InputMaybe<PortCostDefaultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostDefaultsOrderBy>>;
};


export type LocationPortCostsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostCondition>;
  filter?: InputMaybe<PortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostsOrderBy>>;
};


export type LocationPortDataByPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortDatumCondition>;
  filter?: InputMaybe<PortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortDataOrderBy>>;
};


export type LocationPortRegionsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortRegionCondition>;
  filter?: InputMaybe<PortRegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortRegionsOrderBy>>;
};


export type LocationQuaysByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<QuayCondition>;
  filter?: InputMaybe<QuayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuaysOrderBy>>;
};


export type LocationRouteOverridesByFromIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteOverrideCondition>;
  filter?: InputMaybe<RouteOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};


export type LocationRouteOverridesByToIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteOverrideCondition>;
  filter?: InputMaybe<RouteOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};


export type LocationSingleEventsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventCondition>;
  filter?: InputMaybe<SingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};


export type LocationSuppliesByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};


export type LocationTcContractsByDeliveryPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TcContractCondition>;
  filter?: InputMaybe<TcContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TcContractsOrderBy>>;
};


export type LocationTcContractsByRedeliveryPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TcContractCondition>;
  filter?: InputMaybe<TcContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TcContractsOrderBy>>;
};


export type LocationVesselReservationsByEndPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};


export type LocationVesselReservationsByStartPortIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};


export type LocationWorldscaleFreightsByFromLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorldscaleFreightCondition>;
  filter?: InputMaybe<WorldscaleFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorldscaleFreightsOrderBy>>;
};


export type LocationWorldscaleFreightsByToLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorldscaleFreightCondition>;
  filter?: InputMaybe<WorldscaleFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorldscaleFreightsOrderBy>>;
};


export type LocationZoneLocationsByLocationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ZoneLocationCondition>;
  filter?: InputMaybe<ZoneLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZoneLocationsOrderBy>>;
};

export type LocationCluster = Node & {
  __typename?: 'LocationCluster';
  geog?: Maybe<Scalars['String']['output']>;
  id: Scalars['LocationClusterId']['output'];
  latitude: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `Location`. */
  locationsByClusterId: LocationsConnection;
  longitude: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Route`. */
  routesByFromClusterId: RoutesConnection;
  /** Reads and enables pagination through a set of `Route`. */
  routesByToClusterId: RoutesConnection;
};


export type LocationClusterLocationsByClusterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type LocationClusterRoutesByFromClusterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteCondition>;
  filter?: InputMaybe<RouteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};


export type LocationClusterRoutesByToClusterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteCondition>;
  filter?: InputMaybe<RouteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};

/**
 * A condition to be used against `LocationCluster` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LocationClusterCondition = {
  /** Checks for equality with the object’s `geog` field. */
  geog?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['LocationClusterId']['input']>;
  /** Checks for equality with the object’s `latitude` field. */
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `longitude` field. */
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A filter to be used against `LocationCluster` object types. All fields are combined with a logical ‘and.’ */
export type LocationClusterFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LocationClusterFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `latitude` field. */
  latitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `longitude` field. */
  longitude?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LocationClusterFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LocationClusterFilter>>;
};

/** An input for mutations affecting `LocationCluster` */
export type LocationClusterInput = {
  geog?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['BigFloat']['input'];
  longitude: Scalars['BigFloat']['input'];
};

/** Represents an update to a `LocationCluster`. Fields that are set will be updated. */
export type LocationClusterPatch = {
  geog?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `LocationCluster` values. */
export type LocationClustersConnection = {
  __typename?: 'LocationClustersConnection';
  /** A list of edges which contains the `LocationCluster` and cursor to aid in pagination. */
  edges: Array<LocationClustersEdge>;
  /** A list of `LocationCluster` objects. */
  nodes: Array<Maybe<LocationCluster>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LocationCluster` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LocationCluster` edge in the connection. */
export type LocationClustersEdge = {
  __typename?: 'LocationClustersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LocationCluster` at the end of the edge. */
  node?: Maybe<LocationCluster>;
};

/** Methods to use when ordering `LocationCluster`. */
export enum LocationClustersOrderBy {
  GEOG_ASC = 'GEOG_ASC',
  GEOG_DESC = 'GEOG_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LATITUDE_ASC = 'LATITUDE_ASC',
  LATITUDE_DESC = 'LATITUDE_DESC',
  LONGITUDE_ASC = 'LONGITUDE_ASC',
  LONGITUDE_DESC = 'LONGITUDE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/**
 * A condition to be used against `Location` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type LocationCondition = {
  /** Checks for equality with the object’s `airDraft` field. */
  airDraft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `beam` field. */
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `clusterId` field. */
  clusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  /** Checks for equality with the object’s `countryId` field. */
  countryId?: InputMaybe<Scalars['CountryId']['input']>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `extIdArray` field. */
  extIdArray?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `extraPortDays` field. */
  extraPortDays?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `geog` field. */
  geog?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `latitude` field. */
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lengthOverall` field. */
  lengthOverall?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `locode` field. */
  locode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `longitude` field. */
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxDwt` field. */
  maxDwt?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nameSynonyms` field. */
  nameSynonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `parentLocationId` field. */
  parentLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `timezone` field. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LocationType>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `workingHours` field. */
  workingHours?: InputMaybe<Array<InputMaybe<WorkhourInput>>>;
};

/** A filter to be used against `Location` object types. All fields are combined with a logical ‘and.’ */
export type LocationFilter = {
  /** Filter by the object’s `airDraft` field. */
  airDraft?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LocationFilter>>;
  /** Filter by the object’s `beam` field. */
  beam?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `clusterId` field. */
  clusterId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<StringFilter>;
  /** Filter by the object’s `countryId` field. */
  countryId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `extIdArray` field. */
  extIdArray?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extraPortDays` field. */
  extraPortDays?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `latitude` field. */
  latitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lengthOverall` field. */
  lengthOverall?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `locode` field. */
  locode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `longitude` field. */
  longitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxDwt` field. */
  maxDwt?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nameSynonyms` field. */
  nameSynonyms?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LocationFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `parentLocationId` field. */
  parentLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `timezone` field. */
  timezone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LocationTypeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Location` */
export type LocationInput = {
  airDraft?: InputMaybe<Scalars['BigFloat']['input']>;
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  clusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  countryId?: InputMaybe<Scalars['CountryId']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  extIdArray?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  extraPortDays?: InputMaybe<Scalars['BigFloat']['input']>;
  geog?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  lengthOverall?: InputMaybe<Scalars['BigFloat']['input']>;
  locode?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Maximum Deadweight Tonnage */
  maxDwt?: InputMaybe<Scalars['BigFloat']['input']>;
  name: Scalars['String']['input'];
  nameSynonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  parentLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Offset in hours from UTC */
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationType>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Mo, Tu, We, Th, Fr, Sa, Su, Ho */
  workingHours?: InputMaybe<Array<InputMaybe<WorkhourInput>>>;
};

/** Represents an update to a `Location`. Fields that are set will be updated. */
export type LocationPatch = {
  airDraft?: InputMaybe<Scalars['BigFloat']['input']>;
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  clusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  countryId?: InputMaybe<Scalars['CountryId']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  extIdArray?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  extraPortDays?: InputMaybe<Scalars['BigFloat']['input']>;
  geog?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  lengthOverall?: InputMaybe<Scalars['BigFloat']['input']>;
  locode?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Maximum Deadweight Tonnage */
  maxDwt?: InputMaybe<Scalars['BigFloat']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameSynonyms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  parentLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Offset in hours from UTC */
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LocationType>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Mo, Tu, We, Th, Fr, Sa, Su, Ho */
  workingHours?: InputMaybe<Array<InputMaybe<WorkhourInput>>>;
};

export type LocationRequirementAssociation = Node & {
  __typename?: 'LocationRequirementAssociation';
  id: Scalars['LocationRequirementAssociationId']['output'];
  /** Reads a single `Location` that is related to this `LocationRequirementAssociation`. */
  locationByLocationId?: Maybe<Location>;
  locationId?: Maybe<Scalars['LocationId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `SpecialRequirement` that is related to this `LocationRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  specialRequirementId: Scalars['SpecialRequirementId']['output'];
  /** Reads a single `Zone` that is related to this `LocationRequirementAssociation`. */
  zoneByZoneId?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['ZoneId']['output']>;
};

/**
 * A condition to be used against `LocationRequirementAssociation` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type LocationRequirementAssociationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['LocationRequirementAssociationId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `specialRequirementId` field. */
  specialRequirementId?: InputMaybe<Scalars['SpecialRequirementId']['input']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A filter to be used against `LocationRequirementAssociation` object types. All fields are combined with a logical ‘and.’ */
export type LocationRequirementAssociationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LocationRequirementAssociationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LocationRequirementAssociationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LocationRequirementAssociationFilter>>;
  /** Filter by the object’s `specialRequirementId` field. */
  specialRequirementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `LocationRequirementAssociation` */
export type LocationRequirementAssociationInput = {
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  specialRequirementId: Scalars['SpecialRequirementId']['input'];
  zoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** Represents an update to a `LocationRequirementAssociation`. Fields that are set will be updated. */
export type LocationRequirementAssociationPatch = {
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  specialRequirementId?: InputMaybe<Scalars['SpecialRequirementId']['input']>;
  zoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A connection to a list of `LocationRequirementAssociation` values. */
export type LocationRequirementAssociationsConnection = {
  __typename?: 'LocationRequirementAssociationsConnection';
  /** A list of edges which contains the `LocationRequirementAssociation` and cursor to aid in pagination. */
  edges: Array<LocationRequirementAssociationsEdge>;
  /** A list of `LocationRequirementAssociation` objects. */
  nodes: Array<Maybe<LocationRequirementAssociation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LocationRequirementAssociation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LocationRequirementAssociation` edge in the connection. */
export type LocationRequirementAssociationsEdge = {
  __typename?: 'LocationRequirementAssociationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LocationRequirementAssociation` at the end of the edge. */
  node?: Maybe<LocationRequirementAssociation>;
};

/** Methods to use when ordering `LocationRequirementAssociation`. */
export enum LocationRequirementAssociationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SPECIAL_REQUIREMENT_ID_ASC = 'SPECIAL_REQUIREMENT_ID_ASC',
  SPECIAL_REQUIREMENT_ID_DESC = 'SPECIAL_REQUIREMENT_ID_DESC',
  ZONE_ID_ASC = 'ZONE_ID_ASC',
  ZONE_ID_DESC = 'ZONE_ID_DESC'
}

export type LocationSubscriptionPayload = {
  __typename?: 'LocationSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
};

export enum LocationType {
  OTHER = 'OTHER',
  PORT = 'PORT',
  QUAY = 'QUAY',
  TERMINAL = 'TERMINAL'
}

/** A filter to be used against LocationType fields. All fields are combined with a logical ‘and.’ */
export type LocationTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LocationType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LocationType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LocationType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LocationType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LocationType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LocationType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LocationType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LocationType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LocationType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LocationType>>;
};

export type LocationWorkingHour = Node & {
  __typename?: 'LocationWorkingHour';
  date: Scalars['Date']['output'];
  from?: Maybe<Scalars['Time']['output']>;
  id: Scalars['LocationWorkingHourId']['output'];
  isHoliday: Scalars['Boolean']['output'];
  /** Reads a single `Location` that is related to this `LocationWorkingHour`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  to?: Maybe<Scalars['Time']['output']>;
  /** Reads a single `User` that is related to this `LocationWorkingHour`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};

/**
 * A condition to be used against `LocationWorkingHour` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LocationWorkingHourCondition = {
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `from` field. */
  from?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['LocationWorkingHourId']['input']>;
  /** Checks for equality with the object’s `isHoliday` field. */
  isHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `to` field. */
  to?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `LocationWorkingHour` object types. All fields are combined with a logical ‘and.’ */
export type LocationWorkingHourFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LocationWorkingHourFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `from` field. */
  from?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isHoliday` field. */
  isHoliday?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LocationWorkingHourFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LocationWorkingHourFilter>>;
  /** Filter by the object’s `to` field. */
  to?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `LocationWorkingHour` */
export type LocationWorkingHourInput = {
  date: Scalars['Date']['input'];
  from?: InputMaybe<Scalars['Time']['input']>;
  isHoliday: Scalars['Boolean']['input'];
  locationId: Scalars['LocationId']['input'];
  to?: InputMaybe<Scalars['Time']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `LocationWorkingHour`. Fields that are set will be updated. */
export type LocationWorkingHourPatch = {
  date?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<Scalars['Time']['input']>;
  isHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `LocationWorkingHour` values. */
export type LocationWorkingHoursConnection = {
  __typename?: 'LocationWorkingHoursConnection';
  /** A list of edges which contains the `LocationWorkingHour` and cursor to aid in pagination. */
  edges: Array<LocationWorkingHoursEdge>;
  /** A list of `LocationWorkingHour` objects. */
  nodes: Array<Maybe<LocationWorkingHour>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LocationWorkingHour` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LocationWorkingHour` edge in the connection. */
export type LocationWorkingHoursEdge = {
  __typename?: 'LocationWorkingHoursEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LocationWorkingHour` at the end of the edge. */
  node?: Maybe<LocationWorkingHour>;
};

/** Methods to use when ordering `LocationWorkingHour`. */
export enum LocationWorkingHoursOrderBy {
  DATE_ASC = 'DATE_ASC',
  DATE_DESC = 'DATE_DESC',
  FROM_ASC = 'FROM_ASC',
  FROM_DESC = 'FROM_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_HOLIDAY_ASC = 'IS_HOLIDAY_ASC',
  IS_HOLIDAY_DESC = 'IS_HOLIDAY_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TO_ASC = 'TO_ASC',
  TO_DESC = 'TO_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** A connection to a list of `Location` values. */
export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  /** A list of edges which contains the `Location` and cursor to aid in pagination. */
  edges: Array<LocationsEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Maybe<Location>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Location` edge in the connection. */
export type LocationsEdge = {
  __typename?: 'LocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Location` at the end of the edge. */
  node?: Maybe<Location>;
};

/** Methods to use when ordering `Location`. */
export enum LocationsOrderBy {
  AIR_DRAFT_ASC = 'AIR_DRAFT_ASC',
  AIR_DRAFT_DESC = 'AIR_DRAFT_DESC',
  BEAM_ASC = 'BEAM_ASC',
  BEAM_DESC = 'BEAM_DESC',
  CLUSTER_ID_ASC = 'CLUSTER_ID_ASC',
  CLUSTER_ID_DESC = 'CLUSTER_ID_DESC',
  COUNTRY_ID_ASC = 'COUNTRY_ID_ASC',
  COUNTRY_ID_DESC = 'COUNTRY_ID_DESC',
  DRAFT_ASC = 'DRAFT_ASC',
  DRAFT_DESC = 'DRAFT_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  EXTRA_PORT_DAYS_ASC = 'EXTRA_PORT_DAYS_ASC',
  EXTRA_PORT_DAYS_DESC = 'EXTRA_PORT_DAYS_DESC',
  EXT_ID_ARRAY_ASC = 'EXT_ID_ARRAY_ASC',
  EXT_ID_ARRAY_DESC = 'EXT_ID_ARRAY_DESC',
  GEOG_ASC = 'GEOG_ASC',
  GEOG_DESC = 'GEOG_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LATITUDE_ASC = 'LATITUDE_ASC',
  LATITUDE_DESC = 'LATITUDE_DESC',
  LENGTH_OVERALL_ASC = 'LENGTH_OVERALL_ASC',
  LENGTH_OVERALL_DESC = 'LENGTH_OVERALL_DESC',
  LOCODE_ASC = 'LOCODE_ASC',
  LOCODE_DESC = 'LOCODE_DESC',
  LONGITUDE_ASC = 'LONGITUDE_ASC',
  LONGITUDE_DESC = 'LONGITUDE_DESC',
  MAX_DWT_ASC = 'MAX_DWT_ASC',
  MAX_DWT_DESC = 'MAX_DWT_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NAME_SYNONYMS_ASC = 'NAME_SYNONYMS_ASC',
  NAME_SYNONYMS_DESC = 'NAME_SYNONYMS_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PARENT_LOCATION_ID_ASC = 'PARENT_LOCATION_ID_ASC',
  PARENT_LOCATION_ID_DESC = 'PARENT_LOCATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  TIMEZONE_ASC = 'TIMEZONE_ASC',
  TIMEZONE_DESC = 'TIMEZONE_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  WORKING_HOURS_ASC = 'WORKING_HOURS_ASC',
  WORKING_HOURS_DESC = 'WORKING_HOURS_DESC'
}

/** All input for the `logout` mutation. */
export type LogoutInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `logout` mutation. */
export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** Details about who the contract was lost to and for what price */
export type LostContract = Node & {
  __typename?: 'LostContract';
  createdAt: Scalars['Datetime']['output'];
  freightAmount?: Maybe<Scalars['BigFloat']['output']>;
  freightCurrency?: Maybe<Currency>;
  freightUnit?: Maybe<PaymentUnit>;
  id: Scalars['LostContractId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `LostContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `LostContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Freetext remarks about the competition on this contract */
  remarks?: Maybe<Scalars['String']['output']>;
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `VoyageCharter`. */
  voyageChartersByLostContractsId: VoyageChartersConnection;
};


/** Details about who the contract was lost to and for what price */
export type LostContractVoyageChartersByLostContractsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterCondition>;
  filter?: InputMaybe<VoyageCharterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};

/**
 * A condition to be used against `LostContract` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LostContractCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightCurrency` field. */
  freightCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['LostContractId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `remarks` field. */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `LostContract` object types. All fields are combined with a logical ‘and.’ */
export type LostContractFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LostContractFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightCurrency` field. */
  freightCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LostContractFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LostContractFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `remarks` field. */
  remarks?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `LostContract` */
export type LostContractInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightCurrency?: InputMaybe<Currency>;
  freightUnit?: InputMaybe<PaymentUnit>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Freetext remarks about the competition on this contract */
  remarks?: InputMaybe<Scalars['String']['input']>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Represents an update to a `LostContract`. Fields that are set will be updated. */
export type LostContractPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightCurrency?: InputMaybe<Currency>;
  freightUnit?: InputMaybe<PaymentUnit>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Freetext remarks about the competition on this contract */
  remarks?: InputMaybe<Scalars['String']['input']>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `LostContract` values. */
export type LostContractsConnection = {
  __typename?: 'LostContractsConnection';
  /** A list of edges which contains the `LostContract` and cursor to aid in pagination. */
  edges: Array<LostContractsEdge>;
  /** A list of `LostContract` objects. */
  nodes: Array<Maybe<LostContract>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LostContract` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `LostContract` edge in the connection. */
export type LostContractsEdge = {
  __typename?: 'LostContractsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LostContract` at the end of the edge. */
  node?: Maybe<LostContract>;
};

/** Methods to use when ordering `LostContract`. */
export enum LostContractsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_CURRENCY_ASC = 'FREIGHT_CURRENCY_ASC',
  FREIGHT_CURRENCY_DESC = 'FREIGHT_CURRENCY_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMARKS_ASC = 'REMARKS_ASC',
  REMARKS_DESC = 'REMARKS_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

/** All input for the `mapAssortmentSynonymToName` mutation. */
export type MapAssortmentSynonymToNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentAssortmentName?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `mapAssortmentSynonymToName` mutation. */
export type MapAssortmentSynonymToNamePayload = {
  __typename?: 'MapAssortmentSynonymToNamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']['output']>;
};

/** All input for the `mapLocationSynonymToName` mutation. */
export type MapLocationSynonymToNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentPortName?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `mapLocationSynonymToName` mutation. */
export type MapLocationSynonymToNamePayload = {
  __typename?: 'MapLocationSynonymToNamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']['output']>;
};

export type MarcuraPortCost = {
  __typename?: 'MarcuraPortCost';
  assortment_id: Scalars['Int']['output'];
  cached_at: Scalars['Datetime']['output'];
  data: MarcuraPortCostData;
  id: Scalars['Int']['output'];
  location_id: Scalars['Int']['output'];
  marcura_group_id: Scalars['String']['output'];
  marcura_port_id: Scalars['String']['output'];
};

export type MarcuraPortCostData = {
  __typename?: 'MarcuraPortCostData';
  costs?: Maybe<Array<Maybe<MarcuraVesselSegmentCost>>>;
};

export type MarcuraVesselSegmentCost = {
  __typename?: 'MarcuraVesselSegmentCost';
  costDischarging?: Maybe<Scalars['Float']['output']>;
  costDischargingWithTowage?: Maybe<Scalars['Boolean']['output']>;
  costLoading?: Maybe<Scalars['Float']['output']>;
  costLoadingWithTowage?: Maybe<Scalars['Boolean']['output']>;
  dwtMax?: Maybe<Scalars['Int']['output']>;
  dwtMin?: Maybe<Scalars['Int']['output']>;
  segmentName?: Maybe<Scalars['String']['output']>;
};

export type MarcuraWarmCacheResult = {
  __typename?: 'MarcuraWarmCacheResult';
  refreshedCount: Scalars['Int']['output'];
  status: MarcuraWarmCacheStatus;
};

export enum MarcuraWarmCacheStatus {
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  NO_OP = 'NO_OP',
  SUCCESS = 'SUCCESS'
}

export enum MarginUnit {
  MINMAX = 'MINMAX',
  PERCENTAGE = 'PERCENTAGE',
  TONNES = 'TONNES'
}

/** A filter to be used against MarginUnit fields. All fields are combined with a logical ‘and.’ */
export type MarginUnitFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MarginUnit>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MarginUnit>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MarginUnit>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MarginUnit>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MarginUnit>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MarginUnit>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MarginUnit>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MarginUnit>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MarginUnit>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MarginUnit>>;
};

export type MicrosoftAuthenticateInput = {
  idToken: Scalars['String']['input'];
};

export type MicrosoftAuthenticatePayload = {
  __typename?: 'MicrosoftAuthenticatePayload';
  jwtToken?: Maybe<Scalars['JwtToken']['output']>;
};

export type Migration = Node & {
  __typename?: 'Migration';
  id: Scalars['MigrationId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  runOn: Scalars['Datetime']['output'];
};

/** An input for mutations affecting `Migration` */
export type MigrationInput = {
  name: Scalars['String']['input'];
  runOn: Scalars['Datetime']['input'];
};

/** Represents an update to a `Migration`. Fields that are set will be updated. */
export type MigrationPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  runOn?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A `Migration` edge in the connection. */
export type MigrationsEdge = {
  __typename?: 'MigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Migration` at the end of the edge. */
  node?: Maybe<Migration>;
};

/** Methods to use when ordering `Migration`. */
export enum MigrationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RUN_ON_ASC = 'RUN_ON_ASC',
  RUN_ON_DESC = 'RUN_ON_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Marks voyage charter update accepted/rejected and updates voyage charter on accept. If accepted returns updated voyage charter. */
  acceptVoyageCharterUpdate?: Maybe<AcceptVoyageCharterUpdatePayload>;
  addJobImosRobSync?: Maybe<AddJobImosRobSyncPayload>;
  allOrgTreeListFromSessOrg?: Maybe<AllOrgTreeListFromSessOrgPayload>;
  apiOrdersDateValidation?: Maybe<ApiOrdersDateValidationPayload>;
  apiPushExtraCost?: Maybe<ApiPushExtraCostPayload>;
  apiPushLostContract?: Maybe<ApiPushLostContractPayload>;
  apiPushPortCost?: Maybe<ApiPushPortCostPayload>;
  /**
   * Main entry point for external systems (e.g., NESTE) to push port call timestamps.
   * Supports identifying port calls by either external order ID or direct port call ID.
   * Implements threshold-based updates to avoid unnecessary changes for small time adjustments.
   */
  apiPushPortcallTime?: Maybe<ApiPushPortcallTimePayload>;
  archiveByIds?: Maybe<Scalars['Boolean']['output']>;
  authenticate?: Maybe<AuthenticatePayload>;
  balticOrdersSync?: Maybe<BalticOrdersSyncResult>;
  balticScenarioSync?: Maybe<BalticScenarioSyncResult>;
  balticUpdateData?: Maybe<BalticUpdateData>;
  balticVesselsSync?: Maybe<BalticVesselsSyncResult>;
  /** Batch tune performance models for multiple vessels */
  batchTunePerformanceModels: BatchTunePerformanceModelsResult;
  bunkerEx?: Maybe<BunkerEx>;
  canAccessBunkerGradeOverride?: Maybe<CanAccessBunkerGradeOverridePayload>;
  canAccessCommitLog?: Maybe<CanAccessCommitLogPayload>;
  canAccessScenario?: Maybe<CanAccessScenarioPayload>;
  carbonPrice?: Maybe<CarbonPrice>;
  changePassword?: Maybe<ChangePasswordPayload>;
  coaContractsForCurrentPortAgent?: Maybe<CoaContractsForCurrentPortAgentPayload>;
  coaContractsForCurrentSendersReceivers?: Maybe<CoaContractsForCurrentSendersReceiversPayload>;
  commit?: Maybe<CommitPayload>;
  commodityGroupMapping?: Maybe<CommodityGroupMappingResult>;
  /** Creates a single `ActualCost`. */
  createActualCost?: Maybe<CreateActualCostPayload>;
  /** Creates a single `ApiCoaContract`. */
  createApiCoaContract?: Maybe<CreateApiCoaContractPayload>;
  /** Creates a single `ApiLocation`. */
  createApiLocation?: Maybe<CreateApiLocationPayload>;
  createApiOrders?: Maybe<CreateApiOrdersPayload>;
  /** Creates a single `ApiOrdersNotice`. */
  createApiOrdersNotice?: Maybe<CreateApiOrdersNoticePayload>;
  /** Creates a single `ApiShip`. */
  createApiShip?: Maybe<CreateApiShipPayload>;
  /** Creates a single `ApiShipmentStatus`. */
  createApiShipmentStatus?: Maybe<CreateApiShipmentStatusPayload>;
  /** Creates a single `Assortment`. */
  createAssortment?: Maybe<CreateAssortmentPayload>;
  /** Creates a single `AssortmentExclusion`. */
  createAssortmentExclusion?: Maybe<CreateAssortmentExclusionPayload>;
  /** Creates a single `AssortmentGroup`. */
  createAssortmentGroup?: Maybe<CreateAssortmentGroupPayload>;
  /** Creates a single `BatchUpdate`. */
  createBatchUpdate?: Maybe<CreateBatchUpdatePayload>;
  /** Creates a single `BillOfLading`. */
  createBillOfLading?: Maybe<CreateBillOfLadingPayload>;
  /** Creates a single `BillOfLadingDatum`. */
  createBillOfLadingDatum?: Maybe<CreateBillOfLadingDatumPayload>;
  /** Creates a single `BunkerGradeCalculation`. */
  createBunkerGradeCalculation?: Maybe<CreateBunkerGradeCalculationPayload>;
  /** Creates a single `BunkerGradeMapping`. */
  createBunkerGradeMapping?: Maybe<CreateBunkerGradeMappingPayload>;
  /** Creates a single `BunkerGradeOverride`. */
  createBunkerGradeOverride?: Maybe<CreateBunkerGradeOverridePayload>;
  /** Creates a single `Bunkering`. */
  createBunkering?: Maybe<CreateBunkeringPayload>;
  /** Creates a single `CarbonPriceOverride`. */
  createCarbonPriceOverride?: Maybe<CreateCarbonPriceOverridePayload>;
  /** Creates a single `CargoCompartment`. */
  createCargoCompartment?: Maybe<CreateCargoCompartmentPayload>;
  /** Creates a single `CargoCompartmentAllocation`. */
  createCargoCompartmentAllocation?: Maybe<CreateCargoCompartmentAllocationPayload>;
  /** Creates a single `CargoEquipment`. */
  createCargoEquipment?: Maybe<CreateCargoEquipmentPayload>;
  /** Creates a single `CargoExclusion`. */
  createCargoExclusion?: Maybe<CreateCargoExclusionPayload>;
  /** Creates a single `CargoLengthUnit`. */
  createCargoLengthUnit?: Maybe<CreateCargoLengthUnitPayload>;
  /** Creates a single `CargoMeasurement`. */
  createCargoMeasurement?: Maybe<CreateCargoMeasurementPayload>;
  /** Creates a single `CargoUnit`. */
  createCargoUnit?: Maybe<CreateCargoUnitPayload>;
  /** Creates a single `CargoUnitsConversion`. */
  createCargoUnitsConversion?: Maybe<CreateCargoUnitsConversionPayload>;
  /** Creates a single `CargoWeightUnit`. */
  createCargoWeightUnit?: Maybe<CreateCargoWeightUnitPayload>;
  /** Creates a single `Channel`. */
  createChannel?: Maybe<CreateChannelPayload>;
  /** Creates a single `ChannelCost`. */
  createChannelCost?: Maybe<CreateChannelCostPayload>;
  /** Creates a single `ChannelCostEstimate`. */
  createChannelCostEstimate?: Maybe<CreateChannelCostEstimatePayload>;
  /** Creates a single `ChannelIncompatibility`. */
  createChannelIncompatibility?: Maybe<CreateChannelIncompatibilityPayload>;
  /** Creates a single `Chat`. */
  createChat?: Maybe<CreateChatPayload>;
  /** Creates a single `ClassSocietyAssociation`. */
  createClassSocietyAssociation?: Maybe<CreateClassSocietyAssociationPayload>;
  /** Creates a single `ClassificationSociety`. */
  createClassificationSociety?: Maybe<CreateClassificationSocietyPayload>;
  /** Creates a single `CoaContract`. */
  createCoaContract?: Maybe<CreateCoaContractPayload>;
  /** Creates a single `CoaContractAssortment`. */
  createCoaContractAssortment?: Maybe<CreateCoaContractAssortmentPayload>;
  /** Creates a single `CoaContractBunker`. */
  createCoaContractBunker?: Maybe<CreateCoaContractBunkerPayload>;
  /** Creates a single `CoaContractCommission`. */
  createCoaContractCommission?: Maybe<CreateCoaContractCommissionPayload>;
  /** Creates a single `CoaContractDeviationCost`. */
  createCoaContractDeviationCost?: Maybe<CreateCoaContractDeviationCostPayload>;
  /** Creates a single `CoaContractPort`. */
  createCoaContractPort?: Maybe<CreateCoaContractPortPayload>;
  /** Creates a single `CoaContractPortCost`. */
  createCoaContractPortCost?: Maybe<CreateCoaContractPortCostPayload>;
  /** Creates a single `CoaContractPortDatum`. */
  createCoaContractPortDatum?: Maybe<CreateCoaContractPortDatumPayload>;
  /** Creates a single `CoaContractPrice`. */
  createCoaContractPrice?: Maybe<CreateCoaContractPricePayload>;
  /** Creates a single `CoaContractShip`. */
  createCoaContractShip?: Maybe<CreateCoaContractShipPayload>;
  /** Creates a single `Commission`. */
  createCommission?: Maybe<CreateCommissionPayload>;
  /** Creates a single `CommitLogScenario`. */
  createCommitLogScenario?: Maybe<CreateCommitLogScenarioPayload>;
  /** Creates a single `CostSplitOnScheduledOrder`. */
  createCostSplitOnScheduledOrder?: Maybe<CreateCostSplitOnScheduledOrderPayload>;
  /** Creates a single `CostSplitOnSingleEvent`. */
  createCostSplitOnSingleEvent?: Maybe<CreateCostSplitOnSingleEventPayload>;
  /** Creates a single `Country`. */
  createCountry?: Maybe<CreateCountryPayload>;
  /** Creates a single `CurrentOrganization`. */
  createCurrentOrganization?: Maybe<CreateCurrentOrganizationPayload>;
  /** Creates a single `DbChange`. */
  createDbChange?: Maybe<CreateDbChangePayload>;
  /** Creates a single `Demand`. */
  createDemand?: Maybe<CreateDemandPayload>;
  /** Creates a single `EmailToOrderConfig`. */
  createEmailToOrderConfig?: Maybe<CreateEmailToOrderConfigPayload>;
  /** Creates a single `EmailToOrderLog`. */
  createEmailToOrderLog?: Maybe<CreateEmailToOrderLogPayload>;
  /** Creates a single `Feature`. */
  createFeature?: Maybe<CreateFeaturePayload>;
  /** Creates a single `File`. */
  createFile?: Maybe<CreateFilePayload>;
  /** Creates a single `GeographicalEntity`. */
  createGeographicalEntity?: Maybe<CreateGeographicalEntityPayload>;
  /** Creates a single `GeographicalRelation`. */
  createGeographicalRelation?: Maybe<CreateGeographicalRelationPayload>;
  /** Creates a single `HandledByCoa`. */
  createHandledByCoa?: Maybe<CreateHandledByCoaPayload>;
  /** Creates a single `HandledBySpot`. */
  createHandledBySpot?: Maybe<CreateHandledBySpotPayload>;
  /** Creates a single `Holiday`. */
  createHoliday?: Maybe<CreateHolidayPayload>;
  /** Creates a single `IceClass`. */
  createIceClass?: Maybe<CreateIceClassPayload>;
  /** Creates a single `Instruction`. */
  createInstruction?: Maybe<CreateInstructionPayload>;
  /** Creates a single `IntegrationLog`. */
  createIntegrationLog?: Maybe<CreateIntegrationLogPayload>;
  /** Creates a single `Invoice`. */
  createInvoice?: Maybe<CreateInvoicePayload>;
  /** Creates a single `InvoiceItem`. */
  createInvoiceItem?: Maybe<CreateInvoiceItemPayload>;
  /** Creates a single `InvoiceItemOrder`. */
  createInvoiceItemOrder?: Maybe<CreateInvoiceItemOrderPayload>;
  /** Creates a single `LaytimeResponsibility`. */
  createLaytimeResponsibility?: Maybe<CreateLaytimeResponsibilityPayload>;
  /** Creates a single `Location`. */
  createLocation?: Maybe<CreateLocationPayload>;
  /** Creates a single `LocationCluster`. */
  createLocationCluster?: Maybe<CreateLocationClusterPayload>;
  /** Creates a single `LocationRequirementAssociation`. */
  createLocationRequirementAssociation?: Maybe<CreateLocationRequirementAssociationPayload>;
  /** Creates a single `LocationWorkingHour`. */
  createLocationWorkingHour?: Maybe<CreateLocationWorkingHourPayload>;
  /** Creates a single `LostContract`. */
  createLostContract?: Maybe<CreateLostContractPayload>;
  /** Creates a single `Migration`. */
  createMigration?: Maybe<CreateMigrationPayload>;
  /** Creates a single `NoGoZone`. */
  createNoGoZone?: Maybe<CreateNoGoZonePayload>;
  /** Creates a single `NotificationReceiver`. */
  createNotificationReceiver?: Maybe<CreateNotificationReceiverPayload>;
  /** Creates a single `OffHire`. */
  createOffHire?: Maybe<CreateOffHirePayload>;
  /** Creates a single `OpenPosition`. */
  createOpenPosition?: Maybe<CreateOpenPositionPayload>;
  /** Creates a single `Order`. */
  createOrder?: Maybe<CreateOrderPayload>;
  /** Creates a single `OrderAttribute`. */
  createOrderAttribute?: Maybe<CreateOrderAttributePayload>;
  /** Creates a single `OrderAttributeAssociation`. */
  createOrderAttributeAssociation?: Maybe<CreateOrderAttributeAssociationPayload>;
  /** Creates a single `OrderDetail`. */
  createOrderDetail?: Maybe<CreateOrderDetailPayload>;
  /** Creates a single `OrderPortCallRelation`. */
  createOrderPortCallRelation?: Maybe<CreateOrderPortCallRelationPayload>;
  /** Creates a single `OrderPortOverride`. */
  createOrderPortOverride?: Maybe<CreateOrderPortOverridePayload>;
  /** Creates a single `OrderRequirementAssociation`. */
  createOrderRequirementAssociation?: Maybe<CreateOrderRequirementAssociationPayload>;
  /** Creates a single `OrderVoyageCharterRelation`. */
  createOrderVoyageCharterRelation?: Maybe<CreateOrderVoyageCharterRelationPayload>;
  /** Creates a single `Organization`. */
  createOrganization?: Maybe<CreateOrganizationPayload>;
  /** Creates a single `OrganizationAreaBunkerGradeMapping`. */
  createOrganizationAreaBunkerGradeMapping?: Maybe<CreateOrganizationAreaBunkerGradeMappingPayload>;
  /** Creates a single `OrganizationFeature`. */
  createOrganizationFeature?: Maybe<CreateOrganizationFeaturePayload>;
  /** Creates a single `PortActivity`. */
  createPortActivity?: Maybe<CreatePortActivityPayload>;
  /** Creates a single `PortCall`. */
  createPortCall?: Maybe<CreatePortCallPayload>;
  /** Creates a single `PortCallExternalTimestamp`. */
  createPortCallExternalTimestamp?: Maybe<CreatePortCallExternalTimestampPayload>;
  /** Creates a single `PortCallFile`. */
  createPortCallFile?: Maybe<CreatePortCallFilePayload>;
  /** Creates a single `PortCommodityLdRate`. */
  createPortCommodityLdRate?: Maybe<CreatePortCommodityLdRatePayload>;
  /** Creates a single `PortCost`. */
  createPortCost?: Maybe<CreatePortCostPayload>;
  /** Creates a single `PortCostDefault`. */
  createPortCostDefault?: Maybe<CreatePortCostDefaultPayload>;
  /** Creates a single `PortCostEstimatesExternal`. */
  createPortCostEstimatesExternal?: Maybe<CreatePortCostEstimatesExternalPayload>;
  /** Creates a single `PortDatum`. */
  createPortDatum?: Maybe<CreatePortDatumPayload>;
  /** Creates a single `PortNotice`. */
  createPortNotice?: Maybe<CreatePortNoticePayload>;
  /** Creates a single `PortRegion`. */
  createPortRegion?: Maybe<CreatePortRegionPayload>;
  /** Creates a single `Prompt`. */
  createPrompt?: Maybe<CreatePromptPayload>;
  /** Creates a single `Quay`. */
  createQuay?: Maybe<CreateQuayPayload>;
  /** Creates a single `ReceiverOrganization`. */
  createReceiverOrganization?: Maybe<CreateReceiverOrganizationPayload>;
  /** Creates a single `Region`. */
  createRegion?: Maybe<CreateRegionPayload>;
  /** Creates a single `RequestLog`. */
  createRequestLog?: Maybe<CreateRequestLogPayload>;
  createRoleIfNotExists?: Maybe<CreateRoleIfNotExistsPayload>;
  /** Creates a single `Route`. */
  createRoute?: Maybe<CreateRoutePayload>;
  /** Creates a single `RouteOverride`. */
  createRouteOverride?: Maybe<CreateRouteOverridePayload>;
  /** Creates a single `RoutePoint`. */
  createRoutePoint?: Maybe<CreateRoutePointPayload>;
  /** Creates a single `RoutePointUsage`. */
  createRoutePointUsage?: Maybe<CreateRoutePointUsagePayload>;
  /** Creates a single `Scenario`. */
  createScenario?: Maybe<CreateScenarioPayload>;
  /** Creates a single `ScheduledOrder`. */
  createScheduledOrder?: Maybe<CreateScheduledOrderPayload>;
  /** Creates a single `SeenMessage`. */
  createSeenMessage?: Maybe<CreateSeenMessagePayload>;
  /** Creates a single `SenderOrganization`. */
  createSenderOrganization?: Maybe<CreateSenderOrganizationPayload>;
  /** Creates a single `Ship`. */
  createShip?: Maybe<CreateShipPayload>;
  /** Creates a single `ShipVoyageNamingRuleRelation`. */
  createShipVoyageNamingRuleRelation?: Maybe<CreateShipVoyageNamingRuleRelationPayload>;
  /** Creates a single `Shipment`. */
  createShipment?: Maybe<CreateShipmentPayload>;
  /** Creates a single `ShipmentExternalStatus`. */
  createShipmentExternalStatus?: Maybe<CreateShipmentExternalStatusPayload>;
  /** Creates a single `ShipmentExtraFreight`. */
  createShipmentExtraFreight?: Maybe<CreateShipmentExtraFreightPayload>;
  /** Creates a single `ShipmentFreight`. */
  createShipmentFreight?: Maybe<CreateShipmentFreightPayload>;
  /** Creates a single `ShipmentGroup`. */
  createShipmentGroup?: Maybe<CreateShipmentGroupPayload>;
  /** Creates a single `ShipmentGroupAssociation`. */
  createShipmentGroupAssociation?: Maybe<CreateShipmentGroupAssociationPayload>;
  /** Creates a single `SingleEvent`. */
  createSingleEvent?: Maybe<CreateSingleEventPayload>;
  /** Creates a single `SingleEventPortCallRelation`. */
  createSingleEventPortCallRelation?: Maybe<CreateSingleEventPortCallRelationPayload>;
  /** Creates a single `SpecialRequirement`. */
  createSpecialRequirement?: Maybe<CreateSpecialRequirementPayload>;
  /** Creates a single `SplitOrder`. */
  createSplitOrder?: Maybe<CreateSplitOrderPayload>;
  /** Creates a single `SpotNegotiation`. */
  createSpotNegotiation?: Maybe<CreateSpotNegotiationPayload>;
  /** Creates a single `StatementOfFact`. */
  createStatementOfFact?: Maybe<CreateStatementOfFactPayload>;
  /** Creates a single `Supply`. */
  createSupply?: Maybe<CreateSupplyPayload>;
  /** Creates a single `SupplyContract`. */
  createSupplyContract?: Maybe<CreateSupplyContractPayload>;
  /** Creates a single `TankDistance`. */
  createTankDistance?: Maybe<CreateTankDistancePayload>;
  /** Creates a single `TcContract`. */
  createTcContract?: Maybe<CreateTcContractPayload>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserRegion`. */
  createUserRegion?: Maybe<CreateUserRegionPayload>;
  /** Creates a single `UserRight`. */
  createUserRight?: Maybe<CreateUserRightPayload>;
  /** Creates a single `UserSetting`. */
  createUserSetting?: Maybe<CreateUserSettingPayload>;
  /** Creates a single `UserShip`. */
  createUserShip?: Maybe<CreateUserShipPayload>;
  /** Creates a single `VesselAttribute`. */
  createVesselAttribute?: Maybe<CreateVesselAttributePayload>;
  /** Creates a single `VesselAttributeAssortmentExclusion`. */
  createVesselAttributeAssortmentExclusion?: Maybe<CreateVesselAttributeAssortmentExclusionPayload>;
  /** Creates a single `VesselAttributesAssociation`. */
  createVesselAttributesAssociation?: Maybe<CreateVesselAttributesAssociationPayload>;
  /** Creates a single `VesselDraftDatapoint`. */
  createVesselDraftDatapoint?: Maybe<CreateVesselDraftDatapointPayload>;
  /** Creates a single `VesselFulfillsRequirementAssociation`. */
  createVesselFulfillsRequirementAssociation?: Maybe<CreateVesselFulfillsRequirementAssociationPayload>;
  /** Creates a single `VesselInfo`. */
  createVesselInfo?: Maybe<CreateVesselInfoPayload>;
  /** Creates a single `VesselPerformanceModel`. */
  createVesselPerformanceModel?: Maybe<CreateVesselPerformanceModelPayload>;
  /** Creates a single `VesselReservation`. */
  createVesselReservation?: Maybe<CreateVesselReservationPayload>;
  /** Creates a single `VesselScheduleSharedToOrganization`. */
  createVesselScheduleSharedToOrganization?: Maybe<CreateVesselScheduleSharedToOrganizationPayload>;
  /** Creates a single `VesselSecret`. */
  createVesselSecret?: Maybe<CreateVesselSecretPayload>;
  /** Creates a single `VesselSpeedConsumption`. */
  createVesselSpeedConsumption?: Maybe<CreateVesselSpeedConsumptionPayload>;
  /** Creates a single `Voyage`. */
  createVoyage?: Maybe<CreateVoyagePayload>;
  /** Creates a single `VoyageAssociation`. */
  createVoyageAssociation?: Maybe<CreateVoyageAssociationPayload>;
  /** Creates a single `VoyageAttribute`. */
  createVoyageAttribute?: Maybe<CreateVoyageAttributePayload>;
  /** Creates a single `VoyageCharter`. */
  createVoyageCharter?: Maybe<CreateVoyageCharterPayload>;
  /** Creates a single `VoyageCharterExtraCost`. */
  createVoyageCharterExtraCost?: Maybe<CreateVoyageCharterExtraCostPayload>;
  /** Creates a single `VoyageCharterExtraFreight`. */
  createVoyageCharterExtraFreight?: Maybe<CreateVoyageCharterExtraFreightPayload>;
  /** Creates a single `VoyageCharterOrderFreight`. */
  createVoyageCharterOrderFreight?: Maybe<CreateVoyageCharterOrderFreightPayload>;
  /** Creates a single `VoyageCharterPortCost`. */
  createVoyageCharterPortCost?: Maybe<CreateVoyageCharterPortCostPayload>;
  /** Creates a single `VoyageCharterPortDatum`. */
  createVoyageCharterPortDatum?: Maybe<CreateVoyageCharterPortDatumPayload>;
  /** Creates a single `VoyageCharterToContract`. */
  createVoyageCharterToContract?: Maybe<CreateVoyageCharterToContractPayload>;
  /** Creates a single `VoyageCharterUpdate`. */
  createVoyageCharterUpdate?: Maybe<CreateVoyageCharterUpdatePayload>;
  /** Creates a single `VoyageNamingRule`. */
  createVoyageNamingRule?: Maybe<CreateVoyageNamingRulePayload>;
  /** Creates a single `VwHandledBySpotShipOwnerPg`. */
  createVwHandledBySpotShipOwnerPg?: Maybe<CreateVwHandledBySpotShipOwnerPgPayload>;
  /** Creates a single `VwVoyageCharterShipownerNonfinancial`. */
  createVwVoyageCharterShipownerNonfinancial?: Maybe<CreateVwVoyageCharterShipownerNonfinancialPayload>;
  /** Creates a single `WorldscaleFreight`. */
  createWorldscaleFreight?: Maybe<CreateWorldscaleFreightPayload>;
  /** Creates a single `Zone`. */
  createZone?: Maybe<CreateZonePayload>;
  /** Creates a single `ZoneLocation`. */
  createZoneLocation?: Maybe<CreateZoneLocationPayload>;
  currencyApi?: Maybe<CurrencyApi>;
  currentOrgId?: Maybe<CurrentOrgIdPayload>;
  /** Return true if current user can administer organization */
  currentUserCanAdminOrg?: Maybe<CurrentUserCanAdminOrgPayload>;
  currentUserId?: Maybe<CurrentUserIdPayload>;
  /** Deletes a single `ActualCost` using its globally unique id. */
  deleteActualCost?: Maybe<DeleteActualCostPayload>;
  /** Deletes a single `ActualCost` using a unique key. */
  deleteActualCostById?: Maybe<DeleteActualCostPayload>;
  /** Deletes a single `ApiOrder` using its globally unique id. */
  deleteApiOrder?: Maybe<DeleteApiOrderPayload>;
  /** Deletes a single `ApiOrder` using a unique key. */
  deleteApiOrderByExternalOrderId?: Maybe<DeleteApiOrderPayload>;
  /** Deletes a single `ApiOrdersNotice` using its globally unique id. */
  deleteApiOrdersNotice?: Maybe<DeleteApiOrdersNoticePayload>;
  /** Deletes a single `ApiOrdersNotice` using a unique key. */
  deleteApiOrdersNoticeById?: Maybe<DeleteApiOrdersNoticePayload>;
  /** Deletes a single `Assortment` using its globally unique id. */
  deleteAssortment?: Maybe<DeleteAssortmentPayload>;
  /** Deletes a single `Assortment` using a unique key. */
  deleteAssortmentById?: Maybe<DeleteAssortmentPayload>;
  /** Deletes a single `AssortmentExclusion` using its globally unique id. */
  deleteAssortmentExclusion?: Maybe<DeleteAssortmentExclusionPayload>;
  /** Deletes a single `AssortmentExclusion` using a unique key. */
  deleteAssortmentExclusionById?: Maybe<DeleteAssortmentExclusionPayload>;
  /** Deletes a single `AssortmentGroup` using its globally unique id. */
  deleteAssortmentGroup?: Maybe<DeleteAssortmentGroupPayload>;
  /** Deletes a single `AssortmentGroup` using a unique key. */
  deleteAssortmentGroupById?: Maybe<DeleteAssortmentGroupPayload>;
  deleteBalticConfig?: Maybe<BalticConfigPayload>;
  /** Deletes a single `BatchUpdate` using its globally unique id. */
  deleteBatchUpdate?: Maybe<DeleteBatchUpdatePayload>;
  /** Deletes a single `BatchUpdate` using a unique key. */
  deleteBatchUpdateById?: Maybe<DeleteBatchUpdatePayload>;
  /** Deletes a single `BillOfLading` using its globally unique id. */
  deleteBillOfLading?: Maybe<DeleteBillOfLadingPayload>;
  /** Deletes a single `BillOfLading` using a unique key. */
  deleteBillOfLadingById?: Maybe<DeleteBillOfLadingPayload>;
  /** Deletes a single `BillOfLadingDatum` using its globally unique id. */
  deleteBillOfLadingDatum?: Maybe<DeleteBillOfLadingDatumPayload>;
  /** Deletes a single `BillOfLadingDatum` using a unique key. */
  deleteBillOfLadingDatumById?: Maybe<DeleteBillOfLadingDatumPayload>;
  /** Deletes a single `BunkerGradeCalculation` using its globally unique id. */
  deleteBunkerGradeCalculation?: Maybe<DeleteBunkerGradeCalculationPayload>;
  /** Deletes a single `BunkerGradeCalculation` using a unique key. */
  deleteBunkerGradeCalculationById?: Maybe<DeleteBunkerGradeCalculationPayload>;
  /** Deletes a single `BunkerGradeCalculation` using a unique key. */
  deleteBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeId?: Maybe<DeleteBunkerGradeCalculationPayload>;
  /** Deletes a single `BunkerGradeMapping` using its globally unique id. */
  deleteBunkerGradeMapping?: Maybe<DeleteBunkerGradeMappingPayload>;
  /** Deletes a single `BunkerGradeMapping` using a unique key. */
  deleteBunkerGradeMappingById?: Maybe<DeleteBunkerGradeMappingPayload>;
  /** Deletes a single `BunkerGradeMapping` using a unique key. */
  deleteBunkerGradeMappingByOrganizationIdAndFromGradeId?: Maybe<DeleteBunkerGradeMappingPayload>;
  /** Deletes a single `BunkerGradeOverride` using its globally unique id. */
  deleteBunkerGradeOverride?: Maybe<DeleteBunkerGradeOverridePayload>;
  /** Deletes a single `BunkerGradeOverride` using a unique key. */
  deleteBunkerGradeOverrideByGradeNameAndOrganizationId?: Maybe<DeleteBunkerGradeOverridePayload>;
  /** Deletes a single `BunkerGradeOverride` using a unique key. */
  deleteBunkerGradeOverrideById?: Maybe<DeleteBunkerGradeOverridePayload>;
  /** Deletes a single `Bunkering` using its globally unique id. */
  deleteBunkering?: Maybe<DeleteBunkeringPayload>;
  /** Deletes a single `Bunkering` using a unique key. */
  deleteBunkeringById?: Maybe<DeleteBunkeringPayload>;
  /** Deletes a single `CarbonPriceOverride` using its globally unique id. */
  deleteCarbonPriceOverride?: Maybe<DeleteCarbonPriceOverridePayload>;
  /** Deletes a single `CarbonPriceOverride` using a unique key. */
  deleteCarbonPriceOverrideById?: Maybe<DeleteCarbonPriceOverridePayload>;
  /** Deletes a single `CargoCompartment` using its globally unique id. */
  deleteCargoCompartment?: Maybe<DeleteCargoCompartmentPayload>;
  /** Deletes a single `CargoCompartmentAllocation` using its globally unique id. */
  deleteCargoCompartmentAllocation?: Maybe<DeleteCargoCompartmentAllocationPayload>;
  /** Deletes a single `CargoCompartmentAllocation` using a unique key. */
  deleteCargoCompartmentAllocationById?: Maybe<DeleteCargoCompartmentAllocationPayload>;
  /** Deletes a single `CargoCompartment` using a unique key. */
  deleteCargoCompartmentById?: Maybe<DeleteCargoCompartmentPayload>;
  /** Deletes a single `CargoEquipment` using its globally unique id. */
  deleteCargoEquipment?: Maybe<DeleteCargoEquipmentPayload>;
  /** Deletes a single `CargoEquipment` using a unique key. */
  deleteCargoEquipmentById?: Maybe<DeleteCargoEquipmentPayload>;
  /** Deletes a single `CargoExclusion` using its globally unique id. */
  deleteCargoExclusion?: Maybe<DeleteCargoExclusionPayload>;
  /** Deletes a single `CargoExclusion` using a unique key. */
  deleteCargoExclusionById?: Maybe<DeleteCargoExclusionPayload>;
  /** Deletes a single `CargoLengthUnit` using its globally unique id. */
  deleteCargoLengthUnit?: Maybe<DeleteCargoLengthUnitPayload>;
  /** Deletes a single `CargoLengthUnit` using a unique key. */
  deleteCargoLengthUnitById?: Maybe<DeleteCargoLengthUnitPayload>;
  /** Deletes a single `CargoMeasurement` using its globally unique id. */
  deleteCargoMeasurement?: Maybe<DeleteCargoMeasurementPayload>;
  /** Deletes a single `CargoMeasurement` using a unique key. */
  deleteCargoMeasurementById?: Maybe<DeleteCargoMeasurementPayload>;
  /** Deletes a single `CargoUnit` using its globally unique id. */
  deleteCargoUnit?: Maybe<DeleteCargoUnitPayload>;
  /** Deletes a single `CargoUnit` using a unique key. */
  deleteCargoUnitById?: Maybe<DeleteCargoUnitPayload>;
  /** Deletes a single `CargoUnitsConversion` using a unique key. */
  deleteCargoUnitsConversionByExtraUnitName?: Maybe<DeleteCargoUnitsConversionPayload>;
  /** Deletes a single `CargoWeightUnit` using its globally unique id. */
  deleteCargoWeightUnit?: Maybe<DeleteCargoWeightUnitPayload>;
  /** Deletes a single `CargoWeightUnit` using a unique key. */
  deleteCargoWeightUnitById?: Maybe<DeleteCargoWeightUnitPayload>;
  /** Deletes a single `Channel` using its globally unique id. */
  deleteChannel?: Maybe<DeleteChannelPayload>;
  /** Deletes a single `Channel` using a unique key. */
  deleteChannelById?: Maybe<DeleteChannelPayload>;
  /** Deletes a single `ChannelCost` using its globally unique id. */
  deleteChannelCost?: Maybe<DeleteChannelCostPayload>;
  /** Deletes a single `ChannelCost` using a unique key. */
  deleteChannelCostById?: Maybe<DeleteChannelCostPayload>;
  /** Deletes a single `ChannelCostEstimate` using its globally unique id. */
  deleteChannelCostEstimate?: Maybe<DeleteChannelCostEstimatePayload>;
  /** Deletes a single `ChannelCostEstimate` using a unique key. */
  deleteChannelCostEstimateById?: Maybe<DeleteChannelCostEstimatePayload>;
  /** Deletes a single `ChannelIncompatibility` using its globally unique id. */
  deleteChannelIncompatibility?: Maybe<DeleteChannelIncompatibilityPayload>;
  /** Deletes a single `ChannelIncompatibility` using a unique key. */
  deleteChannelIncompatibilityById?: Maybe<DeleteChannelIncompatibilityPayload>;
  /** Deletes a single `ChannelIncompatibility` using a unique key. */
  deleteChannelIncompatibilityByVesselAttributeIdAndChannelName?: Maybe<DeleteChannelIncompatibilityPayload>;
  /** Deletes a single `Chat` using its globally unique id. */
  deleteChat?: Maybe<DeleteChatPayload>;
  /** Deletes a single `Chat` using a unique key. */
  deleteChatById?: Maybe<DeleteChatPayload>;
  /** Deletes a single `ClassSocietyAssociation` using its globally unique id. */
  deleteClassSocietyAssociation?: Maybe<DeleteClassSocietyAssociationPayload>;
  /** Deletes a single `ClassSocietyAssociation` using a unique key. */
  deleteClassSocietyAssociationById?: Maybe<DeleteClassSocietyAssociationPayload>;
  /** Deletes a single `ClassificationSociety` using its globally unique id. */
  deleteClassificationSociety?: Maybe<DeleteClassificationSocietyPayload>;
  /** Deletes a single `ClassificationSociety` using a unique key. */
  deleteClassificationSocietyById?: Maybe<DeleteClassificationSocietyPayload>;
  /** Deletes a single `CoaContract` using its globally unique id. */
  deleteCoaContract?: Maybe<DeleteCoaContractPayload>;
  /** Deletes a single `CoaContractAssortment` using its globally unique id. */
  deleteCoaContractAssortment?: Maybe<DeleteCoaContractAssortmentPayload>;
  /** Deletes a single `CoaContractAssortment` using a unique key. */
  deleteCoaContractAssortmentById?: Maybe<DeleteCoaContractAssortmentPayload>;
  /** Deletes a single `CoaContractBunker` using its globally unique id. */
  deleteCoaContractBunker?: Maybe<DeleteCoaContractBunkerPayload>;
  /** Deletes a single `CoaContractBunker` using a unique key. */
  deleteCoaContractBunkerById?: Maybe<DeleteCoaContractBunkerPayload>;
  /** Deletes a single `CoaContract` using a unique key. */
  deleteCoaContractById?: Maybe<DeleteCoaContractPayload>;
  /** Deletes a single `CoaContractCommission` using its globally unique id. */
  deleteCoaContractCommission?: Maybe<DeleteCoaContractCommissionPayload>;
  /** Deletes a single `CoaContractCommission` using a unique key. */
  deleteCoaContractCommissionById?: Maybe<DeleteCoaContractCommissionPayload>;
  /** Deletes a single `CoaContractDeviationCost` using its globally unique id. */
  deleteCoaContractDeviationCost?: Maybe<DeleteCoaContractDeviationCostPayload>;
  /** Deletes a single `CoaContractDeviationCost` using a unique key. */
  deleteCoaContractDeviationCostById?: Maybe<DeleteCoaContractDeviationCostPayload>;
  /** Deletes a single `CoaContractPort` using its globally unique id. */
  deleteCoaContractPort?: Maybe<DeleteCoaContractPortPayload>;
  /** Deletes a single `CoaContractPort` using a unique key. */
  deleteCoaContractPortByCoaContractIdAndOriginIdAndDestinationId?: Maybe<DeleteCoaContractPortPayload>;
  /** Deletes a single `CoaContractPort` using a unique key. */
  deleteCoaContractPortById?: Maybe<DeleteCoaContractPortPayload>;
  /** Deletes a single `CoaContractPortCost` using its globally unique id. */
  deleteCoaContractPortCost?: Maybe<DeleteCoaContractPortCostPayload>;
  /** Deletes a single `CoaContractPortCost` using a unique key. */
  deleteCoaContractPortCostById?: Maybe<DeleteCoaContractPortCostPayload>;
  /** Deletes a single `CoaContractPortCost` using a unique key. */
  deleteCoaContractPortCostByLocationIdAndShipId?: Maybe<DeleteCoaContractPortCostPayload>;
  /** Deletes a single `CoaContractPortCost` using a unique key. */
  deleteCoaContractPortCostByLocationIdAndVesselTypeId?: Maybe<DeleteCoaContractPortCostPayload>;
  /** Deletes a single `CoaContractPortDatum` using its globally unique id. */
  deleteCoaContractPortDatum?: Maybe<DeleteCoaContractPortDatumPayload>;
  /** Deletes a single `CoaContractPortDatum` using a unique key. */
  deleteCoaContractPortDatumById?: Maybe<DeleteCoaContractPortDatumPayload>;
  /** Deletes a single `CoaContractPrice` using its globally unique id. */
  deleteCoaContractPrice?: Maybe<DeleteCoaContractPricePayload>;
  /** Deletes a single `CoaContractPrice` using a unique key. */
  deleteCoaContractPriceById?: Maybe<DeleteCoaContractPricePayload>;
  /** Deletes a single `CoaContractShip` using its globally unique id. */
  deleteCoaContractShip?: Maybe<DeleteCoaContractShipPayload>;
  /** Deletes a single `CoaContractShip` using a unique key. */
  deleteCoaContractShipByCoaContractIdAndShipId?: Maybe<DeleteCoaContractShipPayload>;
  /** Deletes a single `CoaContractShip` using a unique key. */
  deleteCoaContractShipById?: Maybe<DeleteCoaContractShipPayload>;
  /** Deletes a single `Commission` using its globally unique id. */
  deleteCommission?: Maybe<DeleteCommissionPayload>;
  /** Deletes a single `Commission` using a unique key. */
  deleteCommissionByExternalIdAndVoyageCharterId?: Maybe<DeleteCommissionPayload>;
  /** Deletes a single `Commission` using a unique key. */
  deleteCommissionById?: Maybe<DeleteCommissionPayload>;
  /** Deletes a single `CommitLogScenario` using its globally unique id. */
  deleteCommitLogScenario?: Maybe<DeleteCommitLogScenarioPayload>;
  /** Deletes a single `CommitLogScenario` using a unique key. */
  deleteCommitLogScenarioById?: Maybe<DeleteCommitLogScenarioPayload>;
  /** Deletes a single `CostSplitOnScheduledOrder` using its globally unique id. */
  deleteCostSplitOnScheduledOrder?: Maybe<DeleteCostSplitOnScheduledOrderPayload>;
  /** Deletes a single `CostSplitOnScheduledOrder` using a unique key. */
  deleteCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderId?: Maybe<DeleteCostSplitOnScheduledOrderPayload>;
  /** Deletes a single `CostSplitOnScheduledOrder` using a unique key. */
  deleteCostSplitOnScheduledOrderById?: Maybe<DeleteCostSplitOnScheduledOrderPayload>;
  /** Deletes a single `CostSplitOnSingleEvent` using its globally unique id. */
  deleteCostSplitOnSingleEvent?: Maybe<DeleteCostSplitOnSingleEventPayload>;
  /** Deletes a single `CostSplitOnSingleEvent` using a unique key. */
  deleteCostSplitOnSingleEventByActualCostIdAndSingleEventId?: Maybe<DeleteCostSplitOnSingleEventPayload>;
  /** Deletes a single `CostSplitOnSingleEvent` using a unique key. */
  deleteCostSplitOnSingleEventById?: Maybe<DeleteCostSplitOnSingleEventPayload>;
  /** Deletes a single `Country` using its globally unique id. */
  deleteCountry?: Maybe<DeleteCountryPayload>;
  /** Deletes a single `Country` using a unique key. */
  deleteCountryById?: Maybe<DeleteCountryPayload>;
  /** Deletes a single `Country` using a unique key. */
  deleteCountryByNumeric?: Maybe<DeleteCountryPayload>;
  /** Deletes a single `DbChange` using its globally unique id. */
  deleteDbChange?: Maybe<DeleteDbChangePayload>;
  /** Deletes a single `DbChange` using a unique key. */
  deleteDbChangeById?: Maybe<DeleteDbChangePayload>;
  /** Deletes a single `Demand` using its globally unique id. */
  deleteDemand?: Maybe<DeleteDemandPayload>;
  /** Deletes a single `Demand` using a unique key. */
  deleteDemandById?: Maybe<DeleteDemandPayload>;
  /** Deletes a single `EmailToOrderConfig` using its globally unique id. */
  deleteEmailToOrderConfig?: Maybe<DeleteEmailToOrderConfigPayload>;
  /** Deletes a single `EmailToOrderConfig` using a unique key. */
  deleteEmailToOrderConfigById?: Maybe<DeleteEmailToOrderConfigPayload>;
  /** Deletes a single `EmailToOrderLog` using its globally unique id. */
  deleteEmailToOrderLog?: Maybe<DeleteEmailToOrderLogPayload>;
  /** Deletes a single `EmailToOrderLog` using a unique key. */
  deleteEmailToOrderLogById?: Maybe<DeleteEmailToOrderLogPayload>;
  /** Deletes a single `Feature` using its globally unique id. */
  deleteFeature?: Maybe<DeleteFeaturePayload>;
  /** Deletes a single `Feature` using a unique key. */
  deleteFeatureByFeatureName?: Maybe<DeleteFeaturePayload>;
  /** Deletes a single `File` using its globally unique id. */
  deleteFile?: Maybe<DeleteFilePayload>;
  /** Deletes a single `File` using a unique key. */
  deleteFileById?: Maybe<DeleteFilePayload>;
  /** Deletes a single `GeographicalEntity` using its globally unique id. */
  deleteGeographicalEntity?: Maybe<DeleteGeographicalEntityPayload>;
  /** Deletes a single `GeographicalEntity` using a unique key. */
  deleteGeographicalEntityById?: Maybe<DeleteGeographicalEntityPayload>;
  /** Deletes a single `GeographicalRelation` using its globally unique id. */
  deleteGeographicalRelation?: Maybe<DeleteGeographicalRelationPayload>;
  /** Deletes a single `GeographicalRelation` using a unique key. */
  deleteGeographicalRelationById?: Maybe<DeleteGeographicalRelationPayload>;
  /** Deletes a single `HandledByCoa` using its globally unique id. */
  deleteHandledByCoa?: Maybe<DeleteHandledByCoaPayload>;
  /** Deletes a single `HandledByCoa` using a unique key. */
  deleteHandledByCoaById?: Maybe<DeleteHandledByCoaPayload>;
  /** Deletes a single `HandledByCoa` using a unique key. */
  deleteHandledByCoaByOrderId?: Maybe<DeleteHandledByCoaPayload>;
  /** Deletes a single `HandledBySpot` using its globally unique id. */
  deleteHandledBySpot?: Maybe<DeleteHandledBySpotPayload>;
  /** Deletes a single `HandledBySpot` using a unique key. */
  deleteHandledBySpotById?: Maybe<DeleteHandledBySpotPayload>;
  /** Deletes a single `HandledBySpot` using a unique key. */
  deleteHandledBySpotByOrderId?: Maybe<DeleteHandledBySpotPayload>;
  /** Deletes a single `Holiday` using its globally unique id. */
  deleteHoliday?: Maybe<DeleteHolidayPayload>;
  /** Deletes a single `Holiday` using a unique key. */
  deleteHolidayById?: Maybe<DeleteHolidayPayload>;
  /** Deletes a single `IceClass` using its globally unique id. */
  deleteIceClass?: Maybe<DeleteIceClassPayload>;
  /** Deletes a single `IceClass` using a unique key. */
  deleteIceClassById?: Maybe<DeleteIceClassPayload>;
  /** Deletes a single `Instruction` using its globally unique id. */
  deleteInstruction?: Maybe<DeleteInstructionPayload>;
  /** Deletes a single `Instruction` using a unique key. */
  deleteInstructionById?: Maybe<DeleteInstructionPayload>;
  /** Deletes a single `IntegrationLog` using its globally unique id. */
  deleteIntegrationLog?: Maybe<DeleteIntegrationLogPayload>;
  /** Deletes a single `IntegrationLog` using a unique key. */
  deleteIntegrationLogById?: Maybe<DeleteIntegrationLogPayload>;
  /** Deletes a single `Invoice` using its globally unique id. */
  deleteInvoice?: Maybe<DeleteInvoicePayload>;
  /** Deletes a single `Invoice` using a unique key. */
  deleteInvoiceById?: Maybe<DeleteInvoicePayload>;
  /** Deletes a single `InvoiceItem` using its globally unique id. */
  deleteInvoiceItem?: Maybe<DeleteInvoiceItemPayload>;
  /** Deletes a single `InvoiceItem` using a unique key. */
  deleteInvoiceItemById?: Maybe<DeleteInvoiceItemPayload>;
  /** Deletes a single `InvoiceItemOrder` using its globally unique id. */
  deleteInvoiceItemOrder?: Maybe<DeleteInvoiceItemOrderPayload>;
  /** Deletes a single `InvoiceItemOrder` using a unique key. */
  deleteInvoiceItemOrderById?: Maybe<DeleteInvoiceItemOrderPayload>;
  /** Deletes a single `LaytimeResponsibility` using its globally unique id. */
  deleteLaytimeResponsibility?: Maybe<DeleteLaytimeResponsibilityPayload>;
  /** Deletes a single `LaytimeResponsibility` using a unique key. */
  deleteLaytimeResponsibilityById?: Maybe<DeleteLaytimeResponsibilityPayload>;
  /** Deletes a single `Location` using its globally unique id. */
  deleteLocation?: Maybe<DeleteLocationPayload>;
  /** Deletes a single `Location` using a unique key. */
  deleteLocationById?: Maybe<DeleteLocationPayload>;
  /** Deletes a single `LocationCluster` using its globally unique id. */
  deleteLocationCluster?: Maybe<DeleteLocationClusterPayload>;
  /** Deletes a single `LocationCluster` using a unique key. */
  deleteLocationClusterById?: Maybe<DeleteLocationClusterPayload>;
  /** Deletes a single `LocationRequirementAssociation` using its globally unique id. */
  deleteLocationRequirementAssociation?: Maybe<DeleteLocationRequirementAssociationPayload>;
  /** Deletes a single `LocationRequirementAssociation` using a unique key. */
  deleteLocationRequirementAssociationById?: Maybe<DeleteLocationRequirementAssociationPayload>;
  /** Deletes a single `LocationRequirementAssociation` using a unique key. */
  deleteLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneId?: Maybe<DeleteLocationRequirementAssociationPayload>;
  /** Deletes a single `LocationWorkingHour` using its globally unique id. */
  deleteLocationWorkingHour?: Maybe<DeleteLocationWorkingHourPayload>;
  /** Deletes a single `LocationWorkingHour` using a unique key. */
  deleteLocationWorkingHourById?: Maybe<DeleteLocationWorkingHourPayload>;
  /** Deletes a single `LostContract` using its globally unique id. */
  deleteLostContract?: Maybe<DeleteLostContractPayload>;
  /** Deletes a single `LostContract` using a unique key. */
  deleteLostContractById?: Maybe<DeleteLostContractPayload>;
  /** Deletes a single `Migration` using its globally unique id. */
  deleteMigration?: Maybe<DeleteMigrationPayload>;
  /** Deletes a single `Migration` using a unique key. */
  deleteMigrationById?: Maybe<DeleteMigrationPayload>;
  /** Deletes a single `NoGoZone` using its globally unique id. */
  deleteNoGoZone?: Maybe<DeleteNoGoZonePayload>;
  /** Deletes a single `NoGoZone` using a unique key. */
  deleteNoGoZoneById?: Maybe<DeleteNoGoZonePayload>;
  /** Deletes a single `NotificationReceiver` using a unique key. */
  deleteNotificationReceiverById?: Maybe<DeleteNotificationReceiverPayload>;
  /** Deletes a single `OffHire` using its globally unique id. */
  deleteOffHire?: Maybe<DeleteOffHirePayload>;
  /** Deletes a single `OffHire` using a unique key. */
  deleteOffHireById?: Maybe<DeleteOffHirePayload>;
  /** Deletes a single `OpenPosition` using its globally unique id. */
  deleteOpenPosition?: Maybe<DeleteOpenPositionPayload>;
  /** Deletes a single `OpenPosition` using a unique key. */
  deleteOpenPositionById?: Maybe<DeleteOpenPositionPayload>;
  /** Deletes a single `Order` using its globally unique id. */
  deleteOrder?: Maybe<DeleteOrderPayload>;
  /** Deletes a single `OrderAttribute` using its globally unique id. */
  deleteOrderAttribute?: Maybe<DeleteOrderAttributePayload>;
  /** Deletes a single `OrderAttributeAssociation` using its globally unique id. */
  deleteOrderAttributeAssociation?: Maybe<DeleteOrderAttributeAssociationPayload>;
  /** Deletes a single `OrderAttributeAssociation` using a unique key. */
  deleteOrderAttributeAssociationById?: Maybe<DeleteOrderAttributeAssociationPayload>;
  /** Deletes a single `OrderAttribute` using a unique key. */
  deleteOrderAttributeById?: Maybe<DeleteOrderAttributePayload>;
  /** Deletes a single `Order` using a unique key. */
  deleteOrderById?: Maybe<DeleteOrderPayload>;
  /** Deletes a single `OrderDetail` using its globally unique id. */
  deleteOrderDetail?: Maybe<DeleteOrderDetailPayload>;
  /** Deletes a single `OrderDetail` using a unique key. */
  deleteOrderDetailById?: Maybe<DeleteOrderDetailPayload>;
  /** Deletes a single `OrderPortCallRelation` using its globally unique id. */
  deleteOrderPortCallRelation?: Maybe<DeleteOrderPortCallRelationPayload>;
  /** Deletes a single `OrderPortCallRelation` using a unique key. */
  deleteOrderPortCallRelationById?: Maybe<DeleteOrderPortCallRelationPayload>;
  /** Deletes a single `OrderPortCallRelation` using a unique key. */
  deleteOrderPortCallRelationByOrderIdAndIsLoadPort?: Maybe<DeleteOrderPortCallRelationPayload>;
  /** Deletes a single `OrderPortOverride` using its globally unique id. */
  deleteOrderPortOverride?: Maybe<DeleteOrderPortOverridePayload>;
  /** Deletes a single `OrderPortOverride` using a unique key. */
  deleteOrderPortOverrideByOrderId?: Maybe<DeleteOrderPortOverridePayload>;
  /** Deletes a single `OrderRequirementAssociation` using its globally unique id. */
  deleteOrderRequirementAssociation?: Maybe<DeleteOrderRequirementAssociationPayload>;
  /** Deletes a single `OrderRequirementAssociation` using a unique key. */
  deleteOrderRequirementAssociationById?: Maybe<DeleteOrderRequirementAssociationPayload>;
  /** Deletes a single `OrderRequirementAssociation` using a unique key. */
  deleteOrderRequirementAssociationBySpecialRequirementIdAndOrderId?: Maybe<DeleteOrderRequirementAssociationPayload>;
  /** Deletes a single `OrderVoyageCharterRelation` using its globally unique id. */
  deleteOrderVoyageCharterRelation?: Maybe<DeleteOrderVoyageCharterRelationPayload>;
  /** Deletes a single `OrderVoyageCharterRelation` using a unique key. */
  deleteOrderVoyageCharterRelationById?: Maybe<DeleteOrderVoyageCharterRelationPayload>;
  /** Deletes a single `OrderVoyageCharterRelation` using a unique key. */
  deleteOrderVoyageCharterRelationByOrderIdAndOutgoing?: Maybe<DeleteOrderVoyageCharterRelationPayload>;
  /** Deletes a single `Organization` using its globally unique id. */
  deleteOrganization?: Maybe<DeleteOrganizationPayload>;
  /** Deletes a single `OrganizationAreaBunkerGradeMapping` using its globally unique id. */
  deleteOrganizationAreaBunkerGradeMapping?: Maybe<DeleteOrganizationAreaBunkerGradeMappingPayload>;
  /** Deletes a single `OrganizationAreaBunkerGradeMapping` using a unique key. */
  deleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea?: Maybe<DeleteOrganizationAreaBunkerGradeMappingPayload>;
  /** Deletes a single `Organization` using a unique key. */
  deleteOrganizationById?: Maybe<DeleteOrganizationPayload>;
  /** Deletes a single `OrganizationFeature` using its globally unique id. */
  deleteOrganizationFeature?: Maybe<DeleteOrganizationFeaturePayload>;
  /** Deletes a single `OrganizationFeature` using a unique key. */
  deleteOrganizationFeatureById?: Maybe<DeleteOrganizationFeaturePayload>;
  /** Deletes a single `PortActivity` using its globally unique id. */
  deletePortActivity?: Maybe<DeletePortActivityPayload>;
  /** Deletes a single `PortActivity` using a unique key. */
  deletePortActivityById?: Maybe<DeletePortActivityPayload>;
  /** Deletes a single `PortCall` using its globally unique id. */
  deletePortCall?: Maybe<DeletePortCallPayload>;
  /** Deletes a single `PortCall` using a unique key. */
  deletePortCallById?: Maybe<DeletePortCallPayload>;
  /** Deletes a single `PortCallExternalTimestamp` using its globally unique id. */
  deletePortCallExternalTimestamp?: Maybe<DeletePortCallExternalTimestampPayload>;
  /** Deletes a single `PortCallExternalTimestamp` using a unique key. */
  deletePortCallExternalTimestampById?: Maybe<DeletePortCallExternalTimestampPayload>;
  /** Deletes a single `PortCallFile` using its globally unique id. */
  deletePortCallFile?: Maybe<DeletePortCallFilePayload>;
  /** Deletes a single `PortCallFile` using a unique key. */
  deletePortCallFileByFileId?: Maybe<DeletePortCallFilePayload>;
  /** Deletes a single `PortCallFile` using a unique key. */
  deletePortCallFileById?: Maybe<DeletePortCallFilePayload>;
  /** Deletes a single `PortCommodityLdRate` using its globally unique id. */
  deletePortCommodityLdRate?: Maybe<DeletePortCommodityLdRatePayload>;
  /** Deletes a single `PortCommodityLdRate` using a unique key. */
  deletePortCommodityLdRateById?: Maybe<DeletePortCommodityLdRatePayload>;
  /** Deletes a single `PortCost` using its globally unique id. */
  deletePortCost?: Maybe<DeletePortCostPayload>;
  /** Deletes a single `PortCost` using a unique key. */
  deletePortCostById?: Maybe<DeletePortCostPayload>;
  /** Deletes a single `PortCostDefault` using its globally unique id. */
  deletePortCostDefault?: Maybe<DeletePortCostDefaultPayload>;
  /** Deletes a single `PortCostDefault` using a unique key. */
  deletePortCostDefaultById?: Maybe<DeletePortCostDefaultPayload>;
  /** Deletes a single `PortCostDefault` using a unique key. */
  deletePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrency?: Maybe<DeletePortCostDefaultPayload>;
  /** Deletes a single `PortCostEstimatesExternal` using its globally unique id. */
  deletePortCostEstimatesExternal?: Maybe<DeletePortCostEstimatesExternalPayload>;
  /** Deletes a single `PortCostEstimatesExternal` using a unique key. */
  deletePortCostEstimatesExternalById?: Maybe<DeletePortCostEstimatesExternalPayload>;
  /** Deletes a single `PortDatum` using its globally unique id. */
  deletePortDatum?: Maybe<DeletePortDatumPayload>;
  /** Deletes a single `PortDatum` using a unique key. */
  deletePortDatumById?: Maybe<DeletePortDatumPayload>;
  /** Deletes a single `PortNotice` using its globally unique id. */
  deletePortNotice?: Maybe<DeletePortNoticePayload>;
  /** Deletes a single `PortNotice` using a unique key. */
  deletePortNoticeById?: Maybe<DeletePortNoticePayload>;
  /** Deletes a single `PortRegion` using its globally unique id. */
  deletePortRegion?: Maybe<DeletePortRegionPayload>;
  /** Deletes a single `PortRegion` using a unique key. */
  deletePortRegionById?: Maybe<DeletePortRegionPayload>;
  /** Deletes a single `PortRegion` using a unique key. */
  deletePortRegionByLocationIdAndRegionIdAndOrganizationId?: Maybe<DeletePortRegionPayload>;
  /** Deletes a single `Prompt` using its globally unique id. */
  deletePrompt?: Maybe<DeletePromptPayload>;
  /** Deletes a single `Prompt` using a unique key. */
  deletePromptById?: Maybe<DeletePromptPayload>;
  /** Deletes a single `Quay` using its globally unique id. */
  deleteQuay?: Maybe<DeleteQuayPayload>;
  /** Deletes a single `Quay` using a unique key. */
  deleteQuayById?: Maybe<DeleteQuayPayload>;
  /** Deletes a single `ReceiverOrganization` using its globally unique id. */
  deleteReceiverOrganization?: Maybe<DeleteReceiverOrganizationPayload>;
  /** Deletes a single `ReceiverOrganization` using a unique key. */
  deleteReceiverOrganizationByAdminOrganizationIdAndOrganizationId?: Maybe<DeleteReceiverOrganizationPayload>;
  /** Deletes a single `ReceiverOrganization` using a unique key. */
  deleteReceiverOrganizationById?: Maybe<DeleteReceiverOrganizationPayload>;
  /** Deletes a single `Region` using its globally unique id. */
  deleteRegion?: Maybe<DeleteRegionPayload>;
  /** Deletes a single `Region` using a unique key. */
  deleteRegionById?: Maybe<DeleteRegionPayload>;
  /** Deletes a single `RequestLog` using its globally unique id. */
  deleteRequestLog?: Maybe<DeleteRequestLogPayload>;
  /** Deletes a single `RequestLog` using a unique key. */
  deleteRequestLogById?: Maybe<DeleteRequestLogPayload>;
  /** Deletes a single `Route` using its globally unique id. */
  deleteRoute?: Maybe<DeleteRoutePayload>;
  /** Deletes a single `Route` using a unique key. */
  deleteRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZones?: Maybe<DeleteRoutePayload>;
  /** Deletes a single `Route` using a unique key. */
  deleteRouteById?: Maybe<DeleteRoutePayload>;
  /** Deletes a single `RouteOverride` using its globally unique id. */
  deleteRouteOverride?: Maybe<DeleteRouteOverridePayload>;
  /** Deletes a single `RouteOverride` using a unique key. */
  deleteRouteOverrideById?: Maybe<DeleteRouteOverridePayload>;
  /** Deletes a single `RouteOverride` using a unique key. */
  deleteRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannels?: Maybe<DeleteRouteOverridePayload>;
  /** Deletes a single `RoutePoint` using its globally unique id. */
  deleteRoutePoint?: Maybe<DeleteRoutePointPayload>;
  /** Deletes a single `RoutePoint` using a unique key. */
  deleteRoutePointById?: Maybe<DeleteRoutePointPayload>;
  /** Deletes a single `RoutePointUsage` using its globally unique id. */
  deleteRoutePointUsage?: Maybe<DeleteRoutePointUsagePayload>;
  /** Deletes a single `RoutePointUsage` using a unique key. */
  deleteRoutePointUsageById?: Maybe<DeleteRoutePointUsagePayload>;
  /** Deletes a single `Scenario` using its globally unique id. */
  deleteScenario?: Maybe<DeleteScenarioPayload>;
  /** Deletes a single `Scenario` using a unique key. */
  deleteScenarioById?: Maybe<DeleteScenarioPayload>;
  /** Deletes a single `ScheduledOrder` using its globally unique id. */
  deleteScheduledOrder?: Maybe<DeleteScheduledOrderPayload>;
  /** Deletes a single `ScheduledOrder` using a unique key. */
  deleteScheduledOrderById?: Maybe<DeleteScheduledOrderPayload>;
  /** Deletes a single `SeenMessage` using its globally unique id. */
  deleteSeenMessage?: Maybe<DeleteSeenMessagePayload>;
  /** Deletes a single `SeenMessage` using a unique key. */
  deleteSeenMessageById?: Maybe<DeleteSeenMessagePayload>;
  /** Deletes a single `SenderOrganization` using its globally unique id. */
  deleteSenderOrganization?: Maybe<DeleteSenderOrganizationPayload>;
  /** Deletes a single `SenderOrganization` using a unique key. */
  deleteSenderOrganizationByAdminOrganizationIdAndOrganizationId?: Maybe<DeleteSenderOrganizationPayload>;
  /** Deletes a single `SenderOrganization` using a unique key. */
  deleteSenderOrganizationById?: Maybe<DeleteSenderOrganizationPayload>;
  /** Deletes a single `Ship` using its globally unique id. */
  deleteShip?: Maybe<DeleteShipPayload>;
  /** Deletes a single `Ship` using a unique key. */
  deleteShipById?: Maybe<DeleteShipPayload>;
  /** Deletes a single `ShipVoyageNamingRuleRelation` using its globally unique id. */
  deleteShipVoyageNamingRuleRelation?: Maybe<DeleteShipVoyageNamingRuleRelationPayload>;
  /** Deletes a single `ShipVoyageNamingRuleRelation` using a unique key. */
  deleteShipVoyageNamingRuleRelationById?: Maybe<DeleteShipVoyageNamingRuleRelationPayload>;
  /** Deletes a single `Shipment` using its globally unique id. */
  deleteShipment?: Maybe<DeleteShipmentPayload>;
  /** Deletes a single `Shipment` using a unique key. */
  deleteShipmentById?: Maybe<DeleteShipmentPayload>;
  /** Deletes a single `ShipmentExternalStatus` using its globally unique id. */
  deleteShipmentExternalStatus?: Maybe<DeleteShipmentExternalStatusPayload>;
  /** Deletes a single `ShipmentExternalStatus` using a unique key. */
  deleteShipmentExternalStatusById?: Maybe<DeleteShipmentExternalStatusPayload>;
  /** Deletes a single `ShipmentExtraFreight` using its globally unique id. */
  deleteShipmentExtraFreight?: Maybe<DeleteShipmentExtraFreightPayload>;
  /** Deletes a single `ShipmentExtraFreight` using a unique key. */
  deleteShipmentExtraFreightById?: Maybe<DeleteShipmentExtraFreightPayload>;
  /** Deletes a single `ShipmentFreight` using its globally unique id. */
  deleteShipmentFreight?: Maybe<DeleteShipmentFreightPayload>;
  /** Deletes a single `ShipmentFreight` using a unique key. */
  deleteShipmentFreightById?: Maybe<DeleteShipmentFreightPayload>;
  /** Deletes a single `ShipmentFreight` using a unique key. */
  deleteShipmentFreightByShipmentId?: Maybe<DeleteShipmentFreightPayload>;
  /** Deletes a single `ShipmentGroup` using its globally unique id. */
  deleteShipmentGroup?: Maybe<DeleteShipmentGroupPayload>;
  /** Deletes a single `ShipmentGroupAssociation` using its globally unique id. */
  deleteShipmentGroupAssociation?: Maybe<DeleteShipmentGroupAssociationPayload>;
  /** Deletes a single `ShipmentGroupAssociation` using a unique key. */
  deleteShipmentGroupAssociationById?: Maybe<DeleteShipmentGroupAssociationPayload>;
  /** Deletes a single `ShipmentGroup` using a unique key. */
  deleteShipmentGroupById?: Maybe<DeleteShipmentGroupPayload>;
  deleteShipnetConfig?: Maybe<ShipnetConfigPayload>;
  /** Deletes a single `SingleEvent` using its globally unique id. */
  deleteSingleEvent?: Maybe<DeleteSingleEventPayload>;
  /** Deletes a single `SingleEvent` using a unique key. */
  deleteSingleEventById?: Maybe<DeleteSingleEventPayload>;
  /** Deletes a single `SingleEventPortCallRelation` using its globally unique id. */
  deleteSingleEventPortCallRelation?: Maybe<DeleteSingleEventPortCallRelationPayload>;
  /** Deletes a single `SingleEventPortCallRelation` using a unique key. */
  deleteSingleEventPortCallRelationById?: Maybe<DeleteSingleEventPortCallRelationPayload>;
  /** Deletes a single `SpecialRequirement` using its globally unique id. */
  deleteSpecialRequirement?: Maybe<DeleteSpecialRequirementPayload>;
  /** Deletes a single `SpecialRequirement` using a unique key. */
  deleteSpecialRequirementById?: Maybe<DeleteSpecialRequirementPayload>;
  /** Deletes a single `SplitOrder` using its globally unique id. */
  deleteSplitOrder?: Maybe<DeleteSplitOrderPayload>;
  /** Deletes a single `SplitOrder` using a unique key. */
  deleteSplitOrderById?: Maybe<DeleteSplitOrderPayload>;
  /** Deletes a single `SpotNegotiation` using its globally unique id. */
  deleteSpotNegotiation?: Maybe<DeleteSpotNegotiationPayload>;
  /** Deletes a single `SpotNegotiation` using a unique key. */
  deleteSpotNegotiationById?: Maybe<DeleteSpotNegotiationPayload>;
  /** Deletes a single `StatementOfFact` using its globally unique id. */
  deleteStatementOfFact?: Maybe<DeleteStatementOfFactPayload>;
  /** Deletes a single `StatementOfFact` using a unique key. */
  deleteStatementOfFactById?: Maybe<DeleteStatementOfFactPayload>;
  /** Deletes a single `Supply` using its globally unique id. */
  deleteSupply?: Maybe<DeleteSupplyPayload>;
  /** Deletes a single `Supply` using a unique key. */
  deleteSupplyById?: Maybe<DeleteSupplyPayload>;
  /** Deletes a single `SupplyContract` using its globally unique id. */
  deleteSupplyContract?: Maybe<DeleteSupplyContractPayload>;
  /** Deletes a single `SupplyContract` using a unique key. */
  deleteSupplyContractById?: Maybe<DeleteSupplyContractPayload>;
  /** Deletes a single `TankDistance` using its globally unique id. */
  deleteTankDistance?: Maybe<DeleteTankDistancePayload>;
  /** Deletes a single `TankDistance` using a unique key. */
  deleteTankDistanceById?: Maybe<DeleteTankDistancePayload>;
  /** Deletes a single `TcContract` using its globally unique id. */
  deleteTcContract?: Maybe<DeleteTcContractPayload>;
  /** Deletes a single `TcContract` using a unique key. */
  deleteTcContractById?: Maybe<DeleteTcContractPayload>;
  /** Deletes a single `TcContract` using a unique key. */
  deleteTcContractByRootOrgAndExternalId?: Maybe<DeleteTcContractPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserById?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserRegion` using its globally unique id. */
  deleteUserRegion?: Maybe<DeleteUserRegionPayload>;
  /** Deletes a single `UserRegion` using a unique key. */
  deleteUserRegionById?: Maybe<DeleteUserRegionPayload>;
  /** Deletes a single `UserRight` using its globally unique id. */
  deleteUserRight?: Maybe<DeleteUserRightPayload>;
  /** Deletes a single `UserRight` using a unique key. */
  deleteUserRightById?: Maybe<DeleteUserRightPayload>;
  /** Deletes a single `UserRight` using a unique key. */
  deleteUserRightByUserIdAndOrganizationId?: Maybe<DeleteUserRightPayload>;
  /** Deletes a single `UserSetting` using its globally unique id. */
  deleteUserSetting?: Maybe<DeleteUserSettingPayload>;
  /** Deletes a single `UserSetting` using a unique key. */
  deleteUserSettingById?: Maybe<DeleteUserSettingPayload>;
  /** Deletes a single `UserShip` using its globally unique id. */
  deleteUserShip?: Maybe<DeleteUserShipPayload>;
  /** Deletes a single `UserShip` using a unique key. */
  deleteUserShipById?: Maybe<DeleteUserShipPayload>;
  deleteVesonConfig?: Maybe<VesonConfigPayload>;
  /** Deletes a single `VesselAttribute` using its globally unique id. */
  deleteVesselAttribute?: Maybe<DeleteVesselAttributePayload>;
  /** Deletes a single `VesselAttributeAssortmentExclusion` using its globally unique id. */
  deleteVesselAttributeAssortmentExclusion?: Maybe<DeleteVesselAttributeAssortmentExclusionPayload>;
  /** Deletes a single `VesselAttributeAssortmentExclusion` using a unique key. */
  deleteVesselAttributeAssortmentExclusionById?: Maybe<DeleteVesselAttributeAssortmentExclusionPayload>;
  /** Deletes a single `VesselAttribute` using a unique key. */
  deleteVesselAttributeById?: Maybe<DeleteVesselAttributePayload>;
  /** Deletes a single `VesselAttribute` using a unique key. */
  deleteVesselAttributeByOrganizationIdAndName?: Maybe<DeleteVesselAttributePayload>;
  /** Deletes a single `VesselAttributesAssociation` using its globally unique id. */
  deleteVesselAttributesAssociation?: Maybe<DeleteVesselAttributesAssociationPayload>;
  /** Deletes a single `VesselAttributesAssociation` using a unique key. */
  deleteVesselAttributesAssociationById?: Maybe<DeleteVesselAttributesAssociationPayload>;
  /** Deletes a single `VesselDraftDatapoint` using its globally unique id. */
  deleteVesselDraftDatapoint?: Maybe<DeleteVesselDraftDatapointPayload>;
  /** Deletes a single `VesselDraftDatapoint` using a unique key. */
  deleteVesselDraftDatapointById?: Maybe<DeleteVesselDraftDatapointPayload>;
  /** Deletes a single `VesselFulfillsRequirementAssociation` using its globally unique id. */
  deleteVesselFulfillsRequirementAssociation?: Maybe<DeleteVesselFulfillsRequirementAssociationPayload>;
  /** Deletes a single `VesselFulfillsRequirementAssociation` using a unique key. */
  deleteVesselFulfillsRequirementAssociationById?: Maybe<DeleteVesselFulfillsRequirementAssociationPayload>;
  /** Deletes a single `VesselInfo` using its globally unique id. */
  deleteVesselInfo?: Maybe<DeleteVesselInfoPayload>;
  /** Deletes a single `VesselInfo` using a unique key. */
  deleteVesselInfoById?: Maybe<DeleteVesselInfoPayload>;
  /** Deletes a single `VesselInfo` using a unique key. */
  deleteVesselInfoByImo?: Maybe<DeleteVesselInfoPayload>;
  /** Deletes a single `VesselPerformanceModel` using its globally unique id. */
  deleteVesselPerformanceModel?: Maybe<DeleteVesselPerformanceModelPayload>;
  /** Deletes a single `VesselPerformanceModel` using a unique key. */
  deleteVesselPerformanceModelById?: Maybe<DeleteVesselPerformanceModelPayload>;
  /** Deletes a single `VesselPerformanceModel` using a unique key. */
  deleteVesselPerformanceModelByRootOrgAndShipId?: Maybe<DeleteVesselPerformanceModelPayload>;
  /** Deletes a single `VesselReservation` using its globally unique id. */
  deleteVesselReservation?: Maybe<DeleteVesselReservationPayload>;
  /** Deletes a single `VesselReservation` using a unique key. */
  deleteVesselReservationById?: Maybe<DeleteVesselReservationPayload>;
  /** Deletes a single `VesselScheduleSharedToOrganization` using its globally unique id. */
  deleteVesselScheduleSharedToOrganization?: Maybe<DeleteVesselScheduleSharedToOrganizationPayload>;
  /** Deletes a single `VesselScheduleSharedToOrganization` using a unique key. */
  deleteVesselScheduleSharedToOrganizationById?: Maybe<DeleteVesselScheduleSharedToOrganizationPayload>;
  /** Deletes a single `VesselScheduleSharedToOrganization` using a unique key. */
  deleteVesselScheduleSharedToOrganizationByVesselIdAndOrganizationId?: Maybe<DeleteVesselScheduleSharedToOrganizationPayload>;
  /** Deletes a single `VesselSecret` using its globally unique id. */
  deleteVesselSecret?: Maybe<DeleteVesselSecretPayload>;
  /** Deletes a single `VesselSecret` using a unique key. */
  deleteVesselSecretById?: Maybe<DeleteVesselSecretPayload>;
  /** Deletes a single `VesselSpeedConsumption` using its globally unique id. */
  deleteVesselSpeedConsumption?: Maybe<DeleteVesselSpeedConsumptionPayload>;
  /** Deletes a single `VesselSpeedConsumption` using a unique key. */
  deleteVesselSpeedConsumptionById?: Maybe<DeleteVesselSpeedConsumptionPayload>;
  /** Deletes a single `Voyage` using its globally unique id. */
  deleteVoyage?: Maybe<DeleteVoyagePayload>;
  /** Deletes a single `VoyageAssociation` using its globally unique id. */
  deleteVoyageAssociation?: Maybe<DeleteVoyageAssociationPayload>;
  /** Deletes a single `VoyageAssociation` using a unique key. */
  deleteVoyageAssociationById?: Maybe<DeleteVoyageAssociationPayload>;
  /** Deletes a single `VoyageAttribute` using its globally unique id. */
  deleteVoyageAttribute?: Maybe<DeleteVoyageAttributePayload>;
  /** Deletes a single `VoyageAttribute` using a unique key. */
  deleteVoyageAttributeById?: Maybe<DeleteVoyageAttributePayload>;
  /** Deletes a single `VoyageAttribute` using a unique key. */
  deleteVoyageAttributeByOrganizationIdAndNameAndColor?: Maybe<DeleteVoyageAttributePayload>;
  /** Deletes a single `Voyage` using a unique key. */
  deleteVoyageById?: Maybe<DeleteVoyagePayload>;
  /** Deletes a single `VoyageCharter` using its globally unique id. */
  deleteVoyageCharter?: Maybe<DeleteVoyageCharterPayload>;
  /** Deletes a single `VoyageCharter` using a unique key. */
  deleteVoyageCharterById?: Maybe<DeleteVoyageCharterPayload>;
  /** Deletes a single `VoyageCharter` using a unique key. */
  deleteVoyageCharterByRootOrgAndExternalId?: Maybe<DeleteVoyageCharterPayload>;
  /** Deletes a single `VoyageCharter` using a unique key. */
  deleteVoyageCharterByRootOrgAndName?: Maybe<DeleteVoyageCharterPayload>;
  /** Deletes a single `VoyageCharterExtraCost` using its globally unique id. */
  deleteVoyageCharterExtraCost?: Maybe<DeleteVoyageCharterExtraCostPayload>;
  /** Deletes a single `VoyageCharterExtraCost` using a unique key. */
  deleteVoyageCharterExtraCostById?: Maybe<DeleteVoyageCharterExtraCostPayload>;
  /** Deletes a single `VoyageCharterExtraFreight` using its globally unique id. */
  deleteVoyageCharterExtraFreight?: Maybe<DeleteVoyageCharterExtraFreightPayload>;
  /** Deletes a single `VoyageCharterExtraFreight` using a unique key. */
  deleteVoyageCharterExtraFreightById?: Maybe<DeleteVoyageCharterExtraFreightPayload>;
  /** Deletes a single `VoyageCharterOrderFreight` using its globally unique id. */
  deleteVoyageCharterOrderFreight?: Maybe<DeleteVoyageCharterOrderFreightPayload>;
  /** Deletes a single `VoyageCharterOrderFreight` using a unique key. */
  deleteVoyageCharterOrderFreightById?: Maybe<DeleteVoyageCharterOrderFreightPayload>;
  /** Deletes a single `VoyageCharterPortCost` using its globally unique id. */
  deleteVoyageCharterPortCost?: Maybe<DeleteVoyageCharterPortCostPayload>;
  /** Deletes a single `VoyageCharterPortCost` using a unique key. */
  deleteVoyageCharterPortCostById?: Maybe<DeleteVoyageCharterPortCostPayload>;
  /** Deletes a single `VoyageCharterPortDatum` using its globally unique id. */
  deleteVoyageCharterPortDatum?: Maybe<DeleteVoyageCharterPortDatumPayload>;
  /** Deletes a single `VoyageCharterPortDatum` using a unique key. */
  deleteVoyageCharterPortDatumById?: Maybe<DeleteVoyageCharterPortDatumPayload>;
  /** Deletes a single `VoyageCharterToContract` using its globally unique id. */
  deleteVoyageCharterToContract?: Maybe<DeleteVoyageCharterToContractPayload>;
  /** Deletes a single `VoyageCharterToContract` using a unique key. */
  deleteVoyageCharterToContractById?: Maybe<DeleteVoyageCharterToContractPayload>;
  /** Deletes a single `VoyageCharterUpdate` using its globally unique id. */
  deleteVoyageCharterUpdate?: Maybe<DeleteVoyageCharterUpdatePayload>;
  /** Deletes a single `VoyageCharterUpdate` using a unique key. */
  deleteVoyageCharterUpdateById?: Maybe<DeleteVoyageCharterUpdatePayload>;
  /** Deletes a single `VoyageNamingRule` using its globally unique id. */
  deleteVoyageNamingRule?: Maybe<DeleteVoyageNamingRulePayload>;
  /** Deletes a single `VoyageNamingRule` using a unique key. */
  deleteVoyageNamingRuleById?: Maybe<DeleteVoyageNamingRulePayload>;
  /** Deletes a single `WorldscaleFreight` using its globally unique id. */
  deleteWorldscaleFreight?: Maybe<DeleteWorldscaleFreightPayload>;
  /** Deletes a single `WorldscaleFreight` using a unique key. */
  deleteWorldscaleFreightById?: Maybe<DeleteWorldscaleFreightPayload>;
  /** Deletes a single `WorldscaleFreight` using a unique key. */
  deleteWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYear?: Maybe<DeleteWorldscaleFreightPayload>;
  /** Deletes a single `Zone` using its globally unique id. */
  deleteZone?: Maybe<DeleteZonePayload>;
  /** Deletes a single `Zone` using a unique key. */
  deleteZoneById?: Maybe<DeleteZonePayload>;
  /** Deletes a single `ZoneLocation` using its globally unique id. */
  deleteZoneLocation?: Maybe<DeleteZoneLocationPayload>;
  /** Deletes a single `ZoneLocation` using a unique key. */
  deleteZoneLocationById?: Maybe<DeleteZoneLocationPayload>;
  /** Deletes a single `ZoneLocation` using a unique key. */
  deleteZoneLocationByZoneIdAndLocationId?: Maybe<DeleteZoneLocationPayload>;
  findOrCreateLocationCluster?: Maybe<FindOrCreateLocationClusterPayload>;
  formatTimestampWithOffset?: Maybe<FormatTimestampWithOffsetPayload>;
  generateInitialsForAllUsers?: Maybe<GenerateInitialsForAllUsersPayload>;
  genericOrderImport?: Maybe<ImportOrderResultData>;
  getMarcuraPortCosts?: Maybe<Array<Maybe<MarcuraPortCost>>>;
  googleAuthenticate?: Maybe<GoogleAuthenticatePayload>;
  /** Sets inactive status to true for all ships with IDs contained in the input array. */
  inactivateShips?: Maybe<InactivateShipsPayload>;
  logout?: Maybe<LogoutPayload>;
  /** Maps assortment synonyms to the actual assortment name. If name already matches a assortment, returns the name as is. */
  mapAssortmentSynonymToName?: Maybe<MapAssortmentSynonymToNamePayload>;
  /** Maps location synonyms to the actual location name. If name already matches a location, returns the name as is. */
  mapLocationSynonymToName?: Maybe<MapLocationSynonymToNamePayload>;
  marcuraWarmCache: MarcuraWarmCacheResult;
  microsoftAuthenticate?: Maybe<MicrosoftAuthenticatePayload>;
  optimizeSchedule?: Maybe<Scalars['JSON']['output']>;
  parseImportedOrders?: Maybe<LlmParserResult>;
  parseOrders?: Maybe<LlmParserResult>;
  portAgentsListFromSessOrg?: Maybe<PortAgentsListFromSessOrgPayload>;
  portCostDefaultsImport?: Maybe<PortCostDefaultsImportResult>;
  portCostEstimatesExternalImport?: Maybe<PortCostExternalImportResult>;
  publishOrders?: Maybe<PublishOrdersPayload>;
  q88OrderSync?: Maybe<Q88OrderSyncResult>;
  q88PortSync?: Maybe<Q88PortSyncResult>;
  q88UpdateCache?: Maybe<Q88UpdateCache>;
  q88UpdateData?: Maybe<Q88UpdateData>;
  q88VesselSync?: Maybe<Q88VesselSyncResult>;
  refreshShipnetOrders?: Maybe<RefreshShipnetOrdersResult>;
  /** Removes a specified notice from the invalid_dates array in the input JSONB object */
  removeInvalidDateNotice?: Maybe<RemoveInvalidDateNoticePayload>;
  requestResetPassword?: Maybe<RequestResetPasswordPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  restoreOrderVoyageCharterRelation?: Maybe<RestoreOrderVoyageCharterRelationPayload>;
  sendersReceiversListFromSessOrg?: Maybe<SendersReceiversListFromSessOrgPayload>;
  /** Set user activated status */
  setUserActivated?: Maybe<SetUserActivatedPayload>;
  setupShipnetCoa?: Maybe<SetupShipnetCoasResult>;
  sharedListFromSessOrg?: Maybe<SharedListFromSessOrgPayload>;
  softDeleteOrders?: Maybe<SoftDeleteOrdersPayload>;
  speechToText?: Maybe<SpeechToTextResult>;
  syncBookingList?: Maybe<SyncBookingListResult>;
  /** Starts sync of IMOS COAs */
  syncImosCoas: SyncImosCoasResult;
  syncPreemOrders?: Maybe<SyncOrdersResult>;
  syncShipnetOrders?: Maybe<SyncShipnetOrdersResult>;
  syncTcContractByExternalId?: Maybe<TcContractSyncResult>;
  unarchiveByIds?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a single `ActualCost` using its globally unique id and a patch. */
  updateActualCost?: Maybe<UpdateActualCostPayload>;
  /** Updates a single `ActualCost` using a unique key and a patch. */
  updateActualCostById?: Maybe<UpdateActualCostPayload>;
  /** Updates a single `ApiOrdersNotice` using its globally unique id and a patch. */
  updateApiOrdersNotice?: Maybe<UpdateApiOrdersNoticePayload>;
  /** Updates a single `ApiOrdersNotice` using a unique key and a patch. */
  updateApiOrdersNoticeById?: Maybe<UpdateApiOrdersNoticePayload>;
  /** Updates a single `Assortment` using its globally unique id and a patch. */
  updateAssortment?: Maybe<UpdateAssortmentPayload>;
  /** Updates a single `Assortment` using a unique key and a patch. */
  updateAssortmentById?: Maybe<UpdateAssortmentPayload>;
  /** Updates a single `AssortmentExclusion` using its globally unique id and a patch. */
  updateAssortmentExclusion?: Maybe<UpdateAssortmentExclusionPayload>;
  /** Updates a single `AssortmentExclusion` using a unique key and a patch. */
  updateAssortmentExclusionById?: Maybe<UpdateAssortmentExclusionPayload>;
  /** Updates a single `AssortmentGroup` using its globally unique id and a patch. */
  updateAssortmentGroup?: Maybe<UpdateAssortmentGroupPayload>;
  /** Updates a single `AssortmentGroup` using a unique key and a patch. */
  updateAssortmentGroupById?: Maybe<UpdateAssortmentGroupPayload>;
  /** Updates a single `BatchUpdate` using its globally unique id and a patch. */
  updateBatchUpdate?: Maybe<UpdateBatchUpdatePayload>;
  /** Updates a single `BatchUpdate` using a unique key and a patch. */
  updateBatchUpdateById?: Maybe<UpdateBatchUpdatePayload>;
  /** Updates a single `BillOfLading` using its globally unique id and a patch. */
  updateBillOfLading?: Maybe<UpdateBillOfLadingPayload>;
  /** Updates a single `BillOfLading` using a unique key and a patch. */
  updateBillOfLadingById?: Maybe<UpdateBillOfLadingPayload>;
  /** Updates a single `BillOfLadingDatum` using its globally unique id and a patch. */
  updateBillOfLadingDatum?: Maybe<UpdateBillOfLadingDatumPayload>;
  /** Updates a single `BillOfLadingDatum` using a unique key and a patch. */
  updateBillOfLadingDatumById?: Maybe<UpdateBillOfLadingDatumPayload>;
  /** Updates a single `BunkerGradeCalculation` using its globally unique id and a patch. */
  updateBunkerGradeCalculation?: Maybe<UpdateBunkerGradeCalculationPayload>;
  /** Updates a single `BunkerGradeCalculation` using a unique key and a patch. */
  updateBunkerGradeCalculationById?: Maybe<UpdateBunkerGradeCalculationPayload>;
  /** Updates a single `BunkerGradeCalculation` using a unique key and a patch. */
  updateBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeId?: Maybe<UpdateBunkerGradeCalculationPayload>;
  /** Updates a single `BunkerGradeMapping` using its globally unique id and a patch. */
  updateBunkerGradeMapping?: Maybe<UpdateBunkerGradeMappingPayload>;
  /** Updates a single `BunkerGradeMapping` using a unique key and a patch. */
  updateBunkerGradeMappingById?: Maybe<UpdateBunkerGradeMappingPayload>;
  /** Updates a single `BunkerGradeMapping` using a unique key and a patch. */
  updateBunkerGradeMappingByOrganizationIdAndFromGradeId?: Maybe<UpdateBunkerGradeMappingPayload>;
  /** Updates a single `BunkerGradeOverride` using its globally unique id and a patch. */
  updateBunkerGradeOverride?: Maybe<UpdateBunkerGradeOverridePayload>;
  /** Updates a single `BunkerGradeOverride` using a unique key and a patch. */
  updateBunkerGradeOverrideByGradeNameAndOrganizationId?: Maybe<UpdateBunkerGradeOverridePayload>;
  /** Updates a single `BunkerGradeOverride` using a unique key and a patch. */
  updateBunkerGradeOverrideById?: Maybe<UpdateBunkerGradeOverridePayload>;
  /** Updates a single `Bunkering` using its globally unique id and a patch. */
  updateBunkering?: Maybe<UpdateBunkeringPayload>;
  /** Updates a single `Bunkering` using a unique key and a patch. */
  updateBunkeringById?: Maybe<UpdateBunkeringPayload>;
  /** Updates a single `CarbonPriceOverride` using its globally unique id and a patch. */
  updateCarbonPriceOverride?: Maybe<UpdateCarbonPriceOverridePayload>;
  /** Updates a single `CarbonPriceOverride` using a unique key and a patch. */
  updateCarbonPriceOverrideById?: Maybe<UpdateCarbonPriceOverridePayload>;
  /** Updates a single `CargoCompartment` using its globally unique id and a patch. */
  updateCargoCompartment?: Maybe<UpdateCargoCompartmentPayload>;
  /** Updates a single `CargoCompartmentAllocation` using its globally unique id and a patch. */
  updateCargoCompartmentAllocation?: Maybe<UpdateCargoCompartmentAllocationPayload>;
  /** Updates a single `CargoCompartmentAllocation` using a unique key and a patch. */
  updateCargoCompartmentAllocationById?: Maybe<UpdateCargoCompartmentAllocationPayload>;
  /** Updates a single `CargoCompartment` using a unique key and a patch. */
  updateCargoCompartmentById?: Maybe<UpdateCargoCompartmentPayload>;
  /** Updates a single `CargoEquipment` using its globally unique id and a patch. */
  updateCargoEquipment?: Maybe<UpdateCargoEquipmentPayload>;
  /** Updates a single `CargoEquipment` using a unique key and a patch. */
  updateCargoEquipmentById?: Maybe<UpdateCargoEquipmentPayload>;
  /** Updates a single `CargoExclusion` using its globally unique id and a patch. */
  updateCargoExclusion?: Maybe<UpdateCargoExclusionPayload>;
  /** Updates a single `CargoExclusion` using a unique key and a patch. */
  updateCargoExclusionById?: Maybe<UpdateCargoExclusionPayload>;
  /** Updates a single `CargoLengthUnit` using its globally unique id and a patch. */
  updateCargoLengthUnit?: Maybe<UpdateCargoLengthUnitPayload>;
  /** Updates a single `CargoLengthUnit` using a unique key and a patch. */
  updateCargoLengthUnitById?: Maybe<UpdateCargoLengthUnitPayload>;
  /** Updates a single `CargoMeasurement` using its globally unique id and a patch. */
  updateCargoMeasurement?: Maybe<UpdateCargoMeasurementPayload>;
  /** Updates a single `CargoMeasurement` using a unique key and a patch. */
  updateCargoMeasurementById?: Maybe<UpdateCargoMeasurementPayload>;
  /** Updates a single `CargoUnit` using its globally unique id and a patch. */
  updateCargoUnit?: Maybe<UpdateCargoUnitPayload>;
  /** Updates a single `CargoUnit` using a unique key and a patch. */
  updateCargoUnitById?: Maybe<UpdateCargoUnitPayload>;
  /** Updates a single `CargoUnitsConversion` using a unique key and a patch. */
  updateCargoUnitsConversionByExtraUnitName?: Maybe<UpdateCargoUnitsConversionPayload>;
  /** Updates a single `CargoWeightUnit` using its globally unique id and a patch. */
  updateCargoWeightUnit?: Maybe<UpdateCargoWeightUnitPayload>;
  /** Updates a single `CargoWeightUnit` using a unique key and a patch. */
  updateCargoWeightUnitById?: Maybe<UpdateCargoWeightUnitPayload>;
  /** Updates a single `Channel` using its globally unique id and a patch. */
  updateChannel?: Maybe<UpdateChannelPayload>;
  /** Updates a single `Channel` using a unique key and a patch. */
  updateChannelById?: Maybe<UpdateChannelPayload>;
  /** Updates a single `ChannelCost` using its globally unique id and a patch. */
  updateChannelCost?: Maybe<UpdateChannelCostPayload>;
  /** Updates a single `ChannelCost` using a unique key and a patch. */
  updateChannelCostById?: Maybe<UpdateChannelCostPayload>;
  /** Updates a single `ChannelCostEstimate` using its globally unique id and a patch. */
  updateChannelCostEstimate?: Maybe<UpdateChannelCostEstimatePayload>;
  /** Updates a single `ChannelCostEstimate` using a unique key and a patch. */
  updateChannelCostEstimateById?: Maybe<UpdateChannelCostEstimatePayload>;
  /** Updates a single `ChannelIncompatibility` using its globally unique id and a patch. */
  updateChannelIncompatibility?: Maybe<UpdateChannelIncompatibilityPayload>;
  /** Updates a single `ChannelIncompatibility` using a unique key and a patch. */
  updateChannelIncompatibilityById?: Maybe<UpdateChannelIncompatibilityPayload>;
  /** Updates a single `ChannelIncompatibility` using a unique key and a patch. */
  updateChannelIncompatibilityByVesselAttributeIdAndChannelName?: Maybe<UpdateChannelIncompatibilityPayload>;
  /** Updates a single `Chat` using its globally unique id and a patch. */
  updateChat?: Maybe<UpdateChatPayload>;
  /** Updates a single `Chat` using a unique key and a patch. */
  updateChatById?: Maybe<UpdateChatPayload>;
  /** Updates a single `ClassSocietyAssociation` using its globally unique id and a patch. */
  updateClassSocietyAssociation?: Maybe<UpdateClassSocietyAssociationPayload>;
  /** Updates a single `ClassSocietyAssociation` using a unique key and a patch. */
  updateClassSocietyAssociationById?: Maybe<UpdateClassSocietyAssociationPayload>;
  /** Updates a single `ClassificationSociety` using its globally unique id and a patch. */
  updateClassificationSociety?: Maybe<UpdateClassificationSocietyPayload>;
  /** Updates a single `ClassificationSociety` using a unique key and a patch. */
  updateClassificationSocietyById?: Maybe<UpdateClassificationSocietyPayload>;
  /** Updates a single `CoaContract` using its globally unique id and a patch. */
  updateCoaContract?: Maybe<UpdateCoaContractPayload>;
  /** Updates a single `CoaContractAssortment` using its globally unique id and a patch. */
  updateCoaContractAssortment?: Maybe<UpdateCoaContractAssortmentPayload>;
  /** Updates a single `CoaContractAssortment` using a unique key and a patch. */
  updateCoaContractAssortmentById?: Maybe<UpdateCoaContractAssortmentPayload>;
  /** Updates a single `CoaContractBunker` using its globally unique id and a patch. */
  updateCoaContractBunker?: Maybe<UpdateCoaContractBunkerPayload>;
  /** Updates a single `CoaContractBunker` using a unique key and a patch. */
  updateCoaContractBunkerById?: Maybe<UpdateCoaContractBunkerPayload>;
  /** Updates a single `CoaContract` using a unique key and a patch. */
  updateCoaContractById?: Maybe<UpdateCoaContractPayload>;
  /** Updates a single `CoaContractCommission` using its globally unique id and a patch. */
  updateCoaContractCommission?: Maybe<UpdateCoaContractCommissionPayload>;
  /** Updates a single `CoaContractCommission` using a unique key and a patch. */
  updateCoaContractCommissionById?: Maybe<UpdateCoaContractCommissionPayload>;
  /** Updates a single `CoaContractDeviationCost` using its globally unique id and a patch. */
  updateCoaContractDeviationCost?: Maybe<UpdateCoaContractDeviationCostPayload>;
  /** Updates a single `CoaContractDeviationCost` using a unique key and a patch. */
  updateCoaContractDeviationCostById?: Maybe<UpdateCoaContractDeviationCostPayload>;
  /** Updates a single `CoaContractPort` using its globally unique id and a patch. */
  updateCoaContractPort?: Maybe<UpdateCoaContractPortPayload>;
  /** Updates a single `CoaContractPort` using a unique key and a patch. */
  updateCoaContractPortByCoaContractIdAndOriginIdAndDestinationId?: Maybe<UpdateCoaContractPortPayload>;
  /** Updates a single `CoaContractPort` using a unique key and a patch. */
  updateCoaContractPortById?: Maybe<UpdateCoaContractPortPayload>;
  /** Updates a single `CoaContractPortCost` using its globally unique id and a patch. */
  updateCoaContractPortCost?: Maybe<UpdateCoaContractPortCostPayload>;
  /** Updates a single `CoaContractPortCost` using a unique key and a patch. */
  updateCoaContractPortCostById?: Maybe<UpdateCoaContractPortCostPayload>;
  /** Updates a single `CoaContractPortCost` using a unique key and a patch. */
  updateCoaContractPortCostByLocationIdAndShipId?: Maybe<UpdateCoaContractPortCostPayload>;
  /** Updates a single `CoaContractPortCost` using a unique key and a patch. */
  updateCoaContractPortCostByLocationIdAndVesselTypeId?: Maybe<UpdateCoaContractPortCostPayload>;
  /** Updates a single `CoaContractPortDatum` using its globally unique id and a patch. */
  updateCoaContractPortDatum?: Maybe<UpdateCoaContractPortDatumPayload>;
  /** Updates a single `CoaContractPortDatum` using a unique key and a patch. */
  updateCoaContractPortDatumById?: Maybe<UpdateCoaContractPortDatumPayload>;
  /** Updates a single `CoaContractPrice` using its globally unique id and a patch. */
  updateCoaContractPrice?: Maybe<UpdateCoaContractPricePayload>;
  /** Updates a single `CoaContractPrice` using a unique key and a patch. */
  updateCoaContractPriceById?: Maybe<UpdateCoaContractPricePayload>;
  /** Updates a single `CoaContractShip` using its globally unique id and a patch. */
  updateCoaContractShip?: Maybe<UpdateCoaContractShipPayload>;
  /** Updates a single `CoaContractShip` using a unique key and a patch. */
  updateCoaContractShipByCoaContractIdAndShipId?: Maybe<UpdateCoaContractShipPayload>;
  /** Updates a single `CoaContractShip` using a unique key and a patch. */
  updateCoaContractShipById?: Maybe<UpdateCoaContractShipPayload>;
  /** Updates a single `Commission` using its globally unique id and a patch. */
  updateCommission?: Maybe<UpdateCommissionPayload>;
  /** Updates a single `Commission` using a unique key and a patch. */
  updateCommissionByExternalIdAndVoyageCharterId?: Maybe<UpdateCommissionPayload>;
  /** Updates a single `Commission` using a unique key and a patch. */
  updateCommissionById?: Maybe<UpdateCommissionPayload>;
  /** Updates a single `CommitLogScenario` using its globally unique id and a patch. */
  updateCommitLogScenario?: Maybe<UpdateCommitLogScenarioPayload>;
  /** Updates a single `CommitLogScenario` using a unique key and a patch. */
  updateCommitLogScenarioById?: Maybe<UpdateCommitLogScenarioPayload>;
  updateConfirmedVoyages?: Maybe<UpdateConfirmedVoyages>;
  /** Updates a single `CostSplitOnScheduledOrder` using its globally unique id and a patch. */
  updateCostSplitOnScheduledOrder?: Maybe<UpdateCostSplitOnScheduledOrderPayload>;
  /** Updates a single `CostSplitOnScheduledOrder` using a unique key and a patch. */
  updateCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderId?: Maybe<UpdateCostSplitOnScheduledOrderPayload>;
  /** Updates a single `CostSplitOnScheduledOrder` using a unique key and a patch. */
  updateCostSplitOnScheduledOrderById?: Maybe<UpdateCostSplitOnScheduledOrderPayload>;
  /** Updates a single `CostSplitOnSingleEvent` using its globally unique id and a patch. */
  updateCostSplitOnSingleEvent?: Maybe<UpdateCostSplitOnSingleEventPayload>;
  /** Updates a single `CostSplitOnSingleEvent` using a unique key and a patch. */
  updateCostSplitOnSingleEventByActualCostIdAndSingleEventId?: Maybe<UpdateCostSplitOnSingleEventPayload>;
  /** Updates a single `CostSplitOnSingleEvent` using a unique key and a patch. */
  updateCostSplitOnSingleEventById?: Maybe<UpdateCostSplitOnSingleEventPayload>;
  /** Updates a single `Country` using its globally unique id and a patch. */
  updateCountry?: Maybe<UpdateCountryPayload>;
  /** Updates a single `Country` using a unique key and a patch. */
  updateCountryById?: Maybe<UpdateCountryPayload>;
  /** Updates a single `Country` using a unique key and a patch. */
  updateCountryByNumeric?: Maybe<UpdateCountryPayload>;
  updateDateShipnet?: Maybe<UpdateDateShipnetResult>;
  /** Updates a single `DbChange` using its globally unique id and a patch. */
  updateDbChange?: Maybe<UpdateDbChangePayload>;
  /** Updates a single `DbChange` using a unique key and a patch. */
  updateDbChangeById?: Maybe<UpdateDbChangePayload>;
  /** Updates a single `Demand` using its globally unique id and a patch. */
  updateDemand?: Maybe<UpdateDemandPayload>;
  /** Updates a single `Demand` using a unique key and a patch. */
  updateDemandById?: Maybe<UpdateDemandPayload>;
  /** Updates a single `EmailToOrderConfig` using its globally unique id and a patch. */
  updateEmailToOrderConfig?: Maybe<UpdateEmailToOrderConfigPayload>;
  /** Updates a single `EmailToOrderConfig` using a unique key and a patch. */
  updateEmailToOrderConfigById?: Maybe<UpdateEmailToOrderConfigPayload>;
  /** Updates a single `EmailToOrderLog` using its globally unique id and a patch. */
  updateEmailToOrderLog?: Maybe<UpdateEmailToOrderLogPayload>;
  /** Updates a single `EmailToOrderLog` using a unique key and a patch. */
  updateEmailToOrderLogById?: Maybe<UpdateEmailToOrderLogPayload>;
  /** Updates a single `Feature` using its globally unique id and a patch. */
  updateFeature?: Maybe<UpdateFeaturePayload>;
  /** Updates a single `Feature` using a unique key and a patch. */
  updateFeatureByFeatureName?: Maybe<UpdateFeaturePayload>;
  /** Updates a single `File` using its globally unique id and a patch. */
  updateFile?: Maybe<UpdateFilePayload>;
  /** Updates a single `File` using a unique key and a patch. */
  updateFileById?: Maybe<UpdateFilePayload>;
  /** Updates a single `GeographicalEntity` using its globally unique id and a patch. */
  updateGeographicalEntity?: Maybe<UpdateGeographicalEntityPayload>;
  /** Updates a single `GeographicalEntity` using a unique key and a patch. */
  updateGeographicalEntityById?: Maybe<UpdateGeographicalEntityPayload>;
  /** Updates a single `GeographicalRelation` using its globally unique id and a patch. */
  updateGeographicalRelation?: Maybe<UpdateGeographicalRelationPayload>;
  /** Updates a single `GeographicalRelation` using a unique key and a patch. */
  updateGeographicalRelationById?: Maybe<UpdateGeographicalRelationPayload>;
  /** Updates a single `HandledByCoa` using its globally unique id and a patch. */
  updateHandledByCoa?: Maybe<UpdateHandledByCoaPayload>;
  /** Updates a single `HandledByCoa` using a unique key and a patch. */
  updateHandledByCoaById?: Maybe<UpdateHandledByCoaPayload>;
  /** Updates a single `HandledByCoa` using a unique key and a patch. */
  updateHandledByCoaByOrderId?: Maybe<UpdateHandledByCoaPayload>;
  /** Updates a single `HandledBySpot` using its globally unique id and a patch. */
  updateHandledBySpot?: Maybe<UpdateHandledBySpotPayload>;
  /** Updates a single `HandledBySpot` using a unique key and a patch. */
  updateHandledBySpotById?: Maybe<UpdateHandledBySpotPayload>;
  /** Updates a single `HandledBySpot` using a unique key and a patch. */
  updateHandledBySpotByOrderId?: Maybe<UpdateHandledBySpotPayload>;
  /** Updates a single `Holiday` using its globally unique id and a patch. */
  updateHoliday?: Maybe<UpdateHolidayPayload>;
  /** Updates a single `Holiday` using a unique key and a patch. */
  updateHolidayById?: Maybe<UpdateHolidayPayload>;
  /** Updates a single `IceClass` using its globally unique id and a patch. */
  updateIceClass?: Maybe<UpdateIceClassPayload>;
  /** Updates a single `IceClass` using a unique key and a patch. */
  updateIceClassById?: Maybe<UpdateIceClassPayload>;
  /** Updates a single `Instruction` using its globally unique id and a patch. */
  updateInstruction?: Maybe<UpdateInstructionPayload>;
  /** Updates a single `Instruction` using a unique key and a patch. */
  updateInstructionById?: Maybe<UpdateInstructionPayload>;
  /** Updates a single `IntegrationLog` using its globally unique id and a patch. */
  updateIntegrationLog?: Maybe<UpdateIntegrationLogPayload>;
  /** Updates a single `IntegrationLog` using a unique key and a patch. */
  updateIntegrationLogById?: Maybe<UpdateIntegrationLogPayload>;
  /** Updates a single `Invoice` using its globally unique id and a patch. */
  updateInvoice?: Maybe<UpdateInvoicePayload>;
  /** Updates a single `Invoice` using a unique key and a patch. */
  updateInvoiceById?: Maybe<UpdateInvoicePayload>;
  /** Updates a single `InvoiceItem` using its globally unique id and a patch. */
  updateInvoiceItem?: Maybe<UpdateInvoiceItemPayload>;
  /** Updates a single `InvoiceItem` using a unique key and a patch. */
  updateInvoiceItemById?: Maybe<UpdateInvoiceItemPayload>;
  /** Updates a single `InvoiceItemOrder` using its globally unique id and a patch. */
  updateInvoiceItemOrder?: Maybe<UpdateInvoiceItemOrderPayload>;
  /** Updates a single `InvoiceItemOrder` using a unique key and a patch. */
  updateInvoiceItemOrderById?: Maybe<UpdateInvoiceItemOrderPayload>;
  /** Updates a single `LaytimeResponsibility` using its globally unique id and a patch. */
  updateLaytimeResponsibility?: Maybe<UpdateLaytimeResponsibilityPayload>;
  /** Updates a single `LaytimeResponsibility` using a unique key and a patch. */
  updateLaytimeResponsibilityById?: Maybe<UpdateLaytimeResponsibilityPayload>;
  /** Updates a single `Location` using its globally unique id and a patch. */
  updateLocation?: Maybe<UpdateLocationPayload>;
  /** Updates a single `Location` using a unique key and a patch. */
  updateLocationById?: Maybe<UpdateLocationPayload>;
  /** Updates a single `LocationCluster` using its globally unique id and a patch. */
  updateLocationCluster?: Maybe<UpdateLocationClusterPayload>;
  /** Updates a single `LocationCluster` using a unique key and a patch. */
  updateLocationClusterById?: Maybe<UpdateLocationClusterPayload>;
  /** Updates a single `LocationRequirementAssociation` using its globally unique id and a patch. */
  updateLocationRequirementAssociation?: Maybe<UpdateLocationRequirementAssociationPayload>;
  /** Updates a single `LocationRequirementAssociation` using a unique key and a patch. */
  updateLocationRequirementAssociationById?: Maybe<UpdateLocationRequirementAssociationPayload>;
  /** Updates a single `LocationRequirementAssociation` using a unique key and a patch. */
  updateLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneId?: Maybe<UpdateLocationRequirementAssociationPayload>;
  /** Updates a single `LocationWorkingHour` using its globally unique id and a patch. */
  updateLocationWorkingHour?: Maybe<UpdateLocationWorkingHourPayload>;
  /** Updates a single `LocationWorkingHour` using a unique key and a patch. */
  updateLocationWorkingHourById?: Maybe<UpdateLocationWorkingHourPayload>;
  /** Updates a single `LostContract` using its globally unique id and a patch. */
  updateLostContract?: Maybe<UpdateLostContractPayload>;
  /** Updates a single `LostContract` using a unique key and a patch. */
  updateLostContractById?: Maybe<UpdateLostContractPayload>;
  updateManySAP: UpdateSapResults;
  /** Updates a single `Migration` using its globally unique id and a patch. */
  updateMigration?: Maybe<UpdateMigrationPayload>;
  /** Updates a single `Migration` using a unique key and a patch. */
  updateMigrationById?: Maybe<UpdateMigrationPayload>;
  /** Updates a single `NoGoZone` using its globally unique id and a patch. */
  updateNoGoZone?: Maybe<UpdateNoGoZonePayload>;
  /** Updates a single `NoGoZone` using a unique key and a patch. */
  updateNoGoZoneById?: Maybe<UpdateNoGoZonePayload>;
  /** Updates a single `NotificationReceiver` using a unique key and a patch. */
  updateNotificationReceiverById?: Maybe<UpdateNotificationReceiverPayload>;
  /** Updates a single `OffHire` using its globally unique id and a patch. */
  updateOffHire?: Maybe<UpdateOffHirePayload>;
  /** Updates a single `OffHire` using a unique key and a patch. */
  updateOffHireById?: Maybe<UpdateOffHirePayload>;
  /** Updates a single `OpenPosition` using its globally unique id and a patch. */
  updateOpenPosition?: Maybe<UpdateOpenPositionPayload>;
  /** Updates a single `OpenPosition` using a unique key and a patch. */
  updateOpenPositionById?: Maybe<UpdateOpenPositionPayload>;
  /** Updates a single `Order` using its globally unique id and a patch. */
  updateOrder?: Maybe<UpdateOrderPayload>;
  /** Updates a single `OrderAttribute` using its globally unique id and a patch. */
  updateOrderAttribute?: Maybe<UpdateOrderAttributePayload>;
  /** Updates a single `OrderAttributeAssociation` using its globally unique id and a patch. */
  updateOrderAttributeAssociation?: Maybe<UpdateOrderAttributeAssociationPayload>;
  /** Updates a single `OrderAttributeAssociation` using a unique key and a patch. */
  updateOrderAttributeAssociationById?: Maybe<UpdateOrderAttributeAssociationPayload>;
  /** Updates a single `OrderAttribute` using a unique key and a patch. */
  updateOrderAttributeById?: Maybe<UpdateOrderAttributePayload>;
  /** Updates a single `Order` using a unique key and a patch. */
  updateOrderById?: Maybe<UpdateOrderPayload>;
  /** Updates a single `OrderDetail` using its globally unique id and a patch. */
  updateOrderDetail?: Maybe<UpdateOrderDetailPayload>;
  /** Updates a single `OrderDetail` using a unique key and a patch. */
  updateOrderDetailById?: Maybe<UpdateOrderDetailPayload>;
  /** Updates a single `OrderPortCallRelation` using its globally unique id and a patch. */
  updateOrderPortCallRelation?: Maybe<UpdateOrderPortCallRelationPayload>;
  /** Updates a single `OrderPortCallRelation` using a unique key and a patch. */
  updateOrderPortCallRelationById?: Maybe<UpdateOrderPortCallRelationPayload>;
  /** Updates a single `OrderPortCallRelation` using a unique key and a patch. */
  updateOrderPortCallRelationByOrderIdAndIsLoadPort?: Maybe<UpdateOrderPortCallRelationPayload>;
  /** Updates a single `OrderPortOverride` using its globally unique id and a patch. */
  updateOrderPortOverride?: Maybe<UpdateOrderPortOverridePayload>;
  /** Updates a single `OrderPortOverride` using a unique key and a patch. */
  updateOrderPortOverrideByOrderId?: Maybe<UpdateOrderPortOverridePayload>;
  /** Updates a single `OrderRequirementAssociation` using its globally unique id and a patch. */
  updateOrderRequirementAssociation?: Maybe<UpdateOrderRequirementAssociationPayload>;
  /** Updates a single `OrderRequirementAssociation` using a unique key and a patch. */
  updateOrderRequirementAssociationById?: Maybe<UpdateOrderRequirementAssociationPayload>;
  /** Updates a single `OrderRequirementAssociation` using a unique key and a patch. */
  updateOrderRequirementAssociationBySpecialRequirementIdAndOrderId?: Maybe<UpdateOrderRequirementAssociationPayload>;
  /** Updates a single `OrderVoyageCharterRelation` using its globally unique id and a patch. */
  updateOrderVoyageCharterRelation?: Maybe<UpdateOrderVoyageCharterRelationPayload>;
  /** Updates a single `OrderVoyageCharterRelation` using a unique key and a patch. */
  updateOrderVoyageCharterRelationById?: Maybe<UpdateOrderVoyageCharterRelationPayload>;
  /** Updates a single `OrderVoyageCharterRelation` using a unique key and a patch. */
  updateOrderVoyageCharterRelationByOrderIdAndOutgoing?: Maybe<UpdateOrderVoyageCharterRelationPayload>;
  updateOrdersAfterLocationTimezoneChange?: Maybe<UpdateOrdersAfterLocationTimezoneChangePayload>;
  updateOrgDescendants?: Maybe<UpdateOrgDescendantsPayload>;
  /** Updates a single `Organization` using its globally unique id and a patch. */
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  /** Updates a single `OrganizationAreaBunkerGradeMapping` using its globally unique id and a patch. */
  updateOrganizationAreaBunkerGradeMapping?: Maybe<UpdateOrganizationAreaBunkerGradeMappingPayload>;
  /** Updates a single `OrganizationAreaBunkerGradeMapping` using a unique key and a patch. */
  updateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea?: Maybe<UpdateOrganizationAreaBunkerGradeMappingPayload>;
  /** Updates a single `Organization` using a unique key and a patch. */
  updateOrganizationById?: Maybe<UpdateOrganizationPayload>;
  /** Updates a single `OrganizationFeature` using its globally unique id and a patch. */
  updateOrganizationFeature?: Maybe<UpdateOrganizationFeaturePayload>;
  /** Updates a single `OrganizationFeature` using a unique key and a patch. */
  updateOrganizationFeatureById?: Maybe<UpdateOrganizationFeaturePayload>;
  /** Updates a single `PortActivity` using its globally unique id and a patch. */
  updatePortActivity?: Maybe<UpdatePortActivityPayload>;
  /** Updates a single `PortActivity` using a unique key and a patch. */
  updatePortActivityById?: Maybe<UpdatePortActivityPayload>;
  /** Updates a single `PortCall` using its globally unique id and a patch. */
  updatePortCall?: Maybe<UpdatePortCallPayload>;
  /** Updates a single `PortCall` using a unique key and a patch. */
  updatePortCallById?: Maybe<UpdatePortCallPayload>;
  /** Updates a single `PortCallExternalTimestamp` using its globally unique id and a patch. */
  updatePortCallExternalTimestamp?: Maybe<UpdatePortCallExternalTimestampPayload>;
  /** Updates a single `PortCallExternalTimestamp` using a unique key and a patch. */
  updatePortCallExternalTimestampById?: Maybe<UpdatePortCallExternalTimestampPayload>;
  updatePortCallExternalTimestamps: Array<UpdatePortCallExternalTimestampsOutput>;
  /** Updates a single `PortCallFile` using its globally unique id and a patch. */
  updatePortCallFile?: Maybe<UpdatePortCallFilePayload>;
  /** Updates a single `PortCallFile` using a unique key and a patch. */
  updatePortCallFileByFileId?: Maybe<UpdatePortCallFilePayload>;
  /** Updates a single `PortCallFile` using a unique key and a patch. */
  updatePortCallFileById?: Maybe<UpdatePortCallFilePayload>;
  /** Updates a single `PortCommodityLdRate` using its globally unique id and a patch. */
  updatePortCommodityLdRate?: Maybe<UpdatePortCommodityLdRatePayload>;
  /** Updates a single `PortCommodityLdRate` using a unique key and a patch. */
  updatePortCommodityLdRateById?: Maybe<UpdatePortCommodityLdRatePayload>;
  /** Updates a single `PortCost` using its globally unique id and a patch. */
  updatePortCost?: Maybe<UpdatePortCostPayload>;
  /** Updates a single `PortCost` using a unique key and a patch. */
  updatePortCostById?: Maybe<UpdatePortCostPayload>;
  /** Updates a single `PortCostDefault` using its globally unique id and a patch. */
  updatePortCostDefault?: Maybe<UpdatePortCostDefaultPayload>;
  /** Updates a single `PortCostDefault` using a unique key and a patch. */
  updatePortCostDefaultById?: Maybe<UpdatePortCostDefaultPayload>;
  /** Updates a single `PortCostDefault` using a unique key and a patch. */
  updatePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrency?: Maybe<UpdatePortCostDefaultPayload>;
  /** Updates a single `PortCostEstimatesExternal` using its globally unique id and a patch. */
  updatePortCostEstimatesExternal?: Maybe<UpdatePortCostEstimatesExternalPayload>;
  /** Updates a single `PortCostEstimatesExternal` using a unique key and a patch. */
  updatePortCostEstimatesExternalById?: Maybe<UpdatePortCostEstimatesExternalPayload>;
  /** Updates a single `PortDatum` using its globally unique id and a patch. */
  updatePortDatum?: Maybe<UpdatePortDatumPayload>;
  /** Updates a single `PortDatum` using a unique key and a patch. */
  updatePortDatumById?: Maybe<UpdatePortDatumPayload>;
  updatePortMissedTimezone?: Maybe<UpdatePortMissedTimezoneResult>;
  /** Updates a single `PortNotice` using its globally unique id and a patch. */
  updatePortNotice?: Maybe<UpdatePortNoticePayload>;
  /** Updates a single `PortNotice` using a unique key and a patch. */
  updatePortNoticeById?: Maybe<UpdatePortNoticePayload>;
  /** Updates a single `PortRegion` using its globally unique id and a patch. */
  updatePortRegion?: Maybe<UpdatePortRegionPayload>;
  /** Updates a single `PortRegion` using a unique key and a patch. */
  updatePortRegionById?: Maybe<UpdatePortRegionPayload>;
  /** Updates a single `PortRegion` using a unique key and a patch. */
  updatePortRegionByLocationIdAndRegionIdAndOrganizationId?: Maybe<UpdatePortRegionPayload>;
  /** Updates a single `Prompt` using its globally unique id and a patch. */
  updatePrompt?: Maybe<UpdatePromptPayload>;
  /** Updates a single `Prompt` using a unique key and a patch. */
  updatePromptById?: Maybe<UpdatePromptPayload>;
  updateQ88Scenario?: Maybe<UpdateQ88ScenarioResult>;
  /** Updates a single `Quay` using its globally unique id and a patch. */
  updateQuay?: Maybe<UpdateQuayPayload>;
  /** Updates a single `Quay` using a unique key and a patch. */
  updateQuayById?: Maybe<UpdateQuayPayload>;
  /** Updates a single `ReceiverOrganization` using its globally unique id and a patch. */
  updateReceiverOrganization?: Maybe<UpdateReceiverOrganizationPayload>;
  /** Updates a single `ReceiverOrganization` using a unique key and a patch. */
  updateReceiverOrganizationByAdminOrganizationIdAndOrganizationId?: Maybe<UpdateReceiverOrganizationPayload>;
  /** Updates a single `ReceiverOrganization` using a unique key and a patch. */
  updateReceiverOrganizationById?: Maybe<UpdateReceiverOrganizationPayload>;
  /** Updates a single `Region` using its globally unique id and a patch. */
  updateRegion?: Maybe<UpdateRegionPayload>;
  /** Updates a single `Region` using a unique key and a patch. */
  updateRegionById?: Maybe<UpdateRegionPayload>;
  /** Updates a single `RequestLog` using its globally unique id and a patch. */
  updateRequestLog?: Maybe<UpdateRequestLogPayload>;
  /** Updates a single `RequestLog` using a unique key and a patch. */
  updateRequestLogById?: Maybe<UpdateRequestLogPayload>;
  /** Updates a single `Route` using its globally unique id and a patch. */
  updateRoute?: Maybe<UpdateRoutePayload>;
  /** Updates a single `Route` using a unique key and a patch. */
  updateRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZones?: Maybe<UpdateRoutePayload>;
  /** Updates a single `Route` using a unique key and a patch. */
  updateRouteById?: Maybe<UpdateRoutePayload>;
  /** Updates a single `RouteOverride` using its globally unique id and a patch. */
  updateRouteOverride?: Maybe<UpdateRouteOverridePayload>;
  /** Updates a single `RouteOverride` using a unique key and a patch. */
  updateRouteOverrideById?: Maybe<UpdateRouteOverridePayload>;
  /** Updates a single `RouteOverride` using a unique key and a patch. */
  updateRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannels?: Maybe<UpdateRouteOverridePayload>;
  /** Updates a single `RoutePoint` using its globally unique id and a patch. */
  updateRoutePoint?: Maybe<UpdateRoutePointPayload>;
  /** Updates a single `RoutePoint` using a unique key and a patch. */
  updateRoutePointById?: Maybe<UpdateRoutePointPayload>;
  /** Updates a single `RoutePointUsage` using its globally unique id and a patch. */
  updateRoutePointUsage?: Maybe<UpdateRoutePointUsagePayload>;
  /** Updates a single `RoutePointUsage` using a unique key and a patch. */
  updateRoutePointUsageById?: Maybe<UpdateRoutePointUsagePayload>;
  updateSAP: UpdateSapResult;
  /** Updates a single `Scenario` using its globally unique id and a patch. */
  updateScenario?: Maybe<UpdateScenarioPayload>;
  /** Updates a single `Scenario` using a unique key and a patch. */
  updateScenarioById?: Maybe<UpdateScenarioPayload>;
  /** Updates a single `ScheduledOrder` using its globally unique id and a patch. */
  updateScheduledOrder?: Maybe<UpdateScheduledOrderPayload>;
  /** Updates a single `ScheduledOrder` using a unique key and a patch. */
  updateScheduledOrderById?: Maybe<UpdateScheduledOrderPayload>;
  /** Updates a single `SeenMessage` using its globally unique id and a patch. */
  updateSeenMessage?: Maybe<UpdateSeenMessagePayload>;
  /** Updates a single `SeenMessage` using a unique key and a patch. */
  updateSeenMessageById?: Maybe<UpdateSeenMessagePayload>;
  /** Updates a single `SenderOrganization` using its globally unique id and a patch. */
  updateSenderOrganization?: Maybe<UpdateSenderOrganizationPayload>;
  /** Updates a single `SenderOrganization` using a unique key and a patch. */
  updateSenderOrganizationByAdminOrganizationIdAndOrganizationId?: Maybe<UpdateSenderOrganizationPayload>;
  /** Updates a single `SenderOrganization` using a unique key and a patch. */
  updateSenderOrganizationById?: Maybe<UpdateSenderOrganizationPayload>;
  /** Update organization information on sesstion table */
  updateSessionOrgs?: Maybe<UpdateSessionOrgsPayload>;
  /** Performs organization updates on sesstion table on last day active sessions */
  updateSessionOrgsInCurrentTree?: Maybe<UpdateSessionOrgsInCurrentTreePayload>;
  /** Updates a single `Ship` using its globally unique id and a patch. */
  updateShip?: Maybe<UpdateShipPayload>;
  /** Updates a single `Ship` using a unique key and a patch. */
  updateShipById?: Maybe<UpdateShipPayload>;
  /** Updates a single `ShipVoyageNamingRuleRelation` using its globally unique id and a patch. */
  updateShipVoyageNamingRuleRelation?: Maybe<UpdateShipVoyageNamingRuleRelationPayload>;
  /** Updates a single `ShipVoyageNamingRuleRelation` using a unique key and a patch. */
  updateShipVoyageNamingRuleRelationById?: Maybe<UpdateShipVoyageNamingRuleRelationPayload>;
  /** Updates a single `Shipment` using its globally unique id and a patch. */
  updateShipment?: Maybe<UpdateShipmentPayload>;
  /** Updates a single `Shipment` using a unique key and a patch. */
  updateShipmentById?: Maybe<UpdateShipmentPayload>;
  /** Updates a single `ShipmentExternalStatus` using its globally unique id and a patch. */
  updateShipmentExternalStatus?: Maybe<UpdateShipmentExternalStatusPayload>;
  /** Updates a single `ShipmentExternalStatus` using a unique key and a patch. */
  updateShipmentExternalStatusById?: Maybe<UpdateShipmentExternalStatusPayload>;
  /** Updates a single `ShipmentExtraFreight` using its globally unique id and a patch. */
  updateShipmentExtraFreight?: Maybe<UpdateShipmentExtraFreightPayload>;
  /** Updates a single `ShipmentExtraFreight` using a unique key and a patch. */
  updateShipmentExtraFreightById?: Maybe<UpdateShipmentExtraFreightPayload>;
  /** Updates a single `ShipmentFreight` using its globally unique id and a patch. */
  updateShipmentFreight?: Maybe<UpdateShipmentFreightPayload>;
  /** Updates a single `ShipmentFreight` using a unique key and a patch. */
  updateShipmentFreightById?: Maybe<UpdateShipmentFreightPayload>;
  /** Updates a single `ShipmentFreight` using a unique key and a patch. */
  updateShipmentFreightByShipmentId?: Maybe<UpdateShipmentFreightPayload>;
  /** Updates a single `ShipmentGroup` using its globally unique id and a patch. */
  updateShipmentGroup?: Maybe<UpdateShipmentGroupPayload>;
  /** Updates a single `ShipmentGroupAssociation` using its globally unique id and a patch. */
  updateShipmentGroupAssociation?: Maybe<UpdateShipmentGroupAssociationPayload>;
  /** Updates a single `ShipmentGroupAssociation` using a unique key and a patch. */
  updateShipmentGroupAssociationById?: Maybe<UpdateShipmentGroupAssociationPayload>;
  /** Updates a single `ShipmentGroup` using a unique key and a patch. */
  updateShipmentGroupById?: Maybe<UpdateShipmentGroupPayload>;
  updateShipnetScenario?: Maybe<UpdateShipnetScenarioResult>;
  /** Updates a single `SingleEvent` using its globally unique id and a patch. */
  updateSingleEvent?: Maybe<UpdateSingleEventPayload>;
  /** Updates a single `SingleEvent` using a unique key and a patch. */
  updateSingleEventById?: Maybe<UpdateSingleEventPayload>;
  /** Updates a single `SingleEventPortCallRelation` using its globally unique id and a patch. */
  updateSingleEventPortCallRelation?: Maybe<UpdateSingleEventPortCallRelationPayload>;
  /** Updates a single `SingleEventPortCallRelation` using a unique key and a patch. */
  updateSingleEventPortCallRelationById?: Maybe<UpdateSingleEventPortCallRelationPayload>;
  /** Updates a single `SpecialRequirement` using its globally unique id and a patch. */
  updateSpecialRequirement?: Maybe<UpdateSpecialRequirementPayload>;
  /** Updates a single `SpecialRequirement` using a unique key and a patch. */
  updateSpecialRequirementById?: Maybe<UpdateSpecialRequirementPayload>;
  /** Updates a single `SplitOrder` using its globally unique id and a patch. */
  updateSplitOrder?: Maybe<UpdateSplitOrderPayload>;
  /** Updates a single `SplitOrder` using a unique key and a patch. */
  updateSplitOrderById?: Maybe<UpdateSplitOrderPayload>;
  /** Updates a single `SpotNegotiation` using its globally unique id and a patch. */
  updateSpotNegotiation?: Maybe<UpdateSpotNegotiationPayload>;
  /** Updates a single `SpotNegotiation` using a unique key and a patch. */
  updateSpotNegotiationById?: Maybe<UpdateSpotNegotiationPayload>;
  /** Updates a single `StatementOfFact` using its globally unique id and a patch. */
  updateStatementOfFact?: Maybe<UpdateStatementOfFactPayload>;
  /** Updates a single `StatementOfFact` using a unique key and a patch. */
  updateStatementOfFactById?: Maybe<UpdateStatementOfFactPayload>;
  /** Updates a single `Supply` using its globally unique id and a patch. */
  updateSupply?: Maybe<UpdateSupplyPayload>;
  /** Updates a single `Supply` using a unique key and a patch. */
  updateSupplyById?: Maybe<UpdateSupplyPayload>;
  /** Updates a single `SupplyContract` using its globally unique id and a patch. */
  updateSupplyContract?: Maybe<UpdateSupplyContractPayload>;
  /** Updates a single `SupplyContract` using a unique key and a patch. */
  updateSupplyContractById?: Maybe<UpdateSupplyContractPayload>;
  /** Updates a single `TankDistance` using its globally unique id and a patch. */
  updateTankDistance?: Maybe<UpdateTankDistancePayload>;
  /** Updates a single `TankDistance` using a unique key and a patch. */
  updateTankDistanceById?: Maybe<UpdateTankDistancePayload>;
  /** Updates a single `TcContract` using its globally unique id and a patch. */
  updateTcContract?: Maybe<UpdateTcContractPayload>;
  /** Updates a single `TcContract` using a unique key and a patch. */
  updateTcContractById?: Maybe<UpdateTcContractPayload>;
  /** Updates a single `TcContract` using a unique key and a patch. */
  updateTcContractByRootOrgAndExternalId?: Maybe<UpdateTcContractPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserById?: Maybe<UpdateUserPayload>;
  /** Updates a single `UserRegion` using its globally unique id and a patch. */
  updateUserRegion?: Maybe<UpdateUserRegionPayload>;
  /** Updates a single `UserRegion` using a unique key and a patch. */
  updateUserRegionById?: Maybe<UpdateUserRegionPayload>;
  /** Updates a single `UserRight` using its globally unique id and a patch. */
  updateUserRight?: Maybe<UpdateUserRightPayload>;
  /** Updates a single `UserRight` using a unique key and a patch. */
  updateUserRightById?: Maybe<UpdateUserRightPayload>;
  /** Updates a single `UserRight` using a unique key and a patch. */
  updateUserRightByUserIdAndOrganizationId?: Maybe<UpdateUserRightPayload>;
  /** Updates a single `UserSetting` using its globally unique id and a patch. */
  updateUserSetting?: Maybe<UpdateUserSettingPayload>;
  /** Updates a single `UserSetting` using a unique key and a patch. */
  updateUserSettingById?: Maybe<UpdateUserSettingPayload>;
  /** Updates a single `UserShip` using its globally unique id and a patch. */
  updateUserShip?: Maybe<UpdateUserShipPayload>;
  /** Updates a single `UserShip` using a unique key and a patch. */
  updateUserShipById?: Maybe<UpdateUserShipPayload>;
  updateVesonScenario?: Maybe<UpdateVesonScenarioResult>;
  /** Updates a single `VesselAttribute` using its globally unique id and a patch. */
  updateVesselAttribute?: Maybe<UpdateVesselAttributePayload>;
  /** Updates a single `VesselAttributeAssortmentExclusion` using its globally unique id and a patch. */
  updateVesselAttributeAssortmentExclusion?: Maybe<UpdateVesselAttributeAssortmentExclusionPayload>;
  /** Updates a single `VesselAttributeAssortmentExclusion` using a unique key and a patch. */
  updateVesselAttributeAssortmentExclusionById?: Maybe<UpdateVesselAttributeAssortmentExclusionPayload>;
  /** Updates a single `VesselAttribute` using a unique key and a patch. */
  updateVesselAttributeById?: Maybe<UpdateVesselAttributePayload>;
  /** Updates a single `VesselAttribute` using a unique key and a patch. */
  updateVesselAttributeByOrganizationIdAndName?: Maybe<UpdateVesselAttributePayload>;
  /** Updates a single `VesselAttributesAssociation` using its globally unique id and a patch. */
  updateVesselAttributesAssociation?: Maybe<UpdateVesselAttributesAssociationPayload>;
  /** Updates a single `VesselAttributesAssociation` using a unique key and a patch. */
  updateVesselAttributesAssociationById?: Maybe<UpdateVesselAttributesAssociationPayload>;
  /** Updates a single `VesselDraftDatapoint` using its globally unique id and a patch. */
  updateVesselDraftDatapoint?: Maybe<UpdateVesselDraftDatapointPayload>;
  /** Updates a single `VesselDraftDatapoint` using a unique key and a patch. */
  updateVesselDraftDatapointById?: Maybe<UpdateVesselDraftDatapointPayload>;
  /** Updates a single `VesselFulfillsRequirementAssociation` using its globally unique id and a patch. */
  updateVesselFulfillsRequirementAssociation?: Maybe<UpdateVesselFulfillsRequirementAssociationPayload>;
  /** Updates a single `VesselFulfillsRequirementAssociation` using a unique key and a patch. */
  updateVesselFulfillsRequirementAssociationById?: Maybe<UpdateVesselFulfillsRequirementAssociationPayload>;
  /** Updates a single `VesselInfo` using its globally unique id and a patch. */
  updateVesselInfo?: Maybe<UpdateVesselInfoPayload>;
  /** Updates a single `VesselInfo` using a unique key and a patch. */
  updateVesselInfoById?: Maybe<UpdateVesselInfoPayload>;
  /** Updates a single `VesselInfo` using a unique key and a patch. */
  updateVesselInfoByImo?: Maybe<UpdateVesselInfoPayload>;
  /** Updates a single `VesselPerformanceModel` using its globally unique id and a patch. */
  updateVesselPerformanceModel?: Maybe<UpdateVesselPerformanceModelPayload>;
  /** Updates a single `VesselPerformanceModel` using a unique key and a patch. */
  updateVesselPerformanceModelById?: Maybe<UpdateVesselPerformanceModelPayload>;
  /** Updates a single `VesselPerformanceModel` using a unique key and a patch. */
  updateVesselPerformanceModelByRootOrgAndShipId?: Maybe<UpdateVesselPerformanceModelPayload>;
  /** Updates a single `VesselReservation` using its globally unique id and a patch. */
  updateVesselReservation?: Maybe<UpdateVesselReservationPayload>;
  /** Updates a single `VesselReservation` using a unique key and a patch. */
  updateVesselReservationById?: Maybe<UpdateVesselReservationPayload>;
  /** Updates a single `VesselScheduleSharedToOrganization` using its globally unique id and a patch. */
  updateVesselScheduleSharedToOrganization?: Maybe<UpdateVesselScheduleSharedToOrganizationPayload>;
  /** Updates a single `VesselScheduleSharedToOrganization` using a unique key and a patch. */
  updateVesselScheduleSharedToOrganizationById?: Maybe<UpdateVesselScheduleSharedToOrganizationPayload>;
  /** Updates a single `VesselScheduleSharedToOrganization` using a unique key and a patch. */
  updateVesselScheduleSharedToOrganizationByVesselIdAndOrganizationId?: Maybe<UpdateVesselScheduleSharedToOrganizationPayload>;
  /** Updates a single `VesselSecret` using its globally unique id and a patch. */
  updateVesselSecret?: Maybe<UpdateVesselSecretPayload>;
  /** Updates a single `VesselSecret` using a unique key and a patch. */
  updateVesselSecretById?: Maybe<UpdateVesselSecretPayload>;
  /** Updates a single `VesselSpeedConsumption` using its globally unique id and a patch. */
  updateVesselSpeedConsumption?: Maybe<UpdateVesselSpeedConsumptionPayload>;
  /** Updates a single `VesselSpeedConsumption` using a unique key and a patch. */
  updateVesselSpeedConsumptionById?: Maybe<UpdateVesselSpeedConsumptionPayload>;
  /** Updates a single `Voyage` using its globally unique id and a patch. */
  updateVoyage?: Maybe<UpdateVoyagePayload>;
  /** Updates a single `VoyageAssociation` using its globally unique id and a patch. */
  updateVoyageAssociation?: Maybe<UpdateVoyageAssociationPayload>;
  /** Updates a single `VoyageAssociation` using a unique key and a patch. */
  updateVoyageAssociationById?: Maybe<UpdateVoyageAssociationPayload>;
  /** Updates a single `VoyageAttribute` using its globally unique id and a patch. */
  updateVoyageAttribute?: Maybe<UpdateVoyageAttributePayload>;
  /** Updates a single `VoyageAttribute` using a unique key and a patch. */
  updateVoyageAttributeById?: Maybe<UpdateVoyageAttributePayload>;
  /** Updates a single `VoyageAttribute` using a unique key and a patch. */
  updateVoyageAttributeByOrganizationIdAndNameAndColor?: Maybe<UpdateVoyageAttributePayload>;
  /** Updates a single `Voyage` using a unique key and a patch. */
  updateVoyageById?: Maybe<UpdateVoyagePayload>;
  /** Updates a single `VoyageCharter` using its globally unique id and a patch. */
  updateVoyageCharter?: Maybe<UpdateVoyageCharterPayload>;
  /** Updates a single `VoyageCharter` using a unique key and a patch. */
  updateVoyageCharterById?: Maybe<UpdateVoyageCharterPayload>;
  /** Updates a single `VoyageCharter` using a unique key and a patch. */
  updateVoyageCharterByRootOrgAndExternalId?: Maybe<UpdateVoyageCharterPayload>;
  /** Updates a single `VoyageCharter` using a unique key and a patch. */
  updateVoyageCharterByRootOrgAndName?: Maybe<UpdateVoyageCharterPayload>;
  /** Updates a single `VoyageCharterExtraCost` using its globally unique id and a patch. */
  updateVoyageCharterExtraCost?: Maybe<UpdateVoyageCharterExtraCostPayload>;
  /** Updates a single `VoyageCharterExtraCost` using a unique key and a patch. */
  updateVoyageCharterExtraCostById?: Maybe<UpdateVoyageCharterExtraCostPayload>;
  /** Updates a single `VoyageCharterExtraFreight` using its globally unique id and a patch. */
  updateVoyageCharterExtraFreight?: Maybe<UpdateVoyageCharterExtraFreightPayload>;
  /** Updates a single `VoyageCharterExtraFreight` using a unique key and a patch. */
  updateVoyageCharterExtraFreightById?: Maybe<UpdateVoyageCharterExtraFreightPayload>;
  /** Updates a single `VoyageCharterOrderFreight` using its globally unique id and a patch. */
  updateVoyageCharterOrderFreight?: Maybe<UpdateVoyageCharterOrderFreightPayload>;
  /** Updates a single `VoyageCharterOrderFreight` using a unique key and a patch. */
  updateVoyageCharterOrderFreightById?: Maybe<UpdateVoyageCharterOrderFreightPayload>;
  /** Updates a single `VoyageCharterPortCost` using its globally unique id and a patch. */
  updateVoyageCharterPortCost?: Maybe<UpdateVoyageCharterPortCostPayload>;
  /** Updates a single `VoyageCharterPortCost` using a unique key and a patch. */
  updateVoyageCharterPortCostById?: Maybe<UpdateVoyageCharterPortCostPayload>;
  /** Updates a single `VoyageCharterPortDatum` using its globally unique id and a patch. */
  updateVoyageCharterPortDatum?: Maybe<UpdateVoyageCharterPortDatumPayload>;
  /** Updates a single `VoyageCharterPortDatum` using a unique key and a patch. */
  updateVoyageCharterPortDatumById?: Maybe<UpdateVoyageCharterPortDatumPayload>;
  /** Updates a single `VoyageCharterToContract` using its globally unique id and a patch. */
  updateVoyageCharterToContract?: Maybe<UpdateVoyageCharterToContractPayload>;
  /** Updates a single `VoyageCharterToContract` using a unique key and a patch. */
  updateVoyageCharterToContractById?: Maybe<UpdateVoyageCharterToContractPayload>;
  /** Updates a single `VoyageCharterUpdate` using its globally unique id and a patch. */
  updateVoyageCharterUpdate?: Maybe<UpdateVoyageCharterUpdatePayload>;
  /** Updates a single `VoyageCharterUpdate` using a unique key and a patch. */
  updateVoyageCharterUpdateById?: Maybe<UpdateVoyageCharterUpdatePayload>;
  /** Updates a single `VoyageNamingRule` using its globally unique id and a patch. */
  updateVoyageNamingRule?: Maybe<UpdateVoyageNamingRulePayload>;
  /** Updates a single `VoyageNamingRule` using a unique key and a patch. */
  updateVoyageNamingRuleById?: Maybe<UpdateVoyageNamingRulePayload>;
  /** Updates a single `WorldscaleFreight` using its globally unique id and a patch. */
  updateWorldscaleFreight?: Maybe<UpdateWorldscaleFreightPayload>;
  /** Updates a single `WorldscaleFreight` using a unique key and a patch. */
  updateWorldscaleFreightById?: Maybe<UpdateWorldscaleFreightPayload>;
  /** Updates a single `WorldscaleFreight` using a unique key and a patch. */
  updateWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYear?: Maybe<UpdateWorldscaleFreightPayload>;
  /** Updates a single `Zone` using its globally unique id and a patch. */
  updateZone?: Maybe<UpdateZonePayload>;
  /** Updates a single `Zone` using a unique key and a patch. */
  updateZoneById?: Maybe<UpdateZonePayload>;
  /** Updates a single `ZoneLocation` using its globally unique id and a patch. */
  updateZoneLocation?: Maybe<UpdateZoneLocationPayload>;
  /** Updates a single `ZoneLocation` using a unique key and a patch. */
  updateZoneLocationById?: Maybe<UpdateZoneLocationPayload>;
  /** Updates a single `ZoneLocation` using a unique key and a patch. */
  updateZoneLocationByZoneIdAndLocationId?: Maybe<UpdateZoneLocationPayload>;
  upsertBalticConfig?: Maybe<BalticConfigPayload>;
  upsertMarcuraLocation?: Maybe<UpsertMarcuraLocationResult>;
  upsertShipnetConfig?: Maybe<ShipnetConfigPayload>;
  upsertVesonConfig?: Maybe<VesonConfigPayload>;
  upsertVoyageCharterCosts?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  vcAndOrders?: Maybe<VcAndOrdersPayload>;
  verifyEmail?: Maybe<VerifyEmailPayload>;
  vesonExtraPortDaysSync?: Maybe<VesonExtraPortDaysSyncResult>;
  vesonOrdersSync?: Maybe<VesonOrdersSyncResult>;
  vesonPortsSync?: Maybe<VesonPortsSyncResult>;
  vesonUpdateData?: Maybe<VesonUpdateData>;
  vesonVesselsSync?: Maybe<VesonVesselsSyncResult>;
  voyagePrefixGetNextIds?: Maybe<VoyagePrefixGetNextIdsPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcceptVoyageCharterUpdateArgs = {
  input: AcceptVoyageCharterUpdateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddJobImosRobSyncArgs = {
  input: AddJobImosRobSyncInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAllOrgTreeListFromSessOrgArgs = {
  input: AllOrgTreeListFromSessOrgInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApiOrdersDateValidationArgs = {
  input: ApiOrdersDateValidationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApiPushExtraCostArgs = {
  input: ApiPushExtraCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApiPushLostContractArgs = {
  input: ApiPushLostContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApiPushPortCostArgs = {
  input: ApiPushPortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApiPushPortcallTimeArgs = {
  input: ApiPushPortcallTimeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationArchiveByIdsArgs = {
  input?: InputMaybe<ArchiveInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAuthenticateArgs = {
  input: AuthenticateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBalticOrdersSyncArgs = {
  input?: InputMaybe<BalticSyncInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBalticScenarioSyncArgs = {
  input?: InputMaybe<BalticSyncInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBalticUpdateDataArgs = {
  input?: InputMaybe<BalticSyncInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBalticVesselsSyncArgs = {
  input?: InputMaybe<BalticSyncInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBatchTunePerformanceModelsArgs = {
  input: BatchTunePerformanceModelsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCanAccessBunkerGradeOverrideArgs = {
  input: CanAccessBunkerGradeOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCanAccessCommitLogArgs = {
  input: CanAccessCommitLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCanAccessScenarioArgs = {
  input: CanAccessScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCoaContractsForCurrentPortAgentArgs = {
  input: CoaContractsForCurrentPortAgentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCoaContractsForCurrentSendersReceiversArgs = {
  input: CoaContractsForCurrentSendersReceiversInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCommitArgs = {
  input?: InputMaybe<CommitInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateActualCostArgs = {
  input: CreateActualCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApiCoaContractArgs = {
  input: CreateApiCoaContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApiLocationArgs = {
  input: CreateApiLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApiOrdersArgs = {
  input: CreateApiOrdersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApiOrdersNoticeArgs = {
  input: CreateApiOrdersNoticeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApiShipArgs = {
  input: CreateApiShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApiShipmentStatusArgs = {
  input: CreateApiShipmentStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssortmentArgs = {
  input: CreateAssortmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssortmentExclusionArgs = {
  input: CreateAssortmentExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssortmentGroupArgs = {
  input: CreateAssortmentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBatchUpdateArgs = {
  input: CreateBatchUpdateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBillOfLadingArgs = {
  input: CreateBillOfLadingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBillOfLadingDatumArgs = {
  input: CreateBillOfLadingDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBunkerGradeCalculationArgs = {
  input: CreateBunkerGradeCalculationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBunkerGradeMappingArgs = {
  input: CreateBunkerGradeMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBunkerGradeOverrideArgs = {
  input: CreateBunkerGradeOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBunkeringArgs = {
  input: CreateBunkeringInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCarbonPriceOverrideArgs = {
  input: CreateCarbonPriceOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoCompartmentArgs = {
  input: CreateCargoCompartmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoCompartmentAllocationArgs = {
  input: CreateCargoCompartmentAllocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoEquipmentArgs = {
  input: CreateCargoEquipmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoExclusionArgs = {
  input: CreateCargoExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoLengthUnitArgs = {
  input: CreateCargoLengthUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoMeasurementArgs = {
  input: CreateCargoMeasurementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoUnitArgs = {
  input: CreateCargoUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoUnitsConversionArgs = {
  input: CreateCargoUnitsConversionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCargoWeightUnitArgs = {
  input: CreateCargoWeightUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChannelArgs = {
  input: CreateChannelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChannelCostArgs = {
  input: CreateChannelCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChannelCostEstimateArgs = {
  input: CreateChannelCostEstimateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChannelIncompatibilityArgs = {
  input: CreateChannelIncompatibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateChatArgs = {
  input: CreateChatInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClassSocietyAssociationArgs = {
  input: CreateClassSocietyAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClassificationSocietyArgs = {
  input: CreateClassificationSocietyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractArgs = {
  input: CreateCoaContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractAssortmentArgs = {
  input: CreateCoaContractAssortmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractBunkerArgs = {
  input: CreateCoaContractBunkerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractCommissionArgs = {
  input: CreateCoaContractCommissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractDeviationCostArgs = {
  input: CreateCoaContractDeviationCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractPortArgs = {
  input: CreateCoaContractPortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractPortCostArgs = {
  input: CreateCoaContractPortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractPortDatumArgs = {
  input: CreateCoaContractPortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractPriceArgs = {
  input: CreateCoaContractPriceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCoaContractShipArgs = {
  input: CreateCoaContractShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCommissionArgs = {
  input: CreateCommissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCommitLogScenarioArgs = {
  input: CreateCommitLogScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCostSplitOnScheduledOrderArgs = {
  input: CreateCostSplitOnScheduledOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCostSplitOnSingleEventArgs = {
  input: CreateCostSplitOnSingleEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCountryArgs = {
  input: CreateCountryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCurrentOrganizationArgs = {
  input: CreateCurrentOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDbChangeArgs = {
  input: CreateDbChangeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDemandArgs = {
  input: CreateDemandInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmailToOrderConfigArgs = {
  input: CreateEmailToOrderConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmailToOrderLogArgs = {
  input: CreateEmailToOrderLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeatureArgs = {
  input: CreateFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFileArgs = {
  input: CreateFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGeographicalEntityArgs = {
  input: CreateGeographicalEntityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGeographicalRelationArgs = {
  input: CreateGeographicalRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateHandledByCoaArgs = {
  input: CreateHandledByCoaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateHandledBySpotArgs = {
  input: CreateHandledBySpotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateHolidayArgs = {
  input: CreateHolidayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIceClassArgs = {
  input: CreateIceClassInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInstructionArgs = {
  input: CreateInstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIntegrationLogArgs = {
  input: CreateIntegrationLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInvoiceItemArgs = {
  input: CreateInvoiceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInvoiceItemOrderArgs = {
  input: CreateInvoiceItemOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLaytimeResponsibilityArgs = {
  input: CreateLaytimeResponsibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLocationClusterArgs = {
  input: CreateLocationClusterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLocationRequirementAssociationArgs = {
  input: CreateLocationRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLocationWorkingHourArgs = {
  input: CreateLocationWorkingHourInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLostContractArgs = {
  input: CreateLostContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMigrationArgs = {
  input: CreateMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNoGoZoneArgs = {
  input: CreateNoGoZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateNotificationReceiverArgs = {
  input: CreateNotificationReceiverInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOffHireArgs = {
  input: CreateOffHireInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOpenPositionArgs = {
  input: CreateOpenPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderAttributeArgs = {
  input: CreateOrderAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderAttributeAssociationArgs = {
  input: CreateOrderAttributeAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderDetailArgs = {
  input: CreateOrderDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderPortCallRelationArgs = {
  input: CreateOrderPortCallRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderPortOverrideArgs = {
  input: CreateOrderPortOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderRequirementAssociationArgs = {
  input: CreateOrderRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrderVoyageCharterRelationArgs = {
  input: CreateOrderVoyageCharterRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrganizationAreaBunkerGradeMappingArgs = {
  input: CreateOrganizationAreaBunkerGradeMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOrganizationFeatureArgs = {
  input: CreateOrganizationFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortActivityArgs = {
  input: CreatePortActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortCallArgs = {
  input: CreatePortCallInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortCallExternalTimestampArgs = {
  input: CreatePortCallExternalTimestampInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortCallFileArgs = {
  input: CreatePortCallFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortCommodityLdRateArgs = {
  input: CreatePortCommodityLdRateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortCostArgs = {
  input: CreatePortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortCostDefaultArgs = {
  input: CreatePortCostDefaultInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortCostEstimatesExternalArgs = {
  input: CreatePortCostEstimatesExternalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortDatumArgs = {
  input: CreatePortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortNoticeArgs = {
  input: CreatePortNoticeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePortRegionArgs = {
  input: CreatePortRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePromptArgs = {
  input: CreatePromptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateQuayArgs = {
  input: CreateQuayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReceiverOrganizationArgs = {
  input: CreateReceiverOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRegionArgs = {
  input: CreateRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRequestLogArgs = {
  input: CreateRequestLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoleIfNotExistsArgs = {
  input: CreateRoleIfNotExistsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRouteArgs = {
  input: CreateRouteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRouteOverrideArgs = {
  input: CreateRouteOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoutePointArgs = {
  input: CreateRoutePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoutePointUsageArgs = {
  input: CreateRoutePointUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScenarioArgs = {
  input: CreateScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateScheduledOrderArgs = {
  input: CreateScheduledOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSeenMessageArgs = {
  input: CreateSeenMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSenderOrganizationArgs = {
  input: CreateSenderOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShipArgs = {
  input: CreateShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShipVoyageNamingRuleRelationArgs = {
  input: CreateShipVoyageNamingRuleRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShipmentArgs = {
  input: CreateShipmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShipmentExternalStatusArgs = {
  input: CreateShipmentExternalStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShipmentExtraFreightArgs = {
  input: CreateShipmentExtraFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShipmentFreightArgs = {
  input: CreateShipmentFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShipmentGroupArgs = {
  input: CreateShipmentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShipmentGroupAssociationArgs = {
  input: CreateShipmentGroupAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSingleEventArgs = {
  input: CreateSingleEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSingleEventPortCallRelationArgs = {
  input: CreateSingleEventPortCallRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSpecialRequirementArgs = {
  input: CreateSpecialRequirementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSplitOrderArgs = {
  input: CreateSplitOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSpotNegotiationArgs = {
  input: CreateSpotNegotiationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStatementOfFactArgs = {
  input: CreateStatementOfFactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSupplyArgs = {
  input: CreateSupplyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSupplyContractArgs = {
  input: CreateSupplyContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTankDistanceArgs = {
  input: CreateTankDistanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTcContractArgs = {
  input: CreateTcContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRegionArgs = {
  input: CreateUserRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRightArgs = {
  input: CreateUserRightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserSettingArgs = {
  input: CreateUserSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserShipArgs = {
  input: CreateUserShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselAttributeArgs = {
  input: CreateVesselAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselAttributeAssortmentExclusionArgs = {
  input: CreateVesselAttributeAssortmentExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselAttributesAssociationArgs = {
  input: CreateVesselAttributesAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselDraftDatapointArgs = {
  input: CreateVesselDraftDatapointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselFulfillsRequirementAssociationArgs = {
  input: CreateVesselFulfillsRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselInfoArgs = {
  input: CreateVesselInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselPerformanceModelArgs = {
  input: CreateVesselPerformanceModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselReservationArgs = {
  input: CreateVesselReservationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselScheduleSharedToOrganizationArgs = {
  input: CreateVesselScheduleSharedToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselSecretArgs = {
  input: CreateVesselSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVesselSpeedConsumptionArgs = {
  input: CreateVesselSpeedConsumptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageArgs = {
  input: CreateVoyageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageAssociationArgs = {
  input: CreateVoyageAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageAttributeArgs = {
  input: CreateVoyageAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageCharterArgs = {
  input: CreateVoyageCharterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageCharterExtraCostArgs = {
  input: CreateVoyageCharterExtraCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageCharterExtraFreightArgs = {
  input: CreateVoyageCharterExtraFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageCharterOrderFreightArgs = {
  input: CreateVoyageCharterOrderFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageCharterPortCostArgs = {
  input: CreateVoyageCharterPortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageCharterPortDatumArgs = {
  input: CreateVoyageCharterPortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageCharterToContractArgs = {
  input: CreateVoyageCharterToContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageCharterUpdateArgs = {
  input: CreateVoyageCharterUpdateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVoyageNamingRuleArgs = {
  input: CreateVoyageNamingRuleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVwHandledBySpotShipOwnerPgArgs = {
  input: CreateVwHandledBySpotShipOwnerPgInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateVwVoyageCharterShipownerNonfinancialArgs = {
  input: CreateVwVoyageCharterShipownerNonfinancialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorldscaleFreightArgs = {
  input: CreateWorldscaleFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneArgs = {
  input: CreateZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateZoneLocationArgs = {
  input: CreateZoneLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrencyApiArgs = {
  baseCurrency?: InputMaybe<Currency>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentOrgIdArgs = {
  input: CurrentOrgIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserCanAdminOrgArgs = {
  input: CurrentUserCanAdminOrgInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCurrentUserIdArgs = {
  input: CurrentUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActualCostArgs = {
  input: DeleteActualCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActualCostByIdArgs = {
  input: DeleteActualCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApiOrderArgs = {
  input: DeleteApiOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApiOrderByExternalOrderIdArgs = {
  input: DeleteApiOrderByExternalOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApiOrdersNoticeArgs = {
  input: DeleteApiOrdersNoticeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApiOrdersNoticeByIdArgs = {
  input: DeleteApiOrdersNoticeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssortmentArgs = {
  input: DeleteAssortmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssortmentByIdArgs = {
  input: DeleteAssortmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssortmentExclusionArgs = {
  input: DeleteAssortmentExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssortmentExclusionByIdArgs = {
  input: DeleteAssortmentExclusionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssortmentGroupArgs = {
  input: DeleteAssortmentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssortmentGroupByIdArgs = {
  input: DeleteAssortmentGroupByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBalticConfigArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBatchUpdateArgs = {
  input: DeleteBatchUpdateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBatchUpdateByIdArgs = {
  input: DeleteBatchUpdateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBillOfLadingArgs = {
  input: DeleteBillOfLadingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBillOfLadingByIdArgs = {
  input: DeleteBillOfLadingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBillOfLadingDatumArgs = {
  input: DeleteBillOfLadingDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBillOfLadingDatumByIdArgs = {
  input: DeleteBillOfLadingDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeCalculationArgs = {
  input: DeleteBunkerGradeCalculationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeCalculationByIdArgs = {
  input: DeleteBunkerGradeCalculationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeIdArgs = {
  input: DeleteBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeMappingArgs = {
  input: DeleteBunkerGradeMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeMappingByIdArgs = {
  input: DeleteBunkerGradeMappingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeMappingByOrganizationIdAndFromGradeIdArgs = {
  input: DeleteBunkerGradeMappingByOrganizationIdAndFromGradeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeOverrideArgs = {
  input: DeleteBunkerGradeOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeOverrideByGradeNameAndOrganizationIdArgs = {
  input: DeleteBunkerGradeOverrideByGradeNameAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkerGradeOverrideByIdArgs = {
  input: DeleteBunkerGradeOverrideByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkeringArgs = {
  input: DeleteBunkeringInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBunkeringByIdArgs = {
  input: DeleteBunkeringByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCarbonPriceOverrideArgs = {
  input: DeleteCarbonPriceOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCarbonPriceOverrideByIdArgs = {
  input: DeleteCarbonPriceOverrideByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoCompartmentArgs = {
  input: DeleteCargoCompartmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoCompartmentAllocationArgs = {
  input: DeleteCargoCompartmentAllocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoCompartmentAllocationByIdArgs = {
  input: DeleteCargoCompartmentAllocationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoCompartmentByIdArgs = {
  input: DeleteCargoCompartmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoEquipmentArgs = {
  input: DeleteCargoEquipmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoEquipmentByIdArgs = {
  input: DeleteCargoEquipmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoExclusionArgs = {
  input: DeleteCargoExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoExclusionByIdArgs = {
  input: DeleteCargoExclusionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoLengthUnitArgs = {
  input: DeleteCargoLengthUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoLengthUnitByIdArgs = {
  input: DeleteCargoLengthUnitByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoMeasurementArgs = {
  input: DeleteCargoMeasurementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoMeasurementByIdArgs = {
  input: DeleteCargoMeasurementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoUnitArgs = {
  input: DeleteCargoUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoUnitByIdArgs = {
  input: DeleteCargoUnitByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoUnitsConversionByExtraUnitNameArgs = {
  input: DeleteCargoUnitsConversionByExtraUnitNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoWeightUnitArgs = {
  input: DeleteCargoWeightUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCargoWeightUnitByIdArgs = {
  input: DeleteCargoWeightUnitByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelArgs = {
  input: DeleteChannelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelByIdArgs = {
  input: DeleteChannelByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelCostArgs = {
  input: DeleteChannelCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelCostByIdArgs = {
  input: DeleteChannelCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelCostEstimateArgs = {
  input: DeleteChannelCostEstimateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelCostEstimateByIdArgs = {
  input: DeleteChannelCostEstimateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelIncompatibilityArgs = {
  input: DeleteChannelIncompatibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelIncompatibilityByIdArgs = {
  input: DeleteChannelIncompatibilityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChannelIncompatibilityByVesselAttributeIdAndChannelNameArgs = {
  input: DeleteChannelIncompatibilityByVesselAttributeIdAndChannelNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChatArgs = {
  input: DeleteChatInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteChatByIdArgs = {
  input: DeleteChatByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClassSocietyAssociationArgs = {
  input: DeleteClassSocietyAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClassSocietyAssociationByIdArgs = {
  input: DeleteClassSocietyAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClassificationSocietyArgs = {
  input: DeleteClassificationSocietyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClassificationSocietyByIdArgs = {
  input: DeleteClassificationSocietyByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractArgs = {
  input: DeleteCoaContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractAssortmentArgs = {
  input: DeleteCoaContractAssortmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractAssortmentByIdArgs = {
  input: DeleteCoaContractAssortmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractBunkerArgs = {
  input: DeleteCoaContractBunkerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractBunkerByIdArgs = {
  input: DeleteCoaContractBunkerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractByIdArgs = {
  input: DeleteCoaContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractCommissionArgs = {
  input: DeleteCoaContractCommissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractCommissionByIdArgs = {
  input: DeleteCoaContractCommissionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractDeviationCostArgs = {
  input: DeleteCoaContractDeviationCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractDeviationCostByIdArgs = {
  input: DeleteCoaContractDeviationCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortArgs = {
  input: DeleteCoaContractPortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortByCoaContractIdAndOriginIdAndDestinationIdArgs = {
  input: DeleteCoaContractPortByCoaContractIdAndOriginIdAndDestinationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortByIdArgs = {
  input: DeleteCoaContractPortByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortCostArgs = {
  input: DeleteCoaContractPortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortCostByIdArgs = {
  input: DeleteCoaContractPortCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortCostByLocationIdAndShipIdArgs = {
  input: DeleteCoaContractPortCostByLocationIdAndShipIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortCostByLocationIdAndVesselTypeIdArgs = {
  input: DeleteCoaContractPortCostByLocationIdAndVesselTypeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortDatumArgs = {
  input: DeleteCoaContractPortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPortDatumByIdArgs = {
  input: DeleteCoaContractPortDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPriceArgs = {
  input: DeleteCoaContractPriceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractPriceByIdArgs = {
  input: DeleteCoaContractPriceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractShipArgs = {
  input: DeleteCoaContractShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractShipByCoaContractIdAndShipIdArgs = {
  input: DeleteCoaContractShipByCoaContractIdAndShipIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCoaContractShipByIdArgs = {
  input: DeleteCoaContractShipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommissionArgs = {
  input: DeleteCommissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommissionByExternalIdAndVoyageCharterIdArgs = {
  input: DeleteCommissionByExternalIdAndVoyageCharterIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommissionByIdArgs = {
  input: DeleteCommissionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommitLogScenarioArgs = {
  input: DeleteCommitLogScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommitLogScenarioByIdArgs = {
  input: DeleteCommitLogScenarioByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCostSplitOnScheduledOrderArgs = {
  input: DeleteCostSplitOnScheduledOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderIdArgs = {
  input: DeleteCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCostSplitOnScheduledOrderByIdArgs = {
  input: DeleteCostSplitOnScheduledOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCostSplitOnSingleEventArgs = {
  input: DeleteCostSplitOnSingleEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCostSplitOnSingleEventByActualCostIdAndSingleEventIdArgs = {
  input: DeleteCostSplitOnSingleEventByActualCostIdAndSingleEventIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCostSplitOnSingleEventByIdArgs = {
  input: DeleteCostSplitOnSingleEventByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCountryArgs = {
  input: DeleteCountryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCountryByIdArgs = {
  input: DeleteCountryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCountryByNumericArgs = {
  input: DeleteCountryByNumericInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDbChangeArgs = {
  input: DeleteDbChangeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDbChangeByIdArgs = {
  input: DeleteDbChangeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDemandArgs = {
  input: DeleteDemandInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDemandByIdArgs = {
  input: DeleteDemandByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailToOrderConfigArgs = {
  input: DeleteEmailToOrderConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailToOrderConfigByIdArgs = {
  input: DeleteEmailToOrderConfigByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailToOrderLogArgs = {
  input: DeleteEmailToOrderLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailToOrderLogByIdArgs = {
  input: DeleteEmailToOrderLogByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureArgs = {
  input: DeleteFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureByFeatureNameArgs = {
  input: DeleteFeatureByFeatureNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileArgs = {
  input: DeleteFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileByIdArgs = {
  input: DeleteFileByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGeographicalEntityArgs = {
  input: DeleteGeographicalEntityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGeographicalEntityByIdArgs = {
  input: DeleteGeographicalEntityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGeographicalRelationArgs = {
  input: DeleteGeographicalRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGeographicalRelationByIdArgs = {
  input: DeleteGeographicalRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandledByCoaArgs = {
  input: DeleteHandledByCoaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandledByCoaByIdArgs = {
  input: DeleteHandledByCoaByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandledByCoaByOrderIdArgs = {
  input: DeleteHandledByCoaByOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandledBySpotArgs = {
  input: DeleteHandledBySpotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandledBySpotByIdArgs = {
  input: DeleteHandledBySpotByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHandledBySpotByOrderIdArgs = {
  input: DeleteHandledBySpotByOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHolidayArgs = {
  input: DeleteHolidayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteHolidayByIdArgs = {
  input: DeleteHolidayByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIceClassArgs = {
  input: DeleteIceClassInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIceClassByIdArgs = {
  input: DeleteIceClassByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInstructionArgs = {
  input: DeleteInstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInstructionByIdArgs = {
  input: DeleteInstructionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIntegrationLogArgs = {
  input: DeleteIntegrationLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIntegrationLogByIdArgs = {
  input: DeleteIntegrationLogByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvoiceArgs = {
  input: DeleteInvoiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvoiceByIdArgs = {
  input: DeleteInvoiceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvoiceItemArgs = {
  input: DeleteInvoiceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvoiceItemByIdArgs = {
  input: DeleteInvoiceItemByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvoiceItemOrderArgs = {
  input: DeleteInvoiceItemOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInvoiceItemOrderByIdArgs = {
  input: DeleteInvoiceItemOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLaytimeResponsibilityArgs = {
  input: DeleteLaytimeResponsibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLaytimeResponsibilityByIdArgs = {
  input: DeleteLaytimeResponsibilityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationArgs = {
  input: DeleteLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationByIdArgs = {
  input: DeleteLocationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationClusterArgs = {
  input: DeleteLocationClusterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationClusterByIdArgs = {
  input: DeleteLocationClusterByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationRequirementAssociationArgs = {
  input: DeleteLocationRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationRequirementAssociationByIdArgs = {
  input: DeleteLocationRequirementAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneIdArgs = {
  input: DeleteLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationWorkingHourArgs = {
  input: DeleteLocationWorkingHourInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLocationWorkingHourByIdArgs = {
  input: DeleteLocationWorkingHourByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLostContractArgs = {
  input: DeleteLostContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLostContractByIdArgs = {
  input: DeleteLostContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMigrationArgs = {
  input: DeleteMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMigrationByIdArgs = {
  input: DeleteMigrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNoGoZoneArgs = {
  input: DeleteNoGoZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNoGoZoneByIdArgs = {
  input: DeleteNoGoZoneByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationReceiverByIdArgs = {
  input: DeleteNotificationReceiverByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOffHireArgs = {
  input: DeleteOffHireInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOffHireByIdArgs = {
  input: DeleteOffHireByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenPositionArgs = {
  input: DeleteOpenPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOpenPositionByIdArgs = {
  input: DeleteOpenPositionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderAttributeArgs = {
  input: DeleteOrderAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderAttributeAssociationArgs = {
  input: DeleteOrderAttributeAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderAttributeAssociationByIdArgs = {
  input: DeleteOrderAttributeAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderAttributeByIdArgs = {
  input: DeleteOrderAttributeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderByIdArgs = {
  input: DeleteOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderDetailArgs = {
  input: DeleteOrderDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderDetailByIdArgs = {
  input: DeleteOrderDetailByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderPortCallRelationArgs = {
  input: DeleteOrderPortCallRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderPortCallRelationByIdArgs = {
  input: DeleteOrderPortCallRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderPortCallRelationByOrderIdAndIsLoadPortArgs = {
  input: DeleteOrderPortCallRelationByOrderIdAndIsLoadPortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderPortOverrideArgs = {
  input: DeleteOrderPortOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderPortOverrideByOrderIdArgs = {
  input: DeleteOrderPortOverrideByOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderRequirementAssociationArgs = {
  input: DeleteOrderRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderRequirementAssociationByIdArgs = {
  input: DeleteOrderRequirementAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderRequirementAssociationBySpecialRequirementIdAndOrderIdArgs = {
  input: DeleteOrderRequirementAssociationBySpecialRequirementIdAndOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderVoyageCharterRelationArgs = {
  input: DeleteOrderVoyageCharterRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderVoyageCharterRelationByIdArgs = {
  input: DeleteOrderVoyageCharterRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrderVoyageCharterRelationByOrderIdAndOutgoingArgs = {
  input: DeleteOrderVoyageCharterRelationByOrderIdAndOutgoingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrganizationAreaBunkerGradeMappingArgs = {
  input: DeleteOrganizationAreaBunkerGradeMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaArgs = {
  input: DeleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrganizationByIdArgs = {
  input: DeleteOrganizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrganizationFeatureArgs = {
  input: DeleteOrganizationFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOrganizationFeatureByIdArgs = {
  input: DeleteOrganizationFeatureByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortActivityArgs = {
  input: DeletePortActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortActivityByIdArgs = {
  input: DeletePortActivityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCallArgs = {
  input: DeletePortCallInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCallByIdArgs = {
  input: DeletePortCallByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCallExternalTimestampArgs = {
  input: DeletePortCallExternalTimestampInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCallExternalTimestampByIdArgs = {
  input: DeletePortCallExternalTimestampByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCallFileArgs = {
  input: DeletePortCallFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCallFileByFileIdArgs = {
  input: DeletePortCallFileByFileIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCallFileByIdArgs = {
  input: DeletePortCallFileByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCommodityLdRateArgs = {
  input: DeletePortCommodityLdRateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCommodityLdRateByIdArgs = {
  input: DeletePortCommodityLdRateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCostArgs = {
  input: DeletePortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCostByIdArgs = {
  input: DeletePortCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCostDefaultArgs = {
  input: DeletePortCostDefaultInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCostDefaultByIdArgs = {
  input: DeletePortCostDefaultByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrencyArgs = {
  input: DeletePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrencyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCostEstimatesExternalArgs = {
  input: DeletePortCostEstimatesExternalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortCostEstimatesExternalByIdArgs = {
  input: DeletePortCostEstimatesExternalByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortDatumArgs = {
  input: DeletePortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortDatumByIdArgs = {
  input: DeletePortDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortNoticeArgs = {
  input: DeletePortNoticeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortNoticeByIdArgs = {
  input: DeletePortNoticeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortRegionArgs = {
  input: DeletePortRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortRegionByIdArgs = {
  input: DeletePortRegionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePortRegionByLocationIdAndRegionIdAndOrganizationIdArgs = {
  input: DeletePortRegionByLocationIdAndRegionIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePromptArgs = {
  input: DeletePromptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePromptByIdArgs = {
  input: DeletePromptByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteQuayArgs = {
  input: DeleteQuayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteQuayByIdArgs = {
  input: DeleteQuayByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReceiverOrganizationArgs = {
  input: DeleteReceiverOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReceiverOrganizationByAdminOrganizationIdAndOrganizationIdArgs = {
  input: DeleteReceiverOrganizationByAdminOrganizationIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReceiverOrganizationByIdArgs = {
  input: DeleteReceiverOrganizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRegionArgs = {
  input: DeleteRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRegionByIdArgs = {
  input: DeleteRegionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRequestLogArgs = {
  input: DeleteRequestLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRequestLogByIdArgs = {
  input: DeleteRequestLogByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRouteArgs = {
  input: DeleteRouteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZonesArgs = {
  input: DeleteRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZonesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRouteByIdArgs = {
  input: DeleteRouteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRouteOverrideArgs = {
  input: DeleteRouteOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRouteOverrideByIdArgs = {
  input: DeleteRouteOverrideByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannelsArgs = {
  input: DeleteRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannelsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoutePointArgs = {
  input: DeleteRoutePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoutePointByIdArgs = {
  input: DeleteRoutePointByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoutePointUsageArgs = {
  input: DeleteRoutePointUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRoutePointUsageByIdArgs = {
  input: DeleteRoutePointUsageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioArgs = {
  input: DeleteScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScenarioByIdArgs = {
  input: DeleteScenarioByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScheduledOrderArgs = {
  input: DeleteScheduledOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteScheduledOrderByIdArgs = {
  input: DeleteScheduledOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSeenMessageArgs = {
  input: DeleteSeenMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSeenMessageByIdArgs = {
  input: DeleteSeenMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSenderOrganizationArgs = {
  input: DeleteSenderOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSenderOrganizationByAdminOrganizationIdAndOrganizationIdArgs = {
  input: DeleteSenderOrganizationByAdminOrganizationIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSenderOrganizationByIdArgs = {
  input: DeleteSenderOrganizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipArgs = {
  input: DeleteShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipByIdArgs = {
  input: DeleteShipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipVoyageNamingRuleRelationArgs = {
  input: DeleteShipVoyageNamingRuleRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipVoyageNamingRuleRelationByIdArgs = {
  input: DeleteShipVoyageNamingRuleRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentArgs = {
  input: DeleteShipmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentByIdArgs = {
  input: DeleteShipmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentExternalStatusArgs = {
  input: DeleteShipmentExternalStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentExternalStatusByIdArgs = {
  input: DeleteShipmentExternalStatusByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentExtraFreightArgs = {
  input: DeleteShipmentExtraFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentExtraFreightByIdArgs = {
  input: DeleteShipmentExtraFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentFreightArgs = {
  input: DeleteShipmentFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentFreightByIdArgs = {
  input: DeleteShipmentFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentFreightByShipmentIdArgs = {
  input: DeleteShipmentFreightByShipmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentGroupArgs = {
  input: DeleteShipmentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentGroupAssociationArgs = {
  input: DeleteShipmentGroupAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentGroupAssociationByIdArgs = {
  input: DeleteShipmentGroupAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipmentGroupByIdArgs = {
  input: DeleteShipmentGroupByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShipnetConfigArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSingleEventArgs = {
  input: DeleteSingleEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSingleEventByIdArgs = {
  input: DeleteSingleEventByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSingleEventPortCallRelationArgs = {
  input: DeleteSingleEventPortCallRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSingleEventPortCallRelationByIdArgs = {
  input: DeleteSingleEventPortCallRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSpecialRequirementArgs = {
  input: DeleteSpecialRequirementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSpecialRequirementByIdArgs = {
  input: DeleteSpecialRequirementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSplitOrderArgs = {
  input: DeleteSplitOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSplitOrderByIdArgs = {
  input: DeleteSplitOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSpotNegotiationArgs = {
  input: DeleteSpotNegotiationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSpotNegotiationByIdArgs = {
  input: DeleteSpotNegotiationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStatementOfFactArgs = {
  input: DeleteStatementOfFactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStatementOfFactByIdArgs = {
  input: DeleteStatementOfFactByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSupplyArgs = {
  input: DeleteSupplyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSupplyByIdArgs = {
  input: DeleteSupplyByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSupplyContractArgs = {
  input: DeleteSupplyContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSupplyContractByIdArgs = {
  input: DeleteSupplyContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTankDistanceArgs = {
  input: DeleteTankDistanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTankDistanceByIdArgs = {
  input: DeleteTankDistanceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTcContractArgs = {
  input: DeleteTcContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTcContractByIdArgs = {
  input: DeleteTcContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTcContractByRootOrgAndExternalIdArgs = {
  input: DeleteTcContractByRootOrgAndExternalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByIdArgs = {
  input: DeleteUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRegionArgs = {
  input: DeleteUserRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRegionByIdArgs = {
  input: DeleteUserRegionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRightArgs = {
  input: DeleteUserRightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRightByIdArgs = {
  input: DeleteUserRightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRightByUserIdAndOrganizationIdArgs = {
  input: DeleteUserRightByUserIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserSettingArgs = {
  input: DeleteUserSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserSettingByIdArgs = {
  input: DeleteUserSettingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserShipArgs = {
  input: DeleteUserShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserShipByIdArgs = {
  input: DeleteUserShipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesonConfigArgs = {
  id: Scalars['Int']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselAttributeArgs = {
  input: DeleteVesselAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselAttributeAssortmentExclusionArgs = {
  input: DeleteVesselAttributeAssortmentExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselAttributeAssortmentExclusionByIdArgs = {
  input: DeleteVesselAttributeAssortmentExclusionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselAttributeByIdArgs = {
  input: DeleteVesselAttributeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselAttributeByOrganizationIdAndNameArgs = {
  input: DeleteVesselAttributeByOrganizationIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselAttributesAssociationArgs = {
  input: DeleteVesselAttributesAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselAttributesAssociationByIdArgs = {
  input: DeleteVesselAttributesAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselDraftDatapointArgs = {
  input: DeleteVesselDraftDatapointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselDraftDatapointByIdArgs = {
  input: DeleteVesselDraftDatapointByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselFulfillsRequirementAssociationArgs = {
  input: DeleteVesselFulfillsRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselFulfillsRequirementAssociationByIdArgs = {
  input: DeleteVesselFulfillsRequirementAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselInfoArgs = {
  input: DeleteVesselInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselInfoByIdArgs = {
  input: DeleteVesselInfoByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselInfoByImoArgs = {
  input: DeleteVesselInfoByImoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselPerformanceModelArgs = {
  input: DeleteVesselPerformanceModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselPerformanceModelByIdArgs = {
  input: DeleteVesselPerformanceModelByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselPerformanceModelByRootOrgAndShipIdArgs = {
  input: DeleteVesselPerformanceModelByRootOrgAndShipIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselReservationArgs = {
  input: DeleteVesselReservationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselReservationByIdArgs = {
  input: DeleteVesselReservationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselScheduleSharedToOrganizationArgs = {
  input: DeleteVesselScheduleSharedToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselScheduleSharedToOrganizationByIdArgs = {
  input: DeleteVesselScheduleSharedToOrganizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselScheduleSharedToOrganizationByVesselIdAndOrganizationIdArgs = {
  input: DeleteVesselScheduleSharedToOrganizationByVesselIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselSecretArgs = {
  input: DeleteVesselSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselSecretByIdArgs = {
  input: DeleteVesselSecretByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselSpeedConsumptionArgs = {
  input: DeleteVesselSpeedConsumptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVesselSpeedConsumptionByIdArgs = {
  input: DeleteVesselSpeedConsumptionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageArgs = {
  input: DeleteVoyageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageAssociationArgs = {
  input: DeleteVoyageAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageAssociationByIdArgs = {
  input: DeleteVoyageAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageAttributeArgs = {
  input: DeleteVoyageAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageAttributeByIdArgs = {
  input: DeleteVoyageAttributeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageAttributeByOrganizationIdAndNameAndColorArgs = {
  input: DeleteVoyageAttributeByOrganizationIdAndNameAndColorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageByIdArgs = {
  input: DeleteVoyageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterArgs = {
  input: DeleteVoyageCharterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterByIdArgs = {
  input: DeleteVoyageCharterByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterByRootOrgAndExternalIdArgs = {
  input: DeleteVoyageCharterByRootOrgAndExternalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterByRootOrgAndNameArgs = {
  input: DeleteVoyageCharterByRootOrgAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterExtraCostArgs = {
  input: DeleteVoyageCharterExtraCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterExtraCostByIdArgs = {
  input: DeleteVoyageCharterExtraCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterExtraFreightArgs = {
  input: DeleteVoyageCharterExtraFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterExtraFreightByIdArgs = {
  input: DeleteVoyageCharterExtraFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterOrderFreightArgs = {
  input: DeleteVoyageCharterOrderFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterOrderFreightByIdArgs = {
  input: DeleteVoyageCharterOrderFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterPortCostArgs = {
  input: DeleteVoyageCharterPortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterPortCostByIdArgs = {
  input: DeleteVoyageCharterPortCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterPortDatumArgs = {
  input: DeleteVoyageCharterPortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterPortDatumByIdArgs = {
  input: DeleteVoyageCharterPortDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterToContractArgs = {
  input: DeleteVoyageCharterToContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterToContractByIdArgs = {
  input: DeleteVoyageCharterToContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterUpdateArgs = {
  input: DeleteVoyageCharterUpdateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageCharterUpdateByIdArgs = {
  input: DeleteVoyageCharterUpdateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageNamingRuleArgs = {
  input: DeleteVoyageNamingRuleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVoyageNamingRuleByIdArgs = {
  input: DeleteVoyageNamingRuleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorldscaleFreightArgs = {
  input: DeleteWorldscaleFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorldscaleFreightByIdArgs = {
  input: DeleteWorldscaleFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYearArgs = {
  input: DeleteWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYearInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneArgs = {
  input: DeleteZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneByIdArgs = {
  input: DeleteZoneByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneLocationArgs = {
  input: DeleteZoneLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneLocationByIdArgs = {
  input: DeleteZoneLocationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteZoneLocationByZoneIdAndLocationIdArgs = {
  input: DeleteZoneLocationByZoneIdAndLocationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFindOrCreateLocationClusterArgs = {
  input: FindOrCreateLocationClusterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationFormatTimestampWithOffsetArgs = {
  input: FormatTimestampWithOffsetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateInitialsForAllUsersArgs = {
  input: GenerateInitialsForAllUsersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenericOrderImportArgs = {
  input: Array<InputMaybe<GenericOrderInput>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetMarcuraPortCostsArgs = {
  clientRunUuid?: InputMaybe<Scalars['String']['input']>;
  drainRemaining?: InputMaybe<Scalars['Int']['input']>;
  drainTotal?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<Array<GetMarcuraPortCostInput>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGoogleAuthenticateArgs = {
  input: GoogleAuthenticateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInactivateShipsArgs = {
  input: InactivateShipsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationLogoutArgs = {
  input: LogoutInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMapAssortmentSynonymToNameArgs = {
  input: MapAssortmentSynonymToNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMapLocationSynonymToNameArgs = {
  input: MapLocationSynonymToNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMicrosoftAuthenticateArgs = {
  input: MicrosoftAuthenticateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationOptimizeScheduleArgs = {
  method?: InputMaybe<ScheduleOptimizationMethod>;
  task: Scalars['JSON']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationParseImportedOrdersArgs = {
  input: ParsedImportedOrdersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationParseOrdersArgs = {
  input: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPortAgentsListFromSessOrgArgs = {
  input: PortAgentsListFromSessOrgInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPortCostDefaultsImportArgs = {
  input?: InputMaybe<Array<PortCostDefaultsImportInput>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPortCostEstimatesExternalImportArgs = {
  input?: InputMaybe<Array<CreatePortCostEstimatesExternalInput>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPublishOrdersArgs = {
  ids: Array<Scalars['OrderId']['input']>;
  shared: Scalars['Boolean']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveInvalidDateNoticeArgs = {
  input: RemoveInvalidDateNoticeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRequestResetPasswordArgs = {
  input: RequestResetPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRestoreOrderVoyageCharterRelationArgs = {
  input: RestoreOrderVoyageCharterRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSendersReceiversListFromSessOrgArgs = {
  input: SendersReceiversListFromSessOrgInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetUserActivatedArgs = {
  input: SetUserActivatedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSharedListFromSessOrgArgs = {
  input: SharedListFromSessOrgInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSoftDeleteOrdersArgs = {
  ids: Array<Scalars['OrderId']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSpeechToTextArgs = {
  input: SpeechToTextInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSyncTcContractByExternalIdArgs = {
  externalId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnarchiveByIdsArgs = {
  input?: InputMaybe<ArchiveInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActualCostArgs = {
  input: UpdateActualCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActualCostByIdArgs = {
  input: UpdateActualCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApiOrdersNoticeArgs = {
  input: UpdateApiOrdersNoticeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApiOrdersNoticeByIdArgs = {
  input: UpdateApiOrdersNoticeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssortmentArgs = {
  input: UpdateAssortmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssortmentByIdArgs = {
  input: UpdateAssortmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssortmentExclusionArgs = {
  input: UpdateAssortmentExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssortmentExclusionByIdArgs = {
  input: UpdateAssortmentExclusionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssortmentGroupArgs = {
  input: UpdateAssortmentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssortmentGroupByIdArgs = {
  input: UpdateAssortmentGroupByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBatchUpdateArgs = {
  input: UpdateBatchUpdateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBatchUpdateByIdArgs = {
  input: UpdateBatchUpdateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBillOfLadingArgs = {
  input: UpdateBillOfLadingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBillOfLadingByIdArgs = {
  input: UpdateBillOfLadingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBillOfLadingDatumArgs = {
  input: UpdateBillOfLadingDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBillOfLadingDatumByIdArgs = {
  input: UpdateBillOfLadingDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeCalculationArgs = {
  input: UpdateBunkerGradeCalculationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeCalculationByIdArgs = {
  input: UpdateBunkerGradeCalculationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeIdArgs = {
  input: UpdateBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeMappingArgs = {
  input: UpdateBunkerGradeMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeMappingByIdArgs = {
  input: UpdateBunkerGradeMappingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeMappingByOrganizationIdAndFromGradeIdArgs = {
  input: UpdateBunkerGradeMappingByOrganizationIdAndFromGradeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeOverrideArgs = {
  input: UpdateBunkerGradeOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeOverrideByGradeNameAndOrganizationIdArgs = {
  input: UpdateBunkerGradeOverrideByGradeNameAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkerGradeOverrideByIdArgs = {
  input: UpdateBunkerGradeOverrideByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkeringArgs = {
  input: UpdateBunkeringInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBunkeringByIdArgs = {
  input: UpdateBunkeringByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCarbonPriceOverrideArgs = {
  input: UpdateCarbonPriceOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCarbonPriceOverrideByIdArgs = {
  input: UpdateCarbonPriceOverrideByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoCompartmentArgs = {
  input: UpdateCargoCompartmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoCompartmentAllocationArgs = {
  input: UpdateCargoCompartmentAllocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoCompartmentAllocationByIdArgs = {
  input: UpdateCargoCompartmentAllocationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoCompartmentByIdArgs = {
  input: UpdateCargoCompartmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoEquipmentArgs = {
  input: UpdateCargoEquipmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoEquipmentByIdArgs = {
  input: UpdateCargoEquipmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoExclusionArgs = {
  input: UpdateCargoExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoExclusionByIdArgs = {
  input: UpdateCargoExclusionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoLengthUnitArgs = {
  input: UpdateCargoLengthUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoLengthUnitByIdArgs = {
  input: UpdateCargoLengthUnitByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoMeasurementArgs = {
  input: UpdateCargoMeasurementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoMeasurementByIdArgs = {
  input: UpdateCargoMeasurementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoUnitArgs = {
  input: UpdateCargoUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoUnitByIdArgs = {
  input: UpdateCargoUnitByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoUnitsConversionByExtraUnitNameArgs = {
  input: UpdateCargoUnitsConversionByExtraUnitNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoWeightUnitArgs = {
  input: UpdateCargoWeightUnitInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCargoWeightUnitByIdArgs = {
  input: UpdateCargoWeightUnitByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelArgs = {
  input: UpdateChannelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelByIdArgs = {
  input: UpdateChannelByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelCostArgs = {
  input: UpdateChannelCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelCostByIdArgs = {
  input: UpdateChannelCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelCostEstimateArgs = {
  input: UpdateChannelCostEstimateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelCostEstimateByIdArgs = {
  input: UpdateChannelCostEstimateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelIncompatibilityArgs = {
  input: UpdateChannelIncompatibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelIncompatibilityByIdArgs = {
  input: UpdateChannelIncompatibilityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChannelIncompatibilityByVesselAttributeIdAndChannelNameArgs = {
  input: UpdateChannelIncompatibilityByVesselAttributeIdAndChannelNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChatArgs = {
  input: UpdateChatInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateChatByIdArgs = {
  input: UpdateChatByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClassSocietyAssociationArgs = {
  input: UpdateClassSocietyAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClassSocietyAssociationByIdArgs = {
  input: UpdateClassSocietyAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClassificationSocietyArgs = {
  input: UpdateClassificationSocietyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClassificationSocietyByIdArgs = {
  input: UpdateClassificationSocietyByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractArgs = {
  input: UpdateCoaContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractAssortmentArgs = {
  input: UpdateCoaContractAssortmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractAssortmentByIdArgs = {
  input: UpdateCoaContractAssortmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractBunkerArgs = {
  input: UpdateCoaContractBunkerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractBunkerByIdArgs = {
  input: UpdateCoaContractBunkerByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractByIdArgs = {
  input: UpdateCoaContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractCommissionArgs = {
  input: UpdateCoaContractCommissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractCommissionByIdArgs = {
  input: UpdateCoaContractCommissionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractDeviationCostArgs = {
  input: UpdateCoaContractDeviationCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractDeviationCostByIdArgs = {
  input: UpdateCoaContractDeviationCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortArgs = {
  input: UpdateCoaContractPortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortByCoaContractIdAndOriginIdAndDestinationIdArgs = {
  input: UpdateCoaContractPortByCoaContractIdAndOriginIdAndDestinationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortByIdArgs = {
  input: UpdateCoaContractPortByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortCostArgs = {
  input: UpdateCoaContractPortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortCostByIdArgs = {
  input: UpdateCoaContractPortCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortCostByLocationIdAndShipIdArgs = {
  input: UpdateCoaContractPortCostByLocationIdAndShipIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortCostByLocationIdAndVesselTypeIdArgs = {
  input: UpdateCoaContractPortCostByLocationIdAndVesselTypeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortDatumArgs = {
  input: UpdateCoaContractPortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPortDatumByIdArgs = {
  input: UpdateCoaContractPortDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPriceArgs = {
  input: UpdateCoaContractPriceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractPriceByIdArgs = {
  input: UpdateCoaContractPriceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractShipArgs = {
  input: UpdateCoaContractShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractShipByCoaContractIdAndShipIdArgs = {
  input: UpdateCoaContractShipByCoaContractIdAndShipIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCoaContractShipByIdArgs = {
  input: UpdateCoaContractShipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommissionArgs = {
  input: UpdateCommissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommissionByExternalIdAndVoyageCharterIdArgs = {
  input: UpdateCommissionByExternalIdAndVoyageCharterIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommissionByIdArgs = {
  input: UpdateCommissionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommitLogScenarioArgs = {
  input: UpdateCommitLogScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommitLogScenarioByIdArgs = {
  input: UpdateCommitLogScenarioByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConfirmedVoyagesArgs = {
  scenarioCid?: InputMaybe<Scalars['String']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCostSplitOnScheduledOrderArgs = {
  input: UpdateCostSplitOnScheduledOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderIdArgs = {
  input: UpdateCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCostSplitOnScheduledOrderByIdArgs = {
  input: UpdateCostSplitOnScheduledOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCostSplitOnSingleEventArgs = {
  input: UpdateCostSplitOnSingleEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCostSplitOnSingleEventByActualCostIdAndSingleEventIdArgs = {
  input: UpdateCostSplitOnSingleEventByActualCostIdAndSingleEventIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCostSplitOnSingleEventByIdArgs = {
  input: UpdateCostSplitOnSingleEventByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCountryByIdArgs = {
  input: UpdateCountryByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCountryByNumericArgs = {
  input: UpdateCountryByNumericInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDbChangeArgs = {
  input: UpdateDbChangeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDbChangeByIdArgs = {
  input: UpdateDbChangeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDemandArgs = {
  input: UpdateDemandInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDemandByIdArgs = {
  input: UpdateDemandByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailToOrderConfigArgs = {
  input: UpdateEmailToOrderConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailToOrderConfigByIdArgs = {
  input: UpdateEmailToOrderConfigByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailToOrderLogArgs = {
  input: UpdateEmailToOrderLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailToOrderLogByIdArgs = {
  input: UpdateEmailToOrderLogByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureArgs = {
  input: UpdateFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureByFeatureNameArgs = {
  input: UpdateFeatureByFeatureNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileArgs = {
  input: UpdateFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileByIdArgs = {
  input: UpdateFileByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGeographicalEntityArgs = {
  input: UpdateGeographicalEntityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGeographicalEntityByIdArgs = {
  input: UpdateGeographicalEntityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGeographicalRelationArgs = {
  input: UpdateGeographicalRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGeographicalRelationByIdArgs = {
  input: UpdateGeographicalRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandledByCoaArgs = {
  input: UpdateHandledByCoaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandledByCoaByIdArgs = {
  input: UpdateHandledByCoaByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandledByCoaByOrderIdArgs = {
  input: UpdateHandledByCoaByOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandledBySpotArgs = {
  input: UpdateHandledBySpotInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandledBySpotByIdArgs = {
  input: UpdateHandledBySpotByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHandledBySpotByOrderIdArgs = {
  input: UpdateHandledBySpotByOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHolidayArgs = {
  input: UpdateHolidayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateHolidayByIdArgs = {
  input: UpdateHolidayByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIceClassArgs = {
  input: UpdateIceClassInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIceClassByIdArgs = {
  input: UpdateIceClassByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInstructionArgs = {
  input: UpdateInstructionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInstructionByIdArgs = {
  input: UpdateInstructionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationLogArgs = {
  input: UpdateIntegrationLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationLogByIdArgs = {
  input: UpdateIntegrationLogByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvoiceByIdArgs = {
  input: UpdateInvoiceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvoiceItemArgs = {
  input: UpdateInvoiceItemInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvoiceItemByIdArgs = {
  input: UpdateInvoiceItemByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvoiceItemOrderArgs = {
  input: UpdateInvoiceItemOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInvoiceItemOrderByIdArgs = {
  input: UpdateInvoiceItemOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLaytimeResponsibilityArgs = {
  input: UpdateLaytimeResponsibilityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLaytimeResponsibilityByIdArgs = {
  input: UpdateLaytimeResponsibilityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationByIdArgs = {
  input: UpdateLocationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationClusterArgs = {
  input: UpdateLocationClusterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationClusterByIdArgs = {
  input: UpdateLocationClusterByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationRequirementAssociationArgs = {
  input: UpdateLocationRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationRequirementAssociationByIdArgs = {
  input: UpdateLocationRequirementAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneIdArgs = {
  input: UpdateLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationWorkingHourArgs = {
  input: UpdateLocationWorkingHourInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLocationWorkingHourByIdArgs = {
  input: UpdateLocationWorkingHourByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLostContractArgs = {
  input: UpdateLostContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLostContractByIdArgs = {
  input: UpdateLostContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateManySapArgs = {
  input: Array<UpdateSapInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMigrationArgs = {
  input: UpdateMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMigrationByIdArgs = {
  input: UpdateMigrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNoGoZoneArgs = {
  input: UpdateNoGoZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNoGoZoneByIdArgs = {
  input: UpdateNoGoZoneByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationReceiverByIdArgs = {
  input: UpdateNotificationReceiverByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOffHireArgs = {
  input: UpdateOffHireInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOffHireByIdArgs = {
  input: UpdateOffHireByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenPositionArgs = {
  input: UpdateOpenPositionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOpenPositionByIdArgs = {
  input: UpdateOpenPositionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderAttributeArgs = {
  input: UpdateOrderAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderAttributeAssociationArgs = {
  input: UpdateOrderAttributeAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderAttributeAssociationByIdArgs = {
  input: UpdateOrderAttributeAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderAttributeByIdArgs = {
  input: UpdateOrderAttributeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderByIdArgs = {
  input: UpdateOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderDetailArgs = {
  input: UpdateOrderDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderDetailByIdArgs = {
  input: UpdateOrderDetailByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderPortCallRelationArgs = {
  input: UpdateOrderPortCallRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderPortCallRelationByIdArgs = {
  input: UpdateOrderPortCallRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderPortCallRelationByOrderIdAndIsLoadPortArgs = {
  input: UpdateOrderPortCallRelationByOrderIdAndIsLoadPortInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderPortOverrideArgs = {
  input: UpdateOrderPortOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderPortOverrideByOrderIdArgs = {
  input: UpdateOrderPortOverrideByOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderRequirementAssociationArgs = {
  input: UpdateOrderRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderRequirementAssociationByIdArgs = {
  input: UpdateOrderRequirementAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderRequirementAssociationBySpecialRequirementIdAndOrderIdArgs = {
  input: UpdateOrderRequirementAssociationBySpecialRequirementIdAndOrderIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderVoyageCharterRelationArgs = {
  input: UpdateOrderVoyageCharterRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderVoyageCharterRelationByIdArgs = {
  input: UpdateOrderVoyageCharterRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrderVoyageCharterRelationByOrderIdAndOutgoingArgs = {
  input: UpdateOrderVoyageCharterRelationByOrderIdAndOutgoingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrdersAfterLocationTimezoneChangeArgs = {
  input: UpdateOrdersAfterLocationTimezoneChangeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrgDescendantsArgs = {
  input: UpdateOrgDescendantsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationAreaBunkerGradeMappingArgs = {
  input: UpdateOrganizationAreaBunkerGradeMappingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaArgs = {
  input: UpdateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationByIdArgs = {
  input: UpdateOrganizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationFeatureArgs = {
  input: UpdateOrganizationFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganizationFeatureByIdArgs = {
  input: UpdateOrganizationFeatureByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortActivityArgs = {
  input: UpdatePortActivityInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortActivityByIdArgs = {
  input: UpdatePortActivityByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCallArgs = {
  input: UpdatePortCallInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCallByIdArgs = {
  input: UpdatePortCallByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCallExternalTimestampArgs = {
  input: UpdatePortCallExternalTimestampInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCallExternalTimestampByIdArgs = {
  input: UpdatePortCallExternalTimestampByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCallExternalTimestampsArgs = {
  input: Array<UpdatePortCallExternalTimestampsInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCallFileArgs = {
  input: UpdatePortCallFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCallFileByFileIdArgs = {
  input: UpdatePortCallFileByFileIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCallFileByIdArgs = {
  input: UpdatePortCallFileByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCommodityLdRateArgs = {
  input: UpdatePortCommodityLdRateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCommodityLdRateByIdArgs = {
  input: UpdatePortCommodityLdRateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCostArgs = {
  input: UpdatePortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCostByIdArgs = {
  input: UpdatePortCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCostDefaultArgs = {
  input: UpdatePortCostDefaultInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCostDefaultByIdArgs = {
  input: UpdatePortCostDefaultByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrencyArgs = {
  input: UpdatePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrencyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCostEstimatesExternalArgs = {
  input: UpdatePortCostEstimatesExternalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortCostEstimatesExternalByIdArgs = {
  input: UpdatePortCostEstimatesExternalByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortDatumArgs = {
  input: UpdatePortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortDatumByIdArgs = {
  input: UpdatePortDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortNoticeArgs = {
  input: UpdatePortNoticeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortNoticeByIdArgs = {
  input: UpdatePortNoticeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortRegionArgs = {
  input: UpdatePortRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortRegionByIdArgs = {
  input: UpdatePortRegionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePortRegionByLocationIdAndRegionIdAndOrganizationIdArgs = {
  input: UpdatePortRegionByLocationIdAndRegionIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePromptArgs = {
  input: UpdatePromptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePromptByIdArgs = {
  input: UpdatePromptByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateQuayArgs = {
  input: UpdateQuayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateQuayByIdArgs = {
  input: UpdateQuayByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReceiverOrganizationArgs = {
  input: UpdateReceiverOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReceiverOrganizationByAdminOrganizationIdAndOrganizationIdArgs = {
  input: UpdateReceiverOrganizationByAdminOrganizationIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReceiverOrganizationByIdArgs = {
  input: UpdateReceiverOrganizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRegionArgs = {
  input: UpdateRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRegionByIdArgs = {
  input: UpdateRegionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRequestLogArgs = {
  input: UpdateRequestLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRequestLogByIdArgs = {
  input: UpdateRequestLogByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRouteArgs = {
  input: UpdateRouteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZonesArgs = {
  input: UpdateRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZonesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRouteByIdArgs = {
  input: UpdateRouteByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRouteOverrideArgs = {
  input: UpdateRouteOverrideInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRouteOverrideByIdArgs = {
  input: UpdateRouteOverrideByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannelsArgs = {
  input: UpdateRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannelsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoutePointArgs = {
  input: UpdateRoutePointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoutePointByIdArgs = {
  input: UpdateRoutePointByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoutePointUsageArgs = {
  input: UpdateRoutePointUsageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRoutePointUsageByIdArgs = {
  input: UpdateRoutePointUsageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSapArgs = {
  input: UpdateSapInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioArgs = {
  input: UpdateScenarioInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScenarioByIdArgs = {
  input: UpdateScenarioByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledOrderArgs = {
  input: UpdateScheduledOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateScheduledOrderByIdArgs = {
  input: UpdateScheduledOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSeenMessageArgs = {
  input: UpdateSeenMessageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSeenMessageByIdArgs = {
  input: UpdateSeenMessageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSenderOrganizationArgs = {
  input: UpdateSenderOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSenderOrganizationByAdminOrganizationIdAndOrganizationIdArgs = {
  input: UpdateSenderOrganizationByAdminOrganizationIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSenderOrganizationByIdArgs = {
  input: UpdateSenderOrganizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSessionOrgsArgs = {
  input: UpdateSessionOrgsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSessionOrgsInCurrentTreeArgs = {
  input: UpdateSessionOrgsInCurrentTreeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipArgs = {
  input: UpdateShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipByIdArgs = {
  input: UpdateShipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipVoyageNamingRuleRelationArgs = {
  input: UpdateShipVoyageNamingRuleRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipVoyageNamingRuleRelationByIdArgs = {
  input: UpdateShipVoyageNamingRuleRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentArgs = {
  input: UpdateShipmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentByIdArgs = {
  input: UpdateShipmentByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentExternalStatusArgs = {
  input: UpdateShipmentExternalStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentExternalStatusByIdArgs = {
  input: UpdateShipmentExternalStatusByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentExtraFreightArgs = {
  input: UpdateShipmentExtraFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentExtraFreightByIdArgs = {
  input: UpdateShipmentExtraFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentFreightArgs = {
  input: UpdateShipmentFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentFreightByIdArgs = {
  input: UpdateShipmentFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentFreightByShipmentIdArgs = {
  input: UpdateShipmentFreightByShipmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentGroupArgs = {
  input: UpdateShipmentGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentGroupAssociationArgs = {
  input: UpdateShipmentGroupAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentGroupAssociationByIdArgs = {
  input: UpdateShipmentGroupAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShipmentGroupByIdArgs = {
  input: UpdateShipmentGroupByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSingleEventArgs = {
  input: UpdateSingleEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSingleEventByIdArgs = {
  input: UpdateSingleEventByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSingleEventPortCallRelationArgs = {
  input: UpdateSingleEventPortCallRelationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSingleEventPortCallRelationByIdArgs = {
  input: UpdateSingleEventPortCallRelationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSpecialRequirementArgs = {
  input: UpdateSpecialRequirementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSpecialRequirementByIdArgs = {
  input: UpdateSpecialRequirementByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSplitOrderArgs = {
  input: UpdateSplitOrderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSplitOrderByIdArgs = {
  input: UpdateSplitOrderByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSpotNegotiationArgs = {
  input: UpdateSpotNegotiationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSpotNegotiationByIdArgs = {
  input: UpdateSpotNegotiationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStatementOfFactArgs = {
  input: UpdateStatementOfFactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStatementOfFactByIdArgs = {
  input: UpdateStatementOfFactByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSupplyArgs = {
  input: UpdateSupplyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSupplyByIdArgs = {
  input: UpdateSupplyByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSupplyContractArgs = {
  input: UpdateSupplyContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSupplyContractByIdArgs = {
  input: UpdateSupplyContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTankDistanceArgs = {
  input: UpdateTankDistanceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTankDistanceByIdArgs = {
  input: UpdateTankDistanceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTcContractArgs = {
  input: UpdateTcContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTcContractByIdArgs = {
  input: UpdateTcContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTcContractByRootOrgAndExternalIdArgs = {
  input: UpdateTcContractByRootOrgAndExternalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByIdArgs = {
  input: UpdateUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRegionArgs = {
  input: UpdateUserRegionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRegionByIdArgs = {
  input: UpdateUserRegionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRightArgs = {
  input: UpdateUserRightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRightByIdArgs = {
  input: UpdateUserRightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRightByUserIdAndOrganizationIdArgs = {
  input: UpdateUserRightByUserIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserSettingArgs = {
  input: UpdateUserSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserSettingByIdArgs = {
  input: UpdateUserSettingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserShipArgs = {
  input: UpdateUserShipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserShipByIdArgs = {
  input: UpdateUserShipByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselAttributeArgs = {
  input: UpdateVesselAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselAttributeAssortmentExclusionArgs = {
  input: UpdateVesselAttributeAssortmentExclusionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselAttributeAssortmentExclusionByIdArgs = {
  input: UpdateVesselAttributeAssortmentExclusionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselAttributeByIdArgs = {
  input: UpdateVesselAttributeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselAttributeByOrganizationIdAndNameArgs = {
  input: UpdateVesselAttributeByOrganizationIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselAttributesAssociationArgs = {
  input: UpdateVesselAttributesAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselAttributesAssociationByIdArgs = {
  input: UpdateVesselAttributesAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselDraftDatapointArgs = {
  input: UpdateVesselDraftDatapointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselDraftDatapointByIdArgs = {
  input: UpdateVesselDraftDatapointByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselFulfillsRequirementAssociationArgs = {
  input: UpdateVesselFulfillsRequirementAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselFulfillsRequirementAssociationByIdArgs = {
  input: UpdateVesselFulfillsRequirementAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselInfoArgs = {
  input: UpdateVesselInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselInfoByIdArgs = {
  input: UpdateVesselInfoByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselInfoByImoArgs = {
  input: UpdateVesselInfoByImoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselPerformanceModelArgs = {
  input: UpdateVesselPerformanceModelInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselPerformanceModelByIdArgs = {
  input: UpdateVesselPerformanceModelByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselPerformanceModelByRootOrgAndShipIdArgs = {
  input: UpdateVesselPerformanceModelByRootOrgAndShipIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselReservationArgs = {
  input: UpdateVesselReservationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselReservationByIdArgs = {
  input: UpdateVesselReservationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselScheduleSharedToOrganizationArgs = {
  input: UpdateVesselScheduleSharedToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselScheduleSharedToOrganizationByIdArgs = {
  input: UpdateVesselScheduleSharedToOrganizationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselScheduleSharedToOrganizationByVesselIdAndOrganizationIdArgs = {
  input: UpdateVesselScheduleSharedToOrganizationByVesselIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselSecretArgs = {
  input: UpdateVesselSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselSecretByIdArgs = {
  input: UpdateVesselSecretByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselSpeedConsumptionArgs = {
  input: UpdateVesselSpeedConsumptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVesselSpeedConsumptionByIdArgs = {
  input: UpdateVesselSpeedConsumptionByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageArgs = {
  input: UpdateVoyageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageAssociationArgs = {
  input: UpdateVoyageAssociationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageAssociationByIdArgs = {
  input: UpdateVoyageAssociationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageAttributeArgs = {
  input: UpdateVoyageAttributeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageAttributeByIdArgs = {
  input: UpdateVoyageAttributeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageAttributeByOrganizationIdAndNameAndColorArgs = {
  input: UpdateVoyageAttributeByOrganizationIdAndNameAndColorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageByIdArgs = {
  input: UpdateVoyageByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterArgs = {
  input: UpdateVoyageCharterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterByIdArgs = {
  input: UpdateVoyageCharterByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterByRootOrgAndExternalIdArgs = {
  input: UpdateVoyageCharterByRootOrgAndExternalIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterByRootOrgAndNameArgs = {
  input: UpdateVoyageCharterByRootOrgAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterExtraCostArgs = {
  input: UpdateVoyageCharterExtraCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterExtraCostByIdArgs = {
  input: UpdateVoyageCharterExtraCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterExtraFreightArgs = {
  input: UpdateVoyageCharterExtraFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterExtraFreightByIdArgs = {
  input: UpdateVoyageCharterExtraFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterOrderFreightArgs = {
  input: UpdateVoyageCharterOrderFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterOrderFreightByIdArgs = {
  input: UpdateVoyageCharterOrderFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterPortCostArgs = {
  input: UpdateVoyageCharterPortCostInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterPortCostByIdArgs = {
  input: UpdateVoyageCharterPortCostByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterPortDatumArgs = {
  input: UpdateVoyageCharterPortDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterPortDatumByIdArgs = {
  input: UpdateVoyageCharterPortDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterToContractArgs = {
  input: UpdateVoyageCharterToContractInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterToContractByIdArgs = {
  input: UpdateVoyageCharterToContractByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterUpdateArgs = {
  input: UpdateVoyageCharterUpdateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageCharterUpdateByIdArgs = {
  input: UpdateVoyageCharterUpdateByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageNamingRuleArgs = {
  input: UpdateVoyageNamingRuleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateVoyageNamingRuleByIdArgs = {
  input: UpdateVoyageNamingRuleByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorldscaleFreightArgs = {
  input: UpdateWorldscaleFreightInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorldscaleFreightByIdArgs = {
  input: UpdateWorldscaleFreightByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYearArgs = {
  input: UpdateWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYearInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneArgs = {
  input: UpdateZoneInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneByIdArgs = {
  input: UpdateZoneByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneLocationArgs = {
  input: UpdateZoneLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneLocationByIdArgs = {
  input: UpdateZoneLocationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateZoneLocationByZoneIdAndLocationIdArgs = {
  input: UpdateZoneLocationByZoneIdAndLocationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertBalticConfigArgs = {
  input: UpsertBalticConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMarcuraLocationArgs = {
  allowOverride?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertShipnetConfigArgs = {
  input: UpsertShipnetConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertVesonConfigArgs = {
  input: UpsertVesonConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertVoyageCharterCostsArgs = {
  input: UpsertVoyageCharterCostsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVcAndOrdersArgs = {
  input?: InputMaybe<VcAndOrdersInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVesonPortsSyncArgs = {
  portName?: InputMaybe<Scalars['String']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationVoyagePrefixGetNextIdsArgs = {
  input: VoyagePrefixGetNextIdsInput;
};

export type MvLatestPortCostByPortAndPrimaryAttribute = {
  __typename?: 'MvLatestPortCostByPortAndPrimaryAttribute';
  organizationId?: Maybe<Scalars['Int']['output']>;
  portCost?: Maybe<Scalars['BigFloat']['output']>;
  portCostCurrency?: Maybe<Scalars['String']['output']>;
  portName?: Maybe<Scalars['String']['output']>;
  portType?: Maybe<Scalars['String']['output']>;
  primaryAttributeId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `MvLatestPortCostByPortAndPrimaryAttribute`
 * object types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type MvLatestPortCostByPortAndPrimaryAttributeCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portCost` field. */
  portCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portName` field. */
  portName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portType` field. */
  portType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `MvLatestPortCostByPortAndPrimaryAttribute` object types. All fields are combined with a logical ‘and.’ */
export type MvLatestPortCostByPortAndPrimaryAttributeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MvLatestPortCostByPortAndPrimaryAttributeFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<MvLatestPortCostByPortAndPrimaryAttributeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MvLatestPortCostByPortAndPrimaryAttributeFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCost` field. */
  portCost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portName` field. */
  portName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portType` field. */
  portType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `MvLatestPortCostByPortAndPrimaryAttribute` values. */
export type MvLatestPortCostByPortAndPrimaryAttributesConnection = {
  __typename?: 'MvLatestPortCostByPortAndPrimaryAttributesConnection';
  /** A list of edges which contains the `MvLatestPortCostByPortAndPrimaryAttribute` and cursor to aid in pagination. */
  edges: Array<MvLatestPortCostByPortAndPrimaryAttributesEdge>;
  /** A list of `MvLatestPortCostByPortAndPrimaryAttribute` objects. */
  nodes: Array<Maybe<MvLatestPortCostByPortAndPrimaryAttribute>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MvLatestPortCostByPortAndPrimaryAttribute` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MvLatestPortCostByPortAndPrimaryAttribute` edge in the connection. */
export type MvLatestPortCostByPortAndPrimaryAttributesEdge = {
  __typename?: 'MvLatestPortCostByPortAndPrimaryAttributesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MvLatestPortCostByPortAndPrimaryAttribute` at the end of the edge. */
  node?: Maybe<MvLatestPortCostByPortAndPrimaryAttribute>;
};

/** Methods to use when ordering `MvLatestPortCostByPortAndPrimaryAttribute`. */
export enum MvLatestPortCostByPortAndPrimaryAttributesOrderBy {
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_COST_ASC = 'PORT_COST_ASC',
  PORT_COST_CURRENCY_ASC = 'PORT_COST_CURRENCY_ASC',
  PORT_COST_CURRENCY_DESC = 'PORT_COST_CURRENCY_DESC',
  PORT_COST_DESC = 'PORT_COST_DESC',
  PORT_NAME_ASC = 'PORT_NAME_ASC',
  PORT_NAME_DESC = 'PORT_NAME_DESC',
  PORT_TYPE_ASC = 'PORT_TYPE_ASC',
  PORT_TYPE_DESC = 'PORT_TYPE_DESC',
  PRIMARY_ATTRIBUTE_ID_ASC = 'PRIMARY_ATTRIBUTE_ID_ASC',
  PRIMARY_ATTRIBUTE_ID_DESC = 'PRIMARY_ATTRIBUTE_ID_DESC'
}

export type MvPortCostsByPortAndPrimaryAttribute = {
  __typename?: 'MvPortCostsByPortAndPrimaryAttribute';
  avg?: Maybe<Scalars['BigFloat']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['BigFloat']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['BigFloat']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  portCostCurrency?: Maybe<Scalars['String']['output']>;
  portName?: Maybe<Scalars['String']['output']>;
  portType?: Maybe<Scalars['String']['output']>;
  primaryAttributeId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `MvPortCostsByPortAndPrimaryAttribute` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type MvPortCostsByPortAndPrimaryAttributeCondition = {
  /** Checks for equality with the object’s `avg` field. */
  avg?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `count` field. */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `max` field. */
  max?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `median` field. */
  median?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `min` field. */
  min?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portName` field. */
  portName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portType` field. */
  portType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `MvPortCostsByPortAndPrimaryAttribute` object types. All fields are combined with a logical ‘and.’ */
export type MvPortCostsByPortAndPrimaryAttributeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MvPortCostsByPortAndPrimaryAttributeFilter>>;
  /** Filter by the object’s `avg` field. */
  avg?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<IntFilter>;
  /** Filter by the object’s `max` field. */
  max?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `median` field. */
  median?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `min` field. */
  min?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MvPortCostsByPortAndPrimaryAttributeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MvPortCostsByPortAndPrimaryAttributeFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portName` field. */
  portName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portType` field. */
  portType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `MvPortCostsByPortAndPrimaryAttribute` values. */
export type MvPortCostsByPortAndPrimaryAttributesConnection = {
  __typename?: 'MvPortCostsByPortAndPrimaryAttributesConnection';
  /** A list of edges which contains the `MvPortCostsByPortAndPrimaryAttribute` and cursor to aid in pagination. */
  edges: Array<MvPortCostsByPortAndPrimaryAttributesEdge>;
  /** A list of `MvPortCostsByPortAndPrimaryAttribute` objects. */
  nodes: Array<Maybe<MvPortCostsByPortAndPrimaryAttribute>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MvPortCostsByPortAndPrimaryAttribute` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MvPortCostsByPortAndPrimaryAttribute` edge in the connection. */
export type MvPortCostsByPortAndPrimaryAttributesEdge = {
  __typename?: 'MvPortCostsByPortAndPrimaryAttributesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MvPortCostsByPortAndPrimaryAttribute` at the end of the edge. */
  node?: Maybe<MvPortCostsByPortAndPrimaryAttribute>;
};

/** Methods to use when ordering `MvPortCostsByPortAndPrimaryAttribute`. */
export enum MvPortCostsByPortAndPrimaryAttributesOrderBy {
  AVG_ASC = 'AVG_ASC',
  AVG_DESC = 'AVG_DESC',
  COUNT_ASC = 'COUNT_ASC',
  COUNT_DESC = 'COUNT_DESC',
  MAX_ASC = 'MAX_ASC',
  MAX_DESC = 'MAX_DESC',
  MEDIAN_ASC = 'MEDIAN_ASC',
  MEDIAN_DESC = 'MEDIAN_DESC',
  MIN_ASC = 'MIN_ASC',
  MIN_DESC = 'MIN_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_COST_CURRENCY_ASC = 'PORT_COST_CURRENCY_ASC',
  PORT_COST_CURRENCY_DESC = 'PORT_COST_CURRENCY_DESC',
  PORT_NAME_ASC = 'PORT_NAME_ASC',
  PORT_NAME_DESC = 'PORT_NAME_DESC',
  PORT_TYPE_ASC = 'PORT_TYPE_ASC',
  PORT_TYPE_DESC = 'PORT_TYPE_DESC',
  PRIMARY_ATTRIBUTE_ID_ASC = 'PRIMARY_ATTRIBUTE_ID_ASC',
  PRIMARY_ATTRIBUTE_ID_DESC = 'PRIMARY_ATTRIBUTE_ID_DESC'
}

export type MvPortCostsByPortAndVesselName = {
  __typename?: 'MvPortCostsByPortAndVesselName';
  avg?: Maybe<Scalars['BigFloat']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['BigFloat']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['BigFloat']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  portCostCurrency?: Maybe<Scalars['String']['output']>;
  portName?: Maybe<Scalars['String']['output']>;
  portType?: Maybe<Scalars['String']['output']>;
  vesselName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `MvPortCostsByPortAndVesselName` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type MvPortCostsByPortAndVesselNameCondition = {
  /** Checks for equality with the object’s `avg` field. */
  avg?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `count` field. */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `max` field. */
  max?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `median` field. */
  median?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `min` field. */
  min?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portName` field. */
  portName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portType` field. */
  portType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vesselName` field. */
  vesselName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MvPortCostsByPortAndVesselName` object types. All fields are combined with a logical ‘and.’ */
export type MvPortCostsByPortAndVesselNameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MvPortCostsByPortAndVesselNameFilter>>;
  /** Filter by the object’s `avg` field. */
  avg?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<IntFilter>;
  /** Filter by the object’s `max` field. */
  max?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `median` field. */
  median?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `min` field. */
  min?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MvPortCostsByPortAndVesselNameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MvPortCostsByPortAndVesselNameFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portName` field. */
  portName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portType` field. */
  portType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vesselName` field. */
  vesselName?: InputMaybe<StringFilter>;
};

/** A connection to a list of `MvPortCostsByPortAndVesselName` values. */
export type MvPortCostsByPortAndVesselNamesConnection = {
  __typename?: 'MvPortCostsByPortAndVesselNamesConnection';
  /** A list of edges which contains the `MvPortCostsByPortAndVesselName` and cursor to aid in pagination. */
  edges: Array<MvPortCostsByPortAndVesselNamesEdge>;
  /** A list of `MvPortCostsByPortAndVesselName` objects. */
  nodes: Array<Maybe<MvPortCostsByPortAndVesselName>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MvPortCostsByPortAndVesselName` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MvPortCostsByPortAndVesselName` edge in the connection. */
export type MvPortCostsByPortAndVesselNamesEdge = {
  __typename?: 'MvPortCostsByPortAndVesselNamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MvPortCostsByPortAndVesselName` at the end of the edge. */
  node?: Maybe<MvPortCostsByPortAndVesselName>;
};

/** Methods to use when ordering `MvPortCostsByPortAndVesselName`. */
export enum MvPortCostsByPortAndVesselNamesOrderBy {
  AVG_ASC = 'AVG_ASC',
  AVG_DESC = 'AVG_DESC',
  COUNT_ASC = 'COUNT_ASC',
  COUNT_DESC = 'COUNT_DESC',
  MAX_ASC = 'MAX_ASC',
  MAX_DESC = 'MAX_DESC',
  MEDIAN_ASC = 'MEDIAN_ASC',
  MEDIAN_DESC = 'MEDIAN_DESC',
  MIN_ASC = 'MIN_ASC',
  MIN_DESC = 'MIN_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_COST_CURRENCY_ASC = 'PORT_COST_CURRENCY_ASC',
  PORT_COST_CURRENCY_DESC = 'PORT_COST_CURRENCY_DESC',
  PORT_NAME_ASC = 'PORT_NAME_ASC',
  PORT_NAME_DESC = 'PORT_NAME_DESC',
  PORT_TYPE_ASC = 'PORT_TYPE_ASC',
  PORT_TYPE_DESC = 'PORT_TYPE_DESC',
  VESSEL_NAME_ASC = 'VESSEL_NAME_ASC',
  VESSEL_NAME_DESC = 'VESSEL_NAME_DESC'
}

export type NoGoZone = Node & {
  __typename?: 'NoGoZone';
  id: Scalars['NoGoZoneId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `NoGoZone`. */
  organizationByRootOrg?: Maybe<Organization>;
  polygon: Array<Maybe<Latlng>>;
  rootOrg: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `NoGoZone` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type NoGoZoneCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['NoGoZoneId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `polygon` field. */
  polygon?: InputMaybe<Array<InputMaybe<LatlngInput>>>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `NoGoZone` object types. All fields are combined with a logical ‘and.’ */
export type NoGoZoneFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NoGoZoneFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NoGoZoneFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NoGoZoneFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `NoGoZone` */
export type NoGoZoneInput = {
  name: Scalars['String']['input'];
  polygon: Array<InputMaybe<LatlngInput>>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Represents an update to a `NoGoZone`. Fields that are set will be updated. */
export type NoGoZonePatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  polygon?: InputMaybe<Array<InputMaybe<LatlngInput>>>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `NoGoZone` values. */
export type NoGoZonesConnection = {
  __typename?: 'NoGoZonesConnection';
  /** A list of edges which contains the `NoGoZone` and cursor to aid in pagination. */
  edges: Array<NoGoZonesEdge>;
  /** A list of `NoGoZone` objects. */
  nodes: Array<Maybe<NoGoZone>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NoGoZone` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NoGoZone` edge in the connection. */
export type NoGoZonesEdge = {
  __typename?: 'NoGoZonesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NoGoZone` at the end of the edge. */
  node?: Maybe<NoGoZone>;
};

/** Methods to use when ordering `NoGoZone`. */
export enum NoGoZonesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  POLYGON_ASC = 'POLYGON_ASC',
  POLYGON_DESC = 'POLYGON_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type NotificationReceiver = {
  __typename?: 'NotificationReceiver';
  email: Scalars['Email']['output'];
  id: Scalars['Int']['output'];
  /** Reads a single `Location` that is related to this `NotificationReceiver`. */
  locationByLocationId?: Maybe<Location>;
  locationId?: Maybe<Scalars['LocationId']['output']>;
  /** Reads a single `Order` that is related to this `NotificationReceiver`. */
  orderByOrderId?: Maybe<Order>;
  orderId?: Maybe<Scalars['OrderId']['output']>;
  /** Reads a single `Shipment` that is related to this `NotificationReceiver`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['ShipmentId']['output']>;
  /** Reads a single `User` that is related to this `NotificationReceiver`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  /** Reads a single `Voyage` that is related to this `NotificationReceiver`. */
  voyageByVoyageId?: Maybe<Voyage>;
  voyageId?: Maybe<Scalars['VoyageId']['output']>;
};

/**
 * A condition to be used against `NotificationReceiver` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type NotificationReceiverCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['Email']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `voyageId` field. */
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** A filter to be used against `NotificationReceiver` object types. All fields are combined with a logical ‘and.’ */
export type NotificationReceiverFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationReceiverFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<EmailFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationReceiverFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationReceiverFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageId` field. */
  voyageId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `NotificationReceiver` */
export type NotificationReceiverInput = {
  email: Scalars['Email']['input'];
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  userId: Scalars['UserId']['input'];
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** Represents an update to a `NotificationReceiver`. Fields that are set will be updated. */
export type NotificationReceiverPatch = {
  email?: InputMaybe<Scalars['Email']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** A connection to a list of `NotificationReceiver` values. */
export type NotificationReceiversConnection = {
  __typename?: 'NotificationReceiversConnection';
  /** A list of edges which contains the `NotificationReceiver` and cursor to aid in pagination. */
  edges: Array<NotificationReceiversEdge>;
  /** A list of `NotificationReceiver` objects. */
  nodes: Array<Maybe<NotificationReceiver>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationReceiver` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `NotificationReceiver` edge in the connection. */
export type NotificationReceiversEdge = {
  __typename?: 'NotificationReceiversEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NotificationReceiver` at the end of the edge. */
  node?: Maybe<NotificationReceiver>;
};

/** Methods to use when ordering `NotificationReceiver`. */
export enum NotificationReceiversOrderBy {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VOYAGE_ID_ASC = 'VOYAGE_ID_ASC',
  VOYAGE_ID_DESC = 'VOYAGE_ID_DESC'
}

/** User notification settings for orders, load and discharge */
export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  dischargeDocumentUploaded?: Maybe<Scalars['Boolean']['output']>;
  dischargeEta?: Maybe<Scalars['Boolean']['output']>;
  dischargeEtb?: Maybe<Scalars['Boolean']['output']>;
  dischargeEtd?: Maybe<Scalars['Boolean']['output']>;
  dischargeMrSaved?: Maybe<Scalars['Boolean']['output']>;
  dischargeNorSaved?: Maybe<Scalars['Boolean']['output']>;
  dischargeSofSaved?: Maybe<Scalars['Boolean']['output']>;
  loadBlSaved?: Maybe<Scalars['Boolean']['output']>;
  loadDocumentUploaded?: Maybe<Scalars['Boolean']['output']>;
  loadEtaChanged?: Maybe<Scalars['Boolean']['output']>;
  loadEtbChanged?: Maybe<Scalars['Boolean']['output']>;
  loadEtdChanged?: Maybe<Scalars['Boolean']['output']>;
  loadNorSaved?: Maybe<Scalars['Boolean']['output']>;
  loadSofSaved?: Maybe<Scalars['Boolean']['output']>;
  orderPublishedEdited?: Maybe<Scalars['Boolean']['output']>;
  orderPublishedShippingPlan?: Maybe<Scalars['Boolean']['output']>;
  orderPublishedUnassignedShipment?: Maybe<Scalars['Boolean']['output']>;
  orderVesselChanged?: Maybe<Scalars['Boolean']['output']>;
  ordersUpsertedViaIntegration?: Maybe<Scalars['Boolean']['output']>;
};

/** A filter to be used against `NotificationSetting` object types. All fields are combined with a logical ‘and.’ */
export type NotificationSettingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationSettingFilter>>;
  /** Filter by the object’s `dischargeDocumentUploaded` field. */
  dischargeDocumentUploaded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargeEta` field. */
  dischargeEta?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargeEtb` field. */
  dischargeEtb?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargeEtd` field. */
  dischargeEtd?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargeMrSaved` field. */
  dischargeMrSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargeNorSaved` field. */
  dischargeNorSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargeSofSaved` field. */
  dischargeSofSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadBlSaved` field. */
  loadBlSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadDocumentUploaded` field. */
  loadDocumentUploaded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadEtaChanged` field. */
  loadEtaChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadEtbChanged` field. */
  loadEtbChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadEtdChanged` field. */
  loadEtdChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadNorSaved` field. */
  loadNorSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadSofSaved` field. */
  loadSofSaved?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationSettingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationSettingFilter>>;
  /** Filter by the object’s `orderPublishedEdited` field. */
  orderPublishedEdited?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `orderPublishedShippingPlan` field. */
  orderPublishedShippingPlan?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `orderPublishedUnassignedShipment` field. */
  orderPublishedUnassignedShipment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `orderVesselChanged` field. */
  orderVesselChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `ordersUpsertedViaIntegration` field. */
  ordersUpsertedViaIntegration?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `NotificationSetting` */
export type NotificationSettingInput = {
  dischargeDocumentUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  dischargeEta?: InputMaybe<Scalars['Boolean']['input']>;
  dischargeEtb?: InputMaybe<Scalars['Boolean']['input']>;
  dischargeEtd?: InputMaybe<Scalars['Boolean']['input']>;
  dischargeMrSaved?: InputMaybe<Scalars['Boolean']['input']>;
  dischargeNorSaved?: InputMaybe<Scalars['Boolean']['input']>;
  dischargeSofSaved?: InputMaybe<Scalars['Boolean']['input']>;
  loadBlSaved?: InputMaybe<Scalars['Boolean']['input']>;
  loadDocumentUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  loadEtaChanged?: InputMaybe<Scalars['Boolean']['input']>;
  loadEtbChanged?: InputMaybe<Scalars['Boolean']['input']>;
  loadEtdChanged?: InputMaybe<Scalars['Boolean']['input']>;
  loadNorSaved?: InputMaybe<Scalars['Boolean']['input']>;
  loadSofSaved?: InputMaybe<Scalars['Boolean']['input']>;
  orderPublishedEdited?: InputMaybe<Scalars['Boolean']['input']>;
  orderPublishedShippingPlan?: InputMaybe<Scalars['Boolean']['input']>;
  orderPublishedUnassignedShipment?: InputMaybe<Scalars['Boolean']['input']>;
  orderVesselChanged?: InputMaybe<Scalars['Boolean']['input']>;
  ordersUpsertedViaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OffHire = Node & {
  __typename?: 'OffHire';
  archived: Scalars['Boolean']['output'];
  /** Ballast bonus amount paid by charterer to owner for vessel delivery */
  ballastBonus?: Maybe<Scalars['BigFloat']['output']>;
  /** Whether the ballast bonus is subject to address commission */
  ballastBonusCommissionable?: Maybe<Scalars['Boolean']['output']>;
  clientId: Scalars['UUID']['output'];
  /** Address commission percentage paid to charterer during TC out period */
  commissionPct?: Maybe<Scalars['BigFloat']['output']>;
  duration: Scalars['BigInt']['output'];
  end: Scalars['Datetime']['output'];
  id: Scalars['OffHireId']['output'];
  locationAId: Scalars['LocationId']['output'];
  locationBId: Scalars['LocationId']['output'];
  /** Reads a single `Location` that is related to this `OffHire`. */
  locationByLocationAId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OffHire`. */
  locationByLocationBId?: Maybe<Location>;
  locked: Scalars['Boolean']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `OffHire`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OffHire`. */
  organizationByRootOrg?: Maybe<Organization>;
  planningOrganisationId: Scalars['OrganizationId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  shared: Scalars['Boolean']['output'];
  /** Reads a single `Ship` that is related to this `OffHire`. */
  shipByVesselId?: Maybe<Ship>;
  start: Scalars['Datetime']['output'];
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Daily TC out rate for the vessel during off-hire period */
  tcOutRate?: Maybe<Scalars['BigFloat']['output']>;
  type?: Maybe<OffHireType>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `OffHire`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `OffHire`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};

/** A condition to be used against `OffHire` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type OffHireCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `ballastBonus` field. */
  ballastBonus?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ballastBonusCommissionable` field. */
  ballastBonusCommissionable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `commissionPct` field. */
  commissionPct?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OffHireId']['input']>;
  /** Checks for equality with the object’s `locationAId` field. */
  locationAId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `locationBId` field. */
  locationBId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `locked` field. */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meta` field. */
  meta?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `tcOutRate` field. */
  tcOutRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<OffHireType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `OffHire` object types. All fields are combined with a logical ‘and.’ */
export type OffHireFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OffHireFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `ballastBonus` field. */
  ballastBonus?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ballastBonusCommissionable` field. */
  ballastBonusCommissionable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `commissionPct` field. */
  commissionPct?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationAId` field. */
  locationAId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationBId` field. */
  locationBId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locked` field. */
  locked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meta` field. */
  meta?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OffHireFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OffHireFilter>>;
  /** Filter by the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `tcOutRate` field. */
  tcOutRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<OffHireTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `OffHireHistory` values. */
export type OffHireHistoriesConnection = {
  __typename?: 'OffHireHistoriesConnection';
  /** A list of edges which contains the `OffHireHistory` and cursor to aid in pagination. */
  edges: Array<OffHireHistoriesEdge>;
  /** A list of `OffHireHistory` objects. */
  nodes: Array<Maybe<OffHireHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OffHireHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OffHireHistory` edge in the connection. */
export type OffHireHistoriesEdge = {
  __typename?: 'OffHireHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OffHireHistory` at the end of the edge. */
  node?: Maybe<OffHireHistory>;
};

/** Methods to use when ordering `OffHireHistory`. */
export enum OffHireHistoriesOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  BALLAST_BONUS_ASC = 'BALLAST_BONUS_ASC',
  BALLAST_BONUS_COMMISSIONABLE_ASC = 'BALLAST_BONUS_COMMISSIONABLE_ASC',
  BALLAST_BONUS_COMMISSIONABLE_DESC = 'BALLAST_BONUS_COMMISSIONABLE_DESC',
  BALLAST_BONUS_DESC = 'BALLAST_BONUS_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  COMMISSION_PCT_ASC = 'COMMISSION_PCT_ASC',
  COMMISSION_PCT_DESC = 'COMMISSION_PCT_DESC',
  DURATION_ASC = 'DURATION_ASC',
  DURATION_DESC = 'DURATION_DESC',
  END_ASC = 'END_ASC',
  END_DESC = 'END_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_A_ID_ASC = 'LOCATION_A_ID_ASC',
  LOCATION_A_ID_DESC = 'LOCATION_A_ID_DESC',
  LOCATION_B_ID_ASC = 'LOCATION_B_ID_ASC',
  LOCATION_B_ID_DESC = 'LOCATION_B_ID_DESC',
  LOCKED_ASC = 'LOCKED_ASC',
  LOCKED_DESC = 'LOCKED_DESC',
  META_ASC = 'META_ASC',
  META_DESC = 'META_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PLANNING_ORGANISATION_ID_ASC = 'PLANNING_ORGANISATION_ID_ASC',
  PLANNING_ORGANISATION_ID_DESC = 'PLANNING_ORGANISATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  START_ASC = 'START_ASC',
  START_DESC = 'START_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TC_OUT_RATE_ASC = 'TC_OUT_RATE_ASC',
  TC_OUT_RATE_DESC = 'TC_OUT_RATE_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for this table */
export type OffHireHistory = {
  __typename?: 'OffHireHistory';
  archived: Scalars['Boolean']['output'];
  ballastBonus?: Maybe<Scalars['BigFloat']['output']>;
  ballastBonusCommissionable?: Maybe<Scalars['Boolean']['output']>;
  clientId: Scalars['UUID']['output'];
  commissionPct?: Maybe<Scalars['BigFloat']['output']>;
  duration: Scalars['BigInt']['output'];
  end: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  locationAId: Scalars['Int']['output'];
  locationBId: Scalars['Int']['output'];
  locked: Scalars['Boolean']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  planningOrganisationId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  shared: Scalars['Boolean']['output'];
  start: Scalars['Datetime']['output'];
  sysPeriod: DatetimeRange;
  tcOutRate?: Maybe<Scalars['BigFloat']['output']>;
  type?: Maybe<OffHireType>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  userId: Scalars['Int']['output'];
  vesselId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `OffHireHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OffHireHistoryCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `ballastBonus` field. */
  ballastBonus?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ballastBonusCommissionable` field. */
  ballastBonusCommissionable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `commissionPct` field. */
  commissionPct?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `locationAId` field. */
  locationAId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `locationBId` field. */
  locationBId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `locked` field. */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meta` field. */
  meta?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `tcOutRate` field. */
  tcOutRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<OffHireType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `OffHireHistory` object types. All fields are combined with a logical ‘and.’ */
export type OffHireHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OffHireHistoryFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `ballastBonus` field. */
  ballastBonus?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ballastBonusCommissionable` field. */
  ballastBonusCommissionable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `commissionPct` field. */
  commissionPct?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationAId` field. */
  locationAId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationBId` field. */
  locationBId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locked` field. */
  locked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meta` field. */
  meta?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OffHireHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OffHireHistoryFilter>>;
  /** Filter by the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `tcOutRate` field. */
  tcOutRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<OffHireTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OffHire` */
export type OffHireInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ballast bonus amount paid by charterer to owner for vessel delivery */
  ballastBonus?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Whether the ballast bonus is subject to address commission */
  ballastBonusCommissionable?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Address commission percentage paid to charterer during TC out period */
  commissionPct?: InputMaybe<Scalars['BigFloat']['input']>;
  duration: Scalars['BigInt']['input'];
  end: Scalars['Datetime']['input'];
  locationAId: Scalars['LocationId']['input'];
  locationBId: Scalars['LocationId']['input'];
  locked: Scalars['Boolean']['input'];
  meta?: InputMaybe<Scalars['String']['input']>;
  planningOrganisationId: Scalars['OrganizationId']['input'];
  shared: Scalars['Boolean']['input'];
  start: Scalars['Datetime']['input'];
  /** Daily TC out rate for the vessel during off-hire period */
  tcOutRate?: InputMaybe<Scalars['BigFloat']['input']>;
  type?: InputMaybe<OffHireType>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['UserId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `OffHire`. Fields that are set will be updated. */
export type OffHirePatch = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ballast bonus amount paid by charterer to owner for vessel delivery */
  ballastBonus?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Whether the ballast bonus is subject to address commission */
  ballastBonusCommissionable?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Address commission percentage paid to charterer during TC out period */
  commissionPct?: InputMaybe<Scalars['BigFloat']['input']>;
  duration?: InputMaybe<Scalars['BigInt']['input']>;
  end?: InputMaybe<Scalars['Datetime']['input']>;
  locationAId?: InputMaybe<Scalars['LocationId']['input']>;
  locationBId?: InputMaybe<Scalars['LocationId']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  planningOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Datetime']['input']>;
  /** Daily TC out rate for the vessel during off-hire period */
  tcOutRate?: InputMaybe<Scalars['BigFloat']['input']>;
  type?: InputMaybe<OffHireType>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export enum OffHireType {
  DRY_DOCK = 'DRY_DOCK',
  VESSEL_CHARTERED_OUT = 'VESSEL_CHARTERED_OUT'
}

/** A filter to be used against OffHireType fields. All fields are combined with a logical ‘and.’ */
export type OffHireTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OffHireType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OffHireType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OffHireType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OffHireType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OffHireType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OffHireType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OffHireType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OffHireType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OffHireType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OffHireType>>;
};

/** A connection to a list of `OffHire` values. */
export type OffHiresConnection = {
  __typename?: 'OffHiresConnection';
  /** A list of edges which contains the `OffHire` and cursor to aid in pagination. */
  edges: Array<OffHiresEdge>;
  /** A list of `OffHire` objects. */
  nodes: Array<Maybe<OffHire>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OffHire` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OffHire` edge in the connection. */
export type OffHiresEdge = {
  __typename?: 'OffHiresEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OffHire` at the end of the edge. */
  node?: Maybe<OffHire>;
};

/** Methods to use when ordering `OffHire`. */
export enum OffHiresOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  BALLAST_BONUS_ASC = 'BALLAST_BONUS_ASC',
  BALLAST_BONUS_COMMISSIONABLE_ASC = 'BALLAST_BONUS_COMMISSIONABLE_ASC',
  BALLAST_BONUS_COMMISSIONABLE_DESC = 'BALLAST_BONUS_COMMISSIONABLE_DESC',
  BALLAST_BONUS_DESC = 'BALLAST_BONUS_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  COMMISSION_PCT_ASC = 'COMMISSION_PCT_ASC',
  COMMISSION_PCT_DESC = 'COMMISSION_PCT_DESC',
  DURATION_ASC = 'DURATION_ASC',
  DURATION_DESC = 'DURATION_DESC',
  END_ASC = 'END_ASC',
  END_DESC = 'END_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_A_ID_ASC = 'LOCATION_A_ID_ASC',
  LOCATION_A_ID_DESC = 'LOCATION_A_ID_DESC',
  LOCATION_B_ID_ASC = 'LOCATION_B_ID_ASC',
  LOCATION_B_ID_DESC = 'LOCATION_B_ID_DESC',
  LOCKED_ASC = 'LOCKED_ASC',
  LOCKED_DESC = 'LOCKED_DESC',
  META_ASC = 'META_ASC',
  META_DESC = 'META_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PLANNING_ORGANISATION_ID_ASC = 'PLANNING_ORGANISATION_ID_ASC',
  PLANNING_ORGANISATION_ID_DESC = 'PLANNING_ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  START_ASC = 'START_ASC',
  START_DESC = 'START_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TC_OUT_RATE_ASC = 'TC_OUT_RATE_ASC',
  TC_OUT_RATE_DESC = 'TC_OUT_RATE_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type OpenPosition = Node & {
  __typename?: 'OpenPosition';
  /** Timestamp of creation */
  createdAt: Scalars['Datetime']['output'];
  /** User that originally create the open position */
  createdByUserId?: Maybe<Scalars['UserId']['output']>;
  directionId?: Maybe<Scalars['LocationId']['output']>;
  id: Scalars['OpenPositionId']['output'];
  /** Reads a single `Location` that is related to this `OpenPosition`. */
  locationByDirectionId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OpenPosition`. */
  locationByStartPortId?: Maybe<Location>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `OpenPosition`. */
  organizationByRootOrg?: Maybe<Organization>;
  remark?: Maybe<Scalars['String']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `OpenPosition`. */
  shipByVesselId?: Maybe<Ship>;
  startPortId: Scalars['LocationId']['output'];
  startTime: Scalars['Datetime']['output'];
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `OpenPosition`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `OpenPosition`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId: Scalars['ShipId']['output'];
};

/**
 * A condition to be used against `OpenPosition` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OpenPositionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `directionId` field. */
  directionId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OpenPositionId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `remark` field. */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `startPortId` field. */
  startPortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `OpenPosition` object types. All fields are combined with a logical ‘and.’ */
export type OpenPositionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OpenPositionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `directionId` field. */
  directionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OpenPositionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OpenPositionFilter>>;
  /** Filter by the object’s `remark` field. */
  remark?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startPortId` field. */
  startPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `OpenPositionHistory` values. */
export type OpenPositionHistoriesConnection = {
  __typename?: 'OpenPositionHistoriesConnection';
  /** A list of edges which contains the `OpenPositionHistory` and cursor to aid in pagination. */
  edges: Array<OpenPositionHistoriesEdge>;
  /** A list of `OpenPositionHistory` objects. */
  nodes: Array<Maybe<OpenPositionHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenPositionHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OpenPositionHistory` edge in the connection. */
export type OpenPositionHistoriesEdge = {
  __typename?: 'OpenPositionHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OpenPositionHistory` at the end of the edge. */
  node?: Maybe<OpenPositionHistory>;
};

/** Methods to use when ordering `OpenPositionHistory`. */
export enum OpenPositionHistoriesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DIRECTION_ID_ASC = 'DIRECTION_ID_ASC',
  DIRECTION_ID_DESC = 'DIRECTION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  START_PORT_ID_ASC = 'START_PORT_ID_ASC',
  START_PORT_ID_DESC = 'START_PORT_ID_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for open_position table */
export type OpenPositionHistory = {
  __typename?: 'OpenPositionHistory';
  createdAt: Scalars['Datetime']['output'];
  createdByUserId?: Maybe<Scalars['UserId']['output']>;
  directionId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  rootOrg: Scalars['Int']['output'];
  startPortId: Scalars['Int']['output'];
  startTime: Scalars['Datetime']['output'];
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `OpenPositionHistory`. */
  userByCreatedByUserId?: Maybe<User>;
  vesselId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `OpenPositionHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OpenPositionHistoryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `directionId` field. */
  directionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startPortId` field. */
  startPortId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `OpenPositionHistory` object types. All fields are combined with a logical ‘and.’ */
export type OpenPositionHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OpenPositionHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `directionId` field. */
  directionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OpenPositionHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OpenPositionHistoryFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startPortId` field. */
  startPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OpenPosition` */
export type OpenPositionInput = {
  directionId?: InputMaybe<Scalars['LocationId']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startPortId: Scalars['LocationId']['input'];
  startTime: Scalars['Datetime']['input'];
  vesselId: Scalars['ShipId']['input'];
};

/** Represents an update to a `OpenPosition`. Fields that are set will be updated. */
export type OpenPositionPatch = {
  directionId?: InputMaybe<Scalars['LocationId']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startPortId?: InputMaybe<Scalars['LocationId']['input']>;
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type OpenPositionSubscriptionPayload = {
  __typename?: 'OpenPositionSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  openPosition?: Maybe<OpenPosition>;
};

/** A connection to a list of `OpenPosition` values. */
export type OpenPositionsConnection = {
  __typename?: 'OpenPositionsConnection';
  /** A list of edges which contains the `OpenPosition` and cursor to aid in pagination. */
  edges: Array<OpenPositionsEdge>;
  /** A list of `OpenPosition` objects. */
  nodes: Array<Maybe<OpenPosition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OpenPosition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OpenPosition` edge in the connection. */
export type OpenPositionsEdge = {
  __typename?: 'OpenPositionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OpenPosition` at the end of the edge. */
  node?: Maybe<OpenPosition>;
};

/** Methods to use when ordering `OpenPosition`. */
export enum OpenPositionsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DIRECTION_ID_ASC = 'DIRECTION_ID_ASC',
  DIRECTION_ID_DESC = 'DIRECTION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMARK_ASC = 'REMARK_ASC',
  REMARK_DESC = 'REMARK_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  START_PORT_ID_ASC = 'START_PORT_ID_ASC',
  START_PORT_ID_DESC = 'START_PORT_ID_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type OperationMethod = {
  arrivalTime?: InputMaybe<Scalars['Datetime']['input']>;
  engineLoad?: InputMaybe<Scalars['Float']['input']>;
  propellerRpm?: InputMaybe<Scalars['Float']['input']>;
  speedOverGround?: InputMaybe<Scalars['Float']['input']>;
};

export type Order = Node & {
  __typename?: 'Order';
  /** Reads and enables pagination through a set of `ApiOrdersNotice`. */
  apiOrdersNoticesByOrderId: ApiOrdersNoticesConnection;
  archived: Scalars['Boolean']['output'];
  /** Reads a single `Assortment` that is related to this `Order`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  assortmentId?: Maybe<Scalars['AssortmentId']['output']>;
  /** Reads and enables pagination through a set of `BillOfLadingDatum`. */
  billOfLadingDataByOrderId: BillOfLadingDataConnection;
  cancelling?: Maybe<Scalars['Datetime']['output']>;
  cargoAmount: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `CargoCompartmentAllocation`. */
  cargoCompartmentAllocationsByOrderId: CargoCompartmentAllocationsConnection;
  /** Reads and enables pagination through a set of `CargoExclusion`. */
  cargoExclusionsByOrderId: CargoExclusionsConnection;
  /** Reads and enables pagination through a set of `CargoMeasurement`. */
  cargoMeasurementsByOrderId: CargoMeasurementsConnection;
  /** Reads a single `CargoUnit` that is related to this `Order`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  cargoUnitId?: Maybe<Scalars['CargoUnitId']['output']>;
  /** Charterer organization of the order */
  chartererOrganizationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `Chat`. */
  chatsByOrderId: ChatsConnection;
  /** Reads a single `CoaContract` that is related to this `Order`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  coaId?: Maybe<Scalars['CoaContractId']['output']>;
  completed?: Maybe<Scalars['Datetime']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  deliveredBefore?: Maybe<Scalars['Datetime']['output']>;
  dischargeExternallyPlanned?: Maybe<Scalars['Boolean']['output']>;
  dischargePortCall?: Maybe<PortCall>;
  dischargePortId: Scalars['LocationId']['output'];
  dischargingDays?: Maybe<ShincShex>;
  dischargingOverheadDuration?: Maybe<Scalars['BigFloat']['output']>;
  dischargingRate?: Maybe<Scalars['BigFloat']['output']>;
  dischargingUnit?: Maybe<LoadingUnit>;
  externalGroupingId?: Maybe<Scalars['String']['output']>;
  externalIdDisplay?: Maybe<Scalars['String']['output']>;
  /** Used for ERP / CRM integrations */
  externalOrderId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `File`. */
  filesByOrderId: FilesConnection;
  freightAmount?: Maybe<Scalars['BigFloat']['output']>;
  freightCurrency?: Maybe<Currency>;
  freightUnit?: Maybe<PaymentUnit>;
  /** Reads a single `HandledByCoa` that is related to this `Order`. */
  handledByCoaByOrderId?: Maybe<HandledByCoa>;
  /**
   * Reads and enables pagination through a set of `HandledByCoa`.
   * @deprecated Please use handledByCoaByOrderId instead
   */
  handledByCoasByOrderId: HandledByCoasConnection;
  /** Reads a single `HandledBySpot` that is related to this `Order`. */
  handledBySpotByOrderId?: Maybe<HandledBySpot>;
  /**
   * Reads and enables pagination through a set of `HandledBySpot`.
   * @deprecated Please use handledBySpotByOrderId instead
   */
  handledBySpotsByOrderId: HandledBySpotsConnection;
  id: Scalars['OrderId']['output'];
  incomingVoyageCharterRelation?: Maybe<OrderVoyageCharterRelation>;
  /** Reads and enables pagination through a set of `Instruction`. */
  instructionsByOrderId: InstructionsConnection;
  /** Source system that created this order. */
  integrationSource?: Maybe<IntegrationSourceType>;
  /** Reads and enables pagination through a set of `InvoiceItemOrder`. */
  invoiceItemOrdersByOrderId: InvoiceItemOrdersConnection;
  layday?: Maybe<Scalars['Datetime']['output']>;
  loadExternallyPlanned?: Maybe<Scalars['Boolean']['output']>;
  loadPortCall?: Maybe<PortCall>;
  loadPortId?: Maybe<Scalars['LocationId']['output']>;
  loadingDays?: Maybe<ShincShex>;
  loadingOverheadDuration?: Maybe<Scalars['BigFloat']['output']>;
  loadingRate?: Maybe<Scalars['BigFloat']['output']>;
  loadingUnit?: Maybe<LoadingUnit>;
  /** Reads a single `Location` that is related to this `Order`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Order`. */
  locationByLoadPortId?: Maybe<Location>;
  marginAmount?: Maybe<Scalars['BigFloat']['output']>;
  marginUnit?: Maybe<MarginUnit>;
  /** Minimum vessel class requirement for the order */
  minVesselClassRequirement?: Maybe<Scalars['VesselAttributeId']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  nominatedVessel?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `NotificationReceiver`. */
  notificationReceiversByOrderId: NotificationReceiversConnection;
  numberOfPackages?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `OrderAttributeAssociation`. */
  orderAttributeAssociationsByOrderId: OrderAttributeAssociationsConnection;
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsByOrderId: OrderDetailsConnection;
  /** Reads and enables pagination through a set of `OrderPortCallRelation`. */
  orderPortCallRelationsByOrderId: OrderPortCallRelationsConnection;
  /** Reads a single `OrderPortOverride` that is related to this `Order`. */
  orderPortOverrideByOrderId?: Maybe<OrderPortOverride>;
  /**
   * Reads and enables pagination through a set of `OrderPortOverride`.
   * @deprecated Please use orderPortOverrideByOrderId instead
   */
  orderPortOverridesByOrderId: OrderPortOverridesConnection;
  /** Reads and enables pagination through a set of `OrderRequirementAssociation`. */
  orderRequirementAssociationsByOrderId: OrderRequirementAssociationsConnection;
  /** Reads and enables pagination through a set of `OrderVoyageCharterRelation`. */
  orderVoyageCharterRelationsByOrderId: OrderVoyageCharterRelationsConnection;
  /** Reads and enables pagination through a set of `OrdersHistory`. */
  ordersHistoriesById: OrdersHistoriesConnection;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByChartererOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** The organization that owns the order */
  organizationId: Scalars['OrganizationId']['output'];
  outgoingVoyageCharterRelation?: Maybe<OrderVoyageCharterRelation>;
  /** Nominated shipowner organization for the order */
  ownerOrganisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `PortActivity`. */
  portActivitiesByOrderId: PortActivitiesConnection;
  relatedOrgs?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  rta?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `ScheduledOrder`. */
  scheduledOrdersByOrderId: ScheduledOrdersConnection;
  /** Reads a single `Shipment` that is related to this `Order`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['ShipmentId']['output']>;
  /** Defines if an order is soft deleted or not through integration API on integration.nomkeyitems.deletionindicator */
  softDelete: Scalars['Boolean']['output'];
  specificGravity?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `SplitOrder`. */
  splitOrdersByFromOrderId: SplitOrdersConnection;
  /** Reads and enables pagination through a set of `SplitOrder`. */
  splitOrdersByToOrderId: SplitOrdersConnection;
  started?: Maybe<Scalars['Datetime']['output']>;
  stowageFactorMax?: Maybe<Scalars['BigFloat']['output']>;
  stowageFactorMin?: Maybe<Scalars['BigFloat']['output']>;
  stowageMode?: Maybe<StowageModeType>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Flag indicating order should be reviewed for deletion. */
  toBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `User` that is related to this `Order`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Order`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
  /** Reads a single `VesselAttribute` that is related to this `Order`. */
  vesselAttributeByMinVesselClassRequirement?: Maybe<VesselAttribute>;
  /** Reads and enables pagination through a set of `VoyageAssociation`. */
  voyageAssociationsByOrderId: VoyageAssociationsConnection;
  withoutGuarantee?: Maybe<Scalars['Boolean']['output']>;
};


export type OrderApiOrdersNoticesByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiOrdersNoticeCondition>;
  filter?: InputMaybe<ApiOrdersNoticeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiOrdersNoticesOrderBy>>;
};


export type OrderBillOfLadingDataByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillOfLadingDatumCondition>;
  filter?: InputMaybe<BillOfLadingDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOfLadingDataOrderBy>>;
};


export type OrderCargoCompartmentAllocationsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentAllocationCondition>;
  filter?: InputMaybe<CargoCompartmentAllocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};


export type OrderCargoExclusionsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoExclusionCondition>;
  filter?: InputMaybe<CargoExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoExclusionsOrderBy>>;
};


export type OrderCargoMeasurementsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoMeasurementCondition>;
  filter?: InputMaybe<CargoMeasurementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoMeasurementsOrderBy>>;
};


export type OrderChatsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChatCondition>;
  filter?: InputMaybe<ChatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};


export type OrderFilesByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type OrderHandledByCoasByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaCondition>;
  filter?: InputMaybe<HandledByCoaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};


export type OrderHandledBySpotsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotCondition>;
  filter?: InputMaybe<HandledBySpotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};


export type OrderInstructionsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InstructionCondition>;
  filter?: InputMaybe<InstructionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InstructionsOrderBy>>;
};


export type OrderInvoiceItemOrdersByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceItemOrderCondition>;
  filter?: InputMaybe<InvoiceItemOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoiceItemOrdersOrderBy>>;
};


export type OrderNotificationReceiversByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationReceiverCondition>;
  filter?: InputMaybe<NotificationReceiverFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};


export type OrderOrderAttributeAssociationsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderAttributeAssociationCondition>;
  filter?: InputMaybe<OrderAttributeAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderAttributeAssociationsOrderBy>>;
};


export type OrderOrderDetailsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};


export type OrderOrderPortCallRelationsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderPortCallRelationCondition>;
  filter?: InputMaybe<OrderPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderPortCallRelationsOrderBy>>;
};


export type OrderOrderPortOverridesByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderPortOverrideCondition>;
  filter?: InputMaybe<OrderPortOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderPortOverridesOrderBy>>;
};


export type OrderOrderRequirementAssociationsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderRequirementAssociationCondition>;
  filter?: InputMaybe<OrderRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderRequirementAssociationsOrderBy>>;
};


export type OrderOrderVoyageCharterRelationsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderVoyageCharterRelationCondition>;
  filter?: InputMaybe<OrderVoyageCharterRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};


export type OrderOrdersHistoriesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrdersHistoryCondition>;
  filter?: InputMaybe<OrdersHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersHistoriesOrderBy>>;
};


export type OrderPortActivitiesByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortActivityCondition>;
  filter?: InputMaybe<PortActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortActivitiesOrderBy>>;
};


export type OrderScheduledOrdersByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderCondition>;
  filter?: InputMaybe<ScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};


export type OrderSplitOrdersByFromOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SplitOrderCondition>;
  filter?: InputMaybe<SplitOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SplitOrdersOrderBy>>;
};


export type OrderSplitOrdersByToOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SplitOrderCondition>;
  filter?: InputMaybe<SplitOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SplitOrdersOrderBy>>;
};


export type OrderVoyageAssociationsByOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageAssociationCondition>;
  filter?: InputMaybe<VoyageAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageAssociationsOrderBy>>;
};

/** Attributes such as wood certificates that can be attached to any orders */
export type OrderAttribute = Node & {
  __typename?: 'OrderAttribute';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['OrderAttributeId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrderAttributeAssociation`. */
  orderAttributeAssociationsByOrderAttributeId: OrderAttributeAssociationsConnection;
  /** Reads a single `Organization` that is related to this `OrderAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
};


/** Attributes such as wood certificates that can be attached to any orders */
export type OrderAttributeOrderAttributeAssociationsByOrderAttributeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderAttributeAssociationCondition>;
  filter?: InputMaybe<OrderAttributeAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderAttributeAssociationsOrderBy>>;
};

/** Marks an order as implementing the associated attribute */
export type OrderAttributeAssociation = Node & {
  __typename?: 'OrderAttributeAssociation';
  id: Scalars['OrderAttributeAssociationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OrderAttribute` that is related to this `OrderAttributeAssociation`. */
  orderAttributeByOrderAttributeId?: Maybe<OrderAttribute>;
  orderAttributeId: Scalars['OrderAttributeId']['output'];
  /** Reads a single `Order` that is related to this `OrderAttributeAssociation`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Organization` that is related to this `OrderAttributeAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `OrderAttributeAssociation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type OrderAttributeAssociationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrderAttributeAssociationId']['input']>;
  /** Checks for equality with the object’s `orderAttributeId` field. */
  orderAttributeId?: InputMaybe<Scalars['OrderAttributeId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `OrderAttributeAssociation` object types. All fields are combined with a logical ‘and.’ */
export type OrderAttributeAssociationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderAttributeAssociationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderAttributeAssociationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderAttributeAssociationFilter>>;
  /** Filter by the object’s `orderAttributeId` field. */
  orderAttributeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OrderAttributeAssociation` */
export type OrderAttributeAssociationInput = {
  orderAttributeId: Scalars['OrderAttributeId']['input'];
  orderId: Scalars['OrderId']['input'];
};

/** Represents an update to a `OrderAttributeAssociation`. Fields that are set will be updated. */
export type OrderAttributeAssociationPatch = {
  orderAttributeId?: InputMaybe<Scalars['OrderAttributeId']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
};

/** A connection to a list of `OrderAttributeAssociation` values. */
export type OrderAttributeAssociationsConnection = {
  __typename?: 'OrderAttributeAssociationsConnection';
  /** A list of edges which contains the `OrderAttributeAssociation` and cursor to aid in pagination. */
  edges: Array<OrderAttributeAssociationsEdge>;
  /** A list of `OrderAttributeAssociation` objects. */
  nodes: Array<Maybe<OrderAttributeAssociation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderAttributeAssociation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderAttributeAssociation` edge in the connection. */
export type OrderAttributeAssociationsEdge = {
  __typename?: 'OrderAttributeAssociationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderAttributeAssociation` at the end of the edge. */
  node?: Maybe<OrderAttributeAssociation>;
};

/** Methods to use when ordering `OrderAttributeAssociation`. */
export enum OrderAttributeAssociationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ATTRIBUTE_ID_ASC = 'ORDER_ATTRIBUTE_ID_ASC',
  ORDER_ATTRIBUTE_ID_DESC = 'ORDER_ATTRIBUTE_ID_DESC',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

/**
 * A condition to be used against `OrderAttribute` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrderAttributeCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrderAttributeId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `OrderAttribute` object types. All fields are combined with a logical ‘and.’ */
export type OrderAttributeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderAttributeFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderAttributeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderAttributeFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OrderAttribute` */
export type OrderAttributeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** Represents an update to a `OrderAttribute`. Fields that are set will be updated. */
export type OrderAttributePatch = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `OrderAttribute` values. */
export type OrderAttributesConnection = {
  __typename?: 'OrderAttributesConnection';
  /** A list of edges which contains the `OrderAttribute` and cursor to aid in pagination. */
  edges: Array<OrderAttributesEdge>;
  /** A list of `OrderAttribute` objects. */
  nodes: Array<Maybe<OrderAttribute>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderAttribute` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderAttribute` edge in the connection. */
export type OrderAttributesEdge = {
  __typename?: 'OrderAttributesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderAttribute` at the end of the edge. */
  node?: Maybe<OrderAttribute>;
};

/** Methods to use when ordering `OrderAttribute`. */
export enum OrderAttributesOrderBy {
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A condition to be used against `Order` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type OrderCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `cancelling` field. */
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `cargoAmount` field. */
  cargoAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Checks for equality with the object’s `chartererOrganizationId` field. */
  chartererOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `coaId` field. */
  coaId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `completed` field. */
  completed?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deliveredBefore` field. */
  deliveredBefore?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargeExternallyPlanned` field. */
  dischargeExternallyPlanned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargePortId` field. */
  dischargePortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `dischargingDays` field. */
  dischargingDays?: InputMaybe<ShincShexInput>;
  /** Checks for equality with the object’s `dischargingOverheadDuration` field. */
  dischargingOverheadDuration?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `externalGroupingId` field. */
  externalGroupingId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalOrderId` field. */
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightCurrency` field. */
  freightCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `integrationSource` field. */
  integrationSource?: InputMaybe<IntegrationSourceType>;
  /** Checks for equality with the object’s `layday` field. */
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadExternallyPlanned` field. */
  loadExternallyPlanned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadPortId` field. */
  loadPortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `loadingDays` field. */
  loadingDays?: InputMaybe<ShincShexInput>;
  /** Checks for equality with the object’s `loadingOverheadDuration` field. */
  loadingOverheadDuration?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `marginAmount` field. */
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `marginUnit` field. */
  marginUnit?: InputMaybe<MarginUnit>;
  /** Checks for equality with the object’s `minVesselClassRequirement` field. */
  minVesselClassRequirement?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `nominatedVessel` field. */
  nominatedVessel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `numberOfPackages` field. */
  numberOfPackages?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rta` field. */
  rta?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Checks for equality with the object’s `softDelete` field. */
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `specificGravity` field. */
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `started` field. */
  started?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `stowageFactorMax` field. */
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stowageFactorMin` field. */
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stowageMode` field. */
  stowageMode?: InputMaybe<StowageModeType>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `toBeDeleted` field. */
  toBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `withoutGuarantee` field. */
  withoutGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderDetail = Node & {
  __typename?: 'OrderDetail';
  cargoCount?: Maybe<Scalars['Int']['output']>;
  cargoDeckOption?: Maybe<CargoDeckOptionType>;
  cargoDepth?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `CargoEquipment` that is related to this `OrderDetail`. */
  cargoEquipmentByCargoEquipmentId?: Maybe<CargoEquipment>;
  cargoEquipmentCount?: Maybe<Scalars['Int']['output']>;
  cargoEquipmentId?: Maybe<Scalars['CargoEquipmentId']['output']>;
  cargoHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `CargoLengthUnit` that is related to this `OrderDetail`. */
  cargoLengthUnitByCargoLengthUnitId?: Maybe<CargoLengthUnit>;
  cargoLengthUnitId?: Maybe<Scalars['CargoLengthUnitId']['output']>;
  /** Max Unit Weight of the cargo */
  cargoMaxUnitWeight?: Maybe<Scalars['BigFloat']['output']>;
  cargoPackageType?: Maybe<Scalars['String']['output']>;
  cargoPackingMethod?: Maybe<CargoPackingMethodType>;
  cargoWeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `CargoWeightUnit` that is related to this `OrderDetail`. */
  cargoWeightUnitByCargoWeightUnitId?: Maybe<CargoWeightUnit>;
  cargoWeightUnitId?: Maybe<Scalars['CargoWeightUnitId']['output']>;
  cargoWidth?: Maybe<Scalars['BigFloat']['output']>;
  closingDate?: Maybe<Scalars['Datetime']['output']>;
  commission?: Maybe<Scalars['BigFloat']['output']>;
  consignee?: Maybe<Scalars['String']['output']>;
  demurrage?: Maybe<Scalars['BigFloat']['output']>;
  dischargePortAgentId?: Maybe<Scalars['OrganizationId']['output']>;
  externalRemarks?: Maybe<Scalars['String']['output']>;
  extraInfo?: Maybe<Scalars['String']['output']>;
  fixtureNote?: Maybe<Scalars['String']['output']>;
  id: Scalars['OrderDetailId']['output'];
  imoClass?: Maybe<ImoClass>;
  incoTerms?: Maybe<IncoTermsType>;
  linerTerms?: Maybe<Scalars['String']['output']>;
  loadPortAgentOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `OrderDetail`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  orderName?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByDischargePortAgentId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByLoadPortAgentOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByReceiverOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationBySenderOrganisationId?: Maybe<Organization>;
  paymentTerms?: Maybe<PaymentType>;
  paymentTrigger?: Maybe<PaymentTrigger>;
  peymentTime?: Maybe<Scalars['Int']['output']>;
  receiverOrganisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  senderOrganisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `SupplyContract` that is related to this `OrderDetail`. */
  supplyContractBySupplyContractId?: Maybe<SupplyContract>;
  supplyContractId?: Maybe<Scalars['SupplyContractId']['output']>;
};

/**
 * A condition to be used against `OrderDetail` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OrderDetailCondition = {
  /** Checks for equality with the object’s `cargoCount` field. */
  cargoCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cargoDeckOption` field. */
  cargoDeckOption?: InputMaybe<CargoDeckOptionType>;
  /** Checks for equality with the object’s `cargoDepth` field. */
  cargoDepth?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoEquipmentCount` field. */
  cargoEquipmentCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cargoEquipmentId` field. */
  cargoEquipmentId?: InputMaybe<Scalars['CargoEquipmentId']['input']>;
  /** Checks for equality with the object’s `cargoHeight` field. */
  cargoHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoLengthUnitId` field. */
  cargoLengthUnitId?: InputMaybe<Scalars['CargoLengthUnitId']['input']>;
  /** Checks for equality with the object’s `cargoMaxUnitWeight` field. */
  cargoMaxUnitWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoPackageType` field. */
  cargoPackageType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cargoPackingMethod` field. */
  cargoPackingMethod?: InputMaybe<CargoPackingMethodType>;
  /** Checks for equality with the object’s `cargoWeight` field. */
  cargoWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoWeightUnitId` field. */
  cargoWeightUnitId?: InputMaybe<Scalars['CargoWeightUnitId']['input']>;
  /** Checks for equality with the object’s `cargoWidth` field. */
  cargoWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `closingDate` field. */
  closingDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `commission` field. */
  commission?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `consignee` field. */
  consignee?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `demurrage` field. */
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargePortAgentId` field. */
  dischargePortAgentId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `externalRemarks` field. */
  externalRemarks?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `extraInfo` field. */
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fixtureNote` field. */
  fixtureNote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrderDetailId']['input']>;
  /** Checks for equality with the object’s `imoClass` field. */
  imoClass?: InputMaybe<ImoClass>;
  /** Checks for equality with the object’s `incoTerms` field. */
  incoTerms?: InputMaybe<IncoTermsType>;
  /** Checks for equality with the object’s `linerTerms` field. */
  linerTerms?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadPortAgentOrgId` field. */
  loadPortAgentOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `orderName` field. */
  orderName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `paymentTerms` field. */
  paymentTerms?: InputMaybe<PaymentType>;
  /** Checks for equality with the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  /** Checks for equality with the object’s `peymentTime` field. */
  peymentTime?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `receiverOrganisationId` field. */
  receiverOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `senderOrganisationId` field. */
  senderOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `supplyContractId` field. */
  supplyContractId?: InputMaybe<Scalars['SupplyContractId']['input']>;
};

/** A filter to be used against `OrderDetail` object types. All fields are combined with a logical ‘and.’ */
export type OrderDetailFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderDetailFilter>>;
  /** Filter by the object’s `cargoCount` field. */
  cargoCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoDeckOption` field. */
  cargoDeckOption?: InputMaybe<CargoDeckOptionTypeFilter>;
  /** Filter by the object’s `cargoDepth` field. */
  cargoDepth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoEquipmentCount` field. */
  cargoEquipmentCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoEquipmentId` field. */
  cargoEquipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoHeight` field. */
  cargoHeight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoLengthUnitId` field. */
  cargoLengthUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoMaxUnitWeight` field. */
  cargoMaxUnitWeight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoPackageType` field. */
  cargoPackageType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cargoPackingMethod` field. */
  cargoPackingMethod?: InputMaybe<CargoPackingMethodTypeFilter>;
  /** Filter by the object’s `cargoWeight` field. */
  cargoWeight?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoWeightUnitId` field. */
  cargoWeightUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cargoWidth` field. */
  cargoWidth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `closingDate` field. */
  closingDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `commission` field. */
  commission?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `consignee` field. */
  consignee?: InputMaybe<StringFilter>;
  /** Filter by the object’s `demurrage` field. */
  demurrage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargePortAgentId` field. */
  dischargePortAgentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `externalRemarks` field. */
  externalRemarks?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extraInfo` field. */
  extraInfo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fixtureNote` field. */
  fixtureNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imoClass` field. */
  imoClass?: InputMaybe<ImoClassFilter>;
  /** Filter by the object’s `incoTerms` field. */
  incoTerms?: InputMaybe<IncoTermsTypeFilter>;
  /** Filter by the object’s `linerTerms` field. */
  linerTerms?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadPortAgentOrgId` field. */
  loadPortAgentOrgId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderDetailFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderDetailFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orderName` field. */
  orderName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `paymentTerms` field. */
  paymentTerms?: InputMaybe<PaymentTypeFilter>;
  /** Filter by the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTriggerFilter>;
  /** Filter by the object’s `peymentTime` field. */
  peymentTime?: InputMaybe<IntFilter>;
  /** Filter by the object’s `receiverOrganisationId` field. */
  receiverOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `senderOrganisationId` field. */
  senderOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `supplyContractId` field. */
  supplyContractId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OrderDetail` */
export type OrderDetailInput = {
  cargoCount?: InputMaybe<Scalars['Int']['input']>;
  cargoDeckOption?: InputMaybe<CargoDeckOptionType>;
  cargoDepth?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoEquipmentCount?: InputMaybe<Scalars['Int']['input']>;
  cargoEquipmentId?: InputMaybe<Scalars['CargoEquipmentId']['input']>;
  cargoHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoLengthUnitId?: InputMaybe<Scalars['CargoLengthUnitId']['input']>;
  /** Max Unit Weight of the cargo */
  cargoMaxUnitWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoPackageType?: InputMaybe<Scalars['String']['input']>;
  cargoPackingMethod?: InputMaybe<CargoPackingMethodType>;
  cargoWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoWeightUnitId?: InputMaybe<Scalars['CargoWeightUnitId']['input']>;
  cargoWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  closingDate?: InputMaybe<Scalars['Datetime']['input']>;
  commission?: InputMaybe<Scalars['BigFloat']['input']>;
  consignee?: InputMaybe<Scalars['String']['input']>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargePortAgentId?: InputMaybe<Scalars['OrganizationId']['input']>;
  externalRemarks?: InputMaybe<Scalars['String']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  fixtureNote?: InputMaybe<Scalars['String']['input']>;
  imoClass?: InputMaybe<ImoClass>;
  incoTerms?: InputMaybe<IncoTermsType>;
  linerTerms?: InputMaybe<Scalars['String']['input']>;
  loadPortAgentOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  orderId: Scalars['OrderId']['input'];
  orderName?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<PaymentType>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  peymentTime?: InputMaybe<Scalars['Int']['input']>;
  receiverOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  senderOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  supplyContractId?: InputMaybe<Scalars['SupplyContractId']['input']>;
};

/** Represents an update to a `OrderDetail`. Fields that are set will be updated. */
export type OrderDetailPatch = {
  cargoCount?: InputMaybe<Scalars['Int']['input']>;
  cargoDeckOption?: InputMaybe<CargoDeckOptionType>;
  cargoDepth?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoEquipmentCount?: InputMaybe<Scalars['Int']['input']>;
  cargoEquipmentId?: InputMaybe<Scalars['CargoEquipmentId']['input']>;
  cargoHeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoLengthUnitId?: InputMaybe<Scalars['CargoLengthUnitId']['input']>;
  /** Max Unit Weight of the cargo */
  cargoMaxUnitWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoPackageType?: InputMaybe<Scalars['String']['input']>;
  cargoPackingMethod?: InputMaybe<CargoPackingMethodType>;
  cargoWeight?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoWeightUnitId?: InputMaybe<Scalars['CargoWeightUnitId']['input']>;
  cargoWidth?: InputMaybe<Scalars['BigFloat']['input']>;
  closingDate?: InputMaybe<Scalars['Datetime']['input']>;
  commission?: InputMaybe<Scalars['BigFloat']['input']>;
  consignee?: InputMaybe<Scalars['String']['input']>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargePortAgentId?: InputMaybe<Scalars['OrganizationId']['input']>;
  externalRemarks?: InputMaybe<Scalars['String']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  fixtureNote?: InputMaybe<Scalars['String']['input']>;
  imoClass?: InputMaybe<ImoClass>;
  incoTerms?: InputMaybe<IncoTermsType>;
  linerTerms?: InputMaybe<Scalars['String']['input']>;
  loadPortAgentOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  orderName?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<PaymentType>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  peymentTime?: InputMaybe<Scalars['Int']['input']>;
  receiverOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  senderOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  supplyContractId?: InputMaybe<Scalars['SupplyContractId']['input']>;
};

/** A connection to a list of `OrderDetail` values. */
export type OrderDetailsConnection = {
  __typename?: 'OrderDetailsConnection';
  /** A list of edges which contains the `OrderDetail` and cursor to aid in pagination. */
  edges: Array<OrderDetailsEdge>;
  /** A list of `OrderDetail` objects. */
  nodes: Array<Maybe<OrderDetail>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderDetail` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderDetail` edge in the connection. */
export type OrderDetailsEdge = {
  __typename?: 'OrderDetailsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderDetail` at the end of the edge. */
  node?: Maybe<OrderDetail>;
};

/** Methods to use when ordering `OrderDetail`. */
export enum OrderDetailsOrderBy {
  CARGO_COUNT_ASC = 'CARGO_COUNT_ASC',
  CARGO_COUNT_DESC = 'CARGO_COUNT_DESC',
  CARGO_DECK_OPTION_ASC = 'CARGO_DECK_OPTION_ASC',
  CARGO_DECK_OPTION_DESC = 'CARGO_DECK_OPTION_DESC',
  CARGO_DEPTH_ASC = 'CARGO_DEPTH_ASC',
  CARGO_DEPTH_DESC = 'CARGO_DEPTH_DESC',
  CARGO_EQUIPMENT_COUNT_ASC = 'CARGO_EQUIPMENT_COUNT_ASC',
  CARGO_EQUIPMENT_COUNT_DESC = 'CARGO_EQUIPMENT_COUNT_DESC',
  CARGO_EQUIPMENT_ID_ASC = 'CARGO_EQUIPMENT_ID_ASC',
  CARGO_EQUIPMENT_ID_DESC = 'CARGO_EQUIPMENT_ID_DESC',
  CARGO_HEIGHT_ASC = 'CARGO_HEIGHT_ASC',
  CARGO_HEIGHT_DESC = 'CARGO_HEIGHT_DESC',
  CARGO_LENGTH_UNIT_ID_ASC = 'CARGO_LENGTH_UNIT_ID_ASC',
  CARGO_LENGTH_UNIT_ID_DESC = 'CARGO_LENGTH_UNIT_ID_DESC',
  CARGO_MAX_UNIT_WEIGHT_ASC = 'CARGO_MAX_UNIT_WEIGHT_ASC',
  CARGO_MAX_UNIT_WEIGHT_DESC = 'CARGO_MAX_UNIT_WEIGHT_DESC',
  CARGO_PACKAGE_TYPE_ASC = 'CARGO_PACKAGE_TYPE_ASC',
  CARGO_PACKAGE_TYPE_DESC = 'CARGO_PACKAGE_TYPE_DESC',
  CARGO_PACKING_METHOD_ASC = 'CARGO_PACKING_METHOD_ASC',
  CARGO_PACKING_METHOD_DESC = 'CARGO_PACKING_METHOD_DESC',
  CARGO_WEIGHT_ASC = 'CARGO_WEIGHT_ASC',
  CARGO_WEIGHT_DESC = 'CARGO_WEIGHT_DESC',
  CARGO_WEIGHT_UNIT_ID_ASC = 'CARGO_WEIGHT_UNIT_ID_ASC',
  CARGO_WEIGHT_UNIT_ID_DESC = 'CARGO_WEIGHT_UNIT_ID_DESC',
  CARGO_WIDTH_ASC = 'CARGO_WIDTH_ASC',
  CARGO_WIDTH_DESC = 'CARGO_WIDTH_DESC',
  CLOSING_DATE_ASC = 'CLOSING_DATE_ASC',
  CLOSING_DATE_DESC = 'CLOSING_DATE_DESC',
  COMMISSION_ASC = 'COMMISSION_ASC',
  COMMISSION_DESC = 'COMMISSION_DESC',
  CONSIGNEE_ASC = 'CONSIGNEE_ASC',
  CONSIGNEE_DESC = 'CONSIGNEE_DESC',
  DEMURRAGE_ASC = 'DEMURRAGE_ASC',
  DEMURRAGE_DESC = 'DEMURRAGE_DESC',
  DISCHARGE_PORT_AGENT_ID_ASC = 'DISCHARGE_PORT_AGENT_ID_ASC',
  DISCHARGE_PORT_AGENT_ID_DESC = 'DISCHARGE_PORT_AGENT_ID_DESC',
  EXTERNAL_REMARKS_ASC = 'EXTERNAL_REMARKS_ASC',
  EXTERNAL_REMARKS_DESC = 'EXTERNAL_REMARKS_DESC',
  EXTRA_INFO_ASC = 'EXTRA_INFO_ASC',
  EXTRA_INFO_DESC = 'EXTRA_INFO_DESC',
  FIXTURE_NOTE_ASC = 'FIXTURE_NOTE_ASC',
  FIXTURE_NOTE_DESC = 'FIXTURE_NOTE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IMO_CLASS_ASC = 'IMO_CLASS_ASC',
  IMO_CLASS_DESC = 'IMO_CLASS_DESC',
  INCO_TERMS_ASC = 'INCO_TERMS_ASC',
  INCO_TERMS_DESC = 'INCO_TERMS_DESC',
  LINER_TERMS_ASC = 'LINER_TERMS_ASC',
  LINER_TERMS_DESC = 'LINER_TERMS_DESC',
  LOAD_PORT_AGENT_ORG_ID_ASC = 'LOAD_PORT_AGENT_ORG_ID_ASC',
  LOAD_PORT_AGENT_ORG_ID_DESC = 'LOAD_PORT_AGENT_ORG_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  ORDER_NAME_ASC = 'ORDER_NAME_ASC',
  ORDER_NAME_DESC = 'ORDER_NAME_DESC',
  PAYMENT_TERMS_ASC = 'PAYMENT_TERMS_ASC',
  PAYMENT_TERMS_DESC = 'PAYMENT_TERMS_DESC',
  PAYMENT_TRIGGER_ASC = 'PAYMENT_TRIGGER_ASC',
  PAYMENT_TRIGGER_DESC = 'PAYMENT_TRIGGER_DESC',
  PEYMENT_TIME_ASC = 'PEYMENT_TIME_ASC',
  PEYMENT_TIME_DESC = 'PEYMENT_TIME_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RECEIVER_ORGANISATION_ID_ASC = 'RECEIVER_ORGANISATION_ID_ASC',
  RECEIVER_ORGANISATION_ID_DESC = 'RECEIVER_ORGANISATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SENDER_ORGANISATION_ID_ASC = 'SENDER_ORGANISATION_ID_ASC',
  SENDER_ORGANISATION_ID_DESC = 'SENDER_ORGANISATION_ID_DESC',
  SUPPLY_CONTRACT_ID_ASC = 'SUPPLY_CONTRACT_ID_ASC',
  SUPPLY_CONTRACT_ID_DESC = 'SUPPLY_CONTRACT_ID_DESC'
}

/** A filter to be used against `Order` object types. All fields are combined with a logical ‘and.’ */
export type OrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cancelling` field. */
  cancelling?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `cargoAmount` field. */
  cargoAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chartererOrganizationId` field. */
  chartererOrganizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `coaId` field. */
  coaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `completed` field. */
  completed?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deliveredBefore` field. */
  deliveredBefore?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargeExternallyPlanned` field. */
  dischargeExternallyPlanned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargePortId` field. */
  dischargePortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingDays` field. */
  dischargingDays?: InputMaybe<ShincShexFilter>;
  /** Filter by the object’s `dischargingOverheadDuration` field. */
  dischargingOverheadDuration?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `externalGroupingId` field. */
  externalGroupingId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalIdDisplay` field. */
  externalIdDisplay?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalOrderId` field. */
  externalOrderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightCurrency` field. */
  freightCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `integrationSource` field. */
  integrationSource?: InputMaybe<IntegrationSourceTypeFilter>;
  /** Filter by the object’s `layday` field. */
  layday?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadExternallyPlanned` field. */
  loadExternallyPlanned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadPortId` field. */
  loadPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingDays` field. */
  loadingDays?: InputMaybe<ShincShexFilter>;
  /** Filter by the object’s `loadingOverheadDuration` field. */
  loadingOverheadDuration?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `marginAmount` field. */
  marginAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `marginUnit` field. */
  marginUnit?: InputMaybe<MarginUnitFilter>;
  /** Filter by the object’s `minVesselClassRequirement` field. */
  minVesselClassRequirement?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nominatedVessel` field. */
  nominatedVessel?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderFilter>;
  /** Filter by the object’s `numberOfPackages` field. */
  numberOfPackages?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `relatedOrgs` field. */
  relatedOrgs?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rta` field. */
  rta?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softDelete` field. */
  softDelete?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `specificGravity` field. */
  specificGravity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `started` field. */
  started?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `stowageFactorMax` field. */
  stowageFactorMax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stowageFactorMin` field. */
  stowageFactorMin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stowageMode` field. */
  stowageMode?: InputMaybe<StowageModeTypeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `toBeDeleted` field. */
  toBeDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `withoutGuarantee` field. */
  withoutGuarantee?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `Order` */
export type OrderInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  cargoAmount: Scalars['BigFloat']['input'];
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Charterer organization of the order */
  chartererOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  coaId?: InputMaybe<Scalars['CoaContractId']['input']>;
  completed?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deliveredBefore?: InputMaybe<Scalars['Datetime']['input']>;
  dischargeExternallyPlanned?: InputMaybe<Scalars['Boolean']['input']>;
  dischargePortId: Scalars['LocationId']['input'];
  dischargingDays?: InputMaybe<ShincShexInput>;
  dischargingOverheadDuration?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingUnit?: InputMaybe<LoadingUnit>;
  externalGroupingId?: InputMaybe<Scalars['String']['input']>;
  /** Used for ERP / CRM integrations */
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightCurrency?: InputMaybe<Currency>;
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Source system that created this order. */
  integrationSource?: InputMaybe<IntegrationSourceType>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  loadExternallyPlanned?: InputMaybe<Scalars['Boolean']['input']>;
  loadPortId?: InputMaybe<Scalars['LocationId']['input']>;
  loadingDays?: InputMaybe<ShincShexInput>;
  loadingOverheadDuration?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingUnit?: InputMaybe<LoadingUnit>;
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  marginUnit?: InputMaybe<MarginUnit>;
  /** Minimum vessel class requirement for the order */
  minVesselClassRequirement?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  nominatedVessel?: InputMaybe<Scalars['String']['input']>;
  numberOfPackages?: InputMaybe<Scalars['Int']['input']>;
  /** The organization that owns the order */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Nominated shipowner organization for the order */
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  rta?: InputMaybe<Scalars['Datetime']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Defines if an order is soft deleted or not through integration API on integration.nomkeyitems.deletionindicator */
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  started?: InputMaybe<Scalars['Datetime']['input']>;
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageMode?: InputMaybe<StowageModeType>;
  /** Flag indicating order should be reviewed for deletion. */
  toBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  withoutGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `Order`. Fields that are set will be updated. */
export type OrderPatch = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  cargoAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Charterer organization of the order */
  chartererOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  coaId?: InputMaybe<Scalars['CoaContractId']['input']>;
  completed?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deliveredBefore?: InputMaybe<Scalars['Datetime']['input']>;
  dischargeExternallyPlanned?: InputMaybe<Scalars['Boolean']['input']>;
  dischargePortId?: InputMaybe<Scalars['LocationId']['input']>;
  dischargingDays?: InputMaybe<ShincShexInput>;
  dischargingOverheadDuration?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingUnit?: InputMaybe<LoadingUnit>;
  externalGroupingId?: InputMaybe<Scalars['String']['input']>;
  /** Used for ERP / CRM integrations */
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightCurrency?: InputMaybe<Currency>;
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Source system that created this order. */
  integrationSource?: InputMaybe<IntegrationSourceType>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  loadExternallyPlanned?: InputMaybe<Scalars['Boolean']['input']>;
  loadPortId?: InputMaybe<Scalars['LocationId']['input']>;
  loadingDays?: InputMaybe<ShincShexInput>;
  loadingOverheadDuration?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingUnit?: InputMaybe<LoadingUnit>;
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  marginUnit?: InputMaybe<MarginUnit>;
  /** Minimum vessel class requirement for the order */
  minVesselClassRequirement?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  nominatedVessel?: InputMaybe<Scalars['String']['input']>;
  numberOfPackages?: InputMaybe<Scalars['Int']['input']>;
  /** The organization that owns the order */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Nominated shipowner organization for the order */
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  rta?: InputMaybe<Scalars['Datetime']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Defines if an order is soft deleted or not through integration API on integration.nomkeyitems.deletionindicator */
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  started?: InputMaybe<Scalars['Datetime']['input']>;
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  stowageMode?: InputMaybe<StowageModeType>;
  /** Flag indicating order should be reviewed for deletion. */
  toBeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  withoutGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderPortCallRelation = Node & {
  __typename?: 'OrderPortCallRelation';
  id: Scalars['OrderPortCallRelationId']['output'];
  isLoadPort: Scalars['Boolean']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `OrderPortCallRelation`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Organization` that is related to this `OrderPortCallRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `OrderPortCallRelation`. */
  portCallByPortCallId?: Maybe<PortCall>;
  portCallId: Scalars['PortCallId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `OrderPortCallRelation`. */
  userByModifiedByUserId?: Maybe<User>;
};

/**
 * A condition to be used against `OrderPortCallRelation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OrderPortCallRelationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrderPortCallRelationId']['input']>;
  /** Checks for equality with the object’s `isLoadPort` field. */
  isLoadPort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `OrderPortCallRelation` object types. All fields are combined with a logical ‘and.’ */
export type OrderPortCallRelationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderPortCallRelationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isLoadPort` field. */
  isLoadPort?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderPortCallRelationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderPortCallRelationFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** A connection to a list of `OrderPortCallRelationHistory` values. */
export type OrderPortCallRelationHistoriesConnection = {
  __typename?: 'OrderPortCallRelationHistoriesConnection';
  /** A list of edges which contains the `OrderPortCallRelationHistory` and cursor to aid in pagination. */
  edges: Array<OrderPortCallRelationHistoriesEdge>;
  /** A list of `OrderPortCallRelationHistory` objects. */
  nodes: Array<Maybe<OrderPortCallRelationHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderPortCallRelationHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderPortCallRelationHistory` edge in the connection. */
export type OrderPortCallRelationHistoriesEdge = {
  __typename?: 'OrderPortCallRelationHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderPortCallRelationHistory` at the end of the edge. */
  node?: Maybe<OrderPortCallRelationHistory>;
};

/** Methods to use when ordering `OrderPortCallRelationHistory`. */
export enum OrderPortCallRelationHistoriesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_LOAD_PORT_ASC = 'IS_LOAD_PORT_ASC',
  IS_LOAD_PORT_DESC = 'IS_LOAD_PORT_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC'
}

/** History log for orders x port call relation */
export type OrderPortCallRelationHistory = {
  __typename?: 'OrderPortCallRelationHistory';
  id: Scalars['Int']['output'];
  isLoadPort: Scalars['Boolean']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['Int']['output'];
  portCallId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  sysPeriod: DatetimeRange;
};

/**
 * A condition to be used against `OrderPortCallRelationHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type OrderPortCallRelationHistoryCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isLoadPort` field. */
  isLoadPort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `OrderPortCallRelationHistory` object types. All fields are combined with a logical ‘and.’ */
export type OrderPortCallRelationHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderPortCallRelationHistoryFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isLoadPort` field. */
  isLoadPort?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderPortCallRelationHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderPortCallRelationHistoryFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** An input for mutations affecting `OrderPortCallRelation` */
export type OrderPortCallRelationInput = {
  isLoadPort: Scalars['Boolean']['input'];
  orderId: Scalars['OrderId']['input'];
  portCallId: Scalars['PortCallId']['input'];
};

/** Represents an update to a `OrderPortCallRelation`. Fields that are set will be updated. */
export type OrderPortCallRelationPatch = {
  isLoadPort?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
};

/** A connection to a list of `OrderPortCallRelation` values. */
export type OrderPortCallRelationsConnection = {
  __typename?: 'OrderPortCallRelationsConnection';
  /** A list of edges which contains the `OrderPortCallRelation` and cursor to aid in pagination. */
  edges: Array<OrderPortCallRelationsEdge>;
  /** A list of `OrderPortCallRelation` objects. */
  nodes: Array<Maybe<OrderPortCallRelation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderPortCallRelation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderPortCallRelation` edge in the connection. */
export type OrderPortCallRelationsEdge = {
  __typename?: 'OrderPortCallRelationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderPortCallRelation` at the end of the edge. */
  node?: Maybe<OrderPortCallRelation>;
};

/** Methods to use when ordering `OrderPortCallRelation`. */
export enum OrderPortCallRelationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_LOAD_PORT_ASC = 'IS_LOAD_PORT_ASC',
  IS_LOAD_PORT_DESC = 'IS_LOAD_PORT_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC'
}

export type OrderPortOverride = Node & {
  __typename?: 'OrderPortOverride';
  dischargePort: Scalars['String']['output'];
  loadPort?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `OrderPortOverride`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  rootOrg: Scalars['Int']['output'];
};

/**
 * A condition to be used against `OrderPortOverride` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrderPortOverrideCondition = {
  /** Checks for equality with the object’s `dischargePort` field. */
  dischargePort?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `loadPort` field. */
  loadPort?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `OrderPortOverride` object types. All fields are combined with a logical ‘and.’ */
export type OrderPortOverrideFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderPortOverrideFilter>>;
  /** Filter by the object’s `dischargePort` field. */
  dischargePort?: InputMaybe<StringFilter>;
  /** Filter by the object’s `loadPort` field. */
  loadPort?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderPortOverrideFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderPortOverrideFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OrderPortOverride` */
export type OrderPortOverrideInput = {
  dischargePort: Scalars['String']['input'];
  loadPort?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `OrderPortOverride`. Fields that are set will be updated. */
export type OrderPortOverridePatch = {
  dischargePort?: InputMaybe<Scalars['String']['input']>;
  loadPort?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `OrderPortOverride` values. */
export type OrderPortOverridesConnection = {
  __typename?: 'OrderPortOverridesConnection';
  /** A list of edges which contains the `OrderPortOverride` and cursor to aid in pagination. */
  edges: Array<OrderPortOverridesEdge>;
  /** A list of `OrderPortOverride` objects. */
  nodes: Array<Maybe<OrderPortOverride>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderPortOverride` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderPortOverride` edge in the connection. */
export type OrderPortOverridesEdge = {
  __typename?: 'OrderPortOverridesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderPortOverride` at the end of the edge. */
  node?: Maybe<OrderPortOverride>;
};

/** Methods to use when ordering `OrderPortOverride`. */
export enum OrderPortOverridesOrderBy {
  DISCHARGE_PORT_ASC = 'DISCHARGE_PORT_ASC',
  DISCHARGE_PORT_DESC = 'DISCHARGE_PORT_DESC',
  LOAD_PORT_ASC = 'LOAD_PORT_ASC',
  LOAD_PORT_DESC = 'LOAD_PORT_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type OrderRequirementAssociation = Node & {
  __typename?: 'OrderRequirementAssociation';
  id: Scalars['OrderRequirementAssociationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `OrderRequirementAssociation`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Organization` that is related to this `OrderRequirementAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `SpecialRequirement` that is related to this `OrderRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  specialRequirementId: Scalars['SpecialRequirementId']['output'];
};

/**
 * A condition to be used against `OrderRequirementAssociation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type OrderRequirementAssociationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrderRequirementAssociationId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `specialRequirementId` field. */
  specialRequirementId?: InputMaybe<Scalars['SpecialRequirementId']['input']>;
};

/** A filter to be used against `OrderRequirementAssociation` object types. All fields are combined with a logical ‘and.’ */
export type OrderRequirementAssociationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderRequirementAssociationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderRequirementAssociationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderRequirementAssociationFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `specialRequirementId` field. */
  specialRequirementId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OrderRequirementAssociation` */
export type OrderRequirementAssociationInput = {
  orderId: Scalars['OrderId']['input'];
  specialRequirementId: Scalars['SpecialRequirementId']['input'];
};

/** Represents an update to a `OrderRequirementAssociation`. Fields that are set will be updated. */
export type OrderRequirementAssociationPatch = {
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  specialRequirementId?: InputMaybe<Scalars['SpecialRequirementId']['input']>;
};

/** A connection to a list of `OrderRequirementAssociation` values. */
export type OrderRequirementAssociationsConnection = {
  __typename?: 'OrderRequirementAssociationsConnection';
  /** A list of edges which contains the `OrderRequirementAssociation` and cursor to aid in pagination. */
  edges: Array<OrderRequirementAssociationsEdge>;
  /** A list of `OrderRequirementAssociation` objects. */
  nodes: Array<Maybe<OrderRequirementAssociation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderRequirementAssociation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderRequirementAssociation` edge in the connection. */
export type OrderRequirementAssociationsEdge = {
  __typename?: 'OrderRequirementAssociationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderRequirementAssociation` at the end of the edge. */
  node?: Maybe<OrderRequirementAssociation>;
};

/** Methods to use when ordering `OrderRequirementAssociation`. */
export enum OrderRequirementAssociationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SPECIAL_REQUIREMENT_ID_ASC = 'SPECIAL_REQUIREMENT_ID_ASC',
  SPECIAL_REQUIREMENT_ID_DESC = 'SPECIAL_REQUIREMENT_ID_DESC'
}

export type OrderVoyageCharterRelation = Node & {
  __typename?: 'OrderVoyageCharterRelation';
  /** Reads a single `CoaContractPort` that is related to this `OrderVoyageCharterRelation`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  coaRouteId?: Maybe<Scalars['CoaContractPortId']['output']>;
  id: Scalars['OrderVoyageCharterRelationId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `OrderVoyageCharterRelation`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Organization` that is related to this `OrderVoyageCharterRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  outgoing: Scalars['Boolean']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `OrderVoyageCharterRelation`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `OrderVoyageCharterRelation`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId: Scalars['VoyageCharterId']['output'];
  /** Reads and enables pagination through a set of `VoyageCharterOrderFreight`. */
  voyageCharterOrderFreightsByOrderVoyageCharterRelationId: VoyageCharterOrderFreightsConnection;
};


export type OrderVoyageCharterRelationVoyageCharterOrderFreightsByOrderVoyageCharterRelationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterOrderFreightCondition>;
  filter?: InputMaybe<VoyageCharterOrderFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterOrderFreightsOrderBy>>;
};

/**
 * A condition to be used against `OrderVoyageCharterRelation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type OrderVoyageCharterRelationCondition = {
  /** Checks for equality with the object’s `coaRouteId` field. */
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrderVoyageCharterRelationId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `outgoing` field. */
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `OrderVoyageCharterRelation` object types. All fields are combined with a logical ‘and.’ */
export type OrderVoyageCharterRelationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderVoyageCharterRelationFilter>>;
  /** Filter by the object’s `coaRouteId` field. */
  coaRouteId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderVoyageCharterRelationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderVoyageCharterRelationFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `outgoing` field. */
  outgoing?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `OrderVoyageCharterRelationHistory` values. */
export type OrderVoyageCharterRelationHistoriesConnection = {
  __typename?: 'OrderVoyageCharterRelationHistoriesConnection';
  /** A list of edges which contains the `OrderVoyageCharterRelationHistory` and cursor to aid in pagination. */
  edges: Array<OrderVoyageCharterRelationHistoriesEdge>;
  /** A list of `OrderVoyageCharterRelationHistory` objects. */
  nodes: Array<Maybe<OrderVoyageCharterRelationHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderVoyageCharterRelationHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderVoyageCharterRelationHistory` edge in the connection. */
export type OrderVoyageCharterRelationHistoriesEdge = {
  __typename?: 'OrderVoyageCharterRelationHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderVoyageCharterRelationHistory` at the end of the edge. */
  node?: Maybe<OrderVoyageCharterRelationHistory>;
};

/** Methods to use when ordering `OrderVoyageCharterRelationHistory`. */
export enum OrderVoyageCharterRelationHistoriesOrderBy {
  COA_ROUTE_ID_ASC = 'COA_ROUTE_ID_ASC',
  COA_ROUTE_ID_DESC = 'COA_ROUTE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  OUTGOING_ASC = 'OUTGOING_ASC',
  OUTGOING_DESC = 'OUTGOING_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** History log for this table */
export type OrderVoyageCharterRelationHistory = {
  __typename?: 'OrderVoyageCharterRelationHistory';
  coaRouteId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['Int']['output'];
  outgoing?: Maybe<Scalars['Boolean']['output']>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  sysPeriod: DatetimeRange;
  voyageCharterId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `OrderVoyageCharterRelationHistory` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type OrderVoyageCharterRelationHistoryCondition = {
  /** Checks for equality with the object’s `coaRouteId` field. */
  coaRouteId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `outgoing` field. */
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `OrderVoyageCharterRelationHistory` object types. All fields are combined with a logical ‘and.’ */
export type OrderVoyageCharterRelationHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrderVoyageCharterRelationHistoryFilter>>;
  /** Filter by the object’s `coaRouteId` field. */
  coaRouteId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrderVoyageCharterRelationHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrderVoyageCharterRelationHistoryFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `outgoing` field. */
  outgoing?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OrderVoyageCharterRelation` */
export type OrderVoyageCharterRelationInput = {
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  orderId: Scalars['OrderId']['input'];
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** Represents an update to a `OrderVoyageCharterRelation`. Fields that are set will be updated. */
export type OrderVoyageCharterRelationPatch = {
  coaRouteId?: InputMaybe<Scalars['CoaContractPortId']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `OrderVoyageCharterRelation` values. */
export type OrderVoyageCharterRelationsConnection = {
  __typename?: 'OrderVoyageCharterRelationsConnection';
  /** A list of edges which contains the `OrderVoyageCharterRelation` and cursor to aid in pagination. */
  edges: Array<OrderVoyageCharterRelationsEdge>;
  /** A list of `OrderVoyageCharterRelation` objects. */
  nodes: Array<Maybe<OrderVoyageCharterRelation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrderVoyageCharterRelation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrderVoyageCharterRelation` edge in the connection. */
export type OrderVoyageCharterRelationsEdge = {
  __typename?: 'OrderVoyageCharterRelationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrderVoyageCharterRelation` at the end of the edge. */
  node?: Maybe<OrderVoyageCharterRelation>;
};

/** Methods to use when ordering `OrderVoyageCharterRelation`. */
export enum OrderVoyageCharterRelationsOrderBy {
  COA_ROUTE_ID_ASC = 'COA_ROUTE_ID_ASC',
  COA_ROUTE_ID_DESC = 'COA_ROUTE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  OUTGOING_ASC = 'OUTGOING_ASC',
  OUTGOING_DESC = 'OUTGOING_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** A connection to a list of `Order` values. */
export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  /** A list of edges which contains the `Order` and cursor to aid in pagination. */
  edges: Array<OrdersEdge>;
  /** A list of `Order` objects. */
  nodes: Array<Maybe<Order>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Order` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Order` edge in the connection. */
export type OrdersEdge = {
  __typename?: 'OrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Order` at the end of the edge. */
  node?: Maybe<Order>;
};

/** A connection to a list of `OrdersHistory` values. */
export type OrdersHistoriesConnection = {
  __typename?: 'OrdersHistoriesConnection';
  /** A list of edges which contains the `OrdersHistory` and cursor to aid in pagination. */
  edges: Array<OrdersHistoriesEdge>;
  /** A list of `OrdersHistory` objects. */
  nodes: Array<Maybe<OrdersHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrdersHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrdersHistory` edge in the connection. */
export type OrdersHistoriesEdge = {
  __typename?: 'OrdersHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrdersHistory` at the end of the edge. */
  node?: Maybe<OrdersHistory>;
};

/** Methods to use when ordering `OrdersHistory`. */
export enum OrdersHistoriesOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  ASSORTMENT_ID_ASC = 'ASSORTMENT_ID_ASC',
  ASSORTMENT_ID_DESC = 'ASSORTMENT_ID_DESC',
  CANCELLING_ASC = 'CANCELLING_ASC',
  CANCELLING_DESC = 'CANCELLING_DESC',
  CARGO_AMOUNT_ASC = 'CARGO_AMOUNT_ASC',
  CARGO_AMOUNT_DESC = 'CARGO_AMOUNT_DESC',
  CARGO_UNIT_ID_ASC = 'CARGO_UNIT_ID_ASC',
  CARGO_UNIT_ID_DESC = 'CARGO_UNIT_ID_DESC',
  CHARTERER_ORGANIZATION_ID_ASC = 'CHARTERER_ORGANIZATION_ID_ASC',
  CHARTERER_ORGANIZATION_ID_DESC = 'CHARTERER_ORGANIZATION_ID_DESC',
  COMPLETED_ASC = 'COMPLETED_ASC',
  COMPLETED_DESC = 'COMPLETED_DESC',
  DELIVERED_BEFORE_ASC = 'DELIVERED_BEFORE_ASC',
  DELIVERED_BEFORE_DESC = 'DELIVERED_BEFORE_DESC',
  DISCHARGE_PORT_ID_ASC = 'DISCHARGE_PORT_ID_ASC',
  DISCHARGE_PORT_ID_DESC = 'DISCHARGE_PORT_ID_DESC',
  DISCHARGING_DAYS_ASC = 'DISCHARGING_DAYS_ASC',
  DISCHARGING_DAYS_DESC = 'DISCHARGING_DAYS_DESC',
  DISCHARGING_RATE_ASC = 'DISCHARGING_RATE_ASC',
  DISCHARGING_RATE_DESC = 'DISCHARGING_RATE_DESC',
  DISCHARGING_UNIT_ASC = 'DISCHARGING_UNIT_ASC',
  DISCHARGING_UNIT_DESC = 'DISCHARGING_UNIT_DESC',
  EXTERNAL_ORDER_ID_ASC = 'EXTERNAL_ORDER_ID_ASC',
  EXTERNAL_ORDER_ID_DESC = 'EXTERNAL_ORDER_ID_DESC',
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_CURRENCY_ASC = 'FREIGHT_CURRENCY_ASC',
  FREIGHT_CURRENCY_DESC = 'FREIGHT_CURRENCY_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAYDAY_ASC = 'LAYDAY_ASC',
  LAYDAY_DESC = 'LAYDAY_DESC',
  LOADING_DAYS_ASC = 'LOADING_DAYS_ASC',
  LOADING_DAYS_DESC = 'LOADING_DAYS_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  LOADING_UNIT_ASC = 'LOADING_UNIT_ASC',
  LOADING_UNIT_DESC = 'LOADING_UNIT_DESC',
  LOAD_PORT_ID_ASC = 'LOAD_PORT_ID_ASC',
  LOAD_PORT_ID_DESC = 'LOAD_PORT_ID_DESC',
  MARGIN_AMOUNT_ASC = 'MARGIN_AMOUNT_ASC',
  MARGIN_AMOUNT_DESC = 'MARGIN_AMOUNT_DESC',
  MARGIN_UNIT_ASC = 'MARGIN_UNIT_ASC',
  MARGIN_UNIT_DESC = 'MARGIN_UNIT_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  NOMINATED_VESSEL_ASC = 'NOMINATED_VESSEL_ASC',
  NOMINATED_VESSEL_DESC = 'NOMINATED_VESSEL_DESC',
  NUMBER_OF_PACKAGES_ASC = 'NUMBER_OF_PACKAGES_ASC',
  NUMBER_OF_PACKAGES_DESC = 'NUMBER_OF_PACKAGES_DESC',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  OWNER_ORGANISATION_ID_ASC = 'OWNER_ORGANISATION_ID_ASC',
  OWNER_ORGANISATION_ID_DESC = 'OWNER_ORGANISATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  RTA_ASC = 'RTA_ASC',
  RTA_DESC = 'RTA_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  SOFT_DELETE_ASC = 'SOFT_DELETE_ASC',
  SOFT_DELETE_DESC = 'SOFT_DELETE_DESC',
  SPECIFIC_GRAVITY_ASC = 'SPECIFIC_GRAVITY_ASC',
  SPECIFIC_GRAVITY_DESC = 'SPECIFIC_GRAVITY_DESC',
  STARTED_ASC = 'STARTED_ASC',
  STARTED_DESC = 'STARTED_DESC',
  STOWAGE_FACTOR_MAX_ASC = 'STOWAGE_FACTOR_MAX_ASC',
  STOWAGE_FACTOR_MAX_DESC = 'STOWAGE_FACTOR_MAX_DESC',
  STOWAGE_FACTOR_MIN_ASC = 'STOWAGE_FACTOR_MIN_ASC',
  STOWAGE_FACTOR_MIN_DESC = 'STOWAGE_FACTOR_MIN_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  WITHOUT_GUARANTEE_ASC = 'WITHOUT_GUARANTEE_ASC',
  WITHOUT_GUARANTEE_DESC = 'WITHOUT_GUARANTEE_DESC'
}

/** History log for orders_history table */
export type OrdersHistory = {
  __typename?: 'OrdersHistory';
  archived: Scalars['Boolean']['output'];
  /** Reads a single `Assortment` that is related to this `OrdersHistory`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  assortmentId?: Maybe<Scalars['AssortmentId']['output']>;
  cancelling?: Maybe<Scalars['Datetime']['output']>;
  cargoAmount: Scalars['BigFloat']['output'];
  /** Reads a single `CargoUnit` that is related to this `OrdersHistory`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  cargoUnitId?: Maybe<Scalars['CargoUnitId']['output']>;
  chartererOrganizationId?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Datetime']['output']>;
  deliveredBefore?: Maybe<Scalars['Datetime']['output']>;
  dischargePortId: Scalars['LocationId']['output'];
  dischargingDays?: Maybe<ShincShex>;
  dischargingRate?: Maybe<Scalars['BigFloat']['output']>;
  dischargingUnit?: Maybe<Scalars['String']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  freightAmount?: Maybe<Scalars['BigFloat']['output']>;
  freightCurrency?: Maybe<Currency>;
  freightUnit?: Maybe<PaymentUnit>;
  id: Scalars['OrderId']['output'];
  layday?: Maybe<Scalars['Datetime']['output']>;
  loadPortId?: Maybe<Scalars['LocationId']['output']>;
  loadingDays?: Maybe<ShincShex>;
  loadingRate?: Maybe<Scalars['BigFloat']['output']>;
  loadingUnit?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `OrdersHistory`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OrdersHistory`. */
  locationByLoadPortId?: Maybe<Location>;
  marginAmount?: Maybe<Scalars['BigFloat']['output']>;
  marginUnit?: Maybe<MarginUnit>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  nominatedVessel?: Maybe<Scalars['String']['output']>;
  numberOfPackages?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Order` that is related to this `OrdersHistory`. */
  orderById?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `OrdersHistory`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  ownerOrganisationId?: Maybe<Scalars['Int']['output']>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  rta?: Maybe<Scalars['Datetime']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  softDelete?: Maybe<Scalars['Boolean']['output']>;
  specificGravity?: Maybe<Scalars['BigFloat']['output']>;
  started?: Maybe<Scalars['Datetime']['output']>;
  stowageFactorMax?: Maybe<Scalars['BigFloat']['output']>;
  stowageFactorMin?: Maybe<Scalars['BigFloat']['output']>;
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `OrdersHistory`. */
  userByModifiedByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  withoutGuarantee?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A condition to be used against `OrdersHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrdersHistoryCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `cancelling` field. */
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `cargoAmount` field. */
  cargoAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Checks for equality with the object’s `chartererOrganizationId` field. */
  chartererOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `completed` field. */
  completed?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deliveredBefore` field. */
  deliveredBefore?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargePortId` field. */
  dischargePortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `dischargingDays` field. */
  dischargingDays?: InputMaybe<ShincShexInput>;
  /** Checks for equality with the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalOrderId` field. */
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightCurrency` field. */
  freightCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `layday` field. */
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadPortId` field. */
  loadPortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `loadingDays` field. */
  loadingDays?: InputMaybe<ShincShexInput>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `marginAmount` field. */
  marginAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `marginUnit` field. */
  marginUnit?: InputMaybe<MarginUnit>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `nominatedVessel` field. */
  nominatedVessel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `numberOfPackages` field. */
  numberOfPackages?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rta` field. */
  rta?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `softDelete` field. */
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `specificGravity` field. */
  specificGravity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `started` field. */
  started?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `stowageFactorMax` field. */
  stowageFactorMax?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stowageFactorMin` field. */
  stowageFactorMin?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `withoutGuarantee` field. */
  withoutGuarantee?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `OrdersHistory` object types. All fields are combined with a logical ‘and.’ */
export type OrdersHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrdersHistoryFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cancelling` field. */
  cancelling?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `cargoAmount` field. */
  cargoAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cargoUnitId` field. */
  cargoUnitId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chartererOrganizationId` field. */
  chartererOrganizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `completed` field. */
  completed?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deliveredBefore` field. */
  deliveredBefore?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargePortId` field. */
  dischargePortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingDays` field. */
  dischargingDays?: InputMaybe<ShincShexFilter>;
  /** Filter by the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalOrderId` field. */
  externalOrderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightCurrency` field. */
  freightCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `layday` field. */
  layday?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadPortId` field. */
  loadPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingDays` field. */
  loadingDays?: InputMaybe<ShincShexFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `marginAmount` field. */
  marginAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `marginUnit` field. */
  marginUnit?: InputMaybe<MarginUnitFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nominatedVessel` field. */
  nominatedVessel?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrdersHistoryFilter>;
  /** Filter by the object’s `numberOfPackages` field. */
  numberOfPackages?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrdersHistoryFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rta` field. */
  rta?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softDelete` field. */
  softDelete?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `specificGravity` field. */
  specificGravity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `started` field. */
  started?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `stowageFactorMax` field. */
  stowageFactorMax?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stowageFactorMin` field. */
  stowageFactorMin?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `withoutGuarantee` field. */
  withoutGuarantee?: InputMaybe<BooleanFilter>;
};

/** Methods to use when ordering `Order`. */
export enum OrdersOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  ASSORTMENT_ID_ASC = 'ASSORTMENT_ID_ASC',
  ASSORTMENT_ID_DESC = 'ASSORTMENT_ID_DESC',
  CANCELLING_ASC = 'CANCELLING_ASC',
  CANCELLING_DESC = 'CANCELLING_DESC',
  CARGO_AMOUNT_ASC = 'CARGO_AMOUNT_ASC',
  CARGO_AMOUNT_DESC = 'CARGO_AMOUNT_DESC',
  CARGO_UNIT_ID_ASC = 'CARGO_UNIT_ID_ASC',
  CARGO_UNIT_ID_DESC = 'CARGO_UNIT_ID_DESC',
  CHARTERER_ORGANIZATION_ID_ASC = 'CHARTERER_ORGANIZATION_ID_ASC',
  CHARTERER_ORGANIZATION_ID_DESC = 'CHARTERER_ORGANIZATION_ID_DESC',
  COA_ID_ASC = 'COA_ID_ASC',
  COA_ID_DESC = 'COA_ID_DESC',
  COMPLETED_ASC = 'COMPLETED_ASC',
  COMPLETED_DESC = 'COMPLETED_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DELIVERED_BEFORE_ASC = 'DELIVERED_BEFORE_ASC',
  DELIVERED_BEFORE_DESC = 'DELIVERED_BEFORE_DESC',
  DISCHARGE_EXTERNALLY_PLANNED_ASC = 'DISCHARGE_EXTERNALLY_PLANNED_ASC',
  DISCHARGE_EXTERNALLY_PLANNED_DESC = 'DISCHARGE_EXTERNALLY_PLANNED_DESC',
  DISCHARGE_PORT_ID_ASC = 'DISCHARGE_PORT_ID_ASC',
  DISCHARGE_PORT_ID_DESC = 'DISCHARGE_PORT_ID_DESC',
  DISCHARGING_DAYS_ASC = 'DISCHARGING_DAYS_ASC',
  DISCHARGING_DAYS_DESC = 'DISCHARGING_DAYS_DESC',
  DISCHARGING_OVERHEAD_DURATION_ASC = 'DISCHARGING_OVERHEAD_DURATION_ASC',
  DISCHARGING_OVERHEAD_DURATION_DESC = 'DISCHARGING_OVERHEAD_DURATION_DESC',
  DISCHARGING_RATE_ASC = 'DISCHARGING_RATE_ASC',
  DISCHARGING_RATE_DESC = 'DISCHARGING_RATE_DESC',
  DISCHARGING_UNIT_ASC = 'DISCHARGING_UNIT_ASC',
  DISCHARGING_UNIT_DESC = 'DISCHARGING_UNIT_DESC',
  EXTERNAL_GROUPING_ID_ASC = 'EXTERNAL_GROUPING_ID_ASC',
  EXTERNAL_GROUPING_ID_DESC = 'EXTERNAL_GROUPING_ID_DESC',
  EXTERNAL_ORDER_ID_ASC = 'EXTERNAL_ORDER_ID_ASC',
  EXTERNAL_ORDER_ID_DESC = 'EXTERNAL_ORDER_ID_DESC',
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_CURRENCY_ASC = 'FREIGHT_CURRENCY_ASC',
  FREIGHT_CURRENCY_DESC = 'FREIGHT_CURRENCY_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INTEGRATION_SOURCE_ASC = 'INTEGRATION_SOURCE_ASC',
  INTEGRATION_SOURCE_DESC = 'INTEGRATION_SOURCE_DESC',
  LAYDAY_ASC = 'LAYDAY_ASC',
  LAYDAY_DESC = 'LAYDAY_DESC',
  LOADING_DAYS_ASC = 'LOADING_DAYS_ASC',
  LOADING_DAYS_DESC = 'LOADING_DAYS_DESC',
  LOADING_OVERHEAD_DURATION_ASC = 'LOADING_OVERHEAD_DURATION_ASC',
  LOADING_OVERHEAD_DURATION_DESC = 'LOADING_OVERHEAD_DURATION_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  LOADING_UNIT_ASC = 'LOADING_UNIT_ASC',
  LOADING_UNIT_DESC = 'LOADING_UNIT_DESC',
  LOAD_EXTERNALLY_PLANNED_ASC = 'LOAD_EXTERNALLY_PLANNED_ASC',
  LOAD_EXTERNALLY_PLANNED_DESC = 'LOAD_EXTERNALLY_PLANNED_DESC',
  LOAD_PORT_ID_ASC = 'LOAD_PORT_ID_ASC',
  LOAD_PORT_ID_DESC = 'LOAD_PORT_ID_DESC',
  MARGIN_AMOUNT_ASC = 'MARGIN_AMOUNT_ASC',
  MARGIN_AMOUNT_DESC = 'MARGIN_AMOUNT_DESC',
  MARGIN_UNIT_ASC = 'MARGIN_UNIT_ASC',
  MARGIN_UNIT_DESC = 'MARGIN_UNIT_DESC',
  MIN_VESSEL_CLASS_REQUIREMENT_ASC = 'MIN_VESSEL_CLASS_REQUIREMENT_ASC',
  MIN_VESSEL_CLASS_REQUIREMENT_DESC = 'MIN_VESSEL_CLASS_REQUIREMENT_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  NOMINATED_VESSEL_ASC = 'NOMINATED_VESSEL_ASC',
  NOMINATED_VESSEL_DESC = 'NOMINATED_VESSEL_DESC',
  NUMBER_OF_PACKAGES_ASC = 'NUMBER_OF_PACKAGES_ASC',
  NUMBER_OF_PACKAGES_DESC = 'NUMBER_OF_PACKAGES_DESC',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  OWNER_ORGANISATION_ID_ASC = 'OWNER_ORGANISATION_ID_ASC',
  OWNER_ORGANISATION_ID_DESC = 'OWNER_ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  RTA_ASC = 'RTA_ASC',
  RTA_DESC = 'RTA_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  SOFT_DELETE_ASC = 'SOFT_DELETE_ASC',
  SOFT_DELETE_DESC = 'SOFT_DELETE_DESC',
  SPECIFIC_GRAVITY_ASC = 'SPECIFIC_GRAVITY_ASC',
  SPECIFIC_GRAVITY_DESC = 'SPECIFIC_GRAVITY_DESC',
  STARTED_ASC = 'STARTED_ASC',
  STARTED_DESC = 'STARTED_DESC',
  STOWAGE_FACTOR_MAX_ASC = 'STOWAGE_FACTOR_MAX_ASC',
  STOWAGE_FACTOR_MAX_DESC = 'STOWAGE_FACTOR_MAX_DESC',
  STOWAGE_FACTOR_MIN_ASC = 'STOWAGE_FACTOR_MIN_ASC',
  STOWAGE_FACTOR_MIN_DESC = 'STOWAGE_FACTOR_MIN_DESC',
  STOWAGE_MODE_ASC = 'STOWAGE_MODE_ASC',
  STOWAGE_MODE_DESC = 'STOWAGE_MODE_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TO_BE_DELETED_ASC = 'TO_BE_DELETED_ASC',
  TO_BE_DELETED_DESC = 'TO_BE_DELETED_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  WITHOUT_GUARANTEE_ASC = 'WITHOUT_GUARANTEE_ASC',
  WITHOUT_GUARANTEE_DESC = 'WITHOUT_GUARANTEE_DESC'
}

/** A connection to a list of `OrdersRelatedOrgsArrRecord` values. */
export type OrdersRelatedOrgsArrConnection = {
  __typename?: 'OrdersRelatedOrgsArrConnection';
  /** A list of edges which contains the `OrdersRelatedOrgsArrRecord` and cursor to aid in pagination. */
  edges: Array<OrdersRelatedOrgsArrEdge>;
  /** A list of `OrdersRelatedOrgsArrRecord` objects. */
  nodes: Array<Maybe<OrdersRelatedOrgsArrRecord>>;
  /** The count of *all* `OrdersRelatedOrgsArrRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrdersRelatedOrgsArrRecord` edge in the connection. */
export type OrdersRelatedOrgsArrEdge = {
  __typename?: 'OrdersRelatedOrgsArrEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrdersRelatedOrgsArrRecord` at the end of the edge. */
  node?: Maybe<OrdersRelatedOrgsArrRecord>;
};

/** The return type of our `ordersRelatedOrgsArr` query. */
export type OrdersRelatedOrgsArrRecord = {
  __typename?: 'OrdersRelatedOrgsArrRecord';
  orderId?: Maybe<Scalars['Int']['output']>;
  orgIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

/** A filter to be used against `OrdersRelatedOrgsArrRecord` object types. All fields are combined with a logical ‘and.’ */
export type OrdersRelatedOrgsArrRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrdersRelatedOrgsArrRecordFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<OrdersRelatedOrgsArrRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrdersRelatedOrgsArrRecordFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orgIds` field. */
  orgIds?: InputMaybe<IntListFilter>;
};

export type Organization = Node & {
  __typename?: 'Organization';
  /** Reads and enables pagination through a set of `ApiOrdersNotice`. */
  apiOrdersNoticesByOrganizationId: ApiOrdersNoticesConnection;
  /** Reads and enables pagination through a set of `AssortmentGroup`. */
  assortmentGroupsByChartererOrgId: AssortmentGroupsConnection;
  /** Reads and enables pagination through a set of `Assortment`. */
  assortmentsByChartererOrgId: AssortmentsConnection;
  /** Reads and enables pagination through a set of `Assortment`. */
  assortmentsByOrganizationId: AssortmentsConnection;
  /** Reads and enables pagination through a set of `Assortment`. */
  assortmentsByRootOrg: AssortmentsConnection;
  /** Reads and enables pagination through a set of `BatchUpdate`. */
  batchUpdatesByRootOrg: BatchUpdatesConnection;
  /** Reads and enables pagination through a set of `BillOfLading`. */
  billOfLadingsByRootOrg: BillOfLadingsConnection;
  /** broker user type for organisations */
  broker: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `BunkerGradeCalculation`. */
  bunkerGradeCalculationsByOrganizationId: BunkerGradeCalculationsConnection;
  /** Reads and enables pagination through a set of `BunkerGradeMapping`. */
  bunkerGradeMappingsByOrganizationId: BunkerGradeMappingsConnection;
  /** Reads and enables pagination through a set of `BunkerGradeOverride`. */
  bunkerGradeOverridesByOrganizationId: BunkerGradeOverridesConnection;
  /** Reads and enables pagination through a set of `BunkerGradeOverride`. */
  bunkerGradeOverridesByRootOrg: BunkerGradeOverridesConnection;
  /** Reads and enables pagination through a set of `Bunkering`. */
  bunkeringsByPlanningOrganisationId: BunkeringsConnection;
  /** Reads and enables pagination through a set of `CarbonPriceOverride`. */
  carbonPriceOverridesByOrganizationId: CarbonPriceOverridesConnection;
  /** Reads and enables pagination through a set of `CargoCompartmentAllocation`. */
  cargoCompartmentAllocationsByRootOrg: CargoCompartmentAllocationsConnection;
  /** Reads and enables pagination through a set of `CargoCompartment`. */
  cargoCompartmentsByOrganisationId: CargoCompartmentsConnection;
  /** Reads and enables pagination through a set of `CargoCompartment`. */
  cargoCompartmentsByRootOrg: CargoCompartmentsConnection;
  /** Reads and enables pagination through a set of `ChannelCostEstimate`. */
  channelCostEstimatesByOrganizationId: ChannelCostEstimatesConnection;
  /** Reads and enables pagination through a set of `ChannelCost`. */
  channelCostsByOrganisationId: ChannelCostsConnection;
  charterer: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `Chat`. */
  chatsByFromOrganizationId: ChatsConnection;
  /** Reads and enables pagination through a set of `Chat`. */
  chatsByToOrganizationId: ChatsConnection;
  /** Reads and enables pagination through a set of `CoaContractAssortment`. */
  coaContractAssortmentsByRootOrg: CoaContractAssortmentsConnection;
  /** Reads and enables pagination through a set of `CoaContractPortDatum`. */
  coaContractPortDataByRootOrg: CoaContractPortDataConnection;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  coaContractPortsByChartererOrgId: CoaContractPortsConnection;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  coaContractPortsByRootOrg: CoaContractPortsConnection;
  /** Reads and enables pagination through a set of `CoaContractPrice`. */
  coaContractPricesByRootOrg: CoaContractPricesConnection;
  /** Reads and enables pagination through a set of `CoaContractShip`. */
  coaContractShipsByRootOrg: CoaContractShipsConnection;
  /** Reads and enables pagination through a set of `CoaContract`. */
  coaContractsByChartererOrgId: CoaContractsConnection;
  /** Reads and enables pagination through a set of `CoaContract`. */
  coaContractsByOrganizationId: CoaContractsConnection;
  /** Reads and enables pagination through a set of `CoaContract`. */
  coaContractsByRootOrg: CoaContractsConnection;
  /** Reads and enables pagination through a set of `CoaContract`. */
  coaContractsByShipownerOrgId: CoaContractsConnection;
  /** Reads and enables pagination through a set of `Commission`. */
  commissionsByOrganizationId: CommissionsConnection;
  /** Reads and enables pagination through a set of `CommitLogScenario`. */
  commitLogScenariosByOrganizationId: CommitLogScenariosConnection;
  /** Reads and enables pagination through a set of `CommitLog`. */
  commitLogsByOrganizationId: CommitLogsConnection;
  /** Reads and enables pagination through a set of `CommitLog`. */
  commitLogsByRootOrg: CommitLogsConnection;
  configAutoAcceptOnlyConfirmed: Scalars['Boolean']['output'];
  configAutoAcceptUpdates: Scalars['Boolean']['output'];
  configAutoSyncUserScenarios: Scalars['Boolean']['output'];
  configAutoUpdatePortTimezone: Scalars['Boolean']['output'];
  /** can multiple orders of same assortment be allocated to the same tank */
  configCargoAllocationCombineAssortment: Scalars['Boolean']['output'];
  configDisablePcUpdates: Scalars['Boolean']['output'];
  configEnableAcceptAllUpdates: Scalars['Boolean']['output'];
  configEnableDefaultLaycan: Scalars['Boolean']['output'];
  configEnableScenarioAutoSave: Scalars['Boolean']['output'];
  /** can use Worldscale for determining freights */
  configEnableWorldscaleFreights: Scalars['Boolean']['output'];
  configEventsConcurrentDefault: Scalars['Boolean']['output'];
  configIgnoreIntegrationCargoMargins: Scalars['Boolean']['output'];
  configIncludeFuelEuInCosts: Scalars['Boolean']['output'];
  configIntegrationHistoricalPortCalls: Scalars['Boolean']['output'];
  configIntegrationManageOrders: Scalars['Boolean']['output'];
  configIntegrationMergeShipments: Scalars['Boolean']['output'];
  configPortcallDurationBerthapiDefault: Scalars['Boolean']['output'];
  configReducedUnits: Scalars['Boolean']['output'];
  configUseCalculatedLimit: Scalars['Boolean']['output'];
  configUseMasterPorts: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `DbChange`. */
  dbChangesByRootOrg: DbChangesConnection;
  defaultCurrency?: Maybe<Currency>;
  /** Default commodities fill factor for the organization */
  defaultFillFactor?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsByChartererOrgId: DemandsConnection;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsByDestinationId: DemandsConnection;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsByOrganizationId: DemandsConnection;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsBySendingOrganizationId: DemandsConnection;
  descendants?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  domain?: Maybe<Scalars['String']['output']>;
  draft?: Maybe<Scalars['BigFloat']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `EmailToOrderLog`. */
  emailToOrderLogsByRootOrg: EmailToOrderLogsConnection;
  endpoint?: Maybe<Scalars['String']['output']>;
  euEtsCosts: Scalars['Boolean']['output'];
  externalOrderIdPrefix?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `GeographicalEntity`. */
  geographicalEntitiesByOrganisationId: GeographicalEntitiesConnection;
  /** Reads and enables pagination through a set of `HandledByCoa`. */
  handledByCoasByRootOrg: HandledByCoasConnection;
  /** Reads and enables pagination through a set of `HandledBySpot`. */
  handledBySpotsByOwnerOrganisationId: HandledBySpotsConnection;
  /** Reads and enables pagination through a set of `HandledBySpot`. */
  handledBySpotsByRootOrg: HandledBySpotsConnection;
  id: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `Instruction`. */
  instructionsByOrganizationId: InstructionsConnection;
  /** Reads and enables pagination through a set of `IntegrationLog`. */
  integrationLogsByOrganizationId: IntegrationLogsConnection;
  /** Reads and enables pagination through a set of `InvoiceItem`. */
  invoiceItemsByRootOrg: InvoiceItemsConnection;
  /** Reads and enables pagination through a set of `Invoice`. */
  invoicesByPayingOrganizationId: InvoicesConnection;
  /** Reads and enables pagination through a set of `LaytimeResponsibility`. */
  laytimeResponsibilitiesByOrganizationId: LaytimeResponsibilitiesConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByOrganisationId: LocationsConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByRootOrg: LocationsConnection;
  /** Reads and enables pagination through a set of `LostContract`. */
  lostContractsByOrganizationId: LostContractsConnection;
  /** Reads and enables pagination through a set of `LostContract`. */
  lostContractsByRootOrg: LostContractsConnection;
  mailBackup?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `NoGoZone`. */
  noGoZonesByRootOrg: NoGoZonesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OffHire`. */
  offHiresByPlanningOrganisationId: OffHiresConnection;
  /** Reads and enables pagination through a set of `OffHire`. */
  offHiresByRootOrg: OffHiresConnection;
  /** Reads and enables pagination through a set of `OpenPosition`. */
  openPositionsByRootOrg: OpenPositionsConnection;
  /** Reads and enables pagination through a set of `OrderAttributeAssociation`. */
  orderAttributeAssociationsByRootOrg: OrderAttributeAssociationsConnection;
  /** Reads and enables pagination through a set of `OrderAttribute`. */
  orderAttributesByOrganizationId: OrderAttributesConnection;
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsByDischargePortAgentId: OrderDetailsConnection;
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsByLoadPortAgentOrgId: OrderDetailsConnection;
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsByReceiverOrganisationId: OrderDetailsConnection;
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsByRootOrg: OrderDetailsConnection;
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsBySenderOrganisationId: OrderDetailsConnection;
  /** Reads and enables pagination through a set of `OrderPortCallRelation`. */
  orderPortCallRelationsByRootOrg: OrderPortCallRelationsConnection;
  /** Reads and enables pagination through a set of `OrderRequirementAssociation`. */
  orderRequirementAssociationsByRootOrg: OrderRequirementAssociationsConnection;
  /** Reads and enables pagination through a set of `OrderVoyageCharterRelation`. */
  orderVoyageCharterRelationsByRootOrg: OrderVoyageCharterRelationsConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByChartererOrganizationId: OrdersConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByOrganizationId: OrdersConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByOwnerOrganisationId: OrdersConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByRootOrg: OrdersConnection;
  /** Reads and enables pagination through a set of `OrdersHistory`. */
  ordersHistoriesByOrganizationId: OrdersHistoriesConnection;
  /** Reads and enables pagination through a set of `OrganizationAreaBunkerGradeMapping`. */
  organizationAreaBunkerGradeMappingsByOrganizationId: OrganizationAreaBunkerGradeMappingsConnection;
  /** Reads a single `Organization` that is related to this `Organization`. */
  organizationByParentOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Organization`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads and enables pagination through a set of `OrganizationFeature`. */
  organizationFeaturesByOrganizationId: OrganizationFeaturesConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByParentOrganizationId: OrganizationsConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByRootOrg: OrganizationsConnection;
  parentOrganizationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `PortActivity`. */
  portActivitiesByRootOrg: PortActivitiesConnection;
  portAgent: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `PortCallExternalTimestamp`. */
  portCallExternalTimestampsByRootOrg: PortCallExternalTimestampsConnection;
  /** Reads and enables pagination through a set of `PortCallFile`. */
  portCallFilesByRootOrg: PortCallFilesConnection;
  /** Reads and enables pagination through a set of `PortCommodityLdRate`. */
  portCommodityLdRatesByOrganizationId: PortCommodityLdRatesConnection;
  /** Reads and enables pagination through a set of `PortCostDefault`. */
  portCostDefaultsByOrganizationId: PortCostDefaultsConnection;
  /** Reads and enables pagination through a set of `PortCostEstimatesExternal`. */
  portCostEstimatesExternalsByOrganizationId: PortCostEstimatesExternalsConnection;
  portCostPriority?: Maybe<Scalars['JSON']['output']>;
  /** Reads and enables pagination through a set of `PortCost`. */
  portCostsByOrganisationId: PortCostsConnection;
  /** Reads and enables pagination through a set of `PortDatum`. */
  portDataByPortAgentOrgId: PortDataConnection;
  /** Reads and enables pagination through a set of `PortDatum`. */
  portDataByRootOrg: PortDataConnection;
  /** Reads and enables pagination through a set of `PortNotice`. */
  portNoticesByRootOrg: PortNoticesConnection;
  /** Reads and enables pagination through a set of `PortRegion`. */
  portRegionsByOrganizationId: PortRegionsConnection;
  /** Reads and enables pagination through a set of `Prompt`. */
  promptsByOrganizationId: PromptsConnection;
  receiver: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `ReceiverOrganization`. */
  receiverOrganizationsByAdminOrganizationId: ReceiverOrganizationsConnection;
  /** Reads and enables pagination through a set of `ReceiverOrganization`. */
  receiverOrganizationsByOrganizationId: ReceiverOrganizationsConnection;
  /** Reads and enables pagination through a set of `Region`. */
  regionsByChartererOrgId: RegionsConnection;
  /** Reads and enables pagination through a set of `RequestLog`. */
  requestLogsByOrganizationId: RequestLogsConnection;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `RouteOverride`. */
  routeOverridesByOrganisationId: RouteOverridesConnection;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenariosByOrganizationId: ScenariosConnection;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenariosByRootOrg: ScenariosConnection;
  /** Reads and enables pagination through a set of `ScheduledOrder`. */
  scheduledOrdersByPlanningOrganisationId: ScheduledOrdersConnection;
  /** Reads and enables pagination through a set of `ScheduledOrder`. */
  scheduledOrdersByRootOrg: ScheduledOrdersConnection;
  sender: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `SenderOrganization`. */
  senderOrganizationsByAdminOrganizationId: SenderOrganizationsConnection;
  /** Reads and enables pagination through a set of `SenderOrganization`. */
  senderOrganizationsByOrganizationId: SenderOrganizationsConnection;
  shipOwner: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `ShipmentGroup`. */
  shipmentGroupsByOrganisationId: ShipmentGroupsConnection;
  /** Reads and enables pagination through a set of `Shipment`. */
  shipmentsByChartererOrganisation: ShipmentsConnection;
  /** Reads and enables pagination through a set of `Shipment`. */
  shipmentsByOwnerOrganisation: ShipmentsConnection;
  /** Reads and enables pagination through a set of `Shipment`. */
  shipmentsByRootOrg: ShipmentsConnection;
  /** Reads and enables pagination through a set of `Ship`. */
  shipsByOrganizationId: ShipsConnection;
  /** Reads and enables pagination through a set of `Ship`. */
  shipsByRootOrg: ShipsConnection;
  /** Reads and enables pagination through a set of `SingleEventPortCallRelation`. */
  singleEventPortCallRelationsByRootOrg: SingleEventPortCallRelationsConnection;
  /** Reads and enables pagination through a set of `SingleEvent`. */
  singleEventsByPlanningOrganisationId: SingleEventsConnection;
  /** Reads and enables pagination through a set of `SingleEvent`. */
  singleEventsByRootOrg: SingleEventsConnection;
  /** Reads and enables pagination through a set of `SpecialRequirement`. */
  specialRequirementsByOrganizationId: SpecialRequirementsConnection;
  /** Reads and enables pagination through a set of `SpotNegotiation`. */
  spotNegotiationsByChartererOrganisationId: SpotNegotiationsConnection;
  /** Reads and enables pagination through a set of `SpotNegotiation`. */
  spotNegotiationsByOwnerOrganisationId: SpotNegotiationsConnection;
  /** Reads and enables pagination through a set of `StatementOfFact`. */
  statementOfFactsByRootOrg: StatementOfFactsConnection;
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesByChartererOrgId: SuppliesConnection;
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesByOrganizationId: SuppliesConnection;
  /** Reads and enables pagination through a set of `SupplyContract`. */
  supplyContractsByOrganizationId: SupplyContractsConnection;
  /** Reads and enables pagination through a set of `SupplyContract`. */
  supplyContractsBySenderOrganizationId: SupplyContractsConnection;
  /** Reads and enables pagination through a set of `TcContract`. */
  tcContractsByRootOrg: TcContractsConnection;
  /** Reads and enables pagination through a set of `UserRight`. */
  userRightsByOrganizationId: UserRightsConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByOrganizationId: UsersConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByRootOrg: UsersConnection;
  /** Reads and enables pagination through a set of `VesselAttributesAssociation`. */
  vesselAttributesAssociationsByRootOrg: VesselAttributesAssociationsConnection;
  /** Reads and enables pagination through a set of `VesselAttribute`. */
  vesselAttributesByOrganizationId: VesselAttributesConnection;
  /** Reads and enables pagination through a set of `VesselAttribute`. */
  vesselAttributesByRootOrg: VesselAttributesConnection;
  /** Reads and enables pagination through a set of `VesselDraftDatapoint`. */
  vesselDraftDatapointsByOrganizationId: VesselDraftDatapointsConnection;
  /** Reads and enables pagination through a set of `VesselFulfillsRequirementAssociation`. */
  vesselFulfillsRequirementAssociationsByRootOrg: VesselFulfillsRequirementAssociationsConnection;
  /** Reads and enables pagination through a set of `VesselInfo`. */
  vesselInfosByOwnerOrganisationId: VesselInfosConnection;
  /** Reads and enables pagination through a set of `VesselInfo`. */
  vesselInfosByRootOrg: VesselInfosConnection;
  /** Reads and enables pagination through a set of `VesselPerformanceModel`. */
  vesselPerformanceModelsByRootOrg: VesselPerformanceModelsConnection;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  vesselReservationsByRootOrg: VesselReservationsConnection;
  /** Reads and enables pagination through a set of `VesselScheduleSharedToOrganization`. */
  vesselScheduleSharedToOrganizationsByOrganizationId: VesselScheduleSharedToOrganizationsConnection;
  /** Reads and enables pagination through a set of `VesselScheduleSharedToOrganization`. */
  vesselScheduleSharedToOrganizationsByRootOrg: VesselScheduleSharedToOrganizationsConnection;
  /** Reads and enables pagination through a set of `VesselSecret`. */
  vesselSecretsByOrganisationId: VesselSecretsConnection;
  /** Reads and enables pagination through a set of `VesselSpeedConsumption`. */
  vesselSpeedConsumptionsByOrganizationId: VesselSpeedConsumptionsConnection;
  /** Reads and enables pagination through a set of `VesselSpeedConsumption`. */
  vesselSpeedConsumptionsByRootOrg: VesselSpeedConsumptionsConnection;
  /** Reads and enables pagination through a set of `VoyageAttribute`. */
  voyageAttributesByOrganizationId: VoyageAttributesConnection;
  /** Reads and enables pagination through a set of `VoyageAttribute`. */
  voyageAttributesByRootOrg: VoyageAttributesConnection;
  /** Reads and enables pagination through a set of `VoyageCharterHistory`. */
  voyageCharterHistoriesByChartererOrgId: VoyageCharterHistoriesConnection;
  /** Reads and enables pagination through a set of `VoyageCharterOrderFreight`. */
  voyageCharterOrderFreightsByRootOrg: VoyageCharterOrderFreightsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterPortDatum`. */
  voyageCharterPortDataByRootOrg: VoyageCharterPortDataConnection;
  /** Reads and enables pagination through a set of `VoyageCharterToContract`. */
  voyageCharterToContractsByRootOrg: VoyageCharterToContractsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterUpdate`. */
  voyageCharterUpdatesByCreatedByOrgId: VoyageCharterUpdatesConnection;
  /** Reads and enables pagination through a set of `VoyageCharter`. */
  voyageChartersByChartererOrgId: VoyageChartersConnection;
  /** Reads and enables pagination through a set of `VoyageCharter`. */
  voyageChartersByOrganisationId: VoyageChartersConnection;
  /** Reads and enables pagination through a set of `VoyageCharter`. */
  voyageChartersByRootOrg: VoyageChartersConnection;
  /** Reads and enables pagination through a set of `VoyageCharter`. */
  voyageChartersByShipownerOrgId: VoyageChartersConnection;
  /** Reads and enables pagination through a set of `VoyageNamingRule`. */
  voyageNamingRulesByOrganizationId: VoyageNamingRulesConnection;
  /** Reads and enables pagination through a set of `Voyage`. */
  voyagesByOrganisationId: VoyagesConnection;
  /** Reads and enables pagination through a set of `WorldscaleFreight`. */
  worldscaleFreightsByOrganizationId: WorldscaleFreightsConnection;
  /** Reads and enables pagination through a set of `ZoneLocation`. */
  zoneLocationsByRootOrg: ZoneLocationsConnection;
  /** Reads and enables pagination through a set of `Zone`. */
  zonesByRootOrg: ZonesConnection;
};


export type OrganizationApiOrdersNoticesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiOrdersNoticeCondition>;
  filter?: InputMaybe<ApiOrdersNoticeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiOrdersNoticesOrderBy>>;
};


export type OrganizationAssortmentGroupsByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentGroupCondition>;
  filter?: InputMaybe<AssortmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentGroupsOrderBy>>;
};


export type OrganizationAssortmentsByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentCondition>;
  filter?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};


export type OrganizationAssortmentsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentCondition>;
  filter?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};


export type OrganizationAssortmentsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentCondition>;
  filter?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};


export type OrganizationBatchUpdatesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BatchUpdateCondition>;
  filter?: InputMaybe<BatchUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchUpdatesOrderBy>>;
};


export type OrganizationBillOfLadingsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillOfLadingCondition>;
  filter?: InputMaybe<BillOfLadingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOfLadingsOrderBy>>;
};


export type OrganizationBunkerGradeCalculationsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeCalculationCondition>;
  filter?: InputMaybe<BunkerGradeCalculationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeCalculationsOrderBy>>;
};


export type OrganizationBunkerGradeMappingsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeMappingCondition>;
  filter?: InputMaybe<BunkerGradeMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeMappingsOrderBy>>;
};


export type OrganizationBunkerGradeOverridesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeOverrideCondition>;
  filter?: InputMaybe<BunkerGradeOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};


export type OrganizationBunkerGradeOverridesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeOverrideCondition>;
  filter?: InputMaybe<BunkerGradeOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};


export type OrganizationBunkeringsByPlanningOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkeringCondition>;
  filter?: InputMaybe<BunkeringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkeringsOrderBy>>;
};


export type OrganizationCarbonPriceOverridesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarbonPriceOverrideCondition>;
  filter?: InputMaybe<CarbonPriceOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarbonPriceOverridesOrderBy>>;
};


export type OrganizationCargoCompartmentAllocationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentAllocationCondition>;
  filter?: InputMaybe<CargoCompartmentAllocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};


export type OrganizationCargoCompartmentsByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentCondition>;
  filter?: InputMaybe<CargoCompartmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};


export type OrganizationCargoCompartmentsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentCondition>;
  filter?: InputMaybe<CargoCompartmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};


export type OrganizationChannelCostEstimatesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostEstimateCondition>;
  filter?: InputMaybe<ChannelCostEstimateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
};


export type OrganizationChannelCostsByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostCondition>;
  filter?: InputMaybe<ChannelCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostsOrderBy>>;
};


export type OrganizationChatsByFromOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChatCondition>;
  filter?: InputMaybe<ChatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};


export type OrganizationChatsByToOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChatCondition>;
  filter?: InputMaybe<ChatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};


export type OrganizationCoaContractAssortmentsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractAssortmentCondition>;
  filter?: InputMaybe<CoaContractAssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractAssortmentsOrderBy>>;
};


export type OrganizationCoaContractPortDataByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortDatumCondition>;
  filter?: InputMaybe<CoaContractPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortDataOrderBy>>;
};


export type OrganizationCoaContractPortsByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


export type OrganizationCoaContractPortsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


export type OrganizationCoaContractPricesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPriceCondition>;
  filter?: InputMaybe<CoaContractPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};


export type OrganizationCoaContractShipsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractShipCondition>;
  filter?: InputMaybe<CoaContractShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractShipsOrderBy>>;
};


export type OrganizationCoaContractsByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCondition>;
  filter?: InputMaybe<CoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};


export type OrganizationCoaContractsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCondition>;
  filter?: InputMaybe<CoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};


export type OrganizationCoaContractsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCondition>;
  filter?: InputMaybe<CoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};


export type OrganizationCoaContractsByShipownerOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCondition>;
  filter?: InputMaybe<CoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};


export type OrganizationCommissionsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommissionCondition>;
  filter?: InputMaybe<CommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};


export type OrganizationCommitLogScenariosByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogScenarioCondition>;
  filter?: InputMaybe<CommitLogScenarioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogScenariosOrderBy>>;
};


export type OrganizationCommitLogsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogCondition>;
  filter?: InputMaybe<CommitLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogsOrderBy>>;
};


export type OrganizationCommitLogsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogCondition>;
  filter?: InputMaybe<CommitLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogsOrderBy>>;
};


export type OrganizationDbChangesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DbChangeCondition>;
  filter?: InputMaybe<DbChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbChangesOrderBy>>;
};


export type OrganizationDemandsByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type OrganizationDemandsByDestinationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type OrganizationDemandsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type OrganizationDemandsBySendingOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type OrganizationEmailToOrderLogsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailToOrderLogCondition>;
  filter?: InputMaybe<EmailToOrderLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailToOrderLogsOrderBy>>;
};


export type OrganizationGeographicalEntitiesByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GeographicalEntityCondition>;
  filter?: InputMaybe<GeographicalEntityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeographicalEntitiesOrderBy>>;
};


export type OrganizationHandledByCoasByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaCondition>;
  filter?: InputMaybe<HandledByCoaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};


export type OrganizationHandledBySpotsByOwnerOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotCondition>;
  filter?: InputMaybe<HandledBySpotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};


export type OrganizationHandledBySpotsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotCondition>;
  filter?: InputMaybe<HandledBySpotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};


export type OrganizationInstructionsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InstructionCondition>;
  filter?: InputMaybe<InstructionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InstructionsOrderBy>>;
};


export type OrganizationIntegrationLogsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IntegrationLogCondition>;
  filter?: InputMaybe<IntegrationLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationLogsOrderBy>>;
};


export type OrganizationInvoiceItemsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceItemCondition>;
  filter?: InputMaybe<InvoiceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoiceItemsOrderBy>>;
};


export type OrganizationInvoicesByPayingOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceCondition>;
  filter?: InputMaybe<InvoiceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
};


export type OrganizationLaytimeResponsibilitiesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LaytimeResponsibilityCondition>;
  filter?: InputMaybe<LaytimeResponsibilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LaytimeResponsibilitiesOrderBy>>;
};


export type OrganizationLocationsByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLocationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type OrganizationLostContractsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LostContractCondition>;
  filter?: InputMaybe<LostContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LostContractsOrderBy>>;
};


export type OrganizationLostContractsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LostContractCondition>;
  filter?: InputMaybe<LostContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LostContractsOrderBy>>;
};


export type OrganizationNoGoZonesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NoGoZoneCondition>;
  filter?: InputMaybe<NoGoZoneFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NoGoZonesOrderBy>>;
};


export type OrganizationOffHiresByPlanningOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireCondition>;
  filter?: InputMaybe<OffHireFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};


export type OrganizationOffHiresByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireCondition>;
  filter?: InputMaybe<OffHireFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};


export type OrganizationOpenPositionsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionCondition>;
  filter?: InputMaybe<OpenPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};


export type OrganizationOrderAttributeAssociationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderAttributeAssociationCondition>;
  filter?: InputMaybe<OrderAttributeAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderAttributeAssociationsOrderBy>>;
};


export type OrganizationOrderAttributesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderAttributeCondition>;
  filter?: InputMaybe<OrderAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderAttributesOrderBy>>;
};


export type OrganizationOrderDetailsByDischargePortAgentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};


export type OrganizationOrderDetailsByLoadPortAgentOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};


export type OrganizationOrderDetailsByReceiverOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};


export type OrganizationOrderDetailsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};


export type OrganizationOrderDetailsBySenderOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};


export type OrganizationOrderPortCallRelationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderPortCallRelationCondition>;
  filter?: InputMaybe<OrderPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderPortCallRelationsOrderBy>>;
};


export type OrganizationOrderRequirementAssociationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderRequirementAssociationCondition>;
  filter?: InputMaybe<OrderRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderRequirementAssociationsOrderBy>>;
};


export type OrganizationOrderVoyageCharterRelationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderVoyageCharterRelationCondition>;
  filter?: InputMaybe<OrderVoyageCharterRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};


export type OrganizationOrdersByChartererOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type OrganizationOrdersByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type OrganizationOrdersByOwnerOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type OrganizationOrdersByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type OrganizationOrdersHistoriesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrdersHistoryCondition>;
  filter?: InputMaybe<OrdersHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersHistoriesOrderBy>>;
};


export type OrganizationOrganizationAreaBunkerGradeMappingsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationAreaBunkerGradeMappingCondition>;
  filter?: InputMaybe<OrganizationAreaBunkerGradeMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationAreaBunkerGradeMappingsOrderBy>>;
};


export type OrganizationOrganizationFeaturesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationFeatureCondition>;
  filter?: InputMaybe<OrganizationFeatureFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationFeaturesOrderBy>>;
};


export type OrganizationOrganizationsByParentOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type OrganizationOrganizationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type OrganizationPortActivitiesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortActivityCondition>;
  filter?: InputMaybe<PortActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortActivitiesOrderBy>>;
};


export type OrganizationPortCallExternalTimestampsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallExternalTimestampCondition>;
  filter?: InputMaybe<PortCallExternalTimestampFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallExternalTimestampsOrderBy>>;
};


export type OrganizationPortCallFilesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallFileCondition>;
  filter?: InputMaybe<PortCallFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallFilesOrderBy>>;
};


export type OrganizationPortCommodityLdRatesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCommodityLdRateCondition>;
  filter?: InputMaybe<PortCommodityLdRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};


export type OrganizationPortCostDefaultsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostDefaultCondition>;
  filter?: InputMaybe<PortCostDefaultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostDefaultsOrderBy>>;
};


export type OrganizationPortCostEstimatesExternalsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostEstimatesExternalCondition>;
  filter?: InputMaybe<PortCostEstimatesExternalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostEstimatesExternalsOrderBy>>;
};


export type OrganizationPortCostsByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostCondition>;
  filter?: InputMaybe<PortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostsOrderBy>>;
};


export type OrganizationPortDataByPortAgentOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortDatumCondition>;
  filter?: InputMaybe<PortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortDataOrderBy>>;
};


export type OrganizationPortDataByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortDatumCondition>;
  filter?: InputMaybe<PortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortDataOrderBy>>;
};


export type OrganizationPortNoticesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortNoticeCondition>;
  filter?: InputMaybe<PortNoticeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortNoticesOrderBy>>;
};


export type OrganizationPortRegionsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortRegionCondition>;
  filter?: InputMaybe<PortRegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortRegionsOrderBy>>;
};


export type OrganizationPromptsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PromptCondition>;
  filter?: InputMaybe<PromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptsOrderBy>>;
};


export type OrganizationReceiverOrganizationsByAdminOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReceiverOrganizationCondition>;
  filter?: InputMaybe<ReceiverOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReceiverOrganizationsOrderBy>>;
};


export type OrganizationReceiverOrganizationsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReceiverOrganizationCondition>;
  filter?: InputMaybe<ReceiverOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReceiverOrganizationsOrderBy>>;
};


export type OrganizationRegionsByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RegionCondition>;
  filter?: InputMaybe<RegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionsOrderBy>>;
};


export type OrganizationRequestLogsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RequestLogCondition>;
  filter?: InputMaybe<RequestLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RequestLogsOrderBy>>;
};


export type OrganizationRouteOverridesByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteOverrideCondition>;
  filter?: InputMaybe<RouteOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};


export type OrganizationScenariosByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


export type OrganizationScenariosByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


export type OrganizationScheduledOrdersByPlanningOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderCondition>;
  filter?: InputMaybe<ScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};


export type OrganizationScheduledOrdersByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderCondition>;
  filter?: InputMaybe<ScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};


export type OrganizationSenderOrganizationsByAdminOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SenderOrganizationCondition>;
  filter?: InputMaybe<SenderOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SenderOrganizationsOrderBy>>;
};


export type OrganizationSenderOrganizationsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SenderOrganizationCondition>;
  filter?: InputMaybe<SenderOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SenderOrganizationsOrderBy>>;
};


export type OrganizationShipmentGroupsByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentGroupCondition>;
  filter?: InputMaybe<ShipmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentGroupsOrderBy>>;
};


export type OrganizationShipmentsByChartererOrganisationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentCondition>;
  filter?: InputMaybe<ShipmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};


export type OrganizationShipmentsByOwnerOrganisationArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentCondition>;
  filter?: InputMaybe<ShipmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};


export type OrganizationShipmentsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentCondition>;
  filter?: InputMaybe<ShipmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};


export type OrganizationShipsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipCondition>;
  filter?: InputMaybe<ShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};


export type OrganizationShipsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipCondition>;
  filter?: InputMaybe<ShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};


export type OrganizationSingleEventPortCallRelationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventPortCallRelationCondition>;
  filter?: InputMaybe<SingleEventPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventPortCallRelationsOrderBy>>;
};


export type OrganizationSingleEventsByPlanningOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventCondition>;
  filter?: InputMaybe<SingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};


export type OrganizationSingleEventsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventCondition>;
  filter?: InputMaybe<SingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};


export type OrganizationSpecialRequirementsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpecialRequirementCondition>;
  filter?: InputMaybe<SpecialRequirementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpecialRequirementsOrderBy>>;
};


export type OrganizationSpotNegotiationsByChartererOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpotNegotiationCondition>;
  filter?: InputMaybe<SpotNegotiationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};


export type OrganizationSpotNegotiationsByOwnerOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpotNegotiationCondition>;
  filter?: InputMaybe<SpotNegotiationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};


export type OrganizationStatementOfFactsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatementOfFactCondition>;
  filter?: InputMaybe<StatementOfFactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatementOfFactsOrderBy>>;
};


export type OrganizationSuppliesByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};


export type OrganizationSuppliesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};


export type OrganizationSupplyContractsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyContractCondition>;
  filter?: InputMaybe<SupplyContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplyContractsOrderBy>>;
};


export type OrganizationSupplyContractsBySenderOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyContractCondition>;
  filter?: InputMaybe<SupplyContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplyContractsOrderBy>>;
};


export type OrganizationTcContractsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TcContractCondition>;
  filter?: InputMaybe<TcContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TcContractsOrderBy>>;
};


export type OrganizationUserRightsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRightCondition>;
  filter?: InputMaybe<UserRightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRightsOrderBy>>;
};


export type OrganizationUsersByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type OrganizationUsersByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type OrganizationVesselAttributesAssociationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributesAssociationCondition>;
  filter?: InputMaybe<VesselAttributesAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributesAssociationsOrderBy>>;
};


export type OrganizationVesselAttributesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributeCondition>;
  filter?: InputMaybe<VesselAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributesOrderBy>>;
};


export type OrganizationVesselAttributesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributeCondition>;
  filter?: InputMaybe<VesselAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributesOrderBy>>;
};


export type OrganizationVesselDraftDatapointsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselDraftDatapointCondition>;
  filter?: InputMaybe<VesselDraftDatapointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselDraftDatapointsOrderBy>>;
};


export type OrganizationVesselFulfillsRequirementAssociationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselFulfillsRequirementAssociationCondition>;
  filter?: InputMaybe<VesselFulfillsRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
};


export type OrganizationVesselInfosByOwnerOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselInfoCondition>;
  filter?: InputMaybe<VesselInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
};


export type OrganizationVesselInfosByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselInfoCondition>;
  filter?: InputMaybe<VesselInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
};


export type OrganizationVesselPerformanceModelsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselPerformanceModelCondition>;
  filter?: InputMaybe<VesselPerformanceModelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselPerformanceModelsOrderBy>>;
};


export type OrganizationVesselReservationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};


export type OrganizationVesselScheduleSharedToOrganizationsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselScheduleSharedToOrganizationCondition>;
  filter?: InputMaybe<VesselScheduleSharedToOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselScheduleSharedToOrganizationsOrderBy>>;
};


export type OrganizationVesselScheduleSharedToOrganizationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselScheduleSharedToOrganizationCondition>;
  filter?: InputMaybe<VesselScheduleSharedToOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselScheduleSharedToOrganizationsOrderBy>>;
};


export type OrganizationVesselSecretsByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSecretCondition>;
  filter?: InputMaybe<VesselSecretFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSecretsOrderBy>>;
};


export type OrganizationVesselSpeedConsumptionsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSpeedConsumptionCondition>;
  filter?: InputMaybe<VesselSpeedConsumptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSpeedConsumptionsOrderBy>>;
};


export type OrganizationVesselSpeedConsumptionsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSpeedConsumptionCondition>;
  filter?: InputMaybe<VesselSpeedConsumptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSpeedConsumptionsOrderBy>>;
};


export type OrganizationVoyageAttributesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageAttributeCondition>;
  filter?: InputMaybe<VoyageAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageAttributesOrderBy>>;
};


export type OrganizationVoyageAttributesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageAttributeCondition>;
  filter?: InputMaybe<VoyageAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageAttributesOrderBy>>;
};


export type OrganizationVoyageCharterHistoriesByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterHistoryCondition>;
  filter?: InputMaybe<VoyageCharterHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterHistoriesOrderBy>>;
};


export type OrganizationVoyageCharterOrderFreightsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterOrderFreightCondition>;
  filter?: InputMaybe<VoyageCharterOrderFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterOrderFreightsOrderBy>>;
};


export type OrganizationVoyageCharterPortDataByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortDatumCondition>;
  filter?: InputMaybe<VoyageCharterPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortDataOrderBy>>;
};


export type OrganizationVoyageCharterToContractsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterToContractCondition>;
  filter?: InputMaybe<VoyageCharterToContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};


export type OrganizationVoyageCharterUpdatesByCreatedByOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterUpdateCondition>;
  filter?: InputMaybe<VoyageCharterUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};


export type OrganizationVoyageChartersByChartererOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterCondition>;
  filter?: InputMaybe<VoyageCharterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};


export type OrganizationVoyageChartersByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterCondition>;
  filter?: InputMaybe<VoyageCharterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};


export type OrganizationVoyageChartersByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterCondition>;
  filter?: InputMaybe<VoyageCharterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};


export type OrganizationVoyageChartersByShipownerOrgIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterCondition>;
  filter?: InputMaybe<VoyageCharterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};


export type OrganizationVoyageNamingRulesByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageNamingRuleCondition>;
  filter?: InputMaybe<VoyageNamingRuleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageNamingRulesOrderBy>>;
};


export type OrganizationVoyagesByOrganisationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCondition>;
  filter?: InputMaybe<VoyageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyagesOrderBy>>;
};


export type OrganizationWorldscaleFreightsByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorldscaleFreightCondition>;
  filter?: InputMaybe<WorldscaleFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorldscaleFreightsOrderBy>>;
};


export type OrganizationZoneLocationsByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ZoneLocationCondition>;
  filter?: InputMaybe<ZoneLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZoneLocationsOrderBy>>;
};


export type OrganizationZonesByRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ZoneCondition>;
  filter?: InputMaybe<ZoneFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

export type OrganizationAreaBunkerGradeMapping = Node & {
  __typename?: 'OrganizationAreaBunkerGradeMapping';
  bunkerGradeId: Scalars['BunkerGradeOverrideId']['output'];
  /** Reads a single `BunkerGradeOverride` that is related to this `OrganizationAreaBunkerGradeMapping`. */
  bunkerGradeOverrideByBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `OrganizationAreaBunkerGradeMapping`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  vesselArea: VesselArea;
};

/**
 * A condition to be used against `OrganizationAreaBunkerGradeMapping` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type OrganizationAreaBunkerGradeMappingCondition = {
  /** Checks for equality with the object’s `bunkerGradeId` field. */
  bunkerGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `vesselArea` field. */
  vesselArea?: InputMaybe<VesselArea>;
};

/** A filter to be used against `OrganizationAreaBunkerGradeMapping` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationAreaBunkerGradeMappingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrganizationAreaBunkerGradeMappingFilter>>;
  /** Filter by the object’s `bunkerGradeId` field. */
  bunkerGradeId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrganizationAreaBunkerGradeMappingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrganizationAreaBunkerGradeMappingFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselArea` field. */
  vesselArea?: InputMaybe<VesselAreaFilter>;
};

/** An input for mutations affecting `OrganizationAreaBunkerGradeMapping` */
export type OrganizationAreaBunkerGradeMappingInput = {
  bunkerGradeId: Scalars['BunkerGradeOverrideId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  vesselArea: VesselArea;
};

/** Represents an update to a `OrganizationAreaBunkerGradeMapping`. Fields that are set will be updated. */
export type OrganizationAreaBunkerGradeMappingPatch = {
  bunkerGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselArea?: InputMaybe<VesselArea>;
};

/** A connection to a list of `OrganizationAreaBunkerGradeMapping` values. */
export type OrganizationAreaBunkerGradeMappingsConnection = {
  __typename?: 'OrganizationAreaBunkerGradeMappingsConnection';
  /** A list of edges which contains the `OrganizationAreaBunkerGradeMapping` and cursor to aid in pagination. */
  edges: Array<OrganizationAreaBunkerGradeMappingsEdge>;
  /** A list of `OrganizationAreaBunkerGradeMapping` objects. */
  nodes: Array<Maybe<OrganizationAreaBunkerGradeMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrganizationAreaBunkerGradeMapping` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrganizationAreaBunkerGradeMapping` edge in the connection. */
export type OrganizationAreaBunkerGradeMappingsEdge = {
  __typename?: 'OrganizationAreaBunkerGradeMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrganizationAreaBunkerGradeMapping` at the end of the edge. */
  node?: Maybe<OrganizationAreaBunkerGradeMapping>;
};

/** Methods to use when ordering `OrganizationAreaBunkerGradeMapping`. */
export enum OrganizationAreaBunkerGradeMappingsOrderBy {
  BUNKER_GRADE_ID_ASC = 'BUNKER_GRADE_ID_ASC',
  BUNKER_GRADE_ID_DESC = 'BUNKER_GRADE_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VESSEL_AREA_ASC = 'VESSEL_AREA_ASC',
  VESSEL_AREA_DESC = 'VESSEL_AREA_DESC'
}

/**
 * A condition to be used against `Organization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrganizationCondition = {
  /** Checks for equality with the object’s `broker` field. */
  broker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `charterer` field. */
  charterer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configAutoAcceptOnlyConfirmed` field. */
  configAutoAcceptOnlyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configAutoAcceptUpdates` field. */
  configAutoAcceptUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configAutoSyncUserScenarios` field. */
  configAutoSyncUserScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configAutoUpdatePortTimezone` field. */
  configAutoUpdatePortTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configCargoAllocationCombineAssortment` field. */
  configCargoAllocationCombineAssortment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configDisablePcUpdates` field. */
  configDisablePcUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configEnableAcceptAllUpdates` field. */
  configEnableAcceptAllUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configEnableDefaultLaycan` field. */
  configEnableDefaultLaycan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configEnableScenarioAutoSave` field. */
  configEnableScenarioAutoSave?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configEnableWorldscaleFreights` field. */
  configEnableWorldscaleFreights?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configEventsConcurrentDefault` field. */
  configEventsConcurrentDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configIgnoreIntegrationCargoMargins` field. */
  configIgnoreIntegrationCargoMargins?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configIncludeFuelEuInCosts` field. */
  configIncludeFuelEuInCosts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configIntegrationHistoricalPortCalls` field. */
  configIntegrationHistoricalPortCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configIntegrationManageOrders` field. */
  configIntegrationManageOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configIntegrationMergeShipments` field. */
  configIntegrationMergeShipments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configPortcallDurationBerthapiDefault` field. */
  configPortcallDurationBerthapiDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configReducedUnits` field. */
  configReducedUnits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configUseCalculatedLimit` field. */
  configUseCalculatedLimit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `configUseMasterPorts` field. */
  configUseMasterPorts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `defaultCurrency` field. */
  defaultCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `defaultFillFactor` field. */
  defaultFillFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `descendants` field. */
  descendants?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `domain` field. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `endpoint` field. */
  endpoint?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `euEtsCosts` field. */
  euEtsCosts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `externalOrderIdPrefix` field. */
  externalOrderIdPrefix?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `mailBackup` field. */
  mailBackup?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `parentOrganizationId` field. */
  parentOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `portAgent` field. */
  portAgent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `portCostPriority` field. */
  portCostPriority?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `receiver` field. */
  receiver?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sender` field. */
  sender?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `shipOwner` field. */
  shipOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationFeature = Node & {
  __typename?: 'OrganizationFeature';
  /** Reads a single `Feature` that is related to this `OrganizationFeature`. */
  featureByFeatureName?: Maybe<Feature>;
  featureName: Scalars['FeatureFeatureNameString']['output'];
  id: Scalars['OrganizationFeatureId']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `OrganizationFeature`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `OrganizationFeature` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OrganizationFeatureCondition = {
  /** Checks for equality with the object’s `featureName` field. */
  featureName?: InputMaybe<Scalars['FeatureFeatureNameString']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['OrganizationFeatureId']['input']>;
  /** Checks for equality with the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `OrganizationFeature` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationFeatureFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrganizationFeatureFilter>>;
  /** Filter by the object’s `featureName` field. */
  featureName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isEnabled` field. */
  isEnabled?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrganizationFeatureFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrganizationFeatureFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `OrganizationFeature` */
export type OrganizationFeatureInput = {
  featureName: Scalars['FeatureFeatureNameString']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
};

/** Represents an update to a `OrganizationFeature`. Fields that are set will be updated. */
export type OrganizationFeaturePatch = {
  featureName?: InputMaybe<Scalars['FeatureFeatureNameString']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `OrganizationFeature` values. */
export type OrganizationFeaturesConnection = {
  __typename?: 'OrganizationFeaturesConnection';
  /** A list of edges which contains the `OrganizationFeature` and cursor to aid in pagination. */
  edges: Array<OrganizationFeaturesEdge>;
  /** A list of `OrganizationFeature` objects. */
  nodes: Array<Maybe<OrganizationFeature>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OrganizationFeature` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OrganizationFeature` edge in the connection. */
export type OrganizationFeaturesEdge = {
  __typename?: 'OrganizationFeaturesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrganizationFeature` at the end of the edge. */
  node?: Maybe<OrganizationFeature>;
};

/** Methods to use when ordering `OrganizationFeature`. */
export enum OrganizationFeaturesOrderBy {
  FEATURE_NAME_ASC = 'FEATURE_NAME_ASC',
  FEATURE_NAME_DESC = 'FEATURE_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ENABLED_ASC = 'IS_ENABLED_ASC',
  IS_ENABLED_DESC = 'IS_ENABLED_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against `Organization` object types. All fields are combined with a logical ‘and.’ */
export type OrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrganizationFilter>>;
  /** Filter by the object’s `broker` field. */
  broker?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `charterer` field. */
  charterer?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configAutoAcceptOnlyConfirmed` field. */
  configAutoAcceptOnlyConfirmed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configAutoAcceptUpdates` field. */
  configAutoAcceptUpdates?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configAutoSyncUserScenarios` field. */
  configAutoSyncUserScenarios?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configAutoUpdatePortTimezone` field. */
  configAutoUpdatePortTimezone?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configCargoAllocationCombineAssortment` field. */
  configCargoAllocationCombineAssortment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configDisablePcUpdates` field. */
  configDisablePcUpdates?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configEnableAcceptAllUpdates` field. */
  configEnableAcceptAllUpdates?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configEnableDefaultLaycan` field. */
  configEnableDefaultLaycan?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configEnableScenarioAutoSave` field. */
  configEnableScenarioAutoSave?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configEnableWorldscaleFreights` field. */
  configEnableWorldscaleFreights?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configEventsConcurrentDefault` field. */
  configEventsConcurrentDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configIgnoreIntegrationCargoMargins` field. */
  configIgnoreIntegrationCargoMargins?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configIncludeFuelEuInCosts` field. */
  configIncludeFuelEuInCosts?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configIntegrationHistoricalPortCalls` field. */
  configIntegrationHistoricalPortCalls?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configIntegrationManageOrders` field. */
  configIntegrationManageOrders?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configIntegrationMergeShipments` field. */
  configIntegrationMergeShipments?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configPortcallDurationBerthapiDefault` field. */
  configPortcallDurationBerthapiDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configReducedUnits` field. */
  configReducedUnits?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configUseCalculatedLimit` field. */
  configUseCalculatedLimit?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `configUseMasterPorts` field. */
  configUseMasterPorts?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultCurrency` field. */
  defaultCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `defaultFillFactor` field. */
  defaultFillFactor?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `descendants` field. */
  descendants?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `domain` field. */
  domain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endpoint` field. */
  endpoint?: InputMaybe<StringFilter>;
  /** Filter by the object’s `euEtsCosts` field. */
  euEtsCosts?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `externalOrderIdPrefix` field. */
  externalOrderIdPrefix?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `mailBackup` field. */
  mailBackup?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrganizationFilter>>;
  /** Filter by the object’s `parentOrganizationId` field. */
  parentOrganizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portAgent` field. */
  portAgent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `portCostPriority` field. */
  portCostPriority?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `receiver` field. */
  receiver?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sender` field. */
  sender?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `shipOwner` field. */
  shipOwner?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `Organization` */
export type OrganizationInput = {
  /** broker user type for organisations */
  broker?: InputMaybe<Scalars['Boolean']['input']>;
  charterer?: InputMaybe<Scalars['Boolean']['input']>;
  configAutoAcceptOnlyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  configAutoAcceptUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  configAutoSyncUserScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  configAutoUpdatePortTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  /** can multiple orders of same assortment be allocated to the same tank */
  configCargoAllocationCombineAssortment?: InputMaybe<Scalars['Boolean']['input']>;
  configDisablePcUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  configEnableAcceptAllUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  configEnableDefaultLaycan?: InputMaybe<Scalars['Boolean']['input']>;
  configEnableScenarioAutoSave?: InputMaybe<Scalars['Boolean']['input']>;
  /** can use Worldscale for determining freights */
  configEnableWorldscaleFreights?: InputMaybe<Scalars['Boolean']['input']>;
  configEventsConcurrentDefault?: InputMaybe<Scalars['Boolean']['input']>;
  configIgnoreIntegrationCargoMargins?: InputMaybe<Scalars['Boolean']['input']>;
  configIncludeFuelEuInCosts?: InputMaybe<Scalars['Boolean']['input']>;
  configIntegrationHistoricalPortCalls?: InputMaybe<Scalars['Boolean']['input']>;
  configIntegrationManageOrders?: InputMaybe<Scalars['Boolean']['input']>;
  configIntegrationMergeShipments?: InputMaybe<Scalars['Boolean']['input']>;
  configPortcallDurationBerthapiDefault?: InputMaybe<Scalars['Boolean']['input']>;
  configReducedUnits?: InputMaybe<Scalars['Boolean']['input']>;
  configUseCalculatedLimit?: InputMaybe<Scalars['Boolean']['input']>;
  configUseMasterPorts?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  defaultCurrency?: InputMaybe<Currency>;
  /** Default commodities fill factor for the organization */
  defaultFillFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  euEtsCosts?: InputMaybe<Scalars['Boolean']['input']>;
  externalOrderIdPrefix?: InputMaybe<Scalars['String']['input']>;
  mailBackup?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portAgent?: InputMaybe<Scalars['Boolean']['input']>;
  portCostPriority?: InputMaybe<Scalars['JSON']['input']>;
  receiver?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['Boolean']['input']>;
  shipOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `Organization`. Fields that are set will be updated. */
export type OrganizationPatch = {
  /** broker user type for organisations */
  broker?: InputMaybe<Scalars['Boolean']['input']>;
  charterer?: InputMaybe<Scalars['Boolean']['input']>;
  configAutoAcceptOnlyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  configAutoAcceptUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  configAutoSyncUserScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  configAutoUpdatePortTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  /** can multiple orders of same assortment be allocated to the same tank */
  configCargoAllocationCombineAssortment?: InputMaybe<Scalars['Boolean']['input']>;
  configDisablePcUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  configEnableAcceptAllUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  configEnableDefaultLaycan?: InputMaybe<Scalars['Boolean']['input']>;
  configEnableScenarioAutoSave?: InputMaybe<Scalars['Boolean']['input']>;
  /** can use Worldscale for determining freights */
  configEnableWorldscaleFreights?: InputMaybe<Scalars['Boolean']['input']>;
  configEventsConcurrentDefault?: InputMaybe<Scalars['Boolean']['input']>;
  configIgnoreIntegrationCargoMargins?: InputMaybe<Scalars['Boolean']['input']>;
  configIncludeFuelEuInCosts?: InputMaybe<Scalars['Boolean']['input']>;
  configIntegrationHistoricalPortCalls?: InputMaybe<Scalars['Boolean']['input']>;
  configIntegrationManageOrders?: InputMaybe<Scalars['Boolean']['input']>;
  configIntegrationMergeShipments?: InputMaybe<Scalars['Boolean']['input']>;
  configPortcallDurationBerthapiDefault?: InputMaybe<Scalars['Boolean']['input']>;
  configReducedUnits?: InputMaybe<Scalars['Boolean']['input']>;
  configUseCalculatedLimit?: InputMaybe<Scalars['Boolean']['input']>;
  configUseMasterPorts?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  defaultCurrency?: InputMaybe<Currency>;
  /** Default commodities fill factor for the organization */
  defaultFillFactor?: InputMaybe<Scalars['BigFloat']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  euEtsCosts?: InputMaybe<Scalars['Boolean']['input']>;
  externalOrderIdPrefix?: InputMaybe<Scalars['String']['input']>;
  mailBackup?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portAgent?: InputMaybe<Scalars['Boolean']['input']>;
  portCostPriority?: InputMaybe<Scalars['JSON']['input']>;
  receiver?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['Boolean']['input']>;
  shipOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `Organization` values. */
export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  /** A list of edges which contains the `Organization` and cursor to aid in pagination. */
  edges: Array<OrganizationsEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<Organization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organization` edge in the connection. */
export type OrganizationsEdge = {
  __typename?: 'OrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Organization` at the end of the edge. */
  node?: Maybe<Organization>;
};

/** Methods to use when ordering `Organization`. */
export enum OrganizationsOrderBy {
  BROKER_ASC = 'BROKER_ASC',
  BROKER_DESC = 'BROKER_DESC',
  CHARTERER_ASC = 'CHARTERER_ASC',
  CHARTERER_DESC = 'CHARTERER_DESC',
  CONFIG_AUTO_ACCEPT_ONLY_CONFIRMED_ASC = 'CONFIG_AUTO_ACCEPT_ONLY_CONFIRMED_ASC',
  CONFIG_AUTO_ACCEPT_ONLY_CONFIRMED_DESC = 'CONFIG_AUTO_ACCEPT_ONLY_CONFIRMED_DESC',
  CONFIG_AUTO_ACCEPT_UPDATES_ASC = 'CONFIG_AUTO_ACCEPT_UPDATES_ASC',
  CONFIG_AUTO_ACCEPT_UPDATES_DESC = 'CONFIG_AUTO_ACCEPT_UPDATES_DESC',
  CONFIG_AUTO_SYNC_USER_SCENARIOS_ASC = 'CONFIG_AUTO_SYNC_USER_SCENARIOS_ASC',
  CONFIG_AUTO_SYNC_USER_SCENARIOS_DESC = 'CONFIG_AUTO_SYNC_USER_SCENARIOS_DESC',
  CONFIG_AUTO_UPDATE_PORT_TIMEZONE_ASC = 'CONFIG_AUTO_UPDATE_PORT_TIMEZONE_ASC',
  CONFIG_AUTO_UPDATE_PORT_TIMEZONE_DESC = 'CONFIG_AUTO_UPDATE_PORT_TIMEZONE_DESC',
  CONFIG_CARGO_ALLOCATION_COMBINE_ASSORTMENT_ASC = 'CONFIG_CARGO_ALLOCATION_COMBINE_ASSORTMENT_ASC',
  CONFIG_CARGO_ALLOCATION_COMBINE_ASSORTMENT_DESC = 'CONFIG_CARGO_ALLOCATION_COMBINE_ASSORTMENT_DESC',
  CONFIG_DISABLE_PC_UPDATES_ASC = 'CONFIG_DISABLE_PC_UPDATES_ASC',
  CONFIG_DISABLE_PC_UPDATES_DESC = 'CONFIG_DISABLE_PC_UPDATES_DESC',
  CONFIG_ENABLE_ACCEPT_ALL_UPDATES_ASC = 'CONFIG_ENABLE_ACCEPT_ALL_UPDATES_ASC',
  CONFIG_ENABLE_ACCEPT_ALL_UPDATES_DESC = 'CONFIG_ENABLE_ACCEPT_ALL_UPDATES_DESC',
  CONFIG_ENABLE_DEFAULT_LAYCAN_ASC = 'CONFIG_ENABLE_DEFAULT_LAYCAN_ASC',
  CONFIG_ENABLE_DEFAULT_LAYCAN_DESC = 'CONFIG_ENABLE_DEFAULT_LAYCAN_DESC',
  CONFIG_ENABLE_SCENARIO_AUTO_SAVE_ASC = 'CONFIG_ENABLE_SCENARIO_AUTO_SAVE_ASC',
  CONFIG_ENABLE_SCENARIO_AUTO_SAVE_DESC = 'CONFIG_ENABLE_SCENARIO_AUTO_SAVE_DESC',
  CONFIG_ENABLE_WORLDSCALE_FREIGHTS_ASC = 'CONFIG_ENABLE_WORLDSCALE_FREIGHTS_ASC',
  CONFIG_ENABLE_WORLDSCALE_FREIGHTS_DESC = 'CONFIG_ENABLE_WORLDSCALE_FREIGHTS_DESC',
  CONFIG_EVENTS_CONCURRENT_DEFAULT_ASC = 'CONFIG_EVENTS_CONCURRENT_DEFAULT_ASC',
  CONFIG_EVENTS_CONCURRENT_DEFAULT_DESC = 'CONFIG_EVENTS_CONCURRENT_DEFAULT_DESC',
  CONFIG_IGNORE_INTEGRATION_CARGO_MARGINS_ASC = 'CONFIG_IGNORE_INTEGRATION_CARGO_MARGINS_ASC',
  CONFIG_IGNORE_INTEGRATION_CARGO_MARGINS_DESC = 'CONFIG_IGNORE_INTEGRATION_CARGO_MARGINS_DESC',
  CONFIG_INCLUDE_FUEL_EU_IN_COSTS_ASC = 'CONFIG_INCLUDE_FUEL_EU_IN_COSTS_ASC',
  CONFIG_INCLUDE_FUEL_EU_IN_COSTS_DESC = 'CONFIG_INCLUDE_FUEL_EU_IN_COSTS_DESC',
  CONFIG_INTEGRATION_HISTORICAL_PORT_CALLS_ASC = 'CONFIG_INTEGRATION_HISTORICAL_PORT_CALLS_ASC',
  CONFIG_INTEGRATION_HISTORICAL_PORT_CALLS_DESC = 'CONFIG_INTEGRATION_HISTORICAL_PORT_CALLS_DESC',
  CONFIG_INTEGRATION_MANAGE_ORDERS_ASC = 'CONFIG_INTEGRATION_MANAGE_ORDERS_ASC',
  CONFIG_INTEGRATION_MANAGE_ORDERS_DESC = 'CONFIG_INTEGRATION_MANAGE_ORDERS_DESC',
  CONFIG_INTEGRATION_MERGE_SHIPMENTS_ASC = 'CONFIG_INTEGRATION_MERGE_SHIPMENTS_ASC',
  CONFIG_INTEGRATION_MERGE_SHIPMENTS_DESC = 'CONFIG_INTEGRATION_MERGE_SHIPMENTS_DESC',
  CONFIG_PORTCALL_DURATION_BERTHAPI_DEFAULT_ASC = 'CONFIG_PORTCALL_DURATION_BERTHAPI_DEFAULT_ASC',
  CONFIG_PORTCALL_DURATION_BERTHAPI_DEFAULT_DESC = 'CONFIG_PORTCALL_DURATION_BERTHAPI_DEFAULT_DESC',
  CONFIG_REDUCED_UNITS_ASC = 'CONFIG_REDUCED_UNITS_ASC',
  CONFIG_REDUCED_UNITS_DESC = 'CONFIG_REDUCED_UNITS_DESC',
  CONFIG_USE_CALCULATED_LIMIT_ASC = 'CONFIG_USE_CALCULATED_LIMIT_ASC',
  CONFIG_USE_CALCULATED_LIMIT_DESC = 'CONFIG_USE_CALCULATED_LIMIT_DESC',
  CONFIG_USE_MASTER_PORTS_ASC = 'CONFIG_USE_MASTER_PORTS_ASC',
  CONFIG_USE_MASTER_PORTS_DESC = 'CONFIG_USE_MASTER_PORTS_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEFAULT_CURRENCY_ASC = 'DEFAULT_CURRENCY_ASC',
  DEFAULT_CURRENCY_DESC = 'DEFAULT_CURRENCY_DESC',
  DEFAULT_FILL_FACTOR_ASC = 'DEFAULT_FILL_FACTOR_ASC',
  DEFAULT_FILL_FACTOR_DESC = 'DEFAULT_FILL_FACTOR_DESC',
  DESCENDANTS_ASC = 'DESCENDANTS_ASC',
  DESCENDANTS_DESC = 'DESCENDANTS_DESC',
  DOMAIN_ASC = 'DOMAIN_ASC',
  DOMAIN_DESC = 'DOMAIN_DESC',
  DRAFT_ASC = 'DRAFT_ASC',
  DRAFT_DESC = 'DRAFT_DESC',
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  ENDPOINT_ASC = 'ENDPOINT_ASC',
  ENDPOINT_DESC = 'ENDPOINT_DESC',
  EU_ETS_COSTS_ASC = 'EU_ETS_COSTS_ASC',
  EU_ETS_COSTS_DESC = 'EU_ETS_COSTS_DESC',
  EXTERNAL_ORDER_ID_PREFIX_ASC = 'EXTERNAL_ORDER_ID_PREFIX_ASC',
  EXTERNAL_ORDER_ID_PREFIX_DESC = 'EXTERNAL_ORDER_ID_PREFIX_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MAIL_BACKUP_ASC = 'MAIL_BACKUP_ASC',
  MAIL_BACKUP_DESC = 'MAIL_BACKUP_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PARENT_ORGANIZATION_ID_ASC = 'PARENT_ORGANIZATION_ID_ASC',
  PARENT_ORGANIZATION_ID_DESC = 'PARENT_ORGANIZATION_ID_DESC',
  PORT_AGENT_ASC = 'PORT_AGENT_ASC',
  PORT_AGENT_DESC = 'PORT_AGENT_DESC',
  PORT_COST_PRIORITY_ASC = 'PORT_COST_PRIORITY_ASC',
  PORT_COST_PRIORITY_DESC = 'PORT_COST_PRIORITY_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RECEIVER_ASC = 'RECEIVER_ASC',
  RECEIVER_DESC = 'RECEIVER_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SENDER_ASC = 'SENDER_ASC',
  SENDER_DESC = 'SENDER_DESC',
  SHIP_OWNER_ASC = 'SHIP_OWNER_ASC',
  SHIP_OWNER_DESC = 'SHIP_OWNER_DESC'
}

export type OrganizationsSubscriptionPayload = {
  __typename?: 'OrganizationsSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type ParsedImportedOrdersInput = {
  file: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export enum PaymentTrigger {
  AFTER_MEASUREMENT = 'AFTER_MEASUREMENT',
  AFTER_RIGHT_AND_TRUE_DELIVERY = 'AFTER_RIGHT_AND_TRUE_DELIVERY',
  INVOICE_DATE = 'INVOICE_DATE',
  UPON_S_R_BO_L = 'UPON_S_R_BO_L'
}

/** A filter to be used against PaymentTrigger fields. All fields are combined with a logical ‘and.’ */
export type PaymentTriggerFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PaymentTrigger>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PaymentTrigger>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PaymentTrigger>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PaymentTrigger>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PaymentTrigger>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PaymentTrigger>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PaymentTrigger>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PaymentTrigger>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PaymentTrigger>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PaymentTrigger>>;
};

export enum PaymentType {
  AFTER_R_T_DELIVERY_ON_OUTTURNED_WEIGHT = 'AFTER_R_T_DELIVERY_ON_OUTTURNED_WEIGHT',
  AS_PER_BOOKING_NOTE = 'AS_PER_BOOKING_NOTE',
  BANKING_DAYS_AFTER_DELIVERY_OF_CARGO = 'BANKING_DAYS_AFTER_DELIVERY_OF_CARGO',
  BANKING_DAYS_AFTER_SIGNING_RELEASING_B_L = 'BANKING_DAYS_AFTER_SIGNING_RELEASING_B_L',
  BDAYS_AFTER_S_R_B_L_BUT_IN_ANY_CASE_BBB = 'BDAYS_AFTER_S_R_B_L_BUT_IN_ANY_CASE_BBB',
  BEFORE_BREAKING_BULK = 'BEFORE_BREAKING_BULK',
  B_DAYS_AFTER_RECEIPT_OF_OWNERS_INVOICE = 'B_DAYS_AFTER_RECEIPT_OF_OWNERS_INVOICE',
  DAYS_AFTER_DATE_OF_FREIGHT_INVOICE = 'DAYS_AFTER_DATE_OF_FREIGHT_INVOICE',
  DAYS_AFTER_RECEIPT_OF_INVOICE_ON_B_L = 'DAYS_AFTER_RECEIPT_OF_INVOICE_ON_B_L',
  DAYS_AFTER_RECEIPT_OF_OWNERS_INVOICE = 'DAYS_AFTER_RECEIPT_OF_OWNERS_INVOICE',
  DAYS_AFTER_R_T_DELIVERY_OF_CARGO_ON_B_L = 'DAYS_AFTER_R_T_DELIVERY_OF_CARGO_ON_B_L',
  DAYS_AFTER_R_T_DEL_OF_CARGO_OUTTURN_WT = 'DAYS_AFTER_R_T_DEL_OF_CARGO_OUTTURN_WT',
  DAYS_AFTER_SIGNING_RELEASING_B_L = 'DAYS_AFTER_SIGNING_RELEASING_B_L',
  DAYS_AFTER_S_R_B_L_BUT_IN_ANY_CASE_BBB = 'DAYS_AFTER_S_R_B_L_BUT_IN_ANY_CASE_BBB',
  DAYS_BEFORE_BREAKING_BULK = 'DAYS_BEFORE_BREAKING_BULK',
  DESPATCH = 'DESPATCH',
  ON_B_L_WEIGHT_AFTER_R_T_DELIVERY = 'ON_B_L_WEIGHT_AFTER_R_T_DELIVERY',
  ON_DELIVERY = 'ON_DELIVERY',
  PREPAID = 'PREPAID',
  UPON_RECEIPT_OF_OWNERS_FREIGHT_INVOICE = 'UPON_RECEIPT_OF_OWNERS_FREIGHT_INVOICE',
  UPON_SIGNING_RELEASING_B_L = 'UPON_SIGNING_RELEASING_B_L',
  _15TH_AND_30TH_OF_EACH_MONTH = '_15TH_AND_30TH_OF_EACH_MONTH'
}

/** A filter to be used against PaymentType fields. All fields are combined with a logical ‘and.’ */
export type PaymentTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PaymentType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PaymentType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PaymentType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PaymentType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PaymentType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PaymentType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PaymentType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PaymentType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PaymentType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PaymentType>>;
};

export enum PaymentUnit {
  BDMT = 'BDMT',
  FRT = 'FRT',
  FT3 = 'FT3',
  LUMPSUM = 'LUMPSUM',
  M3 = 'M3',
  MT = 'MT',
  PER_PCS = 'PER_PCS',
  PER_SET = 'PER_SET',
  SCBM_UB = 'SCBM_UB',
  WORLDSCALE = 'WORLDSCALE'
}

/** A filter to be used against PaymentUnit fields. All fields are combined with a logical ‘and.’ */
export type PaymentUnitFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PaymentUnit>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PaymentUnit>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PaymentUnit>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PaymentUnit>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PaymentUnit>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PaymentUnit>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PaymentUnit>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PaymentUnit>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PaymentUnit>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PaymentUnit>>;
};

/** A connection to a list of `PortActivity` values. */
export type PortActivitiesConnection = {
  __typename?: 'PortActivitiesConnection';
  /** A list of edges which contains the `PortActivity` and cursor to aid in pagination. */
  edges: Array<PortActivitiesEdge>;
  /** A list of `PortActivity` objects. */
  nodes: Array<Maybe<PortActivity>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortActivity` edge in the connection. */
export type PortActivitiesEdge = {
  __typename?: 'PortActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortActivity` at the end of the edge. */
  node?: Maybe<PortActivity>;
};

/** Methods to use when ordering `PortActivity`. */
export enum PortActivitiesOrderBy {
  END_ASC = 'END_ASC',
  END_DESC = 'END_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  OPERATION_ASC = 'OPERATION_ASC',
  OPERATION_DESC = 'OPERATION_DESC',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  START_ASC = 'START_ASC',
  START_DESC = 'START_DESC',
  STATEMENT_OF_FACTS_ID_ASC = 'STATEMENT_OF_FACTS_ID_ASC',
  STATEMENT_OF_FACTS_ID_DESC = 'STATEMENT_OF_FACTS_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type PortActivity = Node & {
  __typename?: 'PortActivity';
  end?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['PortActivityId']['output'];
  /** Reads and enables pagination through a set of `LaytimeResponsibility`. */
  laytimeResponsibilitiesByPortActivityId: LaytimeResponsibilitiesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  operation?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `PortActivity`. */
  orderByOrderId?: Maybe<Order>;
  orderId?: Maybe<Scalars['OrderId']['output']>;
  /** Reads a single `Organization` that is related to this `PortActivity`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  start: Scalars['Datetime']['output'];
  /** Reads a single `StatementOfFact` that is related to this `PortActivity`. */
  statementOfFactByStatementOfFactsId?: Maybe<StatementOfFact>;
  statementOfFactsId: Scalars['StatementOfFactId']['output'];
  /** Reads a single `User` that is related to this `PortActivity`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
};


export type PortActivityLaytimeResponsibilitiesByPortActivityIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LaytimeResponsibilityCondition>;
  filter?: InputMaybe<LaytimeResponsibilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LaytimeResponsibilitiesOrderBy>>;
};

/**
 * A condition to be used against `PortActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PortActivityCondition = {
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortActivityId']['input']>;
  /** Checks for equality with the object’s `operation` field. */
  operation?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `statementOfFactsId` field. */
  statementOfFactsId?: InputMaybe<Scalars['StatementOfFactId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `PortActivity` object types. All fields are combined with a logical ‘and.’ */
export type PortActivityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortActivityFilter>>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortActivityFilter>;
  /** Filter by the object’s `operation` field. */
  operation?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortActivityFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `statementOfFactsId` field. */
  statementOfFactsId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `PortActivity` */
export type PortActivityInput = {
  end?: InputMaybe<Scalars['Datetime']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  start: Scalars['Datetime']['input'];
  statementOfFactsId: Scalars['StatementOfFactId']['input'];
  userId: Scalars['UserId']['input'];
};

/** Represents an update to a `PortActivity`. Fields that are set will be updated. */
export type PortActivityPatch = {
  end?: InputMaybe<Scalars['Datetime']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  start?: InputMaybe<Scalars['Datetime']['input']>;
  statementOfFactsId?: InputMaybe<Scalars['StatementOfFactId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** All input for the `portAgentsListFromSessOrg` mutation. */
export type PortAgentsListFromSessOrgInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `portAgentsListFromSessOrg` mutation. */
export type PortAgentsListFromSessOrgPayload = {
  __typename?: 'PortAgentsListFromSessOrgPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type PortCall = Node & {
  __typename?: 'PortCall';
  archived: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `BillOfLading`. */
  billOfLadingsByPortCallId: BillOfLadingsConnection;
  bunkerOverrides?: Maybe<Scalars['JSON']['output']>;
  bunkerPriceSource?: Maybe<Scalars['JSON']['output']>;
  channelCostDefaultId?: Maybe<Scalars['ChannelCostEstimateId']['output']>;
  /** Reads a single `ChannelCostEstimate` that is related to this `PortCall`. */
  channelCostEstimateByChannelCostDefaultId?: Maybe<ChannelCostEstimate>;
  /** Hours. Additional duration added to computed sea duration when the leg uses a channel. NULL when not using a channel, interpreted as 0. Ignored when sea_duration_overhead is set. */
  channelDurationOverhead?: Maybe<Scalars['BigInt']['output']>;
  clientId: Scalars['UUID']['output'];
  /** Redundant as of 2021-08-31. The column can be removed. */
  firstStart?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['PortCallId']['output'];
  /** Reads and enables pagination through a set of `InvoiceItem`. */
  invoiceItemsByPortCallId: InvoiceItemsConnection;
  /** Redundant as of 2021-08-31. The column can be removed. */
  lastEnd?: Maybe<Scalars['Datetime']['output']>;
  legAvoidsChannels: Scalars['Boolean']['output'];
  /** Reads a single `Location` that is related to this `PortCall`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `PortCall`. */
  locationByPreviousLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  oneTimeOverrideChannelCost?: Maybe<Scalars['BigFloat']['output']>;
  oneTimeOverrideCost?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `OrderPortCallRelation`. */
  orderPortCallRelationsByPortCallId: OrderPortCallRelationsConnection;
  /** Planned time of arrival */
  plannedArrival?: Maybe<Scalars['Datetime']['output']>;
  plannedArrivalDuration?: Maybe<Scalars['BigInt']['output']>;
  plannedArrivalOverride?: Maybe<Scalars['Datetime']['output']>;
  plannedArrivalOverrideSourcedAt?: Maybe<Scalars['Datetime']['output']>;
  plannedArrivalOverrideSourcedFrom?: Maybe<Scalars['String']['output']>;
  /** Planned time of berth */
  plannedBerthing?: Maybe<Scalars['Datetime']['output']>;
  plannedBerthingDuration?: Maybe<Scalars['BigInt']['output']>;
  plannedBerthingOverride?: Maybe<Scalars['Datetime']['output']>;
  plannedBerthingOverrideSourcedAt?: Maybe<Scalars['Datetime']['output']>;
  plannedBerthingOverrideSourcedFrom?: Maybe<Scalars['String']['output']>;
  /** Planned time of departure */
  plannedDeparture?: Maybe<Scalars['Datetime']['output']>;
  plannedDepartureDuration?: Maybe<Scalars['BigInt']['output']>;
  plannedDepartureOverride?: Maybe<Scalars['Datetime']['output']>;
  plannedDepartureOverrideSourcedAt?: Maybe<Scalars['Datetime']['output']>;
  plannedDepartureOverrideSourcedFrom?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PortCallExternalTimestamp`. */
  portCallExternalTimestampsByPortCallId: PortCallExternalTimestampsConnection;
  /** Reads and enables pagination through a set of `PortCallFile`. */
  portCallFilesByPortCallId: PortCallFilesConnection;
  /** Reads and enables pagination through a set of `PortCallHistory`. */
  portCallHistoriesById: PortCallHistoriesConnection;
  /** Reads a single `PortCostDefault` that is related to this `PortCall`. */
  portCostDefaultByPortCostDefaultId?: Maybe<PortCostDefault>;
  portCostDefaultId?: Maybe<Scalars['PortCostDefaultId']['output']>;
  /** Reads and enables pagination through a set of `PortNotice`. */
  portNoticesByPortCallId: PortNoticesConnection;
  /** The previous port; The origin location for the sea duration. */
  previousLocationId?: Maybe<Scalars['LocationId']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  seaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Ship` that is related to this `PortCall`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads and enables pagination through a set of `SingleEventPortCallRelation`. */
  singleEventPortCallRelationsByPortCallId: SingleEventPortCallRelationsConnection;
  /** Reads and enables pagination through a set of `StatementOfFact`. */
  statementOfFactsByPortCallId: StatementOfFactsConnection;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  totalDischargeDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  totalLoadDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  useHistoricalPortCost: Scalars['Boolean']['output'];
  useIntegrationPortCost: Scalars['Boolean']['output'];
  useLatestHistoricalPortCost: Scalars['Boolean']['output'];
  useOneTimeOverrideCost: Scalars['Boolean']['output'];
  /** Reads a single `User` that is related to this `PortCall`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  /** The weather factor for the port call, value in percentage range 0-100 */
  weatherFactor?: Maybe<Scalars['BigFloat']['output']>;
};


export type PortCallBillOfLadingsByPortCallIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillOfLadingCondition>;
  filter?: InputMaybe<BillOfLadingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOfLadingsOrderBy>>;
};


export type PortCallInvoiceItemsByPortCallIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceItemCondition>;
  filter?: InputMaybe<InvoiceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoiceItemsOrderBy>>;
};


export type PortCallOrderPortCallRelationsByPortCallIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderPortCallRelationCondition>;
  filter?: InputMaybe<OrderPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderPortCallRelationsOrderBy>>;
};


export type PortCallPortCallExternalTimestampsByPortCallIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallExternalTimestampCondition>;
  filter?: InputMaybe<PortCallExternalTimestampFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallExternalTimestampsOrderBy>>;
};


export type PortCallPortCallFilesByPortCallIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallFileCondition>;
  filter?: InputMaybe<PortCallFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallFilesOrderBy>>;
};


export type PortCallPortCallHistoriesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallHistoryCondition>;
  filter?: InputMaybe<PortCallHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallHistoriesOrderBy>>;
};


export type PortCallPortNoticesByPortCallIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortNoticeCondition>;
  filter?: InputMaybe<PortNoticeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortNoticesOrderBy>>;
};


export type PortCallSingleEventPortCallRelationsByPortCallIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventPortCallRelationCondition>;
  filter?: InputMaybe<SingleEventPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventPortCallRelationsOrderBy>>;
};


export type PortCallStatementOfFactsByPortCallIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatementOfFactCondition>;
  filter?: InputMaybe<StatementOfFactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatementOfFactsOrderBy>>;
};

/**
 * A condition to be used against `PortCall` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PortCallCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `bunkerOverrides` field. */
  bunkerOverrides?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `bunkerPriceSource` field. */
  bunkerPriceSource?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `channelCostDefaultId` field. */
  channelCostDefaultId?: InputMaybe<Scalars['ChannelCostEstimateId']['input']>;
  /** Checks for equality with the object’s `channelDurationOverhead` field. */
  channelDurationOverhead?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `firstStart` field. */
  firstStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `lastEnd` field. */
  lastEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `legAvoidsChannels` field. */
  legAvoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `oneTimeOverrideChannelCost` field. */
  oneTimeOverrideChannelCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `oneTimeOverrideCost` field. */
  oneTimeOverrideCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `plannedArrival` field. */
  plannedArrival?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedArrivalDuration` field. */
  plannedArrivalDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `plannedArrivalOverride` field. */
  plannedArrivalOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedArrivalOverrideSourcedAt` field. */
  plannedArrivalOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedArrivalOverrideSourcedFrom` field. */
  plannedArrivalOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `plannedBerthing` field. */
  plannedBerthing?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedBerthingDuration` field. */
  plannedBerthingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `plannedBerthingOverride` field. */
  plannedBerthingOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedBerthingOverrideSourcedAt` field. */
  plannedBerthingOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedBerthingOverrideSourcedFrom` field. */
  plannedBerthingOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `plannedDeparture` field. */
  plannedDeparture?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedDepartureDuration` field. */
  plannedDepartureDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `plannedDepartureOverride` field. */
  plannedDepartureOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedDepartureOverrideSourcedAt` field. */
  plannedDepartureOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedDepartureOverrideSourcedFrom` field. */
  plannedDepartureOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portCostDefaultId` field. */
  portCostDefaultId?: InputMaybe<Scalars['PortCostDefaultId']['input']>;
  /** Checks for equality with the object’s `previousLocationId` field. */
  previousLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `seaDurationOverride` field. */
  seaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `totalDischargeDurationOverride` field. */
  totalDischargeDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalLoadDurationOverride` field. */
  totalLoadDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `useHistoricalPortCost` field. */
  useHistoricalPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `useIntegrationPortCost` field. */
  useIntegrationPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `useLatestHistoricalPortCost` field. */
  useLatestHistoricalPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `useOneTimeOverrideCost` field. */
  useOneTimeOverrideCost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `weatherFactor` field. */
  weatherFactor?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** External timesources for port calls. */
export type PortCallExternalTimestamp = Node & {
  __typename?: 'PortCallExternalTimestamp';
  eventType: PortcallExternalTimestampEvent;
  id: Scalars['PortCallExternalTimestampId']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  latestValueReceivedAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PortCallExternalTimestamp`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortCallExternalTimestamp`. */
  portCallByPortCallId?: Maybe<PortCall>;
  portCallId: Scalars['PortCallId']['output'];
  priority: Scalars['Int']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  sourceName: Scalars['String']['output'];
  timestampType: PortcallExternalTimestampType;
  updatedAt: Scalars['Datetime']['output'];
  value: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `PortCallExternalTimestamp` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PortCallExternalTimestampCondition = {
  /** Checks for equality with the object’s `eventType` field. */
  eventType?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortCallExternalTimestampId']['input']>;
  /** Checks for equality with the object’s `isConfirmed` field. */
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `latestValueReceivedAt` field. */
  latestValueReceivedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `priority` field. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sourceName` field. */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `timestampType` field. */
  timestampType?: InputMaybe<PortcallExternalTimestampType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `PortCallExternalTimestamp` object types. All fields are combined with a logical ‘and.’ */
export type PortCallExternalTimestampFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCallExternalTimestampFilter>>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<PortcallExternalTimestampEventFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isConfirmed` field. */
  isConfirmed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `latestValueReceivedAt` field. */
  latestValueReceivedAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCallExternalTimestampFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCallExternalTimestampFilter>>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `priority` field. */
  priority?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceName` field. */
  sourceName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `timestampType` field. */
  timestampType?: InputMaybe<PortcallExternalTimestampTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `PortCallExternalTimestamp` */
export type PortCallExternalTimestampInput = {
  eventType: PortcallExternalTimestampEvent;
  isConfirmed: Scalars['Boolean']['input'];
  latestValueReceivedAt: Scalars['Datetime']['input'];
  portCallId: Scalars['PortCallId']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  sourceName: Scalars['String']['input'];
  timestampType: PortcallExternalTimestampType;
  updatedAt: Scalars['Datetime']['input'];
  value: Scalars['Datetime']['input'];
};

/** Represents an update to a `PortCallExternalTimestamp`. Fields that are set will be updated. */
export type PortCallExternalTimestampPatch = {
  eventType?: InputMaybe<PortcallExternalTimestampEvent>;
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  latestValueReceivedAt?: InputMaybe<Scalars['Datetime']['input']>;
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  timestampType?: InputMaybe<PortcallExternalTimestampType>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  value?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `PortCallExternalTimestamp` values. */
export type PortCallExternalTimestampsConnection = {
  __typename?: 'PortCallExternalTimestampsConnection';
  /** A list of edges which contains the `PortCallExternalTimestamp` and cursor to aid in pagination. */
  edges: Array<PortCallExternalTimestampsEdge>;
  /** A list of `PortCallExternalTimestamp` objects. */
  nodes: Array<Maybe<PortCallExternalTimestamp>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCallExternalTimestamp` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCallExternalTimestamp` edge in the connection. */
export type PortCallExternalTimestampsEdge = {
  __typename?: 'PortCallExternalTimestampsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCallExternalTimestamp` at the end of the edge. */
  node?: Maybe<PortCallExternalTimestamp>;
};

/** Methods to use when ordering `PortCallExternalTimestamp`. */
export enum PortCallExternalTimestampsOrderBy {
  EVENT_TYPE_ASC = 'EVENT_TYPE_ASC',
  EVENT_TYPE_DESC = 'EVENT_TYPE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_CONFIRMED_ASC = 'IS_CONFIRMED_ASC',
  IS_CONFIRMED_DESC = 'IS_CONFIRMED_DESC',
  LATEST_VALUE_RECEIVED_AT_ASC = 'LATEST_VALUE_RECEIVED_AT_ASC',
  LATEST_VALUE_RECEIVED_AT_DESC = 'LATEST_VALUE_RECEIVED_AT_DESC',
  NATURAL = 'NATURAL',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PRIORITY_ASC = 'PRIORITY_ASC',
  PRIORITY_DESC = 'PRIORITY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SOURCE_NAME_ASC = 'SOURCE_NAME_ASC',
  SOURCE_NAME_DESC = 'SOURCE_NAME_DESC',
  TIMESTAMP_TYPE_ASC = 'TIMESTAMP_TYPE_ASC',
  TIMESTAMP_TYPE_DESC = 'TIMESTAMP_TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VALUE_ASC = 'VALUE_ASC',
  VALUE_DESC = 'VALUE_DESC'
}

export type PortCallFile = Node & {
  __typename?: 'PortCallFile';
  /** Reads a single `File` that is related to this `PortCallFile`. */
  fileByFileId?: Maybe<File>;
  fileId: Scalars['FileId']['output'];
  id: Scalars['PortCallFileId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PortCallFile`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortCallFile`. */
  portCallByPortCallId?: Maybe<PortCall>;
  portCallId: Scalars['PortCallId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `PortCallFile` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PortCallFileCondition = {
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars['FileId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortCallFileId']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `PortCallFile` object types. All fields are combined with a logical ‘and.’ */
export type PortCallFileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCallFileFilter>>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCallFileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCallFileFilter>>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `PortCallFile` */
export type PortCallFileInput = {
  fileId: Scalars['FileId']['input'];
  portCallId: Scalars['PortCallId']['input'];
};

/** Represents an update to a `PortCallFile`. Fields that are set will be updated. */
export type PortCallFilePatch = {
  fileId?: InputMaybe<Scalars['FileId']['input']>;
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
};

/** A connection to a list of `PortCallFile` values. */
export type PortCallFilesConnection = {
  __typename?: 'PortCallFilesConnection';
  /** A list of edges which contains the `PortCallFile` and cursor to aid in pagination. */
  edges: Array<PortCallFilesEdge>;
  /** A list of `PortCallFile` objects. */
  nodes: Array<Maybe<PortCallFile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCallFile` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCallFile` edge in the connection. */
export type PortCallFilesEdge = {
  __typename?: 'PortCallFilesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCallFile` at the end of the edge. */
  node?: Maybe<PortCallFile>;
};

/** Methods to use when ordering `PortCallFile`. */
export enum PortCallFilesOrderBy {
  FILE_ID_ASC = 'FILE_ID_ASC',
  FILE_ID_DESC = 'FILE_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

/** A filter to be used against `PortCall` object types. All fields are combined with a logical ‘and.’ */
export type PortCallFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCallFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `bunkerOverrides` field. */
  bunkerOverrides?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `bunkerPriceSource` field. */
  bunkerPriceSource?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `channelCostDefaultId` field. */
  channelCostDefaultId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `channelDurationOverhead` field. */
  channelDurationOverhead?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `firstStart` field. */
  firstStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastEnd` field. */
  lastEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `legAvoidsChannels` field. */
  legAvoidsChannels?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCallFilter>;
  /** Filter by the object’s `oneTimeOverrideChannelCost` field. */
  oneTimeOverrideChannelCost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `oneTimeOverrideCost` field. */
  oneTimeOverrideCost?: InputMaybe<BigFloatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCallFilter>>;
  /** Filter by the object’s `plannedArrival` field. */
  plannedArrival?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedArrivalDuration` field. */
  plannedArrivalDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `plannedArrivalOverride` field. */
  plannedArrivalOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedArrivalOverrideSourcedAt` field. */
  plannedArrivalOverrideSourcedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedArrivalOverrideSourcedFrom` field. */
  plannedArrivalOverrideSourcedFrom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `plannedBerthing` field. */
  plannedBerthing?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedBerthingDuration` field. */
  plannedBerthingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `plannedBerthingOverride` field. */
  plannedBerthingOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedBerthingOverrideSourcedAt` field. */
  plannedBerthingOverrideSourcedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedBerthingOverrideSourcedFrom` field. */
  plannedBerthingOverrideSourcedFrom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `plannedDeparture` field. */
  plannedDeparture?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedDepartureDuration` field. */
  plannedDepartureDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `plannedDepartureOverride` field. */
  plannedDepartureOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedDepartureOverrideSourcedAt` field. */
  plannedDepartureOverrideSourcedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedDepartureOverrideSourcedFrom` field. */
  plannedDepartureOverrideSourcedFrom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portCostDefaultId` field. */
  portCostDefaultId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `previousLocationId` field. */
  previousLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `seaDurationOverride` field. */
  seaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `totalDischargeDurationOverride` field. */
  totalDischargeDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalLoadDurationOverride` field. */
  totalLoadDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `useHistoricalPortCost` field. */
  useHistoricalPortCost?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `useIntegrationPortCost` field. */
  useIntegrationPortCost?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `useLatestHistoricalPortCost` field. */
  useLatestHistoricalPortCost?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `useOneTimeOverrideCost` field. */
  useOneTimeOverrideCost?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `weatherFactor` field. */
  weatherFactor?: InputMaybe<BigFloatFilter>;
};

/** A connection to a list of `PortCallHistory` values. */
export type PortCallHistoriesConnection = {
  __typename?: 'PortCallHistoriesConnection';
  /** A list of edges which contains the `PortCallHistory` and cursor to aid in pagination. */
  edges: Array<PortCallHistoriesEdge>;
  /** A list of `PortCallHistory` objects. */
  nodes: Array<Maybe<PortCallHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCallHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCallHistory` edge in the connection. */
export type PortCallHistoriesEdge = {
  __typename?: 'PortCallHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCallHistory` at the end of the edge. */
  node?: Maybe<PortCallHistory>;
};

/** Methods to use when ordering `PortCallHistory`. */
export enum PortCallHistoriesOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  FIRST_START_ASC = 'FIRST_START_ASC',
  FIRST_START_DESC = 'FIRST_START_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAST_END_ASC = 'LAST_END_ASC',
  LAST_END_DESC = 'LAST_END_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PLANNED_ARRIVAL_ASC = 'PLANNED_ARRIVAL_ASC',
  PLANNED_ARRIVAL_DESC = 'PLANNED_ARRIVAL_DESC',
  PLANNED_ARRIVAL_DURATION_ASC = 'PLANNED_ARRIVAL_DURATION_ASC',
  PLANNED_ARRIVAL_DURATION_DESC = 'PLANNED_ARRIVAL_DURATION_DESC',
  PLANNED_ARRIVAL_OVERRIDE_ASC = 'PLANNED_ARRIVAL_OVERRIDE_ASC',
  PLANNED_ARRIVAL_OVERRIDE_DESC = 'PLANNED_ARRIVAL_OVERRIDE_DESC',
  PLANNED_ARRIVAL_OVERRIDE_SOURCED_AT_ASC = 'PLANNED_ARRIVAL_OVERRIDE_SOURCED_AT_ASC',
  PLANNED_ARRIVAL_OVERRIDE_SOURCED_AT_DESC = 'PLANNED_ARRIVAL_OVERRIDE_SOURCED_AT_DESC',
  PLANNED_ARRIVAL_OVERRIDE_SOURCED_FROM_ASC = 'PLANNED_ARRIVAL_OVERRIDE_SOURCED_FROM_ASC',
  PLANNED_ARRIVAL_OVERRIDE_SOURCED_FROM_DESC = 'PLANNED_ARRIVAL_OVERRIDE_SOURCED_FROM_DESC',
  PLANNED_BERTHING_ASC = 'PLANNED_BERTHING_ASC',
  PLANNED_BERTHING_DESC = 'PLANNED_BERTHING_DESC',
  PLANNED_BERTHING_DURATION_ASC = 'PLANNED_BERTHING_DURATION_ASC',
  PLANNED_BERTHING_DURATION_DESC = 'PLANNED_BERTHING_DURATION_DESC',
  PLANNED_BERTHING_OVERRIDE_ASC = 'PLANNED_BERTHING_OVERRIDE_ASC',
  PLANNED_BERTHING_OVERRIDE_DESC = 'PLANNED_BERTHING_OVERRIDE_DESC',
  PLANNED_BERTHING_OVERRIDE_SOURCED_AT_ASC = 'PLANNED_BERTHING_OVERRIDE_SOURCED_AT_ASC',
  PLANNED_BERTHING_OVERRIDE_SOURCED_AT_DESC = 'PLANNED_BERTHING_OVERRIDE_SOURCED_AT_DESC',
  PLANNED_BERTHING_OVERRIDE_SOURCED_FROM_ASC = 'PLANNED_BERTHING_OVERRIDE_SOURCED_FROM_ASC',
  PLANNED_BERTHING_OVERRIDE_SOURCED_FROM_DESC = 'PLANNED_BERTHING_OVERRIDE_SOURCED_FROM_DESC',
  PLANNED_DEPARTURE_ASC = 'PLANNED_DEPARTURE_ASC',
  PLANNED_DEPARTURE_DESC = 'PLANNED_DEPARTURE_DESC',
  PLANNED_DEPARTURE_DURATION_ASC = 'PLANNED_DEPARTURE_DURATION_ASC',
  PLANNED_DEPARTURE_DURATION_DESC = 'PLANNED_DEPARTURE_DURATION_DESC',
  PLANNED_DEPARTURE_OVERRIDE_ASC = 'PLANNED_DEPARTURE_OVERRIDE_ASC',
  PLANNED_DEPARTURE_OVERRIDE_DESC = 'PLANNED_DEPARTURE_OVERRIDE_DESC',
  PLANNED_DEPARTURE_OVERRIDE_SOURCED_AT_ASC = 'PLANNED_DEPARTURE_OVERRIDE_SOURCED_AT_ASC',
  PLANNED_DEPARTURE_OVERRIDE_SOURCED_AT_DESC = 'PLANNED_DEPARTURE_OVERRIDE_SOURCED_AT_DESC',
  PLANNED_DEPARTURE_OVERRIDE_SOURCED_FROM_ASC = 'PLANNED_DEPARTURE_OVERRIDE_SOURCED_FROM_ASC',
  PLANNED_DEPARTURE_OVERRIDE_SOURCED_FROM_DESC = 'PLANNED_DEPARTURE_OVERRIDE_SOURCED_FROM_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SEA_DURATION_OVERRIDE_ASC = 'SEA_DURATION_OVERRIDE_ASC',
  SEA_DURATION_OVERRIDE_DESC = 'SEA_DURATION_OVERRIDE_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for port call */
export type PortCallHistory = {
  __typename?: 'PortCallHistory';
  archived: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['UUID']['output']>;
  firstStart?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['PortCallId']['output'];
  lastEnd?: Maybe<Scalars['Datetime']['output']>;
  locationId: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  plannedArrival?: Maybe<Scalars['Datetime']['output']>;
  plannedArrivalDuration?: Maybe<Scalars['BigInt']['output']>;
  plannedArrivalOverride?: Maybe<Scalars['Datetime']['output']>;
  plannedArrivalOverrideSourcedAt?: Maybe<Scalars['Datetime']['output']>;
  plannedArrivalOverrideSourcedFrom?: Maybe<Scalars['String']['output']>;
  plannedBerthing?: Maybe<Scalars['Datetime']['output']>;
  plannedBerthingDuration?: Maybe<Scalars['BigInt']['output']>;
  plannedBerthingOverride?: Maybe<Scalars['Datetime']['output']>;
  plannedBerthingOverrideSourcedAt?: Maybe<Scalars['Datetime']['output']>;
  plannedBerthingOverrideSourcedFrom?: Maybe<Scalars['String']['output']>;
  plannedDeparture?: Maybe<Scalars['Datetime']['output']>;
  plannedDepartureDuration?: Maybe<Scalars['BigInt']['output']>;
  plannedDepartureOverride?: Maybe<Scalars['Datetime']['output']>;
  plannedDepartureOverrideSourcedAt?: Maybe<Scalars['Datetime']['output']>;
  plannedDepartureOverrideSourcedFrom?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PortCall` that is related to this `PortCallHistory`. */
  portCallById?: Maybe<PortCall>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  seaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `PortCallHistory`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `PortCallHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PortCallHistoryCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `firstStart` field. */
  firstStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `lastEnd` field. */
  lastEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `plannedArrival` field. */
  plannedArrival?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedArrivalDuration` field. */
  plannedArrivalDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `plannedArrivalOverride` field. */
  plannedArrivalOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedArrivalOverrideSourcedAt` field. */
  plannedArrivalOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedArrivalOverrideSourcedFrom` field. */
  plannedArrivalOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `plannedBerthing` field. */
  plannedBerthing?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedBerthingDuration` field. */
  plannedBerthingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `plannedBerthingOverride` field. */
  plannedBerthingOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedBerthingOverrideSourcedAt` field. */
  plannedBerthingOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedBerthingOverrideSourcedFrom` field. */
  plannedBerthingOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `plannedDeparture` field. */
  plannedDeparture?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedDepartureDuration` field. */
  plannedDepartureDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `plannedDepartureOverride` field. */
  plannedDepartureOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedDepartureOverrideSourcedAt` field. */
  plannedDepartureOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `plannedDepartureOverrideSourcedFrom` field. */
  plannedDepartureOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `seaDurationOverride` field. */
  seaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `PortCallHistory` object types. All fields are combined with a logical ‘and.’ */
export type PortCallHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCallHistoryFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `firstStart` field. */
  firstStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastEnd` field. */
  lastEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCallHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCallHistoryFilter>>;
  /** Filter by the object’s `plannedArrival` field. */
  plannedArrival?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedArrivalDuration` field. */
  plannedArrivalDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `plannedArrivalOverride` field. */
  plannedArrivalOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedArrivalOverrideSourcedAt` field. */
  plannedArrivalOverrideSourcedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedArrivalOverrideSourcedFrom` field. */
  plannedArrivalOverrideSourcedFrom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `plannedBerthing` field. */
  plannedBerthing?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedBerthingDuration` field. */
  plannedBerthingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `plannedBerthingOverride` field. */
  plannedBerthingOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedBerthingOverrideSourcedAt` field. */
  plannedBerthingOverrideSourcedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedBerthingOverrideSourcedFrom` field. */
  plannedBerthingOverrideSourcedFrom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `plannedDeparture` field. */
  plannedDeparture?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedDepartureDuration` field. */
  plannedDepartureDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `plannedDepartureOverride` field. */
  plannedDepartureOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedDepartureOverrideSourcedAt` field. */
  plannedDepartureOverrideSourcedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `plannedDepartureOverrideSourcedFrom` field. */
  plannedDepartureOverrideSourcedFrom?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `seaDurationOverride` field. */
  seaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `PortCall` */
export type PortCallInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bunkerOverrides?: InputMaybe<Scalars['JSON']['input']>;
  bunkerPriceSource?: InputMaybe<Scalars['JSON']['input']>;
  channelCostDefaultId?: InputMaybe<Scalars['ChannelCostEstimateId']['input']>;
  /** Hours. Additional duration added to computed sea duration when the leg uses a channel. NULL when not using a channel, interpreted as 0. Ignored when sea_duration_overhead is set. */
  channelDurationOverhead?: InputMaybe<Scalars['BigInt']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Redundant as of 2021-08-31. The column can be removed. */
  firstStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Redundant as of 2021-08-31. The column can be removed. */
  lastEnd?: InputMaybe<Scalars['Datetime']['input']>;
  legAvoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['LocationId']['input'];
  oneTimeOverrideChannelCost?: InputMaybe<Scalars['BigFloat']['input']>;
  oneTimeOverrideCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Planned time of arrival */
  plannedArrival?: InputMaybe<Scalars['Datetime']['input']>;
  plannedArrivalDuration?: InputMaybe<Scalars['BigInt']['input']>;
  plannedArrivalOverride?: InputMaybe<Scalars['Datetime']['input']>;
  plannedArrivalOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  plannedArrivalOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Planned time of berth */
  plannedBerthing?: InputMaybe<Scalars['Datetime']['input']>;
  plannedBerthingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  plannedBerthingOverride?: InputMaybe<Scalars['Datetime']['input']>;
  plannedBerthingOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  plannedBerthingOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Planned time of departure */
  plannedDeparture?: InputMaybe<Scalars['Datetime']['input']>;
  plannedDepartureDuration?: InputMaybe<Scalars['BigInt']['input']>;
  plannedDepartureOverride?: InputMaybe<Scalars['Datetime']['input']>;
  plannedDepartureOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  plannedDepartureOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  portCostDefaultId?: InputMaybe<Scalars['PortCostDefaultId']['input']>;
  /** The previous port; The origin location for the sea duration. */
  previousLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  seaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  totalDischargeDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoadDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  useHistoricalPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  useIntegrationPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  useLatestHistoricalPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  useOneTimeOverrideCost?: InputMaybe<Scalars['Boolean']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  /** The weather factor for the port call, value in percentage range 0-100 */
  weatherFactor?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Represents an update to a `PortCall`. Fields that are set will be updated. */
export type PortCallPatch = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  bunkerOverrides?: InputMaybe<Scalars['JSON']['input']>;
  bunkerPriceSource?: InputMaybe<Scalars['JSON']['input']>;
  channelCostDefaultId?: InputMaybe<Scalars['ChannelCostEstimateId']['input']>;
  /** Hours. Additional duration added to computed sea duration when the leg uses a channel. NULL when not using a channel, interpreted as 0. Ignored when sea_duration_overhead is set. */
  channelDurationOverhead?: InputMaybe<Scalars['BigInt']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Redundant as of 2021-08-31. The column can be removed. */
  firstStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Redundant as of 2021-08-31. The column can be removed. */
  lastEnd?: InputMaybe<Scalars['Datetime']['input']>;
  legAvoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  oneTimeOverrideChannelCost?: InputMaybe<Scalars['BigFloat']['input']>;
  oneTimeOverrideCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Planned time of arrival */
  plannedArrival?: InputMaybe<Scalars['Datetime']['input']>;
  plannedArrivalDuration?: InputMaybe<Scalars['BigInt']['input']>;
  plannedArrivalOverride?: InputMaybe<Scalars['Datetime']['input']>;
  plannedArrivalOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  plannedArrivalOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Planned time of berth */
  plannedBerthing?: InputMaybe<Scalars['Datetime']['input']>;
  plannedBerthingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  plannedBerthingOverride?: InputMaybe<Scalars['Datetime']['input']>;
  plannedBerthingOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  plannedBerthingOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Planned time of departure */
  plannedDeparture?: InputMaybe<Scalars['Datetime']['input']>;
  plannedDepartureDuration?: InputMaybe<Scalars['BigInt']['input']>;
  plannedDepartureOverride?: InputMaybe<Scalars['Datetime']['input']>;
  plannedDepartureOverrideSourcedAt?: InputMaybe<Scalars['Datetime']['input']>;
  plannedDepartureOverrideSourcedFrom?: InputMaybe<Scalars['String']['input']>;
  portCostDefaultId?: InputMaybe<Scalars['PortCostDefaultId']['input']>;
  /** The previous port; The origin location for the sea duration. */
  previousLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  seaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  totalDischargeDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  totalLoadDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  useHistoricalPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  useIntegrationPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  useLatestHistoricalPortCost?: InputMaybe<Scalars['Boolean']['input']>;
  useOneTimeOverrideCost?: InputMaybe<Scalars['Boolean']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  /** The weather factor for the port call, value in percentage range 0-100 */
  weatherFactor?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** A connection to a list of `PortCall` values. */
export type PortCallsConnection = {
  __typename?: 'PortCallsConnection';
  /** A list of edges which contains the `PortCall` and cursor to aid in pagination. */
  edges: Array<PortCallsEdge>;
  /** A list of `PortCall` objects. */
  nodes: Array<Maybe<PortCall>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCall` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCall` edge in the connection. */
export type PortCallsEdge = {
  __typename?: 'PortCallsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCall` at the end of the edge. */
  node?: Maybe<PortCall>;
};

/** Methods to use when ordering `PortCall`. */
export enum PortCallsOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  BUNKER_OVERRIDES_ASC = 'BUNKER_OVERRIDES_ASC',
  BUNKER_OVERRIDES_DESC = 'BUNKER_OVERRIDES_DESC',
  BUNKER_PRICE_SOURCE_ASC = 'BUNKER_PRICE_SOURCE_ASC',
  BUNKER_PRICE_SOURCE_DESC = 'BUNKER_PRICE_SOURCE_DESC',
  CHANNEL_COST_DEFAULT_ID_ASC = 'CHANNEL_COST_DEFAULT_ID_ASC',
  CHANNEL_COST_DEFAULT_ID_DESC = 'CHANNEL_COST_DEFAULT_ID_DESC',
  CHANNEL_DURATION_OVERHEAD_ASC = 'CHANNEL_DURATION_OVERHEAD_ASC',
  CHANNEL_DURATION_OVERHEAD_DESC = 'CHANNEL_DURATION_OVERHEAD_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  FIRST_START_ASC = 'FIRST_START_ASC',
  FIRST_START_DESC = 'FIRST_START_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAST_END_ASC = 'LAST_END_ASC',
  LAST_END_DESC = 'LAST_END_DESC',
  LEG_AVOIDS_CHANNELS_ASC = 'LEG_AVOIDS_CHANNELS_ASC',
  LEG_AVOIDS_CHANNELS_DESC = 'LEG_AVOIDS_CHANNELS_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ONE_TIME_OVERRIDE_CHANNEL_COST_ASC = 'ONE_TIME_OVERRIDE_CHANNEL_COST_ASC',
  ONE_TIME_OVERRIDE_CHANNEL_COST_DESC = 'ONE_TIME_OVERRIDE_CHANNEL_COST_DESC',
  ONE_TIME_OVERRIDE_COST_ASC = 'ONE_TIME_OVERRIDE_COST_ASC',
  ONE_TIME_OVERRIDE_COST_DESC = 'ONE_TIME_OVERRIDE_COST_DESC',
  PLANNED_ARRIVAL_ASC = 'PLANNED_ARRIVAL_ASC',
  PLANNED_ARRIVAL_DESC = 'PLANNED_ARRIVAL_DESC',
  PLANNED_ARRIVAL_DURATION_ASC = 'PLANNED_ARRIVAL_DURATION_ASC',
  PLANNED_ARRIVAL_DURATION_DESC = 'PLANNED_ARRIVAL_DURATION_DESC',
  PLANNED_ARRIVAL_OVERRIDE_ASC = 'PLANNED_ARRIVAL_OVERRIDE_ASC',
  PLANNED_ARRIVAL_OVERRIDE_DESC = 'PLANNED_ARRIVAL_OVERRIDE_DESC',
  PLANNED_ARRIVAL_OVERRIDE_SOURCED_AT_ASC = 'PLANNED_ARRIVAL_OVERRIDE_SOURCED_AT_ASC',
  PLANNED_ARRIVAL_OVERRIDE_SOURCED_AT_DESC = 'PLANNED_ARRIVAL_OVERRIDE_SOURCED_AT_DESC',
  PLANNED_ARRIVAL_OVERRIDE_SOURCED_FROM_ASC = 'PLANNED_ARRIVAL_OVERRIDE_SOURCED_FROM_ASC',
  PLANNED_ARRIVAL_OVERRIDE_SOURCED_FROM_DESC = 'PLANNED_ARRIVAL_OVERRIDE_SOURCED_FROM_DESC',
  PLANNED_BERTHING_ASC = 'PLANNED_BERTHING_ASC',
  PLANNED_BERTHING_DESC = 'PLANNED_BERTHING_DESC',
  PLANNED_BERTHING_DURATION_ASC = 'PLANNED_BERTHING_DURATION_ASC',
  PLANNED_BERTHING_DURATION_DESC = 'PLANNED_BERTHING_DURATION_DESC',
  PLANNED_BERTHING_OVERRIDE_ASC = 'PLANNED_BERTHING_OVERRIDE_ASC',
  PLANNED_BERTHING_OVERRIDE_DESC = 'PLANNED_BERTHING_OVERRIDE_DESC',
  PLANNED_BERTHING_OVERRIDE_SOURCED_AT_ASC = 'PLANNED_BERTHING_OVERRIDE_SOURCED_AT_ASC',
  PLANNED_BERTHING_OVERRIDE_SOURCED_AT_DESC = 'PLANNED_BERTHING_OVERRIDE_SOURCED_AT_DESC',
  PLANNED_BERTHING_OVERRIDE_SOURCED_FROM_ASC = 'PLANNED_BERTHING_OVERRIDE_SOURCED_FROM_ASC',
  PLANNED_BERTHING_OVERRIDE_SOURCED_FROM_DESC = 'PLANNED_BERTHING_OVERRIDE_SOURCED_FROM_DESC',
  PLANNED_DEPARTURE_ASC = 'PLANNED_DEPARTURE_ASC',
  PLANNED_DEPARTURE_DESC = 'PLANNED_DEPARTURE_DESC',
  PLANNED_DEPARTURE_DURATION_ASC = 'PLANNED_DEPARTURE_DURATION_ASC',
  PLANNED_DEPARTURE_DURATION_DESC = 'PLANNED_DEPARTURE_DURATION_DESC',
  PLANNED_DEPARTURE_OVERRIDE_ASC = 'PLANNED_DEPARTURE_OVERRIDE_ASC',
  PLANNED_DEPARTURE_OVERRIDE_DESC = 'PLANNED_DEPARTURE_OVERRIDE_DESC',
  PLANNED_DEPARTURE_OVERRIDE_SOURCED_AT_ASC = 'PLANNED_DEPARTURE_OVERRIDE_SOURCED_AT_ASC',
  PLANNED_DEPARTURE_OVERRIDE_SOURCED_AT_DESC = 'PLANNED_DEPARTURE_OVERRIDE_SOURCED_AT_DESC',
  PLANNED_DEPARTURE_OVERRIDE_SOURCED_FROM_ASC = 'PLANNED_DEPARTURE_OVERRIDE_SOURCED_FROM_ASC',
  PLANNED_DEPARTURE_OVERRIDE_SOURCED_FROM_DESC = 'PLANNED_DEPARTURE_OVERRIDE_SOURCED_FROM_DESC',
  PORT_COST_DEFAULT_ID_ASC = 'PORT_COST_DEFAULT_ID_ASC',
  PORT_COST_DEFAULT_ID_DESC = 'PORT_COST_DEFAULT_ID_DESC',
  PREVIOUS_LOCATION_ID_ASC = 'PREVIOUS_LOCATION_ID_ASC',
  PREVIOUS_LOCATION_ID_DESC = 'PREVIOUS_LOCATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SEA_DURATION_OVERRIDE_ASC = 'SEA_DURATION_OVERRIDE_ASC',
  SEA_DURATION_OVERRIDE_DESC = 'SEA_DURATION_OVERRIDE_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TOTAL_DISCHARGE_DURATION_OVERRIDE_ASC = 'TOTAL_DISCHARGE_DURATION_OVERRIDE_ASC',
  TOTAL_DISCHARGE_DURATION_OVERRIDE_DESC = 'TOTAL_DISCHARGE_DURATION_OVERRIDE_DESC',
  TOTAL_LOAD_DURATION_OVERRIDE_ASC = 'TOTAL_LOAD_DURATION_OVERRIDE_ASC',
  TOTAL_LOAD_DURATION_OVERRIDE_DESC = 'TOTAL_LOAD_DURATION_OVERRIDE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USE_HISTORICAL_PORT_COST_ASC = 'USE_HISTORICAL_PORT_COST_ASC',
  USE_HISTORICAL_PORT_COST_DESC = 'USE_HISTORICAL_PORT_COST_DESC',
  USE_INTEGRATION_PORT_COST_ASC = 'USE_INTEGRATION_PORT_COST_ASC',
  USE_INTEGRATION_PORT_COST_DESC = 'USE_INTEGRATION_PORT_COST_DESC',
  USE_LATEST_HISTORICAL_PORT_COST_ASC = 'USE_LATEST_HISTORICAL_PORT_COST_ASC',
  USE_LATEST_HISTORICAL_PORT_COST_DESC = 'USE_LATEST_HISTORICAL_PORT_COST_DESC',
  USE_ONE_TIME_OVERRIDE_COST_ASC = 'USE_ONE_TIME_OVERRIDE_COST_ASC',
  USE_ONE_TIME_OVERRIDE_COST_DESC = 'USE_ONE_TIME_OVERRIDE_COST_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC',
  WEATHER_FACTOR_ASC = 'WEATHER_FACTOR_ASC',
  WEATHER_FACTOR_DESC = 'WEATHER_FACTOR_DESC'
}

export type PortCommodityLdRate = Node & {
  __typename?: 'PortCommodityLdRate';
  /** Reads a single `Assortment` that is related to this `PortCommodityLdRate`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `PortCommodityLdRate`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  assortmentGroupId?: Maybe<Scalars['AssortmentGroupId']['output']>;
  assortmentId?: Maybe<Scalars['AssortmentId']['output']>;
  dischargeRate: Scalars['BigFloat']['output'];
  dischargeUnit: LoadingUnit;
  id: Scalars['PortCommodityLdRateIdString']['output'];
  loadingRate: Scalars['BigFloat']['output'];
  loadingUnit: LoadingUnit;
  /** Reads a single `Location` that is related to this `PortCommodityLdRate`. */
  locationByPortId?: Maybe<Location>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PortCommodityLdRate`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  portId?: Maybe<Scalars['LocationId']['output']>;
  /** Reads a single `Zone` that is related to this `PortCommodityLdRate`. */
  zoneByZoneId?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['ZoneId']['output']>;
};

/**
 * A condition to be used against `PortCommodityLdRate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PortCommodityLdRateCondition = {
  /** Checks for equality with the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `dischargeRate` field. */
  dischargeRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargeUnit` field. */
  dischargeUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortCommodityLdRateIdString']['input']>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `portId` field. */
  portId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A filter to be used against `PortCommodityLdRate` object types. All fields are combined with a logical ‘and.’ */
export type PortCommodityLdRateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCommodityLdRateFilter>>;
  /** Filter by the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargeRate` field. */
  dischargeRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargeUnit` field. */
  dischargeUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCommodityLdRateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCommodityLdRateFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portId` field. */
  portId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `PortCommodityLdRate` */
export type PortCommodityLdRateInput = {
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  dischargeRate: Scalars['BigFloat']['input'];
  dischargeUnit: LoadingUnit;
  loadingRate: Scalars['BigFloat']['input'];
  loadingUnit: LoadingUnit;
  organizationId: Scalars['OrganizationId']['input'];
  portId?: InputMaybe<Scalars['LocationId']['input']>;
  zoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** Represents an update to a `PortCommodityLdRate`. Fields that are set will be updated. */
export type PortCommodityLdRatePatch = {
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  dischargeRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargeUnit?: InputMaybe<LoadingUnit>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingUnit?: InputMaybe<LoadingUnit>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portId?: InputMaybe<Scalars['LocationId']['input']>;
  zoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A connection to a list of `PortCommodityLdRate` values. */
export type PortCommodityLdRatesConnection = {
  __typename?: 'PortCommodityLdRatesConnection';
  /** A list of edges which contains the `PortCommodityLdRate` and cursor to aid in pagination. */
  edges: Array<PortCommodityLdRatesEdge>;
  /** A list of `PortCommodityLdRate` objects. */
  nodes: Array<Maybe<PortCommodityLdRate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCommodityLdRate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCommodityLdRate` edge in the connection. */
export type PortCommodityLdRatesEdge = {
  __typename?: 'PortCommodityLdRatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCommodityLdRate` at the end of the edge. */
  node?: Maybe<PortCommodityLdRate>;
};

/** Methods to use when ordering `PortCommodityLdRate`. */
export enum PortCommodityLdRatesOrderBy {
  ASSORTMENT_GROUP_ID_ASC = 'ASSORTMENT_GROUP_ID_ASC',
  ASSORTMENT_GROUP_ID_DESC = 'ASSORTMENT_GROUP_ID_DESC',
  ASSORTMENT_ID_ASC = 'ASSORTMENT_ID_ASC',
  ASSORTMENT_ID_DESC = 'ASSORTMENT_ID_DESC',
  DISCHARGE_RATE_ASC = 'DISCHARGE_RATE_ASC',
  DISCHARGE_RATE_DESC = 'DISCHARGE_RATE_DESC',
  DISCHARGE_UNIT_ASC = 'DISCHARGE_UNIT_ASC',
  DISCHARGE_UNIT_DESC = 'DISCHARGE_UNIT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  LOADING_UNIT_ASC = 'LOADING_UNIT_ASC',
  LOADING_UNIT_DESC = 'LOADING_UNIT_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_ID_ASC = 'PORT_ID_ASC',
  PORT_ID_DESC = 'PORT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ZONE_ID_ASC = 'ZONE_ID_ASC',
  ZONE_ID_DESC = 'ZONE_ID_DESC'
}

export type PortCost = Node & {
  __typename?: 'PortCost';
  cost?: Maybe<Scalars['BigFloat']['output']>;
  estimatedCost?: Maybe<Scalars['Int']['output']>;
  id: Scalars['PortCostId']['output'];
  /** Reads a single `Location` that is related to this `PortCost`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['OrganizationId']['output'];
  /** Reads a single `Organization` that is related to this `PortCost`. */
  organizationByOrganisationId?: Maybe<Organization>;
  portCostCurrency?: Maybe<Currency>;
  /** Reads a single `Ship` that is related to this `PortCost`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `PortCost`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads and enables pagination through a set of `VoyageCharterPortCost`. */
  voyageCharterPortCostsByPortCostId: VoyageCharterPortCostsConnection;
};


export type PortCostVoyageCharterPortCostsByPortCostIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortCostCondition>;
  filter?: InputMaybe<VoyageCharterPortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortCostsOrderBy>>;
};

/**
 * A condition to be used against `PortCost` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PortCostCondition = {
  /** Checks for equality with the object’s `cost` field. */
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `estimatedCost` field. */
  estimatedCost?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortCostId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type PortCostDefault = Node & {
  __typename?: 'PortCostDefault';
  cost: Scalars['BigFloat']['output'];
  createdAt: Scalars['Datetime']['output'];
  currency: Currency;
  id: Scalars['PortCostDefaultId']['output'];
  /** Reads a single `Location` that is related to this `PortCostDefault`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PortCostDefault`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `PortCall`. */
  portCallsByPortCostDefaultId: PortCallsConnection;
  /** Reads a single `Ship` that is related to this `PortCostDefault`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `PortCostDefault`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  vesselTypeId?: Maybe<Scalars['VesselAttributeId']['output']>;
};


export type PortCostDefaultPortCallsByPortCostDefaultIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallCondition>;
  filter?: InputMaybe<PortCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};

/**
 * A condition to be used against `PortCostDefault` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PortCostDefaultCondition = {
  /** Checks for equality with the object’s `cost` field. */
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortCostDefaultId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `vesselTypeId` field. */
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A filter to be used against `PortCostDefault` object types. All fields are combined with a logical ‘and.’ */
export type PortCostDefaultFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCostDefaultFilter>>;
  /** Filter by the object’s `cost` field. */
  cost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCostDefaultFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCostDefaultFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselTypeId` field. */
  vesselTypeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `PortCostDefault` */
export type PortCostDefaultInput = {
  cost: Scalars['BigFloat']['input'];
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency: Currency;
  locationId: Scalars['LocationId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** Represents an update to a `PortCostDefault`. Fields that are set will be updated. */
export type PortCostDefaultPatch = {
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Currency>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  vesselTypeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

export type PortCostDefaultSubscriptionPayload = {
  __typename?: 'PortCostDefaultSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  portCostDefault?: Maybe<PortCostDefault>;
};

/** A connection to a list of `PortCostDefault` values. */
export type PortCostDefaultsConnection = {
  __typename?: 'PortCostDefaultsConnection';
  /** A list of edges which contains the `PortCostDefault` and cursor to aid in pagination. */
  edges: Array<PortCostDefaultsEdge>;
  /** A list of `PortCostDefault` objects. */
  nodes: Array<Maybe<PortCostDefault>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCostDefault` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCostDefault` edge in the connection. */
export type PortCostDefaultsEdge = {
  __typename?: 'PortCostDefaultsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCostDefault` at the end of the edge. */
  node?: Maybe<PortCostDefault>;
};

export type PortCostDefaultsImportInput = {
  portCost: Scalars['Float']['input'];
  portCostCurrency: Scalars['String']['input'];
  portName: Scalars['String']['input'];
  vesselName?: InputMaybe<Scalars['String']['input']>;
  vesselType?: InputMaybe<Scalars['String']['input']>;
};

export type PortCostDefaultsImportResult = {
  __typename?: 'PortCostDefaultsImportResult';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalImportSucess?: Maybe<Scalars['Int']['output']>;
};

/** Methods to use when ordering `PortCostDefault`. */
export enum PortCostDefaultsOrderBy {
  COST_ASC = 'COST_ASC',
  COST_DESC = 'COST_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC',
  VESSEL_TYPE_ID_ASC = 'VESSEL_TYPE_ID_ASC',
  VESSEL_TYPE_ID_DESC = 'VESSEL_TYPE_ID_DESC'
}

export type PortCostEstimatesExternal = Node & {
  __typename?: 'PortCostEstimatesExternal';
  assortment?: Maybe<Scalars['String']['output']>;
  commencedDate?: Maybe<Scalars['Date']['output']>;
  completedDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Datetime']['output'];
  deprecated: Scalars['Boolean']['output'];
  id: Scalars['PortCostEstimatesExternalId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PortCostEstimatesExternal`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  portCost: Scalars['BigFloat']['output'];
  portCostCurrency: Scalars['String']['output'];
  portName: Scalars['String']['output'];
  portType?: Maybe<PortType>;
  vesselCode?: Maybe<Scalars['String']['output']>;
  vesselName: Scalars['String']['output'];
};

/**
 * A condition to be used against `PortCostEstimatesExternal` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PortCostEstimatesExternalCondition = {
  /** Checks for equality with the object’s `assortment` field. */
  assortment?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `commencedDate` field. */
  commencedDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `completedDate` field. */
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deprecated` field. */
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortCostEstimatesExternalId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `portCost` field. */
  portCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portName` field. */
  portName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portType` field. */
  portType?: InputMaybe<PortType>;
  /** Checks for equality with the object’s `vesselCode` field. */
  vesselCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vesselName` field. */
  vesselName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `PortCostEstimatesExternal` object types. All fields are combined with a logical ‘and.’ */
export type PortCostEstimatesExternalFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCostEstimatesExternalFilter>>;
  /** Filter by the object’s `assortment` field. */
  assortment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `commencedDate` field. */
  commencedDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `completedDate` field. */
  completedDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deprecated` field. */
  deprecated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCostEstimatesExternalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCostEstimatesExternalFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCost` field. */
  portCost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portName` field. */
  portName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portType` field. */
  portType?: InputMaybe<PortTypeFilter>;
  /** Filter by the object’s `vesselCode` field. */
  vesselCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vesselName` field. */
  vesselName?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PortCostEstimatesExternal` */
export type PortCostEstimatesExternalInput = {
  assortment?: InputMaybe<Scalars['String']['input']>;
  commencedDate?: InputMaybe<Scalars['Date']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  portCost: Scalars['BigFloat']['input'];
  portCostCurrency: Scalars['String']['input'];
  portName: Scalars['String']['input'];
  portType?: InputMaybe<PortType>;
  vesselCode?: InputMaybe<Scalars['String']['input']>;
  vesselName: Scalars['String']['input'];
};

/** Represents an update to a `PortCostEstimatesExternal`. Fields that are set will be updated. */
export type PortCostEstimatesExternalPatch = {
  assortment?: InputMaybe<Scalars['String']['input']>;
  commencedDate?: InputMaybe<Scalars['Date']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portCost?: InputMaybe<Scalars['BigFloat']['input']>;
  portCostCurrency?: InputMaybe<Scalars['String']['input']>;
  portName?: InputMaybe<Scalars['String']['input']>;
  portType?: InputMaybe<PortType>;
  vesselCode?: InputMaybe<Scalars['String']['input']>;
  vesselName?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `PortCostEstimatesExternal` values. */
export type PortCostEstimatesExternalsConnection = {
  __typename?: 'PortCostEstimatesExternalsConnection';
  /** A list of edges which contains the `PortCostEstimatesExternal` and cursor to aid in pagination. */
  edges: Array<PortCostEstimatesExternalsEdge>;
  /** A list of `PortCostEstimatesExternal` objects. */
  nodes: Array<Maybe<PortCostEstimatesExternal>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCostEstimatesExternal` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCostEstimatesExternal` edge in the connection. */
export type PortCostEstimatesExternalsEdge = {
  __typename?: 'PortCostEstimatesExternalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCostEstimatesExternal` at the end of the edge. */
  node?: Maybe<PortCostEstimatesExternal>;
};

/** Methods to use when ordering `PortCostEstimatesExternal`. */
export enum PortCostEstimatesExternalsOrderBy {
  ASSORTMENT_ASC = 'ASSORTMENT_ASC',
  ASSORTMENT_DESC = 'ASSORTMENT_DESC',
  COMMENCED_DATE_ASC = 'COMMENCED_DATE_ASC',
  COMMENCED_DATE_DESC = 'COMMENCED_DATE_DESC',
  COMPLETED_DATE_ASC = 'COMPLETED_DATE_ASC',
  COMPLETED_DATE_DESC = 'COMPLETED_DATE_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DEPRECATED_ASC = 'DEPRECATED_ASC',
  DEPRECATED_DESC = 'DEPRECATED_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_COST_ASC = 'PORT_COST_ASC',
  PORT_COST_CURRENCY_ASC = 'PORT_COST_CURRENCY_ASC',
  PORT_COST_CURRENCY_DESC = 'PORT_COST_CURRENCY_DESC',
  PORT_COST_DESC = 'PORT_COST_DESC',
  PORT_NAME_ASC = 'PORT_NAME_ASC',
  PORT_NAME_DESC = 'PORT_NAME_DESC',
  PORT_TYPE_ASC = 'PORT_TYPE_ASC',
  PORT_TYPE_DESC = 'PORT_TYPE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VESSEL_CODE_ASC = 'VESSEL_CODE_ASC',
  VESSEL_CODE_DESC = 'VESSEL_CODE_DESC',
  VESSEL_NAME_ASC = 'VESSEL_NAME_ASC',
  VESSEL_NAME_DESC = 'VESSEL_NAME_DESC'
}

export type PortCostExternalImportResult = {
  __typename?: 'PortCostExternalImportResult';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalImportSucess?: Maybe<Scalars['Int']['output']>;
};

/** A filter to be used against `PortCost` object types. All fields are combined with a logical ‘and.’ */
export type PortCostFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCostFilter>>;
  /** Filter by the object’s `cost` field. */
  cost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `estimatedCost` field. */
  estimatedCost?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCostFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `PortCost` */
export type PortCostInput = {
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  estimatedCost?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['LocationId']['input'];
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portCostCurrency?: InputMaybe<Currency>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `PortCost`. Fields that are set will be updated. */
export type PortCostPatch = {
  cost?: InputMaybe<Scalars['BigFloat']['input']>;
  estimatedCost?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portCostCurrency?: InputMaybe<Currency>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type PortCostsByPortAndPrimaryAttribute = {
  __typename?: 'PortCostsByPortAndPrimaryAttribute';
  avg?: Maybe<Scalars['BigFloat']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['BigFloat']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['BigFloat']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  portCostCurrency?: Maybe<Scalars['String']['output']>;
  portName?: Maybe<Scalars['String']['output']>;
  portType?: Maybe<Scalars['String']['output']>;
  primaryAttributeId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `PortCostsByPortAndPrimaryAttribute` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type PortCostsByPortAndPrimaryAttributeCondition = {
  /** Checks for equality with the object’s `avg` field. */
  avg?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `count` field. */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `max` field. */
  max?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `median` field. */
  median?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `min` field. */
  min?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portName` field. */
  portName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portType` field. */
  portType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `PortCostsByPortAndPrimaryAttribute` object types. All fields are combined with a logical ‘and.’ */
export type PortCostsByPortAndPrimaryAttributeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCostsByPortAndPrimaryAttributeFilter>>;
  /** Filter by the object’s `avg` field. */
  avg?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<IntFilter>;
  /** Filter by the object’s `max` field. */
  max?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `median` field. */
  median?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `min` field. */
  min?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCostsByPortAndPrimaryAttributeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCostsByPortAndPrimaryAttributeFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portName` field. */
  portName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portType` field. */
  portType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `PortCostsByPortAndPrimaryAttribute` values. */
export type PortCostsByPortAndPrimaryAttributesConnection = {
  __typename?: 'PortCostsByPortAndPrimaryAttributesConnection';
  /** A list of edges which contains the `PortCostsByPortAndPrimaryAttribute` and cursor to aid in pagination. */
  edges: Array<PortCostsByPortAndPrimaryAttributesEdge>;
  /** A list of `PortCostsByPortAndPrimaryAttribute` objects. */
  nodes: Array<Maybe<PortCostsByPortAndPrimaryAttribute>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCostsByPortAndPrimaryAttribute` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCostsByPortAndPrimaryAttribute` edge in the connection. */
export type PortCostsByPortAndPrimaryAttributesEdge = {
  __typename?: 'PortCostsByPortAndPrimaryAttributesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCostsByPortAndPrimaryAttribute` at the end of the edge. */
  node?: Maybe<PortCostsByPortAndPrimaryAttribute>;
};

/** Methods to use when ordering `PortCostsByPortAndPrimaryAttribute`. */
export enum PortCostsByPortAndPrimaryAttributesOrderBy {
  AVG_ASC = 'AVG_ASC',
  AVG_DESC = 'AVG_DESC',
  COUNT_ASC = 'COUNT_ASC',
  COUNT_DESC = 'COUNT_DESC',
  MAX_ASC = 'MAX_ASC',
  MAX_DESC = 'MAX_DESC',
  MEDIAN_ASC = 'MEDIAN_ASC',
  MEDIAN_DESC = 'MEDIAN_DESC',
  MIN_ASC = 'MIN_ASC',
  MIN_DESC = 'MIN_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_COST_CURRENCY_ASC = 'PORT_COST_CURRENCY_ASC',
  PORT_COST_CURRENCY_DESC = 'PORT_COST_CURRENCY_DESC',
  PORT_NAME_ASC = 'PORT_NAME_ASC',
  PORT_NAME_DESC = 'PORT_NAME_DESC',
  PORT_TYPE_ASC = 'PORT_TYPE_ASC',
  PORT_TYPE_DESC = 'PORT_TYPE_DESC',
  PRIMARY_ATTRIBUTE_ID_ASC = 'PRIMARY_ATTRIBUTE_ID_ASC',
  PRIMARY_ATTRIBUTE_ID_DESC = 'PRIMARY_ATTRIBUTE_ID_DESC'
}

export type PortCostsByPortAndVesselName = {
  __typename?: 'PortCostsByPortAndVesselName';
  avg?: Maybe<Scalars['BigFloat']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['BigFloat']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['BigFloat']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  portCostCurrency?: Maybe<Scalars['String']['output']>;
  portName?: Maybe<Scalars['String']['output']>;
  portType?: Maybe<Scalars['String']['output']>;
  vesselName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `PortCostsByPortAndVesselName` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PortCostsByPortAndVesselNameCondition = {
  /** Checks for equality with the object’s `avg` field. */
  avg?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `count` field. */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `max` field. */
  max?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `median` field. */
  median?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `min` field. */
  min?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portName` field. */
  portName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portType` field. */
  portType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vesselName` field. */
  vesselName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `PortCostsByPortAndVesselName` object types. All fields are combined with a logical ‘and.’ */
export type PortCostsByPortAndVesselNameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortCostsByPortAndVesselNameFilter>>;
  /** Filter by the object’s `avg` field. */
  avg?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<IntFilter>;
  /** Filter by the object’s `max` field. */
  max?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `median` field. */
  median?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `min` field. */
  min?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortCostsByPortAndVesselNameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortCostsByPortAndVesselNameFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portCostCurrency` field. */
  portCostCurrency?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portName` field. */
  portName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `portType` field. */
  portType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vesselName` field. */
  vesselName?: InputMaybe<StringFilter>;
};

/** A connection to a list of `PortCostsByPortAndVesselName` values. */
export type PortCostsByPortAndVesselNamesConnection = {
  __typename?: 'PortCostsByPortAndVesselNamesConnection';
  /** A list of edges which contains the `PortCostsByPortAndVesselName` and cursor to aid in pagination. */
  edges: Array<PortCostsByPortAndVesselNamesEdge>;
  /** A list of `PortCostsByPortAndVesselName` objects. */
  nodes: Array<Maybe<PortCostsByPortAndVesselName>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCostsByPortAndVesselName` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCostsByPortAndVesselName` edge in the connection. */
export type PortCostsByPortAndVesselNamesEdge = {
  __typename?: 'PortCostsByPortAndVesselNamesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCostsByPortAndVesselName` at the end of the edge. */
  node?: Maybe<PortCostsByPortAndVesselName>;
};

/** Methods to use when ordering `PortCostsByPortAndVesselName`. */
export enum PortCostsByPortAndVesselNamesOrderBy {
  AVG_ASC = 'AVG_ASC',
  AVG_DESC = 'AVG_DESC',
  COUNT_ASC = 'COUNT_ASC',
  COUNT_DESC = 'COUNT_DESC',
  MAX_ASC = 'MAX_ASC',
  MAX_DESC = 'MAX_DESC',
  MEDIAN_ASC = 'MEDIAN_ASC',
  MEDIAN_DESC = 'MEDIAN_DESC',
  MIN_ASC = 'MIN_ASC',
  MIN_DESC = 'MIN_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PORT_COST_CURRENCY_ASC = 'PORT_COST_CURRENCY_ASC',
  PORT_COST_CURRENCY_DESC = 'PORT_COST_CURRENCY_DESC',
  PORT_NAME_ASC = 'PORT_NAME_ASC',
  PORT_NAME_DESC = 'PORT_NAME_DESC',
  PORT_TYPE_ASC = 'PORT_TYPE_ASC',
  PORT_TYPE_DESC = 'PORT_TYPE_DESC',
  VESSEL_NAME_ASC = 'VESSEL_NAME_ASC',
  VESSEL_NAME_DESC = 'VESSEL_NAME_DESC'
}

/** A connection to a list of `PortCost` values. */
export type PortCostsConnection = {
  __typename?: 'PortCostsConnection';
  /** A list of edges which contains the `PortCost` and cursor to aid in pagination. */
  edges: Array<PortCostsEdge>;
  /** A list of `PortCost` objects. */
  nodes: Array<Maybe<PortCost>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortCost` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortCost` edge in the connection. */
export type PortCostsEdge = {
  __typename?: 'PortCostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortCost` at the end of the edge. */
  node?: Maybe<PortCost>;
};

/** Methods to use when ordering `PortCost`. */
export enum PortCostsOrderBy {
  COST_ASC = 'COST_ASC',
  COST_DESC = 'COST_DESC',
  ESTIMATED_COST_ASC = 'ESTIMATED_COST_ASC',
  ESTIMATED_COST_DESC = 'ESTIMATED_COST_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PORT_COST_CURRENCY_ASC = 'PORT_COST_CURRENCY_ASC',
  PORT_COST_CURRENCY_DESC = 'PORT_COST_CURRENCY_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** A connection to a list of `PortDatum` values. */
export type PortDataConnection = {
  __typename?: 'PortDataConnection';
  /** A list of edges which contains the `PortDatum` and cursor to aid in pagination. */
  edges: Array<PortDataEdge>;
  /** A list of `PortDatum` objects. */
  nodes: Array<Maybe<PortDatum>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortDatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortDatum` edge in the connection. */
export type PortDataEdge = {
  __typename?: 'PortDataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortDatum` at the end of the edge. */
  node?: Maybe<PortDatum>;
};

/** Methods to use when ordering `PortDatum`. */
export enum PortDataOrderBy {
  BIMCO_HOLIDAYS_ASC = 'BIMCO_HOLIDAYS_ASC',
  BIMCO_HOLIDAYS_DESC = 'BIMCO_HOLIDAYS_DESC',
  DISCHARGE_RATE_ASC = 'DISCHARGE_RATE_ASC',
  DISCHARGE_RATE_DESC = 'DISCHARGE_RATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAYTIME_DAYS_ASC = 'LAYTIME_DAYS_ASC',
  LAYTIME_DAYS_DESC = 'LAYTIME_DAYS_DESC',
  LAYTIME_EXCLUSION_END_ASC = 'LAYTIME_EXCLUSION_END_ASC',
  LAYTIME_EXCLUSION_END_DESC = 'LAYTIME_EXCLUSION_END_DESC',
  LAYTIME_EXCLUSION_START_ASC = 'LAYTIME_EXCLUSION_START_ASC',
  LAYTIME_EXCLUSION_START_DESC = 'LAYTIME_EXCLUSION_START_DESC',
  LAYTIME_NOR_TIME_LIMIT_ASC = 'LAYTIME_NOR_TIME_LIMIT_ASC',
  LAYTIME_NOR_TIME_LIMIT_DESC = 'LAYTIME_NOR_TIME_LIMIT_DESC',
  LAYTIME_START_AFTER_NOR_TIME_LIMIT_ASC = 'LAYTIME_START_AFTER_NOR_TIME_LIMIT_ASC',
  LAYTIME_START_AFTER_NOR_TIME_LIMIT_DESC = 'LAYTIME_START_AFTER_NOR_TIME_LIMIT_DESC',
  LAYTIME_START_AFTER_OFFICE_HOURS_ASC = 'LAYTIME_START_AFTER_OFFICE_HOURS_ASC',
  LAYTIME_START_AFTER_OFFICE_HOURS_DESC = 'LAYTIME_START_AFTER_OFFICE_HOURS_DESC',
  LAYTIME_START_BEFORE_NOR_TIME_LIMIT_ASC = 'LAYTIME_START_BEFORE_NOR_TIME_LIMIT_ASC',
  LAYTIME_START_BEFORE_NOR_TIME_LIMIT_DESC = 'LAYTIME_START_BEFORE_NOR_TIME_LIMIT_DESC',
  LAYTIME_TRIGGER_ASC = 'LAYTIME_TRIGGER_ASC',
  LAYTIME_TRIGGER_DESC = 'LAYTIME_TRIGGER_DESC',
  LOADING_DISCHARGE_UNIT_ASC = 'LOADING_DISCHARGE_UNIT_ASC',
  LOADING_DISCHARGE_UNIT_DESC = 'LOADING_DISCHARGE_UNIT_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  NATURAL = 'NATURAL',
  OFFICE_HOURS_END_ASC = 'OFFICE_HOURS_END_ASC',
  OFFICE_HOURS_END_DESC = 'OFFICE_HOURS_END_DESC',
  OFFICE_HOURS_START_ASC = 'OFFICE_HOURS_START_ASC',
  OFFICE_HOURS_START_DESC = 'OFFICE_HOURS_START_DESC',
  PILOT_DEDUCTED_ASC = 'PILOT_DEDUCTED_ASC',
  PILOT_DEDUCTED_DESC = 'PILOT_DEDUCTED_DESC',
  PORTCALL_COST_ESTIMATION_ASC = 'PORTCALL_COST_ESTIMATION_ASC',
  PORTCALL_COST_ESTIMATION_CURRENCY_ASC = 'PORTCALL_COST_ESTIMATION_CURRENCY_ASC',
  PORTCALL_COST_ESTIMATION_CURRENCY_DESC = 'PORTCALL_COST_ESTIMATION_CURRENCY_DESC',
  PORTCALL_COST_ESTIMATION_DESC = 'PORTCALL_COST_ESTIMATION_DESC',
  PORT_AGENT_ORG_ID_ASC = 'PORT_AGENT_ORG_ID_ASC',
  PORT_AGENT_ORG_ID_DESC = 'PORT_AGENT_ORG_ID_DESC',
  PORT_ID_ASC = 'PORT_ID_ASC',
  PORT_ID_DESC = 'PORT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  WEATHER_PERMITTING_ASC = 'WEATHER_PERMITTING_ASC',
  WEATHER_PERMITTING_DESC = 'WEATHER_PERMITTING_DESC'
}

export type PortDatum = Node & {
  __typename?: 'PortDatum';
  bimcoHolidays?: Maybe<IncludedExcludedUnlessUsed>;
  /** Reads and enables pagination through a set of `CoaContractPortDatum`. */
  coaContractPortDataByPortDataId: CoaContractPortDataConnection;
  dischargeRate?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['PortDatumId']['output'];
  laytimeDays?: Maybe<ShincShex>;
  laytimeExclusionEnd?: Maybe<Scalars['Time']['output']>;
  laytimeExclusionStart?: Maybe<Scalars['Time']['output']>;
  laytimeNorTimeLimit?: Maybe<Scalars['Time']['output']>;
  laytimeStartAfterNorTimeLimit?: Maybe<Scalars['Time']['output']>;
  laytimeStartAfterOfficeHours?: Maybe<Scalars['Time']['output']>;
  laytimeStartBeforeNorTimeLimit?: Maybe<Scalars['Time']['output']>;
  laytimeTrigger?: Maybe<LaytimeCountingTrigger>;
  loadingDischargeUnit?: Maybe<LoadingUnit>;
  loadingRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `Location` that is related to this `PortDatum`. */
  locationByPortId?: Maybe<Location>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  officeHoursEnd?: Maybe<Scalars['Time']['output']>;
  officeHoursStart?: Maybe<Scalars['Time']['output']>;
  /** Reads a single `Organization` that is related to this `PortDatum`. */
  organizationByPortAgentOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `PortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  pilotDeducted?: Maybe<Scalars['Boolean']['output']>;
  portAgentOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  portId: Scalars['LocationId']['output'];
  portcallCostEstimation?: Maybe<Scalars['BigFloat']['output']>;
  portcallCostEstimationCurrency?: Maybe<Currency>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `VoyageCharterPortDatum`. */
  voyageCharterPortDataByPortDataId: VoyageCharterPortDataConnection;
  weatherPermitting?: Maybe<Scalars['Boolean']['output']>;
};


export type PortDatumCoaContractPortDataByPortDataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortDatumCondition>;
  filter?: InputMaybe<CoaContractPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortDataOrderBy>>;
};


export type PortDatumVoyageCharterPortDataByPortDataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortDatumCondition>;
  filter?: InputMaybe<VoyageCharterPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortDataOrderBy>>;
};

/**
 * A condition to be used against `PortDatum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PortDatumCondition = {
  /** Checks for equality with the object’s `bimcoHolidays` field. */
  bimcoHolidays?: InputMaybe<IncludedExcludedUnlessUsed>;
  /** Checks for equality with the object’s `dischargeRate` field. */
  dischargeRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortDatumId']['input']>;
  /** Checks for equality with the object’s `laytimeDays` field. */
  laytimeDays?: InputMaybe<ShincShexInput>;
  /** Checks for equality with the object’s `laytimeExclusionEnd` field. */
  laytimeExclusionEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `laytimeExclusionStart` field. */
  laytimeExclusionStart?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `laytimeNorTimeLimit` field. */
  laytimeNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `laytimeStartAfterNorTimeLimit` field. */
  laytimeStartAfterNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `laytimeStartAfterOfficeHours` field. */
  laytimeStartAfterOfficeHours?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `laytimeStartBeforeNorTimeLimit` field. */
  laytimeStartBeforeNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `laytimeTrigger` field. */
  laytimeTrigger?: InputMaybe<LaytimeCountingTrigger>;
  /** Checks for equality with the object’s `loadingDischargeUnit` field. */
  loadingDischargeUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `officeHoursEnd` field. */
  officeHoursEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `officeHoursStart` field. */
  officeHoursStart?: InputMaybe<Scalars['Time']['input']>;
  /** Checks for equality with the object’s `pilotDeducted` field. */
  pilotDeducted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `portAgentOrgId` field. */
  portAgentOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `portId` field. */
  portId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `portcallCostEstimation` field. */
  portcallCostEstimation?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `portcallCostEstimationCurrency` field. */
  portcallCostEstimationCurrency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `weatherPermitting` field. */
  weatherPermitting?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `PortDatum` object types. All fields are combined with a logical ‘and.’ */
export type PortDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortDatumFilter>>;
  /** Filter by the object’s `bimcoHolidays` field. */
  bimcoHolidays?: InputMaybe<IncludedExcludedUnlessUsedFilter>;
  /** Filter by the object’s `dischargeRate` field. */
  dischargeRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `laytimeDays` field. */
  laytimeDays?: InputMaybe<ShincShexFilter>;
  /** Filter by the object’s `laytimeExclusionEnd` field. */
  laytimeExclusionEnd?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `laytimeExclusionStart` field. */
  laytimeExclusionStart?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `laytimeNorTimeLimit` field. */
  laytimeNorTimeLimit?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `laytimeStartAfterNorTimeLimit` field. */
  laytimeStartAfterNorTimeLimit?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `laytimeStartAfterOfficeHours` field. */
  laytimeStartAfterOfficeHours?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `laytimeStartBeforeNorTimeLimit` field. */
  laytimeStartBeforeNorTimeLimit?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `laytimeTrigger` field. */
  laytimeTrigger?: InputMaybe<LaytimeCountingTriggerFilter>;
  /** Filter by the object’s `loadingDischargeUnit` field. */
  loadingDischargeUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortDatumFilter>;
  /** Filter by the object’s `officeHoursEnd` field. */
  officeHoursEnd?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `officeHoursStart` field. */
  officeHoursStart?: InputMaybe<TimeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortDatumFilter>>;
  /** Filter by the object’s `pilotDeducted` field. */
  pilotDeducted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `portAgentOrgId` field. */
  portAgentOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portId` field. */
  portId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portcallCostEstimation` field. */
  portcallCostEstimation?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `portcallCostEstimationCurrency` field. */
  portcallCostEstimationCurrency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `weatherPermitting` field. */
  weatherPermitting?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `PortDatum` */
export type PortDatumInput = {
  bimcoHolidays?: InputMaybe<IncludedExcludedUnlessUsed>;
  dischargeRate?: InputMaybe<Scalars['BigFloat']['input']>;
  laytimeDays?: InputMaybe<ShincShexInput>;
  laytimeExclusionEnd?: InputMaybe<Scalars['Time']['input']>;
  laytimeExclusionStart?: InputMaybe<Scalars['Time']['input']>;
  laytimeNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  laytimeStartAfterNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  laytimeStartAfterOfficeHours?: InputMaybe<Scalars['Time']['input']>;
  laytimeStartBeforeNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  laytimeTrigger?: InputMaybe<LaytimeCountingTrigger>;
  loadingDischargeUnit?: InputMaybe<LoadingUnit>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  officeHoursEnd?: InputMaybe<Scalars['Time']['input']>;
  officeHoursStart?: InputMaybe<Scalars['Time']['input']>;
  pilotDeducted?: InputMaybe<Scalars['Boolean']['input']>;
  portAgentOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portId: Scalars['LocationId']['input'];
  portcallCostEstimation?: InputMaybe<Scalars['BigFloat']['input']>;
  portcallCostEstimationCurrency?: InputMaybe<Currency>;
  weatherPermitting?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `PortDatum`. Fields that are set will be updated. */
export type PortDatumPatch = {
  bimcoHolidays?: InputMaybe<IncludedExcludedUnlessUsed>;
  dischargeRate?: InputMaybe<Scalars['BigFloat']['input']>;
  laytimeDays?: InputMaybe<ShincShexInput>;
  laytimeExclusionEnd?: InputMaybe<Scalars['Time']['input']>;
  laytimeExclusionStart?: InputMaybe<Scalars['Time']['input']>;
  laytimeNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  laytimeStartAfterNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  laytimeStartAfterOfficeHours?: InputMaybe<Scalars['Time']['input']>;
  laytimeStartBeforeNorTimeLimit?: InputMaybe<Scalars['Time']['input']>;
  laytimeTrigger?: InputMaybe<LaytimeCountingTrigger>;
  loadingDischargeUnit?: InputMaybe<LoadingUnit>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  officeHoursEnd?: InputMaybe<Scalars['Time']['input']>;
  officeHoursStart?: InputMaybe<Scalars['Time']['input']>;
  pilotDeducted?: InputMaybe<Scalars['Boolean']['input']>;
  portAgentOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  portId?: InputMaybe<Scalars['LocationId']['input']>;
  portcallCostEstimation?: InputMaybe<Scalars['BigFloat']['input']>;
  portcallCostEstimationCurrency?: InputMaybe<Currency>;
  weatherPermitting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortNotice = Node & {
  __typename?: 'PortNotice';
  ataBerth?: Maybe<Scalars['Datetime']['output']>;
  ataPbp?: Maybe<Scalars['Datetime']['output']>;
  /** Agent */
  berthingProspects?: Maybe<Scalars['Datetime']['output']>;
  /** Ship captain */
  eta?: Maybe<Scalars['Datetime']['output']>;
  /** Agent */
  etaNextPort?: Maybe<Scalars['Datetime']['output']>;
  /** Bunker operator */
  etcBunkers?: Maybe<Scalars['Datetime']['output']>;
  /** Terminal operator */
  etcTerminal?: Maybe<Scalars['Datetime']['output']>;
  /** Ship (via agent) */
  etdBerth?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['PortNoticeId']['output'];
  /** Agent */
  loadingProspects?: Maybe<Scalars['Datetime']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  norTendered?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Organization` that is related to this `PortNotice`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortNotice`. */
  portCallByPortCallId?: Maybe<PortCall>;
  portCallId: Scalars['PortCallId']['output'];
  /** Reads and enables pagination through a set of `PortNoticeHistory`. */
  portNoticeHistoriesById: PortNoticeHistoriesConnection;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Terminal operator */
  rtaBerth?: Maybe<Scalars['Datetime']['output']>;
  /** Port Authority */
  rtaPbp?: Maybe<Scalars['Datetime']['output']>;
  /** Port Authority */
  rtdBerth?: Maybe<Scalars['Datetime']['output']>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `PortNotice`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `PortNotice`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
};


export type PortNoticePortNoticeHistoriesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortNoticeHistoryCondition>;
  filter?: InputMaybe<PortNoticeHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortNoticeHistoriesOrderBy>>;
};

/**
 * A condition to be used against `PortNotice` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PortNoticeCondition = {
  /** Checks for equality with the object’s `ataBerth` field. */
  ataBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `ataPbp` field. */
  ataPbp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `berthingProspects` field. */
  berthingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `eta` field. */
  eta?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etaNextPort` field. */
  etaNextPort?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etcBunkers` field. */
  etcBunkers?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etcTerminal` field. */
  etcTerminal?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etdBerth` field. */
  etdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortNoticeId']['input']>;
  /** Checks for equality with the object’s `loadingProspects` field. */
  loadingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `norTendered` field. */
  norTendered?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rtaBerth` field. */
  rtaBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rtaPbp` field. */
  rtaPbp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rtdBerth` field. */
  rtdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `PortNotice` object types. All fields are combined with a logical ‘and.’ */
export type PortNoticeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortNoticeFilter>>;
  /** Filter by the object’s `ataBerth` field. */
  ataBerth?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `ataPbp` field. */
  ataPbp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `berthingProspects` field. */
  berthingProspects?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eta` field. */
  eta?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etaNextPort` field. */
  etaNextPort?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etcBunkers` field. */
  etcBunkers?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etcTerminal` field. */
  etcTerminal?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etdBerth` field. */
  etdBerth?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingProspects` field. */
  loadingProspects?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `norTendered` field. */
  norTendered?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortNoticeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortNoticeFilter>>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rtaBerth` field. */
  rtaBerth?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `rtaPbp` field. */
  rtaPbp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `rtdBerth` field. */
  rtdBerth?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `PortNoticeHistory` values. */
export type PortNoticeHistoriesConnection = {
  __typename?: 'PortNoticeHistoriesConnection';
  /** A list of edges which contains the `PortNoticeHistory` and cursor to aid in pagination. */
  edges: Array<PortNoticeHistoriesEdge>;
  /** A list of `PortNoticeHistory` objects. */
  nodes: Array<Maybe<PortNoticeHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortNoticeHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortNoticeHistory` edge in the connection. */
export type PortNoticeHistoriesEdge = {
  __typename?: 'PortNoticeHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortNoticeHistory` at the end of the edge. */
  node?: Maybe<PortNoticeHistory>;
};

/** Methods to use when ordering `PortNoticeHistory`. */
export enum PortNoticeHistoriesOrderBy {
  ATA_BERTH_ASC = 'ATA_BERTH_ASC',
  ATA_BERTH_DESC = 'ATA_BERTH_DESC',
  ATA_PBP_ASC = 'ATA_PBP_ASC',
  ATA_PBP_DESC = 'ATA_PBP_DESC',
  BERTHING_PROSPECTS_ASC = 'BERTHING_PROSPECTS_ASC',
  BERTHING_PROSPECTS_DESC = 'BERTHING_PROSPECTS_DESC',
  ETA_ASC = 'ETA_ASC',
  ETA_DESC = 'ETA_DESC',
  ETA_NEXT_PORT_ASC = 'ETA_NEXT_PORT_ASC',
  ETA_NEXT_PORT_DESC = 'ETA_NEXT_PORT_DESC',
  ETC_BUNKERS_ASC = 'ETC_BUNKERS_ASC',
  ETC_BUNKERS_DESC = 'ETC_BUNKERS_DESC',
  ETC_TERMINAL_ASC = 'ETC_TERMINAL_ASC',
  ETC_TERMINAL_DESC = 'ETC_TERMINAL_DESC',
  ETD_BERTH_ASC = 'ETD_BERTH_ASC',
  ETD_BERTH_DESC = 'ETD_BERTH_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_PROSPECTS_ASC = 'LOADING_PROSPECTS_ASC',
  LOADING_PROSPECTS_DESC = 'LOADING_PROSPECTS_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  NOR_TENDERED_ASC = 'NOR_TENDERED_ASC',
  NOR_TENDERED_DESC = 'NOR_TENDERED_DESC',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  RTA_BERTH_ASC = 'RTA_BERTH_ASC',
  RTA_BERTH_DESC = 'RTA_BERTH_DESC',
  RTA_PBP_ASC = 'RTA_PBP_ASC',
  RTA_PBP_DESC = 'RTA_PBP_DESC',
  RTD_BERTH_ASC = 'RTD_BERTH_ASC',
  RTD_BERTH_DESC = 'RTD_BERTH_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** History log for port notices */
export type PortNoticeHistory = {
  __typename?: 'PortNoticeHistory';
  ataBerth?: Maybe<Scalars['Datetime']['output']>;
  ataPbp?: Maybe<Scalars['Datetime']['output']>;
  berthingProspects?: Maybe<Scalars['Datetime']['output']>;
  eta?: Maybe<Scalars['Datetime']['output']>;
  etaNextPort?: Maybe<Scalars['Datetime']['output']>;
  etcBunkers?: Maybe<Scalars['Datetime']['output']>;
  etcTerminal?: Maybe<Scalars['Datetime']['output']>;
  etdBerth?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['PortNoticeId']['output'];
  loadingProspects?: Maybe<Scalars['Datetime']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  norTendered?: Maybe<Scalars['Datetime']['output']>;
  portCallId: Scalars['Int']['output'];
  /** Reads a single `PortNotice` that is related to this `PortNoticeHistory`. */
  portNoticeById?: Maybe<PortNotice>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  rtaBerth?: Maybe<Scalars['Datetime']['output']>;
  rtaPbp?: Maybe<Scalars['Datetime']['output']>;
  rtdBerth?: Maybe<Scalars['Datetime']['output']>;
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `PortNoticeHistory`. */
  userByModifiedByUserId?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `PortNoticeHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PortNoticeHistoryCondition = {
  /** Checks for equality with the object’s `ataBerth` field. */
  ataBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `ataPbp` field. */
  ataPbp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `berthingProspects` field. */
  berthingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `eta` field. */
  eta?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etaNextPort` field. */
  etaNextPort?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etcBunkers` field. */
  etcBunkers?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etcTerminal` field. */
  etcTerminal?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `etdBerth` field. */
  etdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortNoticeId']['input']>;
  /** Checks for equality with the object’s `loadingProspects` field. */
  loadingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `norTendered` field. */
  norTendered?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rtaBerth` field. */
  rtaBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rtaPbp` field. */
  rtaPbp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rtdBerth` field. */
  rtdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `PortNoticeHistory` object types. All fields are combined with a logical ‘and.’ */
export type PortNoticeHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortNoticeHistoryFilter>>;
  /** Filter by the object’s `ataBerth` field. */
  ataBerth?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `ataPbp` field. */
  ataPbp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `berthingProspects` field. */
  berthingProspects?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eta` field. */
  eta?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etaNextPort` field. */
  etaNextPort?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etcBunkers` field. */
  etcBunkers?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etcTerminal` field. */
  etcTerminal?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `etdBerth` field. */
  etdBerth?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingProspects` field. */
  loadingProspects?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `norTendered` field. */
  norTendered?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortNoticeHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortNoticeHistoryFilter>>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rtaBerth` field. */
  rtaBerth?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `rtaPbp` field. */
  rtaPbp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `rtdBerth` field. */
  rtdBerth?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `PortNotice` */
export type PortNoticeInput = {
  ataBerth?: InputMaybe<Scalars['Datetime']['input']>;
  ataPbp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Agent */
  berthingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  /** Ship captain */
  eta?: InputMaybe<Scalars['Datetime']['input']>;
  /** Agent */
  etaNextPort?: InputMaybe<Scalars['Datetime']['input']>;
  /** Bunker operator */
  etcBunkers?: InputMaybe<Scalars['Datetime']['input']>;
  /** Terminal operator */
  etcTerminal?: InputMaybe<Scalars['Datetime']['input']>;
  /** Ship (via agent) */
  etdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Agent */
  loadingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  norTendered?: InputMaybe<Scalars['Datetime']['input']>;
  portCallId: Scalars['PortCallId']['input'];
  /** Terminal operator */
  rtaBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Port Authority */
  rtaPbp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Port Authority */
  rtdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['UserId']['input'];
};

/** Represents an update to a `PortNotice`. Fields that are set will be updated. */
export type PortNoticePatch = {
  ataBerth?: InputMaybe<Scalars['Datetime']['input']>;
  ataPbp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Agent */
  berthingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  /** Ship captain */
  eta?: InputMaybe<Scalars['Datetime']['input']>;
  /** Agent */
  etaNextPort?: InputMaybe<Scalars['Datetime']['input']>;
  /** Bunker operator */
  etcBunkers?: InputMaybe<Scalars['Datetime']['input']>;
  /** Terminal operator */
  etcTerminal?: InputMaybe<Scalars['Datetime']['input']>;
  /** Ship (via agent) */
  etdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Agent */
  loadingProspects?: InputMaybe<Scalars['Datetime']['input']>;
  norTendered?: InputMaybe<Scalars['Datetime']['input']>;
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Terminal operator */
  rtaBerth?: InputMaybe<Scalars['Datetime']['input']>;
  /** Port Authority */
  rtaPbp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Port Authority */
  rtdBerth?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `PortNotice` values. */
export type PortNoticesConnection = {
  __typename?: 'PortNoticesConnection';
  /** A list of edges which contains the `PortNotice` and cursor to aid in pagination. */
  edges: Array<PortNoticesEdge>;
  /** A list of `PortNotice` objects. */
  nodes: Array<Maybe<PortNotice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortNotice` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortNotice` edge in the connection. */
export type PortNoticesEdge = {
  __typename?: 'PortNoticesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortNotice` at the end of the edge. */
  node?: Maybe<PortNotice>;
};

/** Methods to use when ordering `PortNotice`. */
export enum PortNoticesOrderBy {
  ATA_BERTH_ASC = 'ATA_BERTH_ASC',
  ATA_BERTH_DESC = 'ATA_BERTH_DESC',
  ATA_PBP_ASC = 'ATA_PBP_ASC',
  ATA_PBP_DESC = 'ATA_PBP_DESC',
  BERTHING_PROSPECTS_ASC = 'BERTHING_PROSPECTS_ASC',
  BERTHING_PROSPECTS_DESC = 'BERTHING_PROSPECTS_DESC',
  ETA_ASC = 'ETA_ASC',
  ETA_DESC = 'ETA_DESC',
  ETA_NEXT_PORT_ASC = 'ETA_NEXT_PORT_ASC',
  ETA_NEXT_PORT_DESC = 'ETA_NEXT_PORT_DESC',
  ETC_BUNKERS_ASC = 'ETC_BUNKERS_ASC',
  ETC_BUNKERS_DESC = 'ETC_BUNKERS_DESC',
  ETC_TERMINAL_ASC = 'ETC_TERMINAL_ASC',
  ETC_TERMINAL_DESC = 'ETC_TERMINAL_DESC',
  ETD_BERTH_ASC = 'ETD_BERTH_ASC',
  ETD_BERTH_DESC = 'ETD_BERTH_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_PROSPECTS_ASC = 'LOADING_PROSPECTS_ASC',
  LOADING_PROSPECTS_DESC = 'LOADING_PROSPECTS_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  NOR_TENDERED_ASC = 'NOR_TENDERED_ASC',
  NOR_TENDERED_DESC = 'NOR_TENDERED_DESC',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  RTA_BERTH_ASC = 'RTA_BERTH_ASC',
  RTA_BERTH_DESC = 'RTA_BERTH_DESC',
  RTA_PBP_ASC = 'RTA_PBP_ASC',
  RTA_PBP_DESC = 'RTA_PBP_DESC',
  RTD_BERTH_ASC = 'RTD_BERTH_ASC',
  RTD_BERTH_DESC = 'RTD_BERTH_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type PortRegion = Node & {
  __typename?: 'PortRegion';
  /** Reads a single `GeographicalEntity` that is related to this `PortRegion`. */
  geographicalEntityByGeographicalEntityId?: Maybe<GeographicalEntity>;
  geographicalEntityId?: Maybe<Scalars['GeographicalEntityId']['output']>;
  id: Scalars['PortRegionId']['output'];
  /** Reads a single `Location` that is related to this `PortRegion`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `PortRegion`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Region` that is related to this `PortRegion`. */
  regionByRegionId?: Maybe<Region>;
  regionId: Scalars['RegionId']['output'];
  sortOrder?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `PortRegion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PortRegionCondition = {
  /** Checks for equality with the object’s `geographicalEntityId` field. */
  geographicalEntityId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PortRegionId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `regionId` field. */
  regionId?: InputMaybe<Scalars['RegionId']['input']>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `PortRegion` object types. All fields are combined with a logical ‘and.’ */
export type PortRegionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PortRegionFilter>>;
  /** Filter by the object’s `geographicalEntityId` field. */
  geographicalEntityId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PortRegionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PortRegionFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `regionId` field. */
  regionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `PortRegion` */
export type PortRegionInput = {
  geographicalEntityId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  locationId: Scalars['LocationId']['input'];
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  regionId: Scalars['RegionId']['input'];
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `PortRegion`. Fields that are set will be updated. */
export type PortRegionPatch = {
  geographicalEntityId?: InputMaybe<Scalars['GeographicalEntityId']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  regionId?: InputMaybe<Scalars['RegionId']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `PortRegion` values. */
export type PortRegionsConnection = {
  __typename?: 'PortRegionsConnection';
  /** A list of edges which contains the `PortRegion` and cursor to aid in pagination. */
  edges: Array<PortRegionsEdge>;
  /** A list of `PortRegion` objects. */
  nodes: Array<Maybe<PortRegion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PortRegion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `PortRegion` edge in the connection. */
export type PortRegionsEdge = {
  __typename?: 'PortRegionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PortRegion` at the end of the edge. */
  node?: Maybe<PortRegion>;
};

/** Methods to use when ordering `PortRegion`. */
export enum PortRegionsOrderBy {
  GEOGRAPHICAL_ENTITY_ID_ASC = 'GEOGRAPHICAL_ENTITY_ID_ASC',
  GEOGRAPHICAL_ENTITY_ID_DESC = 'GEOGRAPHICAL_ENTITY_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REGION_ID_ASC = 'REGION_ID_ASC',
  REGION_ID_DESC = 'REGION_ID_DESC',
  SORT_ORDER_ASC = 'SORT_ORDER_ASC',
  SORT_ORDER_DESC = 'SORT_ORDER_DESC'
}

export enum PortType {
  /** Alongside */
  A = 'A',
  B = 'B',
  /** Commencing */
  C = 'C',
  /** Discharging */
  D = 'D',
  /** Fueling */
  F = 'F',
  /** Canal Transit */
  I = 'I',
  K = 'K',
  /** Loading */
  L = 'L',
  /** Loading and Discharging */
  M = 'M',
  N = 'N',
  /** Other */
  O = 'O',
  /** Passing */
  P = 'P',
  /** Repair */
  R = 'R',
  /** Terminating */
  T = 'T',
  U = 'U',
  /** Waiting */
  W = 'W',
  X = 'X',
  Y = 'Y',
  /** Redelivery */
  Z = 'Z',
  _EMPTY_ = '_EMPTY_'
}

/** A filter to be used against PortType fields. All fields are combined with a logical ‘and.’ */
export type PortTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PortType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PortType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PortType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PortType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PortType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PortType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PortType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PortType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PortType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PortType>>;
};

export enum PortcallExternalTimestampEvent {
  ARRIVE = 'ARRIVE',
  BERTH = 'BERTH',
  DEPART = 'DEPART'
}

/** A filter to be used against PortcallExternalTimestampEvent fields. All fields are combined with a logical ‘and.’ */
export type PortcallExternalTimestampEventFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PortcallExternalTimestampEvent>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PortcallExternalTimestampEvent>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PortcallExternalTimestampEvent>>;
};

export enum PortcallExternalTimestampType {
  ACTUAL = 'ACTUAL',
  ESTIMATE = 'ESTIMATE',
  PLANNED = 'PLANNED',
  REQUESTED = 'REQUESTED'
}

/** A filter to be used against PortcallExternalTimestampType fields. All fields are combined with a logical ‘and.’ */
export type PortcallExternalTimestampTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PortcallExternalTimestampType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PortcallExternalTimestampType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PortcallExternalTimestampType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PortcallExternalTimestampType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PortcallExternalTimestampType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PortcallExternalTimestampType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PortcallExternalTimestampType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PortcallExternalTimestampType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PortcallExternalTimestampType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PortcallExternalTimestampType>>;
};

export type Prompt = Node & {
  __typename?: 'Prompt';
  createdBy: Scalars['UserId']['output'];
  id: Scalars['PromptId']['output'];
  modifiedBy?: Maybe<Scalars['UserId']['output']>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Prompt`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  prompt: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `Prompt`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Prompt`. */
  userByModifiedBy?: Maybe<User>;
};

/** A condition to be used against `Prompt` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PromptCondition = {
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['PromptId']['input']>;
  /** Checks for equality with the object’s `modifiedBy` field. */
  modifiedBy?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `prompt` field. */
  prompt?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Prompt` object types. All fields are combined with a logical ‘and.’ */
export type PromptFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PromptFilter>>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBy` field. */
  modifiedBy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PromptFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PromptFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `prompt` field. */
  prompt?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Prompt` */
export type PromptInput = {
  createdBy?: InputMaybe<Scalars['UserId']['input']>;
  modifiedBy?: InputMaybe<Scalars['UserId']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  prompt: Scalars['String']['input'];
};

/** Represents an update to a `Prompt`. Fields that are set will be updated. */
export type PromptPatch = {
  createdBy?: InputMaybe<Scalars['UserId']['input']>;
  modifiedBy?: InputMaybe<Scalars['UserId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Prompt` values. */
export type PromptsConnection = {
  __typename?: 'PromptsConnection';
  /** A list of edges which contains the `Prompt` and cursor to aid in pagination. */
  edges: Array<PromptsEdge>;
  /** A list of `Prompt` objects. */
  nodes: Array<Maybe<Prompt>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Prompt` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Prompt` edge in the connection. */
export type PromptsEdge = {
  __typename?: 'PromptsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Prompt` at the end of the edge. */
  node?: Maybe<Prompt>;
};

/** Methods to use when ordering `Prompt`. */
export enum PromptsOrderBy {
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_ASC = 'MODIFIED_BY_ASC',
  MODIFIED_BY_DESC = 'MODIFIED_BY_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PROMPT_ASC = 'PROMPT_ASC',
  PROMPT_DESC = 'PROMPT_DESC'
}

export type PublishOrdersPayload = {
  __typename?: 'PublishOrdersPayload';
  hbcs: Array<Scalars['String']['output']>;
  hbss: Array<Scalars['String']['output']>;
  orders: Array<Order>;
  sos: Array<Scalars['String']['output']>;
};

export type Q88OrderSyncResult = {
  __typename?: 'Q88OrderSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Q88PortSyncResult = {
  __typename?: 'Q88PortSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Q88UpdateCache = {
  __typename?: 'Q88UpdateCache';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Q88UpdateData = {
  __typename?: 'Q88UpdateData';
  syncOrder: Q88OrderSyncResult;
  updateScenario: UpdateQ88ScenarioResult;
};

export type Q88VesselSyncResult = {
  __typename?: 'Q88VesselSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Quay = Node & {
  __typename?: 'Quay';
  airdraft?: Maybe<Scalars['BigFloat']['output']>;
  beam?: Maybe<Scalars['BigFloat']['output']>;
  cranes?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsByQuayId: DemandsConnection;
  description?: Maybe<Scalars['String']['output']>;
  dischargeSpeed?: Maybe<Scalars['BigFloat']['output']>;
  draught?: Maybe<Scalars['BigFloat']['output']>;
  height?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['QuayId']['output'];
  isDefault: Scalars['Boolean']['output'];
  loa?: Maybe<Scalars['BigFloat']['output']>;
  loadSpeed?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `Location` that is related to this `Quay`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  portId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesByQuay: SuppliesConnection;
  /** Reads a single `User` that is related to this `Quay`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};


export type QuayDemandsByQuayIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type QuaySuppliesByQuayArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};

/** A condition to be used against `Quay` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type QuayCondition = {
  /** Checks for equality with the object’s `airdraft` field. */
  airdraft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `beam` field. */
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `cranes` field. */
  cranes?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dischargeSpeed` field. */
  dischargeSpeed?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `draught` field. */
  draught?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `height` field. */
  height?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['QuayId']['input']>;
  /** Checks for equality with the object’s `isDefault` field. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loa` field. */
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadSpeed` field. */
  loadSpeed?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portId` field. */
  portId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `Quay` object types. All fields are combined with a logical ‘and.’ */
export type QuayFilter = {
  /** Filter by the object’s `airdraft` field. */
  airdraft?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<QuayFilter>>;
  /** Filter by the object’s `beam` field. */
  beam?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `cranes` field. */
  cranes?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dischargeSpeed` field. */
  dischargeSpeed?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `draught` field. */
  draught?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `height` field. */
  height?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDefault` field. */
  isDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loa` field. */
  loa?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadSpeed` field. */
  loadSpeed?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<QuayFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<QuayFilter>>;
  /** Filter by the object’s `portId` field. */
  portId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Quay` */
export type QuayInput = {
  airdraft?: InputMaybe<Scalars['BigFloat']['input']>;
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  cranes?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dischargeSpeed?: InputMaybe<Scalars['BigFloat']['input']>;
  draught?: InputMaybe<Scalars['BigFloat']['input']>;
  height?: InputMaybe<Scalars['BigFloat']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
  loadSpeed?: InputMaybe<Scalars['BigFloat']['input']>;
  locationId: Scalars['LocationId']['input'];
  name: Scalars['String']['input'];
  portId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `Quay`. Fields that are set will be updated. */
export type QuayPatch = {
  airdraft?: InputMaybe<Scalars['BigFloat']['input']>;
  beam?: InputMaybe<Scalars['BigFloat']['input']>;
  cranes?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dischargeSpeed?: InputMaybe<Scalars['BigFloat']['input']>;
  draught?: InputMaybe<Scalars['BigFloat']['input']>;
  height?: InputMaybe<Scalars['BigFloat']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
  loadSpeed?: InputMaybe<Scalars['BigFloat']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `Quay` values. */
export type QuaysConnection = {
  __typename?: 'QuaysConnection';
  /** A list of edges which contains the `Quay` and cursor to aid in pagination. */
  edges: Array<QuaysEdge>;
  /** A list of `Quay` objects. */
  nodes: Array<Maybe<Quay>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Quay` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Quay` edge in the connection. */
export type QuaysEdge = {
  __typename?: 'QuaysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Quay` at the end of the edge. */
  node?: Maybe<Quay>;
};

/** Methods to use when ordering `Quay`. */
export enum QuaysOrderBy {
  AIRDRAFT_ASC = 'AIRDRAFT_ASC',
  AIRDRAFT_DESC = 'AIRDRAFT_DESC',
  BEAM_ASC = 'BEAM_ASC',
  BEAM_DESC = 'BEAM_DESC',
  CRANES_ASC = 'CRANES_ASC',
  CRANES_DESC = 'CRANES_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  DISCHARGE_SPEED_ASC = 'DISCHARGE_SPEED_ASC',
  DISCHARGE_SPEED_DESC = 'DISCHARGE_SPEED_DESC',
  DRAUGHT_ASC = 'DRAUGHT_ASC',
  DRAUGHT_DESC = 'DRAUGHT_DESC',
  HEIGHT_ASC = 'HEIGHT_ASC',
  HEIGHT_DESC = 'HEIGHT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_DEFAULT_ASC = 'IS_DEFAULT_ASC',
  IS_DEFAULT_DESC = 'IS_DEFAULT_DESC',
  LOAD_SPEED_ASC = 'LOAD_SPEED_ASC',
  LOAD_SPEED_DESC = 'LOAD_SPEED_DESC',
  LOA_ASC = 'LOA_ASC',
  LOA_DESC = 'LOA_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PORT_ID_ASC = 'PORT_ID_ASC',
  PORT_ID_DESC = 'PORT_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  GetBerthPredictions?: Maybe<BerthPredictions>;
  /** Reads a single `ActualCost` using its globally unique `ID`. */
  actualCost?: Maybe<ActualCost>;
  actualCostById?: Maybe<ActualCost>;
  /** Reads and enables pagination through a set of `ActualCost`. */
  allActualCosts?: Maybe<ActualCostsConnection>;
  /** Reads and enables pagination through a set of `ApiCoaContract`. */
  allApiCoaContracts?: Maybe<ApiCoaContractsConnection>;
  /** Reads and enables pagination through a set of `ApiLocation`. */
  allApiLocations?: Maybe<ApiLocationsConnection>;
  /** Reads and enables pagination through a set of `ApiOrder`. */
  allApiOrders?: Maybe<ApiOrdersConnection>;
  /** Reads and enables pagination through a set of `ApiOrdersNotice`. */
  allApiOrdersNotices?: Maybe<ApiOrdersNoticesConnection>;
  /** Reads and enables pagination through a set of `ApiScheduledOrder`. */
  allApiScheduledOrders?: Maybe<ApiScheduledOrdersConnection>;
  /** Reads and enables pagination through a set of `ApiShipmentStatus`. */
  allApiShipmentStatuses?: Maybe<ApiShipmentStatusesConnection>;
  /** Reads and enables pagination through a set of `ApiShip`. */
  allApiShips?: Maybe<ApiShipsConnection>;
  /** Reads and enables pagination through a set of `AssortmentExclusion`. */
  allAssortmentExclusions?: Maybe<AssortmentExclusionsConnection>;
  /** Reads and enables pagination through a set of `AssortmentGroup`. */
  allAssortmentGroups?: Maybe<AssortmentGroupsConnection>;
  /** Reads and enables pagination through a set of `Assortment`. */
  allAssortments?: Maybe<AssortmentsConnection>;
  allBalticConfigs: Array<BalticConfig>;
  /** Reads and enables pagination through a set of `BatchUpdate`. */
  allBatchUpdates?: Maybe<BatchUpdatesConnection>;
  /** Reads and enables pagination through a set of `BillOfLadingDatum`. */
  allBillOfLadingData?: Maybe<BillOfLadingDataConnection>;
  /** Reads and enables pagination through a set of `BillOfLading`. */
  allBillOfLadings?: Maybe<BillOfLadingsConnection>;
  /** Reads and enables pagination through a set of `BunkerGradeCalculation`. */
  allBunkerGradeCalculations?: Maybe<BunkerGradeCalculationsConnection>;
  /** Reads and enables pagination through a set of `BunkerGradeMapping`. */
  allBunkerGradeMappings?: Maybe<BunkerGradeMappingsConnection>;
  /** Reads and enables pagination through a set of `BunkerGradeOverrideHistory`. */
  allBunkerGradeOverrideHistories?: Maybe<BunkerGradeOverrideHistoriesConnection>;
  /** Reads and enables pagination through a set of `BunkerGradeOverride`. */
  allBunkerGradeOverrides?: Maybe<BunkerGradeOverridesConnection>;
  /** Reads and enables pagination through a set of `Bunkering`. */
  allBunkerings?: Maybe<BunkeringsConnection>;
  /** Reads and enables pagination through a set of `CarbonPriceOverride`. */
  allCarbonPriceOverrides?: Maybe<CarbonPriceOverridesConnection>;
  /** Reads and enables pagination through a set of `CargoCompartmentAllocation`. */
  allCargoCompartmentAllocations?: Maybe<CargoCompartmentAllocationsConnection>;
  /** Reads and enables pagination through a set of `CargoCompartment`. */
  allCargoCompartments?: Maybe<CargoCompartmentsConnection>;
  /** Reads and enables pagination through a set of `CargoEquipment`. */
  allCargoEquipments?: Maybe<CargoEquipmentsConnection>;
  /** Reads and enables pagination through a set of `CargoExclusion`. */
  allCargoExclusions?: Maybe<CargoExclusionsConnection>;
  /** Reads and enables pagination through a set of `CargoLengthUnit`. */
  allCargoLengthUnits?: Maybe<CargoLengthUnitsConnection>;
  /** Reads and enables pagination through a set of `CargoMeasurement`. */
  allCargoMeasurements?: Maybe<CargoMeasurementsConnection>;
  /** Reads and enables pagination through a set of `CargoUnit`. */
  allCargoUnits?: Maybe<CargoUnitsConnection>;
  /** Reads and enables pagination through a set of `CargoUnitsConversion`. */
  allCargoUnitsConversions?: Maybe<CargoUnitsConversionsConnection>;
  /** Reads and enables pagination through a set of `CargoWeightUnit`. */
  allCargoWeightUnits?: Maybe<CargoWeightUnitsConnection>;
  /** Reads and enables pagination through a set of `ChannelCostEstimate`. */
  allChannelCostEstimates?: Maybe<ChannelCostEstimatesConnection>;
  /** Reads and enables pagination through a set of `ChannelCost`. */
  allChannelCosts?: Maybe<ChannelCostsConnection>;
  /** Reads and enables pagination through a set of `ChannelIncompatibility`. */
  allChannelIncompatibilities?: Maybe<ChannelIncompatibilitiesConnection>;
  /** Reads and enables pagination through a set of `Channel`. */
  allChannels?: Maybe<ChannelsConnection>;
  /** Reads and enables pagination through a set of `Chat`. */
  allChats?: Maybe<ChatsConnection>;
  /** Reads and enables pagination through a set of `ClassSocietyAssociation`. */
  allClassSocietyAssociations?: Maybe<ClassSocietyAssociationsConnection>;
  /** Reads and enables pagination through a set of `ClassificationSociety`. */
  allClassificationSocieties?: Maybe<ClassificationSocietiesConnection>;
  /** Reads and enables pagination through a set of `CoaContractAssortment`. */
  allCoaContractAssortments?: Maybe<CoaContractAssortmentsConnection>;
  /** Reads and enables pagination through a set of `CoaContractBunker`. */
  allCoaContractBunkers?: Maybe<CoaContractBunkersConnection>;
  /** Reads and enables pagination through a set of `CoaContractCommission`. */
  allCoaContractCommissions?: Maybe<CoaContractCommissionsConnection>;
  /** Reads and enables pagination through a set of `CoaContractDeviationCost`. */
  allCoaContractDeviationCosts?: Maybe<CoaContractDeviationCostsConnection>;
  /** Reads and enables pagination through a set of `CoaContractPortCost`. */
  allCoaContractPortCosts?: Maybe<CoaContractPortCostsConnection>;
  /** Reads and enables pagination through a set of `CoaContractPortDatum`. */
  allCoaContractPortData?: Maybe<CoaContractPortDataConnection>;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  allCoaContractPorts?: Maybe<CoaContractPortsConnection>;
  /** Reads and enables pagination through a set of `CoaContractPrice`. */
  allCoaContractPrices?: Maybe<CoaContractPricesConnection>;
  /** Reads and enables pagination through a set of `CoaContractShip`. */
  allCoaContractShips?: Maybe<CoaContractShipsConnection>;
  /** Reads and enables pagination through a set of `CoaContract`. */
  allCoaContracts?: Maybe<CoaContractsConnection>;
  /** Reads and enables pagination through a set of `Commission`. */
  allCommissions?: Maybe<CommissionsConnection>;
  /** Reads and enables pagination through a set of `CommitLogHistory`. */
  allCommitLogHistories?: Maybe<CommitLogHistoriesConnection>;
  /** Reads and enables pagination through a set of `CommitLogScenario`. */
  allCommitLogScenarios?: Maybe<CommitLogScenariosConnection>;
  /** Reads and enables pagination through a set of `CommitLog`. */
  allCommitLogs?: Maybe<CommitLogsConnection>;
  /** Reads and enables pagination through a set of `CostSplitOnScheduledOrder`. */
  allCostSplitOnScheduledOrders?: Maybe<CostSplitOnScheduledOrdersConnection>;
  /** Reads and enables pagination through a set of `CostSplitOnSingleEvent`. */
  allCostSplitOnSingleEvents?: Maybe<CostSplitOnSingleEventsConnection>;
  /** Reads and enables pagination through a set of `Country`. */
  allCountries?: Maybe<CountriesConnection>;
  /** Reads and enables pagination through a set of `CurrentOrganization`. */
  allCurrentOrganizations?: Maybe<CurrentOrganizationsConnection>;
  /** Reads and enables pagination through a set of `DbChange`. */
  allDbChanges?: Maybe<DbChangesConnection>;
  /** Reads and enables pagination through a set of `Demand`. */
  allDemands?: Maybe<DemandsConnection>;
  /** Reads and enables pagination through a set of `EmailToOrderConfig`. */
  allEmailToOrderConfigs?: Maybe<EmailToOrderConfigsConnection>;
  /** Reads and enables pagination through a set of `EmailToOrderLog`. */
  allEmailToOrderLogs?: Maybe<EmailToOrderLogsConnection>;
  /** Reads and enables pagination through a set of `Feature`. */
  allFeatures?: Maybe<FeaturesConnection>;
  /** Reads and enables pagination through a set of `File`. */
  allFiles?: Maybe<FilesConnection>;
  /** Reads and enables pagination through a set of `GeographicalEntity`. */
  allGeographicalEntities?: Maybe<GeographicalEntitiesConnection>;
  /** Reads and enables pagination through a set of `GeographicalRelation`. */
  allGeographicalRelations?: Maybe<GeographicalRelationsConnection>;
  /** Reads and enables pagination through a set of `HandledByCoaHistory`. */
  allHandledByCoaHistories?: Maybe<HandledByCoaHistoriesConnection>;
  /** Reads and enables pagination through a set of `HandledByCoa`. */
  allHandledByCoas?: Maybe<HandledByCoasConnection>;
  /** Reads and enables pagination through a set of `HandledBySpotHistory`. */
  allHandledBySpotHistories?: Maybe<HandledBySpotHistoriesConnection>;
  /** Reads and enables pagination through a set of `HandledBySpot`. */
  allHandledBySpots?: Maybe<HandledBySpotsConnection>;
  /** Reads and enables pagination through a set of `Holiday`. */
  allHolidays?: Maybe<HolidaysConnection>;
  /** Reads and enables pagination through a set of `IceClass`. */
  allIceClasses?: Maybe<IceClassesConnection>;
  /** Reads and enables pagination through a set of `Instruction`. */
  allInstructions?: Maybe<InstructionsConnection>;
  /** Reads and enables pagination through a set of `IntegrationLog`. */
  allIntegrationLogs?: Maybe<IntegrationLogsConnection>;
  /** Reads and enables pagination through a set of `InvoiceItemOrder`. */
  allInvoiceItemOrders?: Maybe<InvoiceItemOrdersConnection>;
  /** Reads and enables pagination through a set of `InvoiceItem`. */
  allInvoiceItems?: Maybe<InvoiceItemsConnection>;
  /** Reads and enables pagination through a set of `Invoice`. */
  allInvoices?: Maybe<InvoicesConnection>;
  /** Reads and enables pagination through a set of `LatestPortCostByPortAndPrimaryAttribute`. */
  allLatestPortCostByPortAndPrimaryAttributes?: Maybe<LatestPortCostByPortAndPrimaryAttributesConnection>;
  /** Reads and enables pagination through a set of `LaytimeResponsibility`. */
  allLaytimeResponsibilities?: Maybe<LaytimeResponsibilitiesConnection>;
  /** Reads and enables pagination through a set of `LocationCluster`. */
  allLocationClusters?: Maybe<LocationClustersConnection>;
  /** Reads and enables pagination through a set of `LocationRequirementAssociation`. */
  allLocationRequirementAssociations?: Maybe<LocationRequirementAssociationsConnection>;
  /** Reads and enables pagination through a set of `LocationWorkingHour`. */
  allLocationWorkingHours?: Maybe<LocationWorkingHoursConnection>;
  /** Reads and enables pagination through a set of `Location`. */
  allLocations?: Maybe<LocationsConnection>;
  /** Reads and enables pagination through a set of `LostContract`. */
  allLostContracts?: Maybe<LostContractsConnection>;
  /** Reads and enables pagination through a set of `MvLatestPortCostByPortAndPrimaryAttribute`. */
  allMvLatestPortCostByPortAndPrimaryAttributes?: Maybe<MvLatestPortCostByPortAndPrimaryAttributesConnection>;
  /** Reads and enables pagination through a set of `MvPortCostsByPortAndPrimaryAttribute`. */
  allMvPortCostsByPortAndPrimaryAttributes?: Maybe<MvPortCostsByPortAndPrimaryAttributesConnection>;
  /** Reads and enables pagination through a set of `MvPortCostsByPortAndVesselName`. */
  allMvPortCostsByPortAndVesselNames?: Maybe<MvPortCostsByPortAndVesselNamesConnection>;
  /** Reads and enables pagination through a set of `NoGoZone`. */
  allNoGoZones?: Maybe<NoGoZonesConnection>;
  /** Reads and enables pagination through a set of `NotificationReceiver`. */
  allNotificationReceivers?: Maybe<NotificationReceiversConnection>;
  /** Reads and enables pagination through a set of `OffHireHistory`. */
  allOffHireHistories?: Maybe<OffHireHistoriesConnection>;
  /** Reads and enables pagination through a set of `OffHire`. */
  allOffHires?: Maybe<OffHiresConnection>;
  /** Reads and enables pagination through a set of `OpenPositionHistory`. */
  allOpenPositionHistories?: Maybe<OpenPositionHistoriesConnection>;
  /** Reads and enables pagination through a set of `OpenPosition`. */
  allOpenPositions?: Maybe<OpenPositionsConnection>;
  /** Reads and enables pagination through a set of `OrderAttributeAssociation`. */
  allOrderAttributeAssociations?: Maybe<OrderAttributeAssociationsConnection>;
  /** Reads and enables pagination through a set of `OrderAttribute`. */
  allOrderAttributes?: Maybe<OrderAttributesConnection>;
  /** Reads and enables pagination through a set of `OrderDetail`. */
  allOrderDetails?: Maybe<OrderDetailsConnection>;
  /** Reads and enables pagination through a set of `OrderPortCallRelationHistory`. */
  allOrderPortCallRelationHistories?: Maybe<OrderPortCallRelationHistoriesConnection>;
  /** Reads and enables pagination through a set of `OrderPortCallRelation`. */
  allOrderPortCallRelations?: Maybe<OrderPortCallRelationsConnection>;
  /** Reads and enables pagination through a set of `OrderPortOverride`. */
  allOrderPortOverrides?: Maybe<OrderPortOverridesConnection>;
  /** Reads and enables pagination through a set of `OrderRequirementAssociation`. */
  allOrderRequirementAssociations?: Maybe<OrderRequirementAssociationsConnection>;
  /** Reads and enables pagination through a set of `OrderVoyageCharterRelationHistory`. */
  allOrderVoyageCharterRelationHistories?: Maybe<OrderVoyageCharterRelationHistoriesConnection>;
  /** Reads and enables pagination through a set of `OrderVoyageCharterRelation`. */
  allOrderVoyageCharterRelations?: Maybe<OrderVoyageCharterRelationsConnection>;
  /** Reads and enables pagination through a set of `Order`. */
  allOrders?: Maybe<OrdersConnection>;
  allOrdersAllRelatedOrgs?: Maybe<AllOrdersAllRelatedOrgsConnection>;
  /** Reads and enables pagination through a set of `OrdersHistory`. */
  allOrdersHistories?: Maybe<OrdersHistoriesConnection>;
  /** Reads and enables pagination through a set of `OrganizationAreaBunkerGradeMapping`. */
  allOrganizationAreaBunkerGradeMappings?: Maybe<OrganizationAreaBunkerGradeMappingsConnection>;
  /** Reads and enables pagination through a set of `OrganizationFeature`. */
  allOrganizationFeatures?: Maybe<OrganizationFeaturesConnection>;
  /** Reads and enables pagination through a set of `Organization`. */
  allOrganizations?: Maybe<OrganizationsConnection>;
  /** Reads and enables pagination through a set of `PortActivity`. */
  allPortActivities?: Maybe<PortActivitiesConnection>;
  /** Reads and enables pagination through a set of `PortCallExternalTimestamp`. */
  allPortCallExternalTimestamps?: Maybe<PortCallExternalTimestampsConnection>;
  /** Reads and enables pagination through a set of `PortCallFile`. */
  allPortCallFiles?: Maybe<PortCallFilesConnection>;
  /** Reads and enables pagination through a set of `PortCallHistory`. */
  allPortCallHistories?: Maybe<PortCallHistoriesConnection>;
  /** Reads and enables pagination through a set of `PortCall`. */
  allPortCalls?: Maybe<PortCallsConnection>;
  /** Reads and enables pagination through a set of `PortCommodityLdRate`. */
  allPortCommodityLdRates?: Maybe<PortCommodityLdRatesConnection>;
  /** Reads and enables pagination through a set of `PortCostDefault`. */
  allPortCostDefaults?: Maybe<PortCostDefaultsConnection>;
  /** Reads and enables pagination through a set of `PortCostEstimatesExternal`. */
  allPortCostEstimatesExternals?: Maybe<PortCostEstimatesExternalsConnection>;
  /** Reads and enables pagination through a set of `PortCost`. */
  allPortCosts?: Maybe<PortCostsConnection>;
  /** Reads and enables pagination through a set of `PortCostsByPortAndPrimaryAttribute`. */
  allPortCostsByPortAndPrimaryAttributes?: Maybe<PortCostsByPortAndPrimaryAttributesConnection>;
  /** Reads and enables pagination through a set of `PortCostsByPortAndVesselName`. */
  allPortCostsByPortAndVesselNames?: Maybe<PortCostsByPortAndVesselNamesConnection>;
  /** Reads and enables pagination through a set of `PortDatum`. */
  allPortData?: Maybe<PortDataConnection>;
  /** Reads and enables pagination through a set of `PortNoticeHistory`. */
  allPortNoticeHistories?: Maybe<PortNoticeHistoriesConnection>;
  /** Reads and enables pagination through a set of `PortNotice`. */
  allPortNotices?: Maybe<PortNoticesConnection>;
  /** Reads and enables pagination through a set of `PortRegion`. */
  allPortRegions?: Maybe<PortRegionsConnection>;
  /** Reads and enables pagination through a set of `Prompt`. */
  allPrompts?: Maybe<PromptsConnection>;
  /** Reads and enables pagination through a set of `Quay`. */
  allQuays?: Maybe<QuaysConnection>;
  /** Reads and enables pagination through a set of `ReceiverOrganization`. */
  allReceiverOrganizations?: Maybe<ReceiverOrganizationsConnection>;
  /** Reads and enables pagination through a set of `Region`. */
  allRegions?: Maybe<RegionsConnection>;
  /** Reads and enables pagination through a set of `RequestLog`. */
  allRequestLogs?: Maybe<RequestLogsConnection>;
  /** Reads and enables pagination through a set of `RouteOverride`. */
  allRouteOverrides?: Maybe<RouteOverridesConnection>;
  /** Reads and enables pagination through a set of `RoutePointUsage`. */
  allRoutePointUsages?: Maybe<RoutePointUsagesConnection>;
  /** Reads and enables pagination through a set of `RoutePoint`. */
  allRoutePoints?: Maybe<RoutePointsConnection>;
  /** Reads and enables pagination through a set of `Route`. */
  allRoutes?: Maybe<RoutesConnection>;
  /** Reads and enables pagination through a set of `Scenario`. */
  allScenarios?: Maybe<ScenariosConnection>;
  /** Reads and enables pagination through a set of `ScenariosHistory`. */
  allScenariosHistories?: Maybe<ScenariosHistoriesConnection>;
  /** Reads and enables pagination through a set of `ScheduledOrderHistory`. */
  allScheduledOrderHistories?: Maybe<ScheduledOrderHistoriesConnection>;
  /** Reads and enables pagination through a set of `ScheduledOrder`. */
  allScheduledOrders?: Maybe<ScheduledOrdersConnection>;
  /** Reads and enables pagination through a set of `SeenMessage`. */
  allSeenMessages?: Maybe<SeenMessagesConnection>;
  /** Reads and enables pagination through a set of `SenderOrganization`. */
  allSenderOrganizations?: Maybe<SenderOrganizationsConnection>;
  /** Reads and enables pagination through a set of `ShipVoyageNamingRuleRelation`. */
  allShipVoyageNamingRuleRelations?: Maybe<ShipVoyageNamingRuleRelationsConnection>;
  /** Reads and enables pagination through a set of `ShipmentExternalStatus`. */
  allShipmentExternalStatuses?: Maybe<ShipmentExternalStatusesConnection>;
  /** Reads and enables pagination through a set of `ShipmentExtraFreight`. */
  allShipmentExtraFreights?: Maybe<ShipmentExtraFreightsConnection>;
  /** Reads and enables pagination through a set of `ShipmentFreight`. */
  allShipmentFreights?: Maybe<ShipmentFreightsConnection>;
  /** Reads and enables pagination through a set of `ShipmentGroupAssociation`. */
  allShipmentGroupAssociations?: Maybe<ShipmentGroupAssociationsConnection>;
  /** Reads and enables pagination through a set of `ShipmentGroup`. */
  allShipmentGroups?: Maybe<ShipmentGroupsConnection>;
  /** Reads and enables pagination through a set of `ShipmentHistory`. */
  allShipmentHistories?: Maybe<ShipmentHistoriesConnection>;
  /** Reads and enables pagination through a set of `Shipment`. */
  allShipments?: Maybe<ShipmentsConnection>;
  allShipnetConfigs: Array<ShipnetConfig>;
  /** Reads and enables pagination through a set of `Ship`. */
  allShips?: Maybe<ShipsConnection>;
  /** Reads and enables pagination through a set of `SingleEventHistory`. */
  allSingleEventHistories?: Maybe<SingleEventHistoriesConnection>;
  /** Reads and enables pagination through a set of `SingleEventPortCallRelation`. */
  allSingleEventPortCallRelations?: Maybe<SingleEventPortCallRelationsConnection>;
  /** Reads and enables pagination through a set of `SingleEvent`. */
  allSingleEvents?: Maybe<SingleEventsConnection>;
  /** Reads and enables pagination through a set of `SpecialRequirement`. */
  allSpecialRequirements?: Maybe<SpecialRequirementsConnection>;
  /** Reads and enables pagination through a set of `SplitOrder`. */
  allSplitOrders?: Maybe<SplitOrdersConnection>;
  /** Reads and enables pagination through a set of `SpotNegotiation`. */
  allSpotNegotiations?: Maybe<SpotNegotiationsConnection>;
  /** Reads and enables pagination through a set of `StatementOfFact`. */
  allStatementOfFacts?: Maybe<StatementOfFactsConnection>;
  /** Reads and enables pagination through a set of `StatementOfFactsHistory`. */
  allStatementOfFactsHistories?: Maybe<StatementOfFactsHistoriesConnection>;
  /** Reads and enables pagination through a set of `Supply`. */
  allSupplies?: Maybe<SuppliesConnection>;
  /** Reads and enables pagination through a set of `SupplyContract`. */
  allSupplyContracts?: Maybe<SupplyContractsConnection>;
  /** Reads and enables pagination through a set of `TankDistance`. */
  allTankDistances?: Maybe<TankDistancesConnection>;
  /** Reads and enables pagination through a set of `TcContract`. */
  allTcContracts?: Maybe<TcContractsConnection>;
  /** Reads and enables pagination through a set of `UserRegion`. */
  allUserRegions?: Maybe<UserRegionsConnection>;
  /** Reads and enables pagination through a set of `UserRight`. */
  allUserRights?: Maybe<UserRightsConnection>;
  /** Reads and enables pagination through a set of `UserSetting`. */
  allUserSettings?: Maybe<UserSettingsConnection>;
  /** Reads and enables pagination through a set of `UserShip`. */
  allUserShips?: Maybe<UserShipsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  allUsers?: Maybe<UsersConnection>;
  allVesonConfigs: Array<VesonConfig>;
  /** Reads and enables pagination through a set of `VesselAttributeAssortmentExclusion`. */
  allVesselAttributeAssortmentExclusions?: Maybe<VesselAttributeAssortmentExclusionsConnection>;
  /** Reads and enables pagination through a set of `VesselAttribute`. */
  allVesselAttributes?: Maybe<VesselAttributesConnection>;
  /** Reads and enables pagination through a set of `VesselAttributesAssociation`. */
  allVesselAttributesAssociations?: Maybe<VesselAttributesAssociationsConnection>;
  /** Reads and enables pagination through a set of `VesselDraftDatapoint`. */
  allVesselDraftDatapoints?: Maybe<VesselDraftDatapointsConnection>;
  /** Reads and enables pagination through a set of `VesselFulfillsRequirementAssociation`. */
  allVesselFulfillsRequirementAssociations?: Maybe<VesselFulfillsRequirementAssociationsConnection>;
  /** Reads and enables pagination through a set of `VesselInfo`. */
  allVesselInfos?: Maybe<VesselInfosConnection>;
  /** Reads and enables pagination through a set of `VesselPerformanceModel`. */
  allVesselPerformanceModels?: Maybe<VesselPerformanceModelsConnection>;
  /** Reads and enables pagination through a set of `VesselReservationHistory`. */
  allVesselReservationHistories?: Maybe<VesselReservationHistoriesConnection>;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  allVesselReservations?: Maybe<VesselReservationsConnection>;
  /** Reads and enables pagination through a set of `VesselScheduleSharedToOrganization`. */
  allVesselScheduleSharedToOrganizations?: Maybe<VesselScheduleSharedToOrganizationsConnection>;
  /** Reads and enables pagination through a set of `VesselSecret`. */
  allVesselSecrets?: Maybe<VesselSecretsConnection>;
  /** Reads and enables pagination through a set of `VesselSpeedConsumption`. */
  allVesselSpeedConsumptions?: Maybe<VesselSpeedConsumptionsConnection>;
  /** Reads and enables pagination through a set of `VoyageAssociation`. */
  allVoyageAssociations?: Maybe<VoyageAssociationsConnection>;
  /** Reads and enables pagination through a set of `VoyageAttribute`. */
  allVoyageAttributes?: Maybe<VoyageAttributesConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterExtraCost`. */
  allVoyageCharterExtraCosts?: Maybe<VoyageCharterExtraCostsConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterExtraFreight`. */
  allVoyageCharterExtraFreights?: Maybe<VoyageCharterExtraFreightsConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterHistory`. */
  allVoyageCharterHistories?: Maybe<VoyageCharterHistoriesConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterOrderFreightHistory`. */
  allVoyageCharterOrderFreightHistories?: Maybe<VoyageCharterOrderFreightHistoriesConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterOrderFreight`. */
  allVoyageCharterOrderFreights?: Maybe<VoyageCharterOrderFreightsConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterPortCost`. */
  allVoyageCharterPortCosts?: Maybe<VoyageCharterPortCostsConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterPortDatum`. */
  allVoyageCharterPortData?: Maybe<VoyageCharterPortDataConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterPortDataHistory`. */
  allVoyageCharterPortDataHistories?: Maybe<VoyageCharterPortDataHistoriesConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterToContractHistory`. */
  allVoyageCharterToContractHistories?: Maybe<VoyageCharterToContractHistoriesConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterToContract`. */
  allVoyageCharterToContracts?: Maybe<VoyageCharterToContractsConnection>;
  /** Reads and enables pagination through a set of `VoyageCharterUpdate`. */
  allVoyageCharterUpdates?: Maybe<VoyageCharterUpdatesConnection>;
  /** Reads and enables pagination through a set of `VoyageCharter`. */
  allVoyageCharters?: Maybe<VoyageChartersConnection>;
  /** Reads and enables pagination through a set of `VoyageNamingRule`. */
  allVoyageNamingRules?: Maybe<VoyageNamingRulesConnection>;
  /** Reads and enables pagination through a set of `Voyage`. */
  allVoyages?: Maybe<VoyagesConnection>;
  /** Reads and enables pagination through a set of `VwBrokerAccessibleOrder`. */
  allVwBrokerAccessibleOrders?: Maybe<VwBrokerAccessibleOrdersConnection>;
  /** Reads and enables pagination through a set of `VwHandledByCoaPortAgentOrdersPg`. */
  allVwHandledByCoaPortAgentOrdersPgs?: Maybe<VwHandledByCoaPortAgentOrdersPgsConnection>;
  /** Reads and enables pagination through a set of `VwHandledByCoaShipOwnerOrdersPg`. */
  allVwHandledByCoaShipOwnerOrdersPgs?: Maybe<VwHandledByCoaShipOwnerOrdersPgsConnection>;
  /** Reads and enables pagination through a set of `VwHandledBySpotOrgRef`. */
  allVwHandledBySpotOrgRefs?: Maybe<VwHandledBySpotOrgRefsConnection>;
  /** Reads and enables pagination through a set of `VwHandledBySpotShipOwnerPg`. */
  allVwHandledBySpotShipOwnerPgs?: Maybe<VwHandledBySpotShipOwnerPgsConnection>;
  /** Reads and enables pagination through a set of `VwOrderPolicyPortAgentOrder`. */
  allVwOrderPolicyPortAgentOrders?: Maybe<VwOrderPolicyPortAgentOrdersConnection>;
  /** Reads and enables pagination through a set of `VwOrderPolicySharedOrdersForReceiver`. */
  allVwOrderPolicySharedOrdersForReceivers?: Maybe<VwOrderPolicySharedOrdersForReceiversConnection>;
  /** Reads and enables pagination through a set of `VwOrderPolicySharedOrdersForSender`. */
  allVwOrderPolicySharedOrdersForSenders?: Maybe<VwOrderPolicySharedOrdersForSendersConnection>;
  /** Reads and enables pagination through a set of `VwOrdersVisibilityListByOrganization`. */
  allVwOrdersVisibilityListByOrganizations?: Maybe<VwOrdersVisibilityListByOrganizationsConnection>;
  /** Reads and enables pagination through a set of `VwOrgTree`. */
  allVwOrgTrees?: Maybe<VwOrgTreesConnection>;
  /** Reads and enables pagination through a set of `VwOrgUnpivotPg`. */
  allVwOrgUnpivotPgs?: Maybe<VwOrgUnpivotPgsConnection>;
  /** Reads and enables pagination through a set of `VwPortNoticeChangelog`. */
  allVwPortNoticeChangelogs?: Maybe<VwPortNoticeChangelogsConnection>;
  /** Reads and enables pagination through a set of `VwSapOrdersIntegrationSummary`. */
  allVwSapOrdersIntegrationSummaries?: Maybe<VwSapOrdersIntegrationSummariesConnection>;
  /** Reads and enables pagination through a set of `VwSapOrdersIntegration`. */
  allVwSapOrdersIntegrations?: Maybe<VwSapOrdersIntegrationsConnection>;
  /** Reads and enables pagination through a set of `VwScheduledOrderShipOwnerOrdersPg`. */
  allVwScheduledOrderShipOwnerOrdersPgs?: Maybe<VwScheduledOrderShipOwnerOrdersPgsConnection>;
  /** Reads and enables pagination through a set of `VwSharedOrdersOnlySenderReceiverPg`. */
  allVwSharedOrdersOnlySenderReceiverPgs?: Maybe<VwSharedOrdersOnlySenderReceiverPgsConnection>;
  /** Reads and enables pagination through a set of `VwShipsByOrder`. */
  allVwShipsByOrders?: Maybe<VwShipsByOrdersConnection>;
  /** Reads and enables pagination through a set of `VwSpotOrdersPortAgentRelationPg`. */
  allVwSpotOrdersPortAgentRelationPgs?: Maybe<VwSpotOrdersPortAgentRelationPgsConnection>;
  /** Reads and enables pagination through a set of `VwStatementOfFactsChangelog`. */
  allVwStatementOfFactsChangelogs?: Maybe<VwStatementOfFactsChangelogsConnection>;
  /** Reads and enables pagination through a set of `VwUserNotifyByOrderPg`. */
  allVwUserNotifyByOrderPgs?: Maybe<VwUserNotifyByOrderPgsConnection>;
  /** Reads and enables pagination through a set of `VwVoyageCharterShipownerNonfinancial`. */
  allVwVoyageCharterShipownerNonfinancials?: Maybe<VwVoyageCharterShipownerNonfinancialsConnection>;
  /** Reads and enables pagination through a set of `WorldscaleFreight`. */
  allWorldscaleFreights?: Maybe<WorldscaleFreightsConnection>;
  /** Reads and enables pagination through a set of `ZoneLocation`. */
  allZoneLocations?: Maybe<ZoneLocationsConnection>;
  /** Reads and enables pagination through a set of `Zone`. */
  allZones?: Maybe<ZonesConnection>;
  /** Reads a single `ApiOrder` using its globally unique `ID`. */
  apiOrder?: Maybe<ApiOrder>;
  apiOrderByExternalOrderId?: Maybe<ApiOrder>;
  /** Reads a single `ApiOrdersNotice` using its globally unique `ID`. */
  apiOrdersNotice?: Maybe<ApiOrdersNotice>;
  apiOrdersNoticeById?: Maybe<ApiOrdersNotice>;
  /** Reads a single `Assortment` using its globally unique `ID`. */
  assortment?: Maybe<Assortment>;
  assortmentById?: Maybe<Assortment>;
  /** Reads a single `AssortmentExclusion` using its globally unique `ID`. */
  assortmentExclusion?: Maybe<AssortmentExclusion>;
  assortmentExclusionById?: Maybe<AssortmentExclusion>;
  /** Reads a single `AssortmentGroup` using its globally unique `ID`. */
  assortmentGroup?: Maybe<AssortmentGroup>;
  assortmentGroupById?: Maybe<AssortmentGroup>;
  /** Reads a single `BatchUpdate` using its globally unique `ID`. */
  batchUpdate?: Maybe<BatchUpdate>;
  batchUpdateById?: Maybe<BatchUpdate>;
  /** Reads a single `BillOfLading` using its globally unique `ID`. */
  billOfLading?: Maybe<BillOfLading>;
  billOfLadingById?: Maybe<BillOfLading>;
  /** Reads a single `BillOfLadingDatum` using its globally unique `ID`. */
  billOfLadingDatum?: Maybe<BillOfLadingDatum>;
  billOfLadingDatumById?: Maybe<BillOfLadingDatum>;
  bunkerEx?: Maybe<BunkerEx>;
  /** Reads a single `BunkerGradeCalculation` using its globally unique `ID`. */
  bunkerGradeCalculation?: Maybe<BunkerGradeCalculation>;
  bunkerGradeCalculationById?: Maybe<BunkerGradeCalculation>;
  bunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeId?: Maybe<BunkerGradeCalculation>;
  /** Reads a single `BunkerGradeMapping` using its globally unique `ID`. */
  bunkerGradeMapping?: Maybe<BunkerGradeMapping>;
  bunkerGradeMappingById?: Maybe<BunkerGradeMapping>;
  bunkerGradeMappingByOrganizationIdAndFromGradeId?: Maybe<BunkerGradeMapping>;
  /** Reads a single `BunkerGradeOverride` using its globally unique `ID`. */
  bunkerGradeOverride?: Maybe<BunkerGradeOverride>;
  bunkerGradeOverrideByGradeNameAndOrganizationId?: Maybe<BunkerGradeOverride>;
  bunkerGradeOverrideById?: Maybe<BunkerGradeOverride>;
  /** Reads a single `Bunkering` using its globally unique `ID`. */
  bunkering?: Maybe<Bunkering>;
  bunkeringById?: Maybe<Bunkering>;
  cachedExactRoutesByClusterPairs?: Maybe<Array<Maybe<ClusterRoute>>>;
  cachedExactRoutesByPortPairs?: Maybe<Array<Maybe<CachedRoute>>>;
  cachedRoutesByPortPairs?: Maybe<Array<Maybe<CachedRoute>>>;
  calculateRootOrg?: Maybe<CalculateRootOrgConnection>;
  calculateVoyages?: Maybe<Array<Maybe<VoyageCalculation>>>;
  /** Reads a single `CarbonPriceOverride` using its globally unique `ID`. */
  carbonPriceOverride?: Maybe<CarbonPriceOverride>;
  carbonPriceOverrideById?: Maybe<CarbonPriceOverride>;
  /** Reads a single `CargoCompartment` using its globally unique `ID`. */
  cargoCompartment?: Maybe<CargoCompartment>;
  /** Reads a single `CargoCompartmentAllocation` using its globally unique `ID`. */
  cargoCompartmentAllocation?: Maybe<CargoCompartmentAllocation>;
  cargoCompartmentAllocationById?: Maybe<CargoCompartmentAllocation>;
  cargoCompartmentById?: Maybe<CargoCompartment>;
  /** Reads a single `CargoEquipment` using its globally unique `ID`. */
  cargoEquipment?: Maybe<CargoEquipment>;
  cargoEquipmentById?: Maybe<CargoEquipment>;
  /** Reads a single `CargoExclusion` using its globally unique `ID`. */
  cargoExclusion?: Maybe<CargoExclusion>;
  cargoExclusionById?: Maybe<CargoExclusion>;
  /** Reads a single `CargoLengthUnit` using its globally unique `ID`. */
  cargoLengthUnit?: Maybe<CargoLengthUnit>;
  cargoLengthUnitById?: Maybe<CargoLengthUnit>;
  /** Reads a single `CargoMeasurement` using its globally unique `ID`. */
  cargoMeasurement?: Maybe<CargoMeasurement>;
  cargoMeasurementById?: Maybe<CargoMeasurement>;
  /** Reads a single `CargoUnit` using its globally unique `ID`. */
  cargoUnit?: Maybe<CargoUnit>;
  cargoUnitById?: Maybe<CargoUnit>;
  cargoUnitsConversionByExtraUnitName?: Maybe<CargoUnitsConversion>;
  /** Reads a single `CargoWeightUnit` using its globally unique `ID`. */
  cargoWeightUnit?: Maybe<CargoWeightUnit>;
  cargoWeightUnitById?: Maybe<CargoWeightUnit>;
  /** Reads a single `Channel` using its globally unique `ID`. */
  channel?: Maybe<Channel>;
  channelById?: Maybe<Channel>;
  /** Reads a single `ChannelCost` using its globally unique `ID`. */
  channelCost?: Maybe<ChannelCost>;
  channelCostById?: Maybe<ChannelCost>;
  /** Reads a single `ChannelCostEstimate` using its globally unique `ID`. */
  channelCostEstimate?: Maybe<ChannelCostEstimate>;
  channelCostEstimateById?: Maybe<ChannelCostEstimate>;
  /** Reads a single `ChannelIncompatibility` using its globally unique `ID`. */
  channelIncompatibility?: Maybe<ChannelIncompatibility>;
  channelIncompatibilityById?: Maybe<ChannelIncompatibility>;
  channelIncompatibilityByVesselAttributeIdAndChannelName?: Maybe<ChannelIncompatibility>;
  /** Reads a single `Chat` using its globally unique `ID`. */
  chat?: Maybe<Chat>;
  chatById?: Maybe<Chat>;
  checkWorkHourParts?: Maybe<Scalars['Boolean']['output']>;
  checkWorkHourPartsArray?: Maybe<Scalars['Boolean']['output']>;
  checkWorkhours?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `ClassSocietyAssociation` using its globally unique `ID`. */
  classSocietyAssociation?: Maybe<ClassSocietyAssociation>;
  classSocietyAssociationById?: Maybe<ClassSocietyAssociation>;
  /** Reads a single `ClassificationSociety` using its globally unique `ID`. */
  classificationSociety?: Maybe<ClassificationSociety>;
  classificationSocietyById?: Maybe<ClassificationSociety>;
  /** Reads a single `CoaContract` using its globally unique `ID`. */
  coaContract?: Maybe<CoaContract>;
  /** Reads a single `CoaContractAssortment` using its globally unique `ID`. */
  coaContractAssortment?: Maybe<CoaContractAssortment>;
  coaContractAssortmentById?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContractBunker` using its globally unique `ID`. */
  coaContractBunker?: Maybe<CoaContractBunker>;
  coaContractBunkerById?: Maybe<CoaContractBunker>;
  coaContractById?: Maybe<CoaContract>;
  /** Reads a single `CoaContractCommission` using its globally unique `ID`. */
  coaContractCommission?: Maybe<CoaContractCommission>;
  coaContractCommissionById?: Maybe<CoaContractCommission>;
  /** Reads a single `CoaContractDeviationCost` using its globally unique `ID`. */
  coaContractDeviationCost?: Maybe<CoaContractDeviationCost>;
  coaContractDeviationCostById?: Maybe<CoaContractDeviationCost>;
  /** Reads a single `CoaContractPort` using its globally unique `ID`. */
  coaContractPort?: Maybe<CoaContractPort>;
  coaContractPortByCoaContractIdAndOriginIdAndDestinationId?: Maybe<CoaContractPort>;
  coaContractPortById?: Maybe<CoaContractPort>;
  /** Reads a single `CoaContractPortCost` using its globally unique `ID`. */
  coaContractPortCost?: Maybe<CoaContractPortCost>;
  coaContractPortCostById?: Maybe<CoaContractPortCost>;
  coaContractPortCostByLocationIdAndShipId?: Maybe<CoaContractPortCost>;
  coaContractPortCostByLocationIdAndVesselTypeId?: Maybe<CoaContractPortCost>;
  /** Reads a single `CoaContractPortDatum` using its globally unique `ID`. */
  coaContractPortDatum?: Maybe<CoaContractPortDatum>;
  coaContractPortDatumById?: Maybe<CoaContractPortDatum>;
  /** Reads a single `CoaContractPrice` using its globally unique `ID`. */
  coaContractPrice?: Maybe<CoaContractPrice>;
  coaContractPriceById?: Maybe<CoaContractPrice>;
  /** Reads a single `CoaContractShip` using its globally unique `ID`. */
  coaContractShip?: Maybe<CoaContractShip>;
  coaContractShipByCoaContractIdAndShipId?: Maybe<CoaContractShip>;
  coaContractShipById?: Maybe<CoaContractShip>;
  /** Reads a single `Commission` using its globally unique `ID`. */
  commission?: Maybe<Commission>;
  commissionByExternalIdAndVoyageCharterId?: Maybe<Commission>;
  commissionById?: Maybe<Commission>;
  /** Reads a single `CommitLog` using its globally unique `ID`. */
  commitLog?: Maybe<CommitLog>;
  commitLogById?: Maybe<CommitLog>;
  /** Reads a single `CommitLogScenario` using its globally unique `ID`. */
  commitLogScenario?: Maybe<CommitLogScenario>;
  commitLogScenarioById?: Maybe<CommitLogScenario>;
  /** Reads a single `CostSplitOnScheduledOrder` using its globally unique `ID`. */
  costSplitOnScheduledOrder?: Maybe<CostSplitOnScheduledOrder>;
  costSplitOnScheduledOrderByActualCostIdAndScheduledOrderId?: Maybe<CostSplitOnScheduledOrder>;
  costSplitOnScheduledOrderById?: Maybe<CostSplitOnScheduledOrder>;
  /** Reads a single `CostSplitOnSingleEvent` using its globally unique `ID`. */
  costSplitOnSingleEvent?: Maybe<CostSplitOnSingleEvent>;
  costSplitOnSingleEventByActualCostIdAndSingleEventId?: Maybe<CostSplitOnSingleEvent>;
  costSplitOnSingleEventById?: Maybe<CostSplitOnSingleEvent>;
  /** Reads a single `Country` using its globally unique `ID`. */
  country?: Maybe<Country>;
  countryById?: Maybe<Country>;
  countryByNumeric?: Maybe<Country>;
  currentRootOrgId?: Maybe<Scalars['Int']['output']>;
  currentRootOrgOrNull?: Maybe<Scalars['Int']['output']>;
  currentUser?: Maybe<User>;
  currentUserIsSystemAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `DbChange` using its globally unique `ID`. */
  dbChange?: Maybe<DbChange>;
  dbChangeById?: Maybe<DbChange>;
  /** Reads a single `Demand` using its globally unique `ID`. */
  demand?: Maybe<Demand>;
  demandById?: Maybe<Demand>;
  /** Reads a single `EmailToOrderConfig` using its globally unique `ID`. */
  emailToOrderConfig?: Maybe<EmailToOrderConfig>;
  emailToOrderConfigById?: Maybe<EmailToOrderConfig>;
  /** Reads a single `EmailToOrderLog` using its globally unique `ID`. */
  emailToOrderLog?: Maybe<EmailToOrderLog>;
  emailToOrderLogById?: Maybe<EmailToOrderLog>;
  externalPortCostPredictions: Array<Maybe<ExternalPortCostPredictionsResult>>;
  /** Reads a single `Feature` using its globally unique `ID`. */
  feature?: Maybe<Feature>;
  featureByFeatureName?: Maybe<Feature>;
  /** Reads a single `File` using its globally unique `ID`. */
  file?: Maybe<File>;
  fileById?: Maybe<File>;
  /** Reads a single `GeographicalEntity` using its globally unique `ID`. */
  geographicalEntity?: Maybe<GeographicalEntity>;
  geographicalEntityById?: Maybe<GeographicalEntity>;
  /** Reads a single `GeographicalRelation` using its globally unique `ID`. */
  geographicalRelation?: Maybe<GeographicalRelation>;
  geographicalRelationById?: Maybe<GeographicalRelation>;
  /** Return all descendants of org */
  getChildOrgs?: Maybe<GetChildOrgsConnection>;
  getLatestSAP: Scalars['JSON']['output'];
  /** Return all ancestors of child org */
  getOrgHierarchy?: Maybe<GetOrgHierarchyConnection>;
  /** Return org tree, i.e. find root and all its descendants */
  getOrgTree?: Maybe<GetOrgTreeConnection>;
  getRaptorDraft?: Maybe<RaptorDraft>;
  /** Return root org, i.e. top most ancestor of child org */
  getRootOrg?: Maybe<GetRootOrgConnection>;
  getVesonBunker?: Maybe<GetVesonBunkerResult>;
  getVesonPnl?: Maybe<GetVesonPnlResult>;
  /** Reads a single `HandledByCoa` using its globally unique `ID`. */
  handledByCoa?: Maybe<HandledByCoa>;
  handledByCoaById?: Maybe<HandledByCoa>;
  handledByCoaByOrderId?: Maybe<HandledByCoa>;
  /** Reads a single `HandledBySpot` using its globally unique `ID`. */
  handledBySpot?: Maybe<HandledBySpot>;
  handledBySpotById?: Maybe<HandledBySpot>;
  handledBySpotByOrderId?: Maybe<HandledBySpot>;
  /** Returns true for port agents matching contracts */
  hasContractForPortAgent?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true for senders or receivers matching contracts */
  hasContractForSendersReceivers?: Maybe<Scalars['Boolean']['output']>;
  hasRightToAccessBillOfLadingFromAnyOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToAccessCargoMeasurementFromAnyOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToAccessFinancesInAnyOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToAccessFinancesInOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToMutateBillOfLadingInAnyOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToMutateCargoMeasurementInAnyOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToMutateContractsInOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToMutateOrdersInAnyOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToMutatePortCalls?: Maybe<Scalars['Boolean']['output']>;
  hasRightToMutatePortCallsInAnyOrg?: Maybe<Scalars['Boolean']['output']>;
  hasRightToMutateVoyagesInOrg?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Holiday` using its globally unique `ID`. */
  holiday?: Maybe<Holiday>;
  holidayById?: Maybe<Holiday>;
  /** Reads a single `IceClass` using its globally unique `ID`. */
  iceClass?: Maybe<IceClass>;
  iceClassById?: Maybe<IceClass>;
  /** Reads a single `Instruction` using its globally unique `ID`. */
  instruction?: Maybe<Instruction>;
  instructionById?: Maybe<Instruction>;
  /** Reads a single `IntegrationLog` using its globally unique `ID`. */
  integrationLog?: Maybe<IntegrationLog>;
  integrationLogById?: Maybe<IntegrationLog>;
  /** Reads a single `Invoice` using its globally unique `ID`. */
  invoice?: Maybe<Invoice>;
  invoiceById?: Maybe<Invoice>;
  /** Reads a single `InvoiceItem` using its globally unique `ID`. */
  invoiceItem?: Maybe<InvoiceItem>;
  invoiceItemById?: Maybe<InvoiceItem>;
  /** Reads a single `InvoiceItemOrder` using its globally unique `ID`. */
  invoiceItemOrder?: Maybe<InvoiceItemOrder>;
  invoiceItemOrderById?: Maybe<InvoiceItemOrder>;
  isAnyOrgInSessionOrgChildren?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if any provided organizarion is in the current session tree */
  isAnyOrgInSessionOrgTree?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if organization is a children organization */
  isOrgInSessionOrgChildren?: Maybe<Scalars['Boolean']['output']>;
  isOrgInSessionOrgTree?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true for orgs that are port agent */
  isOrgPortAgentInSessionOrgTree?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true for orgs that are root or charterer */
  isOrgRootChartererInSessionOrgTree?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true for orgs that are senders or receivers */
  isOrgSenderReceiverInSessionOrgTree?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true for orgs that are ship owner */
  isOrgShipOwnerInSessionOrgTree?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `LaytimeResponsibility` using its globally unique `ID`. */
  laytimeResponsibility?: Maybe<LaytimeResponsibility>;
  laytimeResponsibilityById?: Maybe<LaytimeResponsibility>;
  /** Reads a single `Location` using its globally unique `ID`. */
  location?: Maybe<Location>;
  locationById?: Maybe<Location>;
  /** Reads a single `LocationCluster` using its globally unique `ID`. */
  locationCluster?: Maybe<LocationCluster>;
  locationClusterById?: Maybe<LocationCluster>;
  /** Reads a single `LocationRequirementAssociation` using its globally unique `ID`. */
  locationRequirementAssociation?: Maybe<LocationRequirementAssociation>;
  locationRequirementAssociationById?: Maybe<LocationRequirementAssociation>;
  locationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneId?: Maybe<LocationRequirementAssociation>;
  /** Reads a single `LocationWorkingHour` using its globally unique `ID`. */
  locationWorkingHour?: Maybe<LocationWorkingHour>;
  locationWorkingHourById?: Maybe<LocationWorkingHour>;
  /** Reads a single `LostContract` using its globally unique `ID`. */
  lostContract?: Maybe<LostContract>;
  lostContractById?: Maybe<LostContract>;
  marcuraCachedPortCosts?: Maybe<Array<Maybe<MarcuraPortCost>>>;
  /** Reads a single `Migration` using its globally unique `ID`. */
  migration?: Maybe<Migration>;
  migrationById?: Maybe<Migration>;
  myMail?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Ship`. */
  myShips?: Maybe<ShipsConnection>;
  /** Reads a single `NoGoZone` using its globally unique `ID`. */
  noGoZone?: Maybe<NoGoZone>;
  noGoZoneById?: Maybe<NoGoZone>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  notificationReceiverById?: Maybe<NotificationReceiver>;
  /** Reads a single `OffHire` using its globally unique `ID`. */
  offHire?: Maybe<OffHire>;
  offHireById?: Maybe<OffHire>;
  /** Reads a single `OpenPosition` using its globally unique `ID`. */
  openPosition?: Maybe<OpenPosition>;
  openPositionById?: Maybe<OpenPosition>;
  /** Reads a single `Order` using its globally unique `ID`. */
  order?: Maybe<Order>;
  /** Reads a single `OrderAttribute` using its globally unique `ID`. */
  orderAttribute?: Maybe<OrderAttribute>;
  /** Reads a single `OrderAttributeAssociation` using its globally unique `ID`. */
  orderAttributeAssociation?: Maybe<OrderAttributeAssociation>;
  orderAttributeAssociationById?: Maybe<OrderAttributeAssociation>;
  orderAttributeById?: Maybe<OrderAttribute>;
  orderById?: Maybe<Order>;
  /** Reads a single `OrderDetail` using its globally unique `ID`. */
  orderDetail?: Maybe<OrderDetail>;
  orderDetailById?: Maybe<OrderDetail>;
  /** Reads a single `OrderPortCallRelation` using its globally unique `ID`. */
  orderPortCallRelation?: Maybe<OrderPortCallRelation>;
  orderPortCallRelationById?: Maybe<OrderPortCallRelation>;
  orderPortCallRelationByOrderIdAndIsLoadPort?: Maybe<OrderPortCallRelation>;
  /** Reads a single `OrderPortOverride` using its globally unique `ID`. */
  orderPortOverride?: Maybe<OrderPortOverride>;
  orderPortOverrideByOrderId?: Maybe<OrderPortOverride>;
  /** Reads a single `OrderRequirementAssociation` using its globally unique `ID`. */
  orderRequirementAssociation?: Maybe<OrderRequirementAssociation>;
  orderRequirementAssociationById?: Maybe<OrderRequirementAssociation>;
  orderRequirementAssociationBySpecialRequirementIdAndOrderId?: Maybe<OrderRequirementAssociation>;
  /** Reads a single `OrderVoyageCharterRelation` using its globally unique `ID`. */
  orderVoyageCharterRelation?: Maybe<OrderVoyageCharterRelation>;
  orderVoyageCharterRelationById?: Maybe<OrderVoyageCharterRelation>;
  orderVoyageCharterRelationByOrderIdAndOutgoing?: Maybe<OrderVoyageCharterRelation>;
  ordersRelatedOrgsArr?: Maybe<OrdersRelatedOrgsArrConnection>;
  orgRouteOverridesByPortPairs?: Maybe<Array<Maybe<RouteOverride>>>;
  /** Reads a single `Organization` using its globally unique `ID`. */
  organization?: Maybe<Organization>;
  /** Reads a single `OrganizationAreaBunkerGradeMapping` using its globally unique `ID`. */
  organizationAreaBunkerGradeMapping?: Maybe<OrganizationAreaBunkerGradeMapping>;
  organizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea?: Maybe<OrganizationAreaBunkerGradeMapping>;
  organizationById?: Maybe<Organization>;
  /** Reads a single `OrganizationFeature` using its globally unique `ID`. */
  organizationFeature?: Maybe<OrganizationFeature>;
  organizationFeatureById?: Maybe<OrganizationFeature>;
  orgsCurrentUserCanAdmin?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  orgsWithRightToAccessFinances?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Reads a single `PortActivity` using its globally unique `ID`. */
  portActivity?: Maybe<PortActivity>;
  portActivityById?: Maybe<PortActivity>;
  /** Reads a single `PortCall` using its globally unique `ID`. */
  portCall?: Maybe<PortCall>;
  portCallById?: Maybe<PortCall>;
  /** Reads a single `PortCallExternalTimestamp` using its globally unique `ID`. */
  portCallExternalTimestamp?: Maybe<PortCallExternalTimestamp>;
  portCallExternalTimestampById?: Maybe<PortCallExternalTimestamp>;
  /** Reads a single `PortCallFile` using its globally unique `ID`. */
  portCallFile?: Maybe<PortCallFile>;
  portCallFileByFileId?: Maybe<PortCallFile>;
  portCallFileById?: Maybe<PortCallFile>;
  /** Reads a single `PortCommodityLdRate` using its globally unique `ID`. */
  portCommodityLdRate?: Maybe<PortCommodityLdRate>;
  portCommodityLdRateById?: Maybe<PortCommodityLdRate>;
  /** Reads a single `PortCost` using its globally unique `ID`. */
  portCost?: Maybe<PortCost>;
  portCostById?: Maybe<PortCost>;
  /** Reads a single `PortCostDefault` using its globally unique `ID`. */
  portCostDefault?: Maybe<PortCostDefault>;
  portCostDefaultById?: Maybe<PortCostDefault>;
  portCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrency?: Maybe<PortCostDefault>;
  /** Reads a single `PortCostEstimatesExternal` using its globally unique `ID`. */
  portCostEstimatesExternal?: Maybe<PortCostEstimatesExternal>;
  portCostEstimatesExternalById?: Maybe<PortCostEstimatesExternal>;
  /** Reads a single `PortDatum` using its globally unique `ID`. */
  portDatum?: Maybe<PortDatum>;
  portDatumById?: Maybe<PortDatum>;
  /** Reads a single `PortNotice` using its globally unique `ID`. */
  portNotice?: Maybe<PortNotice>;
  portNoticeById?: Maybe<PortNotice>;
  /** Reads a single `PortRegion` using its globally unique `ID`. */
  portRegion?: Maybe<PortRegion>;
  portRegionById?: Maybe<PortRegion>;
  portRegionByLocationIdAndRegionIdAndOrganizationId?: Maybe<PortRegion>;
  /** Reads a single `Prompt` using its globally unique `ID`. */
  prompt?: Maybe<Prompt>;
  promptById?: Maybe<Prompt>;
  /** Reads a single `Quay` using its globally unique `ID`. */
  quay?: Maybe<Quay>;
  quayById?: Maybe<Quay>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `ReceiverOrganization` using its globally unique `ID`. */
  receiverOrganization?: Maybe<ReceiverOrganization>;
  receiverOrganizationByAdminOrganizationIdAndOrganizationId?: Maybe<ReceiverOrganization>;
  receiverOrganizationById?: Maybe<ReceiverOrganization>;
  /** Reads a single `Region` using its globally unique `ID`. */
  region?: Maybe<Region>;
  regionById?: Maybe<Region>;
  /** Reads a single `RequestLog` using its globally unique `ID`. */
  requestLog?: Maybe<RequestLog>;
  requestLogById?: Maybe<RequestLog>;
  /** Reads a single `Route` using its globally unique `ID`. */
  route?: Maybe<Route>;
  routeByClusterPair?: Maybe<Scalars['JSON']['output']>;
  routeByDraftAndCoordinatesAndAvoidsChannels?: Maybe<Route>;
  routeByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZones?: Maybe<Route>;
  routeById?: Maybe<Route>;
  routeByPortPair?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `RouteOverride` using its globally unique `ID`. */
  routeOverride?: Maybe<RouteOverride>;
  routeOverrideById?: Maybe<RouteOverride>;
  routeOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannels?: Maybe<RouteOverride>;
  routeOverridesByPortPairs?: Maybe<Array<Maybe<RouteOverride>>>;
  /** Reads a single `RoutePoint` using its globally unique `ID`. */
  routePoint?: Maybe<RoutePoint>;
  routePointById?: Maybe<RoutePoint>;
  /** Reads a single `RoutePointUsage` using its globally unique `ID`. */
  routePointUsage?: Maybe<RoutePointUsage>;
  routePointUsageById?: Maybe<RoutePointUsage>;
  routesByClusterPairs?: Maybe<Array<Maybe<ClusterRoute>>>;
  routesByPortPairs?: Maybe<Array<Maybe<CachedRoute>>>;
  /** Reads a single `Scenario` using its globally unique `ID`. */
  scenario?: Maybe<Scenario>;
  scenarioById?: Maybe<Scenario>;
  /** Reads a single `ScheduledOrder` using its globally unique `ID`. */
  scheduledOrder?: Maybe<ScheduledOrder>;
  scheduledOrderById?: Maybe<ScheduledOrder>;
  /** Reads and enables pagination through a set of `Location`. */
  searchLocations?: Maybe<LocationsConnection>;
  /** Reads a single `SeenMessage` using its globally unique `ID`. */
  seenMessage?: Maybe<SeenMessage>;
  seenMessageById?: Maybe<SeenMessage>;
  /** Reads a single `SenderOrganization` using its globally unique `ID`. */
  senderOrganization?: Maybe<SenderOrganization>;
  senderOrganizationByAdminOrganizationIdAndOrganizationId?: Maybe<SenderOrganization>;
  senderOrganizationById?: Maybe<SenderOrganization>;
  sessionOrgTree?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Reads a single `Ship` using its globally unique `ID`. */
  ship?: Maybe<Ship>;
  shipById?: Maybe<Ship>;
  /** Reads a single `ShipVoyageNamingRuleRelation` using its globally unique `ID`. */
  shipVoyageNamingRuleRelation?: Maybe<ShipVoyageNamingRuleRelation>;
  shipVoyageNamingRuleRelationById?: Maybe<ShipVoyageNamingRuleRelation>;
  /** Reads a single `Shipment` using its globally unique `ID`. */
  shipment?: Maybe<Shipment>;
  shipmentById?: Maybe<Shipment>;
  /** Reads a single `ShipmentExternalStatus` using its globally unique `ID`. */
  shipmentExternalStatus?: Maybe<ShipmentExternalStatus>;
  shipmentExternalStatusById?: Maybe<ShipmentExternalStatus>;
  /** Reads a single `ShipmentExtraFreight` using its globally unique `ID`. */
  shipmentExtraFreight?: Maybe<ShipmentExtraFreight>;
  shipmentExtraFreightById?: Maybe<ShipmentExtraFreight>;
  /** Reads a single `ShipmentFreight` using its globally unique `ID`. */
  shipmentFreight?: Maybe<ShipmentFreight>;
  shipmentFreightById?: Maybe<ShipmentFreight>;
  shipmentFreightByShipmentId?: Maybe<ShipmentFreight>;
  /** Reads a single `ShipmentGroup` using its globally unique `ID`. */
  shipmentGroup?: Maybe<ShipmentGroup>;
  /** Reads a single `ShipmentGroupAssociation` using its globally unique `ID`. */
  shipmentGroupAssociation?: Maybe<ShipmentGroupAssociation>;
  shipmentGroupAssociationById?: Maybe<ShipmentGroupAssociation>;
  shipmentGroupById?: Maybe<ShipmentGroup>;
  /** Reads a single `SingleEvent` using its globally unique `ID`. */
  singleEvent?: Maybe<SingleEvent>;
  singleEventById?: Maybe<SingleEvent>;
  /** Reads a single `SingleEventPortCallRelation` using its globally unique `ID`. */
  singleEventPortCallRelation?: Maybe<SingleEventPortCallRelation>;
  singleEventPortCallRelationById?: Maybe<SingleEventPortCallRelation>;
  /** Reads a single `SpecialRequirement` using its globally unique `ID`. */
  specialRequirement?: Maybe<SpecialRequirement>;
  specialRequirementById?: Maybe<SpecialRequirement>;
  /** Reads a single `SplitOrder` using its globally unique `ID`. */
  splitOrder?: Maybe<SplitOrder>;
  splitOrderById?: Maybe<SplitOrder>;
  /** Reads a single `SpotNegotiation` using its globally unique `ID`. */
  spotNegotiation?: Maybe<SpotNegotiation>;
  spotNegotiationById?: Maybe<SpotNegotiation>;
  /** Reads a single `StatementOfFact` using its globally unique `ID`. */
  statementOfFact?: Maybe<StatementOfFact>;
  statementOfFactById?: Maybe<StatementOfFact>;
  /** Reads a single `Supply` using its globally unique `ID`. */
  supply?: Maybe<Supply>;
  supplyById?: Maybe<Supply>;
  /** Reads a single `SupplyContract` using its globally unique `ID`. */
  supplyContract?: Maybe<SupplyContract>;
  supplyContractById?: Maybe<SupplyContract>;
  /** Reads a single `TankDistance` using its globally unique `ID`. */
  tankDistance?: Maybe<TankDistance>;
  tankDistanceById?: Maybe<TankDistance>;
  /** Reads a single `TcContract` using its globally unique `ID`. */
  tcContract?: Maybe<TcContract>;
  tcContractById?: Maybe<TcContract>;
  tcContractByRootOrgAndExternalId?: Maybe<TcContract>;
  /** Reads a single `User` using its globally unique `ID`. */
  user?: Maybe<User>;
  userById?: Maybe<User>;
  /** Reads a single `UserRegion` using its globally unique `ID`. */
  userRegion?: Maybe<UserRegion>;
  userRegionById?: Maybe<UserRegion>;
  /** Reads a single `UserRight` using its globally unique `ID`. */
  userRight?: Maybe<UserRight>;
  userRightById?: Maybe<UserRight>;
  userRightByUserIdAndOrganizationId?: Maybe<UserRight>;
  /** Reads a single `UserSetting` using its globally unique `ID`. */
  userSetting?: Maybe<UserSetting>;
  userSettingById?: Maybe<UserSetting>;
  /** Reads a single `UserShip` using its globally unique `ID`. */
  userShip?: Maybe<UserShip>;
  userShipById?: Maybe<UserShip>;
  /** Reads a single `VesselAttribute` using its globally unique `ID`. */
  vesselAttribute?: Maybe<VesselAttribute>;
  /** Reads a single `VesselAttributeAssortmentExclusion` using its globally unique `ID`. */
  vesselAttributeAssortmentExclusion?: Maybe<VesselAttributeAssortmentExclusion>;
  vesselAttributeAssortmentExclusionById?: Maybe<VesselAttributeAssortmentExclusion>;
  vesselAttributeById?: Maybe<VesselAttribute>;
  vesselAttributeByOrganizationIdAndName?: Maybe<VesselAttribute>;
  /** Reads a single `VesselAttributesAssociation` using its globally unique `ID`. */
  vesselAttributesAssociation?: Maybe<VesselAttributesAssociation>;
  vesselAttributesAssociationById?: Maybe<VesselAttributesAssociation>;
  /** Reads a single `VesselDraftDatapoint` using its globally unique `ID`. */
  vesselDraftDatapoint?: Maybe<VesselDraftDatapoint>;
  vesselDraftDatapointById?: Maybe<VesselDraftDatapoint>;
  /** Reads a single `VesselFulfillsRequirementAssociation` using its globally unique `ID`. */
  vesselFulfillsRequirementAssociation?: Maybe<VesselFulfillsRequirementAssociation>;
  vesselFulfillsRequirementAssociationById?: Maybe<VesselFulfillsRequirementAssociation>;
  /** Reads a single `VesselInfo` using its globally unique `ID`. */
  vesselInfo?: Maybe<VesselInfo>;
  vesselInfoById?: Maybe<VesselInfo>;
  vesselInfoByImo?: Maybe<VesselInfo>;
  /** Reads a single `VesselPerformanceModel` using its globally unique `ID`. */
  vesselPerformanceModel?: Maybe<VesselPerformanceModel>;
  vesselPerformanceModelById?: Maybe<VesselPerformanceModel>;
  vesselPerformanceModelByRootOrgAndShipId?: Maybe<VesselPerformanceModel>;
  /** Reads a single `VesselReservation` using its globally unique `ID`. */
  vesselReservation?: Maybe<VesselReservation>;
  vesselReservationById?: Maybe<VesselReservation>;
  /** Reads a single `VesselScheduleSharedToOrganization` using its globally unique `ID`. */
  vesselScheduleSharedToOrganization?: Maybe<VesselScheduleSharedToOrganization>;
  vesselScheduleSharedToOrganizationById?: Maybe<VesselScheduleSharedToOrganization>;
  vesselScheduleSharedToOrganizationByVesselIdAndOrganizationId?: Maybe<VesselScheduleSharedToOrganization>;
  /** Reads a single `VesselSecret` using its globally unique `ID`. */
  vesselSecret?: Maybe<VesselSecret>;
  vesselSecretById?: Maybe<VesselSecret>;
  /** Reads a single `VesselSpeedConsumption` using its globally unique `ID`. */
  vesselSpeedConsumption?: Maybe<VesselSpeedConsumption>;
  vesselSpeedConsumptionById?: Maybe<VesselSpeedConsumption>;
  /** Reads a single `Voyage` using its globally unique `ID`. */
  voyage?: Maybe<Voyage>;
  /** Reads a single `VoyageAssociation` using its globally unique `ID`. */
  voyageAssociation?: Maybe<VoyageAssociation>;
  voyageAssociationById?: Maybe<VoyageAssociation>;
  /** Reads a single `VoyageAttribute` using its globally unique `ID`. */
  voyageAttribute?: Maybe<VoyageAttribute>;
  voyageAttributeById?: Maybe<VoyageAttribute>;
  voyageAttributeByOrganizationIdAndNameAndColor?: Maybe<VoyageAttribute>;
  voyageById?: Maybe<Voyage>;
  /** Reads a single `VoyageCharter` using its globally unique `ID`. */
  voyageCharter?: Maybe<VoyageCharter>;
  voyageCharterById?: Maybe<VoyageCharter>;
  voyageCharterByRootOrgAndExternalId?: Maybe<VoyageCharter>;
  voyageCharterByRootOrgAndName?: Maybe<VoyageCharter>;
  /** Reads a single `VoyageCharterExtraCost` using its globally unique `ID`. */
  voyageCharterExtraCost?: Maybe<VoyageCharterExtraCost>;
  voyageCharterExtraCostById?: Maybe<VoyageCharterExtraCost>;
  /** Reads a single `VoyageCharterExtraFreight` using its globally unique `ID`. */
  voyageCharterExtraFreight?: Maybe<VoyageCharterExtraFreight>;
  voyageCharterExtraFreightById?: Maybe<VoyageCharterExtraFreight>;
  /** Reads a single `VoyageCharterOrderFreight` using its globally unique `ID`. */
  voyageCharterOrderFreight?: Maybe<VoyageCharterOrderFreight>;
  voyageCharterOrderFreightById?: Maybe<VoyageCharterOrderFreight>;
  /** Reads a single `VoyageCharterPortCost` using its globally unique `ID`. */
  voyageCharterPortCost?: Maybe<VoyageCharterPortCost>;
  voyageCharterPortCostById?: Maybe<VoyageCharterPortCost>;
  /** Reads a single `VoyageCharterPortDatum` using its globally unique `ID`. */
  voyageCharterPortDatum?: Maybe<VoyageCharterPortDatum>;
  voyageCharterPortDatumById?: Maybe<VoyageCharterPortDatum>;
  /** Reads a single `VoyageCharterToContract` using its globally unique `ID`. */
  voyageCharterToContract?: Maybe<VoyageCharterToContract>;
  voyageCharterToContractById?: Maybe<VoyageCharterToContract>;
  /** Reads a single `VoyageCharterUpdate` using its globally unique `ID`. */
  voyageCharterUpdate?: Maybe<VoyageCharterUpdate>;
  voyageCharterUpdateById?: Maybe<VoyageCharterUpdate>;
  /** Reads a single `VoyageNamingRule` using its globally unique `ID`. */
  voyageNamingRule?: Maybe<VoyageNamingRule>;
  voyageNamingRuleById?: Maybe<VoyageNamingRule>;
  /** Reads a single `WorldscaleFreight` using its globally unique `ID`. */
  worldscaleFreight?: Maybe<WorldscaleFreight>;
  worldscaleFreightById?: Maybe<WorldscaleFreight>;
  worldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYear?: Maybe<WorldscaleFreight>;
  /** Reads a single `Zone` using its globally unique `ID`. */
  zone?: Maybe<Zone>;
  zoneById?: Maybe<Zone>;
  /** Reads a single `ZoneLocation` using its globally unique `ID`. */
  zoneLocation?: Maybe<ZoneLocation>;
  zoneLocationById?: Maybe<ZoneLocation>;
  zoneLocationByZoneIdAndLocationId?: Maybe<ZoneLocation>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetBerthPredictionsArgs = {
  query: Array<BerthPredictionInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActualCostArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActualCostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllActualCostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActualCostCondition>;
  filter?: InputMaybe<ActualCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActualCostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApiCoaContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiCoaContractCondition>;
  filter?: InputMaybe<ApiCoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiCoaContractsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApiLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiLocationCondition>;
  filter?: InputMaybe<ApiLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiLocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApiOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiOrderCondition>;
  filter?: InputMaybe<ApiOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApiOrdersNoticesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiOrdersNoticeCondition>;
  filter?: InputMaybe<ApiOrdersNoticeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiOrdersNoticesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApiScheduledOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiScheduledOrderCondition>;
  filter?: InputMaybe<ApiScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiScheduledOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApiShipmentStatusesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiShipmentStatusCondition>;
  filter?: InputMaybe<ApiShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiShipmentStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllApiShipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ApiShipCondition>;
  filter?: InputMaybe<ApiShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiShipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAssortmentExclusionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentExclusionCondition>;
  filter?: InputMaybe<AssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAssortmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentGroupCondition>;
  filter?: InputMaybe<AssortmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAssortmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentCondition>;
  filter?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBatchUpdatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BatchUpdateCondition>;
  filter?: InputMaybe<BatchUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchUpdatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBillOfLadingDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillOfLadingDatumCondition>;
  filter?: InputMaybe<BillOfLadingDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOfLadingDataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBillOfLadingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillOfLadingCondition>;
  filter?: InputMaybe<BillOfLadingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOfLadingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBunkerGradeCalculationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeCalculationCondition>;
  filter?: InputMaybe<BunkerGradeCalculationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeCalculationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBunkerGradeMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeMappingCondition>;
  filter?: InputMaybe<BunkerGradeMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBunkerGradeOverrideHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeOverrideHistoryCondition>;
  filter?: InputMaybe<BunkerGradeOverrideHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeOverrideHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBunkerGradeOverridesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeOverrideCondition>;
  filter?: InputMaybe<BunkerGradeOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBunkeringsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkeringCondition>;
  filter?: InputMaybe<BunkeringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkeringsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCarbonPriceOverridesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CarbonPriceOverrideCondition>;
  filter?: InputMaybe<CarbonPriceOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CarbonPriceOverridesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoCompartmentAllocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentAllocationCondition>;
  filter?: InputMaybe<CargoCompartmentAllocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoCompartmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentCondition>;
  filter?: InputMaybe<CargoCompartmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoEquipmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoEquipmentCondition>;
  filter?: InputMaybe<CargoEquipmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoEquipmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoExclusionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoExclusionCondition>;
  filter?: InputMaybe<CargoExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoExclusionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoLengthUnitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoLengthUnitCondition>;
  filter?: InputMaybe<CargoLengthUnitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoLengthUnitsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoMeasurementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoMeasurementCondition>;
  filter?: InputMaybe<CargoMeasurementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoMeasurementsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoUnitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoUnitCondition>;
  filter?: InputMaybe<CargoUnitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoUnitsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoUnitsConversionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoUnitsConversionCondition>;
  filter?: InputMaybe<CargoUnitsConversionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoUnitsConversionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCargoWeightUnitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoWeightUnitCondition>;
  filter?: InputMaybe<CargoWeightUnitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoWeightUnitsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllChannelCostEstimatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostEstimateCondition>;
  filter?: InputMaybe<ChannelCostEstimateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllChannelCostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostCondition>;
  filter?: InputMaybe<ChannelCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllChannelIncompatibilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelIncompatibilityCondition>;
  filter?: InputMaybe<ChannelIncompatibilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelIncompatibilitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllChannelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCondition>;
  filter?: InputMaybe<ChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllChatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChatCondition>;
  filter?: InputMaybe<ChatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllClassSocietyAssociationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassSocietyAssociationCondition>;
  filter?: InputMaybe<ClassSocietyAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassSocietyAssociationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllClassificationSocietiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClassificationSocietyCondition>;
  filter?: InputMaybe<ClassificationSocietyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClassificationSocietiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractAssortmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractAssortmentCondition>;
  filter?: InputMaybe<CoaContractAssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractAssortmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractBunkersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractBunkerCondition>;
  filter?: InputMaybe<CoaContractBunkerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractBunkersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractCommissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCommissionCondition>;
  filter?: InputMaybe<CoaContractCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractCommissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractDeviationCostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractDeviationCostCondition>;
  filter?: InputMaybe<CoaContractDeviationCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractPortCostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCostCondition>;
  filter?: InputMaybe<CoaContractPortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortCostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractPortDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortDatumCondition>;
  filter?: InputMaybe<CoaContractPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortDataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractPortsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractPricesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPriceCondition>;
  filter?: InputMaybe<CoaContractPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractShipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractShipCondition>;
  filter?: InputMaybe<CoaContractShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractShipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCoaContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCondition>;
  filter?: InputMaybe<CoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCommissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommissionCondition>;
  filter?: InputMaybe<CommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCommitLogHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogHistoryCondition>;
  filter?: InputMaybe<CommitLogHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCommitLogScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogScenarioCondition>;
  filter?: InputMaybe<CommitLogScenarioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogScenariosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCommitLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogCondition>;
  filter?: InputMaybe<CommitLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCostSplitOnScheduledOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CostSplitOnScheduledOrderCondition>;
  filter?: InputMaybe<CostSplitOnScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CostSplitOnScheduledOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCostSplitOnSingleEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CostSplitOnSingleEventCondition>;
  filter?: InputMaybe<CostSplitOnSingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CostSplitOnSingleEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CountryCondition>;
  filter?: InputMaybe<CountryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCurrentOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CurrentOrganizationCondition>;
  filter?: InputMaybe<CurrentOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CurrentOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDbChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DbChangeCondition>;
  filter?: InputMaybe<DbChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbChangesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDemandsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEmailToOrderConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailToOrderConfigCondition>;
  filter?: InputMaybe<EmailToOrderConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailToOrderConfigsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEmailToOrderLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailToOrderLogCondition>;
  filter?: InputMaybe<EmailToOrderLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailToOrderLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFeaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FeatureCondition>;
  filter?: InputMaybe<FeatureFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGeographicalEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GeographicalEntityCondition>;
  filter?: InputMaybe<GeographicalEntityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeographicalEntitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllGeographicalRelationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GeographicalRelationCondition>;
  filter?: InputMaybe<GeographicalRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeographicalRelationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllHandledByCoaHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaHistoryCondition>;
  filter?: InputMaybe<HandledByCoaHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoaHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllHandledByCoasArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaCondition>;
  filter?: InputMaybe<HandledByCoaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllHandledBySpotHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotHistoryCondition>;
  filter?: InputMaybe<HandledBySpotHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllHandledBySpotsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotCondition>;
  filter?: InputMaybe<HandledBySpotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllHolidaysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HolidayCondition>;
  filter?: InputMaybe<HolidayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HolidaysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIceClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IceClassCondition>;
  filter?: InputMaybe<IceClassFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IceClassesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInstructionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InstructionCondition>;
  filter?: InputMaybe<InstructionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InstructionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIntegrationLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IntegrationLogCondition>;
  filter?: InputMaybe<IntegrationLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInvoiceItemOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceItemOrderCondition>;
  filter?: InputMaybe<InvoiceItemOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoiceItemOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInvoiceItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceItemCondition>;
  filter?: InputMaybe<InvoiceItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoiceItemsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllInvoicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceCondition>;
  filter?: InputMaybe<InvoiceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLatestPortCostByPortAndPrimaryAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LatestPortCostByPortAndPrimaryAttributeCondition>;
  filter?: InputMaybe<LatestPortCostByPortAndPrimaryAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LatestPortCostByPortAndPrimaryAttributesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLaytimeResponsibilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LaytimeResponsibilityCondition>;
  filter?: InputMaybe<LaytimeResponsibilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LaytimeResponsibilitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLocationClustersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationClusterCondition>;
  filter?: InputMaybe<LocationClusterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationClustersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLocationRequirementAssociationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationRequirementAssociationCondition>;
  filter?: InputMaybe<LocationRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLocationWorkingHoursArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationWorkingHourCondition>;
  filter?: InputMaybe<LocationWorkingHourFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationWorkingHoursOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLostContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LostContractCondition>;
  filter?: InputMaybe<LostContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LostContractsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMvLatestPortCostByPortAndPrimaryAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MvLatestPortCostByPortAndPrimaryAttributeCondition>;
  filter?: InputMaybe<MvLatestPortCostByPortAndPrimaryAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MvLatestPortCostByPortAndPrimaryAttributesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMvPortCostsByPortAndPrimaryAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MvPortCostsByPortAndPrimaryAttributeCondition>;
  filter?: InputMaybe<MvPortCostsByPortAndPrimaryAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MvPortCostsByPortAndPrimaryAttributesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMvPortCostsByPortAndVesselNamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MvPortCostsByPortAndVesselNameCondition>;
  filter?: InputMaybe<MvPortCostsByPortAndVesselNameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MvPortCostsByPortAndVesselNamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNoGoZonesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NoGoZoneCondition>;
  filter?: InputMaybe<NoGoZoneFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NoGoZonesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNotificationReceiversArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationReceiverCondition>;
  filter?: InputMaybe<NotificationReceiverFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOffHireHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireHistoryCondition>;
  filter?: InputMaybe<OffHireHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHireHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOffHiresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireCondition>;
  filter?: InputMaybe<OffHireFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOpenPositionHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionHistoryCondition>;
  filter?: InputMaybe<OpenPositionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOpenPositionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionCondition>;
  filter?: InputMaybe<OpenPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderAttributeAssociationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderAttributeAssociationCondition>;
  filter?: InputMaybe<OrderAttributeAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderAttributeAssociationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderAttributeCondition>;
  filter?: InputMaybe<OrderAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderAttributesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderPortCallRelationHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderPortCallRelationHistoryCondition>;
  filter?: InputMaybe<OrderPortCallRelationHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderPortCallRelationHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderPortCallRelationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderPortCallRelationCondition>;
  filter?: InputMaybe<OrderPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderPortCallRelationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderPortOverridesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderPortOverrideCondition>;
  filter?: InputMaybe<OrderPortOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderPortOverridesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderRequirementAssociationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderRequirementAssociationCondition>;
  filter?: InputMaybe<OrderRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderRequirementAssociationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderVoyageCharterRelationHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderVoyageCharterRelationHistoryCondition>;
  filter?: InputMaybe<OrderVoyageCharterRelationHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrderVoyageCharterRelationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderVoyageCharterRelationCondition>;
  filter?: InputMaybe<OrderVoyageCharterRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrdersAllRelatedOrgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<AllOrdersAllRelatedOrgsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrdersHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrdersHistoryCondition>;
  filter?: InputMaybe<OrdersHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrganizationAreaBunkerGradeMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationAreaBunkerGradeMappingCondition>;
  filter?: InputMaybe<OrganizationAreaBunkerGradeMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationAreaBunkerGradeMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrganizationFeaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationFeatureCondition>;
  filter?: InputMaybe<OrganizationFeatureFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationFeaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganizationCondition>;
  filter?: InputMaybe<OrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortActivityCondition>;
  filter?: InputMaybe<PortActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCallExternalTimestampsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallExternalTimestampCondition>;
  filter?: InputMaybe<PortCallExternalTimestampFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallExternalTimestampsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCallFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallFileCondition>;
  filter?: InputMaybe<PortCallFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallFilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCallHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallHistoryCondition>;
  filter?: InputMaybe<PortCallHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCallsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallCondition>;
  filter?: InputMaybe<PortCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCommodityLdRatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCommodityLdRateCondition>;
  filter?: InputMaybe<PortCommodityLdRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCostDefaultsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostDefaultCondition>;
  filter?: InputMaybe<PortCostDefaultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostDefaultsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCostEstimatesExternalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostEstimatesExternalCondition>;
  filter?: InputMaybe<PortCostEstimatesExternalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostEstimatesExternalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostCondition>;
  filter?: InputMaybe<PortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCostsByPortAndPrimaryAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostsByPortAndPrimaryAttributeCondition>;
  filter?: InputMaybe<PortCostsByPortAndPrimaryAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostsByPortAndPrimaryAttributesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortCostsByPortAndVesselNamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostsByPortAndVesselNameCondition>;
  filter?: InputMaybe<PortCostsByPortAndVesselNameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostsByPortAndVesselNamesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortDatumCondition>;
  filter?: InputMaybe<PortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortDataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortNoticeHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortNoticeHistoryCondition>;
  filter?: InputMaybe<PortNoticeHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortNoticeHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortNoticesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortNoticeCondition>;
  filter?: InputMaybe<PortNoticeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortNoticesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPortRegionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortRegionCondition>;
  filter?: InputMaybe<PortRegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortRegionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPromptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PromptCondition>;
  filter?: InputMaybe<PromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllQuaysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<QuayCondition>;
  filter?: InputMaybe<QuayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuaysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllReceiverOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ReceiverOrganizationCondition>;
  filter?: InputMaybe<ReceiverOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReceiverOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRegionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RegionCondition>;
  filter?: InputMaybe<RegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRequestLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RequestLogCondition>;
  filter?: InputMaybe<RequestLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RequestLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRouteOverridesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteOverrideCondition>;
  filter?: InputMaybe<RouteOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRoutePointUsagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoutePointUsageCondition>;
  filter?: InputMaybe<RoutePointUsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutePointUsagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRoutePointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoutePointCondition>;
  filter?: InputMaybe<RoutePointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutePointsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRoutesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteCondition>;
  filter?: InputMaybe<RouteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllScenariosHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScenariosHistoryCondition>;
  filter?: InputMaybe<ScenariosHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScenariosHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllScheduledOrderHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderHistoryCondition>;
  filter?: InputMaybe<ScheduledOrderHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrderHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllScheduledOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderCondition>;
  filter?: InputMaybe<ScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSeenMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SeenMessageCondition>;
  filter?: InputMaybe<SeenMessageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SeenMessagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSenderOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SenderOrganizationCondition>;
  filter?: InputMaybe<SenderOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SenderOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipVoyageNamingRuleRelationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipVoyageNamingRuleRelationCondition>;
  filter?: InputMaybe<ShipVoyageNamingRuleRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipVoyageNamingRuleRelationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipmentExternalStatusesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentExternalStatusCondition>;
  filter?: InputMaybe<ShipmentExternalStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentExternalStatusesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipmentExtraFreightsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentExtraFreightCondition>;
  filter?: InputMaybe<ShipmentExtraFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentExtraFreightsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipmentFreightsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentFreightCondition>;
  filter?: InputMaybe<ShipmentFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentFreightsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipmentGroupAssociationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentGroupAssociationCondition>;
  filter?: InputMaybe<ShipmentGroupAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentGroupAssociationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentGroupCondition>;
  filter?: InputMaybe<ShipmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipmentHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentHistoryCondition>;
  filter?: InputMaybe<ShipmentHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentCondition>;
  filter?: InputMaybe<ShipmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipCondition>;
  filter?: InputMaybe<ShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSingleEventHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventHistoryCondition>;
  filter?: InputMaybe<SingleEventHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSingleEventPortCallRelationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventPortCallRelationCondition>;
  filter?: InputMaybe<SingleEventPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventPortCallRelationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSingleEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventCondition>;
  filter?: InputMaybe<SingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSpecialRequirementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpecialRequirementCondition>;
  filter?: InputMaybe<SpecialRequirementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpecialRequirementsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSplitOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SplitOrderCondition>;
  filter?: InputMaybe<SplitOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SplitOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSpotNegotiationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpotNegotiationCondition>;
  filter?: InputMaybe<SpotNegotiationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllStatementOfFactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatementOfFactCondition>;
  filter?: InputMaybe<StatementOfFactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatementOfFactsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllStatementOfFactsHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatementOfFactsHistoryCondition>;
  filter?: InputMaybe<StatementOfFactsHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatementOfFactsHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSuppliesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSupplyContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyContractCondition>;
  filter?: InputMaybe<SupplyContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplyContractsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTankDistancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TankDistanceCondition>;
  filter?: InputMaybe<TankDistanceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TankDistancesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTcContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TcContractCondition>;
  filter?: InputMaybe<TcContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TcContractsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUserRegionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRegionCondition>;
  filter?: InputMaybe<UserRegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRegionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUserRightsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRightCondition>;
  filter?: InputMaybe<UserRightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRightsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUserSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserSettingCondition>;
  filter?: InputMaybe<UserSettingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUserShipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserShipCondition>;
  filter?: InputMaybe<UserShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserShipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselAttributeAssortmentExclusionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributeAssortmentExclusionCondition>;
  filter?: InputMaybe<VesselAttributeAssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributeAssortmentExclusionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributeCondition>;
  filter?: InputMaybe<VesselAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselAttributesAssociationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributesAssociationCondition>;
  filter?: InputMaybe<VesselAttributesAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributesAssociationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselDraftDatapointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselDraftDatapointCondition>;
  filter?: InputMaybe<VesselDraftDatapointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselDraftDatapointsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselFulfillsRequirementAssociationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselFulfillsRequirementAssociationCondition>;
  filter?: InputMaybe<VesselFulfillsRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselInfoCondition>;
  filter?: InputMaybe<VesselInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselPerformanceModelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselPerformanceModelCondition>;
  filter?: InputMaybe<VesselPerformanceModelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselPerformanceModelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselReservationHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationHistoryCondition>;
  filter?: InputMaybe<VesselReservationHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselReservationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselScheduleSharedToOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselScheduleSharedToOrganizationCondition>;
  filter?: InputMaybe<VesselScheduleSharedToOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselScheduleSharedToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselSecretsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSecretCondition>;
  filter?: InputMaybe<VesselSecretFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSecretsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVesselSpeedConsumptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSpeedConsumptionCondition>;
  filter?: InputMaybe<VesselSpeedConsumptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSpeedConsumptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageAssociationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageAssociationCondition>;
  filter?: InputMaybe<VoyageAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageAssociationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageAttributesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageAttributeCondition>;
  filter?: InputMaybe<VoyageAttributeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageAttributesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterExtraCostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterExtraCostCondition>;
  filter?: InputMaybe<VoyageCharterExtraCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterExtraCostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterExtraFreightsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterExtraFreightCondition>;
  filter?: InputMaybe<VoyageCharterExtraFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterExtraFreightsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterHistoryCondition>;
  filter?: InputMaybe<VoyageCharterHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterOrderFreightHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterOrderFreightHistoryCondition>;
  filter?: InputMaybe<VoyageCharterOrderFreightHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterOrderFreightHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterOrderFreightsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterOrderFreightCondition>;
  filter?: InputMaybe<VoyageCharterOrderFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterOrderFreightsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterPortCostsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortCostCondition>;
  filter?: InputMaybe<VoyageCharterPortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortCostsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterPortDataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortDatumCondition>;
  filter?: InputMaybe<VoyageCharterPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortDataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterPortDataHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortDataHistoryCondition>;
  filter?: InputMaybe<VoyageCharterPortDataHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortDataHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterToContractHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterToContractHistoryCondition>;
  filter?: InputMaybe<VoyageCharterToContractHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterToContractHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterToContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterToContractCondition>;
  filter?: InputMaybe<VoyageCharterToContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageCharterUpdatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterUpdateCondition>;
  filter?: InputMaybe<VoyageCharterUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageChartersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterCondition>;
  filter?: InputMaybe<VoyageCharterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyageNamingRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageNamingRuleCondition>;
  filter?: InputMaybe<VoyageNamingRuleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageNamingRulesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVoyagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCondition>;
  filter?: InputMaybe<VoyageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwBrokerAccessibleOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwBrokerAccessibleOrderCondition>;
  filter?: InputMaybe<VwBrokerAccessibleOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwBrokerAccessibleOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwHandledByCoaPortAgentOrdersPgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwHandledByCoaPortAgentOrdersPgCondition>;
  filter?: InputMaybe<VwHandledByCoaPortAgentOrdersPgFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwHandledByCoaPortAgentOrdersPgsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwHandledByCoaShipOwnerOrdersPgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwHandledByCoaShipOwnerOrdersPgCondition>;
  filter?: InputMaybe<VwHandledByCoaShipOwnerOrdersPgFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwHandledByCoaShipOwnerOrdersPgsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwHandledBySpotOrgRefsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwHandledBySpotOrgRefCondition>;
  filter?: InputMaybe<VwHandledBySpotOrgRefFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwHandledBySpotOrgRefsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwHandledBySpotShipOwnerPgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwHandledBySpotShipOwnerPgCondition>;
  filter?: InputMaybe<VwHandledBySpotShipOwnerPgFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwHandledBySpotShipOwnerPgsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwOrderPolicyPortAgentOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwOrderPolicyPortAgentOrderCondition>;
  filter?: InputMaybe<VwOrderPolicyPortAgentOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwOrderPolicyPortAgentOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwOrderPolicySharedOrdersForReceiversArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwOrderPolicySharedOrdersForReceiverCondition>;
  filter?: InputMaybe<VwOrderPolicySharedOrdersForReceiverFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwOrderPolicySharedOrdersForReceiversOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwOrderPolicySharedOrdersForSendersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwOrderPolicySharedOrdersForSenderCondition>;
  filter?: InputMaybe<VwOrderPolicySharedOrdersForSenderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwOrderPolicySharedOrdersForSendersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwOrdersVisibilityListByOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwOrdersVisibilityListByOrganizationCondition>;
  filter?: InputMaybe<VwOrdersVisibilityListByOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwOrdersVisibilityListByOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwOrgTreesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwOrgTreeCondition>;
  filter?: InputMaybe<VwOrgTreeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwOrgTreesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwOrgUnpivotPgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwOrgUnpivotPgCondition>;
  filter?: InputMaybe<VwOrgUnpivotPgFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwOrgUnpivotPgsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwPortNoticeChangelogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwPortNoticeChangelogCondition>;
  filter?: InputMaybe<VwPortNoticeChangelogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwPortNoticeChangelogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwSapOrdersIntegrationSummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwSapOrdersIntegrationSummaryCondition>;
  filter?: InputMaybe<VwSapOrdersIntegrationSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwSapOrdersIntegrationSummariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwSapOrdersIntegrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwSapOrdersIntegrationCondition>;
  filter?: InputMaybe<VwSapOrdersIntegrationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwSapOrdersIntegrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwScheduledOrderShipOwnerOrdersPgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwScheduledOrderShipOwnerOrdersPgCondition>;
  filter?: InputMaybe<VwScheduledOrderShipOwnerOrdersPgFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwScheduledOrderShipOwnerOrdersPgsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwSharedOrdersOnlySenderReceiverPgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwSharedOrdersOnlySenderReceiverPgCondition>;
  filter?: InputMaybe<VwSharedOrdersOnlySenderReceiverPgFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwSharedOrdersOnlySenderReceiverPgsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwShipsByOrdersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwShipsByOrderCondition>;
  filter?: InputMaybe<VwShipsByOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwShipsByOrdersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwSpotOrdersPortAgentRelationPgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwSpotOrdersPortAgentRelationPgCondition>;
  filter?: InputMaybe<VwSpotOrdersPortAgentRelationPgFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwSpotOrdersPortAgentRelationPgsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwStatementOfFactsChangelogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwStatementOfFactsChangelogCondition>;
  filter?: InputMaybe<VwStatementOfFactsChangelogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwStatementOfFactsChangelogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwUserNotifyByOrderPgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwUserNotifyByOrderPgCondition>;
  filter?: InputMaybe<VwUserNotifyByOrderPgFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwUserNotifyByOrderPgsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllVwVoyageCharterShipownerNonfinancialsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VwVoyageCharterShipownerNonfinancialCondition>;
  filter?: InputMaybe<VwVoyageCharterShipownerNonfinancialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VwVoyageCharterShipownerNonfinancialsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWorldscaleFreightsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorldscaleFreightCondition>;
  filter?: InputMaybe<WorldscaleFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorldscaleFreightsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllZoneLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ZoneLocationCondition>;
  filter?: InputMaybe<ZoneLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZoneLocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllZonesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ZoneCondition>;
  filter?: InputMaybe<ZoneFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryApiOrderArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApiOrderByExternalOrderIdArgs = {
  externalOrderId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApiOrdersNoticeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryApiOrdersNoticeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssortmentArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssortmentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssortmentExclusionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssortmentExclusionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssortmentGroupArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssortmentGroupByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBatchUpdateArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBatchUpdateByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillOfLadingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillOfLadingByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillOfLadingDatumArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillOfLadingDatumByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeCalculationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeCalculationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeIdArgs = {
  fromGradeId: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  toGradeId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeMappingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeMappingByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeMappingByOrganizationIdAndFromGradeIdArgs = {
  fromGradeId: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeOverrideArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeOverrideByGradeNameAndOrganizationIdArgs = {
  gradeName: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkerGradeOverrideByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkeringArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBunkeringByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCachedExactRoutesByClusterPairsArgs = {
  inputs: Array<RoutesByClusterPairsInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCachedExactRoutesByPortPairsArgs = {
  inputs: Array<CachedRoutesByPortPairsInputs>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCachedRoutesByPortPairsArgs = {
  inputs: Array<CachedRoutesByPortPairsInputs>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCalculateRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  childOrg?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCalculateVoyagesArgs = {
  inputs: Array<CalculateVoyageInputs>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCarbonPriceOverrideArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCarbonPriceOverrideByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoCompartmentArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoCompartmentAllocationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoCompartmentAllocationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoCompartmentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoEquipmentArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoEquipmentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoExclusionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoExclusionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoLengthUnitArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoLengthUnitByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoMeasurementArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoMeasurementByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoUnitArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoUnitByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoUnitsConversionByExtraUnitNameArgs = {
  extraUnitName: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoWeightUnitArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCargoWeightUnitByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelCostArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelCostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelCostEstimateArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelCostEstimateByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelIncompatibilityArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelIncompatibilityByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChannelIncompatibilityByVesselAttributeIdAndChannelNameArgs = {
  channelName: Scalars['String']['input'];
  vesselAttributeId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChatArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChatByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckWorkHourPartsArgs = {
  whp: WorkHourPartInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckWorkHourPartsArrayArgs = {
  wh: Array<InputMaybe<WorkHourPartInput>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCheckWorkhoursArgs = {
  wh: Array<InputMaybe<WorkhourInput>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryClassSocietyAssociationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClassSocietyAssociationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClassificationSocietyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClassificationSocietyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractAssortmentArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractAssortmentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractBunkerArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractBunkerByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractCommissionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractCommissionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractDeviationCostArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractDeviationCostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortByCoaContractIdAndOriginIdAndDestinationIdArgs = {
  coaContractId: Scalars['Int']['input'];
  destinationId: Scalars['Int']['input'];
  originId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortCostArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortCostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortCostByLocationIdAndShipIdArgs = {
  locationId: Scalars['Int']['input'];
  shipId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortCostByLocationIdAndVesselTypeIdArgs = {
  locationId: Scalars['Int']['input'];
  vesselTypeId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortDatumArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPortDatumByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPriceArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractPriceByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractShipArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractShipByCoaContractIdAndShipIdArgs = {
  coaContractId: Scalars['Int']['input'];
  shipId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCoaContractShipByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommissionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommissionByExternalIdAndVoyageCharterIdArgs = {
  externalId: Scalars['String']['input'];
  voyageCharterId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommissionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommitLogArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommitLogByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommitLogScenarioArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommitLogScenarioByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCostSplitOnScheduledOrderArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderIdArgs = {
  actualCostId: Scalars['Int']['input'];
  scheduledOrderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCostSplitOnScheduledOrderByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCostSplitOnSingleEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCostSplitOnSingleEventByActualCostIdAndSingleEventIdArgs = {
  actualCostId: Scalars['Int']['input'];
  singleEventId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCostSplitOnSingleEventByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCountryByNumericArgs = {
  numeric: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDbChangeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDbChangeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDemandArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDemandByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailToOrderConfigArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailToOrderConfigByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailToOrderLogArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailToOrderLogByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExternalPortCostPredictionsArgs = {
  input: Array<ExternalPortCostPredictionsInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureByFeatureNameArgs = {
  featureName: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFileByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGeographicalEntityArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGeographicalEntityByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGeographicalRelationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGeographicalRelationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetChildOrgsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetOrgHierarchyArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  childOrg?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetOrgTreeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  org?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRaptorDraftArgs = {
  imo: Scalars['Int']['input'];
  loadedMass: Scalars['Float']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetRootOrgArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  childOrg?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<IntFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHandledByCoaArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandledByCoaByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandledByCoaByOrderIdArgs = {
  orderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandledBySpotArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandledBySpotByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHandledBySpotByOrderIdArgs = {
  orderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHasContractForPortAgentArgs = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasContractForSendersReceiversArgs = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToAccessBillOfLadingFromAnyOrgArgs = {
  orgIdsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToAccessCargoMeasurementFromAnyOrgArgs = {
  orgIdsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToAccessFinancesInAnyOrgArgs = {
  orgIdsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToAccessFinancesInOrgArgs = {
  orgIdIn?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToMutateBillOfLadingInAnyOrgArgs = {
  orgIdsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToMutateCargoMeasurementInAnyOrgArgs = {
  orgIdsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToMutateContractsInOrgArgs = {
  orgIdIn?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToMutateOrdersInAnyOrgArgs = {
  orgIdsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToMutatePortCallsArgs = {
  orgIdIn?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToMutatePortCallsInAnyOrgArgs = {
  orgIdsIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHasRightToMutateVoyagesInOrgArgs = {
  orgIdIn?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHolidayArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHolidayByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIceClassArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIceClassByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInstructionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInstructionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationLogArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationLogByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvoiceArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvoiceByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvoiceItemArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvoiceItemByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvoiceItemOrderArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInvoiceItemOrderByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIsAnyOrgInSessionOrgChildrenArgs = {
  orgs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsAnyOrgInSessionOrgTreeArgs = {
  orgs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsOrgInSessionOrgChildrenArgs = {
  org?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsOrgInSessionOrgTreeArgs = {
  org?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsOrgPortAgentInSessionOrgTreeArgs = {
  org?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsOrgRootChartererInSessionOrgTreeArgs = {
  org?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsOrgSenderReceiverInSessionOrgTreeArgs = {
  org?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIsOrgShipOwnerInSessionOrgTreeArgs = {
  org?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLaytimeResponsibilityArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLaytimeResponsibilityByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationClusterArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationClusterByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationRequirementAssociationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationRequirementAssociationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneIdArgs = {
  locationId: Scalars['Int']['input'];
  specialRequirementId: Scalars['Int']['input'];
  zoneId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationWorkingHourArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLocationWorkingHourByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLostContractArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLostContractByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMigrationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMigrationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMyShipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<ShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNoGoZoneArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNoGoZoneByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationReceiverByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOffHireArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOffHireByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenPositionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOpenPositionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderAttributeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderAttributeAssociationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderAttributeAssociationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderAttributeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderDetailArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderDetailByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderPortCallRelationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderPortCallRelationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderPortCallRelationByOrderIdAndIsLoadPortArgs = {
  isLoadPort: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderPortOverrideArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderPortOverrideByOrderIdArgs = {
  orderId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderRequirementAssociationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderRequirementAssociationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderRequirementAssociationBySpecialRequirementIdAndOrderIdArgs = {
  orderId: Scalars['Int']['input'];
  specialRequirementId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderVoyageCharterRelationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderVoyageCharterRelationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrderVoyageCharterRelationByOrderIdAndOutgoingArgs = {
  orderId: Scalars['Int']['input'];
  outgoing: Scalars['Boolean']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrdersRelatedOrgsArrArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<OrdersRelatedOrgsArrRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrgRouteOverridesByPortPairsArgs = {
  inputs: Array<CachedRoutesByPortPairsInputs>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationAreaBunkerGradeMappingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaArgs = {
  organizationId: Scalars['Int']['input'];
  vesselArea: VesselArea;
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationFeatureArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganizationFeatureByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortActivityArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortActivityByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCallArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCallByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCallExternalTimestampArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCallExternalTimestampByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCallFileArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCallFileByFileIdArgs = {
  fileId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCallFileByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCommodityLdRateArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCommodityLdRateByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCostArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCostDefaultArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCostDefaultByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrencyArgs = {
  currency: Currency;
  locationId: Scalars['Int']['input'];
  vesselId: Scalars['Int']['input'];
  vesselTypeId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCostEstimatesExternalArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortCostEstimatesExternalByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortDatumArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortDatumByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortNoticeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortNoticeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortRegionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortRegionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPortRegionByLocationIdAndRegionIdAndOrganizationIdArgs = {
  locationId: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  regionId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPromptArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPromptByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuayArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuayByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReceiverOrganizationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReceiverOrganizationByAdminOrganizationIdAndOrganizationIdArgs = {
  adminOrganizationId: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryReceiverOrganizationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRegionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRegionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRequestLogArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRequestLogByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteByClusterPairArgs = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  fromClusterId: Scalars['Int']['input'];
  noGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  toClusterId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteByDraftAndCoordinatesAndAvoidsChannelsArgs = {
  avoidsChannels: Scalars['Boolean']['input'];
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  fromClusterId: Scalars['Int']['input'];
  noGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  toClusterId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZonesArgs = {
  avoidsChannels: Scalars['Boolean']['input'];
  draft: Scalars['BigFloat']['input'];
  fromLat: Scalars['BigFloat']['input'];
  fromLong: Scalars['BigFloat']['input'];
  toLat: Scalars['BigFloat']['input'];
  toLong: Scalars['BigFloat']['input'];
  usedNoGoZones: Array<InputMaybe<Scalars['Int']['input']>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteByPortPairArgs = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  from: Scalars['Int']['input'];
  noGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteOverrideArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteOverrideByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannelsArgs = {
  avoidsChannels: Scalars['Boolean']['input'];
  fromId: Scalars['Int']['input'];
  organisationId: Scalars['Int']['input'];
  toId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRouteOverridesByPortPairsArgs = {
  inputs: Array<CachedRoutesByPortPairsInputs>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoutePointArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoutePointByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoutePointUsageArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoutePointUsageByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRoutesByClusterPairsArgs = {
  inputs: Array<RoutesByClusterPairsInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRoutesByPortPairsArgs = {
  inputs: Array<CachedRoutesByPortPairsInputs>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScenarioByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledOrderArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryScheduledOrderByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySearchLocationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySeenMessageArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySeenMessageByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySenderOrganizationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySenderOrganizationByAdminOrganizationIdAndOrganizationIdArgs = {
  adminOrganizationId: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySenderOrganizationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipVoyageNamingRuleRelationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipVoyageNamingRuleRelationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentExternalStatusArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentExternalStatusByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentExtraFreightArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentExtraFreightByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentFreightArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentFreightByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentFreightByShipmentIdArgs = {
  shipmentId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentGroupArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentGroupAssociationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentGroupAssociationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShipmentGroupByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySingleEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySingleEventByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySingleEventPortCallRelationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySingleEventPortCallRelationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySpecialRequirementArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySpecialRequirementByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySplitOrderArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySplitOrderByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySpotNegotiationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySpotNegotiationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStatementOfFactArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStatementOfFactByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySupplyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySupplyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySupplyContractArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySupplyContractByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTankDistanceArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTankDistanceByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTcContractArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTcContractByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTcContractByRootOrgAndExternalIdArgs = {
  externalId: Scalars['String']['input'];
  rootOrg: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRegionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRegionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRightArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRightByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRightByUserIdAndOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSettingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserSettingByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserShipArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserShipByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselAttributeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselAttributeAssortmentExclusionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselAttributeAssortmentExclusionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselAttributeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselAttributeByOrganizationIdAndNameArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselAttributesAssociationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselAttributesAssociationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselDraftDatapointArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselDraftDatapointByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselFulfillsRequirementAssociationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselFulfillsRequirementAssociationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselInfoArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselInfoByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselInfoByImoArgs = {
  imo: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselPerformanceModelArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselPerformanceModelByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselPerformanceModelByRootOrgAndShipIdArgs = {
  rootOrg: Scalars['Int']['input'];
  shipId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselReservationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselReservationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselScheduleSharedToOrganizationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselScheduleSharedToOrganizationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselScheduleSharedToOrganizationByVesselIdAndOrganizationIdArgs = {
  organizationId: Scalars['Int']['input'];
  vesselId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselSecretArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselSecretByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselSpeedConsumptionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVesselSpeedConsumptionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageAssociationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageAssociationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageAttributeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageAttributeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageAttributeByOrganizationIdAndNameAndColorArgs = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterByRootOrgAndExternalIdArgs = {
  externalId: Scalars['String']['input'];
  rootOrg: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterByRootOrgAndNameArgs = {
  name: Scalars['String']['input'];
  rootOrg: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterExtraCostArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterExtraCostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterExtraFreightArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterExtraFreightByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterOrderFreightArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterOrderFreightByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterPortCostArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterPortCostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterPortDatumArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterPortDatumByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterToContractArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterToContractByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterUpdateArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageCharterUpdateByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageNamingRuleArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVoyageNamingRuleByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorldscaleFreightArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorldscaleFreightByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYearArgs = {
  fromLocationId: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  route: Scalars['String']['input'];
  toLocationId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneLocationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneLocationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryZoneLocationByZoneIdAndLocationIdArgs = {
  locationId: Scalars['Int']['input'];
  zoneId: Scalars['Int']['input'];
};

export type RaptorDraft = {
  __typename?: 'RaptorDraft';
  fit?: Maybe<Scalars['Float']['output']>;
  lwr?: Maybe<Scalars['Float']['output']>;
  upr?: Maybe<Scalars['Float']['output']>;
};

export type ReceiverOrganization = Node & {
  __typename?: 'ReceiverOrganization';
  adminOrganizationId: Scalars['OrganizationId']['output'];
  id: Scalars['ReceiverOrganizationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `ReceiverOrganization`. */
  organizationByAdminOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `ReceiverOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `ReceiverOrganization` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ReceiverOrganizationCondition = {
  /** Checks for equality with the object’s `adminOrganizationId` field. */
  adminOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ReceiverOrganizationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `ReceiverOrganization` object types. All fields are combined with a logical ‘and.’ */
export type ReceiverOrganizationFilter = {
  /** Filter by the object’s `adminOrganizationId` field. */
  adminOrganizationId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReceiverOrganizationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ReceiverOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReceiverOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ReceiverOrganization` */
export type ReceiverOrganizationInput = {
  adminOrganizationId: Scalars['OrganizationId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** Represents an update to a `ReceiverOrganization`. Fields that are set will be updated. */
export type ReceiverOrganizationPatch = {
  adminOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `ReceiverOrganization` values. */
export type ReceiverOrganizationsConnection = {
  __typename?: 'ReceiverOrganizationsConnection';
  /** A list of edges which contains the `ReceiverOrganization` and cursor to aid in pagination. */
  edges: Array<ReceiverOrganizationsEdge>;
  /** A list of `ReceiverOrganization` objects. */
  nodes: Array<Maybe<ReceiverOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ReceiverOrganization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ReceiverOrganization` edge in the connection. */
export type ReceiverOrganizationsEdge = {
  __typename?: 'ReceiverOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ReceiverOrganization` at the end of the edge. */
  node?: Maybe<ReceiverOrganization>;
};

/** Methods to use when ordering `ReceiverOrganization`. */
export enum ReceiverOrganizationsOrderBy {
  ADMIN_ORGANIZATION_ID_ASC = 'ADMIN_ORGANIZATION_ID_ASC',
  ADMIN_ORGANIZATION_ID_DESC = 'ADMIN_ORGANIZATION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type RefreshShipnetOrdersResult = {
  __typename?: 'RefreshShipnetOrdersResult';
  status: Status;
};

export type Region = Node & {
  __typename?: 'Region';
  chartererOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  id: Scalars['RegionId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  ordinal?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Organization` that is related to this `Region`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  parentRegion?: Maybe<Scalars['RegionId']['output']>;
  polygon?: Maybe<Array<Maybe<Latlng>>>;
  /** Reads and enables pagination through a set of `PortRegion`. */
  portRegionsByRegionId: PortRegionsConnection;
  /** Reads a single `Region` that is related to this `Region`. */
  regionByParentRegion?: Maybe<Region>;
  /** Reads and enables pagination through a set of `Region`. */
  regionsByParentRegion: RegionsConnection;
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesByRegion: SuppliesConnection;
  /** Reads a single `User` that is related to this `Region`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
  /** Reads and enables pagination through a set of `UserRegion`. */
  userRegionsByRegionId: UserRegionsConnection;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  vesselReservationsByEndRegionId: VesselReservationsConnection;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  vesselReservationsByStartRegionId: VesselReservationsConnection;
};


export type RegionPortRegionsByRegionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortRegionCondition>;
  filter?: InputMaybe<PortRegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortRegionsOrderBy>>;
};


export type RegionRegionsByParentRegionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RegionCondition>;
  filter?: InputMaybe<RegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionsOrderBy>>;
};


export type RegionSuppliesByRegionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};


export type RegionUserRegionsByRegionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRegionCondition>;
  filter?: InputMaybe<UserRegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRegionsOrderBy>>;
};


export type RegionVesselReservationsByEndRegionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};


export type RegionVesselReservationsByStartRegionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};

/** A condition to be used against `Region` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RegionCondition = {
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['RegionId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ordinal` field. */
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `parentRegion` field. */
  parentRegion?: InputMaybe<Scalars['RegionId']['input']>;
  /** Checks for equality with the object’s `polygon` field. */
  polygon?: InputMaybe<Array<InputMaybe<LatlngInput>>>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `Region` object types. All fields are combined with a logical ‘and.’ */
export type RegionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RegionFilter>>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RegionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RegionFilter>>;
  /** Filter by the object’s `ordinal` field. */
  ordinal?: InputMaybe<IntFilter>;
  /** Filter by the object’s `parentRegion` field. */
  parentRegion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Region` */
export type RegionInput = {
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  name: Scalars['String']['input'];
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  parentRegion?: InputMaybe<Scalars['RegionId']['input']>;
  polygon?: InputMaybe<Array<InputMaybe<LatlngInput>>>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `Region`. Fields that are set will be updated. */
export type RegionPatch = {
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  parentRegion?: InputMaybe<Scalars['RegionId']['input']>;
  polygon?: InputMaybe<Array<InputMaybe<LatlngInput>>>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `Region` values. */
export type RegionsConnection = {
  __typename?: 'RegionsConnection';
  /** A list of edges which contains the `Region` and cursor to aid in pagination. */
  edges: Array<RegionsEdge>;
  /** A list of `Region` objects. */
  nodes: Array<Maybe<Region>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Region` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Region` edge in the connection. */
export type RegionsEdge = {
  __typename?: 'RegionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Region` at the end of the edge. */
  node?: Maybe<Region>;
};

/** Methods to use when ordering `Region`. */
export enum RegionsOrderBy {
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORDINAL_ASC = 'ORDINAL_ASC',
  ORDINAL_DESC = 'ORDINAL_DESC',
  PARENT_REGION_ASC = 'PARENT_REGION_ASC',
  PARENT_REGION_DESC = 'PARENT_REGION_DESC',
  POLYGON_ASC = 'POLYGON_ASC',
  POLYGON_DESC = 'POLYGON_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** All input for the `removeInvalidDateNotice` mutation. */
export type RemoveInvalidDateNoticeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentNotices?: InputMaybe<Scalars['JSON']['input']>;
  noticeKey?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `removeInvalidDateNotice` mutation. */
export type RemoveInvalidDateNoticePayload = {
  __typename?: 'RemoveInvalidDateNoticePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  json?: Maybe<Scalars['JSON']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type RequestLog = Node & {
  __typename?: 'RequestLog';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['RequestLogId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `RequestLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  request: Scalars['JSON']['output'];
  response: Scalars['JSON']['output'];
  status: ResponseStatus;
};

/**
 * A condition to be used against `RequestLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RequestLogCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['RequestLogId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `request` field. */
  request?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `response` field. */
  response?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ResponseStatus>;
};

/** A filter to be used against `RequestLog` object types. All fields are combined with a logical ‘and.’ */
export type RequestLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RequestLogFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RequestLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RequestLogFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ResponseStatusFilter>;
};

/** An input for mutations affecting `RequestLog` */
export type RequestLogInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  request: Scalars['JSON']['input'];
  response: Scalars['JSON']['input'];
  status: ResponseStatus;
};

/** Represents an update to a `RequestLog`. Fields that are set will be updated. */
export type RequestLogPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  request?: InputMaybe<Scalars['JSON']['input']>;
  response?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ResponseStatus>;
};

/** A connection to a list of `RequestLog` values. */
export type RequestLogsConnection = {
  __typename?: 'RequestLogsConnection';
  /** A list of edges which contains the `RequestLog` and cursor to aid in pagination. */
  edges: Array<RequestLogsEdge>;
  /** A list of `RequestLog` objects. */
  nodes: Array<Maybe<RequestLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RequestLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RequestLog` edge in the connection. */
export type RequestLogsEdge = {
  __typename?: 'RequestLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RequestLog` at the end of the edge. */
  node?: Maybe<RequestLog>;
};

/** Methods to use when ordering `RequestLog`. */
export enum RequestLogsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REQUEST_ASC = 'REQUEST_ASC',
  REQUEST_DESC = 'REQUEST_DESC',
  RESPONSE_ASC = 'RESPONSE_ASC',
  RESPONSE_DESC = 'RESPONSE_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC'
}

/** All input for the `requestResetPassword` mutation. */
export type RequestResetPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `requestResetPassword` mutation. */
export type RequestResetPasswordPayload = {
  __typename?: 'RequestResetPasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `resetPassword` mutation. */
export type ResetPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  loginToken: Scalars['String']['input'];
  newpassword: Scalars['String']['input'];
};

/** The output of our `resetPassword` mutation. */
export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integer?: Maybe<Scalars['Int']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export enum ResponseStatus {
  ERROR = 'ERROR',
  OK = 'OK'
}

/** A filter to be used against ResponseStatus fields. All fields are combined with a logical ‘and.’ */
export type ResponseStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ResponseStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ResponseStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ResponseStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ResponseStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ResponseStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ResponseStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ResponseStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ResponseStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ResponseStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ResponseStatus>>;
};

/** All input for the `restoreOrderVoyageCharterRelation` mutation. */
export type RestoreOrderVoyageCharterRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** The output of our `restoreOrderVoyageCharterRelation` mutation. */
export type RestoreOrderVoyageCharterRelationPayload = {
  __typename?: 'RestoreOrderVoyageCharterRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ResultResponseDouble = {
  __typename?: 'ResultResponseDouble';
  errors: Array<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type RobTaskSubscriptionPayload = {
  __typename?: 'RobTaskSubscriptionPayload';
  bunker?: Maybe<GetVesonBunkerResult>;
  event?: Maybe<Scalars['String']['output']>;
};

export type Route = Node & {
  __typename?: 'Route';
  avoidsChannels: Scalars['Boolean']['output'];
  decomposed?: Maybe<Scalars['JSON']['output']>;
  distance?: Maybe<Scalars['BigFloat']['output']>;
  draft?: Maybe<Scalars['BigFloat']['output']>;
  exact?: Maybe<Scalars['JSON']['output']>;
  fromClusterId?: Maybe<Scalars['LocationClusterId']['output']>;
  fromLat?: Maybe<Scalars['BigFloat']['output']>;
  fromLong?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['RouteId']['output'];
  insertedAt?: Maybe<Scalars['Datetime']['output']>;
  insideDistance?: Maybe<Scalars['BigFloat']['output']>;
  insideNm?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `LocationCluster` that is related to this `Route`. */
  locationClusterByFromClusterId?: Maybe<LocationCluster>;
  /** Reads a single `LocationCluster` that is related to this `Route`. */
  locationClusterByToClusterId?: Maybe<LocationCluster>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  outsideNm?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `RoutePointUsage`. */
  routePointUsagesByRouteId: RoutePointUsagesConnection;
  toClusterId?: Maybe<Scalars['LocationClusterId']['output']>;
  toLat?: Maybe<Scalars['BigFloat']['output']>;
  toLong?: Maybe<Scalars['BigFloat']['output']>;
  totalDistance?: Maybe<Scalars['BigFloat']['output']>;
  usedChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  usedNoGoZones?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};


export type RouteRoutePointUsagesByRouteIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoutePointUsageCondition>;
  filter?: InputMaybe<RoutePointUsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutePointUsagesOrderBy>>;
};

/** A condition to be used against `Route` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RouteCondition = {
  /** Checks for equality with the object’s `avoidsChannels` field. */
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `decomposed` field. */
  decomposed?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `distance` field. */
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `exact` field. */
  exact?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `fromClusterId` field. */
  fromClusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  /** Checks for equality with the object’s `fromLat` field. */
  fromLat?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `fromLong` field. */
  fromLong?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['RouteId']['input']>;
  /** Checks for equality with the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `insideDistance` field. */
  insideDistance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `insideNm` field. */
  insideNm?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `outsideNm` field. */
  outsideNm?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `toClusterId` field. */
  toClusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  /** Checks for equality with the object’s `toLat` field. */
  toLat?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `toLong` field. */
  toLong?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `totalDistance` field. */
  totalDistance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `usedChannels` field. */
  usedChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `usedNoGoZones` field. */
  usedNoGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** A filter to be used against `Route` object types. All fields are combined with a logical ‘and.’ */
export type RouteFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RouteFilter>>;
  /** Filter by the object’s `avoidsChannels` field. */
  avoidsChannels?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `decomposed` field. */
  decomposed?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `distance` field. */
  distance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fromClusterId` field. */
  fromClusterId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fromLat` field. */
  fromLat?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fromLong` field. */
  fromLong?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `insideDistance` field. */
  insideDistance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `insideNm` field. */
  insideNm?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RouteFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RouteFilter>>;
  /** Filter by the object’s `outsideNm` field. */
  outsideNm?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `toClusterId` field. */
  toClusterId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toLat` field. */
  toLat?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `toLong` field. */
  toLong?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `totalDistance` field. */
  totalDistance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `usedChannels` field. */
  usedChannels?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `usedNoGoZones` field. */
  usedNoGoZones?: InputMaybe<IntListFilter>;
};

/** An input for mutations affecting `Route` */
export type RouteInput = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  decomposed?: InputMaybe<Scalars['JSON']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  exact?: InputMaybe<Scalars['JSON']['input']>;
  fromClusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  fromLat?: InputMaybe<Scalars['BigFloat']['input']>;
  fromLong?: InputMaybe<Scalars['BigFloat']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  insideDistance?: InputMaybe<Scalars['BigFloat']['input']>;
  insideNm?: InputMaybe<Scalars['BigFloat']['input']>;
  outsideNm?: InputMaybe<Scalars['BigFloat']['input']>;
  toClusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  toLat?: InputMaybe<Scalars['BigFloat']['input']>;
  toLong?: InputMaybe<Scalars['BigFloat']['input']>;
  totalDistance?: InputMaybe<Scalars['BigFloat']['input']>;
  usedChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usedNoGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type RouteOverride = Node & {
  __typename?: 'RouteOverride';
  avoidsChannels: Scalars['Boolean']['output'];
  distance?: Maybe<Scalars['BigFloat']['output']>;
  exact?: Maybe<Scalars['JSON']['output']>;
  fromId: Scalars['LocationId']['output'];
  id: Scalars['RouteOverrideId']['output'];
  /** Reads a single `Location` that is related to this `RouteOverride`. */
  locationByFromId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `RouteOverride`. */
  locationByToId?: Maybe<Location>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Organization` that is related to this `RouteOverride`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Ship` that is related to this `RouteOverride`. */
  shipByVesselId?: Maybe<Ship>;
  /** Hours */
  time?: Maybe<Scalars['BigFloat']['output']>;
  toId: Scalars['LocationId']['output'];
  /** Reads a single `User` that is related to this `RouteOverride`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};

/**
 * A condition to be used against `RouteOverride` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RouteOverrideCondition = {
  /** Checks for equality with the object’s `avoidsChannels` field. */
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `distance` field. */
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `exact` field. */
  exact?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `fromId` field. */
  fromId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['RouteOverrideId']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `time` field. */
  time?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `toId` field. */
  toId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `RouteOverride` object types. All fields are combined with a logical ‘and.’ */
export type RouteOverrideFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RouteOverrideFilter>>;
  /** Filter by the object’s `avoidsChannels` field. */
  avoidsChannels?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `distance` field. */
  distance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fromId` field. */
  fromId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RouteOverrideFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RouteOverrideFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `time` field. */
  time?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `toId` field. */
  toId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `RouteOverride` */
export type RouteOverrideInput = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  exact?: InputMaybe<Scalars['JSON']['input']>;
  fromId: Scalars['LocationId']['input'];
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Hours */
  time?: InputMaybe<Scalars['BigFloat']['input']>;
  toId: Scalars['LocationId']['input'];
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `RouteOverride`. Fields that are set will be updated. */
export type RouteOverridePatch = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  exact?: InputMaybe<Scalars['JSON']['input']>;
  fromId?: InputMaybe<Scalars['LocationId']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Hours */
  time?: InputMaybe<Scalars['BigFloat']['input']>;
  toId?: InputMaybe<Scalars['LocationId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type RouteOverrideSubscriptionPayload = {
  __typename?: 'RouteOverrideSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  routeOverride?: Maybe<RouteOverride>;
};

/** A connection to a list of `RouteOverride` values. */
export type RouteOverridesConnection = {
  __typename?: 'RouteOverridesConnection';
  /** A list of edges which contains the `RouteOverride` and cursor to aid in pagination. */
  edges: Array<RouteOverridesEdge>;
  /** A list of `RouteOverride` objects. */
  nodes: Array<Maybe<RouteOverride>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RouteOverride` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RouteOverride` edge in the connection. */
export type RouteOverridesEdge = {
  __typename?: 'RouteOverridesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RouteOverride` at the end of the edge. */
  node?: Maybe<RouteOverride>;
};

/** Methods to use when ordering `RouteOverride`. */
export enum RouteOverridesOrderBy {
  AVOIDS_CHANNELS_ASC = 'AVOIDS_CHANNELS_ASC',
  AVOIDS_CHANNELS_DESC = 'AVOIDS_CHANNELS_DESC',
  DISTANCE_ASC = 'DISTANCE_ASC',
  DISTANCE_DESC = 'DISTANCE_DESC',
  EXACT_ASC = 'EXACT_ASC',
  EXACT_DESC = 'EXACT_DESC',
  FROM_ID_ASC = 'FROM_ID_ASC',
  FROM_ID_DESC = 'FROM_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TIME_ASC = 'TIME_ASC',
  TIME_DESC = 'TIME_DESC',
  TO_ID_ASC = 'TO_ID_ASC',
  TO_ID_DESC = 'TO_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** Represents an update to a `Route`. Fields that are set will be updated. */
export type RoutePatch = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  decomposed?: InputMaybe<Scalars['JSON']['input']>;
  distance?: InputMaybe<Scalars['BigFloat']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  exact?: InputMaybe<Scalars['JSON']['input']>;
  fromClusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  fromLat?: InputMaybe<Scalars['BigFloat']['input']>;
  fromLong?: InputMaybe<Scalars['BigFloat']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  insideDistance?: InputMaybe<Scalars['BigFloat']['input']>;
  insideNm?: InputMaybe<Scalars['BigFloat']['input']>;
  outsideNm?: InputMaybe<Scalars['BigFloat']['input']>;
  toClusterId?: InputMaybe<Scalars['LocationClusterId']['input']>;
  toLat?: InputMaybe<Scalars['BigFloat']['input']>;
  toLong?: InputMaybe<Scalars['BigFloat']['input']>;
  totalDistance?: InputMaybe<Scalars['BigFloat']['input']>;
  usedChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  usedNoGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type RoutePoint = Node & {
  __typename?: 'RoutePoint';
  defaultState?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['RoutePointId']['output'];
  latitude: Scalars['BigFloat']['output'];
  longitude: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `RoutePointUsage`. */
  routePointUsagesByRoutePointId: RoutePointUsagesConnection;
  shortId: Scalars['String']['output'];
};


export type RoutePointRoutePointUsagesByRoutePointIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RoutePointUsageCondition>;
  filter?: InputMaybe<RoutePointUsageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoutePointUsagesOrderBy>>;
};

/**
 * A condition to be used against `RoutePoint` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RoutePointCondition = {
  /** Checks for equality with the object’s `defaultState` field. */
  defaultState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['RoutePointId']['input']>;
  /** Checks for equality with the object’s `latitude` field. */
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `longitude` field. */
  longitude?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `shortId` field. */
  shortId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `RoutePoint` object types. All fields are combined with a logical ‘and.’ */
export type RoutePointFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoutePointFilter>>;
  /** Filter by the object’s `defaultState` field. */
  defaultState?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `latitude` field. */
  latitude?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `longitude` field. */
  longitude?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoutePointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoutePointFilter>>;
  /** Filter by the object’s `shortId` field. */
  shortId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RoutePoint` */
export type RoutePointInput = {
  defaultState?: InputMaybe<Scalars['Boolean']['input']>;
  latitude: Scalars['BigFloat']['input'];
  longitude: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  shortId: Scalars['String']['input'];
};

/** Represents an update to a `RoutePoint`. Fields that are set will be updated. */
export type RoutePointPatch = {
  defaultState?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['BigFloat']['input']>;
  longitude?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
};

export type RoutePointUsage = Node & {
  __typename?: 'RoutePointUsage';
  id: Scalars['RoutePointUsageId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Route` that is related to this `RoutePointUsage`. */
  routeByRouteId?: Maybe<Route>;
  routeId: Scalars['RouteId']['output'];
  /** Reads a single `RoutePoint` that is related to this `RoutePointUsage`. */
  routePointByRoutePointId?: Maybe<RoutePoint>;
  routePointId: Scalars['RoutePointId']['output'];
  used?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A condition to be used against `RoutePointUsage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RoutePointUsageCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['RoutePointUsageId']['input']>;
  /** Checks for equality with the object’s `routeId` field. */
  routeId?: InputMaybe<Scalars['RouteId']['input']>;
  /** Checks for equality with the object’s `routePointId` field. */
  routePointId?: InputMaybe<Scalars['RoutePointId']['input']>;
  /** Checks for equality with the object’s `used` field. */
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `RoutePointUsage` object types. All fields are combined with a logical ‘and.’ */
export type RoutePointUsageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoutePointUsageFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoutePointUsageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoutePointUsageFilter>>;
  /** Filter by the object’s `routeId` field. */
  routeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `routePointId` field. */
  routePointId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `used` field. */
  used?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `RoutePointUsage` */
export type RoutePointUsageInput = {
  routeId: Scalars['RouteId']['input'];
  routePointId: Scalars['RoutePointId']['input'];
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `RoutePointUsage`. Fields that are set will be updated. */
export type RoutePointUsagePatch = {
  routeId?: InputMaybe<Scalars['RouteId']['input']>;
  routePointId?: InputMaybe<Scalars['RoutePointId']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `RoutePointUsage` values. */
export type RoutePointUsagesConnection = {
  __typename?: 'RoutePointUsagesConnection';
  /** A list of edges which contains the `RoutePointUsage` and cursor to aid in pagination. */
  edges: Array<RoutePointUsagesEdge>;
  /** A list of `RoutePointUsage` objects. */
  nodes: Array<Maybe<RoutePointUsage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoutePointUsage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RoutePointUsage` edge in the connection. */
export type RoutePointUsagesEdge = {
  __typename?: 'RoutePointUsagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RoutePointUsage` at the end of the edge. */
  node?: Maybe<RoutePointUsage>;
};

/** Methods to use when ordering `RoutePointUsage`. */
export enum RoutePointUsagesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROUTE_ID_ASC = 'ROUTE_ID_ASC',
  ROUTE_ID_DESC = 'ROUTE_ID_DESC',
  ROUTE_POINT_ID_ASC = 'ROUTE_POINT_ID_ASC',
  ROUTE_POINT_ID_DESC = 'ROUTE_POINT_ID_DESC',
  USED_ASC = 'USED_ASC',
  USED_DESC = 'USED_DESC'
}

/** A connection to a list of `RoutePoint` values. */
export type RoutePointsConnection = {
  __typename?: 'RoutePointsConnection';
  /** A list of edges which contains the `RoutePoint` and cursor to aid in pagination. */
  edges: Array<RoutePointsEdge>;
  /** A list of `RoutePoint` objects. */
  nodes: Array<Maybe<RoutePoint>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoutePoint` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RoutePoint` edge in the connection. */
export type RoutePointsEdge = {
  __typename?: 'RoutePointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RoutePoint` at the end of the edge. */
  node?: Maybe<RoutePoint>;
};

/** Methods to use when ordering `RoutePoint`. */
export enum RoutePointsOrderBy {
  DEFAULT_STATE_ASC = 'DEFAULT_STATE_ASC',
  DEFAULT_STATE_DESC = 'DEFAULT_STATE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LATITUDE_ASC = 'LATITUDE_ASC',
  LATITUDE_DESC = 'LATITUDE_DESC',
  LONGITUDE_ASC = 'LONGITUDE_ASC',
  LONGITUDE_DESC = 'LONGITUDE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHORT_ID_ASC = 'SHORT_ID_ASC',
  SHORT_ID_DESC = 'SHORT_ID_DESC'
}

export type RoutesByClusterPairsInput = {
  avoidsChannels?: InputMaybe<Scalars['Boolean']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  fromClusterId: Scalars['Int']['input'];
  noGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  toClusterId: Scalars['Int']['input'];
};

/** A connection to a list of `Route` values. */
export type RoutesConnection = {
  __typename?: 'RoutesConnection';
  /** A list of edges which contains the `Route` and cursor to aid in pagination. */
  edges: Array<RoutesEdge>;
  /** A list of `Route` objects. */
  nodes: Array<Maybe<Route>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Route` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Route` edge in the connection. */
export type RoutesEdge = {
  __typename?: 'RoutesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Route` at the end of the edge. */
  node?: Maybe<Route>;
};

/** Methods to use when ordering `Route`. */
export enum RoutesOrderBy {
  AVOIDS_CHANNELS_ASC = 'AVOIDS_CHANNELS_ASC',
  AVOIDS_CHANNELS_DESC = 'AVOIDS_CHANNELS_DESC',
  DECOMPOSED_ASC = 'DECOMPOSED_ASC',
  DECOMPOSED_DESC = 'DECOMPOSED_DESC',
  DISTANCE_ASC = 'DISTANCE_ASC',
  DISTANCE_DESC = 'DISTANCE_DESC',
  DRAFT_ASC = 'DRAFT_ASC',
  DRAFT_DESC = 'DRAFT_DESC',
  EXACT_ASC = 'EXACT_ASC',
  EXACT_DESC = 'EXACT_DESC',
  FROM_CLUSTER_ID_ASC = 'FROM_CLUSTER_ID_ASC',
  FROM_CLUSTER_ID_DESC = 'FROM_CLUSTER_ID_DESC',
  FROM_LAT_ASC = 'FROM_LAT_ASC',
  FROM_LAT_DESC = 'FROM_LAT_DESC',
  FROM_LONG_ASC = 'FROM_LONG_ASC',
  FROM_LONG_DESC = 'FROM_LONG_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INSERTED_AT_ASC = 'INSERTED_AT_ASC',
  INSERTED_AT_DESC = 'INSERTED_AT_DESC',
  INSIDE_DISTANCE_ASC = 'INSIDE_DISTANCE_ASC',
  INSIDE_DISTANCE_DESC = 'INSIDE_DISTANCE_DESC',
  INSIDE_NM_ASC = 'INSIDE_NM_ASC',
  INSIDE_NM_DESC = 'INSIDE_NM_DESC',
  NATURAL = 'NATURAL',
  OUTSIDE_NM_ASC = 'OUTSIDE_NM_ASC',
  OUTSIDE_NM_DESC = 'OUTSIDE_NM_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TOTAL_DISTANCE_ASC = 'TOTAL_DISTANCE_ASC',
  TOTAL_DISTANCE_DESC = 'TOTAL_DISTANCE_DESC',
  TO_CLUSTER_ID_ASC = 'TO_CLUSTER_ID_ASC',
  TO_CLUSTER_ID_DESC = 'TO_CLUSTER_ID_DESC',
  TO_LAT_ASC = 'TO_LAT_ASC',
  TO_LAT_DESC = 'TO_LAT_DESC',
  TO_LONG_ASC = 'TO_LONG_ASC',
  TO_LONG_DESC = 'TO_LONG_DESC',
  USED_CHANNELS_ASC = 'USED_CHANNELS_ASC',
  USED_CHANNELS_DESC = 'USED_CHANNELS_DESC',
  USED_NO_GO_ZONES_ASC = 'USED_NO_GO_ZONES_ASC',
  USED_NO_GO_ZONES_DESC = 'USED_NO_GO_ZONES_DESC'
}

export type Scenario = Node & {
  __typename?: 'Scenario';
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy: Scalars['UserId']['output'];
  /** Actual scenario data, schema is defined in the web client */
  data: Scalars['JSON']['output'];
  /** Client provided version number for determining if their cached data version and code version is compatible */
  dataSchemaVersion: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ScenarioId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Scenario`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Scenario`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Root organization from the current session */
  rootOrg?: Maybe<Scalars['OrganizationId']['output']>;
  shared: Scalars['Boolean']['output'];
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy: Scalars['UserId']['output'];
  /** Reads a single `User` that is related to this `Scenario`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByUpdatedBy?: Maybe<User>;
};

/**
 * A condition to be used against `Scenario` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ScenarioCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `dataSchemaVersion` field. */
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ScenarioId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `Scenario` object types. All fields are combined with a logical ‘and.’ */
export type ScenarioFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScenarioFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dataSchemaVersion` field. */
  dataSchemaVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScenarioFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScenarioFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Scenario` */
export type ScenarioInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdBy?: InputMaybe<Scalars['UserId']['input']>;
  /** Actual scenario data, schema is defined in the web client */
  data: Scalars['JSON']['input'];
  /** Client provided version number for determining if their cached data version and code version is compatible */
  dataSchemaVersion: Scalars['Int']['input'];
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedBy?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `Scenario`. Fields that are set will be updated. */
export type ScenarioPatch = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdBy?: InputMaybe<Scalars['UserId']['input']>;
  /** Actual scenario data, schema is defined in the web client */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Client provided version number for determining if their cached data version and code version is compatible */
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedBy?: InputMaybe<Scalars['UserId']['input']>;
};

export type ScenarioSubscriptionPayload = {
  __typename?: 'ScenarioSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  scenario?: Maybe<Scenario>;
};

/** A connection to a list of `Scenario` values. */
export type ScenariosConnection = {
  __typename?: 'ScenariosConnection';
  /** A list of edges which contains the `Scenario` and cursor to aid in pagination. */
  edges: Array<ScenariosEdge>;
  /** A list of `Scenario` objects. */
  nodes: Array<Maybe<Scenario>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Scenario` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Scenario` edge in the connection. */
export type ScenariosEdge = {
  __typename?: 'ScenariosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Scenario` at the end of the edge. */
  node?: Maybe<Scenario>;
};

/** A connection to a list of `ScenariosHistory` values. */
export type ScenariosHistoriesConnection = {
  __typename?: 'ScenariosHistoriesConnection';
  /** A list of edges which contains the `ScenariosHistory` and cursor to aid in pagination. */
  edges: Array<ScenariosHistoriesEdge>;
  /** A list of `ScenariosHistory` objects. */
  nodes: Array<Maybe<ScenariosHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScenariosHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ScenariosHistory` edge in the connection. */
export type ScenariosHistoriesEdge = {
  __typename?: 'ScenariosHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ScenariosHistory` at the end of the edge. */
  node?: Maybe<ScenariosHistory>;
};

/** Methods to use when ordering `ScenariosHistory`. */
export enum ScenariosHistoriesOrderBy {
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  DATA_ASC = 'DATA_ASC',
  DATA_DESC = 'DATA_DESC',
  DATA_SCHEMA_VERSION_ASC = 'DATA_SCHEMA_VERSION_ASC',
  DATA_SCHEMA_VERSION_DESC = 'DATA_SCHEMA_VERSION_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UPDATED_BY_ASC = 'UPDATED_BY_ASC',
  UPDATED_BY_DESC = 'UPDATED_BY_DESC'
}

/** History log for this table */
export type ScenariosHistory = {
  __typename?: 'ScenariosHistory';
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy: Scalars['Int']['output'];
  data: Scalars['JSON']['output'];
  dataSchemaVersion: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  shared: Scalars['Boolean']['output'];
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy: Scalars['Int']['output'];
};

/**
 * A condition to be used against `ScenariosHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ScenariosHistoryCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `dataSchemaVersion` field. */
  dataSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ScenariosHistory` object types. All fields are combined with a logical ‘and.’ */
export type ScenariosHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScenariosHistoryFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dataSchemaVersion` field. */
  dataSchemaVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScenariosHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScenariosHistoryFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<IntFilter>;
};

/** Methods to use when ordering `Scenario`. */
export enum ScenariosOrderBy {
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ASC = 'CREATED_BY_ASC',
  CREATED_BY_DESC = 'CREATED_BY_DESC',
  DATA_ASC = 'DATA_ASC',
  DATA_DESC = 'DATA_DESC',
  DATA_SCHEMA_VERSION_ASC = 'DATA_SCHEMA_VERSION_ASC',
  DATA_SCHEMA_VERSION_DESC = 'DATA_SCHEMA_VERSION_DESC',
  DELETED_AT_ASC = 'DELETED_AT_ASC',
  DELETED_AT_DESC = 'DELETED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  UPDATED_BY_ASC = 'UPDATED_BY_ASC',
  UPDATED_BY_DESC = 'UPDATED_BY_DESC'
}

export enum ScheduleOptimizationMethod {
  best_add = 'best_add',
  best_group_add = 'best_group_add',
  solve = 'solve'
}

export type ScheduledOrder = Node & {
  __typename?: 'ScheduledOrder';
  amount?: Maybe<Scalars['BigFloat']['output']>;
  archived: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `CargoCompartmentAllocation`. */
  cargoCompartmentAllocationsByScheduledOrderClientId: CargoCompartmentAllocationsConnection;
  /** Reads and enables pagination through a set of `CargoCompartmentAllocation`. */
  cargoCompartmentAllocationsByScheduledOrderId: CargoCompartmentAllocationsConnection;
  /** Indicates if cleaning event was manually omitted */
  cleaningOmitted: Scalars['Boolean']['output'];
  clientId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `CostSplitOnScheduledOrder`. */
  costSplitOnScheduledOrdersByScheduledOrderId: CostSplitOnScheduledOrdersConnection;
  createdAt: Scalars['Datetime']['output'];
  createdByUserId?: Maybe<Scalars['UserId']['output']>;
  dischargingConcurrent: Scalars['Boolean']['output'];
  dischargingDuration: Scalars['BigInt']['output'];
  dischargingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingEnd: Scalars['Datetime']['output'];
  dischargingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingStart: Scalars['Datetime']['output'];
  dischargingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ScheduledOrderId']['output'];
  loadingConcurrent: Scalars['Boolean']['output'];
  loadingDuration: Scalars['BigInt']['output'];
  loadingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingEnd: Scalars['Datetime']['output'];
  loadingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingStart: Scalars['Datetime']['output'];
  loadingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  locked: Scalars['Boolean']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `ScheduledOrder`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Organization` that is related to this `ScheduledOrder`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `ScheduledOrder`. */
  organizationByRootOrg?: Maybe<Organization>;
  planningOrganisationId: Scalars['OrganizationId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  shared: Scalars['Boolean']['output'];
  /** Reads a single `Ship` that is related to this `ScheduledOrder`. */
  shipByVesselId?: Maybe<Ship>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};


export type ScheduledOrderCargoCompartmentAllocationsByScheduledOrderClientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentAllocationCondition>;
  filter?: InputMaybe<CargoCompartmentAllocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};


export type ScheduledOrderCargoCompartmentAllocationsByScheduledOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentAllocationCondition>;
  filter?: InputMaybe<CargoCompartmentAllocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};


export type ScheduledOrderCostSplitOnScheduledOrdersByScheduledOrderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CostSplitOnScheduledOrderCondition>;
  filter?: InputMaybe<CostSplitOnScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CostSplitOnScheduledOrdersOrderBy>>;
};

/**
 * A condition to be used against `ScheduledOrder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ScheduledOrderCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `cleaningOmitted` field. */
  cleaningOmitted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ScheduledOrderId']['input']>;
  /** Checks for equality with the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `locked` field. */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meta` field. */
  meta?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `ScheduledOrder` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledOrderFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledOrderFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `cleaningOmitted` field. */
  cleaningOmitted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `locked` field. */
  locked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meta` field. */
  meta?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledOrderFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `ScheduledOrderHistory` values. */
export type ScheduledOrderHistoriesConnection = {
  __typename?: 'ScheduledOrderHistoriesConnection';
  /** A list of edges which contains the `ScheduledOrderHistory` and cursor to aid in pagination. */
  edges: Array<ScheduledOrderHistoriesEdge>;
  /** A list of `ScheduledOrderHistory` objects. */
  nodes: Array<Maybe<ScheduledOrderHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledOrderHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ScheduledOrderHistory` edge in the connection. */
export type ScheduledOrderHistoriesEdge = {
  __typename?: 'ScheduledOrderHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ScheduledOrderHistory` at the end of the edge. */
  node?: Maybe<ScheduledOrderHistory>;
};

/** Methods to use when ordering `ScheduledOrderHistory`. */
export enum ScheduledOrderHistoriesOrderBy {
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DISCHARGING_CONCURRENT_ASC = 'DISCHARGING_CONCURRENT_ASC',
  DISCHARGING_CONCURRENT_DESC = 'DISCHARGING_CONCURRENT_DESC',
  DISCHARGING_DURATION_ASC = 'DISCHARGING_DURATION_ASC',
  DISCHARGING_DURATION_DESC = 'DISCHARGING_DURATION_DESC',
  DISCHARGING_DURATION_OVERRIDE_ASC = 'DISCHARGING_DURATION_OVERRIDE_ASC',
  DISCHARGING_DURATION_OVERRIDE_DESC = 'DISCHARGING_DURATION_OVERRIDE_DESC',
  DISCHARGING_END_ASC = 'DISCHARGING_END_ASC',
  DISCHARGING_END_DESC = 'DISCHARGING_END_DESC',
  DISCHARGING_SEA_DURATION_OVERRIDE_ASC = 'DISCHARGING_SEA_DURATION_OVERRIDE_ASC',
  DISCHARGING_SEA_DURATION_OVERRIDE_DESC = 'DISCHARGING_SEA_DURATION_OVERRIDE_DESC',
  DISCHARGING_START_ASC = 'DISCHARGING_START_ASC',
  DISCHARGING_START_DESC = 'DISCHARGING_START_DESC',
  DISCHARGING_START_OVERRIDE_ASC = 'DISCHARGING_START_OVERRIDE_ASC',
  DISCHARGING_START_OVERRIDE_DESC = 'DISCHARGING_START_OVERRIDE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_CONCURRENT_ASC = 'LOADING_CONCURRENT_ASC',
  LOADING_CONCURRENT_DESC = 'LOADING_CONCURRENT_DESC',
  LOADING_DURATION_ASC = 'LOADING_DURATION_ASC',
  LOADING_DURATION_DESC = 'LOADING_DURATION_DESC',
  LOADING_DURATION_OVERRIDE_ASC = 'LOADING_DURATION_OVERRIDE_ASC',
  LOADING_DURATION_OVERRIDE_DESC = 'LOADING_DURATION_OVERRIDE_DESC',
  LOADING_END_ASC = 'LOADING_END_ASC',
  LOADING_END_DESC = 'LOADING_END_DESC',
  LOADING_SEA_DURATION_OVERRIDE_ASC = 'LOADING_SEA_DURATION_OVERRIDE_ASC',
  LOADING_SEA_DURATION_OVERRIDE_DESC = 'LOADING_SEA_DURATION_OVERRIDE_DESC',
  LOADING_START_ASC = 'LOADING_START_ASC',
  LOADING_START_DESC = 'LOADING_START_DESC',
  LOADING_START_OVERRIDE_ASC = 'LOADING_START_OVERRIDE_ASC',
  LOADING_START_OVERRIDE_DESC = 'LOADING_START_OVERRIDE_DESC',
  LOCKED_ASC = 'LOCKED_ASC',
  LOCKED_DESC = 'LOCKED_DESC',
  META_ASC = 'META_ASC',
  META_DESC = 'META_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PLANNING_ORGANISATION_ID_ASC = 'PLANNING_ORGANISATION_ID_ASC',
  PLANNING_ORGANISATION_ID_DESC = 'PLANNING_ORGANISATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for scheduled_order table */
export type ScheduledOrderHistory = {
  __typename?: 'ScheduledOrderHistory';
  amount?: Maybe<Scalars['BigFloat']['output']>;
  archived: Scalars['Boolean']['output'];
  clientId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdByUserId?: Maybe<Scalars['UserId']['output']>;
  dischargingConcurrent: Scalars['Boolean']['output'];
  dischargingDuration: Scalars['BigInt']['output'];
  dischargingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingEnd: Scalars['Datetime']['output'];
  dischargingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  dischargingStart: Scalars['Datetime']['output'];
  dischargingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  loadingConcurrent: Scalars['Boolean']['output'];
  loadingDuration: Scalars['BigInt']['output'];
  loadingDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingEnd: Scalars['Datetime']['output'];
  loadingSeaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  loadingStart: Scalars['Datetime']['output'];
  loadingStartOverride?: Maybe<Scalars['Datetime']['output']>;
  locked: Scalars['Boolean']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['Int']['output'];
  planningOrganisationId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  shared: Scalars['Boolean']['output'];
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `ScheduledOrderHistory`. */
  userByCreatedByUserId?: Maybe<User>;
  userId: Scalars['Int']['output'];
  vesselId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `ScheduledOrderHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ScheduledOrderHistoryCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `locked` field. */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meta` field. */
  meta?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ScheduledOrderHistory` object types. All fields are combined with a logical ‘and.’ */
export type ScheduledOrderHistoryFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ScheduledOrderHistoryFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingConcurrent` field. */
  dischargingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargingDuration` field. */
  dischargingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingDurationOverride` field. */
  dischargingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingEnd` field. */
  dischargingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingSeaDurationOverride` field. */
  dischargingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dischargingStart` field. */
  dischargingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dischargingStartOverride` field. */
  dischargingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingConcurrent` field. */
  loadingConcurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `loadingDuration` field. */
  loadingDuration?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingDurationOverride` field. */
  loadingDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingEnd` field. */
  loadingEnd?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingSeaDurationOverride` field. */
  loadingSeaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loadingStart` field. */
  loadingStart?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingStartOverride` field. */
  loadingStartOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `locked` field. */
  locked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meta` field. */
  meta?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ScheduledOrderHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ScheduledOrderHistoryFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ScheduledOrder` */
export type ScheduledOrderInput = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if cleaning event was manually omitted */
  cleaningOmitted?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  dischargingDuration: Scalars['BigInt']['input'];
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingEnd: Scalars['Datetime']['input'];
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingStart: Scalars['Datetime']['input'];
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDuration: Scalars['BigInt']['input'];
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingEnd: Scalars['Datetime']['input'];
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingStart: Scalars['Datetime']['input'];
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  locked: Scalars['Boolean']['input'];
  meta?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
  planningOrganisationId: Scalars['OrganizationId']['input'];
  shared: Scalars['Boolean']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['UserId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `ScheduledOrder`. Fields that are set will be updated. */
export type ScheduledOrderPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if cleaning event was manually omitted */
  cleaningOmitted?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  dischargingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  dischargingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  dischargingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  dischargingStart?: InputMaybe<Scalars['Datetime']['input']>;
  dischargingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  loadingConcurrent?: InputMaybe<Scalars['Boolean']['input']>;
  loadingDuration?: InputMaybe<Scalars['BigInt']['input']>;
  loadingDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingEnd?: InputMaybe<Scalars['Datetime']['input']>;
  loadingSeaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  loadingStart?: InputMaybe<Scalars['Datetime']['input']>;
  loadingStartOverride?: InputMaybe<Scalars['Datetime']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  planningOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `ScheduledOrder` values. */
export type ScheduledOrdersConnection = {
  __typename?: 'ScheduledOrdersConnection';
  /** A list of edges which contains the `ScheduledOrder` and cursor to aid in pagination. */
  edges: Array<ScheduledOrdersEdge>;
  /** A list of `ScheduledOrder` objects. */
  nodes: Array<Maybe<ScheduledOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ScheduledOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ScheduledOrder` edge in the connection. */
export type ScheduledOrdersEdge = {
  __typename?: 'ScheduledOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ScheduledOrder` at the end of the edge. */
  node?: Maybe<ScheduledOrder>;
};

/** Methods to use when ordering `ScheduledOrder`. */
export enum ScheduledOrdersOrderBy {
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLEANING_OMITTED_ASC = 'CLEANING_OMITTED_ASC',
  CLEANING_OMITTED_DESC = 'CLEANING_OMITTED_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DISCHARGING_CONCURRENT_ASC = 'DISCHARGING_CONCURRENT_ASC',
  DISCHARGING_CONCURRENT_DESC = 'DISCHARGING_CONCURRENT_DESC',
  DISCHARGING_DURATION_ASC = 'DISCHARGING_DURATION_ASC',
  DISCHARGING_DURATION_DESC = 'DISCHARGING_DURATION_DESC',
  DISCHARGING_DURATION_OVERRIDE_ASC = 'DISCHARGING_DURATION_OVERRIDE_ASC',
  DISCHARGING_DURATION_OVERRIDE_DESC = 'DISCHARGING_DURATION_OVERRIDE_DESC',
  DISCHARGING_END_ASC = 'DISCHARGING_END_ASC',
  DISCHARGING_END_DESC = 'DISCHARGING_END_DESC',
  DISCHARGING_SEA_DURATION_OVERRIDE_ASC = 'DISCHARGING_SEA_DURATION_OVERRIDE_ASC',
  DISCHARGING_SEA_DURATION_OVERRIDE_DESC = 'DISCHARGING_SEA_DURATION_OVERRIDE_DESC',
  DISCHARGING_START_ASC = 'DISCHARGING_START_ASC',
  DISCHARGING_START_DESC = 'DISCHARGING_START_DESC',
  DISCHARGING_START_OVERRIDE_ASC = 'DISCHARGING_START_OVERRIDE_ASC',
  DISCHARGING_START_OVERRIDE_DESC = 'DISCHARGING_START_OVERRIDE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_CONCURRENT_ASC = 'LOADING_CONCURRENT_ASC',
  LOADING_CONCURRENT_DESC = 'LOADING_CONCURRENT_DESC',
  LOADING_DURATION_ASC = 'LOADING_DURATION_ASC',
  LOADING_DURATION_DESC = 'LOADING_DURATION_DESC',
  LOADING_DURATION_OVERRIDE_ASC = 'LOADING_DURATION_OVERRIDE_ASC',
  LOADING_DURATION_OVERRIDE_DESC = 'LOADING_DURATION_OVERRIDE_DESC',
  LOADING_END_ASC = 'LOADING_END_ASC',
  LOADING_END_DESC = 'LOADING_END_DESC',
  LOADING_SEA_DURATION_OVERRIDE_ASC = 'LOADING_SEA_DURATION_OVERRIDE_ASC',
  LOADING_SEA_DURATION_OVERRIDE_DESC = 'LOADING_SEA_DURATION_OVERRIDE_DESC',
  LOADING_START_ASC = 'LOADING_START_ASC',
  LOADING_START_DESC = 'LOADING_START_DESC',
  LOADING_START_OVERRIDE_ASC = 'LOADING_START_OVERRIDE_ASC',
  LOADING_START_OVERRIDE_DESC = 'LOADING_START_OVERRIDE_DESC',
  LOCKED_ASC = 'LOCKED_ASC',
  LOCKED_DESC = 'LOCKED_DESC',
  META_ASC = 'META_ASC',
  META_DESC = 'META_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PLANNING_ORGANISATION_ID_ASC = 'PLANNING_ORGANISATION_ID_ASC',
  PLANNING_ORGANISATION_ID_DESC = 'PLANNING_ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type SeenMessage = Node & {
  __typename?: 'SeenMessage';
  /** Reads a single `Chat` that is related to this `SeenMessage`. */
  chatByChatId?: Maybe<Chat>;
  chatId: Scalars['ChatId']['output'];
  id: Scalars['SeenMessageId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `User` that is related to this `SeenMessage`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
};

/**
 * A condition to be used against `SeenMessage` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SeenMessageCondition = {
  /** Checks for equality with the object’s `chatId` field. */
  chatId?: InputMaybe<Scalars['ChatId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SeenMessageId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `SeenMessage` object types. All fields are combined with a logical ‘and.’ */
export type SeenMessageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SeenMessageFilter>>;
  /** Filter by the object’s `chatId` field. */
  chatId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SeenMessageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SeenMessageFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SeenMessage` */
export type SeenMessageInput = {
  chatId: Scalars['ChatId']['input'];
  userId: Scalars['UserId']['input'];
};

/** Represents an update to a `SeenMessage`. Fields that are set will be updated. */
export type SeenMessagePatch = {
  chatId?: InputMaybe<Scalars['ChatId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `SeenMessage` values. */
export type SeenMessagesConnection = {
  __typename?: 'SeenMessagesConnection';
  /** A list of edges which contains the `SeenMessage` and cursor to aid in pagination. */
  edges: Array<SeenMessagesEdge>;
  /** A list of `SeenMessage` objects. */
  nodes: Array<Maybe<SeenMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SeenMessage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SeenMessage` edge in the connection. */
export type SeenMessagesEdge = {
  __typename?: 'SeenMessagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SeenMessage` at the end of the edge. */
  node?: Maybe<SeenMessage>;
};

/** Methods to use when ordering `SeenMessage`. */
export enum SeenMessagesOrderBy {
  CHAT_ID_ASC = 'CHAT_ID_ASC',
  CHAT_ID_DESC = 'CHAT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type SenderOrganization = Node & {
  __typename?: 'SenderOrganization';
  adminOrganizationId: Scalars['OrganizationId']['output'];
  id: Scalars['SenderOrganizationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `SenderOrganization`. */
  organizationByAdminOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SenderOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
};

/**
 * A condition to be used against `SenderOrganization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SenderOrganizationCondition = {
  /** Checks for equality with the object’s `adminOrganizationId` field. */
  adminOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SenderOrganizationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `SenderOrganization` object types. All fields are combined with a logical ‘and.’ */
export type SenderOrganizationFilter = {
  /** Filter by the object’s `adminOrganizationId` field. */
  adminOrganizationId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SenderOrganizationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SenderOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SenderOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SenderOrganization` */
export type SenderOrganizationInput = {
  adminOrganizationId: Scalars['OrganizationId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** Represents an update to a `SenderOrganization`. Fields that are set will be updated. */
export type SenderOrganizationPatch = {
  adminOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `SenderOrganization` values. */
export type SenderOrganizationsConnection = {
  __typename?: 'SenderOrganizationsConnection';
  /** A list of edges which contains the `SenderOrganization` and cursor to aid in pagination. */
  edges: Array<SenderOrganizationsEdge>;
  /** A list of `SenderOrganization` objects. */
  nodes: Array<Maybe<SenderOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SenderOrganization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SenderOrganization` edge in the connection. */
export type SenderOrganizationsEdge = {
  __typename?: 'SenderOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SenderOrganization` at the end of the edge. */
  node?: Maybe<SenderOrganization>;
};

/** Methods to use when ordering `SenderOrganization`. */
export enum SenderOrganizationsOrderBy {
  ADMIN_ORGANIZATION_ID_ASC = 'ADMIN_ORGANIZATION_ID_ASC',
  ADMIN_ORGANIZATION_ID_DESC = 'ADMIN_ORGANIZATION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** All input for the `sendersReceiversListFromSessOrg` mutation. */
export type SendersReceiversListFromSessOrgInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `sendersReceiversListFromSessOrg` mutation. */
export type SendersReceiversListFromSessOrgPayload = {
  __typename?: 'SendersReceiversListFromSessOrgPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `setUserActivated` mutation. */
export type SetUserActivatedInput = {
  activated: Scalars['Boolean']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['Int']['input'];
};

/** The output of our `setUserActivated` mutation. */
export type SetUserActivatedPayload = {
  __typename?: 'SetUserActivatedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type SetupShipnetCoasResult = {
  __typename?: 'SetupShipnetCoasResult';
  status: Status;
};

/** All input for the `sharedListFromSessOrg` mutation. */
export type SharedListFromSessOrgInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `sharedListFromSessOrg` mutation. */
export type SharedListFromSessOrgPayload = {
  __typename?: 'SharedListFromSessOrgPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type ShincShex = {
  __typename?: 'ShincShex';
  fr?: Maybe<Scalars['Boolean']['output']>;
  ho?: Maybe<Scalars['Boolean']['output']>;
  incExUu?: Maybe<IncludedExcludedUnlessUsed>;
  mo?: Maybe<Scalars['Boolean']['output']>;
  sa?: Maybe<Scalars['Boolean']['output']>;
  su?: Maybe<Scalars['Boolean']['output']>;
  th?: Maybe<Scalars['Boolean']['output']>;
  tu?: Maybe<Scalars['Boolean']['output']>;
  we?: Maybe<Scalars['Boolean']['output']>;
};

/** A filter to be used against `ShincShex` object types. All fields are combined with a logical ‘and.’ */
export type ShincShexFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShincShexFilter>>;
  /** Filter by the object’s `fr` field. */
  fr?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `ho` field. */
  ho?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `incExUu` field. */
  incExUu?: InputMaybe<IncludedExcludedUnlessUsedFilter>;
  /** Filter by the object’s `mo` field. */
  mo?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShincShexFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShincShexFilter>>;
  /** Filter by the object’s `sa` field. */
  sa?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `su` field. */
  su?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `th` field. */
  th?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tu` field. */
  tu?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `we` field. */
  we?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `ShincShex` */
export type ShincShexInput = {
  fr?: InputMaybe<Scalars['Boolean']['input']>;
  ho?: InputMaybe<Scalars['Boolean']['input']>;
  incExUu?: InputMaybe<IncludedExcludedUnlessUsed>;
  mo?: InputMaybe<Scalars['Boolean']['input']>;
  sa?: InputMaybe<Scalars['Boolean']['input']>;
  su?: InputMaybe<Scalars['Boolean']['input']>;
  th?: InputMaybe<Scalars['Boolean']['input']>;
  tu?: InputMaybe<Scalars['Boolean']['input']>;
  we?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Ship = Node & {
  __typename?: 'Ship';
  airDraft?: Maybe<Scalars['BigFloat']['output']>;
  breadth?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `BunkerGradeOverride` that is related to this `Ship`. */
  bunkerGradeOverrideByDefaultBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads and enables pagination through a set of `Bunkering`. */
  bunkeringsByVesselId: BunkeringsConnection;
  callSign?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `CargoCompartment`. */
  cargoCompartmentsByShipId: CargoCompartmentsConnection;
  /** Reads and enables pagination through a set of `ChannelCostEstimate`. */
  channelCostEstimatesByVesselId: ChannelCostEstimatesConnection;
  /** Reads and enables pagination through a set of `ChannelCost`. */
  channelCostsByVesselId: ChannelCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractPortCost`. */
  coaContractPortCostsByShipId: CoaContractPortCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractPrice`. */
  coaContractPricesByShipId: CoaContractPricesConnection;
  /** Reads and enables pagination through a set of `CoaContractShip`. */
  coaContractShipsByShipId: CoaContractShipsConnection;
  /** Crane capacity of the vessel */
  craneCapacity?: Maybe<Scalars['BigFloat']['output']>;
  /** Clean shipping index score (0 - 150) */
  csiScore?: Maybe<Scalars['BigFloat']['output']>;
  /** Deck volume capacity of the vessel */
  deckVolumeCapacity?: Maybe<Scalars['BigFloat']['output']>;
  /** Default bunker grade for this vessel, used when resolving bunker grade for legs and port calls */
  defaultBunkerGradeId?: Maybe<Scalars['BunkerGradeOverrideId']['output']>;
  dischargingRate?: Maybe<Scalars['BigFloat']['output']>;
  dischargingUnit?: Maybe<LoadingUnit>;
  draft?: Maybe<Scalars['BigFloat']['output']>;
  enableConsecutiveCoaVoyages: Scalars['Boolean']['output'];
  /** Environmental ship index score (0.00 - 100.00) */
  esiScore?: Maybe<Scalars['BigFloat']['output']>;
  externalFleet?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `File`. */
  filesByVesselId: FilesConnection;
  flag?: Maybe<Scalars['String']['output']>;
  grossTonnage?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `HandledByCoaHistory`. */
  handledByCoaHistoriesByVesselId: HandledByCoaHistoriesConnection;
  /** Reads and enables pagination through a set of `HandledByCoa`. */
  handledByCoasByVesselId: HandledByCoasConnection;
  /** Reads and enables pagination through a set of `HandledBySpotHistory`. */
  handledBySpotHistoriesByVesselId: HandledBySpotHistoriesConnection;
  /** Reads and enables pagination through a set of `HandledBySpot`. */
  handledBySpotsByVesselId: HandledBySpotsConnection;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ShipId']['output'];
  imo?: Maybe<Scalars['BigFloat']['output']>;
  inSessionChildren?: Maybe<Scalars['Boolean']['output']>;
  inactive: Scalars['Boolean']['output'];
  insertedAt?: Maybe<Scalars['Datetime']['output']>;
  loa?: Maybe<Scalars['BigFloat']['output']>;
  loadingRate?: Maybe<Scalars['BigFloat']['output']>;
  loadingUnit?: Maybe<LoadingUnit>;
  /** Main engine capacity in kW */
  mainEngineCapacity?: Maybe<Scalars['BigFloat']['output']>;
  massCapacity?: Maybe<Scalars['BigFloat']['output']>;
  massUnit?: Maybe<WeightUnits>;
  mmsi?: Maybe<Scalars['BigFloat']['output']>;
  mtid?: Maybe<Scalars['Int']['output']>;
  mtname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netTonnage?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OffHire`. */
  offHiresByVesselId: OffHiresConnection;
  /** Reads and enables pagination through a set of `OpenPosition`. */
  openPositionsByVesselId: OpenPositionsConnection;
  /** Reads a single `Organization` that is related to this `Ship`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Ship`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `PortCall`. */
  portCallsByVesselId: PortCallsConnection;
  /** Reads and enables pagination through a set of `PortCostDefault`. */
  portCostDefaultsByVesselId: PortCostDefaultsConnection;
  /** Reads and enables pagination through a set of `PortCost`. */
  portCostsByVesselId: PortCostsConnection;
  primaryAttributeId?: Maybe<Scalars['VesselAttributeId']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  /** Vessel remarks/notes */
  remarks?: Maybe<Scalars['String']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `RouteOverride`. */
  routeOverridesByVesselId: RouteOverridesConnection;
  /** Reads and enables pagination through a set of `ScheduledOrder`. */
  scheduledOrdersByVesselId: ScheduledOrdersConnection;
  /** Reads and enables pagination through a set of `ShipVoyageNamingRuleRelation`. */
  shipVoyageNamingRuleRelationsByShipId: ShipVoyageNamingRuleRelationsConnection;
  shortName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `SingleEvent`. */
  singleEventsByVesselId: SingleEventsConnection;
  /** Sorting id to explicitly sort vessels in planning timeline */
  sortId?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `TcContract`. */
  tcContractsByVesselId: TcContractsConnection;
  tcRate?: Maybe<Scalars['BigFloat']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `Ship`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
  /** Reads and enables pagination through a set of `UserShip`. */
  userShipsByShipId: UserShipsConnection;
  /** Reads a single `VesselAttribute` that is related to this `Ship`. */
  vesselAttributeByPrimaryAttributeId?: Maybe<VesselAttribute>;
  /** Reads and enables pagination through a set of `VesselAttributesAssociation`. */
  vesselAttributesAssociationsByShipId: VesselAttributesAssociationsConnection;
  /** Reads and enables pagination through a set of `VesselDraftDatapoint`. */
  vesselDraftDatapointsByShipId: VesselDraftDatapointsConnection;
  /** Reads and enables pagination through a set of `VesselFulfillsRequirementAssociation`. */
  vesselFulfillsRequirementAssociationsByVesselId: VesselFulfillsRequirementAssociationsConnection;
  /** Reads a single `VesselInfo` that is related to this `Ship`. */
  vesselInfoByVesselInfoId?: Maybe<VesselInfo>;
  vesselInfoId?: Maybe<Scalars['VesselInfoId']['output']>;
  /** Reads and enables pagination through a set of `VesselPerformanceModel`. */
  vesselPerformanceModelsByShipId: VesselPerformanceModelsConnection;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  vesselReservationsByVesselId: VesselReservationsConnection;
  /** Reads and enables pagination through a set of `VesselScheduleSharedToOrganization`. */
  vesselScheduleSharedToOrganizationsByVesselId: VesselScheduleSharedToOrganizationsConnection;
  /** Reads and enables pagination through a set of `VesselSecret`. */
  vesselSecretsByVesselId: VesselSecretsConnection;
  /** Reads and enables pagination through a set of `VesselSpeedConsumption`. */
  vesselSpeedConsumptionsByShipId: VesselSpeedConsumptionsConnection;
  volumeCapacity?: Maybe<Scalars['BigFloat']['output']>;
  volumeUnit?: Maybe<VolumeUnits>;
  /** Reads and enables pagination through a set of `VoyageCharterHistory`. */
  voyageCharterHistoriesByVesselId: VoyageCharterHistoriesConnection;
  /** Reads and enables pagination through a set of `VoyageCharterUpdate`. */
  voyageCharterUpdatesByVesselId: VoyageCharterUpdatesConnection;
  /** Reads and enables pagination through a set of `VoyageCharter`. */
  voyageChartersByVesselId: VoyageChartersConnection;
  /** Reads and enables pagination through a set of `Voyage`. */
  voyagesByVesselId: VoyagesConnection;
  weightCapacity?: Maybe<Scalars['Int']['output']>;
  weightCapacityType?: Maybe<WeightCapacityType>;
  year?: Maybe<Scalars['Int']['output']>;
};


export type ShipBunkeringsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkeringCondition>;
  filter?: InputMaybe<BunkeringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkeringsOrderBy>>;
};


export type ShipCargoCompartmentsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentCondition>;
  filter?: InputMaybe<CargoCompartmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};


export type ShipChannelCostEstimatesByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostEstimateCondition>;
  filter?: InputMaybe<ChannelCostEstimateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
};


export type ShipChannelCostsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostCondition>;
  filter?: InputMaybe<ChannelCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostsOrderBy>>;
};


export type ShipCoaContractPortCostsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCostCondition>;
  filter?: InputMaybe<CoaContractPortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortCostsOrderBy>>;
};


export type ShipCoaContractPricesByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPriceCondition>;
  filter?: InputMaybe<CoaContractPriceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};


export type ShipCoaContractShipsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractShipCondition>;
  filter?: InputMaybe<CoaContractShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractShipsOrderBy>>;
};


export type ShipFilesByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type ShipHandledByCoaHistoriesByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaHistoryCondition>;
  filter?: InputMaybe<HandledByCoaHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoaHistoriesOrderBy>>;
};


export type ShipHandledByCoasByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaCondition>;
  filter?: InputMaybe<HandledByCoaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};


export type ShipHandledBySpotHistoriesByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotHistoryCondition>;
  filter?: InputMaybe<HandledBySpotHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotHistoriesOrderBy>>;
};


export type ShipHandledBySpotsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotCondition>;
  filter?: InputMaybe<HandledBySpotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};


export type ShipOffHiresByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireCondition>;
  filter?: InputMaybe<OffHireFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};


export type ShipOpenPositionsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionCondition>;
  filter?: InputMaybe<OpenPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};


export type ShipPortCallsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallCondition>;
  filter?: InputMaybe<PortCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};


export type ShipPortCostDefaultsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostDefaultCondition>;
  filter?: InputMaybe<PortCostDefaultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostDefaultsOrderBy>>;
};


export type ShipPortCostsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostCondition>;
  filter?: InputMaybe<PortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostsOrderBy>>;
};


export type ShipRouteOverridesByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteOverrideCondition>;
  filter?: InputMaybe<RouteOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};


export type ShipScheduledOrdersByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderCondition>;
  filter?: InputMaybe<ScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};


export type ShipShipVoyageNamingRuleRelationsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipVoyageNamingRuleRelationCondition>;
  filter?: InputMaybe<ShipVoyageNamingRuleRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipVoyageNamingRuleRelationsOrderBy>>;
};


export type ShipSingleEventsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventCondition>;
  filter?: InputMaybe<SingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};


export type ShipTcContractsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TcContractCondition>;
  filter?: InputMaybe<TcContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TcContractsOrderBy>>;
};


export type ShipUserShipsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserShipCondition>;
  filter?: InputMaybe<UserShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserShipsOrderBy>>;
};


export type ShipVesselAttributesAssociationsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributesAssociationCondition>;
  filter?: InputMaybe<VesselAttributesAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributesAssociationsOrderBy>>;
};


export type ShipVesselDraftDatapointsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselDraftDatapointCondition>;
  filter?: InputMaybe<VesselDraftDatapointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselDraftDatapointsOrderBy>>;
};


export type ShipVesselFulfillsRequirementAssociationsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselFulfillsRequirementAssociationCondition>;
  filter?: InputMaybe<VesselFulfillsRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
};


export type ShipVesselPerformanceModelsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselPerformanceModelCondition>;
  filter?: InputMaybe<VesselPerformanceModelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselPerformanceModelsOrderBy>>;
};


export type ShipVesselReservationsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};


export type ShipVesselScheduleSharedToOrganizationsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselScheduleSharedToOrganizationCondition>;
  filter?: InputMaybe<VesselScheduleSharedToOrganizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselScheduleSharedToOrganizationsOrderBy>>;
};


export type ShipVesselSecretsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSecretCondition>;
  filter?: InputMaybe<VesselSecretFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSecretsOrderBy>>;
};


export type ShipVesselSpeedConsumptionsByShipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSpeedConsumptionCondition>;
  filter?: InputMaybe<VesselSpeedConsumptionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSpeedConsumptionsOrderBy>>;
};


export type ShipVoyageCharterHistoriesByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterHistoryCondition>;
  filter?: InputMaybe<VoyageCharterHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterHistoriesOrderBy>>;
};


export type ShipVoyageCharterUpdatesByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterUpdateCondition>;
  filter?: InputMaybe<VoyageCharterUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};


export type ShipVoyageChartersByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterCondition>;
  filter?: InputMaybe<VoyageCharterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};


export type ShipVoyagesByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCondition>;
  filter?: InputMaybe<VoyageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyagesOrderBy>>;
};

/** A condition to be used against `Ship` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ShipCondition = {
  /** Checks for equality with the object’s `airDraft` field. */
  airDraft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `breadth` field. */
  breadth?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `callSign` field. */
  callSign?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `craneCapacity` field. */
  craneCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `csiScore` field. */
  csiScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `deckVolumeCapacity` field. */
  deckVolumeCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `defaultBunkerGradeId` field. */
  defaultBunkerGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  /** Checks for equality with the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `enableConsecutiveCoaVoyages` field. */
  enableConsecutiveCoaVoyages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `esiScore` field. */
  esiScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `externalFleet` field. */
  externalFleet?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flag` field. */
  flag?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `grossTonnage` field. */
  grossTonnage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `href` field. */
  href?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `imo` field. */
  imo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `inactive` field. */
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loa` field. */
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `mainEngineCapacity` field. */
  mainEngineCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `massCapacity` field. */
  massCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `massUnit` field. */
  massUnit?: InputMaybe<WeightUnits>;
  /** Checks for equality with the object’s `mmsi` field. */
  mmsi?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `mtid` field. */
  mtid?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `mtname` field. */
  mtname?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `netTonnage` field. */
  netTonnage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  /** Checks for equality with the object’s `public` field. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `remarks` field. */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shortName` field. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sortId` field. */
  sortId?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `tcRate` field. */
  tcRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselInfoId` field. */
  vesselInfoId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  /** Checks for equality with the object’s `volumeCapacity` field. */
  volumeCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `volumeUnit` field. */
  volumeUnit?: InputMaybe<VolumeUnits>;
  /** Checks for equality with the object’s `weightCapacity` field. */
  weightCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `weightCapacityType` field. */
  weightCapacityType?: InputMaybe<WeightCapacityType>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Ship` object types. All fields are combined with a logical ‘and.’ */
export type ShipFilter = {
  /** Filter by the object’s `airDraft` field. */
  airDraft?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipFilter>>;
  /** Filter by the object’s `breadth` field. */
  breadth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `callSign` field. */
  callSign?: InputMaybe<StringFilter>;
  /** Filter by the object’s `craneCapacity` field. */
  craneCapacity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `csiScore` field. */
  csiScore?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `deckVolumeCapacity` field. */
  deckVolumeCapacity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `defaultBunkerGradeId` field. */
  defaultBunkerGradeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `enableConsecutiveCoaVoyages` field. */
  enableConsecutiveCoaVoyages?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `esiScore` field. */
  esiScore?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `externalFleet` field. */
  externalFleet?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flag` field. */
  flag?: InputMaybe<StringFilter>;
  /** Filter by the object’s `grossTonnage` field. */
  grossTonnage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `href` field. */
  href?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imo` field. */
  imo?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `inSessionChildren` field. */
  inSessionChildren?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `inactive` field. */
  inactive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loa` field. */
  loa?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `mainEngineCapacity` field. */
  mainEngineCapacity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `massCapacity` field. */
  massCapacity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `massUnit` field. */
  massUnit?: InputMaybe<WeightUnitsFilter>;
  /** Filter by the object’s `mmsi` field. */
  mmsi?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `mtid` field. */
  mtid?: InputMaybe<IntFilter>;
  /** Filter by the object’s `mtname` field. */
  mtname?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `netTonnage` field. */
  netTonnage?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `primaryAttributeId` field. */
  primaryAttributeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `public` field. */
  public?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `remarks` field. */
  remarks?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shortName` field. */
  shortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sortId` field. */
  sortId?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `tcRate` field. */
  tcRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselInfoId` field. */
  vesselInfoId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `volumeCapacity` field. */
  volumeCapacity?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `volumeUnit` field. */
  volumeUnit?: InputMaybe<VolumeUnitsFilter>;
  /** Filter by the object’s `weightCapacity` field. */
  weightCapacity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `weightCapacityType` field. */
  weightCapacityType?: InputMaybe<WeightCapacityTypeFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Ship` */
export type ShipInput = {
  airDraft?: InputMaybe<Scalars['BigFloat']['input']>;
  breadth?: InputMaybe<Scalars['BigFloat']['input']>;
  callSign?: InputMaybe<Scalars['String']['input']>;
  /** Crane capacity of the vessel */
  craneCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Clean shipping index score (0 - 150) */
  csiScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Deck volume capacity of the vessel */
  deckVolumeCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Default bunker grade for this vessel, used when resolving bunker grade for legs and port calls */
  defaultBunkerGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingUnit?: InputMaybe<LoadingUnit>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  enableConsecutiveCoaVoyages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Environmental ship index score (0.00 - 100.00) */
  esiScore?: InputMaybe<Scalars['BigFloat']['input']>;
  externalFleet?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  grossTonnage?: InputMaybe<Scalars['BigFloat']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  imo?: InputMaybe<Scalars['BigFloat']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingUnit?: InputMaybe<LoadingUnit>;
  /** Main engine capacity in kW */
  mainEngineCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  massCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  massUnit?: InputMaybe<WeightUnits>;
  mmsi?: InputMaybe<Scalars['BigFloat']['input']>;
  mtid?: InputMaybe<Scalars['Int']['input']>;
  mtname?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  netTonnage?: InputMaybe<Scalars['BigFloat']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  primaryAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vessel remarks/notes */
  remarks?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Sorting id to explicitly sort vessels in planning timeline */
  sortId?: InputMaybe<Scalars['BigFloat']['input']>;
  tcRate?: InputMaybe<Scalars['BigFloat']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselInfoId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  volumeCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  volumeUnit?: InputMaybe<VolumeUnits>;
  weightCapacity?: InputMaybe<Scalars['Int']['input']>;
  weightCapacityType?: InputMaybe<WeightCapacityType>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `Ship`. Fields that are set will be updated. */
export type ShipPatch = {
  airDraft?: InputMaybe<Scalars['BigFloat']['input']>;
  breadth?: InputMaybe<Scalars['BigFloat']['input']>;
  callSign?: InputMaybe<Scalars['String']['input']>;
  /** Crane capacity of the vessel */
  craneCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Clean shipping index score (0 - 150) */
  csiScore?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Deck volume capacity of the vessel */
  deckVolumeCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Default bunker grade for this vessel, used when resolving bunker grade for legs and port calls */
  defaultBunkerGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingUnit?: InputMaybe<LoadingUnit>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  enableConsecutiveCoaVoyages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Environmental ship index score (0.00 - 100.00) */
  esiScore?: InputMaybe<Scalars['BigFloat']['input']>;
  externalFleet?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['String']['input']>;
  grossTonnage?: InputMaybe<Scalars['BigFloat']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  imo?: InputMaybe<Scalars['BigFloat']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingUnit?: InputMaybe<LoadingUnit>;
  /** Main engine capacity in kW */
  mainEngineCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  massCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  massUnit?: InputMaybe<WeightUnits>;
  mmsi?: InputMaybe<Scalars['BigFloat']['input']>;
  mtid?: InputMaybe<Scalars['Int']['input']>;
  mtname?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  netTonnage?: InputMaybe<Scalars['BigFloat']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  primaryAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vessel remarks/notes */
  remarks?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Sorting id to explicitly sort vessels in planning timeline */
  sortId?: InputMaybe<Scalars['BigFloat']['input']>;
  tcRate?: InputMaybe<Scalars['BigFloat']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselInfoId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  volumeCapacity?: InputMaybe<Scalars['BigFloat']['input']>;
  volumeUnit?: InputMaybe<VolumeUnits>;
  weightCapacity?: InputMaybe<Scalars['Int']['input']>;
  weightCapacityType?: InputMaybe<WeightCapacityType>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ShipSubscriptionPayload = {
  __typename?: 'ShipSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  ship?: Maybe<Ship>;
};

export type ShipVoyageNamingRuleRelation = Node & {
  __typename?: 'ShipVoyageNamingRuleRelation';
  id: Scalars['ShipVoyageNamingRuleRelationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  ruleId: Scalars['VoyageNamingRuleId']['output'];
  /** Reads a single `Ship` that is related to this `ShipVoyageNamingRuleRelation`. */
  shipByShipId?: Maybe<Ship>;
  shipId: Scalars['ShipId']['output'];
  /** Reads a single `VoyageNamingRule` that is related to this `ShipVoyageNamingRuleRelation`. */
  voyageNamingRuleByRuleId?: Maybe<VoyageNamingRule>;
};

/**
 * A condition to be used against `ShipVoyageNamingRuleRelation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ShipVoyageNamingRuleRelationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ShipVoyageNamingRuleRelationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ruleId` field. */
  ruleId?: InputMaybe<Scalars['VoyageNamingRuleId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `ShipVoyageNamingRuleRelation` object types. All fields are combined with a logical ‘and.’ */
export type ShipVoyageNamingRuleRelationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipVoyageNamingRuleRelationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipVoyageNamingRuleRelationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipVoyageNamingRuleRelationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ruleId` field. */
  ruleId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ShipVoyageNamingRuleRelation` */
export type ShipVoyageNamingRuleRelationInput = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  ruleId: Scalars['VoyageNamingRuleId']['input'];
  shipId: Scalars['ShipId']['input'];
};

/** Represents an update to a `ShipVoyageNamingRuleRelation`. Fields that are set will be updated. */
export type ShipVoyageNamingRuleRelationPatch = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  ruleId?: InputMaybe<Scalars['VoyageNamingRuleId']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type ShipVoyageNamingRuleRelationSubscriptionPayload = {
  __typename?: 'ShipVoyageNamingRuleRelationSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  shipVoyageNamingRuleRelation?: Maybe<ShipVoyageNamingRuleRelation>;
};

/** A connection to a list of `ShipVoyageNamingRuleRelation` values. */
export type ShipVoyageNamingRuleRelationsConnection = {
  __typename?: 'ShipVoyageNamingRuleRelationsConnection';
  /** A list of edges which contains the `ShipVoyageNamingRuleRelation` and cursor to aid in pagination. */
  edges: Array<ShipVoyageNamingRuleRelationsEdge>;
  /** A list of `ShipVoyageNamingRuleRelation` objects. */
  nodes: Array<Maybe<ShipVoyageNamingRuleRelation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShipVoyageNamingRuleRelation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ShipVoyageNamingRuleRelation` edge in the connection. */
export type ShipVoyageNamingRuleRelationsEdge = {
  __typename?: 'ShipVoyageNamingRuleRelationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ShipVoyageNamingRuleRelation` at the end of the edge. */
  node?: Maybe<ShipVoyageNamingRuleRelation>;
};

/** Methods to use when ordering `ShipVoyageNamingRuleRelation`. */
export enum ShipVoyageNamingRuleRelationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RULE_ID_ASC = 'RULE_ID_ASC',
  RULE_ID_DESC = 'RULE_ID_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC'
}

export type Shipment = Node & {
  __typename?: 'Shipment';
  chartererOrganisation?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `Chat`. */
  chatsByShipmentId: ChatsConnection;
  clientId: Scalars['UUID']['output'];
  externalShipmentId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `File`. */
  filesByShipmentId: FilesConnection;
  id: Scalars['ShipmentId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `NotificationReceiver`. */
  notificationReceiversByShipmentId: NotificationReceiversConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByShipmentId: OrdersConnection;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByChartererOrganisation?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByOwnerOrganisation?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByRootOrg?: Maybe<Organization>;
  ownerOrganisation?: Maybe<Scalars['OrganizationId']['output']>;
  /** Shipment remarks/notes */
  remarks?: Maybe<Scalars['String']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `ShipmentExternalStatus`. */
  shipmentExternalStatusesByShipmentId: ShipmentExternalStatusesConnection;
  /** Reads and enables pagination through a set of `ShipmentExtraFreight`. */
  shipmentExtraFreightsByShipmentId: ShipmentExtraFreightsConnection;
  /** Reads a single `ShipmentFreight` that is related to this `Shipment`. */
  shipmentFreightByShipmentId?: Maybe<ShipmentFreight>;
  /**
   * Reads and enables pagination through a set of `ShipmentFreight`.
   * @deprecated Please use shipmentFreightByShipmentId instead
   */
  shipmentFreightsByShipmentId: ShipmentFreightsConnection;
  /** Reads and enables pagination through a set of `ShipmentGroupAssociation`. */
  shipmentGroupAssociationsByShipmentId: ShipmentGroupAssociationsConnection;
  /** Defines if a shipment is soft deleted or not through integration API on integration.headers.deletionindicator */
  softDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `Shipment`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Shipment`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  /** Reads a single `VoyageAttribute` that is related to this `Shipment`. */
  voyageAttributeByVoyageAttributeId?: Maybe<VoyageAttribute>;
  voyageAttributeId?: Maybe<Scalars['VoyageAttributeId']['output']>;
};


export type ShipmentChatsByShipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChatCondition>;
  filter?: InputMaybe<ChatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};


export type ShipmentFilesByShipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type ShipmentNotificationReceiversByShipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationReceiverCondition>;
  filter?: InputMaybe<NotificationReceiverFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};


export type ShipmentOrdersByShipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type ShipmentShipmentExternalStatusesByShipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentExternalStatusCondition>;
  filter?: InputMaybe<ShipmentExternalStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentExternalStatusesOrderBy>>;
};


export type ShipmentShipmentExtraFreightsByShipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentExtraFreightCondition>;
  filter?: InputMaybe<ShipmentExtraFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentExtraFreightsOrderBy>>;
};


export type ShipmentShipmentFreightsByShipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentFreightCondition>;
  filter?: InputMaybe<ShipmentFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentFreightsOrderBy>>;
};


export type ShipmentShipmentGroupAssociationsByShipmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentGroupAssociationCondition>;
  filter?: InputMaybe<ShipmentGroupAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentGroupAssociationsOrderBy>>;
};

/**
 * A condition to be used against `Shipment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ShipmentCondition = {
  /** Checks for equality with the object’s `chartererOrganisation` field. */
  chartererOrganisation?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownerOrganisation` field. */
  ownerOrganisation?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `remarks` field. */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `softDelete` field. */
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `voyageAttributeId` field. */
  voyageAttributeId?: InputMaybe<Scalars['VoyageAttributeId']['input']>;
};

export type ShipmentExternalStatus = Node & {
  __typename?: 'ShipmentExternalStatus';
  id: Scalars['ShipmentExternalStatusId']['output'];
  isAccepted: Scalars['Boolean']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId: Scalars['Int']['output'];
  /** User that added or modified the record */
  modifiedByUserId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  /** Reads a single `Shipment` that is related to this `ShipmentExternalStatus`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  shipmentId: Scalars['ShipmentId']['output'];
  sourceId?: Maybe<Scalars['String']['output']>;
  status: ShipmentStatus;
  sysPeriod: DatetimeRange;
};

/**
 * A condition to be used against `ShipmentExternalStatus` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ShipmentExternalStatusCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ShipmentExternalStatusId']['input']>;
  /** Checks for equality with the object’s `isAccepted` field. */
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ShipmentStatus>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `ShipmentExternalStatus` object types. All fields are combined with a logical ‘and.’ */
export type ShipmentExternalStatusFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipmentExternalStatusFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isAccepted` field. */
  isAccepted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipmentExternalStatusFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipmentExternalStatusFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ShipmentStatusFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** An input for mutations affecting `ShipmentExternalStatus` */
export type ShipmentExternalStatusInput = {
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentId: Scalars['ShipmentId']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status: ShipmentStatus;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** Represents an update to a `ShipmentExternalStatus`. Fields that are set will be updated. */
export type ShipmentExternalStatusPatch = {
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A connection to a list of `ShipmentExternalStatus` values. */
export type ShipmentExternalStatusesConnection = {
  __typename?: 'ShipmentExternalStatusesConnection';
  /** A list of edges which contains the `ShipmentExternalStatus` and cursor to aid in pagination. */
  edges: Array<ShipmentExternalStatusesEdge>;
  /** A list of `ShipmentExternalStatus` objects. */
  nodes: Array<Maybe<ShipmentExternalStatus>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShipmentExternalStatus` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ShipmentExternalStatus` edge in the connection. */
export type ShipmentExternalStatusesEdge = {
  __typename?: 'ShipmentExternalStatusesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ShipmentExternalStatus` at the end of the edge. */
  node?: Maybe<ShipmentExternalStatus>;
};

/** Methods to use when ordering `ShipmentExternalStatus`. */
export enum ShipmentExternalStatusesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ACCEPTED_ASC = 'IS_ACCEPTED_ASC',
  IS_ACCEPTED_DESC = 'IS_ACCEPTED_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  SOURCE_ID_ASC = 'SOURCE_ID_ASC',
  SOURCE_ID_DESC = 'SOURCE_ID_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC'
}

export type ShipmentExtraFreight = Node & {
  __typename?: 'ShipmentExtraFreight';
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  freightAmount: Scalars['BigFloat']['output'];
  freightUnit: PaymentUnit;
  id: Scalars['ShipmentExtraFreightId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId: Scalars['Int']['output'];
  /** User that added or modified the record */
  modifiedByUserId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  /** Reads a single `Shipment` that is related to this `ShipmentExtraFreight`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  shipmentId: Scalars['ShipmentId']['output'];
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `ShipmentExtraFreight` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ShipmentExtraFreightCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ShipmentExtraFreightId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ShipmentExtraFreight` object types. All fields are combined with a logical ‘and.’ */
export type ShipmentExtraFreightFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipmentExtraFreightFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipmentExtraFreightFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipmentExtraFreightFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ShipmentExtraFreight` */
export type ShipmentExtraFreightInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freightAmount: Scalars['BigFloat']['input'];
  freightUnit: PaymentUnit;
  name?: InputMaybe<Scalars['String']['input']>;
  shipmentId: Scalars['ShipmentId']['input'];
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `ShipmentExtraFreight`. Fields that are set will be updated. */
export type ShipmentExtraFreightPatch = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightUnit?: InputMaybe<PaymentUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `ShipmentExtraFreight` values. */
export type ShipmentExtraFreightsConnection = {
  __typename?: 'ShipmentExtraFreightsConnection';
  /** A list of edges which contains the `ShipmentExtraFreight` and cursor to aid in pagination. */
  edges: Array<ShipmentExtraFreightsEdge>;
  /** A list of `ShipmentExtraFreight` objects. */
  nodes: Array<Maybe<ShipmentExtraFreight>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShipmentExtraFreight` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ShipmentExtraFreight` edge in the connection. */
export type ShipmentExtraFreightsEdge = {
  __typename?: 'ShipmentExtraFreightsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ShipmentExtraFreight` at the end of the edge. */
  node?: Maybe<ShipmentExtraFreight>;
};

/** Methods to use when ordering `ShipmentExtraFreight`. */
export enum ShipmentExtraFreightsOrderBy {
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

/** A filter to be used against `Shipment` object types. All fields are combined with a logical ‘and.’ */
export type ShipmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipmentFilter>>;
  /** Filter by the object’s `chartererOrganisation` field. */
  chartererOrganisation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipmentFilter>>;
  /** Filter by the object’s `ownerOrganisation` field. */
  ownerOrganisation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `remarks` field. */
  remarks?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softDelete` field. */
  softDelete?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageAttributeId` field. */
  voyageAttributeId?: InputMaybe<IntFilter>;
};

export type ShipmentFreight = Node & {
  __typename?: 'ShipmentFreight';
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  freightAmount: Scalars['BigFloat']['output'];
  freightUnit: PaymentUnit;
  id: Scalars['ShipmentFreightId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId: Scalars['Int']['output'];
  /** User that added or modified the record */
  modifiedByUserId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  /** Reads a single `Shipment` that is related to this `ShipmentFreight`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  shipmentId: Scalars['ShipmentId']['output'];
  sysPeriod: DatetimeRange;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `ShipmentFreight` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ShipmentFreightCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ShipmentFreightId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ShipmentFreight` object types. All fields are combined with a logical ‘and.’ */
export type ShipmentFreightFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipmentFreightFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipmentFreightFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipmentFreightFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ShipmentFreight` */
export type ShipmentFreightInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  freightAmount: Scalars['BigFloat']['input'];
  freightUnit: PaymentUnit;
  shipmentId: Scalars['ShipmentId']['input'];
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `ShipmentFreight`. Fields that are set will be updated. */
export type ShipmentFreightPatch = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightUnit?: InputMaybe<PaymentUnit>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `ShipmentFreight` values. */
export type ShipmentFreightsConnection = {
  __typename?: 'ShipmentFreightsConnection';
  /** A list of edges which contains the `ShipmentFreight` and cursor to aid in pagination. */
  edges: Array<ShipmentFreightsEdge>;
  /** A list of `ShipmentFreight` objects. */
  nodes: Array<Maybe<ShipmentFreight>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShipmentFreight` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ShipmentFreight` edge in the connection. */
export type ShipmentFreightsEdge = {
  __typename?: 'ShipmentFreightsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ShipmentFreight` at the end of the edge. */
  node?: Maybe<ShipmentFreight>;
};

/** Methods to use when ordering `ShipmentFreight`. */
export enum ShipmentFreightsOrderBy {
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type ShipmentGroup = Node & {
  __typename?: 'ShipmentGroup';
  id: Scalars['ShipmentGroupId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['OrganizationId']['output'];
  /** Reads a single `Organization` that is related to this `ShipmentGroup`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads and enables pagination through a set of `ShipmentGroupAssociation`. */
  shipmentGroupAssociationsByShipmentGroupId: ShipmentGroupAssociationsConnection;
};


export type ShipmentGroupShipmentGroupAssociationsByShipmentGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentGroupAssociationCondition>;
  filter?: InputMaybe<ShipmentGroupAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentGroupAssociationsOrderBy>>;
};

export type ShipmentGroupAssociation = Node & {
  __typename?: 'ShipmentGroupAssociation';
  id: Scalars['ShipmentGroupAssociationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Shipment` that is related to this `ShipmentGroupAssociation`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `ShipmentGroup` that is related to this `ShipmentGroupAssociation`. */
  shipmentGroupByShipmentGroupId?: Maybe<ShipmentGroup>;
  shipmentGroupId: Scalars['ShipmentGroupId']['output'];
  shipmentId: Scalars['ShipmentId']['output'];
};

/**
 * A condition to be used against `ShipmentGroupAssociation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ShipmentGroupAssociationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ShipmentGroupAssociationId']['input']>;
  /** Checks for equality with the object’s `shipmentGroupId` field. */
  shipmentGroupId?: InputMaybe<Scalars['ShipmentGroupId']['input']>;
  /** Checks for equality with the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
};

/** A filter to be used against `ShipmentGroupAssociation` object types. All fields are combined with a logical ‘and.’ */
export type ShipmentGroupAssociationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipmentGroupAssociationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipmentGroupAssociationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipmentGroupAssociationFilter>>;
  /** Filter by the object’s `shipmentGroupId` field. */
  shipmentGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipmentId` field. */
  shipmentId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ShipmentGroupAssociation` */
export type ShipmentGroupAssociationInput = {
  shipmentGroupId: Scalars['ShipmentGroupId']['input'];
  shipmentId: Scalars['ShipmentId']['input'];
};

/** Represents an update to a `ShipmentGroupAssociation`. Fields that are set will be updated. */
export type ShipmentGroupAssociationPatch = {
  shipmentGroupId?: InputMaybe<Scalars['ShipmentGroupId']['input']>;
  shipmentId?: InputMaybe<Scalars['ShipmentId']['input']>;
};

/** A connection to a list of `ShipmentGroupAssociation` values. */
export type ShipmentGroupAssociationsConnection = {
  __typename?: 'ShipmentGroupAssociationsConnection';
  /** A list of edges which contains the `ShipmentGroupAssociation` and cursor to aid in pagination. */
  edges: Array<ShipmentGroupAssociationsEdge>;
  /** A list of `ShipmentGroupAssociation` objects. */
  nodes: Array<Maybe<ShipmentGroupAssociation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShipmentGroupAssociation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ShipmentGroupAssociation` edge in the connection. */
export type ShipmentGroupAssociationsEdge = {
  __typename?: 'ShipmentGroupAssociationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ShipmentGroupAssociation` at the end of the edge. */
  node?: Maybe<ShipmentGroupAssociation>;
};

/** Methods to use when ordering `ShipmentGroupAssociation`. */
export enum ShipmentGroupAssociationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHIPMENT_GROUP_ID_ASC = 'SHIPMENT_GROUP_ID_ASC',
  SHIPMENT_GROUP_ID_DESC = 'SHIPMENT_GROUP_ID_DESC',
  SHIPMENT_ID_ASC = 'SHIPMENT_ID_ASC',
  SHIPMENT_ID_DESC = 'SHIPMENT_ID_DESC'
}

/**
 * A condition to be used against `ShipmentGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ShipmentGroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ShipmentGroupId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `ShipmentGroup` object types. All fields are combined with a logical ‘and.’ */
export type ShipmentGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipmentGroupFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipmentGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipmentGroupFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ShipmentGroup` */
export type ShipmentGroupInput = {
  name: Scalars['String']['input'];
  organisationId: Scalars['OrganizationId']['input'];
};

/** Represents an update to a `ShipmentGroup`. Fields that are set will be updated. */
export type ShipmentGroupPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `ShipmentGroup` values. */
export type ShipmentGroupsConnection = {
  __typename?: 'ShipmentGroupsConnection';
  /** A list of edges which contains the `ShipmentGroup` and cursor to aid in pagination. */
  edges: Array<ShipmentGroupsEdge>;
  /** A list of `ShipmentGroup` objects. */
  nodes: Array<Maybe<ShipmentGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShipmentGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ShipmentGroup` edge in the connection. */
export type ShipmentGroupsEdge = {
  __typename?: 'ShipmentGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ShipmentGroup` at the end of the edge. */
  node?: Maybe<ShipmentGroup>;
};

/** Methods to use when ordering `ShipmentGroup`. */
export enum ShipmentGroupsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `ShipmentHistory` values. */
export type ShipmentHistoriesConnection = {
  __typename?: 'ShipmentHistoriesConnection';
  /** A list of edges which contains the `ShipmentHistory` and cursor to aid in pagination. */
  edges: Array<ShipmentHistoriesEdge>;
  /** A list of `ShipmentHistory` objects. */
  nodes: Array<Maybe<ShipmentHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShipmentHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ShipmentHistory` edge in the connection. */
export type ShipmentHistoriesEdge = {
  __typename?: 'ShipmentHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ShipmentHistory` at the end of the edge. */
  node?: Maybe<ShipmentHistory>;
};

/** Methods to use when ordering `ShipmentHistory`. */
export enum ShipmentHistoriesOrderBy {
  CHARTERER_ORGANISATION_ASC = 'CHARTERER_ORGANISATION_ASC',
  CHARTERER_ORGANISATION_DESC = 'CHARTERER_ORGANISATION_DESC',
  EXTERNAL_SHIPMENT_ID_ASC = 'EXTERNAL_SHIPMENT_ID_ASC',
  EXTERNAL_SHIPMENT_ID_DESC = 'EXTERNAL_SHIPMENT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  OWNER_ORGANISATION_ASC = 'OWNER_ORGANISATION_ASC',
  OWNER_ORGANISATION_DESC = 'OWNER_ORGANISATION_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SOFT_DELETE_ASC = 'SOFT_DELETE_ASC',
  SOFT_DELETE_DESC = 'SOFT_DELETE_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** History log for this table */
export type ShipmentHistory = {
  __typename?: 'ShipmentHistory';
  chartererOrganisation?: Maybe<Scalars['Int']['output']>;
  externalShipmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  ownerOrganisation?: Maybe<Scalars['Int']['output']>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  softDelete?: Maybe<Scalars['Boolean']['output']>;
  sysPeriod: DatetimeRange;
  userId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `ShipmentHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ShipmentHistoryCondition = {
  /** Checks for equality with the object’s `chartererOrganisation` field. */
  chartererOrganisation?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownerOrganisation` field. */
  ownerOrganisation?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `softDelete` field. */
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ShipmentHistory` object types. All fields are combined with a logical ‘and.’ */
export type ShipmentHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShipmentHistoryFilter>>;
  /** Filter by the object’s `chartererOrganisation` field. */
  chartererOrganisation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `externalShipmentId` field. */
  externalShipmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShipmentHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShipmentHistoryFilter>>;
  /** Filter by the object’s `ownerOrganisation` field. */
  ownerOrganisation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `softDelete` field. */
  softDelete?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Shipment` */
export type ShipmentInput = {
  chartererOrganisation?: InputMaybe<Scalars['OrganizationId']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerOrganisation?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Shipment remarks/notes */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Defines if a shipment is soft deleted or not through integration API on integration.headers.deletionindicator */
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['UserId']['input'];
  voyageAttributeId?: InputMaybe<Scalars['VoyageAttributeId']['input']>;
};

/** Represents an update to a `Shipment`. Fields that are set will be updated. */
export type ShipmentPatch = {
  chartererOrganisation?: InputMaybe<Scalars['OrganizationId']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  externalShipmentId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerOrganisation?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Shipment remarks/notes */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Defines if a shipment is soft deleted or not through integration API on integration.headers.deletionindicator */
  softDelete?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  voyageAttributeId?: InputMaybe<Scalars['VoyageAttributeId']['input']>;
};

export enum ShipmentStatus {
  COMPLETED = 'COMPLETED',
  DELETED = 'DELETED',
  GENERATED = 'GENERATED',
  OPERATIONAL = 'OPERATIONAL'
}

/** A filter to be used against ShipmentStatus fields. All fields are combined with a logical ‘and.’ */
export type ShipmentStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ShipmentStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ShipmentStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ShipmentStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ShipmentStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ShipmentStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ShipmentStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ShipmentStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ShipmentStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ShipmentStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ShipmentStatus>>;
};

export type ShipmentSubscriptionPayload = {
  __typename?: 'ShipmentSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  shipment?: Maybe<Shipment>;
};

/** A connection to a list of `Shipment` values. */
export type ShipmentsConnection = {
  __typename?: 'ShipmentsConnection';
  /** A list of edges which contains the `Shipment` and cursor to aid in pagination. */
  edges: Array<ShipmentsEdge>;
  /** A list of `Shipment` objects. */
  nodes: Array<Maybe<Shipment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Shipment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Shipment` edge in the connection. */
export type ShipmentsEdge = {
  __typename?: 'ShipmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Shipment` at the end of the edge. */
  node?: Maybe<Shipment>;
};

/** Methods to use when ordering `Shipment`. */
export enum ShipmentsOrderBy {
  CHARTERER_ORGANISATION_ASC = 'CHARTERER_ORGANISATION_ASC',
  CHARTERER_ORGANISATION_DESC = 'CHARTERER_ORGANISATION_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  EXTERNAL_SHIPMENT_ID_ASC = 'EXTERNAL_SHIPMENT_ID_ASC',
  EXTERNAL_SHIPMENT_ID_DESC = 'EXTERNAL_SHIPMENT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  OWNER_ORGANISATION_ASC = 'OWNER_ORGANISATION_ASC',
  OWNER_ORGANISATION_DESC = 'OWNER_ORGANISATION_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMARKS_ASC = 'REMARKS_ASC',
  REMARKS_DESC = 'REMARKS_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SOFT_DELETE_ASC = 'SOFT_DELETE_ASC',
  SOFT_DELETE_DESC = 'SOFT_DELETE_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VOYAGE_ATTRIBUTE_ID_ASC = 'VOYAGE_ATTRIBUTE_ID_ASC',
  VOYAGE_ATTRIBUTE_ID_DESC = 'VOYAGE_ATTRIBUTE_ID_DESC'
}

export type ShipnetConfig = {
  __typename?: 'ShipnetConfig';
  authorizeKey: Scalars['String']['output'];
  bookingListEndpoint?: Maybe<Scalars['String']['output']>;
  hasShipnetFeature: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  ignorePorts?: Maybe<Array<Scalars['String']['output']>>;
  integrationUserId: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  loggingEndpoint?: Maybe<Scalars['String']['output']>;
  operationalVoyageEndpoint?: Maybe<Scalars['String']['output']>;
  orderEndpoint?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['Int']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  portCallEndpoint: Scalars['String']['output'];
  refreshOrderEndpoint?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['Int']['output'];
  setupCoaEndpoint?: Maybe<Scalars['String']['output']>;
  updateDateEndpoint?: Maybe<Scalars['String']['output']>;
};

export type ShipnetConfigPayload = {
  __typename?: 'ShipnetConfigPayload';
  shipnetConfig?: Maybe<ShipnetConfig>;
};

/** A connection to a list of `Ship` values. */
export type ShipsConnection = {
  __typename?: 'ShipsConnection';
  /** A list of edges which contains the `Ship` and cursor to aid in pagination. */
  edges: Array<ShipsEdge>;
  /** A list of `Ship` objects. */
  nodes: Array<Maybe<Ship>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Ship` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Ship` edge in the connection. */
export type ShipsEdge = {
  __typename?: 'ShipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Ship` at the end of the edge. */
  node?: Maybe<Ship>;
};

/** Methods to use when ordering `Ship`. */
export enum ShipsOrderBy {
  AIR_DRAFT_ASC = 'AIR_DRAFT_ASC',
  AIR_DRAFT_DESC = 'AIR_DRAFT_DESC',
  BREADTH_ASC = 'BREADTH_ASC',
  BREADTH_DESC = 'BREADTH_DESC',
  CALL_SIGN_ASC = 'CALL_SIGN_ASC',
  CALL_SIGN_DESC = 'CALL_SIGN_DESC',
  CRANE_CAPACITY_ASC = 'CRANE_CAPACITY_ASC',
  CRANE_CAPACITY_DESC = 'CRANE_CAPACITY_DESC',
  CSI_SCORE_ASC = 'CSI_SCORE_ASC',
  CSI_SCORE_DESC = 'CSI_SCORE_DESC',
  DECK_VOLUME_CAPACITY_ASC = 'DECK_VOLUME_CAPACITY_ASC',
  DECK_VOLUME_CAPACITY_DESC = 'DECK_VOLUME_CAPACITY_DESC',
  DEFAULT_BUNKER_GRADE_ID_ASC = 'DEFAULT_BUNKER_GRADE_ID_ASC',
  DEFAULT_BUNKER_GRADE_ID_DESC = 'DEFAULT_BUNKER_GRADE_ID_DESC',
  DISCHARGING_RATE_ASC = 'DISCHARGING_RATE_ASC',
  DISCHARGING_RATE_DESC = 'DISCHARGING_RATE_DESC',
  DISCHARGING_UNIT_ASC = 'DISCHARGING_UNIT_ASC',
  DISCHARGING_UNIT_DESC = 'DISCHARGING_UNIT_DESC',
  DRAFT_ASC = 'DRAFT_ASC',
  DRAFT_DESC = 'DRAFT_DESC',
  ENABLE_CONSECUTIVE_COA_VOYAGES_ASC = 'ENABLE_CONSECUTIVE_COA_VOYAGES_ASC',
  ENABLE_CONSECUTIVE_COA_VOYAGES_DESC = 'ENABLE_CONSECUTIVE_COA_VOYAGES_DESC',
  ESI_SCORE_ASC = 'ESI_SCORE_ASC',
  ESI_SCORE_DESC = 'ESI_SCORE_DESC',
  EXTERNAL_FLEET_ASC = 'EXTERNAL_FLEET_ASC',
  EXTERNAL_FLEET_DESC = 'EXTERNAL_FLEET_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  FLAG_ASC = 'FLAG_ASC',
  FLAG_DESC = 'FLAG_DESC',
  GROSS_TONNAGE_ASC = 'GROSS_TONNAGE_ASC',
  GROSS_TONNAGE_DESC = 'GROSS_TONNAGE_DESC',
  HREF_ASC = 'HREF_ASC',
  HREF_DESC = 'HREF_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IMO_ASC = 'IMO_ASC',
  IMO_DESC = 'IMO_DESC',
  INACTIVE_ASC = 'INACTIVE_ASC',
  INACTIVE_DESC = 'INACTIVE_DESC',
  INSERTED_AT_ASC = 'INSERTED_AT_ASC',
  INSERTED_AT_DESC = 'INSERTED_AT_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  LOADING_UNIT_ASC = 'LOADING_UNIT_ASC',
  LOADING_UNIT_DESC = 'LOADING_UNIT_DESC',
  LOA_ASC = 'LOA_ASC',
  LOA_DESC = 'LOA_DESC',
  MAIN_ENGINE_CAPACITY_ASC = 'MAIN_ENGINE_CAPACITY_ASC',
  MAIN_ENGINE_CAPACITY_DESC = 'MAIN_ENGINE_CAPACITY_DESC',
  MASS_CAPACITY_ASC = 'MASS_CAPACITY_ASC',
  MASS_CAPACITY_DESC = 'MASS_CAPACITY_DESC',
  MASS_UNIT_ASC = 'MASS_UNIT_ASC',
  MASS_UNIT_DESC = 'MASS_UNIT_DESC',
  MMSI_ASC = 'MMSI_ASC',
  MMSI_DESC = 'MMSI_DESC',
  MTID_ASC = 'MTID_ASC',
  MTID_DESC = 'MTID_DESC',
  MTNAME_ASC = 'MTNAME_ASC',
  MTNAME_DESC = 'MTNAME_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  NET_TONNAGE_ASC = 'NET_TONNAGE_ASC',
  NET_TONNAGE_DESC = 'NET_TONNAGE_DESC',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_ATTRIBUTE_ID_ASC = 'PRIMARY_ATTRIBUTE_ID_ASC',
  PRIMARY_ATTRIBUTE_ID_DESC = 'PRIMARY_ATTRIBUTE_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  PUBLIC_ASC = 'PUBLIC_ASC',
  PUBLIC_DESC = 'PUBLIC_DESC',
  REMARKS_ASC = 'REMARKS_ASC',
  REMARKS_DESC = 'REMARKS_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHORT_NAME_ASC = 'SHORT_NAME_ASC',
  SHORT_NAME_DESC = 'SHORT_NAME_DESC',
  SORT_ID_ASC = 'SORT_ID_ASC',
  SORT_ID_DESC = 'SORT_ID_DESC',
  TC_RATE_ASC = 'TC_RATE_ASC',
  TC_RATE_DESC = 'TC_RATE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_INFO_ID_ASC = 'VESSEL_INFO_ID_ASC',
  VESSEL_INFO_ID_DESC = 'VESSEL_INFO_ID_DESC',
  VOLUME_CAPACITY_ASC = 'VOLUME_CAPACITY_ASC',
  VOLUME_CAPACITY_DESC = 'VOLUME_CAPACITY_DESC',
  VOLUME_UNIT_ASC = 'VOLUME_UNIT_ASC',
  VOLUME_UNIT_DESC = 'VOLUME_UNIT_DESC',
  WEIGHT_CAPACITY_ASC = 'WEIGHT_CAPACITY_ASC',
  WEIGHT_CAPACITY_DESC = 'WEIGHT_CAPACITY_DESC',
  WEIGHT_CAPACITY_TYPE_ASC = 'WEIGHT_CAPACITY_TYPE_ASC',
  WEIGHT_CAPACITY_TYPE_DESC = 'WEIGHT_CAPACITY_TYPE_DESC',
  YEAR_ASC = 'YEAR_ASC',
  YEAR_DESC = 'YEAR_DESC'
}

export type SingleEvent = Node & {
  __typename?: 'SingleEvent';
  archived: Scalars['Boolean']['output'];
  /** Reads a single `AssortmentExclusion` that is related to this `SingleEvent`. */
  assortmentExclusionByCleaningAssortmentExclusionId?: Maybe<AssortmentExclusion>;
  /** id of assortment_exclusion for cleaning single event */
  cleaningAssortmentExclusionId?: Maybe<Scalars['AssortmentExclusionId']['output']>;
  clientId: Scalars['UUID']['output'];
  concurrent: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `CostSplitOnSingleEvent`. */
  costSplitOnSingleEventsBySingleEventId: CostSplitOnSingleEventsConnection;
  /** Hours */
  duration: Scalars['BigFloat']['output'];
  end: Scalars['Datetime']['output'];
  id: Scalars['SingleEventId']['output'];
  /** Reads a single `Location` that is related to this `SingleEvent`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  locked: Scalars['Boolean']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `SingleEvent`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SingleEvent`. */
  organizationByRootOrg?: Maybe<Organization>;
  planningOrganisationId: Scalars['OrganizationId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  seaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  shared: Scalars['Boolean']['output'];
  /** Reads a single `Ship` that is related to this `SingleEvent`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads and enables pagination through a set of `SingleEventPortCallRelation`. */
  singleEventPortCallRelationsBySingleEventId: SingleEventPortCallRelationsConnection;
  start: Scalars['Datetime']['output'];
  startOverride?: Maybe<Scalars['Datetime']['output']>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  type: EventType;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `User` that is related to this `SingleEvent`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `SingleEvent`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};


export type SingleEventCostSplitOnSingleEventsBySingleEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CostSplitOnSingleEventCondition>;
  filter?: InputMaybe<CostSplitOnSingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CostSplitOnSingleEventsOrderBy>>;
};


export type SingleEventSingleEventPortCallRelationsBySingleEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventPortCallRelationCondition>;
  filter?: InputMaybe<SingleEventPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventPortCallRelationsOrderBy>>;
};

/**
 * A condition to be used against `SingleEvent` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SingleEventCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `cleaningAssortmentExclusionId` field. */
  cleaningAssortmentExclusionId?: InputMaybe<Scalars['AssortmentExclusionId']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `concurrent` field. */
  concurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SingleEventId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `locked` field. */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meta` field. */
  meta?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `seaDurationOverride` field. */
  seaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `startOverride` field. */
  startOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<EventType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `SingleEvent` object types. All fields are combined with a logical ‘and.’ */
export type SingleEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SingleEventFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `cleaningAssortmentExclusionId` field. */
  cleaningAssortmentExclusionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `concurrent` field. */
  concurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locked` field. */
  locked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meta` field. */
  meta?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SingleEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SingleEventFilter>>;
  /** Filter by the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `seaDurationOverride` field. */
  seaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startOverride` field. */
  startOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<EventTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `SingleEventHistory` values. */
export type SingleEventHistoriesConnection = {
  __typename?: 'SingleEventHistoriesConnection';
  /** A list of edges which contains the `SingleEventHistory` and cursor to aid in pagination. */
  edges: Array<SingleEventHistoriesEdge>;
  /** A list of `SingleEventHistory` objects. */
  nodes: Array<Maybe<SingleEventHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SingleEventHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SingleEventHistory` edge in the connection. */
export type SingleEventHistoriesEdge = {
  __typename?: 'SingleEventHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SingleEventHistory` at the end of the edge. */
  node?: Maybe<SingleEventHistory>;
};

/** Methods to use when ordering `SingleEventHistory`. */
export enum SingleEventHistoriesOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CONCURRENT_ASC = 'CONCURRENT_ASC',
  CONCURRENT_DESC = 'CONCURRENT_DESC',
  DURATION_ASC = 'DURATION_ASC',
  DURATION_DESC = 'DURATION_DESC',
  END_ASC = 'END_ASC',
  END_DESC = 'END_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  LOCKED_ASC = 'LOCKED_ASC',
  LOCKED_DESC = 'LOCKED_DESC',
  META_ASC = 'META_ASC',
  META_DESC = 'META_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PLANNING_ORGANISATION_ID_ASC = 'PLANNING_ORGANISATION_ID_ASC',
  PLANNING_ORGANISATION_ID_DESC = 'PLANNING_ORGANISATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SEA_DURATION_OVERRIDE_ASC = 'SEA_DURATION_OVERRIDE_ASC',
  SEA_DURATION_OVERRIDE_DESC = 'SEA_DURATION_OVERRIDE_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  START_ASC = 'START_ASC',
  START_DESC = 'START_DESC',
  START_OVERRIDE_ASC = 'START_OVERRIDE_ASC',
  START_OVERRIDE_DESC = 'START_OVERRIDE_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for this table */
export type SingleEventHistory = {
  __typename?: 'SingleEventHistory';
  archived: Scalars['Boolean']['output'];
  clientId: Scalars['UUID']['output'];
  concurrent: Scalars['Boolean']['output'];
  duration: Scalars['BigFloat']['output'];
  end: Scalars['Datetime']['output'];
  id: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  locked: Scalars['Boolean']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  planningOrganisationId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  seaDurationOverride?: Maybe<Scalars['BigInt']['output']>;
  shared: Scalars['Boolean']['output'];
  start: Scalars['Datetime']['output'];
  startOverride?: Maybe<Scalars['Datetime']['output']>;
  sysPeriod: DatetimeRange;
  type: EventType;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  userId: Scalars['Int']['output'];
  vesselId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `SingleEventHistory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SingleEventHistoryCondition = {
  /** Checks for equality with the object’s `archived` field. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `concurrent` field. */
  concurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `end` field. */
  end?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `locked` field. */
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `meta` field. */
  meta?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `seaDurationOverride` field. */
  seaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `start` field. */
  start?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `startOverride` field. */
  startOverride?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<EventType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `SingleEventHistory` object types. All fields are combined with a logical ‘and.’ */
export type SingleEventHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SingleEventHistoryFilter>>;
  /** Filter by the object’s `archived` field. */
  archived?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `concurrent` field. */
  concurrent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `end` field. */
  end?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locked` field. */
  locked?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meta` field. */
  meta?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SingleEventHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SingleEventHistoryFilter>>;
  /** Filter by the object’s `planningOrganisationId` field. */
  planningOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `seaDurationOverride` field. */
  seaDurationOverride?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `start` field. */
  start?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startOverride` field. */
  startOverride?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<EventTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SingleEvent` */
export type SingleEventInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** id of assortment_exclusion for cleaning single event */
  cleaningAssortmentExclusionId?: InputMaybe<Scalars['AssortmentExclusionId']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  concurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hours */
  duration: Scalars['BigFloat']['input'];
  end: Scalars['Datetime']['input'];
  locationId: Scalars['LocationId']['input'];
  locked: Scalars['Boolean']['input'];
  meta?: InputMaybe<Scalars['String']['input']>;
  planningOrganisationId: Scalars['OrganizationId']['input'];
  seaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  shared: Scalars['Boolean']['input'];
  start: Scalars['Datetime']['input'];
  startOverride?: InputMaybe<Scalars['Datetime']['input']>;
  type?: InputMaybe<EventType>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['UserId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `SingleEvent`. Fields that are set will be updated. */
export type SingleEventPatch = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** id of assortment_exclusion for cleaning single event */
  cleaningAssortmentExclusionId?: InputMaybe<Scalars['AssortmentExclusionId']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  concurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hours */
  duration?: InputMaybe<Scalars['BigFloat']['input']>;
  end?: InputMaybe<Scalars['Datetime']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  planningOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  seaDurationOverride?: InputMaybe<Scalars['BigInt']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Datetime']['input']>;
  startOverride?: InputMaybe<Scalars['Datetime']['input']>;
  type?: InputMaybe<EventType>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type SingleEventPortCallRelation = Node & {
  __typename?: 'SingleEventPortCallRelation';
  id: Scalars['SingleEventPortCallRelationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `SingleEventPortCallRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `SingleEventPortCallRelation`. */
  portCallByPortCallId?: Maybe<PortCall>;
  portCallId: Scalars['PortCallId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `SingleEvent` that is related to this `SingleEventPortCallRelation`. */
  singleEventBySingleEventId?: Maybe<SingleEvent>;
  singleEventId: Scalars['SingleEventId']['output'];
};

/**
 * A condition to be used against `SingleEventPortCallRelation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type SingleEventPortCallRelationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SingleEventPortCallRelationId']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `singleEventId` field. */
  singleEventId?: InputMaybe<Scalars['SingleEventId']['input']>;
};

/** A filter to be used against `SingleEventPortCallRelation` object types. All fields are combined with a logical ‘and.’ */
export type SingleEventPortCallRelationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SingleEventPortCallRelationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SingleEventPortCallRelationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SingleEventPortCallRelationFilter>>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `singleEventId` field. */
  singleEventId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SingleEventPortCallRelation` */
export type SingleEventPortCallRelationInput = {
  portCallId: Scalars['PortCallId']['input'];
  singleEventId: Scalars['SingleEventId']['input'];
};

/** Represents an update to a `SingleEventPortCallRelation`. Fields that are set will be updated. */
export type SingleEventPortCallRelationPatch = {
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  singleEventId?: InputMaybe<Scalars['SingleEventId']['input']>;
};

/** A connection to a list of `SingleEventPortCallRelation` values. */
export type SingleEventPortCallRelationsConnection = {
  __typename?: 'SingleEventPortCallRelationsConnection';
  /** A list of edges which contains the `SingleEventPortCallRelation` and cursor to aid in pagination. */
  edges: Array<SingleEventPortCallRelationsEdge>;
  /** A list of `SingleEventPortCallRelation` objects. */
  nodes: Array<Maybe<SingleEventPortCallRelation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SingleEventPortCallRelation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SingleEventPortCallRelation` edge in the connection. */
export type SingleEventPortCallRelationsEdge = {
  __typename?: 'SingleEventPortCallRelationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SingleEventPortCallRelation` at the end of the edge. */
  node?: Maybe<SingleEventPortCallRelation>;
};

/** Methods to use when ordering `SingleEventPortCallRelation`. */
export enum SingleEventPortCallRelationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SINGLE_EVENT_ID_ASC = 'SINGLE_EVENT_ID_ASC',
  SINGLE_EVENT_ID_DESC = 'SINGLE_EVENT_ID_DESC'
}

/** A connection to a list of `SingleEvent` values. */
export type SingleEventsConnection = {
  __typename?: 'SingleEventsConnection';
  /** A list of edges which contains the `SingleEvent` and cursor to aid in pagination. */
  edges: Array<SingleEventsEdge>;
  /** A list of `SingleEvent` objects. */
  nodes: Array<Maybe<SingleEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SingleEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SingleEvent` edge in the connection. */
export type SingleEventsEdge = {
  __typename?: 'SingleEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SingleEvent` at the end of the edge. */
  node?: Maybe<SingleEvent>;
};

/** Methods to use when ordering `SingleEvent`. */
export enum SingleEventsOrderBy {
  ARCHIVED_ASC = 'ARCHIVED_ASC',
  ARCHIVED_DESC = 'ARCHIVED_DESC',
  CLEANING_ASSORTMENT_EXCLUSION_ID_ASC = 'CLEANING_ASSORTMENT_EXCLUSION_ID_ASC',
  CLEANING_ASSORTMENT_EXCLUSION_ID_DESC = 'CLEANING_ASSORTMENT_EXCLUSION_ID_DESC',
  CLIENT_ID_ASC = 'CLIENT_ID_ASC',
  CLIENT_ID_DESC = 'CLIENT_ID_DESC',
  CONCURRENT_ASC = 'CONCURRENT_ASC',
  CONCURRENT_DESC = 'CONCURRENT_DESC',
  DURATION_ASC = 'DURATION_ASC',
  DURATION_DESC = 'DURATION_DESC',
  END_ASC = 'END_ASC',
  END_DESC = 'END_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  LOCKED_ASC = 'LOCKED_ASC',
  LOCKED_DESC = 'LOCKED_DESC',
  META_ASC = 'META_ASC',
  META_DESC = 'META_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PLANNING_ORGANISATION_ID_ASC = 'PLANNING_ORGANISATION_ID_ASC',
  PLANNING_ORGANISATION_ID_DESC = 'PLANNING_ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SEA_DURATION_OVERRIDE_ASC = 'SEA_DURATION_OVERRIDE_ASC',
  SEA_DURATION_OVERRIDE_DESC = 'SEA_DURATION_OVERRIDE_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  START_ASC = 'START_ASC',
  START_DESC = 'START_DESC',
  START_OVERRIDE_ASC = 'START_OVERRIDE_ASC',
  START_OVERRIDE_DESC = 'START_OVERRIDE_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type SoftDeleteOrdersPayload = {
  __typename?: 'SoftDeleteOrdersPayload';
  bols: Array<Scalars['Int']['output']>;
  ccas: Array<Scalars['Int']['output']>;
  ces: Array<Scalars['Int']['output']>;
  cms: Array<Scalars['Int']['output']>;
  nrs: Array<Scalars['Int']['output']>;
  opcrs: Array<Scalars['Int']['output']>;
  orders: Array<Order>;
  ovcrs: Array<Scalars['Int']['output']>;
};

export type SpecialRequirement = Node & {
  __typename?: 'SpecialRequirement';
  id: Scalars['SpecialRequirementId']['output'];
  /** Reads and enables pagination through a set of `LocationRequirementAssociation`. */
  locationRequirementAssociationsBySpecialRequirementId: LocationRequirementAssociationsConnection;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrderRequirementAssociation`. */
  orderRequirementAssociationsBySpecialRequirementId: OrderRequirementAssociationsConnection;
  /** Reads a single `Organization` that is related to this `SpecialRequirement`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `VesselFulfillsRequirementAssociation`. */
  vesselFulfillsRequirementAssociationsBySpecialRequirementId: VesselFulfillsRequirementAssociationsConnection;
};


export type SpecialRequirementLocationRequirementAssociationsBySpecialRequirementIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationRequirementAssociationCondition>;
  filter?: InputMaybe<LocationRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
};


export type SpecialRequirementOrderRequirementAssociationsBySpecialRequirementIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderRequirementAssociationCondition>;
  filter?: InputMaybe<OrderRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderRequirementAssociationsOrderBy>>;
};


export type SpecialRequirementVesselFulfillsRequirementAssociationsBySpecialRequirementIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselFulfillsRequirementAssociationCondition>;
  filter?: InputMaybe<VesselFulfillsRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
};

/**
 * A condition to be used against `SpecialRequirement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SpecialRequirementCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SpecialRequirementId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `SpecialRequirement` object types. All fields are combined with a logical ‘and.’ */
export type SpecialRequirementFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SpecialRequirementFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SpecialRequirementFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SpecialRequirementFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SpecialRequirement` */
export type SpecialRequirementInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Represents an update to a `SpecialRequirement`. Fields that are set will be updated. */
export type SpecialRequirementPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `SpecialRequirement` values. */
export type SpecialRequirementsConnection = {
  __typename?: 'SpecialRequirementsConnection';
  /** A list of edges which contains the `SpecialRequirement` and cursor to aid in pagination. */
  edges: Array<SpecialRequirementsEdge>;
  /** A list of `SpecialRequirement` objects. */
  nodes: Array<Maybe<SpecialRequirement>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SpecialRequirement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SpecialRequirement` edge in the connection. */
export type SpecialRequirementsEdge = {
  __typename?: 'SpecialRequirementsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SpecialRequirement` at the end of the edge. */
  node?: Maybe<SpecialRequirement>;
};

/** Methods to use when ordering `SpecialRequirement`. */
export enum SpecialRequirementsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC'
}

export type SpeechToTextInput = {
  audioBuffer?: InputMaybe<Scalars['String']['input']>;
};

export type SpeechToTextResult = {
  __typename?: 'SpeechToTextResult';
  text?: Maybe<Scalars['String']['output']>;
};

export type SplitOrder = Node & {
  __typename?: 'SplitOrder';
  fromOrderId: Scalars['OrderId']['output'];
  id: Scalars['SplitOrderId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `SplitOrder`. */
  orderByFromOrderId?: Maybe<Order>;
  /** Reads a single `Order` that is related to this `SplitOrder`. */
  orderByToOrderId?: Maybe<Order>;
  toOrderId: Scalars['OrderId']['output'];
};

/**
 * A condition to be used against `SplitOrder` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SplitOrderCondition = {
  /** Checks for equality with the object’s `fromOrderId` field. */
  fromOrderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SplitOrderId']['input']>;
  /** Checks for equality with the object’s `toOrderId` field. */
  toOrderId?: InputMaybe<Scalars['OrderId']['input']>;
};

/** A filter to be used against `SplitOrder` object types. All fields are combined with a logical ‘and.’ */
export type SplitOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SplitOrderFilter>>;
  /** Filter by the object’s `fromOrderId` field. */
  fromOrderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SplitOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SplitOrderFilter>>;
  /** Filter by the object’s `toOrderId` field. */
  toOrderId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SplitOrder` */
export type SplitOrderInput = {
  fromOrderId: Scalars['OrderId']['input'];
  toOrderId: Scalars['OrderId']['input'];
};

/** Represents an update to a `SplitOrder`. Fields that are set will be updated. */
export type SplitOrderPatch = {
  fromOrderId?: InputMaybe<Scalars['OrderId']['input']>;
  toOrderId?: InputMaybe<Scalars['OrderId']['input']>;
};

/** A connection to a list of `SplitOrder` values. */
export type SplitOrdersConnection = {
  __typename?: 'SplitOrdersConnection';
  /** A list of edges which contains the `SplitOrder` and cursor to aid in pagination. */
  edges: Array<SplitOrdersEdge>;
  /** A list of `SplitOrder` objects. */
  nodes: Array<Maybe<SplitOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SplitOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SplitOrder` edge in the connection. */
export type SplitOrdersEdge = {
  __typename?: 'SplitOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SplitOrder` at the end of the edge. */
  node?: Maybe<SplitOrder>;
};

/** Methods to use when ordering `SplitOrder`. */
export enum SplitOrdersOrderBy {
  FROM_ORDER_ID_ASC = 'FROM_ORDER_ID_ASC',
  FROM_ORDER_ID_DESC = 'FROM_ORDER_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TO_ORDER_ID_ASC = 'TO_ORDER_ID_ASC',
  TO_ORDER_ID_DESC = 'TO_ORDER_ID_DESC'
}

export type SpotNegotiation = Node & {
  __typename?: 'SpotNegotiation';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  cancelling?: Maybe<Scalars['Datetime']['output']>;
  chartererOrganisationId: Scalars['OrganizationId']['output'];
  commission?: Maybe<Scalars['BigFloat']['output']>;
  demurrage?: Maybe<Scalars['BigFloat']['output']>;
  extraInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['SpotNegotiationId']['output'];
  layday?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `SpotNegotiation`. */
  organizationByChartererOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SpotNegotiation`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  ownerOrganisationId: Scalars['OrganizationId']['output'];
  paymentTime?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `User` that is related to this `SpotNegotiation`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  vesselId?: Maybe<Scalars['VesselInfoId']['output']>;
  /** Reads a single `VesselInfo` that is related to this `SpotNegotiation`. */
  vesselInfoByVesselId?: Maybe<VesselInfo>;
  /** Reads a single `VoyageCharter` that is related to this `SpotNegotiation`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId: Scalars['VoyageCharterId']['output'];
  /** Reads and enables pagination through a set of `VoyageCharterToContract`. */
  voyageCharterToContractsBySpotNegotiationId: VoyageCharterToContractsConnection;
};


export type SpotNegotiationVoyageCharterToContractsBySpotNegotiationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterToContractCondition>;
  filter?: InputMaybe<VoyageCharterToContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};

/**
 * A condition to be used against `SpotNegotiation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SpotNegotiationCondition = {
  /** Checks for equality with the object’s `accepted` field. */
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `cancelling` field. */
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `chartererOrganisationId` field. */
  chartererOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `commission` field. */
  commission?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `demurrage` field. */
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `extraInfo` field. */
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SpotNegotiationId']['input']>;
  /** Checks for equality with the object’s `layday` field. */
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `paymentTime` field. */
  paymentTime?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `SpotNegotiation` object types. All fields are combined with a logical ‘and.’ */
export type SpotNegotiationFilter = {
  /** Filter by the object’s `accepted` field. */
  accepted?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SpotNegotiationFilter>>;
  /** Filter by the object’s `cancelling` field. */
  cancelling?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `chartererOrganisationId` field. */
  chartererOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `commission` field. */
  commission?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `demurrage` field. */
  demurrage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `extraInfo` field. */
  extraInfo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `layday` field. */
  layday?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SpotNegotiationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SpotNegotiationFilter>>;
  /** Filter by the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentTime` field. */
  paymentTime?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SpotNegotiation` */
export type SpotNegotiationInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  chartererOrganisationId: Scalars['OrganizationId']['input'];
  commission?: InputMaybe<Scalars['BigFloat']['input']>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  ownerOrganisationId: Scalars['OrganizationId']['input'];
  paymentTime?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['UserId']['input'];
  vesselId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** Represents an update to a `SpotNegotiation`. Fields that are set will be updated. */
export type SpotNegotiationPatch = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  chartererOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  commission?: InputMaybe<Scalars['BigFloat']['input']>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  paymentTime?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['VesselInfoId']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `SpotNegotiation` values. */
export type SpotNegotiationsConnection = {
  __typename?: 'SpotNegotiationsConnection';
  /** A list of edges which contains the `SpotNegotiation` and cursor to aid in pagination. */
  edges: Array<SpotNegotiationsEdge>;
  /** A list of `SpotNegotiation` objects. */
  nodes: Array<Maybe<SpotNegotiation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SpotNegotiation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SpotNegotiation` edge in the connection. */
export type SpotNegotiationsEdge = {
  __typename?: 'SpotNegotiationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SpotNegotiation` at the end of the edge. */
  node?: Maybe<SpotNegotiation>;
};

/** Methods to use when ordering `SpotNegotiation`. */
export enum SpotNegotiationsOrderBy {
  ACCEPTED_ASC = 'ACCEPTED_ASC',
  ACCEPTED_DESC = 'ACCEPTED_DESC',
  CANCELLING_ASC = 'CANCELLING_ASC',
  CANCELLING_DESC = 'CANCELLING_DESC',
  CHARTERER_ORGANISATION_ID_ASC = 'CHARTERER_ORGANISATION_ID_ASC',
  CHARTERER_ORGANISATION_ID_DESC = 'CHARTERER_ORGANISATION_ID_DESC',
  COMMISSION_ASC = 'COMMISSION_ASC',
  COMMISSION_DESC = 'COMMISSION_DESC',
  DEMURRAGE_ASC = 'DEMURRAGE_ASC',
  DEMURRAGE_DESC = 'DEMURRAGE_DESC',
  EXTRA_INFO_ASC = 'EXTRA_INFO_ASC',
  EXTRA_INFO_DESC = 'EXTRA_INFO_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAYDAY_ASC = 'LAYDAY_ASC',
  LAYDAY_DESC = 'LAYDAY_DESC',
  NATURAL = 'NATURAL',
  OWNER_ORGANISATION_ID_ASC = 'OWNER_ORGANISATION_ID_ASC',
  OWNER_ORGANISATION_ID_DESC = 'OWNER_ORGANISATION_ID_DESC',
  PAYMENT_TIME_ASC = 'PAYMENT_TIME_ASC',
  PAYMENT_TIME_DESC = 'PAYMENT_TIME_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

export type StatementOfFact = Node & {
  __typename?: 'StatementOfFact';
  arrivalTime?: Maybe<Scalars['Datetime']['output']>;
  berthed?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['StatementOfFactId']['output'];
  loadingCommenced?: Maybe<Scalars['Datetime']['output']>;
  loadingCompleted?: Maybe<Scalars['Datetime']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  noticeOfReadiness?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Organization` that is related to this `StatementOfFact`. */
  organizationByRootOrg?: Maybe<Organization>;
  pilotOnboard?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `PortActivity`. */
  portActivitiesByStatementOfFactsId: PortActivitiesConnection;
  /** Reads a single `PortCall` that is related to this `StatementOfFact`. */
  portCallByPortCallId?: Maybe<PortCall>;
  portCallId: Scalars['PortCallId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  sailingTime?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `StatementOfFactsHistory`. */
  statementOfFactsHistoriesById: StatementOfFactsHistoriesConnection;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `StatementOfFact`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `StatementOfFact`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
};


export type StatementOfFactPortActivitiesByStatementOfFactsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortActivityCondition>;
  filter?: InputMaybe<PortActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortActivitiesOrderBy>>;
};


export type StatementOfFactStatementOfFactsHistoriesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatementOfFactsHistoryCondition>;
  filter?: InputMaybe<StatementOfFactsHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatementOfFactsHistoriesOrderBy>>;
};

/**
 * A condition to be used against `StatementOfFact` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type StatementOfFactCondition = {
  /** Checks for equality with the object’s `arrivalTime` field. */
  arrivalTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `berthed` field. */
  berthed?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['StatementOfFactId']['input']>;
  /** Checks for equality with the object’s `loadingCommenced` field. */
  loadingCommenced?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingCompleted` field. */
  loadingCompleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `noticeOfReadiness` field. */
  noticeOfReadiness?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `pilotOnboard` field. */
  pilotOnboard?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sailingTime` field. */
  sailingTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `StatementOfFact` object types. All fields are combined with a logical ‘and.’ */
export type StatementOfFactFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StatementOfFactFilter>>;
  /** Filter by the object’s `arrivalTime` field. */
  arrivalTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `berthed` field. */
  berthed?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingCommenced` field. */
  loadingCommenced?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingCompleted` field. */
  loadingCompleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StatementOfFactFilter>;
  /** Filter by the object’s `noticeOfReadiness` field. */
  noticeOfReadiness?: InputMaybe<DatetimeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StatementOfFactFilter>>;
  /** Filter by the object’s `pilotOnboard` field. */
  pilotOnboard?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sailingTime` field. */
  sailingTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `StatementOfFact` */
export type StatementOfFactInput = {
  arrivalTime?: InputMaybe<Scalars['Datetime']['input']>;
  berthed?: InputMaybe<Scalars['Datetime']['input']>;
  loadingCommenced?: InputMaybe<Scalars['Datetime']['input']>;
  loadingCompleted?: InputMaybe<Scalars['Datetime']['input']>;
  noticeOfReadiness?: InputMaybe<Scalars['Datetime']['input']>;
  pilotOnboard?: InputMaybe<Scalars['Datetime']['input']>;
  portCallId: Scalars['PortCallId']['input'];
  sailingTime?: InputMaybe<Scalars['Datetime']['input']>;
  userId: Scalars['UserId']['input'];
};

/** Represents an update to a `StatementOfFact`. Fields that are set will be updated. */
export type StatementOfFactPatch = {
  arrivalTime?: InputMaybe<Scalars['Datetime']['input']>;
  berthed?: InputMaybe<Scalars['Datetime']['input']>;
  loadingCommenced?: InputMaybe<Scalars['Datetime']['input']>;
  loadingCompleted?: InputMaybe<Scalars['Datetime']['input']>;
  noticeOfReadiness?: InputMaybe<Scalars['Datetime']['input']>;
  pilotOnboard?: InputMaybe<Scalars['Datetime']['input']>;
  portCallId?: InputMaybe<Scalars['PortCallId']['input']>;
  sailingTime?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `StatementOfFact` values. */
export type StatementOfFactsConnection = {
  __typename?: 'StatementOfFactsConnection';
  /** A list of edges which contains the `StatementOfFact` and cursor to aid in pagination. */
  edges: Array<StatementOfFactsEdge>;
  /** A list of `StatementOfFact` objects. */
  nodes: Array<Maybe<StatementOfFact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StatementOfFact` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `StatementOfFact` edge in the connection. */
export type StatementOfFactsEdge = {
  __typename?: 'StatementOfFactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `StatementOfFact` at the end of the edge. */
  node?: Maybe<StatementOfFact>;
};

/** A connection to a list of `StatementOfFactsHistory` values. */
export type StatementOfFactsHistoriesConnection = {
  __typename?: 'StatementOfFactsHistoriesConnection';
  /** A list of edges which contains the `StatementOfFactsHistory` and cursor to aid in pagination. */
  edges: Array<StatementOfFactsHistoriesEdge>;
  /** A list of `StatementOfFactsHistory` objects. */
  nodes: Array<Maybe<StatementOfFactsHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StatementOfFactsHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `StatementOfFactsHistory` edge in the connection. */
export type StatementOfFactsHistoriesEdge = {
  __typename?: 'StatementOfFactsHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `StatementOfFactsHistory` at the end of the edge. */
  node?: Maybe<StatementOfFactsHistory>;
};

/** Methods to use when ordering `StatementOfFactsHistory`. */
export enum StatementOfFactsHistoriesOrderBy {
  ARRIVAL_TIME_ASC = 'ARRIVAL_TIME_ASC',
  ARRIVAL_TIME_DESC = 'ARRIVAL_TIME_DESC',
  BERTHED_ASC = 'BERTHED_ASC',
  BERTHED_DESC = 'BERTHED_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_COMMENCED_ASC = 'LOADING_COMMENCED_ASC',
  LOADING_COMMENCED_DESC = 'LOADING_COMMENCED_DESC',
  LOADING_COMPLETED_ASC = 'LOADING_COMPLETED_ASC',
  LOADING_COMPLETED_DESC = 'LOADING_COMPLETED_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  NOTICE_OF_READINESS_ASC = 'NOTICE_OF_READINESS_ASC',
  NOTICE_OF_READINESS_DESC = 'NOTICE_OF_READINESS_DESC',
  PILOT_ONBOARD_ASC = 'PILOT_ONBOARD_ASC',
  PILOT_ONBOARD_DESC = 'PILOT_ONBOARD_DESC',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SAILING_TIME_ASC = 'SAILING_TIME_ASC',
  SAILING_TIME_DESC = 'SAILING_TIME_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** History log for statement of facts */
export type StatementOfFactsHistory = {
  __typename?: 'StatementOfFactsHistory';
  arrivalTime?: Maybe<Scalars['Datetime']['output']>;
  berthed?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['StatementOfFactId']['output'];
  loadingCommenced?: Maybe<Scalars['Datetime']['output']>;
  loadingCompleted?: Maybe<Scalars['Datetime']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  noticeOfReadiness?: Maybe<Scalars['Datetime']['output']>;
  pilotOnboard?: Maybe<Scalars['Datetime']['output']>;
  portCallId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  sailingTime?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `StatementOfFact` that is related to this `StatementOfFactsHistory`. */
  statementOfFactById?: Maybe<StatementOfFact>;
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `StatementOfFactsHistory`. */
  userByModifiedByUserId?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `StatementOfFactsHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type StatementOfFactsHistoryCondition = {
  /** Checks for equality with the object’s `arrivalTime` field. */
  arrivalTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `berthed` field. */
  berthed?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['StatementOfFactId']['input']>;
  /** Checks for equality with the object’s `loadingCommenced` field. */
  loadingCommenced?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `loadingCompleted` field. */
  loadingCompleted?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `noticeOfReadiness` field. */
  noticeOfReadiness?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `pilotOnboard` field. */
  pilotOnboard?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `portCallId` field. */
  portCallId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sailingTime` field. */
  sailingTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `StatementOfFactsHistory` object types. All fields are combined with a logical ‘and.’ */
export type StatementOfFactsHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StatementOfFactsHistoryFilter>>;
  /** Filter by the object’s `arrivalTime` field. */
  arrivalTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `berthed` field. */
  berthed?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loadingCommenced` field. */
  loadingCommenced?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `loadingCompleted` field. */
  loadingCompleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StatementOfFactsHistoryFilter>;
  /** Filter by the object’s `noticeOfReadiness` field. */
  noticeOfReadiness?: InputMaybe<DatetimeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StatementOfFactsHistoryFilter>>;
  /** Filter by the object’s `pilotOnboard` field. */
  pilotOnboard?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `portCallId` field. */
  portCallId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sailingTime` field. */
  sailingTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** Methods to use when ordering `StatementOfFact`. */
export enum StatementOfFactsOrderBy {
  ARRIVAL_TIME_ASC = 'ARRIVAL_TIME_ASC',
  ARRIVAL_TIME_DESC = 'ARRIVAL_TIME_DESC',
  BERTHED_ASC = 'BERTHED_ASC',
  BERTHED_DESC = 'BERTHED_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOADING_COMMENCED_ASC = 'LOADING_COMMENCED_ASC',
  LOADING_COMMENCED_DESC = 'LOADING_COMMENCED_DESC',
  LOADING_COMPLETED_ASC = 'LOADING_COMPLETED_ASC',
  LOADING_COMPLETED_DESC = 'LOADING_COMPLETED_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  NOTICE_OF_READINESS_ASC = 'NOTICE_OF_READINESS_ASC',
  NOTICE_OF_READINESS_DESC = 'NOTICE_OF_READINESS_DESC',
  PILOT_ONBOARD_ASC = 'PILOT_ONBOARD_ASC',
  PILOT_ONBOARD_DESC = 'PILOT_ONBOARD_DESC',
  PORT_CALL_ID_ASC = 'PORT_CALL_ID_ASC',
  PORT_CALL_ID_DESC = 'PORT_CALL_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SAILING_TIME_ASC = 'SAILING_TIME_ASC',
  SAILING_TIME_DESC = 'SAILING_TIME_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export enum Status {
  fail = 'fail',
  ok = 'ok'
}

export enum StatusType {
  DELETE = 'DELETE',
  ERR = 'ERR',
  INSERT = 'INSERT',
  OK = 'OK',
  ROLLBACK = 'ROLLBACK',
  SKIP = 'SKIP',
  UPDATE = 'UPDATE'
}

/** A filter to be used against StatusType fields. All fields are combined with a logical ‘and.’ */
export type StatusTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<StatusType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<StatusType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<StatusType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<StatusType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<StatusType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<StatusType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<StatusType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<StatusType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<StatusType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<StatusType>>;
};

export enum StowageModeType {
  LOLO = 'LOLO',
  SIDEPORT = 'SIDEPORT',
  STORO = 'STORO'
}

/** A filter to be used against StowageModeType fields. All fields are combined with a logical ‘and.’ */
export type StowageModeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<StowageModeType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<StowageModeType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<StowageModeType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<StowageModeType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<StowageModeType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<StowageModeType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<StowageModeType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<StowageModeType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<StowageModeType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<StowageModeType>>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  assortmentUpdated?: Maybe<AssortmentsSubscriptionPayload>;
  batchUpdate?: Maybe<BatchUpdateSubscriptionPayload>;
  commitLogScenarioUpdated?: Maybe<CommitLogScenarioSubscriptionPayload>;
  commitLogUpdated?: Maybe<CommitLogSubscriptionPayload>;
  dbChange?: Maybe<DbChangeSubscriptionPayload>;
  listen: ListenPayload;
  locationUpdated?: Maybe<LocationSubscriptionPayload>;
  openPositionUpdated?: Maybe<OpenPositionSubscriptionPayload>;
  organizationUpdated?: Maybe<OrganizationsSubscriptionPayload>;
  planningDataUpdated?: Maybe<CommitSubscriptionPayload>;
  portCostDefaultUpdated?: Maybe<PortCostDefaultSubscriptionPayload>;
  robTaskUpdated?: Maybe<RobTaskSubscriptionPayload>;
  routeOverrideUpdated?: Maybe<RouteOverrideSubscriptionPayload>;
  scenarioUpdated?: Maybe<ScenarioSubscriptionPayload>;
  shipUpdated?: Maybe<ShipSubscriptionPayload>;
  shipVoyageNamingRuleRelationUpdated?: Maybe<ShipVoyageNamingRuleRelationSubscriptionPayload>;
  shipmentUpdated?: Maybe<ShipmentSubscriptionPayload>;
  /**
   * Triggered when planning related data changes:
   *
   * - direct modifications to orders
   * - on commit / assign / unassign / reschedule
   */
  transactionalCommit?: Maybe<TransactionalCommitSubscriptionPayload>;
  vesselReservationUpdated?: Maybe<VesselReservationSubscriptionPayload>;
  voyageAttributeUpdated?: Maybe<VoyageAttributeSubscriptionPayload>;
  voyageCharterExtraFreightUpdated?: Maybe<VoyageCharterExtraFreightSubscriptionPayload>;
  worldscaleFreightUpdated?: Maybe<WorldscaleFreightSubscriptionPayload>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAssortmentUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionBatchUpdateArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionCommitLogScenarioUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionCommitLogUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionDbChangeArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionListenArgs = {
  initialEvent?: Scalars['Boolean']['input'];
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionLocationUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionOpenPositionUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionOrganizationUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionPlanningDataUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionPortCostDefaultUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionRobTaskUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionRouteOverrideUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionScenarioUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionShipUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionShipVoyageNamingRuleRelationUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionShipmentUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionTransactionalCommitArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionVesselReservationUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionVoyageAttributeUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionVoyageCharterExtraFreightUpdatedArgs = {
  topic: Scalars['String']['input'];
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionWorldscaleFreightUpdatedArgs = {
  topic: Scalars['String']['input'];
};

/** A connection to a list of `Supply` values. */
export type SuppliesConnection = {
  __typename?: 'SuppliesConnection';
  /** A list of edges which contains the `Supply` and cursor to aid in pagination. */
  edges: Array<SuppliesEdge>;
  /** A list of `Supply` objects. */
  nodes: Array<Maybe<Supply>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Supply` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Supply` edge in the connection. */
export type SuppliesEdge = {
  __typename?: 'SuppliesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Supply` at the end of the edge. */
  node?: Maybe<Supply>;
};

/** Methods to use when ordering `Supply`. */
export enum SuppliesOrderBy {
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  AMOUNT_UNIT_ID_ASC = 'AMOUNT_UNIT_ID_ASC',
  AMOUNT_UNIT_ID_DESC = 'AMOUNT_UNIT_ID_DESC',
  ASSORTMENT_ASC = 'ASSORTMENT_ASC',
  ASSORTMENT_DESC = 'ASSORTMENT_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  DELETED_ASC = 'DELETED_ASC',
  DELETED_DESC = 'DELETED_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  QUAY_ASC = 'QUAY_ASC',
  QUAY_DESC = 'QUAY_DESC',
  REGION_ASC = 'REGION_ASC',
  REGION_DESC = 'REGION_DESC',
  SUPPLY_CONTRACT_ASC = 'SUPPLY_CONTRACT_ASC',
  SUPPLY_CONTRACT_DESC = 'SUPPLY_CONTRACT_DESC',
  TIME_PERIOD_ASC = 'TIME_PERIOD_ASC',
  TIME_PERIOD_DESC = 'TIME_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type Supply = Node & {
  __typename?: 'Supply';
  amount: Scalars['BigFloat']['output'];
  amountUnitId: Scalars['CargoUnitId']['output'];
  assortment?: Maybe<Scalars['AssortmentId']['output']>;
  /** Reads a single `Assortment` that is related to this `Supply`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Supply`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  chartererOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['SupplyId']['output'];
  /** Reads a single `Location` that is related to this `Supply`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Supply`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Supply`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  quay?: Maybe<Scalars['QuayId']['output']>;
  /** Reads a single `Quay` that is related to this `Supply`. */
  quayByQuay?: Maybe<Quay>;
  region?: Maybe<Scalars['RegionId']['output']>;
  /** Reads a single `Region` that is related to this `Supply`. */
  regionByRegion?: Maybe<Region>;
  supplyContract?: Maybe<Scalars['SupplyContractId']['output']>;
  /** Reads a single `SupplyContract` that is related to this `Supply`. */
  supplyContractBySupplyContract?: Maybe<SupplyContract>;
  timePeriod?: Maybe<DateRange>;
  /** Reads a single `User` that is related to this `Supply`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};

/** A condition to be used against `Supply` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SupplyCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `amountUnitId` field. */
  amountUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  /** Checks for equality with the object’s `assortment` field. */
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SupplyId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `quay` field. */
  quay?: InputMaybe<Scalars['QuayId']['input']>;
  /** Checks for equality with the object’s `region` field. */
  region?: InputMaybe<Scalars['RegionId']['input']>;
  /** Checks for equality with the object’s `supplyContract` field. */
  supplyContract?: InputMaybe<Scalars['SupplyContractId']['input']>;
  /** Checks for equality with the object’s `timePeriod` field. */
  timePeriod?: InputMaybe<DateRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

export type SupplyContract = Node & {
  __typename?: 'SupplyContract';
  batchCode?: Maybe<Scalars['String']['output']>;
  batchSeq?: Maybe<Scalars['Int']['output']>;
  id: Scalars['SupplyContractId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OrderDetail`. */
  orderDetailsBySupplyContractId: OrderDetailsConnection;
  /** Reads a single `Organization` that is related to this `SupplyContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SupplyContract`. */
  organizationBySenderOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  senderOrganizationId?: Maybe<Scalars['OrganizationId']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesBySupplyContract: SuppliesConnection;
  supplyContract?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};


export type SupplyContractOrderDetailsBySupplyContractIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderDetailCondition>;
  filter?: InputMaybe<OrderDetailFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};


export type SupplyContractSuppliesBySupplyContractArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};

/**
 * A condition to be used against `SupplyContract` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SupplyContractCondition = {
  /** Checks for equality with the object’s `batchCode` field. */
  batchCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `batchSeq` field. */
  batchSeq?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['SupplyContractId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `senderOrganizationId` field. */
  senderOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `supplier` field. */
  supplier?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `supplyContract` field. */
  supplyContract?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `SupplyContract` object types. All fields are combined with a logical ‘and.’ */
export type SupplyContractFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SupplyContractFilter>>;
  /** Filter by the object’s `batchCode` field. */
  batchCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `batchSeq` field. */
  batchSeq?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SupplyContractFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SupplyContractFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `senderOrganizationId` field. */
  senderOrganizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `supplier` field. */
  supplier?: InputMaybe<StringFilter>;
  /** Filter by the object’s `supplyContract` field. */
  supplyContract?: InputMaybe<StringFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `SupplyContract` */
export type SupplyContractInput = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  batchSeq?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  senderOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  supplyContract?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an update to a `SupplyContract`. Fields that are set will be updated. */
export type SupplyContractPatch = {
  batchCode?: InputMaybe<Scalars['String']['input']>;
  batchSeq?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  senderOrganizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  supplyContract?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `SupplyContract` values. */
export type SupplyContractsConnection = {
  __typename?: 'SupplyContractsConnection';
  /** A list of edges which contains the `SupplyContract` and cursor to aid in pagination. */
  edges: Array<SupplyContractsEdge>;
  /** A list of `SupplyContract` objects. */
  nodes: Array<Maybe<SupplyContract>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SupplyContract` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `SupplyContract` edge in the connection. */
export type SupplyContractsEdge = {
  __typename?: 'SupplyContractsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SupplyContract` at the end of the edge. */
  node?: Maybe<SupplyContract>;
};

/** Methods to use when ordering `SupplyContract`. */
export enum SupplyContractsOrderBy {
  BATCH_CODE_ASC = 'BATCH_CODE_ASC',
  BATCH_CODE_DESC = 'BATCH_CODE_DESC',
  BATCH_SEQ_ASC = 'BATCH_SEQ_ASC',
  BATCH_SEQ_DESC = 'BATCH_SEQ_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SENDER_ORGANIZATION_ID_ASC = 'SENDER_ORGANIZATION_ID_ASC',
  SENDER_ORGANIZATION_ID_DESC = 'SENDER_ORGANIZATION_ID_DESC',
  SUPPLIER_ASC = 'SUPPLIER_ASC',
  SUPPLIER_DESC = 'SUPPLIER_DESC',
  SUPPLY_CONTRACT_ASC = 'SUPPLY_CONTRACT_ASC',
  SUPPLY_CONTRACT_DESC = 'SUPPLY_CONTRACT_DESC',
  YEAR_ASC = 'YEAR_ASC',
  YEAR_DESC = 'YEAR_DESC'
}

/** A filter to be used against `Supply` object types. All fields are combined with a logical ‘and.’ */
export type SupplyFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `amountUnitId` field. */
  amountUnitId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SupplyFilter>>;
  /** Filter by the object’s `assortment` field. */
  assortment?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SupplyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SupplyFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `quay` field. */
  quay?: InputMaybe<IntFilter>;
  /** Filter by the object’s `region` field. */
  region?: InputMaybe<IntFilter>;
  /** Filter by the object’s `supplyContract` field. */
  supplyContract?: InputMaybe<IntFilter>;
  /** Filter by the object’s `timePeriod` field. */
  timePeriod?: InputMaybe<DateRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Supply` */
export type SupplyInput = {
  amount: Scalars['BigFloat']['input'];
  amountUnitId: Scalars['CargoUnitId']['input'];
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['LocationId']['input'];
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  quay?: InputMaybe<Scalars['QuayId']['input']>;
  region?: InputMaybe<Scalars['RegionId']['input']>;
  supplyContract?: InputMaybe<Scalars['SupplyContractId']['input']>;
  timePeriod?: InputMaybe<DateRangeInput>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `Supply`. Fields that are set will be updated. */
export type SupplyPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  amountUnitId?: InputMaybe<Scalars['CargoUnitId']['input']>;
  assortment?: InputMaybe<Scalars['AssortmentId']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  quay?: InputMaybe<Scalars['QuayId']['input']>;
  region?: InputMaybe<Scalars['RegionId']['input']>;
  supplyContract?: InputMaybe<Scalars['SupplyContractId']['input']>;
  timePeriod?: InputMaybe<DateRangeInput>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

export type SyncBookingListResult = {
  __typename?: 'SyncBookingListResult';
  status: Status;
};

export type SyncImosCoasResult = {
  __typename?: 'SyncImosCoasResult';
  /** Identifier for the task run */
  runUuid: Scalars['UUID']['output'];
};

export type SyncOrdersResult = {
  __typename?: 'SyncOrdersResult';
  errorLogs: Array<Maybe<Scalars['String']['output']>>;
  status: Status;
};

export type SyncShipnetOrdersResult = {
  __typename?: 'SyncShipnetOrdersResult';
  status: Status;
};

export type TankDistance = Node & {
  __typename?: 'TankDistance';
  /** Reads a single `CargoCompartment` that is related to this `TankDistance`. */
  cargoCompartmentByTankA?: Maybe<CargoCompartment>;
  /** Reads a single `CargoCompartment` that is related to this `TankDistance`. */
  cargoCompartmentByTankB?: Maybe<CargoCompartment>;
  euclideanDistance: Scalars['BigFloat']['output'];
  id: Scalars['TankDistanceId']['output'];
  manhattanDistance: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  tankA: Scalars['CargoCompartmentId']['output'];
  tankB: Scalars['CargoCompartmentId']['output'];
};

/**
 * A condition to be used against `TankDistance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TankDistanceCondition = {
  /** Checks for equality with the object’s `euclideanDistance` field. */
  euclideanDistance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['TankDistanceId']['input']>;
  /** Checks for equality with the object’s `manhattanDistance` field. */
  manhattanDistance?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tankA` field. */
  tankA?: InputMaybe<Scalars['CargoCompartmentId']['input']>;
  /** Checks for equality with the object’s `tankB` field. */
  tankB?: InputMaybe<Scalars['CargoCompartmentId']['input']>;
};

/** A filter to be used against `TankDistance` object types. All fields are combined with a logical ‘and.’ */
export type TankDistanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TankDistanceFilter>>;
  /** Filter by the object’s `euclideanDistance` field. */
  euclideanDistance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `manhattanDistance` field. */
  manhattanDistance?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TankDistanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TankDistanceFilter>>;
  /** Filter by the object’s `tankA` field. */
  tankA?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tankB` field. */
  tankB?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `TankDistance` */
export type TankDistanceInput = {
  euclideanDistance: Scalars['BigFloat']['input'];
  manhattanDistance: Scalars['Int']['input'];
  tankA: Scalars['CargoCompartmentId']['input'];
  tankB: Scalars['CargoCompartmentId']['input'];
};

/** Represents an update to a `TankDistance`. Fields that are set will be updated. */
export type TankDistancePatch = {
  euclideanDistance?: InputMaybe<Scalars['BigFloat']['input']>;
  manhattanDistance?: InputMaybe<Scalars['Int']['input']>;
  tankA?: InputMaybe<Scalars['CargoCompartmentId']['input']>;
  tankB?: InputMaybe<Scalars['CargoCompartmentId']['input']>;
};

/** A connection to a list of `TankDistance` values. */
export type TankDistancesConnection = {
  __typename?: 'TankDistancesConnection';
  /** A list of edges which contains the `TankDistance` and cursor to aid in pagination. */
  edges: Array<TankDistancesEdge>;
  /** A list of `TankDistance` objects. */
  nodes: Array<Maybe<TankDistance>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TankDistance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TankDistance` edge in the connection. */
export type TankDistancesEdge = {
  __typename?: 'TankDistancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TankDistance` at the end of the edge. */
  node?: Maybe<TankDistance>;
};

/** Methods to use when ordering `TankDistance`. */
export enum TankDistancesOrderBy {
  EUCLIDEAN_DISTANCE_ASC = 'EUCLIDEAN_DISTANCE_ASC',
  EUCLIDEAN_DISTANCE_DESC = 'EUCLIDEAN_DISTANCE_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MANHATTAN_DISTANCE_ASC = 'MANHATTAN_DISTANCE_ASC',
  MANHATTAN_DISTANCE_DESC = 'MANHATTAN_DISTANCE_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  TANK_A_ASC = 'TANK_A_ASC',
  TANK_A_DESC = 'TANK_A_DESC',
  TANK_B_ASC = 'TANK_B_ASC',
  TANK_B_DESC = 'TANK_B_DESC'
}

export type TcContract = Node & {
  __typename?: 'TcContract';
  deliveryEndDate: Scalars['Datetime']['output'];
  deliveryPortId: Scalars['LocationId']['output'];
  deliveryStartDate: Scalars['Datetime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['TcContractId']['output'];
  /** Reads a single `Location` that is related to this `TcContract`. */
  locationByDeliveryPortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `TcContract`. */
  locationByRedeliveryPortId?: Maybe<Location>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `TcContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  redeliveryEndDate: Scalars['Datetime']['output'];
  redeliveryPortId: Scalars['LocationId']['output'];
  redeliveryStartDate: Scalars['Datetime']['output'];
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `TcContract`. */
  shipByVesselId?: Maybe<Ship>;
  vesselId: Scalars['ShipId']['output'];
};

/**
 * A condition to be used against `TcContract` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TcContractCondition = {
  /** Checks for equality with the object’s `deliveryEndDate` field. */
  deliveryEndDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deliveryPortId` field. */
  deliveryPortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `deliveryStartDate` field. */
  deliveryStartDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['TcContractId']['input']>;
  /** Checks for equality with the object’s `redeliveryEndDate` field. */
  redeliveryEndDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `redeliveryPortId` field. */
  redeliveryPortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `redeliveryStartDate` field. */
  redeliveryStartDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `TcContract` object types. All fields are combined with a logical ‘and.’ */
export type TcContractFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TcContractFilter>>;
  /** Filter by the object’s `deliveryEndDate` field. */
  deliveryEndDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deliveryPortId` field. */
  deliveryPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deliveryStartDate` field. */
  deliveryStartDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TcContractFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TcContractFilter>>;
  /** Filter by the object’s `redeliveryEndDate` field. */
  redeliveryEndDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `redeliveryPortId` field. */
  redeliveryPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `redeliveryStartDate` field. */
  redeliveryStartDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `TcContract` */
export type TcContractInput = {
  deliveryEndDate: Scalars['Datetime']['input'];
  deliveryPortId: Scalars['LocationId']['input'];
  deliveryStartDate: Scalars['Datetime']['input'];
  externalId: Scalars['String']['input'];
  redeliveryEndDate: Scalars['Datetime']['input'];
  redeliveryPortId: Scalars['LocationId']['input'];
  redeliveryStartDate: Scalars['Datetime']['input'];
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId: Scalars['ShipId']['input'];
};

/** Represents an update to a `TcContract`. Fields that are set will be updated. */
export type TcContractPatch = {
  deliveryEndDate?: InputMaybe<Scalars['Datetime']['input']>;
  deliveryPortId?: InputMaybe<Scalars['LocationId']['input']>;
  deliveryStartDate?: InputMaybe<Scalars['Datetime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  redeliveryEndDate?: InputMaybe<Scalars['Datetime']['input']>;
  redeliveryPortId?: InputMaybe<Scalars['LocationId']['input']>;
  redeliveryStartDate?: InputMaybe<Scalars['Datetime']['input']>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type TcContractSyncResult = {
  __typename?: 'TcContractSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Status;
};

/** A connection to a list of `TcContract` values. */
export type TcContractsConnection = {
  __typename?: 'TcContractsConnection';
  /** A list of edges which contains the `TcContract` and cursor to aid in pagination. */
  edges: Array<TcContractsEdge>;
  /** A list of `TcContract` objects. */
  nodes: Array<Maybe<TcContract>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TcContract` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TcContract` edge in the connection. */
export type TcContractsEdge = {
  __typename?: 'TcContractsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TcContract` at the end of the edge. */
  node?: Maybe<TcContract>;
};

/** Methods to use when ordering `TcContract`. */
export enum TcContractsOrderBy {
  DELIVERY_END_DATE_ASC = 'DELIVERY_END_DATE_ASC',
  DELIVERY_END_DATE_DESC = 'DELIVERY_END_DATE_DESC',
  DELIVERY_PORT_ID_ASC = 'DELIVERY_PORT_ID_ASC',
  DELIVERY_PORT_ID_DESC = 'DELIVERY_PORT_ID_DESC',
  DELIVERY_START_DATE_ASC = 'DELIVERY_START_DATE_ASC',
  DELIVERY_START_DATE_DESC = 'DELIVERY_START_DATE_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REDELIVERY_END_DATE_ASC = 'REDELIVERY_END_DATE_ASC',
  REDELIVERY_END_DATE_DESC = 'REDELIVERY_END_DATE_DESC',
  REDELIVERY_PORT_ID_ASC = 'REDELIVERY_PORT_ID_ASC',
  REDELIVERY_PORT_ID_DESC = 'REDELIVERY_PORT_ID_DESC',
  REDELIVERY_START_DATE_ASC = 'REDELIVERY_START_DATE_ASC',
  REDELIVERY_START_DATE_DESC = 'REDELIVERY_START_DATE_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** A filter to be used against Time fields. All fields are combined with a logical ‘and.’ */
export type TimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Time']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Time']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Time']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Time']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Time']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Time']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Time']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Time']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type TransactionalCommitSubscriptionPayload = {
  __typename?: 'TransactionalCommitSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateActualCostById` mutation. */
export type UpdateActualCostByIdInput = {
  /** An object where the defined keys will be set on the `ActualCost` being updated. */
  actualCostPatch: ActualCostPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ActualCostId']['input'];
};

/** All input for the `updateActualCost` mutation. */
export type UpdateActualCostInput = {
  /** An object where the defined keys will be set on the `ActualCost` being updated. */
  actualCostPatch: ActualCostPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActualCost` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `ActualCost` mutation. */
export type UpdateActualCostPayload = {
  __typename?: 'UpdateActualCostPayload';
  /** The `ActualCost` that was updated by this mutation. */
  actualCost?: Maybe<ActualCost>;
  /** An edge for our `ActualCost`. May be used by Relay 1. */
  actualCostEdge?: Maybe<ActualCostsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `ActualCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our update `ActualCost` mutation. */
export type UpdateActualCostPayloadActualCostEdgeArgs = {
  orderBy?: InputMaybe<Array<ActualCostsOrderBy>>;
};

/** All input for the `updateApiOrdersNoticeById` mutation. */
export type UpdateApiOrdersNoticeByIdInput = {
  /** An object where the defined keys will be set on the `ApiOrdersNotice` being updated. */
  apiOrdersNoticePatch: ApiOrdersNoticePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ApiOrdersNoticeId']['input'];
};

/** All input for the `updateApiOrdersNotice` mutation. */
export type UpdateApiOrdersNoticeInput = {
  /** An object where the defined keys will be set on the `ApiOrdersNotice` being updated. */
  apiOrdersNoticePatch: ApiOrdersNoticePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ApiOrdersNotice` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `ApiOrdersNotice` mutation. */
export type UpdateApiOrdersNoticePayload = {
  __typename?: 'UpdateApiOrdersNoticePayload';
  /** The `ApiOrdersNotice` that was updated by this mutation. */
  apiOrdersNotice?: Maybe<ApiOrdersNotice>;
  /** An edge for our `ApiOrdersNotice`. May be used by Relay 1. */
  apiOrdersNoticeEdge?: Maybe<ApiOrdersNoticesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `ApiOrdersNotice`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `ApiOrdersNotice`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ApiOrdersNotice` mutation. */
export type UpdateApiOrdersNoticePayloadApiOrdersNoticeEdgeArgs = {
  orderBy?: InputMaybe<Array<ApiOrdersNoticesOrderBy>>;
};

/** All input for the `updateAssortmentById` mutation. */
export type UpdateAssortmentByIdInput = {
  /** An object where the defined keys will be set on the `Assortment` being updated. */
  assortmentPatch: AssortmentPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['AssortmentId']['input'];
};

/** All input for the `updateAssortmentExclusionById` mutation. */
export type UpdateAssortmentExclusionByIdInput = {
  /** An object where the defined keys will be set on the `AssortmentExclusion` being updated. */
  assortmentExclusionPatch: AssortmentExclusionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['AssortmentExclusionId']['input'];
};

/** All input for the `updateAssortmentExclusion` mutation. */
export type UpdateAssortmentExclusionInput = {
  /** An object where the defined keys will be set on the `AssortmentExclusion` being updated. */
  assortmentExclusionPatch: AssortmentExclusionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AssortmentExclusion` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `AssortmentExclusion` mutation. */
export type UpdateAssortmentExclusionPayload = {
  __typename?: 'UpdateAssortmentExclusionPayload';
  /** Reads a single `Assortment` that is related to this `AssortmentExclusion`. */
  assortmentByNextAssortment?: Maybe<Assortment>;
  /** Reads a single `Assortment` that is related to this `AssortmentExclusion`. */
  assortmentByPreviousAssortment?: Maybe<Assortment>;
  /** The `AssortmentExclusion` that was updated by this mutation. */
  assortmentExclusion?: Maybe<AssortmentExclusion>;
  /** An edge for our `AssortmentExclusion`. May be used by Relay 1. */
  assortmentExclusionEdge?: Maybe<AssortmentExclusionsEdge>;
  /** Reads a single `AssortmentGroup` that is related to this `AssortmentExclusion`. */
  assortmentGroupByNextAssortmentGroup?: Maybe<AssortmentGroup>;
  /** Reads a single `AssortmentGroup` that is related to this `AssortmentExclusion`. */
  assortmentGroupByPreviousAssortmentGroup?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VesselAttribute` that is related to this `AssortmentExclusion`. */
  vesselAttributeByVesselCostClassId?: Maybe<VesselAttribute>;
};


/** The output of our update `AssortmentExclusion` mutation. */
export type UpdateAssortmentExclusionPayloadAssortmentExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};

/** All input for the `updateAssortmentGroupById` mutation. */
export type UpdateAssortmentGroupByIdInput = {
  /** An object where the defined keys will be set on the `AssortmentGroup` being updated. */
  assortmentGroupPatch: AssortmentGroupPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['AssortmentGroupId']['input'];
};

/** All input for the `updateAssortmentGroup` mutation. */
export type UpdateAssortmentGroupInput = {
  /** An object where the defined keys will be set on the `AssortmentGroup` being updated. */
  assortmentGroupPatch: AssortmentGroupPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AssortmentGroup` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `AssortmentGroup` mutation. */
export type UpdateAssortmentGroupPayload = {
  __typename?: 'UpdateAssortmentGroupPayload';
  /** The `AssortmentGroup` that was updated by this mutation. */
  assortmentGroup?: Maybe<AssortmentGroup>;
  /** An edge for our `AssortmentGroup`. May be used by Relay 1. */
  assortmentGroupEdge?: Maybe<AssortmentGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `AssortmentGroup`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `AssortmentGroup`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `AssortmentGroup` mutation. */
export type UpdateAssortmentGroupPayloadAssortmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentGroupsOrderBy>>;
};

/** All input for the `updateAssortment` mutation. */
export type UpdateAssortmentInput = {
  /** An object where the defined keys will be set on the `Assortment` being updated. */
  assortmentPatch: AssortmentPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Assortment` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Assortment` mutation. */
export type UpdateAssortmentPayload = {
  __typename?: 'UpdateAssortmentPayload';
  /** The `Assortment` that was updated by this mutation. */
  assortment?: Maybe<Assortment>;
  /** An edge for our `Assortment`. May be used by Relay 1. */
  assortmentEdge?: Maybe<AssortmentsEdge>;
  /** Reads a single `AssortmentGroup` that is related to this `Assortment`. */
  assortmentGroupByAssortmentGroup?: Maybe<AssortmentGroup>;
  /** Reads a single `CargoUnit` that is related to this `Assortment`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Assortment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Assortment`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Assortment` mutation. */
export type UpdateAssortmentPayloadAssortmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};

/** All input for the `updateBatchUpdateById` mutation. */
export type UpdateBatchUpdateByIdInput = {
  /** An object where the defined keys will be set on the `BatchUpdate` being updated. */
  batchUpdatePatch: BatchUpdatePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BatchUpdateId']['input'];
};

/** All input for the `updateBatchUpdate` mutation. */
export type UpdateBatchUpdateInput = {
  /** An object where the defined keys will be set on the `BatchUpdate` being updated. */
  batchUpdatePatch: BatchUpdatePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BatchUpdate` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `BatchUpdate` mutation. */
export type UpdateBatchUpdatePayload = {
  __typename?: 'UpdateBatchUpdatePayload';
  /** The `BatchUpdate` that was updated by this mutation. */
  batchUpdate?: Maybe<BatchUpdate>;
  /** An edge for our `BatchUpdate`. May be used by Relay 1. */
  batchUpdateEdge?: Maybe<BatchUpdatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BatchUpdate`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BatchUpdate` mutation. */
export type UpdateBatchUpdatePayloadBatchUpdateEdgeArgs = {
  orderBy?: InputMaybe<Array<BatchUpdatesOrderBy>>;
};

/** All input for the `updateBillOfLadingById` mutation. */
export type UpdateBillOfLadingByIdInput = {
  /** An object where the defined keys will be set on the `BillOfLading` being updated. */
  billOfLadingPatch: BillOfLadingPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BillOfLadingId']['input'];
};

/** All input for the `updateBillOfLadingDatumById` mutation. */
export type UpdateBillOfLadingDatumByIdInput = {
  /** An object where the defined keys will be set on the `BillOfLadingDatum` being updated. */
  billOfLadingDatumPatch: BillOfLadingDatumPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BillOfLadingDatumId']['input'];
};

/** All input for the `updateBillOfLadingDatum` mutation. */
export type UpdateBillOfLadingDatumInput = {
  /** An object where the defined keys will be set on the `BillOfLadingDatum` being updated. */
  billOfLadingDatumPatch: BillOfLadingDatumPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BillOfLadingDatum` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `BillOfLadingDatum` mutation. */
export type UpdateBillOfLadingDatumPayload = {
  __typename?: 'UpdateBillOfLadingDatumPayload';
  /** Reads a single `BillOfLading` that is related to this `BillOfLadingDatum`. */
  billOfLadingByBillOfLadingId?: Maybe<BillOfLading>;
  /** The `BillOfLadingDatum` that was updated by this mutation. */
  billOfLadingDatum?: Maybe<BillOfLadingDatum>;
  /** An edge for our `BillOfLadingDatum`. May be used by Relay 1. */
  billOfLadingDatumEdge?: Maybe<BillOfLadingDataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `BillOfLadingDatum`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BillOfLadingDatum` mutation. */
export type UpdateBillOfLadingDatumPayloadBillOfLadingDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<BillOfLadingDataOrderBy>>;
};

/** All input for the `updateBillOfLading` mutation. */
export type UpdateBillOfLadingInput = {
  /** An object where the defined keys will be set on the `BillOfLading` being updated. */
  billOfLadingPatch: BillOfLadingPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BillOfLading` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `BillOfLading` mutation. */
export type UpdateBillOfLadingPayload = {
  __typename?: 'UpdateBillOfLadingPayload';
  /** The `BillOfLading` that was updated by this mutation. */
  billOfLading?: Maybe<BillOfLading>;
  /** An edge for our `BillOfLading`. May be used by Relay 1. */
  billOfLadingEdge?: Maybe<BillOfLadingsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BillOfLading`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `BillOfLading`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `BillOfLading`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `BillOfLading`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our update `BillOfLading` mutation. */
export type UpdateBillOfLadingPayloadBillOfLadingEdgeArgs = {
  orderBy?: InputMaybe<Array<BillOfLadingsOrderBy>>;
};

/** All input for the `updateBunkerGradeCalculationById` mutation. */
export type UpdateBunkerGradeCalculationByIdInput = {
  /** An object where the defined keys will be set on the `BunkerGradeCalculation` being updated. */
  bunkerGradeCalculationPatch: BunkerGradeCalculationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BunkerGradeCalculationId']['input'];
};

/** All input for the `updateBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeId` mutation. */
export type UpdateBunkerGradeCalculationByOrganizationIdAndFromGradeIdAndToGradeIdInput = {
  /** An object where the defined keys will be set on the `BunkerGradeCalculation` being updated. */
  bunkerGradeCalculationPatch: BunkerGradeCalculationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromGradeId: Scalars['BunkerGradeOverrideId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  toGradeId: Scalars['BunkerGradeOverrideId']['input'];
};

/** All input for the `updateBunkerGradeCalculation` mutation. */
export type UpdateBunkerGradeCalculationInput = {
  /** An object where the defined keys will be set on the `BunkerGradeCalculation` being updated. */
  bunkerGradeCalculationPatch: BunkerGradeCalculationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BunkerGradeCalculation` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `BunkerGradeCalculation` mutation. */
export type UpdateBunkerGradeCalculationPayload = {
  __typename?: 'UpdateBunkerGradeCalculationPayload';
  /** The `BunkerGradeCalculation` that was updated by this mutation. */
  bunkerGradeCalculation?: Maybe<BunkerGradeCalculation>;
  /** An edge for our `BunkerGradeCalculation`. May be used by Relay 1. */
  bunkerGradeCalculationEdge?: Maybe<BunkerGradeCalculationsEdge>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeCalculation`. */
  bunkerGradeOverrideByFromGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeCalculation`. */
  bunkerGradeOverrideByToGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeCalculation`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BunkerGradeCalculation` mutation. */
export type UpdateBunkerGradeCalculationPayloadBunkerGradeCalculationEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeCalculationsOrderBy>>;
};

/** All input for the `updateBunkerGradeMappingById` mutation. */
export type UpdateBunkerGradeMappingByIdInput = {
  /** An object where the defined keys will be set on the `BunkerGradeMapping` being updated. */
  bunkerGradeMappingPatch: BunkerGradeMappingPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BunkerGradeMappingId']['input'];
};

/** All input for the `updateBunkerGradeMappingByOrganizationIdAndFromGradeId` mutation. */
export type UpdateBunkerGradeMappingByOrganizationIdAndFromGradeIdInput = {
  /** An object where the defined keys will be set on the `BunkerGradeMapping` being updated. */
  bunkerGradeMappingPatch: BunkerGradeMappingPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromGradeId: Scalars['BunkerGradeOverrideId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** All input for the `updateBunkerGradeMapping` mutation. */
export type UpdateBunkerGradeMappingInput = {
  /** An object where the defined keys will be set on the `BunkerGradeMapping` being updated. */
  bunkerGradeMappingPatch: BunkerGradeMappingPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BunkerGradeMapping` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `BunkerGradeMapping` mutation. */
export type UpdateBunkerGradeMappingPayload = {
  __typename?: 'UpdateBunkerGradeMappingPayload';
  /** The `BunkerGradeMapping` that was updated by this mutation. */
  bunkerGradeMapping?: Maybe<BunkerGradeMapping>;
  /** An edge for our `BunkerGradeMapping`. May be used by Relay 1. */
  bunkerGradeMappingEdge?: Maybe<BunkerGradeMappingsEdge>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeMapping`. */
  bunkerGradeOverrideByFromGradeId?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeMapping`. */
  bunkerGradeOverrideByToGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeMapping`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BunkerGradeMapping` mutation. */
export type UpdateBunkerGradeMappingPayloadBunkerGradeMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeMappingsOrderBy>>;
};

/** All input for the `updateBunkerGradeOverrideByGradeNameAndOrganizationId` mutation. */
export type UpdateBunkerGradeOverrideByGradeNameAndOrganizationIdInput = {
  /** An object where the defined keys will be set on the `BunkerGradeOverride` being updated. */
  bunkerGradeOverridePatch: BunkerGradeOverridePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gradeName: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** All input for the `updateBunkerGradeOverrideById` mutation. */
export type UpdateBunkerGradeOverrideByIdInput = {
  /** An object where the defined keys will be set on the `BunkerGradeOverride` being updated. */
  bunkerGradeOverridePatch: BunkerGradeOverridePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BunkerGradeOverrideId']['input'];
};

/** All input for the `updateBunkerGradeOverride` mutation. */
export type UpdateBunkerGradeOverrideInput = {
  /** An object where the defined keys will be set on the `BunkerGradeOverride` being updated. */
  bunkerGradeOverridePatch: BunkerGradeOverridePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BunkerGradeOverride` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `BunkerGradeOverride` mutation. */
export type UpdateBunkerGradeOverridePayload = {
  __typename?: 'UpdateBunkerGradeOverridePayload';
  /** The `BunkerGradeOverride` that was updated by this mutation. */
  bunkerGradeOverride?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeOverride`. */
  bunkerGradeOverrideByBlendComponent1Id?: Maybe<BunkerGradeOverride>;
  /** Reads a single `BunkerGradeOverride` that is related to this `BunkerGradeOverride`. */
  bunkerGradeOverrideByBlendComponent2Id?: Maybe<BunkerGradeOverride>;
  /** An edge for our `BunkerGradeOverride`. May be used by Relay 1. */
  bunkerGradeOverrideEdge?: Maybe<BunkerGradeOverridesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `BunkerGradeOverride`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `BunkerGradeOverride`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `BunkerGradeOverride`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our update `BunkerGradeOverride` mutation. */
export type UpdateBunkerGradeOverridePayloadBunkerGradeOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};

/** All input for the `updateBunkeringById` mutation. */
export type UpdateBunkeringByIdInput = {
  /** An object where the defined keys will be set on the `Bunkering` being updated. */
  bunkeringPatch: BunkeringPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['BunkeringId']['input'];
};

/** All input for the `updateBunkering` mutation. */
export type UpdateBunkeringInput = {
  /** An object where the defined keys will be set on the `Bunkering` being updated. */
  bunkeringPatch: BunkeringPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Bunkering` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Bunkering` mutation. */
export type UpdateBunkeringPayload = {
  __typename?: 'UpdateBunkeringPayload';
  /** The `Bunkering` that was updated by this mutation. */
  bunkering?: Maybe<Bunkering>;
  /** An edge for our `Bunkering`. May be used by Relay 1. */
  bunkeringEdge?: Maybe<BunkeringsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `Bunkering`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Bunkering`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `Bunkering`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `Bunkering`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Bunkering` mutation. */
export type UpdateBunkeringPayloadBunkeringEdgeArgs = {
  orderBy?: InputMaybe<Array<BunkeringsOrderBy>>;
};

/** All input for the `updateCarbonPriceOverrideById` mutation. */
export type UpdateCarbonPriceOverrideByIdInput = {
  /** An object where the defined keys will be set on the `CarbonPriceOverride` being updated. */
  carbonPriceOverridePatch: CarbonPriceOverridePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CarbonPriceOverrideId']['input'];
};

/** All input for the `updateCarbonPriceOverride` mutation. */
export type UpdateCarbonPriceOverrideInput = {
  /** An object where the defined keys will be set on the `CarbonPriceOverride` being updated. */
  carbonPriceOverridePatch: CarbonPriceOverridePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CarbonPriceOverride` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CarbonPriceOverride` mutation. */
export type UpdateCarbonPriceOverridePayload = {
  __typename?: 'UpdateCarbonPriceOverridePayload';
  /** The `CarbonPriceOverride` that was updated by this mutation. */
  carbonPriceOverride?: Maybe<CarbonPriceOverride>;
  /** An edge for our `CarbonPriceOverride`. May be used by Relay 1. */
  carbonPriceOverrideEdge?: Maybe<CarbonPriceOverridesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `CarbonPriceOverride`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CarbonPriceOverride` mutation. */
export type UpdateCarbonPriceOverridePayloadCarbonPriceOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<CarbonPriceOverridesOrderBy>>;
};

/** All input for the `updateCargoCompartmentAllocationById` mutation. */
export type UpdateCargoCompartmentAllocationByIdInput = {
  /** An object where the defined keys will be set on the `CargoCompartmentAllocation` being updated. */
  cargoCompartmentAllocationPatch: CargoCompartmentAllocationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoCompartmentAllocationId']['input'];
};

/** All input for the `updateCargoCompartmentAllocation` mutation. */
export type UpdateCargoCompartmentAllocationInput = {
  /** An object where the defined keys will be set on the `CargoCompartmentAllocation` being updated. */
  cargoCompartmentAllocationPatch: CargoCompartmentAllocationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoCompartmentAllocation` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CargoCompartmentAllocation` mutation. */
export type UpdateCargoCompartmentAllocationPayload = {
  __typename?: 'UpdateCargoCompartmentAllocationPayload';
  /** The `CargoCompartmentAllocation` that was updated by this mutation. */
  cargoCompartmentAllocation?: Maybe<CargoCompartmentAllocation>;
  /** An edge for our `CargoCompartmentAllocation`. May be used by Relay 1. */
  cargoCompartmentAllocationEdge?: Maybe<CargoCompartmentAllocationsEdge>;
  /** Reads a single `CargoCompartment` that is related to this `CargoCompartmentAllocation`. */
  cargoCompartmentByCompartmentId?: Maybe<CargoCompartment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `CargoCompartmentAllocation`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `CargoCompartmentAllocation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledOrder` that is related to this `CargoCompartmentAllocation`. */
  scheduledOrderByScheduledOrderClientId?: Maybe<ScheduledOrder>;
  /** Reads a single `ScheduledOrder` that is related to this `CargoCompartmentAllocation`. */
  scheduledOrderByScheduledOrderId?: Maybe<ScheduledOrder>;
};


/** The output of our update `CargoCompartmentAllocation` mutation. */
export type UpdateCargoCompartmentAllocationPayloadCargoCompartmentAllocationEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoCompartmentAllocationsOrderBy>>;
};

/** All input for the `updateCargoCompartmentById` mutation. */
export type UpdateCargoCompartmentByIdInput = {
  /** An object where the defined keys will be set on the `CargoCompartment` being updated. */
  cargoCompartmentPatch: CargoCompartmentPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoCompartmentId']['input'];
};

/** All input for the `updateCargoCompartment` mutation. */
export type UpdateCargoCompartmentInput = {
  /** An object where the defined keys will be set on the `CargoCompartment` being updated. */
  cargoCompartmentPatch: CargoCompartmentPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoCompartment` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CargoCompartment` mutation. */
export type UpdateCargoCompartmentPayload = {
  __typename?: 'UpdateCargoCompartmentPayload';
  /** The `CargoCompartment` that was updated by this mutation. */
  cargoCompartment?: Maybe<CargoCompartment>;
  /** An edge for our `CargoCompartment`. May be used by Relay 1. */
  cargoCompartmentEdge?: Maybe<CargoCompartmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `CargoCompartment`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CargoCompartment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CargoCompartment`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `CargoCompartment`. */
  userByAdminUserId?: Maybe<User>;
  /** Reads a single `VesselInfo` that is related to this `CargoCompartment`. */
  vesselInfoByVesselId?: Maybe<VesselInfo>;
};


/** The output of our update `CargoCompartment` mutation. */
export type UpdateCargoCompartmentPayloadCargoCompartmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};

/** All input for the `updateCargoEquipmentById` mutation. */
export type UpdateCargoEquipmentByIdInput = {
  /** An object where the defined keys will be set on the `CargoEquipment` being updated. */
  cargoEquipmentPatch: CargoEquipmentPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoEquipmentId']['input'];
};

/** All input for the `updateCargoEquipment` mutation. */
export type UpdateCargoEquipmentInput = {
  /** An object where the defined keys will be set on the `CargoEquipment` being updated. */
  cargoEquipmentPatch: CargoEquipmentPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoEquipment` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CargoEquipment` mutation. */
export type UpdateCargoEquipmentPayload = {
  __typename?: 'UpdateCargoEquipmentPayload';
  /** The `CargoEquipment` that was updated by this mutation. */
  cargoEquipment?: Maybe<CargoEquipment>;
  /** An edge for our `CargoEquipment`. May be used by Relay 1. */
  cargoEquipmentEdge?: Maybe<CargoEquipmentsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CargoEquipment` mutation. */
export type UpdateCargoEquipmentPayloadCargoEquipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoEquipmentsOrderBy>>;
};

/** All input for the `updateCargoExclusionById` mutation. */
export type UpdateCargoExclusionByIdInput = {
  /** An object where the defined keys will be set on the `CargoExclusion` being updated. */
  cargoExclusionPatch: CargoExclusionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoExclusionId']['input'];
};

/** All input for the `updateCargoExclusion` mutation. */
export type UpdateCargoExclusionInput = {
  /** An object where the defined keys will be set on the `CargoExclusion` being updated. */
  cargoExclusionPatch: CargoExclusionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoExclusion` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CargoExclusion` mutation. */
export type UpdateCargoExclusionPayload = {
  __typename?: 'UpdateCargoExclusionPayload';
  /** Reads a single `Assortment` that is related to this `CargoExclusion`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `CargoExclusion`. */
  assortmentGroupByAssortmentGroup?: Maybe<AssortmentGroup>;
  /** The `CargoExclusion` that was updated by this mutation. */
  cargoExclusion?: Maybe<CargoExclusion>;
  /** An edge for our `CargoExclusion`. May be used by Relay 1. */
  cargoExclusionEdge?: Maybe<CargoExclusionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `CargoExclusion`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CargoExclusion` mutation. */
export type UpdateCargoExclusionPayloadCargoExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoExclusionsOrderBy>>;
};

/** All input for the `updateCargoLengthUnitById` mutation. */
export type UpdateCargoLengthUnitByIdInput = {
  /** An object where the defined keys will be set on the `CargoLengthUnit` being updated. */
  cargoLengthUnitPatch: CargoLengthUnitPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoLengthUnitId']['input'];
};

/** All input for the `updateCargoLengthUnit` mutation. */
export type UpdateCargoLengthUnitInput = {
  /** An object where the defined keys will be set on the `CargoLengthUnit` being updated. */
  cargoLengthUnitPatch: CargoLengthUnitPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoLengthUnit` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CargoLengthUnit` mutation. */
export type UpdateCargoLengthUnitPayload = {
  __typename?: 'UpdateCargoLengthUnitPayload';
  /** The `CargoLengthUnit` that was updated by this mutation. */
  cargoLengthUnit?: Maybe<CargoLengthUnit>;
  /** An edge for our `CargoLengthUnit`. May be used by Relay 1. */
  cargoLengthUnitEdge?: Maybe<CargoLengthUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CargoLengthUnit` mutation. */
export type UpdateCargoLengthUnitPayloadCargoLengthUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoLengthUnitsOrderBy>>;
};

/** All input for the `updateCargoMeasurementById` mutation. */
export type UpdateCargoMeasurementByIdInput = {
  /** An object where the defined keys will be set on the `CargoMeasurement` being updated. */
  cargoMeasurementPatch: CargoMeasurementPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoMeasurementId']['input'];
};

/** All input for the `updateCargoMeasurement` mutation. */
export type UpdateCargoMeasurementInput = {
  /** An object where the defined keys will be set on the `CargoMeasurement` being updated. */
  cargoMeasurementPatch: CargoMeasurementPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoMeasurement` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CargoMeasurement` mutation. */
export type UpdateCargoMeasurementPayload = {
  __typename?: 'UpdateCargoMeasurementPayload';
  /** The `CargoMeasurement` that was updated by this mutation. */
  cargoMeasurement?: Maybe<CargoMeasurement>;
  /** An edge for our `CargoMeasurement`. May be used by Relay 1. */
  cargoMeasurementEdge?: Maybe<CargoMeasurementsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `CargoMeasurement`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Order` that is related to this `CargoMeasurement`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CargoMeasurement`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `CargoMeasurement` mutation. */
export type UpdateCargoMeasurementPayloadCargoMeasurementEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoMeasurementsOrderBy>>;
};

/** All input for the `updateCargoUnitById` mutation. */
export type UpdateCargoUnitByIdInput = {
  /** An object where the defined keys will be set on the `CargoUnit` being updated. */
  cargoUnitPatch: CargoUnitPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoUnitId']['input'];
};

/** All input for the `updateCargoUnit` mutation. */
export type UpdateCargoUnitInput = {
  /** An object where the defined keys will be set on the `CargoUnit` being updated. */
  cargoUnitPatch: CargoUnitPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoUnit` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CargoUnit` mutation. */
export type UpdateCargoUnitPayload = {
  __typename?: 'UpdateCargoUnitPayload';
  /** The `CargoUnit` that was updated by this mutation. */
  cargoUnit?: Maybe<CargoUnit>;
  /** An edge for our `CargoUnit`. May be used by Relay 1. */
  cargoUnitEdge?: Maybe<CargoUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CargoUnit` mutation. */
export type UpdateCargoUnitPayloadCargoUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoUnitsOrderBy>>;
};

/** All input for the `updateCargoUnitsConversionByExtraUnitName` mutation. */
export type UpdateCargoUnitsConversionByExtraUnitNameInput = {
  /** An object where the defined keys will be set on the `CargoUnitsConversion` being updated. */
  cargoUnitsConversionPatch: CargoUnitsConversionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Extended unit name for a given unit defined in cargo_units table */
  extraUnitName: Scalars['String']['input'];
};

/** The output of our update `CargoUnitsConversion` mutation. */
export type UpdateCargoUnitsConversionPayload = {
  __typename?: 'UpdateCargoUnitsConversionPayload';
  /** Reads a single `CargoUnit` that is related to this `CargoUnitsConversion`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /** The `CargoUnitsConversion` that was updated by this mutation. */
  cargoUnitsConversion?: Maybe<CargoUnitsConversion>;
  /** An edge for our `CargoUnitsConversion`. May be used by Relay 1. */
  cargoUnitsConversionEdge?: Maybe<CargoUnitsConversionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CargoUnitsConversion` mutation. */
export type UpdateCargoUnitsConversionPayloadCargoUnitsConversionEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoUnitsConversionsOrderBy>>;
};

/** All input for the `updateCargoWeightUnitById` mutation. */
export type UpdateCargoWeightUnitByIdInput = {
  /** An object where the defined keys will be set on the `CargoWeightUnit` being updated. */
  cargoWeightUnitPatch: CargoWeightUnitPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['CargoWeightUnitId']['input'];
};

/** All input for the `updateCargoWeightUnit` mutation. */
export type UpdateCargoWeightUnitInput = {
  /** An object where the defined keys will be set on the `CargoWeightUnit` being updated. */
  cargoWeightUnitPatch: CargoWeightUnitPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CargoWeightUnit` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CargoWeightUnit` mutation. */
export type UpdateCargoWeightUnitPayload = {
  __typename?: 'UpdateCargoWeightUnitPayload';
  /** The `CargoWeightUnit` that was updated by this mutation. */
  cargoWeightUnit?: Maybe<CargoWeightUnit>;
  /** An edge for our `CargoWeightUnit`. May be used by Relay 1. */
  cargoWeightUnitEdge?: Maybe<CargoWeightUnitsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CargoWeightUnit` mutation. */
export type UpdateCargoWeightUnitPayloadCargoWeightUnitEdgeArgs = {
  orderBy?: InputMaybe<Array<CargoWeightUnitsOrderBy>>;
};

/** All input for the `updateChannelById` mutation. */
export type UpdateChannelByIdInput = {
  /** An object where the defined keys will be set on the `Channel` being updated. */
  channelPatch: ChannelPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChannelId']['input'];
};

/** All input for the `updateChannelCostById` mutation. */
export type UpdateChannelCostByIdInput = {
  /** An object where the defined keys will be set on the `ChannelCost` being updated. */
  channelCostPatch: ChannelCostPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChannelCostId']['input'];
};

/** All input for the `updateChannelCostEstimateById` mutation. */
export type UpdateChannelCostEstimateByIdInput = {
  /** An object where the defined keys will be set on the `ChannelCostEstimate` being updated. */
  channelCostEstimatePatch: ChannelCostEstimatePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChannelCostEstimateId']['input'];
};

/** All input for the `updateChannelCostEstimate` mutation. */
export type UpdateChannelCostEstimateInput = {
  /** An object where the defined keys will be set on the `ChannelCostEstimate` being updated. */
  channelCostEstimatePatch: ChannelCostEstimatePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ChannelCostEstimate` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `ChannelCostEstimate` mutation. */
export type UpdateChannelCostEstimatePayload = {
  __typename?: 'UpdateChannelCostEstimatePayload';
  /** Reads a single `AssortmentGroup` that is related to this `ChannelCostEstimate`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /** The `ChannelCostEstimate` that was updated by this mutation. */
  channelCostEstimate?: Maybe<ChannelCostEstimate>;
  /** An edge for our `ChannelCostEstimate`. May be used by Relay 1. */
  channelCostEstimateEdge?: Maybe<ChannelCostEstimatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `ChannelCostEstimate`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ChannelCostEstimate`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `ChannelCostEstimate`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our update `ChannelCostEstimate` mutation. */
export type UpdateChannelCostEstimatePayloadChannelCostEstimateEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
};

/** All input for the `updateChannelCost` mutation. */
export type UpdateChannelCostInput = {
  /** An object where the defined keys will be set on the `ChannelCost` being updated. */
  channelCostPatch: ChannelCostPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ChannelCost` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `ChannelCost` mutation. */
export type UpdateChannelCostPayload = {
  __typename?: 'UpdateChannelCostPayload';
  /** Reads a single `Channel` that is related to this `ChannelCost`. */
  channelByChannelId?: Maybe<Channel>;
  /** The `ChannelCost` that was updated by this mutation. */
  channelCost?: Maybe<ChannelCost>;
  /** An edge for our `ChannelCost`. May be used by Relay 1. */
  channelCostEdge?: Maybe<ChannelCostsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `ChannelCost`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ChannelCost`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `ChannelCost`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `ChannelCost` mutation. */
export type UpdateChannelCostPayloadChannelCostEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelCostsOrderBy>>;
};

/** All input for the `updateChannelIncompatibilityById` mutation. */
export type UpdateChannelIncompatibilityByIdInput = {
  /** An object where the defined keys will be set on the `ChannelIncompatibility` being updated. */
  channelIncompatibilityPatch: ChannelIncompatibilityPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChannelIncompatibilityId']['input'];
};

/** All input for the `updateChannelIncompatibilityByVesselAttributeIdAndChannelName` mutation. */
export type UpdateChannelIncompatibilityByVesselAttributeIdAndChannelNameInput = {
  /** An object where the defined keys will be set on the `ChannelIncompatibility` being updated. */
  channelIncompatibilityPatch: ChannelIncompatibilityPatch;
  /** Name of the channel that is incompatible with the vessel attribute */
  channelName: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reference to vessel attribute that is incompatible with the channel */
  vesselAttributeId: Scalars['VesselAttributeId']['input'];
};

/** All input for the `updateChannelIncompatibility` mutation. */
export type UpdateChannelIncompatibilityInput = {
  /** An object where the defined keys will be set on the `ChannelIncompatibility` being updated. */
  channelIncompatibilityPatch: ChannelIncompatibilityPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ChannelIncompatibility` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `ChannelIncompatibility` mutation. */
export type UpdateChannelIncompatibilityPayload = {
  __typename?: 'UpdateChannelIncompatibilityPayload';
  /** The `ChannelIncompatibility` that was updated by this mutation. */
  channelIncompatibility?: Maybe<ChannelIncompatibility>;
  /** An edge for our `ChannelIncompatibility`. May be used by Relay 1. */
  channelIncompatibilityEdge?: Maybe<ChannelIncompatibilitiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VesselAttribute` that is related to this `ChannelIncompatibility`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
};


/** The output of our update `ChannelIncompatibility` mutation. */
export type UpdateChannelIncompatibilityPayloadChannelIncompatibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelIncompatibilitiesOrderBy>>;
};

/** All input for the `updateChannel` mutation. */
export type UpdateChannelInput = {
  /** An object where the defined keys will be set on the `Channel` being updated. */
  channelPatch: ChannelPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Channel` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Channel` mutation. */
export type UpdateChannelPayload = {
  __typename?: 'UpdateChannelPayload';
  /** The `Channel` that was updated by this mutation. */
  channel?: Maybe<Channel>;
  /** An edge for our `Channel`. May be used by Relay 1. */
  channelEdge?: Maybe<ChannelsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `Channel`. */
  geographicalEntityByGeoId?: Maybe<GeographicalEntity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Channel` mutation. */
export type UpdateChannelPayloadChannelEdgeArgs = {
  orderBy?: InputMaybe<Array<ChannelsOrderBy>>;
};

/** All input for the `updateChatById` mutation. */
export type UpdateChatByIdInput = {
  /** An object where the defined keys will be set on the `Chat` being updated. */
  chatPatch: ChatPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ChatId']['input'];
};

/** All input for the `updateChat` mutation. */
export type UpdateChatInput = {
  /** An object where the defined keys will be set on the `Chat` being updated. */
  chatPatch: ChatPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Chat` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Chat` mutation. */
export type UpdateChatPayload = {
  __typename?: 'UpdateChatPayload';
  /** The `Chat` that was updated by this mutation. */
  chat?: Maybe<Chat>;
  /** An edge for our `Chat`. May be used by Relay 1. */
  chatEdge?: Maybe<ChatsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `Chat`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `Chat`. */
  organizationByFromOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Chat`. */
  organizationByToOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `Chat`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `Chat`. */
  userByFromUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Chat`. */
  userByToUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `Chat`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our update `Chat` mutation. */
export type UpdateChatPayloadChatEdgeArgs = {
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};

/** All input for the `updateClassSocietyAssociationById` mutation. */
export type UpdateClassSocietyAssociationByIdInput = {
  /** An object where the defined keys will be set on the `ClassSocietyAssociation` being updated. */
  classSocietyAssociationPatch: ClassSocietyAssociationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ClassSocietyAssociationId']['input'];
};

/** All input for the `updateClassSocietyAssociation` mutation. */
export type UpdateClassSocietyAssociationInput = {
  /** An object where the defined keys will be set on the `ClassSocietyAssociation` being updated. */
  classSocietyAssociationPatch: ClassSocietyAssociationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ClassSocietyAssociation` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `ClassSocietyAssociation` mutation. */
export type UpdateClassSocietyAssociationPayload = {
  __typename?: 'UpdateClassSocietyAssociationPayload';
  /** The `ClassSocietyAssociation` that was updated by this mutation. */
  classSocietyAssociation?: Maybe<ClassSocietyAssociation>;
  /** An edge for our `ClassSocietyAssociation`. May be used by Relay 1. */
  classSocietyAssociationEdge?: Maybe<ClassSocietyAssociationsEdge>;
  /** Reads a single `ClassificationSociety` that is related to this `ClassSocietyAssociation`. */
  classificationSocietyBySocietyId?: Maybe<ClassificationSociety>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `IceClass` that is related to this `ClassSocietyAssociation`. */
  iceClassByIceClassId?: Maybe<IceClass>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ClassSocietyAssociation` mutation. */
export type UpdateClassSocietyAssociationPayloadClassSocietyAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassSocietyAssociationsOrderBy>>;
};

/** All input for the `updateClassificationSocietyById` mutation. */
export type UpdateClassificationSocietyByIdInput = {
  /** An object where the defined keys will be set on the `ClassificationSociety` being updated. */
  classificationSocietyPatch: ClassificationSocietyPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ClassificationSocietyId']['input'];
};

/** All input for the `updateClassificationSociety` mutation. */
export type UpdateClassificationSocietyInput = {
  /** An object where the defined keys will be set on the `ClassificationSociety` being updated. */
  classificationSocietyPatch: ClassificationSocietyPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ClassificationSociety` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `ClassificationSociety` mutation. */
export type UpdateClassificationSocietyPayload = {
  __typename?: 'UpdateClassificationSocietyPayload';
  /** The `ClassificationSociety` that was updated by this mutation. */
  classificationSociety?: Maybe<ClassificationSociety>;
  /** An edge for our `ClassificationSociety`. May be used by Relay 1. */
  classificationSocietyEdge?: Maybe<ClassificationSocietiesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ClassificationSociety` mutation. */
export type UpdateClassificationSocietyPayloadClassificationSocietyEdgeArgs = {
  orderBy?: InputMaybe<Array<ClassificationSocietiesOrderBy>>;
};

/** All input for the `updateCoaContractAssortmentById` mutation. */
export type UpdateCoaContractAssortmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractAssortment` being updated. */
  coaContractAssortmentPatch: CoaContractAssortmentPatch;
  id: Scalars['CoaContractAssortmentId']['input'];
};

/** All input for the `updateCoaContractAssortment` mutation. */
export type UpdateCoaContractAssortmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractAssortment` being updated. */
  coaContractAssortmentPatch: CoaContractAssortmentPatch;
  /** The globally unique `ID` which will identify a single `CoaContractAssortment` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractAssortment` mutation. */
export type UpdateCoaContractAssortmentPayload = {
  __typename?: 'UpdateCoaContractAssortmentPayload';
  /** Reads a single `Assortment` that is related to this `CoaContractAssortment`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `CoaContractAssortment`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoaContractAssortment` that was updated by this mutation. */
  coaContractAssortment?: Maybe<CoaContractAssortment>;
  /** An edge for our `CoaContractAssortment`. May be used by Relay 1. */
  coaContractAssortmentEdge?: Maybe<CoaContractAssortmentsEdge>;
  /** Reads a single `CoaContract` that is related to this `CoaContractAssortment`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads a single `Organization` that is related to this `CoaContractAssortment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CoaContractAssortment` mutation. */
export type UpdateCoaContractAssortmentPayloadCoaContractAssortmentEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractAssortmentsOrderBy>>;
};

/** All input for the `updateCoaContractBunkerById` mutation. */
export type UpdateCoaContractBunkerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractBunker` being updated. */
  coaContractBunkerPatch: CoaContractBunkerPatch;
  id: Scalars['CoaContractBunkerId']['input'];
};

/** All input for the `updateCoaContractBunker` mutation. */
export type UpdateCoaContractBunkerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractBunker` being updated. */
  coaContractBunkerPatch: CoaContractBunkerPatch;
  /** The globally unique `ID` which will identify a single `CoaContractBunker` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractBunker` mutation. */
export type UpdateCoaContractBunkerPayload = {
  __typename?: 'UpdateCoaContractBunkerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractBunker`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** The `CoaContractBunker` that was updated by this mutation. */
  coaContractBunker?: Maybe<CoaContractBunker>;
  /** An edge for our `CoaContractBunker`. May be used by Relay 1. */
  coaContractBunkerEdge?: Maybe<CoaContractBunkersEdge>;
  /** Reads a single `CoaContract` that is related to this `CoaContractBunker`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractBunker`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CoaContractBunker` mutation. */
export type UpdateCoaContractBunkerPayloadCoaContractBunkerEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractBunkersOrderBy>>;
};

/** All input for the `updateCoaContractById` mutation. */
export type UpdateCoaContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContract` being updated. */
  coaContractPatch: CoaContractPatch;
  id: Scalars['CoaContractId']['input'];
};

/** All input for the `updateCoaContractCommissionById` mutation. */
export type UpdateCoaContractCommissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractCommission` being updated. */
  coaContractCommissionPatch: CoaContractCommissionPatch;
  id: Scalars['CoaContractCommissionId']['input'];
};

/** All input for the `updateCoaContractCommission` mutation. */
export type UpdateCoaContractCommissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractCommission` being updated. */
  coaContractCommissionPatch: CoaContractCommissionPatch;
  /** The globally unique `ID` which will identify a single `CoaContractCommission` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractCommission` mutation. */
export type UpdateCoaContractCommissionPayload = {
  __typename?: 'UpdateCoaContractCommissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractCommission`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractCommission`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractCommission` that was updated by this mutation. */
  coaContractCommission?: Maybe<CoaContractCommission>;
  /** An edge for our `CoaContractCommission`. May be used by Relay 1. */
  coaContractCommissionEdge?: Maybe<CoaContractCommissionsEdge>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractCommission`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  /** Reads a single `Commission` that is related to this `CoaContractCommission`. */
  commissionByCommissionId?: Maybe<Commission>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CoaContractCommission` mutation. */
export type UpdateCoaContractCommissionPayloadCoaContractCommissionEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractCommissionsOrderBy>>;
};

/** All input for the `updateCoaContractDeviationCostById` mutation. */
export type UpdateCoaContractDeviationCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractDeviationCost` being updated. */
  coaContractDeviationCostPatch: CoaContractDeviationCostPatch;
  id: Scalars['CoaContractDeviationCostId']['input'];
};

/** All input for the `updateCoaContractDeviationCost` mutation. */
export type UpdateCoaContractDeviationCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractDeviationCost` being updated. */
  coaContractDeviationCostPatch: CoaContractDeviationCostPatch;
  /** The globally unique `ID` which will identify a single `CoaContractDeviationCost` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractDeviationCost` mutation. */
export type UpdateCoaContractDeviationCostPayload = {
  __typename?: 'UpdateCoaContractDeviationCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractDeviationCost`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractDeviationCost` that was updated by this mutation. */
  coaContractDeviationCost?: Maybe<CoaContractDeviationCost>;
  /** An edge for our `CoaContractDeviationCost`. May be used by Relay 1. */
  coaContractDeviationCostEdge?: Maybe<CoaContractDeviationCostsEdge>;
  /** Reads a single `Location` that is related to this `CoaContractDeviationCost`. */
  locationByFromLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `CoaContractDeviationCost`. */
  locationByToLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `CoaContractDeviationCost`. */
  zoneByFromZoneId?: Maybe<Zone>;
  /** Reads a single `Zone` that is related to this `CoaContractDeviationCost`. */
  zoneByToZoneId?: Maybe<Zone>;
};


/** The output of our update `CoaContractDeviationCost` mutation. */
export type UpdateCoaContractDeviationCostPayloadCoaContractDeviationCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};

/** All input for the `updateCoaContract` mutation. */
export type UpdateCoaContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContract` being updated. */
  coaContractPatch: CoaContractPatch;
  /** The globally unique `ID` which will identify a single `CoaContract` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContract` mutation. */
export type UpdateCoaContractPayload = {
  __typename?: 'UpdateCoaContractPayload';
  /** Reads a single `CargoUnit` that is related to this `CoaContract`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CoaContract` that was updated by this mutation. */
  coaContract?: Maybe<CoaContract>;
  /** An edge for our `CoaContract`. May be used by Relay 1. */
  coaContractEdge?: Maybe<CoaContractsEdge>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContract`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CoaContract`. */
  userByChartererId?: Maybe<User>;
  /** Reads a single `User` that is related to this `CoaContract`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `CoaContract` mutation. */
export type UpdateCoaContractPayloadCoaContractEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};

/** All input for the `updateCoaContractPortByCoaContractIdAndOriginIdAndDestinationId` mutation. */
export type UpdateCoaContractPortByCoaContractIdAndOriginIdAndDestinationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coaContractId: Scalars['CoaContractId']['input'];
  /** An object where the defined keys will be set on the `CoaContractPort` being updated. */
  coaContractPortPatch: CoaContractPortPatch;
  destinationId: Scalars['LocationId']['input'];
  originId: Scalars['LocationId']['input'];
};

/** All input for the `updateCoaContractPortById` mutation. */
export type UpdateCoaContractPortByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPort` being updated. */
  coaContractPortPatch: CoaContractPortPatch;
  id: Scalars['CoaContractPortId']['input'];
};

/** All input for the `updateCoaContractPortCostById` mutation. */
export type UpdateCoaContractPortCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPortCost` being updated. */
  coaContractPortCostPatch: CoaContractPortCostPatch;
  id: Scalars['CoaContractPortCostId']['input'];
};

/** All input for the `updateCoaContractPortCostByLocationIdAndShipId` mutation. */
export type UpdateCoaContractPortCostByLocationIdAndShipIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPortCost` being updated. */
  coaContractPortCostPatch: CoaContractPortCostPatch;
  locationId: Scalars['LocationId']['input'];
  shipId: Scalars['ShipId']['input'];
};

/** All input for the `updateCoaContractPortCostByLocationIdAndVesselTypeId` mutation. */
export type UpdateCoaContractPortCostByLocationIdAndVesselTypeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPortCost` being updated. */
  coaContractPortCostPatch: CoaContractPortCostPatch;
  locationId: Scalars['LocationId']['input'];
  vesselTypeId: Scalars['VesselAttributeId']['input'];
};

/** All input for the `updateCoaContractPortCost` mutation. */
export type UpdateCoaContractPortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPortCost` being updated. */
  coaContractPortCostPatch: CoaContractPortCostPatch;
  /** The globally unique `ID` which will identify a single `CoaContractPortCost` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractPortCost` mutation. */
export type UpdateCoaContractPortCostPayload = {
  __typename?: 'UpdateCoaContractPortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPortCost`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPortCost` that was updated by this mutation. */
  coaContractPortCost?: Maybe<CoaContractPortCost>;
  /** An edge for our `CoaContractPortCost`. May be used by Relay 1. */
  coaContractPortCostEdge?: Maybe<CoaContractPortCostsEdge>;
  /** Reads a single `Location` that is related to this `CoaContractPortCost`. */
  locationByLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractPortCost`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `CoaContractPortCost`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our update `CoaContractPortCost` mutation. */
export type UpdateCoaContractPortCostPayloadCoaContractPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortCostsOrderBy>>;
};

/** All input for the `updateCoaContractPortDatumById` mutation. */
export type UpdateCoaContractPortDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPortDatum` being updated. */
  coaContractPortDatumPatch: CoaContractPortDatumPatch;
  id: Scalars['CoaContractPortDatumId']['input'];
};

/** All input for the `updateCoaContractPortDatum` mutation. */
export type UpdateCoaContractPortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPortDatum` being updated. */
  coaContractPortDatumPatch: CoaContractPortDatumPatch;
  /** The globally unique `ID` which will identify a single `CoaContractPortDatum` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractPortDatum` mutation. */
export type UpdateCoaContractPortDatumPayload = {
  __typename?: 'UpdateCoaContractPortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPortDatum`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPortDatum` that was updated by this mutation. */
  coaContractPortDatum?: Maybe<CoaContractPortDatum>;
  /** An edge for our `CoaContractPortDatum`. May be used by Relay 1. */
  coaContractPortDatumEdge?: Maybe<CoaContractPortDataEdge>;
  /** Reads a single `Organization` that is related to this `CoaContractPortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortDatum` that is related to this `CoaContractPortDatum`. */
  portDatumByPortDataId?: Maybe<PortDatum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CoaContractPortDatum` mutation. */
export type UpdateCoaContractPortDatumPayloadCoaContractPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortDataOrderBy>>;
};

/** All input for the `updateCoaContractPort` mutation. */
export type UpdateCoaContractPortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPort` being updated. */
  coaContractPortPatch: CoaContractPortPatch;
  /** The globally unique `ID` which will identify a single `CoaContractPort` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractPort` mutation. */
export type UpdateCoaContractPortPayload = {
  __typename?: 'UpdateCoaContractPortPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPort`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractPort` that was updated by this mutation. */
  coaContractPort?: Maybe<CoaContractPort>;
  /** An edge for our `CoaContractPort`. May be used by Relay 1. */
  coaContractPortEdge?: Maybe<CoaContractPortsEdge>;
  /** Reads a single `Location` that is related to this `CoaContractPort`. */
  locationByDestinationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `CoaContractPort`. */
  locationByOriginId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `CoaContractPort`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `CoaContractPort`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `CoaContractPort`. */
  userByChartererId?: Maybe<User>;
  /** Reads a single `Zone` that is related to this `CoaContractPort`. */
  zoneByDestinationZoneId?: Maybe<Zone>;
  /** Reads a single `Zone` that is related to this `CoaContractPort`. */
  zoneByOriginZoneId?: Maybe<Zone>;
};


/** The output of our update `CoaContractPort` mutation. */
export type UpdateCoaContractPortPayloadCoaContractPortEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};

/** All input for the `updateCoaContractPriceById` mutation. */
export type UpdateCoaContractPriceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPrice` being updated. */
  coaContractPricePatch: CoaContractPricePatch;
  id: Scalars['CoaContractPriceId']['input'];
};

/** All input for the `updateCoaContractPrice` mutation. */
export type UpdateCoaContractPriceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractPrice` being updated. */
  coaContractPricePatch: CoaContractPricePatch;
  /** The globally unique `ID` which will identify a single `CoaContractPrice` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractPrice` mutation. */
export type UpdateCoaContractPricePayload = {
  __typename?: 'UpdateCoaContractPricePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractAssortment` that is related to this `CoaContractPrice`. */
  coaContractAssortmentByCoaAssortmentId?: Maybe<CoaContractAssortment>;
  /** Reads a single `CoaContract` that is related to this `CoaContractPrice`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** Reads a single `CoaContractPort` that is related to this `CoaContractPrice`. */
  coaContractPortByRouteId?: Maybe<CoaContractPort>;
  /** The `CoaContractPrice` that was updated by this mutation. */
  coaContractPrice?: Maybe<CoaContractPrice>;
  /** An edge for our `CoaContractPrice`. May be used by Relay 1. */
  coaContractPriceEdge?: Maybe<CoaContractPricesEdge>;
  /** Reads a single `Organization` that is related to this `CoaContractPrice`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractPrice`. */
  shipByShipId?: Maybe<Ship>;
};


/** The output of our update `CoaContractPrice` mutation. */
export type UpdateCoaContractPricePayloadCoaContractPriceEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractPricesOrderBy>>;
};

/** All input for the `updateCoaContractShipByCoaContractIdAndShipId` mutation. */
export type UpdateCoaContractShipByCoaContractIdAndShipIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coaContractId: Scalars['CoaContractId']['input'];
  /** An object where the defined keys will be set on the `CoaContractShip` being updated. */
  coaContractShipPatch: CoaContractShipPatch;
  shipId: Scalars['ShipId']['input'];
};

/** All input for the `updateCoaContractShipById` mutation. */
export type UpdateCoaContractShipByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractShip` being updated. */
  coaContractShipPatch: CoaContractShipPatch;
  id: Scalars['CoaContractShipId']['input'];
};

/** All input for the `updateCoaContractShip` mutation. */
export type UpdateCoaContractShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CoaContractShip` being updated. */
  coaContractShipPatch: CoaContractShipPatch;
  /** The globally unique `ID` which will identify a single `CoaContractShip` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CoaContractShip` mutation. */
export type UpdateCoaContractShipPayload = {
  __typename?: 'UpdateCoaContractShipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `CoaContractShip`. */
  coaContractByCoaContractId?: Maybe<CoaContract>;
  /** The `CoaContractShip` that was updated by this mutation. */
  coaContractShip?: Maybe<CoaContractShip>;
  /** An edge for our `CoaContractShip`. May be used by Relay 1. */
  coaContractShipEdge?: Maybe<CoaContractShipsEdge>;
  /** Reads a single `Organization` that is related to this `CoaContractShip`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `CoaContractShip`. */
  shipByShipId?: Maybe<Ship>;
};


/** The output of our update `CoaContractShip` mutation. */
export type UpdateCoaContractShipPayloadCoaContractShipEdgeArgs = {
  orderBy?: InputMaybe<Array<CoaContractShipsOrderBy>>;
};

/** All input for the `updateCommissionByExternalIdAndVoyageCharterId` mutation. */
export type UpdateCommissionByExternalIdAndVoyageCharterIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Commission` being updated. */
  commissionPatch: CommissionPatch;
  externalId: Scalars['String']['input'];
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** All input for the `updateCommissionById` mutation. */
export type UpdateCommissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Commission` being updated. */
  commissionPatch: CommissionPatch;
  id: Scalars['CommissionId']['input'];
};

/** All input for the `updateCommission` mutation. */
export type UpdateCommissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Commission` being updated. */
  commissionPatch: CommissionPatch;
  /** The globally unique `ID` which will identify a single `Commission` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Commission` mutation. */
export type UpdateCommissionPayload = {
  __typename?: 'UpdateCommissionPayload';
  /** Reads a single `Assortment` that is related to this `Commission`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Commission` that was updated by this mutation. */
  commission?: Maybe<Commission>;
  /** An edge for our `Commission`. May be used by Relay 1. */
  commissionEdge?: Maybe<CommissionsEdge>;
  /** Reads a single `Location` that is related to this `Commission`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Commission`. */
  locationByLoadPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Commission`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `Commission`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our update `Commission` mutation. */
export type UpdateCommissionPayloadCommissionEdgeArgs = {
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};

/** All input for the `updateCommitLogScenarioById` mutation. */
export type UpdateCommitLogScenarioByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CommitLogScenario` being updated. */
  commitLogScenarioPatch: CommitLogScenarioPatch;
  id: Scalars['CommitLogScenarioId']['input'];
};

/** All input for the `updateCommitLogScenario` mutation. */
export type UpdateCommitLogScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CommitLogScenario` being updated. */
  commitLogScenarioPatch: CommitLogScenarioPatch;
  /** The globally unique `ID` which will identify a single `CommitLogScenario` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CommitLogScenario` mutation. */
export type UpdateCommitLogScenarioPayload = {
  __typename?: 'UpdateCommitLogScenarioPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CommitLogScenario` that was updated by this mutation. */
  commitLogScenario?: Maybe<CommitLogScenario>;
  /** An edge for our `CommitLogScenario`. May be used by Relay 1. */
  commitLogScenarioEdge?: Maybe<CommitLogScenariosEdge>;
  /** Reads a single `Organization` that is related to this `CommitLogScenario`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CommitLogScenario` mutation. */
export type UpdateCommitLogScenarioPayloadCommitLogScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<CommitLogScenariosOrderBy>>;
};

export type UpdateConfirmedVoyages = {
  __typename?: 'UpdateConfirmedVoyages';
  status: Status;
  warnings: Array<Scalars['String']['output']>;
};

/** All input for the `updateCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderId` mutation. */
export type UpdateCostSplitOnScheduledOrderByActualCostIdAndScheduledOrderIdInput = {
  actualCostId: Scalars['ActualCostId']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CostSplitOnScheduledOrder` being updated. */
  costSplitOnScheduledOrderPatch: CostSplitOnScheduledOrderPatch;
  scheduledOrderId: Scalars['ScheduledOrderId']['input'];
};

/** All input for the `updateCostSplitOnScheduledOrderById` mutation. */
export type UpdateCostSplitOnScheduledOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CostSplitOnScheduledOrder` being updated. */
  costSplitOnScheduledOrderPatch: CostSplitOnScheduledOrderPatch;
  id: Scalars['CostSplitOnScheduledOrderId']['input'];
};

/** All input for the `updateCostSplitOnScheduledOrder` mutation. */
export type UpdateCostSplitOnScheduledOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CostSplitOnScheduledOrder` being updated. */
  costSplitOnScheduledOrderPatch: CostSplitOnScheduledOrderPatch;
  /** The globally unique `ID` which will identify a single `CostSplitOnScheduledOrder` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CostSplitOnScheduledOrder` mutation. */
export type UpdateCostSplitOnScheduledOrderPayload = {
  __typename?: 'UpdateCostSplitOnScheduledOrderPayload';
  /** Reads a single `ActualCost` that is related to this `CostSplitOnScheduledOrder`. */
  actualCostByActualCostId?: Maybe<ActualCost>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CostSplitOnScheduledOrder` that was updated by this mutation. */
  costSplitOnScheduledOrder?: Maybe<CostSplitOnScheduledOrder>;
  /** An edge for our `CostSplitOnScheduledOrder`. May be used by Relay 1. */
  costSplitOnScheduledOrderEdge?: Maybe<CostSplitOnScheduledOrdersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ScheduledOrder` that is related to this `CostSplitOnScheduledOrder`. */
  scheduledOrderByScheduledOrderId?: Maybe<ScheduledOrder>;
};


/** The output of our update `CostSplitOnScheduledOrder` mutation. */
export type UpdateCostSplitOnScheduledOrderPayloadCostSplitOnScheduledOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<CostSplitOnScheduledOrdersOrderBy>>;
};

/** All input for the `updateCostSplitOnSingleEventByActualCostIdAndSingleEventId` mutation. */
export type UpdateCostSplitOnSingleEventByActualCostIdAndSingleEventIdInput = {
  actualCostId: Scalars['ActualCostId']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CostSplitOnSingleEvent` being updated. */
  costSplitOnSingleEventPatch: CostSplitOnSingleEventPatch;
  singleEventId: Scalars['SingleEventId']['input'];
};

/** All input for the `updateCostSplitOnSingleEventById` mutation. */
export type UpdateCostSplitOnSingleEventByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CostSplitOnSingleEvent` being updated. */
  costSplitOnSingleEventPatch: CostSplitOnSingleEventPatch;
  id: Scalars['CostSplitOnSingleEventId']['input'];
};

/** All input for the `updateCostSplitOnSingleEvent` mutation. */
export type UpdateCostSplitOnSingleEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `CostSplitOnSingleEvent` being updated. */
  costSplitOnSingleEventPatch: CostSplitOnSingleEventPatch;
  /** The globally unique `ID` which will identify a single `CostSplitOnSingleEvent` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `CostSplitOnSingleEvent` mutation. */
export type UpdateCostSplitOnSingleEventPayload = {
  __typename?: 'UpdateCostSplitOnSingleEventPayload';
  /** Reads a single `ActualCost` that is related to this `CostSplitOnSingleEvent`. */
  actualCostByActualCostId?: Maybe<ActualCost>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CostSplitOnSingleEvent` that was updated by this mutation. */
  costSplitOnSingleEvent?: Maybe<CostSplitOnSingleEvent>;
  /** An edge for our `CostSplitOnSingleEvent`. May be used by Relay 1. */
  costSplitOnSingleEventEdge?: Maybe<CostSplitOnSingleEventsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SingleEvent` that is related to this `CostSplitOnSingleEvent`. */
  singleEventBySingleEventId?: Maybe<SingleEvent>;
};


/** The output of our update `CostSplitOnSingleEvent` mutation. */
export type UpdateCostSplitOnSingleEventPayloadCostSplitOnSingleEventEdgeArgs = {
  orderBy?: InputMaybe<Array<CostSplitOnSingleEventsOrderBy>>;
};

/** All input for the `updateCountryById` mutation. */
export type UpdateCountryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Country` being updated. */
  countryPatch: CountryPatch;
  id: Scalars['CountryId']['input'];
};

/** All input for the `updateCountryByNumeric` mutation. */
export type UpdateCountryByNumericInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Country` being updated. */
  countryPatch: CountryPatch;
  numeric: Scalars['Int']['input'];
};

/** All input for the `updateCountry` mutation. */
export type UpdateCountryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Country` being updated. */
  countryPatch: CountryPatch;
  /** The globally unique `ID` which will identify a single `Country` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Country` mutation. */
export type UpdateCountryPayload = {
  __typename?: 'UpdateCountryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Country` that was updated by this mutation. */
  country?: Maybe<Country>;
  /** An edge for our `Country`. May be used by Relay 1. */
  countryEdge?: Maybe<CountriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Country` mutation. */
export type UpdateCountryPayloadCountryEdgeArgs = {
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
};

export type UpdateDateShipnetResult = {
  __typename?: 'UpdateDateShipnetResult';
  status: Status;
};

/** All input for the `updateDbChangeById` mutation. */
export type UpdateDbChangeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `DbChange` being updated. */
  dbChangePatch: DbChangePatch;
  id: Scalars['DbChangeId']['input'];
};

/** All input for the `updateDbChange` mutation. */
export type UpdateDbChangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `DbChange` being updated. */
  dbChangePatch: DbChangePatch;
  /** The globally unique `ID` which will identify a single `DbChange` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `DbChange` mutation. */
export type UpdateDbChangePayload = {
  __typename?: 'UpdateDbChangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `DbChange` that was updated by this mutation. */
  dbChange?: Maybe<DbChange>;
  /** An edge for our `DbChange`. May be used by Relay 1. */
  dbChangeEdge?: Maybe<DbChangesEdge>;
  /** Reads a single `Organization` that is related to this `DbChange`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `DbChange`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `DbChange` mutation. */
export type UpdateDbChangePayloadDbChangeEdgeArgs = {
  orderBy?: InputMaybe<Array<DbChangesOrderBy>>;
};

/** All input for the `updateDemandById` mutation. */
export type UpdateDemandByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Demand` being updated. */
  demandPatch: DemandPatch;
  id: Scalars['DemandId']['input'];
};

/** All input for the `updateDemand` mutation. */
export type UpdateDemandInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Demand` being updated. */
  demandPatch: DemandPatch;
  /** The globally unique `ID` which will identify a single `Demand` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Demand` mutation. */
export type UpdateDemandPayload = {
  __typename?: 'UpdateDemandPayload';
  /** Reads a single `Assortment` that is related to this `Demand`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Demand`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Demand` that was updated by this mutation. */
  demand?: Maybe<Demand>;
  /** An edge for our `Demand`. May be used by Relay 1. */
  demandEdge?: Maybe<DemandsEdge>;
  /** Reads a single `Location` that is related to this `Demand`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByDestinationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Demand`. */
  organizationBySendingOrganizationId?: Maybe<Organization>;
  /** Reads a single `Quay` that is related to this `Demand`. */
  quayByQuayId?: Maybe<Quay>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Demand`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Demand` mutation. */
export type UpdateDemandPayloadDemandEdgeArgs = {
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};

/** All input for the `updateEmailToOrderConfigById` mutation. */
export type UpdateEmailToOrderConfigByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `EmailToOrderConfig` being updated. */
  emailToOrderConfigPatch: EmailToOrderConfigPatch;
  id: Scalars['EmailToOrderConfigId']['input'];
};

/** All input for the `updateEmailToOrderConfig` mutation. */
export type UpdateEmailToOrderConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `EmailToOrderConfig` being updated. */
  emailToOrderConfigPatch: EmailToOrderConfigPatch;
  /** The globally unique `ID` which will identify a single `EmailToOrderConfig` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `EmailToOrderConfig` mutation. */
export type UpdateEmailToOrderConfigPayload = {
  __typename?: 'UpdateEmailToOrderConfigPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailToOrderConfig` that was updated by this mutation. */
  emailToOrderConfig?: Maybe<EmailToOrderConfig>;
  /** An edge for our `EmailToOrderConfig`. May be used by Relay 1. */
  emailToOrderConfigEdge?: Maybe<EmailToOrderConfigsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmailToOrderConfig`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `EmailToOrderConfig` mutation. */
export type UpdateEmailToOrderConfigPayloadEmailToOrderConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailToOrderConfigsOrderBy>>;
};

/** All input for the `updateEmailToOrderLogById` mutation. */
export type UpdateEmailToOrderLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `EmailToOrderLog` being updated. */
  emailToOrderLogPatch: EmailToOrderLogPatch;
  id: Scalars['EmailToOrderLogId']['input'];
};

/** All input for the `updateEmailToOrderLog` mutation. */
export type UpdateEmailToOrderLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `EmailToOrderLog` being updated. */
  emailToOrderLogPatch: EmailToOrderLogPatch;
  /** The globally unique `ID` which will identify a single `EmailToOrderLog` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `EmailToOrderLog` mutation. */
export type UpdateEmailToOrderLogPayload = {
  __typename?: 'UpdateEmailToOrderLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EmailToOrderConfig` that is related to this `EmailToOrderLog`. */
  emailToOrderConfigByConfigId?: Maybe<EmailToOrderConfig>;
  /** The `EmailToOrderLog` that was updated by this mutation. */
  emailToOrderLog?: Maybe<EmailToOrderLog>;
  /** An edge for our `EmailToOrderLog`. May be used by Relay 1. */
  emailToOrderLogEdge?: Maybe<EmailToOrderLogsEdge>;
  /** Reads a single `Organization` that is related to this `EmailToOrderLog`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EmailToOrderLog` mutation. */
export type UpdateEmailToOrderLogPayloadEmailToOrderLogEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailToOrderLogsOrderBy>>;
};

/** All input for the `updateFeatureByFeatureName` mutation. */
export type UpdateFeatureByFeatureNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureName: Scalars['FeatureFeatureNameString']['input'];
  /** An object where the defined keys will be set on the `Feature` being updated. */
  featurePatch: FeaturePatch;
};

/** All input for the `updateFeature` mutation. */
export type UpdateFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Feature` being updated. */
  featurePatch: FeaturePatch;
  /** The globally unique `ID` which will identify a single `Feature` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Feature` mutation. */
export type UpdateFeaturePayload = {
  __typename?: 'UpdateFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Feature` that was updated by this mutation. */
  feature?: Maybe<Feature>;
  /** An edge for our `Feature`. May be used by Relay 1. */
  featureEdge?: Maybe<FeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Feature` mutation. */
export type UpdateFeaturePayloadFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};

/** All input for the `updateFileById` mutation. */
export type UpdateFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `File` being updated. */
  filePatch: FilePatch;
  id: Scalars['FileId']['input'];
};

/** All input for the `updateFile` mutation. */
export type UpdateFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `File` being updated. */
  filePatch: FilePatch;
  /** The globally unique `ID` which will identify a single `File` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `File` mutation. */
export type UpdateFilePayload = {
  __typename?: 'UpdateFilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `File` that was updated by this mutation. */
  file?: Maybe<File>;
  /** An edge for our `File`. May be used by Relay 1. */
  fileEdge?: Maybe<FilesEdge>;
  /** Reads a single `Location` that is related to this `File`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Order` that is related to this `File`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `File`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `Shipment` that is related to this `File`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `File`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `File`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our update `File` mutation. */
export type UpdateFilePayloadFileEdgeArgs = {
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** All input for the `updateGeographicalEntityById` mutation. */
export type UpdateGeographicalEntityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `GeographicalEntity` being updated. */
  geographicalEntityPatch: GeographicalEntityPatch;
  id: Scalars['GeographicalEntityId']['input'];
};

/** All input for the `updateGeographicalEntity` mutation. */
export type UpdateGeographicalEntityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `GeographicalEntity` being updated. */
  geographicalEntityPatch: GeographicalEntityPatch;
  /** The globally unique `ID` which will identify a single `GeographicalEntity` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `GeographicalEntity` mutation. */
export type UpdateGeographicalEntityPayload = {
  __typename?: 'UpdateGeographicalEntityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `GeographicalEntity` that was updated by this mutation. */
  geographicalEntity?: Maybe<GeographicalEntity>;
  /** An edge for our `GeographicalEntity`. May be used by Relay 1. */
  geographicalEntityEdge?: Maybe<GeographicalEntitiesEdge>;
  /** Reads a single `Organization` that is related to this `GeographicalEntity`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `GeographicalEntity`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `GeographicalEntity` mutation. */
export type UpdateGeographicalEntityPayloadGeographicalEntityEdgeArgs = {
  orderBy?: InputMaybe<Array<GeographicalEntitiesOrderBy>>;
};

/** All input for the `updateGeographicalRelationById` mutation. */
export type UpdateGeographicalRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `GeographicalRelation` being updated. */
  geographicalRelationPatch: GeographicalRelationPatch;
  id: Scalars['GeographicalRelationId']['input'];
};

/** All input for the `updateGeographicalRelation` mutation. */
export type UpdateGeographicalRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `GeographicalRelation` being updated. */
  geographicalRelationPatch: GeographicalRelationPatch;
  /** The globally unique `ID` which will identify a single `GeographicalRelation` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `GeographicalRelation` mutation. */
export type UpdateGeographicalRelationPayload = {
  __typename?: 'UpdateGeographicalRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `GeographicalRelation`. */
  geographicalEntityByEntityId?: Maybe<GeographicalEntity>;
  /** The `GeographicalRelation` that was updated by this mutation. */
  geographicalRelation?: Maybe<GeographicalRelation>;
  /** An edge for our `GeographicalRelation`. May be used by Relay 1. */
  geographicalRelationEdge?: Maybe<GeographicalRelationsEdge>;
  /** Reads a single `Location` that is related to this `GeographicalRelation`. */
  locationByLocationId?: Maybe<Location>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `GeographicalRelation`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `GeographicalRelation` mutation. */
export type UpdateGeographicalRelationPayloadGeographicalRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<GeographicalRelationsOrderBy>>;
};

/** All input for the `updateHandledByCoaById` mutation. */
export type UpdateHandledByCoaByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `HandledByCoa` being updated. */
  handledByCoaPatch: HandledByCoaPatch;
  id: Scalars['HandledByCoaId']['input'];
};

/** All input for the `updateHandledByCoaByOrderId` mutation. */
export type UpdateHandledByCoaByOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `HandledByCoa` being updated. */
  handledByCoaPatch: HandledByCoaPatch;
  orderId: Scalars['OrderId']['input'];
};

/** All input for the `updateHandledByCoa` mutation. */
export type UpdateHandledByCoaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `HandledByCoa` being updated. */
  handledByCoaPatch: HandledByCoaPatch;
  /** The globally unique `ID` which will identify a single `HandledByCoa` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `HandledByCoa` mutation. */
export type UpdateHandledByCoaPayload = {
  __typename?: 'UpdateHandledByCoaPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `HandledByCoa`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  /** The `HandledByCoa` that was updated by this mutation. */
  handledByCoa?: Maybe<HandledByCoa>;
  /** An edge for our `HandledByCoa`. May be used by Relay 1. */
  handledByCoaEdge?: Maybe<HandledByCoasEdge>;
  /** Reads a single `Order` that is related to this `HandledByCoa`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `HandledByCoa`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `HandledByCoa`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `HandledByCoa`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledByCoa`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our update `HandledByCoa` mutation. */
export type UpdateHandledByCoaPayloadHandledByCoaEdgeArgs = {
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};

/** All input for the `updateHandledBySpotById` mutation. */
export type UpdateHandledBySpotByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `HandledBySpot` being updated. */
  handledBySpotPatch: HandledBySpotPatch;
  id: Scalars['HandledBySpotId']['input'];
};

/** All input for the `updateHandledBySpotByOrderId` mutation. */
export type UpdateHandledBySpotByOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `HandledBySpot` being updated. */
  handledBySpotPatch: HandledBySpotPatch;
  orderId: Scalars['OrderId']['input'];
};

/** All input for the `updateHandledBySpot` mutation. */
export type UpdateHandledBySpotInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `HandledBySpot` being updated. */
  handledBySpotPatch: HandledBySpotPatch;
  /** The globally unique `ID` which will identify a single `HandledBySpot` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `HandledBySpot` mutation. */
export type UpdateHandledBySpotPayload = {
  __typename?: 'UpdateHandledBySpotPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `HandledBySpot` that was updated by this mutation. */
  handledBySpot?: Maybe<HandledBySpot>;
  /** An edge for our `HandledBySpot`. May be used by Relay 1. */
  handledBySpotEdge?: Maybe<HandledBySpotsEdge>;
  /** Reads a single `Order` that is related to this `HandledBySpot`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `HandledBySpot`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `HandledBySpot`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `HandledBySpot`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `HandledBySpot`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `HandledBySpot`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our update `HandledBySpot` mutation. */
export type UpdateHandledBySpotPayloadHandledBySpotEdgeArgs = {
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};

/** All input for the `updateHolidayById` mutation. */
export type UpdateHolidayByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Holiday` being updated. */
  holidayPatch: HolidayPatch;
  id: Scalars['HolidayId']['input'];
};

/** All input for the `updateHoliday` mutation. */
export type UpdateHolidayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Holiday` being updated. */
  holidayPatch: HolidayPatch;
  /** The globally unique `ID` which will identify a single `Holiday` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Holiday` mutation. */
export type UpdateHolidayPayload = {
  __typename?: 'UpdateHolidayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `Holiday`. */
  geographicalEntityByGeoId?: Maybe<GeographicalEntity>;
  /** The `Holiday` that was updated by this mutation. */
  holiday?: Maybe<Holiday>;
  /** An edge for our `Holiday`. May be used by Relay 1. */
  holidayEdge?: Maybe<HolidaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Holiday` mutation. */
export type UpdateHolidayPayloadHolidayEdgeArgs = {
  orderBy?: InputMaybe<Array<HolidaysOrderBy>>;
};

/** All input for the `updateIceClassById` mutation. */
export type UpdateIceClassByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `IceClass` being updated. */
  iceClassPatch: IceClassPatch;
  id: Scalars['IceClassId']['input'];
};

/** All input for the `updateIceClass` mutation. */
export type UpdateIceClassInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `IceClass` being updated. */
  iceClassPatch: IceClassPatch;
  /** The globally unique `ID` which will identify a single `IceClass` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `IceClass` mutation. */
export type UpdateIceClassPayload = {
  __typename?: 'UpdateIceClassPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IceClass` that was updated by this mutation. */
  iceClass?: Maybe<IceClass>;
  /** An edge for our `IceClass`. May be used by Relay 1. */
  iceClassEdge?: Maybe<IceClassesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IceClass` mutation. */
export type UpdateIceClassPayloadIceClassEdgeArgs = {
  orderBy?: InputMaybe<Array<IceClassesOrderBy>>;
};

/** All input for the `updateInstructionById` mutation. */
export type UpdateInstructionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InstructionId']['input'];
  /** An object where the defined keys will be set on the `Instruction` being updated. */
  instructionPatch: InstructionPatch;
};

/** All input for the `updateInstruction` mutation. */
export type UpdateInstructionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Instruction` being updated. */
  instructionPatch: InstructionPatch;
  /** The globally unique `ID` which will identify a single `Instruction` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Instruction` mutation. */
export type UpdateInstructionPayload = {
  __typename?: 'UpdateInstructionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Instruction` that was updated by this mutation. */
  instruction?: Maybe<Instruction>;
  /** An edge for our `Instruction`. May be used by Relay 1. */
  instructionEdge?: Maybe<InstructionsEdge>;
  /** Reads a single `Order` that is related to this `Instruction`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `Instruction`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Instruction`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Instruction` mutation. */
export type UpdateInstructionPayloadInstructionEdgeArgs = {
  orderBy?: InputMaybe<Array<InstructionsOrderBy>>;
};

/** All input for the `updateIntegrationLogById` mutation. */
export type UpdateIntegrationLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['IntegrationLogId']['input'];
  /** An object where the defined keys will be set on the `IntegrationLog` being updated. */
  integrationLogPatch: IntegrationLogPatch;
};

/** All input for the `updateIntegrationLog` mutation. */
export type UpdateIntegrationLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `IntegrationLog` being updated. */
  integrationLogPatch: IntegrationLogPatch;
  /** The globally unique `ID` which will identify a single `IntegrationLog` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `IntegrationLog` mutation. */
export type UpdateIntegrationLogPayload = {
  __typename?: 'UpdateIntegrationLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IntegrationLog` that was updated by this mutation. */
  integrationLog?: Maybe<IntegrationLog>;
  /** An edge for our `IntegrationLog`. May be used by Relay 1. */
  integrationLogEdge?: Maybe<IntegrationLogsEdge>;
  /** Reads a single `Organization` that is related to this `IntegrationLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IntegrationLog` mutation. */
export type UpdateIntegrationLogPayloadIntegrationLogEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrationLogsOrderBy>>;
};

/** All input for the `updateInvoiceById` mutation. */
export type UpdateInvoiceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceId']['input'];
  /** An object where the defined keys will be set on the `Invoice` being updated. */
  invoicePatch: InvoicePatch;
};

/** All input for the `updateInvoice` mutation. */
export type UpdateInvoiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Invoice` being updated. */
  invoicePatch: InvoicePatch;
  /** The globally unique `ID` which will identify a single `Invoice` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `updateInvoiceItemById` mutation. */
export type UpdateInvoiceItemByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceItemId']['input'];
  /** An object where the defined keys will be set on the `InvoiceItem` being updated. */
  invoiceItemPatch: InvoiceItemPatch;
};

/** All input for the `updateInvoiceItem` mutation. */
export type UpdateInvoiceItemInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `InvoiceItem` being updated. */
  invoiceItemPatch: InvoiceItemPatch;
  /** The globally unique `ID` which will identify a single `InvoiceItem` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `updateInvoiceItemOrderById` mutation. */
export type UpdateInvoiceItemOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['InvoiceItemOrderId']['input'];
  /** An object where the defined keys will be set on the `InvoiceItemOrder` being updated. */
  invoiceItemOrderPatch: InvoiceItemOrderPatch;
};

/** All input for the `updateInvoiceItemOrder` mutation. */
export type UpdateInvoiceItemOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `InvoiceItemOrder` being updated. */
  invoiceItemOrderPatch: InvoiceItemOrderPatch;
  /** The globally unique `ID` which will identify a single `InvoiceItemOrder` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `InvoiceItemOrder` mutation. */
export type UpdateInvoiceItemOrderPayload = {
  __typename?: 'UpdateInvoiceItemOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `InvoiceItem` that is related to this `InvoiceItemOrder`. */
  invoiceItemByInvoiceItemId?: Maybe<InvoiceItem>;
  /** The `InvoiceItemOrder` that was updated by this mutation. */
  invoiceItemOrder?: Maybe<InvoiceItemOrder>;
  /** An edge for our `InvoiceItemOrder`. May be used by Relay 1. */
  invoiceItemOrderEdge?: Maybe<InvoiceItemOrdersEdge>;
  /** Reads a single `Order` that is related to this `InvoiceItemOrder`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `InvoiceItemOrder` mutation. */
export type UpdateInvoiceItemOrderPayloadInvoiceItemOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoiceItemOrdersOrderBy>>;
};

/** The output of our update `InvoiceItem` mutation. */
export type UpdateInvoiceItemPayload = {
  __typename?: 'UpdateInvoiceItemPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Invoice` that is related to this `InvoiceItem`. */
  invoiceByInvoiceId?: Maybe<Invoice>;
  /** The `InvoiceItem` that was updated by this mutation. */
  invoiceItem?: Maybe<InvoiceItem>;
  /** An edge for our `InvoiceItem`. May be used by Relay 1. */
  invoiceItemEdge?: Maybe<InvoiceItemsEdge>;
  /** Reads a single `Organization` that is related to this `InvoiceItem`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `InvoiceItem`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `InvoiceItem` mutation. */
export type UpdateInvoiceItemPayloadInvoiceItemEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoiceItemsOrderBy>>;
};

/** The output of our update `Invoice` mutation. */
export type UpdateInvoicePayload = {
  __typename?: 'UpdateInvoicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Invoice` that was updated by this mutation. */
  invoice?: Maybe<Invoice>;
  /** An edge for our `Invoice`. May be used by Relay 1. */
  invoiceEdge?: Maybe<InvoicesEdge>;
  /** Reads a single `Organization` that is related to this `Invoice`. */
  organizationByPayingOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `Invoice`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our update `Invoice` mutation. */
export type UpdateInvoicePayloadInvoiceEdgeArgs = {
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
};

/** All input for the `updateLaytimeResponsibilityById` mutation. */
export type UpdateLaytimeResponsibilityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LaytimeResponsibilityId']['input'];
  /** An object where the defined keys will be set on the `LaytimeResponsibility` being updated. */
  laytimeResponsibilityPatch: LaytimeResponsibilityPatch;
};

/** All input for the `updateLaytimeResponsibility` mutation. */
export type UpdateLaytimeResponsibilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `LaytimeResponsibility` being updated. */
  laytimeResponsibilityPatch: LaytimeResponsibilityPatch;
  /** The globally unique `ID` which will identify a single `LaytimeResponsibility` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `LaytimeResponsibility` mutation. */
export type UpdateLaytimeResponsibilityPayload = {
  __typename?: 'UpdateLaytimeResponsibilityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LaytimeResponsibility` that was updated by this mutation. */
  laytimeResponsibility?: Maybe<LaytimeResponsibility>;
  /** An edge for our `LaytimeResponsibility`. May be used by Relay 1. */
  laytimeResponsibilityEdge?: Maybe<LaytimeResponsibilitiesEdge>;
  /** Reads a single `Organization` that is related to this `LaytimeResponsibility`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `PortActivity` that is related to this `LaytimeResponsibility`. */
  portActivityByPortActivityId?: Maybe<PortActivity>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `LaytimeResponsibility`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our update `LaytimeResponsibility` mutation. */
export type UpdateLaytimeResponsibilityPayloadLaytimeResponsibilityEdgeArgs = {
  orderBy?: InputMaybe<Array<LaytimeResponsibilitiesOrderBy>>;
};

/** All input for the `updateLocationById` mutation. */
export type UpdateLocationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LocationId']['input'];
  /** An object where the defined keys will be set on the `Location` being updated. */
  locationPatch: LocationPatch;
};

/** All input for the `updateLocationClusterById` mutation. */
export type UpdateLocationClusterByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LocationClusterId']['input'];
  /** An object where the defined keys will be set on the `LocationCluster` being updated. */
  locationClusterPatch: LocationClusterPatch;
};

/** All input for the `updateLocationCluster` mutation. */
export type UpdateLocationClusterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `LocationCluster` being updated. */
  locationClusterPatch: LocationClusterPatch;
  /** The globally unique `ID` which will identify a single `LocationCluster` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `LocationCluster` mutation. */
export type UpdateLocationClusterPayload = {
  __typename?: 'UpdateLocationClusterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LocationCluster` that was updated by this mutation. */
  locationCluster?: Maybe<LocationCluster>;
  /** An edge for our `LocationCluster`. May be used by Relay 1. */
  locationClusterEdge?: Maybe<LocationClustersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LocationCluster` mutation. */
export type UpdateLocationClusterPayloadLocationClusterEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationClustersOrderBy>>;
};

/** All input for the `updateLocation` mutation. */
export type UpdateLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Location` being updated. */
  locationPatch: LocationPatch;
  /** The globally unique `ID` which will identify a single `Location` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Location` mutation. */
export type UpdateLocationPayload = {
  __typename?: 'UpdateLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Country` that is related to this `Location`. */
  countryByCountryId?: Maybe<Country>;
  /** The `Location` that was updated by this mutation. */
  location?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Location`. */
  locationByParentLocationId?: Maybe<Location>;
  /** Reads a single `LocationCluster` that is related to this `Location`. */
  locationClusterByClusterId?: Maybe<LocationCluster>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge?: Maybe<LocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Location`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Location` mutation. */
export type UpdateLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** All input for the `updateLocationRequirementAssociationById` mutation. */
export type UpdateLocationRequirementAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LocationRequirementAssociationId']['input'];
  /** An object where the defined keys will be set on the `LocationRequirementAssociation` being updated. */
  locationRequirementAssociationPatch: LocationRequirementAssociationPatch;
};

/** All input for the `updateLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneId` mutation. */
export type UpdateLocationRequirementAssociationBySpecialRequirementIdAndLocationIdAndZoneIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['LocationId']['input'];
  /** An object where the defined keys will be set on the `LocationRequirementAssociation` being updated. */
  locationRequirementAssociationPatch: LocationRequirementAssociationPatch;
  specialRequirementId: Scalars['SpecialRequirementId']['input'];
  zoneId: Scalars['ZoneId']['input'];
};

/** All input for the `updateLocationRequirementAssociation` mutation. */
export type UpdateLocationRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `LocationRequirementAssociation` being updated. */
  locationRequirementAssociationPatch: LocationRequirementAssociationPatch;
  /** The globally unique `ID` which will identify a single `LocationRequirementAssociation` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `LocationRequirementAssociation` mutation. */
export type UpdateLocationRequirementAssociationPayload = {
  __typename?: 'UpdateLocationRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `LocationRequirementAssociation`. */
  locationByLocationId?: Maybe<Location>;
  /** The `LocationRequirementAssociation` that was updated by this mutation. */
  locationRequirementAssociation?: Maybe<LocationRequirementAssociation>;
  /** An edge for our `LocationRequirementAssociation`. May be used by Relay 1. */
  locationRequirementAssociationEdge?: Maybe<LocationRequirementAssociationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpecialRequirement` that is related to this `LocationRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  /** Reads a single `Zone` that is related to this `LocationRequirementAssociation`. */
  zoneByZoneId?: Maybe<Zone>;
};


/** The output of our update `LocationRequirementAssociation` mutation. */
export type UpdateLocationRequirementAssociationPayloadLocationRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
};

/** All input for the `updateLocationWorkingHourById` mutation. */
export type UpdateLocationWorkingHourByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LocationWorkingHourId']['input'];
  /** An object where the defined keys will be set on the `LocationWorkingHour` being updated. */
  locationWorkingHourPatch: LocationWorkingHourPatch;
};

/** All input for the `updateLocationWorkingHour` mutation. */
export type UpdateLocationWorkingHourInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `LocationWorkingHour` being updated. */
  locationWorkingHourPatch: LocationWorkingHourPatch;
  /** The globally unique `ID` which will identify a single `LocationWorkingHour` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `LocationWorkingHour` mutation. */
export type UpdateLocationWorkingHourPayload = {
  __typename?: 'UpdateLocationWorkingHourPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `LocationWorkingHour`. */
  locationByLocationId?: Maybe<Location>;
  /** The `LocationWorkingHour` that was updated by this mutation. */
  locationWorkingHour?: Maybe<LocationWorkingHour>;
  /** An edge for our `LocationWorkingHour`. May be used by Relay 1. */
  locationWorkingHourEdge?: Maybe<LocationWorkingHoursEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `LocationWorkingHour`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `LocationWorkingHour` mutation. */
export type UpdateLocationWorkingHourPayloadLocationWorkingHourEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationWorkingHoursOrderBy>>;
};

/** All input for the `updateLostContractById` mutation. */
export type UpdateLostContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['LostContractId']['input'];
  /** An object where the defined keys will be set on the `LostContract` being updated. */
  lostContractPatch: LostContractPatch;
};

/** All input for the `updateLostContract` mutation. */
export type UpdateLostContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `LostContract` being updated. */
  lostContractPatch: LostContractPatch;
  /** The globally unique `ID` which will identify a single `LostContract` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `LostContract` mutation. */
export type UpdateLostContractPayload = {
  __typename?: 'UpdateLostContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `LostContract` that was updated by this mutation. */
  lostContract?: Maybe<LostContract>;
  /** An edge for our `LostContract`. May be used by Relay 1. */
  lostContractEdge?: Maybe<LostContractsEdge>;
  /** Reads a single `Organization` that is related to this `LostContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `LostContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `LostContract` mutation. */
export type UpdateLostContractPayloadLostContractEdgeArgs = {
  orderBy?: InputMaybe<Array<LostContractsOrderBy>>;
};

/** All input for the `updateMigrationById` mutation. */
export type UpdateMigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['MigrationId']['input'];
  /** An object where the defined keys will be set on the `Migration` being updated. */
  migrationPatch: MigrationPatch;
};

/** All input for the `updateMigration` mutation. */
export type UpdateMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `Migration` being updated. */
  migrationPatch: MigrationPatch;
  /** The globally unique `ID` which will identify a single `Migration` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `Migration` mutation. */
export type UpdateMigrationPayload = {
  __typename?: 'UpdateMigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Migration` that was updated by this mutation. */
  migration?: Maybe<Migration>;
  /** An edge for our `Migration`. May be used by Relay 1. */
  migrationEdge?: Maybe<MigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Migration` mutation. */
export type UpdateMigrationPayloadMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<MigrationsOrderBy>>;
};

/** All input for the `updateNoGoZoneById` mutation. */
export type UpdateNoGoZoneByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['NoGoZoneId']['input'];
  /** An object where the defined keys will be set on the `NoGoZone` being updated. */
  noGoZonePatch: NoGoZonePatch;
};

/** All input for the `updateNoGoZone` mutation. */
export type UpdateNoGoZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `NoGoZone` being updated. */
  noGoZonePatch: NoGoZonePatch;
  /** The globally unique `ID` which will identify a single `NoGoZone` to be updated. */
  nodeId: Scalars['ID']['input'];
};

/** The output of our update `NoGoZone` mutation. */
export type UpdateNoGoZonePayload = {
  __typename?: 'UpdateNoGoZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `NoGoZone` that was updated by this mutation. */
  noGoZone?: Maybe<NoGoZone>;
  /** An edge for our `NoGoZone`. May be used by Relay 1. */
  noGoZoneEdge?: Maybe<NoGoZonesEdge>;
  /** Reads a single `Organization` that is related to this `NoGoZone`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `NoGoZone` mutation. */
export type UpdateNoGoZonePayloadNoGoZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<NoGoZonesOrderBy>>;
};

/** All input for the `updateNotificationReceiverById` mutation. */
export type UpdateNotificationReceiverByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `NotificationReceiver` being updated. */
  notificationReceiverPatch: NotificationReceiverPatch;
};

/** The output of our update `NotificationReceiver` mutation. */
export type UpdateNotificationReceiverPayload = {
  __typename?: 'UpdateNotificationReceiverPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `NotificationReceiver`. */
  locationByLocationId?: Maybe<Location>;
  /** The `NotificationReceiver` that was updated by this mutation. */
  notificationReceiver?: Maybe<NotificationReceiver>;
  /** An edge for our `NotificationReceiver`. May be used by Relay 1. */
  notificationReceiverEdge?: Maybe<NotificationReceiversEdge>;
  /** Reads a single `Order` that is related to this `NotificationReceiver`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `NotificationReceiver`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `NotificationReceiver`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Voyage` that is related to this `NotificationReceiver`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our update `NotificationReceiver` mutation. */
export type UpdateNotificationReceiverPayloadNotificationReceiverEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};

/** All input for the `updateOffHireById` mutation. */
export type UpdateOffHireByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OffHireId']['input'];
  /** An object where the defined keys will be set on the `OffHire` being updated. */
  offHirePatch: OffHirePatch;
};

/** All input for the `updateOffHire` mutation. */
export type UpdateOffHireInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OffHire` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OffHire` being updated. */
  offHirePatch: OffHirePatch;
};

/** The output of our update `OffHire` mutation. */
export type UpdateOffHirePayload = {
  __typename?: 'UpdateOffHirePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `OffHire`. */
  locationByLocationAId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OffHire`. */
  locationByLocationBId?: Maybe<Location>;
  /** The `OffHire` that was updated by this mutation. */
  offHire?: Maybe<OffHire>;
  /** An edge for our `OffHire`. May be used by Relay 1. */
  offHireEdge?: Maybe<OffHiresEdge>;
  /** Reads a single `Organization` that is related to this `OffHire`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OffHire`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `OffHire`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `OffHire`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `OffHire`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `OffHire` mutation. */
export type UpdateOffHirePayloadOffHireEdgeArgs = {
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};

/** All input for the `updateOpenPositionById` mutation. */
export type UpdateOpenPositionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OpenPositionId']['input'];
  /** An object where the defined keys will be set on the `OpenPosition` being updated. */
  openPositionPatch: OpenPositionPatch;
};

/** All input for the `updateOpenPosition` mutation. */
export type UpdateOpenPositionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OpenPosition` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OpenPosition` being updated. */
  openPositionPatch: OpenPositionPatch;
};

/** The output of our update `OpenPosition` mutation. */
export type UpdateOpenPositionPayload = {
  __typename?: 'UpdateOpenPositionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `OpenPosition`. */
  locationByDirectionId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `OpenPosition`. */
  locationByStartPortId?: Maybe<Location>;
  /** The `OpenPosition` that was updated by this mutation. */
  openPosition?: Maybe<OpenPosition>;
  /** An edge for our `OpenPosition`. May be used by Relay 1. */
  openPositionEdge?: Maybe<OpenPositionsEdge>;
  /** Reads a single `Organization` that is related to this `OpenPosition`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `OpenPosition`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `OpenPosition`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `OpenPosition`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our update `OpenPosition` mutation. */
export type UpdateOpenPositionPayloadOpenPositionEdgeArgs = {
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};

/** All input for the `updateOrderAttributeAssociationById` mutation. */
export type UpdateOrderAttributeAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderAttributeAssociationId']['input'];
  /** An object where the defined keys will be set on the `OrderAttributeAssociation` being updated. */
  orderAttributeAssociationPatch: OrderAttributeAssociationPatch;
};

/** All input for the `updateOrderAttributeAssociation` mutation. */
export type UpdateOrderAttributeAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderAttributeAssociation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrderAttributeAssociation` being updated. */
  orderAttributeAssociationPatch: OrderAttributeAssociationPatch;
};

/** The output of our update `OrderAttributeAssociation` mutation. */
export type UpdateOrderAttributeAssociationPayload = {
  __typename?: 'UpdateOrderAttributeAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OrderAttributeAssociation` that was updated by this mutation. */
  orderAttributeAssociation?: Maybe<OrderAttributeAssociation>;
  /** An edge for our `OrderAttributeAssociation`. May be used by Relay 1. */
  orderAttributeAssociationEdge?: Maybe<OrderAttributeAssociationsEdge>;
  /** Reads a single `OrderAttribute` that is related to this `OrderAttributeAssociation`. */
  orderAttributeByOrderAttributeId?: Maybe<OrderAttribute>;
  /** Reads a single `Order` that is related to this `OrderAttributeAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `OrderAttributeAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderAttributeAssociation` mutation. */
export type UpdateOrderAttributeAssociationPayloadOrderAttributeAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderAttributeAssociationsOrderBy>>;
};

/** All input for the `updateOrderAttributeById` mutation. */
export type UpdateOrderAttributeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderAttributeId']['input'];
  /** An object where the defined keys will be set on the `OrderAttribute` being updated. */
  orderAttributePatch: OrderAttributePatch;
};

/** All input for the `updateOrderAttribute` mutation. */
export type UpdateOrderAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderAttribute` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrderAttribute` being updated. */
  orderAttributePatch: OrderAttributePatch;
};

/** The output of our update `OrderAttribute` mutation. */
export type UpdateOrderAttributePayload = {
  __typename?: 'UpdateOrderAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OrderAttribute` that was updated by this mutation. */
  orderAttribute?: Maybe<OrderAttribute>;
  /** An edge for our `OrderAttribute`. May be used by Relay 1. */
  orderAttributeEdge?: Maybe<OrderAttributesEdge>;
  /** Reads a single `Organization` that is related to this `OrderAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderAttribute` mutation. */
export type UpdateOrderAttributePayloadOrderAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderAttributesOrderBy>>;
};

/** All input for the `updateOrderById` mutation. */
export type UpdateOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderId']['input'];
  /** An object where the defined keys will be set on the `Order` being updated. */
  orderPatch: OrderPatch;
};

/** All input for the `updateOrderDetailById` mutation. */
export type UpdateOrderDetailByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderDetailId']['input'];
  /** An object where the defined keys will be set on the `OrderDetail` being updated. */
  orderDetailPatch: OrderDetailPatch;
};

/** All input for the `updateOrderDetail` mutation. */
export type UpdateOrderDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderDetail` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrderDetail` being updated. */
  orderDetailPatch: OrderDetailPatch;
};

/** The output of our update `OrderDetail` mutation. */
export type UpdateOrderDetailPayload = {
  __typename?: 'UpdateOrderDetailPayload';
  /** Reads a single `CargoEquipment` that is related to this `OrderDetail`. */
  cargoEquipmentByCargoEquipmentId?: Maybe<CargoEquipment>;
  /** Reads a single `CargoLengthUnit` that is related to this `OrderDetail`. */
  cargoLengthUnitByCargoLengthUnitId?: Maybe<CargoLengthUnit>;
  /** Reads a single `CargoWeightUnit` that is related to this `OrderDetail`. */
  cargoWeightUnitByCargoWeightUnitId?: Maybe<CargoWeightUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `OrderDetail`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderDetail` that was updated by this mutation. */
  orderDetail?: Maybe<OrderDetail>;
  /** An edge for our `OrderDetail`. May be used by Relay 1. */
  orderDetailEdge?: Maybe<OrderDetailsEdge>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByDischargePortAgentId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByLoadPortAgentOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByReceiverOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `OrderDetail`. */
  organizationBySenderOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SupplyContract` that is related to this `OrderDetail`. */
  supplyContractBySupplyContractId?: Maybe<SupplyContract>;
};


/** The output of our update `OrderDetail` mutation. */
export type UpdateOrderDetailPayloadOrderDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderDetailsOrderBy>>;
};

/** All input for the `updateOrder` mutation. */
export type UpdateOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Order` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Order` being updated. */
  orderPatch: OrderPatch;
};

/** The output of our update `Order` mutation. */
export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  /** Reads a single `Assortment` that is related to this `Order`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Order`. */
  cargoUnitByCargoUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `Order`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  /** Reads a single `Location` that is related to this `Order`. */
  locationByDischargePortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `Order`. */
  locationByLoadPortId?: Maybe<Location>;
  /** The `Order` that was updated by this mutation. */
  order?: Maybe<Order>;
  /** An edge for our `Order`. May be used by Relay 1. */
  orderEdge?: Maybe<OrdersEdge>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByChartererOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Order`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `Order`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** Reads a single `User` that is related to this `Order`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Order`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselAttribute` that is related to this `Order`. */
  vesselAttributeByMinVesselClassRequirement?: Maybe<VesselAttribute>;
};


/** The output of our update `Order` mutation. */
export type UpdateOrderPayloadOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};

/** All input for the `updateOrderPortCallRelationById` mutation. */
export type UpdateOrderPortCallRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderPortCallRelationId']['input'];
  /** An object where the defined keys will be set on the `OrderPortCallRelation` being updated. */
  orderPortCallRelationPatch: OrderPortCallRelationPatch;
};

/** All input for the `updateOrderPortCallRelationByOrderIdAndIsLoadPort` mutation. */
export type UpdateOrderPortCallRelationByOrderIdAndIsLoadPortInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isLoadPort: Scalars['Boolean']['input'];
  orderId: Scalars['OrderId']['input'];
  /** An object where the defined keys will be set on the `OrderPortCallRelation` being updated. */
  orderPortCallRelationPatch: OrderPortCallRelationPatch;
};

/** All input for the `updateOrderPortCallRelation` mutation. */
export type UpdateOrderPortCallRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderPortCallRelation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrderPortCallRelation` being updated. */
  orderPortCallRelationPatch: OrderPortCallRelationPatch;
};

/** The output of our update `OrderPortCallRelation` mutation. */
export type UpdateOrderPortCallRelationPayload = {
  __typename?: 'UpdateOrderPortCallRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `OrderPortCallRelation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderPortCallRelation` that was updated by this mutation. */
  orderPortCallRelation?: Maybe<OrderPortCallRelation>;
  /** An edge for our `OrderPortCallRelation`. May be used by Relay 1. */
  orderPortCallRelationEdge?: Maybe<OrderPortCallRelationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderPortCallRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `OrderPortCallRelation`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `OrderPortCallRelation`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our update `OrderPortCallRelation` mutation. */
export type UpdateOrderPortCallRelationPayloadOrderPortCallRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderPortCallRelationsOrderBy>>;
};

/** All input for the `updateOrderPortOverrideByOrderId` mutation. */
export type UpdateOrderPortOverrideByOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
  /** An object where the defined keys will be set on the `OrderPortOverride` being updated. */
  orderPortOverridePatch: OrderPortOverridePatch;
};

/** All input for the `updateOrderPortOverride` mutation. */
export type UpdateOrderPortOverrideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderPortOverride` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrderPortOverride` being updated. */
  orderPortOverridePatch: OrderPortOverridePatch;
};

/** The output of our update `OrderPortOverride` mutation. */
export type UpdateOrderPortOverridePayload = {
  __typename?: 'UpdateOrderPortOverridePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `OrderPortOverride`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderPortOverride` that was updated by this mutation. */
  orderPortOverride?: Maybe<OrderPortOverride>;
  /** An edge for our `OrderPortOverride`. May be used by Relay 1. */
  orderPortOverrideEdge?: Maybe<OrderPortOverridesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrderPortOverride` mutation. */
export type UpdateOrderPortOverridePayloadOrderPortOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderPortOverridesOrderBy>>;
};

/** All input for the `updateOrderRequirementAssociationById` mutation. */
export type UpdateOrderRequirementAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderRequirementAssociationId']['input'];
  /** An object where the defined keys will be set on the `OrderRequirementAssociation` being updated. */
  orderRequirementAssociationPatch: OrderRequirementAssociationPatch;
};

/** All input for the `updateOrderRequirementAssociationBySpecialRequirementIdAndOrderId` mutation. */
export type UpdateOrderRequirementAssociationBySpecialRequirementIdAndOrderIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
  /** An object where the defined keys will be set on the `OrderRequirementAssociation` being updated. */
  orderRequirementAssociationPatch: OrderRequirementAssociationPatch;
  specialRequirementId: Scalars['SpecialRequirementId']['input'];
};

/** All input for the `updateOrderRequirementAssociation` mutation. */
export type UpdateOrderRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderRequirementAssociation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrderRequirementAssociation` being updated. */
  orderRequirementAssociationPatch: OrderRequirementAssociationPatch;
};

/** The output of our update `OrderRequirementAssociation` mutation. */
export type UpdateOrderRequirementAssociationPayload = {
  __typename?: 'UpdateOrderRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `OrderRequirementAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderRequirementAssociation` that was updated by this mutation. */
  orderRequirementAssociation?: Maybe<OrderRequirementAssociation>;
  /** An edge for our `OrderRequirementAssociation`. May be used by Relay 1. */
  orderRequirementAssociationEdge?: Maybe<OrderRequirementAssociationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderRequirementAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpecialRequirement` that is related to this `OrderRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
};


/** The output of our update `OrderRequirementAssociation` mutation. */
export type UpdateOrderRequirementAssociationPayloadOrderRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderRequirementAssociationsOrderBy>>;
};

/** All input for the `updateOrderVoyageCharterRelationById` mutation. */
export type UpdateOrderVoyageCharterRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrderVoyageCharterRelationId']['input'];
  /** An object where the defined keys will be set on the `OrderVoyageCharterRelation` being updated. */
  orderVoyageCharterRelationPatch: OrderVoyageCharterRelationPatch;
};

/** All input for the `updateOrderVoyageCharterRelationByOrderIdAndOutgoing` mutation. */
export type UpdateOrderVoyageCharterRelationByOrderIdAndOutgoingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['OrderId']['input'];
  /** An object where the defined keys will be set on the `OrderVoyageCharterRelation` being updated. */
  orderVoyageCharterRelationPatch: OrderVoyageCharterRelationPatch;
  outgoing: Scalars['Boolean']['input'];
};

/** All input for the `updateOrderVoyageCharterRelation` mutation. */
export type UpdateOrderVoyageCharterRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrderVoyageCharterRelation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrderVoyageCharterRelation` being updated. */
  orderVoyageCharterRelationPatch: OrderVoyageCharterRelationPatch;
};

/** The output of our update `OrderVoyageCharterRelation` mutation. */
export type UpdateOrderVoyageCharterRelationPayload = {
  __typename?: 'UpdateOrderVoyageCharterRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContractPort` that is related to this `OrderVoyageCharterRelation`. */
  coaContractPortByCoaRouteId?: Maybe<CoaContractPort>;
  /** Reads a single `Order` that is related to this `OrderVoyageCharterRelation`. */
  orderByOrderId?: Maybe<Order>;
  /** The `OrderVoyageCharterRelation` that was updated by this mutation. */
  orderVoyageCharterRelation?: Maybe<OrderVoyageCharterRelation>;
  /** An edge for our `OrderVoyageCharterRelation`. May be used by Relay 1. */
  orderVoyageCharterRelationEdge?: Maybe<OrderVoyageCharterRelationsEdge>;
  /** Reads a single `Organization` that is related to this `OrderVoyageCharterRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `OrderVoyageCharterRelation`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `OrderVoyageCharterRelation`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our update `OrderVoyageCharterRelation` mutation. */
export type UpdateOrderVoyageCharterRelationPayloadOrderVoyageCharterRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};

/** All input for the `updateOrdersAfterLocationTimezoneChange` mutation. */
export type UpdateOrdersAfterLocationTimezoneChangeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `updateOrdersAfterLocationTimezoneChange` mutation. */
export type UpdateOrdersAfterLocationTimezoneChangePayload = {
  __typename?: 'UpdateOrdersAfterLocationTimezoneChangePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrgDescendants` mutation. */
export type UpdateOrgDescendantsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** The output of our `updateOrgDescendants` mutation. */
export type UpdateOrgDescendantsPayload = {
  __typename?: 'UpdateOrgDescendantsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea` mutation. */
export type UpdateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `OrganizationAreaBunkerGradeMapping` being updated. */
  organizationAreaBunkerGradeMappingPatch: OrganizationAreaBunkerGradeMappingPatch;
  organizationId: Scalars['OrganizationId']['input'];
  vesselArea: VesselArea;
};

/** All input for the `updateOrganizationAreaBunkerGradeMapping` mutation. */
export type UpdateOrganizationAreaBunkerGradeMappingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrganizationAreaBunkerGradeMapping` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrganizationAreaBunkerGradeMapping` being updated. */
  organizationAreaBunkerGradeMappingPatch: OrganizationAreaBunkerGradeMappingPatch;
};

/** The output of our update `OrganizationAreaBunkerGradeMapping` mutation. */
export type UpdateOrganizationAreaBunkerGradeMappingPayload = {
  __typename?: 'UpdateOrganizationAreaBunkerGradeMappingPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `OrganizationAreaBunkerGradeMapping`. */
  bunkerGradeOverrideByBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `OrganizationAreaBunkerGradeMapping` that was updated by this mutation. */
  organizationAreaBunkerGradeMapping?: Maybe<OrganizationAreaBunkerGradeMapping>;
  /** An edge for our `OrganizationAreaBunkerGradeMapping`. May be used by Relay 1. */
  organizationAreaBunkerGradeMappingEdge?: Maybe<OrganizationAreaBunkerGradeMappingsEdge>;
  /** Reads a single `Organization` that is related to this `OrganizationAreaBunkerGradeMapping`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrganizationAreaBunkerGradeMapping` mutation. */
export type UpdateOrganizationAreaBunkerGradeMappingPayloadOrganizationAreaBunkerGradeMappingEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationAreaBunkerGradeMappingsOrderBy>>;
};

/** All input for the `updateOrganizationById` mutation. */
export type UpdateOrganizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `Organization` being updated. */
  organizationPatch: OrganizationPatch;
};

/** All input for the `updateOrganizationFeatureById` mutation. */
export type UpdateOrganizationFeatureByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['OrganizationFeatureId']['input'];
  /** An object where the defined keys will be set on the `OrganizationFeature` being updated. */
  organizationFeaturePatch: OrganizationFeaturePatch;
};

/** All input for the `updateOrganizationFeature` mutation. */
export type UpdateOrganizationFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `OrganizationFeature` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `OrganizationFeature` being updated. */
  organizationFeaturePatch: OrganizationFeaturePatch;
};

/** The output of our update `OrganizationFeature` mutation. */
export type UpdateOrganizationFeaturePayload = {
  __typename?: 'UpdateOrganizationFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Feature` that is related to this `OrganizationFeature`. */
  featureByFeatureName?: Maybe<Feature>;
  /** Reads a single `Organization` that is related to this `OrganizationFeature`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `OrganizationFeature` that was updated by this mutation. */
  organizationFeature?: Maybe<OrganizationFeature>;
  /** An edge for our `OrganizationFeature`. May be used by Relay 1. */
  organizationFeatureEdge?: Maybe<OrganizationFeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `OrganizationFeature` mutation. */
export type UpdateOrganizationFeaturePayloadOrganizationFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationFeaturesOrderBy>>;
};

/** All input for the `updateOrganization` mutation. */
export type UpdateOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Organization` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Organization` being updated. */
  organizationPatch: OrganizationPatch;
};

/** The output of our update `Organization` mutation. */
export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Organization` that was updated by this mutation. */
  organization?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Organization`. */
  organizationByParentOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Organization`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge?: Maybe<OrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Organization` mutation. */
export type UpdateOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};

/** All input for the `updatePortActivityById` mutation. */
export type UpdatePortActivityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortActivityId']['input'];
  /** An object where the defined keys will be set on the `PortActivity` being updated. */
  portActivityPatch: PortActivityPatch;
};

/** All input for the `updatePortActivity` mutation. */
export type UpdatePortActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortActivity` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortActivity` being updated. */
  portActivityPatch: PortActivityPatch;
};

/** The output of our update `PortActivity` mutation. */
export type UpdatePortActivityPayload = {
  __typename?: 'UpdatePortActivityPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `PortActivity`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `PortActivity`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** The `PortActivity` that was updated by this mutation. */
  portActivity?: Maybe<PortActivity>;
  /** An edge for our `PortActivity`. May be used by Relay 1. */
  portActivityEdge?: Maybe<PortActivitiesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `StatementOfFact` that is related to this `PortActivity`. */
  statementOfFactByStatementOfFactsId?: Maybe<StatementOfFact>;
  /** Reads a single `User` that is related to this `PortActivity`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `PortActivity` mutation. */
export type UpdatePortActivityPayloadPortActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<PortActivitiesOrderBy>>;
};

/** All input for the `updatePortCallById` mutation. */
export type UpdatePortCallByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCallId']['input'];
  /** An object where the defined keys will be set on the `PortCall` being updated. */
  portCallPatch: PortCallPatch;
};

/** All input for the `updatePortCallExternalTimestampById` mutation. */
export type UpdatePortCallExternalTimestampByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCallExternalTimestampId']['input'];
  /** An object where the defined keys will be set on the `PortCallExternalTimestamp` being updated. */
  portCallExternalTimestampPatch: PortCallExternalTimestampPatch;
};

/** All input for the `updatePortCallExternalTimestamp` mutation. */
export type UpdatePortCallExternalTimestampInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCallExternalTimestamp` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortCallExternalTimestamp` being updated. */
  portCallExternalTimestampPatch: PortCallExternalTimestampPatch;
};

/** The output of our update `PortCallExternalTimestamp` mutation. */
export type UpdatePortCallExternalTimestampPayload = {
  __typename?: 'UpdatePortCallExternalTimestampPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PortCallExternalTimestamp`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortCallExternalTimestamp`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortCallExternalTimestamp` that was updated by this mutation. */
  portCallExternalTimestamp?: Maybe<PortCallExternalTimestamp>;
  /** An edge for our `PortCallExternalTimestamp`. May be used by Relay 1. */
  portCallExternalTimestampEdge?: Maybe<PortCallExternalTimestampsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PortCallExternalTimestamp` mutation. */
export type UpdatePortCallExternalTimestampPayloadPortCallExternalTimestampEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallExternalTimestampsOrderBy>>;
};

export type UpdatePortCallExternalTimestampsInput = {
  portCallClientId: Scalars['UUID']['input'];
};

export type UpdatePortCallExternalTimestampsOutput = {
  __typename?: 'UpdatePortCallExternalTimestampsOutput';
  errorText?: Maybe<Scalars['String']['output']>;
  isOk: Scalars['Boolean']['output'];
  portCallClientId: Scalars['UUID']['output'];
};

/** All input for the `updatePortCallFileByFileId` mutation. */
export type UpdatePortCallFileByFileIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['FileId']['input'];
  /** An object where the defined keys will be set on the `PortCallFile` being updated. */
  portCallFilePatch: PortCallFilePatch;
};

/** All input for the `updatePortCallFileById` mutation. */
export type UpdatePortCallFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCallFileId']['input'];
  /** An object where the defined keys will be set on the `PortCallFile` being updated. */
  portCallFilePatch: PortCallFilePatch;
};

/** All input for the `updatePortCallFile` mutation. */
export type UpdatePortCallFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCallFile` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortCallFile` being updated. */
  portCallFilePatch: PortCallFilePatch;
};

/** The output of our update `PortCallFile` mutation. */
export type UpdatePortCallFilePayload = {
  __typename?: 'UpdatePortCallFilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `File` that is related to this `PortCallFile`. */
  fileByFileId?: Maybe<File>;
  /** Reads a single `Organization` that is related to this `PortCallFile`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortCallFile`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortCallFile` that was updated by this mutation. */
  portCallFile?: Maybe<PortCallFile>;
  /** An edge for our `PortCallFile`. May be used by Relay 1. */
  portCallFileEdge?: Maybe<PortCallFilesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PortCallFile` mutation. */
export type UpdatePortCallFilePayloadPortCallFileEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallFilesOrderBy>>;
};

/** All input for the `updatePortCall` mutation. */
export type UpdatePortCallInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCall` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortCall` being updated. */
  portCallPatch: PortCallPatch;
};

/** The output of our update `PortCall` mutation. */
export type UpdatePortCallPayload = {
  __typename?: 'UpdatePortCallPayload';
  /** Reads a single `ChannelCostEstimate` that is related to this `PortCall`. */
  channelCostEstimateByChannelCostDefaultId?: Maybe<ChannelCostEstimate>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortCall`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `PortCall`. */
  locationByPreviousLocationId?: Maybe<Location>;
  /** The `PortCall` that was updated by this mutation. */
  portCall?: Maybe<PortCall>;
  /** An edge for our `PortCall`. May be used by Relay 1. */
  portCallEdge?: Maybe<PortCallsEdge>;
  /** Reads a single `PortCostDefault` that is related to this `PortCall`. */
  portCostDefaultByPortCostDefaultId?: Maybe<PortCostDefault>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCall`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `PortCall`. */
  userByModifiedByUserId?: Maybe<User>;
};


/** The output of our update `PortCall` mutation. */
export type UpdatePortCallPayloadPortCallEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};

/** All input for the `updatePortCommodityLdRateById` mutation. */
export type UpdatePortCommodityLdRateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCommodityLdRateIdString']['input'];
  /** An object where the defined keys will be set on the `PortCommodityLdRate` being updated. */
  portCommodityLdRatePatch: PortCommodityLdRatePatch;
};

/** All input for the `updatePortCommodityLdRate` mutation. */
export type UpdatePortCommodityLdRateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCommodityLdRate` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortCommodityLdRate` being updated. */
  portCommodityLdRatePatch: PortCommodityLdRatePatch;
};

/** The output of our update `PortCommodityLdRate` mutation. */
export type UpdatePortCommodityLdRatePayload = {
  __typename?: 'UpdatePortCommodityLdRatePayload';
  /** Reads a single `Assortment` that is related to this `PortCommodityLdRate`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `PortCommodityLdRate`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortCommodityLdRate`. */
  locationByPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCommodityLdRate`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCommodityLdRate` that was updated by this mutation. */
  portCommodityLdRate?: Maybe<PortCommodityLdRate>;
  /** An edge for our `PortCommodityLdRate`. May be used by Relay 1. */
  portCommodityLdRateEdge?: Maybe<PortCommodityLdRatesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `PortCommodityLdRate`. */
  zoneByZoneId?: Maybe<Zone>;
};


/** The output of our update `PortCommodityLdRate` mutation. */
export type UpdatePortCommodityLdRatePayloadPortCommodityLdRateEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};

/** All input for the `updatePortCostById` mutation. */
export type UpdatePortCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCostId']['input'];
  /** An object where the defined keys will be set on the `PortCost` being updated. */
  portCostPatch: PortCostPatch;
};

/** All input for the `updatePortCostDefaultById` mutation. */
export type UpdatePortCostDefaultByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCostDefaultId']['input'];
  /** An object where the defined keys will be set on the `PortCostDefault` being updated. */
  portCostDefaultPatch: PortCostDefaultPatch;
};

/** All input for the `updatePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrency` mutation. */
export type UpdatePortCostDefaultByVesselIdAndVesselTypeIdAndLocationIdAndCurrencyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
  locationId: Scalars['LocationId']['input'];
  /** An object where the defined keys will be set on the `PortCostDefault` being updated. */
  portCostDefaultPatch: PortCostDefaultPatch;
  vesselId: Scalars['ShipId']['input'];
  vesselTypeId: Scalars['VesselAttributeId']['input'];
};

/** All input for the `updatePortCostDefault` mutation. */
export type UpdatePortCostDefaultInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCostDefault` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortCostDefault` being updated. */
  portCostDefaultPatch: PortCostDefaultPatch;
};

/** The output of our update `PortCostDefault` mutation. */
export type UpdatePortCostDefaultPayload = {
  __typename?: 'UpdatePortCostDefaultPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortCostDefault`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCostDefault`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCostDefault` that was updated by this mutation. */
  portCostDefault?: Maybe<PortCostDefault>;
  /** An edge for our `PortCostDefault`. May be used by Relay 1. */
  portCostDefaultEdge?: Maybe<PortCostDefaultsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCostDefault`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `PortCostDefault`. */
  vesselAttributeByVesselTypeId?: Maybe<VesselAttribute>;
};


/** The output of our update `PortCostDefault` mutation. */
export type UpdatePortCostDefaultPayloadPortCostDefaultEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostDefaultsOrderBy>>;
};

/** All input for the `updatePortCostEstimatesExternalById` mutation. */
export type UpdatePortCostEstimatesExternalByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortCostEstimatesExternalId']['input'];
  /** An object where the defined keys will be set on the `PortCostEstimatesExternal` being updated. */
  portCostEstimatesExternalPatch: PortCostEstimatesExternalPatch;
};

/** All input for the `updatePortCostEstimatesExternal` mutation. */
export type UpdatePortCostEstimatesExternalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCostEstimatesExternal` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortCostEstimatesExternal` being updated. */
  portCostEstimatesExternalPatch: PortCostEstimatesExternalPatch;
};

/** The output of our update `PortCostEstimatesExternal` mutation. */
export type UpdatePortCostEstimatesExternalPayload = {
  __typename?: 'UpdatePortCostEstimatesExternalPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PortCostEstimatesExternal`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortCostEstimatesExternal` that was updated by this mutation. */
  portCostEstimatesExternal?: Maybe<PortCostEstimatesExternal>;
  /** An edge for our `PortCostEstimatesExternal`. May be used by Relay 1. */
  portCostEstimatesExternalEdge?: Maybe<PortCostEstimatesExternalsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PortCostEstimatesExternal` mutation. */
export type UpdatePortCostEstimatesExternalPayloadPortCostEstimatesExternalEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostEstimatesExternalsOrderBy>>;
};

/** All input for the `updatePortCost` mutation. */
export type UpdatePortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortCost` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortCost` being updated. */
  portCostPatch: PortCostPatch;
};

/** The output of our update `PortCost` mutation. */
export type UpdatePortCostPayload = {
  __typename?: 'UpdatePortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortCost`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortCost`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** The `PortCost` that was updated by this mutation. */
  portCost?: Maybe<PortCost>;
  /** An edge for our `PortCost`. May be used by Relay 1. */
  portCostEdge?: Maybe<PortCostsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `PortCost`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `PortCost`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `PortCost` mutation. */
export type UpdatePortCostPayloadPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<PortCostsOrderBy>>;
};

/** All input for the `updatePortDatumById` mutation. */
export type UpdatePortDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortDatumId']['input'];
  /** An object where the defined keys will be set on the `PortDatum` being updated. */
  portDatumPatch: PortDatumPatch;
};

/** All input for the `updatePortDatum` mutation. */
export type UpdatePortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortDatum` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortDatum` being updated. */
  portDatumPatch: PortDatumPatch;
};

/** The output of our update `PortDatum` mutation. */
export type UpdatePortDatumPayload = {
  __typename?: 'UpdatePortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `PortDatum`. */
  locationByPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortDatum`. */
  organizationByPortAgentOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `PortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** The `PortDatum` that was updated by this mutation. */
  portDatum?: Maybe<PortDatum>;
  /** An edge for our `PortDatum`. May be used by Relay 1. */
  portDatumEdge?: Maybe<PortDataEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `PortDatum` mutation. */
export type UpdatePortDatumPayloadPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<PortDataOrderBy>>;
};

export type UpdatePortMissedTimezoneResult = {
  __typename?: 'UpdatePortMissedTimezoneResult';
  errors: Array<Maybe<Scalars['String']['output']>>;
  totalUpdateSuccess: Scalars['Int']['output'];
  warning: Array<Maybe<Scalars['String']['output']>>;
};

/** All input for the `updatePortNoticeById` mutation. */
export type UpdatePortNoticeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortNoticeId']['input'];
  /** An object where the defined keys will be set on the `PortNotice` being updated. */
  portNoticePatch: PortNoticePatch;
};

/** All input for the `updatePortNotice` mutation. */
export type UpdatePortNoticeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortNotice` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortNotice` being updated. */
  portNoticePatch: PortNoticePatch;
};

/** The output of our update `PortNotice` mutation. */
export type UpdatePortNoticePayload = {
  __typename?: 'UpdatePortNoticePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `PortNotice`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `PortNotice`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** The `PortNotice` that was updated by this mutation. */
  portNotice?: Maybe<PortNotice>;
  /** An edge for our `PortNotice`. May be used by Relay 1. */
  portNoticeEdge?: Maybe<PortNoticesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PortNotice`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `PortNotice`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `PortNotice` mutation. */
export type UpdatePortNoticePayloadPortNoticeEdgeArgs = {
  orderBy?: InputMaybe<Array<PortNoticesOrderBy>>;
};

/** All input for the `updatePortRegionById` mutation. */
export type UpdatePortRegionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PortRegionId']['input'];
  /** An object where the defined keys will be set on the `PortRegion` being updated. */
  portRegionPatch: PortRegionPatch;
};

/** All input for the `updatePortRegionByLocationIdAndRegionIdAndOrganizationId` mutation. */
export type UpdatePortRegionByLocationIdAndRegionIdAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['LocationId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `PortRegion` being updated. */
  portRegionPatch: PortRegionPatch;
  regionId: Scalars['RegionId']['input'];
};

/** All input for the `updatePortRegion` mutation. */
export type UpdatePortRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `PortRegion` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `PortRegion` being updated. */
  portRegionPatch: PortRegionPatch;
};

/** The output of our update `PortRegion` mutation. */
export type UpdatePortRegionPayload = {
  __typename?: 'UpdatePortRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `GeographicalEntity` that is related to this `PortRegion`. */
  geographicalEntityByGeographicalEntityId?: Maybe<GeographicalEntity>;
  /** Reads a single `Location` that is related to this `PortRegion`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `PortRegion`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `PortRegion` that was updated by this mutation. */
  portRegion?: Maybe<PortRegion>;
  /** An edge for our `PortRegion`. May be used by Relay 1. */
  portRegionEdge?: Maybe<PortRegionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `PortRegion`. */
  regionByRegionId?: Maybe<Region>;
};


/** The output of our update `PortRegion` mutation. */
export type UpdatePortRegionPayloadPortRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<PortRegionsOrderBy>>;
};

/** All input for the `updatePromptById` mutation. */
export type UpdatePromptByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['PromptId']['input'];
  /** An object where the defined keys will be set on the `Prompt` being updated. */
  promptPatch: PromptPatch;
};

/** All input for the `updatePrompt` mutation. */
export type UpdatePromptInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Prompt` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Prompt` being updated. */
  promptPatch: PromptPatch;
};

/** The output of our update `Prompt` mutation. */
export type UpdatePromptPayload = {
  __typename?: 'UpdatePromptPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Prompt`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** The `Prompt` that was updated by this mutation. */
  prompt?: Maybe<Prompt>;
  /** An edge for our `Prompt`. May be used by Relay 1. */
  promptEdge?: Maybe<PromptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Prompt`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Prompt`. */
  userByModifiedBy?: Maybe<User>;
};


/** The output of our update `Prompt` mutation. */
export type UpdatePromptPayloadPromptEdgeArgs = {
  orderBy?: InputMaybe<Array<PromptsOrderBy>>;
};

export type UpdateQ88ScenarioResult = {
  __typename?: 'UpdateQ88ScenarioResult';
  generatedTCLength: Scalars['Int']['output'];
  itemsLength: Scalars['Int']['output'];
  scenarioCid: Scalars['String']['output'];
  status: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

/** All input for the `updateQuayById` mutation. */
export type UpdateQuayByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['QuayId']['input'];
  /** An object where the defined keys will be set on the `Quay` being updated. */
  quayPatch: QuayPatch;
};

/** All input for the `updateQuay` mutation. */
export type UpdateQuayInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Quay` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Quay` being updated. */
  quayPatch: QuayPatch;
};

/** The output of our update `Quay` mutation. */
export type UpdateQuayPayload = {
  __typename?: 'UpdateQuayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `Quay`. */
  locationByLocationId?: Maybe<Location>;
  /** The `Quay` that was updated by this mutation. */
  quay?: Maybe<Quay>;
  /** An edge for our `Quay`. May be used by Relay 1. */
  quayEdge?: Maybe<QuaysEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Quay`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Quay` mutation. */
export type UpdateQuayPayloadQuayEdgeArgs = {
  orderBy?: InputMaybe<Array<QuaysOrderBy>>;
};

/** All input for the `updateReceiverOrganizationByAdminOrganizationIdAndOrganizationId` mutation. */
export type UpdateReceiverOrganizationByAdminOrganizationIdAndOrganizationIdInput = {
  adminOrganizationId: Scalars['OrganizationId']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `ReceiverOrganization` being updated. */
  receiverOrganizationPatch: ReceiverOrganizationPatch;
};

/** All input for the `updateReceiverOrganizationById` mutation. */
export type UpdateReceiverOrganizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ReceiverOrganizationId']['input'];
  /** An object where the defined keys will be set on the `ReceiverOrganization` being updated. */
  receiverOrganizationPatch: ReceiverOrganizationPatch;
};

/** All input for the `updateReceiverOrganization` mutation. */
export type UpdateReceiverOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ReceiverOrganization` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ReceiverOrganization` being updated. */
  receiverOrganizationPatch: ReceiverOrganizationPatch;
};

/** The output of our update `ReceiverOrganization` mutation. */
export type UpdateReceiverOrganizationPayload = {
  __typename?: 'UpdateReceiverOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `ReceiverOrganization`. */
  organizationByAdminOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `ReceiverOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ReceiverOrganization` that was updated by this mutation. */
  receiverOrganization?: Maybe<ReceiverOrganization>;
  /** An edge for our `ReceiverOrganization`. May be used by Relay 1. */
  receiverOrganizationEdge?: Maybe<ReceiverOrganizationsEdge>;
};


/** The output of our update `ReceiverOrganization` mutation. */
export type UpdateReceiverOrganizationPayloadReceiverOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<ReceiverOrganizationsOrderBy>>;
};

/** All input for the `updateRegionById` mutation. */
export type UpdateRegionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RegionId']['input'];
  /** An object where the defined keys will be set on the `Region` being updated. */
  regionPatch: RegionPatch;
};

/** All input for the `updateRegion` mutation. */
export type UpdateRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Region` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Region` being updated. */
  regionPatch: RegionPatch;
};

/** The output of our update `Region` mutation. */
export type UpdateRegionPayload = {
  __typename?: 'UpdateRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Region`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Region` that was updated by this mutation. */
  region?: Maybe<Region>;
  /** Reads a single `Region` that is related to this `Region`. */
  regionByParentRegion?: Maybe<Region>;
  /** An edge for our `Region`. May be used by Relay 1. */
  regionEdge?: Maybe<RegionsEdge>;
  /** Reads a single `User` that is related to this `Region`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Region` mutation. */
export type UpdateRegionPayloadRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<RegionsOrderBy>>;
};

/** All input for the `updateRequestLogById` mutation. */
export type UpdateRequestLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RequestLogId']['input'];
  /** An object where the defined keys will be set on the `RequestLog` being updated. */
  requestLogPatch: RequestLogPatch;
};

/** All input for the `updateRequestLog` mutation. */
export type UpdateRequestLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RequestLog` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `RequestLog` being updated. */
  requestLogPatch: RequestLogPatch;
};

/** The output of our update `RequestLog` mutation. */
export type UpdateRequestLogPayload = {
  __typename?: 'UpdateRequestLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `RequestLog`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RequestLog` that was updated by this mutation. */
  requestLog?: Maybe<RequestLog>;
  /** An edge for our `RequestLog`. May be used by Relay 1. */
  requestLogEdge?: Maybe<RequestLogsEdge>;
};


/** The output of our update `RequestLog` mutation. */
export type UpdateRequestLogPayloadRequestLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RequestLogsOrderBy>>;
};

/** All input for the `updateRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZones` mutation. */
export type UpdateRouteByDraftAndFromLongAndFromLatAndToLongAndToLatAndAvoidsChannelsAndUsedNoGoZonesInput = {
  avoidsChannels: Scalars['Boolean']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draft: Scalars['BigFloat']['input'];
  fromLat: Scalars['BigFloat']['input'];
  fromLong: Scalars['BigFloat']['input'];
  /** An object where the defined keys will be set on the `Route` being updated. */
  routePatch: RoutePatch;
  toLat: Scalars['BigFloat']['input'];
  toLong: Scalars['BigFloat']['input'];
  usedNoGoZones: Array<InputMaybe<Scalars['Int']['input']>>;
};

/** All input for the `updateRouteById` mutation. */
export type UpdateRouteByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RouteId']['input'];
  /** An object where the defined keys will be set on the `Route` being updated. */
  routePatch: RoutePatch;
};

/** All input for the `updateRoute` mutation. */
export type UpdateRouteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Route` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Route` being updated. */
  routePatch: RoutePatch;
};

/** All input for the `updateRouteOverrideById` mutation. */
export type UpdateRouteOverrideByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RouteOverrideId']['input'];
  /** An object where the defined keys will be set on the `RouteOverride` being updated. */
  routeOverridePatch: RouteOverridePatch;
};

/** All input for the `updateRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannels` mutation. */
export type UpdateRouteOverrideByOrganisationIdAndFromIdAndToIdAndAvoidsChannelsInput = {
  avoidsChannels: Scalars['Boolean']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromId: Scalars['LocationId']['input'];
  organisationId: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `RouteOverride` being updated. */
  routeOverridePatch: RouteOverridePatch;
  toId: Scalars['LocationId']['input'];
};

/** All input for the `updateRouteOverride` mutation. */
export type UpdateRouteOverrideInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RouteOverride` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `RouteOverride` being updated. */
  routeOverridePatch: RouteOverridePatch;
};

/** The output of our update `RouteOverride` mutation. */
export type UpdateRouteOverridePayload = {
  __typename?: 'UpdateRouteOverridePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `RouteOverride`. */
  locationByFromId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `RouteOverride`. */
  locationByToId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `RouteOverride`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RouteOverride` that was updated by this mutation. */
  routeOverride?: Maybe<RouteOverride>;
  /** An edge for our `RouteOverride`. May be used by Relay 1. */
  routeOverrideEdge?: Maybe<RouteOverridesEdge>;
  /** Reads a single `Ship` that is related to this `RouteOverride`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `RouteOverride`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `RouteOverride` mutation. */
export type UpdateRouteOverridePayloadRouteOverrideEdgeArgs = {
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};

/** The output of our update `Route` mutation. */
export type UpdateRoutePayload = {
  __typename?: 'UpdateRoutePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `LocationCluster` that is related to this `Route`. */
  locationClusterByFromClusterId?: Maybe<LocationCluster>;
  /** Reads a single `LocationCluster` that is related to this `Route`. */
  locationClusterByToClusterId?: Maybe<LocationCluster>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Route` that was updated by this mutation. */
  route?: Maybe<Route>;
  /** An edge for our `Route`. May be used by Relay 1. */
  routeEdge?: Maybe<RoutesEdge>;
};


/** The output of our update `Route` mutation. */
export type UpdateRoutePayloadRouteEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutesOrderBy>>;
};

/** All input for the `updateRoutePointById` mutation. */
export type UpdateRoutePointByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RoutePointId']['input'];
  /** An object where the defined keys will be set on the `RoutePoint` being updated. */
  routePointPatch: RoutePointPatch;
};

/** All input for the `updateRoutePoint` mutation. */
export type UpdateRoutePointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RoutePoint` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `RoutePoint` being updated. */
  routePointPatch: RoutePointPatch;
};

/** The output of our update `RoutePoint` mutation. */
export type UpdateRoutePointPayload = {
  __typename?: 'UpdateRoutePointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RoutePoint` that was updated by this mutation. */
  routePoint?: Maybe<RoutePoint>;
  /** An edge for our `RoutePoint`. May be used by Relay 1. */
  routePointEdge?: Maybe<RoutePointsEdge>;
};


/** The output of our update `RoutePoint` mutation. */
export type UpdateRoutePointPayloadRoutePointEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePointsOrderBy>>;
};

/** All input for the `updateRoutePointUsageById` mutation. */
export type UpdateRoutePointUsageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['RoutePointUsageId']['input'];
  /** An object where the defined keys will be set on the `RoutePointUsage` being updated. */
  routePointUsagePatch: RoutePointUsagePatch;
};

/** All input for the `updateRoutePointUsage` mutation. */
export type UpdateRoutePointUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RoutePointUsage` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `RoutePointUsage` being updated. */
  routePointUsagePatch: RoutePointUsagePatch;
};

/** The output of our update `RoutePointUsage` mutation. */
export type UpdateRoutePointUsagePayload = {
  __typename?: 'UpdateRoutePointUsagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Route` that is related to this `RoutePointUsage`. */
  routeByRouteId?: Maybe<Route>;
  /** Reads a single `RoutePoint` that is related to this `RoutePointUsage`. */
  routePointByRoutePointId?: Maybe<RoutePoint>;
  /** The `RoutePointUsage` that was updated by this mutation. */
  routePointUsage?: Maybe<RoutePointUsage>;
  /** An edge for our `RoutePointUsage`. May be used by Relay 1. */
  routePointUsageEdge?: Maybe<RoutePointUsagesEdge>;
};


/** The output of our update `RoutePointUsage` mutation. */
export type UpdateRoutePointUsagePayloadRoutePointUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<RoutePointUsagesOrderBy>>;
};

export type UpdateSapInput = {
  orderId: Scalars['Int']['input'];
  overrideAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  overrideCancelling?: InputMaybe<Scalars['Datetime']['input']>;
  overrideDeliveredBefore?: InputMaybe<Scalars['Datetime']['input']>;
  overrideLayday?: InputMaybe<Scalars['Datetime']['input']>;
  overrideRTA?: InputMaybe<Scalars['Datetime']['input']>;
  syncAmount?: InputMaybe<Scalars['Boolean']['input']>;
  syncDischargeDate?: InputMaybe<Scalars['Boolean']['input']>;
  syncLoadDate?: InputMaybe<Scalars['Boolean']['input']>;
  syncVessel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSapResult = {
  __typename?: 'UpdateSAPResult';
  results?: Maybe<Scalars['JSON']['output']>;
};

export type UpdateSapResults = {
  __typename?: 'UpdateSAPResults';
  results: Array<Maybe<Scalars['JSON']['output']>>;
};

/** All input for the `updateScenarioById` mutation. */
export type UpdateScenarioByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ScenarioId']['input'];
  /** An object where the defined keys will be set on the `Scenario` being updated. */
  scenarioPatch: ScenarioPatch;
};

/** All input for the `updateScenario` mutation. */
export type UpdateScenarioInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Scenario` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Scenario` being updated. */
  scenarioPatch: ScenarioPatch;
};

/** The output of our update `Scenario` mutation. */
export type UpdateScenarioPayload = {
  __typename?: 'UpdateScenarioPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Scenario`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Scenario`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Scenario` that was updated by this mutation. */
  scenario?: Maybe<Scenario>;
  /** An edge for our `Scenario`. May be used by Relay 1. */
  scenarioEdge?: Maybe<ScenariosEdge>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByCreatedBy?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Scenario`. */
  userByUpdatedBy?: Maybe<User>;
};


/** The output of our update `Scenario` mutation. */
export type UpdateScenarioPayloadScenarioEdgeArgs = {
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};

/** All input for the `updateScheduledOrderById` mutation. */
export type UpdateScheduledOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ScheduledOrderId']['input'];
  /** An object where the defined keys will be set on the `ScheduledOrder` being updated. */
  scheduledOrderPatch: ScheduledOrderPatch;
};

/** All input for the `updateScheduledOrder` mutation. */
export type UpdateScheduledOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ScheduledOrder` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ScheduledOrder` being updated. */
  scheduledOrderPatch: ScheduledOrderPatch;
};

/** The output of our update `ScheduledOrder` mutation. */
export type UpdateScheduledOrderPayload = {
  __typename?: 'UpdateScheduledOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `ScheduledOrder`. */
  orderByOrderId?: Maybe<Order>;
  /** Reads a single `Organization` that is related to this `ScheduledOrder`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `ScheduledOrder`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ScheduledOrder` that was updated by this mutation. */
  scheduledOrder?: Maybe<ScheduledOrder>;
  /** An edge for our `ScheduledOrder`. May be used by Relay 1. */
  scheduledOrderEdge?: Maybe<ScheduledOrdersEdge>;
  /** Reads a single `Ship` that is related to this `ScheduledOrder`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `ScheduledOrder`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `ScheduledOrder` mutation. */
export type UpdateScheduledOrderPayloadScheduledOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};

/** All input for the `updateSeenMessageById` mutation. */
export type UpdateSeenMessageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SeenMessageId']['input'];
  /** An object where the defined keys will be set on the `SeenMessage` being updated. */
  seenMessagePatch: SeenMessagePatch;
};

/** All input for the `updateSeenMessage` mutation. */
export type UpdateSeenMessageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SeenMessage` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SeenMessage` being updated. */
  seenMessagePatch: SeenMessagePatch;
};

/** The output of our update `SeenMessage` mutation. */
export type UpdateSeenMessagePayload = {
  __typename?: 'UpdateSeenMessagePayload';
  /** Reads a single `Chat` that is related to this `SeenMessage`. */
  chatByChatId?: Maybe<Chat>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SeenMessage` that was updated by this mutation. */
  seenMessage?: Maybe<SeenMessage>;
  /** An edge for our `SeenMessage`. May be used by Relay 1. */
  seenMessageEdge?: Maybe<SeenMessagesEdge>;
  /** Reads a single `User` that is related to this `SeenMessage`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `SeenMessage` mutation. */
export type UpdateSeenMessagePayloadSeenMessageEdgeArgs = {
  orderBy?: InputMaybe<Array<SeenMessagesOrderBy>>;
};

/** All input for the `updateSenderOrganizationByAdminOrganizationIdAndOrganizationId` mutation. */
export type UpdateSenderOrganizationByAdminOrganizationIdAndOrganizationIdInput = {
  adminOrganizationId: Scalars['OrganizationId']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `SenderOrganization` being updated. */
  senderOrganizationPatch: SenderOrganizationPatch;
};

/** All input for the `updateSenderOrganizationById` mutation. */
export type UpdateSenderOrganizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SenderOrganizationId']['input'];
  /** An object where the defined keys will be set on the `SenderOrganization` being updated. */
  senderOrganizationPatch: SenderOrganizationPatch;
};

/** All input for the `updateSenderOrganization` mutation. */
export type UpdateSenderOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SenderOrganization` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SenderOrganization` being updated. */
  senderOrganizationPatch: SenderOrganizationPatch;
};

/** The output of our update `SenderOrganization` mutation. */
export type UpdateSenderOrganizationPayload = {
  __typename?: 'UpdateSenderOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SenderOrganization`. */
  organizationByAdminOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SenderOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SenderOrganization` that was updated by this mutation. */
  senderOrganization?: Maybe<SenderOrganization>;
  /** An edge for our `SenderOrganization`. May be used by Relay 1. */
  senderOrganizationEdge?: Maybe<SenderOrganizationsEdge>;
};


/** The output of our update `SenderOrganization` mutation. */
export type UpdateSenderOrganizationPayloadSenderOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<SenderOrganizationsOrderBy>>;
};

/** All input for the `updateSessionOrgsInCurrentTree` mutation. */
export type UpdateSessionOrgsInCurrentTreeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `updateSessionOrgsInCurrentTree` mutation. */
export type UpdateSessionOrgsInCurrentTreePayload = {
  __typename?: 'UpdateSessionOrgsInCurrentTreePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateSessionOrgs` mutation. */
export type UpdateSessionOrgsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['Int']['input'];
};

/** The output of our `updateSessionOrgs` mutation. */
export type UpdateSessionOrgsPayload = {
  __typename?: 'UpdateSessionOrgsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `updateShipById` mutation. */
export type UpdateShipByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipId']['input'];
  /** An object where the defined keys will be set on the `Ship` being updated. */
  shipPatch: ShipPatch;
};

/** All input for the `updateShip` mutation. */
export type UpdateShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Ship` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Ship` being updated. */
  shipPatch: ShipPatch;
};

/** The output of our update `Ship` mutation. */
export type UpdateShipPayload = {
  __typename?: 'UpdateShipPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `Ship`. */
  bunkerGradeOverrideByDefaultBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Ship`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Ship`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Ship` that was updated by this mutation. */
  ship?: Maybe<Ship>;
  /** An edge for our `Ship`. May be used by Relay 1. */
  shipEdge?: Maybe<ShipsEdge>;
  /** Reads a single `User` that is related to this `Ship`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselAttribute` that is related to this `Ship`. */
  vesselAttributeByPrimaryAttributeId?: Maybe<VesselAttribute>;
  /** Reads a single `VesselInfo` that is related to this `Ship`. */
  vesselInfoByVesselInfoId?: Maybe<VesselInfo>;
};


/** The output of our update `Ship` mutation. */
export type UpdateShipPayloadShipEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};

/** All input for the `updateShipVoyageNamingRuleRelationById` mutation. */
export type UpdateShipVoyageNamingRuleRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipVoyageNamingRuleRelationId']['input'];
  /** An object where the defined keys will be set on the `ShipVoyageNamingRuleRelation` being updated. */
  shipVoyageNamingRuleRelationPatch: ShipVoyageNamingRuleRelationPatch;
};

/** All input for the `updateShipVoyageNamingRuleRelation` mutation. */
export type UpdateShipVoyageNamingRuleRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipVoyageNamingRuleRelation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ShipVoyageNamingRuleRelation` being updated. */
  shipVoyageNamingRuleRelationPatch: ShipVoyageNamingRuleRelationPatch;
};

/** The output of our update `ShipVoyageNamingRuleRelation` mutation. */
export type UpdateShipVoyageNamingRuleRelationPayload = {
  __typename?: 'UpdateShipVoyageNamingRuleRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `ShipVoyageNamingRuleRelation`. */
  shipByShipId?: Maybe<Ship>;
  /** The `ShipVoyageNamingRuleRelation` that was updated by this mutation. */
  shipVoyageNamingRuleRelation?: Maybe<ShipVoyageNamingRuleRelation>;
  /** An edge for our `ShipVoyageNamingRuleRelation`. May be used by Relay 1. */
  shipVoyageNamingRuleRelationEdge?: Maybe<ShipVoyageNamingRuleRelationsEdge>;
  /** Reads a single `VoyageNamingRule` that is related to this `ShipVoyageNamingRuleRelation`. */
  voyageNamingRuleByRuleId?: Maybe<VoyageNamingRule>;
};


/** The output of our update `ShipVoyageNamingRuleRelation` mutation. */
export type UpdateShipVoyageNamingRuleRelationPayloadShipVoyageNamingRuleRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipVoyageNamingRuleRelationsOrderBy>>;
};

/** All input for the `updateShipmentById` mutation. */
export type UpdateShipmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentId']['input'];
  /** An object where the defined keys will be set on the `Shipment` being updated. */
  shipmentPatch: ShipmentPatch;
};

/** All input for the `updateShipmentExternalStatusById` mutation. */
export type UpdateShipmentExternalStatusByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentExternalStatusId']['input'];
  /** An object where the defined keys will be set on the `ShipmentExternalStatus` being updated. */
  shipmentExternalStatusPatch: ShipmentExternalStatusPatch;
};

/** All input for the `updateShipmentExternalStatus` mutation. */
export type UpdateShipmentExternalStatusInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentExternalStatus` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ShipmentExternalStatus` being updated. */
  shipmentExternalStatusPatch: ShipmentExternalStatusPatch;
};

/** The output of our update `ShipmentExternalStatus` mutation. */
export type UpdateShipmentExternalStatusPayload = {
  __typename?: 'UpdateShipmentExternalStatusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentExternalStatus`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentExternalStatus` that was updated by this mutation. */
  shipmentExternalStatus?: Maybe<ShipmentExternalStatus>;
  /** An edge for our `ShipmentExternalStatus`. May be used by Relay 1. */
  shipmentExternalStatusEdge?: Maybe<ShipmentExternalStatusesEdge>;
};


/** The output of our update `ShipmentExternalStatus` mutation. */
export type UpdateShipmentExternalStatusPayloadShipmentExternalStatusEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentExternalStatusesOrderBy>>;
};

/** All input for the `updateShipmentExtraFreightById` mutation. */
export type UpdateShipmentExtraFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentExtraFreightId']['input'];
  /** An object where the defined keys will be set on the `ShipmentExtraFreight` being updated. */
  shipmentExtraFreightPatch: ShipmentExtraFreightPatch;
};

/** All input for the `updateShipmentExtraFreight` mutation. */
export type UpdateShipmentExtraFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentExtraFreight` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ShipmentExtraFreight` being updated. */
  shipmentExtraFreightPatch: ShipmentExtraFreightPatch;
};

/** The output of our update `ShipmentExtraFreight` mutation. */
export type UpdateShipmentExtraFreightPayload = {
  __typename?: 'UpdateShipmentExtraFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentExtraFreight`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentExtraFreight` that was updated by this mutation. */
  shipmentExtraFreight?: Maybe<ShipmentExtraFreight>;
  /** An edge for our `ShipmentExtraFreight`. May be used by Relay 1. */
  shipmentExtraFreightEdge?: Maybe<ShipmentExtraFreightsEdge>;
};


/** The output of our update `ShipmentExtraFreight` mutation. */
export type UpdateShipmentExtraFreightPayloadShipmentExtraFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentExtraFreightsOrderBy>>;
};

/** All input for the `updateShipmentFreightById` mutation. */
export type UpdateShipmentFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentFreightId']['input'];
  /** An object where the defined keys will be set on the `ShipmentFreight` being updated. */
  shipmentFreightPatch: ShipmentFreightPatch;
};

/** All input for the `updateShipmentFreightByShipmentId` mutation. */
export type UpdateShipmentFreightByShipmentIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ShipmentFreight` being updated. */
  shipmentFreightPatch: ShipmentFreightPatch;
  shipmentId: Scalars['ShipmentId']['input'];
};

/** All input for the `updateShipmentFreight` mutation. */
export type UpdateShipmentFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentFreight` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ShipmentFreight` being updated. */
  shipmentFreightPatch: ShipmentFreightPatch;
};

/** The output of our update `ShipmentFreight` mutation. */
export type UpdateShipmentFreightPayload = {
  __typename?: 'UpdateShipmentFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentFreight`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentFreight` that was updated by this mutation. */
  shipmentFreight?: Maybe<ShipmentFreight>;
  /** An edge for our `ShipmentFreight`. May be used by Relay 1. */
  shipmentFreightEdge?: Maybe<ShipmentFreightsEdge>;
};


/** The output of our update `ShipmentFreight` mutation. */
export type UpdateShipmentFreightPayloadShipmentFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentFreightsOrderBy>>;
};

/** All input for the `updateShipmentGroupAssociationById` mutation. */
export type UpdateShipmentGroupAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentGroupAssociationId']['input'];
  /** An object where the defined keys will be set on the `ShipmentGroupAssociation` being updated. */
  shipmentGroupAssociationPatch: ShipmentGroupAssociationPatch;
};

/** All input for the `updateShipmentGroupAssociation` mutation. */
export type UpdateShipmentGroupAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentGroupAssociation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ShipmentGroupAssociation` being updated. */
  shipmentGroupAssociationPatch: ShipmentGroupAssociationPatch;
};

/** The output of our update `ShipmentGroupAssociation` mutation. */
export type UpdateShipmentGroupAssociationPayload = {
  __typename?: 'UpdateShipmentGroupAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Shipment` that is related to this `ShipmentGroupAssociation`. */
  shipmentByShipmentId?: Maybe<Shipment>;
  /** The `ShipmentGroupAssociation` that was updated by this mutation. */
  shipmentGroupAssociation?: Maybe<ShipmentGroupAssociation>;
  /** An edge for our `ShipmentGroupAssociation`. May be used by Relay 1. */
  shipmentGroupAssociationEdge?: Maybe<ShipmentGroupAssociationsEdge>;
  /** Reads a single `ShipmentGroup` that is related to this `ShipmentGroupAssociation`. */
  shipmentGroupByShipmentGroupId?: Maybe<ShipmentGroup>;
};


/** The output of our update `ShipmentGroupAssociation` mutation. */
export type UpdateShipmentGroupAssociationPayloadShipmentGroupAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentGroupAssociationsOrderBy>>;
};

/** All input for the `updateShipmentGroupById` mutation. */
export type UpdateShipmentGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ShipmentGroupId']['input'];
  /** An object where the defined keys will be set on the `ShipmentGroup` being updated. */
  shipmentGroupPatch: ShipmentGroupPatch;
};

/** All input for the `updateShipmentGroup` mutation. */
export type UpdateShipmentGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ShipmentGroup` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ShipmentGroup` being updated. */
  shipmentGroupPatch: ShipmentGroupPatch;
};

/** The output of our update `ShipmentGroup` mutation. */
export type UpdateShipmentGroupPayload = {
  __typename?: 'UpdateShipmentGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `ShipmentGroup`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShipmentGroup` that was updated by this mutation. */
  shipmentGroup?: Maybe<ShipmentGroup>;
  /** An edge for our `ShipmentGroup`. May be used by Relay 1. */
  shipmentGroupEdge?: Maybe<ShipmentGroupsEdge>;
};


/** The output of our update `ShipmentGroup` mutation. */
export type UpdateShipmentGroupPayloadShipmentGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentGroupsOrderBy>>;
};

/** All input for the `updateShipment` mutation. */
export type UpdateShipmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Shipment` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Shipment` being updated. */
  shipmentPatch: ShipmentPatch;
};

/** The output of our update `Shipment` mutation. */
export type UpdateShipmentPayload = {
  __typename?: 'UpdateShipmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByChartererOrganisation?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByOwnerOrganisation?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Shipment`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shipment` that was updated by this mutation. */
  shipment?: Maybe<Shipment>;
  /** An edge for our `Shipment`. May be used by Relay 1. */
  shipmentEdge?: Maybe<ShipmentsEdge>;
  /** Reads a single `User` that is related to this `Shipment`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `Shipment`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageAttribute` that is related to this `Shipment`. */
  voyageAttributeByVoyageAttributeId?: Maybe<VoyageAttribute>;
};


/** The output of our update `Shipment` mutation. */
export type UpdateShipmentPayloadShipmentEdgeArgs = {
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};

export type UpdateShipnetScenarioResult = {
  __typename?: 'UpdateShipnetScenarioResult';
  generatedTCLength: Scalars['Int']['output'];
  itemsLength: Scalars['Int']['output'];
  scenarioCid: Scalars['String']['output'];
  status: Status;
  warnings: Array<Scalars['String']['output']>;
};

/** All input for the `updateSingleEventById` mutation. */
export type UpdateSingleEventByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SingleEventId']['input'];
  /** An object where the defined keys will be set on the `SingleEvent` being updated. */
  singleEventPatch: SingleEventPatch;
};

/** All input for the `updateSingleEvent` mutation. */
export type UpdateSingleEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SingleEvent` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SingleEvent` being updated. */
  singleEventPatch: SingleEventPatch;
};

/** The output of our update `SingleEvent` mutation. */
export type UpdateSingleEventPayload = {
  __typename?: 'UpdateSingleEventPayload';
  /** Reads a single `AssortmentExclusion` that is related to this `SingleEvent`. */
  assortmentExclusionByCleaningAssortmentExclusionId?: Maybe<AssortmentExclusion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `SingleEvent`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `SingleEvent`. */
  organizationByPlanningOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SingleEvent`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `SingleEvent`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `SingleEvent` that was updated by this mutation. */
  singleEvent?: Maybe<SingleEvent>;
  /** An edge for our `SingleEvent`. May be used by Relay 1. */
  singleEventEdge?: Maybe<SingleEventsEdge>;
  /** Reads a single `User` that is related to this `SingleEvent`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `SingleEvent`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `SingleEvent` mutation. */
export type UpdateSingleEventPayloadSingleEventEdgeArgs = {
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};

/** All input for the `updateSingleEventPortCallRelationById` mutation. */
export type UpdateSingleEventPortCallRelationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SingleEventPortCallRelationId']['input'];
  /** An object where the defined keys will be set on the `SingleEventPortCallRelation` being updated. */
  singleEventPortCallRelationPatch: SingleEventPortCallRelationPatch;
};

/** All input for the `updateSingleEventPortCallRelation` mutation. */
export type UpdateSingleEventPortCallRelationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SingleEventPortCallRelation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SingleEventPortCallRelation` being updated. */
  singleEventPortCallRelationPatch: SingleEventPortCallRelationPatch;
};

/** The output of our update `SingleEventPortCallRelation` mutation. */
export type UpdateSingleEventPortCallRelationPayload = {
  __typename?: 'UpdateSingleEventPortCallRelationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SingleEventPortCallRelation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `SingleEventPortCallRelation`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SingleEvent` that is related to this `SingleEventPortCallRelation`. */
  singleEventBySingleEventId?: Maybe<SingleEvent>;
  /** The `SingleEventPortCallRelation` that was updated by this mutation. */
  singleEventPortCallRelation?: Maybe<SingleEventPortCallRelation>;
  /** An edge for our `SingleEventPortCallRelation`. May be used by Relay 1. */
  singleEventPortCallRelationEdge?: Maybe<SingleEventPortCallRelationsEdge>;
};


/** The output of our update `SingleEventPortCallRelation` mutation. */
export type UpdateSingleEventPortCallRelationPayloadSingleEventPortCallRelationEdgeArgs = {
  orderBy?: InputMaybe<Array<SingleEventPortCallRelationsOrderBy>>;
};

/** All input for the `updateSpecialRequirementById` mutation. */
export type UpdateSpecialRequirementByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SpecialRequirementId']['input'];
  /** An object where the defined keys will be set on the `SpecialRequirement` being updated. */
  specialRequirementPatch: SpecialRequirementPatch;
};

/** All input for the `updateSpecialRequirement` mutation. */
export type UpdateSpecialRequirementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SpecialRequirement` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SpecialRequirement` being updated. */
  specialRequirementPatch: SpecialRequirementPatch;
};

/** The output of our update `SpecialRequirement` mutation. */
export type UpdateSpecialRequirementPayload = {
  __typename?: 'UpdateSpecialRequirementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SpecialRequirement`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpecialRequirement` that was updated by this mutation. */
  specialRequirement?: Maybe<SpecialRequirement>;
  /** An edge for our `SpecialRequirement`. May be used by Relay 1. */
  specialRequirementEdge?: Maybe<SpecialRequirementsEdge>;
};


/** The output of our update `SpecialRequirement` mutation. */
export type UpdateSpecialRequirementPayloadSpecialRequirementEdgeArgs = {
  orderBy?: InputMaybe<Array<SpecialRequirementsOrderBy>>;
};

/** All input for the `updateSplitOrderById` mutation. */
export type UpdateSplitOrderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SplitOrderId']['input'];
  /** An object where the defined keys will be set on the `SplitOrder` being updated. */
  splitOrderPatch: SplitOrderPatch;
};

/** All input for the `updateSplitOrder` mutation. */
export type UpdateSplitOrderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SplitOrder` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SplitOrder` being updated. */
  splitOrderPatch: SplitOrderPatch;
};

/** The output of our update `SplitOrder` mutation. */
export type UpdateSplitOrderPayload = {
  __typename?: 'UpdateSplitOrderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `SplitOrder`. */
  orderByFromOrderId?: Maybe<Order>;
  /** Reads a single `Order` that is related to this `SplitOrder`. */
  orderByToOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SplitOrder` that was updated by this mutation. */
  splitOrder?: Maybe<SplitOrder>;
  /** An edge for our `SplitOrder`. May be used by Relay 1. */
  splitOrderEdge?: Maybe<SplitOrdersEdge>;
};


/** The output of our update `SplitOrder` mutation. */
export type UpdateSplitOrderPayloadSplitOrderEdgeArgs = {
  orderBy?: InputMaybe<Array<SplitOrdersOrderBy>>;
};

/** All input for the `updateSpotNegotiationById` mutation. */
export type UpdateSpotNegotiationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SpotNegotiationId']['input'];
  /** An object where the defined keys will be set on the `SpotNegotiation` being updated. */
  spotNegotiationPatch: SpotNegotiationPatch;
};

/** All input for the `updateSpotNegotiation` mutation. */
export type UpdateSpotNegotiationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SpotNegotiation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SpotNegotiation` being updated. */
  spotNegotiationPatch: SpotNegotiationPatch;
};

/** The output of our update `SpotNegotiation` mutation. */
export type UpdateSpotNegotiationPayload = {
  __typename?: 'UpdateSpotNegotiationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SpotNegotiation`. */
  organizationByChartererOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SpotNegotiation`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SpotNegotiation` that was updated by this mutation. */
  spotNegotiation?: Maybe<SpotNegotiation>;
  /** An edge for our `SpotNegotiation`. May be used by Relay 1. */
  spotNegotiationEdge?: Maybe<SpotNegotiationsEdge>;
  /** Reads a single `User` that is related to this `SpotNegotiation`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VesselInfo` that is related to this `SpotNegotiation`. */
  vesselInfoByVesselId?: Maybe<VesselInfo>;
  /** Reads a single `VoyageCharter` that is related to this `SpotNegotiation`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
};


/** The output of our update `SpotNegotiation` mutation. */
export type UpdateSpotNegotiationPayloadSpotNegotiationEdgeArgs = {
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};

/** All input for the `updateStatementOfFactById` mutation. */
export type UpdateStatementOfFactByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['StatementOfFactId']['input'];
  /** An object where the defined keys will be set on the `StatementOfFact` being updated. */
  statementOfFactPatch: StatementOfFactPatch;
};

/** All input for the `updateStatementOfFact` mutation. */
export type UpdateStatementOfFactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `StatementOfFact` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `StatementOfFact` being updated. */
  statementOfFactPatch: StatementOfFactPatch;
};

/** The output of our update `StatementOfFact` mutation. */
export type UpdateStatementOfFactPayload = {
  __typename?: 'UpdateStatementOfFactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `StatementOfFact`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortCall` that is related to this `StatementOfFact`. */
  portCallByPortCallId?: Maybe<PortCall>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StatementOfFact` that was updated by this mutation. */
  statementOfFact?: Maybe<StatementOfFact>;
  /** An edge for our `StatementOfFact`. May be used by Relay 1. */
  statementOfFactEdge?: Maybe<StatementOfFactsEdge>;
  /** Reads a single `User` that is related to this `StatementOfFact`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `StatementOfFact`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `StatementOfFact` mutation. */
export type UpdateStatementOfFactPayloadStatementOfFactEdgeArgs = {
  orderBy?: InputMaybe<Array<StatementOfFactsOrderBy>>;
};

/** All input for the `updateSupplyById` mutation. */
export type UpdateSupplyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SupplyId']['input'];
  /** An object where the defined keys will be set on the `Supply` being updated. */
  supplyPatch: SupplyPatch;
};

/** All input for the `updateSupplyContractById` mutation. */
export type UpdateSupplyContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['SupplyContractId']['input'];
  /** An object where the defined keys will be set on the `SupplyContract` being updated. */
  supplyContractPatch: SupplyContractPatch;
};

/** All input for the `updateSupplyContract` mutation. */
export type UpdateSupplyContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `SupplyContract` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `SupplyContract` being updated. */
  supplyContractPatch: SupplyContractPatch;
};

/** The output of our update `SupplyContract` mutation. */
export type UpdateSupplyContractPayload = {
  __typename?: 'UpdateSupplyContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `SupplyContract`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `SupplyContract`. */
  organizationBySenderOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `SupplyContract` that was updated by this mutation. */
  supplyContract?: Maybe<SupplyContract>;
  /** An edge for our `SupplyContract`. May be used by Relay 1. */
  supplyContractEdge?: Maybe<SupplyContractsEdge>;
};


/** The output of our update `SupplyContract` mutation. */
export type UpdateSupplyContractPayloadSupplyContractEdgeArgs = {
  orderBy?: InputMaybe<Array<SupplyContractsOrderBy>>;
};

/** All input for the `updateSupply` mutation. */
export type UpdateSupplyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Supply` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Supply` being updated. */
  supplyPatch: SupplyPatch;
};

/** The output of our update `Supply` mutation. */
export type UpdateSupplyPayload = {
  __typename?: 'UpdateSupplyPayload';
  /** Reads a single `Assortment` that is related to this `Supply`. */
  assortmentByAssortment?: Maybe<Assortment>;
  /** Reads a single `CargoUnit` that is related to this `Supply`. */
  cargoUnitByAmountUnitId?: Maybe<CargoUnit>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `Supply`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `Supply`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `Supply`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Quay` that is related to this `Supply`. */
  quayByQuay?: Maybe<Quay>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `Supply`. */
  regionByRegion?: Maybe<Region>;
  /** The `Supply` that was updated by this mutation. */
  supply?: Maybe<Supply>;
  /** Reads a single `SupplyContract` that is related to this `Supply`. */
  supplyContractBySupplyContract?: Maybe<SupplyContract>;
  /** An edge for our `Supply`. May be used by Relay 1. */
  supplyEdge?: Maybe<SuppliesEdge>;
  /** Reads a single `User` that is related to this `Supply`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Supply` mutation. */
export type UpdateSupplyPayloadSupplyEdgeArgs = {
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};

/** All input for the `updateTankDistanceById` mutation. */
export type UpdateTankDistanceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['TankDistanceId']['input'];
  /** An object where the defined keys will be set on the `TankDistance` being updated. */
  tankDistancePatch: TankDistancePatch;
};

/** All input for the `updateTankDistance` mutation. */
export type UpdateTankDistanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TankDistance` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `TankDistance` being updated. */
  tankDistancePatch: TankDistancePatch;
};

/** The output of our update `TankDistance` mutation. */
export type UpdateTankDistancePayload = {
  __typename?: 'UpdateTankDistancePayload';
  /** Reads a single `CargoCompartment` that is related to this `TankDistance`. */
  cargoCompartmentByTankA?: Maybe<CargoCompartment>;
  /** Reads a single `CargoCompartment` that is related to this `TankDistance`. */
  cargoCompartmentByTankB?: Maybe<CargoCompartment>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TankDistance` that was updated by this mutation. */
  tankDistance?: Maybe<TankDistance>;
  /** An edge for our `TankDistance`. May be used by Relay 1. */
  tankDistanceEdge?: Maybe<TankDistancesEdge>;
};


/** The output of our update `TankDistance` mutation. */
export type UpdateTankDistancePayloadTankDistanceEdgeArgs = {
  orderBy?: InputMaybe<Array<TankDistancesOrderBy>>;
};

/** All input for the `updateTcContractById` mutation. */
export type UpdateTcContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['TcContractId']['input'];
  /** An object where the defined keys will be set on the `TcContract` being updated. */
  tcContractPatch: TcContractPatch;
};

/** All input for the `updateTcContractByRootOrgAndExternalId` mutation. */
export type UpdateTcContractByRootOrgAndExternalIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  rootOrg: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `TcContract` being updated. */
  tcContractPatch: TcContractPatch;
};

/** All input for the `updateTcContract` mutation. */
export type UpdateTcContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TcContract` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `TcContract` being updated. */
  tcContractPatch: TcContractPatch;
};

/** The output of our update `TcContract` mutation. */
export type UpdateTcContractPayload = {
  __typename?: 'UpdateTcContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `TcContract`. */
  locationByDeliveryPortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `TcContract`. */
  locationByRedeliveryPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `TcContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `TcContract`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `TcContract` that was updated by this mutation. */
  tcContract?: Maybe<TcContract>;
  /** An edge for our `TcContract`. May be used by Relay 1. */
  tcContractEdge?: Maybe<TcContractsEdge>;
};


/** The output of our update `TcContract` mutation. */
export type UpdateTcContractPayloadTcContractEdgeArgs = {
  orderBy?: InputMaybe<Array<TcContractsOrderBy>>;
};

/** All input for the `updateUserById` mutation. */
export type UpdateUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserId']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUserRegionById` mutation. */
export type UpdateUserRegionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserRegionId']['input'];
  /** An object where the defined keys will be set on the `UserRegion` being updated. */
  userRegionPatch: UserRegionPatch;
};

/** All input for the `updateUserRegion` mutation. */
export type UpdateUserRegionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserRegion` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserRegion` being updated. */
  userRegionPatch: UserRegionPatch;
};

/** The output of our update `UserRegion` mutation. */
export type UpdateUserRegionPayload = {
  __typename?: 'UpdateUserRegionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `UserRegion`. */
  regionByRegionId?: Maybe<Region>;
  /** Reads a single `User` that is related to this `UserRegion`. */
  userByUserId?: Maybe<User>;
  /** The `UserRegion` that was updated by this mutation. */
  userRegion?: Maybe<UserRegion>;
  /** An edge for our `UserRegion`. May be used by Relay 1. */
  userRegionEdge?: Maybe<UserRegionsEdge>;
};


/** The output of our update `UserRegion` mutation. */
export type UpdateUserRegionPayloadUserRegionEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRegionsOrderBy>>;
};

/** All input for the `updateUserRightById` mutation. */
export type UpdateUserRightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserRightId']['input'];
  /** An object where the defined keys will be set on the `UserRight` being updated. */
  userRightPatch: UserRightPatch;
};

/** All input for the `updateUserRightByUserIdAndOrganizationId` mutation. */
export type UpdateUserRightByUserIdAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  userId: Scalars['UserId']['input'];
  /** An object where the defined keys will be set on the `UserRight` being updated. */
  userRightPatch: UserRightPatch;
};

/** All input for the `updateUserRight` mutation. */
export type UpdateUserRightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserRight` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserRight` being updated. */
  userRightPatch: UserRightPatch;
};

/** The output of our update `UserRight` mutation. */
export type UpdateUserRightPayload = {
  __typename?: 'UpdateUserRightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `UserRight`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRight`. */
  userByUserId?: Maybe<User>;
  /** The `UserRight` that was updated by this mutation. */
  userRight?: Maybe<UserRight>;
  /** An edge for our `UserRight`. May be used by Relay 1. */
  userRightEdge?: Maybe<UserRightsEdge>;
};


/** The output of our update `UserRight` mutation. */
export type UpdateUserRightPayloadUserRightEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRightsOrderBy>>;
};

/** All input for the `updateUserSettingById` mutation. */
export type UpdateUserSettingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserSettingId']['input'];
  /** An object where the defined keys will be set on the `UserSetting` being updated. */
  userSettingPatch: UserSettingPatch;
};

/** All input for the `updateUserSetting` mutation. */
export type UpdateUserSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserSetting` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserSetting` being updated. */
  userSettingPatch: UserSettingPatch;
};

/** The output of our update `UserSetting` mutation. */
export type UpdateUserSettingPayload = {
  __typename?: 'UpdateUserSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  userByUserId?: Maybe<User>;
  /** The `UserSetting` that was updated by this mutation. */
  userSetting?: Maybe<UserSetting>;
  /** An edge for our `UserSetting`. May be used by Relay 1. */
  userSettingEdge?: Maybe<UserSettingsEdge>;
};


/** The output of our update `UserSetting` mutation. */
export type UpdateUserSettingPayloadUserSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};

/** All input for the `updateUserShipById` mutation. */
export type UpdateUserShipByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UserShipId']['input'];
  /** An object where the defined keys will be set on the `UserShip` being updated. */
  userShipPatch: UserShipPatch;
};

/** All input for the `updateUserShip` mutation. */
export type UpdateUserShipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `UserShip` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `UserShip` being updated. */
  userShipPatch: UserShipPatch;
};

/** The output of our update `UserShip` mutation. */
export type UpdateUserShipPayload = {
  __typename?: 'UpdateUserShipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `UserShip`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `UserShip`. */
  userByUserId?: Maybe<User>;
  /** The `UserShip` that was updated by this mutation. */
  userShip?: Maybe<UserShip>;
  /** An edge for our `UserShip`. May be used by Relay 1. */
  userShipEdge?: Maybe<UserShipsEdge>;
};


/** The output of our update `UserShip` mutation. */
export type UpdateUserShipPayloadUserShipEdgeArgs = {
  orderBy?: InputMaybe<Array<UserShipsOrderBy>>;
};

export type UpdateVesonScenarioResult = {
  __typename?: 'UpdateVesonScenarioResult';
  generatedTCLength: Scalars['Int']['output'];
  itemsLength: Scalars['Int']['output'];
  scenarioCid: Scalars['String']['output'];
  status: Status;
  warnings: Array<Scalars['String']['output']>;
};

/** All input for the `updateVesselAttributeAssortmentExclusionById` mutation. */
export type UpdateVesselAttributeAssortmentExclusionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselAttributeAssortmentExclusionId']['input'];
  /** An object where the defined keys will be set on the `VesselAttributeAssortmentExclusion` being updated. */
  vesselAttributeAssortmentExclusionPatch: VesselAttributeAssortmentExclusionPatch;
};

/** All input for the `updateVesselAttributeAssortmentExclusion` mutation. */
export type UpdateVesselAttributeAssortmentExclusionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselAttributeAssortmentExclusion` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselAttributeAssortmentExclusion` being updated. */
  vesselAttributeAssortmentExclusionPatch: VesselAttributeAssortmentExclusionPatch;
};

/** The output of our update `VesselAttributeAssortmentExclusion` mutation. */
export type UpdateVesselAttributeAssortmentExclusionPayload = {
  __typename?: 'UpdateVesselAttributeAssortmentExclusionPayload';
  /** Reads a single `Assortment` that is related to this `VesselAttributeAssortmentExclusion`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `VesselAttributeAssortmentExclusion`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VesselAttributeAssortmentExclusion` that was updated by this mutation. */
  vesselAttributeAssortmentExclusion?: Maybe<VesselAttributeAssortmentExclusion>;
  /** An edge for our `VesselAttributeAssortmentExclusion`. May be used by Relay 1. */
  vesselAttributeAssortmentExclusionEdge?: Maybe<VesselAttributeAssortmentExclusionsEdge>;
  /** Reads a single `VesselAttribute` that is related to this `VesselAttributeAssortmentExclusion`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
};


/** The output of our update `VesselAttributeAssortmentExclusion` mutation. */
export type UpdateVesselAttributeAssortmentExclusionPayloadVesselAttributeAssortmentExclusionEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributeAssortmentExclusionsOrderBy>>;
};

/** All input for the `updateVesselAttributeById` mutation. */
export type UpdateVesselAttributeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselAttributeId']['input'];
  /** An object where the defined keys will be set on the `VesselAttribute` being updated. */
  vesselAttributePatch: VesselAttributePatch;
};

/** All input for the `updateVesselAttributeByOrganizationIdAndName` mutation. */
export type UpdateVesselAttributeByOrganizationIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `VesselAttribute` being updated. */
  vesselAttributePatch: VesselAttributePatch;
};

/** All input for the `updateVesselAttribute` mutation. */
export type UpdateVesselAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselAttribute` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselAttribute` being updated. */
  vesselAttributePatch: VesselAttributePatch;
};

/** The output of our update `VesselAttribute` mutation. */
export type UpdateVesselAttributePayload = {
  __typename?: 'UpdateVesselAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselAttribute`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VesselAttribute` that was updated by this mutation. */
  vesselAttribute?: Maybe<VesselAttribute>;
  /** An edge for our `VesselAttribute`. May be used by Relay 1. */
  vesselAttributeEdge?: Maybe<VesselAttributesEdge>;
};


/** The output of our update `VesselAttribute` mutation. */
export type UpdateVesselAttributePayloadVesselAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributesOrderBy>>;
};

/** All input for the `updateVesselAttributesAssociationById` mutation. */
export type UpdateVesselAttributesAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselAttributesAssociationId']['input'];
  /** An object where the defined keys will be set on the `VesselAttributesAssociation` being updated. */
  vesselAttributesAssociationPatch: VesselAttributesAssociationPatch;
};

/** All input for the `updateVesselAttributesAssociation` mutation. */
export type UpdateVesselAttributesAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselAttributesAssociation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselAttributesAssociation` being updated. */
  vesselAttributesAssociationPatch: VesselAttributesAssociationPatch;
};

/** The output of our update `VesselAttributesAssociation` mutation. */
export type UpdateVesselAttributesAssociationPayload = {
  __typename?: 'UpdateVesselAttributesAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselAttributesAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselAttributesAssociation`. */
  shipByShipId?: Maybe<Ship>;
  /** Reads a single `VesselAttribute` that is related to this `VesselAttributesAssociation`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  /** The `VesselAttributesAssociation` that was updated by this mutation. */
  vesselAttributesAssociation?: Maybe<VesselAttributesAssociation>;
  /** An edge for our `VesselAttributesAssociation`. May be used by Relay 1. */
  vesselAttributesAssociationEdge?: Maybe<VesselAttributesAssociationsEdge>;
};


/** The output of our update `VesselAttributesAssociation` mutation. */
export type UpdateVesselAttributesAssociationPayloadVesselAttributesAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselAttributesAssociationsOrderBy>>;
};

/** All input for the `updateVesselDraftDatapointById` mutation. */
export type UpdateVesselDraftDatapointByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselDraftDatapointIdString']['input'];
  /** An object where the defined keys will be set on the `VesselDraftDatapoint` being updated. */
  vesselDraftDatapointPatch: VesselDraftDatapointPatch;
};

/** All input for the `updateVesselDraftDatapoint` mutation. */
export type UpdateVesselDraftDatapointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselDraftDatapoint` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselDraftDatapoint` being updated. */
  vesselDraftDatapointPatch: VesselDraftDatapointPatch;
};

/** The output of our update `VesselDraftDatapoint` mutation. */
export type UpdateVesselDraftDatapointPayload = {
  __typename?: 'UpdateVesselDraftDatapointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselDraftDatapoint`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselDraftDatapoint`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselDraftDatapoint` that was updated by this mutation. */
  vesselDraftDatapoint?: Maybe<VesselDraftDatapoint>;
  /** An edge for our `VesselDraftDatapoint`. May be used by Relay 1. */
  vesselDraftDatapointEdge?: Maybe<VesselDraftDatapointsEdge>;
};


/** The output of our update `VesselDraftDatapoint` mutation. */
export type UpdateVesselDraftDatapointPayloadVesselDraftDatapointEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselDraftDatapointsOrderBy>>;
};

/** All input for the `updateVesselFulfillsRequirementAssociationById` mutation. */
export type UpdateVesselFulfillsRequirementAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselFulfillsRequirementAssociationId']['input'];
  /** An object where the defined keys will be set on the `VesselFulfillsRequirementAssociation` being updated. */
  vesselFulfillsRequirementAssociationPatch: VesselFulfillsRequirementAssociationPatch;
};

/** All input for the `updateVesselFulfillsRequirementAssociation` mutation. */
export type UpdateVesselFulfillsRequirementAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselFulfillsRequirementAssociation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselFulfillsRequirementAssociation` being updated. */
  vesselFulfillsRequirementAssociationPatch: VesselFulfillsRequirementAssociationPatch;
};

/** The output of our update `VesselFulfillsRequirementAssociation` mutation. */
export type UpdateVesselFulfillsRequirementAssociationPayload = {
  __typename?: 'UpdateVesselFulfillsRequirementAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselFulfillsRequirementAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselFulfillsRequirementAssociation`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `SpecialRequirement` that is related to this `VesselFulfillsRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  /** Reads a single `VesselAttribute` that is related to this `VesselFulfillsRequirementAssociation`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  /** The `VesselFulfillsRequirementAssociation` that was updated by this mutation. */
  vesselFulfillsRequirementAssociation?: Maybe<VesselFulfillsRequirementAssociation>;
  /** An edge for our `VesselFulfillsRequirementAssociation`. May be used by Relay 1. */
  vesselFulfillsRequirementAssociationEdge?: Maybe<VesselFulfillsRequirementAssociationsEdge>;
};


/** The output of our update `VesselFulfillsRequirementAssociation` mutation. */
export type UpdateVesselFulfillsRequirementAssociationPayloadVesselFulfillsRequirementAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
};

/** All input for the `updateVesselInfoById` mutation. */
export type UpdateVesselInfoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselInfoId']['input'];
  /** An object where the defined keys will be set on the `VesselInfo` being updated. */
  vesselInfoPatch: VesselInfoPatch;
};

/** All input for the `updateVesselInfoByImo` mutation. */
export type UpdateVesselInfoByImoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  imo: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `VesselInfo` being updated. */
  vesselInfoPatch: VesselInfoPatch;
};

/** All input for the `updateVesselInfo` mutation. */
export type UpdateVesselInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselInfo` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselInfo` being updated. */
  vesselInfoPatch: VesselInfoPatch;
};

/** The output of our update `VesselInfo` mutation. */
export type UpdateVesselInfoPayload = {
  __typename?: 'UpdateVesselInfoPayload';
  /** Reads a single `ClassSocietyAssociation` that is related to this `VesselInfo`. */
  classSocietyAssociationByClassSocietyAssociationId?: Maybe<ClassSocietyAssociation>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselInfo`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselInfo`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VesselInfo`. */
  userByAdminUserId?: Maybe<User>;
  /** The `VesselInfo` that was updated by this mutation. */
  vesselInfo?: Maybe<VesselInfo>;
  /** An edge for our `VesselInfo`. May be used by Relay 1. */
  vesselInfoEdge?: Maybe<VesselInfosEdge>;
};


/** The output of our update `VesselInfo` mutation. */
export type UpdateVesselInfoPayloadVesselInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
};

/** All input for the `updateVesselPerformanceModelById` mutation. */
export type UpdateVesselPerformanceModelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselPerformanceModelId']['input'];
  /** An object where the defined keys will be set on the `VesselPerformanceModel` being updated. */
  vesselPerformanceModelPatch: VesselPerformanceModelPatch;
};

/** All input for the `updateVesselPerformanceModelByRootOrgAndShipId` mutation. */
export type UpdateVesselPerformanceModelByRootOrgAndShipIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Root organization that owns this performance model. Performance models are shared across all sub-organizations. */
  rootOrg: Scalars['OrganizationId']['input'];
  /** Reference to the vessel in the ships table */
  shipId: Scalars['ShipId']['input'];
  /** An object where the defined keys will be set on the `VesselPerformanceModel` being updated. */
  vesselPerformanceModelPatch: VesselPerformanceModelPatch;
};

/** All input for the `updateVesselPerformanceModel` mutation. */
export type UpdateVesselPerformanceModelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselPerformanceModel` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselPerformanceModel` being updated. */
  vesselPerformanceModelPatch: VesselPerformanceModelPatch;
};

/** The output of our update `VesselPerformanceModel` mutation. */
export type UpdateVesselPerformanceModelPayload = {
  __typename?: 'UpdateVesselPerformanceModelPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselPerformanceModel`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselPerformanceModel`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselPerformanceModel` that was updated by this mutation. */
  vesselPerformanceModel?: Maybe<VesselPerformanceModel>;
  /** An edge for our `VesselPerformanceModel`. May be used by Relay 1. */
  vesselPerformanceModelEdge?: Maybe<VesselPerformanceModelsEdge>;
};


/** The output of our update `VesselPerformanceModel` mutation. */
export type UpdateVesselPerformanceModelPayloadVesselPerformanceModelEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselPerformanceModelsOrderBy>>;
};

export type UpdateVesselPerformanceModelResult = {
  __typename?: 'UpdateVesselPerformanceModelResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  performanceModelUid?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  vesselId: Scalars['Int']['output'];
  warningMessage?: Maybe<Scalars['String']['output']>;
};

/** All input for the `updateVesselReservationById` mutation. */
export type UpdateVesselReservationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselReservationId']['input'];
  /** An object where the defined keys will be set on the `VesselReservation` being updated. */
  vesselReservationPatch: VesselReservationPatch;
};

/** All input for the `updateVesselReservation` mutation. */
export type UpdateVesselReservationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselReservation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselReservation` being updated. */
  vesselReservationPatch: VesselReservationPatch;
};

/** The output of our update `VesselReservation` mutation. */
export type UpdateVesselReservationPayload = {
  __typename?: 'UpdateVesselReservationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `VesselReservation`. */
  locationByEndPortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `VesselReservation`. */
  locationByStartPortId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `VesselReservation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Region` that is related to this `VesselReservation`. */
  regionByEndRegionId?: Maybe<Region>;
  /** Reads a single `Region` that is related to this `VesselReservation`. */
  regionByStartRegionId?: Maybe<Region>;
  /** Reads a single `Ship` that is related to this `VesselReservation`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VesselReservation`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VesselReservation`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VesselReservation` that was updated by this mutation. */
  vesselReservation?: Maybe<VesselReservation>;
  /** An edge for our `VesselReservation`. May be used by Relay 1. */
  vesselReservationEdge?: Maybe<VesselReservationsEdge>;
};


/** The output of our update `VesselReservation` mutation. */
export type UpdateVesselReservationPayloadVesselReservationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};

/** All input for the `updateVesselScheduleSharedToOrganizationById` mutation. */
export type UpdateVesselScheduleSharedToOrganizationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselScheduleSharedToOrganizationId']['input'];
  /** An object where the defined keys will be set on the `VesselScheduleSharedToOrganization` being updated. */
  vesselScheduleSharedToOrganizationPatch: VesselScheduleSharedToOrganizationPatch;
};

/** All input for the `updateVesselScheduleSharedToOrganizationByVesselIdAndOrganizationId` mutation. */
export type UpdateVesselScheduleSharedToOrganizationByVesselIdAndOrganizationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  vesselId: Scalars['ShipId']['input'];
  /** An object where the defined keys will be set on the `VesselScheduleSharedToOrganization` being updated. */
  vesselScheduleSharedToOrganizationPatch: VesselScheduleSharedToOrganizationPatch;
};

/** All input for the `updateVesselScheduleSharedToOrganization` mutation. */
export type UpdateVesselScheduleSharedToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselScheduleSharedToOrganization` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselScheduleSharedToOrganization` being updated. */
  vesselScheduleSharedToOrganizationPatch: VesselScheduleSharedToOrganizationPatch;
};

/** The output of our update `VesselScheduleSharedToOrganization` mutation. */
export type UpdateVesselScheduleSharedToOrganizationPayload = {
  __typename?: 'UpdateVesselScheduleSharedToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselScheduleSharedToOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselScheduleSharedToOrganization`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselScheduleSharedToOrganization`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `VesselScheduleSharedToOrganization` that was updated by this mutation. */
  vesselScheduleSharedToOrganization?: Maybe<VesselScheduleSharedToOrganization>;
  /** An edge for our `VesselScheduleSharedToOrganization`. May be used by Relay 1. */
  vesselScheduleSharedToOrganizationEdge?: Maybe<VesselScheduleSharedToOrganizationsEdge>;
};


/** The output of our update `VesselScheduleSharedToOrganization` mutation. */
export type UpdateVesselScheduleSharedToOrganizationPayloadVesselScheduleSharedToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselScheduleSharedToOrganizationsOrderBy>>;
};

/** All input for the `updateVesselSecretById` mutation. */
export type UpdateVesselSecretByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselSecretId']['input'];
  /** An object where the defined keys will be set on the `VesselSecret` being updated. */
  vesselSecretPatch: VesselSecretPatch;
};

/** All input for the `updateVesselSecret` mutation. */
export type UpdateVesselSecretInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselSecret` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselSecret` being updated. */
  vesselSecretPatch: VesselSecretPatch;
};

/** The output of our update `VesselSecret` mutation. */
export type UpdateVesselSecretPayload = {
  __typename?: 'UpdateVesselSecretPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselSecret`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselSecret`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VesselSecret`. */
  userByAdminUserId?: Maybe<User>;
  /** The `VesselSecret` that was updated by this mutation. */
  vesselSecret?: Maybe<VesselSecret>;
  /** An edge for our `VesselSecret`. May be used by Relay 1. */
  vesselSecretEdge?: Maybe<VesselSecretsEdge>;
};


/** The output of our update `VesselSecret` mutation. */
export type UpdateVesselSecretPayloadVesselSecretEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselSecretsOrderBy>>;
};

/** All input for the `updateVesselSpeedConsumptionById` mutation. */
export type UpdateVesselSpeedConsumptionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VesselSpeedConsumptionId']['input'];
  /** An object where the defined keys will be set on the `VesselSpeedConsumption` being updated. */
  vesselSpeedConsumptionPatch: VesselSpeedConsumptionPatch;
};

/** All input for the `updateVesselSpeedConsumption` mutation. */
export type UpdateVesselSpeedConsumptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VesselSpeedConsumption` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VesselSpeedConsumption` being updated. */
  vesselSpeedConsumptionPatch: VesselSpeedConsumptionPatch;
};

/** The output of our update `VesselSpeedConsumption` mutation. */
export type UpdateVesselSpeedConsumptionPayload = {
  __typename?: 'UpdateVesselSpeedConsumptionPayload';
  /** Reads a single `BunkerGradeOverride` that is related to this `VesselSpeedConsumption`. */
  bunkerGradeOverrideByBunkerGradeId?: Maybe<BunkerGradeOverride>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VesselSpeedConsumption`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselSpeedConsumption`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VesselSpeedConsumption`. */
  shipByShipId?: Maybe<Ship>;
  /** The `VesselSpeedConsumption` that was updated by this mutation. */
  vesselSpeedConsumption?: Maybe<VesselSpeedConsumption>;
  /** An edge for our `VesselSpeedConsumption`. May be used by Relay 1. */
  vesselSpeedConsumptionEdge?: Maybe<VesselSpeedConsumptionsEdge>;
};


/** The output of our update `VesselSpeedConsumption` mutation. */
export type UpdateVesselSpeedConsumptionPayloadVesselSpeedConsumptionEdgeArgs = {
  orderBy?: InputMaybe<Array<VesselSpeedConsumptionsOrderBy>>;
};

/** All input for the `updateVoyageAssociationById` mutation. */
export type UpdateVoyageAssociationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageAssociationId']['input'];
  /** An object where the defined keys will be set on the `VoyageAssociation` being updated. */
  voyageAssociationPatch: VoyageAssociationPatch;
};

/** All input for the `updateVoyageAssociation` mutation. */
export type UpdateVoyageAssociationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageAssociation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageAssociation` being updated. */
  voyageAssociationPatch: VoyageAssociationPatch;
};

/** The output of our update `VoyageAssociation` mutation. */
export type UpdateVoyageAssociationPayload = {
  __typename?: 'UpdateVoyageAssociationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Order` that is related to this `VoyageAssociation`. */
  orderByOrderId?: Maybe<Order>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageAssociation` that was updated by this mutation. */
  voyageAssociation?: Maybe<VoyageAssociation>;
  /** An edge for our `VoyageAssociation`. May be used by Relay 1. */
  voyageAssociationEdge?: Maybe<VoyageAssociationsEdge>;
  /** Reads a single `Voyage` that is related to this `VoyageAssociation`. */
  voyageByVoyageId?: Maybe<Voyage>;
};


/** The output of our update `VoyageAssociation` mutation. */
export type UpdateVoyageAssociationPayloadVoyageAssociationEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageAssociationsOrderBy>>;
};

/** All input for the `updateVoyageAttributeById` mutation. */
export type UpdateVoyageAttributeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageAttributeId']['input'];
  /** An object where the defined keys will be set on the `VoyageAttribute` being updated. */
  voyageAttributePatch: VoyageAttributePatch;
};

/** All input for the `updateVoyageAttributeByOrganizationIdAndNameAndColor` mutation. */
export type UpdateVoyageAttributeByOrganizationIdAndNameAndColorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `VoyageAttribute` being updated. */
  voyageAttributePatch: VoyageAttributePatch;
};

/** All input for the `updateVoyageAttribute` mutation. */
export type UpdateVoyageAttributeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageAttribute` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageAttribute` being updated. */
  voyageAttributePatch: VoyageAttributePatch;
};

/** The output of our update `VoyageAttribute` mutation. */
export type UpdateVoyageAttributePayload = {
  __typename?: 'UpdateVoyageAttributePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageAttribute`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageAttribute` that was updated by this mutation. */
  voyageAttribute?: Maybe<VoyageAttribute>;
  /** An edge for our `VoyageAttribute`. May be used by Relay 1. */
  voyageAttributeEdge?: Maybe<VoyageAttributesEdge>;
};


/** The output of our update `VoyageAttribute` mutation. */
export type UpdateVoyageAttributePayloadVoyageAttributeEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageAttributesOrderBy>>;
};

/** All input for the `updateVoyageById` mutation. */
export type UpdateVoyageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageId']['input'];
  /** An object where the defined keys will be set on the `Voyage` being updated. */
  voyagePatch: VoyagePatch;
};

/** All input for the `updateVoyageCharterById` mutation. */
export type UpdateVoyageCharterByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharter` being updated. */
  voyageCharterPatch: VoyageCharterPatch;
};

/** All input for the `updateVoyageCharterByRootOrgAndExternalId` mutation. */
export type UpdateVoyageCharterByRootOrgAndExternalIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharter` being updated. */
  voyageCharterPatch: VoyageCharterPatch;
};

/** All input for the `updateVoyageCharterByRootOrgAndName` mutation. */
export type UpdateVoyageCharterByRootOrgAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharter` being updated. */
  voyageCharterPatch: VoyageCharterPatch;
};

/** All input for the `updateVoyageCharterExtraCostById` mutation. */
export type UpdateVoyageCharterExtraCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterExtraCostId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterExtraCost` being updated. */
  voyageCharterExtraCostPatch: VoyageCharterExtraCostPatch;
};

/** All input for the `updateVoyageCharterExtraCost` mutation. */
export type UpdateVoyageCharterExtraCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterExtraCost` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterExtraCost` being updated. */
  voyageCharterExtraCostPatch: VoyageCharterExtraCostPatch;
};

/** The output of our update `VoyageCharterExtraCost` mutation. */
export type UpdateVoyageCharterExtraCostPayload = {
  __typename?: 'UpdateVoyageCharterExtraCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterExtraCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterExtraCost` that was updated by this mutation. */
  voyageCharterExtraCost?: Maybe<VoyageCharterExtraCost>;
  /** An edge for our `VoyageCharterExtraCost`. May be used by Relay 1. */
  voyageCharterExtraCostEdge?: Maybe<VoyageCharterExtraCostsEdge>;
};


/** The output of our update `VoyageCharterExtraCost` mutation. */
export type UpdateVoyageCharterExtraCostPayloadVoyageCharterExtraCostEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterExtraCostsOrderBy>>;
};

/** All input for the `updateVoyageCharterExtraFreightById` mutation. */
export type UpdateVoyageCharterExtraFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterExtraFreightId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterExtraFreight` being updated. */
  voyageCharterExtraFreightPatch: VoyageCharterExtraFreightPatch;
};

/** All input for the `updateVoyageCharterExtraFreight` mutation. */
export type UpdateVoyageCharterExtraFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterExtraFreight` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterExtraFreight` being updated. */
  voyageCharterExtraFreightPatch: VoyageCharterExtraFreightPatch;
};

/** The output of our update `VoyageCharterExtraFreight` mutation. */
export type UpdateVoyageCharterExtraFreightPayload = {
  __typename?: 'UpdateVoyageCharterExtraFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterExtraFreight`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterExtraFreight` that was updated by this mutation. */
  voyageCharterExtraFreight?: Maybe<VoyageCharterExtraFreight>;
  /** An edge for our `VoyageCharterExtraFreight`. May be used by Relay 1. */
  voyageCharterExtraFreightEdge?: Maybe<VoyageCharterExtraFreightsEdge>;
};


/** The output of our update `VoyageCharterExtraFreight` mutation. */
export type UpdateVoyageCharterExtraFreightPayloadVoyageCharterExtraFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterExtraFreightsOrderBy>>;
};

/** All input for the `updateVoyageCharter` mutation. */
export type UpdateVoyageCharterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharter` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageCharter` being updated. */
  voyageCharterPatch: VoyageCharterPatch;
};

/** All input for the `updateVoyageCharterOrderFreightById` mutation. */
export type UpdateVoyageCharterOrderFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterOrderFreightId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterOrderFreight` being updated. */
  voyageCharterOrderFreightPatch: VoyageCharterOrderFreightPatch;
};

/** All input for the `updateVoyageCharterOrderFreight` mutation. */
export type UpdateVoyageCharterOrderFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterOrderFreight` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterOrderFreight` being updated. */
  voyageCharterOrderFreightPatch: VoyageCharterOrderFreightPatch;
};

/** The output of our update `VoyageCharterOrderFreight` mutation. */
export type UpdateVoyageCharterOrderFreightPayload = {
  __typename?: 'UpdateVoyageCharterOrderFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `OrderVoyageCharterRelation` that is related to this `VoyageCharterOrderFreight`. */
  orderVoyageCharterRelationByOrderVoyageCharterRelationId?: Maybe<OrderVoyageCharterRelation>;
  /** Reads a single `Organization` that is related to this `VoyageCharterOrderFreight`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VoyageCharterOrderFreight`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VoyageCharterOrderFreight` that was updated by this mutation. */
  voyageCharterOrderFreight?: Maybe<VoyageCharterOrderFreight>;
  /** An edge for our `VoyageCharterOrderFreight`. May be used by Relay 1. */
  voyageCharterOrderFreightEdge?: Maybe<VoyageCharterOrderFreightsEdge>;
};


/** The output of our update `VoyageCharterOrderFreight` mutation. */
export type UpdateVoyageCharterOrderFreightPayloadVoyageCharterOrderFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterOrderFreightsOrderBy>>;
};

/** The output of our update `VoyageCharter` mutation. */
export type UpdateVoyageCharterPayload = {
  __typename?: 'UpdateVoyageCharterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `LostContract` that is related to this `VoyageCharter`. */
  lostContractByLostContractsId?: Maybe<LostContract>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VoyageCharter`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VoyageCharter`. */
  userByModifiedByUserId?: Maybe<User>;
  /** The `VoyageCharter` that was updated by this mutation. */
  voyageCharter?: Maybe<VoyageCharter>;
  /** An edge for our `VoyageCharter`. May be used by Relay 1. */
  voyageCharterEdge?: Maybe<VoyageChartersEdge>;
};


/** The output of our update `VoyageCharter` mutation. */
export type UpdateVoyageCharterPayloadVoyageCharterEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};

/** All input for the `updateVoyageCharterPortCostById` mutation. */
export type UpdateVoyageCharterPortCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterPortCostId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterPortCost` being updated. */
  voyageCharterPortCostPatch: VoyageCharterPortCostPatch;
};

/** All input for the `updateVoyageCharterPortCost` mutation. */
export type UpdateVoyageCharterPortCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterPortCost` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterPortCost` being updated. */
  voyageCharterPortCostPatch: VoyageCharterPortCostPatch;
};

/** The output of our update `VoyageCharterPortCost` mutation. */
export type UpdateVoyageCharterPortCostPayload = {
  __typename?: 'UpdateVoyageCharterPortCostPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `PortCost` that is related to this `VoyageCharterPortCost`. */
  portCostByPortCostId?: Maybe<PortCost>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterPortCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterPortCost` that was updated by this mutation. */
  voyageCharterPortCost?: Maybe<VoyageCharterPortCost>;
  /** An edge for our `VoyageCharterPortCost`. May be used by Relay 1. */
  voyageCharterPortCostEdge?: Maybe<VoyageCharterPortCostsEdge>;
};


/** The output of our update `VoyageCharterPortCost` mutation. */
export type UpdateVoyageCharterPortCostPayloadVoyageCharterPortCostEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterPortCostsOrderBy>>;
};

/** All input for the `updateVoyageCharterPortDatumById` mutation. */
export type UpdateVoyageCharterPortDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterPortDatumId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterPortDatum` being updated. */
  voyageCharterPortDatumPatch: VoyageCharterPortDatumPatch;
};

/** All input for the `updateVoyageCharterPortDatum` mutation. */
export type UpdateVoyageCharterPortDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterPortDatum` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterPortDatum` being updated. */
  voyageCharterPortDatumPatch: VoyageCharterPortDatumPatch;
};

/** The output of our update `VoyageCharterPortDatum` mutation. */
export type UpdateVoyageCharterPortDatumPayload = {
  __typename?: 'UpdateVoyageCharterPortDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageCharterPortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `PortDatum` that is related to this `VoyageCharterPortDatum`. */
  portDatumByPortDataId?: Maybe<PortDatum>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `VoyageCharterPortDatum`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterPortDatum`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterPortDatum` that was updated by this mutation. */
  voyageCharterPortDatum?: Maybe<VoyageCharterPortDatum>;
  /** An edge for our `VoyageCharterPortDatum`. May be used by Relay 1. */
  voyageCharterPortDatumEdge?: Maybe<VoyageCharterPortDataEdge>;
};


/** The output of our update `VoyageCharterPortDatum` mutation. */
export type UpdateVoyageCharterPortDatumPayloadVoyageCharterPortDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterPortDataOrderBy>>;
};

/** All input for the `updateVoyageCharterToContractById` mutation. */
export type UpdateVoyageCharterToContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterToContractId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterToContract` being updated. */
  voyageCharterToContractPatch: VoyageCharterToContractPatch;
};

/** All input for the `updateVoyageCharterToContract` mutation. */
export type UpdateVoyageCharterToContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterToContract` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterToContract` being updated. */
  voyageCharterToContractPatch: VoyageCharterToContractPatch;
};

/** The output of our update `VoyageCharterToContract` mutation. */
export type UpdateVoyageCharterToContractPayload = {
  __typename?: 'UpdateVoyageCharterToContractPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CoaContract` that is related to this `VoyageCharterToContract`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  /** Reads a single `Organization` that is related to this `VoyageCharterToContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `SpotNegotiation` that is related to this `VoyageCharterToContract`. */
  spotNegotiationBySpotNegotiationId?: Maybe<SpotNegotiation>;
  /** Reads a single `User` that is related to this `VoyageCharterToContract`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VoyageCharterToContract`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterToContract`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterToContract` that was updated by this mutation. */
  voyageCharterToContract?: Maybe<VoyageCharterToContract>;
  /** An edge for our `VoyageCharterToContract`. May be used by Relay 1. */
  voyageCharterToContractEdge?: Maybe<VoyageCharterToContractsEdge>;
};


/** The output of our update `VoyageCharterToContract` mutation. */
export type UpdateVoyageCharterToContractPayloadVoyageCharterToContractEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};

/** All input for the `updateVoyageCharterUpdateById` mutation. */
export type UpdateVoyageCharterUpdateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageCharterUpdateId']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterUpdate` being updated. */
  voyageCharterUpdatePatch: VoyageCharterUpdatePatch;
};

/** All input for the `updateVoyageCharterUpdate` mutation. */
export type UpdateVoyageCharterUpdateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageCharterUpdate` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageCharterUpdate` being updated. */
  voyageCharterUpdatePatch: VoyageCharterUpdatePatch;
};

/** The output of our update `VoyageCharterUpdate` mutation. */
export type UpdateVoyageCharterUpdatePayload = {
  __typename?: 'UpdateVoyageCharterUpdatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageCharterUpdate`. */
  organizationByCreatedByOrgId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `VoyageCharterUpdate`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VoyageCharterUpdate`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VoyageCharterUpdate`. */
  userByRejectedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterUpdate`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  /** The `VoyageCharterUpdate` that was updated by this mutation. */
  voyageCharterUpdate?: Maybe<VoyageCharterUpdate>;
  /** An edge for our `VoyageCharterUpdate`. May be used by Relay 1. */
  voyageCharterUpdateEdge?: Maybe<VoyageCharterUpdatesEdge>;
};


/** The output of our update `VoyageCharterUpdate` mutation. */
export type UpdateVoyageCharterUpdatePayloadVoyageCharterUpdateEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};

/** All input for the `updateVoyage` mutation. */
export type UpdateVoyageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Voyage` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Voyage` being updated. */
  voyagePatch: VoyagePatch;
};

/** All input for the `updateVoyageNamingRuleById` mutation. */
export type UpdateVoyageNamingRuleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['VoyageNamingRuleId']['input'];
  /** An object where the defined keys will be set on the `VoyageNamingRule` being updated. */
  voyageNamingRulePatch: VoyageNamingRulePatch;
};

/** All input for the `updateVoyageNamingRule` mutation. */
export type UpdateVoyageNamingRuleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `VoyageNamingRule` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `VoyageNamingRule` being updated. */
  voyageNamingRulePatch: VoyageNamingRulePatch;
};

/** The output of our update `VoyageNamingRule` mutation. */
export type UpdateVoyageNamingRulePayload = {
  __typename?: 'UpdateVoyageNamingRulePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `VoyageNamingRule`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `VoyageNamingRule` that was updated by this mutation. */
  voyageNamingRule?: Maybe<VoyageNamingRule>;
  /** An edge for our `VoyageNamingRule`. May be used by Relay 1. */
  voyageNamingRuleEdge?: Maybe<VoyageNamingRulesEdge>;
};


/** The output of our update `VoyageNamingRule` mutation. */
export type UpdateVoyageNamingRulePayloadVoyageNamingRuleEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyageNamingRulesOrderBy>>;
};

/** The output of our update `Voyage` mutation. */
export type UpdateVoyagePayload = {
  __typename?: 'UpdateVoyagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Voyage`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Ship` that is related to this `Voyage`. */
  shipByVesselId?: Maybe<Ship>;
  /** The `Voyage` that was updated by this mutation. */
  voyage?: Maybe<Voyage>;
  /** An edge for our `Voyage`. May be used by Relay 1. */
  voyageEdge?: Maybe<VoyagesEdge>;
};


/** The output of our update `Voyage` mutation. */
export type UpdateVoyagePayloadVoyageEdgeArgs = {
  orderBy?: InputMaybe<Array<VoyagesOrderBy>>;
};

/** All input for the `updateWorldscaleFreightById` mutation. */
export type UpdateWorldscaleFreightByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['WorldscaleFreightId']['input'];
  /** An object where the defined keys will be set on the `WorldscaleFreight` being updated. */
  worldscaleFreightPatch: WorldscaleFreightPatch;
};

/** All input for the `updateWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYear` mutation. */
export type UpdateWorldscaleFreightByRouteAndFromLocationIdAndToLocationIdAndOrganizationIdAndYearInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromLocationId: Scalars['LocationId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  route: Scalars['String']['input'];
  toLocationId: Scalars['LocationId']['input'];
  /** An object where the defined keys will be set on the `WorldscaleFreight` being updated. */
  worldscaleFreightPatch: WorldscaleFreightPatch;
  year: Scalars['Int']['input'];
};

/** All input for the `updateWorldscaleFreight` mutation. */
export type UpdateWorldscaleFreightInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorldscaleFreight` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `WorldscaleFreight` being updated. */
  worldscaleFreightPatch: WorldscaleFreightPatch;
};

/** The output of our update `WorldscaleFreight` mutation. */
export type UpdateWorldscaleFreightPayload = {
  __typename?: 'UpdateWorldscaleFreightPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `WorldscaleFreight`. */
  locationByFromLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `WorldscaleFreight`. */
  locationByToLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `WorldscaleFreight`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WorldscaleFreight` that was updated by this mutation. */
  worldscaleFreight?: Maybe<WorldscaleFreight>;
  /** An edge for our `WorldscaleFreight`. May be used by Relay 1. */
  worldscaleFreightEdge?: Maybe<WorldscaleFreightsEdge>;
};


/** The output of our update `WorldscaleFreight` mutation. */
export type UpdateWorldscaleFreightPayloadWorldscaleFreightEdgeArgs = {
  orderBy?: InputMaybe<Array<WorldscaleFreightsOrderBy>>;
};

/** All input for the `updateZoneById` mutation. */
export type UpdateZoneByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ZoneId']['input'];
  /** An object where the defined keys will be set on the `Zone` being updated. */
  zonePatch: ZonePatch;
};

/** All input for the `updateZone` mutation. */
export type UpdateZoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Zone` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Zone` being updated. */
  zonePatch: ZonePatch;
};

/** All input for the `updateZoneLocationById` mutation. */
export type UpdateZoneLocationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ZoneLocationId']['input'];
  /** An object where the defined keys will be set on the `ZoneLocation` being updated. */
  zoneLocationPatch: ZoneLocationPatch;
};

/** All input for the `updateZoneLocationByZoneIdAndLocationId` mutation. */
export type UpdateZoneLocationByZoneIdAndLocationIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['LocationId']['input'];
  zoneId: Scalars['ZoneId']['input'];
  /** An object where the defined keys will be set on the `ZoneLocation` being updated. */
  zoneLocationPatch: ZoneLocationPatch;
};

/** All input for the `updateZoneLocation` mutation. */
export type UpdateZoneLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ZoneLocation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ZoneLocation` being updated. */
  zoneLocationPatch: ZoneLocationPatch;
};

/** The output of our update `ZoneLocation` mutation. */
export type UpdateZoneLocationPayload = {
  __typename?: 'UpdateZoneLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Location` that is related to this `ZoneLocation`. */
  locationByLocationId?: Maybe<Location>;
  /** Reads a single `Organization` that is related to this `ZoneLocation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Zone` that is related to this `ZoneLocation`. */
  zoneByZoneId?: Maybe<Zone>;
  /** The `ZoneLocation` that was updated by this mutation. */
  zoneLocation?: Maybe<ZoneLocation>;
  /** An edge for our `ZoneLocation`. May be used by Relay 1. */
  zoneLocationEdge?: Maybe<ZoneLocationsEdge>;
};


/** The output of our update `ZoneLocation` mutation. */
export type UpdateZoneLocationPayloadZoneLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<ZoneLocationsOrderBy>>;
};

/** The output of our update `Zone` mutation. */
export type UpdateZonePayload = {
  __typename?: 'UpdateZonePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organization` that is related to this `Zone`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Zone` that was updated by this mutation. */
  zone?: Maybe<Zone>;
  /** An edge for our `Zone`. May be used by Relay 1. */
  zoneEdge?: Maybe<ZonesEdge>;
};


/** The output of our update `Zone` mutation. */
export type UpdateZonePayloadZoneEdgeArgs = {
  orderBy?: InputMaybe<Array<ZonesOrderBy>>;
};

export type UpsertBalticConfigInput = {
  bookedCargoEndpoint: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  companyEndpoint: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  integrationUserId: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  projectsEndpoint?: InputMaybe<Scalars['String']['input']>;
  scope: Scalars['String']['input'];
  shipEndpoint: Scalars['String']['input'];
  tokenUrl: Scalars['String']['input'];
};

export type UpsertMarcuraDataResult = {
  __typename?: 'UpsertMarcuraDataResult';
  status?: Maybe<Scalars['String']['output']>;
};

export type UpsertMarcuraLocationResult = {
  __typename?: 'UpsertMarcuraLocationResult';
  status?: Maybe<Scalars['String']['output']>;
};

export type UpsertShipnetConfigInput = {
  authorizeKey: Scalars['String']['input'];
  bookingListEndpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ignorePorts?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationUserId: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loggingEndpoint?: InputMaybe<Scalars['String']['input']>;
  operationalVoyageEndpoint?: InputMaybe<Scalars['String']['input']>;
  orderEndpoint?: InputMaybe<Scalars['String']['input']>;
  portCallEndpoint: Scalars['String']['input'];
  refreshOrderEndpoint?: InputMaybe<Scalars['String']['input']>;
  setupCoaEndpoint?: InputMaybe<Scalars['String']['input']>;
  updateDateEndpoint?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertVesonConfigInput = {
  cargoEndpoint?: InputMaybe<Scalars['String']['input']>;
  commissionEndpoint?: InputMaybe<Scalars['String']['input']>;
  extraFreightEndpoint?: InputMaybe<Scalars['String']['input']>;
  graphqlEndpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  integrationUserId: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pnlEndpoint?: InputMaybe<Scalars['String']['input']>;
  portCostEndpoint?: InputMaybe<Scalars['String']['input']>;
  robEndpoint?: InputMaybe<Scalars['String']['input']>;
  statusFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  token: Scalars['String']['input'];
  vesonOwnerType?: InputMaybe<Scalars['String']['input']>;
  vesselEndpoint?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertVoyageCharterCostsInput = {
  commissions?: InputMaybe<Array<ApiCommissionInput>>;
  extraFreights?: InputMaybe<Array<ExtraFreightInput>>;
  voyage_charter_external_id?: InputMaybe<Scalars['String']['input']>;
  voyage_charter_id?: InputMaybe<Scalars['Int']['input']>;
};

export type User = Node & {
  __typename?: 'User';
  /** Reads and enables pagination through a set of `AssortmentGroup`. */
  assortmentGroupsByUserId: AssortmentGroupsConnection;
  /** Reads and enables pagination through a set of `Assortment`. */
  assortmentsByUserId: AssortmentsConnection;
  /** Reads and enables pagination through a set of `BillOfLading`. */
  billOfLadingsByUserId: BillOfLadingsConnection;
  /** Reads and enables pagination through a set of `BunkerGradeOverride`. */
  bunkerGradeOverridesByModifiedByUserId: BunkerGradeOverridesConnection;
  /** Reads and enables pagination through a set of `Bunkering`. */
  bunkeringsByUserId: BunkeringsConnection;
  /** Reads and enables pagination through a set of `CargoCompartment`. */
  cargoCompartmentsByAdminUserId: CargoCompartmentsConnection;
  /** Reads and enables pagination through a set of `CargoMeasurement`. */
  cargoMeasurementsByUserId: CargoMeasurementsConnection;
  /** Reads and enables pagination through a set of `ChannelCost`. */
  channelCostsByUserId: ChannelCostsConnection;
  /** Reads and enables pagination through a set of `Chat`. */
  chatsByFromUserId: ChatsConnection;
  /** Reads and enables pagination through a set of `Chat`. */
  chatsByToUserId: ChatsConnection;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  coaContractPortsByChartererId: CoaContractPortsConnection;
  /** Reads and enables pagination through a set of `CoaContract`. */
  coaContractsByChartererId: CoaContractsConnection;
  /** Reads and enables pagination through a set of `CoaContract`. */
  coaContractsByUserId: CoaContractsConnection;
  /** Reads and enables pagination through a set of `CommitLog`. */
  commitLogsByCommittedBy: CommitLogsConnection;
  /** Reads and enables pagination through a set of `CommitLog`. */
  commitLogsByModifiedByUserId: CommitLogsConnection;
  /** Reads and enables pagination through a set of `DbChange`. */
  dbChangesByUserId: DbChangesConnection;
  /** Reads and enables pagination through a set of `Demand`. */
  demandsByUserId: DemandsConnection;
  email?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `EmailToOrderConfig`. */
  emailToOrderConfigsByUserId: EmailToOrderConfigsConnection;
  familyName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `File`. */
  filesByUserId: FilesConnection;
  /** Reads and enables pagination through a set of `GeographicalEntity`. */
  geographicalEntitiesByUserId: GeographicalEntitiesConnection;
  /** Reads and enables pagination through a set of `GeographicalRelation`. */
  geographicalRelationsByUserId: GeographicalRelationsConnection;
  givenName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `HandledByCoaHistory`. */
  handledByCoaHistoriesByCreatedByUserId: HandledByCoaHistoriesConnection;
  /** Reads and enables pagination through a set of `HandledByCoaHistory`. */
  handledByCoaHistoriesByModifiedByUserId: HandledByCoaHistoriesConnection;
  /** Reads and enables pagination through a set of `HandledByCoa`. */
  handledByCoasByCreatedByUserId: HandledByCoasConnection;
  /** Reads and enables pagination through a set of `HandledByCoa`. */
  handledByCoasByModifiedByUserId: HandledByCoasConnection;
  /** Reads and enables pagination through a set of `HandledBySpotHistory`. */
  handledBySpotHistoriesByCreatedByUserId: HandledBySpotHistoriesConnection;
  /** Reads and enables pagination through a set of `HandledBySpotHistory`. */
  handledBySpotHistoriesByModifiedByUserId: HandledBySpotHistoriesConnection;
  /** Reads and enables pagination through a set of `HandledBySpot`. */
  handledBySpotsByCreatedByUserId: HandledBySpotsConnection;
  /** Reads and enables pagination through a set of `HandledBySpot`. */
  handledBySpotsByModifiedByUserId: HandledBySpotsConnection;
  id: Scalars['UserId']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  insertedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Instruction`. */
  instructionsByUserId: InstructionsConnection;
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `LocationWorkingHour`. */
  locationWorkingHoursByUserId: LocationWorkingHoursConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUserId: LocationsConnection;
  monitoringOnly?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `NotificationReceiver`. */
  notificationReceiversByUserId: NotificationReceiversConnection;
  /** Reads and enables pagination through a set of `OffHire`. */
  offHiresByModifiedByUserId: OffHiresConnection;
  /** Reads and enables pagination through a set of `OffHire`. */
  offHiresByUserId: OffHiresConnection;
  /** Reads and enables pagination through a set of `OpenPositionHistory`. */
  openPositionHistoriesByCreatedByUserId: OpenPositionHistoriesConnection;
  /** Reads and enables pagination through a set of `OpenPosition`. */
  openPositionsByCreatedByUserId: OpenPositionsConnection;
  /** Reads and enables pagination through a set of `OpenPosition`. */
  openPositionsByModifiedByUserId: OpenPositionsConnection;
  /** Reads and enables pagination through a set of `OrderPortCallRelation`. */
  orderPortCallRelationsByModifiedByUserId: OrderPortCallRelationsConnection;
  /** Reads and enables pagination through a set of `OrderVoyageCharterRelation`. */
  orderVoyageCharterRelationsByModifiedByUserId: OrderVoyageCharterRelationsConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByModifiedByUserId: OrdersConnection;
  /** Reads and enables pagination through a set of `Order`. */
  ordersByUserId: OrdersConnection;
  /** Reads and enables pagination through a set of `OrdersHistory`. */
  ordersHistoriesByModifiedByUserId: OrdersHistoriesConnection;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Default organization tied to the user. User can admin more than one organization access through entity user_rights */
  organizationId: Scalars['OrganizationId']['output'];
  picture?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PortActivity`. */
  portActivitiesByUserId: PortActivitiesConnection;
  /** Reads and enables pagination through a set of `PortCallHistory`. */
  portCallHistoriesByModifiedByUserId: PortCallHistoriesConnection;
  /** Reads and enables pagination through a set of `PortCall`. */
  portCallsByModifiedByUserId: PortCallsConnection;
  /** Reads and enables pagination through a set of `PortCost`. */
  portCostsByUserId: PortCostsConnection;
  /** Reads and enables pagination through a set of `PortNoticeHistory`. */
  portNoticeHistoriesByModifiedByUserId: PortNoticeHistoriesConnection;
  /** Reads and enables pagination through a set of `PortNotice`. */
  portNoticesByModifiedByUserId: PortNoticesConnection;
  /** Reads and enables pagination through a set of `PortNotice`. */
  portNoticesByUserId: PortNoticesConnection;
  preferredWordForVessel?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Prompt`. */
  promptsByCreatedBy: PromptsConnection;
  /** Reads and enables pagination through a set of `Prompt`. */
  promptsByModifiedBy: PromptsConnection;
  /** Reads and enables pagination through a set of `Quay`. */
  quaysByUserId: QuaysConnection;
  /** Reads and enables pagination through a set of `Region`. */
  regionsByUserId: RegionsConnection;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  rootOrganization?: Maybe<Organization>;
  /** Reads and enables pagination through a set of `RouteOverride`. */
  routeOverridesByUserId: RouteOverridesConnection;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenariosByCreatedBy: ScenariosConnection;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenariosByModifiedByUserId: ScenariosConnection;
  /** Reads and enables pagination through a set of `Scenario`. */
  scenariosByUpdatedBy: ScenariosConnection;
  /** Reads and enables pagination through a set of `ScheduledOrderHistory`. */
  scheduledOrderHistoriesByCreatedByUserId: ScheduledOrderHistoriesConnection;
  /** Reads and enables pagination through a set of `ScheduledOrder`. */
  scheduledOrdersByCreatedByUserId: ScheduledOrdersConnection;
  /** Reads and enables pagination through a set of `ScheduledOrder`. */
  scheduledOrdersByModifiedByUserId: ScheduledOrdersConnection;
  /** Reads and enables pagination through a set of `ScheduledOrder`. */
  scheduledOrdersByUserId: ScheduledOrdersConnection;
  /** Reads and enables pagination through a set of `SeenMessage`. */
  seenMessagesByUserId: SeenMessagesConnection;
  /** Reads and enables pagination through a set of `Shipment`. */
  shipmentsByModifiedByUserId: ShipmentsConnection;
  /** Reads and enables pagination through a set of `Shipment`. */
  shipmentsByUserId: ShipmentsConnection;
  /** Reads and enables pagination through a set of `Ship`. */
  shipsByUserId: ShipsConnection;
  showAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `SingleEvent`. */
  singleEventsByModifiedByUserId: SingleEventsConnection;
  /** Reads and enables pagination through a set of `SingleEvent`. */
  singleEventsByUserId: SingleEventsConnection;
  /** Reads and enables pagination through a set of `SpotNegotiation`. */
  spotNegotiationsByUserId: SpotNegotiationsConnection;
  /** Reads and enables pagination through a set of `StatementOfFact`. */
  statementOfFactsByModifiedByUserId: StatementOfFactsConnection;
  /** Reads and enables pagination through a set of `StatementOfFact`. */
  statementOfFactsByUserId: StatementOfFactsConnection;
  /** Reads and enables pagination through a set of `StatementOfFactsHistory`. */
  statementOfFactsHistoriesByModifiedByUserId: StatementOfFactsHistoriesConnection;
  /** Reads and enables pagination through a set of `Supply`. */
  suppliesByUserId: SuppliesConnection;
  updatedAt: Scalars['Datetime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `UserRegion`. */
  userRegionsByUserId: UserRegionsConnection;
  /** Reads and enables pagination through a set of `UserRight`. */
  userRightsByUserId: UserRightsConnection;
  /** Reads and enables pagination through a set of `UserSetting`. */
  userSettingsByUserId: UserSettingsConnection;
  /** Reads and enables pagination through a set of `UserShip`. */
  userShipsByUserId: UserShipsConnection;
  userType: UserType;
  /** Reads and enables pagination through a set of `VesselInfo`. */
  vesselInfosByAdminUserId: VesselInfosConnection;
  /** Reads and enables pagination through a set of `VesselReservationHistory`. */
  vesselReservationHistoriesByCreatedByUserId: VesselReservationHistoriesConnection;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  vesselReservationsByCreatedByUserId: VesselReservationsConnection;
  /** Reads and enables pagination through a set of `VesselReservation`. */
  vesselReservationsByModifiedByUserId: VesselReservationsConnection;
  /** Reads and enables pagination through a set of `VesselSecret`. */
  vesselSecretsByAdminUserId: VesselSecretsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterHistory`. */
  voyageCharterHistoriesByModifiedByUserId: VoyageCharterHistoriesConnection;
  /** Reads and enables pagination through a set of `VoyageCharterOrderFreight`. */
  voyageCharterOrderFreightsByModifiedByUserId: VoyageCharterOrderFreightsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterPortDatum`. */
  voyageCharterPortDataByModifiedByUserId: VoyageCharterPortDataConnection;
  /** Reads and enables pagination through a set of `VoyageCharterToContract`. */
  voyageCharterToContractsByModifiedByUserId: VoyageCharterToContractsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterToContract`. */
  voyageCharterToContractsByUserId: VoyageCharterToContractsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterUpdate`. */
  voyageCharterUpdatesByCreatedByUserId: VoyageCharterUpdatesConnection;
  /** Reads and enables pagination through a set of `VoyageCharterUpdate`. */
  voyageCharterUpdatesByRejectedByUserId: VoyageCharterUpdatesConnection;
  /** Reads and enables pagination through a set of `VoyageCharter`. */
  voyageChartersByModifiedByUserId: VoyageChartersConnection;
};


export type UserAssortmentGroupsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentGroupCondition>;
  filter?: InputMaybe<AssortmentGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentGroupsOrderBy>>;
};


export type UserAssortmentsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentCondition>;
  filter?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
};


export type UserBillOfLadingsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillOfLadingCondition>;
  filter?: InputMaybe<BillOfLadingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOfLadingsOrderBy>>;
};


export type UserBunkerGradeOverridesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkerGradeOverrideCondition>;
  filter?: InputMaybe<BunkerGradeOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
};


export type UserBunkeringsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BunkeringCondition>;
  filter?: InputMaybe<BunkeringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BunkeringsOrderBy>>;
};


export type UserCargoCompartmentsByAdminUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentCondition>;
  filter?: InputMaybe<CargoCompartmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};


export type UserCargoMeasurementsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoMeasurementCondition>;
  filter?: InputMaybe<CargoMeasurementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoMeasurementsOrderBy>>;
};


export type UserChannelCostsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostCondition>;
  filter?: InputMaybe<ChannelCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostsOrderBy>>;
};


export type UserChatsByFromUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChatCondition>;
  filter?: InputMaybe<ChatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};


export type UserChatsByToUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChatCondition>;
  filter?: InputMaybe<ChatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};


export type UserCoaContractPortsByChartererIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


export type UserCoaContractsByChartererIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCondition>;
  filter?: InputMaybe<CoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};


export type UserCoaContractsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractCondition>;
  filter?: InputMaybe<CoaContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractsOrderBy>>;
};


export type UserCommitLogsByCommittedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogCondition>;
  filter?: InputMaybe<CommitLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogsOrderBy>>;
};


export type UserCommitLogsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommitLogCondition>;
  filter?: InputMaybe<CommitLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommitLogsOrderBy>>;
};


export type UserDbChangesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DbChangeCondition>;
  filter?: InputMaybe<DbChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbChangesOrderBy>>;
};


export type UserDemandsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DemandCondition>;
  filter?: InputMaybe<DemandFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DemandsOrderBy>>;
};


export type UserEmailToOrderConfigsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailToOrderConfigCondition>;
  filter?: InputMaybe<EmailToOrderConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailToOrderConfigsOrderBy>>;
};


export type UserFilesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type UserGeographicalEntitiesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GeographicalEntityCondition>;
  filter?: InputMaybe<GeographicalEntityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeographicalEntitiesOrderBy>>;
};


export type UserGeographicalRelationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GeographicalRelationCondition>;
  filter?: InputMaybe<GeographicalRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeographicalRelationsOrderBy>>;
};


export type UserHandledByCoaHistoriesByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaHistoryCondition>;
  filter?: InputMaybe<HandledByCoaHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoaHistoriesOrderBy>>;
};


export type UserHandledByCoaHistoriesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaHistoryCondition>;
  filter?: InputMaybe<HandledByCoaHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoaHistoriesOrderBy>>;
};


export type UserHandledByCoasByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaCondition>;
  filter?: InputMaybe<HandledByCoaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};


export type UserHandledByCoasByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledByCoaCondition>;
  filter?: InputMaybe<HandledByCoaFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledByCoasOrderBy>>;
};


export type UserHandledBySpotHistoriesByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotHistoryCondition>;
  filter?: InputMaybe<HandledBySpotHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotHistoriesOrderBy>>;
};


export type UserHandledBySpotHistoriesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotHistoryCondition>;
  filter?: InputMaybe<HandledBySpotHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotHistoriesOrderBy>>;
};


export type UserHandledBySpotsByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotCondition>;
  filter?: InputMaybe<HandledBySpotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};


export type UserHandledBySpotsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HandledBySpotCondition>;
  filter?: InputMaybe<HandledBySpotFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HandledBySpotsOrderBy>>;
};


export type UserInstructionsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InstructionCondition>;
  filter?: InputMaybe<InstructionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InstructionsOrderBy>>;
};


export type UserLocationWorkingHoursByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationWorkingHourCondition>;
  filter?: InputMaybe<LocationWorkingHourFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationWorkingHoursOrderBy>>;
};


export type UserLocationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationCondition>;
  filter?: InputMaybe<LocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type UserNotificationReceiversByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationReceiverCondition>;
  filter?: InputMaybe<NotificationReceiverFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};


export type UserOffHiresByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireCondition>;
  filter?: InputMaybe<OffHireFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};


export type UserOffHiresByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OffHireCondition>;
  filter?: InputMaybe<OffHireFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OffHiresOrderBy>>;
};


export type UserOpenPositionHistoriesByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionHistoryCondition>;
  filter?: InputMaybe<OpenPositionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionHistoriesOrderBy>>;
};


export type UserOpenPositionsByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionCondition>;
  filter?: InputMaybe<OpenPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};


export type UserOpenPositionsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OpenPositionCondition>;
  filter?: InputMaybe<OpenPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenPositionsOrderBy>>;
};


export type UserOrderPortCallRelationsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderPortCallRelationCondition>;
  filter?: InputMaybe<OrderPortCallRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderPortCallRelationsOrderBy>>;
};


export type UserOrderVoyageCharterRelationsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderVoyageCharterRelationCondition>;
  filter?: InputMaybe<OrderVoyageCharterRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};


export type UserOrdersByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type UserOrdersByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


export type UserOrdersHistoriesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrdersHistoryCondition>;
  filter?: InputMaybe<OrdersHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersHistoriesOrderBy>>;
};


export type UserPortActivitiesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortActivityCondition>;
  filter?: InputMaybe<PortActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortActivitiesOrderBy>>;
};


export type UserPortCallHistoriesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallHistoryCondition>;
  filter?: InputMaybe<PortCallHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallHistoriesOrderBy>>;
};


export type UserPortCallsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCallCondition>;
  filter?: InputMaybe<PortCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCallsOrderBy>>;
};


export type UserPortCostsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostCondition>;
  filter?: InputMaybe<PortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostsOrderBy>>;
};


export type UserPortNoticeHistoriesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortNoticeHistoryCondition>;
  filter?: InputMaybe<PortNoticeHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortNoticeHistoriesOrderBy>>;
};


export type UserPortNoticesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortNoticeCondition>;
  filter?: InputMaybe<PortNoticeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortNoticesOrderBy>>;
};


export type UserPortNoticesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortNoticeCondition>;
  filter?: InputMaybe<PortNoticeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortNoticesOrderBy>>;
};


export type UserPromptsByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PromptCondition>;
  filter?: InputMaybe<PromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptsOrderBy>>;
};


export type UserPromptsByModifiedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PromptCondition>;
  filter?: InputMaybe<PromptFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptsOrderBy>>;
};


export type UserQuaysByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<QuayCondition>;
  filter?: InputMaybe<QuayFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuaysOrderBy>>;
};


export type UserRegionsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RegionCondition>;
  filter?: InputMaybe<RegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionsOrderBy>>;
};


export type UserRouteOverridesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RouteOverrideCondition>;
  filter?: InputMaybe<RouteOverrideFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
};


export type UserScenariosByCreatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


export type UserScenariosByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


export type UserScenariosByUpdatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScenarioCondition>;
  filter?: InputMaybe<ScenarioFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScenariosOrderBy>>;
};


export type UserScheduledOrderHistoriesByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderHistoryCondition>;
  filter?: InputMaybe<ScheduledOrderHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrderHistoriesOrderBy>>;
};


export type UserScheduledOrdersByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderCondition>;
  filter?: InputMaybe<ScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};


export type UserScheduledOrdersByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderCondition>;
  filter?: InputMaybe<ScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};


export type UserScheduledOrdersByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ScheduledOrderCondition>;
  filter?: InputMaybe<ScheduledOrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledOrdersOrderBy>>;
};


export type UserSeenMessagesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SeenMessageCondition>;
  filter?: InputMaybe<SeenMessageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SeenMessagesOrderBy>>;
};


export type UserShipmentsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentCondition>;
  filter?: InputMaybe<ShipmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};


export type UserShipmentsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentCondition>;
  filter?: InputMaybe<ShipmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};


export type UserShipsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipCondition>;
  filter?: InputMaybe<ShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};


export type UserSingleEventsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventCondition>;
  filter?: InputMaybe<SingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};


export type UserSingleEventsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SingleEventCondition>;
  filter?: InputMaybe<SingleEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SingleEventsOrderBy>>;
};


export type UserSpotNegotiationsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpotNegotiationCondition>;
  filter?: InputMaybe<SpotNegotiationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};


export type UserStatementOfFactsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatementOfFactCondition>;
  filter?: InputMaybe<StatementOfFactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatementOfFactsOrderBy>>;
};


export type UserStatementOfFactsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatementOfFactCondition>;
  filter?: InputMaybe<StatementOfFactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatementOfFactsOrderBy>>;
};


export type UserStatementOfFactsHistoriesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StatementOfFactsHistoryCondition>;
  filter?: InputMaybe<StatementOfFactsHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StatementOfFactsHistoriesOrderBy>>;
};


export type UserSuppliesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SupplyCondition>;
  filter?: InputMaybe<SupplyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SuppliesOrderBy>>;
};


export type UserUserRegionsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRegionCondition>;
  filter?: InputMaybe<UserRegionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRegionsOrderBy>>;
};


export type UserUserRightsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRightCondition>;
  filter?: InputMaybe<UserRightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRightsOrderBy>>;
};


export type UserUserSettingsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserSettingCondition>;
  filter?: InputMaybe<UserSettingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSettingsOrderBy>>;
};


export type UserUserShipsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserShipCondition>;
  filter?: InputMaybe<UserShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserShipsOrderBy>>;
};


export type UserVesselInfosByAdminUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselInfoCondition>;
  filter?: InputMaybe<VesselInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
};


export type UserVesselReservationHistoriesByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationHistoryCondition>;
  filter?: InputMaybe<VesselReservationHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationHistoriesOrderBy>>;
};


export type UserVesselReservationsByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};


export type UserVesselReservationsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselReservationCondition>;
  filter?: InputMaybe<VesselReservationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselReservationsOrderBy>>;
};


export type UserVesselSecretsByAdminUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselSecretCondition>;
  filter?: InputMaybe<VesselSecretFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselSecretsOrderBy>>;
};


export type UserVoyageCharterHistoriesByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterHistoryCondition>;
  filter?: InputMaybe<VoyageCharterHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterHistoriesOrderBy>>;
};


export type UserVoyageCharterOrderFreightsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterOrderFreightCondition>;
  filter?: InputMaybe<VoyageCharterOrderFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterOrderFreightsOrderBy>>;
};


export type UserVoyageCharterPortDataByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortDatumCondition>;
  filter?: InputMaybe<VoyageCharterPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortDataOrderBy>>;
};


export type UserVoyageCharterToContractsByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterToContractCondition>;
  filter?: InputMaybe<VoyageCharterToContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};


export type UserVoyageCharterToContractsByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterToContractCondition>;
  filter?: InputMaybe<VoyageCharterToContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};


export type UserVoyageCharterUpdatesByCreatedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterUpdateCondition>;
  filter?: InputMaybe<VoyageCharterUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};


export type UserVoyageCharterUpdatesByRejectedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterUpdateCondition>;
  filter?: InputMaybe<VoyageCharterUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};


export type UserVoyageChartersByModifiedByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterCondition>;
  filter?: InputMaybe<VoyageCharterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageChartersOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `familyName` field. */
  familyName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `givenName` field. */
  givenName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `initials` field. */
  initials?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `locale` field. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `monitoringOnly` field. */
  monitoringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nickname` field. */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `picture` field. */
  picture?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `preferredWordForVessel` field. */
  preferredWordForVessel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `showAdmin` field. */
  showAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userType` field. */
  userType?: InputMaybe<UserType>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `familyName` field. */
  familyName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `givenName` field. */
  givenName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `initials` field. */
  initials?: InputMaybe<StringFilter>;
  /** Filter by the object’s `insertedAt` field. */
  insertedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `isActivated` field. */
  isActivated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isAdmin` field. */
  isAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isVerified` field. */
  isVerified?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `locale` field. */
  locale?: InputMaybe<StringFilter>;
  /** Filter by the object’s `monitoringOnly` field. */
  monitoringOnly?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nickname` field. */
  nickname?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `picture` field. */
  picture?: InputMaybe<StringFilter>;
  /** Filter by the object’s `preferredWordForVessel` field. */
  preferredWordForVessel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `showAdmin` field. */
  showAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userType` field. */
  userType?: InputMaybe<UserTypeFilter>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  monitoringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Default organization tied to the user. User can admin more than one organization access through entity user_rights */
  organizationId: Scalars['OrganizationId']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  preferredWordForVessel?: InputMaybe<Scalars['String']['input']>;
  showAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<UserType>;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  insertedAt?: InputMaybe<Scalars['Datetime']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  monitoringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Default organization tied to the user. User can admin more than one organization access through entity user_rights */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  preferredWordForVessel?: InputMaybe<Scalars['String']['input']>;
  showAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<UserType>;
};

export type UserRegion = Node & {
  __typename?: 'UserRegion';
  id: Scalars['UserRegionId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Region` that is related to this `UserRegion`. */
  regionByRegionId?: Maybe<Region>;
  regionId?: Maybe<Scalars['RegionId']['output']>;
  /** Reads a single `User` that is related to this `UserRegion`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};

/**
 * A condition to be used against `UserRegion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserRegionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UserRegionId']['input']>;
  /** Checks for equality with the object’s `regionId` field. */
  regionId?: InputMaybe<Scalars['RegionId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `UserRegion` object types. All fields are combined with a logical ‘and.’ */
export type UserRegionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRegionFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRegionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRegionFilter>>;
  /** Filter by the object’s `regionId` field. */
  regionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserRegion` */
export type UserRegionInput = {
  regionId?: InputMaybe<Scalars['RegionId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `UserRegion`. Fields that are set will be updated. */
export type UserRegionPatch = {
  regionId?: InputMaybe<Scalars['RegionId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `UserRegion` values. */
export type UserRegionsConnection = {
  __typename?: 'UserRegionsConnection';
  /** A list of edges which contains the `UserRegion` and cursor to aid in pagination. */
  edges: Array<UserRegionsEdge>;
  /** A list of `UserRegion` objects. */
  nodes: Array<Maybe<UserRegion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRegion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRegion` edge in the connection. */
export type UserRegionsEdge = {
  __typename?: 'UserRegionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRegion` at the end of the edge. */
  node?: Maybe<UserRegion>;
};

/** Methods to use when ordering `UserRegion`. */
export enum UserRegionsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REGION_ID_ASC = 'REGION_ID_ASC',
  REGION_ID_DESC = 'REGION_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** Users granular permissions. An user can mange more than one organization */
export type UserRight = Node & {
  __typename?: 'UserRight';
  accessBillOfLading: Scalars['Boolean']['output'];
  accessCargoMeasurement: Scalars['Boolean']['output'];
  accessFinancialData: Scalars['Boolean']['output'];
  createAndEditBillOfLading: Scalars['Boolean']['output'];
  createAndEditCargoMeasurement: Scalars['Boolean']['output'];
  createAndEditContracts: Scalars['Boolean']['output'];
  createAndEditOrders: Scalars['Boolean']['output'];
  createAndEditPortCalls: Scalars['Boolean']['output'];
  createAndEditVoyages: Scalars['Boolean']['output'];
  id: Scalars['UserRightId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Organization admin, able create or edit users, organizations, assortments, ports, vessels */
  orgAdmin: Scalars['Boolean']['output'];
  /** Reads a single `Organization` that is related to this `UserRight`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Reads a single `User` that is related to this `UserRight`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
};

/**
 * A condition to be used against `UserRight` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserRightCondition = {
  /** Checks for equality with the object’s `accessBillOfLading` field. */
  accessBillOfLading?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `accessCargoMeasurement` field. */
  accessCargoMeasurement?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `accessFinancialData` field. */
  accessFinancialData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createAndEditBillOfLading` field. */
  createAndEditBillOfLading?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createAndEditCargoMeasurement` field. */
  createAndEditCargoMeasurement?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createAndEditContracts` field. */
  createAndEditContracts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createAndEditOrders` field. */
  createAndEditOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createAndEditPortCalls` field. */
  createAndEditPortCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createAndEditVoyages` field. */
  createAndEditVoyages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UserRightId']['input']>;
  /** Checks for equality with the object’s `orgAdmin` field. */
  orgAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `UserRight` object types. All fields are combined with a logical ‘and.’ */
export type UserRightFilter = {
  /** Filter by the object’s `accessBillOfLading` field. */
  accessBillOfLading?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `accessCargoMeasurement` field. */
  accessCargoMeasurement?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `accessFinancialData` field. */
  accessFinancialData?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRightFilter>>;
  /** Filter by the object’s `createAndEditBillOfLading` field. */
  createAndEditBillOfLading?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createAndEditCargoMeasurement` field. */
  createAndEditCargoMeasurement?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createAndEditContracts` field. */
  createAndEditContracts?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createAndEditOrders` field. */
  createAndEditOrders?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createAndEditPortCalls` field. */
  createAndEditPortCalls?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `createAndEditVoyages` field. */
  createAndEditVoyages?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRightFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRightFilter>>;
  /** Filter by the object’s `orgAdmin` field. */
  orgAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserRight` */
export type UserRightInput = {
  accessBillOfLading?: InputMaybe<Scalars['Boolean']['input']>;
  accessCargoMeasurement?: InputMaybe<Scalars['Boolean']['input']>;
  accessFinancialData?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditBillOfLading?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditCargoMeasurement?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditContracts?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditOrders?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditPortCalls?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditVoyages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization admin, able create or edit users, organizations, assortments, ports, vessels */
  orgAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  userId: Scalars['UserId']['input'];
};

/** Represents an update to a `UserRight`. Fields that are set will be updated. */
export type UserRightPatch = {
  accessBillOfLading?: InputMaybe<Scalars['Boolean']['input']>;
  accessCargoMeasurement?: InputMaybe<Scalars['Boolean']['input']>;
  accessFinancialData?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditBillOfLading?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditCargoMeasurement?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditContracts?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditOrders?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditPortCalls?: InputMaybe<Scalars['Boolean']['input']>;
  createAndEditVoyages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization admin, able create or edit users, organizations, assortments, ports, vessels */
  orgAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `UserRight` values. */
export type UserRightsConnection = {
  __typename?: 'UserRightsConnection';
  /** A list of edges which contains the `UserRight` and cursor to aid in pagination. */
  edges: Array<UserRightsEdge>;
  /** A list of `UserRight` objects. */
  nodes: Array<Maybe<UserRight>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRight` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRight` edge in the connection. */
export type UserRightsEdge = {
  __typename?: 'UserRightsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRight` at the end of the edge. */
  node?: Maybe<UserRight>;
};

/** Methods to use when ordering `UserRight`. */
export enum UserRightsOrderBy {
  ACCESS_BILL_OF_LADING_ASC = 'ACCESS_BILL_OF_LADING_ASC',
  ACCESS_BILL_OF_LADING_DESC = 'ACCESS_BILL_OF_LADING_DESC',
  ACCESS_CARGO_MEASUREMENT_ASC = 'ACCESS_CARGO_MEASUREMENT_ASC',
  ACCESS_CARGO_MEASUREMENT_DESC = 'ACCESS_CARGO_MEASUREMENT_DESC',
  ACCESS_FINANCIAL_DATA_ASC = 'ACCESS_FINANCIAL_DATA_ASC',
  ACCESS_FINANCIAL_DATA_DESC = 'ACCESS_FINANCIAL_DATA_DESC',
  CREATE_AND_EDIT_BILL_OF_LADING_ASC = 'CREATE_AND_EDIT_BILL_OF_LADING_ASC',
  CREATE_AND_EDIT_BILL_OF_LADING_DESC = 'CREATE_AND_EDIT_BILL_OF_LADING_DESC',
  CREATE_AND_EDIT_CARGO_MEASUREMENT_ASC = 'CREATE_AND_EDIT_CARGO_MEASUREMENT_ASC',
  CREATE_AND_EDIT_CARGO_MEASUREMENT_DESC = 'CREATE_AND_EDIT_CARGO_MEASUREMENT_DESC',
  CREATE_AND_EDIT_CONTRACTS_ASC = 'CREATE_AND_EDIT_CONTRACTS_ASC',
  CREATE_AND_EDIT_CONTRACTS_DESC = 'CREATE_AND_EDIT_CONTRACTS_DESC',
  CREATE_AND_EDIT_ORDERS_ASC = 'CREATE_AND_EDIT_ORDERS_ASC',
  CREATE_AND_EDIT_ORDERS_DESC = 'CREATE_AND_EDIT_ORDERS_DESC',
  CREATE_AND_EDIT_PORT_CALLS_ASC = 'CREATE_AND_EDIT_PORT_CALLS_ASC',
  CREATE_AND_EDIT_PORT_CALLS_DESC = 'CREATE_AND_EDIT_PORT_CALLS_DESC',
  CREATE_AND_EDIT_VOYAGES_ASC = 'CREATE_AND_EDIT_VOYAGES_ASC',
  CREATE_AND_EDIT_VOYAGES_DESC = 'CREATE_AND_EDIT_VOYAGES_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  ORG_ADMIN_ASC = 'ORG_ADMIN_ASC',
  ORG_ADMIN_DESC = 'ORG_ADMIN_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

/** User settings */
export type UserSetting = Node & {
  __typename?: 'UserSetting';
  formSettings?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['UserSettingId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Notification settings for all indirect orders */
  notificationAllOrders?: Maybe<NotificationSetting>;
  /** Notification settings for orders owned by the user */
  notificationYourOrders?: Maybe<NotificationSetting>;
  /** Reads a single `User` that is related to this `UserSetting`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
};

/**
 * A condition to be used against `UserSetting` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserSettingCondition = {
  /** Checks for equality with the object’s `formSettings` field. */
  formSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UserSettingId']['input']>;
  /** Checks for equality with the object’s `notificationAllOrders` field. */
  notificationAllOrders?: InputMaybe<NotificationSettingInput>;
  /** Checks for equality with the object’s `notificationYourOrders` field. */
  notificationYourOrders?: InputMaybe<NotificationSettingInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `UserSetting` object types. All fields are combined with a logical ‘and.’ */
export type UserSettingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserSettingFilter>>;
  /** Filter by the object’s `formSettings` field. */
  formSettings?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserSettingFilter>;
  /** Filter by the object’s `notificationAllOrders` field. */
  notificationAllOrders?: InputMaybe<NotificationSettingFilter>;
  /** Filter by the object’s `notificationYourOrders` field. */
  notificationYourOrders?: InputMaybe<NotificationSettingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserSettingFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserSetting` */
export type UserSettingInput = {
  formSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** Notification settings for all indirect orders */
  notificationAllOrders?: InputMaybe<NotificationSettingInput>;
  /** Notification settings for orders owned by the user */
  notificationYourOrders?: InputMaybe<NotificationSettingInput>;
  userId: Scalars['UserId']['input'];
};

/** Represents an update to a `UserSetting`. Fields that are set will be updated. */
export type UserSettingPatch = {
  formSettings?: InputMaybe<Scalars['JSON']['input']>;
  /** Notification settings for all indirect orders */
  notificationAllOrders?: InputMaybe<NotificationSettingInput>;
  /** Notification settings for orders owned by the user */
  notificationYourOrders?: InputMaybe<NotificationSettingInput>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `UserSetting` values. */
export type UserSettingsConnection = {
  __typename?: 'UserSettingsConnection';
  /** A list of edges which contains the `UserSetting` and cursor to aid in pagination. */
  edges: Array<UserSettingsEdge>;
  /** A list of `UserSetting` objects. */
  nodes: Array<Maybe<UserSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserSetting` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserSetting` edge in the connection. */
export type UserSettingsEdge = {
  __typename?: 'UserSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserSetting` at the end of the edge. */
  node?: Maybe<UserSetting>;
};

/** Methods to use when ordering `UserSetting`. */
export enum UserSettingsOrderBy {
  FORM_SETTINGS_ASC = 'FORM_SETTINGS_ASC',
  FORM_SETTINGS_DESC = 'FORM_SETTINGS_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  NOTIFICATION_ALL_ORDERS_ASC = 'NOTIFICATION_ALL_ORDERS_ASC',
  NOTIFICATION_ALL_ORDERS_DESC = 'NOTIFICATION_ALL_ORDERS_DESC',
  NOTIFICATION_YOUR_ORDERS_ASC = 'NOTIFICATION_YOUR_ORDERS_ASC',
  NOTIFICATION_YOUR_ORDERS_DESC = 'NOTIFICATION_YOUR_ORDERS_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export type UserShip = Node & {
  __typename?: 'UserShip';
  id: Scalars['UserShipId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Ship` that is related to this `UserShip`. */
  shipByShipId?: Maybe<Ship>;
  shipId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads a single `User` that is related to this `UserShip`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UserId']['output']>;
};

/**
 * A condition to be used against `UserShip` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserShipCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UserShipId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A filter to be used against `UserShip` object types. All fields are combined with a logical ‘and.’ */
export type UserShipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserShipFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserShipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserShipFilter>>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserShip` */
export type UserShipInput = {
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** Represents an update to a `UserShip`. Fields that are set will be updated. */
export type UserShipPatch = {
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
};

/** A connection to a list of `UserShip` values. */
export type UserShipsConnection = {
  __typename?: 'UserShipsConnection';
  /** A list of edges which contains the `UserShip` and cursor to aid in pagination. */
  edges: Array<UserShipsEdge>;
  /** A list of `UserShip` objects. */
  nodes: Array<Maybe<UserShip>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserShip` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserShip` edge in the connection. */
export type UserShipsEdge = {
  __typename?: 'UserShipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserShip` at the end of the edge. */
  node?: Maybe<UserShip>;
};

/** Methods to use when ordering `UserShip`. */
export enum UserShipsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC'
}

export enum UserType {
  CARGO = 'CARGO',
  PORT_AGENT = 'PORT_AGENT',
  SHIP = 'SHIP'
}

/** A filter to be used against UserType fields. All fields are combined with a logical ‘and.’ */
export type UserTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserType>>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  EMAIL_ASC = 'EMAIL_ASC',
  EMAIL_DESC = 'EMAIL_DESC',
  FAMILY_NAME_ASC = 'FAMILY_NAME_ASC',
  FAMILY_NAME_DESC = 'FAMILY_NAME_DESC',
  GIVEN_NAME_ASC = 'GIVEN_NAME_ASC',
  GIVEN_NAME_DESC = 'GIVEN_NAME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  INITIALS_ASC = 'INITIALS_ASC',
  INITIALS_DESC = 'INITIALS_DESC',
  INSERTED_AT_ASC = 'INSERTED_AT_ASC',
  INSERTED_AT_DESC = 'INSERTED_AT_DESC',
  LOCALE_ASC = 'LOCALE_ASC',
  LOCALE_DESC = 'LOCALE_DESC',
  MONITORING_ONLY_ASC = 'MONITORING_ONLY_ASC',
  MONITORING_ONLY_DESC = 'MONITORING_ONLY_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  NICKNAME_ASC = 'NICKNAME_ASC',
  NICKNAME_DESC = 'NICKNAME_DESC',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PICTURE_ASC = 'PICTURE_ASC',
  PICTURE_DESC = 'PICTURE_DESC',
  PREFERRED_WORD_FOR_VESSEL_ASC = 'PREFERRED_WORD_FOR_VESSEL_ASC',
  PREFERRED_WORD_FOR_VESSEL_DESC = 'PREFERRED_WORD_FOR_VESSEL_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHOW_ADMIN_ASC = 'SHOW_ADMIN_ASC',
  SHOW_ADMIN_DESC = 'SHOW_ADMIN_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  USER_TYPE_ASC = 'USER_TYPE_ASC',
  USER_TYPE_DESC = 'USER_TYPE_DESC'
}

export type VcAndOrdersInput = {
  createCargoExclusions?: InputMaybe<Array<CommitCargoExclusionInput>>;
  createCommissions?: InputMaybe<Array<CommitCommissionInput>>;
  createOrderAttributeAssociations?: InputMaybe<Array<CommitOrderAttributeAssociationInput>>;
  createOrderDetails?: InputMaybe<Array<CommitOrderDetailInput>>;
  createOrderRequirementAssociations?: InputMaybe<Array<CommitOrderRequirementAssociationInput>>;
  createOrderVoyageCharterRelations?: InputMaybe<Array<CommitVcOrderVoyageCharterRelationInput>>;
  createOrders?: InputMaybe<Array<OrderInput>>;
  createPortData?: InputMaybe<Array<PortDatumInput>>;
  createVoyageCharterExtraCosts?: InputMaybe<Array<CommitVoyageCharterExtraCostInput>>;
  createVoyageCharterExtraFreights?: InputMaybe<Array<CommitVoyageCharterExtraFreightInput>>;
  createVoyageCharterOrderFreights?: InputMaybe<Array<CommitVoyageCharterOrderFreightInput>>;
  createVoyageCharterPortData?: InputMaybe<Array<CommitVcVoyageCharterPortDatumInput>>;
  createVoyageCharterToContracts?: InputMaybe<Array<CommitVoyageCharterToContractInput>>;
  createVoyageCharters?: InputMaybe<Array<VoyageCharterInput>>;
  deleteCargoExclusions?: InputMaybe<Array<Scalars['CargoExclusionId']['input']>>;
  deleteCommissions?: InputMaybe<Array<Scalars['CommissionId']['input']>>;
  deleteOrderAttributeAssociations?: InputMaybe<Array<Scalars['OrderAttributeAssociationId']['input']>>;
  deleteOrderRequirementAssociations?: InputMaybe<Array<Scalars['OrderRequirementAssociationId']['input']>>;
  deleteOrderVoyageCharterRelations?: InputMaybe<Array<Scalars['OrderVoyageCharterRelationId']['input']>>;
  deleteOrders?: InputMaybe<Array<Scalars['OrderId']['input']>>;
  deletePortData?: InputMaybe<Array<Scalars['PortDatumId']['input']>>;
  deleteVoyageCharterExtraCosts?: InputMaybe<Array<Scalars['VoyageCharterExtraCostId']['input']>>;
  deleteVoyageCharterExtraFreights?: InputMaybe<Array<Scalars['VoyageCharterExtraFreightId']['input']>>;
  deleteVoyageCharterOrderFreights?: InputMaybe<Array<Scalars['VoyageCharterOrderFreightId']['input']>>;
  deleteVoyageCharterPortData?: InputMaybe<Array<Scalars['VoyageCharterPortDatumId']['input']>>;
  deleteVoyageCharterToContracts?: InputMaybe<Array<Scalars['VoyageCharterToContractId']['input']>>;
  deleteVoyageCharters?: InputMaybe<Array<Scalars['VoyageCharterId']['input']>>;
  mapAssortments?: InputMaybe<Array<IdRemappingInput>>;
  mapLocations?: InputMaybe<Array<IdRemappingInput>>;
  suppressEmail?: InputMaybe<Scalars['Boolean']['input']>;
  updateCommissions?: InputMaybe<Array<UpdateCommissionByIdInput>>;
  updateOrderDetails?: InputMaybe<Array<UpdateOrderDetailByIdInput>>;
  updateOrderVoyageCharterRelations?: InputMaybe<Array<UpdateOrderVoyageCharterRelationByIdInput>>;
  updateOrders?: InputMaybe<Array<UpdateOrderByIdInput>>;
  updatePortData?: InputMaybe<Array<UpdatePortDatumByIdInput>>;
  updateVoyageCharterExtraCosts?: InputMaybe<Array<UpdateVoyageCharterExtraCostByIdInput>>;
  updateVoyageCharterExtraFreights?: InputMaybe<Array<UpdateVoyageCharterExtraFreightByIdInput>>;
  updateVoyageCharterOrderFreights?: InputMaybe<Array<UpdateVoyageCharterOrderFreightByIdInput>>;
  updateVoyageCharterPortData?: InputMaybe<Array<UpdateVoyageCharterPortDatumByIdInput>>;
  updateVoyageCharterToContracts?: InputMaybe<Array<UpdateVoyageCharterToContractByIdInput>>;
  updateVoyageCharters?: InputMaybe<Array<UpdateVoyageCharterByIdInput>>;
};

export type VcAndOrdersPayload = {
  __typename?: 'VcAndOrdersPayload';
  createdCargoExclusions: Array<CargoExclusion>;
  createdCommissions: Array<Commission>;
  createdOrderAttributeAssociations: Array<OrderAttributeAssociation>;
  createdOrderDetails: Array<OrderDetail>;
  createdOrderRequirementAssociations: Array<OrderRequirementAssociation>;
  createdOrderVoyageCharterRelations: Array<OrderVoyageCharterRelation>;
  createdOrders: Array<Order>;
  createdPortData: Array<PortDatum>;
  createdVoyageCharterExtraCosts: Array<VoyageCharterExtraCost>;
  createdVoyageCharterExtraFreights: Array<VoyageCharterExtraFreight>;
  createdVoyageCharterOrderFreights: Array<VoyageCharterOrderFreight>;
  createdVoyageCharterPortData: Array<VoyageCharterPortDatum>;
  createdVoyageCharterToContracts: Array<VoyageCharterToContract>;
  createdVoyageCharters: Array<VoyageCharter>;
  deletedCargoExclusions: Array<Ident>;
  deletedCommissions: Array<Ident>;
  deletedOrderAttributeAssociations: Array<Ident>;
  deletedOrderRequirementAssociations: Array<Ident>;
  deletedOrderVoyageCharterRelations: Array<Ident>;
  deletedOrders: Array<Ident>;
  deletedPortData: Array<Ident>;
  deletedVoyageCharterExtraCosts: Array<Ident>;
  deletedVoyageCharterExtraFreights: Array<Ident>;
  deletedVoyageCharterOrderFreights: Array<Ident>;
  deletedVoyageCharterPortData: Array<Ident>;
  deletedVoyageCharterToContracts: Array<Ident>;
  deletedVoyageCharters: Array<Ident>;
  success: Scalars['Boolean']['output'];
  updatedCommissions: Array<Commission>;
  updatedOrderDetails: Array<OrderDetail>;
  updatedOrderVoyageCharterRelations: Array<OrderVoyageCharterRelation>;
  updatedOrders: Array<Order>;
  updatedPortData: Array<PortDatum>;
  updatedVoyageCharterExtraCosts: Array<VoyageCharterExtraCost>;
  updatedVoyageCharterExtraFreights: Array<VoyageCharterExtraFreight>;
  updatedVoyageCharterOrderFreights: Array<VoyageCharterOrderFreight>;
  updatedVoyageCharterPortData: Array<VoyageCharterPortDatum>;
  updatedVoyageCharterToContracts: Array<VoyageCharterToContract>;
  updatedVoyageCharters: Array<VoyageCharter>;
};

/** All input for the `verifyEmail` mutation. */
export type VerifyEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  verify: Scalars['UUID']['input'];
};

/** The output of our `verifyEmail` mutation. */
export type VerifyEmailPayload = {
  __typename?: 'VerifyEmailPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type VesonConfig = {
  __typename?: 'VesonConfig';
  cargoEndpoint?: Maybe<Scalars['String']['output']>;
  commissionEndpoint?: Maybe<Scalars['String']['output']>;
  extraFreightEndpoint?: Maybe<Scalars['String']['output']>;
  graphqlEndpoint?: Maybe<Scalars['String']['output']>;
  hasVesonFeature: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  integrationUserId: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  organizationId: Scalars['Int']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  pnlEndpoint?: Maybe<Scalars['String']['output']>;
  portCostEndpoint?: Maybe<Scalars['String']['output']>;
  robEndpoint?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['Int']['output'];
  statusFilters?: Maybe<Array<Scalars['String']['output']>>;
  token: Scalars['String']['output'];
  vesonOwnerType?: Maybe<Scalars['String']['output']>;
  vesselEndpoint?: Maybe<Scalars['String']['output']>;
};

export type VesonConfigPayload = {
  __typename?: 'VesonConfigPayload';
  vesonConfig?: Maybe<VesonConfig>;
};

export type VesonDefaultBunkerOfVessel = {
  __typename?: 'VesonDefaultBunkerOfVessel';
  bunker: Array<VesonDefaultBunkerPrice>;
  id: Scalars['Int']['output'];
  vessel_code: Scalars['String']['output'];
};

export type VesonDefaultBunkerPrice = {
  __typename?: 'VesonDefaultBunkerPrice';
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type VesonExtraPortDaysSyncResult = {
  __typename?: 'VesonExtraPortDaysSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type VesonOrdersSyncResult = {
  __typename?: 'VesonOrdersSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type VesonPortsSyncResult = {
  __typename?: 'VesonPortsSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type VesonRemainingBunker = {
  __typename?: 'VesonRemainingBunker';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type VesonRemainingBunkerOfVoyage = {
  __typename?: 'VesonRemainingBunkerOfVoyage';
  bunkerClose: Array<VesonRemainingBunker>;
  bunkerOpen: Array<VesonRemainingBunker>;
  id: Scalars['Int']['output'];
  voyage: Scalars['String']['output'];
};

export type VesonUpdateData = {
  __typename?: 'VesonUpdateData';
  syncOrder: VesonOrdersSyncResult;
  syncVessel: VesonVesselsSyncResult;
  updateScenario: UpdateVesonScenarioResult;
};

export type VesonVesselsSyncResult = {
  __typename?: 'VesonVesselsSyncResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: Status;
};

export type VesonVoyagePnl = {
  __typename?: 'VesonVoyagePnl';
  VesselName: Scalars['String']['output'];
  VoyageNo: Scalars['Int']['output'];
  VoyagePnlSummary: Array<VesonVoyagePnlItem>;
};

export type VesonVoyagePnlItem = {
  __typename?: 'VesonVoyagePnlItem';
  ActualAmountBase?: Maybe<Scalars['Float']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  EstimatedAmountBase?: Maybe<Scalars['Float']['output']>;
  PostedAmountBase?: Maybe<Scalars['Float']['output']>;
  RootCategory?: Maybe<Scalars['String']['output']>;
};

export enum VesselArea {
  ALL_AREAS = 'ALL_AREAS',
  INSIDE_ECA = 'INSIDE_ECA',
  OUTSIDE_ECA = 'OUTSIDE_ECA'
}

/** A filter to be used against VesselArea fields. All fields are combined with a logical ‘and.’ */
export type VesselAreaFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VesselArea>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VesselArea>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VesselArea>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VesselArea>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VesselArea>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VesselArea>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VesselArea>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VesselArea>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VesselArea>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VesselArea>>;
};

/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttribute = Node & {
  __typename?: 'VesselAttribute';
  /** Reads and enables pagination through a set of `AssortmentExclusion`. */
  assortmentExclusionsByVesselCostClassId: AssortmentExclusionsConnection;
  /** Cargo compatibility ranking of the vessel attribute */
  cargoCompatibilityRanking?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `ChannelCostEstimate`. */
  channelCostEstimatesByVesselTypeId: ChannelCostEstimatesConnection;
  /** Reads and enables pagination through a set of `ChannelIncompatibility`. */
  channelIncompatibilitiesByVesselAttributeId: ChannelIncompatibilitiesConnection;
  /** Reads and enables pagination through a set of `CoaContractPortCost`. */
  coaContractPortCostsByVesselTypeId: CoaContractPortCostsConnection;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['VesselAttributeId']['output'];
  isVesselClass: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Order`. */
  ordersByMinVesselClassRequirement: OrdersConnection;
  /** Reads a single `Organization` that is related to this `VesselAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselAttribute`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `PortCostDefault`. */
  portCostDefaultsByVesselTypeId: PortCostDefaultsConnection;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `Ship`. */
  shipsByPrimaryAttributeId: ShipsConnection;
  /** Reads and enables pagination through a set of `VesselAttributeAssortmentExclusion`. */
  vesselAttributeAssortmentExclusionsByVesselAttributeId: VesselAttributeAssortmentExclusionsConnection;
  /** Reads and enables pagination through a set of `VesselAttributesAssociation`. */
  vesselAttributesAssociationsByVesselAttributeId: VesselAttributesAssociationsConnection;
  /** Reads and enables pagination through a set of `VesselFulfillsRequirementAssociation`. */
  vesselFulfillsRequirementAssociationsByVesselAttributeId: VesselFulfillsRequirementAssociationsConnection;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeAssortmentExclusionsByVesselCostClassIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssortmentExclusionCondition>;
  filter?: InputMaybe<AssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeChannelCostEstimatesByVesselTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelCostEstimateCondition>;
  filter?: InputMaybe<ChannelCostEstimateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeChannelIncompatibilitiesByVesselAttributeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChannelIncompatibilityCondition>;
  filter?: InputMaybe<ChannelIncompatibilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChannelIncompatibilitiesOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeCoaContractPortCostsByVesselTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCostCondition>;
  filter?: InputMaybe<CoaContractPortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortCostsOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeOrdersByMinVesselClassRequirementArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderCondition>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributePortCostDefaultsByVesselTypeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCostDefaultCondition>;
  filter?: InputMaybe<PortCostDefaultFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCostDefaultsOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeShipsByPrimaryAttributeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipCondition>;
  filter?: InputMaybe<ShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeVesselAttributeAssortmentExclusionsByVesselAttributeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributeAssortmentExclusionCondition>;
  filter?: InputMaybe<VesselAttributeAssortmentExclusionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributeAssortmentExclusionsOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeVesselAttributesAssociationsByVesselAttributeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselAttributesAssociationCondition>;
  filter?: InputMaybe<VesselAttributesAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselAttributesAssociationsOrderBy>>;
};


/** Vessels attributes, e.g., (dirty, clean, ...) */
export type VesselAttributeVesselFulfillsRequirementAssociationsByVesselAttributeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VesselFulfillsRequirementAssociationCondition>;
  filter?: InputMaybe<VesselFulfillsRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
};

export type VesselAttributeAssortmentExclusion = Node & {
  __typename?: 'VesselAttributeAssortmentExclusion';
  /** Reads a single `Assortment` that is related to this `VesselAttributeAssortmentExclusion`. */
  assortmentByAssortmentId?: Maybe<Assortment>;
  /** Reads a single `AssortmentGroup` that is related to this `VesselAttributeAssortmentExclusion`. */
  assortmentGroupByAssortmentGroupId?: Maybe<AssortmentGroup>;
  assortmentGroupId?: Maybe<Scalars['AssortmentGroupId']['output']>;
  assortmentId?: Maybe<Scalars['AssortmentId']['output']>;
  id: Scalars['VesselAttributeAssortmentExclusionId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `VesselAttribute` that is related to this `VesselAttributeAssortmentExclusion`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  vesselAttributeId: Scalars['VesselAttributeId']['output'];
};

/**
 * A condition to be used against `VesselAttributeAssortmentExclusion` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type VesselAttributeAssortmentExclusionCondition = {
  /** Checks for equality with the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  /** Checks for equality with the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselAttributeAssortmentExclusionId']['input']>;
  /** Checks for equality with the object’s `vesselAttributeId` field. */
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A filter to be used against `VesselAttributeAssortmentExclusion` object types. All fields are combined with a logical ‘and.’ */
export type VesselAttributeAssortmentExclusionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselAttributeAssortmentExclusionFilter>>;
  /** Filter by the object’s `assortmentGroupId` field. */
  assortmentGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `assortmentId` field. */
  assortmentId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselAttributeAssortmentExclusionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselAttributeAssortmentExclusionFilter>>;
  /** Filter by the object’s `vesselAttributeId` field. */
  vesselAttributeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselAttributeAssortmentExclusion` */
export type VesselAttributeAssortmentExclusionInput = {
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  vesselAttributeId: Scalars['VesselAttributeId']['input'];
};

/** Represents an update to a `VesselAttributeAssortmentExclusion`. Fields that are set will be updated. */
export type VesselAttributeAssortmentExclusionPatch = {
  assortmentGroupId?: InputMaybe<Scalars['AssortmentGroupId']['input']>;
  assortmentId?: InputMaybe<Scalars['AssortmentId']['input']>;
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A connection to a list of `VesselAttributeAssortmentExclusion` values. */
export type VesselAttributeAssortmentExclusionsConnection = {
  __typename?: 'VesselAttributeAssortmentExclusionsConnection';
  /** A list of edges which contains the `VesselAttributeAssortmentExclusion` and cursor to aid in pagination. */
  edges: Array<VesselAttributeAssortmentExclusionsEdge>;
  /** A list of `VesselAttributeAssortmentExclusion` objects. */
  nodes: Array<Maybe<VesselAttributeAssortmentExclusion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselAttributeAssortmentExclusion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselAttributeAssortmentExclusion` edge in the connection. */
export type VesselAttributeAssortmentExclusionsEdge = {
  __typename?: 'VesselAttributeAssortmentExclusionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselAttributeAssortmentExclusion` at the end of the edge. */
  node?: Maybe<VesselAttributeAssortmentExclusion>;
};

/** Methods to use when ordering `VesselAttributeAssortmentExclusion`. */
export enum VesselAttributeAssortmentExclusionsOrderBy {
  ASSORTMENT_GROUP_ID_ASC = 'ASSORTMENT_GROUP_ID_ASC',
  ASSORTMENT_GROUP_ID_DESC = 'ASSORTMENT_GROUP_ID_DESC',
  ASSORTMENT_ID_ASC = 'ASSORTMENT_ID_ASC',
  ASSORTMENT_ID_DESC = 'ASSORTMENT_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VESSEL_ATTRIBUTE_ID_ASC = 'VESSEL_ATTRIBUTE_ID_ASC',
  VESSEL_ATTRIBUTE_ID_DESC = 'VESSEL_ATTRIBUTE_ID_DESC'
}

/**
 * A condition to be used against `VesselAttribute` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VesselAttributeCondition = {
  /** Checks for equality with the object’s `cargoCompatibilityRanking` field. */
  cargoCompatibilityRanking?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  /** Checks for equality with the object’s `isVesselClass` field. */
  isVesselClass?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `VesselAttribute` object types. All fields are combined with a logical ‘and.’ */
export type VesselAttributeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselAttributeFilter>>;
  /** Filter by the object’s `cargoCompatibilityRanking` field. */
  cargoCompatibilityRanking?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isVesselClass` field. */
  isVesselClass?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselAttributeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselAttributeFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselAttribute` */
export type VesselAttributeInput = {
  /** Cargo compatibility ranking of the vessel attribute */
  cargoCompatibilityRanking?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isVesselClass?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** Represents an update to a `VesselAttribute`. Fields that are set will be updated. */
export type VesselAttributePatch = {
  /** Cargo compatibility ranking of the vessel attribute */
  cargoCompatibilityRanking?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isVesselClass?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Associations between ships and vessels_attributes */
export type VesselAttributesAssociation = Node & {
  __typename?: 'VesselAttributesAssociation';
  id: Scalars['VesselAttributesAssociationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VesselAttributesAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `VesselAttributesAssociation`. */
  shipByShipId?: Maybe<Ship>;
  shipId: Scalars['ShipId']['output'];
  /** Reads a single `VesselAttribute` that is related to this `VesselAttributesAssociation`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  vesselAttributeId: Scalars['VesselAttributeId']['output'];
};

/**
 * A condition to be used against `VesselAttributesAssociation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VesselAttributesAssociationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselAttributesAssociationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `vesselAttributeId` field. */
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A filter to be used against `VesselAttributesAssociation` object types. All fields are combined with a logical ‘and.’ */
export type VesselAttributesAssociationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselAttributesAssociationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselAttributesAssociationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselAttributesAssociationFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselAttributeId` field. */
  vesselAttributeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselAttributesAssociation` */
export type VesselAttributesAssociationInput = {
  shipId: Scalars['ShipId']['input'];
  vesselAttributeId: Scalars['VesselAttributeId']['input'];
};

/** Represents an update to a `VesselAttributesAssociation`. Fields that are set will be updated. */
export type VesselAttributesAssociationPatch = {
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
};

/** A connection to a list of `VesselAttributesAssociation` values. */
export type VesselAttributesAssociationsConnection = {
  __typename?: 'VesselAttributesAssociationsConnection';
  /** A list of edges which contains the `VesselAttributesAssociation` and cursor to aid in pagination. */
  edges: Array<VesselAttributesAssociationsEdge>;
  /** A list of `VesselAttributesAssociation` objects. */
  nodes: Array<Maybe<VesselAttributesAssociation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselAttributesAssociation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselAttributesAssociation` edge in the connection. */
export type VesselAttributesAssociationsEdge = {
  __typename?: 'VesselAttributesAssociationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselAttributesAssociation` at the end of the edge. */
  node?: Maybe<VesselAttributesAssociation>;
};

/** Methods to use when ordering `VesselAttributesAssociation`. */
export enum VesselAttributesAssociationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC',
  VESSEL_ATTRIBUTE_ID_ASC = 'VESSEL_ATTRIBUTE_ID_ASC',
  VESSEL_ATTRIBUTE_ID_DESC = 'VESSEL_ATTRIBUTE_ID_DESC'
}

/** A connection to a list of `VesselAttribute` values. */
export type VesselAttributesConnection = {
  __typename?: 'VesselAttributesConnection';
  /** A list of edges which contains the `VesselAttribute` and cursor to aid in pagination. */
  edges: Array<VesselAttributesEdge>;
  /** A list of `VesselAttribute` objects. */
  nodes: Array<Maybe<VesselAttribute>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselAttribute` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselAttribute` edge in the connection. */
export type VesselAttributesEdge = {
  __typename?: 'VesselAttributesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselAttribute` at the end of the edge. */
  node?: Maybe<VesselAttribute>;
};

/** Methods to use when ordering `VesselAttribute`. */
export enum VesselAttributesOrderBy {
  CARGO_COMPATIBILITY_RANKING_ASC = 'CARGO_COMPATIBILITY_RANKING_ASC',
  CARGO_COMPATIBILITY_RANKING_DESC = 'CARGO_COMPATIBILITY_RANKING_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_VESSEL_CLASS_ASC = 'IS_VESSEL_CLASS_ASC',
  IS_VESSEL_CLASS_DESC = 'IS_VESSEL_CLASS_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type VesselDraftDatapoint = Node & {
  __typename?: 'VesselDraftDatapoint';
  cargoLoad: Scalars['BigFloat']['output'];
  draft: Scalars['BigFloat']['output'];
  id: Scalars['VesselDraftDatapointIdString']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VesselDraftDatapoint`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `VesselDraftDatapoint`. */
  shipByShipId?: Maybe<Ship>;
  shipId: Scalars['ShipId']['output'];
};

/**
 * A condition to be used against `VesselDraftDatapoint` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VesselDraftDatapointCondition = {
  /** Checks for equality with the object’s `cargoLoad` field. */
  cargoLoad?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselDraftDatapointIdString']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `VesselDraftDatapoint` object types. All fields are combined with a logical ‘and.’ */
export type VesselDraftDatapointFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselDraftDatapointFilter>>;
  /** Filter by the object’s `cargoLoad` field. */
  cargoLoad?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselDraftDatapointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselDraftDatapointFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselDraftDatapoint` */
export type VesselDraftDatapointInput = {
  cargoLoad: Scalars['BigFloat']['input'];
  draft: Scalars['BigFloat']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  shipId: Scalars['ShipId']['input'];
};

/** Represents an update to a `VesselDraftDatapoint`. Fields that are set will be updated. */
export type VesselDraftDatapointPatch = {
  cargoLoad?: InputMaybe<Scalars['BigFloat']['input']>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `VesselDraftDatapoint` values. */
export type VesselDraftDatapointsConnection = {
  __typename?: 'VesselDraftDatapointsConnection';
  /** A list of edges which contains the `VesselDraftDatapoint` and cursor to aid in pagination. */
  edges: Array<VesselDraftDatapointsEdge>;
  /** A list of `VesselDraftDatapoint` objects. */
  nodes: Array<Maybe<VesselDraftDatapoint>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselDraftDatapoint` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselDraftDatapoint` edge in the connection. */
export type VesselDraftDatapointsEdge = {
  __typename?: 'VesselDraftDatapointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselDraftDatapoint` at the end of the edge. */
  node?: Maybe<VesselDraftDatapoint>;
};

/** Methods to use when ordering `VesselDraftDatapoint`. */
export enum VesselDraftDatapointsOrderBy {
  CARGO_LOAD_ASC = 'CARGO_LOAD_ASC',
  CARGO_LOAD_DESC = 'CARGO_LOAD_DESC',
  DRAFT_ASC = 'DRAFT_ASC',
  DRAFT_DESC = 'DRAFT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC'
}

export type VesselFulfillsRequirementAssociation = Node & {
  __typename?: 'VesselFulfillsRequirementAssociation';
  id: Scalars['VesselFulfillsRequirementAssociationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VesselFulfillsRequirementAssociation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `VesselFulfillsRequirementAssociation`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `SpecialRequirement` that is related to this `VesselFulfillsRequirementAssociation`. */
  specialRequirementBySpecialRequirementId?: Maybe<SpecialRequirement>;
  specialRequirementId: Scalars['SpecialRequirementId']['output'];
  /** Reads a single `VesselAttribute` that is related to this `VesselFulfillsRequirementAssociation`. */
  vesselAttributeByVesselAttributeId?: Maybe<VesselAttribute>;
  vesselAttributeId?: Maybe<Scalars['VesselAttributeId']['output']>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
};

/**
 * A condition to be used against `VesselFulfillsRequirementAssociation` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type VesselFulfillsRequirementAssociationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselFulfillsRequirementAssociationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `specialRequirementId` field. */
  specialRequirementId?: InputMaybe<Scalars['SpecialRequirementId']['input']>;
  /** Checks for equality with the object’s `vesselAttributeId` field. */
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `VesselFulfillsRequirementAssociation` object types. All fields are combined with a logical ‘and.’ */
export type VesselFulfillsRequirementAssociationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselFulfillsRequirementAssociationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselFulfillsRequirementAssociationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselFulfillsRequirementAssociationFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `specialRequirementId` field. */
  specialRequirementId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselAttributeId` field. */
  vesselAttributeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselFulfillsRequirementAssociation` */
export type VesselFulfillsRequirementAssociationInput = {
  specialRequirementId: Scalars['SpecialRequirementId']['input'];
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** Represents an update to a `VesselFulfillsRequirementAssociation`. Fields that are set will be updated. */
export type VesselFulfillsRequirementAssociationPatch = {
  specialRequirementId?: InputMaybe<Scalars['SpecialRequirementId']['input']>;
  vesselAttributeId?: InputMaybe<Scalars['VesselAttributeId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `VesselFulfillsRequirementAssociation` values. */
export type VesselFulfillsRequirementAssociationsConnection = {
  __typename?: 'VesselFulfillsRequirementAssociationsConnection';
  /** A list of edges which contains the `VesselFulfillsRequirementAssociation` and cursor to aid in pagination. */
  edges: Array<VesselFulfillsRequirementAssociationsEdge>;
  /** A list of `VesselFulfillsRequirementAssociation` objects. */
  nodes: Array<Maybe<VesselFulfillsRequirementAssociation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselFulfillsRequirementAssociation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselFulfillsRequirementAssociation` edge in the connection. */
export type VesselFulfillsRequirementAssociationsEdge = {
  __typename?: 'VesselFulfillsRequirementAssociationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselFulfillsRequirementAssociation` at the end of the edge. */
  node?: Maybe<VesselFulfillsRequirementAssociation>;
};

/** Methods to use when ordering `VesselFulfillsRequirementAssociation`. */
export enum VesselFulfillsRequirementAssociationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SPECIAL_REQUIREMENT_ID_ASC = 'SPECIAL_REQUIREMENT_ID_ASC',
  SPECIAL_REQUIREMENT_ID_DESC = 'SPECIAL_REQUIREMENT_ID_DESC',
  VESSEL_ATTRIBUTE_ID_ASC = 'VESSEL_ATTRIBUTE_ID_ASC',
  VESSEL_ATTRIBUTE_ID_DESC = 'VESSEL_ATTRIBUTE_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type VesselInfo = Node & {
  __typename?: 'VesselInfo';
  adminUserId?: Maybe<Scalars['UserId']['output']>;
  breadth: Scalars['BigFloat']['output'];
  callSign?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `CargoCompartment`. */
  cargoCompartmentsByVesselId: CargoCompartmentsConnection;
  /** Reads a single `ClassSocietyAssociation` that is related to this `VesselInfo`. */
  classSocietyAssociationByClassSocietyAssociationId?: Maybe<ClassSocietyAssociation>;
  classSocietyAssociationId?: Maybe<Scalars['ClassSocietyAssociationId']['output']>;
  cranes?: Maybe<Scalars['Boolean']['output']>;
  dischargingRate?: Maybe<Scalars['BigFloat']['output']>;
  dischargingUnit: LoadingUnit;
  draft: Scalars['BigFloat']['output'];
  flag: Scalars['Int']['output'];
  heating?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['VesselInfoId']['output'];
  imo: Scalars['Int']['output'];
  loa: Scalars['BigFloat']['output'];
  loadingRate?: Maybe<Scalars['BigFloat']['output']>;
  loadingUnit: LoadingUnit;
  mmsi: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VesselInfo`. */
  organizationByOwnerOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselInfo`. */
  organizationByRootOrg?: Maybe<Organization>;
  ownerOrganisationId: Scalars['OrganizationId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `Ship`. */
  shipsByVesselInfoId: ShipsConnection;
  /** Reads and enables pagination through a set of `SpotNegotiation`. */
  spotNegotiationsByVesselId: SpotNegotiationsConnection;
  /** Reads a single `User` that is related to this `VesselInfo`. */
  userByAdminUserId?: Maybe<User>;
  year: Scalars['Int']['output'];
};


export type VesselInfoCargoCompartmentsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CargoCompartmentCondition>;
  filter?: InputMaybe<CargoCompartmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CargoCompartmentsOrderBy>>;
};


export type VesselInfoShipsByVesselInfoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipCondition>;
  filter?: InputMaybe<ShipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipsOrderBy>>;
};


export type VesselInfoSpotNegotiationsByVesselIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpotNegotiationCondition>;
  filter?: InputMaybe<SpotNegotiationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};

/**
 * A condition to be used against `VesselInfo` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type VesselInfoCondition = {
  /** Checks for equality with the object’s `adminUserId` field. */
  adminUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `breadth` field. */
  breadth?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `callSign` field. */
  callSign?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `classSocietyAssociationId` field. */
  classSocietyAssociationId?: InputMaybe<Scalars['ClassSocietyAssociationId']['input']>;
  /** Checks for equality with the object’s `cranes` field. */
  cranes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `flag` field. */
  flag?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `heating` field. */
  heating?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselInfoId']['input']>;
  /** Checks for equality with the object’s `imo` field. */
  imo?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `loa` field. */
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnit>;
  /** Checks for equality with the object’s `mmsi` field. */
  mmsi?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VesselInfo` object types. All fields are combined with a logical ‘and.’ */
export type VesselInfoFilter = {
  /** Filter by the object’s `adminUserId` field. */
  adminUserId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselInfoFilter>>;
  /** Filter by the object’s `breadth` field. */
  breadth?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `callSign` field. */
  callSign?: InputMaybe<StringFilter>;
  /** Filter by the object’s `classSocietyAssociationId` field. */
  classSocietyAssociationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cranes` field. */
  cranes?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dischargingRate` field. */
  dischargingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `dischargingUnit` field. */
  dischargingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `flag` field. */
  flag?: InputMaybe<IntFilter>;
  /** Filter by the object’s `heating` field. */
  heating?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imo` field. */
  imo?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loa` field. */
  loa?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingRate` field. */
  loadingRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loadingUnit` field. */
  loadingUnit?: InputMaybe<LoadingUnitFilter>;
  /** Filter by the object’s `mmsi` field. */
  mmsi?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselInfoFilter>>;
  /** Filter by the object’s `ownerOrganisationId` field. */
  ownerOrganisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselInfo` */
export type VesselInfoInput = {
  adminUserId?: InputMaybe<Scalars['UserId']['input']>;
  breadth: Scalars['BigFloat']['input'];
  callSign?: InputMaybe<Scalars['String']['input']>;
  classSocietyAssociationId?: InputMaybe<Scalars['ClassSocietyAssociationId']['input']>;
  cranes?: InputMaybe<Scalars['Boolean']['input']>;
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingUnit: LoadingUnit;
  draft: Scalars['BigFloat']['input'];
  flag: Scalars['Int']['input'];
  heating?: InputMaybe<Scalars['Boolean']['input']>;
  imo: Scalars['Int']['input'];
  loa: Scalars['BigFloat']['input'];
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingUnit: LoadingUnit;
  mmsi: Scalars['Int']['input'];
  ownerOrganisationId: Scalars['OrganizationId']['input'];
  year: Scalars['Int']['input'];
};

/** Represents an update to a `VesselInfo`. Fields that are set will be updated. */
export type VesselInfoPatch = {
  adminUserId?: InputMaybe<Scalars['UserId']['input']>;
  breadth?: InputMaybe<Scalars['BigFloat']['input']>;
  callSign?: InputMaybe<Scalars['String']['input']>;
  classSocietyAssociationId?: InputMaybe<Scalars['ClassSocietyAssociationId']['input']>;
  cranes?: InputMaybe<Scalars['Boolean']['input']>;
  dischargingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  dischargingUnit?: InputMaybe<LoadingUnit>;
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  flag?: InputMaybe<Scalars['Int']['input']>;
  heating?: InputMaybe<Scalars['Boolean']['input']>;
  imo?: InputMaybe<Scalars['Int']['input']>;
  loa?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingRate?: InputMaybe<Scalars['BigFloat']['input']>;
  loadingUnit?: InputMaybe<LoadingUnit>;
  mmsi?: InputMaybe<Scalars['Int']['input']>;
  ownerOrganisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `VesselInfo` values. */
export type VesselInfosConnection = {
  __typename?: 'VesselInfosConnection';
  /** A list of edges which contains the `VesselInfo` and cursor to aid in pagination. */
  edges: Array<VesselInfosEdge>;
  /** A list of `VesselInfo` objects. */
  nodes: Array<Maybe<VesselInfo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselInfo` edge in the connection. */
export type VesselInfosEdge = {
  __typename?: 'VesselInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselInfo` at the end of the edge. */
  node?: Maybe<VesselInfo>;
};

/** Methods to use when ordering `VesselInfo`. */
export enum VesselInfosOrderBy {
  ADMIN_USER_ID_ASC = 'ADMIN_USER_ID_ASC',
  ADMIN_USER_ID_DESC = 'ADMIN_USER_ID_DESC',
  BREADTH_ASC = 'BREADTH_ASC',
  BREADTH_DESC = 'BREADTH_DESC',
  CALL_SIGN_ASC = 'CALL_SIGN_ASC',
  CALL_SIGN_DESC = 'CALL_SIGN_DESC',
  CLASS_SOCIETY_ASSOCIATION_ID_ASC = 'CLASS_SOCIETY_ASSOCIATION_ID_ASC',
  CLASS_SOCIETY_ASSOCIATION_ID_DESC = 'CLASS_SOCIETY_ASSOCIATION_ID_DESC',
  CRANES_ASC = 'CRANES_ASC',
  CRANES_DESC = 'CRANES_DESC',
  DISCHARGING_RATE_ASC = 'DISCHARGING_RATE_ASC',
  DISCHARGING_RATE_DESC = 'DISCHARGING_RATE_DESC',
  DISCHARGING_UNIT_ASC = 'DISCHARGING_UNIT_ASC',
  DISCHARGING_UNIT_DESC = 'DISCHARGING_UNIT_DESC',
  DRAFT_ASC = 'DRAFT_ASC',
  DRAFT_DESC = 'DRAFT_DESC',
  FLAG_ASC = 'FLAG_ASC',
  FLAG_DESC = 'FLAG_DESC',
  HEATING_ASC = 'HEATING_ASC',
  HEATING_DESC = 'HEATING_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IMO_ASC = 'IMO_ASC',
  IMO_DESC = 'IMO_DESC',
  LOADING_RATE_ASC = 'LOADING_RATE_ASC',
  LOADING_RATE_DESC = 'LOADING_RATE_DESC',
  LOADING_UNIT_ASC = 'LOADING_UNIT_ASC',
  LOADING_UNIT_DESC = 'LOADING_UNIT_DESC',
  LOA_ASC = 'LOA_ASC',
  LOA_DESC = 'LOA_DESC',
  MMSI_ASC = 'MMSI_ASC',
  MMSI_DESC = 'MMSI_DESC',
  NATURAL = 'NATURAL',
  OWNER_ORGANISATION_ID_ASC = 'OWNER_ORGANISATION_ID_ASC',
  OWNER_ORGANISATION_ID_DESC = 'OWNER_ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  YEAR_ASC = 'YEAR_ASC',
  YEAR_DESC = 'YEAR_DESC'
}

/** Stores NAPA performance model UUIDs for vessels. Each vessel can have one performance model per root organization. */
export type VesselPerformanceModel = Node & {
  __typename?: 'VesselPerformanceModel';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['VesselPerformanceModelId']['output'];
  /** IMO number used to identify the vessel in NAPA API requests */
  imoNumber: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VesselPerformanceModel`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Unique identifier for the performance model in NAPA, used for referencing the model in API calls */
  performanceModelUid: Scalars['UUID']['output'];
  /** Root organization that owns this performance model. Performance models are shared across all sub-organizations. */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `VesselPerformanceModel`. */
  shipByShipId?: Maybe<Ship>;
  /** Reference to the vessel in the ships table */
  shipId: Scalars['ShipId']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `VesselPerformanceModel` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VesselPerformanceModelCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselPerformanceModelId']['input']>;
  /** Checks for equality with the object’s `imoNumber` field. */
  imoNumber?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `performanceModelUid` field. */
  performanceModelUid?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `VesselPerformanceModel` object types. All fields are combined with a logical ‘and.’ */
export type VesselPerformanceModelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselPerformanceModelFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imoNumber` field. */
  imoNumber?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselPerformanceModelFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselPerformanceModelFilter>>;
  /** Filter by the object’s `performanceModelUid` field. */
  performanceModelUid?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `VesselPerformanceModel` */
export type VesselPerformanceModelInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** IMO number used to identify the vessel in NAPA API requests */
  imoNumber: Scalars['BigFloat']['input'];
  /** Unique identifier for the performance model in NAPA, used for referencing the model in API calls */
  performanceModelUid: Scalars['UUID']['input'];
  /** Root organization that owns this performance model. Performance models are shared across all sub-organizations. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Reference to the vessel in the ships table */
  shipId: Scalars['ShipId']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `VesselPerformanceModel`. Fields that are set will be updated. */
export type VesselPerformanceModelPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** IMO number used to identify the vessel in NAPA API requests */
  imoNumber?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Unique identifier for the performance model in NAPA, used for referencing the model in API calls */
  performanceModelUid?: InputMaybe<Scalars['UUID']['input']>;
  /** Root organization that owns this performance model. Performance models are shared across all sub-organizations. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Reference to the vessel in the ships table */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `VesselPerformanceModel` values. */
export type VesselPerformanceModelsConnection = {
  __typename?: 'VesselPerformanceModelsConnection';
  /** A list of edges which contains the `VesselPerformanceModel` and cursor to aid in pagination. */
  edges: Array<VesselPerformanceModelsEdge>;
  /** A list of `VesselPerformanceModel` objects. */
  nodes: Array<Maybe<VesselPerformanceModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselPerformanceModel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselPerformanceModel` edge in the connection. */
export type VesselPerformanceModelsEdge = {
  __typename?: 'VesselPerformanceModelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselPerformanceModel` at the end of the edge. */
  node?: Maybe<VesselPerformanceModel>;
};

/** Methods to use when ordering `VesselPerformanceModel`. */
export enum VesselPerformanceModelsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IMO_NUMBER_ASC = 'IMO_NUMBER_ASC',
  IMO_NUMBER_DESC = 'IMO_NUMBER_DESC',
  NATURAL = 'NATURAL',
  PERFORMANCE_MODEL_UID_ASC = 'PERFORMANCE_MODEL_UID_ASC',
  PERFORMANCE_MODEL_UID_DESC = 'PERFORMANCE_MODEL_UID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC'
}

export type VesselReservation = Node & {
  __typename?: 'VesselReservation';
  /** Timestamp of creation */
  createdAt: Scalars['Datetime']['output'];
  /** User that originally reserved the vessel */
  createdByUserId: Scalars['UserId']['output'];
  duration: Scalars['Int']['output'];
  endPortId?: Maybe<Scalars['LocationId']['output']>;
  endRegionId?: Maybe<Scalars['RegionId']['output']>;
  expireTime?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['VesselReservationId']['output'];
  /** Reads a single `Location` that is related to this `VesselReservation`. */
  locationByEndPortId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `VesselReservation`. */
  locationByStartPortId?: Maybe<Location>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VesselReservation`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Region` that is related to this `VesselReservation`. */
  regionByEndRegionId?: Maybe<Region>;
  /** Reads a single `Region` that is related to this `VesselReservation`. */
  regionByStartRegionId?: Maybe<Region>;
  remark?: Maybe<Scalars['String']['output']>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `VesselReservation`. */
  shipByVesselId?: Maybe<Ship>;
  startPortId?: Maybe<Scalars['LocationId']['output']>;
  startRegionId?: Maybe<Scalars['RegionId']['output']>;
  startTime: Scalars['Datetime']['output'];
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  type: VesselReservationType;
  /** Reads a single `User` that is related to this `VesselReservation`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VesselReservation`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId: Scalars['ShipId']['output'];
};

/**
 * A condition to be used against `VesselReservation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VesselReservationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `endPortId` field. */
  endPortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `endRegionId` field. */
  endRegionId?: InputMaybe<Scalars['RegionId']['input']>;
  /** Checks for equality with the object’s `expireTime` field. */
  expireTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselReservationId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `remark` field. */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `startPortId` field. */
  startPortId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `startRegionId` field. */
  startRegionId?: InputMaybe<Scalars['RegionId']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<VesselReservationType>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `VesselReservation` object types. All fields are combined with a logical ‘and.’ */
export type VesselReservationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselReservationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntFilter>;
  /** Filter by the object’s `endPortId` field. */
  endPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `endRegionId` field. */
  endRegionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `expireTime` field. */
  expireTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselReservationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselReservationFilter>>;
  /** Filter by the object’s `remark` field. */
  remark?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startPortId` field. */
  startPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startRegionId` field. */
  startRegionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<VesselReservationTypeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VesselReservationHistory` values. */
export type VesselReservationHistoriesConnection = {
  __typename?: 'VesselReservationHistoriesConnection';
  /** A list of edges which contains the `VesselReservationHistory` and cursor to aid in pagination. */
  edges: Array<VesselReservationHistoriesEdge>;
  /** A list of `VesselReservationHistory` objects. */
  nodes: Array<Maybe<VesselReservationHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselReservationHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselReservationHistory` edge in the connection. */
export type VesselReservationHistoriesEdge = {
  __typename?: 'VesselReservationHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselReservationHistory` at the end of the edge. */
  node?: Maybe<VesselReservationHistory>;
};

/** Methods to use when ordering `VesselReservationHistory`. */
export enum VesselReservationHistoriesOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DURATION_ASC = 'DURATION_ASC',
  DURATION_DESC = 'DURATION_DESC',
  END_PORT_ID_ASC = 'END_PORT_ID_ASC',
  END_PORT_ID_DESC = 'END_PORT_ID_DESC',
  END_REGION_ID_ASC = 'END_REGION_ID_ASC',
  END_REGION_ID_DESC = 'END_REGION_ID_DESC',
  EXPIRE_TIME_ASC = 'EXPIRE_TIME_ASC',
  EXPIRE_TIME_DESC = 'EXPIRE_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  REMARK_ASC = 'REMARK_ASC',
  REMARK_DESC = 'REMARK_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  START_PORT_ID_ASC = 'START_PORT_ID_ASC',
  START_PORT_ID_DESC = 'START_PORT_ID_DESC',
  START_REGION_ID_ASC = 'START_REGION_ID_ASC',
  START_REGION_ID_DESC = 'START_REGION_ID_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for vessel_reservation table */
export type VesselReservationHistory = {
  __typename?: 'VesselReservationHistory';
  createdAt: Scalars['Datetime']['output'];
  createdByUserId: Scalars['UserId']['output'];
  duration: Scalars['Int']['output'];
  endPortId?: Maybe<Scalars['Int']['output']>;
  endRegionId?: Maybe<Scalars['Int']['output']>;
  expireTime?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  rootOrg: Scalars['Int']['output'];
  startPortId?: Maybe<Scalars['Int']['output']>;
  startRegionId?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['Datetime']['output'];
  sysPeriod: DatetimeRange;
  type: VesselReservationType;
  /** Reads a single `User` that is related to this `VesselReservationHistory`. */
  userByCreatedByUserId?: Maybe<User>;
  vesselId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `VesselReservationHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VesselReservationHistoryCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `endPortId` field. */
  endPortId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `endRegionId` field. */
  endRegionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `expireTime` field. */
  expireTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `remark` field. */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startPortId` field. */
  startPortId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startRegionId` field. */
  startRegionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startTime` field. */
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<VesselReservationType>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VesselReservationHistory` object types. All fields are combined with a logical ‘and.’ */
export type VesselReservationHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselReservationHistoryFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntFilter>;
  /** Filter by the object’s `endPortId` field. */
  endPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `endRegionId` field. */
  endRegionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `expireTime` field. */
  expireTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselReservationHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselReservationHistoryFilter>>;
  /** Filter by the object’s `remark` field. */
  remark?: InputMaybe<StringFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startPortId` field. */
  startPortId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startRegionId` field. */
  startRegionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startTime` field. */
  startTime?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<VesselReservationTypeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselReservation` */
export type VesselReservationInput = {
  duration: Scalars['Int']['input'];
  endPortId?: InputMaybe<Scalars['LocationId']['input']>;
  endRegionId?: InputMaybe<Scalars['RegionId']['input']>;
  expireTime?: InputMaybe<Scalars['Datetime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startPortId?: InputMaybe<Scalars['LocationId']['input']>;
  startRegionId?: InputMaybe<Scalars['RegionId']['input']>;
  startTime: Scalars['Datetime']['input'];
  type: VesselReservationType;
  vesselId: Scalars['ShipId']['input'];
};

/** Represents an update to a `VesselReservation`. Fields that are set will be updated. */
export type VesselReservationPatch = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  endPortId?: InputMaybe<Scalars['LocationId']['input']>;
  endRegionId?: InputMaybe<Scalars['RegionId']['input']>;
  expireTime?: InputMaybe<Scalars['Datetime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  startPortId?: InputMaybe<Scalars['LocationId']['input']>;
  startRegionId?: InputMaybe<Scalars['RegionId']['input']>;
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  type?: InputMaybe<VesselReservationType>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type VesselReservationSubscriptionPayload = {
  __typename?: 'VesselReservationSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  vesselReservation?: Maybe<VesselReservation>;
};

export enum VesselReservationType {
  CARGO_ON_SUBS = 'CARGO_ON_SUBS',
  NEGOTIATING = 'NEGOTIATING',
  SCHEDULING = 'SCHEDULING',
  TRADE_LANE = 'TRADE_LANE'
}

/** A filter to be used against VesselReservationType fields. All fields are combined with a logical ‘and.’ */
export type VesselReservationTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VesselReservationType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VesselReservationType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VesselReservationType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VesselReservationType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VesselReservationType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VesselReservationType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VesselReservationType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VesselReservationType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VesselReservationType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VesselReservationType>>;
};

/** A connection to a list of `VesselReservation` values. */
export type VesselReservationsConnection = {
  __typename?: 'VesselReservationsConnection';
  /** A list of edges which contains the `VesselReservation` and cursor to aid in pagination. */
  edges: Array<VesselReservationsEdge>;
  /** A list of `VesselReservation` objects. */
  nodes: Array<Maybe<VesselReservation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselReservation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselReservation` edge in the connection. */
export type VesselReservationsEdge = {
  __typename?: 'VesselReservationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselReservation` at the end of the edge. */
  node?: Maybe<VesselReservation>;
};

/** Methods to use when ordering `VesselReservation`. */
export enum VesselReservationsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  DURATION_ASC = 'DURATION_ASC',
  DURATION_DESC = 'DURATION_DESC',
  END_PORT_ID_ASC = 'END_PORT_ID_ASC',
  END_PORT_ID_DESC = 'END_PORT_ID_DESC',
  END_REGION_ID_ASC = 'END_REGION_ID_ASC',
  END_REGION_ID_DESC = 'END_REGION_ID_DESC',
  EXPIRE_TIME_ASC = 'EXPIRE_TIME_ASC',
  EXPIRE_TIME_DESC = 'EXPIRE_TIME_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REMARK_ASC = 'REMARK_ASC',
  REMARK_DESC = 'REMARK_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  START_PORT_ID_ASC = 'START_PORT_ID_ASC',
  START_PORT_ID_DESC = 'START_PORT_ID_DESC',
  START_REGION_ID_ASC = 'START_REGION_ID_ASC',
  START_REGION_ID_DESC = 'START_REGION_ID_DESC',
  START_TIME_ASC = 'START_TIME_ASC',
  START_TIME_DESC = 'START_TIME_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type VesselScheduleSharedToOrganization = Node & {
  __typename?: 'VesselScheduleSharedToOrganization';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['VesselScheduleSharedToOrganizationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VesselScheduleSharedToOrganization`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselScheduleSharedToOrganization`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `VesselScheduleSharedToOrganization`. */
  shipByVesselId?: Maybe<Ship>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  vesselId: Scalars['ShipId']['output'];
};

/**
 * A condition to be used against `VesselScheduleSharedToOrganization` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type VesselScheduleSharedToOrganizationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselScheduleSharedToOrganizationId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `VesselScheduleSharedToOrganization` object types. All fields are combined with a logical ‘and.’ */
export type VesselScheduleSharedToOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselScheduleSharedToOrganizationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselScheduleSharedToOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselScheduleSharedToOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselScheduleSharedToOrganization` */
export type VesselScheduleSharedToOrganizationInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationId: Scalars['OrganizationId']['input'];
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId: Scalars['ShipId']['input'];
};

/** Represents an update to a `VesselScheduleSharedToOrganization`. Fields that are set will be updated. */
export type VesselScheduleSharedToOrganizationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `VesselScheduleSharedToOrganization` values. */
export type VesselScheduleSharedToOrganizationsConnection = {
  __typename?: 'VesselScheduleSharedToOrganizationsConnection';
  /** A list of edges which contains the `VesselScheduleSharedToOrganization` and cursor to aid in pagination. */
  edges: Array<VesselScheduleSharedToOrganizationsEdge>;
  /** A list of `VesselScheduleSharedToOrganization` objects. */
  nodes: Array<Maybe<VesselScheduleSharedToOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselScheduleSharedToOrganization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselScheduleSharedToOrganization` edge in the connection. */
export type VesselScheduleSharedToOrganizationsEdge = {
  __typename?: 'VesselScheduleSharedToOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselScheduleSharedToOrganization` at the end of the edge. */
  node?: Maybe<VesselScheduleSharedToOrganization>;
};

/** Methods to use when ordering `VesselScheduleSharedToOrganization`. */
export enum VesselScheduleSharedToOrganizationsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type VesselSecret = Node & {
  __typename?: 'VesselSecret';
  adminUserId: Scalars['UserId']['output'];
  currency: Currency;
  dailyCost: Scalars['BigFloat']['output'];
  id: Scalars['VesselSecretId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Organization` that is related to this `VesselSecret`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Ship` that is related to this `VesselSecret`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VesselSecret`. */
  userByAdminUserId?: Maybe<User>;
  vesselId: Scalars['ShipId']['output'];
};

/**
 * A condition to be used against `VesselSecret` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VesselSecretCondition = {
  /** Checks for equality with the object’s `adminUserId` field. */
  adminUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `dailyCost` field. */
  dailyCost?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselSecretId']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `VesselSecret` object types. All fields are combined with a logical ‘and.’ */
export type VesselSecretFilter = {
  /** Filter by the object’s `adminUserId` field. */
  adminUserId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselSecretFilter>>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `dailyCost` field. */
  dailyCost?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselSecretFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselSecretFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VesselSecret` */
export type VesselSecretInput = {
  adminUserId: Scalars['UserId']['input'];
  currency: Currency;
  dailyCost: Scalars['BigFloat']['input'];
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId: Scalars['ShipId']['input'];
};

/** Represents an update to a `VesselSecret`. Fields that are set will be updated. */
export type VesselSecretPatch = {
  adminUserId?: InputMaybe<Scalars['UserId']['input']>;
  currency?: InputMaybe<Currency>;
  dailyCost?: InputMaybe<Scalars['BigFloat']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A connection to a list of `VesselSecret` values. */
export type VesselSecretsConnection = {
  __typename?: 'VesselSecretsConnection';
  /** A list of edges which contains the `VesselSecret` and cursor to aid in pagination. */
  edges: Array<VesselSecretsEdge>;
  /** A list of `VesselSecret` objects. */
  nodes: Array<Maybe<VesselSecret>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselSecret` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselSecret` edge in the connection. */
export type VesselSecretsEdge = {
  __typename?: 'VesselSecretsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselSecret` at the end of the edge. */
  node?: Maybe<VesselSecret>;
};

/** Methods to use when ordering `VesselSecret`. */
export enum VesselSecretsOrderBy {
  ADMIN_USER_ID_ASC = 'ADMIN_USER_ID_ASC',
  ADMIN_USER_ID_DESC = 'ADMIN_USER_ID_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  DAILY_COST_ASC = 'DAILY_COST_ASC',
  DAILY_COST_DESC = 'DAILY_COST_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type VesselSpeedConsumption = Node & {
  __typename?: 'VesselSpeedConsumption';
  area?: Maybe<VesselArea>;
  bunkerGradeId: Scalars['BunkerGradeOverrideId']['output'];
  /** Reads a single `BunkerGradeOverride` that is related to this `VesselSpeedConsumption`. */
  bunkerGradeOverrideByBunkerGradeId?: Maybe<BunkerGradeOverride>;
  consumption: Scalars['BigFloat']['output'];
  id: Scalars['VesselSpeedConsumptionId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VesselSpeedConsumption`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VesselSpeedConsumption`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `VesselSpeedConsumption`. */
  shipByShipId?: Maybe<Ship>;
  shipId: Scalars['ShipId']['output'];
  speed: Scalars['BigFloat']['output'];
  tag?: Maybe<VesselSpeedTag>;
  type: VesselSpeedType;
};

/**
 * A condition to be used against `VesselSpeedConsumption` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VesselSpeedConsumptionCondition = {
  /** Checks for equality with the object’s `area` field. */
  area?: InputMaybe<VesselArea>;
  /** Checks for equality with the object’s `bunkerGradeId` field. */
  bunkerGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  /** Checks for equality with the object’s `consumption` field. */
  consumption?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VesselSpeedConsumptionId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shipId` field. */
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `speed` field. */
  speed?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `tag` field. */
  tag?: InputMaybe<VesselSpeedTag>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<VesselSpeedType>;
};

/** A filter to be used against `VesselSpeedConsumption` object types. All fields are combined with a logical ‘and.’ */
export type VesselSpeedConsumptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VesselSpeedConsumptionFilter>>;
  /** Filter by the object’s `area` field. */
  area?: InputMaybe<VesselAreaFilter>;
  /** Filter by the object’s `bunkerGradeId` field. */
  bunkerGradeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `consumption` field. */
  consumption?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VesselSpeedConsumptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VesselSpeedConsumptionFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipId` field. */
  shipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `speed` field. */
  speed?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `tag` field. */
  tag?: InputMaybe<VesselSpeedTagFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<VesselSpeedTypeFilter>;
};

/** An input for mutations affecting `VesselSpeedConsumption` */
export type VesselSpeedConsumptionInput = {
  area?: InputMaybe<VesselArea>;
  bunkerGradeId: Scalars['BunkerGradeOverrideId']['input'];
  consumption: Scalars['BigFloat']['input'];
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shipId: Scalars['ShipId']['input'];
  speed: Scalars['BigFloat']['input'];
  tag?: InputMaybe<VesselSpeedTag>;
  type: VesselSpeedType;
};

/** Represents an update to a `VesselSpeedConsumption`. Fields that are set will be updated. */
export type VesselSpeedConsumptionPatch = {
  area?: InputMaybe<VesselArea>;
  bunkerGradeId?: InputMaybe<Scalars['BunkerGradeOverrideId']['input']>;
  consumption?: InputMaybe<Scalars['BigFloat']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  shipId?: InputMaybe<Scalars['ShipId']['input']>;
  speed?: InputMaybe<Scalars['BigFloat']['input']>;
  tag?: InputMaybe<VesselSpeedTag>;
  type?: InputMaybe<VesselSpeedType>;
};

/** A connection to a list of `VesselSpeedConsumption` values. */
export type VesselSpeedConsumptionsConnection = {
  __typename?: 'VesselSpeedConsumptionsConnection';
  /** A list of edges which contains the `VesselSpeedConsumption` and cursor to aid in pagination. */
  edges: Array<VesselSpeedConsumptionsEdge>;
  /** A list of `VesselSpeedConsumption` objects. */
  nodes: Array<Maybe<VesselSpeedConsumption>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VesselSpeedConsumption` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VesselSpeedConsumption` edge in the connection. */
export type VesselSpeedConsumptionsEdge = {
  __typename?: 'VesselSpeedConsumptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VesselSpeedConsumption` at the end of the edge. */
  node?: Maybe<VesselSpeedConsumption>;
};

/** Methods to use when ordering `VesselSpeedConsumption`. */
export enum VesselSpeedConsumptionsOrderBy {
  AREA_ASC = 'AREA_ASC',
  AREA_DESC = 'AREA_DESC',
  BUNKER_GRADE_ID_ASC = 'BUNKER_GRADE_ID_ASC',
  BUNKER_GRADE_ID_DESC = 'BUNKER_GRADE_ID_DESC',
  CONSUMPTION_ASC = 'CONSUMPTION_ASC',
  CONSUMPTION_DESC = 'CONSUMPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIP_ID_ASC = 'SHIP_ID_ASC',
  SHIP_ID_DESC = 'SHIP_ID_DESC',
  SPEED_ASC = 'SPEED_ASC',
  SPEED_DESC = 'SPEED_DESC',
  TAG_ASC = 'TAG_ASC',
  TAG_DESC = 'TAG_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export enum VesselSpeedTag {
  DEFAULT = 'DEFAULT',
  DISCHARGING = 'DISCHARGING',
  ECO = 'ECO',
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  MAX = 'MAX'
}

/** A filter to be used against VesselSpeedTag fields. All fields are combined with a logical ‘and.’ */
export type VesselSpeedTagFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VesselSpeedTag>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VesselSpeedTag>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VesselSpeedTag>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VesselSpeedTag>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VesselSpeedTag>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VesselSpeedTag>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VesselSpeedTag>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VesselSpeedTag>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VesselSpeedTag>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VesselSpeedTag>>;
};

export enum VesselSpeedType {
  BALLAST = 'BALLAST',
  LADEN = 'LADEN',
  PORT = 'PORT'
}

/** A filter to be used against VesselSpeedType fields. All fields are combined with a logical ‘and.’ */
export type VesselSpeedTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VesselSpeedType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VesselSpeedType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VesselSpeedType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VesselSpeedType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VesselSpeedType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VesselSpeedType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VesselSpeedType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VesselSpeedType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VesselSpeedType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VesselSpeedType>>;
};

export enum VolumeUnits {
  DT = 'DT',
  FT_3 = 'FT_3',
  FT_UK = 'FT_UK',
  FT_US = 'FT_US',
  GRT = 'GRT',
  LCBM = 'LCBM',
  LITER = 'LITER',
  M_3 = 'M_3',
  M_3_RW = 'M_3_RW',
  M_3_TO = 'M_3_TO',
  SCBM_OB = 'SCBM_OB',
  SCBM_UB = 'SCBM_UB',
  TEU = 'TEU'
}

/** A filter to be used against VolumeUnits fields. All fields are combined with a logical ‘and.’ */
export type VolumeUnitsFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VolumeUnits>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VolumeUnits>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VolumeUnits>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VolumeUnits>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VolumeUnits>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VolumeUnits>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VolumeUnits>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VolumeUnits>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VolumeUnits>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VolumeUnits>>;
};

export type Voyage = Node & {
  __typename?: 'Voyage';
  /** Reads and enables pagination through a set of `Chat`. */
  chatsByVoyageId: ChatsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByVoyageId: FilesConnection;
  id: Scalars['VoyageId']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `NotificationReceiver`. */
  notificationReceiversByVoyageId: NotificationReceiversConnection;
  organisationId: Scalars['OrganizationId']['output'];
  /** Reads a single `Organization` that is related to this `Voyage`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Ship` that is related to this `Voyage`. */
  shipByVesselId?: Maybe<Ship>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads and enables pagination through a set of `VoyageAssociation`. */
  voyageAssociationsByVoyageId: VoyageAssociationsConnection;
};


export type VoyageChatsByVoyageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChatCondition>;
  filter?: InputMaybe<ChatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChatsOrderBy>>;
};


export type VoyageFilesByVoyageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};


export type VoyageNotificationReceiversByVoyageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationReceiverCondition>;
  filter?: InputMaybe<NotificationReceiverFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationReceiversOrderBy>>;
};


export type VoyageVoyageAssociationsByVoyageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageAssociationCondition>;
  filter?: InputMaybe<VoyageAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageAssociationsOrderBy>>;
};

export type VoyageAssociation = Node & {
  __typename?: 'VoyageAssociation';
  id: Scalars['VoyageAssociationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Order` that is related to this `VoyageAssociation`. */
  orderByOrderId?: Maybe<Order>;
  orderId: Scalars['OrderId']['output'];
  /** Reads a single `Voyage` that is related to this `VoyageAssociation`. */
  voyageByVoyageId?: Maybe<Voyage>;
  voyageId: Scalars['VoyageId']['output'];
};

/**
 * A condition to be used against `VoyageAssociation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VoyageAssociationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageAssociationId']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  /** Checks for equality with the object’s `voyageId` field. */
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** A filter to be used against `VoyageAssociation` object types. All fields are combined with a logical ‘and.’ */
export type VoyageAssociationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageAssociationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageAssociationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageAssociationFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageId` field. */
  voyageId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageAssociation` */
export type VoyageAssociationInput = {
  orderId: Scalars['OrderId']['input'];
  voyageId: Scalars['VoyageId']['input'];
};

/** Represents an update to a `VoyageAssociation`. Fields that are set will be updated. */
export type VoyageAssociationPatch = {
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
  voyageId?: InputMaybe<Scalars['VoyageId']['input']>;
};

/** A connection to a list of `VoyageAssociation` values. */
export type VoyageAssociationsConnection = {
  __typename?: 'VoyageAssociationsConnection';
  /** A list of edges which contains the `VoyageAssociation` and cursor to aid in pagination. */
  edges: Array<VoyageAssociationsEdge>;
  /** A list of `VoyageAssociation` objects. */
  nodes: Array<Maybe<VoyageAssociation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageAssociation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageAssociation` edge in the connection. */
export type VoyageAssociationsEdge = {
  __typename?: 'VoyageAssociationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageAssociation` at the end of the edge. */
  node?: Maybe<VoyageAssociation>;
};

/** Methods to use when ordering `VoyageAssociation`. */
export enum VoyageAssociationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VOYAGE_ID_ASC = 'VOYAGE_ID_ASC',
  VOYAGE_ID_DESC = 'VOYAGE_ID_DESC'
}

export type VoyageAttribute = Node & {
  __typename?: 'VoyageAttribute';
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['VoyageAttributeId']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VoyageAttribute`. */
  organizationByOrganizationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageAttribute`. */
  organizationByRootOrg?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads and enables pagination through a set of `Shipment`. */
  shipmentsByVoyageAttributeId: ShipmentsConnection;
};


export type VoyageAttributeShipmentsByVoyageAttributeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipmentCondition>;
  filter?: InputMaybe<ShipmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipmentsOrderBy>>;
};

/**
 * A condition to be used against `VoyageAttribute` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VoyageAttributeCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageAttributeId']['input']>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `VoyageAttribute` object types. All fields are combined with a logical ‘and.’ */
export type VoyageAttributeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageAttributeFilter>>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageAttributeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageAttributeFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageAttribute` */
export type VoyageAttributeInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['OrganizationId']['input'];
};

/** Represents an update to a `VoyageAttribute`. Fields that are set will be updated. */
export type VoyageAttributePatch = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

export type VoyageAttributeSubscriptionPayload = {
  __typename?: 'VoyageAttributeSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  voyageAttribute?: Maybe<VoyageAttribute>;
};

/** A connection to a list of `VoyageAttribute` values. */
export type VoyageAttributesConnection = {
  __typename?: 'VoyageAttributesConnection';
  /** A list of edges which contains the `VoyageAttribute` and cursor to aid in pagination. */
  edges: Array<VoyageAttributesEdge>;
  /** A list of `VoyageAttribute` objects. */
  nodes: Array<Maybe<VoyageAttribute>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageAttribute` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageAttribute` edge in the connection. */
export type VoyageAttributesEdge = {
  __typename?: 'VoyageAttributesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageAttribute` at the end of the edge. */
  node?: Maybe<VoyageAttribute>;
};

/** Methods to use when ordering `VoyageAttribute`. */
export enum VoyageAttributesOrderBy {
  COLOR_ASC = 'COLOR_ASC',
  COLOR_DESC = 'COLOR_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_ACTIVE_ASC = 'IS_ACTIVE_ASC',
  IS_ACTIVE_DESC = 'IS_ACTIVE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type VoyageCalculation = {
  __typename?: 'VoyageCalculation';
  averageEngineLoad: ResultResponseDouble;
  averageRpm: ResultResponseDouble;
  averageSpeed: Scalars['Float']['output'];
  beaufortDistribution: BeaufortDistribution;
  distance: Scalars['Float']['output'];
  distanceWithinECA: Scalars['Float']['output'];
  duration: Scalars['Float']['output'];
  durationWithinECA: Scalars['Float']['output'];
  emissions: Emissions;
  fuelConsumption: ResultResponseDouble;
  fuelConsumptionBreakdown?: Maybe<FuelConsumptionBreakdown>;
  legs: Array<CalculatedLeg>;
  waypoints?: Maybe<Array<Maybe<Waypoint>>>;
};

export type VoyageCalculationConstraints = {
  maximumWaveHeight?: InputMaybe<Scalars['Float']['input']>;
};

export type VoyageCharter = Node & {
  __typename?: 'VoyageCharter';
  /** Reads and enables pagination through a set of `ActualCost`. */
  actualCostsByVoyageCharterId: ActualCostsConnection;
  /** Reads and enables pagination through a set of `BillOfLading`. */
  billOfLadingsByVoyageCharterId: BillOfLadingsConnection;
  cancelling?: Maybe<Scalars['Datetime']['output']>;
  chartererOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `Commission`. */
  commissionsByVoyageCharterId: CommissionsConnection;
  currency?: Maybe<Currency>;
  /** Created from template, delete on unassign */
  deleteOnUnassign: Scalars['Boolean']['output'];
  demurrage?: Maybe<Scalars['BigFloat']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  extraInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['VoyageCharterId']['output'];
  /** Reads and enables pagination through a set of `Invoice`. */
  invoicesByVoyageCharterId: InvoicesConnection;
  isInquiry: Scalars['Boolean']['output'];
  /** If true the voyage charter is considered COA preliminary */
  isPreliminary: Scalars['Boolean']['output'];
  /** If true the voyage charter is considered a template for creating future contracts */
  isTemplate: Scalars['Boolean']['output'];
  layday?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `LaytimeResponsibility`. */
  laytimeResponsibilitiesByVoyageCharterId: LaytimeResponsibilitiesConnection;
  /** Reads a single `LostContract` that is related to this `VoyageCharter`. */
  lostContractByLostContractsId?: Maybe<LostContract>;
  lostContractsId?: Maybe<Scalars['LostContractId']['output']>;
  /** Total lumpsum value for voyage charter. If present then voyage_charter_order_freight are ignored */
  lumpsum?: Maybe<Scalars['BigFloat']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  onSubsUntil?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `OrderVoyageCharterRelation`. */
  orderVoyageCharterRelationsByVoyageCharterId: OrderVoyageCharterRelationsConnection;
  organisationId: Scalars['OrganizationId']['output'];
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByOrganisationId?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads a single `Organization` that is related to this `VoyageCharter`. */
  organizationByShipownerOrgId?: Maybe<Organization>;
  paymentTime?: Maybe<Scalars['Int']['output']>;
  paymentTrigger?: Maybe<PaymentTrigger>;
  paymentType?: Maybe<PaymentType>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Reads a single `Ship` that is related to this `VoyageCharter`. */
  shipByVesselId?: Maybe<Ship>;
  shipownerOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `SpotNegotiation`. */
  spotNegotiationsByVoyageCharterId: SpotNegotiationsConnection;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `VoyageCharter`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads and enables pagination through a set of `VoyageCharterExtraCost`. */
  voyageCharterExtraCostsByVoyageCharterId: VoyageCharterExtraCostsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterExtraFreight`. */
  voyageCharterExtraFreightsByVoyageCharterId: VoyageCharterExtraFreightsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterHistory`. */
  voyageCharterHistoriesById: VoyageCharterHistoriesConnection;
  /** Reads and enables pagination through a set of `VoyageCharterPortCost`. */
  voyageCharterPortCostsByVoyageCharterId: VoyageCharterPortCostsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterPortDatum`. */
  voyageCharterPortDataByVoyageCharterId: VoyageCharterPortDataConnection;
  /** Reads and enables pagination through a set of `VoyageCharterToContract`. */
  voyageCharterToContractsByVoyageCharterId: VoyageCharterToContractsConnection;
  /** Reads and enables pagination through a set of `VoyageCharterUpdate`. */
  voyageCharterUpdatesByVoyageCharterId: VoyageCharterUpdatesConnection;
};


export type VoyageCharterActualCostsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActualCostCondition>;
  filter?: InputMaybe<ActualCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActualCostsOrderBy>>;
};


export type VoyageCharterBillOfLadingsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillOfLadingCondition>;
  filter?: InputMaybe<BillOfLadingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOfLadingsOrderBy>>;
};


export type VoyageCharterCommissionsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CommissionCondition>;
  filter?: InputMaybe<CommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommissionsOrderBy>>;
};


export type VoyageCharterInvoicesByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InvoiceCondition>;
  filter?: InputMaybe<InvoiceFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
};


export type VoyageCharterLaytimeResponsibilitiesByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LaytimeResponsibilityCondition>;
  filter?: InputMaybe<LaytimeResponsibilityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LaytimeResponsibilitiesOrderBy>>;
};


export type VoyageCharterOrderVoyageCharterRelationsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrderVoyageCharterRelationCondition>;
  filter?: InputMaybe<OrderVoyageCharterRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderVoyageCharterRelationsOrderBy>>;
};


export type VoyageCharterSpotNegotiationsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SpotNegotiationCondition>;
  filter?: InputMaybe<SpotNegotiationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SpotNegotiationsOrderBy>>;
};


export type VoyageCharterVoyageCharterExtraCostsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterExtraCostCondition>;
  filter?: InputMaybe<VoyageCharterExtraCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterExtraCostsOrderBy>>;
};


export type VoyageCharterVoyageCharterExtraFreightsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterExtraFreightCondition>;
  filter?: InputMaybe<VoyageCharterExtraFreightFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterExtraFreightsOrderBy>>;
};


export type VoyageCharterVoyageCharterHistoriesByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterHistoryCondition>;
  filter?: InputMaybe<VoyageCharterHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterHistoriesOrderBy>>;
};


export type VoyageCharterVoyageCharterPortCostsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortCostCondition>;
  filter?: InputMaybe<VoyageCharterPortCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortCostsOrderBy>>;
};


export type VoyageCharterVoyageCharterPortDataByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterPortDatumCondition>;
  filter?: InputMaybe<VoyageCharterPortDatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterPortDataOrderBy>>;
};


export type VoyageCharterVoyageCharterToContractsByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterToContractCondition>;
  filter?: InputMaybe<VoyageCharterToContractFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterToContractsOrderBy>>;
};


export type VoyageCharterVoyageCharterUpdatesByVoyageCharterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VoyageCharterUpdateCondition>;
  filter?: InputMaybe<VoyageCharterUpdateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoyageCharterUpdatesOrderBy>>;
};

/**
 * A condition to be used against `VoyageCharter` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterCondition = {
  /** Checks for equality with the object’s `cancelling` field. */
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `deleteOnUnassign` field. */
  deleteOnUnassign?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `demurrage` field. */
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `extraInfo` field. */
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterId']['input']>;
  /** Checks for equality with the object’s `isInquiry` field. */
  isInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isPreliminary` field. */
  isPreliminary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `isTemplate` field. */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `layday` field. */
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `lostContractsId` field. */
  lostContractsId?: InputMaybe<Scalars['LostContractId']['input']>;
  /** Checks for equality with the object’s `lumpsum` field. */
  lumpsum?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `onSubsUntil` field. */
  onSubsUntil?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `paymentTime` field. */
  paymentTime?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  /** Checks for equality with the object’s `paymentType` field. */
  paymentType?: InputMaybe<PaymentType>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `shipownerOrgId` field. */
  shipownerOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export enum VoyageCharterCostType {
  LUMPSUM = 'LUMPSUM',
  RATE = 'RATE'
}

/** A filter to be used against VoyageCharterCostType fields. All fields are combined with a logical ‘and.’ */
export type VoyageCharterCostTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VoyageCharterCostType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VoyageCharterCostType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VoyageCharterCostType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VoyageCharterCostType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VoyageCharterCostType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VoyageCharterCostType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VoyageCharterCostType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VoyageCharterCostType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VoyageCharterCostType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VoyageCharterCostType>>;
};

export type VoyageCharterExtraCost = Node & {
  __typename?: 'VoyageCharterExtraCost';
  amount: Scalars['BigFloat']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['VoyageCharterExtraCostId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  sysPeriod: DatetimeRange;
  type?: Maybe<VoyageCharterCostType>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterExtraCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId: Scalars['VoyageCharterId']['output'];
};

/**
 * A condition to be used against `VoyageCharterExtraCost` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterExtraCostCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterExtraCostId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<VoyageCharterCostType>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `VoyageCharterExtraCost` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterExtraCostFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterExtraCostFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterExtraCostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterExtraCostFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<VoyageCharterCostTypeFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageCharterExtraCost` */
export type VoyageCharterExtraCostInput = {
  amount: Scalars['BigFloat']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  type?: InputMaybe<VoyageCharterCostType>;
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** Represents an update to a `VoyageCharterExtraCost`. Fields that are set will be updated. */
export type VoyageCharterExtraCostPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  type?: InputMaybe<VoyageCharterCostType>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `VoyageCharterExtraCost` values. */
export type VoyageCharterExtraCostsConnection = {
  __typename?: 'VoyageCharterExtraCostsConnection';
  /** A list of edges which contains the `VoyageCharterExtraCost` and cursor to aid in pagination. */
  edges: Array<VoyageCharterExtraCostsEdge>;
  /** A list of `VoyageCharterExtraCost` objects. */
  nodes: Array<Maybe<VoyageCharterExtraCost>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterExtraCost` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterExtraCost` edge in the connection. */
export type VoyageCharterExtraCostsEdge = {
  __typename?: 'VoyageCharterExtraCostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterExtraCost` at the end of the edge. */
  node?: Maybe<VoyageCharterExtraCost>;
};

/** Methods to use when ordering `VoyageCharterExtraCost`. */
export enum VoyageCharterExtraCostsOrderBy {
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

export type VoyageCharterExtraFreight = Node & {
  __typename?: 'VoyageCharterExtraFreight';
  amount: Scalars['BigFloat']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalLastUpdate?: Maybe<Scalars['Datetime']['output']>;
  externalUpdatedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['VoyageCharterExtraFreightId']['output'];
  /** If true, this extra freight will not be included in P&L calculation, and will be shown in voyage charter form only */
  ignoreInPnl?: Maybe<Scalars['Boolean']['output']>;
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  sysPeriod: DatetimeRange;
  type?: Maybe<FreightType>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterExtraFreight`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId: Scalars['VoyageCharterId']['output'];
};

/**
 * A condition to be used against `VoyageCharterExtraFreight` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterExtraFreightCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalLastUpdate` field. */
  externalLastUpdate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `externalUpdatedBy` field. */
  externalUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterExtraFreightId']['input']>;
  /** Checks for equality with the object’s `ignoreInPnl` field. */
  ignoreInPnl?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<FreightType>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `VoyageCharterExtraFreight` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterExtraFreightFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterExtraFreightFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalLastUpdate` field. */
  externalLastUpdate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `externalUpdatedBy` field. */
  externalUpdatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ignoreInPnl` field. */
  ignoreInPnl?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterExtraFreightFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterExtraFreightFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<FreightTypeFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageCharterExtraFreight` */
export type VoyageCharterExtraFreightInput = {
  amount: Scalars['BigFloat']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['Datetime']['input']>;
  externalUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  /** If true, this extra freight will not be included in P&L calculation, and will be shown in voyage charter form only */
  ignoreInPnl?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  type?: InputMaybe<FreightType>;
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** Represents an update to a `VoyageCharterExtraFreight`. Fields that are set will be updated. */
export type VoyageCharterExtraFreightPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLastUpdate?: InputMaybe<Scalars['Datetime']['input']>;
  externalUpdatedBy?: InputMaybe<Scalars['String']['input']>;
  /** If true, this extra freight will not be included in P&L calculation, and will be shown in voyage charter form only */
  ignoreInPnl?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  type?: InputMaybe<FreightType>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

export type VoyageCharterExtraFreightSubscriptionPayload = {
  __typename?: 'VoyageCharterExtraFreightSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  extraFreight?: Maybe<VoyageCharterExtraFreight>;
};

/** A connection to a list of `VoyageCharterExtraFreight` values. */
export type VoyageCharterExtraFreightsConnection = {
  __typename?: 'VoyageCharterExtraFreightsConnection';
  /** A list of edges which contains the `VoyageCharterExtraFreight` and cursor to aid in pagination. */
  edges: Array<VoyageCharterExtraFreightsEdge>;
  /** A list of `VoyageCharterExtraFreight` objects. */
  nodes: Array<Maybe<VoyageCharterExtraFreight>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterExtraFreight` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterExtraFreight` edge in the connection. */
export type VoyageCharterExtraFreightsEdge = {
  __typename?: 'VoyageCharterExtraFreightsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterExtraFreight` at the end of the edge. */
  node?: Maybe<VoyageCharterExtraFreight>;
};

/** Methods to use when ordering `VoyageCharterExtraFreight`. */
export enum VoyageCharterExtraFreightsOrderBy {
  AMOUNT_ASC = 'AMOUNT_ASC',
  AMOUNT_DESC = 'AMOUNT_DESC',
  DESCRIPTION_ASC = 'DESCRIPTION_ASC',
  DESCRIPTION_DESC = 'DESCRIPTION_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  EXTERNAL_LAST_UPDATE_ASC = 'EXTERNAL_LAST_UPDATE_ASC',
  EXTERNAL_LAST_UPDATE_DESC = 'EXTERNAL_LAST_UPDATE_DESC',
  EXTERNAL_UPDATED_BY_ASC = 'EXTERNAL_UPDATED_BY_ASC',
  EXTERNAL_UPDATED_BY_DESC = 'EXTERNAL_UPDATED_BY_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IGNORE_IN_PNL_ASC = 'IGNORE_IN_PNL_ASC',
  IGNORE_IN_PNL_DESC = 'IGNORE_IN_PNL_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** A filter to be used against `VoyageCharter` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterFilter>>;
  /** Filter by the object’s `cancelling` field. */
  cancelling?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `deleteOnUnassign` field. */
  deleteOnUnassign?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `demurrage` field. */
  demurrage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `extraInfo` field. */
  extraInfo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isInquiry` field. */
  isInquiry?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isPreliminary` field. */
  isPreliminary?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isTemplate` field. */
  isTemplate?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `layday` field. */
  layday?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lostContractsId` field. */
  lostContractsId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lumpsum` field. */
  lumpsum?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterFilter>;
  /** Filter by the object’s `onSubsUntil` field. */
  onSubsUntil?: InputMaybe<DatetimeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentTime` field. */
  paymentTime?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTriggerFilter>;
  /** Filter by the object’s `paymentType` field. */
  paymentType?: InputMaybe<PaymentTypeFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipownerOrgId` field. */
  shipownerOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VoyageCharterHistory` values. */
export type VoyageCharterHistoriesConnection = {
  __typename?: 'VoyageCharterHistoriesConnection';
  /** A list of edges which contains the `VoyageCharterHistory` and cursor to aid in pagination. */
  edges: Array<VoyageCharterHistoriesEdge>;
  /** A list of `VoyageCharterHistory` objects. */
  nodes: Array<Maybe<VoyageCharterHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterHistory` edge in the connection. */
export type VoyageCharterHistoriesEdge = {
  __typename?: 'VoyageCharterHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterHistory` at the end of the edge. */
  node?: Maybe<VoyageCharterHistory>;
};

/** Methods to use when ordering `VoyageCharterHistory`. */
export enum VoyageCharterHistoriesOrderBy {
  CANCELLING_ASC = 'CANCELLING_ASC',
  CANCELLING_DESC = 'CANCELLING_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  COMMISSION_ASC = 'COMMISSION_ASC',
  COMMISSION_DESC = 'COMMISSION_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  DEMURRAGE_ASC = 'DEMURRAGE_ASC',
  DEMURRAGE_DESC = 'DEMURRAGE_DESC',
  EXTRA_INFO_ASC = 'EXTRA_INFO_ASC',
  EXTRA_INFO_DESC = 'EXTRA_INFO_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAYDAY_ASC = 'LAYDAY_ASC',
  LAYDAY_DESC = 'LAYDAY_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PAYMENT_TIME_ASC = 'PAYMENT_TIME_ASC',
  PAYMENT_TIME_DESC = 'PAYMENT_TIME_DESC',
  PAYMENT_TRIGGER_ASC = 'PAYMENT_TRIGGER_ASC',
  PAYMENT_TRIGGER_DESC = 'PAYMENT_TRIGGER_DESC',
  PAYMENT_TYPE_ASC = 'PAYMENT_TYPE_ASC',
  PAYMENT_TYPE_DESC = 'PAYMENT_TYPE_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIPOWNER_ORG_ID_ASC = 'SHIPOWNER_ORG_ID_ASC',
  SHIPOWNER_ORG_ID_DESC = 'SHIPOWNER_ORG_ID_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** History log for voyage_charter table */
export type VoyageCharterHistory = {
  __typename?: 'VoyageCharterHistory';
  cancelling?: Maybe<Scalars['Datetime']['output']>;
  chartererOrgId?: Maybe<Scalars['OrganizationId']['output']>;
  commission?: Maybe<Scalars['BigFloat']['output']>;
  currency?: Maybe<Currency>;
  demurrage?: Maybe<Scalars['BigFloat']['output']>;
  extraInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['VoyageCharterId']['output'];
  layday?: Maybe<Scalars['Datetime']['output']>;
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  organisationId: Scalars['Int']['output'];
  /** Reads a single `Organization` that is related to this `VoyageCharterHistory`. */
  organizationByChartererOrgId?: Maybe<Organization>;
  paymentTime?: Maybe<Scalars['Int']['output']>;
  paymentTrigger?: Maybe<PaymentTrigger>;
  paymentType?: Maybe<PaymentType>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Ship` that is related to this `VoyageCharterHistory`. */
  shipByVesselId?: Maybe<Ship>;
  shipownerOrgId?: Maybe<Scalars['Int']['output']>;
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `VoyageCharterHistory`. */
  userByModifiedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterHistory`. */
  voyageCharterById?: Maybe<VoyageCharter>;
};

/**
 * A condition to be used against `VoyageCharterHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterHistoryCondition = {
  /** Checks for equality with the object’s `cancelling` field. */
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `commission` field. */
  commission?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `demurrage` field. */
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `extraInfo` field. */
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterId']['input']>;
  /** Checks for equality with the object’s `layday` field. */
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `paymentTime` field. */
  paymentTime?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  /** Checks for equality with the object’s `paymentType` field. */
  paymentType?: InputMaybe<PaymentType>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipownerOrgId` field. */
  shipownerOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `VoyageCharterHistory` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterHistoryFilter>>;
  /** Filter by the object’s `cancelling` field. */
  cancelling?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `commission` field. */
  commission?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `demurrage` field. */
  demurrage?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `extraInfo` field. */
  extraInfo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `layday` field. */
  layday?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterHistoryFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentTime` field. */
  paymentTime?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentTrigger` field. */
  paymentTrigger?: InputMaybe<PaymentTriggerFilter>;
  /** Filter by the object’s `paymentType` field. */
  paymentType?: InputMaybe<PaymentTypeFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipownerOrgId` field. */
  shipownerOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageCharter` */
export type VoyageCharterInput = {
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  currency?: InputMaybe<Currency>;
  /** Created from template, delete on unassign */
  deleteOnUnassign?: InputMaybe<Scalars['Boolean']['input']>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  isInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true the voyage charter is considered COA preliminary */
  isPreliminary?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true the voyage charter is considered a template for creating future contracts */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  lostContractsId?: InputMaybe<Scalars['LostContractId']['input']>;
  /** Total lumpsum value for voyage charter. If present then voyage_charter_order_freight are ignored */
  lumpsum?: InputMaybe<Scalars['BigFloat']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onSubsUntil?: InputMaybe<Scalars['Datetime']['input']>;
  organisationId: Scalars['OrganizationId']['input'];
  paymentTime?: InputMaybe<Scalars['Int']['input']>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  paymentType?: InputMaybe<PaymentType>;
  shipownerOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type VoyageCharterOrderFreight = Node & {
  __typename?: 'VoyageCharterOrderFreight';
  freightAmount?: Maybe<Scalars['BigFloat']['output']>;
  freightUnit?: Maybe<PaymentUnit>;
  id: Scalars['VoyageCharterOrderFreightId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OrderVoyageCharterRelation` that is related to this `VoyageCharterOrderFreight`. */
  orderVoyageCharterRelationByOrderVoyageCharterRelationId?: Maybe<OrderVoyageCharterRelation>;
  orderVoyageCharterRelationId: Scalars['OrderVoyageCharterRelationId']['output'];
  /** Reads a single `Organization` that is related to this `VoyageCharterOrderFreight`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg?: Maybe<Scalars['OrganizationId']['output']>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `VoyageCharterOrderFreight`. */
  userByModifiedByUserId?: Maybe<User>;
};

/**
 * A condition to be used against `VoyageCharterOrderFreight` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterOrderFreightCondition = {
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterOrderFreightId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `orderVoyageCharterRelationId` field. */
  orderVoyageCharterRelationId?: InputMaybe<Scalars['OrderVoyageCharterRelationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `VoyageCharterOrderFreight` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterOrderFreightFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterOrderFreightFilter>>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterOrderFreightFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterOrderFreightFilter>>;
  /** Filter by the object’s `orderVoyageCharterRelationId` field. */
  orderVoyageCharterRelationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** A connection to a list of `VoyageCharterOrderFreightHistory` values. */
export type VoyageCharterOrderFreightHistoriesConnection = {
  __typename?: 'VoyageCharterOrderFreightHistoriesConnection';
  /** A list of edges which contains the `VoyageCharterOrderFreightHistory` and cursor to aid in pagination. */
  edges: Array<VoyageCharterOrderFreightHistoriesEdge>;
  /** A list of `VoyageCharterOrderFreightHistory` objects. */
  nodes: Array<Maybe<VoyageCharterOrderFreightHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterOrderFreightHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterOrderFreightHistory` edge in the connection. */
export type VoyageCharterOrderFreightHistoriesEdge = {
  __typename?: 'VoyageCharterOrderFreightHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterOrderFreightHistory` at the end of the edge. */
  node?: Maybe<VoyageCharterOrderFreightHistory>;
};

/** Methods to use when ordering `VoyageCharterOrderFreightHistory`. */
export enum VoyageCharterOrderFreightHistoriesOrderBy {
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_VOYAGE_CHARTER_RELATION_ID_ASC = 'ORDER_VOYAGE_CHARTER_RELATION_ID_ASC',
  ORDER_VOYAGE_CHARTER_RELATION_ID_DESC = 'ORDER_VOYAGE_CHARTER_RELATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC'
}

/** History log for this table */
export type VoyageCharterOrderFreightHistory = {
  __typename?: 'VoyageCharterOrderFreightHistory';
  freightAmount?: Maybe<Scalars['BigFloat']['output']>;
  freightUnit?: Maybe<PaymentUnit>;
  id: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  orderVoyageCharterRelationId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  sysPeriod: DatetimeRange;
};

/**
 * A condition to be used against `VoyageCharterOrderFreightHistory` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterOrderFreightHistoryCondition = {
  /** Checks for equality with the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnit>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderVoyageCharterRelationId` field. */
  orderVoyageCharterRelationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `VoyageCharterOrderFreightHistory` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterOrderFreightHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterOrderFreightHistoryFilter>>;
  /** Filter by the object’s `freightAmount` field. */
  freightAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `freightUnit` field. */
  freightUnit?: InputMaybe<PaymentUnitFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterOrderFreightHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterOrderFreightHistoryFilter>>;
  /** Filter by the object’s `orderVoyageCharterRelationId` field. */
  orderVoyageCharterRelationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** An input for mutations affecting `VoyageCharterOrderFreight` */
export type VoyageCharterOrderFreightInput = {
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightUnit?: InputMaybe<PaymentUnit>;
  orderVoyageCharterRelationId: Scalars['OrderVoyageCharterRelationId']['input'];
};

/** Represents an update to a `VoyageCharterOrderFreight`. Fields that are set will be updated. */
export type VoyageCharterOrderFreightPatch = {
  freightAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  freightUnit?: InputMaybe<PaymentUnit>;
  orderVoyageCharterRelationId?: InputMaybe<Scalars['OrderVoyageCharterRelationId']['input']>;
};

/** A connection to a list of `VoyageCharterOrderFreight` values. */
export type VoyageCharterOrderFreightsConnection = {
  __typename?: 'VoyageCharterOrderFreightsConnection';
  /** A list of edges which contains the `VoyageCharterOrderFreight` and cursor to aid in pagination. */
  edges: Array<VoyageCharterOrderFreightsEdge>;
  /** A list of `VoyageCharterOrderFreight` objects. */
  nodes: Array<Maybe<VoyageCharterOrderFreight>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterOrderFreight` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterOrderFreight` edge in the connection. */
export type VoyageCharterOrderFreightsEdge = {
  __typename?: 'VoyageCharterOrderFreightsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterOrderFreight` at the end of the edge. */
  node?: Maybe<VoyageCharterOrderFreight>;
};

/** Methods to use when ordering `VoyageCharterOrderFreight`. */
export enum VoyageCharterOrderFreightsOrderBy {
  FREIGHT_AMOUNT_ASC = 'FREIGHT_AMOUNT_ASC',
  FREIGHT_AMOUNT_DESC = 'FREIGHT_AMOUNT_DESC',
  FREIGHT_UNIT_ASC = 'FREIGHT_UNIT_ASC',
  FREIGHT_UNIT_DESC = 'FREIGHT_UNIT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_VOYAGE_CHARTER_RELATION_ID_ASC = 'ORDER_VOYAGE_CHARTER_RELATION_ID_ASC',
  ORDER_VOYAGE_CHARTER_RELATION_ID_DESC = 'ORDER_VOYAGE_CHARTER_RELATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC'
}

/** Represents an update to a `VoyageCharter`. Fields that are set will be updated. */
export type VoyageCharterPatch = {
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  chartererOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  currency?: InputMaybe<Currency>;
  /** Created from template, delete on unassign */
  deleteOnUnassign?: InputMaybe<Scalars['Boolean']['input']>;
  demurrage?: InputMaybe<Scalars['BigFloat']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  isInquiry?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true the voyage charter is considered COA preliminary */
  isPreliminary?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true the voyage charter is considered a template for creating future contracts */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  lostContractsId?: InputMaybe<Scalars['LostContractId']['input']>;
  /** Total lumpsum value for voyage charter. If present then voyage_charter_order_freight are ignored */
  lumpsum?: InputMaybe<Scalars['BigFloat']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onSubsUntil?: InputMaybe<Scalars['Datetime']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  paymentTime?: InputMaybe<Scalars['Int']['input']>;
  paymentTrigger?: InputMaybe<PaymentTrigger>;
  paymentType?: InputMaybe<PaymentType>;
  shipownerOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type VoyageCharterPortCost = Node & {
  __typename?: 'VoyageCharterPortCost';
  id: Scalars['VoyageCharterPortCostId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `PortCost` that is related to this `VoyageCharterPortCost`. */
  portCostByPortCostId?: Maybe<PortCost>;
  portCostId: Scalars['PortCostId']['output'];
  /** Root organization from the current session */
  rootOrg: Scalars['Int']['output'];
  sysPeriod: DatetimeRange;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterPortCost`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId: Scalars['VoyageCharterId']['output'];
};

/**
 * A condition to be used against `VoyageCharterPortCost` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterPortCostCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterPortCostId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portCostId` field. */
  portCostId?: InputMaybe<Scalars['PortCostId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `VoyageCharterPortCost` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterPortCostFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterPortCostFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterPortCostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterPortCostFilter>>;
  /** Filter by the object’s `portCostId` field. */
  portCostId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageCharterPortCost` */
export type VoyageCharterPortCostInput = {
  portCostId: Scalars['PortCostId']['input'];
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** Represents an update to a `VoyageCharterPortCost`. Fields that are set will be updated. */
export type VoyageCharterPortCostPatch = {
  portCostId?: InputMaybe<Scalars['PortCostId']['input']>;
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `VoyageCharterPortCost` values. */
export type VoyageCharterPortCostsConnection = {
  __typename?: 'VoyageCharterPortCostsConnection';
  /** A list of edges which contains the `VoyageCharterPortCost` and cursor to aid in pagination. */
  edges: Array<VoyageCharterPortCostsEdge>;
  /** A list of `VoyageCharterPortCost` objects. */
  nodes: Array<Maybe<VoyageCharterPortCost>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterPortCost` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterPortCost` edge in the connection. */
export type VoyageCharterPortCostsEdge = {
  __typename?: 'VoyageCharterPortCostsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterPortCost` at the end of the edge. */
  node?: Maybe<VoyageCharterPortCost>;
};

/** Methods to use when ordering `VoyageCharterPortCost`. */
export enum VoyageCharterPortCostsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PORT_COST_ID_ASC = 'PORT_COST_ID_ASC',
  PORT_COST_ID_DESC = 'PORT_COST_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** A connection to a list of `VoyageCharterPortDatum` values. */
export type VoyageCharterPortDataConnection = {
  __typename?: 'VoyageCharterPortDataConnection';
  /** A list of edges which contains the `VoyageCharterPortDatum` and cursor to aid in pagination. */
  edges: Array<VoyageCharterPortDataEdge>;
  /** A list of `VoyageCharterPortDatum` objects. */
  nodes: Array<Maybe<VoyageCharterPortDatum>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterPortDatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterPortDatum` edge in the connection. */
export type VoyageCharterPortDataEdge = {
  __typename?: 'VoyageCharterPortDataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterPortDatum` at the end of the edge. */
  node?: Maybe<VoyageCharterPortDatum>;
};

/** A connection to a list of `VoyageCharterPortDataHistory` values. */
export type VoyageCharterPortDataHistoriesConnection = {
  __typename?: 'VoyageCharterPortDataHistoriesConnection';
  /** A list of edges which contains the `VoyageCharterPortDataHistory` and cursor to aid in pagination. */
  edges: Array<VoyageCharterPortDataHistoriesEdge>;
  /** A list of `VoyageCharterPortDataHistory` objects. */
  nodes: Array<Maybe<VoyageCharterPortDataHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterPortDataHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterPortDataHistory` edge in the connection. */
export type VoyageCharterPortDataHistoriesEdge = {
  __typename?: 'VoyageCharterPortDataHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterPortDataHistory` at the end of the edge. */
  node?: Maybe<VoyageCharterPortDataHistory>;
};

/** Methods to use when ordering `VoyageCharterPortDataHistory`. */
export enum VoyageCharterPortDataHistoriesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PORT_DATA_ID_ASC = 'PORT_DATA_ID_ASC',
  PORT_DATA_ID_DESC = 'PORT_DATA_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** History log for this table */
export type VoyageCharterPortDataHistory = {
  __typename?: 'VoyageCharterPortDataHistory';
  id: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  portDataId: Scalars['Int']['output'];
  rootOrg?: Maybe<Scalars['Int']['output']>;
  sysPeriod: DatetimeRange;
  voyageCharterId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `VoyageCharterPortDataHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterPortDataHistoryCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portDataId` field. */
  portDataId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VoyageCharterPortDataHistory` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterPortDataHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterPortDataHistoryFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterPortDataHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterPortDataHistoryFilter>>;
  /** Filter by the object’s `portDataId` field. */
  portDataId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** Methods to use when ordering `VoyageCharterPortDatum`. */
export enum VoyageCharterPortDataOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PORT_DATA_ID_ASC = 'PORT_DATA_ID_ASC',
  PORT_DATA_ID_DESC = 'PORT_DATA_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

export type VoyageCharterPortDatum = Node & {
  __typename?: 'VoyageCharterPortDatum';
  id: Scalars['VoyageCharterPortDatumId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VoyageCharterPortDatum`. */
  organizationByRootOrg?: Maybe<Organization>;
  portDataId: Scalars['PortDatumId']['output'];
  /** Reads a single `PortDatum` that is related to this `VoyageCharterPortDatum`. */
  portDatumByPortDataId?: Maybe<PortDatum>;
  /** Root organization from the current session */
  rootOrg: Scalars['OrganizationId']['output'];
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `VoyageCharterPortDatum`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterPortDatum`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId: Scalars['VoyageCharterId']['output'];
};

/**
 * A condition to be used against `VoyageCharterPortDatum` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterPortDatumCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterPortDatumId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `portDataId` field. */
  portDataId?: InputMaybe<Scalars['PortDatumId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `VoyageCharterPortDatum` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterPortDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterPortDatumFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterPortDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterPortDatumFilter>>;
  /** Filter by the object’s `portDataId` field. */
  portDataId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageCharterPortDatum` */
export type VoyageCharterPortDatumInput = {
  portDataId: Scalars['PortDatumId']['input'];
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** Represents an update to a `VoyageCharterPortDatum`. Fields that are set will be updated. */
export type VoyageCharterPortDatumPatch = {
  portDataId?: InputMaybe<Scalars['PortDatumId']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

export type VoyageCharterToContract = Node & {
  __typename?: 'VoyageCharterToContract';
  /** Reads a single `CoaContract` that is related to this `VoyageCharterToContract`. */
  coaContractByCoaId?: Maybe<CoaContract>;
  coaId?: Maybe<Scalars['CoaContractId']['output']>;
  id: Scalars['VoyageCharterToContractId']['output'];
  /** Session id that added or modified the record */
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  /** User that added or modified the record */
  modifiedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VoyageCharterToContract`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Root organization from the current session */
  rootOrg?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `SpotNegotiation` that is related to this `VoyageCharterToContract`. */
  spotNegotiationBySpotNegotiationId?: Maybe<SpotNegotiation>;
  spotNegotiationId?: Maybe<Scalars['SpotNegotiationId']['output']>;
  /** Timestamp of the record change */
  sysPeriod: DatetimeRange;
  /** Reads a single `User` that is related to this `VoyageCharterToContract`. */
  userByModifiedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VoyageCharterToContract`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UserId']['output'];
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterToContract`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId: Scalars['VoyageCharterId']['output'];
};

/**
 * A condition to be used against `VoyageCharterToContract` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterToContractCondition = {
  /** Checks for equality with the object’s `coaId` field. */
  coaId?: InputMaybe<Scalars['CoaContractId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterToContractId']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `spotNegotiationId` field. */
  spotNegotiationId?: InputMaybe<Scalars['SpotNegotiationId']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `VoyageCharterToContract` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterToContractFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterToContractFilter>>;
  /** Filter by the object’s `coaId` field. */
  coaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterToContractFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterToContractFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `spotNegotiationId` field. */
  spotNegotiationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VoyageCharterToContractHistory` values. */
export type VoyageCharterToContractHistoriesConnection = {
  __typename?: 'VoyageCharterToContractHistoriesConnection';
  /** A list of edges which contains the `VoyageCharterToContractHistory` and cursor to aid in pagination. */
  edges: Array<VoyageCharterToContractHistoriesEdge>;
  /** A list of `VoyageCharterToContractHistory` objects. */
  nodes: Array<Maybe<VoyageCharterToContractHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterToContractHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterToContractHistory` edge in the connection. */
export type VoyageCharterToContractHistoriesEdge = {
  __typename?: 'VoyageCharterToContractHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterToContractHistory` at the end of the edge. */
  node?: Maybe<VoyageCharterToContractHistory>;
};

/** Methods to use when ordering `VoyageCharterToContractHistory`. */
export enum VoyageCharterToContractHistoriesOrderBy {
  COA_ID_ASC = 'COA_ID_ASC',
  COA_ID_DESC = 'COA_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SPOT_NEGOTIATION_ID_ASC = 'SPOT_NEGOTIATION_ID_ASC',
  SPOT_NEGOTIATION_ID_DESC = 'SPOT_NEGOTIATION_ID_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  TC_ID_ASC = 'TC_ID_ASC',
  TC_ID_DESC = 'TC_ID_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** History log for this table */
export type VoyageCharterToContractHistory = {
  __typename?: 'VoyageCharterToContractHistory';
  coaId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  modifiedBySessionId?: Maybe<Scalars['Int']['output']>;
  modifiedByUserId?: Maybe<Scalars['Int']['output']>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  spotNegotiationId?: Maybe<Scalars['Int']['output']>;
  sysPeriod: DatetimeRange;
  tcId?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['Int']['output'];
  voyageCharterId: Scalars['Int']['output'];
};

/**
 * A condition to be used against `VoyageCharterToContractHistory` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterToContractHistoryCondition = {
  /** Checks for equality with the object’s `coaId` field. */
  coaId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `spotNegotiationId` field. */
  spotNegotiationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `tcId` field. */
  tcId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VoyageCharterToContractHistory` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterToContractHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterToContractHistoryFilter>>;
  /** Filter by the object’s `coaId` field. */
  coaId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedBySessionId` field. */
  modifiedBySessionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modifiedByUserId` field. */
  modifiedByUserId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterToContractHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterToContractHistoryFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `spotNegotiationId` field. */
  spotNegotiationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `tcId` field. */
  tcId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageCharterToContract` */
export type VoyageCharterToContractInput = {
  coaId?: InputMaybe<Scalars['CoaContractId']['input']>;
  spotNegotiationId?: InputMaybe<Scalars['SpotNegotiationId']['input']>;
  userId: Scalars['UserId']['input'];
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** Represents an update to a `VoyageCharterToContract`. Fields that are set will be updated. */
export type VoyageCharterToContractPatch = {
  coaId?: InputMaybe<Scalars['CoaContractId']['input']>;
  spotNegotiationId?: InputMaybe<Scalars['SpotNegotiationId']['input']>;
  userId?: InputMaybe<Scalars['UserId']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `VoyageCharterToContract` values. */
export type VoyageCharterToContractsConnection = {
  __typename?: 'VoyageCharterToContractsConnection';
  /** A list of edges which contains the `VoyageCharterToContract` and cursor to aid in pagination. */
  edges: Array<VoyageCharterToContractsEdge>;
  /** A list of `VoyageCharterToContract` objects. */
  nodes: Array<Maybe<VoyageCharterToContract>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterToContract` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterToContract` edge in the connection. */
export type VoyageCharterToContractsEdge = {
  __typename?: 'VoyageCharterToContractsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterToContract` at the end of the edge. */
  node?: Maybe<VoyageCharterToContract>;
};

/** Methods to use when ordering `VoyageCharterToContract`. */
export enum VoyageCharterToContractsOrderBy {
  COA_ID_ASC = 'COA_ID_ASC',
  COA_ID_DESC = 'COA_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SPOT_NEGOTIATION_ID_ASC = 'SPOT_NEGOTIATION_ID_ASC',
  SPOT_NEGOTIATION_ID_DESC = 'SPOT_NEGOTIATION_ID_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

export type VoyageCharterUpdate = Node & {
  __typename?: 'VoyageCharterUpdate';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  cancelling?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdByOrgId: Scalars['OrganizationId']['output'];
  createdByUserId: Scalars['UserId']['output'];
  id: Scalars['VoyageCharterUpdateId']['output'];
  layday?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VoyageCharterUpdate`. */
  organizationByCreatedByOrgId?: Maybe<Organization>;
  rejectedByUserId?: Maybe<Scalars['UserId']['output']>;
  /** Reads a single `Ship` that is related to this `VoyageCharterUpdate`. */
  shipByVesselId?: Maybe<Ship>;
  /** Reads a single `User` that is related to this `VoyageCharterUpdate`. */
  userByCreatedByUserId?: Maybe<User>;
  /** Reads a single `User` that is related to this `VoyageCharterUpdate`. */
  userByRejectedByUserId?: Maybe<User>;
  vesselId?: Maybe<Scalars['ShipId']['output']>;
  /** Reads a single `VoyageCharter` that is related to this `VoyageCharterUpdate`. */
  voyageCharterByVoyageCharterId?: Maybe<VoyageCharter>;
  voyageCharterId: Scalars['VoyageCharterId']['output'];
};

/**
 * A condition to be used against `VoyageCharterUpdate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VoyageCharterUpdateCondition = {
  /** Checks for equality with the object’s `accepted` field. */
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `cancelling` field. */
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdByOrgId` field. */
  createdByOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageCharterUpdateId']['input']>;
  /** Checks for equality with the object’s `layday` field. */
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `rejectedByUserId` field. */
  rejectedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  /** Checks for equality with the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A filter to be used against `VoyageCharterUpdate` object types. All fields are combined with a logical ‘and.’ */
export type VoyageCharterUpdateFilter = {
  /** Filter by the object’s `accepted` field. */
  accepted?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageCharterUpdateFilter>>;
  /** Filter by the object’s `cancelling` field. */
  cancelling?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdByOrgId` field. */
  createdByOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdByUserId` field. */
  createdByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `layday` field. */
  layday?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageCharterUpdateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageCharterUpdateFilter>>;
  /** Filter by the object’s `rejectedByUserId` field. */
  rejectedByUserId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `voyageCharterId` field. */
  voyageCharterId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageCharterUpdate` */
export type VoyageCharterUpdateInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  rejectedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  voyageCharterId: Scalars['VoyageCharterId']['input'];
};

/** Represents an update to a `VoyageCharterUpdate`. Fields that are set will be updated. */
export type VoyageCharterUpdatePatch = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByOrgId?: InputMaybe<Scalars['OrganizationId']['input']>;
  createdByUserId?: InputMaybe<Scalars['UserId']['input']>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  rejectedByUserId?: InputMaybe<Scalars['UserId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
  voyageCharterId?: InputMaybe<Scalars['VoyageCharterId']['input']>;
};

/** A connection to a list of `VoyageCharterUpdate` values. */
export type VoyageCharterUpdatesConnection = {
  __typename?: 'VoyageCharterUpdatesConnection';
  /** A list of edges which contains the `VoyageCharterUpdate` and cursor to aid in pagination. */
  edges: Array<VoyageCharterUpdatesEdge>;
  /** A list of `VoyageCharterUpdate` objects. */
  nodes: Array<Maybe<VoyageCharterUpdate>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharterUpdate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharterUpdate` edge in the connection. */
export type VoyageCharterUpdatesEdge = {
  __typename?: 'VoyageCharterUpdatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharterUpdate` at the end of the edge. */
  node?: Maybe<VoyageCharterUpdate>;
};

/** Methods to use when ordering `VoyageCharterUpdate`. */
export enum VoyageCharterUpdatesOrderBy {
  ACCEPTED_ASC = 'ACCEPTED_ASC',
  ACCEPTED_DESC = 'ACCEPTED_DESC',
  CANCELLING_ASC = 'CANCELLING_ASC',
  CANCELLING_DESC = 'CANCELLING_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_BY_ORG_ID_ASC = 'CREATED_BY_ORG_ID_ASC',
  CREATED_BY_ORG_ID_DESC = 'CREATED_BY_ORG_ID_DESC',
  CREATED_BY_USER_ID_ASC = 'CREATED_BY_USER_ID_ASC',
  CREATED_BY_USER_ID_DESC = 'CREATED_BY_USER_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAYDAY_ASC = 'LAYDAY_ASC',
  LAYDAY_DESC = 'LAYDAY_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  REJECTED_BY_USER_ID_ASC = 'REJECTED_BY_USER_ID_ASC',
  REJECTED_BY_USER_ID_DESC = 'REJECTED_BY_USER_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC',
  VOYAGE_CHARTER_ID_ASC = 'VOYAGE_CHARTER_ID_ASC',
  VOYAGE_CHARTER_ID_DESC = 'VOYAGE_CHARTER_ID_DESC'
}

/** A connection to a list of `VoyageCharter` values. */
export type VoyageChartersConnection = {
  __typename?: 'VoyageChartersConnection';
  /** A list of edges which contains the `VoyageCharter` and cursor to aid in pagination. */
  edges: Array<VoyageChartersEdge>;
  /** A list of `VoyageCharter` objects. */
  nodes: Array<Maybe<VoyageCharter>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageCharter` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageCharter` edge in the connection. */
export type VoyageChartersEdge = {
  __typename?: 'VoyageChartersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageCharter` at the end of the edge. */
  node?: Maybe<VoyageCharter>;
};

/** Methods to use when ordering `VoyageCharter`. */
export enum VoyageChartersOrderBy {
  CANCELLING_ASC = 'CANCELLING_ASC',
  CANCELLING_DESC = 'CANCELLING_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  DELETE_ON_UNASSIGN_ASC = 'DELETE_ON_UNASSIGN_ASC',
  DELETE_ON_UNASSIGN_DESC = 'DELETE_ON_UNASSIGN_DESC',
  DEMURRAGE_ASC = 'DEMURRAGE_ASC',
  DEMURRAGE_DESC = 'DEMURRAGE_DESC',
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  EXTRA_INFO_ASC = 'EXTRA_INFO_ASC',
  EXTRA_INFO_DESC = 'EXTRA_INFO_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IS_INQUIRY_ASC = 'IS_INQUIRY_ASC',
  IS_INQUIRY_DESC = 'IS_INQUIRY_DESC',
  IS_PRELIMINARY_ASC = 'IS_PRELIMINARY_ASC',
  IS_PRELIMINARY_DESC = 'IS_PRELIMINARY_DESC',
  IS_TEMPLATE_ASC = 'IS_TEMPLATE_ASC',
  IS_TEMPLATE_DESC = 'IS_TEMPLATE_DESC',
  LAYDAY_ASC = 'LAYDAY_ASC',
  LAYDAY_DESC = 'LAYDAY_DESC',
  LOST_CONTRACTS_ID_ASC = 'LOST_CONTRACTS_ID_ASC',
  LOST_CONTRACTS_ID_DESC = 'LOST_CONTRACTS_ID_DESC',
  LUMPSUM_ASC = 'LUMPSUM_ASC',
  LUMPSUM_DESC = 'LUMPSUM_DESC',
  MODIFIED_BY_SESSION_ID_ASC = 'MODIFIED_BY_SESSION_ID_ASC',
  MODIFIED_BY_SESSION_ID_DESC = 'MODIFIED_BY_SESSION_ID_DESC',
  MODIFIED_BY_USER_ID_ASC = 'MODIFIED_BY_USER_ID_ASC',
  MODIFIED_BY_USER_ID_DESC = 'MODIFIED_BY_USER_ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ON_SUBS_UNTIL_ASC = 'ON_SUBS_UNTIL_ASC',
  ON_SUBS_UNTIL_DESC = 'ON_SUBS_UNTIL_DESC',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PAYMENT_TIME_ASC = 'PAYMENT_TIME_ASC',
  PAYMENT_TIME_DESC = 'PAYMENT_TIME_DESC',
  PAYMENT_TRIGGER_ASC = 'PAYMENT_TRIGGER_ASC',
  PAYMENT_TRIGGER_DESC = 'PAYMENT_TRIGGER_DESC',
  PAYMENT_TYPE_ASC = 'PAYMENT_TYPE_ASC',
  PAYMENT_TYPE_DESC = 'PAYMENT_TYPE_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIPOWNER_ORG_ID_ASC = 'SHIPOWNER_ORG_ID_ASC',
  SHIPOWNER_ORG_ID_DESC = 'SHIPOWNER_ORG_ID_DESC',
  SYS_PERIOD_ASC = 'SYS_PERIOD_ASC',
  SYS_PERIOD_DESC = 'SYS_PERIOD_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** A condition to be used against `Voyage` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type VoyageCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** A filter to be used against `Voyage` object types. All fields are combined with a logical ‘and.’ */
export type VoyageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Voyage` */
export type VoyageInput = {
  name: Scalars['String']['input'];
  organisationId: Scalars['OrganizationId']['input'];
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

export type VoyageNamingRule = Node & {
  __typename?: 'VoyageNamingRule';
  id: Scalars['VoyageNamingRuleId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `VoyageNamingRule`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']['output']>;
  rule: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `ShipVoyageNamingRuleRelation`. */
  shipVoyageNamingRuleRelationsByRuleId: ShipVoyageNamingRuleRelationsConnection;
  vesselFullname?: Maybe<Scalars['Boolean']['output']>;
  vesselImo?: Maybe<Scalars['Boolean']['output']>;
  vesselShortname?: Maybe<Scalars['Boolean']['output']>;
  year: VoyageNamingYearFormat;
  /** add leading zeros to voyage sequences */
  zerosPad: Scalars['Int']['output'];
};


export type VoyageNamingRuleShipVoyageNamingRuleRelationsByRuleIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShipVoyageNamingRuleRelationCondition>;
  filter?: InputMaybe<ShipVoyageNamingRuleRelationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShipVoyageNamingRuleRelationsOrderBy>>;
};

/**
 * A condition to be used against `VoyageNamingRule` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VoyageNamingRuleCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['VoyageNamingRuleId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rule` field. */
  rule?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vesselFullname` field. */
  vesselFullname?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `vesselImo` field. */
  vesselImo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `vesselShortname` field. */
  vesselShortname?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<VoyageNamingYearFormat>;
  /** Checks for equality with the object’s `zerosPad` field. */
  zerosPad?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VoyageNamingRule` object types. All fields are combined with a logical ‘and.’ */
export type VoyageNamingRuleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VoyageNamingRuleFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VoyageNamingRuleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VoyageNamingRuleFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rule` field. */
  rule?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vesselFullname` field. */
  vesselFullname?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `vesselImo` field. */
  vesselImo?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `vesselShortname` field. */
  vesselShortname?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<VoyageNamingYearFormatFilter>;
  /** Filter by the object’s `zerosPad` field. */
  zerosPad?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VoyageNamingRule` */
export type VoyageNamingRuleInput = {
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  rule: Scalars['String']['input'];
  vesselFullname?: InputMaybe<Scalars['Boolean']['input']>;
  vesselImo?: InputMaybe<Scalars['Boolean']['input']>;
  vesselShortname?: InputMaybe<Scalars['Boolean']['input']>;
  year: VoyageNamingYearFormat;
  /** add leading zeros to voyage sequences */
  zerosPad: Scalars['Int']['input'];
};

/** Represents an update to a `VoyageNamingRule`. Fields that are set will be updated. */
export type VoyageNamingRulePatch = {
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  vesselFullname?: InputMaybe<Scalars['Boolean']['input']>;
  vesselImo?: InputMaybe<Scalars['Boolean']['input']>;
  vesselShortname?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<VoyageNamingYearFormat>;
  /** add leading zeros to voyage sequences */
  zerosPad?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `VoyageNamingRule` values. */
export type VoyageNamingRulesConnection = {
  __typename?: 'VoyageNamingRulesConnection';
  /** A list of edges which contains the `VoyageNamingRule` and cursor to aid in pagination. */
  edges: Array<VoyageNamingRulesEdge>;
  /** A list of `VoyageNamingRule` objects. */
  nodes: Array<Maybe<VoyageNamingRule>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VoyageNamingRule` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VoyageNamingRule` edge in the connection. */
export type VoyageNamingRulesEdge = {
  __typename?: 'VoyageNamingRulesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VoyageNamingRule` at the end of the edge. */
  node?: Maybe<VoyageNamingRule>;
};

/** Methods to use when ordering `VoyageNamingRule`. */
export enum VoyageNamingRulesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RULE_ASC = 'RULE_ASC',
  RULE_DESC = 'RULE_DESC',
  VESSEL_FULLNAME_ASC = 'VESSEL_FULLNAME_ASC',
  VESSEL_FULLNAME_DESC = 'VESSEL_FULLNAME_DESC',
  VESSEL_IMO_ASC = 'VESSEL_IMO_ASC',
  VESSEL_IMO_DESC = 'VESSEL_IMO_DESC',
  VESSEL_SHORTNAME_ASC = 'VESSEL_SHORTNAME_ASC',
  VESSEL_SHORTNAME_DESC = 'VESSEL_SHORTNAME_DESC',
  YEAR_ASC = 'YEAR_ASC',
  YEAR_DESC = 'YEAR_DESC',
  ZEROS_PAD_ASC = 'ZEROS_PAD_ASC',
  ZEROS_PAD_DESC = 'ZEROS_PAD_DESC'
}

export enum VoyageNamingYearFormat {
  YY = 'YY',
  YYYY = 'YYYY'
}

/** A filter to be used against VoyageNamingYearFormat fields. All fields are combined with a logical ‘and.’ */
export type VoyageNamingYearFormatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<VoyageNamingYearFormat>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<VoyageNamingYearFormat>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<VoyageNamingYearFormat>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<VoyageNamingYearFormat>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<VoyageNamingYearFormat>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<VoyageNamingYearFormat>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<VoyageNamingYearFormat>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<VoyageNamingYearFormat>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<VoyageNamingYearFormat>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<VoyageNamingYearFormat>>;
};

/** Represents an update to a `Voyage`. Fields that are set will be updated. */
export type VoyagePatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  vesselId?: InputMaybe<Scalars['ShipId']['input']>;
};

/** All input for the `voyagePrefixGetNextIds` mutation. */
export type VoyagePrefixGetNextIdsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  prefixObjects?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

/** The output of our `voyagePrefixGetNextIds` mutation. */
export type VoyagePrefixGetNextIdsPayload = {
  __typename?: 'VoyagePrefixGetNextIdsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  strings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A connection to a list of `Voyage` values. */
export type VoyagesConnection = {
  __typename?: 'VoyagesConnection';
  /** A list of edges which contains the `Voyage` and cursor to aid in pagination. */
  edges: Array<VoyagesEdge>;
  /** A list of `Voyage` objects. */
  nodes: Array<Maybe<Voyage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Voyage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Voyage` edge in the connection. */
export type VoyagesEdge = {
  __typename?: 'VoyagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Voyage` at the end of the edge. */
  node?: Maybe<Voyage>;
};

/** Methods to use when ordering `Voyage`. */
export enum VoyagesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type VwBrokerAccessibleOrder = {
  __typename?: 'VwBrokerAccessibleOrder';
  brokerOrgId?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwBrokerAccessibleOrder` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VwBrokerAccessibleOrderCondition = {
  /** Checks for equality with the object’s `brokerOrgId` field. */
  brokerOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwBrokerAccessibleOrder` object types. All fields are combined with a logical ‘and.’ */
export type VwBrokerAccessibleOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwBrokerAccessibleOrderFilter>>;
  /** Filter by the object’s `brokerOrgId` field. */
  brokerOrgId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwBrokerAccessibleOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwBrokerAccessibleOrderFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwBrokerAccessibleOrder` values. */
export type VwBrokerAccessibleOrdersConnection = {
  __typename?: 'VwBrokerAccessibleOrdersConnection';
  /** A list of edges which contains the `VwBrokerAccessibleOrder` and cursor to aid in pagination. */
  edges: Array<VwBrokerAccessibleOrdersEdge>;
  /** A list of `VwBrokerAccessibleOrder` objects. */
  nodes: Array<Maybe<VwBrokerAccessibleOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwBrokerAccessibleOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwBrokerAccessibleOrder` edge in the connection. */
export type VwBrokerAccessibleOrdersEdge = {
  __typename?: 'VwBrokerAccessibleOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwBrokerAccessibleOrder` at the end of the edge. */
  node?: Maybe<VwBrokerAccessibleOrder>;
};

/** Methods to use when ordering `VwBrokerAccessibleOrder`. */
export enum VwBrokerAccessibleOrdersOrderBy {
  BROKER_ORG_ID_ASC = 'BROKER_ORG_ID_ASC',
  BROKER_ORG_ID_DESC = 'BROKER_ORG_ID_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC'
}

/** Return orders on handled by coa associated to port agents [postgres] */
export type VwHandledByCoaPortAgentOrdersPg = {
  __typename?: 'VwHandledByCoaPortAgentOrdersPg';
  orderId?: Maybe<Scalars['Int']['output']>;
  portAgentOrgId?: Maybe<Scalars['Int']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A condition to be used against `VwHandledByCoaPortAgentOrdersPg` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwHandledByCoaPortAgentOrdersPgCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portAgentOrgId` field. */
  portAgentOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `VwHandledByCoaPortAgentOrdersPg` object types. All fields are combined with a logical ‘and.’ */
export type VwHandledByCoaPortAgentOrdersPgFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwHandledByCoaPortAgentOrdersPgFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwHandledByCoaPortAgentOrdersPgFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwHandledByCoaPortAgentOrdersPgFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portAgentOrgId` field. */
  portAgentOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `VwHandledByCoaPortAgentOrdersPg` values. */
export type VwHandledByCoaPortAgentOrdersPgsConnection = {
  __typename?: 'VwHandledByCoaPortAgentOrdersPgsConnection';
  /** A list of edges which contains the `VwHandledByCoaPortAgentOrdersPg` and cursor to aid in pagination. */
  edges: Array<VwHandledByCoaPortAgentOrdersPgsEdge>;
  /** A list of `VwHandledByCoaPortAgentOrdersPg` objects. */
  nodes: Array<Maybe<VwHandledByCoaPortAgentOrdersPg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwHandledByCoaPortAgentOrdersPg` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwHandledByCoaPortAgentOrdersPg` edge in the connection. */
export type VwHandledByCoaPortAgentOrdersPgsEdge = {
  __typename?: 'VwHandledByCoaPortAgentOrdersPgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwHandledByCoaPortAgentOrdersPg` at the end of the edge. */
  node?: Maybe<VwHandledByCoaPortAgentOrdersPg>;
};

/** Methods to use when ordering `VwHandledByCoaPortAgentOrdersPg`. */
export enum VwHandledByCoaPortAgentOrdersPgsOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PORT_AGENT_ORG_ID_ASC = 'PORT_AGENT_ORG_ID_ASC',
  PORT_AGENT_ORG_ID_DESC = 'PORT_AGENT_ORG_ID_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC'
}

/** Return orders on handled by coa associated to ship owners [postgres] */
export type VwHandledByCoaShipOwnerOrdersPg = {
  __typename?: 'VwHandledByCoaShipOwnerOrdersPg';
  orderId?: Maybe<Scalars['Int']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  shipOwnerOrgId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwHandledByCoaShipOwnerOrdersPg` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwHandledByCoaShipOwnerOrdersPgCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `shipOwnerOrgId` field. */
  shipOwnerOrgId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwHandledByCoaShipOwnerOrdersPg` object types. All fields are combined with a logical ‘and.’ */
export type VwHandledByCoaShipOwnerOrdersPgFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwHandledByCoaShipOwnerOrdersPgFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwHandledByCoaShipOwnerOrdersPgFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwHandledByCoaShipOwnerOrdersPgFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `shipOwnerOrgId` field. */
  shipOwnerOrgId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwHandledByCoaShipOwnerOrdersPg` values. */
export type VwHandledByCoaShipOwnerOrdersPgsConnection = {
  __typename?: 'VwHandledByCoaShipOwnerOrdersPgsConnection';
  /** A list of edges which contains the `VwHandledByCoaShipOwnerOrdersPg` and cursor to aid in pagination. */
  edges: Array<VwHandledByCoaShipOwnerOrdersPgsEdge>;
  /** A list of `VwHandledByCoaShipOwnerOrdersPg` objects. */
  nodes: Array<Maybe<VwHandledByCoaShipOwnerOrdersPg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwHandledByCoaShipOwnerOrdersPg` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwHandledByCoaShipOwnerOrdersPg` edge in the connection. */
export type VwHandledByCoaShipOwnerOrdersPgsEdge = {
  __typename?: 'VwHandledByCoaShipOwnerOrdersPgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwHandledByCoaShipOwnerOrdersPg` at the end of the edge. */
  node?: Maybe<VwHandledByCoaShipOwnerOrdersPg>;
};

/** Methods to use when ordering `VwHandledByCoaShipOwnerOrdersPg`. */
export enum VwHandledByCoaShipOwnerOrdersPgsOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SHIP_OWNER_ORG_ID_ASC = 'SHIP_OWNER_ORG_ID_ASC',
  SHIP_OWNER_ORG_ID_DESC = 'SHIP_OWNER_ORG_ID_DESC'
}

export type VwHandledBySpotOrgRef = {
  __typename?: 'VwHandledBySpotOrgRef';
  id?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwHandledBySpotOrgRef` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VwHandledBySpotOrgRefCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwHandledBySpotOrgRef` object types. All fields are combined with a logical ‘and.’ */
export type VwHandledBySpotOrgRefFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwHandledBySpotOrgRefFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwHandledBySpotOrgRefFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwHandledBySpotOrgRefFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwHandledBySpotOrgRef` values. */
export type VwHandledBySpotOrgRefsConnection = {
  __typename?: 'VwHandledBySpotOrgRefsConnection';
  /** A list of edges which contains the `VwHandledBySpotOrgRef` and cursor to aid in pagination. */
  edges: Array<VwHandledBySpotOrgRefsEdge>;
  /** A list of `VwHandledBySpotOrgRef` objects. */
  nodes: Array<Maybe<VwHandledBySpotOrgRef>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwHandledBySpotOrgRef` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwHandledBySpotOrgRef` edge in the connection. */
export type VwHandledBySpotOrgRefsEdge = {
  __typename?: 'VwHandledBySpotOrgRefsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwHandledBySpotOrgRef` at the end of the edge. */
  node?: Maybe<VwHandledBySpotOrgRef>;
};

/** Methods to use when ordering `VwHandledBySpotOrgRef`. */
export enum VwHandledBySpotOrgRefsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC'
}

/** Return orders on handled by spot associated to ship owners [postgres] */
export type VwHandledBySpotShipOwnerPg = {
  __typename?: 'VwHandledBySpotShipOwnerPg';
  orderId?: Maybe<Scalars['Int']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  shipOwnerOrgId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwHandledBySpotShipOwnerPg` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VwHandledBySpotShipOwnerPgCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `shipOwnerOrgId` field. */
  shipOwnerOrgId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwHandledBySpotShipOwnerPg` object types. All fields are combined with a logical ‘and.’ */
export type VwHandledBySpotShipOwnerPgFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwHandledBySpotShipOwnerPgFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwHandledBySpotShipOwnerPgFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwHandledBySpotShipOwnerPgFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `shipOwnerOrgId` field. */
  shipOwnerOrgId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VwHandledBySpotShipOwnerPg` */
export type VwHandledBySpotShipOwnerPgInput = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  shipOwnerOrgId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `VwHandledBySpotShipOwnerPg` values. */
export type VwHandledBySpotShipOwnerPgsConnection = {
  __typename?: 'VwHandledBySpotShipOwnerPgsConnection';
  /** A list of edges which contains the `VwHandledBySpotShipOwnerPg` and cursor to aid in pagination. */
  edges: Array<VwHandledBySpotShipOwnerPgsEdge>;
  /** A list of `VwHandledBySpotShipOwnerPg` objects. */
  nodes: Array<Maybe<VwHandledBySpotShipOwnerPg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwHandledBySpotShipOwnerPg` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwHandledBySpotShipOwnerPg` edge in the connection. */
export type VwHandledBySpotShipOwnerPgsEdge = {
  __typename?: 'VwHandledBySpotShipOwnerPgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwHandledBySpotShipOwnerPg` at the end of the edge. */
  node?: Maybe<VwHandledBySpotShipOwnerPg>;
};

/** Methods to use when ordering `VwHandledBySpotShipOwnerPg`. */
export enum VwHandledBySpotShipOwnerPgsOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SHIP_OWNER_ORG_ID_ASC = 'SHIP_OWNER_ORG_ID_ASC',
  SHIP_OWNER_ORG_ID_DESC = 'SHIP_OWNER_ORG_ID_DESC'
}

export type VwOrderPolicyPortAgentOrder = {
  __typename?: 'VwOrderPolicyPortAgentOrder';
  orderId?: Maybe<Scalars['Int']['output']>;
  portAgentOrgId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwOrderPolicyPortAgentOrder` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VwOrderPolicyPortAgentOrderCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portAgentOrgId` field. */
  portAgentOrgId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwOrderPolicyPortAgentOrder` object types. All fields are combined with a logical ‘and.’ */
export type VwOrderPolicyPortAgentOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwOrderPolicyPortAgentOrderFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwOrderPolicyPortAgentOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwOrderPolicyPortAgentOrderFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portAgentOrgId` field. */
  portAgentOrgId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwOrderPolicyPortAgentOrder` values. */
export type VwOrderPolicyPortAgentOrdersConnection = {
  __typename?: 'VwOrderPolicyPortAgentOrdersConnection';
  /** A list of edges which contains the `VwOrderPolicyPortAgentOrder` and cursor to aid in pagination. */
  edges: Array<VwOrderPolicyPortAgentOrdersEdge>;
  /** A list of `VwOrderPolicyPortAgentOrder` objects. */
  nodes: Array<Maybe<VwOrderPolicyPortAgentOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwOrderPolicyPortAgentOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwOrderPolicyPortAgentOrder` edge in the connection. */
export type VwOrderPolicyPortAgentOrdersEdge = {
  __typename?: 'VwOrderPolicyPortAgentOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwOrderPolicyPortAgentOrder` at the end of the edge. */
  node?: Maybe<VwOrderPolicyPortAgentOrder>;
};

/** Methods to use when ordering `VwOrderPolicyPortAgentOrder`. */
export enum VwOrderPolicyPortAgentOrdersOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PORT_AGENT_ORG_ID_ASC = 'PORT_AGENT_ORG_ID_ASC',
  PORT_AGENT_ORG_ID_DESC = 'PORT_AGENT_ORG_ID_DESC'
}

export type VwOrderPolicySharedOrdersForReceiver = {
  __typename?: 'VwOrderPolicySharedOrdersForReceiver';
  orderId?: Maybe<Scalars['Int']['output']>;
  receiverOrganisationId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwOrderPolicySharedOrdersForReceiver` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwOrderPolicySharedOrdersForReceiverCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `receiverOrganisationId` field. */
  receiverOrganisationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwOrderPolicySharedOrdersForReceiver` object types. All fields are combined with a logical ‘and.’ */
export type VwOrderPolicySharedOrdersForReceiverFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwOrderPolicySharedOrdersForReceiverFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwOrderPolicySharedOrdersForReceiverFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwOrderPolicySharedOrdersForReceiverFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `receiverOrganisationId` field. */
  receiverOrganisationId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwOrderPolicySharedOrdersForReceiver` values. */
export type VwOrderPolicySharedOrdersForReceiversConnection = {
  __typename?: 'VwOrderPolicySharedOrdersForReceiversConnection';
  /** A list of edges which contains the `VwOrderPolicySharedOrdersForReceiver` and cursor to aid in pagination. */
  edges: Array<VwOrderPolicySharedOrdersForReceiversEdge>;
  /** A list of `VwOrderPolicySharedOrdersForReceiver` objects. */
  nodes: Array<Maybe<VwOrderPolicySharedOrdersForReceiver>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwOrderPolicySharedOrdersForReceiver` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwOrderPolicySharedOrdersForReceiver` edge in the connection. */
export type VwOrderPolicySharedOrdersForReceiversEdge = {
  __typename?: 'VwOrderPolicySharedOrdersForReceiversEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwOrderPolicySharedOrdersForReceiver` at the end of the edge. */
  node?: Maybe<VwOrderPolicySharedOrdersForReceiver>;
};

/** Methods to use when ordering `VwOrderPolicySharedOrdersForReceiver`. */
export enum VwOrderPolicySharedOrdersForReceiversOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  RECEIVER_ORGANISATION_ID_ASC = 'RECEIVER_ORGANISATION_ID_ASC',
  RECEIVER_ORGANISATION_ID_DESC = 'RECEIVER_ORGANISATION_ID_DESC'
}

export type VwOrderPolicySharedOrdersForSender = {
  __typename?: 'VwOrderPolicySharedOrdersForSender';
  orderId?: Maybe<Scalars['Int']['output']>;
  senderOrganisationId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwOrderPolicySharedOrdersForSender` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwOrderPolicySharedOrdersForSenderCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `senderOrganisationId` field. */
  senderOrganisationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwOrderPolicySharedOrdersForSender` object types. All fields are combined with a logical ‘and.’ */
export type VwOrderPolicySharedOrdersForSenderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwOrderPolicySharedOrdersForSenderFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwOrderPolicySharedOrdersForSenderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwOrderPolicySharedOrdersForSenderFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `senderOrganisationId` field. */
  senderOrganisationId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwOrderPolicySharedOrdersForSender` values. */
export type VwOrderPolicySharedOrdersForSendersConnection = {
  __typename?: 'VwOrderPolicySharedOrdersForSendersConnection';
  /** A list of edges which contains the `VwOrderPolicySharedOrdersForSender` and cursor to aid in pagination. */
  edges: Array<VwOrderPolicySharedOrdersForSendersEdge>;
  /** A list of `VwOrderPolicySharedOrdersForSender` objects. */
  nodes: Array<Maybe<VwOrderPolicySharedOrdersForSender>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwOrderPolicySharedOrdersForSender` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwOrderPolicySharedOrdersForSender` edge in the connection. */
export type VwOrderPolicySharedOrdersForSendersEdge = {
  __typename?: 'VwOrderPolicySharedOrdersForSendersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwOrderPolicySharedOrdersForSender` at the end of the edge. */
  node?: Maybe<VwOrderPolicySharedOrdersForSender>;
};

/** Methods to use when ordering `VwOrderPolicySharedOrdersForSender`. */
export enum VwOrderPolicySharedOrdersForSendersOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  SENDER_ORGANISATION_ID_ASC = 'SENDER_ORGANISATION_ID_ASC',
  SENDER_ORGANISATION_ID_DESC = 'SENDER_ORGANISATION_ID_DESC'
}

export type VwOrdersVisibilityListByOrganization = {
  __typename?: 'VwOrdersVisibilityListByOrganization';
  orderId?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwOrdersVisibilityListByOrganization` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwOrdersVisibilityListByOrganizationCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orgId` field. */
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwOrdersVisibilityListByOrganization` object types. All fields are combined with a logical ‘and.’ */
export type VwOrdersVisibilityListByOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwOrdersVisibilityListByOrganizationFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwOrdersVisibilityListByOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwOrdersVisibilityListByOrganizationFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orgId` field. */
  orgId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwOrdersVisibilityListByOrganization` values. */
export type VwOrdersVisibilityListByOrganizationsConnection = {
  __typename?: 'VwOrdersVisibilityListByOrganizationsConnection';
  /** A list of edges which contains the `VwOrdersVisibilityListByOrganization` and cursor to aid in pagination. */
  edges: Array<VwOrdersVisibilityListByOrganizationsEdge>;
  /** A list of `VwOrdersVisibilityListByOrganization` objects. */
  nodes: Array<Maybe<VwOrdersVisibilityListByOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwOrdersVisibilityListByOrganization` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwOrdersVisibilityListByOrganization` edge in the connection. */
export type VwOrdersVisibilityListByOrganizationsEdge = {
  __typename?: 'VwOrdersVisibilityListByOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwOrdersVisibilityListByOrganization` at the end of the edge. */
  node?: Maybe<VwOrdersVisibilityListByOrganization>;
};

/** Methods to use when ordering `VwOrdersVisibilityListByOrganization`. */
export enum VwOrdersVisibilityListByOrganizationsOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  ORG_ID_ASC = 'ORG_ID_ASC',
  ORG_ID_DESC = 'ORG_ID_DESC'
}

/** Return the whole organization tree based on root or sub organization session info */
export type VwOrgTree = {
  __typename?: 'VwOrgTree';
  id?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwOrgTree` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type VwOrgTreeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwOrgTree` object types. All fields are combined with a logical ‘and.’ */
export type VwOrgTreeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwOrgTreeFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwOrgTreeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwOrgTreeFilter>>;
};

/** A connection to a list of `VwOrgTree` values. */
export type VwOrgTreesConnection = {
  __typename?: 'VwOrgTreesConnection';
  /** A list of edges which contains the `VwOrgTree` and cursor to aid in pagination. */
  edges: Array<VwOrgTreesEdge>;
  /** A list of `VwOrgTree` objects. */
  nodes: Array<Maybe<VwOrgTree>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwOrgTree` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwOrgTree` edge in the connection. */
export type VwOrgTreesEdge = {
  __typename?: 'VwOrgTreesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwOrgTree` at the end of the edge. */
  node?: Maybe<VwOrgTree>;
};

/** Methods to use when ordering `VwOrgTree`. */
export enum VwOrgTreesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL'
}

/** Return unpivot organizations listing with all possibilities of organization types [postgres] */
export type VwOrgUnpivotPg = {
  __typename?: 'VwOrgUnpivotPg';
  childOrgId?: Maybe<Scalars['Int']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  orgEmail?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  orgType?: Maybe<Scalars['String']['output']>;
  orgValue?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A condition to be used against `VwOrgUnpivotPg` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VwOrgUnpivotPgCondition = {
  /** Checks for equality with the object’s `childOrgId` field. */
  childOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `domain` field. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orgEmail` field. */
  orgEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orgId` field. */
  orgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orgName` field. */
  orgName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orgType` field. */
  orgType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orgValue` field. */
  orgValue?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `VwOrgUnpivotPg` object types. All fields are combined with a logical ‘and.’ */
export type VwOrgUnpivotPgFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwOrgUnpivotPgFilter>>;
  /** Filter by the object’s `childOrgId` field. */
  childOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `domain` field. */
  domain?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwOrgUnpivotPgFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwOrgUnpivotPgFilter>>;
  /** Filter by the object’s `orgEmail` field. */
  orgEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orgId` field. */
  orgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orgName` field. */
  orgName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orgType` field. */
  orgType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orgValue` field. */
  orgValue?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `VwOrgUnpivotPg` values. */
export type VwOrgUnpivotPgsConnection = {
  __typename?: 'VwOrgUnpivotPgsConnection';
  /** A list of edges which contains the `VwOrgUnpivotPg` and cursor to aid in pagination. */
  edges: Array<VwOrgUnpivotPgsEdge>;
  /** A list of `VwOrgUnpivotPg` objects. */
  nodes: Array<Maybe<VwOrgUnpivotPg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwOrgUnpivotPg` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwOrgUnpivotPg` edge in the connection. */
export type VwOrgUnpivotPgsEdge = {
  __typename?: 'VwOrgUnpivotPgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwOrgUnpivotPg` at the end of the edge. */
  node?: Maybe<VwOrgUnpivotPg>;
};

/** Methods to use when ordering `VwOrgUnpivotPg`. */
export enum VwOrgUnpivotPgsOrderBy {
  CHILD_ORG_ID_ASC = 'CHILD_ORG_ID_ASC',
  CHILD_ORG_ID_DESC = 'CHILD_ORG_ID_DESC',
  DOMAIN_ASC = 'DOMAIN_ASC',
  DOMAIN_DESC = 'DOMAIN_DESC',
  NATURAL = 'NATURAL',
  ORG_EMAIL_ASC = 'ORG_EMAIL_ASC',
  ORG_EMAIL_DESC = 'ORG_EMAIL_DESC',
  ORG_ID_ASC = 'ORG_ID_ASC',
  ORG_ID_DESC = 'ORG_ID_DESC',
  ORG_NAME_ASC = 'ORG_NAME_ASC',
  ORG_NAME_DESC = 'ORG_NAME_DESC',
  ORG_TYPE_ASC = 'ORG_TYPE_ASC',
  ORG_TYPE_DESC = 'ORG_TYPE_DESC',
  ORG_VALUE_ASC = 'ORG_VALUE_ASC',
  ORG_VALUE_DESC = 'ORG_VALUE_DESC'
}

export type VwPortNoticeChangelog = {
  __typename?: 'VwPortNoticeChangelog';
  mUserName?: Maybe<Scalars['String']['output']>;
  portNoticeId?: Maybe<Scalars['Int']['output']>;
  portNoticeMsg?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startSysPeriod?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `VwPortNoticeChangelog` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VwPortNoticeChangelogCondition = {
  /** Checks for equality with the object’s `mUserName` field. */
  mUserName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `portNoticeId` field. */
  portNoticeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portNoticeMsg` field. */
  portNoticeMsg?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `startSysPeriod` field. */
  startSysPeriod?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `VwPortNoticeChangelog` object types. All fields are combined with a logical ‘and.’ */
export type VwPortNoticeChangelogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwPortNoticeChangelogFilter>>;
  /** Filter by the object’s `mUserName` field. */
  mUserName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwPortNoticeChangelogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwPortNoticeChangelogFilter>>;
  /** Filter by the object’s `portNoticeId` field. */
  portNoticeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portNoticeMsg` field. */
  portNoticeMsg?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `startSysPeriod` field. */
  startSysPeriod?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `VwPortNoticeChangelog` values. */
export type VwPortNoticeChangelogsConnection = {
  __typename?: 'VwPortNoticeChangelogsConnection';
  /** A list of edges which contains the `VwPortNoticeChangelog` and cursor to aid in pagination. */
  edges: Array<VwPortNoticeChangelogsEdge>;
  /** A list of `VwPortNoticeChangelog` objects. */
  nodes: Array<Maybe<VwPortNoticeChangelog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwPortNoticeChangelog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwPortNoticeChangelog` edge in the connection. */
export type VwPortNoticeChangelogsEdge = {
  __typename?: 'VwPortNoticeChangelogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwPortNoticeChangelog` at the end of the edge. */
  node?: Maybe<VwPortNoticeChangelog>;
};

/** Methods to use when ordering `VwPortNoticeChangelog`. */
export enum VwPortNoticeChangelogsOrderBy {
  M_USER_NAME_ASC = 'M_USER_NAME_ASC',
  M_USER_NAME_DESC = 'M_USER_NAME_DESC',
  NATURAL = 'NATURAL',
  PORT_NOTICE_ID_ASC = 'PORT_NOTICE_ID_ASC',
  PORT_NOTICE_ID_DESC = 'PORT_NOTICE_ID_DESC',
  PORT_NOTICE_MSG_ASC = 'PORT_NOTICE_MSG_ASC',
  PORT_NOTICE_MSG_DESC = 'PORT_NOTICE_MSG_DESC',
  START_SYS_PERIOD_ASC = 'START_SYS_PERIOD_ASC',
  START_SYS_PERIOD_DESC = 'START_SYS_PERIOD_DESC'
}

export type VwSapOrdersIntegration = {
  __typename?: 'VwSapOrdersIntegration';
  externalId?: Maybe<Scalars['String']['output']>;
  externalIdDisplay?: Maybe<Scalars['String']['output']>;
  integrationCode?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Datetime']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  materialId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nominationKey?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  pegId?: Maybe<Scalars['String']['output']>;
  ports?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  sapCreatedAt?: Maybe<Scalars['Datetime']['output']>;
  sapSourceEnv?: Maybe<Scalars['String']['output']>;
  sapUpdatedAt?: Maybe<Scalars['Datetime']['output']>;
  status?: Maybe<StatusType>;
  unit?: Maybe<Scalars['String']['output']>;
  vesselName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `VwSapOrdersIntegration` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VwSapOrdersIntegrationCondition = {
  /** Checks for equality with the object’s `externalId` field. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `externalIdDisplay` field. */
  externalIdDisplay?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `integrationCode` field. */
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `material` field. */
  material?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `materialId` field. */
  materialId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nominationKey` field. */
  nominationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `pegId` field. */
  pegId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ports` field. */
  ports?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `quantity` field. */
  quantity?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sapCreatedAt` field. */
  sapCreatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sapSourceEnv` field. */
  sapSourceEnv?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sapUpdatedAt` field. */
  sapUpdatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<StatusType>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vesselName` field. */
  vesselName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `VwSapOrdersIntegration` object types. All fields are combined with a logical ‘and.’ */
export type VwSapOrdersIntegrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwSapOrdersIntegrationFilter>>;
  /** Filter by the object’s `externalId` field. */
  externalId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalIdDisplay` field. */
  externalIdDisplay?: InputMaybe<StringFilter>;
  /** Filter by the object’s `integrationCode` field. */
  integrationCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `material` field. */
  material?: InputMaybe<StringFilter>;
  /** Filter by the object’s `materialId` field. */
  materialId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nominationKey` field. */
  nominationKey?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwSapOrdersIntegrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwSapOrdersIntegrationFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pegId` field. */
  pegId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ports` field. */
  ports?: InputMaybe<StringFilter>;
  /** Filter by the object’s `quantity` field. */
  quantity?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sapCreatedAt` field. */
  sapCreatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sapSourceEnv` field. */
  sapSourceEnv?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sapUpdatedAt` field. */
  sapUpdatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StatusTypeFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vesselName` field. */
  vesselName?: InputMaybe<StringFilter>;
};

/** A connection to a list of `VwSapOrdersIntegrationSummary` values. */
export type VwSapOrdersIntegrationSummariesConnection = {
  __typename?: 'VwSapOrdersIntegrationSummariesConnection';
  /** A list of edges which contains the `VwSapOrdersIntegrationSummary` and cursor to aid in pagination. */
  edges: Array<VwSapOrdersIntegrationSummariesEdge>;
  /** A list of `VwSapOrdersIntegrationSummary` objects. */
  nodes: Array<Maybe<VwSapOrdersIntegrationSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwSapOrdersIntegrationSummary` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwSapOrdersIntegrationSummary` edge in the connection. */
export type VwSapOrdersIntegrationSummariesEdge = {
  __typename?: 'VwSapOrdersIntegrationSummariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwSapOrdersIntegrationSummary` at the end of the edge. */
  node?: Maybe<VwSapOrdersIntegrationSummary>;
};

/** Methods to use when ordering `VwSapOrdersIntegrationSummary`. */
export enum VwSapOrdersIntegrationSummariesOrderBy {
  EXTERNAL_ID_AGG_ASC = 'EXTERNAL_ID_AGG_ASC',
  EXTERNAL_ID_AGG_DESC = 'EXTERNAL_ID_AGG_DESC',
  INTEGRATION_CODE_ASC = 'INTEGRATION_CODE_ASC',
  INTEGRATION_CODE_DESC = 'INTEGRATION_CODE_DESC',
  LAST_UPDATED_ASC = 'LAST_UPDATED_ASC',
  LAST_UPDATED_DESC = 'LAST_UPDATED_DESC',
  MESSAGE_ASC = 'MESSAGE_ASC',
  MESSAGE_DESC = 'MESSAGE_DESC',
  NATURAL = 'NATURAL',
  NOMINATION_KEY_ASC = 'NOMINATION_KEY_ASC',
  NOMINATION_KEY_DESC = 'NOMINATION_KEY_DESC',
  ORDER_ID_AGG_ASC = 'ORDER_ID_AGG_ASC',
  ORDER_ID_AGG_DESC = 'ORDER_ID_AGG_DESC',
  SAP_CREATED_AT_ASC = 'SAP_CREATED_AT_ASC',
  SAP_CREATED_AT_DESC = 'SAP_CREATED_AT_DESC',
  SAP_SOURCE_ENV_ASC = 'SAP_SOURCE_ENV_ASC',
  SAP_SOURCE_ENV_DESC = 'SAP_SOURCE_ENV_DESC',
  SAP_UPDATED_AT_ASC = 'SAP_UPDATED_AT_ASC',
  SAP_UPDATED_AT_DESC = 'SAP_UPDATED_AT_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC'
}

export type VwSapOrdersIntegrationSummary = {
  __typename?: 'VwSapOrdersIntegrationSummary';
  externalIdAgg?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  integrationCode?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Datetime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nominationKey?: Maybe<Scalars['String']['output']>;
  orderIdAgg?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sapCreatedAt?: Maybe<Scalars['Datetime']['output']>;
  sapSourceEnv?: Maybe<Scalars['String']['output']>;
  sapUpdatedAt?: Maybe<Scalars['Datetime']['output']>;
  status?: Maybe<StatusType>;
};

/**
 * A condition to be used against `VwSapOrdersIntegrationSummary` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VwSapOrdersIntegrationSummaryCondition = {
  /** Checks for equality with the object’s `externalIdAgg` field. */
  externalIdAgg?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `integrationCode` field. */
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nominationKey` field. */
  nominationKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderIdAgg` field. */
  orderIdAgg?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Checks for equality with the object’s `sapCreatedAt` field. */
  sapCreatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sapSourceEnv` field. */
  sapSourceEnv?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sapUpdatedAt` field. */
  sapUpdatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<StatusType>;
};

/** A filter to be used against `VwSapOrdersIntegrationSummary` object types. All fields are combined with a logical ‘and.’ */
export type VwSapOrdersIntegrationSummaryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwSapOrdersIntegrationSummaryFilter>>;
  /** Filter by the object’s `externalIdAgg` field. */
  externalIdAgg?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `integrationCode` field. */
  integrationCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nominationKey` field. */
  nominationKey?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwSapOrdersIntegrationSummaryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwSapOrdersIntegrationSummaryFilter>>;
  /** Filter by the object’s `orderIdAgg` field. */
  orderIdAgg?: InputMaybe<IntListFilter>;
  /** Filter by the object’s `sapCreatedAt` field. */
  sapCreatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sapSourceEnv` field. */
  sapSourceEnv?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sapUpdatedAt` field. */
  sapUpdatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<StatusTypeFilter>;
};

/** A connection to a list of `VwSapOrdersIntegration` values. */
export type VwSapOrdersIntegrationsConnection = {
  __typename?: 'VwSapOrdersIntegrationsConnection';
  /** A list of edges which contains the `VwSapOrdersIntegration` and cursor to aid in pagination. */
  edges: Array<VwSapOrdersIntegrationsEdge>;
  /** A list of `VwSapOrdersIntegration` objects. */
  nodes: Array<Maybe<VwSapOrdersIntegration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwSapOrdersIntegration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwSapOrdersIntegration` edge in the connection. */
export type VwSapOrdersIntegrationsEdge = {
  __typename?: 'VwSapOrdersIntegrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwSapOrdersIntegration` at the end of the edge. */
  node?: Maybe<VwSapOrdersIntegration>;
};

/** Methods to use when ordering `VwSapOrdersIntegration`. */
export enum VwSapOrdersIntegrationsOrderBy {
  EXTERNAL_ID_ASC = 'EXTERNAL_ID_ASC',
  EXTERNAL_ID_DESC = 'EXTERNAL_ID_DESC',
  EXTERNAL_ID_DISPLAY_ASC = 'EXTERNAL_ID_DISPLAY_ASC',
  EXTERNAL_ID_DISPLAY_DESC = 'EXTERNAL_ID_DISPLAY_DESC',
  INTEGRATION_CODE_ASC = 'INTEGRATION_CODE_ASC',
  INTEGRATION_CODE_DESC = 'INTEGRATION_CODE_DESC',
  LAST_UPDATED_ASC = 'LAST_UPDATED_ASC',
  LAST_UPDATED_DESC = 'LAST_UPDATED_DESC',
  MATERIAL_ASC = 'MATERIAL_ASC',
  MATERIAL_DESC = 'MATERIAL_DESC',
  MATERIAL_ID_ASC = 'MATERIAL_ID_ASC',
  MATERIAL_ID_DESC = 'MATERIAL_ID_DESC',
  MESSAGE_ASC = 'MESSAGE_ASC',
  MESSAGE_DESC = 'MESSAGE_DESC',
  NATURAL = 'NATURAL',
  NOMINATION_KEY_ASC = 'NOMINATION_KEY_ASC',
  NOMINATION_KEY_DESC = 'NOMINATION_KEY_DESC',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PEG_ID_ASC = 'PEG_ID_ASC',
  PEG_ID_DESC = 'PEG_ID_DESC',
  PORTS_ASC = 'PORTS_ASC',
  PORTS_DESC = 'PORTS_DESC',
  QUANTITY_ASC = 'QUANTITY_ASC',
  QUANTITY_DESC = 'QUANTITY_DESC',
  SAP_CREATED_AT_ASC = 'SAP_CREATED_AT_ASC',
  SAP_CREATED_AT_DESC = 'SAP_CREATED_AT_DESC',
  SAP_SOURCE_ENV_ASC = 'SAP_SOURCE_ENV_ASC',
  SAP_SOURCE_ENV_DESC = 'SAP_SOURCE_ENV_DESC',
  SAP_UPDATED_AT_ASC = 'SAP_UPDATED_AT_ASC',
  SAP_UPDATED_AT_DESC = 'SAP_UPDATED_AT_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  UNIT_ASC = 'UNIT_ASC',
  UNIT_DESC = 'UNIT_DESC',
  VESSEL_NAME_ASC = 'VESSEL_NAME_ASC',
  VESSEL_NAME_DESC = 'VESSEL_NAME_DESC'
}

/** Return scheduled orders associated to ship owners [postgres] */
export type VwScheduledOrderShipOwnerOrdersPg = {
  __typename?: 'VwScheduledOrderShipOwnerOrdersPg';
  orderId?: Maybe<Scalars['Int']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  shipOwnerOrgId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwScheduledOrderShipOwnerOrdersPg` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwScheduledOrderShipOwnerOrdersPgCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shared` field. */
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `shipOwnerOrgId` field. */
  shipOwnerOrgId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwScheduledOrderShipOwnerOrdersPg` object types. All fields are combined with a logical ‘and.’ */
export type VwScheduledOrderShipOwnerOrdersPgFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwScheduledOrderShipOwnerOrdersPgFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwScheduledOrderShipOwnerOrdersPgFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwScheduledOrderShipOwnerOrdersPgFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shared` field. */
  shared?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `shipOwnerOrgId` field. */
  shipOwnerOrgId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwScheduledOrderShipOwnerOrdersPg` values. */
export type VwScheduledOrderShipOwnerOrdersPgsConnection = {
  __typename?: 'VwScheduledOrderShipOwnerOrdersPgsConnection';
  /** A list of edges which contains the `VwScheduledOrderShipOwnerOrdersPg` and cursor to aid in pagination. */
  edges: Array<VwScheduledOrderShipOwnerOrdersPgsEdge>;
  /** A list of `VwScheduledOrderShipOwnerOrdersPg` objects. */
  nodes: Array<Maybe<VwScheduledOrderShipOwnerOrdersPg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwScheduledOrderShipOwnerOrdersPg` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwScheduledOrderShipOwnerOrdersPg` edge in the connection. */
export type VwScheduledOrderShipOwnerOrdersPgsEdge = {
  __typename?: 'VwScheduledOrderShipOwnerOrdersPgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwScheduledOrderShipOwnerOrdersPg` at the end of the edge. */
  node?: Maybe<VwScheduledOrderShipOwnerOrdersPg>;
};

/** Methods to use when ordering `VwScheduledOrderShipOwnerOrdersPg`. */
export enum VwScheduledOrderShipOwnerOrdersPgsOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  SHARED_ASC = 'SHARED_ASC',
  SHARED_DESC = 'SHARED_DESC',
  SHIP_OWNER_ORG_ID_ASC = 'SHIP_OWNER_ORG_ID_ASC',
  SHIP_OWNER_ORG_ID_DESC = 'SHIP_OWNER_ORG_ID_DESC'
}

/** Return shared orders only and their association type (SPOT, COA, [SCHED]ULED) to senders/receivers [postgres] */
export type VwSharedOrdersOnlySenderReceiverPg = {
  __typename?: 'VwSharedOrdersOnlySenderReceiverPg';
  orderId?: Maybe<Scalars['Int']['output']>;
  receiverOrgId?: Maybe<Scalars['Int']['output']>;
  senderOrgId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `VwSharedOrdersOnlySenderReceiverPg` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwSharedOrdersOnlySenderReceiverPgCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `receiverOrgId` field. */
  receiverOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `senderOrgId` field. */
  senderOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `VwSharedOrdersOnlySenderReceiverPg` object types. All fields are combined with a logical ‘and.’ */
export type VwSharedOrdersOnlySenderReceiverPgFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwSharedOrdersOnlySenderReceiverPgFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwSharedOrdersOnlySenderReceiverPgFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwSharedOrdersOnlySenderReceiverPgFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `receiverOrgId` field. */
  receiverOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `senderOrgId` field. */
  senderOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
};

/** A connection to a list of `VwSharedOrdersOnlySenderReceiverPg` values. */
export type VwSharedOrdersOnlySenderReceiverPgsConnection = {
  __typename?: 'VwSharedOrdersOnlySenderReceiverPgsConnection';
  /** A list of edges which contains the `VwSharedOrdersOnlySenderReceiverPg` and cursor to aid in pagination. */
  edges: Array<VwSharedOrdersOnlySenderReceiverPgsEdge>;
  /** A list of `VwSharedOrdersOnlySenderReceiverPg` objects. */
  nodes: Array<Maybe<VwSharedOrdersOnlySenderReceiverPg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwSharedOrdersOnlySenderReceiverPg` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwSharedOrdersOnlySenderReceiverPg` edge in the connection. */
export type VwSharedOrdersOnlySenderReceiverPgsEdge = {
  __typename?: 'VwSharedOrdersOnlySenderReceiverPgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwSharedOrdersOnlySenderReceiverPg` at the end of the edge. */
  node?: Maybe<VwSharedOrdersOnlySenderReceiverPg>;
};

/** Methods to use when ordering `VwSharedOrdersOnlySenderReceiverPg`. */
export enum VwSharedOrdersOnlySenderReceiverPgsOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  RECEIVER_ORG_ID_ASC = 'RECEIVER_ORG_ID_ASC',
  RECEIVER_ORG_ID_DESC = 'RECEIVER_ORG_ID_DESC',
  SENDER_ORG_ID_ASC = 'SENDER_ORG_ID_ASC',
  SENDER_ORG_ID_DESC = 'SENDER_ORG_ID_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export type VwShipsByOrder = {
  __typename?: 'VwShipsByOrder';
  assignmentType?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  shipName?: Maybe<Scalars['String']['output']>;
  shipOrgId?: Maybe<Scalars['Int']['output']>;
  shipOrgName?: Maybe<Scalars['String']['output']>;
  vesselId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwShipsByOrder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VwShipsByOrderCondition = {
  /** Checks for equality with the object’s `assignmentType` field. */
  assignmentType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipName` field. */
  shipName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `shipOrgId` field. */
  shipOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipOrgName` field. */
  shipOrgName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwShipsByOrder` object types. All fields are combined with a logical ‘and.’ */
export type VwShipsByOrderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwShipsByOrderFilter>>;
  /** Filter by the object’s `assignmentType` field. */
  assignmentType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwShipsByOrderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwShipsByOrderFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipName` field. */
  shipName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `shipOrgId` field. */
  shipOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipOrgName` field. */
  shipOrgName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwShipsByOrder` values. */
export type VwShipsByOrdersConnection = {
  __typename?: 'VwShipsByOrdersConnection';
  /** A list of edges which contains the `VwShipsByOrder` and cursor to aid in pagination. */
  edges: Array<VwShipsByOrdersEdge>;
  /** A list of `VwShipsByOrder` objects. */
  nodes: Array<Maybe<VwShipsByOrder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwShipsByOrder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwShipsByOrder` edge in the connection. */
export type VwShipsByOrdersEdge = {
  __typename?: 'VwShipsByOrdersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwShipsByOrder` at the end of the edge. */
  node?: Maybe<VwShipsByOrder>;
};

/** Methods to use when ordering `VwShipsByOrder`. */
export enum VwShipsByOrdersOrderBy {
  ASSIGNMENT_TYPE_ASC = 'ASSIGNMENT_TYPE_ASC',
  ASSIGNMENT_TYPE_DESC = 'ASSIGNMENT_TYPE_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  SHIP_NAME_ASC = 'SHIP_NAME_ASC',
  SHIP_NAME_DESC = 'SHIP_NAME_DESC',
  SHIP_ORG_ID_ASC = 'SHIP_ORG_ID_ASC',
  SHIP_ORG_ID_DESC = 'SHIP_ORG_ID_DESC',
  SHIP_ORG_NAME_ASC = 'SHIP_ORG_NAME_ASC',
  SHIP_ORG_NAME_DESC = 'SHIP_ORG_NAME_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

/** Return spot orders related to port agents [postgres] */
export type VwSpotOrdersPortAgentRelationPg = {
  __typename?: 'VwSpotOrdersPortAgentRelationPg';
  orderId?: Maybe<Scalars['Int']['output']>;
  portAgentOrgId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwSpotOrdersPortAgentRelationPg` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwSpotOrdersPortAgentRelationPgCondition = {
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `portAgentOrgId` field. */
  portAgentOrgId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwSpotOrdersPortAgentRelationPg` object types. All fields are combined with a logical ‘and.’ */
export type VwSpotOrdersPortAgentRelationPgFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwSpotOrdersPortAgentRelationPgFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwSpotOrdersPortAgentRelationPgFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwSpotOrdersPortAgentRelationPgFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `portAgentOrgId` field. */
  portAgentOrgId?: InputMaybe<IntFilter>;
};

/** A connection to a list of `VwSpotOrdersPortAgentRelationPg` values. */
export type VwSpotOrdersPortAgentRelationPgsConnection = {
  __typename?: 'VwSpotOrdersPortAgentRelationPgsConnection';
  /** A list of edges which contains the `VwSpotOrdersPortAgentRelationPg` and cursor to aid in pagination. */
  edges: Array<VwSpotOrdersPortAgentRelationPgsEdge>;
  /** A list of `VwSpotOrdersPortAgentRelationPg` objects. */
  nodes: Array<Maybe<VwSpotOrdersPortAgentRelationPg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwSpotOrdersPortAgentRelationPg` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwSpotOrdersPortAgentRelationPg` edge in the connection. */
export type VwSpotOrdersPortAgentRelationPgsEdge = {
  __typename?: 'VwSpotOrdersPortAgentRelationPgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwSpotOrdersPortAgentRelationPg` at the end of the edge. */
  node?: Maybe<VwSpotOrdersPortAgentRelationPg>;
};

/** Methods to use when ordering `VwSpotOrdersPortAgentRelationPg`. */
export enum VwSpotOrdersPortAgentRelationPgsOrderBy {
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  PORT_AGENT_ORG_ID_ASC = 'PORT_AGENT_ORG_ID_ASC',
  PORT_AGENT_ORG_ID_DESC = 'PORT_AGENT_ORG_ID_DESC'
}

export type VwStatementOfFactsChangelog = {
  __typename?: 'VwStatementOfFactsChangelog';
  mUserName?: Maybe<Scalars['String']['output']>;
  startSysPeriod?: Maybe<Scalars['Datetime']['output']>;
  statementOfFactsId?: Maybe<Scalars['Int']['output']>;
  statementOfFactsMsg?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * A condition to be used against `VwStatementOfFactsChangelog` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type VwStatementOfFactsChangelogCondition = {
  /** Checks for equality with the object’s `mUserName` field. */
  mUserName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `startSysPeriod` field. */
  startSysPeriod?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `statementOfFactsId` field. */
  statementOfFactsId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statementOfFactsMsg` field. */
  statementOfFactsMsg?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A filter to be used against `VwStatementOfFactsChangelog` object types. All fields are combined with a logical ‘and.’ */
export type VwStatementOfFactsChangelogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwStatementOfFactsChangelogFilter>>;
  /** Filter by the object’s `mUserName` field. */
  mUserName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwStatementOfFactsChangelogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwStatementOfFactsChangelogFilter>>;
  /** Filter by the object’s `startSysPeriod` field. */
  startSysPeriod?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `statementOfFactsId` field. */
  statementOfFactsId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statementOfFactsMsg` field. */
  statementOfFactsMsg?: InputMaybe<StringListFilter>;
};

/** A connection to a list of `VwStatementOfFactsChangelog` values. */
export type VwStatementOfFactsChangelogsConnection = {
  __typename?: 'VwStatementOfFactsChangelogsConnection';
  /** A list of edges which contains the `VwStatementOfFactsChangelog` and cursor to aid in pagination. */
  edges: Array<VwStatementOfFactsChangelogsEdge>;
  /** A list of `VwStatementOfFactsChangelog` objects. */
  nodes: Array<Maybe<VwStatementOfFactsChangelog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwStatementOfFactsChangelog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwStatementOfFactsChangelog` edge in the connection. */
export type VwStatementOfFactsChangelogsEdge = {
  __typename?: 'VwStatementOfFactsChangelogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwStatementOfFactsChangelog` at the end of the edge. */
  node?: Maybe<VwStatementOfFactsChangelog>;
};

/** Methods to use when ordering `VwStatementOfFactsChangelog`. */
export enum VwStatementOfFactsChangelogsOrderBy {
  M_USER_NAME_ASC = 'M_USER_NAME_ASC',
  M_USER_NAME_DESC = 'M_USER_NAME_DESC',
  NATURAL = 'NATURAL',
  START_SYS_PERIOD_ASC = 'START_SYS_PERIOD_ASC',
  START_SYS_PERIOD_DESC = 'START_SYS_PERIOD_DESC',
  STATEMENT_OF_FACTS_ID_ASC = 'STATEMENT_OF_FACTS_ID_ASC',
  STATEMENT_OF_FACTS_ID_DESC = 'STATEMENT_OF_FACTS_ID_DESC',
  STATEMENT_OF_FACTS_MSG_ASC = 'STATEMENT_OF_FACTS_MSG_ASC',
  STATEMENT_OF_FACTS_MSG_DESC = 'STATEMENT_OF_FACTS_MSG_DESC'
}

export type VwUserNotifyByOrderPg = {
  __typename?: 'VwUserNotifyByOrderPg';
  allDischargeDocumentUploaded?: Maybe<Scalars['Boolean']['output']>;
  allDischargeEta?: Maybe<Scalars['Boolean']['output']>;
  allDischargeEtb?: Maybe<Scalars['Boolean']['output']>;
  allDischargeEtd?: Maybe<Scalars['Boolean']['output']>;
  allDischargeMrSaved?: Maybe<Scalars['Boolean']['output']>;
  allDischargeNorSaved?: Maybe<Scalars['Boolean']['output']>;
  allDischargeSofSaved?: Maybe<Scalars['Boolean']['output']>;
  allLoadBlSaved?: Maybe<Scalars['Boolean']['output']>;
  allLoadDocumentUploaded?: Maybe<Scalars['Boolean']['output']>;
  allLoadEtaChanged?: Maybe<Scalars['Boolean']['output']>;
  allLoadEtbChanged?: Maybe<Scalars['Boolean']['output']>;
  allLoadEtdChanged?: Maybe<Scalars['Boolean']['output']>;
  allLoadNorSaved?: Maybe<Scalars['Boolean']['output']>;
  allLoadSofSaved?: Maybe<Scalars['Boolean']['output']>;
  allOrderPublishedEdited?: Maybe<Scalars['Boolean']['output']>;
  allOrderPublishedShippingPlan?: Maybe<Scalars['Boolean']['output']>;
  allOrderPublishedUnassignedShipment?: Maybe<Scalars['Boolean']['output']>;
  allOrderVesselChanged?: Maybe<Scalars['Boolean']['output']>;
  allOrdersUpsertedViaIntegration?: Maybe<Scalars['Boolean']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['Int']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  orgType?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  yourDischargeDocumentUploaded?: Maybe<Scalars['Boolean']['output']>;
  yourDischargeEta?: Maybe<Scalars['Boolean']['output']>;
  yourDischargeEtb?: Maybe<Scalars['Boolean']['output']>;
  yourDischargeEtd?: Maybe<Scalars['Boolean']['output']>;
  yourDischargeMrSaved?: Maybe<Scalars['Boolean']['output']>;
  yourDischargeNorSaved?: Maybe<Scalars['Boolean']['output']>;
  yourDischargeSofSaved?: Maybe<Scalars['Boolean']['output']>;
  yourLoadBlSaved?: Maybe<Scalars['Boolean']['output']>;
  yourLoadDocumentUploaded?: Maybe<Scalars['Boolean']['output']>;
  yourLoadEtaChanged?: Maybe<Scalars['Boolean']['output']>;
  yourLoadEtbChanged?: Maybe<Scalars['Boolean']['output']>;
  yourLoadEtdChanged?: Maybe<Scalars['Boolean']['output']>;
  yourLoadNorSaved?: Maybe<Scalars['Boolean']['output']>;
  yourLoadSofSaved?: Maybe<Scalars['Boolean']['output']>;
  yourOrderPublishedEdited?: Maybe<Scalars['Boolean']['output']>;
  yourOrderPublishedShippingPlan?: Maybe<Scalars['Boolean']['output']>;
  yourOrderPublishedUnassignedShipment?: Maybe<Scalars['Boolean']['output']>;
  yourOrderVesselChanged?: Maybe<Scalars['Boolean']['output']>;
  yourOrdersUpsertedViaIntegration?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A condition to be used against `VwUserNotifyByOrderPg` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type VwUserNotifyByOrderPgCondition = {
  /** Checks for equality with the object’s `allDischargeDocumentUploaded` field. */
  allDischargeDocumentUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allDischargeEta` field. */
  allDischargeEta?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allDischargeEtb` field. */
  allDischargeEtb?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allDischargeEtd` field. */
  allDischargeEtd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allDischargeMrSaved` field. */
  allDischargeMrSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allDischargeNorSaved` field. */
  allDischargeNorSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allDischargeSofSaved` field. */
  allDischargeSofSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allLoadBlSaved` field. */
  allLoadBlSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allLoadDocumentUploaded` field. */
  allLoadDocumentUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allLoadEtaChanged` field. */
  allLoadEtaChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allLoadEtbChanged` field. */
  allLoadEtbChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allLoadEtdChanged` field. */
  allLoadEtdChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allLoadNorSaved` field. */
  allLoadNorSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allLoadSofSaved` field. */
  allLoadSofSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allOrderPublishedEdited` field. */
  allOrderPublishedEdited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allOrderPublishedShippingPlan` field. */
  allOrderPublishedShippingPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allOrderPublishedUnassignedShipment` field. */
  allOrderPublishedUnassignedShipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allOrderVesselChanged` field. */
  allOrderVesselChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `allOrdersUpsertedViaIntegration` field. */
  allOrdersUpsertedViaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orgId` field. */
  orgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `orgName` field. */
  orgName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orgType` field. */
  orgType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userEmail` field. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `userName` field. */
  userName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `yourDischargeDocumentUploaded` field. */
  yourDischargeDocumentUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourDischargeEta` field. */
  yourDischargeEta?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourDischargeEtb` field. */
  yourDischargeEtb?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourDischargeEtd` field. */
  yourDischargeEtd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourDischargeMrSaved` field. */
  yourDischargeMrSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourDischargeNorSaved` field. */
  yourDischargeNorSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourDischargeSofSaved` field. */
  yourDischargeSofSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourLoadBlSaved` field. */
  yourLoadBlSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourLoadDocumentUploaded` field. */
  yourLoadDocumentUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourLoadEtaChanged` field. */
  yourLoadEtaChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourLoadEtbChanged` field. */
  yourLoadEtbChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourLoadEtdChanged` field. */
  yourLoadEtdChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourLoadNorSaved` field. */
  yourLoadNorSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourLoadSofSaved` field. */
  yourLoadSofSaved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourOrderPublishedEdited` field. */
  yourOrderPublishedEdited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourOrderPublishedShippingPlan` field. */
  yourOrderPublishedShippingPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourOrderPublishedUnassignedShipment` field. */
  yourOrderPublishedUnassignedShipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourOrderVesselChanged` field. */
  yourOrderVesselChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `yourOrdersUpsertedViaIntegration` field. */
  yourOrdersUpsertedViaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `VwUserNotifyByOrderPg` object types. All fields are combined with a logical ‘and.’ */
export type VwUserNotifyByOrderPgFilter = {
  /** Filter by the object’s `allDischargeDocumentUploaded` field. */
  allDischargeDocumentUploaded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allDischargeEta` field. */
  allDischargeEta?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allDischargeEtb` field. */
  allDischargeEtb?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allDischargeEtd` field. */
  allDischargeEtd?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allDischargeMrSaved` field. */
  allDischargeMrSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allDischargeNorSaved` field. */
  allDischargeNorSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allDischargeSofSaved` field. */
  allDischargeSofSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allLoadBlSaved` field. */
  allLoadBlSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allLoadDocumentUploaded` field. */
  allLoadDocumentUploaded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allLoadEtaChanged` field. */
  allLoadEtaChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allLoadEtbChanged` field. */
  allLoadEtbChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allLoadEtdChanged` field. */
  allLoadEtdChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allLoadNorSaved` field. */
  allLoadNorSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allLoadSofSaved` field. */
  allLoadSofSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allOrderPublishedEdited` field. */
  allOrderPublishedEdited?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allOrderPublishedShippingPlan` field. */
  allOrderPublishedShippingPlan?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allOrderPublishedUnassignedShipment` field. */
  allOrderPublishedUnassignedShipment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allOrderVesselChanged` field. */
  allOrderVesselChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `allOrdersUpsertedViaIntegration` field. */
  allOrdersUpsertedViaIntegration?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwUserNotifyByOrderPgFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<VwUserNotifyByOrderPgFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwUserNotifyByOrderPgFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orgId` field. */
  orgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `orgName` field. */
  orgName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orgType` field. */
  orgType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userEmail` field. */
  userEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userName` field. */
  userName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `yourDischargeDocumentUploaded` field. */
  yourDischargeDocumentUploaded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourDischargeEta` field. */
  yourDischargeEta?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourDischargeEtb` field. */
  yourDischargeEtb?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourDischargeEtd` field. */
  yourDischargeEtd?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourDischargeMrSaved` field. */
  yourDischargeMrSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourDischargeNorSaved` field. */
  yourDischargeNorSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourDischargeSofSaved` field. */
  yourDischargeSofSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourLoadBlSaved` field. */
  yourLoadBlSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourLoadDocumentUploaded` field. */
  yourLoadDocumentUploaded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourLoadEtaChanged` field. */
  yourLoadEtaChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourLoadEtbChanged` field. */
  yourLoadEtbChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourLoadEtdChanged` field. */
  yourLoadEtdChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourLoadNorSaved` field. */
  yourLoadNorSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourLoadSofSaved` field. */
  yourLoadSofSaved?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourOrderPublishedEdited` field. */
  yourOrderPublishedEdited?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourOrderPublishedShippingPlan` field. */
  yourOrderPublishedShippingPlan?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourOrderPublishedUnassignedShipment` field. */
  yourOrderPublishedUnassignedShipment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourOrderVesselChanged` field. */
  yourOrderVesselChanged?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `yourOrdersUpsertedViaIntegration` field. */
  yourOrdersUpsertedViaIntegration?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `VwUserNotifyByOrderPg` values. */
export type VwUserNotifyByOrderPgsConnection = {
  __typename?: 'VwUserNotifyByOrderPgsConnection';
  /** A list of edges which contains the `VwUserNotifyByOrderPg` and cursor to aid in pagination. */
  edges: Array<VwUserNotifyByOrderPgsEdge>;
  /** A list of `VwUserNotifyByOrderPg` objects. */
  nodes: Array<Maybe<VwUserNotifyByOrderPg>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwUserNotifyByOrderPg` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwUserNotifyByOrderPg` edge in the connection. */
export type VwUserNotifyByOrderPgsEdge = {
  __typename?: 'VwUserNotifyByOrderPgsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwUserNotifyByOrderPg` at the end of the edge. */
  node?: Maybe<VwUserNotifyByOrderPg>;
};

/** Methods to use when ordering `VwUserNotifyByOrderPg`. */
export enum VwUserNotifyByOrderPgsOrderBy {
  ALL_DISCHARGE_DOCUMENT_UPLOADED_ASC = 'ALL_DISCHARGE_DOCUMENT_UPLOADED_ASC',
  ALL_DISCHARGE_DOCUMENT_UPLOADED_DESC = 'ALL_DISCHARGE_DOCUMENT_UPLOADED_DESC',
  ALL_DISCHARGE_ETA_ASC = 'ALL_DISCHARGE_ETA_ASC',
  ALL_DISCHARGE_ETA_DESC = 'ALL_DISCHARGE_ETA_DESC',
  ALL_DISCHARGE_ETB_ASC = 'ALL_DISCHARGE_ETB_ASC',
  ALL_DISCHARGE_ETB_DESC = 'ALL_DISCHARGE_ETB_DESC',
  ALL_DISCHARGE_ETD_ASC = 'ALL_DISCHARGE_ETD_ASC',
  ALL_DISCHARGE_ETD_DESC = 'ALL_DISCHARGE_ETD_DESC',
  ALL_DISCHARGE_MR_SAVED_ASC = 'ALL_DISCHARGE_MR_SAVED_ASC',
  ALL_DISCHARGE_MR_SAVED_DESC = 'ALL_DISCHARGE_MR_SAVED_DESC',
  ALL_DISCHARGE_NOR_SAVED_ASC = 'ALL_DISCHARGE_NOR_SAVED_ASC',
  ALL_DISCHARGE_NOR_SAVED_DESC = 'ALL_DISCHARGE_NOR_SAVED_DESC',
  ALL_DISCHARGE_SOF_SAVED_ASC = 'ALL_DISCHARGE_SOF_SAVED_ASC',
  ALL_DISCHARGE_SOF_SAVED_DESC = 'ALL_DISCHARGE_SOF_SAVED_DESC',
  ALL_LOAD_BL_SAVED_ASC = 'ALL_LOAD_BL_SAVED_ASC',
  ALL_LOAD_BL_SAVED_DESC = 'ALL_LOAD_BL_SAVED_DESC',
  ALL_LOAD_DOCUMENT_UPLOADED_ASC = 'ALL_LOAD_DOCUMENT_UPLOADED_ASC',
  ALL_LOAD_DOCUMENT_UPLOADED_DESC = 'ALL_LOAD_DOCUMENT_UPLOADED_DESC',
  ALL_LOAD_ETA_CHANGED_ASC = 'ALL_LOAD_ETA_CHANGED_ASC',
  ALL_LOAD_ETA_CHANGED_DESC = 'ALL_LOAD_ETA_CHANGED_DESC',
  ALL_LOAD_ETB_CHANGED_ASC = 'ALL_LOAD_ETB_CHANGED_ASC',
  ALL_LOAD_ETB_CHANGED_DESC = 'ALL_LOAD_ETB_CHANGED_DESC',
  ALL_LOAD_ETD_CHANGED_ASC = 'ALL_LOAD_ETD_CHANGED_ASC',
  ALL_LOAD_ETD_CHANGED_DESC = 'ALL_LOAD_ETD_CHANGED_DESC',
  ALL_LOAD_NOR_SAVED_ASC = 'ALL_LOAD_NOR_SAVED_ASC',
  ALL_LOAD_NOR_SAVED_DESC = 'ALL_LOAD_NOR_SAVED_DESC',
  ALL_LOAD_SOF_SAVED_ASC = 'ALL_LOAD_SOF_SAVED_ASC',
  ALL_LOAD_SOF_SAVED_DESC = 'ALL_LOAD_SOF_SAVED_DESC',
  ALL_ORDERS_UPSERTED_VIA_INTEGRATION_ASC = 'ALL_ORDERS_UPSERTED_VIA_INTEGRATION_ASC',
  ALL_ORDERS_UPSERTED_VIA_INTEGRATION_DESC = 'ALL_ORDERS_UPSERTED_VIA_INTEGRATION_DESC',
  ALL_ORDER_PUBLISHED_EDITED_ASC = 'ALL_ORDER_PUBLISHED_EDITED_ASC',
  ALL_ORDER_PUBLISHED_EDITED_DESC = 'ALL_ORDER_PUBLISHED_EDITED_DESC',
  ALL_ORDER_PUBLISHED_SHIPPING_PLAN_ASC = 'ALL_ORDER_PUBLISHED_SHIPPING_PLAN_ASC',
  ALL_ORDER_PUBLISHED_SHIPPING_PLAN_DESC = 'ALL_ORDER_PUBLISHED_SHIPPING_PLAN_DESC',
  ALL_ORDER_PUBLISHED_UNASSIGNED_SHIPMENT_ASC = 'ALL_ORDER_PUBLISHED_UNASSIGNED_SHIPMENT_ASC',
  ALL_ORDER_PUBLISHED_UNASSIGNED_SHIPMENT_DESC = 'ALL_ORDER_PUBLISHED_UNASSIGNED_SHIPMENT_DESC',
  ALL_ORDER_VESSEL_CHANGED_ASC = 'ALL_ORDER_VESSEL_CHANGED_ASC',
  ALL_ORDER_VESSEL_CHANGED_DESC = 'ALL_ORDER_VESSEL_CHANGED_DESC',
  NATURAL = 'NATURAL',
  ORDER_ID_ASC = 'ORDER_ID_ASC',
  ORDER_ID_DESC = 'ORDER_ID_DESC',
  ORG_ID_ASC = 'ORG_ID_ASC',
  ORG_ID_DESC = 'ORG_ID_DESC',
  ORG_NAME_ASC = 'ORG_NAME_ASC',
  ORG_NAME_DESC = 'ORG_NAME_DESC',
  ORG_TYPE_ASC = 'ORG_TYPE_ASC',
  ORG_TYPE_DESC = 'ORG_TYPE_DESC',
  USER_EMAIL_ASC = 'USER_EMAIL_ASC',
  USER_EMAIL_DESC = 'USER_EMAIL_DESC',
  USER_ID_ASC = 'USER_ID_ASC',
  USER_ID_DESC = 'USER_ID_DESC',
  USER_NAME_ASC = 'USER_NAME_ASC',
  USER_NAME_DESC = 'USER_NAME_DESC',
  YOUR_DISCHARGE_DOCUMENT_UPLOADED_ASC = 'YOUR_DISCHARGE_DOCUMENT_UPLOADED_ASC',
  YOUR_DISCHARGE_DOCUMENT_UPLOADED_DESC = 'YOUR_DISCHARGE_DOCUMENT_UPLOADED_DESC',
  YOUR_DISCHARGE_ETA_ASC = 'YOUR_DISCHARGE_ETA_ASC',
  YOUR_DISCHARGE_ETA_DESC = 'YOUR_DISCHARGE_ETA_DESC',
  YOUR_DISCHARGE_ETB_ASC = 'YOUR_DISCHARGE_ETB_ASC',
  YOUR_DISCHARGE_ETB_DESC = 'YOUR_DISCHARGE_ETB_DESC',
  YOUR_DISCHARGE_ETD_ASC = 'YOUR_DISCHARGE_ETD_ASC',
  YOUR_DISCHARGE_ETD_DESC = 'YOUR_DISCHARGE_ETD_DESC',
  YOUR_DISCHARGE_MR_SAVED_ASC = 'YOUR_DISCHARGE_MR_SAVED_ASC',
  YOUR_DISCHARGE_MR_SAVED_DESC = 'YOUR_DISCHARGE_MR_SAVED_DESC',
  YOUR_DISCHARGE_NOR_SAVED_ASC = 'YOUR_DISCHARGE_NOR_SAVED_ASC',
  YOUR_DISCHARGE_NOR_SAVED_DESC = 'YOUR_DISCHARGE_NOR_SAVED_DESC',
  YOUR_DISCHARGE_SOF_SAVED_ASC = 'YOUR_DISCHARGE_SOF_SAVED_ASC',
  YOUR_DISCHARGE_SOF_SAVED_DESC = 'YOUR_DISCHARGE_SOF_SAVED_DESC',
  YOUR_LOAD_BL_SAVED_ASC = 'YOUR_LOAD_BL_SAVED_ASC',
  YOUR_LOAD_BL_SAVED_DESC = 'YOUR_LOAD_BL_SAVED_DESC',
  YOUR_LOAD_DOCUMENT_UPLOADED_ASC = 'YOUR_LOAD_DOCUMENT_UPLOADED_ASC',
  YOUR_LOAD_DOCUMENT_UPLOADED_DESC = 'YOUR_LOAD_DOCUMENT_UPLOADED_DESC',
  YOUR_LOAD_ETA_CHANGED_ASC = 'YOUR_LOAD_ETA_CHANGED_ASC',
  YOUR_LOAD_ETA_CHANGED_DESC = 'YOUR_LOAD_ETA_CHANGED_DESC',
  YOUR_LOAD_ETB_CHANGED_ASC = 'YOUR_LOAD_ETB_CHANGED_ASC',
  YOUR_LOAD_ETB_CHANGED_DESC = 'YOUR_LOAD_ETB_CHANGED_DESC',
  YOUR_LOAD_ETD_CHANGED_ASC = 'YOUR_LOAD_ETD_CHANGED_ASC',
  YOUR_LOAD_ETD_CHANGED_DESC = 'YOUR_LOAD_ETD_CHANGED_DESC',
  YOUR_LOAD_NOR_SAVED_ASC = 'YOUR_LOAD_NOR_SAVED_ASC',
  YOUR_LOAD_NOR_SAVED_DESC = 'YOUR_LOAD_NOR_SAVED_DESC',
  YOUR_LOAD_SOF_SAVED_ASC = 'YOUR_LOAD_SOF_SAVED_ASC',
  YOUR_LOAD_SOF_SAVED_DESC = 'YOUR_LOAD_SOF_SAVED_DESC',
  YOUR_ORDERS_UPSERTED_VIA_INTEGRATION_ASC = 'YOUR_ORDERS_UPSERTED_VIA_INTEGRATION_ASC',
  YOUR_ORDERS_UPSERTED_VIA_INTEGRATION_DESC = 'YOUR_ORDERS_UPSERTED_VIA_INTEGRATION_DESC',
  YOUR_ORDER_PUBLISHED_EDITED_ASC = 'YOUR_ORDER_PUBLISHED_EDITED_ASC',
  YOUR_ORDER_PUBLISHED_EDITED_DESC = 'YOUR_ORDER_PUBLISHED_EDITED_DESC',
  YOUR_ORDER_PUBLISHED_SHIPPING_PLAN_ASC = 'YOUR_ORDER_PUBLISHED_SHIPPING_PLAN_ASC',
  YOUR_ORDER_PUBLISHED_SHIPPING_PLAN_DESC = 'YOUR_ORDER_PUBLISHED_SHIPPING_PLAN_DESC',
  YOUR_ORDER_PUBLISHED_UNASSIGNED_SHIPMENT_ASC = 'YOUR_ORDER_PUBLISHED_UNASSIGNED_SHIPMENT_ASC',
  YOUR_ORDER_PUBLISHED_UNASSIGNED_SHIPMENT_DESC = 'YOUR_ORDER_PUBLISHED_UNASSIGNED_SHIPMENT_DESC',
  YOUR_ORDER_VESSEL_CHANGED_ASC = 'YOUR_ORDER_VESSEL_CHANGED_ASC',
  YOUR_ORDER_VESSEL_CHANGED_DESC = 'YOUR_ORDER_VESSEL_CHANGED_DESC'
}

export type VwVoyageCharterShipownerNonfinancial = {
  __typename?: 'VwVoyageCharterShipownerNonfinancial';
  cancelling?: Maybe<Scalars['Datetime']['output']>;
  chartererOrgId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  layday?: Maybe<Scalars['Datetime']['output']>;
  organisationId?: Maybe<Scalars['Int']['output']>;
  rootOrg?: Maybe<Scalars['Int']['output']>;
  shipownerOrgId?: Maybe<Scalars['Int']['output']>;
  vesselId?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `VwVoyageCharterShipownerNonfinancial` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type VwVoyageCharterShipownerNonfinancialCondition = {
  /** Checks for equality with the object’s `cancelling` field. */
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `layday` field. */
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shipownerOrgId` field. */
  shipownerOrgId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `vesselId` field. */
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `VwVoyageCharterShipownerNonfinancial` object types. All fields are combined with a logical ‘and.’ */
export type VwVoyageCharterShipownerNonfinancialFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VwVoyageCharterShipownerNonfinancialFilter>>;
  /** Filter by the object’s `cancelling` field. */
  cancelling?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `chartererOrgId` field. */
  chartererOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `layday` field. */
  layday?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VwVoyageCharterShipownerNonfinancialFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VwVoyageCharterShipownerNonfinancialFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shipownerOrgId` field. */
  shipownerOrgId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `vesselId` field. */
  vesselId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `VwVoyageCharterShipownerNonfinancial` */
export type VwVoyageCharterShipownerNonfinancialInput = {
  cancelling?: InputMaybe<Scalars['Datetime']['input']>;
  chartererOrgId?: InputMaybe<Scalars['Int']['input']>;
  layday?: InputMaybe<Scalars['Datetime']['input']>;
  organisationId?: InputMaybe<Scalars['Int']['input']>;
  rootOrg?: InputMaybe<Scalars['Int']['input']>;
  shipownerOrgId?: InputMaybe<Scalars['Int']['input']>;
  vesselId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `VwVoyageCharterShipownerNonfinancial` values. */
export type VwVoyageCharterShipownerNonfinancialsConnection = {
  __typename?: 'VwVoyageCharterShipownerNonfinancialsConnection';
  /** A list of edges which contains the `VwVoyageCharterShipownerNonfinancial` and cursor to aid in pagination. */
  edges: Array<VwVoyageCharterShipownerNonfinancialsEdge>;
  /** A list of `VwVoyageCharterShipownerNonfinancial` objects. */
  nodes: Array<Maybe<VwVoyageCharterShipownerNonfinancial>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VwVoyageCharterShipownerNonfinancial` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VwVoyageCharterShipownerNonfinancial` edge in the connection. */
export type VwVoyageCharterShipownerNonfinancialsEdge = {
  __typename?: 'VwVoyageCharterShipownerNonfinancialsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VwVoyageCharterShipownerNonfinancial` at the end of the edge. */
  node?: Maybe<VwVoyageCharterShipownerNonfinancial>;
};

/** Methods to use when ordering `VwVoyageCharterShipownerNonfinancial`. */
export enum VwVoyageCharterShipownerNonfinancialsOrderBy {
  CANCELLING_ASC = 'CANCELLING_ASC',
  CANCELLING_DESC = 'CANCELLING_DESC',
  CHARTERER_ORG_ID_ASC = 'CHARTERER_ORG_ID_ASC',
  CHARTERER_ORG_ID_DESC = 'CHARTERER_ORG_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LAYDAY_ASC = 'LAYDAY_ASC',
  LAYDAY_DESC = 'LAYDAY_DESC',
  NATURAL = 'NATURAL',
  ORGANISATION_ID_ASC = 'ORGANISATION_ID_ASC',
  ORGANISATION_ID_DESC = 'ORGANISATION_ID_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  SHIPOWNER_ORG_ID_ASC = 'SHIPOWNER_ORG_ID_ASC',
  SHIPOWNER_ORG_ID_DESC = 'SHIPOWNER_ORG_ID_DESC',
  VESSEL_ID_ASC = 'VESSEL_ID_ASC',
  VESSEL_ID_DESC = 'VESSEL_ID_DESC'
}

export type Waypoint = {
  __typename?: 'Waypoint';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  seaCurrentDirection?: Maybe<Scalars['Float']['output']>;
  seaCurrentSpeed?: Maybe<Scalars['Float']['output']>;
  swellDirection?: Maybe<Scalars['Float']['output']>;
  swellSignificantHeight?: Maybe<Scalars['Float']['output']>;
  swellZeroCrossingPeriod?: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['String']['output'];
  timestampWhenLeaving: Scalars['String']['output'];
  waterDepth: Scalars['Float']['output'];
  windDirection?: Maybe<Scalars['Float']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
  windWavesDirection?: Maybe<Scalars['Float']['output']>;
  windWavesSignificantHeight?: Maybe<Scalars['Float']['output']>;
  windWavesZeroCrossingPeriod?: Maybe<Scalars['Float']['output']>;
};

export enum WeightCapacityType {
  DWAT = 'DWAT',
  DWCC = 'DWCC',
  DWT = 'DWT'
}

/** A filter to be used against WeightCapacityType fields. All fields are combined with a logical ‘and.’ */
export type WeightCapacityTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<WeightCapacityType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<WeightCapacityType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<WeightCapacityType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<WeightCapacityType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<WeightCapacityType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<WeightCapacityType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<WeightCapacityType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<WeightCapacityType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<WeightCapacityType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<WeightCapacityType>>;
};

export enum WeightUnits {
  ADMT = 'ADMT',
  BDMT = 'BDMT',
  GMT = 'GMT',
  KG = 'KG',
  LONGTON = 'LONGTON',
  POUND = 'POUND',
  SHORTTON = 'SHORTTON',
  TONNE = 'TONNE'
}

/** A filter to be used against WeightUnits fields. All fields are combined with a logical ‘and.’ */
export type WeightUnitsFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<WeightUnits>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<WeightUnits>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<WeightUnits>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<WeightUnits>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<WeightUnits>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<WeightUnits>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<WeightUnits>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<WeightUnits>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<WeightUnits>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<WeightUnits>>;
};

export type WorkHourPart = {
  __typename?: 'WorkHourPart';
  fromHours?: Maybe<Scalars['Int']['output']>;
  fromMinutes?: Maybe<Scalars['Int']['output']>;
  toHours?: Maybe<Scalars['Int']['output']>;
  toMinutes?: Maybe<Scalars['Int']['output']>;
};

/** An input for mutations affecting `WorkHourPart` */
export type WorkHourPartInput = {
  fromHours?: InputMaybe<Scalars['Int']['input']>;
  fromMinutes?: InputMaybe<Scalars['Int']['input']>;
  toHours?: InputMaybe<Scalars['Int']['input']>;
  toMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type Workhour = {
  __typename?: 'Workhour';
  workhours?: Maybe<Array<Maybe<WorkHourPart>>>;
};

/** An input for mutations affecting `Workhour` */
export type WorkhourInput = {
  workhours?: InputMaybe<Array<InputMaybe<WorkHourPartInput>>>;
};

export type WorldscaleFreight = Node & {
  __typename?: 'WorldscaleFreight';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  currency: Currency;
  fromLocationId: Scalars['LocationId']['output'];
  id: Scalars['WorldscaleFreightId']['output'];
  /** Reads a single `Location` that is related to this `WorldscaleFreight`. */
  locationByFromLocationId?: Maybe<Location>;
  /** Reads a single `Location` that is related to this `WorldscaleFreight`. */
  locationByToLocationId?: Maybe<Location>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `WorldscaleFreight`. */
  organizationByOrganizationId?: Maybe<Organization>;
  organizationId: Scalars['OrganizationId']['output'];
  rate: Scalars['BigFloat']['output'];
  route: Scalars['String']['output'];
  toLocationId: Scalars['LocationId']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  year: Scalars['Int']['output'];
};

/**
 * A condition to be used against `WorldscaleFreight` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorldscaleFreightCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Currency>;
  /** Checks for equality with the object’s `fromLocationId` field. */
  fromLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['WorldscaleFreightId']['input']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `rate` field. */
  rate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `route` field. */
  route?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `toLocationId` field. */
  toLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `WorldscaleFreight` object types. All fields are combined with a logical ‘and.’ */
export type WorldscaleFreightFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorldscaleFreightFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<CurrencyFilter>;
  /** Filter by the object’s `fromLocationId` field. */
  fromLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorldscaleFreightFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorldscaleFreightFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rate` field. */
  rate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `route` field. */
  route?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toLocationId` field. */
  toLocationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `WorldscaleFreight` */
export type WorldscaleFreightInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency: Currency;
  fromLocationId: Scalars['LocationId']['input'];
  organizationId: Scalars['OrganizationId']['input'];
  rate: Scalars['BigFloat']['input'];
  route: Scalars['String']['input'];
  toLocationId: Scalars['LocationId']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  year: Scalars['Int']['input'];
};

/** Represents an update to a `WorldscaleFreight`. Fields that are set will be updated. */
export type WorldscaleFreightPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  currency?: InputMaybe<Currency>;
  fromLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  rate?: InputMaybe<Scalars['BigFloat']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  toLocationId?: InputMaybe<Scalars['LocationId']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type WorldscaleFreightSubscriptionPayload = {
  __typename?: 'WorldscaleFreightSubscriptionPayload';
  event?: Maybe<Scalars['String']['output']>;
  worldscaleFreight?: Maybe<WorldscaleFreight>;
};

/** A connection to a list of `WorldscaleFreight` values. */
export type WorldscaleFreightsConnection = {
  __typename?: 'WorldscaleFreightsConnection';
  /** A list of edges which contains the `WorldscaleFreight` and cursor to aid in pagination. */
  edges: Array<WorldscaleFreightsEdge>;
  /** A list of `WorldscaleFreight` objects. */
  nodes: Array<Maybe<WorldscaleFreight>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorldscaleFreight` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WorldscaleFreight` edge in the connection. */
export type WorldscaleFreightsEdge = {
  __typename?: 'WorldscaleFreightsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WorldscaleFreight` at the end of the edge. */
  node?: Maybe<WorldscaleFreight>;
};

/** Methods to use when ordering `WorldscaleFreight`. */
export enum WorldscaleFreightsOrderBy {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CURRENCY_ASC = 'CURRENCY_ASC',
  CURRENCY_DESC = 'CURRENCY_DESC',
  FROM_LOCATION_ID_ASC = 'FROM_LOCATION_ID_ASC',
  FROM_LOCATION_ID_DESC = 'FROM_LOCATION_ID_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NATURAL = 'NATURAL',
  ORGANIZATION_ID_ASC = 'ORGANIZATION_ID_ASC',
  ORGANIZATION_ID_DESC = 'ORGANIZATION_ID_DESC',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  RATE_ASC = 'RATE_ASC',
  RATE_DESC = 'RATE_DESC',
  ROUTE_ASC = 'ROUTE_ASC',
  ROUTE_DESC = 'ROUTE_DESC',
  TO_LOCATION_ID_ASC = 'TO_LOCATION_ID_ASC',
  TO_LOCATION_ID_DESC = 'TO_LOCATION_ID_DESC',
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
  YEAR_ASC = 'YEAR_ASC',
  YEAR_DESC = 'YEAR_DESC'
}

export type Zone = Node & {
  __typename?: 'Zone';
  /** Reads and enables pagination through a set of `CoaContractDeviationCost`. */
  coaContractDeviationCostsByFromZoneId: CoaContractDeviationCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractDeviationCost`. */
  coaContractDeviationCostsByToZoneId: CoaContractDeviationCostsConnection;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  coaContractPortsByDestinationZoneId: CoaContractPortsConnection;
  /** Reads and enables pagination through a set of `CoaContractPort`. */
  coaContractPortsByOriginZoneId: CoaContractPortsConnection;
  id: Scalars['ZoneId']['output'];
  /** Reads and enables pagination through a set of `LocationRequirementAssociation`. */
  locationRequirementAssociationsByZoneId: LocationRequirementAssociationsConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `Zone`. */
  organizationByRootOrg?: Maybe<Organization>;
  /** Reads and enables pagination through a set of `PortCommodityLdRate`. */
  portCommodityLdRatesByZoneId: PortCommodityLdRatesConnection;
  rootOrg?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads and enables pagination through a set of `ZoneLocation`. */
  zoneLocationsByZoneId: ZoneLocationsConnection;
};


export type ZoneCoaContractDeviationCostsByFromZoneIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractDeviationCostCondition>;
  filter?: InputMaybe<CoaContractDeviationCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};


export type ZoneCoaContractDeviationCostsByToZoneIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractDeviationCostCondition>;
  filter?: InputMaybe<CoaContractDeviationCostFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractDeviationCostsOrderBy>>;
};


export type ZoneCoaContractPortsByDestinationZoneIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


export type ZoneCoaContractPortsByOriginZoneIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CoaContractPortCondition>;
  filter?: InputMaybe<CoaContractPortFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoaContractPortsOrderBy>>;
};


export type ZoneLocationRequirementAssociationsByZoneIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LocationRequirementAssociationCondition>;
  filter?: InputMaybe<LocationRequirementAssociationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
};


export type ZonePortCommodityLdRatesByZoneIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PortCommodityLdRateCondition>;
  filter?: InputMaybe<PortCommodityLdRateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
};


export type ZoneZoneLocationsByZoneIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ZoneLocationCondition>;
  filter?: InputMaybe<ZoneLocationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ZoneLocationsOrderBy>>;
};

/** A condition to be used against `Zone` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ZoneCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ZoneId']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A filter to be used against `Zone` object types. All fields are combined with a logical ‘and.’ */
export type ZoneFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Zone` */
export type ZoneInput = {
  name: Scalars['String']['input'];
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

export type ZoneLocation = Node & {
  __typename?: 'ZoneLocation';
  id: Scalars['ZoneLocationId']['output'];
  /** Reads a single `Location` that is related to this `ZoneLocation`. */
  locationByLocationId?: Maybe<Location>;
  locationId: Scalars['LocationId']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organization` that is related to this `ZoneLocation`. */
  organizationByRootOrg?: Maybe<Organization>;
  rootOrg?: Maybe<Scalars['OrganizationId']['output']>;
  /** Reads a single `Zone` that is related to this `ZoneLocation`. */
  zoneByZoneId?: Maybe<Zone>;
  zoneId: Scalars['ZoneId']['output'];
};

/**
 * A condition to be used against `ZoneLocation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ZoneLocationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['ZoneLocationId']['input']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  /** Checks for equality with the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Checks for equality with the object’s `zoneId` field. */
  zoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A filter to be used against `ZoneLocation` object types. All fields are combined with a logical ‘and.’ */
export type ZoneLocationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ZoneLocationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ZoneLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ZoneLocationFilter>>;
  /** Filter by the object’s `rootOrg` field. */
  rootOrg?: InputMaybe<IntFilter>;
  /** Filter by the object’s `zoneId` field. */
  zoneId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ZoneLocation` */
export type ZoneLocationInput = {
  locationId: Scalars['LocationId']['input'];
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  zoneId: Scalars['ZoneId']['input'];
};

/** Represents an update to a `ZoneLocation`. Fields that are set will be updated. */
export type ZoneLocationPatch = {
  locationId?: InputMaybe<Scalars['LocationId']['input']>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
  zoneId?: InputMaybe<Scalars['ZoneId']['input']>;
};

/** A connection to a list of `ZoneLocation` values. */
export type ZoneLocationsConnection = {
  __typename?: 'ZoneLocationsConnection';
  /** A list of edges which contains the `ZoneLocation` and cursor to aid in pagination. */
  edges: Array<ZoneLocationsEdge>;
  /** A list of `ZoneLocation` objects. */
  nodes: Array<Maybe<ZoneLocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ZoneLocation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ZoneLocation` edge in the connection. */
export type ZoneLocationsEdge = {
  __typename?: 'ZoneLocationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ZoneLocation` at the end of the edge. */
  node?: Maybe<ZoneLocation>;
};

/** Methods to use when ordering `ZoneLocation`. */
export enum ZoneLocationsOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  LOCATION_ID_ASC = 'LOCATION_ID_ASC',
  LOCATION_ID_DESC = 'LOCATION_ID_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC',
  ZONE_ID_ASC = 'ZONE_ID_ASC',
  ZONE_ID_DESC = 'ZONE_ID_DESC'
}

/** Represents an update to a `Zone`. Fields that are set will be updated. */
export type ZonePatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  rootOrg?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** A connection to a list of `Zone` values. */
export type ZonesConnection = {
  __typename?: 'ZonesConnection';
  /** A list of edges which contains the `Zone` and cursor to aid in pagination. */
  edges: Array<ZonesEdge>;
  /** A list of `Zone` objects. */
  nodes: Array<Maybe<Zone>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Zone` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Zone` edge in the connection. */
export type ZonesEdge = {
  __typename?: 'ZonesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Zone` at the end of the edge. */
  node?: Maybe<Zone>;
};

/** Methods to use when ordering `Zone`. */
export enum ZonesOrderBy {
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NATURAL = 'NATURAL',
  PRIMARY_KEY_ASC = 'PRIMARY_KEY_ASC',
  PRIMARY_KEY_DESC = 'PRIMARY_KEY_DESC',
  ROOT_ORG_ASC = 'ROOT_ORG_ASC',
  ROOT_ORG_DESC = 'ROOT_ORG_DESC'
}

export type ArchiveInput = {
  handledByCoaIds?: InputMaybe<Array<Scalars['HandledByCoaId']['input']>>;
  handledBySpotIds?: InputMaybe<Array<Scalars['HandledBySpotId']['input']>>;
  offHireIds?: InputMaybe<Array<Scalars['OffHireId']['input']>>;
  orderIds?: InputMaybe<Array<Scalars['OrderId']['input']>>;
  portCallIds?: InputMaybe<Array<Scalars['PortCallId']['input']>>;
  scheduledOrderIds?: InputMaybe<Array<Scalars['ScheduledOrderId']['input']>>;
  singleEventIds?: InputMaybe<Array<Scalars['SingleEventId']['input']>>;
};

export type ApiOrder_AdminFragment = { __typename?: 'ApiOrder', orderId?: number | null, externalOrderId: string, externalGroupingId?: string | null, chartererOrgName?: string | null, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, currency?: Currency | null, voyageCharterExternalId?: string | null, externalCoaId?: string | null, orderName?: string | null, cargoAmount?: string | number | null, cargoUnit?: string | null, marginUnit?: MarginUnit | null, assortmentName?: string | null, earliestLoading?: string | null, latestLoading?: string | null, earliestDischarging?: string | null, latestDischarging?: string | null, loadPortName?: string | null, loadingRate?: string | number | null, loadingUnit?: string | null, dischargePortName?: string | null, dischargingRate?: string | number | null, dischargingUnit?: string | null, nominatedVessel?: string | null };

export type CreateApiOrdersMutationVariables = Exact<{
  input: CreateApiOrdersInput;
}>;


export type CreateApiOrdersMutation = { __typename?: 'Mutation', createApiOrders?: { __typename?: 'CreateApiOrdersPayload', apiOrders: Array<{ __typename?: 'ApiOrder', orderId?: number | null, externalOrderId: string, externalGroupingId?: string | null, chartererOrgName?: string | null, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, currency?: Currency | null, voyageCharterExternalId?: string | null, externalCoaId?: string | null, orderName?: string | null, cargoAmount?: string | number | null, cargoUnit?: string | null, marginUnit?: MarginUnit | null, assortmentName?: string | null, earliestLoading?: string | null, latestLoading?: string | null, earliestDischarging?: string | null, latestDischarging?: string | null, loadPortName?: string | null, loadingRate?: string | number | null, loadingUnit?: string | null, dischargePortName?: string | null, dischargingRate?: string | number | null, dischargingUnit?: string | null, nominatedVessel?: string | null } | null> } | null };

export type ApiShip_AdminFragment = { __typename?: 'ApiShip', shipId?: number | null, shipName?: string | null, externalId?: string | null, imo?: string | number | null, speed?: string | number | null, consumption?: string | number | null, type?: VesselSpeedType | null, tag?: VesselSpeedTag | null, area?: VesselArea | null, gradeName?: string | null };

export type AllApiShipsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllApiShipsQuery = { __typename?: 'Query', allApiShips?: { __typename?: 'ApiShipsConnection', nodes: Array<{ __typename?: 'ApiShip', shipId?: number | null, shipName?: string | null, externalId?: string | null, imo?: string | number | null, speed?: string | number | null, consumption?: string | number | null, type?: VesselSpeedType | null, tag?: VesselSpeedTag | null, area?: VesselArea | null, gradeName?: string | null } | null> } | null };

export type CreateApiShipMutationVariables = Exact<{
  input: CreateApiShipInput;
}>;


export type CreateApiShipMutation = { __typename?: 'Mutation', createApiShip?: { __typename?: 'CreateApiShipPayload', apiShip?: { __typename?: 'ApiShip', shipId?: number | null, shipName?: string | null, externalId?: string | null, imo?: string | number | null, speed?: string | number | null, consumption?: string | number | null, type?: VesselSpeedType | null, tag?: VesselSpeedTag | null, area?: VesselArea | null, gradeName?: string | null } | null } | null };

export type AssortmentExclusion_AdminFragment = { __typename?: 'AssortmentExclusion', id: AssortmentExclusionId, nextAssortmentGroup?: AssortmentGroupId | null, previousAssortmentGroup?: AssortmentGroupId | null, nextAssortment?: AssortmentId | null, previousAssortment?: AssortmentId | null, voyages?: number | null, tanks?: number | null, cleaningPossible?: boolean | null, holdCleaningCost?: string | number | null, holdCleaningTimeHours?: string | number | null, vesselCostClassId?: VesselAttributeId | null, assortmentGroupByNextAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentGroupByPreviousAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByNextAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentByPreviousAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null };

export type AllAssortmentExclusionsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<AssortmentExclusionsOrderBy>>;
}>;


export type AllAssortmentExclusionsQuery = { __typename?: 'Query', allAssortmentExclusions?: { __typename?: 'AssortmentExclusionsConnection', nodes: Array<{ __typename?: 'AssortmentExclusion', id: AssortmentExclusionId, nextAssortmentGroup?: AssortmentGroupId | null, previousAssortmentGroup?: AssortmentGroupId | null, nextAssortment?: AssortmentId | null, previousAssortment?: AssortmentId | null, voyages?: number | null, tanks?: number | null, cleaningPossible?: boolean | null, holdCleaningCost?: string | number | null, holdCleaningTimeHours?: string | number | null, vesselCostClassId?: VesselAttributeId | null, assortmentGroupByNextAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentGroupByPreviousAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByNextAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentByPreviousAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null> } | null };

export type CreateAssortmentExclusionMutationVariables = Exact<{
  input: CreateAssortmentExclusionInput;
}>;


export type CreateAssortmentExclusionMutation = { __typename?: 'Mutation', createAssortmentExclusion?: { __typename?: 'CreateAssortmentExclusionPayload', assortmentExclusion?: { __typename?: 'AssortmentExclusion', id: AssortmentExclusionId, nextAssortmentGroup?: AssortmentGroupId | null, previousAssortmentGroup?: AssortmentGroupId | null, nextAssortment?: AssortmentId | null, previousAssortment?: AssortmentId | null, voyages?: number | null, tanks?: number | null, cleaningPossible?: boolean | null, holdCleaningCost?: string | number | null, holdCleaningTimeHours?: string | number | null, vesselCostClassId?: VesselAttributeId | null, assortmentGroupByNextAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentGroupByPreviousAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByNextAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentByPreviousAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null } | null };

export type UpdateAssortmentExclusionMutationVariables = Exact<{
  input: UpdateAssortmentExclusionByIdInput;
}>;


export type UpdateAssortmentExclusionMutation = { __typename?: 'Mutation', updateAssortmentExclusionById?: { __typename?: 'UpdateAssortmentExclusionPayload', assortmentExclusion?: { __typename?: 'AssortmentExclusion', id: AssortmentExclusionId, nextAssortmentGroup?: AssortmentGroupId | null, previousAssortmentGroup?: AssortmentGroupId | null, nextAssortment?: AssortmentId | null, previousAssortment?: AssortmentId | null, voyages?: number | null, tanks?: number | null, cleaningPossible?: boolean | null, holdCleaningCost?: string | number | null, holdCleaningTimeHours?: string | number | null, vesselCostClassId?: VesselAttributeId | null, assortmentGroupByNextAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentGroupByPreviousAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByNextAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentByPreviousAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null } | null };

export type DeleteAssortmentExclusionByIdMutationVariables = Exact<{
  input: DeleteAssortmentExclusionByIdInput;
}>;


export type DeleteAssortmentExclusionByIdMutation = { __typename?: 'Mutation', deleteAssortmentExclusionById?: { __typename?: 'DeleteAssortmentExclusionPayload', assortmentExclusion?: { __typename?: 'AssortmentExclusion', id: AssortmentExclusionId, nextAssortmentGroup?: AssortmentGroupId | null, previousAssortmentGroup?: AssortmentGroupId | null, nextAssortment?: AssortmentId | null, previousAssortment?: AssortmentId | null, voyages?: number | null, tanks?: number | null, cleaningPossible?: boolean | null, holdCleaningCost?: string | number | null, holdCleaningTimeHours?: string | number | null, vesselCostClassId?: VesselAttributeId | null, assortmentGroupByNextAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentGroupByPreviousAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByNextAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentByPreviousAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null } | null };

export type AssortmentGroup_AdminFragment = { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, requiresHeating?: boolean | null };

export type AllAssortmentGroupsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<AssortmentGroupsOrderBy>>;
}>;


export type AllAssortmentGroupsQuery = { __typename?: 'Query', allAssortmentGroups?: { __typename?: 'AssortmentGroupsConnection', nodes: Array<{ __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, requiresHeating?: boolean | null } | null> } | null };

export type CreateAssortmentGroupMutationVariables = Exact<{
  input: CreateAssortmentGroupInput;
}>;


export type CreateAssortmentGroupMutation = { __typename?: 'Mutation', createAssortmentGroup?: { __typename?: 'CreateAssortmentGroupPayload', assortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, requiresHeating?: boolean | null } | null } | null };

export type UpdateAssortmentGroupMutationVariables = Exact<{
  input: UpdateAssortmentGroupByIdInput;
}>;


export type UpdateAssortmentGroupMutation = { __typename?: 'Mutation', updateAssortmentGroupById?: { __typename?: 'UpdateAssortmentGroupPayload', assortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, requiresHeating?: boolean | null } | null } | null };

export type DeleteAssortmentGroupByIdMutationVariables = Exact<{
  input: DeleteAssortmentGroupByIdInput;
}>;


export type DeleteAssortmentGroupByIdMutation = { __typename?: 'Mutation', deleteAssortmentGroupById?: { __typename?: 'DeleteAssortmentGroupPayload', assortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, requiresHeating?: boolean | null } | null } | null };

export type Assortment_AdminFragment = { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, requiresHeating?: boolean | null, organizationId: OrganizationId, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, fillFactor?: string | number | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, imoClass?: ImoClass | null, cargoUnitId?: CargoUnitId | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, nameSynonyms?: Array<string | null> | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null };

export type AllAssortmentsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<AssortmentsOrderBy>>;
}>;


export type AllAssortmentsQuery = { __typename?: 'Query', allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, requiresHeating?: boolean | null, organizationId: OrganizationId, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, fillFactor?: string | number | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, imoClass?: ImoClass | null, cargoUnitId?: CargoUnitId | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, nameSynonyms?: Array<string | null> | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null> } | null };

export type AllCargoUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCargoUnitsQuery = { __typename?: 'Query', allCargoUnits?: { __typename?: 'CargoUnitsConnection', nodes: Array<{ __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null> } | null };

export type CreateAssortmentMutationVariables = Exact<{
  input: CreateAssortmentInput;
}>;


export type CreateAssortmentMutation = { __typename?: 'Mutation', createAssortment?: { __typename?: 'CreateAssortmentPayload', assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, requiresHeating?: boolean | null, organizationId: OrganizationId, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, fillFactor?: string | number | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, imoClass?: ImoClass | null, cargoUnitId?: CargoUnitId | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, nameSynonyms?: Array<string | null> | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null } | null };

export type UpdateAssortmentMutationVariables = Exact<{
  input: UpdateAssortmentByIdInput;
}>;


export type UpdateAssortmentMutation = { __typename?: 'Mutation', updateAssortmentById?: { __typename?: 'UpdateAssortmentPayload', assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, requiresHeating?: boolean | null, organizationId: OrganizationId, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, fillFactor?: string | number | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, imoClass?: ImoClass | null, cargoUnitId?: CargoUnitId | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, nameSynonyms?: Array<string | null> | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null } | null };

export type DeleteAssortmentByIdMutationVariables = Exact<{
  input: DeleteAssortmentByIdInput;
}>;


export type DeleteAssortmentByIdMutation = { __typename?: 'Mutation', deleteAssortmentById?: { __typename?: 'DeleteAssortmentPayload', assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, requiresHeating?: boolean | null, organizationId: OrganizationId, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, fillFactor?: string | number | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, imoClass?: ImoClass | null, cargoUnitId?: CargoUnitId | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, nameSynonyms?: Array<string | null> | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null } | null };

export type BunkerGradeOverride_AdminFragment = { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string, carbonFactor?: string | number | null, ch4Factor?: string | number | null, lcv?: string | number | null, n2OFactor?: string | number | null, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, price?: string | number | null, priceAdjustment?: string | number | null, createdAt: string, wttFactor?: string | number | null, isBlend: boolean, blendComponent1Id?: BunkerGradeOverrideId | null, blendComponent2Id?: BunkerGradeOverrideId | null, blendPercentage1?: string | number | null, blendPercentage2?: string | number | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, bunkerGradeOverrideByBlendComponent1Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null, bunkerGradeOverrideByBlendComponent2Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null };

export type AllBunkerGradeOverridesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<BunkerGradeOverridesOrderBy>>;
  filter?: InputMaybe<BunkerGradeOverrideFilter>;
}>;


export type AllBunkerGradeOverridesQuery = { __typename?: 'Query', allBunkerGradeOverrides?: { __typename?: 'BunkerGradeOverridesConnection', nodes: Array<{ __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string, carbonFactor?: string | number | null, ch4Factor?: string | number | null, lcv?: string | number | null, n2OFactor?: string | number | null, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, price?: string | number | null, priceAdjustment?: string | number | null, createdAt: string, wttFactor?: string | number | null, isBlend: boolean, blendComponent1Id?: BunkerGradeOverrideId | null, blendComponent2Id?: BunkerGradeOverrideId | null, blendPercentage1?: string | number | null, blendPercentage2?: string | number | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, bunkerGradeOverrideByBlendComponent1Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null, bunkerGradeOverrideByBlendComponent2Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null } | null> } | null };

export type CreateBunkerGradeOverrideMutationVariables = Exact<{
  input: CreateBunkerGradeOverrideInput;
}>;


export type CreateBunkerGradeOverrideMutation = { __typename?: 'Mutation', createBunkerGradeOverride?: { __typename?: 'CreateBunkerGradeOverridePayload', bunkerGradeOverride?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string, carbonFactor?: string | number | null, ch4Factor?: string | number | null, lcv?: string | number | null, n2OFactor?: string | number | null, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, price?: string | number | null, priceAdjustment?: string | number | null, createdAt: string, wttFactor?: string | number | null, isBlend: boolean, blendComponent1Id?: BunkerGradeOverrideId | null, blendComponent2Id?: BunkerGradeOverrideId | null, blendPercentage1?: string | number | null, blendPercentage2?: string | number | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, bunkerGradeOverrideByBlendComponent1Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null, bunkerGradeOverrideByBlendComponent2Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null } | null } | null };

export type UpdateBunkerGradeOverrideMutationVariables = Exact<{
  input: UpdateBunkerGradeOverrideByIdInput;
}>;


export type UpdateBunkerGradeOverrideMutation = { __typename?: 'Mutation', updateBunkerGradeOverrideById?: { __typename?: 'UpdateBunkerGradeOverridePayload', bunkerGradeOverride?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string, carbonFactor?: string | number | null, ch4Factor?: string | number | null, lcv?: string | number | null, n2OFactor?: string | number | null, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, price?: string | number | null, priceAdjustment?: string | number | null, createdAt: string, wttFactor?: string | number | null, isBlend: boolean, blendComponent1Id?: BunkerGradeOverrideId | null, blendComponent2Id?: BunkerGradeOverrideId | null, blendPercentage1?: string | number | null, blendPercentage2?: string | number | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, bunkerGradeOverrideByBlendComponent1Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null, bunkerGradeOverrideByBlendComponent2Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null } | null } | null };

export type DeleteBunkerGradeOverrideByIdMutationVariables = Exact<{
  input: DeleteBunkerGradeOverrideByIdInput;
}>;


export type DeleteBunkerGradeOverrideByIdMutation = { __typename?: 'Mutation', deleteBunkerGradeOverrideById?: { __typename?: 'DeleteBunkerGradeOverridePayload', bunkerGradeOverride?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string, carbonFactor?: string | number | null, ch4Factor?: string | number | null, lcv?: string | number | null, n2OFactor?: string | number | null, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, price?: string | number | null, priceAdjustment?: string | number | null, createdAt: string, wttFactor?: string | number | null, isBlend: boolean, blendComponent1Id?: BunkerGradeOverrideId | null, blendComponent2Id?: BunkerGradeOverrideId | null, blendPercentage1?: string | number | null, blendPercentage2?: string | number | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, bunkerGradeOverrideByBlendComponent1Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null, bunkerGradeOverrideByBlendComponent2Id?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string } | null } | null } | null };

export type CargoCompartment_AdminFragment = { __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null };

export type CreateCargoCompartmentMutationVariables = Exact<{
  input: CreateCargoCompartmentInput;
}>;


export type CreateCargoCompartmentMutation = { __typename?: 'Mutation', createCargoCompartment?: { __typename?: 'CreateCargoCompartmentPayload', vesselInfoByVesselId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number, mmsi: number, ownerOrganisationId: OrganizationId, year: number, flag: number, callSign?: string | null, heating?: boolean | null, loa: string | number, breadth: string | number, draft: string | number, cranes?: boolean | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, cargoCompartment?: { __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null } | null };

export type DeleteCargoCompartmentMutationVariables = Exact<{
  input: DeleteCargoCompartmentByIdInput;
}>;


export type DeleteCargoCompartmentMutation = { __typename?: 'Mutation', deleteCargoCompartmentById?: { __typename?: 'DeleteCargoCompartmentPayload', vesselInfoByVesselId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number, mmsi: number, ownerOrganisationId: OrganizationId, year: number, flag: number, callSign?: string | null, heating?: boolean | null, loa: string | number, breadth: string | number, draft: string | number, cranes?: boolean | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, cargoCompartment?: { __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null } | null };

export type UpdateCargoCompartmentMutationVariables = Exact<{
  input: UpdateCargoCompartmentByIdInput;
}>;


export type UpdateCargoCompartmentMutation = { __typename?: 'Mutation', updateCargoCompartmentById?: { __typename?: 'UpdateCargoCompartmentPayload', cargoCompartment?: { __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null } | null };

export type ChannelCostEstimate_AdminFragment = { __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, assortmentGroupId?: AssortmentGroupId | null, cargoCondition?: ChannelCostCargoCondition | null, channelName: string, channelCostCurrency: string, channelCost: string | number, durationOverhead?: string | number | null, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null };

export type AllChannelCostEstimatesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ChannelCostEstimatesOrderBy>>;
  filter?: InputMaybe<ChannelCostEstimateFilter>;
}>;


export type AllChannelCostEstimatesQuery = { __typename?: 'Query', allChannelCostEstimates?: { __typename?: 'ChannelCostEstimatesConnection', nodes: Array<{ __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, assortmentGroupId?: AssortmentGroupId | null, cargoCondition?: ChannelCostCargoCondition | null, channelName: string, channelCostCurrency: string, channelCost: string | number, durationOverhead?: string | number | null, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null> } | null };

export type CreateChannelCostEstimateMutationVariables = Exact<{
  input: CreateChannelCostEstimateInput;
}>;


export type CreateChannelCostEstimateMutation = { __typename?: 'Mutation', createChannelCostEstimate?: { __typename?: 'CreateChannelCostEstimatePayload', channelCostEstimate?: { __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, assortmentGroupId?: AssortmentGroupId | null, cargoCondition?: ChannelCostCargoCondition | null, channelName: string, channelCostCurrency: string, channelCost: string | number, durationOverhead?: string | number | null, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type UpdateChannelCostEstimateMutationVariables = Exact<{
  input: UpdateChannelCostEstimateByIdInput;
}>;


export type UpdateChannelCostEstimateMutation = { __typename?: 'Mutation', updateChannelCostEstimateById?: { __typename?: 'UpdateChannelCostEstimatePayload', channelCostEstimate?: { __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, assortmentGroupId?: AssortmentGroupId | null, cargoCondition?: ChannelCostCargoCondition | null, channelName: string, channelCostCurrency: string, channelCost: string | number, durationOverhead?: string | number | null, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type DeleteChannelCostEstimateByIdMutationVariables = Exact<{
  input: DeleteChannelCostEstimateByIdInput;
}>;


export type DeleteChannelCostEstimateByIdMutation = { __typename?: 'Mutation', deleteChannelCostEstimateById?: { __typename?: 'DeleteChannelCostEstimatePayload', channelCostEstimate?: { __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, assortmentGroupId?: AssortmentGroupId | null, cargoCondition?: ChannelCostCargoCondition | null, channelName: string, channelCostCurrency: string, channelCost: string | number, durationOverhead?: string | number | null, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type ChannelIncompatibility_AdminFragment = { __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, organizationId: number, vesselAttributeId: VesselAttributeId, channelName: string, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null };

export type AllChannelIncompatibilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllChannelIncompatibilitiesQuery = { __typename?: 'Query', allChannelIncompatibilities?: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, organizationId: number, vesselAttributeId: VesselAttributeId, channelName: string, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null> } | null };

export type CreateChannelIncompatibilityMutationVariables = Exact<{
  input: CreateChannelIncompatibilityInput;
}>;


export type CreateChannelIncompatibilityMutation = { __typename?: 'Mutation', createChannelIncompatibility?: { __typename?: 'CreateChannelIncompatibilityPayload', channelIncompatibility?: { __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, organizationId: number, vesselAttributeId: VesselAttributeId, channelName: string, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type UpdateChannelIncompatibilityByIdMutationVariables = Exact<{
  input: UpdateChannelIncompatibilityByIdInput;
}>;


export type UpdateChannelIncompatibilityByIdMutation = { __typename?: 'Mutation', updateChannelIncompatibilityById?: { __typename?: 'UpdateChannelIncompatibilityPayload', channelIncompatibility?: { __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, organizationId: number, vesselAttributeId: VesselAttributeId, channelName: string, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type DeleteChannelIncompatibilityByIdMutationVariables = Exact<{
  input: DeleteChannelIncompatibilityByIdInput;
}>;


export type DeleteChannelIncompatibilityByIdMutation = { __typename?: 'Mutation', deleteChannelIncompatibilityById?: { __typename?: 'DeleteChannelIncompatibilityPayload', channelIncompatibility?: { __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, organizationId: number, vesselAttributeId: VesselAttributeId, channelName: string, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type GetOrderByExternalIdQueryVariables = Exact<{
  externalOrderId: Scalars['String']['input'];
}>;


export type GetOrderByExternalIdQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId } | null> }, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterId: VoyageCharterId } | null> } } | null> } | null };

export type GetVoyageCharterByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetVoyageCharterByIdQuery = { __typename?: 'Query', vcById?: { __typename?: 'VoyageCharter', id: VoyageCharterId, orderVoyageCharterRelationsByVoyageCharterId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId } | null> } } | null> }, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId } | null> } } | null };

export type UpdateOrderByExternalIdMutationVariables = Exact<{
  orderInput: UpdateOrderByIdInput;
  orderDetails: UpdateOrderDetailByIdInput;
  vc: UpdateVoyageCharterByIdInput;
}>;


export type UpdateOrderByExternalIdMutation = { __typename?: 'Mutation', updateOrderById?: { __typename?: 'UpdateOrderPayload', order?: { __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null } | null, updateOrderDetailById?: { __typename?: 'UpdateOrderDetailPayload', orderDetail?: { __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null } | null, updateVoyageCharterById?: { __typename?: 'UpdateVoyageCharterPayload', voyageCharter?: { __typename?: 'VoyageCharter', id: VoyageCharterId, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, currency?: Currency | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null };

export type UpdateVcOrderFreightByIdMutationVariables = Exact<{
  vcFreight: UpdateVoyageCharterOrderFreightByIdInput;
}>;


export type UpdateVcOrderFreightByIdMutation = { __typename?: 'Mutation', updateVoyageCharterOrderFreightById?: { __typename?: 'UpdateVoyageCharterOrderFreightPayload', voyageCharterOrderFreight?: { __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId } | null } | null };

export type UpdateVcToContractByIdMutationVariables = Exact<{
  vcContract: UpdateVoyageCharterToContractByIdInput;
}>;


export type UpdateVcToContractByIdMutation = { __typename?: 'Mutation', updateVoyageCharterToContractById?: { __typename?: 'UpdateVoyageCharterToContractPayload', voyageCharterToContract?: { __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId } | null } | null };

export type GenericOrderImportMutationVariables = Exact<{
  input: Array<InputMaybe<GenericOrderInput>>;
}>;


export type GenericOrderImportMutation = { __typename?: 'Mutation', genericOrderImport?: { __typename?: 'ImportOrderResultData', updatedOrderIds: Array<OrderId>, insertedOrderIds: Array<OrderId> } | null };

export type VesonConfig_AdminFragment = { __typename?: 'VesonConfig', id: number, organizationId: number, organizationName?: string | null, integrationUserId: number, token: string, cargoEndpoint?: string | null, extraFreightEndpoint?: string | null, commissionEndpoint?: string | null, vesselEndpoint?: string | null, portCostEndpoint?: string | null, pnlEndpoint?: string | null, robEndpoint?: string | null, graphqlEndpoint?: string | null, vesonOwnerType?: string | null, statusFilters?: Array<string> | null, isActive: boolean, hasVesonFeature: boolean };

export type ShipnetConfig_AdminFragment = { __typename?: 'ShipnetConfig', id: number, organizationId: number, organizationName?: string | null, integrationUserId: number, portCallEndpoint: string, authorizeKey: string, orderEndpoint?: string | null, refreshOrderEndpoint?: string | null, updateDateEndpoint?: string | null, setupCoaEndpoint?: string | null, loggingEndpoint?: string | null, operationalVoyageEndpoint?: string | null, bookingListEndpoint?: string | null, ignorePorts?: Array<string> | null, isActive: boolean, hasShipnetFeature: boolean };

export type BalticConfig_AdminFragment = { __typename?: 'BalticConfig', id: number, organizationId: number, organizationName?: string | null, integrationUserId: number, companyEndpoint: string, bookedCargoEndpoint: string, shipEndpoint: string, projectsEndpoint?: string | null, tokenUrl: string, clientId: string, clientSecret: string, scope: string, isActive: boolean, hasBalticFeature: boolean };

export type AllVesonConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVesonConfigsQuery = { __typename?: 'Query', allVesonConfigs: Array<{ __typename?: 'VesonConfig', id: number, organizationId: number, organizationName?: string | null, integrationUserId: number, token: string, cargoEndpoint?: string | null, extraFreightEndpoint?: string | null, commissionEndpoint?: string | null, vesselEndpoint?: string | null, portCostEndpoint?: string | null, pnlEndpoint?: string | null, robEndpoint?: string | null, graphqlEndpoint?: string | null, vesonOwnerType?: string | null, statusFilters?: Array<string> | null, isActive: boolean, hasVesonFeature: boolean }> };

export type AllShipnetConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllShipnetConfigsQuery = { __typename?: 'Query', allShipnetConfigs: Array<{ __typename?: 'ShipnetConfig', id: number, organizationId: number, organizationName?: string | null, integrationUserId: number, portCallEndpoint: string, authorizeKey: string, orderEndpoint?: string | null, refreshOrderEndpoint?: string | null, updateDateEndpoint?: string | null, setupCoaEndpoint?: string | null, loggingEndpoint?: string | null, operationalVoyageEndpoint?: string | null, bookingListEndpoint?: string | null, ignorePorts?: Array<string> | null, isActive: boolean, hasShipnetFeature: boolean }> };

export type AllBalticConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBalticConfigsQuery = { __typename?: 'Query', allBalticConfigs: Array<{ __typename?: 'BalticConfig', id: number, organizationId: number, organizationName?: string | null, integrationUserId: number, companyEndpoint: string, bookedCargoEndpoint: string, shipEndpoint: string, projectsEndpoint?: string | null, tokenUrl: string, clientId: string, clientSecret: string, scope: string, isActive: boolean, hasBalticFeature: boolean }> };

export type UpsertVesonConfigMutationVariables = Exact<{
  input: UpsertVesonConfigInput;
}>;


export type UpsertVesonConfigMutation = { __typename?: 'Mutation', upsertVesonConfig?: { __typename?: 'VesonConfigPayload', vesonConfig?: { __typename?: 'VesonConfig', id: number } | null } | null };

export type DeleteVesonConfigMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteVesonConfigMutation = { __typename?: 'Mutation', deleteVesonConfig?: { __typename?: 'VesonConfigPayload', vesonConfig?: { __typename?: 'VesonConfig', id: number } | null } | null };

export type UpsertShipnetConfigMutationVariables = Exact<{
  input: UpsertShipnetConfigInput;
}>;


export type UpsertShipnetConfigMutation = { __typename?: 'Mutation', upsertShipnetConfig?: { __typename?: 'ShipnetConfigPayload', shipnetConfig?: { __typename?: 'ShipnetConfig', id: number } | null } | null };

export type DeleteShipnetConfigMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteShipnetConfigMutation = { __typename?: 'Mutation', deleteShipnetConfig?: { __typename?: 'ShipnetConfigPayload', shipnetConfig?: { __typename?: 'ShipnetConfig', id: number } | null } | null };

export type UpsertBalticConfigMutationVariables = Exact<{
  input: UpsertBalticConfigInput;
}>;


export type UpsertBalticConfigMutation = { __typename?: 'Mutation', upsertBalticConfig?: { __typename?: 'BalticConfigPayload', balticConfig?: { __typename?: 'BalticConfig', id: number } | null } | null };

export type DeleteBalticConfigMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBalticConfigMutation = { __typename?: 'Mutation', deleteBalticConfig?: { __typename?: 'BalticConfigPayload', balticConfig?: { __typename?: 'BalticConfig', id: number } | null } | null };

export type AllLocationRequirementAssociationsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
}>;


export type AllLocationRequirementAssociationsQuery = { __typename?: 'Query', items?: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> } | null };

export type CreateLocationRequirementAssociationMutationVariables = Exact<{
  input: CreateLocationRequirementAssociationInput;
}>;


export type CreateLocationRequirementAssociationMutation = { __typename?: 'Mutation', createLocationRequirementAssociation?: { __typename?: 'CreateLocationRequirementAssociationPayload', locationRequirementAssociation?: { __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null } | null };

export type UpdateLocationRequirementAssociationMutationVariables = Exact<{
  input: UpdateLocationRequirementAssociationByIdInput;
}>;


export type UpdateLocationRequirementAssociationMutation = { __typename?: 'Mutation', updateLocationRequirementAssociationById?: { __typename?: 'UpdateLocationRequirementAssociationPayload', locationRequirementAssociation?: { __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null } | null };

export type DeleteLocationRequirementAssociationByIdMutationVariables = Exact<{
  input: DeleteLocationRequirementAssociationByIdInput;
}>;


export type DeleteLocationRequirementAssociationByIdMutation = { __typename?: 'Mutation', deleteLocationRequirementAssociationById?: { __typename?: 'DeleteLocationRequirementAssociationPayload', locationRequirementAssociation?: { __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null } | null };

export type NoGoZone_AdminFragment = { __typename?: 'NoGoZone', id: NoGoZoneId, name: string, polygon: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> };

export type AllNoGoZonesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<NoGoZonesOrderBy>>;
}>;


export type AllNoGoZonesQuery = { __typename?: 'Query', allNoGoZones?: { __typename?: 'NoGoZonesConnection', nodes: Array<{ __typename?: 'NoGoZone', id: NoGoZoneId, name: string, polygon: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> } | null> } | null };

export type CreateNoGoZoneMutationVariables = Exact<{
  input: CreateNoGoZoneInput;
}>;


export type CreateNoGoZoneMutation = { __typename?: 'Mutation', createNoGoZone?: { __typename?: 'CreateNoGoZonePayload', noGoZone?: { __typename?: 'NoGoZone', id: NoGoZoneId, name: string, polygon: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> } | null } | null };

export type UpdateNoGoZoneMutationVariables = Exact<{
  input: UpdateNoGoZoneByIdInput;
}>;


export type UpdateNoGoZoneMutation = { __typename?: 'Mutation', updateNoGoZoneById?: { __typename?: 'UpdateNoGoZonePayload', noGoZone?: { __typename?: 'NoGoZone', id: NoGoZoneId, name: string, polygon: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> } | null } | null };

export type DeleteNoGoZoneByIdMutationVariables = Exact<{
  input: DeleteNoGoZoneByIdInput;
}>;


export type DeleteNoGoZoneByIdMutation = { __typename?: 'Mutation', deleteNoGoZoneById?: { __typename?: 'DeleteNoGoZonePayload', noGoZone?: { __typename?: 'NoGoZone', id: NoGoZoneId, name: string, polygon: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> } | null } | null };

export type OrderAttribute_AdminFragment = { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type AllOrderAttributesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<OrderAttributesOrderBy>>;
}>;


export type AllOrderAttributesQuery = { __typename?: 'Query', allOrderAttributes?: { __typename?: 'OrderAttributesConnection', nodes: Array<{ __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } | null };

export type CreateOrderAttributeMutationVariables = Exact<{
  input: CreateOrderAttributeInput;
}>;


export type CreateOrderAttributeMutation = { __typename?: 'Mutation', createOrderAttribute?: { __typename?: 'CreateOrderAttributePayload', orderAttribute?: { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type UpdateOrderAttributeMutationVariables = Exact<{
  input: UpdateOrderAttributeByIdInput;
}>;


export type UpdateOrderAttributeMutation = { __typename?: 'Mutation', updateOrderAttributeById?: { __typename?: 'UpdateOrderAttributePayload', orderAttribute?: { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type DeleteOrderAttributeByIdMutationVariables = Exact<{
  input: DeleteOrderAttributeByIdInput;
}>;


export type DeleteOrderAttributeByIdMutation = { __typename?: 'Mutation', deleteOrderAttributeById?: { __typename?: 'DeleteOrderAttributePayload', orderAttribute?: { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type Organization_AdminFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null, email?: string | null, charterer: boolean, shipOwner: boolean, portAgent: boolean, parentOrganizationId?: OrganizationId | null, receiver: boolean, sender: boolean, draft?: string | number | null, defaultFillFactor?: string | number | null, defaultCurrency?: Currency | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configEnableDefaultLaycan: boolean, configAutoAcceptUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configCargoAllocationCombineAssortment: boolean, configEnableScenarioAutoSave: boolean, configAutoSyncUserScenarios: boolean, configReducedUnits: boolean, configUseMasterPorts: boolean, configIntegrationManageOrders: boolean, configIgnoreIntegrationCargoMargins: boolean, configAutoUpdatePortTimezone: boolean, configUseCalculatedLimit: boolean, configDisablePcUpdates: boolean, euEtsCosts: boolean, configIntegrationHistoricalPortCalls: boolean, configIntegrationMergeShipments: boolean, configEnableWorldscaleFreights: boolean, configIncludeFuelEuInCosts: boolean, portCostPriority?: string | null, broker: boolean, organizationByParentOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> }, bunkerGradeMappingsByOrganizationId: { __typename?: 'BunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'BunkerGradeMapping', id: BunkerGradeMappingId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> }, bunkerGradeCalculationsByOrganizationId: { __typename?: 'BunkerGradeCalculationsConnection', nodes: Array<{ __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> } };

export type OrganizationFeature_AdminFragment = { __typename?: 'OrganizationFeature', id: OrganizationFeatureId, isEnabled?: boolean | null, featureName: FeatureFeatureNameString, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type AllOrganizationsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationFilter>;
}>;


export type AllOrganizationsQuery = { __typename?: 'Query', allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, email?: string | null, charterer: boolean, shipOwner: boolean, portAgent: boolean, parentOrganizationId?: OrganizationId | null, receiver: boolean, sender: boolean, draft?: string | number | null, defaultFillFactor?: string | number | null, defaultCurrency?: Currency | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configEnableDefaultLaycan: boolean, configAutoAcceptUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configCargoAllocationCombineAssortment: boolean, configEnableScenarioAutoSave: boolean, configAutoSyncUserScenarios: boolean, configReducedUnits: boolean, configUseMasterPorts: boolean, configIntegrationManageOrders: boolean, configIgnoreIntegrationCargoMargins: boolean, configAutoUpdatePortTimezone: boolean, configUseCalculatedLimit: boolean, configDisablePcUpdates: boolean, euEtsCosts: boolean, configIntegrationHistoricalPortCalls: boolean, configIntegrationMergeShipments: boolean, configEnableWorldscaleFreights: boolean, configIncludeFuelEuInCosts: boolean, portCostPriority?: string | null, broker: boolean, organizationByParentOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> }, bunkerGradeMappingsByOrganizationId: { __typename?: 'BunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'BunkerGradeMapping', id: BunkerGradeMappingId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> }, bunkerGradeCalculationsByOrganizationId: { __typename?: 'BunkerGradeCalculationsConnection', nodes: Array<{ __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> } } | null> } | null };

export type AllOrganizationFeaturesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<OrganizationFeaturesOrderBy>>;
}>;


export type AllOrganizationFeaturesQuery = { __typename?: 'Query', allOrganizationFeatures?: { __typename?: 'OrganizationFeaturesConnection', nodes: Array<{ __typename?: 'OrganizationFeature', id: OrganizationFeatureId, isEnabled?: boolean | null, featureName: FeatureFeatureNameString, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } | null };

export type AllFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFeaturesQuery = { __typename?: 'Query', allFeatures?: { __typename?: 'FeaturesConnection', nodes: Array<{ __typename?: 'Feature', featureName: FeatureFeatureNameString } | null> } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'CreateOrganizationPayload', organization?: { __typename?: 'Organization', id: OrganizationId, name?: string | null, email?: string | null, charterer: boolean, shipOwner: boolean, portAgent: boolean, parentOrganizationId?: OrganizationId | null, receiver: boolean, sender: boolean, draft?: string | number | null, defaultFillFactor?: string | number | null, defaultCurrency?: Currency | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configEnableDefaultLaycan: boolean, configAutoAcceptUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configCargoAllocationCombineAssortment: boolean, configEnableScenarioAutoSave: boolean, configAutoSyncUserScenarios: boolean, configReducedUnits: boolean, configUseMasterPorts: boolean, configIntegrationManageOrders: boolean, configIgnoreIntegrationCargoMargins: boolean, configAutoUpdatePortTimezone: boolean, configUseCalculatedLimit: boolean, configDisablePcUpdates: boolean, euEtsCosts: boolean, configIntegrationHistoricalPortCalls: boolean, configIntegrationMergeShipments: boolean, configEnableWorldscaleFreights: boolean, configIncludeFuelEuInCosts: boolean, portCostPriority?: string | null, broker: boolean, organizationByParentOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> }, bunkerGradeMappingsByOrganizationId: { __typename?: 'BunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'BunkerGradeMapping', id: BunkerGradeMappingId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> }, bunkerGradeCalculationsByOrganizationId: { __typename?: 'BunkerGradeCalculationsConnection', nodes: Array<{ __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> } } | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationByIdInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganizationById?: { __typename?: 'UpdateOrganizationPayload', organization?: { __typename?: 'Organization', id: OrganizationId, name?: string | null, email?: string | null, charterer: boolean, shipOwner: boolean, portAgent: boolean, parentOrganizationId?: OrganizationId | null, receiver: boolean, sender: boolean, draft?: string | number | null, defaultFillFactor?: string | number | null, defaultCurrency?: Currency | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configEnableDefaultLaycan: boolean, configAutoAcceptUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configCargoAllocationCombineAssortment: boolean, configEnableScenarioAutoSave: boolean, configAutoSyncUserScenarios: boolean, configReducedUnits: boolean, configUseMasterPorts: boolean, configIntegrationManageOrders: boolean, configIgnoreIntegrationCargoMargins: boolean, configAutoUpdatePortTimezone: boolean, configUseCalculatedLimit: boolean, configDisablePcUpdates: boolean, euEtsCosts: boolean, configIntegrationHistoricalPortCalls: boolean, configIntegrationMergeShipments: boolean, configEnableWorldscaleFreights: boolean, configIncludeFuelEuInCosts: boolean, portCostPriority?: string | null, broker: boolean, organizationByParentOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> }, bunkerGradeMappingsByOrganizationId: { __typename?: 'BunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'BunkerGradeMapping', id: BunkerGradeMappingId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> }, bunkerGradeCalculationsByOrganizationId: { __typename?: 'BunkerGradeCalculationsConnection', nodes: Array<{ __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> } } | null } | null };

export type DeleteOrganizationByIdMutationVariables = Exact<{
  input: DeleteOrganizationByIdInput;
}>;


export type DeleteOrganizationByIdMutation = { __typename?: 'Mutation', deleteOrganizationById?: { __typename?: 'DeleteOrganizationPayload', organization?: { __typename?: 'Organization', id: OrganizationId, name?: string | null, email?: string | null, charterer: boolean, shipOwner: boolean, portAgent: boolean, parentOrganizationId?: OrganizationId | null, receiver: boolean, sender: boolean, draft?: string | number | null, defaultFillFactor?: string | number | null, defaultCurrency?: Currency | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configEnableDefaultLaycan: boolean, configAutoAcceptUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configCargoAllocationCombineAssortment: boolean, configEnableScenarioAutoSave: boolean, configAutoSyncUserScenarios: boolean, configReducedUnits: boolean, configUseMasterPorts: boolean, configIntegrationManageOrders: boolean, configIgnoreIntegrationCargoMargins: boolean, configAutoUpdatePortTimezone: boolean, configUseCalculatedLimit: boolean, configDisablePcUpdates: boolean, euEtsCosts: boolean, configIntegrationHistoricalPortCalls: boolean, configIntegrationMergeShipments: boolean, configEnableWorldscaleFreights: boolean, configIncludeFuelEuInCosts: boolean, portCostPriority?: string | null, broker: boolean, organizationByParentOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> }, bunkerGradeMappingsByOrganizationId: { __typename?: 'BunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'BunkerGradeMapping', id: BunkerGradeMappingId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> }, bunkerGradeCalculationsByOrganizationId: { __typename?: 'BunkerGradeCalculationsConnection', nodes: Array<{ __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null> } } | null } | null };

export type CreateOrganizationFeatureMutationVariables = Exact<{
  input: CreateOrganizationFeatureInput;
}>;


export type CreateOrganizationFeatureMutation = { __typename?: 'Mutation', createOrganizationFeature?: { __typename?: 'CreateOrganizationFeaturePayload', organizationFeature?: { __typename?: 'OrganizationFeature', id: OrganizationFeatureId, isEnabled?: boolean | null, featureName: FeatureFeatureNameString, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type UpdateOrganizationFeatureMutationVariables = Exact<{
  input: UpdateOrganizationFeatureByIdInput;
}>;


export type UpdateOrganizationFeatureMutation = { __typename?: 'Mutation', updateOrganizationFeatureById?: { __typename?: 'UpdateOrganizationFeaturePayload', organizationFeature?: { __typename?: 'OrganizationFeature', id: OrganizationFeatureId, isEnabled?: boolean | null, featureName: FeatureFeatureNameString, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type DeleteOrganizationFeatureByIdMutationVariables = Exact<{
  input: DeleteOrganizationFeatureByIdInput;
}>;


export type DeleteOrganizationFeatureByIdMutation = { __typename?: 'Mutation', deleteOrganizationFeatureById?: { __typename?: 'DeleteOrganizationFeaturePayload', organizationFeature?: { __typename?: 'OrganizationFeature', id: OrganizationFeatureId, isEnabled?: boolean | null, featureName: FeatureFeatureNameString, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type UpdateOrganizationAreaBunkerGradeMutationVariables = Exact<{
  input: UpdateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaInput;
}>;


export type UpdateOrganizationAreaBunkerGradeMutation = { __typename?: 'Mutation', updateOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea?: { __typename?: 'UpdateOrganizationAreaBunkerGradeMappingPayload', organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> } } | null } | null };

export type CreateOrganizationAreaBunkerGradeMutationVariables = Exact<{
  input: CreateOrganizationAreaBunkerGradeMappingInput;
}>;


export type CreateOrganizationAreaBunkerGradeMutation = { __typename?: 'Mutation', createOrganizationAreaBunkerGradeMapping?: { __typename?: 'CreateOrganizationAreaBunkerGradeMappingPayload', organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> } } | null } | null };

export type DeleteOrganizationAreaBunkerGradeMutationVariables = Exact<{
  input: DeleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselAreaInput;
}>;


export type DeleteOrganizationAreaBunkerGradeMutation = { __typename?: 'Mutation', deleteOrganizationAreaBunkerGradeMappingByOrganizationIdAndVesselArea?: { __typename?: 'DeleteOrganizationAreaBunkerGradeMappingPayload', organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> } } | null } | null };

export type CreateBunkerGradeMappingMutationVariables = Exact<{
  input: CreateBunkerGradeMappingInput;
}>;


export type CreateBunkerGradeMappingMutation = { __typename?: 'Mutation', createBunkerGradeMapping?: { __typename?: 'CreateBunkerGradeMappingPayload', bunkerGradeMapping?: { __typename?: 'BunkerGradeMapping', id: BunkerGradeMappingId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null } | null };

export type UpdateBunkerGradeMappingMutationVariables = Exact<{
  input: UpdateBunkerGradeMappingByIdInput;
}>;


export type UpdateBunkerGradeMappingMutation = { __typename?: 'Mutation', updateBunkerGradeMappingById?: { __typename?: 'UpdateBunkerGradeMappingPayload', bunkerGradeMapping?: { __typename?: 'BunkerGradeMapping', id: BunkerGradeMappingId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null } | null };

export type DeleteBunkerGradeMappingMutationVariables = Exact<{
  input: DeleteBunkerGradeMappingByIdInput;
}>;


export type DeleteBunkerGradeMappingMutation = { __typename?: 'Mutation', deleteBunkerGradeMappingById?: { __typename?: 'DeleteBunkerGradeMappingPayload', bunkerGradeMapping?: { __typename?: 'BunkerGradeMapping', id: BunkerGradeMappingId } | null } | null };

export type CreateBunkerGradeCalculationMutationVariables = Exact<{
  input: CreateBunkerGradeCalculationInput;
}>;


export type CreateBunkerGradeCalculationMutation = { __typename?: 'Mutation', createBunkerGradeCalculation?: { __typename?: 'CreateBunkerGradeCalculationPayload', bunkerGradeCalculation?: { __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null } | null };

export type UpdateBunkerGradeCalculationMutationVariables = Exact<{
  input: UpdateBunkerGradeCalculationByIdInput;
}>;


export type UpdateBunkerGradeCalculationMutation = { __typename?: 'Mutation', updateBunkerGradeCalculationById?: { __typename?: 'UpdateBunkerGradeCalculationPayload', bunkerGradeCalculation?: { __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId } | null } | null };

export type DeleteBunkerGradeCalculationMutationVariables = Exact<{
  input: DeleteBunkerGradeCalculationByIdInput;
}>;


export type DeleteBunkerGradeCalculationMutation = { __typename?: 'Mutation', deleteBunkerGradeCalculationById?: { __typename?: 'DeleteBunkerGradeCalculationPayload', bunkerGradeCalculation?: { __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId } | null } | null };

export type PortCommodityLdRates_AdminFragment = { __typename?: 'PortCommodityLdRate', id: PortCommodityLdRateIdString, loadingRate: string | number, loadingUnit: LoadingUnit, dischargeRate: string | number, dischargeUnit: LoadingUnit, zoneId?: ZoneId | null, portId?: LocationId | null, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null };

export type AllPortCommodityLdRatesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<PortCommodityLdRatesOrderBy>>;
}>;


export type AllPortCommodityLdRatesQuery = { __typename?: 'Query', allPortCommodityLdRates?: { __typename?: 'PortCommodityLdRatesConnection', nodes: Array<{ __typename?: 'PortCommodityLdRate', id: PortCommodityLdRateIdString, loadingRate: string | number, loadingUnit: LoadingUnit, dischargeRate: string | number, dischargeUnit: LoadingUnit, zoneId?: ZoneId | null, portId?: LocationId | null, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } | null };

export type CreatePortCommodityLdRateMutationVariables = Exact<{
  input: CreatePortCommodityLdRateInput;
}>;


export type CreatePortCommodityLdRateMutation = { __typename?: 'Mutation', createPortCommodityLdRate?: { __typename?: 'CreatePortCommodityLdRatePayload', portCommodityLdRate?: { __typename?: 'PortCommodityLdRate', id: PortCommodityLdRateIdString, loadingRate: string | number, loadingUnit: LoadingUnit, dischargeRate: string | number, dischargeUnit: LoadingUnit, zoneId?: ZoneId | null, portId?: LocationId | null, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, portCommodityLdRatesByOrganizationId: { __typename?: 'PortCommodityLdRatesConnection', nodes: Array<{ __typename?: 'PortCommodityLdRate', id: PortCommodityLdRateIdString } | null> } } | null } | null };

export type UpdatePortCommodityLdRateMutationVariables = Exact<{
  input: UpdatePortCommodityLdRateByIdInput;
}>;


export type UpdatePortCommodityLdRateMutation = { __typename?: 'Mutation', updatePortCommodityLdRateById?: { __typename?: 'UpdatePortCommodityLdRatePayload', portCommodityLdRate?: { __typename?: 'PortCommodityLdRate', id: PortCommodityLdRateIdString, loadingRate: string | number, loadingUnit: LoadingUnit, dischargeRate: string | number, dischargeUnit: LoadingUnit, zoneId?: ZoneId | null, portId?: LocationId | null, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null } | null };

export type DeletePortCommodityLdRateMutationVariables = Exact<{
  input: DeletePortCommodityLdRateByIdInput;
}>;


export type DeletePortCommodityLdRateMutation = { __typename?: 'Mutation', deletePortCommodityLdRateById?: { __typename?: 'DeletePortCommodityLdRatePayload', portCommodityLdRate?: { __typename?: 'PortCommodityLdRate', id: PortCommodityLdRateIdString, loadingRate: string | number, loadingUnit: LoadingUnit, dischargeRate: string | number, dischargeUnit: LoadingUnit, zoneId?: ZoneId | null, portId?: LocationId | null, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null } | null };

export type PortCostDefaults_AdminFragment = { __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null, primaryAttributeId?: VesselAttributeId | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null };

export type AllPortCostDefaultsQueryVariables = Exact<{
  filter?: InputMaybe<PortCostDefaultFilter>;
}>;


export type AllPortCostDefaultsQuery = { __typename?: 'Query', allPortCostDefaults?: { __typename?: 'PortCostDefaultsConnection', nodes: Array<{ __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null, primaryAttributeId?: VesselAttributeId | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null> } | null };

export type CreatePortCostDefaultMutationVariables = Exact<{
  input: CreatePortCostDefaultInput;
}>;


export type CreatePortCostDefaultMutation = { __typename?: 'Mutation', createPortCostDefault?: { __typename?: 'CreatePortCostDefaultPayload', portCostDefault?: { __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null, primaryAttributeId?: VesselAttributeId | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null } | null };

export type UpdatePortCostDefaultByIdMutationVariables = Exact<{
  input: UpdatePortCostDefaultByIdInput;
}>;


export type UpdatePortCostDefaultByIdMutation = { __typename?: 'Mutation', updatePortCostDefaultById?: { __typename?: 'UpdatePortCostDefaultPayload', portCostDefault?: { __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null, primaryAttributeId?: VesselAttributeId | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null } | null };

export type DeletePortCostDefaultByIdMutationVariables = Exact<{
  input: DeletePortCostDefaultByIdInput;
}>;


export type DeletePortCostDefaultByIdMutation = { __typename?: 'Mutation', deletePortCostDefaultById?: { __typename?: 'DeletePortCostDefaultPayload', portCostDefault?: { __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null, primaryAttributeId?: VesselAttributeId | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null } | null };

export type PortCostDefaultsImportMutationVariables = Exact<{
  input?: InputMaybe<Array<PortCostDefaultsImportInput>>;
}>;


export type PortCostDefaultsImportMutation = { __typename?: 'Mutation', portCostDefaultsImport?: { __typename?: 'PortCostDefaultsImportResult', totalImportSucess?: number | null, errors?: Array<string | null> | null } | null };

export type PortCostEstimatesExternal_AdminFragment = { __typename?: 'PortCostEstimatesExternal', id: PortCostEstimatesExternalId, organizationId: OrganizationId, vesselName: string, vesselCode?: string | null, portName: string, portType?: PortType | null, assortment?: string | null, portCost: string | number, portCostCurrency: string, commencedDate?: string | null, completedDate?: string | null, deprecated: boolean };

export type CreatePortCostEstimatesExternalMutationVariables = Exact<{
  input: CreatePortCostEstimatesExternalInput;
}>;


export type CreatePortCostEstimatesExternalMutation = { __typename?: 'Mutation', createPortCostEstimatesExternal?: { __typename?: 'CreatePortCostEstimatesExternalPayload', portCostEstimatesExternal?: { __typename?: 'PortCostEstimatesExternal', id: PortCostEstimatesExternalId, organizationId: OrganizationId, vesselName: string, vesselCode?: string | null, portName: string, portType?: PortType | null, assortment?: string | null, portCost: string | number, portCostCurrency: string, commencedDate?: string | null, completedDate?: string | null, deprecated: boolean } | null } | null };

export type PortCostEstimatesExternalImportMutationVariables = Exact<{
  input?: InputMaybe<Array<CreatePortCostEstimatesExternalInput>>;
}>;


export type PortCostEstimatesExternalImportMutation = { __typename?: 'Mutation', portCostEstimatesExternalImport?: { __typename?: 'PortCostExternalImportResult', totalImportSucess?: number | null, errors?: Array<string | null> | null } | null };

export type PortSpecialRequirement_AdminFragment = { __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null };

export type AllPortSpecialRequirementsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LocationRequirementAssociationsOrderBy>>;
}>;


export type AllPortSpecialRequirementsQuery = { __typename?: 'Query', allLocationRequirementAssociations?: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null } | null> } | null };

export type CreatePortSpecialRequirementMutationVariables = Exact<{
  input: CreateLocationRequirementAssociationInput;
}>;


export type CreatePortSpecialRequirementMutation = { __typename?: 'Mutation', createLocationRequirementAssociation?: { __typename?: 'CreateLocationRequirementAssociationPayload', locationRequirementAssociation?: { __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null } | null } | null };

export type UpdatePortSpecialRequirementMutationVariables = Exact<{
  input: UpdateLocationRequirementAssociationByIdInput;
}>;


export type UpdatePortSpecialRequirementMutation = { __typename?: 'Mutation', updateLocationRequirementAssociationById?: { __typename?: 'UpdateLocationRequirementAssociationPayload', locationRequirementAssociation?: { __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null } | null } | null };

export type DeletePortSpecialRequirementByIdMutationVariables = Exact<{
  input: DeleteLocationRequirementAssociationByIdInput;
}>;


export type DeletePortSpecialRequirementByIdMutation = { __typename?: 'Mutation', deleteLocationRequirementAssociationById?: { __typename?: 'DeleteLocationRequirementAssociationPayload', locationRequirementAssociation?: { __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null } | null } | null };

export type Port_AdminFragment = { __typename?: 'Location', id: LocationId, name: string, nameSynonyms?: Array<string | null> | null, country?: string | null, locode?: string | null, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null, countryId?: CountryId | null, parentLocationId?: LocationId | null, airDraft?: string | number | null, lengthOverall?: string | number | null, beam?: string | number | null, draft?: string | number | null, organisationId?: OrganizationId | null, type?: LocationType | null, extraPortDays?: string | number | null, externalId?: string | null, extIdArray?: Array<string | null> | null, maxDwt?: string | number | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } };

export type AllPortsQueryVariables = Exact<{
  filter?: InputMaybe<LocationFilter>;
}>;


export type AllPortsQuery = { __typename?: 'Query', allLocations?: { __typename?: 'LocationsConnection', nodes: Array<{ __typename?: 'Location', id: LocationId, clusterId?: LocationClusterId | null, name: string, nameSynonyms?: Array<string | null> | null, country?: string | null, locode?: string | null, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null, countryId?: CountryId | null, parentLocationId?: LocationId | null, airDraft?: string | number | null, lengthOverall?: string | number | null, beam?: string | number | null, draft?: string | number | null, organisationId?: OrganizationId | null, type?: LocationType | null, extraPortDays?: string | number | null, externalId?: string | null, extIdArray?: Array<string | null> | null, maxDwt?: string | number | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null> } | null };

export type CountryFragment = { __typename?: 'Country', id: CountryId, english?: string | null, alpha2?: string | null, alpha3?: string | null };

export type AllCountriesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
}>;


export type AllCountriesQuery = { __typename?: 'Query', allCountries?: { __typename?: 'CountriesConnection', nodes: Array<{ __typename?: 'Country', id: CountryId, english?: string | null, alpha2?: string | null, alpha3?: string | null } | null> } | null };

export type CreatePortMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreatePortMutation = { __typename?: 'Mutation', createLocation?: { __typename?: 'CreateLocationPayload', location?: { __typename?: 'Location', id: LocationId, clusterId?: LocationClusterId | null, name: string, nameSynonyms?: Array<string | null> | null, country?: string | null, locode?: string | null, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null, countryId?: CountryId | null, parentLocationId?: LocationId | null, airDraft?: string | number | null, lengthOverall?: string | number | null, beam?: string | number | null, draft?: string | number | null, organisationId?: OrganizationId | null, type?: LocationType | null, extraPortDays?: string | number | null, externalId?: string | null, extIdArray?: Array<string | null> | null, maxDwt?: string | number | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null };

export type UpdatePortMutationVariables = Exact<{
  input: UpdateLocationByIdInput;
}>;


export type UpdatePortMutation = { __typename?: 'Mutation', updateLocationById?: { __typename?: 'UpdateLocationPayload', location?: { __typename?: 'Location', id: LocationId, clusterId?: LocationClusterId | null, name: string, nameSynonyms?: Array<string | null> | null, country?: string | null, locode?: string | null, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null, countryId?: CountryId | null, parentLocationId?: LocationId | null, airDraft?: string | number | null, lengthOverall?: string | number | null, beam?: string | number | null, draft?: string | number | null, organisationId?: OrganizationId | null, type?: LocationType | null, extraPortDays?: string | number | null, externalId?: string | null, extIdArray?: Array<string | null> | null, maxDwt?: string | number | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null };

export type DeletePortByIdMutationVariables = Exact<{
  input: DeleteLocationByIdInput;
}>;


export type DeletePortByIdMutation = { __typename?: 'Mutation', deleteLocationById?: { __typename?: 'DeleteLocationPayload', location?: { __typename?: 'Location', id: LocationId, clusterId?: LocationClusterId | null, name: string, nameSynonyms?: Array<string | null> | null, country?: string | null, locode?: string | null, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null, countryId?: CountryId | null, parentLocationId?: LocationId | null, airDraft?: string | number | null, lengthOverall?: string | number | null, beam?: string | number | null, draft?: string | number | null, organisationId?: OrganizationId | null, type?: LocationType | null, extraPortDays?: string | number | null, externalId?: string | null, extIdArray?: Array<string | null> | null, maxDwt?: string | number | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null };

export type UpdatePortMissedTimezoneMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdatePortMissedTimezoneMutation = { __typename?: 'Mutation', updatePortMissedTimezone?: { __typename?: 'UpdatePortMissedTimezoneResult', totalUpdateSuccess: number, errors: Array<string | null>, warning: Array<string | null> } | null };

export type Prompt_AdminFragment = { __typename?: 'Prompt', id: PromptId, name: string, prompt: string, createdBy: UserId, modifiedBy?: UserId | null, userByCreatedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, userByModifiedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null };

export type AllPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPromptsQuery = { __typename?: 'Query', allPrompts?: { __typename?: 'PromptsConnection', nodes: Array<{ __typename?: 'Prompt', id: PromptId, name: string, prompt: string, createdBy: UserId, modifiedBy?: UserId | null, userByCreatedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, userByModifiedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> } | null };

export type CreatePromptMutationVariables = Exact<{
  input: CreatePromptInput;
}>;


export type CreatePromptMutation = { __typename?: 'Mutation', createPrompt?: { __typename?: 'CreatePromptPayload', prompt?: { __typename?: 'Prompt', id: PromptId, name: string, prompt: string, createdBy: UserId, modifiedBy?: UserId | null, userByCreatedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, userByModifiedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null } | null };

export type UpdatePromptMutationVariables = Exact<{
  input: UpdatePromptByIdInput;
}>;


export type UpdatePromptMutation = { __typename?: 'Mutation', updatePromptById?: { __typename?: 'UpdatePromptPayload', prompt?: { __typename?: 'Prompt', id: PromptId, name: string, prompt: string, createdBy: UserId, modifiedBy?: UserId | null, userByCreatedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, userByModifiedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null } | null };

export type DeletePromptMutationVariables = Exact<{
  input: DeletePromptByIdInput;
}>;


export type DeletePromptMutation = { __typename?: 'Mutation', deletePromptById?: { __typename?: 'DeletePromptPayload', prompt?: { __typename?: 'Prompt', id: PromptId, name: string, prompt: string, createdBy: UserId, modifiedBy?: UserId | null, userByCreatedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, userByModifiedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null } | null };

export type Region_AdminFragment = { __typename?: 'Region', id: RegionId, name: string, polygon?: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> | null };

export type AllRegionsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<RegionsOrderBy>>;
}>;


export type AllRegionsQuery = { __typename?: 'Query', allRegions?: { __typename?: 'RegionsConnection', nodes: Array<{ __typename?: 'Region', id: RegionId, name: string, polygon?: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> | null } | null> } | null };

export type CreateRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;


export type CreateRegionMutation = { __typename?: 'Mutation', createRegion?: { __typename?: 'CreateRegionPayload', region?: { __typename?: 'Region', id: RegionId, name: string, polygon?: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> | null } | null } | null };

export type UpdateRegionMutationVariables = Exact<{
  input: UpdateRegionByIdInput;
}>;


export type UpdateRegionMutation = { __typename?: 'Mutation', updateRegionById?: { __typename?: 'UpdateRegionPayload', region?: { __typename?: 'Region', id: RegionId, name: string, polygon?: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> | null } | null } | null };

export type DeleteRegionByIdMutationVariables = Exact<{
  input: DeleteRegionByIdInput;
}>;


export type DeleteRegionByIdMutation = { __typename?: 'Mutation', deleteRegionById?: { __typename?: 'DeleteRegionPayload', region?: { __typename?: 'Region', id: RegionId, name: string, polygon?: Array<{ __typename?: 'Latlng', lat?: number | null, lng?: number | null } | null> | null } | null } | null };

export type RouteOverride_AdminFragment = { __typename?: 'RouteOverride', id: RouteOverrideId, fromId: LocationId, toId: LocationId, distance?: string | number | null, avoidsChannels: boolean, locationByFromId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null, locationByToId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null };

export type AllRouteOverridesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<RouteOverridesOrderBy>>;
  filter?: InputMaybe<RouteOverrideFilter>;
}>;


export type AllRouteOverridesQuery = { __typename?: 'Query', allRouteOverrides?: { __typename?: 'RouteOverridesConnection', nodes: Array<{ __typename?: 'RouteOverride', id: RouteOverrideId, fromId: LocationId, toId: LocationId, distance?: string | number | null, avoidsChannels: boolean, locationByFromId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null, locationByToId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null } | null> } | null };

export type CreateRouteOverrideMutationVariables = Exact<{
  input: CreateRouteOverrideInput;
}>;


export type CreateRouteOverrideMutation = { __typename?: 'Mutation', createRouteOverride?: { __typename?: 'CreateRouteOverridePayload', routeOverride?: { __typename?: 'RouteOverride', id: RouteOverrideId, fromId: LocationId, toId: LocationId, distance?: string | number | null, avoidsChannels: boolean, locationByFromId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null, locationByToId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null } | null } | null };

export type UpdateRouteOverrideMutationVariables = Exact<{
  input: UpdateRouteOverrideByIdInput;
}>;


export type UpdateRouteOverrideMutation = { __typename?: 'Mutation', updateRouteOverrideById?: { __typename?: 'UpdateRouteOverridePayload', routeOverride?: { __typename?: 'RouteOverride', id: RouteOverrideId, fromId: LocationId, toId: LocationId, distance?: string | number | null, avoidsChannels: boolean, locationByFromId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null, locationByToId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null } | null } | null };

export type DeleteRouteOverrideByIdMutationVariables = Exact<{
  input: DeleteRouteOverrideByIdInput;
}>;


export type DeleteRouteOverrideByIdMutation = { __typename?: 'Mutation', deleteRouteOverrideById?: { __typename?: 'DeleteRouteOverridePayload', routeOverride?: { __typename?: 'RouteOverride', id: RouteOverrideId, fromId: LocationId, toId: LocationId, distance?: string | number | null, avoidsChannels: boolean, locationByFromId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null, locationByToId?: { __typename?: 'Location', id: LocationId, name: string, clusterId?: LocationClusterId | null } | null } | null } | null };

export type SpecialRequirement_AdminFragment = { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, locationRequirementAssociationsBySpecialRequirementId: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, locationId?: LocationId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, vesselFulfillsRequirementAssociationsBySpecialRequirementId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, vesselAttributesAssociationsByVesselAttributeId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, shipId: ShipId } | null> }, shipsByPrimaryAttributeId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId } | null> } } | null } | null> } };

export type AllSpecialRequirementsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<SpecialRequirementsOrderBy>>;
}>;


export type AllSpecialRequirementsQuery = { __typename?: 'Query', allSpecialRequirements?: { __typename?: 'SpecialRequirementsConnection', nodes: Array<{ __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, locationRequirementAssociationsBySpecialRequirementId: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, locationId?: LocationId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, vesselFulfillsRequirementAssociationsBySpecialRequirementId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, vesselAttributesAssociationsByVesselAttributeId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, shipId: ShipId } | null> }, shipsByPrimaryAttributeId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId } | null> } } | null } | null> } } | null> } | null };

export type CreateSpecialRequirementMutationVariables = Exact<{
  input: CreateSpecialRequirementInput;
}>;


export type CreateSpecialRequirementMutation = { __typename?: 'Mutation', createSpecialRequirement?: { __typename?: 'CreateSpecialRequirementPayload', specialRequirement?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, locationRequirementAssociationsBySpecialRequirementId: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, locationId?: LocationId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, vesselFulfillsRequirementAssociationsBySpecialRequirementId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, vesselAttributesAssociationsByVesselAttributeId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, shipId: ShipId } | null> }, shipsByPrimaryAttributeId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId } | null> } } | null } | null> } } | null } | null };

export type UpdateSpecialRequirementMutationVariables = Exact<{
  input: UpdateSpecialRequirementByIdInput;
}>;


export type UpdateSpecialRequirementMutation = { __typename?: 'Mutation', updateSpecialRequirementById?: { __typename?: 'UpdateSpecialRequirementPayload', specialRequirement?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, locationRequirementAssociationsBySpecialRequirementId: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, locationId?: LocationId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, vesselFulfillsRequirementAssociationsBySpecialRequirementId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, vesselAttributesAssociationsByVesselAttributeId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, shipId: ShipId } | null> }, shipsByPrimaryAttributeId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId } | null> } } | null } | null> } } | null } | null };

export type DeleteSpecialRequirementByIdMutationVariables = Exact<{
  input: DeleteSpecialRequirementByIdInput;
}>;


export type DeleteSpecialRequirementByIdMutation = { __typename?: 'Mutation', deleteSpecialRequirementById?: { __typename?: 'DeleteSpecialRequirementPayload', specialRequirement?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, locationRequirementAssociationsBySpecialRequirementId: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, locationId?: LocationId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, vesselFulfillsRequirementAssociationsBySpecialRequirementId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, vesselAttributesAssociationsByVesselAttributeId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, shipId: ShipId } | null> }, shipsByPrimaryAttributeId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId } | null> } } | null } | null> } } | null } | null };

export type SupplyContract_AdminFragment = { __typename?: 'SupplyContract', id: SupplyContractId, supplyContract?: string | null, supplier?: string | null, batchCode?: string | null, year?: number | null, batchSeq?: number | null, senderOrganizationId?: OrganizationId | null, organizationBySenderOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type AllSupplyContractsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<SupplyContractsOrderBy>>;
}>;


export type AllSupplyContractsQuery = { __typename?: 'Query', allSupplyContracts?: { __typename?: 'SupplyContractsConnection', nodes: Array<{ __typename?: 'SupplyContract', id: SupplyContractId, supplyContract?: string | null, supplier?: string | null, batchCode?: string | null, year?: number | null, batchSeq?: number | null, senderOrganizationId?: OrganizationId | null, organizationBySenderOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } | null };

export type CreateSupplyContractMutationVariables = Exact<{
  input: CreateSupplyContractInput;
}>;


export type CreateSupplyContractMutation = { __typename?: 'Mutation', createSupplyContract?: { __typename?: 'CreateSupplyContractPayload', supplyContract?: { __typename?: 'SupplyContract', id: SupplyContractId, supplyContract?: string | null, supplier?: string | null, batchCode?: string | null, year?: number | null, batchSeq?: number | null, senderOrganizationId?: OrganizationId | null, organizationBySenderOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type UpdateSupplyContractMutationVariables = Exact<{
  input: UpdateSupplyContractByIdInput;
}>;


export type UpdateSupplyContractMutation = { __typename?: 'Mutation', updateSupplyContractById?: { __typename?: 'UpdateSupplyContractPayload', supplyContract?: { __typename?: 'SupplyContract', id: SupplyContractId, supplyContract?: string | null, supplier?: string | null, batchCode?: string | null, year?: number | null, batchSeq?: number | null, senderOrganizationId?: OrganizationId | null, organizationBySenderOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type DeleteSupplyContractByIdMutationVariables = Exact<{
  input: DeleteSupplyContractByIdInput;
}>;


export type DeleteSupplyContractByIdMutation = { __typename?: 'Mutation', deleteSupplyContractById?: { __typename?: 'DeleteSupplyContractPayload', supplyContract?: { __typename?: 'SupplyContract', id: SupplyContractId, supplyContract?: string | null, supplier?: string | null, batchCode?: string | null, year?: number | null, batchSeq?: number | null, senderOrganizationId?: OrganizationId | null, organizationBySenderOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type UserRight_AdminFragment = { __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean };

export type User_AdminFragment = { __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } };

export type AllUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilter>;
}>;


export type AllUsersQuery = { __typename?: 'Query', allUsers?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } } | null> } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserPayload', user?: { __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } } | null } | null };

export type CreateUserRightMutationVariables = Exact<{
  input: CreateUserRightInput;
}>;


export type CreateUserRightMutation = { __typename?: 'Mutation', createUserRight?: { __typename?: 'CreateUserRightPayload', userRight?: { __typename?: 'UserRight', id: UserRightId } | null, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserByIdInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUserById?: { __typename?: 'UpdateUserPayload', user?: { __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } } | null } | null };

export type UpdateUserRightMutationVariables = Exact<{
  input: UpdateUserRightByIdInput;
}>;


export type UpdateUserRightMutation = { __typename?: 'Mutation', updateUserRightById?: { __typename?: 'UpdateUserRightPayload', userByUserId?: { __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } } | null } | null };

export type DeleteUserByIdMutationVariables = Exact<{
  input: DeleteUserByIdInput;
}>;


export type DeleteUserByIdMutation = { __typename?: 'Mutation', deleteUserById?: { __typename?: 'DeleteUserPayload', user?: { __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } } | null } | null };

export type DeleteUserRightMutationVariables = Exact<{
  input: DeleteUserRightByIdInput;
}>;


export type DeleteUserRightMutation = { __typename?: 'Mutation', deleteUserRightById?: { __typename?: 'DeleteUserRightPayload', userByUserId?: { __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } } | null } | null };

export type SetUserActivatedMutationVariables = Exact<{
  uid: Scalars['Int']['input'];
  activated: Scalars['Boolean']['input'];
}>;


export type SetUserActivatedMutation = { __typename?: 'Mutation', setUserActivated?: { __typename?: 'SetUserActivatedPayload', query?: { __typename?: 'Query', userById?: { __typename?: 'User', id: UserId, name?: string | null, email?: string | null, initials?: string | null, insertedAt: string, updatedAt: string, userType: UserType, isActivated?: boolean | null, isVerified?: boolean | null, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, userRightsByUserId: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', id: UserRightId, organizationId: OrganizationId, userId: UserId, orgAdmin: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditContracts: boolean, accessFinancialData: boolean, createAndEditPortCalls: boolean, accessCargoMeasurement: boolean, createAndEditCargoMeasurement: boolean, accessBillOfLading: boolean, createAndEditBillOfLading: boolean } | null> } } | null } | null } | null };

export type VesselAttributeAssortmentExclusion_AdminFragment = { __typename?: 'VesselAttributeAssortmentExclusion', id: VesselAttributeAssortmentExclusionId, assortmentGroupId?: AssortmentGroupId | null, assortmentId?: AssortmentId | null, vesselAttributeId: VesselAttributeId, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null };

export type AllVesselAttributeAssortmentExclusionsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<VesselAttributeAssortmentExclusionsOrderBy>>;
}>;


export type AllVesselAttributeAssortmentExclusionsQuery = { __typename?: 'Query', allVesselAttributeAssortmentExclusions?: { __typename?: 'VesselAttributeAssortmentExclusionsConnection', nodes: Array<{ __typename?: 'VesselAttributeAssortmentExclusion', id: VesselAttributeAssortmentExclusionId, assortmentGroupId?: AssortmentGroupId | null, assortmentId?: AssortmentId | null, vesselAttributeId: VesselAttributeId, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null> } | null };

export type CreateVesselAttributeAssortmentExclusionMutationVariables = Exact<{
  input: CreateVesselAttributeAssortmentExclusionInput;
}>;


export type CreateVesselAttributeAssortmentExclusionMutation = { __typename?: 'Mutation', createVesselAttributeAssortmentExclusion?: { __typename?: 'CreateVesselAttributeAssortmentExclusionPayload', vesselAttributeAssortmentExclusion?: { __typename?: 'VesselAttributeAssortmentExclusion', id: VesselAttributeAssortmentExclusionId, assortmentGroupId?: AssortmentGroupId | null, assortmentId?: AssortmentId | null, vesselAttributeId: VesselAttributeId, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type UpdateVesselAttributeAssortmentExclusionMutationVariables = Exact<{
  input: UpdateVesselAttributeAssortmentExclusionByIdInput;
}>;


export type UpdateVesselAttributeAssortmentExclusionMutation = { __typename?: 'Mutation', updateVesselAttributeAssortmentExclusionById?: { __typename?: 'UpdateVesselAttributeAssortmentExclusionPayload', vesselAttributeAssortmentExclusion?: { __typename?: 'VesselAttributeAssortmentExclusion', id: VesselAttributeAssortmentExclusionId, assortmentGroupId?: AssortmentGroupId | null, assortmentId?: AssortmentId | null, vesselAttributeId: VesselAttributeId, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type DeleteVesselAttributeAssortmentExclusionByIdMutationVariables = Exact<{
  input: DeleteVesselAttributeAssortmentExclusionByIdInput;
}>;


export type DeleteVesselAttributeAssortmentExclusionByIdMutation = { __typename?: 'Mutation', deleteVesselAttributeAssortmentExclusionById?: { __typename?: 'DeleteVesselAttributeAssortmentExclusionPayload', vesselAttributeAssortmentExclusion?: { __typename?: 'VesselAttributeAssortmentExclusion', id: VesselAttributeAssortmentExclusionId, assortmentGroupId?: AssortmentGroupId | null, assortmentId?: AssortmentId | null, vesselAttributeId: VesselAttributeId, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type VesselAttribute_AdminFragment = { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, description?: string | null };

export type AllVesselAttributesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<VesselAttributesOrderBy>>;
}>;


export type AllVesselAttributesQuery = { __typename?: 'Query', allVesselAttributes?: { __typename?: 'VesselAttributesConnection', nodes: Array<{ __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, description?: string | null } | null> } | null };

export type CreateVesselAttributeMutationVariables = Exact<{
  input: CreateVesselAttributeInput;
}>;


export type CreateVesselAttributeMutation = { __typename?: 'Mutation', createVesselAttribute?: { __typename?: 'CreateVesselAttributePayload', vesselAttribute?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, description?: string | null } | null } | null };

export type UpdateVesselAttributeByIdMutationVariables = Exact<{
  input: UpdateVesselAttributeByIdInput;
}>;


export type UpdateVesselAttributeByIdMutation = { __typename?: 'Mutation', updateVesselAttributeById?: { __typename?: 'UpdateVesselAttributePayload', vesselAttribute?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, description?: string | null } | null } | null };

export type DeleteVesselAttributeByIdMutationVariables = Exact<{
  input: DeleteVesselAttributeByIdInput;
}>;


export type DeleteVesselAttributeByIdMutation = { __typename?: 'Mutation', deleteVesselAttributeById?: { __typename?: 'DeleteVesselAttributePayload', vesselAttribute?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, description?: string | null } | null } | null };

export type CreateVesselAttributesAssociationMutationVariables = Exact<{
  input: CreateVesselAttributesAssociationInput;
}>;


export type CreateVesselAttributesAssociationMutation = { __typename?: 'Mutation', createVesselAttributesAssociation?: { __typename?: 'CreateVesselAttributesAssociationPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null };

export type DeleteVesselAttributesAssociationByIdMutationVariables = Exact<{
  associationId: Scalars['VesselAttributesAssociationId']['input'];
}>;


export type DeleteVesselAttributesAssociationByIdMutation = { __typename?: 'Mutation', deleteVesselAttributesAssociationById?: { __typename?: 'DeleteVesselAttributesAssociationPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null };

export type VesselDraftDatapoint_AdminFragment = { __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number };

export type CreateVesselDraftDatapointMutationVariables = Exact<{
  input: CreateVesselDraftDatapointInput;
}>;


export type CreateVesselDraftDatapointMutation = { __typename?: 'Mutation', createVesselDraftDatapoint?: { __typename?: 'CreateVesselDraftDatapointPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, vesselDraftDatapoint?: { __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null } | null };

export type UpdateVesselDraftDatapointMutationVariables = Exact<{
  input: UpdateVesselDraftDatapointByIdInput;
}>;


export type UpdateVesselDraftDatapointMutation = { __typename?: 'Mutation', updateVesselDraftDatapointById?: { __typename?: 'UpdateVesselDraftDatapointPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, vesselDraftDatapoint?: { __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null } | null };

export type DeleteVesselDraftDatapointMutationVariables = Exact<{
  input: DeleteVesselDraftDatapointByIdInput;
}>;


export type DeleteVesselDraftDatapointMutation = { __typename?: 'Mutation', deleteVesselDraftDatapointById?: { __typename?: 'DeleteVesselDraftDatapointPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, vesselDraftDatapoint?: { __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null } | null };

export type VesselFulfillsRequirementAssociation_AdminFragment = { __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId, vesselId?: ShipId | null, vesselAttributeId?: VesselAttributeId | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null };

export type AllVesselFulfillsRequirementsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<VesselFulfillsRequirementAssociationsOrderBy>>;
}>;


export type AllVesselFulfillsRequirementsQuery = { __typename?: 'Query', allVesselFulfillsRequirementAssociations?: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId, vesselId?: ShipId | null, vesselAttributeId?: VesselAttributeId | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null> } | null };

export type CreateVesselFulfillsRequirementMutationVariables = Exact<{
  input: CreateVesselFulfillsRequirementAssociationInput;
}>;


export type CreateVesselFulfillsRequirementMutation = { __typename?: 'Mutation', createVesselFulfillsRequirementAssociation?: { __typename?: 'CreateVesselFulfillsRequirementAssociationPayload', vesselFulfillsRequirementAssociation?: { __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId, vesselId?: ShipId | null, vesselAttributeId?: VesselAttributeId | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null } | null };

export type UpdateVesselFulfillsRequirementMutationVariables = Exact<{
  input: UpdateVesselFulfillsRequirementAssociationByIdInput;
}>;


export type UpdateVesselFulfillsRequirementMutation = { __typename?: 'Mutation', updateVesselFulfillsRequirementAssociationById?: { __typename?: 'UpdateVesselFulfillsRequirementAssociationPayload', vesselFulfillsRequirementAssociation?: { __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId, vesselId?: ShipId | null, vesselAttributeId?: VesselAttributeId | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null } | null };

export type DeleteVesselFulfillsRequirementByIdMutationVariables = Exact<{
  input: DeleteVesselFulfillsRequirementAssociationByIdInput;
}>;


export type DeleteVesselFulfillsRequirementByIdMutation = { __typename?: 'Mutation', deleteVesselFulfillsRequirementAssociationById?: { __typename?: 'DeleteVesselFulfillsRequirementAssociationPayload', vesselFulfillsRequirementAssociation?: { __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId, vesselId?: ShipId | null, vesselAttributeId?: VesselAttributeId | null, specialRequirementBySpecialRequirementId?: { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null } | null };

export type VesselInfo_AdminFragment = { __typename?: 'VesselInfo', id: VesselInfoId, imo: number, mmsi: number, ownerOrganisationId: OrganizationId, year: number, flag: number, callSign?: string | null, heating?: boolean | null, loa: string | number, breadth: string | number, draft: string | number, cranes?: boolean | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } };

export type AllVesselInfosQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<VesselInfosOrderBy>>;
}>;


export type AllVesselInfosQuery = { __typename?: 'Query', allVesselInfos?: { __typename?: 'VesselInfosConnection', nodes: Array<{ __typename?: 'VesselInfo', id: VesselInfoId, imo: number, mmsi: number, ownerOrganisationId: OrganizationId, year: number, flag: number, callSign?: string | null, heating?: boolean | null, loa: string | number, breadth: string | number, draft: string | number, cranes?: boolean | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null> } | null };

export type CreateVesselInfoMutationVariables = Exact<{
  input: CreateVesselInfoInput;
}>;


export type CreateVesselInfoMutation = { __typename?: 'Mutation', createVesselInfo?: { __typename?: 'CreateVesselInfoPayload', vesselInfo?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number, mmsi: number, ownerOrganisationId: OrganizationId, year: number, flag: number, callSign?: string | null, heating?: boolean | null, loa: string | number, breadth: string | number, draft: string | number, cranes?: boolean | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null } | null };

export type UpdateVesselInfoMutationVariables = Exact<{
  input: UpdateVesselInfoByIdInput;
}>;


export type UpdateVesselInfoMutation = { __typename?: 'Mutation', updateVesselInfoById?: { __typename?: 'UpdateVesselInfoPayload', vesselInfo?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number, mmsi: number, ownerOrganisationId: OrganizationId, year: number, flag: number, callSign?: string | null, heating?: boolean | null, loa: string | number, breadth: string | number, draft: string | number, cranes?: boolean | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null } | null };

export type DeleteVesselInfoByIdMutationVariables = Exact<{
  input: DeleteVesselInfoByIdInput;
}>;


export type DeleteVesselInfoByIdMutation = { __typename?: 'Mutation', deleteVesselInfoById?: { __typename?: 'DeleteVesselInfoPayload', vesselInfo?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number, mmsi: number, ownerOrganisationId: OrganizationId, year: number, flag: number, callSign?: string | null, heating?: boolean | null, loa: string | number, breadth: string | number, draft: string | number, cranes?: boolean | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null } | null };

export type VesselScheduleSharedToOrganization_AdminFragment = { __typename?: 'VesselScheduleSharedToOrganization', id: VesselScheduleSharedToOrganizationId, vesselId: ShipId, organizationId: OrganizationId, createdAt?: string | null, updatedAt?: string | null };

export type AllVesselScheduleSharedToOrganizationsQueryVariables = Exact<{
  filter?: InputMaybe<VesselScheduleSharedToOrganizationFilter>;
}>;


export type AllVesselScheduleSharedToOrganizationsQuery = { __typename?: 'Query', allVesselScheduleSharedToOrganizations?: { __typename?: 'VesselScheduleSharedToOrganizationsConnection', nodes: Array<{ __typename?: 'VesselScheduleSharedToOrganization', id: VesselScheduleSharedToOrganizationId, vesselId: ShipId, organizationId: OrganizationId, createdAt?: string | null, updatedAt?: string | null } | null> } | null };

export type CreateVesselScheduleSharedToOrganizationMutationVariables = Exact<{
  input: CreateVesselScheduleSharedToOrganizationInput;
}>;


export type CreateVesselScheduleSharedToOrganizationMutation = { __typename?: 'Mutation', createVesselScheduleSharedToOrganization?: { __typename?: 'CreateVesselScheduleSharedToOrganizationPayload', vesselScheduleSharedToOrganization?: { __typename?: 'VesselScheduleSharedToOrganization', id: VesselScheduleSharedToOrganizationId, vesselId: ShipId, organizationId: OrganizationId, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type UpdateVesselScheduleSharedToOrganizationMutationVariables = Exact<{
  input: UpdateVesselScheduleSharedToOrganizationByIdInput;
}>;


export type UpdateVesselScheduleSharedToOrganizationMutation = { __typename?: 'Mutation', updateVesselScheduleSharedToOrganizationById?: { __typename?: 'UpdateVesselScheduleSharedToOrganizationPayload', vesselScheduleSharedToOrganization?: { __typename?: 'VesselScheduleSharedToOrganization', id: VesselScheduleSharedToOrganizationId, vesselId: ShipId, organizationId: OrganizationId, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type DeleteVesselScheduleSharedToOrganizationMutationVariables = Exact<{
  input: DeleteVesselScheduleSharedToOrganizationByIdInput;
}>;


export type DeleteVesselScheduleSharedToOrganizationMutation = { __typename?: 'Mutation', deleteVesselScheduleSharedToOrganizationById?: { __typename?: 'DeleteVesselScheduleSharedToOrganizationPayload', vesselScheduleSharedToOrganization?: { __typename?: 'VesselScheduleSharedToOrganization', id: VesselScheduleSharedToOrganizationId, vesselId: ShipId, organizationId: OrganizationId, createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type VesselSpeedConsumption_AdminFragment = { __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null };

export type CreateVesselSpeedConsumptionMutationVariables = Exact<{
  input: CreateVesselSpeedConsumptionInput;
}>;


export type CreateVesselSpeedConsumptionMutation = { __typename?: 'Mutation', createVesselSpeedConsumption?: { __typename?: 'CreateVesselSpeedConsumptionPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, vesselSpeedConsumption?: { __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null } | null };

export type UpdateVesselSpeedConsumptionMutationVariables = Exact<{
  input: UpdateVesselSpeedConsumptionByIdInput;
}>;


export type UpdateVesselSpeedConsumptionMutation = { __typename?: 'Mutation', updateVesselSpeedConsumptionById?: { __typename?: 'UpdateVesselSpeedConsumptionPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, vesselSpeedConsumption?: { __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null } | null };

export type DeleteVesselSpeedConsumptionMutationVariables = Exact<{
  input: DeleteVesselSpeedConsumptionByIdInput;
}>;


export type DeleteVesselSpeedConsumptionMutation = { __typename?: 'Mutation', deleteVesselSpeedConsumptionById?: { __typename?: 'DeleteVesselSpeedConsumptionPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, vesselSpeedConsumption?: { __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null } | null };

export type VesselPerformanceModel_AdminFragment = { __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string };

export type Ship_AdminFragment = { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } };

export type AllShipsQueryVariables = Exact<{
  filter?: InputMaybe<ShipFilter>;
}>;


export type AllShipsQuery = { __typename?: 'Query', allShips?: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null> } | null };

export type CreateShipAdminMutationVariables = Exact<{
  input: CreateShipInput;
}>;


export type CreateShipAdminMutation = { __typename?: 'Mutation', createShip?: { __typename?: 'CreateShipPayload', ship?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null };

export type UpdateShipMutationVariables = Exact<{
  input: UpdateShipByIdInput;
}>;


export type UpdateShipMutation = { __typename?: 'Mutation', updateShipById?: { __typename?: 'UpdateShipPayload', ship?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null };

export type DeleteShipByIdMutationVariables = Exact<{
  input: DeleteShipByIdInput;
}>;


export type DeleteShipByIdMutation = { __typename?: 'Mutation', deleteShipById?: { __typename?: 'DeleteShipPayload', ship?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null };

export type BatchTunePerformanceModelsMutationVariables = Exact<{
  input: BatchTunePerformanceModelsInput;
}>;


export type BatchTunePerformanceModelsMutation = { __typename?: 'Mutation', batchTunePerformanceModels: { __typename?: 'BatchTunePerformanceModelsResult', totalProcessed: number, successCount: number, errorCount: number, results: Array<{ __typename?: 'UpdateVesselPerformanceModelResult', vesselId: number, performanceModelUid?: string | null, status: string, errorMessage?: string | null, warningMessage?: string | null }> } };

export type VoyageAttribute_AdminFragment = { __typename?: 'VoyageAttribute', id: VoyageAttributeId, name: string, color: string, isActive: boolean, description?: string | null };

export type AllVoyageAttributesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<VoyageAttributesOrderBy>>;
}>;


export type AllVoyageAttributesQuery = { __typename?: 'Query', allVoyageAttributes?: { __typename?: 'VoyageAttributesConnection', nodes: Array<{ __typename?: 'VoyageAttribute', id: VoyageAttributeId, name: string, color: string, isActive: boolean, description?: string | null } | null> } | null };

export type CreateVoyageAttributeMutationVariables = Exact<{
  input: CreateVoyageAttributeInput;
}>;


export type CreateVoyageAttributeMutation = { __typename?: 'Mutation', createVoyageAttribute?: { __typename?: 'CreateVoyageAttributePayload', voyageAttribute?: { __typename?: 'VoyageAttribute', id: VoyageAttributeId, name: string, color: string, isActive: boolean, description?: string | null } | null } | null };

export type UpdateVoyageAttributeByIdMutationVariables = Exact<{
  input: UpdateVoyageAttributeByIdInput;
}>;


export type UpdateVoyageAttributeByIdMutation = { __typename?: 'Mutation', updateVoyageAttributeById?: { __typename?: 'UpdateVoyageAttributePayload', voyageAttribute?: { __typename?: 'VoyageAttribute', id: VoyageAttributeId, name: string, color: string, isActive: boolean, description?: string | null } | null } | null };

export type DeleteVoyageAttributeByIdMutationVariables = Exact<{
  input: DeleteVoyageAttributeByIdInput;
}>;


export type DeleteVoyageAttributeByIdMutation = { __typename?: 'Mutation', deleteVoyageAttributeById?: { __typename?: 'DeleteVoyageAttributePayload', voyageAttribute?: { __typename?: 'VoyageAttribute', id: VoyageAttributeId, name: string, color: string, isActive: boolean, description?: string | null } | null } | null };

export type VoyageNamingRule_AdminFragment = { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null };

export type AllVoyageNamingRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVoyageNamingRulesQuery = { __typename?: 'Query', allVoyageNamingRules?: { __typename?: 'VoyageNamingRulesConnection', nodes: Array<{ __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null> } | null };

export type AllShipVoyageNamingRuleRelationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllShipVoyageNamingRuleRelationsQuery = { __typename?: 'Query', allShipVoyageNamingRuleRelations?: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, shipId: ShipId, ruleId: VoyageNamingRuleId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> } | null };

export type CreateVoyageNamingRuleMutationVariables = Exact<{
  input: CreateVoyageNamingRuleInput;
}>;


export type CreateVoyageNamingRuleMutation = { __typename?: 'Mutation', createVoyageNamingRule?: { __typename?: 'CreateVoyageNamingRulePayload', voyageNamingRule?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null };

export type UpdateVoyageNamingRuleMutationVariables = Exact<{
  input: UpdateVoyageNamingRuleByIdInput;
}>;


export type UpdateVoyageNamingRuleMutation = { __typename?: 'Mutation', updateVoyageNamingRuleById?: { __typename?: 'UpdateVoyageNamingRulePayload', voyageNamingRule?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null };

export type DeleteVoygeNamingRuleMutationVariables = Exact<{
  input: DeleteVoyageNamingRuleByIdInput;
}>;


export type DeleteVoygeNamingRuleMutation = { __typename?: 'Mutation', deleteVoyageNamingRuleById?: { __typename?: 'DeleteVoyageNamingRulePayload', voyageNamingRule?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null };

export type CreateShipVoyageNamingRuleRelationMutationVariables = Exact<{
  input: CreateShipVoyageNamingRuleRelationInput;
}>;


export type CreateShipVoyageNamingRuleRelationMutation = { __typename?: 'Mutation', createShipVoyageNamingRuleRelation?: { __typename?: 'CreateShipVoyageNamingRuleRelationPayload', shipVoyageNamingRuleRelation?: { __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null } | null };

export type UpdateShipVoyageNamingRuleRelationByIdMutationVariables = Exact<{
  input: UpdateShipVoyageNamingRuleRelationByIdInput;
}>;


export type UpdateShipVoyageNamingRuleRelationByIdMutation = { __typename?: 'Mutation', updateShipVoyageNamingRuleRelationById?: { __typename?: 'UpdateShipVoyageNamingRuleRelationPayload', shipVoyageNamingRuleRelation?: { __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null } | null };

export type DeleteShipVoyageNamingRuleRelationByIdMutationVariables = Exact<{
  input: DeleteShipVoyageNamingRuleRelationByIdInput;
}>;


export type DeleteShipVoyageNamingRuleRelationByIdMutation = { __typename?: 'Mutation', deleteShipVoyageNamingRuleRelationById?: { __typename?: 'DeleteShipVoyageNamingRuleRelationPayload', shipVoyageNamingRuleRelation?: { __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null } | null };

export type WorldscaleFreight_AdminFragment = { __typename?: 'WorldscaleFreight', id: WorldscaleFreightId, organizationId: OrganizationId, route: string, rate: string | number, currency: Currency, year: number, createdAt?: string | null, updatedAt?: string | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null };

export type AllWorldscaleFreightsQueryVariables = Exact<{
  filter?: InputMaybe<WorldscaleFreightFilter>;
}>;


export type AllWorldscaleFreightsQuery = { __typename?: 'Query', allWorldscaleFreights?: { __typename?: 'WorldscaleFreightsConnection', nodes: Array<{ __typename?: 'WorldscaleFreight', id: WorldscaleFreightId, organizationId: OrganizationId, route: string, rate: string | number, currency: Currency, year: number, createdAt?: string | null, updatedAt?: string | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null } | null> } | null };

export type CreateWorldscaleFreightMutationVariables = Exact<{
  input: CreateWorldscaleFreightInput;
}>;


export type CreateWorldscaleFreightMutation = { __typename?: 'Mutation', createWorldscaleFreight?: { __typename?: 'CreateWorldscaleFreightPayload', worldscaleFreight?: { __typename?: 'WorldscaleFreight', id: WorldscaleFreightId, organizationId: OrganizationId, route: string, rate: string | number, currency: Currency, year: number, createdAt?: string | null, updatedAt?: string | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null } | null } | null };

export type UpdateWorldscaleFreightMutationVariables = Exact<{
  input: UpdateWorldscaleFreightByIdInput;
}>;


export type UpdateWorldscaleFreightMutation = { __typename?: 'Mutation', updateWorldscaleFreightById?: { __typename?: 'UpdateWorldscaleFreightPayload', worldscaleFreight?: { __typename?: 'WorldscaleFreight', id: WorldscaleFreightId, organizationId: OrganizationId, route: string, rate: string | number, currency: Currency, year: number, createdAt?: string | null, updatedAt?: string | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null } | null } | null };

export type DeleteWorldscaleFreightMutationVariables = Exact<{
  input: DeleteWorldscaleFreightByIdInput;
}>;


export type DeleteWorldscaleFreightMutation = { __typename?: 'Mutation', deleteWorldscaleFreightById?: { __typename?: 'DeleteWorldscaleFreightPayload', worldscaleFreight?: { __typename?: 'WorldscaleFreight', id: WorldscaleFreightId, organizationId: OrganizationId, route: string, rate: string | number, currency: Currency, year: number, createdAt?: string | null, updatedAt?: string | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null } | null } | null };

export type ZonesAdmin_ZoneFragment = { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId, zoneId: ZoneId, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null> } };

export type ZonesAdmin_ZoneLocationFragment = { __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId, zoneId: ZoneId, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null };

export type ZonesAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type ZonesAdminQuery = { __typename?: 'Query', allZones?: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId, zoneId: ZoneId, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null> } } | null> } | null };

export type CreateZoneMutationVariables = Exact<{
  input: CreateZoneInput;
}>;


export type CreateZoneMutation = { __typename?: 'Mutation', createZone?: { __typename?: 'CreateZonePayload', zone?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId, zoneId: ZoneId, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null> } } | null } | null };

export type UpdateZoneMutationVariables = Exact<{
  input: UpdateZoneByIdInput;
}>;


export type UpdateZoneMutation = { __typename?: 'Mutation', updateZoneById?: { __typename?: 'UpdateZonePayload', zone?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId, zoneId: ZoneId, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null> } } | null } | null };

export type DeleteZoneMutationVariables = Exact<{
  input: DeleteZoneByIdInput;
}>;


export type DeleteZoneMutation = { __typename?: 'Mutation', deleteZoneById?: { __typename?: 'DeleteZonePayload', zone?: { __typename?: 'Zone', id: ZoneId } | null } | null };

export type CreateZoneLocationMutationVariables = Exact<{
  input: CreateZoneLocationInput;
}>;


export type CreateZoneLocationMutation = { __typename?: 'Mutation', createZoneLocation?: { __typename?: 'CreateZoneLocationPayload', zoneLocation?: { __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId, zoneId: ZoneId, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null } | null };

export type DeleteZoneLocationMutationVariables = Exact<{
  input: DeleteZoneLocationByIdInput;
}>;


export type DeleteZoneLocationMutation = { __typename?: 'Mutation', deleteZoneLocationById?: { __typename?: 'DeleteZoneLocationPayload', zoneLocation?: { __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId, zoneId: ZoneId, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null } | null };

export type ZonesAdminFormQueryVariables = Exact<{ [key: string]: never; }>;


export type ZonesAdminFormQuery = { __typename?: 'Query', allLocations?: { __typename?: 'LocationsConnection', nodes: Array<{ __typename?: 'Location', id: LocationId, name: string } | null> } | null };

export type ContractPortDatumFragment = { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null };

export type ScheduledOrderFragment = { __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null };

export type ArchiveByIdsMutationVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['OrderId']['input']>>;
  portCallIds?: InputMaybe<Array<Scalars['PortCallId']['input']>>;
  scheduledOrderIds?: InputMaybe<Array<Scalars['ScheduledOrderId']['input']>>;
  handledBySpotIds?: InputMaybe<Array<Scalars['HandledBySpotId']['input']>>;
  handledByCoaIds?: InputMaybe<Array<Scalars['HandledByCoaId']['input']>>;
  singleEventIds?: InputMaybe<Array<Scalars['SingleEventId']['input']>>;
  offHireIds?: InputMaybe<Array<Scalars['OffHireId']['input']>>;
}>;


export type ArchiveByIdsMutation = { __typename?: 'Mutation', archiveByIds?: boolean | null };

export type UnarchiveByIdsMutationVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['OrderId']['input']>>;
  portCallIds?: InputMaybe<Array<Scalars['PortCallId']['input']>>;
  scheduledOrderIds?: InputMaybe<Array<Scalars['ScheduledOrderId']['input']>>;
  handledBySpotIds?: InputMaybe<Array<Scalars['HandledBySpotId']['input']>>;
  handledByCoaIds?: InputMaybe<Array<Scalars['HandledByCoaId']['input']>>;
  singleEventIds?: InputMaybe<Array<Scalars['SingleEventId']['input']>>;
  offHireIds?: InputMaybe<Array<Scalars['OffHireId']['input']>>;
}>;


export type UnarchiveByIdsMutation = { __typename?: 'Mutation', unarchiveByIds?: boolean | null };

export type AuthenticateMutationVariables = Exact<{
  input: AuthenticateInput;
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate?: { __typename?: 'AuthenticatePayload', jwtToken?: string | null } | null };

export type GoogleAuthenticateMutationVariables = Exact<{
  input: GoogleAuthenticateInput;
}>;


export type GoogleAuthenticateMutation = { __typename?: 'Mutation', googleAuthenticate?: { __typename?: 'GoogleAuthenticatePayload', jwtToken?: string | null } | null };

export type MicrosoftAuthenticateMutationVariables = Exact<{
  input: MicrosoftAuthenticateInput;
}>;


export type MicrosoftAuthenticateMutation = { __typename?: 'Mutation', microsoftAuthenticate?: { __typename?: 'MicrosoftAuthenticatePayload', jwtToken?: string | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'ChangePasswordPayload', jwtToken?: string | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordPayload', clientMutationId?: string | null } | null };

export type RequestResetPasswordMutationVariables = Exact<{
  input: RequestResetPasswordInput;
}>;


export type RequestResetPasswordMutation = { __typename?: 'Mutation', requestResetPassword?: { __typename?: 'RequestResetPasswordPayload', clientMutationId?: string | null } | null };

export type BolForm__BillOfLadingFragment = { __typename?: 'BillOfLading', id: BillOfLadingId, portCallId: PortCallId, billOfLadingDataByBillOfLadingId: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null } | null> } };

export type BolForm__BillOfLadingDatumFragment = { __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null };

export type CreateBolMutationVariables = Exact<{
  input: CreateBillOfLadingInput;
}>;


export type CreateBolMutation = { __typename?: 'Mutation', createBillOfLading?: { __typename?: 'CreateBillOfLadingPayload', billOfLading?: { __typename?: 'BillOfLading', id: BillOfLadingId, portCallId: PortCallId, billOfLadingDataByBillOfLadingId: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null } | null> } } | null } | null };

export type CreateBolDatumMutationVariables = Exact<{
  input: CreateBillOfLadingDatumInput;
}>;


export type CreateBolDatumMutation = { __typename?: 'Mutation', createBillOfLadingDatum?: { __typename?: 'CreateBillOfLadingDatumPayload', billOfLadingDatum?: { __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null } | null } | null };

export type UpdateBolDatumMutationVariables = Exact<{
  input: UpdateBillOfLadingDatumByIdInput;
}>;


export type UpdateBolDatumMutation = { __typename?: 'Mutation', updateBillOfLadingDatumById?: { __typename?: 'UpdateBillOfLadingDatumPayload', billOfLadingDatum?: { __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null } | null } | null };

export type BalticOrdersSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type BalticOrdersSyncMutation = { __typename?: 'Mutation', balticOrdersSync?: { __typename?: 'BalticOrdersSyncResult', status: Status, errorMessage?: string | null } | null };

export type BalticVesselsSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type BalticVesselsSyncMutation = { __typename?: 'Mutation', balticVesselsSync?: { __typename?: 'BalticVesselsSyncResult', status: Status, errorMessage?: string | null } | null };

export type BalticScenarioSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type BalticScenarioSyncMutation = { __typename?: 'Mutation', balticScenarioSync?: { __typename?: 'BalticScenarioSyncResult', status: Status, errorMessage?: string | null } | null };

export type BalticUpdateDataMutationVariables = Exact<{ [key: string]: never; }>;


export type BalticUpdateDataMutation = { __typename?: 'Mutation', balticUpdateData?: { __typename?: 'BalticUpdateData', syncOrders: { __typename?: 'BalticOrdersSyncResult', status: Status, errorMessage?: string | null }, syncVessel: { __typename?: 'BalticVesselsSyncResult', status: Status, errorMessage?: string | null }, syncScenario: { __typename?: 'BalticScenarioSyncResult', status: Status, errorMessage?: string | null } } | null };

export type BunkerExMutationVariables = Exact<{ [key: string]: never; }>;


export type BunkerExMutation = { __typename?: 'Mutation', bunkerEx?: { __typename?: 'BunkerEx', message?: string | null, prices?: Array<{ __typename?: 'BunkerExSpotPrice', port: { __typename?: 'BunkerExPort', id: string, name: string }, fuelGrade: { __typename?: 'BunkerExFuelGrade', id: string }, latestPrices: Array<{ __typename?: 'BunkerExLatestPrice', publishedDate: string, price: number }> } | null> | null } | null };

export type CreateCoaAssignmentMutationVariables = Exact<{
  input: CreateHandledByCoaInput;
}>;


export type CreateCoaAssignmentMutation = { __typename?: 'Mutation', createHandledByCoa?: { __typename?: 'CreateHandledByCoaPayload', handledByCoa?: { __typename?: 'HandledByCoa', id: HandledByCoaId, coaId: CoaContractId, orderId: OrderId, vesselId?: ShipId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null } | null };

export type UpdateCoaAssignmentMutationVariables = Exact<{
  input: UpdateHandledByCoaByIdInput;
}>;


export type UpdateCoaAssignmentMutation = { __typename?: 'Mutation', updateHandledByCoaById?: { __typename?: 'UpdateHandledByCoaPayload', handledByCoa?: { __typename?: 'HandledByCoa', id: HandledByCoaId, coaId: CoaContractId, orderId: OrderId, vesselId?: ShipId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null } | null };

export type DeleteCoaAssignmentMutationVariables = Exact<{
  input: DeleteHandledByCoaByIdInput;
}>;


export type DeleteCoaAssignmentMutation = { __typename?: 'Mutation', deleteHandledByCoaById?: { __typename?: 'DeleteHandledByCoaPayload', deletedHandledByCoaId?: string | null } | null };

export type CreateOffHireMutationVariables = Exact<{
  input: CreateOffHireInput;
}>;


export type CreateOffHireMutation = { __typename?: 'Mutation', createOffHire?: { __typename?: 'CreateOffHirePayload', offHire?: { __typename?: 'OffHire', id: OffHireId, end: string, locationAId: LocationId, locationBId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, duration: string | number, vesselId?: ShipId | null, type?: OffHireType | null, planningOrganisationId: OrganizationId, userId: UserId, clientId: string, updatedAt?: string | null, archived: boolean, tcOutRate?: string | number | null, commissionPct?: string | number | null, ballastBonus?: string | number | null, ballastBonusCommissionable?: boolean | null, locationByLocationAId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLocationBId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null } | null };

export type UpdateOffHireMutationVariables = Exact<{
  input: UpdateOffHireByIdInput;
}>;


export type UpdateOffHireMutation = { __typename?: 'Mutation', updateOffHireById?: { __typename?: 'UpdateOffHirePayload', offHire?: { __typename?: 'OffHire', id: OffHireId, end: string, locationAId: LocationId, locationBId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, duration: string | number, vesselId?: ShipId | null, type?: OffHireType | null, planningOrganisationId: OrganizationId, userId: UserId, clientId: string, updatedAt?: string | null, archived: boolean, tcOutRate?: string | number | null, commissionPct?: string | number | null, ballastBonus?: string | number | null, ballastBonusCommissionable?: boolean | null, locationByLocationAId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLocationBId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null } | null };

export type DeleteOffHireMutationVariables = Exact<{
  offHireId: Scalars['OffHireId']['input'];
}>;


export type DeleteOffHireMutation = { __typename?: 'Mutation', deleteOffHireById?: { __typename?: 'DeleteOffHirePayload', deletedOffHireId?: string | null } | null };

export type CreateOpenPositionMutationVariables = Exact<{
  input: CreateOpenPositionInput;
}>;


export type CreateOpenPositionMutation = { __typename?: 'Mutation', createOpenPosition?: { __typename?: 'CreateOpenPositionPayload', openPosition?: { __typename?: 'OpenPosition', id: OpenPositionId, vesselId: ShipId, startTime: string, startPortId: LocationId, directionId?: LocationId | null, remark?: string | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByDirectionId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null } | null };

export type UpdateOpenPositionMutationVariables = Exact<{
  input: UpdateOpenPositionByIdInput;
}>;


export type UpdateOpenPositionMutation = { __typename?: 'Mutation', updateOpenPositionById?: { __typename?: 'UpdateOpenPositionPayload', openPosition?: { __typename?: 'OpenPosition', id: OpenPositionId, vesselId: ShipId, startTime: string, startPortId: LocationId, directionId?: LocationId | null, remark?: string | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByDirectionId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null } | null };

export type DeleteOpenPositionMutationVariables = Exact<{
  openPositionId: Scalars['OpenPositionId']['input'];
}>;


export type DeleteOpenPositionMutation = { __typename?: 'Mutation', deleteOpenPositionById?: { __typename?: 'DeleteOpenPositionPayload', deletedOpenPositionId?: string | null } | null };

export type CreateScenarioMutationVariables = Exact<{
  input: CreateScenarioInput;
}>;


export type CreateScenarioMutation = { __typename?: 'Mutation', createScenario?: { __typename?: 'CreateScenarioPayload', scenario?: { __typename?: 'Scenario', id: ScenarioId, clientId: string, organizationId: OrganizationId, name?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, createdBy: UserId, updatedBy: UserId, dataSchemaVersion: number, data: string, shared: boolean, deletedAt?: string | null } | null } | null };

export type UpdateScenarioMutationVariables = Exact<{
  input: UpdateScenarioByIdInput;
}>;


export type UpdateScenarioMutation = { __typename?: 'Mutation', updateScenarioById?: { __typename?: 'UpdateScenarioPayload', scenario?: { __typename?: 'Scenario', id: ScenarioId, clientId: string, organizationId: OrganizationId, name?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, createdBy: UserId, updatedBy: UserId, dataSchemaVersion: number, data: string, shared: boolean, deletedAt?: string | null } | null } | null };

export type DeleteScenarioMutationVariables = Exact<{
  input: DeleteScenarioByIdInput;
}>;


export type DeleteScenarioMutation = { __typename?: 'Mutation', deleteScenarioById?: { __typename?: 'DeleteScenarioPayload', deletedScenarioId?: string | null } | null };

export type CreateVesselReservationMutationVariables = Exact<{
  input: CreateVesselReservationInput;
}>;


export type CreateVesselReservationMutation = { __typename?: 'Mutation', createVesselReservation?: { __typename?: 'CreateVesselReservationPayload', vesselReservation?: { __typename?: 'VesselReservation', id: VesselReservationId, duration: number, expireTime?: string | null, remark?: string | null, startPortId?: LocationId | null, endPortId?: LocationId | null, startRegionId?: RegionId | null, endRegionId?: RegionId | null, startTime: string, type: VesselReservationType, vesselId: ShipId, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByEndPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, regionByStartRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, regionByEndRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null } | null };

export type UpdateVesselReservationMutationVariables = Exact<{
  input: UpdateVesselReservationByIdInput;
}>;


export type UpdateVesselReservationMutation = { __typename?: 'Mutation', updateVesselReservationById?: { __typename?: 'UpdateVesselReservationPayload', vesselReservation?: { __typename?: 'VesselReservation', id: VesselReservationId, duration: number, expireTime?: string | null, remark?: string | null, startPortId?: LocationId | null, endPortId?: LocationId | null, startRegionId?: RegionId | null, endRegionId?: RegionId | null, startTime: string, type: VesselReservationType, vesselId: ShipId, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByEndPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, regionByStartRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, regionByEndRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null } | null };

export type DeleteVesselReservationMutationVariables = Exact<{
  id: Scalars['VesselReservationId']['input'];
}>;


export type DeleteVesselReservationMutation = { __typename?: 'Mutation', deleteVesselReservationById?: { __typename?: 'DeleteVesselReservationPayload', deletedVesselReservationId?: string | null } | null };

export type CarbonPriceMutationVariables = Exact<{ [key: string]: never; }>;


export type CarbonPriceMutation = { __typename?: 'Mutation', carbonPrice?: { __typename?: 'CarbonPrice', price: number, updatedAt: string | number, isOverride?: boolean | null } | null };

export type CarbonPriceOverride_AdminFragment = { __typename?: 'CarbonPriceOverride', id: CarbonPriceOverrideId, price: string | number, organizationId: OrganizationId, updatedAt?: string | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type AllCarbonPriceOverrideQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCarbonPriceOverrideQuery = { __typename?: 'Query', allCarbonPriceOverrides?: { __typename?: 'CarbonPriceOverridesConnection', nodes: Array<{ __typename?: 'CarbonPriceOverride', id: CarbonPriceOverrideId, price: string | number, organizationId: OrganizationId, updatedAt?: string | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } | null };

export type CreateCarbonPriceOverrideMutationVariables = Exact<{
  input: CreateCarbonPriceOverrideInput;
}>;


export type CreateCarbonPriceOverrideMutation = { __typename?: 'Mutation', createCarbonPriceOverride?: { __typename?: 'CreateCarbonPriceOverridePayload', carbonPriceOverride?: { __typename?: 'CarbonPriceOverride', id: CarbonPriceOverrideId, price: string | number, organizationId: OrganizationId, updatedAt?: string | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type UpdateCarbonPriceOverrideByIdMutationVariables = Exact<{
  input: UpdateCarbonPriceOverrideByIdInput;
}>;


export type UpdateCarbonPriceOverrideByIdMutation = { __typename?: 'Mutation', updateCarbonPriceOverrideById?: { __typename?: 'UpdateCarbonPriceOverridePayload', carbonPriceOverride?: { __typename?: 'CarbonPriceOverride', id: CarbonPriceOverrideId, price: string | number, organizationId: OrganizationId, updatedAt?: string | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type DeleteCarbonPriceOverrideByIdMutationVariables = Exact<{
  input: DeleteCarbonPriceOverrideByIdInput;
}>;


export type DeleteCarbonPriceOverrideByIdMutation = { __typename?: 'Mutation', deleteCarbonPriceOverrideById?: { __typename?: 'DeleteCarbonPriceOverridePayload', carbonPriceOverride?: { __typename?: 'CarbonPriceOverride', id: CarbonPriceOverrideId, price: string | number, organizationId: OrganizationId, updatedAt?: string | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type CreateChannelCostEstimateClientMutationVariables = Exact<{
  input: CreateChannelCostEstimateInput;
}>;


export type CreateChannelCostEstimateClientMutation = { __typename?: 'Mutation', createChannelCostEstimate?: { __typename?: 'CreateChannelCostEstimatePayload', channelCostEstimate?: { __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, vesselTypeId?: VesselAttributeId | null, vesselId?: ShipId | null, channelCost: string | number, channelCostCurrency: string, durationOverhead?: string | number | null, channelName: string, cargoCondition?: ChannelCostCargoCondition | null, assortmentGroupId?: AssortmentGroupId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null, query?: { __typename?: 'Query', allChannelCostEstimates?: { __typename?: 'ChannelCostEstimatesConnection', nodes: Array<{ __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, vesselTypeId?: VesselAttributeId | null, vesselId?: ShipId | null, channelCost: string | number, channelCostCurrency: string, durationOverhead?: string | number | null, channelName: string, cargoCondition?: ChannelCostCargoCondition | null, assortmentGroupId?: AssortmentGroupId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } | null } | null } | null };

export type UpdateChannelCostEstimateClientMutationVariables = Exact<{
  input: UpdateChannelCostEstimateByIdInput;
}>;


export type UpdateChannelCostEstimateClientMutation = { __typename?: 'Mutation', updateChannelCostEstimateById?: { __typename?: 'UpdateChannelCostEstimatePayload', channelCostEstimate?: { __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, vesselTypeId?: VesselAttributeId | null, vesselId?: ShipId | null, channelCost: string | number, channelCostCurrency: string, durationOverhead?: string | number | null, channelName: string, cargoCondition?: ChannelCostCargoCondition | null, assortmentGroupId?: AssortmentGroupId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null } | null };

export type DeleteBillOfLadingDatumByIdMutationVariables = Exact<{
  bolDatumId: Scalars['BillOfLadingDatumId']['input'];
}>;


export type DeleteBillOfLadingDatumByIdMutation = { __typename?: 'Mutation', deleteBillOfLadingDatumById?: { __typename?: 'DeleteBillOfLadingDatumPayload', deletedBillOfLadingDatumId?: string | null } | null };

export type DeleteCargoMeasurementByIdMutationVariables = Exact<{
  cargoMeasurementId: Scalars['CargoMeasurementId']['input'];
}>;


export type DeleteCargoMeasurementByIdMutation = { __typename?: 'Mutation', deleteCargoMeasurementById?: { __typename?: 'DeleteCargoMeasurementPayload', deletedCargoMeasurementId?: string | null } | null };

export type DeleteNotificationReceiverByIdMutationVariables = Exact<{
  notificationReceiverId: Scalars['Int']['input'];
}>;


export type DeleteNotificationReceiverByIdMutation = { __typename?: 'Mutation', deleteNotificationReceiverById?: { __typename?: 'DeleteNotificationReceiverPayload', deletedNotificationReceiverId?: string | null } | null };

export type DeleteCargoCompartmentAllocationByIdMutationVariables = Exact<{
  cargoCompartmentAllocationId: Scalars['CargoCompartmentAllocationId']['input'];
}>;


export type DeleteCargoCompartmentAllocationByIdMutation = { __typename?: 'Mutation', deleteCargoCompartmentAllocationById?: { __typename?: 'DeleteCargoCompartmentAllocationPayload', deletedCargoCompartmentAllocationId?: string | null } | null };

export type SoftDeleteOrdersMutationVariables = Exact<{
  ids: Array<Scalars['OrderId']['input']>;
}>;


export type SoftDeleteOrdersMutation = { __typename?: 'Mutation', softDeleteOrders?: { __typename?: 'SoftDeleteOrdersPayload', bols: Array<number>, ccas: Array<number>, ces: Array<number>, cms: Array<number>, nrs: Array<number>, opcrs: Array<number>, ovcrs: Array<number>, orders: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } }> } | null };

export type CreateCoaMutationVariables = Exact<{
  input: CreateCoaContractInput;
}>;


export type CreateCoaMutation = { __typename?: 'Mutation', createCoaContract?: { __typename?: 'CreateCoaContractPayload', coaContract?: { __typename?: 'CoaContract', id: CoaContractId, name?: string | null, externalId?: string | null, amountUnitId?: CargoUnitId | null, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, shipownerOrgId: OrganizationId, chartererOrgId: OrganizationId, currency?: Currency | null, paymentDays?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type UpdateCoaMutationVariables = Exact<{
  input: UpdateCoaContractByIdInput;
}>;


export type UpdateCoaMutation = { __typename?: 'Mutation', updateCoaContractById?: { __typename?: 'UpdateCoaContractPayload', coaContract?: { __typename?: 'CoaContract', id: CoaContractId, name?: string | null, externalId?: string | null, amountUnitId?: CargoUnitId | null, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, shipownerOrgId: OrganizationId, chartererOrgId: OrganizationId, currency?: Currency | null, paymentDays?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type DeleteCoaMutationVariables = Exact<{
  input: DeleteCoaContractByIdInput;
}>;


export type DeleteCoaMutation = { __typename?: 'Mutation', deleteCoaContractById?: { __typename?: 'DeleteCoaContractPayload', deletedCoaContractId?: string | null } | null };

export type CreateCoaBunkerMutationVariables = Exact<{
  input: CreateCoaContractBunkerInput;
}>;


export type CreateCoaBunkerMutation = { __typename?: 'Mutation', createCoaContractBunker?: { __typename?: 'CreateCoaContractBunkerPayload', coaContractBunker?: { __typename?: 'CoaContractBunker', id: CoaContractBunkerId, coaContractId: CoaContractId, bunkerGrade: BunkerGrade, price: string | number, basePriceMax?: string | number | null, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, bafType?: BafTypes | null, bafStepSize?: string | number | null, bafStepEffect?: string | number | null, bafStartFromBase?: boolean | null, bafUseStepEffectAsValue?: boolean | null, bafBunkerAmount?: string | number | null } | null } | null };

export type UpdateCoaBunkerMutationVariables = Exact<{
  input: UpdateCoaContractBunkerByIdInput;
}>;


export type UpdateCoaBunkerMutation = { __typename?: 'Mutation', updateCoaContractBunkerById?: { __typename?: 'UpdateCoaContractBunkerPayload', coaContractBunker?: { __typename?: 'CoaContractBunker', id: CoaContractBunkerId, coaContractId: CoaContractId, bunkerGrade: BunkerGrade, price: string | number, basePriceMax?: string | number | null, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, bafType?: BafTypes | null, bafStepSize?: string | number | null, bafStepEffect?: string | number | null, bafStartFromBase?: boolean | null, bafUseStepEffectAsValue?: boolean | null, bafBunkerAmount?: string | number | null } | null } | null };

export type DeleteCoaBunkerMutationVariables = Exact<{
  input: DeleteCoaContractBunkerByIdInput;
}>;


export type DeleteCoaBunkerMutation = { __typename?: 'Mutation', deleteCoaContractBunkerById?: { __typename?: 'DeleteCoaContractBunkerPayload', deletedCoaContractBunkerId?: string | null } | null };

export type CreateCoaPortPairMutationVariables = Exact<{
  input: CreateCoaContractPortInput;
}>;


export type CreateCoaPortPairMutation = { __typename?: 'Mutation', createCoaContractPort?: { __typename?: 'CreateCoaContractPortPayload', coaContractPort?: { __typename?: 'CoaContractPort', id: CoaContractPortId, chartererId: UserId, originId?: LocationId | null, destinationId?: LocationId | null, originZoneId?: ZoneId | null, destinationZoneId?: ZoneId | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null } | null } | null };

export type UpdateCoaPortPairMutationVariables = Exact<{
  input: UpdateCoaContractPortByIdInput;
}>;


export type UpdateCoaPortPairMutation = { __typename?: 'Mutation', updateCoaContractPortById?: { __typename?: 'UpdateCoaContractPortPayload', coaContractPort?: { __typename?: 'CoaContractPort', id: CoaContractPortId, chartererId: UserId, originId?: LocationId | null, destinationId?: LocationId | null, originZoneId?: ZoneId | null, destinationZoneId?: ZoneId | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null } | null } | null };

export type DeleteCoaPortPairMutationVariables = Exact<{
  input: DeleteCoaContractPortByIdInput;
}>;


export type DeleteCoaPortPairMutation = { __typename?: 'Mutation', deleteCoaContractPortById?: { __typename?: 'DeleteCoaContractPortPayload', deletedCoaContractPortId?: string | null } | null };

export type CreateCoaPortDataMutationVariables = Exact<{
  input: CreateCoaContractPortDatumInput;
}>;


export type CreateCoaPortDataMutation = { __typename?: 'Mutation', createCoaContractPortDatum?: { __typename?: 'CreateCoaContractPortDatumPayload', coaContractPortDatum?: { __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, coaContractId: CoaContractId, portDataId: PortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null } | null };

export type CreateCoaAssortmentMutationVariables = Exact<{
  input: CreateCoaContractAssortmentInput;
}>;


export type CreateCoaAssortmentMutation = { __typename?: 'Mutation', createCoaContractAssortment?: { __typename?: 'CreateCoaContractAssortmentPayload', coaContractAssortment?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, coaContractId: CoaContractId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null } | null };

export type UpdateCoaAssortmentMutationVariables = Exact<{
  input: UpdateCoaContractAssortmentByIdInput;
}>;


export type UpdateCoaAssortmentMutation = { __typename?: 'Mutation', updateCoaContractAssortmentById?: { __typename?: 'UpdateCoaContractAssortmentPayload', coaContractAssortment?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, coaContractId: CoaContractId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null } | null };

export type DeleteCoaAssortmentMutationVariables = Exact<{
  input: DeleteCoaContractAssortmentByIdInput;
}>;


export type DeleteCoaAssortmentMutation = { __typename?: 'Mutation', deleteCoaContractAssortmentById?: { __typename?: 'DeleteCoaContractAssortmentPayload', deletedCoaContractAssortmentId?: string | null } | null };

export type CreateCoaPriceMutationVariables = Exact<{
  input: CreateCoaContractPriceInput;
}>;


export type CreateCoaPriceMutation = { __typename?: 'Mutation', createCoaContractPrice?: { __typename?: 'CreateCoaContractPricePayload', coaContractPrice?: { __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaContractId: CoaContractId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, shipId?: ShipId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null } | null };

export type UpdateCoaPriceMutationVariables = Exact<{
  input: UpdateCoaContractPriceByIdInput;
}>;


export type UpdateCoaPriceMutation = { __typename?: 'Mutation', updateCoaContractPriceById?: { __typename?: 'UpdateCoaContractPricePayload', coaContractPrice?: { __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaContractId: CoaContractId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, shipId?: ShipId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null } | null };

export type DeleteCoaPriceMutationVariables = Exact<{
  input: DeleteCoaContractPriceByIdInput;
}>;


export type DeleteCoaPriceMutation = { __typename?: 'Mutation', deleteCoaContractPriceById?: { __typename?: 'DeleteCoaContractPricePayload', deletedCoaContractPriceId?: string | null } | null };

export type CreateCoaVesselMutationVariables = Exact<{
  input: CreateCoaContractShipInput;
}>;


export type CreateCoaVesselMutation = { __typename?: 'Mutation', createCoaContractShip?: { __typename?: 'CreateCoaContractShipPayload', coaContractShip?: { __typename?: 'CoaContractShip', id: CoaContractShipId, demurrage?: string | number | null, shipId: ShipId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null } | null };

export type UpdateCoaVesselMutationVariables = Exact<{
  input: UpdateCoaContractShipByIdInput;
}>;


export type UpdateCoaVesselMutation = { __typename?: 'Mutation', updateCoaContractShipById?: { __typename?: 'UpdateCoaContractShipPayload', coaContractShip?: { __typename?: 'CoaContractShip', id: CoaContractShipId, demurrage?: string | number | null, shipId: ShipId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null } | null };

export type DeleteCoaVesselMutationVariables = Exact<{
  input: DeleteCoaContractShipByIdInput;
}>;


export type DeleteCoaVesselMutation = { __typename?: 'Mutation', deleteCoaContractShipById?: { __typename?: 'DeleteCoaContractShipPayload', deletedCoaContractShipId?: string | null } | null };

export type UpdateCoaInactivityMutationVariables = Exact<{
  coaId: Scalars['CoaContractId']['input'];
  inactive: Scalars['Boolean']['input'];
}>;


export type UpdateCoaInactivityMutation = { __typename?: 'Mutation', updateCoaContractById?: { __typename?: 'UpdateCoaContractPayload', coaContract?: { __typename?: 'CoaContract', id: CoaContractId, inactive: boolean } | null } | null };

export type CreateCoaCommissionMutationVariables = Exact<{
  input: CreateCoaContractCommissionInput;
}>;


export type CreateCoaCommissionMutation = { __typename?: 'Mutation', createCoaContractCommission?: { __typename?: 'CreateCoaContractCommissionPayload', coaContractCommission?: { __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null } | null };

export type UpdateCoaCommissionMutationVariables = Exact<{
  input: UpdateCoaContractCommissionByIdInput;
}>;


export type UpdateCoaCommissionMutation = { __typename?: 'Mutation', updateCoaContractCommissionById?: { __typename?: 'UpdateCoaContractCommissionPayload', coaContractCommission?: { __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null } | null };

export type DeleteCoaCommissionMutationVariables = Exact<{
  input: DeleteCoaContractCommissionByIdInput;
}>;


export type DeleteCoaCommissionMutation = { __typename?: 'Mutation', deleteCoaContractCommissionById?: { __typename?: 'DeleteCoaContractCommissionPayload', coaContractCommission?: { __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null } | null };

export type CreateCoaPortCostMutationVariables = Exact<{
  input: CreateCoaContractPortCostInput;
}>;


export type CreateCoaPortCostMutation = { __typename?: 'Mutation', createCoaContractPortCost?: { __typename?: 'CreateCoaContractPortCostPayload', coaContractPortCost?: { __typename?: 'CoaContractPortCost', id: CoaContractPortCostId, locationId: LocationId, coaContractId: CoaContractId, shipId?: ShipId | null, cost: string | number, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type UpdateCoaPortCostMutationVariables = Exact<{
  input: UpdateCoaContractPortCostByIdInput;
}>;


export type UpdateCoaPortCostMutation = { __typename?: 'Mutation', updateCoaContractPortCostById?: { __typename?: 'UpdateCoaContractPortCostPayload', coaContractPortCost?: { __typename?: 'CoaContractPortCost', id: CoaContractPortCostId, locationId: LocationId, coaContractId: CoaContractId, shipId?: ShipId | null, cost: string | number, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type DeleteCoaPortCostMutationVariables = Exact<{
  input: DeleteCoaContractPortCostByIdInput;
}>;


export type DeleteCoaPortCostMutation = { __typename?: 'Mutation', deleteCoaContractPortCostById?: { __typename?: 'DeleteCoaContractPortCostPayload', coaContractPortCost?: { __typename?: 'CoaContractPortCost', id: CoaContractPortCostId, locationId: LocationId, coaContractId: CoaContractId, shipId?: ShipId | null, cost: string | number, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null } | null };

export type CreateCoaDeviationCostMutationVariables = Exact<{
  input: CreateCoaContractDeviationCostInput;
}>;


export type CreateCoaDeviationCostMutation = { __typename?: 'Mutation', createCoaContractDeviationCost?: { __typename?: 'CreateCoaContractDeviationCostPayload', coaContractDeviationCost?: { __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null, zoneByFromZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByToZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null } | null };

export type UpdateCoaDeviationCostMutationVariables = Exact<{
  input: UpdateCoaContractDeviationCostByIdInput;
}>;


export type UpdateCoaDeviationCostMutation = { __typename?: 'Mutation', updateCoaContractDeviationCostById?: { __typename?: 'UpdateCoaContractDeviationCostPayload', coaContractDeviationCost?: { __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null, zoneByFromZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByToZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null } | null };

export type DeleteCoaDeviationCostMutationVariables = Exact<{
  input: DeleteCoaContractDeviationCostByIdInput;
}>;


export type DeleteCoaDeviationCostMutation = { __typename?: 'Mutation', deleteCoaContractDeviationCostById?: { __typename?: 'DeleteCoaContractDeviationCostPayload', coaContractDeviationCost?: { __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null, zoneByFromZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByToZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null } | null };

export type CommitMutationVariables = Exact<{
  data: CommitInput;
}>;


export type CommitMutation = { __typename?: 'Mutation', commit?: { __typename?: 'CommitPayload', success: boolean, committedAt: string, createdShipments: Array<{ __typename?: 'Ident', id: number }>, createdVoyageCharters: Array<{ __typename?: 'Ident', id: number }> } | null };

export type CreateCommitLogScenarioMutationVariables = Exact<{
  input: CreateCommitLogScenarioInput;
}>;


export type CreateCommitLogScenarioMutation = { __typename?: 'Mutation', createCommitLogScenario?: { __typename?: 'CreateCommitLogScenarioPayload', commitLogScenario?: { __typename?: 'CommitLogScenario', id: CommitLogScenarioId } | null } | null };

export type CreateFileMutationVariables = Exact<{
  input: CreateFileInput;
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createFile?: { __typename?: 'CreateFilePayload', file?: { __typename?: 'File', id: FileId, uri: string, orderId?: OrderId | null, vesselId?: ShipId | null, voyageId?: VoyageId | null, locationId?: LocationId | null, shipmentId?: ShipmentId | null, uploaded?: string | null, userId: UserId, type: DocumentType, note?: string | null } | null } | null };

export type DeleteFileMutationVariables = Exact<{
  input: DeleteFileByIdInput;
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFileById?: { __typename?: 'DeleteFilePayload', file?: { __typename?: 'File', id: FileId } | null } | null };

export type CreateHandledBySpotMutationVariables = Exact<{
  input: CreateHandledBySpotInput;
}>;


export type CreateHandledBySpotMutation = { __typename?: 'Mutation', createHandledBySpot?: { __typename?: 'CreateHandledBySpotPayload', handledBySpot?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null } | null };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'CreateOrderPayload', order?: { __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null } | null };

export type CreateOrderDetailMutationVariables = Exact<{
  input: CreateOrderDetailInput;
}>;


export type CreateOrderDetailMutation = { __typename?: 'Mutation', createOrderDetail?: { __typename?: 'CreateOrderDetailPayload', orderDetail?: { __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null } | null };

export type CreateCargoExclusionMutationVariables = Exact<{
  input: CreateCargoExclusionInput;
}>;


export type CreateCargoExclusionMutation = { __typename?: 'Mutation', createCargoExclusion?: { __typename?: 'CreateCargoExclusionPayload', cargoExclusion?: { __typename?: 'CargoExclusion', id: CargoExclusionId } | null } | null };

export type CreateOrderRequirementAssociationMutationVariables = Exact<{
  input: CreateOrderRequirementAssociationInput;
}>;


export type CreateOrderRequirementAssociationMutation = { __typename?: 'Mutation', createOrderRequirementAssociation?: { __typename?: 'CreateOrderRequirementAssociationPayload', orderRequirementAssociation?: { __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null } | null };

export type CreateOrderAttributeAssociationMutationVariables = Exact<{
  input: CreateOrderAttributeAssociationInput;
}>;


export type CreateOrderAttributeAssociationMutation = { __typename?: 'Mutation', createOrderAttributeAssociation?: { __typename?: 'CreateOrderAttributeAssociationPayload', orderAttributeAssociation?: { __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null } | null };

export type CreatePortCallFileMutationVariables = Exact<{
  input: CreatePortCallFileInput;
}>;


export type CreatePortCallFileMutation = { __typename?: 'Mutation', createPortCallFile?: { __typename?: 'CreatePortCallFilePayload', portCallFile?: { __typename?: 'PortCallFile', id: PortCallFileId, fileId: FileId, portCallId: PortCallId } | null } | null };

export type CreateScheduledOrderMutationVariables = Exact<{
  input: CreateScheduledOrderInput;
}>;


export type CreateScheduledOrderMutation = { __typename?: 'Mutation', createScheduledOrder?: { __typename?: 'CreateScheduledOrderPayload', scheduledOrder?: { __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null } | null };

export type CreateShipmentMutationVariables = Exact<{
  input: CreateShipmentInput;
}>;


export type CreateShipmentMutation = { __typename?: 'Mutation', createShipment?: { __typename?: 'CreateShipmentPayload', shipment?: { __typename?: 'Shipment', name: string, id: ShipmentId } | null } | null };

export type CreateSingleEventMutationVariables = Exact<{
  input: CreateSingleEventInput;
}>;


export type CreateSingleEventMutation = { __typename?: 'Mutation', createSingleEvent?: { __typename?: 'CreateSingleEventPayload', singleEvent?: { __typename?: 'SingleEvent', id: SingleEventId, duration: string | number, end: string, locationId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, vesselId?: ShipId | null, type: EventType, concurrent: boolean, startOverride?: string | null, seaDurationOverride?: string | number | null, clientId: string, updatedAt?: string | null, archived: boolean, cleaningAssortmentExclusionId?: AssortmentExclusionId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, singleEventPortCallRelationsBySingleEventId: { __typename?: 'SingleEventPortCallRelationsConnection', nodes: Array<{ __typename?: 'SingleEventPortCallRelation', id: SingleEventPortCallRelationId, portCallId: PortCallId, singleEventId: SingleEventId } | null> } } | null } | null };

export type CurrencyApiMutationVariables = Exact<{
  baseCurrency?: InputMaybe<Currency>;
}>;


export type CurrencyApiMutation = { __typename?: 'Mutation', currencyApi?: { __typename?: 'CurrencyAPI', baseCurrency?: Currency | null, message?: string | null, rates?: Array<{ __typename?: 'CurrencyApiRate', code: string, value: number } | null> | null } | null };

export type DeleteHandledBySpotMutationVariables = Exact<{
  handledBySpotById: Scalars['HandledBySpotId']['input'];
}>;


export type DeleteHandledBySpotMutation = { __typename?: 'Mutation', deleteHandledBySpotById?: { __typename?: 'DeleteHandledBySpotPayload', deletedHandledBySpotId?: string | null } | null };

export type DeleteScheduledOrderMutationVariables = Exact<{
  scheduledOrderId: Scalars['ScheduledOrderId']['input'];
}>;


export type DeleteScheduledOrderMutation = { __typename?: 'Mutation', deleteScheduledOrderById?: { __typename?: 'DeleteScheduledOrderPayload', deletedScheduledOrderId?: string | null } | null };

export type DeleteSingleEventMutationVariables = Exact<{
  singleEventId: Scalars['SingleEventId']['input'];
}>;


export type DeleteSingleEventMutation = { __typename?: 'Mutation', deleteSingleEventById?: { __typename?: 'DeleteSingleEventPayload', deletedSingleEventId?: string | null } | null };

export type UpdatePortCallExternalTimestampsMutationVariables = Exact<{
  query: Array<UpdatePortCallExternalTimestampsInput>;
}>;


export type UpdatePortCallExternalTimestampsMutation = { __typename?: 'Mutation', updatePortCallExternalTimestamps: Array<{ __typename?: 'UpdatePortCallExternalTimestampsOutput', portCallClientId: string, isOk: boolean, errorText?: string | null }> };

export type InactivateVesselsMutationVariables = Exact<{
  vesselIds: Array<Scalars['Int']['input']>;
}>;


export type InactivateVesselsMutation = { __typename?: 'Mutation', inactivateShips?: { __typename?: 'InactivateShipsPayload', ships?: Array<{ __typename?: 'Ship', id: ShipId, inactive: boolean } | null> | null } | null };

export type UpdateVesonScenarioMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateVesonScenarioMutation = { __typename?: 'Mutation', updateVesonScenario?: { __typename?: 'UpdateVesonScenarioResult', scenarioCid: string, warnings: Array<string>, generatedTCLength: number } | null };

export type VesonOrdersSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type VesonOrdersSyncMutation = { __typename?: 'Mutation', vesonOrdersSync?: { __typename?: 'VesonOrdersSyncResult', status: Status, errorMessage?: string | null } | null };

export type VesonUpdateDataMutationVariables = Exact<{ [key: string]: never; }>;


export type VesonUpdateDataMutation = { __typename?: 'Mutation', vesonUpdateData?: { __typename?: 'VesonUpdateData', syncOrder: { __typename?: 'VesonOrdersSyncResult', status: Status, errorMessage?: string | null }, syncVessel: { __typename?: 'VesonVesselsSyncResult', status: Status, errorMessage?: string | null }, updateScenario: { __typename?: 'UpdateVesonScenarioResult', scenarioCid: string, warnings: Array<string>, generatedTCLength: number, status: Status } } | null };

export type VesonPortsSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type VesonPortsSyncMutation = { __typename?: 'Mutation', vesonPortsSync?: { __typename?: 'VesonPortsSyncResult', status: Status, errorMessage?: string | null } | null };

export type VesonVesselsSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type VesonVesselsSyncMutation = { __typename?: 'Mutation', vesonVesselsSync?: { __typename?: 'VesonVesselsSyncResult', status: Status, errorMessage?: string | null } | null };

export type SyncTcContractByExternalIdMutationVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type SyncTcContractByExternalIdMutation = { __typename?: 'Mutation', syncTcContractByExternalId?: { __typename?: 'TcContractSyncResult', status: Status, errorMessage?: string | null } | null };

export type InvoiceFormItemOrderFragment = { __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null };

export type InvoiceFormItemFragment = { __typename: 'InvoiceItem', id: InvoiceItemId, amount?: string | number | null, costType?: CostType | null, note?: string | null, portCallId?: PortCallId | null, invoiceId?: InvoiceId | null, invoiceItemOrdersByInvoiceItemId: { __typename?: 'InvoiceItemOrdersConnection', nodes: Array<{ __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null } | null> } };

export type InvoiceFormFragment = { __typename: 'Invoice', id: InvoiceId, currency?: Currency | null, dueDate?: string | null, invoiceNumber?: string | null, voyageCharterId?: VoyageCharterId | null, payingOrganizationId?: OrganizationId | null, invoiceItemsByInvoiceId: { __typename?: 'InvoiceItemsConnection', nodes: Array<{ __typename: 'InvoiceItem', id: InvoiceItemId, amount?: string | number | null, costType?: CostType | null, note?: string | null, portCallId?: PortCallId | null, invoiceId?: InvoiceId | null, invoiceItemOrdersByInvoiceItemId: { __typename?: 'InvoiceItemOrdersConnection', nodes: Array<{ __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null } | null> } } | null> } };

export type InvoiceOrderInfoFragment = { __typename: 'Order', id: OrderId, assortmentByAssortmentId?: { __typename: 'Assortment', id: AssortmentId, name: string } | null, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename: 'OrderDetail', id: OrderDetailId, orderName?: string | null } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename: 'OrderPortCallRelation', id: OrderPortCallRelationId, isLoadPort: boolean, portCallByPortCallId?: { __typename: 'PortCall', id: PortCallId, locationId: LocationId, locationByLocationId?: { __typename: 'Location', id: LocationId, name: string } | null } | null } | null> } };

export type InvoiceOrdersFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, orderVoyageCharterRelationsByVoyageCharterId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, coaRouteId?: CoaContractPortId | null, orderByOrderId?: { __typename: 'Order', id: OrderId, assortmentByAssortmentId?: { __typename: 'Assortment', id: AssortmentId, name: string } | null, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename: 'OrderDetail', id: OrderDetailId, orderName?: string | null } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename: 'OrderPortCallRelation', id: OrderPortCallRelationId, isLoadPort: boolean, portCallByPortCallId?: { __typename: 'PortCall', id: PortCallId, locationId: LocationId, locationByLocationId?: { __typename: 'Location', id: LocationId, name: string } | null } | null } | null> } } | null } | null> } };

export type InvoicesByIdQueryVariables = Exact<{
  voyageCharterId: Scalars['Int']['input'];
}>;


export type InvoicesByIdQuery = { __typename?: 'Query', voyageCharterById?: { __typename: 'VoyageCharter', id: VoyageCharterId, invoicesByVoyageCharterId: { __typename?: 'InvoicesConnection', nodes: Array<{ __typename: 'Invoice', id: InvoiceId, currency?: Currency | null, dueDate?: string | null, invoiceNumber?: string | null, voyageCharterId?: VoyageCharterId | null, payingOrganizationId?: OrganizationId | null, invoiceItemsByInvoiceId: { __typename?: 'InvoiceItemsConnection', nodes: Array<{ __typename: 'InvoiceItem', id: InvoiceItemId, amount?: string | number | null, costType?: CostType | null, note?: string | null, portCallId?: PortCallId | null, invoiceId?: InvoiceId | null, invoiceItemOrdersByInvoiceItemId: { __typename?: 'InvoiceItemOrdersConnection', nodes: Array<{ __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null } | null> } } | null> } } | null> }, orderVoyageCharterRelationsByVoyageCharterId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, coaRouteId?: CoaContractPortId | null, orderByOrderId?: { __typename: 'Order', id: OrderId, assortmentByAssortmentId?: { __typename: 'Assortment', id: AssortmentId, name: string } | null, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename: 'OrderDetail', id: OrderDetailId, orderName?: string | null } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename: 'OrderPortCallRelation', id: OrderPortCallRelationId, isLoadPort: boolean, portCallByPortCallId?: { __typename: 'PortCall', id: PortCallId, locationId: LocationId, locationByLocationId?: { __typename: 'Location', id: LocationId, name: string } | null } | null } | null> } } | null } | null> } } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename: 'Organization', id: OrganizationId, name?: string | null } | null> } | null };

export type CreateInvoiceMutationVariables = Exact<{
  input: CreateInvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice?: { __typename?: 'CreateInvoicePayload', invoice?: { __typename: 'Invoice', id: InvoiceId, currency?: Currency | null, dueDate?: string | null, invoiceNumber?: string | null, voyageCharterId?: VoyageCharterId | null, payingOrganizationId?: OrganizationId | null, invoiceItemsByInvoiceId: { __typename?: 'InvoiceItemsConnection', nodes: Array<{ __typename: 'InvoiceItem', id: InvoiceItemId, amount?: string | number | null, costType?: CostType | null, note?: string | null, portCallId?: PortCallId | null, invoiceId?: InvoiceId | null, invoiceItemOrdersByInvoiceItemId: { __typename?: 'InvoiceItemOrdersConnection', nodes: Array<{ __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null } | null> } } | null> } } | null } | null };

export type UpdateInvoiceMutationVariables = Exact<{
  input: UpdateInvoiceByIdInput;
}>;


export type UpdateInvoiceMutation = { __typename?: 'Mutation', updateInvoiceById?: { __typename?: 'UpdateInvoicePayload', invoice?: { __typename: 'Invoice', id: InvoiceId, currency?: Currency | null, dueDate?: string | null, invoiceNumber?: string | null, voyageCharterId?: VoyageCharterId | null, payingOrganizationId?: OrganizationId | null, invoiceItemsByInvoiceId: { __typename?: 'InvoiceItemsConnection', nodes: Array<{ __typename: 'InvoiceItem', id: InvoiceItemId, amount?: string | number | null, costType?: CostType | null, note?: string | null, portCallId?: PortCallId | null, invoiceId?: InvoiceId | null, invoiceItemOrdersByInvoiceItemId: { __typename?: 'InvoiceItemOrdersConnection', nodes: Array<{ __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null } | null> } } | null> } } | null } | null };

export type DeleteInvoiceMutationVariables = Exact<{
  input: DeleteInvoiceByIdInput;
}>;


export type DeleteInvoiceMutation = { __typename?: 'Mutation', deleteInvoiceById?: { __typename?: 'DeleteInvoicePayload', invoice?: { __typename?: 'Invoice', id: InvoiceId } | null } | null };

export type CreateInvoiceItemMutationVariables = Exact<{
  input: CreateInvoiceItemInput;
}>;


export type CreateInvoiceItemMutation = { __typename?: 'Mutation', createInvoiceItem?: { __typename?: 'CreateInvoiceItemPayload', invoiceItem?: { __typename: 'InvoiceItem', id: InvoiceItemId, amount?: string | number | null, costType?: CostType | null, note?: string | null, portCallId?: PortCallId | null, invoiceId?: InvoiceId | null, invoiceItemOrdersByInvoiceItemId: { __typename?: 'InvoiceItemOrdersConnection', nodes: Array<{ __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null } | null> } } | null } | null };

export type UpdateInvoiceItemMutationVariables = Exact<{
  input: UpdateInvoiceItemByIdInput;
}>;


export type UpdateInvoiceItemMutation = { __typename?: 'Mutation', updateInvoiceItemById?: { __typename?: 'UpdateInvoiceItemPayload', invoiceItem?: { __typename: 'InvoiceItem', id: InvoiceItemId, amount?: string | number | null, costType?: CostType | null, note?: string | null, portCallId?: PortCallId | null, invoiceId?: InvoiceId | null, invoiceItemOrdersByInvoiceItemId: { __typename?: 'InvoiceItemOrdersConnection', nodes: Array<{ __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null } | null> } } | null } | null };

export type DeleteInvoiceItemMutationVariables = Exact<{
  input: DeleteInvoiceItemByIdInput;
}>;


export type DeleteInvoiceItemMutation = { __typename?: 'Mutation', deleteInvoiceItemById?: { __typename?: 'DeleteInvoiceItemPayload', invoiceItem?: { __typename?: 'InvoiceItem', id: InvoiceItemId } | null } | null };

export type CreateInvoiceItemOrderMutationVariables = Exact<{
  input: CreateInvoiceItemOrderInput;
}>;


export type CreateInvoiceItemOrderMutation = { __typename?: 'Mutation', createInvoiceItemOrder?: { __typename?: 'CreateInvoiceItemOrderPayload', invoiceItemOrder?: { __typename: 'InvoiceItemOrder', id: InvoiceItemOrderId, orderId?: OrderId | null, invoiceItemId?: InvoiceItemId | null } | null } | null };

export type DeleteInvoiceItemOrderByIdMutationVariables = Exact<{
  input: DeleteInvoiceItemOrderByIdInput;
}>;


export type DeleteInvoiceItemOrderByIdMutation = { __typename?: 'Mutation', deleteInvoiceItemOrderById?: { __typename?: 'DeleteInvoiceItemOrderPayload', invoiceItemOrder?: { __typename?: 'InvoiceItemOrder', id: InvoiceItemOrderId } | null } | null };

export type LogOutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogOutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutPayload', clientMutationId?: string | null } | null };

export type MrForm_CargoMeasurementFragment = { __typename?: 'CargoMeasurement', id: CargoMeasurementId, orderId: OrderId, locationId?: LocationId | null, time: string, measuredWeight?: string | number | null, rejectedWeight?: string | number | null, weightUnit?: WeightUnits | null, measuredVolume?: string | number | null, rejectedVolume?: string | number | null, volumeUnit?: VolumeUnits | null };

export type CreateCargoMeasurementMutationVariables = Exact<{
  input: CreateCargoMeasurementInput;
}>;


export type CreateCargoMeasurementMutation = { __typename?: 'Mutation', createCargoMeasurement?: { __typename?: 'CreateCargoMeasurementPayload', cargoMeasurement?: { __typename?: 'CargoMeasurement', id: CargoMeasurementId, orderId: OrderId, locationId?: LocationId | null, time: string, measuredWeight?: string | number | null, rejectedWeight?: string | number | null, weightUnit?: WeightUnits | null, measuredVolume?: string | number | null, rejectedVolume?: string | number | null, volumeUnit?: VolumeUnits | null } | null } | null };

export type UpdateCargoMeasurementMutationVariables = Exact<{
  input: UpdateCargoMeasurementByIdInput;
}>;


export type UpdateCargoMeasurementMutation = { __typename?: 'Mutation', updateCargoMeasurementById?: { __typename?: 'UpdateCargoMeasurementPayload', cargoMeasurement?: { __typename?: 'CargoMeasurement', id: CargoMeasurementId, orderId: OrderId, locationId?: LocationId | null, time: string, measuredWeight?: string | number | null, rejectedWeight?: string | number | null, weightUnit?: WeightUnits | null, measuredVolume?: string | number | null, rejectedVolume?: string | number | null, volumeUnit?: VolumeUnits | null } | null } | null };

export type MarcuraCommodityGroupMappingMutationVariables = Exact<{ [key: string]: never; }>;


export type MarcuraCommodityGroupMappingMutation = { __typename?: 'Mutation', commodityGroupMapping?: { __typename?: 'CommodityGroupMappingResult', status?: string | null } | null };

export type UpsertMarcuraLocationMutationVariables = Exact<{ [key: string]: never; }>;


export type UpsertMarcuraLocationMutation = { __typename?: 'Mutation', upsertMarcuraLocation?: { __typename?: 'UpsertMarcuraLocationResult', status?: string | null } | null };

export type GetMarcuraPortCostsMutationVariables = Exact<{
  input: Array<GetMarcuraPortCostInput>;
  clientRunUuid?: InputMaybe<Scalars['String']['input']>;
  drainTotal?: InputMaybe<Scalars['Int']['input']>;
  drainRemaining?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMarcuraPortCostsMutation = { __typename?: 'Mutation', getMarcuraPortCosts?: Array<{ __typename?: 'MarcuraPortCost', id: number, marcura_port_id: string, marcura_group_id: string, location_id: number, assortment_id: number, cached_at: string, data: { __typename?: 'MarcuraPortCostData', costs?: Array<{ __typename?: 'MarcuraVesselSegmentCost', dwtMax?: number | null, dwtMin?: number | null, costLoading?: number | null, segmentName?: string | null, costDischarging?: number | null, costLoadingWithTowage?: boolean | null, costDischargingWithTowage?: boolean | null } | null> | null } } | null> | null };

export type NorForm__NoticeOfReadinessFragment = { __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null };

export type CreateNorMutationVariables = Exact<{
  input: CreatePortNoticeInput;
}>;


export type CreateNorMutation = { __typename?: 'Mutation', createPortNotice?: { __typename?: 'CreatePortNoticePayload', portNotice?: { __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null } | null };

export type UpdateNorMutationVariables = Exact<{
  input: UpdatePortNoticeByIdInput;
}>;


export type UpdateNorMutation = { __typename?: 'Mutation', updatePortNoticeById?: { __typename?: 'UpdatePortNoticePayload', portNotice?: { __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null } | null };

export type LlmParsedOrder_FragmentFragment = { __typename?: 'LLMParsedOrder', assortmentName: string, cargoAmount: number, cargoDeckOption?: CargoDeckOptionType | null, cargoUnit: CargoUnitEnum, chartererOrgName?: string | null, dischargePortName?: string | null, dischargingRate?: number | null, dischargingUnit?: LoadingUnit | null, earliestDischarging?: string | null, earliestLoading?: string | null, externalGroupingId?: string | null, externalOrderId?: string | null, isInquiry?: boolean | null, isPreliminary?: boolean | null, latestLoading?: string | null, loadPortName: string, loadingRate?: number | null, loadingUnit?: LoadingUnit | null, marginUnit?: MarginUnit | null, marginAmount?: number | null, nominatedVessel?: string | null, onSubjectsUntil?: string | null, orderName: string, orderNotes?: string | null, specificGravity?: number | null, stowageFactorMax?: number | null, stowageFactorMin?: number | null, commission?: number | null, charterParty?: string | null, laytimeTerms?: string | null };

export type ParseOrdersMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type ParseOrdersMutation = { __typename?: 'Mutation', parseOrders?: { __typename?: 'LLMParserResult', orders: Array<{ __typename?: 'LLMParsedOrder', assortmentName: string, cargoAmount: number, cargoDeckOption?: CargoDeckOptionType | null, cargoUnit: CargoUnitEnum, chartererOrgName?: string | null, dischargePortName?: string | null, dischargingRate?: number | null, dischargingUnit?: LoadingUnit | null, earliestDischarging?: string | null, earliestLoading?: string | null, externalGroupingId?: string | null, externalOrderId?: string | null, isInquiry?: boolean | null, isPreliminary?: boolean | null, latestLoading?: string | null, loadPortName: string, loadingRate?: number | null, loadingUnit?: LoadingUnit | null, marginUnit?: MarginUnit | null, marginAmount?: number | null, nominatedVessel?: string | null, onSubjectsUntil?: string | null, orderName: string, orderNotes?: string | null, specificGravity?: number | null, stowageFactorMax?: number | null, stowageFactorMin?: number | null, commission?: number | null, charterParty?: string | null, laytimeTerms?: string | null }> } | null };

export type LlmParseImportedOrdersMutationVariables = Exact<{
  input: ParsedImportedOrdersInput;
}>;


export type LlmParseImportedOrdersMutation = { __typename?: 'Mutation', parseImportedOrders?: { __typename?: 'LLMParserResult', orders: Array<{ __typename?: 'LLMParsedOrder', assortmentName: string, cargoAmount: number, cargoDeckOption?: CargoDeckOptionType | null, cargoUnit: CargoUnitEnum, chartererOrgName?: string | null, dischargePortName?: string | null, dischargingRate?: number | null, dischargingUnit?: LoadingUnit | null, earliestDischarging?: string | null, earliestLoading?: string | null, externalGroupingId?: string | null, externalOrderId?: string | null, isInquiry?: boolean | null, isPreliminary?: boolean | null, latestLoading?: string | null, loadPortName: string, loadingRate?: number | null, loadingUnit?: LoadingUnit | null, marginUnit?: MarginUnit | null, marginAmount?: number | null, nominatedVessel?: string | null, onSubjectsUntil?: string | null, orderName: string, orderNotes?: string | null, specificGravity?: number | null, stowageFactorMax?: number | null, stowageFactorMin?: number | null, commission?: number | null, charterParty?: string | null, laytimeTerms?: string | null }> } | null };

export type OptimizeScheduleMutationVariables = Exact<{
  task: Scalars['JSON']['input'];
  method?: InputMaybe<ScheduleOptimizationMethod>;
}>;


export type OptimizeScheduleMutation = { __typename?: 'Mutation', optimizeSchedule?: string | null };

export type CreatePortCallMutationVariables = Exact<{
  input: CreatePortCallInput;
}>;


export type CreatePortCallMutation = { __typename?: 'Mutation', createPortCall?: { __typename?: 'CreatePortCallPayload', portCall?: { __typename?: 'PortCall', id: PortCallId, vesselId?: ShipId | null, locationId: LocationId, updatedAt?: string | null } | null } | null };

export type UpdatePortCallMutationVariables = Exact<{
  portCallId: Scalars['PortCallId']['input'];
  patch: PortCallPatch;
}>;


export type UpdatePortCallMutation = { __typename?: 'Mutation', updatePortCallById?: { __typename?: 'UpdatePortCallPayload', portCall?: { __typename?: 'PortCall', id: PortCallId, updatedAt?: string | null } | null } | null };

export type CreateOrderPortCallRelationMutationVariables = Exact<{
  input: CreateOrderPortCallRelationInput;
}>;


export type CreateOrderPortCallRelationMutation = { __typename?: 'Mutation', createOrderPortCallRelation?: { __typename?: 'CreateOrderPortCallRelationPayload', orderPortCallRelation?: { __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, isLoadPort: boolean, orderId: OrderId } | null } | null };

export type CreateSingleEventPortCallRelationMutationVariables = Exact<{
  input: CreateSingleEventPortCallRelationInput;
}>;


export type CreateSingleEventPortCallRelationMutation = { __typename?: 'Mutation', createSingleEventPortCallRelation?: { __typename?: 'CreateSingleEventPortCallRelationPayload', singleEventPortCallRelation?: { __typename?: 'SingleEventPortCallRelation', id: SingleEventPortCallRelationId, portCallId: PortCallId, singleEventId: SingleEventId } | null } | null };

export type DeleteOrderPortCallRelationMutationVariables = Exact<{
  input: DeleteOrderPortCallRelationByIdInput;
}>;


export type DeleteOrderPortCallRelationMutation = { __typename?: 'Mutation', deleteOrderPortCallRelationById?: { __typename?: 'DeleteOrderPortCallRelationPayload', deletedOrderPortCallRelationId?: string | null } | null };

export type DeleteSingleEventPortCallRelationMutationVariables = Exact<{
  input: DeleteSingleEventPortCallRelationByIdInput;
}>;


export type DeleteSingleEventPortCallRelationMutation = { __typename?: 'Mutation', deleteSingleEventPortCallRelationById?: { __typename?: 'DeleteSingleEventPortCallRelationPayload', deletedSingleEventPortCallRelationId?: string | null } | null };

export type UpdatePortNoticeMutationVariables = Exact<{
  input: UpdatePortNoticeByIdInput;
}>;


export type UpdatePortNoticeMutation = { __typename?: 'Mutation', updatePortNoticeById?: { __typename?: 'UpdatePortNoticePayload', portNotice?: { __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null } | null };

export type CreatePortDataMutationVariables = Exact<{
  input: CreatePortDatumInput;
}>;


export type CreatePortDataMutation = { __typename?: 'Mutation', createPortDatum?: { __typename?: 'CreatePortDatumPayload', portDatum?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null };

export type UpdatePortDataMutationVariables = Exact<{
  input: UpdatePortDatumByIdInput;
}>;


export type UpdatePortDataMutation = { __typename?: 'Mutation', updatePortDatumById?: { __typename?: 'UpdatePortDatumPayload', portDatum?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null };

export type DeletePortDataMutationVariables = Exact<{
  input: DeletePortDatumByIdInput;
}>;


export type DeletePortDataMutation = { __typename?: 'Mutation', deletePortDatumById?: { __typename?: 'DeletePortDatumPayload', deletedPortDatumId?: string | null } | null };

export type SyncPreemOrdersMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncPreemOrdersMutation = { __typename?: 'Mutation', syncPreemOrders?: { __typename?: 'SyncOrdersResult', status: Status, errorLogs: Array<string | null> } | null };

export type PublishOrdersMutationVariables = Exact<{
  ids: Array<Scalars['OrderId']['input']>;
  shared: Scalars['Boolean']['input'];
}>;


export type PublishOrdersMutation = { __typename?: 'Mutation', publishOrders?: { __typename?: 'PublishOrdersPayload', sos: Array<string>, hbss: Array<string>, hbcs: Array<string>, orders: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } }> } | null };

export type Q88OrderSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type Q88OrderSyncMutation = { __typename?: 'Mutation', q88OrderSync?: { __typename?: 'Q88OrderSyncResult', status: string } | null };

export type UpdateQ88ScenarioMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateQ88ScenarioMutation = { __typename?: 'Mutation', updateQ88Scenario?: { __typename?: 'UpdateQ88ScenarioResult', scenarioCid: string, warnings: Array<string>, generatedTCLength: number } | null };

export type Q88UpdateDataMutationVariables = Exact<{ [key: string]: never; }>;


export type Q88UpdateDataMutation = { __typename?: 'Mutation', q88UpdateData?: { __typename?: 'Q88UpdateData', syncOrder: { __typename?: 'Q88OrderSyncResult', status: string, errorMessage?: string | null }, updateScenario: { __typename?: 'UpdateQ88ScenarioResult', status: string, itemsLength: number, generatedTCLength: number, warnings: Array<string>, scenarioCid: string } } | null };

export type UpdateSapMutationVariables = Exact<{
  input: UpdateSapInput;
}>;


export type UpdateSapMutation = { __typename?: 'Mutation', updateSAP: { __typename?: 'UpdateSAPResult', results?: string | null } };

export type UpdateManySapMutationVariables = Exact<{
  input: Array<UpdateSapInput>;
}>;


export type UpdateManySapMutation = { __typename?: 'Mutation', updateManySAP: { __typename?: 'UpdateSAPResults', results: Array<string | null> } };

export type GetLatestSapQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestSapQuery = { __typename?: 'Query', getLatestSAP: string };

export type SofForm__StatementOfFactsFragment = { __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } };

export type SofForm__PortActivityFragment = { __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null };

export type CreateSofMutationVariables = Exact<{
  input: CreateStatementOfFactInput;
}>;


export type CreateSofMutation = { __typename?: 'Mutation', createStatementOfFact?: { __typename?: 'CreateStatementOfFactPayload', statementOfFact?: { __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null } | null };

export type UpdateSofMutationVariables = Exact<{
  input: UpdateStatementOfFactByIdInput;
}>;


export type UpdateSofMutation = { __typename?: 'Mutation', updateStatementOfFactById?: { __typename?: 'UpdateStatementOfFactPayload', statementOfFact?: { __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null } | null };

export type CreatePortActivityMutationVariables = Exact<{
  input: CreatePortActivityInput;
}>;


export type CreatePortActivityMutation = { __typename?: 'Mutation', createPortActivity?: { __typename?: 'CreatePortActivityPayload', portActivity?: { __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null } | null };

export type UpdatePortActivityMutationVariables = Exact<{
  input: UpdatePortActivityByIdInput;
}>;


export type UpdatePortActivityMutation = { __typename?: 'Mutation', updatePortActivityById?: { __typename?: 'UpdatePortActivityPayload', portActivity?: { __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null } | null };

export type DeletePortActivityMutationVariables = Exact<{
  input: DeletePortActivityByIdInput;
}>;


export type DeletePortActivityMutation = { __typename?: 'Mutation', deletePortActivityById?: { __typename?: 'DeletePortActivityPayload', deletedPortActivityId?: string | null } | null };

export type UpdateShipnetScenarioMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateShipnetScenarioMutation = { __typename?: 'Mutation', updateShipnetScenario?: { __typename?: 'UpdateShipnetScenarioResult', scenarioCid: string, warnings: Array<string>, generatedTCLength: number, status: Status } | null };

export type SyncShipnetOrdersMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncShipnetOrdersMutation = { __typename?: 'Mutation', syncShipnetOrders?: { __typename?: 'SyncShipnetOrdersResult', status: Status } | null };

export type RefreshShipnetOrdersMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshShipnetOrdersMutation = { __typename?: 'Mutation', refreshShipnetOrders?: { __typename?: 'RefreshShipnetOrdersResult', status: Status } | null };

export type UpdateDateShipnetMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateDateShipnetMutation = { __typename?: 'Mutation', updateDateShipnet?: { __typename?: 'UpdateDateShipnetResult', status: Status } | null };

export type SetupShipnetCoaMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupShipnetCoaMutation = { __typename?: 'Mutation', setupShipnetCoa?: { __typename?: 'SetupShipnetCoasResult', status: Status } | null };

export type SyncBookingListMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncBookingListMutation = { __typename?: 'Mutation', syncBookingList?: { __typename?: 'SyncBookingListResult', status: Status } | null };

export type UpdateConfirmedVoyagesMutationVariables = Exact<{
  scenarioCid: Scalars['String']['input'];
}>;


export type UpdateConfirmedVoyagesMutation = { __typename?: 'Mutation', updateConfirmedVoyages?: { __typename?: 'UpdateConfirmedVoyages', status: Status, warnings: Array<string> } | null };

export type SpeechToTextMutationVariables = Exact<{
  input: SpeechToTextInput;
}>;


export type SpeechToTextMutation = { __typename?: 'Mutation', speechToText?: { __typename?: 'SpeechToTextResult', text?: string | null } | null };

export type CreateSpotMutationVariables = Exact<{
  input: CreateVoyageCharterInput;
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateSpotMutation = { __typename?: 'Mutation', createVoyageCharter?: { __typename?: 'CreateVoyageCharterPayload', voyageCharter?: { __typename?: 'VoyageCharter', id: VoyageCharterId, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, lumpsum?: string | number | null, name?: string | null, externalId?: string | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, portDataRelations: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> } } | null } | null };

export type UpdateSpotMutationVariables = Exact<{
  input: UpdateVoyageCharterByIdInput;
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSpotMutation = { __typename?: 'Mutation', updateVoyageCharterById?: { __typename?: 'UpdateVoyageCharterPayload', voyageCharter?: { __typename?: 'VoyageCharter', id: VoyageCharterId, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, lumpsum?: string | number | null, name?: string | null, externalId?: string | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, portDataRelations: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> } } | null } | null };

export type DeleteSpotMutationVariables = Exact<{
  input: DeleteVoyageCharterByIdInput;
}>;


export type DeleteSpotMutation = { __typename?: 'Mutation', deleteVoyageCharterById?: { __typename?: 'DeleteVoyageCharterPayload', deletedVoyageCharterId?: string | null } | null };

export type CreateOrderSpotRelationMutationVariables = Exact<{
  input: CreateOrderVoyageCharterRelationInput;
}>;


export type CreateOrderSpotRelationMutation = { __typename?: 'Mutation', createOrderVoyageCharterRelation?: { __typename?: 'CreateOrderVoyageCharterRelationPayload', orderVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null } | null } | null };

export type DeleteOrderSpotRelationMutationVariables = Exact<{
  input: DeleteOrderVoyageCharterRelationByIdInput;
}>;


export type DeleteOrderSpotRelationMutation = { __typename?: 'Mutation', deleteOrderVoyageCharterRelationById?: { __typename?: 'DeleteOrderVoyageCharterRelationPayload', orderVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null } | null } | null };

export type CreateVoyageCharterOrderFreightMutationVariables = Exact<{
  input: CreateVoyageCharterOrderFreightInput;
}>;


export type CreateVoyageCharterOrderFreightMutation = { __typename?: 'Mutation', createVoyageCharterOrderFreight?: { __typename?: 'CreateVoyageCharterOrderFreightPayload', voyageCharterOrderFreight?: { __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null } | null };

export type UpdateVoyageCharterOrderFreightMutationVariables = Exact<{
  input: UpdateVoyageCharterOrderFreightByIdInput;
}>;


export type UpdateVoyageCharterOrderFreightMutation = { __typename?: 'Mutation', updateVoyageCharterOrderFreightById?: { __typename?: 'UpdateVoyageCharterOrderFreightPayload', voyageCharterOrderFreight?: { __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null } | null };

export type CreateSpotPortDataMutationVariables = Exact<{
  input: CreateVoyageCharterPortDatumInput;
}>;


export type CreateSpotPortDataMutation = { __typename?: 'Mutation', createVoyageCharterPortDatum?: { __typename?: 'CreateVoyageCharterPortDatumPayload', voyageCharterPortDatum?: { __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, voyageCharterId: VoyageCharterId, portDataId: PortDatumId } | null } | null };

export type DeleteVoyageCharterPortDataMutationVariables = Exact<{
  input: DeleteVoyageCharterPortDatumByIdInput;
}>;


export type DeleteVoyageCharterPortDataMutation = { __typename?: 'Mutation', deleteVoyageCharterPortDatumById?: { __typename?: 'DeleteVoyageCharterPortDatumPayload', voyageCharterPortDatum?: { __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, voyageCharterId: VoyageCharterId, portDataId: PortDatumId } | null } | null };

export type CreateVoyageCharterContractMutationVariables = Exact<{
  input: CreateVoyageCharterToContractInput;
}>;


export type CreateVoyageCharterContractMutation = { __typename?: 'Mutation', createVoyageCharterToContract?: { __typename?: 'CreateVoyageCharterToContractPayload', voyageCharterToContract?: { __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId } | null } | null };

export type UpdateVoyageCharterContractMutationVariables = Exact<{
  input: UpdateVoyageCharterToContractByIdInput;
}>;


export type UpdateVoyageCharterContractMutation = { __typename?: 'Mutation', updateVoyageCharterToContractById?: { __typename?: 'UpdateVoyageCharterToContractPayload', voyageCharterToContract?: { __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId } | null } | null };

export type DeleteVoyageCharterContractMutationVariables = Exact<{
  input: DeleteVoyageCharterToContractByIdInput;
}>;


export type DeleteVoyageCharterContractMutation = { __typename?: 'Mutation', deleteVoyageCharterToContractById?: { __typename?: 'DeleteVoyageCharterToContractPayload', voyageCharterToContract?: { __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId } | null } | null };

export type CreateChartererMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateChartererMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'CreateOrganizationPayload', organization?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type CreateShipOwnerMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateShipOwnerMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'CreateOrganizationPayload', organization?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type CreateShipMutationVariables = Exact<{
  input: CreateShipInput;
}>;


export type CreateShipMutation = { __typename?: 'Mutation', createShip?: { __typename?: 'CreateShipPayload', ship?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null };

export type CreateExtraFreightMutationVariables = Exact<{
  input: CreateVoyageCharterExtraFreightInput;
}>;


export type CreateExtraFreightMutation = { __typename?: 'Mutation', createVoyageCharterExtraFreight?: { __typename?: 'CreateVoyageCharterExtraFreightPayload', voyageCharterExtraFreight?: { __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null } | null };

export type DeleteExtraFreightMutationVariables = Exact<{
  input: DeleteVoyageCharterExtraFreightByIdInput;
}>;


export type DeleteExtraFreightMutation = { __typename?: 'Mutation', deleteVoyageCharterExtraFreightById?: { __typename?: 'DeleteVoyageCharterExtraFreightPayload', voyageCharterExtraFreight?: { __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId } | null } | null };

export type UpdateExtraFreightMutationVariables = Exact<{
  input: UpdateVoyageCharterExtraFreightByIdInput;
}>;


export type UpdateExtraFreightMutation = { __typename?: 'Mutation', updateVoyageCharterExtraFreightById?: { __typename?: 'UpdateVoyageCharterExtraFreightPayload', voyageCharterExtraFreight?: { __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null } | null };

export type CreateExtraCostMutationVariables = Exact<{
  input: CreateVoyageCharterExtraCostInput;
}>;


export type CreateExtraCostMutation = { __typename?: 'Mutation', createVoyageCharterExtraCost?: { __typename?: 'CreateVoyageCharterExtraCostPayload', voyageCharterExtraCost?: { __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null } | null };

export type DeleteExtraCostMutationVariables = Exact<{
  input: DeleteVoyageCharterExtraCostByIdInput;
}>;


export type DeleteExtraCostMutation = { __typename?: 'Mutation', deleteVoyageCharterExtraCostById?: { __typename?: 'DeleteVoyageCharterExtraCostPayload', voyageCharterExtraCost?: { __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId } | null } | null };

export type UpdateExtraCostMutationVariables = Exact<{
  input: UpdateVoyageCharterExtraCostByIdInput;
}>;


export type UpdateExtraCostMutation = { __typename?: 'Mutation', updateVoyageCharterExtraCostById?: { __typename?: 'UpdateVoyageCharterExtraCostPayload', voyageCharterExtraCost?: { __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null } | null };

export type CreateCommissionMutationVariables = Exact<{
  input: CreateCommissionInput;
}>;


export type CreateCommissionMutation = { __typename?: 'Mutation', createCommission?: { __typename?: 'CreateCommissionPayload', commission?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type UpdateCommissionMutationVariables = Exact<{
  input: UpdateCommissionByIdInput;
}>;


export type UpdateCommissionMutation = { __typename?: 'Mutation', updateCommissionById?: { __typename?: 'UpdateCommissionPayload', commission?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null };

export type DeleteCommissionMutationVariables = Exact<{
  input: DeleteCommissionByIdInput;
}>;


export type DeleteCommissionMutation = { __typename?: 'Mutation', deleteCommissionById?: { __typename?: 'DeleteCommissionPayload', commission?: { __typename?: 'Commission', id: CommissionId } | null } | null };

export type UpdateFileMutationVariables = Exact<{
  fileId: Scalars['FileId']['input'];
  patch: FilePatch;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateFileById?: { __typename?: 'UpdateFilePayload', file?: { __typename?: 'File', id: FileId, type: DocumentType, note?: string | null } | null } | null };

export type UpdateHandledBySpotMutationVariables = Exact<{
  handledBySpotId: Scalars['HandledBySpotId']['input'];
  patch: HandledBySpotPatch;
}>;


export type UpdateHandledBySpotMutation = { __typename?: 'Mutation', updateHandledBySpotById?: { __typename?: 'UpdateHandledBySpotPayload', handledBySpot?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null } | null };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderByIdInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrderById?: { __typename?: 'UpdateOrderPayload', order?: { __typename?: 'Order', id: OrderId, shipmentId?: ShipmentId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string } | null, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> } } | null } | null };

export type UpdateOrderDetailMutationVariables = Exact<{
  input: UpdateOrderDetailByIdInput;
}>;


export type UpdateOrderDetailMutation = { __typename?: 'Mutation', updateOrderDetailById?: { __typename?: 'UpdateOrderDetailPayload', orderDetail?: { __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, consignee?: string | null, extraInfo?: string | null } | null } | null };

export type UpdateCargoExclusionMutationVariables = Exact<{
  input: UpdateCargoExclusionByIdInput;
}>;


export type UpdateCargoExclusionMutation = { __typename?: 'Mutation', updateCargoExclusionById?: { __typename?: 'UpdateCargoExclusionPayload', cargoExclusion?: { __typename?: 'CargoExclusion', id: CargoExclusionId } | null } | null };

export type DeleteCargoExclusionByIdMutationVariables = Exact<{
  input: DeleteCargoExclusionByIdInput;
}>;


export type DeleteCargoExclusionByIdMutation = { __typename?: 'Mutation', deleteCargoExclusionById?: { __typename?: 'DeleteCargoExclusionPayload', cargoExclusion?: { __typename?: 'CargoExclusion', id: CargoExclusionId } | null } | null };

export type DeleteOrderRequirementAssociationMutationVariables = Exact<{
  input: DeleteOrderRequirementAssociationByIdInput;
}>;


export type DeleteOrderRequirementAssociationMutation = { __typename?: 'Mutation', deleteOrderRequirementAssociationById?: { __typename?: 'DeleteOrderRequirementAssociationPayload', orderRequirementAssociation?: { __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId } | null } | null };

export type DeleteOrderAttributeAssociationMutationVariables = Exact<{
  input: DeleteOrderAttributeAssociationByIdInput;
}>;


export type DeleteOrderAttributeAssociationMutation = { __typename?: 'Mutation', deleteOrderAttributeAssociationById?: { __typename?: 'DeleteOrderAttributeAssociationPayload', orderAttributeAssociation?: { __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null } | null };

export type DeleteOrderMutationVariables = Exact<{
  input: DeleteOrderByIdInput;
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrderById?: { __typename?: 'DeleteOrderPayload', order?: { __typename?: 'Order', id: OrderId } | null } | null };

export type UpdateScheduledOrderMutationVariables = Exact<{
  scheduledOrderId: Scalars['ScheduledOrderId']['input'];
  patch: ScheduledOrderPatch;
}>;


export type UpdateScheduledOrderMutation = { __typename?: 'Mutation', updateScheduledOrderById?: { __typename?: 'UpdateScheduledOrderPayload', scheduledOrder?: { __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null } | null };

export type UpdateShipmentMutationVariables = Exact<{
  shipmentId: Scalars['ShipmentId']['input'];
  patch: ShipmentPatch;
}>;


export type UpdateShipmentMutation = { __typename?: 'Mutation', updateShipmentById?: { __typename?: 'UpdateShipmentPayload', shipment?: { __typename?: 'Shipment', id: ShipmentId, clientId: string, name: string, remarks?: string | null, externalShipmentId?: string | null, voyageAttributeId?: VoyageAttributeId | null, shipmentExternalStatusesByShipmentId: { __typename?: 'ShipmentExternalStatusesConnection', nodes: Array<{ __typename?: 'ShipmentExternalStatus', id: ShipmentExternalStatusId, status: ShipmentStatus } | null> }, shipmentFreightByShipmentId?: { __typename?: 'ShipmentFreight', id: ShipmentFreightId, clientId: string, shipmentId: ShipmentId, freightAmount: string | number, freightUnit: PaymentUnit } | null, shipmentExtraFreightsByShipmentId: { __typename?: 'ShipmentExtraFreightsConnection', nodes: Array<{ __typename?: 'ShipmentExtraFreight', id: ShipmentExtraFreightId, clientId: string, shipmentId: ShipmentId, name?: string | null, freightAmount: string | number, freightUnit: PaymentUnit, description?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> } } | null } | null };

export type ApiShipmentStatusMutationVariables = Exact<{
  input: CreateApiShipmentStatusInput;
}>;


export type ApiShipmentStatusMutation = { __typename?: 'Mutation', createApiShipmentStatus?: { __typename?: 'CreateApiShipmentStatusPayload', apiShipmentStatus?: { __typename?: 'ApiShipmentStatus', shipmentId?: number | null, externalShipmentId?: string | null, sourceId?: string | null, status?: ShipmentStatus | null, isAccepted?: boolean | null, shipmentStatusId?: number | null } | null } | null };

export type UpdateSingleEventMutationVariables = Exact<{
  singleEventId: Scalars['SingleEventId']['input'];
  patch: SingleEventPatch;
}>;


export type UpdateSingleEventMutation = { __typename?: 'Mutation', updateSingleEventById?: { __typename?: 'UpdateSingleEventPayload', singleEvent?: { __typename?: 'SingleEvent', id: SingleEventId, duration: string | number, end: string, locationId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, vesselId?: ShipId | null, type: EventType, startOverride?: string | null, concurrent: boolean, seaDurationOverride?: string | number | null, clientId: string, updatedAt?: string | null, archived: boolean, cleaningAssortmentExclusionId?: AssortmentExclusionId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, singleEventPortCallRelationsBySingleEventId: { __typename?: 'SingleEventPortCallRelationsConnection', nodes: Array<{ __typename?: 'SingleEventPortCallRelation', id: SingleEventPortCallRelationId, portCallId: PortCallId, singleEventId: SingleEventId } | null> } } | null } | null };

export type UpdatePlanningPageVesselInfoMutationVariables = Exact<{
  id: Scalars['ShipId']['input'];
  vessel: ShipPatch;
}>;


export type UpdatePlanningPageVesselInfoMutation = { __typename?: 'Mutation', updateShipById?: { __typename?: 'UpdateShipPayload', ship?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null } | null };

export type CreateVaAssociationMutationVariables = Exact<{
  input: CreateVesselAttributesAssociationInput;
}>;


export type CreateVaAssociationMutation = { __typename?: 'Mutation', createVesselAttributesAssociation?: { __typename?: 'CreateVesselAttributesAssociationPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null } | null };

export type DeleteVaaByIdMutationVariables = Exact<{
  associationId: Scalars['VesselAttributesAssociationId']['input'];
}>;


export type DeleteVaaByIdMutation = { __typename?: 'Mutation', deleteVesselAttributesAssociationById?: { __typename?: 'DeleteVesselAttributesAssociationPayload', shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingByIdInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettingById?: { __typename?: 'UpdateUserSettingPayload', userSetting?: { __typename?: 'UserSetting', id: UserSettingId, userId: UserId, notificationAllOrders?: { __typename?: 'NotificationSetting', dischargeDocumentUploaded?: boolean | null, orderVesselChanged?: boolean | null, orderPublishedUnassignedShipment?: boolean | null, orderPublishedShippingPlan?: boolean | null, orderPublishedEdited?: boolean | null, loadSofSaved?: boolean | null, loadNorSaved?: boolean | null, loadEtdChanged?: boolean | null, loadEtbChanged?: boolean | null, loadEtaChanged?: boolean | null, loadDocumentUploaded?: boolean | null, loadBlSaved?: boolean | null, dischargeSofSaved?: boolean | null, dischargeNorSaved?: boolean | null, dischargeMrSaved?: boolean | null, dischargeEtd?: boolean | null, dischargeEtb?: boolean | null, dischargeEta?: boolean | null, ordersUpsertedViaIntegration?: boolean | null } | null, notificationYourOrders?: { __typename?: 'NotificationSetting', dischargeDocumentUploaded?: boolean | null, orderVesselChanged?: boolean | null, orderPublishedUnassignedShipment?: boolean | null, orderPublishedShippingPlan?: boolean | null, orderPublishedEdited?: boolean | null, loadSofSaved?: boolean | null, loadNorSaved?: boolean | null, loadEtdChanged?: boolean | null, loadEtaChanged?: boolean | null, loadEtbChanged?: boolean | null, loadBlSaved?: boolean | null, loadDocumentUploaded?: boolean | null, dischargeNorSaved?: boolean | null, dischargeSofSaved?: boolean | null, dischargeMrSaved?: boolean | null, dischargeEtd?: boolean | null, dischargeEtb?: boolean | null, dischargeEta?: boolean | null, ordersUpsertedViaIntegration?: boolean | null } | null } | null } | null };

export type VcAndOrdersMutationVariables = Exact<{
  deleteCargoExclusions?: InputMaybe<Array<Scalars['CargoExclusionId']['input']>>;
  deleteOrderRequirementAssociations?: InputMaybe<Array<Scalars['OrderRequirementAssociationId']['input']>>;
  deleteOrderAttributeAssociations?: InputMaybe<Array<Scalars['OrderAttributeAssociationId']['input']>>;
  deleteCommissions?: InputMaybe<Array<Scalars['CommissionId']['input']>>;
  deleteVoyageCharterExtraFreights?: InputMaybe<Array<Scalars['VoyageCharterExtraFreightId']['input']>>;
  deleteVoyageCharterExtraCosts?: InputMaybe<Array<Scalars['VoyageCharterExtraCostId']['input']>>;
  deleteOrderVoyageCharterRelations?: InputMaybe<Array<Scalars['OrderVoyageCharterRelationId']['input']>>;
  deleteVoyageCharterOrderFreights?: InputMaybe<Array<Scalars['VoyageCharterOrderFreightId']['input']>>;
  deleteVoyageCharterToContracts?: InputMaybe<Array<Scalars['VoyageCharterToContractId']['input']>>;
  deleteVoyageCharterPortData?: InputMaybe<Array<Scalars['VoyageCharterPortDatumId']['input']>>;
  deleteVoyageCharters?: InputMaybe<Array<Scalars['VoyageCharterId']['input']>>;
  deletePortData?: InputMaybe<Array<Scalars['PortDatumId']['input']>>;
  deleteOrders?: InputMaybe<Array<Scalars['OrderId']['input']>>;
  createOrders?: InputMaybe<Array<OrderInput>>;
  createOrderDetails?: InputMaybe<Array<CommitOrderDetailInput>>;
  createCargoExclusions?: InputMaybe<Array<CommitCargoExclusionInput>>;
  createOrderRequirementAssociations?: InputMaybe<Array<CommitOrderRequirementAssociationInput>>;
  createOrderAttributeAssociations?: InputMaybe<Array<CommitOrderAttributeAssociationInput>>;
  createPortData?: InputMaybe<Array<PortDatumInput>>;
  createVoyageCharters?: InputMaybe<Array<VoyageCharterInput>>;
  createVoyageCharterPortData?: InputMaybe<Array<CommitVcVoyageCharterPortDatumInput>>;
  createVoyageCharterToContracts?: InputMaybe<Array<CommitVoyageCharterToContractInput>>;
  createOrderVoyageCharterRelations?: InputMaybe<Array<CommitVcOrderVoyageCharterRelationInput>>;
  createVoyageCharterOrderFreights?: InputMaybe<Array<CommitVoyageCharterOrderFreightInput>>;
  createVoyageCharterExtraFreights?: InputMaybe<Array<CommitVoyageCharterExtraFreightInput>>;
  createVoyageCharterExtraCosts?: InputMaybe<Array<CommitVoyageCharterExtraCostInput>>;
  createCommissions?: InputMaybe<Array<CommitCommissionInput>>;
  mapLocations?: InputMaybe<Array<IdRemappingInput>>;
  mapAssortments?: InputMaybe<Array<IdRemappingInput>>;
  updateOrders?: InputMaybe<Array<UpdateOrderByIdInput>>;
  updateOrderDetails?: InputMaybe<Array<UpdateOrderDetailByIdInput>>;
  updatePortData?: InputMaybe<Array<UpdatePortDatumByIdInput>>;
  updateVoyageCharters?: InputMaybe<Array<UpdateVoyageCharterByIdInput>>;
  updateVoyageCharterPortData?: InputMaybe<Array<UpdateVoyageCharterPortDatumByIdInput>>;
  updateVoyageCharterToContracts?: InputMaybe<Array<UpdateVoyageCharterToContractByIdInput>>;
  updateOrderVoyageCharterRelations?: InputMaybe<Array<UpdateOrderVoyageCharterRelationByIdInput>>;
  updateVoyageCharterOrderFreights?: InputMaybe<Array<UpdateVoyageCharterOrderFreightByIdInput>>;
  updateVoyageCharterExtraFreights?: InputMaybe<Array<UpdateVoyageCharterExtraFreightByIdInput>>;
  updateVoyageCharterExtraCosts?: InputMaybe<Array<UpdateVoyageCharterExtraCostByIdInput>>;
  updateCommissions?: InputMaybe<Array<UpdateCommissionByIdInput>>;
}>;


export type VcAndOrdersMutation = { __typename?: 'Mutation', vcAndOrders?: { __typename?: 'VcAndOrdersPayload', createdOrders: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } }>, createdVoyageCharters: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId }>, updatedOrders: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } }>, updatedOrderDetails: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null }>, updatedPortData: Array<{ __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null }>, updatedVoyageCharters: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, currency?: Currency | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } }>, updatedVoyageCharterPortData: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId }>, updatedVoyageCharterToContracts: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, price: string | number, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit, minAmount?: string | number | null, maxAmount?: string | number | null } | null> } } | null }>, updatedOrderVoyageCharterRelations: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null }>, updatedVoyageCharterOrderFreights: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightUnit?: PaymentUnit | null, freightAmount?: string | number | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId }>, updatedVoyageCharterExtraFreights: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, name?: string | null, type?: FreightType | null, description?: string | null, ignoreInPnl?: boolean | null }>, updatedVoyageCharterExtraCosts: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId }>, updatedCommissions: Array<{ __typename?: 'Commission', id: CommissionId }> } | null };

export type CreateVoyageCharterMutationVariables = Exact<{
  input: CreateVoyageCharterInput;
}>;


export type CreateVoyageCharterMutation = { __typename?: 'Mutation', createVoyageCharter?: { __typename?: 'CreateVoyageCharterPayload', voyageCharter?: { __typename?: 'VoyageCharter', id: VoyageCharterId } | null } | null };

export type DeleteVoyageCharterMutationVariables = Exact<{
  input: DeleteVoyageCharterByIdInput;
}>;


export type DeleteVoyageCharterMutation = { __typename?: 'Mutation', deleteVoyageCharterById?: { __typename?: 'DeleteVoyageCharterPayload', voyageCharter?: { __typename?: 'VoyageCharter', id: VoyageCharterId } | null } | null };

export type CreateOrderVoyageCharterRelationMutationVariables = Exact<{
  input: CreateOrderVoyageCharterRelationInput;
}>;


export type CreateOrderVoyageCharterRelationMutation = { __typename?: 'Mutation', createOrderVoyageCharterRelation?: { __typename?: 'CreateOrderVoyageCharterRelationPayload', orderVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null } | null } | null };

export type UpdateOrderVoyageCharterRelationMutationVariables = Exact<{
  input: UpdateOrderVoyageCharterRelationByIdInput;
}>;


export type UpdateOrderVoyageCharterRelationMutation = { __typename?: 'Mutation', updateOrderVoyageCharterRelationById?: { __typename?: 'UpdateOrderVoyageCharterRelationPayload', orderVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null } | null } | null };

export type DeleteOrderVoyageCharterRelationMutationVariables = Exact<{
  input: DeleteOrderVoyageCharterRelationByIdInput;
}>;


export type DeleteOrderVoyageCharterRelationMutation = { __typename?: 'Mutation', deleteOrderVoyageCharterRelationById?: { __typename?: 'DeleteOrderVoyageCharterRelationPayload', orderVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null } | null } | null };

export type UpdateVoyageCharterOnSubsMutationVariables = Exact<{
  voyageCharterId: Scalars['VoyageCharterId']['input'];
  onSubsUntil?: InputMaybe<Scalars['Datetime']['input']>;
}>;


export type UpdateVoyageCharterOnSubsMutation = { __typename?: 'Mutation', updateVoyageCharterById?: { __typename?: 'UpdateVoyageCharterPayload', voyageCharter?: { __typename?: 'VoyageCharter', id: VoyageCharterId, onSubsUntil?: string | null } | null } | null };

export type UpdateVoyageCharterIsInquiryMutationVariables = Exact<{
  voyageCharterId: Scalars['VoyageCharterId']['input'];
  isInquiry: Scalars['Boolean']['input'];
}>;


export type UpdateVoyageCharterIsInquiryMutation = { __typename?: 'Mutation', updateVoyageCharterById?: { __typename?: 'UpdateVoyageCharterPayload', voyageCharter?: { __typename?: 'VoyageCharter', id: VoyageCharterId, isInquiry: boolean } | null } | null };

export type CreateLostContractMutationVariables = Exact<{
  input: CreateLostContractInput;
}>;


export type CreateLostContractMutation = { __typename?: 'Mutation', createLostContract?: { __typename?: 'CreateLostContractPayload', lostContract?: { __typename?: 'LostContract', id: LostContractId } | null } | null };

export type UpdateLostContractMutationVariables = Exact<{
  input: UpdateLostContractByIdInput;
}>;


export type UpdateLostContractMutation = { __typename?: 'Mutation', updateLostContractById?: { __typename?: 'UpdateLostContractPayload', lostContract?: { __typename?: 'LostContract', id: LostContractId } | null } | null };

export type CreateVoyageCharterUpdateMutationVariables = Exact<{
  input: CreateVoyageCharterUpdateInput;
}>;


export type CreateVoyageCharterUpdateMutation = { __typename?: 'Mutation', createVoyageCharterUpdate?: { __typename?: 'CreateVoyageCharterUpdatePayload', voyageCharterUpdate?: { __typename?: 'VoyageCharterUpdate', id: VoyageCharterUpdateId, createdByUserId: UserId, createdAt: string, cancelling?: string | null, accepted?: boolean | null, layday?: string | null, vesselId?: ShipId | null, voyageCharterId: VoyageCharterId, userByCreatedByUserId?: { __typename?: 'User', id: UserId, email?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null } | null };

export type DeleteVoyageCharterUpdateMutationVariables = Exact<{
  input: DeleteVoyageCharterUpdateByIdInput;
}>;


export type DeleteVoyageCharterUpdateMutation = { __typename?: 'Mutation', deleteVoyageCharterUpdateById?: { __typename?: 'DeleteVoyageCharterUpdatePayload', deletedVoyageCharterUpdateId?: string | null } | null };

export type AcceptVoyageCharterUpdateMutationVariables = Exact<{
  input: AcceptVoyageCharterUpdateInput;
}>;


export type AcceptVoyageCharterUpdateMutation = { __typename?: 'Mutation', acceptVoyageCharterUpdate?: { __typename?: 'AcceptVoyageCharterUpdatePayload', voyageCharter?: { __typename?: 'VoyageCharter', id: VoyageCharterId, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null } | null };

export type VoyagePrefixGetNextIdsMutationVariables = Exact<{
  input: VoyagePrefixGetNextIdsInput;
}>;


export type VoyagePrefixGetNextIdsMutation = { __typename?: 'Mutation', voyagePrefixGetNextIds?: { __typename?: 'VoyagePrefixGetNextIdsPayload', strings?: Array<string | null> | null } | null };

export type AllLocationsQueryVariables = Exact<{
  filter?: InputMaybe<LocationFilter>;
}>;


export type AllLocationsQuery = { __typename?: 'Query', allLocations?: { __typename?: 'LocationsConnection', nodes: Array<{ __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null> } | null };

export type AllZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllZonesQuery = { __typename?: 'Query', allZones?: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: ZoneId, name: string } | null> } | null };

export type ArchivePageQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchivePageQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, cancelling?: string | null, cargoAmount: string | number, deliveredBefore?: string | null, layday?: string | null, rta?: string | null, nominatedVessel?: string | null, externalOrderId?: string | null, createdAt?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null, orderDetails: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, externalRemarks?: string | null, sender?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, receiver?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> } | null };

export type ArchivePage_QueryFragment = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, cancelling?: string | null, cargoAmount: string | number, deliveredBefore?: string | null, layday?: string | null, rta?: string | null, nominatedVessel?: string | null, externalOrderId?: string | null, createdAt?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null, orderDetails: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, externalRemarks?: string | null, sender?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, receiver?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> } | null };

export type ArchivePage_OrderFragment = { __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, cancelling?: string | null, cargoAmount: string | number, deliveredBefore?: string | null, layday?: string | null, rta?: string | null, nominatedVessel?: string | null, externalOrderId?: string | null, createdAt?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null, orderDetails: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, externalRemarks?: string | null, sender?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, receiver?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null };

export type ArchivedAndLostPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchivedAndLostPageQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, loadPortId?: LocationId | null, shipmentId?: ShipmentId | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, dischargePortId: LocationId, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, timezone?: string | null } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, timezone?: string | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, lostContractByLostContractsId?: { __typename?: 'LostContract', id: LostContractId, remarks?: string | null, organizationId: OrganizationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, freightCurrency?: Currency | null, createdAt: string } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, loadingStart: string, dischargingEnd: string } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, plannedArrival?: string | null, plannedDeparture?: string | null } | null } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterId: VoyageCharterId } | null, shipmentByShipmentId?: { __typename?: 'Shipment', id: ShipmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, orderDetails: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null, extraInfo?: string | null, receiverOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, senderOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, billOfLading: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, volume?: string | number | null, volumeOnDeck?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightOnDeck?: string | number | null, weightUnit?: WeightUnits | null } | null> }, cargoMeasurement: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, measuredVolume?: string | number | null, measuredWeight?: string | number | null, volumeUnit?: VolumeUnits | null, weightUnit?: WeightUnits | null } | null> }, chartererOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpot?: { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, handledByCoa?: { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, scheduledOrder: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> }, portCallRelations: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, isLoadPort: boolean, portCall?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, sailingTime?: string | null, arrivalTime?: string | null, portCallId: PortCallId, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, eta?: string | null, etdBerth?: string | null, ataPbp?: string | null, portCallId: PortCallId, berthingProspects?: string | null, ataBerth?: string | null, norTendered?: string | null } | null> }, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null } | null> }, orderAtributeAssociations: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderAttribute?: { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string } | null } | null> }, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', coaId?: CoaContractId | null, id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, name?: string | null } | null } | null> } } | null } | null> } } | null> } | null, allSingleEvents?: { __typename?: 'SingleEventsConnection', nodes: Array<{ __typename?: 'SingleEvent', id: SingleEventId, start: string, vesselId?: ShipId | null, singleEventPortCallRelationsBySingleEventId: { __typename?: 'SingleEventPortCallRelationsConnection', nodes: Array<{ __typename?: 'SingleEventPortCallRelation', id: SingleEventPortCallRelationId, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, plannedArrival?: string | null, plannedDeparture?: string | null } | null } | null> } } | null> } | null, allOffHires?: { __typename?: 'OffHiresConnection', nodes: Array<{ __typename?: 'OffHire', id: OffHireId, start: string, vesselId?: ShipId | null } | null> } | null };

export type ArchivedAndLostTable_OrderFragment = { __typename?: 'Order', id: OrderId, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, loadPortId?: LocationId | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, dischargePortId: LocationId, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, timezone?: string | null } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, timezone?: string | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, lostContractByLostContractsId?: { __typename?: 'LostContract', id: LostContractId, remarks?: string | null, organizationId: OrganizationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, freightCurrency?: Currency | null, createdAt: string } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId } | null, shipmentByShipmentId?: { __typename?: 'Shipment', id: ShipmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, orderDetails: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null, extraInfo?: string | null, receiverOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, senderOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, billOfLading: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, volume?: string | number | null, volumeOnDeck?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightOnDeck?: string | number | null, weightUnit?: WeightUnits | null } | null> }, cargoMeasurement: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, measuredVolume?: string | number | null, measuredWeight?: string | number | null, volumeUnit?: VolumeUnits | null, weightUnit?: WeightUnits | null } | null> }, chartererOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpot?: { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, handledByCoa?: { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, scheduledOrder: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> }, portCallRelations: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, isLoadPort: boolean, portCall?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, sailingTime?: string | null, arrivalTime?: string | null, portCallId: PortCallId, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, eta?: string | null, etdBerth?: string | null, ataPbp?: string | null, portCallId: PortCallId, berthingProspects?: string | null, ataBerth?: string | null, norTendered?: string | null } | null> }, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null } | null> }, orderAtributeAssociations: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderAttribute?: { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string } | null } | null> }, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', coaId?: CoaContractId | null, id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, name?: string | null } | null } | null> } } | null } | null> } };

export type ArchivedAndLostTable_Order_UnarchiveFragment = { __typename?: 'Order', id: OrderId, shipmentId?: ShipmentId | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, loadingStart: string, dischargingEnd: string } | null> }, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, plannedArrival?: string | null, plannedDeparture?: string | null } | null } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterId: VoyageCharterId } | null };

export type ArchivedAndLostTable_SingleEvent_UnarchiveFragment = { __typename?: 'SingleEvent', id: SingleEventId, start: string, vesselId?: ShipId | null, singleEventPortCallRelationsBySingleEventId: { __typename?: 'SingleEventPortCallRelationsConnection', nodes: Array<{ __typename?: 'SingleEventPortCallRelation', id: SingleEventPortCallRelationId, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, plannedArrival?: string | null, plannedDeparture?: string | null } | null } | null> } };

export type ArchivedAndLostTable_OffHire_UnarchiveFragment = { __typename?: 'OffHire', id: OffHireId, start: string, vesselId?: ShipId | null };

export type LostContractFragment = { __typename?: 'LostContract', id: LostContractId, remarks?: string | null, organizationId: OrganizationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, freightCurrency?: Currency | null, createdAt: string };

export type ArchivedDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchivedDataQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId } | null> } | null, allSingleEvents?: { __typename?: 'SingleEventsConnection', nodes: Array<{ __typename?: 'SingleEvent', id: SingleEventId, clientId: string } | null> } | null, allOffHires?: { __typename?: 'OffHiresConnection', nodes: Array<{ __typename?: 'OffHire', id: OffHireId, clientId: string } | null> } | null, allPortCalls?: { __typename?: 'PortCallsConnection', nodes: Array<{ __typename?: 'PortCall', id: PortCallId, clientId: string } | null> } | null };

export type Baf_VoyageCharterFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> } };

export type Baf_CoaFragment = { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } };

export type Baf_CoaBunkerFragment = { __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number };

export type BatchDataQueryVariables = Exact<{
  updatedIds: Array<Scalars['Int']['input']>;
  insertedIds: Array<Scalars['Int']['input']>;
  updatedCoaIds: Array<Scalars['Int']['input']>;
  insertedCoaIds: Array<Scalars['Int']['input']>;
  updatedVcIds: Array<Scalars['Int']['input']>;
  includeOrgs: Scalars['Boolean']['input'];
  includeShips: Scalars['Boolean']['input'];
  includeAssortments: Scalars['Boolean']['input'];
  includeUpdated: Scalars['Boolean']['input'];
  includeInserted: Scalars['Boolean']['input'];
  includeUpdatedCoas: Scalars['Boolean']['input'];
  includeInsertedCoas: Scalars['Boolean']['input'];
  includeUpdatedVcs: Scalars['Boolean']['input'];
}>;


export type BatchDataQuery = { __typename?: 'Query', updated?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null> } | null, inserted?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null> } | null, updatedCoas?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, inactive: boolean, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, shipowner?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vessels: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, portDataRelations: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaAssortments: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, id: CoaContractAssortmentId } | null> }, ports: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, coaContractId: CoaContractId, originId?: LocationId | null, destinationId?: LocationId | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null> } | null, insertedCoas?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, inactive: boolean, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, shipowner?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vessels: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, portDataRelations: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaAssortments: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, id: CoaContractAssortmentId } | null> }, ports: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, coaContractId: CoaContractId, originId?: LocationId | null, destinationId?: LocationId | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null> } | null, updatedVcs?: { __typename?: 'VoyageChartersConnection', nodes: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, currency?: Currency | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, draft?: string | number | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configEnableScenarioAutoSave: boolean, configCargoAllocationCombineAssortment: boolean, portCostPriority?: string | null, broker: boolean } | null> } | null, allShips?: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null> } | null, allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null> } | null };

export type AllOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type AllOrdersQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null> } | null };

export type BerthPredictionsQueryVariables = Exact<{
  inputs: Array<BerthPredictionInput>;
}>;


export type BerthPredictionsQuery = { __typename?: 'Query', GetBerthPredictions?: { __typename?: 'BerthPredictions', predictions?: Array<{ __typename?: 'BerthPrediction', PredictedBerthTime?: number | null, InputUsedByTheModel?: { __typename?: 'BerthPredictionMapping', VesselName?: string | null, PortName?: string | null, TerminalName?: string | null, Operation?: string | null, Scheduled_Quantity?: number | null, Cargo?: string | null, dwt?: number | null, vesselType?: string | null, CargoOPL?: string | null } | null } | null> | null } | null };

export type BunkerGradesQueryVariables = Exact<{ [key: string]: never; }>;


export type BunkerGradesQuery = { __typename?: 'Query', allBunkerGradeOverrides?: { __typename?: 'BunkerGradeOverridesConnection', nodes: Array<{ __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string, carbonFactor?: string | number | null, ch4Factor?: string | number | null, lcv?: string | number | null, n2OFactor?: string | number | null, wttFactor?: string | number | null, price?: string | number | null, priceAdjustment?: string | number | null, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, isBlend: boolean, blendComponent1Id?: BunkerGradeOverrideId | null, blendComponent2Id?: BunkerGradeOverrideId | null, blendPercentage1?: string | number | null, blendPercentage2?: string | number | null } | null> } | null };

export type CalculateVoyagesQueryVariables = Exact<{
  inputs: Array<CalculateVoyageInputs>;
}>;


export type CalculateVoyagesQuery = { __typename?: 'Query', calculateVoyages?: Array<{ __typename?: 'VoyageCalculation', fuelConsumptionBreakdown?: { __typename?: 'FuelConsumptionBreakdown', isSuccess: boolean, errors: Array<string>, value?: { __typename?: 'FuelSummaries', HFO?: { __typename?: 'FuelSummary', consumption: number, cost: number } | null, LSFO?: { __typename?: 'FuelSummary', consumption: number, cost: number } | null, MGO?: { __typename?: 'FuelSummary', consumption: number, cost: number } | null, LNG?: { __typename?: 'FuelSummary', consumption: number, cost: number } | null } | null } | null } | null> | null };

export type ChangelogQueryVariables = Exact<{
  portCallIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  portCallClientIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  voyageCharterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type ChangelogQuery = { __typename?: 'Query', allPortCalls?: { __typename?: 'PortCallsConnection', nodes: Array<{ __typename?: 'PortCall', id: PortCallId, plannedArrival?: string | null, plannedArrivalDuration?: string | number | null, plannedArrivalOverride?: string | null, plannedBerthing?: string | null, plannedBerthingDuration?: string | number | null, plannedBerthingOverride?: string | null, plannedDeparture?: string | null, plannedDepartureDuration?: string | number | null, plannedDepartureOverride?: string | null, seaDurationOverride?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, portCallHistoriesById: { __typename?: 'PortCallHistoriesConnection', nodes: Array<{ __typename?: 'PortCallHistory', id: PortCallId, plannedArrival?: string | null, plannedArrivalDuration?: string | number | null, plannedArrivalOverride?: string | null, plannedBerthing?: string | null, plannedBerthingDuration?: string | number | null, plannedBerthingOverride?: string | null, plannedDeparture?: string | null, plannedDepartureDuration?: string | number | null, plannedDepartureOverride?: string | null, seaDurationOverride?: string | number | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> } | null, allPortNotices?: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, ataBerth?: string | null, ataPbp?: string | null, berthingProspects?: string | null, eta?: string | null, etdBerth?: string | null, norTendered?: string | null, portCallId: PortCallId, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null }, portNoticeHistoriesById: { __typename?: 'PortNoticeHistoriesConnection', nodes: Array<{ __typename?: 'PortNoticeHistory', id: PortNoticeId, ataBerth?: string | null, ataPbp?: string | null, berthingProspects?: string | null, eta?: string | null, etdBerth?: string | null, norTendered?: string | null, portCallId: number, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> } } | null> } | null, allStatementOfFacts?: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, arrivalTime?: string | null, berthed?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, noticeOfReadiness?: string | null, pilotOnboard?: string | null, portCallId: PortCallId, sailingTime?: string | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, statementOfFactsHistoriesById: { __typename?: 'StatementOfFactsHistoriesConnection', nodes: Array<{ __typename?: 'StatementOfFactsHistory', id: StatementOfFactId, arrivalTime?: string | null, berthed?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, noticeOfReadiness?: string | null, pilotOnboard?: string | null, portCallId: number, sailingTime?: string | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> } | null, allVoyageCharters?: { __typename?: 'VoyageChartersConnection', nodes: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId, vesselId?: ShipId | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, voyageCharterHistoriesById: { __typename?: 'VoyageCharterHistoriesConnection', nodes: Array<{ __typename?: 'VoyageCharterHistory', id: VoyageCharterId, vesselId?: ShipId | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, orderVoyageCharterRelationsByVoyageCharterId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderByOrderId?: { __typename?: 'Order', id: OrderId, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, handledByCoaHistoriesById: { __typename?: 'HandledByCoaHistoriesConnection', nodes: Array<{ __typename?: 'HandledByCoaHistory', id: HandledByCoaId, shared: boolean, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, handledBySpotHistoriesById: { __typename?: 'HandledBySpotHistoriesConnection', nodes: Array<{ __typename?: 'HandledBySpotHistory', id: HandledBySpotId, shared: boolean, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null } | null } | null> }, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> } | null };

export type Changelog_PortCallFragment = { __typename?: 'PortCall', id: PortCallId, plannedArrival?: string | null, plannedArrivalDuration?: string | number | null, plannedArrivalOverride?: string | null, plannedBerthing?: string | null, plannedBerthingDuration?: string | number | null, plannedBerthingOverride?: string | null, plannedDeparture?: string | null, plannedDepartureDuration?: string | number | null, plannedDepartureOverride?: string | null, seaDurationOverride?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, portCallHistoriesById: { __typename?: 'PortCallHistoriesConnection', nodes: Array<{ __typename?: 'PortCallHistory', id: PortCallId, plannedArrival?: string | null, plannedArrivalDuration?: string | number | null, plannedArrivalOverride?: string | null, plannedBerthing?: string | null, plannedBerthingDuration?: string | number | null, plannedBerthingOverride?: string | null, plannedDeparture?: string | null, plannedDepartureDuration?: string | number | null, plannedDepartureOverride?: string | null, seaDurationOverride?: string | number | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_LocationFragment = { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null };

export type Changelog_PortCallHistoryFragment = { __typename?: 'PortCallHistory', id: PortCallId, plannedArrival?: string | null, plannedArrivalDuration?: string | number | null, plannedArrivalOverride?: string | null, plannedBerthing?: string | null, plannedBerthingDuration?: string | number | null, plannedBerthingOverride?: string | null, plannedDeparture?: string | null, plannedDepartureDuration?: string | number | null, plannedDepartureOverride?: string | null, seaDurationOverride?: string | number | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_PortNoticeFragment = { __typename?: 'PortNotice', ataBerth?: string | null, ataPbp?: string | null, berthingProspects?: string | null, eta?: string | null, etdBerth?: string | null, id: PortNoticeId, norTendered?: string | null, portCallId: PortCallId, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null }, portNoticeHistoriesById: { __typename?: 'PortNoticeHistoriesConnection', nodes: Array<{ __typename?: 'PortNoticeHistory', id: PortNoticeId, ataBerth?: string | null, ataPbp?: string | null, berthingProspects?: string | null, eta?: string | null, etdBerth?: string | null, norTendered?: string | null, portCallId: number, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> } };

export type Changelog_PortNoticeHistoryFragment = { __typename?: 'PortNoticeHistory', ataBerth?: string | null, ataPbp?: string | null, berthingProspects?: string | null, eta?: string | null, etdBerth?: string | null, id: PortNoticeId, norTendered?: string | null, portCallId: number, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_StatementOfFactsFragment = { __typename?: 'StatementOfFact', arrivalTime?: string | null, berthed?: string | null, id: StatementOfFactId, loadingCommenced?: string | null, loadingCompleted?: string | null, noticeOfReadiness?: string | null, pilotOnboard?: string | null, portCallId: PortCallId, sailingTime?: string | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, statementOfFactsHistoriesById: { __typename?: 'StatementOfFactsHistoriesConnection', nodes: Array<{ __typename?: 'StatementOfFactsHistory', id: StatementOfFactId, arrivalTime?: string | null, berthed?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, noticeOfReadiness?: string | null, pilotOnboard?: string | null, portCallId: number, sailingTime?: string | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_StatementOfFactsHistoryFragment = { __typename?: 'StatementOfFactsHistory', arrivalTime?: string | null, berthed?: string | null, id: StatementOfFactId, loadingCommenced?: string | null, loadingCompleted?: string | null, noticeOfReadiness?: string | null, pilotOnboard?: string | null, portCallId: number, sailingTime?: string | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_VoyageChartersFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, vesselId?: ShipId | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, voyageCharterHistoriesById: { __typename?: 'VoyageCharterHistoriesConnection', nodes: Array<{ __typename?: 'VoyageCharterHistory', id: VoyageCharterId, vesselId?: ShipId | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, orderVoyageCharterRelationsByVoyageCharterId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderByOrderId?: { __typename?: 'Order', id: OrderId, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, handledByCoaHistoriesById: { __typename?: 'HandledByCoaHistoriesConnection', nodes: Array<{ __typename?: 'HandledByCoaHistory', id: HandledByCoaId, shared: boolean, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, handledBySpotHistoriesById: { __typename?: 'HandledBySpotHistoriesConnection', nodes: Array<{ __typename?: 'HandledBySpotHistory', id: HandledBySpotId, shared: boolean, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null } | null } | null> }, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_VoyageCharterHistoryFragment = { __typename?: 'VoyageCharterHistory', id: VoyageCharterId, vesselId?: ShipId | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_HandledByCoaFragment = { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_HandledByCoaHistoryFragment = { __typename?: 'HandledByCoaHistory', id: HandledByCoaId, shared: boolean, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_HandledBySpotFragment = { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_HandledBySpotHistoryFragment = { __typename?: 'HandledBySpotHistory', id: HandledBySpotId, shared: boolean, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type Changelog_ModifiedByUserFragment = { __typename?: 'User', id: UserId, name?: string | null };

export type GetDataToCleanupForOrderQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetDataToCleanupForOrderQuery = { __typename?: 'Query', orderById?: { __typename?: 'Order', id: OrderId, billOfLadingDataByOrderId: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId } | null> }, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterId: VoyageCharterId } | null> }, cargoMeasurementsByOrderId: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId } | null> }, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId } | null> }, notificationReceiversByOrderId: { __typename?: 'NotificationReceiversConnection', nodes: Array<{ __typename?: 'NotificationReceiver', id: number } | null> }, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId } | null> }, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId } | null> }, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId } | null } | null };

export type GetOrderAssignmentsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type GetOrderAssignmentsQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId } | null> }, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId } | null } | null> } | null };

export type GetDataToCleanupForAllOrdersQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type GetDataToCleanupForAllOrdersQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, billOfLadingDataByOrderId: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId } | null> }, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterId: VoyageCharterId } | null> }, cargoMeasurementsByOrderId: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId } | null> }, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId } | null> }, notificationReceiversByOrderId: { __typename?: 'NotificationReceiversConnection', nodes: Array<{ __typename?: 'NotificationReceiver', id: number } | null> }, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId } | null> } } | null> } | null };

export type CoaFormQueryVariables = Exact<{ [key: string]: never; }>;


export type CoaFormQuery = { __typename?: 'Query', allCargoUnits?: { __typename?: 'CargoUnitsConnection', nodes: Array<{ __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null> } | null, shipowners?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, shipsByOrganizationId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } } | null> } | null, charterers?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, portAgents?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null } | null> } | null, allAssortmentGroups?: { __typename?: 'AssortmentGroupsConnection', nodes: Array<{ __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null> } | null, allZones?: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null> } | null };

export type CoaFormFragment = { __typename?: 'Query', allCargoUnits?: { __typename?: 'CargoUnitsConnection', nodes: Array<{ __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null> } | null, shipowners?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, shipsByOrganizationId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } } | null> } | null, charterers?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, portAgents?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null } | null> } | null, allAssortmentGroups?: { __typename?: 'AssortmentGroupsConnection', nodes: Array<{ __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null> } | null, allZones?: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null> } | null };

export type CoaForm_CargoUnitFragment = { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null };

export type CoaForm_ShipownerFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null, shipsByOrganizationId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } };

export type CoaForm_ChartererFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null };

export type CoaForm_PortAgentFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null };

export type CoaForm_AssortmentFragment = { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null };

export type CoaForm_AssortmentGroupFragment = { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string };

export type CoaForm_CoaFragment = { __typename?: 'CoaContract', id: CoaContractId, name?: string | null, externalId?: string | null, amountUnitId?: CargoUnitId | null, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, shipownerOrgId: OrganizationId, chartererOrgId: OrganizationId, currency?: Currency | null, paymentDays?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, useHighestFreightRate: boolean, bunkers: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, coaContractId: CoaContractId, bunkerGrade: BunkerGrade, price: string | number, basePriceMax?: string | number | null, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, bafType?: BafTypes | null, bafStepSize?: string | number | null, bafStepEffect?: string | number | null, bafStartFromBase?: boolean | null, bafUseStepEffectAsValue?: boolean | null, bafBunkerAmount?: string | number | null } | null> }, portPairs: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, chartererId: UserId, originId?: LocationId | null, destinationId?: LocationId | null, originZoneId?: ZoneId | null, destinationZoneId?: ZoneId | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null } | null> }, portData: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, coaContractId: CoaContractId, portDataId: PortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null> }, coaAssortments: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, coaContractId: CoaContractId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> }, prices: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaContractId: CoaContractId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, shipId?: ShipId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> }, vessels: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, demurrage?: string | number | null, shipId: ShipId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> }, commissions: { __typename?: 'CoaContractCommissionsConnection', nodes: Array<{ __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> }, portCosts: { __typename?: 'CoaContractPortCostsConnection', nodes: Array<{ __typename?: 'CoaContractPortCost', id: CoaContractPortCostId, locationId: LocationId, coaContractId: CoaContractId, shipId?: ShipId | null, cost: string | number, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null> }, deviationCosts: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null, zoneByFromZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByToZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null> }, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type CoaForm_BaseContractFragment = { __typename?: 'CoaContract', id: CoaContractId, name?: string | null, externalId?: string | null, amountUnitId?: CargoUnitId | null, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, shipownerOrgId: OrganizationId, chartererOrgId: OrganizationId, currency?: Currency | null, paymentDays?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type CoaForm_CoaBunkerFragment = { __typename?: 'CoaContractBunker', id: CoaContractBunkerId, coaContractId: CoaContractId, bunkerGrade: BunkerGrade, price: string | number, basePriceMax?: string | number | null, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, bafType?: BafTypes | null, bafStepSize?: string | number | null, bafStepEffect?: string | number | null, bafStartFromBase?: boolean | null, bafUseStepEffectAsValue?: boolean | null, bafBunkerAmount?: string | number | null };

export type CoaForm_PortPairFragment = { __typename?: 'CoaContractPort', id: CoaContractPortId, chartererId: UserId, originId?: LocationId | null, destinationId?: LocationId | null, originZoneId?: ZoneId | null, destinationZoneId?: ZoneId | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null };

export type CoaForm_PortDataFragment = { __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, coaContractId: CoaContractId, portDataId: PortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null };

export type CoaForm_CoaAssortmentFragment = { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, coaContractId: CoaContractId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null };

export type CoaForm_CoaPriceFragment = { __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaContractId: CoaContractId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, shipId?: ShipId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null };

export type CoaForm_CoaVesselFragment = { __typename?: 'CoaContractShip', id: CoaContractShipId, demurrage?: string | number | null, shipId: ShipId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null };

export type CoaForm_CommissionFragment = { __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type CoaForm_PortCostFragment = { __typename?: 'CoaContractPortCost', id: CoaContractPortCostId, locationId: LocationId, coaContractId: CoaContractId, shipId?: ShipId | null, cost: string | number, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null };

export type CoaForm_ZoneFragment = { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } };

export type CoaForm_DeviationCostFragment = { __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null, zoneByFromZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByToZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null };

export type Commission_VoyageCharterFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, currency?: Currency | null, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, assortmentId?: AssortmentId | null, bafApplied?: boolean | null, dischargePortId?: LocationId | null, extraFreightApplied?: boolean | null, loadPortId?: LocationId | null, type: CommissionType, value: string | number, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } };

export type Commission_CommissionFragment = { __typename?: 'Commission', id: CommissionId, assortmentId?: AssortmentId | null, bafApplied?: boolean | null, dischargePortId?: LocationId | null, extraFreightApplied?: boolean | null, loadPortId?: LocationId | null, type: CommissionType, value: string | number, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type CommitLogScenarioByClientIdQueryVariables = Exact<{
  commitLogScenarioClientId: Scalars['UUID']['input'];
}>;


export type CommitLogScenarioByClientIdQuery = { __typename?: 'Query', allCommitLogScenarios?: { __typename?: 'CommitLogScenariosConnection', nodes: Array<{ __typename?: 'CommitLogScenario', id: CommitLogScenarioId, dataSchemaVersion: number, scenarioData?: string | null, organizationId: OrganizationId } | null> } | null };

export type LastCommitFragment = { __typename?: 'CommitLog', id: CommitLogId, committedAt: string, committedBy?: UserId | null, scenarioClientId?: string | null, masterClientId?: string | null, userByCommittedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, commitLogScenarioByMasterClientId?: { __typename?: 'CommitLogScenario', id: CommitLogScenarioId, clientId: string } | null };

export type UserWithNameFragment = { __typename?: 'User', id: UserId, name?: string | null };

export type LastCommitQueryVariables = Exact<{ [key: string]: never; }>;


export type LastCommitQuery = { __typename?: 'Query', lastCommit?: { __typename?: 'CommitLogsConnection', nodes: Array<{ __typename?: 'CommitLog', id: CommitLogId, committedAt: string, committedBy?: UserId | null, scenarioClientId?: string | null, masterClientId?: string | null, userByCommittedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, commitLogScenarioByMasterClientId?: { __typename?: 'CommitLogScenario', id: CommitLogScenarioId, clientId: string } | null } | null> } | null };

export type LastCommitsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type LastCommitsQuery = { __typename?: 'Query', lastCommits?: { __typename?: 'CommitLogsConnection', nodes: Array<{ __typename?: 'CommitLog', id: CommitLogId, committedAt: string, committedBy?: UserId | null, scenarioClientId?: string | null, masterClientId?: string | null, userByCommittedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, commitLogScenarioByMasterClientId?: { __typename?: 'CommitLogScenario', id: CommitLogScenarioId, clientId: string } | null } | null> } | null };

export type CommitsSinceDisconnectQueryVariables = Exact<{
  committedAt: Scalars['Datetime']['input'];
}>;


export type CommitsSinceDisconnectQuery = { __typename?: 'Query', allCommitLogs?: { __typename?: 'CommitLogsConnection', nodes: Array<{ __typename?: 'CommitLog', id: CommitLogId, input: string, payload?: string | null, success: boolean, committedAt: string, committedBy?: UserId | null } | null> } | null };

export type ContractsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractsPageQuery = { __typename?: 'Query', allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, inactive: boolean, startDate: string, endDate: string, externalId?: string | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> } } | null> } | null, allVoyageCharters?: { __typename?: 'VoyageChartersConnection', nodes: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null } | null> }, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderByOrderId?: { __typename?: 'Order', id: OrderId, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null } | null> }, shipmentByShipmentId?: { __typename?: 'Shipment', id: ShipmentId, name: string } | null } | null } | null> } } | null> } | null };

export type VoyageChartersForSpotContractsFragment = { __typename?: 'Query', allVoyageCharters?: { __typename?: 'VoyageChartersConnection', nodes: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null } | null> }, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderByOrderId?: { __typename?: 'Order', id: OrderId, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null } | null> }, shipmentByShipmentId?: { __typename?: 'Shipment', id: ShipmentId, name: string } | null } | null } | null> } } | null> } | null };

export type ContractsPageQueryFragment = { __typename?: 'Query', allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, inactive: boolean, startDate: string, endDate: string, externalId?: string | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> } } | null> } | null };

export type ContractsPage_CoaFragment = { __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, inactive: boolean, startDate: string, endDate: string, externalId?: string | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> } };

export type SyncImosCoasMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncImosCoasMutation = { __typename?: 'Mutation', syncImosCoas: { __typename?: 'SyncImosCoasResult', runUuid: string } };

export type FreightCostsQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type FreightCostsQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId: LocationId, cargoMeasurementsByOrderId: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, locationId?: LocationId | null, measuredVolume?: string | number | null, rejectedVolume?: string | number | null, rejectedWeight?: string | number | null, measuredWeight?: string | number | null, volumeUnit?: VolumeUnits | null, weightUnit?: WeightUnits | null } | null> }, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, assortmentGroup?: AssortmentGroupId | null, name: string } | null, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightUnit?: PaymentUnit | null, freightAmount?: string | number | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, currency?: Currency | null, lumpsum?: string | number | null, externalId?: string | null, name?: string | null, vesselId?: ShipId | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null } | null> } } | null> } | null, allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null> } | null };

export type Costs_MeasurementFragment = { __typename?: 'CargoMeasurement', id: CargoMeasurementId, locationId?: LocationId | null, measuredVolume?: string | number | null, rejectedVolume?: string | number | null, rejectedWeight?: string | number | null, measuredWeight?: string | number | null, volumeUnit?: VolumeUnits | null, weightUnit?: WeightUnits | null };

export type Costs_FreightFragment = { __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightUnit?: PaymentUnit | null, freightAmount?: string | number | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId };

export type VoyageCosts_VoyageCharterFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, currency?: Currency | null, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> } };

export type VoyageCosts_VoyageCharterExtraCostFragment = { __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, name?: string | null, type?: VoyageCharterCostType | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', myMail?: string | null, currentUserIsSystemAdmin?: boolean | null, currentUser?: { __typename?: 'User', id: UserId, name?: string | null, nickname?: string | null, email?: string | null, userType: UserType, initials?: string | null, organizationId: OrganizationId, isVerified?: boolean | null, isActivated?: boolean | null, isAdmin?: boolean | null, monitoringOnly?: boolean | null, organization?: { __typename?: 'Organization', id: OrganizationId, name?: string | null, charterer: boolean, configEnableDefaultLaycan: boolean, configCargoAllocationCombineAssortment: boolean, configDisablePcUpdates: boolean, configUseMasterPorts: boolean, configIgnoreIntegrationCargoMargins: boolean, configEnableWorldscaleFreights: boolean, portAgent: boolean, shipOwner: boolean, defaultCurrency?: Currency | null, parentOrganizationId?: OrganizationId | null, defaultFillFactor?: string | number | null, organizationFeaturesByOrganizationId: { __typename?: 'OrganizationFeaturesConnection', nodes: Array<{ __typename?: 'OrganizationFeature', id: OrganizationFeatureId, organizationId: OrganizationId, featureName: FeatureFeatureNameString, isEnabled?: boolean | null } | null> }, organizationAreaBunkerGradeMappingsByOrganizationId: { __typename?: 'OrganizationAreaBunkerGradeMappingsConnection', nodes: Array<{ __typename?: 'OrganizationAreaBunkerGradeMapping', organizationId: OrganizationId, bunkerGradeId: BunkerGradeOverrideId, vesselArea: VesselArea } | null> }, bunkerGradeCalculationsByOrganizationId: { __typename?: 'BunkerGradeCalculationsConnection', nodes: Array<{ __typename?: 'BunkerGradeCalculation', id: BunkerGradeCalculationId, fromGradeId: BunkerGradeOverrideId, toGradeId: BunkerGradeOverrideId, bunkerGradeOverrideByFromGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string, price?: string | number | null, carbonFactor?: string | number | null } | null, bunkerGradeOverrideByToGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, gradeName: string, price?: string | number | null, carbonFactor?: string | number | null } | null } | null> }, portCommodityLdRatesByOrganizationId: { __typename?: 'PortCommodityLdRatesConnection', nodes: Array<{ __typename?: 'PortCommodityLdRate', id: PortCommodityLdRateIdString, organizationId: OrganizationId, portId?: LocationId | null, zoneId?: ZoneId | null, loadingRate: string | number, loadingUnit: LoadingUnit, dischargeRate: string | number, dischargeUnit: LoadingUnit, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null } | null> } } | null, rootOrganization?: { __typename?: 'Organization', id: OrganizationId, defaultCurrency?: Currency | null, configAutoAcceptUpdates: boolean, configAutoSyncUserScenarios: boolean, configAutoAcceptOnlyConfirmed: boolean, configIncludeFuelEuInCosts: boolean, configUseCalculatedLimit: boolean, configReducedUnits: boolean, euEtsCosts: boolean, draft?: string | number | null, portCostPriority?: string | null } | null, userRights: { __typename?: 'UserRightsConnection', nodes: Array<{ __typename?: 'UserRight', accessFinancialData: boolean, createAndEditContracts: boolean, createAndEditOrders: boolean, createAndEditVoyages: boolean, createAndEditPortCalls: boolean, createAndEditCargoMeasurement: boolean, accessCargoMeasurement: boolean, createAndEditBillOfLading: boolean, accessBillOfLading: boolean, orgAdmin: boolean, id: UserRightId, userId: UserId, organizationId: OrganizationId, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, descendants?: Array<number | null> | null } | null } | null> }, userSettingsByUserId: { __typename?: 'UserSettingsConnection', nodes: Array<{ __typename?: 'UserSetting', id: UserSettingId, userId: UserId, formSettings?: string | null, notificationAllOrders?: { __typename?: 'NotificationSetting', ordersUpsertedViaIntegration?: boolean | null } | null, notificationYourOrders?: { __typename?: 'NotificationSetting', ordersUpsertedViaIntegration?: boolean | null } | null } | null> } } | null };

export type EditCoaModalQueryVariables = Exact<{
  coaId: Scalars['Int']['input'];
}>;


export type EditCoaModalQuery = { __typename?: 'Query', coaContractById?: { __typename?: 'CoaContract', id: CoaContractId, name?: string | null, externalId?: string | null, amountUnitId?: CargoUnitId | null, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, shipownerOrgId: OrganizationId, chartererOrgId: OrganizationId, currency?: Currency | null, paymentDays?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, useHighestFreightRate: boolean, bunkers: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, coaContractId: CoaContractId, bunkerGrade: BunkerGrade, price: string | number, basePriceMax?: string | number | null, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, bafType?: BafTypes | null, bafStepSize?: string | number | null, bafStepEffect?: string | number | null, bafStartFromBase?: boolean | null, bafUseStepEffectAsValue?: boolean | null, bafBunkerAmount?: string | number | null } | null> }, portPairs: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, chartererId: UserId, originId?: LocationId | null, destinationId?: LocationId | null, originZoneId?: ZoneId | null, destinationZoneId?: ZoneId | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null, locode?: string | null, timezone?: string | null } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null } | null> }, portData: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, coaContractId: CoaContractId, portDataId: PortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null> }, coaAssortments: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, coaContractId: CoaContractId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> }, prices: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaContractId: CoaContractId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, shipId?: ShipId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> }, vessels: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, demurrage?: string | number | null, shipId: ShipId, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> }, commissions: { __typename?: 'CoaContractCommissionsConnection', nodes: Array<{ __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> }, portCosts: { __typename?: 'CoaContractPortCostsConnection', nodes: Array<{ __typename?: 'CoaContractPortCost', id: CoaContractPortCostId, locationId: LocationId, coaContractId: CoaContractId, shipId?: ShipId | null, cost: string | number, vesselTypeId?: VesselAttributeId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null> }, deviationCosts: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null, zoneByFromZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, zoneByToZoneId?: { __typename?: 'Zone', id: ZoneId, name: string } | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null> }, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type EditOrderModalQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type EditOrderModalQuery = { __typename?: 'Query', orderById?: { __typename?: 'Order', id: OrderId, organizationId: OrganizationId, coaId?: CoaContractId | null, chartererOrganizationId?: OrganizationId | null, assortmentId?: AssortmentId | null, cargoAmount: string | number, cargoUnitId?: CargoUnitId | null, externalOrderId?: string | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, rta?: string | null, layday?: string | null, cancelling?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, nominatedVessel?: string | null, shipmentId?: ShipmentId | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, loadExternallyPlanned?: boolean | null, dischargeExternallyPlanned?: boolean | null, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, outgoing: boolean, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, layday?: string | null, cancelling?: string | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null } | null, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null } | null> }, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, orderId: OrderId, assortmentGroup?: AssortmentGroupId | null, distance?: string | number | null, voyages?: number | null, tanks?: number | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, marginUnit?: MarginUnit | null, marginAmount?: string | number | null, imoClass?: ImoClass | null, cargoType?: CargoType | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, cargoUnitId?: CargoUnitId | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null }, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> } } | null };

export type EditOrderModal_QueryFragment = { __typename?: 'Query', orderById?: { __typename?: 'Order', id: OrderId, organizationId: OrganizationId, coaId?: CoaContractId | null, chartererOrganizationId?: OrganizationId | null, assortmentId?: AssortmentId | null, cargoAmount: string | number, cargoUnitId?: CargoUnitId | null, externalOrderId?: string | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, rta?: string | null, layday?: string | null, cancelling?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, nominatedVessel?: string | null, shipmentId?: ShipmentId | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, loadExternallyPlanned?: boolean | null, dischargeExternallyPlanned?: boolean | null, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, outgoing: boolean, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, layday?: string | null, cancelling?: string | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null } | null, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null } | null> }, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, orderId: OrderId, assortmentGroup?: AssortmentGroupId | null, distance?: string | number | null, voyages?: number | null, tanks?: number | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, marginUnit?: MarginUnit | null, marginAmount?: string | number | null, imoClass?: ImoClass | null, cargoType?: CargoType | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, cargoUnitId?: CargoUnitId | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null }, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> } } | null };

export type DuplicateOrdersModalQueryVariables = Exact<{
  orderIds: Array<Scalars['Int']['input']>;
}>;


export type DuplicateOrdersModalQuery = { __typename?: 'Query', allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, organizationId: OrganizationId, coaId?: CoaContractId | null, chartererOrganizationId?: OrganizationId | null, assortmentId?: AssortmentId | null, cargoAmount: string | number, cargoUnitId?: CargoUnitId | null, externalOrderId?: string | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, rta?: string | null, layday?: string | null, cancelling?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, nominatedVessel?: string | null, shipmentId?: ShipmentId | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, loadExternallyPlanned?: boolean | null, dischargeExternallyPlanned?: boolean | null, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, outgoing: boolean, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, layday?: string | null, cancelling?: string | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null } | null, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null } | null> }, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, orderId: OrderId, assortmentGroup?: AssortmentGroupId | null, distance?: string | number | null, voyages?: number | null, tanks?: number | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, marginUnit?: MarginUnit | null, marginAmount?: string | number | null, imoClass?: ImoClass | null, cargoType?: CargoType | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, cargoUnitId?: CargoUnitId | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null }, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> } } | null> } | null };

export type EditSpotModalQueryVariables = Exact<{
  spotId: Scalars['Int']['input'];
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditSpotModalQuery = { __typename?: 'Query', voyageCharterById?: { __typename?: 'VoyageCharter', id: VoyageCharterId, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, lumpsum?: string | number | null, name?: string | null, externalId?: string | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, portDataRelations: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> } } | null };

export type OrderToEmailQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type OrderToEmailQuery = { __typename?: 'Query', allEmailToOrderLogs?: { __typename?: 'EmailToOrderLogsConnection', nodes: Array<{ __typename?: 'EmailToOrderLog', id: EmailToOrderLogId, createdAt: string, mailSubject: string, mailText: string, mailHtml: string, parsed?: string | null, error?: string | null } | null> } | null };

export type FetchOrderAssignmentByClientIdQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
}>;


export type FetchOrderAssignmentByClientIdQuery = { __typename?: 'Query', allScheduledOrders?: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId } | null> } | null, allHandledByCoas?: { __typename?: 'HandledByCoasConnection', nodes: Array<{ __typename?: 'HandledByCoa', id: HandledByCoaId } | null> } | null, allHandledBySpots?: { __typename?: 'HandledBySpotsConnection', nodes: Array<{ __typename?: 'HandledBySpot', id: HandledBySpotId } | null> } | null };

export type FormSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FormSettingsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: UserId, userSettingsByUserId: { __typename?: 'UserSettingsConnection', nodes: Array<{ __typename?: 'UserSetting', id: UserSettingId, formSettings?: string | null } | null> } } | null };

export type UpdateFormSettingsMutationVariables = Exact<{
  id: Scalars['UserSettingId']['input'];
  formSettings?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateFormSettingsMutation = { __typename?: 'Mutation', updateUserSettingById?: { __typename?: 'UpdateUserSettingPayload', userSetting?: { __typename?: 'UserSetting', id: UserSettingId, formSettings?: string | null } | null } | null };

export type GetClusterRoutesQueryVariables = Exact<{
  inputs: Array<RoutesByClusterPairsInput>;
}>;


export type GetClusterRoutesQuery = { __typename?: 'Query', routesByClusterPairs?: Array<{ __typename?: 'ClusterRoute', fromClusterId: number, toClusterId: number, exact?: string | null, draft?: string | number | null, avoidsChannels?: boolean | null } | null> | null };

export type GetCachedExactClusterRoutesQueryVariables = Exact<{
  inputs: Array<RoutesByClusterPairsInput>;
}>;


export type GetCachedExactClusterRoutesQuery = { __typename?: 'Query', cachedExactRoutesByClusterPairs?: Array<{ __typename?: 'ClusterRoute', fromClusterId: number, toClusterId: number, exact?: string | null, draft?: string | number | null, avoidsChannels?: boolean | null } | null> | null };

export type GetClusterRouteQueryVariables = Exact<{
  fromClusterId: Scalars['Int']['input'];
  toClusterId: Scalars['Int']['input'];
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  avoidsChannels: Scalars['Boolean']['input'];
  noGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
}>;


export type GetClusterRouteQuery = { __typename?: 'Query', routeByClusterPair?: string | null };

export type GetRouteOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRouteOverridesQuery = { __typename?: 'Query', allRouteOverrides?: { __typename?: 'RouteOverridesConnection', nodes: Array<{ __typename?: 'RouteOverride', id: RouteOverrideId, organisationId?: OrganizationId | null, fromId: LocationId, toId: LocationId, distance?: string | number | null, time?: string | number | null, vesselId?: ShipId | null, userId?: UserId | null, avoidsChannels: boolean } | null> } | null };

export type VoyageIncomeQueryVariables = Exact<{ [key: string]: never; }>;


export type VoyageIncomeQuery = { __typename?: 'Query', allVoyageCharters?: { __typename?: 'VoyageChartersConnection', nodes: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId, currency?: Currency | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, name?: string | null, type?: FreightType | null, description?: string | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, assortmentId?: AssortmentId | null, bafApplied?: boolean | null, dischargePortId?: LocationId | null, extraFreightApplied?: boolean | null, loadPortId?: LocationId | null, type: CommissionType, value: string | number, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null> } | null };

export type VoyageIncomeQuery_VoyageCharterFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, currency?: Currency | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, name?: string | null, type?: FreightType | null, description?: string | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, assortmentId?: AssortmentId | null, bafApplied?: boolean | null, dischargePortId?: LocationId | null, extraFreightApplied?: boolean | null, loadPortId?: LocationId | null, type: CommissionType, value: string | number, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } };

export type VoyageIncome_VoyageCharterOrderFreightFragment = { __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightUnit?: PaymentUnit | null, freightAmount?: string | number | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId };

export type VoyageIncome_OrderVoyageCharterRelationFragment = { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, coaRouteId?: CoaContractPortId | null, outgoing: boolean, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightUnit?: PaymentUnit | null, freightAmount?: string | number | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> } };

export type VoyageIncome_VoyageCharterExtraFreightFragment = { __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, name?: string | null, type?: FreightType | null, description?: string | null, ignoreInPnl?: boolean | null };

export type VoyageIncome_VoyageCharterToContractFragment = { __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, price: string | number, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit, minAmount?: string | number | null, maxAmount?: string | number | null } | null> } } | null };

export type VoyageIncome_CoaFragment = { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, price: string | number, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit, minAmount?: string | number | null, maxAmount?: string | number | null } | null> } };

export type VoyageIncome_VoyageCharterFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, currency?: Currency | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, name?: string | null, type?: FreightType | null, description?: string | null, ignoreInPnl?: boolean | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, assortmentId?: AssortmentId | null, bafApplied?: boolean | null, dischargePortId?: LocationId | null, extraFreightApplied?: boolean | null, loadPortId?: LocationId | null, type: CommissionType, value: string | number, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } };

export type IncomingEntryFragment = { __typename: 'VwSapOrdersIntegration', externalId?: string | null, integrationCode?: string | null, lastUpdated?: string | null, materialId?: string | null, message?: string | null, nominationKey?: string | null, orderId?: number | null, pegId?: string | null, sapCreatedAt?: string | null, sapSourceEnv?: string | null, sapUpdatedAt?: string | null, status?: StatusType | null, vesselName?: string | null, material?: string | null, quantity?: string | null, unit?: string | null, ports?: string | null };

export type IncomingQueryVariables = Exact<{ [key: string]: never; }>;


export type IncomingQuery = { __typename?: 'Query', allVwSapOrdersIntegrations?: { __typename?: 'VwSapOrdersIntegrationsConnection', nodes: Array<{ __typename: 'VwSapOrdersIntegration', externalId?: string | null, integrationCode?: string | null, lastUpdated?: string | null, materialId?: string | null, message?: string | null, nominationKey?: string | null, orderId?: number | null, pegId?: string | null, sapCreatedAt?: string | null, sapSourceEnv?: string | null, sapUpdatedAt?: string | null, status?: StatusType | null, vesselName?: string | null, material?: string | null, quantity?: string | null, unit?: string | null, ports?: string | null } | null> } | null };

export type IntegrationLogEntryFragment = { __typename?: 'IntegrationLog', id: IntegrationLogId, organizationId?: OrganizationId | null, runtimeUuid?: string | null, message?: string | null, createdAt: string, severity: IntegrationLogsSeverityType, cargoId?: string | null };

export type LatestIntegrationLogQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestIntegrationLogQuery = { __typename?: 'Query', allIntegrationLogs?: { __typename?: 'IntegrationLogsConnection', nodes: Array<{ __typename?: 'IntegrationLog', id: IntegrationLogId, organizationId?: OrganizationId | null, runtimeUuid?: string | null, message?: string | null, createdAt: string, severity: IntegrationLogsSeverityType, cargoId?: string | null } | null> } | null };

export type AllIntegrationLogsQueryVariables = Exact<{
  runtime_uuid?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AllIntegrationLogsQuery = { __typename?: 'Query', allIntegrationLogs?: { __typename?: 'IntegrationLogsConnection', nodes: Array<{ __typename?: 'IntegrationLog', id: IntegrationLogId, organizationId?: OrganizationId | null, runtimeUuid?: string | null, message?: string | null, createdAt: string, severity: IntegrationLogsSeverityType, cargoId?: string | null } | null> } | null };

export type RaptorDraftQueryVariables = Exact<{
  imo: Scalars['Int']['input'];
  loadedMass: Scalars['Float']['input'];
}>;


export type RaptorDraftQuery = { __typename?: 'Query', getRaptorDraft?: { __typename?: 'RaptorDraft', fit?: number | null, lwr?: number | null, upr?: number | null } | null };

export type NotificationSettingsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type NotificationSettingsQuery = { __typename?: 'Query', allUserSettings?: { __typename?: 'UserSettingsConnection', nodes: Array<{ __typename?: 'UserSetting', id: UserSettingId, userId: UserId, notificationAllOrders?: { __typename?: 'NotificationSetting', dischargeDocumentUploaded?: boolean | null, orderVesselChanged?: boolean | null, orderPublishedUnassignedShipment?: boolean | null, orderPublishedShippingPlan?: boolean | null, orderPublishedEdited?: boolean | null, loadSofSaved?: boolean | null, loadNorSaved?: boolean | null, loadEtdChanged?: boolean | null, loadEtbChanged?: boolean | null, loadEtaChanged?: boolean | null, loadDocumentUploaded?: boolean | null, loadBlSaved?: boolean | null, dischargeSofSaved?: boolean | null, dischargeNorSaved?: boolean | null, dischargeMrSaved?: boolean | null, dischargeEtd?: boolean | null, dischargeEtb?: boolean | null, dischargeEta?: boolean | null, ordersUpsertedViaIntegration?: boolean | null } | null, notificationYourOrders?: { __typename?: 'NotificationSetting', dischargeDocumentUploaded?: boolean | null, orderVesselChanged?: boolean | null, orderPublishedUnassignedShipment?: boolean | null, orderPublishedShippingPlan?: boolean | null, orderPublishedEdited?: boolean | null, loadSofSaved?: boolean | null, loadNorSaved?: boolean | null, loadEtdChanged?: boolean | null, loadEtaChanged?: boolean | null, loadEtbChanged?: boolean | null, loadBlSaved?: boolean | null, loadDocumentUploaded?: boolean | null, dischargeNorSaved?: boolean | null, dischargeSofSaved?: boolean | null, dischargeMrSaved?: boolean | null, dischargeEtd?: boolean | null, dischargeEtb?: boolean | null, dischargeEta?: boolean | null, ordersUpsertedViaIntegration?: boolean | null } | null } | null> } | null };

export type NotificationSettingsFragment = { __typename?: 'UserSetting', id: UserSettingId, notificationAllOrders?: { __typename?: 'NotificationSetting', dischargeDocumentUploaded?: boolean | null, orderVesselChanged?: boolean | null, orderPublishedUnassignedShipment?: boolean | null, orderPublishedShippingPlan?: boolean | null, orderPublishedEdited?: boolean | null, loadSofSaved?: boolean | null, loadNorSaved?: boolean | null, loadEtdChanged?: boolean | null, loadEtbChanged?: boolean | null, loadEtaChanged?: boolean | null, loadDocumentUploaded?: boolean | null, loadBlSaved?: boolean | null, dischargeSofSaved?: boolean | null, dischargeNorSaved?: boolean | null, dischargeMrSaved?: boolean | null, dischargeEtd?: boolean | null, dischargeEtb?: boolean | null, dischargeEta?: boolean | null, ordersUpsertedViaIntegration?: boolean | null } | null, notificationYourOrders?: { __typename?: 'NotificationSetting', dischargeDocumentUploaded?: boolean | null, orderVesselChanged?: boolean | null, orderPublishedUnassignedShipment?: boolean | null, orderPublishedShippingPlan?: boolean | null, orderPublishedEdited?: boolean | null, loadSofSaved?: boolean | null, loadNorSaved?: boolean | null, loadEtdChanged?: boolean | null, loadEtaChanged?: boolean | null, loadEtbChanged?: boolean | null, loadBlSaved?: boolean | null, loadDocumentUploaded?: boolean | null, dischargeNorSaved?: boolean | null, dischargeSofSaved?: boolean | null, dischargeMrSaved?: boolean | null, dischargeEtd?: boolean | null, dischargeEtb?: boolean | null, dischargeEta?: boolean | null, ordersUpsertedViaIntegration?: boolean | null } | null };

export type OpenPositionsFragment = { __typename?: 'OpenPosition', id: OpenPositionId, vesselId: ShipId, startTime: string, startPortId: LocationId, directionId?: LocationId | null, remark?: string | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByDirectionId?: { __typename?: 'Location', id: LocationId, name: string } | null };

export type OpenPositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenPositionsQuery = { __typename?: 'Query', allOpenPositions?: { __typename?: 'OpenPositionsConnection', nodes: Array<{ __typename?: 'OpenPosition', id: OpenPositionId, vesselId: ShipId, startTime: string, startPortId: LocationId, directionId?: LocationId | null, remark?: string | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByDirectionId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null> } | null };

export type OrderFormQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderFormQuery = { __typename?: 'Query', allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, marginUnit?: MarginUnit | null, marginAmount?: string | number | null, imoClass?: ImoClass | null, cargoType?: CargoType | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, cargoUnitId?: CargoUnitId | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null> } | null, allAssortmentGroups?: { __typename?: 'AssortmentGroupsConnection', nodes: Array<{ __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, assortmentExclusionsByNextAssortmentGroup: { __typename?: 'AssortmentExclusionsConnection', nodes: Array<{ __typename?: 'AssortmentExclusion', id: AssortmentExclusionId, voyages?: number | null, previousAssortmentGroup?: AssortmentGroupId | null, nextAssortmentGroup?: AssortmentGroupId | null } | null> } } | null> } | null, allCargoUnits?: { __typename?: 'CargoUnitsConnection', nodes: Array<{ __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, charterer: boolean, receiver: boolean, sender: boolean, parentOrganizationId?: OrganizationId | null, configEnableDefaultLaycan: boolean } | null> } | null, allSpecialRequirements?: { __typename?: 'SpecialRequirementsConnection', nodes: Array<{ __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null, organizationId?: OrganizationId | null } | null> } | null, allOrderAttributes?: { __typename?: 'OrderAttributesConnection', nodes: Array<{ __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId } | null> } | null, allLocationRequirementAssociations?: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> } | null, allSupplyContracts?: { __typename?: 'SupplyContractsConnection', nodes: Array<{ __typename?: 'SupplyContract', id: SupplyContractId, organizationId?: OrganizationId | null, supplyContract?: string | null, supplier?: string | null, batchCode?: string | null, year?: number | null, batchSeq?: number | null } | null> } | null };

export type ApiOrdersNoticeFragment = { __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string };

export type LocationByPortIdFragment = { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null };

export type OrderForm_QueryFragment = { __typename?: 'Query', allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, marginUnit?: MarginUnit | null, marginAmount?: string | number | null, imoClass?: ImoClass | null, cargoType?: CargoType | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, cargoUnitId?: CargoUnitId | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null> } | null, allAssortmentGroups?: { __typename?: 'AssortmentGroupsConnection', nodes: Array<{ __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, assortmentExclusionsByNextAssortmentGroup: { __typename?: 'AssortmentExclusionsConnection', nodes: Array<{ __typename?: 'AssortmentExclusion', id: AssortmentExclusionId, voyages?: number | null, previousAssortmentGroup?: AssortmentGroupId | null, nextAssortmentGroup?: AssortmentGroupId | null } | null> } } | null> } | null, allCargoUnits?: { __typename?: 'CargoUnitsConnection', nodes: Array<{ __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, charterer: boolean, receiver: boolean, sender: boolean, parentOrganizationId?: OrganizationId | null, configEnableDefaultLaycan: boolean } | null> } | null, allSpecialRequirements?: { __typename?: 'SpecialRequirementsConnection', nodes: Array<{ __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null, organizationId?: OrganizationId | null } | null> } | null, allOrderAttributes?: { __typename?: 'OrderAttributesConnection', nodes: Array<{ __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId } | null> } | null, allLocationRequirementAssociations?: { __typename?: 'LocationRequirementAssociationsConnection', nodes: Array<{ __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> } | null, allSupplyContracts?: { __typename?: 'SupplyContractsConnection', nodes: Array<{ __typename?: 'SupplyContract', id: SupplyContractId, organizationId?: OrganizationId | null, supplyContract?: string | null, supplier?: string | null, batchCode?: string | null, year?: number | null, batchSeq?: number | null } | null> } | null };

export type OrderForm_VoyageCharterFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, layday?: string | null, cancelling?: string | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } };

export type OrderForm_PortDatumFragment = { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null };

export type OrderForm_AssortmentFragment = { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, marginUnit?: MarginUnit | null, marginAmount?: string | number | null, imoClass?: ImoClass | null, cargoType?: CargoType | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, cargoUnitId?: CargoUnitId | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null };

export type OrderForm_AssortmentGroupFragment = { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, assortmentExclusionsByNextAssortmentGroup: { __typename?: 'AssortmentExclusionsConnection', nodes: Array<{ __typename?: 'AssortmentExclusion', id: AssortmentExclusionId, voyages?: number | null, previousAssortmentGroup?: AssortmentGroupId | null, nextAssortmentGroup?: AssortmentGroupId | null } | null> } };

export type OrderForm_CargoUnitFragment = { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null };

export type OrderForm_OrganizationFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null, charterer: boolean, receiver: boolean, sender: boolean, parentOrganizationId?: OrganizationId | null, configEnableDefaultLaycan: boolean };

export type OrderForm_SpecialRequirementFragment = { __typename?: 'SpecialRequirement', id: SpecialRequirementId, name?: string | null, organizationId?: OrganizationId | null };

export type OrderForm_LocationRequirementAssociationFragment = { __typename?: 'LocationRequirementAssociation', id: LocationRequirementAssociationId, specialRequirementId: SpecialRequirementId, locationId?: LocationId | null, zoneId?: ZoneId | null, zoneByZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null };

export type OrderForm_OrderAttributeFragment = { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId };

export type OrderForm_OrderAttributeAssociationFragment = { __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId };

export type OrderForm_SupplyContractFragment = { __typename?: 'SupplyContract', id: SupplyContractId, organizationId?: OrganizationId | null, supplyContract?: string | null, supplier?: string | null, batchCode?: string | null, year?: number | null, batchSeq?: number | null };

export type OrderForm_OrderFragment = { __typename?: 'Order', id: OrderId, organizationId: OrganizationId, coaId?: CoaContractId | null, chartererOrganizationId?: OrganizationId | null, assortmentId?: AssortmentId | null, cargoAmount: string | number, cargoUnitId?: CargoUnitId | null, externalOrderId?: string | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, rta?: string | null, layday?: string | null, cancelling?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, nominatedVessel?: string | null, shipmentId?: ShipmentId | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, loadExternallyPlanned?: boolean | null, dischargeExternallyPlanned?: boolean | null, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, outgoing: boolean, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, layday?: string | null, cancelling?: string | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null } | null } | null> } } | null } | null> }, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, latitude?: string | number | null, longitude?: string | number | null, timezone?: string | null } | null, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null } | null> }, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, orderId: OrderId, assortmentGroup?: AssortmentGroupId | null, distance?: string | number | null, voyages?: number | null, tanks?: number | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, specificGravity?: string | number | null, marginUnit?: MarginUnit | null, marginAmount?: string | number | null, imoClass?: ImoClass | null, cargoType?: CargoType | null, loadingUnit?: LoadingUnit | null, dischargingUnit?: LoadingUnit | null, loadingRate?: string | number | null, dischargingRate?: string | number | null, cargoUnitId?: CargoUnitId | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, sysPeriod: { __typename?: 'DatetimeRange', end?: { __typename?: 'DatetimeRangeBound', value: string } | null, start?: { __typename?: 'DatetimeRangeBound', value: string } | null }, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> } };

export type OrderHistoriesByIdQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['OrderId']['input']>;
}>;


export type OrderHistoriesByIdQuery = { __typename?: 'Query', allOrdersHistories?: { __typename?: 'OrdersHistoriesConnection', nodes: Array<{ __typename?: 'OrdersHistory', id: OrderId, started?: string | null, completed?: string | null, archived: boolean, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, externalOrderId?: string | null, nominatedVessel?: string | null, chartererOrganizationId?: number | null, cargoAmount: string | number, shipmentId?: number | null, userId?: number | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, latitude?: string | number | null, longitude?: string | number | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, latitude?: string | number | null, longitude?: string | number | null } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, orderById?: { __typename?: 'Order', id: OrderId, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null } | null> } } | null, sysPeriod: { __typename?: 'DatetimeRange', start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> } | null };

export type OrdersHistory_OrderFragment = { __typename?: 'OrdersHistory', id: OrderId, started?: string | null, completed?: string | null, archived: boolean, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, externalOrderId?: string | null, nominatedVessel?: string | null, chartererOrganizationId?: number | null, cargoAmount: string | number, shipmentId?: number | null, userId?: number | null, userByModifiedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, latitude?: string | number | null, longitude?: string | number | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, latitude?: string | number | null, longitude?: string | number | null } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, orderById?: { __typename?: 'Order', id: OrderId, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null } | null> } } | null, sysPeriod: { __typename?: 'DatetimeRange', start?: { __typename?: 'DatetimeRangeBound', value: string } | null } };

export type OrderTable_Order_DetailsFragment = { __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null };

export type OrderTable_Order_AssortmentFragment = { __typename?: 'Assortment', id: AssortmentId, name: string };

export type OrderTable_Order_CargoUnitFragment = { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null };

export type OrderTable_OrderLocationFragment = { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, latitude?: string | number | null, longitude?: string | number | null };

export type OrderVoyageCharterQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrderVoyageCharterQuery = { __typename?: 'Query', allOrderVoyageCharterRelations?: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, isInquiry: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, lumpsum?: string | number | null, name?: string | null, externalId?: string | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', coaId?: CoaContractId | null, id: VoyageCharterToContractId } | null> }, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, portDataRelations: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> } } | null } | null> } | null };

export type OrdersPageQueryVariables = Exact<{
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrdersPageQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, shipmentByShipmentId?: { __typename?: 'Shipment', id: ShipmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, orderDetails: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null, extraInfo?: string | null, receiverOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, senderOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, billOfLading: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, volume?: string | number | null, volumeOnDeck?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightOnDeck?: string | number | null, weightUnit?: WeightUnits | null } | null> }, cargoMeasurement: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, measuredVolume?: string | number | null, measuredWeight?: string | number | null, volumeUnit?: VolumeUnits | null, weightUnit?: WeightUnits | null } | null> }, chartererOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpot?: { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, handledByCoa?: { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, scheduledOrder: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> }, portCallRelations: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, isLoadPort: boolean, portCall?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, sailingTime?: string | null, arrivalTime?: string | null, portCallId: PortCallId, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, eta?: string | null, etdBerth?: string | null, ataPbp?: string | null, portCallId: PortCallId, berthingProspects?: string | null, ataBerth?: string | null, norTendered?: string | null } | null> }, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null } | null> }, orderAtributeAssociations: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderAttribute?: { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string } | null } | null> }, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', coaId?: CoaContractId | null, id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, name?: string | null } | null } | null> } } | null } | null> } } | null> } | null };

export type ReportingTableFragment = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, shipmentByShipmentId?: { __typename?: 'Shipment', id: ShipmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, orderDetails: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null, extraInfo?: string | null, receiverOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, senderOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, billOfLading: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, volume?: string | number | null, volumeOnDeck?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightOnDeck?: string | number | null, weightUnit?: WeightUnits | null } | null> }, cargoMeasurement: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, measuredVolume?: string | number | null, measuredWeight?: string | number | null, volumeUnit?: VolumeUnits | null, weightUnit?: WeightUnits | null } | null> }, chartererOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpot?: { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, handledByCoa?: { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, scheduledOrder: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> }, portCallRelations: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, isLoadPort: boolean, portCall?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, sailingTime?: string | null, arrivalTime?: string | null, portCallId: PortCallId, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, eta?: string | null, etdBerth?: string | null, ataPbp?: string | null, portCallId: PortCallId, berthingProspects?: string | null, ataBerth?: string | null, norTendered?: string | null } | null> }, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null } | null> }, orderAtributeAssociations: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderAttribute?: { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string } | null } | null> }, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', coaId?: CoaContractId | null, id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, name?: string | null } | null } | null> } } | null } | null> } } | null> } | null };

export type ReportingTable_OrderFragment = { __typename?: 'Order', id: OrderId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, shipmentByShipmentId?: { __typename?: 'Shipment', id: ShipmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, orderDetails: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null, extraInfo?: string | null, receiverOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, senderOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, billOfLading: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, volume?: string | number | null, volumeOnDeck?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightOnDeck?: string | number | null, weightUnit?: WeightUnits | null } | null> }, cargoMeasurement: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, measuredVolume?: string | number | null, measuredWeight?: string | number | null, volumeUnit?: VolumeUnits | null, weightUnit?: WeightUnits | null } | null> }, chartererOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpot?: { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, handledByCoa?: { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null, scheduledOrder: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> }, portCallRelations: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, isLoadPort: boolean, portCall?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, sailingTime?: string | null, arrivalTime?: string | null, portCallId: PortCallId, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, eta?: string | null, etdBerth?: string | null, ataPbp?: string | null, portCallId: PortCallId, berthingProspects?: string | null, ataBerth?: string | null, norTendered?: string | null } | null> }, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null } | null> }, orderAtributeAssociations: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderAttribute?: { __typename?: 'OrderAttribute', id: OrderAttributeId, name: string } | null } | null> }, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', coaId?: CoaContractId | null, id: VoyageCharterToContractId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, name?: string | null } | null } | null> } } | null } | null> } };

export type ReportingTable_OrderDetailsFragment = { __typename?: 'OrderDetail', id: OrderDetailId, orderName?: string | null, extraInfo?: string | null, receiverOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, senderOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type ReportingTable_AssortmentFragment = { __typename?: 'Assortment', id: AssortmentId, name: string };

export type ReportingTable_CargoUnitFragment = { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null };

export type ReportingTable_LocationFragment = { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null };

export type ReportingTable_OrganizationFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null };

export type ReportingTable_BillOfLadingDatumFragment = { __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, volume?: string | number | null, volumeOnDeck?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightOnDeck?: string | number | null, weightUnit?: WeightUnits | null };

export type ReportingTable_CargoMeasurementFragment = { __typename?: 'CargoMeasurement', id: CargoMeasurementId, measuredVolume?: string | number | null, measuredWeight?: string | number | null, volumeUnit?: VolumeUnits | null, weightUnit?: WeightUnits | null };

export type ReportingTable_HandledBySpotFragment = { __typename?: 'HandledBySpot', id: HandledBySpotId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type ReportingTable_HandledByCoaFragment = { __typename?: 'HandledByCoa', id: HandledByCoaId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type ReportingTable_ScheduledOrderFragment = { __typename?: 'ScheduledOrder', id: ScheduledOrderId, shared: boolean, vessel?: { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type ReportingTable_VesselFragment = { __typename?: 'Ship', id: ShipId, name?: string | null, imo?: string | number | null, ownerOrg?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type ReportingTable_PortCallFragment = { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, sailingTime?: string | null, arrivalTime?: string | null, portCallId: PortCallId, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, eta?: string | null, etdBerth?: string | null, ataPbp?: string | null, portCallId: PortCallId, berthingProspects?: string | null, ataBerth?: string | null, norTendered?: string | null } | null> }, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null };

export type ReportingTable_SofFragment = { __typename?: 'StatementOfFact', id: StatementOfFactId, sailingTime?: string | null, arrivalTime?: string | null };

export type ReportingTable_PortNoticeFragment = { __typename?: 'PortNotice', id: PortNoticeId, eta?: string | null, etdBerth?: string | null, ataPbp?: string | null };

export type PlanningPageQueryVariables = Exact<{
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PlanningPageQuery = { __typename?: 'Query', allZones?: { __typename?: 'ZonesConnection', nodes: Array<{ __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null> } | null, allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId } | null } | null> } | null, lastCommit?: { __typename?: 'CommitLogsConnection', nodes: Array<{ __typename?: 'CommitLog', id: CommitLogId, committedAt: string, committedBy?: UserId | null, scenarioClientId?: string | null, masterClientId?: string | null, userByCommittedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, commitLogScenarioByMasterClientId?: { __typename?: 'CommitLogScenario', id: CommitLogScenarioId, clientId: string } | null } | null> } | null, allShips?: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null> } | null, allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null> } | null, allScheduledOrders?: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> } | null, allHandledBySpots?: { __typename?: 'HandledBySpotsConnection', nodes: Array<{ __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null> } | null, allSingleEvents?: { __typename?: 'SingleEventsConnection', nodes: Array<{ __typename?: 'SingleEvent', id: SingleEventId, duration: string | number, end: string, locationId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, vesselId?: ShipId | null, type: EventType, concurrent: boolean, startOverride?: string | null, seaDurationOverride?: string | number | null, clientId: string, updatedAt?: string | null, archived: boolean, cleaningAssortmentExclusionId?: AssortmentExclusionId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, singleEventPortCallRelationsBySingleEventId: { __typename?: 'SingleEventPortCallRelationsConnection', nodes: Array<{ __typename?: 'SingleEventPortCallRelation', id: SingleEventPortCallRelationId, portCallId: PortCallId, singleEventId: SingleEventId } | null> } } | null> } | null, allOffHires?: { __typename?: 'OffHiresConnection', nodes: Array<{ __typename?: 'OffHire', id: OffHireId, end: string, locationAId: LocationId, locationBId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, duration: string | number, vesselId?: ShipId | null, type?: OffHireType | null, planningOrganisationId: OrganizationId, userId: UserId, clientId: string, updatedAt?: string | null, archived: boolean, tcOutRate?: string | number | null, commissionPct?: string | number | null, ballastBonus?: string | number | null, ballastBonusCommissionable?: boolean | null, locationByLocationAId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLocationBId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> } | null, allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, inactive: boolean, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, shipowner?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vessels: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, portDataRelations: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaAssortments: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, id: CoaContractAssortmentId } | null> }, ports: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, coaContractId: CoaContractId, originId?: LocationId | null, destinationId?: LocationId | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null> } | null, allHandledByCoas?: { __typename?: 'HandledByCoasConnection', nodes: Array<{ __typename?: 'HandledByCoa', id: HandledByCoaId, coaId: CoaContractId, orderId: OrderId, vesselId?: ShipId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, draft?: string | number | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configEnableScenarioAutoSave: boolean, configCargoAllocationCombineAssortment: boolean, portCostPriority?: string | null, broker: boolean } | null> } | null, allPortCalls?: { __typename?: 'PortCallsConnection', nodes: Array<{ __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portCallFilesByPortCallId: { __typename?: 'PortCallFilesConnection', nodes: Array<{ __typename?: 'PortCallFile', id: PortCallFileId, fileByFileId?: { __typename?: 'File', id: FileId, note?: string | null, type: DocumentType } | null } | null> } } | null> } | null, allShipments?: { __typename?: 'ShipmentsConnection', nodes: Array<{ __typename?: 'Shipment', id: ShipmentId, clientId: string, name: string, remarks?: string | null, externalShipmentId?: string | null, voyageAttributeId?: VoyageAttributeId | null, shipmentExternalStatusesByShipmentId: { __typename?: 'ShipmentExternalStatusesConnection', nodes: Array<{ __typename?: 'ShipmentExternalStatus', id: ShipmentExternalStatusId, status: ShipmentStatus } | null> }, shipmentFreightByShipmentId?: { __typename?: 'ShipmentFreight', id: ShipmentFreightId, clientId: string, shipmentId: ShipmentId, freightAmount: string | number, freightUnit: PaymentUnit } | null, shipmentExtraFreightsByShipmentId: { __typename?: 'ShipmentExtraFreightsConnection', nodes: Array<{ __typename?: 'ShipmentExtraFreight', id: ShipmentExtraFreightId, clientId: string, shipmentId: ShipmentId, name?: string | null, freightAmount: string | number, freightUnit: PaymentUnit, description?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> } } | null> } | null, allPortCostsByPortAndVesselNames?: { __typename?: 'PortCostsByPortAndVesselNamesConnection', nodes: Array<{ __typename?: 'PortCostsByPortAndVesselName', portName?: string | null, vesselName?: string | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null } | null> } | null, allPortCostsByPortAndPrimaryAttributes?: { __typename?: 'PortCostsByPortAndPrimaryAttributesConnection', nodes: Array<{ __typename?: 'PortCostsByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null } | null> } | null, allLatestPortCostByPortAndPrimaryAttributes?: { __typename?: 'LatestPortCostByPortAndPrimaryAttributesConnection', nodes: Array<{ __typename?: 'LatestPortCostByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portCost?: string | number | null, portType?: string | null } | null> } | null, allChannelCostEstimates?: { __typename?: 'ChannelCostEstimatesConnection', nodes: Array<{ __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, vesselTypeId?: VesselAttributeId | null, vesselId?: ShipId | null, channelCost: string | number, channelCostCurrency: string, durationOverhead?: string | number | null, channelName: string, cargoCondition?: ChannelCostCargoCondition | null, assortmentGroupId?: AssortmentGroupId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } | null, allPortCostDefaults?: { __typename?: 'PortCostDefaultsConnection', nodes: Array<{ __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null> } | null };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', allUsers?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: UserId, name?: string | null } | null> } | null };

export type PlanningTcContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlanningTcContractsQuery = { __typename?: 'Query', allShips?: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null> } | null };

export type PortCallUpdatesQueryVariables = Exact<{
  portCallClientIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
}>;


export type PortCallUpdatesQuery = { __typename?: 'Query', allPortCalls?: { __typename?: 'PortCallsConnection', nodes: Array<{ __typename?: 'PortCall', id: PortCallId, clientId: string, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, ataBerth?: string | null, ataPbp?: string | null, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, sysPeriod: { __typename?: 'DatetimeRange', start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, arrivalTime?: string | null, berthed?: string | null, sailingTime?: string | null, sysPeriod: { __typename?: 'DatetimeRange', start?: { __typename?: 'DatetimeRangeBound', value: string } | null } } | null> }, portCallExternalTimestampsByPortCallId: { __typename?: 'PortCallExternalTimestampsConnection', nodes: Array<{ __typename?: 'PortCallExternalTimestamp', id: PortCallExternalTimestampId, sourceName: string, eventType: PortcallExternalTimestampEvent, timestampType: PortcallExternalTimestampType, isConfirmed: boolean, value: string, updatedAt: string, latestValueReceivedAt: string } | null> } } | null> } | null };

export type PortCallExternalTimestampFragment = { __typename?: 'PortCallExternalTimestamp', id: PortCallExternalTimestampId, sourceName: string, eventType: PortcallExternalTimestampEvent, timestampType: PortcallExternalTimestampType, isConfirmed: boolean, value: string, updatedAt: string, latestValueReceivedAt: string };

export type PortCallsDocumentsQueryVariables = Exact<{
  portCallClientIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type PortCallsDocumentsQuery = { __typename?: 'Query', allPortCalls?: { __typename?: 'PortCallsConnection', nodes: Array<{ __typename?: 'PortCall', id: PortCallId, clientId: string, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portCallFilesByPortCallId: { __typename?: 'PortCallFilesConnection', nodes: Array<{ __typename?: 'PortCallFile', id: PortCallFileId, portCallId: PortCallId, fileByFileId?: { __typename?: 'File', id: FileId, note?: string | null, uri: string, type: DocumentType, userByUserId?: { __typename?: 'User', id: UserId, email?: string | null } | null } | null } | null> }, billOfLadingsByPortCallId: { __typename?: 'BillOfLadingsConnection', nodes: Array<{ __typename?: 'BillOfLading', id: BillOfLadingId, portCallId: PortCallId, billOfLadingDataByBillOfLadingId: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null } | null> } } | null> } } | null> } | null, allCargoMeasurements?: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, orderId: OrderId, locationId?: LocationId | null, time: string, measuredWeight?: string | number | null, rejectedWeight?: string | number | null, weightUnit?: WeightUnits | null, measuredVolume?: string | number | null, rejectedVolume?: string | number | null, volumeUnit?: VolumeUnits | null } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allOrderAttributes?: { __typename?: 'OrderAttributesConnection', nodes: Array<{ __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId } | null> } | null };

export type PortCallsDocumentsQueryFragment = { __typename?: 'Query', allPortCalls?: { __typename?: 'PortCallsConnection', nodes: Array<{ __typename?: 'PortCall', id: PortCallId, clientId: string, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portCallFilesByPortCallId: { __typename?: 'PortCallFilesConnection', nodes: Array<{ __typename?: 'PortCallFile', id: PortCallFileId, portCallId: PortCallId, fileByFileId?: { __typename?: 'File', id: FileId, note?: string | null, uri: string, type: DocumentType, userByUserId?: { __typename?: 'User', id: UserId, email?: string | null } | null } | null } | null> }, billOfLadingsByPortCallId: { __typename?: 'BillOfLadingsConnection', nodes: Array<{ __typename?: 'BillOfLading', id: BillOfLadingId, portCallId: PortCallId, billOfLadingDataByBillOfLadingId: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null } | null> } } | null> } } | null> } | null, allCargoMeasurements?: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, orderId: OrderId, locationId?: LocationId | null, time: string, measuredWeight?: string | number | null, rejectedWeight?: string | number | null, weightUnit?: WeightUnits | null, measuredVolume?: string | number | null, rejectedVolume?: string | number | null, volumeUnit?: VolumeUnits | null } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allOrderAttributes?: { __typename?: 'OrderAttributesConnection', nodes: Array<{ __typename?: 'OrderAttribute', id: OrderAttributeId, name: string, description?: string | null, organizationId: OrganizationId } | null> } | null };

export type PortCallsDocuments__PortCallFragment = { __typename?: 'PortCall', id: PortCallId, clientId: string, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portCallFilesByPortCallId: { __typename?: 'PortCallFilesConnection', nodes: Array<{ __typename?: 'PortCallFile', id: PortCallFileId, portCallId: PortCallId, fileByFileId?: { __typename?: 'File', id: FileId, note?: string | null, uri: string, type: DocumentType, userByUserId?: { __typename?: 'User', id: UserId, email?: string | null } | null } | null } | null> }, billOfLadingsByPortCallId: { __typename?: 'BillOfLadingsConnection', nodes: Array<{ __typename?: 'BillOfLading', id: BillOfLadingId, portCallId: PortCallId, billOfLadingDataByBillOfLadingId: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null } | null> } } | null> } };

export type PortCallsDocuments__PortCallFileFragment = { __typename?: 'PortCallFile', id: PortCallFileId, portCallId: PortCallId, fileByFileId?: { __typename?: 'File', id: FileId, note?: string | null, uri: string, type: DocumentType, userByUserId?: { __typename?: 'User', id: UserId, email?: string | null } | null } | null };

export type PortCallsDocuments__OrganizationFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null };

export type PortCost_FieldsFragment = { __typename?: 'PortCost', id: PortCostId, locationId: LocationId, vesselId?: ShipId | null, cost?: string | number | null, userId: UserId, estimatedCost?: number | null, portCostCurrency?: Currency | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null };

export type VoyageCharterPortCostsQueryVariables = Exact<{ [key: string]: never; }>;


export type VoyageCharterPortCostsQuery = { __typename?: 'Query', allVoyageCharterPortCosts?: { __typename?: 'VoyageCharterPortCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterPortCost', id: VoyageCharterPortCostId, voyageCharterId: VoyageCharterId, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null } | null, portCostByPortCostId?: { __typename?: 'PortCost', id: PortCostId, locationId: LocationId, vesselId?: ShipId | null, cost?: string | number | null, userId: UserId, estimatedCost?: number | null, portCostCurrency?: Currency | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null } | null> } | null };

export type CoaPortCostsQueryVariables = Exact<{ [key: string]: never; }>;


export type CoaPortCostsQuery = { __typename?: 'Query', allCoaContractPortCosts?: { __typename?: 'CoaContractPortCostsConnection', nodes: Array<{ __typename?: 'CoaContractPortCost', id: CoaContractPortCostId, locationId: LocationId, coaContractId: CoaContractId, shipId?: ShipId | null, cost: string | number, vesselTypeId?: VesselAttributeId | null, coaContractByCoaContractId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null } | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, shipByShipId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null } | null> } | null };

export type PortCostDefault_FieldsFragment = { __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null };

export type ChannelCostEstimate_FieldsFragment = { __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, vesselTypeId?: VesselAttributeId | null, vesselId?: ShipId | null, channelCost: string | number, channelCostCurrency: string, durationOverhead?: string | number | null, channelName: string, cargoCondition?: ChannelCostCargoCondition | null, assortmentGroupId?: AssortmentGroupId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null };

export type PortCostsByPortAndVesselName_FieldsFragment = { __typename?: 'PortCostsByPortAndVesselName', portName?: string | null, vesselName?: string | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null };

export type PortCostsByPortAndPrimaryAttributes_FieldsFragment = { __typename?: 'PortCostsByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null };

export type LatestPortCostByPortAndPrimaryAttributes_FieldsFragment = { __typename?: 'LatestPortCostByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portCost?: string | number | null, portType?: string | null };

export type PortCostEstimatesQueryVariables = Exact<{ [key: string]: never; }>;


export type PortCostEstimatesQuery = { __typename?: 'Query', allPortCostsByPortAndVesselNames?: { __typename?: 'PortCostsByPortAndVesselNamesConnection', nodes: Array<{ __typename?: 'PortCostsByPortAndVesselName', portName?: string | null, vesselName?: string | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null } | null> } | null, allPortCostsByPortAndPrimaryAttributes?: { __typename?: 'PortCostsByPortAndPrimaryAttributesConnection', nodes: Array<{ __typename?: 'PortCostsByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null } | null> } | null, allLatestPortCostByPortAndPrimaryAttributes?: { __typename?: 'LatestPortCostByPortAndPrimaryAttributesConnection', nodes: Array<{ __typename?: 'LatestPortCostByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portCost?: string | number | null, portType?: string | null } | null> } | null, allChannelCostEstimates?: { __typename?: 'ChannelCostEstimatesConnection', nodes: Array<{ __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, vesselTypeId?: VesselAttributeId | null, vesselId?: ShipId | null, channelCost: string | number, channelCostCurrency: string, durationOverhead?: string | number | null, channelName: string, cargoCondition?: ChannelCostCargoCondition | null, assortmentGroupId?: AssortmentGroupId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } | null, allPortCostDefaults?: { __typename?: 'PortCostDefaultsConnection', nodes: Array<{ __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null> } | null };

export type PortCostsByPortAndPrimaryAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type PortCostsByPortAndPrimaryAttributesQuery = { __typename?: 'Query', allPortCostsByPortAndPrimaryAttributes?: { __typename?: 'PortCostsByPortAndPrimaryAttributesConnection', nodes: Array<{ __typename?: 'PortCostsByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null } | null> } | null };

export type LatestPortCostByPortAndPrimaryAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestPortCostByPortAndPrimaryAttributesQuery = { __typename?: 'Query', allLatestPortCostByPortAndPrimaryAttributes?: { __typename?: 'LatestPortCostByPortAndPrimaryAttributesConnection', nodes: Array<{ __typename?: 'LatestPortCostByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portCost?: string | number | null, portType?: string | null } | null> } | null };

export type PortCostEstimatesQueryFragment = { __typename?: 'Query', allPortCostsByPortAndVesselNames?: { __typename?: 'PortCostsByPortAndVesselNamesConnection', nodes: Array<{ __typename?: 'PortCostsByPortAndVesselName', portName?: string | null, vesselName?: string | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null } | null> } | null, allPortCostsByPortAndPrimaryAttributes?: { __typename?: 'PortCostsByPortAndPrimaryAttributesConnection', nodes: Array<{ __typename?: 'PortCostsByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portType?: string | null, avg?: string | number | null, min?: string | number | null, max?: string | number | null, count?: number | null, median?: number | null } | null> } | null, allLatestPortCostByPortAndPrimaryAttributes?: { __typename?: 'LatestPortCostByPortAndPrimaryAttributesConnection', nodes: Array<{ __typename?: 'LatestPortCostByPortAndPrimaryAttribute', portName?: string | null, primaryAttributeId?: number | null, portCostCurrency?: string | null, portCost?: string | number | null, portType?: string | null } | null> } | null, allChannelCostEstimates?: { __typename?: 'ChannelCostEstimatesConnection', nodes: Array<{ __typename?: 'ChannelCostEstimate', id: ChannelCostEstimateId, vesselTypeId?: VesselAttributeId | null, vesselId?: ShipId | null, channelCost: string | number, channelCostCurrency: string, durationOverhead?: string | number | null, channelName: string, cargoCondition?: ChannelCostCargoCondition | null, assortmentGroupId?: AssortmentGroupId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, assortmentGroupByAssortmentGroupId?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } | null, allPortCostDefaults?: { __typename?: 'PortCostDefaultsConnection', nodes: Array<{ __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null> } | null };

export type PortCostEstimatesFromVcQueryVariables = Exact<{
  vcIds: Array<Scalars['Int']['input']>;
}>;


export type PortCostEstimatesFromVcQuery = { __typename?: 'Query', allVoyageCharterPortData?: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, voyageCharterId: VoyageCharterId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, portcallCostEstimation?: string | number | null, portcallCostEstimationCurrency?: Currency | null } | null } | null> } | null };

export type ExternalPortCostPredictionsQueryVariables = Exact<{
  input: Array<ExternalPortCostPredictionsInput>;
}>;


export type ExternalPortCostPredictionsQuery = { __typename?: 'Query', externalPortCostPredictions: Array<{ __typename?: 'ExternalPortCostPredictionsResult', predicted?: { __typename?: 'ExternalPortCostPredictionsPredictedResult', fairway_dues: number, harbor_dues: number, mooring_dues: number, pilotage_dues: number, tonnage_dues: number, total_dues: number, towage_dues: number } | null } | null> };

export type ReconnectQueryVariables = Exact<{ [key: string]: never; }>;


export type ReconnectQuery = { __typename?: 'Query', allShips?: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null> } | null, allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null> } | null, allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, inactive: boolean, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, shipowner?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vessels: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, portDataRelations: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaAssortments: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, id: CoaContractAssortmentId } | null> }, ports: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, coaContractId: CoaContractId, originId?: LocationId | null, destinationId?: LocationId | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, draft?: string | number | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configEnableScenarioAutoSave: boolean, configCargoAllocationCombineAssortment: boolean, portCostPriority?: string | null, broker: boolean } | null> } | null, allPortCalls?: { __typename?: 'PortCallsConnection', nodes: Array<{ __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portCallFilesByPortCallId: { __typename?: 'PortCallFilesConnection', nodes: Array<{ __typename?: 'PortCallFile', id: PortCallFileId, fileByFileId?: { __typename?: 'File', id: FileId, note?: string | null, type: DocumentType } | null } | null> } } | null> } | null, allScenarios?: { __typename?: 'ScenariosConnection', nodes: Array<{ __typename?: 'Scenario', id: ScenarioId, clientId: string, updatedAt?: string | null } | null> } | null };

export type RelatedOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type RelatedOrgsQuery = { __typename?: 'Query', ordersRelatedOrgsArr?: { __typename?: 'OrdersRelatedOrgsArrConnection', nodes: Array<{ __typename?: 'OrdersRelatedOrgsArrRecord', orderId?: number | null, orgIds?: Array<number | null> | null } | null> } | null };

export type RequestLogEntryFragment = { __typename?: 'RequestLog', id: RequestLogId, organizationId: OrganizationId, request: string, response: string, status: ResponseStatus, createdAt: string };

export type AllRequestLogsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRequestLogsQuery = { __typename?: 'Query', allRequestLogs?: { __typename?: 'RequestLogsConnection', nodes: Array<{ __typename?: 'RequestLog', id: RequestLogId, organizationId: OrganizationId, request: string, response: string, status: ResponseStatus, createdAt: string } | null> } | null };

export type ScenarioTimeline_QueryFragment = { __typename?: 'Query', allShips?: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null> } | null, allOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null> } | null, allScheduledOrders?: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> } | null, allHandledBySpots?: { __typename?: 'HandledBySpotsConnection', nodes: Array<{ __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null> } | null, allSingleEvents?: { __typename?: 'SingleEventsConnection', nodes: Array<{ __typename?: 'SingleEvent', id: SingleEventId, duration: string | number, end: string, locationId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, vesselId?: ShipId | null, type: EventType, concurrent: boolean, startOverride?: string | null, seaDurationOverride?: string | number | null, clientId: string, updatedAt?: string | null, archived: boolean, cleaningAssortmentExclusionId?: AssortmentExclusionId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, singleEventPortCallRelationsBySingleEventId: { __typename?: 'SingleEventPortCallRelationsConnection', nodes: Array<{ __typename?: 'SingleEventPortCallRelation', id: SingleEventPortCallRelationId, portCallId: PortCallId, singleEventId: SingleEventId } | null> } } | null> } | null, allOffHires?: { __typename?: 'OffHiresConnection', nodes: Array<{ __typename?: 'OffHire', id: OffHireId, end: string, locationAId: LocationId, locationBId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, duration: string | number, vesselId?: ShipId | null, type?: OffHireType | null, planningOrganisationId: OrganizationId, userId: UserId, clientId: string, updatedAt?: string | null, archived: boolean, tcOutRate?: string | number | null, commissionPct?: string | number | null, ballastBonus?: string | number | null, ballastBonusCommissionable?: boolean | null, locationByLocationAId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLocationBId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> } | null, allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, inactive: boolean, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, shipowner?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vessels: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, portDataRelations: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaAssortments: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, id: CoaContractAssortmentId } | null> }, ports: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, coaContractId: CoaContractId, originId?: LocationId | null, destinationId?: LocationId | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null> } | null, allHandledByCoas?: { __typename?: 'HandledByCoasConnection', nodes: Array<{ __typename?: 'HandledByCoa', id: HandledByCoaId, coaId: CoaContractId, orderId: OrderId, vesselId?: ShipId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, draft?: string | number | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configEnableScenarioAutoSave: boolean, configCargoAllocationCombineAssortment: boolean, portCostPriority?: string | null, broker: boolean } | null> } | null, allPortCalls?: { __typename?: 'PortCallsConnection', nodes: Array<{ __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> }, portCallFilesByPortCallId: { __typename?: 'PortCallFilesConnection', nodes: Array<{ __typename?: 'PortCallFile', id: PortCallFileId, fileByFileId?: { __typename?: 'File', id: FileId, note?: string | null, type: DocumentType } | null } | null> } } | null> } | null, allShipments?: { __typename?: 'ShipmentsConnection', nodes: Array<{ __typename?: 'Shipment', id: ShipmentId, clientId: string, name: string, remarks?: string | null, externalShipmentId?: string | null, voyageAttributeId?: VoyageAttributeId | null, shipmentExternalStatusesByShipmentId: { __typename?: 'ShipmentExternalStatusesConnection', nodes: Array<{ __typename?: 'ShipmentExternalStatus', id: ShipmentExternalStatusId, status: ShipmentStatus } | null> }, shipmentFreightByShipmentId?: { __typename?: 'ShipmentFreight', id: ShipmentFreightId, clientId: string, shipmentId: ShipmentId, freightAmount: string | number, freightUnit: PaymentUnit } | null, shipmentExtraFreightsByShipmentId: { __typename?: 'ShipmentExtraFreightsConnection', nodes: Array<{ __typename?: 'ShipmentExtraFreight', id: ShipmentExtraFreightId, clientId: string, shipmentId: ShipmentId, name?: string | null, freightAmount: string | number, freightUnit: PaymentUnit, description?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> } } | null> } | null };

export type ScenarioTimeline_PortCall_FilesFragment = { __typename?: 'PortCall', id: PortCallId, portCallFilesByPortCallId: { __typename?: 'PortCallFilesConnection', nodes: Array<{ __typename?: 'PortCallFile', id: PortCallFileId, fileByFileId?: { __typename?: 'File', id: FileId, note?: string | null, type: DocumentType } | null } | null> } };

export type ScenarioTimeline_OrganizationFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null, draft?: string | number | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configEnableScenarioAutoSave: boolean, configCargoAllocationCombineAssortment: boolean, portCostPriority?: string | null, broker: boolean };

export type ScenarioTimeline_PortDatumFragment = { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null };

export type ScenarioTimeline_CoaFragment = { __typename?: 'CoaContract', id: CoaContractId, name?: string | null, chartererOrgId: OrganizationId, startDate: string, endDate: string, maxAmount?: string | number | null, minAmount?: string | number | null, inactive: boolean, currency?: Currency | null, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, shipowner?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vessels: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, portDataRelations: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaAssortments: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, id: CoaContractAssortmentId } | null> }, ports: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, coaContractId: CoaContractId, originId?: LocationId | null, destinationId?: LocationId | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, locationId: LocationId } | null> } } | null } | null> }, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } };

export type ScenarioTimeline_PortNoticeFragment = { __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null };

export type ScenarioTimeline_StatementOfFactFragment = { __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } };

export type ScenarioTimeline_PortCallFieldsFragment = { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null };

export type ScenarioTimeline_PortCallFragment = { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } };

export type ScenarioTimeline_ShipmentFragment = { __typename?: 'Shipment', id: ShipmentId, clientId: string, name: string, remarks?: string | null, externalShipmentId?: string | null, voyageAttributeId?: VoyageAttributeId | null, shipmentExternalStatusesByShipmentId: { __typename?: 'ShipmentExternalStatusesConnection', nodes: Array<{ __typename?: 'ShipmentExternalStatus', id: ShipmentExternalStatusId, status: ShipmentStatus } | null> }, shipmentFreightByShipmentId?: { __typename?: 'ShipmentFreight', id: ShipmentFreightId, clientId: string, shipmentId: ShipmentId, freightAmount: string | number, freightUnit: PaymentUnit } | null, shipmentExtraFreightsByShipmentId: { __typename?: 'ShipmentExtraFreightsConnection', nodes: Array<{ __typename?: 'ShipmentExtraFreight', id: ShipmentExtraFreightId, clientId: string, shipmentId: ShipmentId, name?: string | null, freightAmount: string | number, freightUnit: PaymentUnit, description?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> } };

export type ScenarioTimeline_CoaAssignmentFragment = { __typename?: 'HandledByCoa', id: HandledByCoaId, coaId: CoaContractId, orderId: OrderId, vesselId?: ShipId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null };

export type ScenarioTimeline_HandledBySpotFragment = { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null };

export type ScenarioTimeline_SingleEventFragment = { __typename?: 'SingleEvent', id: SingleEventId, duration: string | number, end: string, locationId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, vesselId?: ShipId | null, type: EventType, concurrent: boolean, startOverride?: string | null, seaDurationOverride?: string | number | null, clientId: string, updatedAt?: string | null, archived: boolean, cleaningAssortmentExclusionId?: AssortmentExclusionId | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, singleEventPortCallRelationsBySingleEventId: { __typename?: 'SingleEventPortCallRelationsConnection', nodes: Array<{ __typename?: 'SingleEventPortCallRelation', id: SingleEventPortCallRelationId, portCallId: PortCallId, singleEventId: SingleEventId } | null> } };

export type ScenarioTimeline_OffHireFragment = { __typename?: 'OffHire', id: OffHireId, end: string, locationAId: LocationId, locationBId: LocationId, locked: boolean, meta?: string | null, shared: boolean, start: string, duration: string | number, vesselId?: ShipId | null, type?: OffHireType | null, planningOrganisationId: OrganizationId, userId: UserId, clientId: string, updatedAt?: string | null, archived: boolean, tcOutRate?: string | number | null, commissionPct?: string | number | null, ballastBonus?: string | number | null, ballastBonusCommissionable?: boolean | null, locationByLocationAId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLocationBId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null };

export type ScenarioTimeline_VesselFulfillsRequirementAssociationFragment = { __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null };

export type ScenarioTimeline_ShipFragment = { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } };

export type VesselTcContractFragment = { __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId };

export type VesselSpeedConsumptionFragment = { __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null };

export type VesselDraftDatapointFragment = { __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number };

export type ScenarioTimeline_CargoCompartmentFragment = { __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null };

export type ScenarioTimeline_VoyageCharterToContractFragment = { __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId };

export type ScenarioTimeline_OrderVoyageCharterRelationFragment = { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null };

export type ScenarioTimeline_VoyageCharterFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, currency?: Currency | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } };

export type ScenarioTimeline_AssortmentFragment = { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null };

export type ScenarioTimeline_OrderFragment = { __typename?: 'Order', id: OrderId, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } };

export type ScenarioTimeline_Order_OrderAttributeAssociationFragment = { __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId };

export type ScenarioTimeline_Order_OrderRequirementAssociationFragment = { __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId };

export type ScenarioTimeline_Order_DetailsFragment = { __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null };

export type ScenarioTimeline_CargoCompartmentAllocationsFragment = { __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number };

export type ScenarioTimeline_OrderLocationFragment = { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } };

export type ScenariosQueryVariables = Exact<{
  scenarioDataSchemaVersion: Scalars['Int']['input'];
}>;


export type ScenariosQuery = { __typename?: 'Query', allScenarios?: { __typename?: 'ScenariosConnection', nodes: Array<{ __typename?: 'Scenario', id: ScenarioId, clientId: string, organizationId: OrganizationId, name?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, createdBy: UserId, updatedBy: UserId, dataSchemaVersion: number, data: string, shared: boolean, deletedAt?: string | null } | null> } | null };

export type ScenariosByIdsQueryVariables = Exact<{
  scenarioDataSchemaVersion: Scalars['Int']['input'];
  cids: Array<Scalars['UUID']['input']>;
}>;


export type ScenariosByIdsQuery = { __typename?: 'Query', allScenarios?: { __typename?: 'ScenariosConnection', nodes: Array<{ __typename?: 'Scenario', id: ScenarioId, clientId: string, organizationId: OrganizationId, name?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, createdBy: UserId, updatedBy: UserId, dataSchemaVersion: number, data: string, shared: boolean, deletedAt?: string | null } | null> } | null };

export type ScenarioByClientIdQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
}>;


export type ScenarioByClientIdQuery = { __typename?: 'Query', scenario?: { __typename?: 'ScenariosConnection', nodes: Array<{ __typename?: 'Scenario', id: ScenarioId } | null> } | null };

export type Scenarios_ScenarioFragment = { __typename?: 'Scenario', id: ScenarioId, clientId: string, organizationId: OrganizationId, name?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, createdBy: UserId, updatedBy: UserId, dataSchemaVersion: number, data: string, shared: boolean, deletedAt?: string | null };

export type LocationSearchQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type LocationSearchQuery = { __typename?: 'Query', searchLocations?: { __typename?: 'LocationsConnection', nodes: Array<{ __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null> } | null };

export type ShipmentsByExternalIdQueryVariables = Exact<{
  externalIds: Array<Scalars['String']['input']>;
}>;


export type ShipmentsByExternalIdQuery = { __typename?: 'Query', allShipments?: { __typename?: 'ShipmentsConnection', nodes: Array<{ __typename?: 'Shipment', id: ShipmentId, externalShipmentId?: string | null, ordersByShipmentId: { __typename?: 'OrdersConnection', totalCount: number } } | null> } | null };

export type SpotContractQueryVariables = Exact<{
  voyageCharterId: Scalars['Int']['input'];
  outgoing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SpotContractQuery = { __typename?: 'Query', voyageCharterById?: { __typename?: 'VoyageCharter', id: VoyageCharterId, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, lumpsum?: string | number | null, name?: string | null, externalId?: string | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, portDataRelations: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> } } | null };

export type SpotFormQueryVariables = Exact<{
  unsavedOrderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  outgoing: Scalars['Boolean']['input'];
}>;


export type SpotFormQuery = { __typename?: 'Query', portAgents?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, unsavedOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null } | null> }, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null } | null> } | null, charterers?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, shipowners?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, shipsByOrganizationId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, nameSynonyms?: Array<string | null> | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, assortmentGroup?: AssortmentGroupId | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null } | null> } | null, allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, inactive: boolean, name?: string | null, amountUnitId?: CargoUnitId | null, endDate: string, externalId?: string | null, currency?: Currency | null, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', name?: string | null, id: OrganizationId } | null, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, paymentType?: PaymentType | null, price: string | number, routeId?: CoaContractPortId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentId?: AssortmentId | null } | null } | null> }, coaContractCommissionsByCoaContractId: { __typename?: 'CoaContractCommissionsConnection', nodes: Array<{ __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, destinationId?: LocationId | null } | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null } | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> } } | null> } | null, allVesselAttributes?: { __typename?: 'VesselAttributesConnection', nodes: Array<{ __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null> } | null };

export type BaseContractFormFragment = { __typename?: 'Query', charterers?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, shipowners?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, shipsByOrganizationId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, nameSynonyms?: Array<string | null> | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, assortmentGroup?: AssortmentGroupId | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null } | null> } | null, allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, inactive: boolean, name?: string | null, amountUnitId?: CargoUnitId | null, endDate: string, externalId?: string | null, currency?: Currency | null, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', name?: string | null, id: OrganizationId } | null, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, paymentType?: PaymentType | null, price: string | number, routeId?: CoaContractPortId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentId?: AssortmentId | null } | null } | null> }, coaContractCommissionsByCoaContractId: { __typename?: 'CoaContractCommissionsConnection', nodes: Array<{ __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, destinationId?: LocationId | null } | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null } | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> } } | null> } | null, allVesselAttributes?: { __typename?: 'VesselAttributesConnection', nodes: Array<{ __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null> } | null };

export type SpotFormFragment = { __typename?: 'Query', portAgents?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, unsavedOrders?: { __typename?: 'OrdersConnection', nodes: Array<{ __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, orderVoyageCharterRelationsByOrderId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null } | null> }, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null } | null> } | null, charterers?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, shipowners?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, shipsByOrganizationId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, nameSynonyms?: Array<string | null> | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, assortmentGroup?: AssortmentGroupId | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null } | null> } | null, allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, inactive: boolean, name?: string | null, amountUnitId?: CargoUnitId | null, endDate: string, externalId?: string | null, currency?: Currency | null, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', name?: string | null, id: OrganizationId } | null, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, paymentType?: PaymentType | null, price: string | number, routeId?: CoaContractPortId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentId?: AssortmentId | null } | null } | null> }, coaContractCommissionsByCoaContractId: { __typename?: 'CoaContractCommissionsConnection', nodes: Array<{ __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, destinationId?: LocationId | null } | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null } | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> } } | null> } | null, allVesselAttributes?: { __typename?: 'VesselAttributesConnection', nodes: Array<{ __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null> } | null };

export type SpotForm_ChartererFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null };

export type SpotForm_ShipownerFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null, shipsByOrganizationId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } };

export type SpotForm_VesselFragment = { __typename?: 'Ship', id: ShipId, name?: string | null };

export type SpotForm_PortAgentFragment = { __typename?: 'Organization', id: OrganizationId, name?: string | null };

export type SpotForm_OrderFragment = { __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null };

export type SpotForm_ExtraFreightFragment = { __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null };

export type SpotForm_ExtraCostFragment = { __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null };

export type SpotForm_CommissionFragment = { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null };

export type SpotForm_SpotContractFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, lumpsum?: string | number | null, name?: string | null, externalId?: string | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, cargoAmount: string | number, loadPortId?: LocationId | null, dischargePortId: LocationId, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnit?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, loadPort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, dischargePort?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, portDataRelations: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portData?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portAgentOrgId?: OrganizationId | null, pilotDeducted?: boolean | null, weatherPermitting?: boolean | null, bimcoHolidays?: IncludedExcludedUnlessUsed | null, laytimeExclusionStart?: string | null, laytimeExclusionEnd?: string | null, officeHoursStart?: string | null, officeHoursEnd?: string | null, laytimeStartAfterOfficeHours?: string | null, laytimeTrigger?: LaytimeCountingTrigger | null, laytimeNorTimeLimit?: string | null, laytimeStartBeforeNorTimeLimit?: string | null, laytimeStartAfterNorTimeLimit?: string | null, organizationByPortAgentOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, laytimeDays?: { __typename?: 'ShincShex', sa?: boolean | null, su?: boolean | null, ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null } | null } | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> } };

export type AllTcContractsAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTcContractsAdminQuery = { __typename?: 'Query', allTcContracts?: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, externalId: string, deliveryStartDate: string, deliveryEndDate: string, redeliveryStartDate: string, redeliveryEndDate: string, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, locationByDeliveryPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByRedeliveryPortId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null> } | null };

export type DeleteTcContractByIdMutationVariables = Exact<{
  input: DeleteTcContractByIdInput;
}>;


export type DeleteTcContractByIdMutation = { __typename?: 'Mutation', deleteTcContractById?: { __typename?: 'DeleteTcContractPayload', deletedTcContractId?: string | null } | null };

export type GetUserDataByIdQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserDataByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: UserId, name?: string | null, nickname?: string | null, userId?: string | null, email?: string | null, familyName?: string | null, givenName?: string | null, picture?: string | null, locale?: string | null, userType: UserType, organizationId: OrganizationId, monitoringOnly?: boolean | null, showAdmin?: boolean | null, initials?: string | null, preferredWordForVessel?: string | null } | null };

export type VesonPnlQueryVariables = Exact<{ [key: string]: never; }>;


export type VesonPnlQuery = { __typename?: 'Query', getVesonPnl?: { __typename?: 'GetVesonPnlResult', voyagePnl: Array<{ __typename?: 'VesonVoyagePnl', VesselName: string, VoyageNo: number, VoyagePnlSummary: Array<{ __typename?: 'VesonVoyagePnlItem', ActualAmountBase?: number | null, EstimatedAmountBase?: number | null, Description?: string | null, PostedAmountBase?: number | null, RootCategory?: string | null }> }> } | null };

export type VesonBunkerQueryVariables = Exact<{ [key: string]: never; }>;


export type VesonBunkerQuery = { __typename?: 'Query', getVesonBunker?: { __typename?: 'GetVesonBunkerResult', errorMessage?: string | null, remainingBunkerOfVoyages?: Array<{ __typename?: 'VesonRemainingBunkerOfVoyage', id: number, voyage: string, bunkerOpen: Array<{ __typename?: 'VesonRemainingBunker', price: number, amount: number, name: string }>, bunkerClose: Array<{ __typename?: 'VesonRemainingBunker', price: number, amount: number, name: string }> }> | null, defaultBunkerOfVessels?: Array<{ __typename?: 'VesonDefaultBunkerOfVessel', id: number, vessel_code: string, bunker: Array<{ __typename?: 'VesonDefaultBunkerPrice', price: number, name: string }> }> | null } | null };

export type VesselChangeFormQueryVariables = Exact<{
  shipownerOrgId: Scalars['Int']['input'];
  includeCoaVessels: Scalars['Boolean']['input'];
  coaId?: InputMaybe<Scalars['Int']['input']>;
  includeVoyageCharter: Scalars['Boolean']['input'];
  voyageCharterId: Scalars['Int']['input'];
}>;


export type VesselChangeFormQuery = { __typename?: 'Query', allShips?: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } | null, allCoaContractShips?: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> } | null, voyageCharterById?: { __typename?: 'VoyageCharter', id: VoyageCharterId, layday?: string | null, cancelling?: string | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null };

export type VesselChangeForm_VesselFragment = { __typename?: 'Ship', id: ShipId, name?: string | null };

export type VesselReservationFragment = { __typename?: 'VesselReservation', duration: number, expireTime?: string | null, id: VesselReservationId, remark?: string | null, startPortId?: LocationId | null, endPortId?: LocationId | null, startRegionId?: RegionId | null, endRegionId?: RegionId | null, startTime: string, type: VesselReservationType, vesselId: ShipId, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByEndPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, regionByStartRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, regionByEndRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null };

export type AllVesselReservationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVesselReservationsQuery = { __typename?: 'Query', allVesselReservations?: { __typename?: 'VesselReservationsConnection', nodes: Array<{ __typename?: 'VesselReservation', id: VesselReservationId, duration: number, expireTime?: string | null, remark?: string | null, startPortId?: LocationId | null, endPortId?: LocationId | null, startRegionId?: RegionId | null, endRegionId?: RegionId | null, startTime: string, type: VesselReservationType, vesselId: ShipId, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByEndPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, regionByStartRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, regionByEndRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> } | null };

export type VoyageCharterDataForCommitQueryVariables = Exact<{
  coaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  voyageCharterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type VoyageCharterDataForCommitQuery = { __typename?: 'Query', allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, paymentDays?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, shipownerOrgId: OrganizationId, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, demurrage?: string | number | null, shipId: ShipId } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, price: string | number, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, originId?: LocationId | null } | null } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, paymentUnit: PaymentUnit } | null> }, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDataId: PortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId } | null } | null> } } | null> } | null, allVoyageCharters?: { __typename?: 'VoyageChartersConnection', nodes: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId, currency?: Currency | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, shipownerOrgId?: OrganizationId | null, chartererOrgId?: OrganizationId | null, vesselId?: ShipId | null, isTemplate: boolean, deleteOnUnassign: boolean, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDataId: PortDatumId } | null> }, orderVoyageCharterRelationsByVoyageCharterId: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> } } | null> }, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId } | null> } } | null> } | null };

export type SpotForVoyageCharterQueryVariables = Exact<{
  spotId: Scalars['Int']['input'];
}>;


export type SpotForVoyageCharterQuery = { __typename?: 'Query', voyageCharterById?: { __typename?: 'VoyageCharter', id: VoyageCharterId, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type VoyageCharterFormQueryVariables = Exact<{ [key: string]: never; }>;


export type VoyageCharterFormQuery = { __typename?: 'Query', allCargoUnits?: { __typename?: 'CargoUnitsConnection', nodes: Array<{ __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null> } | null, charterers?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, shipowners?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null, shipsByOrganizationId: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } } | null> } | null, allOrganizations?: { __typename?: 'OrganizationsConnection', nodes: Array<{ __typename?: 'Organization', id: OrganizationId, name?: string | null } | null> } | null, allAssortments?: { __typename?: 'AssortmentsConnection', nodes: Array<{ __typename?: 'Assortment', id: AssortmentId, name: string, nameSynonyms?: Array<string | null> | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, assortmentGroup?: AssortmentGroupId | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null } | null> } | null, allCoaContracts?: { __typename?: 'CoaContractsConnection', nodes: Array<{ __typename?: 'CoaContract', id: CoaContractId, inactive: boolean, name?: string | null, amountUnitId?: CargoUnitId | null, endDate: string, externalId?: string | null, currency?: Currency | null, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', name?: string | null, id: OrganizationId } | null, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, paymentType?: PaymentType | null, price: string | number, routeId?: CoaContractPortId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentId?: AssortmentId | null } | null } | null> }, coaContractCommissionsByCoaContractId: { __typename?: 'CoaContractCommissionsConnection', nodes: Array<{ __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, destinationId?: LocationId | null } | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null } | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> } } | null> } | null, allVesselAttributes?: { __typename?: 'VesselAttributesConnection', nodes: Array<{ __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null> } | null };

export type VoyageCharterForm_AssortmentFragment = { __typename?: 'Assortment', id: AssortmentId, name: string, nameSynonyms?: Array<string | null> | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, assortmentGroup?: AssortmentGroupId | null, cargoType?: CargoType | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null };

export type VoyageCharterForm_CargoUnitFragment = { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null };

export type VoyageCharterForm_CoaFragment = { __typename?: 'CoaContract', id: CoaContractId, inactive: boolean, name?: string | null, amountUnitId?: CargoUnitId | null, endDate: string, externalId?: string | null, currency?: Currency | null, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', name?: string | null, id: OrganizationId } | null, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPortDataByCoaContractId: { __typename?: 'CoaContractPortDataConnection', nodes: Array<{ __typename?: 'CoaContractPortDatum', id: CoaContractPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, coaContractShipsByCoaContractId: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, paymentType?: PaymentType | null, price: string | number, routeId?: CoaContractPortId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentId?: AssortmentId | null } | null } | null> }, coaContractCommissionsByCoaContractId: { __typename?: 'CoaContractCommissionsConnection', nodes: Array<{ __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, destinationId?: LocationId | null } | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null } | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null } | null> } };

export type VoyageCharterForm_CoaAssortmentFragment = { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit };

export type VoyageCharterForm_CoaRouteFragment = { __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null };

export type VoyageCharterForm_CoaPriceFragment = { __typename?: 'CoaContractPrice', id: CoaContractPriceId, coaAssortmentId: CoaContractAssortmentId, paymentType?: PaymentType | null, price: string | number, routeId?: CoaContractPortId | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, minAmount?: string | number | null, maxAmount?: string | number | null, assortmentId?: AssortmentId | null } | null };

export type VoyageCharterForm_CoaCommissionFragment = { __typename?: 'CoaContractCommission', id: CoaContractCommissionId, coaRouteId?: CoaContractPortId | null, coaAssortmentId?: CoaContractAssortmentId | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, destinationId?: LocationId | null } | null, coaContractAssortmentByCoaAssortmentId?: { __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null } | null, commissionByCommissionId?: { __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, voyageCharterId?: VoyageCharterId | null, bafApplied?: boolean | null, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, organizationId?: OrganizationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null };

export type VoyageCharterQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type VoyageCharterQuery = { __typename?: 'Query', voyageCharterById?: { __typename?: 'VoyageCharter', id: VoyageCharterId, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, name?: string | null, lumpsum?: string | number | null, externalId?: string | null, onSubsUntil?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null } | null> }, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, coaRouteId?: CoaContractPortId | null, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, assortmentId?: AssortmentId | null, cargoAmount: string | number, cargoUnitId?: CargoUnitId | null, loadPortId?: LocationId | null, dischargePortId: LocationId, chartererOrganizationId?: OrganizationId | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, softDelete: boolean, externalOrderId?: string | null, nominatedVessel?: string | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMax?: string | number | null, stowageFactorMin?: string | number | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, clusterId?: LocationClusterId | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, clusterId?: LocationClusterId | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, extraInfo?: string | null, orderName?: string | null, fixtureNote?: string | null, imoClass?: ImoClass | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> } } | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDataId: PortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> } } | null };

export type VoyageChartersQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type VoyageChartersQuery = { __typename?: 'Query', allVoyageCharters?: { __typename?: 'VoyageChartersConnection', nodes: Array<{ __typename?: 'VoyageCharter', id: VoyageCharterId, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, name?: string | null, lumpsum?: string | number | null, externalId?: string | null, onSubsUntil?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null } | null> }, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, coaRouteId?: CoaContractPortId | null, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, assortmentId?: AssortmentId | null, cargoAmount: string | number, cargoUnitId?: CargoUnitId | null, loadPortId?: LocationId | null, dischargePortId: LocationId, chartererOrganizationId?: OrganizationId | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, softDelete: boolean, externalOrderId?: string | null, nominatedVessel?: string | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMax?: string | number | null, stowageFactorMin?: string | number | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, clusterId?: LocationClusterId | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, clusterId?: LocationClusterId | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, extraInfo?: string | null, orderName?: string | null, fixtureNote?: string | null, imoClass?: ImoClass | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> } } | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDataId: PortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> } } | null> } | null };

export type VoyageCharter_VoyageCharterFragment = { __typename?: 'VoyageCharter', id: VoyageCharterId, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, vesselId?: ShipId | null, cancelling?: string | null, layday?: string | null, demurrage?: string | number | null, organisationId: OrganizationId, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, currency?: Currency | null, name?: string | null, lumpsum?: string | number | null, externalId?: string | null, onSubsUntil?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null } | null> }, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, organizationByShipownerOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderRelations: { __typename?: 'OrderVoyageCharterRelationsConnection', nodes: Array<{ __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, coaRouteId?: CoaContractPortId | null, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, orderByOrderId?: { __typename?: 'Order', id: OrderId, assortmentId?: AssortmentId | null, cargoAmount: string | number, cargoUnitId?: CargoUnitId | null, loadPortId?: LocationId | null, dischargePortId: LocationId, chartererOrganizationId?: OrganizationId | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, softDelete: boolean, externalOrderId?: string | null, nominatedVessel?: string | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMax?: string | number | null, stowageFactorMin?: string | number | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, clusterId?: LocationClusterId | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, clusterId?: LocationClusterId | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, extraInfo?: string | null, orderName?: string | null, fixtureNote?: string | null, imoClass?: ImoClass | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> } } | null, coaContractPortByCoaRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, locationByDestinationId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByOriginId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null } | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null, freight: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, orderVoyageCharterRelationId: OrderVoyageCharterRelationId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null } | null> } } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, demurrageApplied?: boolean | null, extraFreightApplied?: boolean | null, bafApplied?: boolean | null, organizationId?: OrganizationId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, assortmentId?: AssortmentId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, amount: string | number, description?: string | null, externalId?: string | null, name?: string | null, type?: VoyageCharterCostType | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDataId: PortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> } };

export type VoyageCharter_OrderFragment = { __typename?: 'Order', id: OrderId, assortmentId?: AssortmentId | null, cargoAmount: string | number, cargoUnitId?: CargoUnitId | null, loadPortId?: LocationId | null, dischargePortId: LocationId, chartererOrganizationId?: OrganizationId | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, softDelete: boolean, externalOrderId?: string | null, nominatedVessel?: string | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMax?: string | number | null, stowageFactorMin?: string | number | null, minVesselClassRequirement?: VesselAttributeId | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, clusterId?: LocationClusterId | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, timezone?: string | null, clusterId?: LocationClusterId | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, extraInfo?: string | null, orderName?: string | null, fixtureNote?: string | null, imoClass?: ImoClass | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> } };

export type VoyageCharter_ContractFragment = { __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null };

export type VoyageCharter_PortDatumFragment = { __typename?: 'PortDatum', id: PortDatumId, dischargeRate?: string | number | null, loadingRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, portId: LocationId, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null };

export type VoyageCharter_VesselAttributeFragment = { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null };

export type AllVoyageCharterUpdatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllVoyageCharterUpdatesQuery = { __typename?: 'Query', allVoyageCharterUpdates?: { __typename?: 'VoyageCharterUpdatesConnection', nodes: Array<{ __typename?: 'VoyageCharterUpdate', id: VoyageCharterUpdateId, createdByUserId: UserId, createdAt: string, cancelling?: string | null, accepted?: boolean | null, layday?: string | null, vesselId?: ShipId | null, voyageCharterId: VoyageCharterId, userByCreatedByUserId?: { __typename?: 'User', id: UserId, email?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> } | null };

export type VoyageCharterUpdatesQueryVariables = Exact<{
  voyageCharterId: Scalars['Int']['input'];
}>;


export type VoyageCharterUpdatesQuery = { __typename?: 'Query', allVoyageCharterUpdates?: { __typename?: 'VoyageCharterUpdatesConnection', nodes: Array<{ __typename?: 'VoyageCharterUpdate', id: VoyageCharterUpdateId, createdByUserId: UserId, createdAt: string, cancelling?: string | null, accepted?: boolean | null, layday?: string | null, vesselId?: ShipId | null, voyageCharterId: VoyageCharterId, userByCreatedByUserId?: { __typename?: 'User', id: UserId, email?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null } | null> } | null };

export type VoyageCharterContractsQueryVariables = Exact<{
  voyageCharterId: Scalars['Int']['input'];
}>;


export type VoyageCharterContractsQuery = { __typename?: 'Query', allVoyageCharterToContracts?: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null } | null> } | null };

export type VoyageCharterUpdates_UpdateFragment = { __typename?: 'VoyageCharterUpdate', id: VoyageCharterUpdateId, createdByUserId: UserId, createdAt: string, cancelling?: string | null, accepted?: boolean | null, layday?: string | null, vesselId?: ShipId | null, voyageCharterId: VoyageCharterId, userByCreatedByUserId?: { __typename?: 'User', id: UserId, email?: string | null } | null, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null };

export type VoyageCharterUpdateFormQueryVariables = Exact<{
  shipownerOrgId: Scalars['Int']['input'];
  includeCoaVessels: Scalars['Boolean']['input'];
  coaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VoyageCharterUpdateFormQuery = { __typename?: 'Query', allShips?: { __typename?: 'ShipsConnection', nodes: Array<{ __typename?: 'Ship', id: ShipId, name?: string | null } | null> } | null, allCoaContractShips?: { __typename?: 'CoaContractShipsConnection', nodes: Array<{ __typename?: 'CoaContractShip', id: CoaContractShipId, shipId: ShipId } | null> } | null };

export type VoyageCharterUpdates_VoyageCharterFragment = { __typename?: 'VwVoyageCharterShipownerNonfinancial', id?: number | null, vesselId?: number | null, cancelling?: string | null, layday?: string | null, shipownerOrgId?: number | null };

export type VoyageCharterShipownerNonFinancialQueryVariables = Exact<{
  voyageCharterId: Scalars['Int']['input'];
}>;


export type VoyageCharterShipownerNonFinancialQuery = { __typename?: 'Query', allVwVoyageCharterShipownerNonfinancials?: { __typename?: 'VwVoyageCharterShipownerNonfinancialsConnection', nodes: Array<{ __typename?: 'VwVoyageCharterShipownerNonfinancial', id?: number | null, vesselId?: number | null, cancelling?: string | null, layday?: string | null, shipownerOrgId?: number | null } | null> } | null };

export type VoyagesTable_BillOfLadingsQueryVariables = Exact<{
  portCallIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type VoyagesTable_BillOfLadingsQuery = { __typename?: 'Query', allBillOfLadings?: { __typename?: 'BillOfLadingsConnection', nodes: Array<{ __typename?: 'BillOfLading', id: BillOfLadingId, portCallId: PortCallId, billOfLadingDataByBillOfLadingId: { __typename?: 'BillOfLadingDataConnection', nodes: Array<{ __typename?: 'BillOfLadingDatum', id: BillOfLadingDatumId, billOfLadingId: BillOfLadingId, orderId?: OrderId | null, description?: string | null, volume?: string | number | null, volumeUnit?: VolumeUnits | null, weight?: string | number | null, weightUnit?: WeightUnits | null, volumeOnDeck?: string | number | null, weightOnDeck?: string | number | null } | null> } } | null> } | null };

export type VoyagesTable_MeasurementReportsQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type VoyagesTable_MeasurementReportsQuery = { __typename?: 'Query', allCargoMeasurements?: { __typename?: 'CargoMeasurementsConnection', nodes: Array<{ __typename?: 'CargoMeasurement', id: CargoMeasurementId, orderId: OrderId, locationId?: LocationId | null, time: string, measuredWeight?: string | number | null, rejectedWeight?: string | number | null, weightUnit?: WeightUnits | null, measuredVolume?: string | number | null, rejectedVolume?: string | number | null, volumeUnit?: VolumeUnits | null } | null> } | null };

export type VoyagesTable_DocumentsQueryVariables = Exact<{
  portCallIds?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type VoyagesTable_DocumentsQuery = { __typename?: 'Query', allPortCallFiles?: { __typename?: 'PortCallFilesConnection', nodes: Array<{ __typename?: 'PortCallFile', id: PortCallFileId, portCallId: PortCallId, fileByFileId?: { __typename?: 'File', id: FileId, type: DocumentType, uri: string } | null } | null> } | null };

export type RouteByDraftAndCoordinatesAndAvoidsChannelsQueryVariables = Exact<{
  fromClusterId: Scalars['Int']['input'];
  toClusterId: Scalars['Int']['input'];
  draft?: InputMaybe<Scalars['BigFloat']['input']>;
  avoidsChannels: Scalars['Boolean']['input'];
  noGoZones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
}>;


export type RouteByDraftAndCoordinatesAndAvoidsChannelsQuery = { __typename?: 'Query', routeByDraftAndCoordinatesAndAvoidsChannels?: { __typename?: 'Route', id: RouteId, decomposed?: string | null } | null };

export type BatchUpdateSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type BatchUpdateSubscription = { __typename?: 'Subscription', batchUpdate?: { __typename?: 'BatchUpdateSubscriptionPayload', batchUpdate?: { __typename: 'BatchUpdate', id: BatchUpdateId, data: string } | null } | null };

export type CommitLogScenarioUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type CommitLogScenarioUpdatedSubscription = { __typename?: 'Subscription', commitLogScenarioUpdated?: { __typename?: 'CommitLogScenarioSubscriptionPayload', event?: string | null } | null };

export type CommitLogUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type CommitLogUpdatedSubscription = { __typename?: 'Subscription', commitLogUpdated?: { __typename?: 'CommitLogSubscriptionPayload', event?: string | null, commitLog?: { __typename?: 'CommitLog', id: CommitLogId, input: string, payload?: string | null, success: boolean, committedAt: string, committedBy?: UserId | null, scenarioClientId?: string | null, masterClientId?: string | null, userByCommittedBy?: { __typename?: 'User', id: UserId, name?: string | null } | null, commitLogScenarioByMasterClientId?: { __typename?: 'CommitLogScenario', id: CommitLogScenarioId, clientId: string } | null } | null } | null };

export type DbChangeSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type DbChangeSubscription = { __typename?: 'Subscription', dbChange?: { __typename?: 'DbChangeSubscriptionPayload', dbChange?: { __typename: 'DbChange', id: DbChangeId, deletedBillOfLadingData?: Array<number | null> | null, deletedCargoCompartmentAllocation?: Array<number | null> | null, deletedCargoExclusion?: Array<number | null> | null, deletedCargoMeasurement?: Array<number | null> | null, deletedNotificationReceivers?: Array<number | null> | null, deletedOrderPortCallRelation?: Array<number | null> | null, deletedOrderVoyageCharterRelation?: Array<number | null> | null, softDeletedOrders?: Array<number | null> | null } | null } | null };

export type OpenPositionUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type OpenPositionUpdatedSubscription = { __typename?: 'Subscription', openPositionUpdated?: { __typename?: 'OpenPositionSubscriptionPayload', event?: string | null, openPosition?: { __typename?: 'OpenPosition', id: OpenPositionId, vesselId: ShipId, startTime: string, startPortId: LocationId, directionId?: LocationId | null, remark?: string | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByDirectionId?: { __typename?: 'Location', id: LocationId, name: string } | null } | null } | null };

export type PlanningOrderUpdateFragment = { __typename?: 'Order', id: OrderId, softDelete: boolean, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId, coaId: CoaContractId, orderId: OrderId, vesselId?: ShipId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } };

export type PlanningDataUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type PlanningDataUpdatedSubscription = { __typename?: 'Subscription', planningDataUpdated?: { __typename?: 'CommitSubscriptionPayload', event?: string | null, order?: { __typename?: 'Order', id: OrderId, softDelete: boolean, coaId?: CoaContractId | null, externalOrderId?: string | null, nominatedVessel?: string | null, started?: string | null, completed?: string | null, archived: boolean, shipmentId?: ShipmentId | null, toBeDeleted?: boolean | null, assortmentId?: AssortmentId | null, dischargePortId: LocationId, loadPortId?: LocationId | null, cargoAmount: string | number, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, loadingOverheadDuration?: string | number | null, dischargingOverheadDuration?: string | number | null, layday?: string | null, cancelling?: string | null, rta?: string | null, deliveredBefore?: string | null, chartererOrganizationId?: OrganizationId | null, createdAt?: string | null, minVesselClassRequirement?: VesselAttributeId | null, handledBySpotByOrderId?: { __typename?: 'HandledBySpot', id: HandledBySpotId, orderId?: OrderId | null, vesselId?: ShipId | null, ownerOrganisationId?: OrganizationId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null, handledByCoaByOrderId?: { __typename?: 'HandledByCoa', id: HandledByCoaId, coaId: CoaContractId, orderId: OrderId, vesselId?: ShipId | null, metadata?: string | null, loadingStart: string, loadingEnd: string, loadingDuration: string | number, dischargingStart: string, dischargingEnd: string, dischargingDuration: string | number, loadingStartOverride?: string | null, loadingDurationOverride?: string | number | null, loadingSeaDurationOverride?: string | number | null, dischargingSeaDurationOverride?: string | number | null, dischargingStartOverride?: string | null, dischargingDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null } | null, assortmentByAssortmentId?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null, locationByDischargePortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, locationByLoadPortId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, scheduledOrdersByOrderId: { __typename?: 'ScheduledOrdersConnection', nodes: Array<{ __typename?: 'ScheduledOrder', id: ScheduledOrderId, vesselId?: ShipId | null, orderId: OrderId, loadingStart: string, loadingStartOverride?: string | null, loadingDuration: string | number, loadingDurationOverride?: string | number | null, loadingEnd: string, loadingSeaDurationOverride?: string | number | null, dischargingStart: string, dischargingStartOverride?: string | null, dischargingDuration: string | number, dischargingDurationOverride?: string | number | null, dischargingEnd: string, dischargingSeaDurationOverride?: string | number | null, loadingConcurrent: boolean, dischargingConcurrent: boolean, shared: boolean, clientId: string, updatedAt?: string | null, cleaningOmitted: boolean, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null> }, orderRequirementAssociationsByOrderId: { __typename?: 'OrderRequirementAssociationsConnection', nodes: Array<{ __typename?: 'OrderRequirementAssociation', id: OrderRequirementAssociationId, orderId: OrderId, specialRequirementId: SpecialRequirementId } | null> }, cargoUnitByCargoUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, organizationByChartererOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, orderPortCallRelationsByOrderId: { __typename?: 'OrderPortCallRelationsConnection', nodes: Array<{ __typename?: 'OrderPortCallRelation', id: OrderPortCallRelationId, portCallId: PortCallId, orderId: OrderId, isLoadPort: boolean, portCallByPortCallId?: { __typename?: 'PortCall', id: PortCallId, clientId: string, vesselId?: ShipId | null, seaDurationOverride?: string | number | null, plannedArrival?: string | null, plannedBerthing?: string | null, plannedDeparture?: string | null, plannedArrivalOverride?: string | null, plannedArrivalOverrideSourcedAt?: string | null, plannedArrivalOverrideSourcedFrom?: string | null, plannedBerthingOverride?: string | null, plannedBerthingOverrideSourcedAt?: string | null, plannedBerthingOverrideSourcedFrom?: string | null, plannedDepartureOverride?: string | null, plannedDepartureOverrideSourcedAt?: string | null, plannedDepartureOverrideSourcedFrom?: string | null, plannedArrivalDuration?: string | number | null, plannedBerthingDuration?: string | number | null, plannedDepartureDuration?: string | number | null, totalLoadDurationOverride?: string | number | null, totalDischargeDurationOverride?: string | number | null, legAvoidsChannels: boolean, updatedAt?: string | null, archived: boolean, locationId: LocationId, previousLocationId?: LocationId | null, oneTimeOverrideChannelCost?: string | number | null, channelCostDefaultId?: ChannelCostEstimateId | null, oneTimeOverrideCost?: string | number | null, useHistoricalPortCost: boolean, useLatestHistoricalPortCost: boolean, useOneTimeOverrideCost: boolean, useIntegrationPortCost: boolean, portCostDefaultId?: PortCostDefaultId | null, channelDurationOverhead?: string | number | null, bunkerOverrides?: string | null, bunkerPriceSource?: string | null, weatherFactor?: string | number | null, locationByLocationId?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, portNoticesByPortCallId: { __typename?: 'PortNoticesConnection', nodes: Array<{ __typename?: 'PortNotice', id: PortNoticeId, portCallId: PortCallId, eta?: string | null, berthingProspects?: string | null, etdBerth?: string | null, ataBerth?: string | null, ataPbp?: string | null, norTendered?: string | null } | null> }, statementOfFactsByPortCallId: { __typename?: 'StatementOfFactsConnection', nodes: Array<{ __typename?: 'StatementOfFact', id: StatementOfFactId, portCallId: PortCallId, arrivalTime?: string | null, pilotOnboard?: string | null, berthed?: string | null, noticeOfReadiness?: string | null, loadingCommenced?: string | null, loadingCompleted?: string | null, sailingTime?: string | null, portActivitiesByStatementOfFactsId: { __typename?: 'PortActivitiesConnection', nodes: Array<{ __typename?: 'PortActivity', id: PortActivityId, start: string, end?: string | null, operation?: string | null } | null> } } | null> } } | null } | null> }, orderDetailsByOrderId: { __typename?: 'OrderDetailsConnection', nodes: Array<{ __typename?: 'OrderDetail', id: OrderDetailId, closingDate?: string | null, senderOrganisationId?: OrganizationId | null, receiverOrganisationId?: OrganizationId | null, supplyContractId?: SupplyContractId | null, consignee?: string | null, orderName?: string | null, fixtureNote?: string | null, extraInfo?: string | null, externalRemarks?: string | null, imoClass?: ImoClass | null, incoTerms?: IncoTermsType | null, cargoDeckOption?: CargoDeckOptionType | null, cargoMaxUnitWeight?: string | number | null } | null> }, orderAttributeAssociationsByOrderId: { __typename?: 'OrderAttributeAssociationsConnection', nodes: Array<{ __typename?: 'OrderAttributeAssociation', id: OrderAttributeAssociationId, orderId: OrderId, orderAttributeId: OrderAttributeId } | null> }, outgoingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, incomingVoyageCharterRelation?: { __typename?: 'OrderVoyageCharterRelation', id: OrderVoyageCharterRelationId, orderId: OrderId, voyageCharterId: VoyageCharterId, outgoing: boolean, coaRouteId?: CoaContractPortId | null, voyageCharterOrderFreightsByOrderVoyageCharterRelationId: { __typename?: 'VoyageCharterOrderFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterOrderFreight', id: VoyageCharterOrderFreightId, freightAmount?: string | number | null, freightUnit?: PaymentUnit | null, orderVoyageCharterRelationId: OrderVoyageCharterRelationId } | null> }, voyageCharterByVoyageCharterId?: { __typename?: 'VoyageCharter', id: VoyageCharterId, externalId?: string | null, currency?: Currency | null, vesselId?: ShipId | null, layday?: string | null, cancelling?: string | null, paymentTime?: number | null, paymentTrigger?: PaymentTrigger | null, paymentType?: PaymentType | null, demurrage?: string | number | null, name?: string | null, isInquiry: boolean, isPreliminary: boolean, isTemplate: boolean, deleteOnUnassign: boolean, onSubsUntil?: string | null, chartererOrgId?: OrganizationId | null, shipownerOrgId?: OrganizationId | null, lumpsum?: string | number | null, organizationByChartererOrgId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, voyageCharterToContractsByVoyageCharterId: { __typename?: 'VoyageCharterToContractsConnection', nodes: Array<{ __typename?: 'VoyageCharterToContract', id: VoyageCharterToContractId, coaId?: CoaContractId | null, voyageCharterId: VoyageCharterId, coaContractByCoaId?: { __typename?: 'CoaContract', id: CoaContractId, currency?: Currency | null, chartererOrgId: OrganizationId, shipownerOrgId: OrganizationId, useHighestFreightRate: boolean, cargoUnitByAmountUnitId?: { __typename?: 'CargoUnit', id: CargoUnitId, name?: string | null } | null, coaContractBunkersByCoaContractId: { __typename?: 'CoaContractBunkersConnection', nodes: Array<{ __typename?: 'CoaContractBunker', id: CoaContractBunkerId, bafBunkerAmount?: string | number | null, bafStartFromBase?: boolean | null, bafStepEffect?: string | number | null, bafStepSize?: string | number | null, bafType?: BafTypes | null, bafUseStepEffectAsValue?: boolean | null, basePriceMax?: string | number | null, bunkerGrade: BunkerGrade, coaAssortmentId?: CoaContractAssortmentId | null, coaRouteId?: CoaContractPortId | null, price: string | number } | null> }, coaContractAssortmentsByCoaContractId: { __typename?: 'CoaContractAssortmentsConnection', nodes: Array<{ __typename?: 'CoaContractAssortment', id: CoaContractAssortmentId, assortmentId?: AssortmentId | null, assortmentGroupId?: AssortmentGroupId | null, minAmount?: string | number | null, maxAmount?: string | number | null, paymentUnit: PaymentUnit } | null> }, coaContractPortsByCoaContractId: { __typename?: 'CoaContractPortsConnection', nodes: Array<{ __typename?: 'CoaContractPort', id: CoaContractPortId, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null, originId?: LocationId | null, originZoneId?: ZoneId | null, zoneByDestinationZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null, zoneByOriginZoneId?: { __typename?: 'Zone', id: ZoneId, name: string, zoneLocationsByZoneId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null> }, coaContractPricesByCoaContractId: { __typename?: 'CoaContractPricesConnection', nodes: Array<{ __typename?: 'CoaContractPrice', id: CoaContractPriceId, price: string | number, coaAssortmentId: CoaContractAssortmentId, routeId?: CoaContractPortId | null, coaContractPortByRouteId?: { __typename?: 'CoaContractPort', id: CoaContractPortId, originId?: LocationId | null, originZoneId?: ZoneId | null, destinationId?: LocationId | null, destinationZoneId?: ZoneId | null } | null } | null> }, coaContractDeviationCostsByCoaContractId: { __typename?: 'CoaContractDeviationCostsConnection', nodes: Array<{ __typename?: 'CoaContractDeviationCost', id: CoaContractDeviationCostId, fromZoneId?: ZoneId | null, toZoneId?: ZoneId | null, fromLocationId?: LocationId | null, toLocationId?: LocationId | null, lumpSumAmount?: string | number | null } | null> } } | null } | null> }, voyageCharterPortDataByVoyageCharterId: { __typename?: 'VoyageCharterPortDataConnection', nodes: Array<{ __typename?: 'VoyageCharterPortDatum', id: VoyageCharterPortDatumId, portDatumByPortDataId?: { __typename?: 'PortDatum', id: PortDatumId, portId: LocationId, loadingRate?: string | number | null, dischargeRate?: string | number | null, loadingDischargeUnit?: LoadingUnit | null, laytimeDays?: { __typename?: 'ShincShex', ho?: boolean | null, incExUu?: IncludedExcludedUnlessUsed | null, sa?: boolean | null, su?: boolean | null } | null } | null } | null> }, voyageCharterExtraFreightsByVoyageCharterId: { __typename?: 'VoyageCharterExtraFreightsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, name?: string | null, amount: string | number, description?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null> }, voyageCharterExtraCostsByVoyageCharterId: { __typename?: 'VoyageCharterExtraCostsConnection', nodes: Array<{ __typename?: 'VoyageCharterExtraCost', id: VoyageCharterExtraCostId, name?: string | null, amount: string | number, description?: string | null, type?: VoyageCharterCostType | null } | null> }, commissionsByVoyageCharterId: { __typename?: 'CommissionsConnection', nodes: Array<{ __typename?: 'Commission', id: CommissionId, type: CommissionType, value: string | number, bafApplied?: boolean | null, extraFreightApplied?: boolean | null, demurrageApplied?: boolean | null, assortmentId?: AssortmentId | null, loadPortId?: LocationId | null, dischargePortId?: LocationId | null, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null } | null> } } | null } | null, cargoCompartmentAllocationsByOrderId: { __typename?: 'CargoCompartmentAllocationsConnection', nodes: Array<{ __typename?: 'CargoCompartmentAllocation', id: CargoCompartmentAllocationId, clientId: string, orderId: OrderId, compartmentId: CargoCompartmentId, scheduledOrderClientId: string, amount: string | number } | null> }, apiOrdersNoticesByOrderId: { __typename?: 'ApiOrdersNoticesConnection', nodes: Array<{ __typename?: 'ApiOrdersNotice', id: ApiOrdersNoticeId, notices: string } | null> }, userByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null, vesselAttributeByMinVesselClassRequirement?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, cargoCompatibilityRanking?: number | null } | null, cargoExclusionsByOrderId: { __typename?: 'CargoExclusionsConnection', nodes: Array<{ __typename?: 'CargoExclusion', id: CargoExclusionId, distance?: string | number | null, voyages?: number | null, tanks?: number | null, assortmentByAssortment?: { __typename?: 'Assortment', id: AssortmentId, name: string } | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string } | null } | null> } } | null } | null };

export type LocationUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type LocationUpdatedSubscription = { __typename?: 'Subscription', locationUpdated?: { __typename?: 'LocationSubscriptionPayload', event?: string | null, location?: { __typename?: 'Location', id: LocationId, name: string, locode?: string | null, timezone?: string | null, countryId?: CountryId | null, country?: string | null, draft?: string | number | null, latitude?: string | number | null, longitude?: string | number | null, clusterId?: LocationClusterId | null, extraPortDays?: string | number | null, rootOrg?: OrganizationId | null, nameSynonyms?: Array<string | null> | null, parentLocationId?: LocationId | null, externalId?: string | null, maxDwt?: string | number | null, countryByCountryId?: { __typename?: 'Country', id: CountryId, alpha2?: string | null } | null, workingHours?: Array<{ __typename?: 'Workhour', workhours?: Array<{ __typename?: 'WorkHourPart', fromHours?: number | null, fromMinutes?: number | null, toHours?: number | null, toMinutes?: number | null } | null> | null } | null> | null, zoneLocationsByLocationId: { __typename?: 'ZoneLocationsConnection', nodes: Array<{ __typename?: 'ZoneLocation', id: ZoneLocationId, zoneId: ZoneId, locationId: LocationId } | null> } } | null } | null };

export type OrganizationUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type OrganizationUpdatedSubscription = { __typename?: 'Subscription', organizationUpdated?: { __typename?: 'OrganizationsSubscriptionPayload', event?: string | null, organization?: { __typename?: 'Organization', id: OrganizationId, name?: string | null, draft?: string | number | null, configEventsConcurrentDefault: boolean, configPortcallDurationBerthapiDefault: boolean, configEnableAcceptAllUpdates: boolean, configAutoAcceptOnlyConfirmed: boolean, configEnableScenarioAutoSave: boolean, configCargoAllocationCombineAssortment: boolean, portCostPriority?: string | null, broker: boolean } | null } | null };

export type AssortmentUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type AssortmentUpdatedSubscription = { __typename?: 'Subscription', assortmentUpdated?: { __typename?: 'AssortmentsSubscriptionPayload', event?: string | null, assortment?: { __typename?: 'Assortment', id: AssortmentId, name: string, assortmentGroup?: AssortmentGroupId | null, groupName?: string | null, specificGravity?: string | number | null, stowageFactorMin?: string | number | null, stowageFactorMax?: string | number | null, marginAmount?: string | number | null, marginUnit?: MarginUnit | null, cargoType?: CargoType | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, fillFactor?: string | number | null, assortmentGroupByAssortmentGroup?: { __typename?: 'AssortmentGroup', id: AssortmentGroupId, name: string, externalId?: string | null } | null } | null } | null };

export type ShipsUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type ShipsUpdatedSubscription = { __typename?: 'Subscription', shipUpdated?: { __typename?: 'ShipSubscriptionPayload', event?: string | null, ship?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, craneCapacity?: string | number | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, organizationId?: OrganizationId | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, imo?: string | number | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, mainEngineCapacity?: string | number | null, esiScore?: string | number | null, csiScore?: string | number | null, inactive: boolean, remarks?: string | null, externalFleet?: boolean | null, sortId?: string | number | null, primaryAttributeId?: VesselAttributeId | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, enableConsecutiveCoaVoyages: boolean, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> } } | null, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, loadingRate?: string | number | null, loadingUnit: LoadingUnit, dischargingRate?: string | number | null, dischargingUnit: LoadingUnit, cargoCompartmentsByVesselId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> } } | null, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean, cargoCompatibilityRanking?: number | null, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId, vesselAttributeId?: VesselAttributeId | null } | null> }, channelIncompatibilitiesByVesselAttributeId: { __typename?: 'ChannelIncompatibilitiesConnection', nodes: Array<{ __typename?: 'ChannelIncompatibility', id: ChannelIncompatibilityId, channelName: string } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, speed: string | number, consumption: string | number, type: VesselSpeedType, tag?: VesselSpeedTag | null, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId, price?: string | number | null, priceAdjustment?: string | number | null, gradeName: string, referenceGrade?: string | null, referencePort?: string | null, currency: Currency, carbonFactor?: string | number | null } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number } | null } | null> }, tcContractsByVesselId: { __typename?: 'TcContractsConnection', nodes: Array<{ __typename?: 'TcContract', id: TcContractId, deliveryEndDate: string, deliveryStartDate: string, deliveryPortId: LocationId, externalId: string, redeliveryEndDate: string, redeliveryStartDate: string, redeliveryPortId: LocationId, vesselId: ShipId } | null> } } | null } | null };

export type VoyageAttributeUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type VoyageAttributeUpdatedSubscription = { __typename?: 'Subscription', voyageAttributeUpdated?: { __typename?: 'VoyageAttributeSubscriptionPayload', event?: string | null, voyageAttribute?: { __typename?: 'VoyageAttribute', id: VoyageAttributeId, name: string, color: string, isActive: boolean, description?: string | null } | null } | null };

export type ShipmentUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type ShipmentUpdatedSubscription = { __typename?: 'Subscription', shipmentUpdated?: { __typename?: 'ShipmentSubscriptionPayload', event?: string | null, shipment?: { __typename?: 'Shipment', id: ShipmentId, clientId: string, name: string, remarks?: string | null, externalShipmentId?: string | null, voyageAttributeId?: VoyageAttributeId | null, shipmentExternalStatusesByShipmentId: { __typename?: 'ShipmentExternalStatusesConnection', nodes: Array<{ __typename?: 'ShipmentExternalStatus', id: ShipmentExternalStatusId, status: ShipmentStatus } | null> }, shipmentFreightByShipmentId?: { __typename?: 'ShipmentFreight', id: ShipmentFreightId, clientId: string, shipmentId: ShipmentId, freightAmount: string | number, freightUnit: PaymentUnit } | null, shipmentExtraFreightsByShipmentId: { __typename?: 'ShipmentExtraFreightsConnection', nodes: Array<{ __typename?: 'ShipmentExtraFreight', id: ShipmentExtraFreightId, clientId: string, shipmentId: ShipmentId, name?: string | null, freightAmount: string | number, freightUnit: PaymentUnit, description?: string | null, createdAt?: string | null, updatedAt?: string | null } | null> } } | null } | null };

export type PortCostDefaultUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type PortCostDefaultUpdatedSubscription = { __typename?: 'Subscription', portCostDefaultUpdated?: { __typename?: 'PortCostDefaultSubscriptionPayload', event?: string | null, portCostDefault?: { __typename?: 'PortCostDefault', id: PortCostDefaultId, cost: string | number, currency: Currency, locationId: LocationId, vesselId?: ShipId | null, vesselTypeId?: VesselAttributeId | null, vesselAttributeByVesselTypeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, isVesselClass: boolean } | null } | null } | null };

export type RobTaskUpdateSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type RobTaskUpdateSubscription = { __typename?: 'Subscription', robTaskUpdated?: { __typename?: 'RobTaskSubscriptionPayload', bunker?: { __typename?: 'GetVesonBunkerResult', errorMessage?: string | null, remainingBunkerOfVoyages?: Array<{ __typename?: 'VesonRemainingBunkerOfVoyage', id: number, voyage: string, bunkerOpen: Array<{ __typename?: 'VesonRemainingBunker', price: number, amount: number, name: string }>, bunkerClose: Array<{ __typename?: 'VesonRemainingBunker', price: number, amount: number, name: string }> }> | null, defaultBunkerOfVessels?: Array<{ __typename?: 'VesonDefaultBunkerOfVessel', id: number, vessel_code: string, bunker: Array<{ __typename?: 'VesonDefaultBunkerPrice', price: number, name: string }> }> | null } | null } | null };

export type RouteOverrideUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type RouteOverrideUpdatedSubscription = { __typename?: 'Subscription', routeOverrideUpdated?: { __typename?: 'RouteOverrideSubscriptionPayload', event?: string | null, routeOverride?: { __typename?: 'RouteOverride', id: RouteOverrideId, fromId: LocationId, toId: LocationId, distance?: string | number | null, avoidsChannels: boolean, locationByFromId?: { __typename?: 'Location', id: LocationId, clusterId?: LocationClusterId | null } | null, locationByToId?: { __typename?: 'Location', id: LocationId, clusterId?: LocationClusterId | null } | null } | null } | null };

export type ScenarioUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type ScenarioUpdatedSubscription = { __typename?: 'Subscription', scenarioUpdated?: { __typename?: 'ScenarioSubscriptionPayload', event?: string | null, scenario?: { __typename?: 'Scenario', id: ScenarioId, clientId: string, organizationId: OrganizationId, name?: string | null, description?: string | null, createdAt?: string | null, updatedAt?: string | null, createdBy: UserId, updatedBy: UserId, dataSchemaVersion: number, data: string, shared: boolean, deletedAt?: string | null } | null } | null };

export type ScenariosListQueryVariables = Exact<{ [key: string]: never; }>;


export type ScenariosListQuery = { __typename?: 'Query', allScenarios?: { __typename?: 'ScenariosConnection', nodes: Array<{ __typename?: 'Scenario', id: ScenarioId, clientId: string, createdBy: UserId } | null> } | null };

export type ShipUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type ShipUpdatedSubscription = { __typename?: 'Subscription', shipUpdated?: { __typename?: 'ShipSubscriptionPayload', event?: string | null, ship?: { __typename?: 'Ship', id: ShipId, name?: string | null, shortName?: string | null, imo?: string | number | null, inactive: boolean, organizationId?: OrganizationId | null, vesselInfoId?: VesselInfoId | null, weightCapacity?: number | null, weightCapacityType?: WeightCapacityType | null, massCapacity?: string | number | null, massUnit?: WeightUnits | null, volumeCapacity?: string | number | null, volumeUnit?: VolumeUnits | null, deckVolumeCapacity?: string | number | null, tcRate?: string | number | null, loadingRate?: string | number | null, loadingUnit?: LoadingUnit | null, dischargingRate?: string | number | null, dischargingUnit?: LoadingUnit | null, year?: number | null, airDraft?: string | number | null, netTonnage?: string | number | null, grossTonnage?: string | number | null, craneCapacity?: string | number | null, flag?: string | null, href?: string | null, callSign?: string | null, draft?: string | number | null, loa?: string | number | null, breadth?: string | number | null, mmsi?: string | number | null, externalFleet?: boolean | null, enableConsecutiveCoaVoyages: boolean, sortId?: string | number | null, defaultBunkerGradeId?: BunkerGradeOverrideId | null, primaryAttributeId?: VesselAttributeId | null, vesselInfoByVesselInfoId?: { __typename?: 'VesselInfo', id: VesselInfoId, imo: number } | null, vesselFulfillsRequirementAssociationsByVesselId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, vesselId?: ShipId | null, specialRequirementId: SpecialRequirementId } | null> }, vesselAttributesAssociationsByShipId: { __typename?: 'VesselAttributesAssociationsConnection', nodes: Array<{ __typename?: 'VesselAttributesAssociation', id: VesselAttributesAssociationId, vesselAttributeId: VesselAttributeId, vesselAttributeByVesselAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, isVesselClass: boolean, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null } | null> }, vesselSpeedConsumptionsByShipId: { __typename?: 'VesselSpeedConsumptionsConnection', nodes: Array<{ __typename?: 'VesselSpeedConsumption', id: VesselSpeedConsumptionId, bunkerGradeId: BunkerGradeOverrideId, tag?: VesselSpeedTag | null, type: VesselSpeedType, consumption: string | number, speed: string | number, area?: VesselArea | null, shipId: ShipId, bunkerGradeOverrideByBunkerGradeId?: { __typename?: 'BunkerGradeOverride', id: BunkerGradeOverrideId } | null } | null> }, vesselDraftDatapointsByShipId: { __typename?: 'VesselDraftDatapointsConnection', nodes: Array<{ __typename?: 'VesselDraftDatapoint', id: VesselDraftDatapointIdString, cargoLoad: string | number, draft: string | number } | null> }, cargoCompartmentsByShipId: { __typename?: 'CargoCompartmentsConnection', nodes: Array<{ __typename?: 'CargoCompartment', id: CargoCompartmentId, name: string, maxVolume: string | number, volumeUnit?: VolumeUnits | null, type?: HoldType | null } | null> }, organizationByOrganizationId?: { __typename?: 'Organization', id: OrganizationId, name?: string | null } | null, vesselAttributeByPrimaryAttributeId?: { __typename?: 'VesselAttribute', id: VesselAttributeId, name: string, vesselFulfillsRequirementAssociationsByVesselAttributeId: { __typename?: 'VesselFulfillsRequirementAssociationsConnection', nodes: Array<{ __typename?: 'VesselFulfillsRequirementAssociation', id: VesselFulfillsRequirementAssociationId, specialRequirementId: SpecialRequirementId } | null> } } | null, shipVoyageNamingRuleRelationsByShipId: { __typename?: 'ShipVoyageNamingRuleRelationsConnection', nodes: Array<{ __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null> }, vesselPerformanceModelsByShipId: { __typename?: 'VesselPerformanceModelsConnection', nodes: Array<{ __typename?: 'VesselPerformanceModel', id: VesselPerformanceModelId, performanceModelUid: string } | null> } } | null } | null };

export type ShipVoyageNamingRuleRelationUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type ShipVoyageNamingRuleRelationUpdatedSubscription = { __typename?: 'Subscription', shipVoyageNamingRuleRelationUpdated?: { __typename?: 'ShipVoyageNamingRuleRelationSubscriptionPayload', event?: string | null, shipVoyageNamingRuleRelation?: { __typename?: 'ShipVoyageNamingRuleRelation', id: ShipVoyageNamingRuleRelationId, shipId: ShipId, ruleId: VoyageNamingRuleId, voyageNamingRuleByRuleId?: { __typename?: 'VoyageNamingRule', id: VoyageNamingRuleId, rule: string, vesselFullname?: boolean | null, vesselImo?: boolean | null, vesselShortname?: boolean | null, year: VoyageNamingYearFormat, zerosPad: number, organizationId?: OrganizationId | null } | null } | null } | null };

export type TransactionalCommitSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type TransactionalCommitSubscription = { __typename?: 'Subscription', transactionalCommit?: { __typename?: 'TransactionalCommitSubscriptionPayload', event?: string | null, userId?: string | null } | null };

export type VesselReservationUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type VesselReservationUpdatedSubscription = { __typename?: 'Subscription', vesselReservationUpdated?: { __typename?: 'VesselReservationSubscriptionPayload', event?: string | null, vesselReservation?: { __typename?: 'VesselReservation', id: VesselReservationId, duration: number, expireTime?: string | null, remark?: string | null, startPortId?: LocationId | null, endPortId?: LocationId | null, startRegionId?: RegionId | null, endRegionId?: RegionId | null, startTime: string, type: VesselReservationType, vesselId: ShipId, shipByVesselId?: { __typename?: 'Ship', id: ShipId, name?: string | null } | null, locationByStartPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, locationByEndPortId?: { __typename?: 'Location', id: LocationId, name: string } | null, regionByStartRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, regionByEndRegionId?: { __typename?: 'Region', id: RegionId, name: string, ordinal?: number | null } | null, userByCreatedByUserId?: { __typename?: 'User', id: UserId, name?: string | null } | null } | null } | null };

export type ExtraFreightUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type ExtraFreightUpdatedSubscription = { __typename?: 'Subscription', voyageCharterExtraFreightUpdated?: { __typename?: 'VoyageCharterExtraFreightSubscriptionPayload', event?: string | null, extraFreight?: { __typename?: 'VoyageCharterExtraFreight', id: VoyageCharterExtraFreightId, voyageCharterId: VoyageCharterId, amount: string | number, description?: string | null, externalId?: string | null, externalLastUpdate?: string | null, externalUpdatedBy?: string | null, name?: string | null, type?: FreightType | null, ignoreInPnl?: boolean | null } | null } | null };

export type WorldscaleFreightUpdatedSubscriptionVariables = Exact<{
  org: Scalars['String']['input'];
}>;


export type WorldscaleFreightUpdatedSubscription = { __typename?: 'Subscription', worldscaleFreightUpdated?: { __typename?: 'WorldscaleFreightSubscriptionPayload', event?: string | null, worldscaleFreight?: { __typename?: 'WorldscaleFreight', id: WorldscaleFreightId, organizationId: OrganizationId, route: string, rate: string | number, currency: Currency, year: number, createdAt?: string | null, updatedAt?: string | null, locationByFromLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null, locationByToLocationId?: { __typename?: 'Location', id: LocationId, name: string, country?: string | null } | null } | null } | null };
